(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888,2741],{

/***/ 84683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (Utility_strlen(value) - 1 - length > 6)
				switch (Utility_charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (Utility_charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (Utility_charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (Utility_charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length)
					break
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case Enum_RULESET:
					if (element.length)
						return Utility_combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 62568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CacheProvider": function() { return /* reexport */ CacheProvider; },
  "ClassNames": function() { return /* binding */ ClassNames; },
  "Global": function() { return /* binding */ Global; },
  "ThemeContext": function() { return /* reexport */ ThemeContext; },
  "createElement": function() { return /* binding */ jsx; },
  "css": function() { return /* reexport */ css_browser_esm; },
  "jsx": function() { return /* binding */ jsx; },
  "keyframes": function() { return /* binding */ keyframes; },
  "withEmotionCache": function() { return /* reexport */ withEmotionCache; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



// EXTERNAL MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
var stylis_browser_esm = __webpack_require__(48285);
;// CONCATENATED MODULE: ./node_modules/@emotion/core/node_modules/@emotion/cache/dist/cache.browser.esm.js




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_browser_esm/* default */.Z(stylisOptions);

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) { var map; }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) { var commentEnd, commentStart; }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ var cache_browser_esm = (createCache);

;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



// EXTERNAL MODULE: ./node_modules/@emotion/hash/dist/hash.browser.esm.js
var hash_browser_esm = __webpack_require__(62506);
// EXTERNAL MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(40351);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
var memoize_browser_esm = __webpack_require__(12717);
;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = (0,memoize_browser_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm/* default */.Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {}

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,hash_browser_esm/* default */.Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/core/dist/emotion-element-04d85134.browser.esm.js






var emotion_element_04d85134_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? cache_browser_esm() : null);
var ThemeContext = /*#__PURE__*/(0,react.createContext)({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/(0,react.createElement)(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/(0,react.forwardRef)(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) { var match, error; }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (false) { var labelFromStack; }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {}



;// CONCATENATED MODULE: ./node_modules/@emotion/css/dist/css.browser.esm.js


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

/* harmony default export */ var css_browser_esm = (css);

;// CONCATENATED MODULE: ./node_modules/@emotion/core/dist/core.browser.esm.js











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(react.Component);

var keyframes = function keyframes() {
  var insertable = css_browser_esm.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var core_browser_esm_Noop = function Noop() {
  return null;
};

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      {
        insertStyles(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(core_browser_esm_Noop, null);


    return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
  });
});




/***/ }),

/***/ 62506:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["Z"] = (murmur2);


/***/ }),

/***/ 12717:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 54880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CacheProvider; },
/* harmony export */   "E": function() { return /* binding */ Emotion; },
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "c": function() { return /* binding */ createEmotionProps; },
/* harmony export */   "h": function() { return /* binding */ hasOwnProperty; },
/* harmony export */   "u": function() { return /* binding */ useInsertionEffectMaybe; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports _, a, b, d */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84683);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67728);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52849);









var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {

  useInsertionEffect(create);
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_3__/* .registerStyles */ .hC)(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_3__/* .insertStyles */ .My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_3__/* .getRegisteredStyles */ .fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(registeredStyles, undefined, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, newProps));
});

if (false) {}




/***/ }),

/***/ 70917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "ms": function() { return /* binding */ ClassNames; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; }
/* harmony export */ });
/* unused harmony exports Global, createElement */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84683);
/* harmony import */ var _emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54880);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67728);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52849);













var pkg = {
	name: "@emotion/react",
	version: "11.8.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/babel-plugin": "^11.7.1",
		"@emotion/cache": "^11.7.1",
		"@emotion/serialize": "^1.0.2",
		"@emotion/sheet": "^1.1.0",
		"@emotion/utils": "^1.1.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.7.1",
		"@emotion/css-prettifier": "1.0.1",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.8.1",
		"@types/react": "^16.9.11",
		dtslint: "^0.3.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.h.call(props, 'css')) {
    // $FlowFixMe
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.E;
  createElementArgArray[1] = (0,_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffect(function () {
    var key = cache.key + "-global";
    var sheet = new StyleSheet({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffect(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_5__/* .getRegisteredStyles */ .fp)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = (0,_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.u)(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_5__/* .insertStyles */ .My)(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(0,_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.w)(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_5__/* .registerStyles */ .hC)(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.T)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (false) {}

if (false) { var globalKey, globalContext, isJest, isBrowser; }




/***/ }),

/***/ 52849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/hash/dist/hash.browser.esm.js
var hash_browser_esm = __webpack_require__(62506);
// EXTERNAL MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(40351);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_browser_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm/* default */.Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,hash_browser_esm/* default */.Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 67728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 48285:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["Z"] = (stylis_min);


/***/ }),

/***/ 40351:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 35114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3604);

/***/ }),

/***/ 19758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);
var settle = __webpack_require__(49629);
var cookies = __webpack_require__(30321);
var buildURL = __webpack_require__(57251);
var buildFullPath = __webpack_require__(58325);
var parseHeaders = __webpack_require__(93206);
var isURLSameOrigin = __webpack_require__(83827);
var createError = __webpack_require__(38259);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    if (
      (utils.isBlob(requestData) || utils.isFile(requestData)) &&
      requestData.type
    ) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = unescape(encodeURIComponent(config.auth.password)) || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 3604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);
var bind = __webpack_require__(68393);
var Axios = __webpack_require__(50868);
var mergeConfig = __webpack_require__(93148);
var defaults = __webpack_require__(25627);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(52080);
axios.CancelToken = __webpack_require__(11432);
axios.isCancel = __webpack_require__(97517);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(36428);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 52080:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 11432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(52080);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 97517:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 50868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);
var buildURL = __webpack_require__(57251);
var InterceptorManager = __webpack_require__(10123);
var dispatchRequest = __webpack_require__(56074);
var mergeConfig = __webpack_require__(93148);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 10123:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 58325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(5498);
var combineURLs = __webpack_require__(5668);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 38259:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(20859);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 56074:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);
var transformData = __webpack_require__(53870);
var isCancel = __webpack_require__(97517);
var defaults = __webpack_require__(25627);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 20859:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 93148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ 49629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(38259);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 53870:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ 25627:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(19590);
var normalizeHeaderName = __webpack_require__(98474);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(19758);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(19758);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 68393:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 57251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 5668:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 5498:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 83827:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 98474:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 93206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(19590);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 36428:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 19590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(68393);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 35357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xC": function() { return /* binding */ configureStore; },
  "oM": function() { return /* binding */ createSlice; },
  "Bx": function() { return /* binding */ getDefaultMiddleware; }
});

// UNUSED EXPORTS: MiddlewareArray, __DO_NOT_USE__ActionTypes, applyMiddleware, bindActionCreators, combineReducers, compose, createAction, createAsyncThunk, createDraftSafeSelector, createEntityAdapter, createImmutableStateInvariantMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, current, findNonSerializableValue, freeze, getType, isAllOf, isAnyOf, isAsyncThunkAction, isDraft, isFulfilled, isImmutableDefault, isPending, isPlain, isPlainObject, isRejected, isRejectedWithValue, miniSerializeError, nanoid, original, unwrapResult

;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.js
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?(n.delete(r),n.add(t)):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0),n)}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function O(n){g(n),n.p.forEach(S),n.p=null}function g(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.O=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.g||b("ES5").S(e,r,o),o?(i[Q].P&&(O(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(r,i){return A(n,e,o,r,i,t)})),x(n,o,!1),t&&n.u&&b("Patches").R(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s){if( false&&0,r(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!r(v))return;e.m=!1}if(t(c)&&!y(c)){if(!e.h.F&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),n.h.F&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function R(n,r,t){var e=s(r)?b("MapSet").N(r,t):v(r)?b("MapSet").T(r,t):n.g?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function D(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=F(r,c),u.I=!1}else e=F(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function F(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function N(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.O&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:i,o:null,O:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.D,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=""+i[s];0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},R:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.D,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.D,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=R(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.O&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,O:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.D.set(n,!0),t.o.set(n,r),t.D.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.D.set(n,!1):r.D.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.D=new Map,i(n.t,(function(r){n.D.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=R(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,O:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{N:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){N(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=R(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.D[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&"number"!=typeof t&&(void 0!==t||r in n.o)||(n.o[r]=t,n.D[r]=!0,!0)},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.D[r]=!1,E(n),k(n)):delete n.D[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.g=B,this.F=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=R(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?O(c):g(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.F&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.F=n},i.setUseProxies=function(r){r&&!B&&n(20),this.g=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = (fn);
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}



;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return compose;
    return compose.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop) {
        return noop;
    };
};
// src/isPlainObject.ts
function redux_toolkit_esm_isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/utils.ts
function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value === null || typeof value === "undefined" || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    var tracked = { value: obj };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    for (var key in keysToDetect) {
        var childPath = path ? path + "." + key : key;
        if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
            continue;
        }
        var result = detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) {
            return result;
        }
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return type === "undefined" || val === null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || redux_toolkit_esm_isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath) >= 0) {
            continue;
        }
        if (!isSerializable(nestedValue)) {
            return {
                keyPath: nestedPath,
                value: nestedValue
            };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);
            if (foundNestedSerializable) {
                return foundNestedSerializable;
            }
        }
    }
    return false;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j;
    return function (storeAPI) { return function (next) { return function (action) {
        if (ignoreActions || ignoredActions.length && ignoredActions.indexOf(action.type) !== -1) {
            return next(action);
        }
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        measureUtils.measureTime(function () {
            var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths);
            if (foundActionNonSerializableValue) {
                var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
            }
        });
        var result = next(action);
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(es);
        }
        else {
            middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (redux_toolkit_esm_isPlainObject(reducer)) {
        rootReducer = combineReducers(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = applyMiddleware.apply(void 0, finalMiddleware);
    var finalCompose = compose;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var storeEnhancers = [middlewareEnhancer];
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(storeEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isFSA(action) {
    return redux_toolkit_esm_isPlainObject(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) {
                throw new Error("addCase cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return immer_esm(initialState(), function () {
        }); };
    }
    else {
        var frozenInitialState_1 = immer_esm(initialState, function () {
        });
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (typeof result === "undefined") {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (typeof result === "undefined") {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return immer_esm(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    var initialState = typeof options.initialState == "function" ? options.initialState : immer_esm(options.initialState, function () {
    });
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, finalCaseReducers, actionMatchers, defaultCaseReducer);
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (isDraft3(state)) {
            runMutator(state);
            return state;
        }
        else {
            return createNextState2(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = state.ids.map(function (id) { return newKeys[id] || id; });
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function takeUpdatedModel(models, update, state) {
        if (!(update.id in state.entities)) {
            return false;
        }
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        delete state.entities[update.id];
        models.push(updated);
        return newKey !== update.id;
    }
    function updateManyMutably(updates, state) {
        var models = [];
        updates.forEach(function (update) { return takeUpdatedModel(models, update, state); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = (/* unused pure expression or super */ null && ([
    "name",
    "message",
    "stack",
    "code"
]));
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
function createAsyncThunk(typePrefix, payloadCreator, options) {
    var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
        payload: payload,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            requestStatus: "fulfilled"
        })
    }); });
    var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
        payload: void 0,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            requestStatus: "pending"
        })
    }); });
    var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
        payload: payload,
        error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            rejectedWithValue: !!payload,
            requestStatus: "rejected",
            aborted: (error == null ? void 0 : error.name) === "AbortError",
            condition: (error == null ? void 0 : error.name) === "ConditionError"
        })
    }); });
    var displayedWarning = false;
    var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
        function class_1() {
            this.signal = {
                aborted: false,
                addEventListener: function () {
                },
                dispatchEvent: function () {
                    return false;
                },
                onabort: function () {
                },
                removeEventListener: function () {
                }
            };
        }
        class_1.prototype.abort = function () {
            if (false) {}
        };
        return class_1;
    }());
    function actionCreator(arg) {
        return function (dispatch, getState, extra) {
            var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
            var abortController = new AC();
            var abortReason;
            var abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({ name: "AbortError", message: abortReason || "Aborted" }); }); });
            var started = false;
            function abort(reason) {
                if (started) {
                    abortReason = reason;
                    abortController.abort();
                }
            }
            var promise = function () {
                return __async(this, null, function () {
                    var _a, _b, finalAction, conditionResult, err_1, skipDispatch;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 4, , 5]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                return [4 /*yield*/, conditionResult];
                            case 1:
                                conditionResult = _c.sent();
                                _c.label = 2;
                            case 2:
                                if (conditionResult === false) {
                                    throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                }
                                started = true;
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                return [4 /*yield*/, Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            rejectWithValue: function (value, meta) {
                                                return new RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function (value, meta) {
                                                return new FulfillWithMeta(value, meta);
                                            }
                                        })).then(function (result) {
                                            if (result instanceof RejectWithValue) {
                                                throw result;
                                            }
                                            if (result instanceof FulfillWithMeta) {
                                                return fulfilled(result.payload, requestId, arg, result.meta);
                                            }
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])];
                            case 3:
                                finalAction = _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                err_1 = _c.sent();
                                finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                return [3 /*break*/, 5];
                            case 5:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) {
                                    dispatch(finalAction);
                                }
                                return [2 /*return*/, finalAction];
                        }
                    });
                });
            }();
            return Object.assign(promise, {
                abort: abort,
                requestId: requestId,
                arg: arg,
                unwrap: function () {
                    return promise.then(unwrapResult);
                }
            });
        };
    }
    return Object.assign(actionCreator, {
        pending: pending,
        rejected: rejected,
        fulfilled: fulfilled,
        typePrefix: typePrefix
    });
}
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/index.ts
N();

//# sourceMappingURL=redux-toolkit.esm.js.map

/***/ }),

/***/ 39472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xb": function() { return /* binding */ Hub; },
  "Gd": function() { return /* binding */ getCurrentHub; },
  "cu": function() { return /* binding */ getMainCarrier; }
});

// UNUSED EXPORTS: API_VERSION, getActiveDomain, getHubFromCarrier, makeMain, setHubOnCarrier

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(82991);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__(61422);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(25252);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js + 1 modules
var object = __webpack_require__(68252);
;// CONCATENATED MODULE: ./node_modules/@sentry/hub/esm/session.js

/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = (0,misc/* uuid4 */.DM)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0,time/* timestampInSeconds */.ph)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : (0,misc/* uuid4 */.DM)();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === 'ok') {
            this.update({ status: 'exited' });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return (0,object/* dropUndefinedKeys */.Jr)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            },
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/hub/esm/hub.js




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new esm_scope/* Scope */.s(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = esm_scope/* Scope.clone */.s.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = (0,misc/* uuid4 */.DM)());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = (0,misc/* uuid4 */.DM)());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (0,misc/* uuid4 */.DM)();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = (0,time/* dateTimestampInSeconds */.yW)();
        var mergedBreadcrumb = (0,tslib_es6/* __assign */.pi)({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? (0,esm_logger/* consoleSandbox */.C)(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            esm_logger/* logger.warn */.k.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) {
            session.close();
        }
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) {
            scope.setSession();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0,esm_global/* getGlobalObject */.R)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new Session((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') {
                currentSession.update({ status: 'exited' });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, (0,tslib_es6/* __spread */.fl)(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        esm_logger/* logger.warn */.k.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = (0,esm_global/* getGlobalObject */.R)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0,node/* isNodeEnv */.KV)()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveDomain() {
    logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, esm_scope/* Scope.clone */.s.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
        return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map

/***/ }),

/***/ 25252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82991);


/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */
        this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(scope._breadcrumbs);
            newScope._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._tags);
            newScope._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._extra);
            newScope._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), captureContext._tags);
            this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), captureContext._extra);
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), captureContext.tags);
            this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), captureContext.extra);
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)() }, breadcrumb);
        this._breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) {
                event.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */
    Scope.prototype.setSDKProcessingMetadata = function (newData) {
        this._sdkProcessingMetadata = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, event), hint);
                if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
    var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalObject */ .R)();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),

/***/ 39666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "e": function() { return /* binding */ configureScope; }
/* harmony export */ });
/* unused harmony exports captureMessage, captureEvent, addBreadcrumb, setContext, setExtras, setTags, setExtra, setTag, _callOnClient, startTransaction */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39472);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spread */ .fl)(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, __assign({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __spread(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', __assign({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ FINISH_REASON_TAG; },
/* harmony export */   "x": function() { return /* binding */ IDLE_TRANSACTION_FINISH_REASONS; }
/* harmony export */ });
// Store finish reasons in tuple to save on bundle size
// Readonly type should enforce that this is not mutated.
var FINISH_REASON_TAG = 'finishReason';
var IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 62758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js + 1 modules
var hub = __webpack_require__(39472);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__(61422);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/errors.js


/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
    (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
    (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var status_1 = 'internal_error';
        logger/* logger.log */.k.log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
        activeTransaction.setStatus(status_1);
    }
}
//# sourceMappingURL=errors.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(33391);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) {
            return {
                'sentry-trace': span.toTraceparent(),
            };
        }
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            transactionSampling: { method: 'explicitly_set' },
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_sampler',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.setMetadata({
            transactionSampling: { method: 'inheritance' },
        });
    }
    else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_rate',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        logger/* logger.warn */.k.warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        logger/* logger.log */.k.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        logger/* logger.log */.k.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    logger/* logger.log */.k.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        logger/* logger.warn */.k.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        logger/* logger.warn */.k.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
    transaction = sample(transaction, options, (0,tslib_es6/* __assign */.pi)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * Create new idle transaction.
 */
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
    var client = hub.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, onScope);
    transaction = sample(transaction, options, (0,tslib_es6/* __assign */.pi)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * @private
 */
function _addTracingExtensions() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) {
        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    }
    if (!carrier.__SENTRY__.extensions.traceHeaders) {
        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
}
/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    var packageToIntegrationMapping = {
        mongodb: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo');
            return new integration.Mongo();
        },
        mongoose: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo');
            return new integration.Mongo({ mongoose: true });
        },
        mysql: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql');
            return new integration.Mysql();
        },
        pg: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres');
            return new integration.Postgres();
        },
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping)
        .filter(function (moduleName) { return !!(0,node/* loadModule */.$y)(moduleName); })
        .map(function (pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        }
        catch (e) {
            return undefined;
        }
    })
        .filter(function (p) { return p; });
    if (mappedPackages.length > 0) {
        carrier.__SENTRY__.integrations = (0,tslib_es6/* __spread */.fl)((carrier.__SENTRY__.integrations || []), mappedPackages);
    }
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if ((0,node/* isNodeEnv */.KV)()) {
        _autoloadDatabaseIntegrations();
    }
    // If an error happens globally, we should make sure transaction status is set to error.
    registerErrorInstrumentation();
}
//# sourceMappingURL=hubextensions.js.map

/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony exports HEARTBEAT_INTERVAL, IdleTransactionSpanRecorder */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26257);
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55334);
/* harmony import */ var _transaction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33391);





var DEFAULT_IDLE_TIMEOUT = 1000;
var HEARTBEAT_INTERVAL = 5000;
/**
 * @inheritDoc
 */
var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) { transactionSpanId = ''; }
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */
    IdleTransactionSpanRecorder.prototype.add = function (span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function (endTimestamp) {
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) {
                this._pushActivity(span.spanId);
            }
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}(_span__WEBPACK_IMPORTED_MODULE_2__/* .SpanRecorder */ .gB));

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
var IdleTransaction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, 
    /**
     * The time to wait in ms until the idle transaction will be finished.
     * @default 1000
     */
    _idleTimeout, 
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope) {
        if (_idleTimeout === void 0) { _idleTimeout = DEFAULT_IDLE_TIMEOUT; }
        if (_onScope === void 0) { _onScope = false; }
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
        }
        _this._initTimeout = setTimeout(function () {
            if (!_this._finished) {
                _this.finish();
            }
        }, _this._idleTimeout);
        return _this;
    }
    /** {@inheritDoc} */
    IdleTransaction.prototype.finish = function (endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) { endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)(); }
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) {
                    return true;
                }
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) {
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                }
                return keepSpan;
            });
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log('[Tracing] flushing IdleTransaction');
        }
        else {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log('[Tracing] No active IdleTransaction');
        }
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            clearActiveTransaction(this._idleHub);
        }
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */
    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */
    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            var pushActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._pushActivity(id);
            };
            var popActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._popActivity(id);
            };
            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._pushActivity = function (spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log('[Tracing] new activities count', Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._popActivity = function (spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + timeout / 1000;
            setTimeout(function () {
                if (!_this._finished) {
                    _this.setTag(_constants__WEBPACK_IMPORTED_MODULE_4__/* .FINISH_REASON_TAG */ .d, _constants__WEBPACK_IMPORTED_MODULE_4__/* .IDLE_TRANSACTION_FINISH_REASONS[1] */ .x[1]);
                    _this.finish(end_1);
                }
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */
    IdleTransaction.prototype._beat = function () {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) {
            return;
        }
        var heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) {
            this._heartbeatCounter += 1;
        }
        else {
            this._heartbeatCounter = 1;
        }
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus('deadline_exceeded');
            this.setTag(_constants__WEBPACK_IMPORTED_MODULE_4__/* .FINISH_REASON_TAG */ .d, _constants__WEBPACK_IMPORTED_MODULE_4__/* .IDLE_TRANSACTION_FINISH_REASONS[0] */ .x[0]);
            this.finish();
        }
        else {
            this._pingHeartbeat();
        }
    };
    /**
     * Pings the heartbeat
     */
    IdleTransaction.prototype._pingHeartbeat = function () {
        var _this = this;
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        setTimeout(function () {
            _this._beat();
        }, HEARTBEAT_INTERVAL);
    };
    return IdleTransaction;
}(_transaction__WEBPACK_IMPORTED_MODULE_5__/* .Transaction */ .Y));

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) {
                scope.setSpan(undefined);
            }
        }
    }
}
//# sourceMappingURL=idletransaction.js.map

/***/ }),

/***/ 55334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68252);


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
var SpanRecorder = /** @class */ (function () {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */
    SpanRecorder.prototype.add = function (span) {
        if (this.spans.length > this._maxlen) {
            span.spanRecorder = undefined;
        }
        else {
            this.spans.push(span);
        }
    };
    return SpanRecorder;
}());

/**
 * Span contains all data about a span
 */
var Span = /** @class */ (function () {
    /**
     * You should never call the constructor manually, always use `Sentry.startTransaction()`
     * or call `startChild()` on an existing span.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Span(spanContext) {
        /**
         * @inheritDoc
         */
        this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();
        /**
         * @inheritDoc
         */
        this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */
        this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        /**
         * @inheritDoc
         */
        this.tags = {};
        /**
         * @inheritDoc
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) {
            return this;
        }
        if (spanContext.traceId) {
            this.traceId = spanContext.traceId;
        }
        if (spanContext.spanId) {
            this.spanId = spanContext.spanId;
        }
        if (spanContext.parentSpanId) {
            this.parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ('sampled' in spanContext) {
            this.sampled = spanContext.sampled;
        }
        if (spanContext.op) {
            this.op = spanContext.op;
        }
        if (spanContext.description) {
            this.description = spanContext.description;
        }
        if (spanContext.data) {
            this.data = spanContext.data;
        }
        if (spanContext.tags) {
            this.tags = spanContext.tags;
        }
        if (spanContext.status) {
            this.status = spanContext.status;
        }
        if (spanContext.startTimestamp) {
            this.startTimestamp = spanContext.startTimestamp;
        }
        if (spanContext.endTimestamp) {
            this.endTimestamp = spanContext.endTimestamp;
        }
    }
    /**
     * @inheritDoc
     * @deprecated
     */
    Span.prototype.child = function (spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */
    Span.prototype.startChild = function (spanContext) {
        var childSpan = new Span((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) {
            childSpan.spanRecorder.add(childSpan);
        }
        childSpan.transaction = this.transaction;
        return childSpan;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setTag = function (key, value) {
        var _a;
        this.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function (key, value) {
        var _a;
        this.data = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setStatus = function (value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setHttpStatus = function (httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        var spanStatus = spanStatusfromHttpCode(httpStatus);
        if (spanStatus !== 'unknown_error') {
            this.setStatus(spanStatus);
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.isSuccess = function () {
        return this.status === 'ok';
    };
    /**
     * @inheritDoc
     */
    Span.prototype.finish = function (endTimestamp) {
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampledString = '';
        if (this.sampled !== undefined) {
            sampledString = this.sampled ? '-1' : '-0';
        }
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toContext = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.updateWithContext = function (spanContext) {
        var _a, _b, _c, _d, _e;
        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
        this.status = spanContext.status;
        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.getTraceContext = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
        });
    };
    return Span;
}());

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) {
        return 'ok';
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch (httpStatus) {
            case 401:
                return 'unauthenticated';
            case 403:
                return 'permission_denied';
            case 404:
                return 'not_found';
            case 409:
                return 'already_exists';
            case 413:
                return 'failed_precondition';
            case 429:
                return 'resource_exhausted';
            default:
                return 'invalid_argument';
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch (httpStatus) {
            case 501:
                return 'unimplemented';
            case 503:
                return 'unavailable';
            case 504:
                return 'deadline_exceeded';
            default:
                return 'internal_error';
        }
    }
    return 'unknown_error';
}
//# sourceMappingURL=span.js.map

/***/ }),

/***/ 33391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39472);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68252);
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55334);




/** JSDoc */
var Transaction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        _this._measurements = {};
        /**
         * The reference to the current hub.
         */
        _this._hub = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(hub, _sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .Hub */ .Xb)) {
            _this._hub = hub;
        }
        _this.name = transactionContext.name || '';
        _this.metadata = transactionContext.metadata || {};
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = _this;
        return _this;
    }
    /**
     * JSDoc
     */
    Transaction.prototype.setName = function (name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */
    Transaction.prototype.initSpanRecorder = function (maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        if (!this.spanRecorder) {
            this.spanRecorder = new _span__WEBPACK_IMPORTED_MODULE_3__/* .SpanRecorder */ .gB(maxlen);
        }
        this.spanRecorder.add(this);
    };
    /**
     * Set observed measurements for this transaction.
     * @hidden
     */
    Transaction.prototype.setMeasurements = function (measurements) {
        this._measurements = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, measurements);
    };
    /**
     * Set metadata for this transaction.
     * @hidden
     */
    Transaction.prototype.setMetadata = function (newMetadata) {
        this.metadata = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this.metadata), newMetadata);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.finish = function (endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) {
            return undefined;
        }
        if (!this.name) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.warn */ .k.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .k.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            var client = this._hub.getClient();
            var transport = client && client.getTransport && client.getTransport();
            if (transport && transport.recordLostEvent) {
                transport.recordLostEvent('sample_rate', 'transaction');
            }
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
                if (prev.endTimestamp && current.endTimestamp) {
                    return prev.endTimestamp > current.endTimestamp ? prev : current;
                }
                return prev;
            }).endTimestamp;
        }
        var transaction = {
            contexts: {
                trace: this.getTraceContext(),
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: this.metadata,
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .k.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .k.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
        return this._hub.captureEvent(transaction);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.toContext = function () {
        var spanContext = _super.prototype.toContext.call(this);
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .dropUndefinedKeys */ .Jr)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.updateWithContext = function (transactionContext) {
        var _a;
        _super.prototype.updateWithContext.call(this, transactionContext);
        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
        this._trimEnd = transactionContext.trimEnd;
        return this;
    };
    return Transaction;
}(_span__WEBPACK_IMPORTED_MODULE_3__/* .Span */ .Dr));

//# sourceMappingURL=transaction.js.map

/***/ }),

/***/ 63233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WB": function() { return /* binding */ secToMs; },
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "qG": function() { return /* binding */ extractTraceparentData; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39472);

var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$');
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(maybeOptions) {
    var client = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
    var options = maybeOptions || (client && client.getOptions());
    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === '1') {
            parentSampled = true;
        }
        else if (matches[3] === '0') {
            parentSampled = false;
        }
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2],
        };
    }
    return undefined;
}
/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
    var hub = maybeHub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    var scope = hub.getScope();
    return scope && scope.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
    return time / 1000;
}
/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
    return time * 1000;
}
// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l": function() { return /* binding */ getLocationHref; }
/* harmony export */ });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82991);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length
        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}
//# sourceMappingURL=browser.js.map

/***/ }),

/***/ 68518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ isDebugBuild; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/**
 * This module mostly exists for optimizations in the build process
 * through rollup and terser.  We define some global constants which
 * are normally undefined.  However terser overrides these with global
 * definitions which can be evaluated by the static analyzer when
 * creating a bundle.
 *
 * In turn the `isDebugBuild` and `isBrowserBundle` functions are pure
 * and can help us remove unused code from the bundles.
 */
/**
 * Figures out if we're building with debug functionality.
 *
 * @returns true if this is a debug build
 */
function isDebugBuild() {
    return typeof __SENTRY_NO_DEBUG__ !== 'undefined' && !__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
//# sourceMappingURL=env.js.map

/***/ }),

/***/ 82991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; }
/* harmony export */ });
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61422);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return ((0,_node__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
        ? __webpack_require__.g
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
//# sourceMappingURL=global.js.map

/***/ }),

/***/ 9732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68518);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67597);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68252);
/* harmony import */ var _stacktrace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30360);
/* harmony import */ var _supports__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8823);








var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            _logger__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .k.warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__values */ .XA)(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                if ((0,_env__WEBPACK_IMPORTED_MODULE_3__/* .isDebugBuild */ .c)()) {
                    _logger__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0,_stacktrace__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(handler) + "\nError: " + e);
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!(0,_supports__WEBPACK_IMPORTED_MODULE_6__/* .supportsNativeFetch */ .t$)()) {
        return;
    }
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = (xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            });
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.__sentry_xhr__ && args[0] !== undefined) {
                this.__sentry_xhr__.body = args[0];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!(0,_supports__WEBPACK_IMPORTED_MODULE_6__/* .supportsHistory */ .Bf)()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.history, 'pushState', historyReplacementFunction);
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = global.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    global.document.addEventListener('click', globalDOMEventHandler, false);
    global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (objectToString.call(wat)) {
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "k": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);

// TODO: Implement different loggers for different environments
var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/**
 * Temporarily unwrap `console.log` and friends in order to perform the given callback using the original methods.
 * Restores wrapping after the callback completes.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' '));
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "JY": function() { return /* binding */ parseRetryAfterHeader; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony exports parseSemver, addContextToFrame */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68252);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return firstException.type + ": " + firstException.value;
        }
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    var exception = (event.exception = event.exception || {});
    var values = (exception.values = exception.values || []);
    var firstException = (values[0] = values[0] || {});
    if (!firstException.value) {
        firstException.value = value || '';
    }
    if (!firstException.type) {
        firstException.type = type || 'Error';
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return snipLine(line, 0); });
    frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return snipLine(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0,_object__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(exception, '__sentry_captured__', true);
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ 61422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ loadModule; },
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68518);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(83454);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return (!(0,_env__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}
//# sourceMappingURL=node.js.map

/***/ }),

/***/ 68252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xp": function() { return /* binding */ addNonEnumerableProperty; },
  "Jr": function() { return /* binding */ dropUndefinedKeys; },
  "zf": function() { return /* binding */ extractExceptionKeysForMessage; },
  "hl": function() { return /* binding */ fill; },
  "HK": function() { return /* binding */ getOriginalFunction; },
  "$Q": function() { return /* binding */ markFunctionWrapped; },
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; },
  "_j": function() { return /* binding */ urlEncode; }
});

// UNUSED EXPORTS: objectify, walk

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < inner.length; i++) {
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        }
        else {
            for (var i = 0; i < inner.length; i++) {
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [memoize, unmemoize];
}
//# sourceMappingURL=memo.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/object.js






/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            markFunctionWrapped(wrapped, original);
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true,
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function getWalkSource(value) {
    if ((0,is/* isError */.VZ)(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if ((0,is/* isEvent */.cO)(value)) {
        var event_1 = value;
        var source = {};
        // Accessing event attributes can throw (see https://github.com/getsentry/sentry-javascript/issues/768 and
        // https://github.com/getsentry/sentry-javascript/issues/838), but accessing `type` hasn't been wrapped in a
        // try-catch in at least two years and no one's complained, so that's likely not an issue anymore
        source.type = event_1.type;
        try {
            source.target = (0,is/* isElement */.kK)(event_1.target)
                ? (0,browser/* htmlTreeAsString */.R)(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = (0,is/* isElement */.kK)(event_1.currentTarget)
                ? (0,browser/* htmlTreeAsString */.R)(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        if (typeof CustomEvent !== 'undefined' && (0,is/* isInstanceOf */.V9)(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var attr in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, attr)) {
                source[attr] = event_1[attr];
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */
function serializeValue(value) {
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    var type = Object.prototype.toString.call(value);
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return (0,is/* isPrimitive */.pt)(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
        return '[Global]';
    }
    // It's safe to use `window` and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.
    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
        return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + (0,stacktrace/* getFunctionName */.$P)(value) + "]";
    }
    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
    if (typeof value === 'symbol') {
        return "[" + String(value) + "]";
    }
    if (typeof value === 'bigint') {
        return "[BigInt: " + String(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = memoBuilder(); }
    // If we reach the maximum depth, serialize whatever is left
    if (depth === 0) {
        return serializeValue(value);
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    // If normalized value is a primitive, there are no branches left to walk, so bail out
    var normalized = normalizeValue(value, key);
    if ((0,is/* isPrimitive */.pt)(normalized)) {
        return normalized;
    }
    // Create source that we will use for the next iteration. It will either be an objectified error object (`Error` type
    // with extracted key:value pairs) or the input itself.
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo[0](value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo[1](value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function normalize(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return (0,string/* truncate */.$G)(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return (0,string/* truncate */.$G)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if ((0,is/* isPlainObject */.PO)(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = (0,tslib_es6/* __values */.XA)(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
    var objectified;
    switch (true) {
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
//# sourceMappingURL=object.js.map

/***/ }),

/***/ 30360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony export stripSentryFramesAndReverse */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);

var STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 * */
function createStackParser() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    return function (stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) { skipFirst = 0; }
        var frames = [];
        try {
            for (var _c = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var line = _d.value;
                try {
                    for (var parsers_1 = (e_2 = void 0, (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(parsers)), parsers_1_1 = parsers_1.next(); !parsers_1_1.done; parsers_1_1 = parsers_1.next()) {
                        var parser = parsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (parsers_1_1 && !parsers_1_1.done && (_b = parsers_1.return)) _b.call(parsers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
        .reverse();
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map

/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "zC": function() { return /* binding */ isMatchingPattern; }
/* harmony export */ });
/* unused harmony exports snipLine, escapeStringForRegex */
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) {
        return newLine;
    }
    if (colno > lineLength) {
        // eslint-disable-next-line no-param-reassign
        colno = lineLength;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) {
        end = lineLength;
    }
    if (end === lineLength) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < lineLength) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!(0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
        return false;
    }
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
//# sourceMappingURL=string.js.map

/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "hv": function() { return /* binding */ supportsReferrerPolicy; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsErrorEvent, supportsDOMError, supportsDOMException, supportsReportingObserver */
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68518);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            if ((0,_env__WEBPACK_IMPORTED_MODULE_1__/* .isDebugBuild */ .c)()) {
                _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .k.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
            }
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in getGlobalObject();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
    return new SyncPromise(function (resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
    return new SyncPromise(function (_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(1 /* RESOLVED */, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(2 /* REJECTED */, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== 0 /* PENDING */) {
                return;
            }
            if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === 0 /* PENDING */) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler[0]) {
                    return;
                }
                if (_this._state === 1 /* RESOLVED */) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler[1](_this._value);
                }
                if (_this._state === 2 /* REJECTED */) {
                    handler[2](_this._value);
                }
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._handlers.push([
                false,
                function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                    }
                    else {
                        try {
                            resolve(onfulfilled(result));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
                function (reason) {
                    if (!onrejected) {
                        reject(reason);
                    }
                    else {
                        try {
                            resolve(onrejected(reason));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports usingPerformanceAPI, _browserPerformanceTimeOriginMode */
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61422);
/* module decorator */ module = __webpack_require__.hmd(module);


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        }
        else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();
//# sourceMappingURL=time.js.map

/***/ }),

/***/ 16395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5eYLZhV95QU96koWyB8mY"};

/***/ }),

/***/ 21282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ tippy_react_esm; }
});

// UNUSED EXPORTS: tippy, useSingleton

;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js


function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js







function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js



function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/tippy.js/node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/tippy.js/dist/tippy.esm.js
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/


var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function tippy_esm_hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function tippy_esm_debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function tippy_esm_getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function tippy_esm_isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (tippy_esm_isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = tippy_esm_getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (false) {}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (false) {}

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !tippy_esm_hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (tippy_esm_isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function setContent(content, props) {
  if (tippy_esm_isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = tippy_esm_debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (false) {}

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = popper_createPopper(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (false) {}
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = tippy_esm_debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (false) {} // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (false) {} // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (false) {}

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (false) {}

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (false) { var isMoreThanOneReferenceElement, isSingleContentElement; }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return tippy_esm_isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  mountedInstances.forEach(function (instance) {
    var isExcluded = false;

    if (excludedReferenceOrInstance) {
      isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
    }

    if (!isExcluded) {
      var originalDuration = instance.props.duration;
      instance.setProps({
        duration: duration
      });
      instance.hide();

      if (!instance.state.isDestroyed) {
        instance.setProps({
          duration: originalDuration
        });
      }
    }
  });
};

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

var applyStylesModifier = Object.assign({}, modifiers_applyStyles, {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

var createSingleton = function createSingleton(tippyInstances, optionalProps) {
  var _optionalProps$popper;

  if (optionalProps === void 0) {
    optionalProps = {};
  }

  /* istanbul ignore else */
  if (false) {}

  var individualInstances = tippyInstances;
  var references = [];
  var triggerTargets = [];
  var currentTarget;
  var overrides = optionalProps.overrides;
  var interceptSetPropsCleanups = [];
  var shownOnCreate = false;

  function setTriggerTargets() {
    triggerTargets = individualInstances.map(function (instance) {
      return normalizeToArray(instance.props.triggerTarget || instance.reference);
    }).reduce(function (acc, item) {
      return acc.concat(item);
    }, []);
  }

  function setReferences() {
    references = individualInstances.map(function (instance) {
      return instance.reference;
    });
  }

  function enableInstances(isEnabled) {
    individualInstances.forEach(function (instance) {
      if (isEnabled) {
        instance.enable();
      } else {
        instance.disable();
      }
    });
  }

  function interceptSetProps(singleton) {
    return individualInstances.map(function (instance) {
      var originalSetProps = instance.setProps;

      instance.setProps = function (props) {
        originalSetProps(props);

        if (instance.reference === currentTarget) {
          singleton.setProps(props);
        }
      };

      return function () {
        instance.setProps = originalSetProps;
      };
    });
  } // have to pass singleton, as it maybe undefined on first call


  function prepareInstance(singleton, target) {
    var index = triggerTargets.indexOf(target); // bail-out

    if (target === currentTarget) {
      return;
    }

    currentTarget = target;
    var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
      acc[prop] = individualInstances[index].props[prop];
      return acc;
    }, {});
    singleton.setProps(Object.assign({}, overrideProps, {
      getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
        var _references$index;

        return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
      }
    }));
  }

  enableInstances(false);
  setReferences();
  setTriggerTargets();
  var plugin = {
    fn: function fn() {
      return {
        onDestroy: function onDestroy() {
          enableInstances(true);
        },
        onHidden: function onHidden() {
          currentTarget = null;
        },
        onClickOutside: function onClickOutside(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            currentTarget = null;
          }
        },
        onShow: function onShow(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            prepareInstance(instance, references[0]);
          }
        },
        onTrigger: function onTrigger(instance, event) {
          prepareInstance(instance, event.currentTarget);
        }
      };
    }
  };
  var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
    plugins: [plugin].concat(optionalProps.plugins || []),
    triggerTarget: triggerTargets,
    popperOptions: Object.assign({}, optionalProps.popperOptions, {
      modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
    })
  }));
  var originalShow = singleton.show;

  singleton.show = function (target) {
    originalShow(); // first time, showOnCreate or programmatic call with no params
    // default to showing first instance

    if (!currentTarget && target == null) {
      return prepareInstance(singleton, references[0]);
    } // triggered from event (do nothing as prepareInstance already called by onTrigger)
    // programmatic call with no params when already visible (do nothing again)


    if (currentTarget && target == null) {
      return;
    } // target is index of instance


    if (typeof target === 'number') {
      return references[target] && prepareInstance(singleton, references[target]);
    } // target is a child tippy instance


    if (individualInstances.indexOf(target) >= 0) {
      var ref = target.reference;
      return prepareInstance(singleton, ref);
    } // target is a ReferenceElement


    if (references.indexOf(target) >= 0) {
      return prepareInstance(singleton, target);
    }
  };

  singleton.showNext = function () {
    var first = references[0];

    if (!currentTarget) {
      return singleton.show(0);
    }

    var index = references.indexOf(currentTarget);
    singleton.show(references[index + 1] || first);
  };

  singleton.showPrevious = function () {
    var last = references[references.length - 1];

    if (!currentTarget) {
      return singleton.show(last);
    }

    var index = references.indexOf(currentTarget);
    var target = references[index - 1] || last;
    singleton.show(target);
  };

  var originalSetProps = singleton.setProps;

  singleton.setProps = function (props) {
    overrides = props.overrides || overrides;
    originalSetProps(props);
  };

  singleton.setInstances = function (nextInstances) {
    enableInstances(true);
    interceptSetPropsCleanups.forEach(function (fn) {
      return fn();
    });
    individualInstances = nextInstances;
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    interceptSetPropsCleanups = interceptSetProps(singleton);
    singleton.setProps({
      triggerTarget: triggerTargets
    });
  };

  interceptSetPropsCleanups = interceptSetProps(singleton);
  return singleton;
};

var BUBBLING_EVENTS_MAP = {
  mouseover: 'mouseenter',
  focusin: 'focus',
  click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */

function delegate(targets, props) {
  /* istanbul ignore else */
  if (false) {}

  var listeners = [];
  var childTippyInstances = [];
  var disabled = false;
  var target = props.target;
  var nativeProps = removeProperties(props, ['target']);
  var parentProps = Object.assign({}, nativeProps, {
    trigger: 'manual',
    touch: false
  });
  var childProps = Object.assign({
    touch: defaultProps.touch
  }, nativeProps, {
    showOnCreate: true
  });
  var returnValue = tippy(targets, parentProps);
  var normalizedReturnValue = normalizeToArray(returnValue);

  function onTrigger(event) {
    if (!event.target || disabled) {
      return;
    }

    var targetNode = event.target.closest(target);

    if (!targetNode) {
      return;
    } // Get relevant trigger with fallbacks:
    // 1. Check `data-tippy-trigger` attribute on target node
    // 2. Fallback to `trigger` passed to `delegate()`
    // 3. Fallback to `defaultProps.trigger`


    var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

    if (targetNode._tippy) {
      return;
    }

    if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
      return;
    }

    if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
      return;
    }

    var instance = tippy(targetNode, childProps);

    if (instance) {
      childTippyInstances = childTippyInstances.concat(instance);
    }
  }

  function on(node, eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    node.addEventListener(eventType, handler, options);
    listeners.push({
      node: node,
      eventType: eventType,
      handler: handler,
      options: options
    });
  }

  function addEventListeners(instance) {
    var reference = instance.reference;
    on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
    on(reference, 'mouseover', onTrigger);
    on(reference, 'focusin', onTrigger);
    on(reference, 'click', onTrigger);
  }

  function removeEventListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function applyMutations(instance) {
    var originalDestroy = instance.destroy;
    var originalEnable = instance.enable;
    var originalDisable = instance.disable;

    instance.destroy = function (shouldDestroyChildInstances) {
      if (shouldDestroyChildInstances === void 0) {
        shouldDestroyChildInstances = true;
      }

      if (shouldDestroyChildInstances) {
        childTippyInstances.forEach(function (instance) {
          instance.destroy();
        });
      }

      childTippyInstances = [];
      removeEventListeners();
      originalDestroy();
    };

    instance.enable = function () {
      originalEnable();
      childTippyInstances.forEach(function (instance) {
        return instance.enable();
      });
      disabled = false;
    };

    instance.disable = function () {
      originalDisable();
      childTippyInstances.forEach(function (instance) {
        return instance.disable();
      });
      disabled = true;
    };

    addEventListeners(instance);
  }

  normalizedReturnValue.forEach(applyMutations);
  return returnValue;
}

var animateFill = {
  name: 'animateFill',
  defaultValue: false,
  fn: function fn(instance) {
    var _instance$props$rende;

    // @ts-ignore
    if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
      if (false) {}

      return {};
    }

    var _getChildren = getChildren(instance.popper),
        box = _getChildren.box,
        content = _getChildren.content;

    var backdrop = instance.props.animateFill ? createBackdropElement() : null;
    return {
      onCreate: function onCreate() {
        if (backdrop) {
          box.insertBefore(backdrop, box.firstElementChild);
          box.setAttribute('data-animatefill', '');
          box.style.overflow = 'hidden';
          instance.setProps({
            arrow: false,
            animation: 'shift-away'
          });
        }
      },
      onMount: function onMount() {
        if (backdrop) {
          var transitionDuration = box.style.transitionDuration;
          var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
          // tooltip element. `clip-path` is the other alternative but is not
          // well-supported and is buggy on some devices.

          content.style.transitionDelay = Math.round(duration / 10) + "ms";
          backdrop.style.transitionDuration = transitionDuration;
          setVisibilityState([backdrop], 'visible');
        }
      },
      onShow: function onShow() {
        if (backdrop) {
          backdrop.style.transitionDuration = '0ms';
        }
      },
      onHide: function onHide() {
        if (backdrop) {
          setVisibilityState([backdrop], 'hidden');
        }
      }
    };
  }
};

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  setVisibilityState([backdrop], 'hidden');
  return backdrop;
}

var mouseCoords = {
  clientX: 0,
  clientY: 0
};
var activeInstances = [];

function storeMouseCoords(_ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  mouseCoords = {
    clientX: clientX,
    clientY: clientY
  };
}

function addMouseCoordsListener(doc) {
  doc.addEventListener('mousemove', storeMouseCoords);
}

function removeMouseCoordsListener(doc) {
  doc.removeEventListener('mousemove', storeMouseCoords);
}

var followCursor = {
  name: 'followCursor',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    var doc = getOwnerDocument(instance.props.triggerTarget || reference);
    var isInternalUpdate = false;
    var wasFocusEvent = false;
    var isUnmounted = true;
    var prevProps = instance.props;

    function getIsInitialBehavior() {
      return instance.props.followCursor === 'initial' && instance.state.isVisible;
    }

    function addListener() {
      doc.addEventListener('mousemove', onMouseMove);
    }

    function removeListener() {
      doc.removeEventListener('mousemove', onMouseMove);
    }

    function unsetGetReferenceClientRect() {
      isInternalUpdate = true;
      instance.setProps({
        getReferenceClientRect: null
      });
      isInternalUpdate = false;
    }

    function onMouseMove(event) {
      // If the instance is interactive, avoid updating the position unless it's
      // over the reference element
      var isCursorOverReference = event.target ? reference.contains(event.target) : true;
      var followCursor = instance.props.followCursor;
      var clientX = event.clientX,
          clientY = event.clientY;
      var rect = reference.getBoundingClientRect();
      var relativeX = clientX - rect.left;
      var relativeY = clientY - rect.top;

      if (isCursorOverReference || !instance.props.interactive) {
        instance.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function getReferenceClientRect() {
            var rect = reference.getBoundingClientRect();
            var x = clientX;
            var y = clientY;

            if (followCursor === 'initial') {
              x = rect.left + relativeX;
              y = rect.top + relativeY;
            }

            var top = followCursor === 'horizontal' ? rect.top : y;
            var right = followCursor === 'vertical' ? rect.right : x;
            var bottom = followCursor === 'horizontal' ? rect.bottom : y;
            var left = followCursor === 'vertical' ? rect.left : x;
            return {
              width: right - left,
              height: bottom - top,
              top: top,
              right: right,
              bottom: bottom,
              left: left
            };
          }
        });
      }
    }

    function create() {
      if (instance.props.followCursor) {
        activeInstances.push({
          instance: instance,
          doc: doc
        });
        addMouseCoordsListener(doc);
      }
    }

    function destroy() {
      activeInstances = activeInstances.filter(function (data) {
        return data.instance !== instance;
      });

      if (activeInstances.filter(function (data) {
        return data.doc === doc;
      }).length === 0) {
        removeMouseCoordsListener(doc);
      }
    }

    return {
      onCreate: create,
      onDestroy: destroy,
      onBeforeUpdate: function onBeforeUpdate() {
        prevProps = instance.props;
      },
      onAfterUpdate: function onAfterUpdate(_, _ref2) {
        var followCursor = _ref2.followCursor;

        if (isInternalUpdate) {
          return;
        }

        if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
          destroy();

          if (followCursor) {
            create();

            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
              addListener();
            }
          } else {
            removeListener();
            unsetGetReferenceClientRect();
          }
        }
      },
      onMount: function onMount() {
        if (instance.props.followCursor && !wasFocusEvent) {
          if (isUnmounted) {
            onMouseMove(mouseCoords);
            isUnmounted = false;
          }

          if (!getIsInitialBehavior()) {
            addListener();
          }
        }
      },
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          mouseCoords = {
            clientX: event.clientX,
            clientY: event.clientY
          };
        }

        wasFocusEvent = event.type === 'focus';
      },
      onHidden: function onHidden() {
        if (instance.props.followCursor) {
          unsetGetReferenceClientRect();
          removeListener();
          isUnmounted = true;
        }
      }
    };
  }
};

function getProps(props, modifier) {
  var _props$popperOptions;

  return {
    popperOptions: Object.assign({}, props.popperOptions, {
      modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
        var name = _ref.name;
        return name !== modifier.name;
      }), [modifier])
    })
  };
}

var inlinePositioning = {
  name: 'inlinePositioning',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;

    function isEnabled() {
      return !!instance.props.inlinePositioning;
    }

    var placement;
    var cursorRectIndex = -1;
    var isInternalUpdate = false;
    var triedPlacements = [];
    var modifier = {
      name: 'tippyInlinePositioning',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (isEnabled()) {
          if (triedPlacements.indexOf(state.placement) !== -1) {
            triedPlacements = [];
          }

          if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
            triedPlacements.push(state.placement);
            instance.setProps({
              // @ts-ignore - unneeded DOMRect properties
              getReferenceClientRect: function getReferenceClientRect() {
                return _getReferenceClientRect(state.placement);
              }
            });
          }

          placement = state.placement;
        }
      }
    };

    function _getReferenceClientRect(placement) {
      return getInlineBoundingClientRect(tippy_esm_getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
    }

    function setInternalProps(partialProps) {
      isInternalUpdate = true;
      instance.setProps(partialProps);
      isInternalUpdate = false;
    }

    function addModifier() {
      if (!isInternalUpdate) {
        setInternalProps(getProps(instance.props, modifier));
      }
    }

    return {
      onCreate: addModifier,
      onAfterUpdate: addModifier,
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          var rects = arrayFrom(instance.reference.getClientRects());
          var cursorRect = rects.find(function (rect) {
            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
          });
          var index = rects.indexOf(cursorRect);
          cursorRectIndex = index > -1 ? index : cursorRectIndex;
        }
      },
      onHidden: function onHidden() {
        cursorRectIndex = -1;
      }
    };
  }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
  // Not an inline element, or placement is not yet known
  if (clientRects.length < 2 || currentBasePlacement === null) {
    return boundingRect;
  } // There are two rects and they are disjoined


  if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
    return clientRects[cursorRectIndex] || boundingRect;
  }

  switch (currentBasePlacement) {
    case 'top':
    case 'bottom':
      {
        var firstRect = clientRects[0];
        var lastRect = clientRects[clientRects.length - 1];
        var isTop = currentBasePlacement === 'top';
        var top = firstRect.top;
        var bottom = lastRect.bottom;
        var left = isTop ? firstRect.left : lastRect.left;
        var right = isTop ? firstRect.right : lastRect.right;
        var width = right - left;
        var height = bottom - top;
        return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height
        };
      }

    case 'left':
    case 'right':
      {
        var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
          return rects.left;
        }));
        var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
          return rects.right;
        }));
        var measureRects = clientRects.filter(function (rect) {
          return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
        });
        var _top = measureRects[0].top;
        var _bottom = measureRects[measureRects.length - 1].bottom;
        var _left = minLeft;
        var _right = maxRight;

        var _width = _right - _left;

        var _height = _bottom - _top;

        return {
          top: _top,
          bottom: _bottom,
          left: _left,
          right: _right,
          width: _width,
          height: _height
        };
      }

    default:
      {
        return boundingRect;
      }
  }
}

var sticky = {
  name: 'sticky',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference,
        popper = instance.popper;

    function getReference() {
      return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
    }

    function shouldCheck(value) {
      return instance.props.sticky === true || instance.props.sticky === value;
    }

    var prevRefRect = null;
    var prevPopRect = null;

    function updatePosition() {
      var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
      var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;

      if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
        if (instance.popperInstance) {
          instance.popperInstance.update();
        }
      }

      prevRefRect = currentRefRect;
      prevPopRect = currentPopRect;

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }

    return {
      onMount: function onMount() {
        if (instance.props.sticky) {
          updatePosition();
        }
      }
    };
  }
};

function areRectsDifferent(rectA, rectB) {
  if (rectA && rectB) {
    return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
  }

  return true;
}

tippy.setDefaultProps({
  render: render
});

/* harmony default export */ var tippy_esm = (tippy);

//# sourceMappingURL=tippy.esm.js.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@tippyjs/react/dist/tippy-react.esm.js





function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var tippy_react_esm_isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function preserveRef(ref, node) {
  if (ref) {
    if (typeof ref === 'function') {
      ref(node);
    }

    if ({}.hasOwnProperty.call(ref, 'current')) {
      ref.current = node;
    }
  }
}
function ssrSafeCreateDiv() {
  return tippy_react_esm_isBrowser && document.createElement('div');
}
function toDataAttributes(attrs) {
  var dataAttrs = {
    'data-placement': attrs.placement
  };

  if (attrs.referenceHidden) {
    dataAttrs['data-reference-hidden'] = '';
  }

  if (attrs.escaped) {
    dataAttrs['data-escaped'] = '';
  }

  return dataAttrs;
}

function deepEqual(x, y) {
  if (x === y) {
    return true;
  } else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
    if (Object.keys(x).length !== Object.keys(y).length) {
      return false;
    }

    for (var prop in x) {
      if (y.hasOwnProperty(prop)) {
        if (!deepEqual(x[prop], y[prop])) {
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
}

function uniqueByShape(arr) {
  var output = [];
  arr.forEach(function (item) {
    if (!output.find(function (outputItem) {
      return deepEqual(item, outputItem);
    })) {
      output.push(item);
    }
  });
  return output;
}
function deepPreserveProps(instanceProps, componentProps) {
  var _instanceProps$popper, _componentProps$poppe;

  return Object.assign({}, componentProps, {
    popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
      modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
    })
  });
}

var useIsomorphicLayoutEffect = tippy_react_esm_isBrowser ? react.useLayoutEffect : react.useEffect;
function useMutableBox(initialValue) {
  // Using refs instead of state as it's recommended to not store imperative
  // values in state due to memory problems in React(?)
  var ref = (0,react.useRef)();

  if (!ref.current) {
    ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
  }

  return ref.current;
}

function updateClassName(box, action, classNames) {
  classNames.split(/\s+/).forEach(function (name) {
    if (name) {
      box.classList[action](name);
    }
  });
}

var classNamePlugin = {
  name: 'className',
  defaultValue: '',
  fn: function fn(instance) {
    var box = instance.popper.firstElementChild;

    var isDefaultRenderFn = function isDefaultRenderFn() {
      var _instance$props$rende;

      return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
    };

    function add() {
      if (instance.props.className && !isDefaultRenderFn()) {
        if (false) {}

        return;
      }

      updateClassName(box, 'add', instance.props.className);
    }

    function remove() {
      if (isDefaultRenderFn()) {
        updateClassName(box, 'remove', instance.props.className);
      }
    }

    return {
      onCreate: add,
      onBeforeUpdate: remove,
      onAfterUpdate: add
    };
  }
};

function TippyGenerator(tippy) {
  function Tippy(_ref) {
    var children = _ref.children,
        content = _ref.content,
        visible = _ref.visible,
        singleton = _ref.singleton,
        render = _ref.render,
        reference = _ref.reference,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$ignoreAttributes = _ref.ignoreAttributes,
        ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes,
        __source = _ref.__source,
        __self = _ref.__self,
        restOfNativeProps = _objectWithoutPropertiesLoose(_ref, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]);

    var isControlledMode = visible !== undefined;
    var isSingletonMode = singleton !== undefined;

    var _useState = (0,react.useState)(false),
        mounted = _useState[0],
        setMounted = _useState[1];

    var _useState2 = (0,react.useState)({}),
        attrs = _useState2[0],
        setAttrs = _useState2[1];

    var _useState3 = (0,react.useState)(),
        singletonContent = _useState3[0],
        setSingletonContent = _useState3[1];

    var mutableBox = useMutableBox(function () {
      return {
        container: ssrSafeCreateDiv(),
        renders: 1
      };
    });
    var props = Object.assign({
      ignoreAttributes: ignoreAttributes
    }, restOfNativeProps, {
      content: mutableBox.container
    });

    if (isControlledMode) {
      if (false) {}

      props.trigger = 'manual';
      props.hideOnClick = false;
    }

    if (isSingletonMode) {
      disabled = true;
    }

    var computedProps = props;
    var plugins = props.plugins || [];

    if (render) {
      computedProps = Object.assign({}, props, {
        plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [{
          fn: function fn() {
            return {
              onTrigger: function onTrigger(instance, event) {
                var node = singleton.data.children.find(function (_ref2) {
                  var instance = _ref2.instance;
                  return instance.reference === event.currentTarget;
                });
                instance.state.$$activeSingletonInstance = node.instance;
                setSingletonContent(node.content);
              }
            };
          }
        }]) : plugins,
        render: function render() {
          return {
            popper: mutableBox.container
          };
        }
      });
    }

    var deps = [reference].concat(children ? [children.type] : []); // CREATE

    useIsomorphicLayoutEffect(function () {
      var element = reference;

      if (reference && reference.hasOwnProperty('current')) {
        element = reference.current;
      }

      var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
        plugins: [classNamePlugin].concat(props.plugins || [])
      }));
      mutableBox.instance = instance;

      if (disabled) {
        instance.disable();
      }

      if (visible) {
        instance.show();
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps,
          setSingletonContent: setSingletonContent
        });
      }

      setMounted(true);
      return function () {
        instance.destroy();
        singleton == null ? void 0 : singleton.cleanup(instance);
      };
    }, deps); // UPDATE

    useIsomorphicLayoutEffect(function () {
      var _instance$popperInsta;

      // Prevent this effect from running on 1st render
      if (mutableBox.renders === 1) {
        mutableBox.renders++;
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps(deepPreserveProps(instance.props, computedProps)); // Fixes #264

      (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.forceUpdate();

      if (disabled) {
        instance.disable();
      } else {
        instance.enable();
      }

      if (isControlledMode) {
        if (visible) {
          instance.show();
        } else {
          instance.hide();
        }
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps,
          setSingletonContent: setSingletonContent
        });
      }
    });
    useIsomorphicLayoutEffect(function () {
      var _instance$props$poppe;

      if (!render) {
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps({
        popperOptions: Object.assign({}, instance.props.popperOptions, {
          modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function (_ref3) {
            var name = _ref3.name;
            return name !== '$$tippyReact';
          }), [{
            name: '$$tippyReact',
            enabled: true,
            phase: 'beforeWrite',
            requires: ['computeStyles'],
            fn: function fn(_ref4) {
              var _state$modifiersData;

              var state = _ref4.state;
              var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
              // loop. This expression _must_ evaluate to false when required

              if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) {
                setAttrs({
                  placement: state.placement,
                  referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                  escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                });
              }

              state.attributes.popper = {};
            }
          }])
        })
      });
    }, [attrs.placement, attrs.referenceHidden, attrs.escaped].concat(deps));
    return /*#__PURE__*/react.createElement(react.Fragment, null, children ? /*#__PURE__*/(0,react.cloneElement)(children, {
      ref: function ref(node) {
        mutableBox.ref = node;
        preserveRef(children.ref, node);
      }
    }) : null, mounted && /*#__PURE__*/(0,react_dom.createPortal)(render ? render(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
  }

  return Tippy;
}

function useSingletonGenerator(createSingleton) {
  return function useSingleton(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$overrides = _ref.overrides,
        overrides = _ref$overrides === void 0 ? [] : _ref$overrides;

    var _useState = (0,react.useState)(false),
        mounted = _useState[0],
        setMounted = _useState[1];

    var mutableBox = useMutableBox({
      children: [],
      renders: 1
    });
    useIsomorphicLayoutEffect(function () {
      if (!mounted) {
        setMounted(true);
        return;
      }

      var children = mutableBox.children,
          sourceData = mutableBox.sourceData;

      if (!sourceData) {
        if (false) {}

        return;
      }

      var instance = createSingleton(children.map(function (child) {
        return child.instance;
      }), Object.assign({}, sourceData.props, {
        popperOptions: sourceData.instance.props.popperOptions,
        overrides: overrides,
        plugins: [classNamePlugin].concat(sourceData.props.plugins || [])
      }));
      mutableBox.instance = instance;

      if (disabled) {
        instance.disable();
      }

      return function () {
        instance.destroy();
        mutableBox.children = children.filter(function (_ref2) {
          var instance = _ref2.instance;
          return !instance.state.isDestroyed;
        });
      };
    }, [mounted]);
    useIsomorphicLayoutEffect(function () {
      if (!mounted) {
        return;
      }

      if (mutableBox.renders === 1) {
        mutableBox.renders++;
        return;
      }

      var children = mutableBox.children,
          instance = mutableBox.instance,
          sourceData = mutableBox.sourceData;

      if (!(instance && sourceData)) {
        return;
      }

      var _sourceData$props = sourceData.props,
          content = _sourceData$props.content,
          props = _objectWithoutPropertiesLoose(_sourceData$props, ["content"]);

      instance.setProps(deepPreserveProps(instance.props, Object.assign({}, props, {
        overrides: overrides
      })));
      instance.setInstances(children.map(function (child) {
        return child.instance;
      }));

      if (disabled) {
        instance.disable();
      } else {
        instance.enable();
      }
    });
    return (0,react.useMemo)(function () {
      var source = {
        data: mutableBox,
        hook: function hook(data) {
          mutableBox.sourceData = data;
          mutableBox.setSingletonContent = data.setSingletonContent;
        },
        cleanup: function cleanup() {
          mutableBox.sourceData = null;
        }
      };
      var target = {
        hook: function hook(data) {
          var _mutableBox$instance, _mutableBox$instance2;

          mutableBox.children = mutableBox.children.filter(function (_ref3) {
            var instance = _ref3.instance;
            return data.instance !== instance;
          });
          mutableBox.children.push(data);

          if (((_mutableBox$instance = mutableBox.instance) == null ? void 0 : _mutableBox$instance.state.isMounted) && ((_mutableBox$instance2 = mutableBox.instance) == null ? void 0 : _mutableBox$instance2.state.$$activeSingletonInstance) === data.instance) {
            mutableBox.setSingletonContent == null ? void 0 : mutableBox.setSingletonContent(data.content);
          }

          if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) {
            mutableBox.instance.setInstances(mutableBox.children.map(function (child) {
              return child.instance;
            }));
          }
        },
        cleanup: function cleanup(instance) {
          mutableBox.children = mutableBox.children.filter(function (data) {
            return data.instance !== instance;
          });

          if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) {
            mutableBox.instance.setInstances(mutableBox.children.map(function (child) {
              return child.instance;
            }));
          }
        }
      };
      return [source, target];
    }, []);
  };
}

var forwardRef = (function (Tippy, defaultProps) {
  return /*#__PURE__*/(0,react.forwardRef)(function TippyWrapper(_ref, _ref2) {
    var children = _ref.children,
        props = _objectWithoutPropertiesLoose(_ref, ["children"]);

    return (
      /*#__PURE__*/
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      react.createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/(0,react.cloneElement)(children, {
        ref: function ref(node) {
          preserveRef(_ref2, node);
          preserveRef(children.ref, node);
        }
      }) : null)
    );
  });
});

var useSingleton = /*#__PURE__*/useSingletonGenerator(createSingleton);
var index = /*#__PURE__*/forwardRef( /*#__PURE__*/TippyGenerator(tippy_esm));

/* harmony default export */ var tippy_react_esm = (index);

//# sourceMappingURL=tippy-react.esm.js.map


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var createError = __webpack_require__(85061);
var defaults = __webpack_require__(45655);
var Cancel = __webpack_require__(65263);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(85496);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65263);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 65263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 85496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 85061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(80481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45655);
var Cancel = __webpack_require__(65263);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 80481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(85061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var enhanceError = __webpack_require__(80481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.24.0"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 21924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBind = __webpack_require__(55559);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 55559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var GetIntrinsic = __webpack_require__(40210);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 11227:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(11658);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),

/***/ 11658:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(57824);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 63494:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const client_1 = __importDefault(__webpack_require__(29401));
const device_1 = __importDefault(__webpack_require__(10523));
const operating_system_1 = __importDefault(__webpack_require__(5247));
const vendor_fragment_1 = __importDefault(__webpack_require__(921));
const browser_1 = __importDefault(__webpack_require__(36804));
const BotParser = __webpack_require__(55397);
const user_agent_1 = __webpack_require__(42042);
const version_compare_1 = __webpack_require__(32862);
class DeviceDetector {
    constructor(options) {
        // Default options
        this.options = {
            skipBotDetection: false,
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            const result = {
                client: this.clientParser.parse(userAgent),
                os: this.operatingSystemParser.parse(userAgent),
                device: this.deviceParser.parse(userAgent),
                bot: this.options.skipBotDetection ? null : this.botParser.parse(userAgent)
            };
            const osName = (_a = result.os) === null || _a === void 0 ? void 0 : _a.name;
            const osVersion = (_b = result.os) === null || _b === void 0 ? void 0 : _b.version;
            const osFamily = operating_system_1.default.getOsFamily(osName || "");
            if (!((_c = result.device) === null || _c === void 0 ? void 0 : _c.brand)) {
                const brand = this.vendorFragmentParser.parse(userAgent);
                if (brand) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.brand = brand;
                }
            }
            /**
             * Assume all devices running iOS / Mac OS are from Apple
             */
            if (!((_d = result.device) === null || _d === void 0 ? void 0 : _d.brand) && ["Apple TV", "watchOS", "iOS", "Mac"].includes(osName || "")) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.brand = "Apple";
            }
            /**
             * Chrome on Android passes the device type based on the keyword 'Mobile'
             * If it is present the device should be a smartphone, otherwise it's a tablet
             * See https://developer.chrome.com/multidevice/user-agent#chrome_for_android_user_agent
             * Note: We do not check for browser (family) here, as there might be mobile apps using Chrome, that won't have
             *       a detected browser, but can still be detected. So we check the useragent for Chrome instead.
             */
            if (!((_e = result.device) === null || _e === void 0 ? void 0 : _e.type) && osFamily === "Android" && user_agent_1.userAgentParser("Chrome/[\\.0-9]*", userAgent)) {
                if (user_agent_1.userAgentParser("Chrome/[.0-9]* (?:Mobile|eliboM)", userAgent)) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.type = "smartphone";
                }
                else if (user_agent_1.userAgentParser("Chrome/[.0-9]* (?!Mobile)", userAgent)) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.type = "tablet";
                }
            }
            /**
             * Some user agents simply contain the fragment 'Android; Tablet;' or 'Opera Tablet', so we assume those devices are tablets
             */
            if (!((_f = result.device) === null || _f === void 0 ? void 0 : _f.type) && this.hasAndroidTabletFragment(userAgent) || user_agent_1.userAgentParser("Opera Tablet", userAgent)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "tablet";
            }
            /**
             * Some user agents simply contain the fragment 'Android; Mobile;', so we assume those devices are smartphones
             */
            if (!((_g = result.device) === null || _g === void 0 ? void 0 : _g.type) && this.hasAndroidMobileFragment(userAgent)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "smartphone";
            }
            /**
             * Android up to 3.0 was designed for smartphones only. But as 3.0, which was tablet only, was published
             * too late, there were a bunch of tablets running with 2.x
             * With 4.0 the two trees were merged and it is for smartphones and tablets
             *
             * So were are expecting that all devices running Android < 2 are smartphones
             * Devices running Android 3.X are tablets. Device type of Android 2.X and 4.X+ are unknown
             */
            if (!((_h = result.device) === null || _h === void 0 ? void 0 : _h.type) && osName === "Android" && osVersion !== "") {
                if (version_compare_1.versionCompare(osVersion, "2.0") === -1) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.type = "smartphone";
                }
                else if (version_compare_1.versionCompare(osVersion, "3.0") >= 0 && version_compare_1.versionCompare(osVersion, "4.0") === -1) {
                    if (!result.device) {
                        result.device = this.createDeviceObject();
                    }
                    result.device.type = "tablet";
                }
            }
            /**
             * All detected feature phones running android are more likely smartphones
             */
            if (((_j = result.device) === null || _j === void 0 ? void 0 : _j.type) === "feature phone" && osFamily === "Android") {
                result.device.type = "smartphone";
            }
            /**
             * According to http://msdn.microsoft.com/en-us/library/ie/hh920767(v=vs.85).aspx
             * Internet Explorer 10 introduces the "Touch" UA string token. If this token is present at the end of the
             * UA string, the computer has touch capability, and is running Windows 8 (or later).
             * This UA string will be transmitted on a touch-enabled system running Windows 8 (RT)
             *
             * As most touch enabled devices are tablets and only a smaller part are desktops/notebooks we assume that
             * all Windows 8 touch devices are tablets.
             */
            if (!((_k = result.device) === null || _k === void 0 ? void 0 : _k.type)
                && this.isToucheEnabled(userAgent)
                && (osName === "Windows RT"
                    || (osName === "Windows"
                        && version_compare_1.versionCompare(osVersion, "8.0") >= 0))) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "tablet";
            }
            /**
             * All devices running Opera TV Store are assumed to be televisions
             */
            if (user_agent_1.userAgentParser("Opera TV Store", userAgent)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "television";
            }
            /**
             * All devices running Tizen TV or SmartTV are assumed to be televisions
             */
            if (user_agent_1.userAgentParser("SmartTV|Tizen.+ TV .+$", userAgent)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "television";
            }
            /**
             * Devices running Kylo or Espital TV Browsers are assumed to be televisions
             */
            if (!((_l = result.device) === null || _l === void 0 ? void 0 : _l.type) && ["Kylo", "Espial TV Browser"].includes(((_m = result.client) === null || _m === void 0 ? void 0 : _m.name) || "")) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "television";
            }
            /**
             * Set device type to desktop if string ua contains desktop
             */
            const hasDesktop = "desktop" !== ((_o = result.device) === null || _o === void 0 ? void 0 : _o.type)
                && null !== user_agent_1.userAgentParser("Desktop", userAgent)
                && this.hasDesktopFragment(userAgent);
            if (hasDesktop) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "desktop";
            }
            // set device type to desktop for all devices running a desktop os that were not detected as an other device type
            if (!((_p = result.device) === null || _p === void 0 ? void 0 : _p.type) && this.isDesktop(result, osFamily)) {
                if (!result.device) {
                    result.device = this.createDeviceObject();
                }
                result.device.type = "desktop";
            }
            return result;
        };
        this.hasAndroidMobileFragment = (userAgent) => {
            return user_agent_1.userAgentParser("Android( [\.0-9]+)?; Mobile;", userAgent);
        };
        this.hasAndroidTabletFragment = (userAgent) => {
            return user_agent_1.userAgentParser("Android( [\.0-9]+)?; Tablet;", userAgent);
        };
        this.hasDesktopFragment = (userAgent) => {
            return user_agent_1.userAgentParser("Desktop (x(?:32|64)|WOW64);", userAgent);
        };
        this.isDesktop = (result, osFamily) => {
            if (!result.os) {
                return false;
            }
            // Check for browsers available for mobile devices only
            if (this.usesMobileBrowser(result.client)) {
                return false;
            }
            return operating_system_1.default.getDesktopOsArray().includes(osFamily);
        };
        this.usesMobileBrowser = (client) => {
            var _a, _b;
            if (!client)
                return false;
            return ((_a = client) === null || _a === void 0 ? void 0 : _a.type) === "browser" && browser_1.default.isMobileOnlyBrowser((_b = client) === null || _b === void 0 ? void 0 : _b.name);
        };
        this.isToucheEnabled = (userAgent) => {
            return user_agent_1.userAgentParser("Touch", userAgent);
        };
        this.createDeviceObject = () => ({
            type: "",
            brand: "",
            model: ""
        });
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.clientParser = new client_1.default(this.options);
        this.deviceParser = new device_1.default();
        this.operatingSystemParser = new operating_system_1.default(this.options);
        this.vendorFragmentParser = new vendor_fragment_1.default();
        this.botParser = new BotParser();
    }
}
module.exports = DeviceDetector;


/***/ }),

/***/ 55397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const bots_json_1 = __importDefault(__webpack_require__(24829));
const user_agent_1 = __webpack_require__(42042);
class BotParser {
    constructor() {
        this.parse = (userAgent) => {
            var _a, _b, _c, _d;
            for (const bot of bots_json_1.default) {
                const match = user_agent_1.userAgentParser(bot.regex, userAgent);
                if (!match)
                    continue;
                return {
                    name: bot.name,
                    category: bot.category || "",
                    url: bot.url || "",
                    producer: {
                        name: ((_b = (_a = bot) === null || _a === void 0 ? void 0 : _a.producer) === null || _b === void 0 ? void 0 : _b.name) || "",
                        url: ((_d = (_c = bot) === null || _c === void 0 ? void 0 : _c.producer) === null || _d === void 0 ? void 0 : _d.url) || ""
                    }
                };
            }
            return null;
        };
    }
}
module.exports = BotParser;


/***/ }),

/***/ 36804:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const version_1 = __webpack_require__(87729);
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
const browsers_json_1 = __importDefault(__webpack_require__(67759));
const browser_engine_json_1 = __importDefault(__webpack_require__(27039));
const available_browsers_json_1 = __importDefault(__webpack_require__(43005));
const mobile_only_browsers_json_1 = __importDefault(__webpack_require__(56643));
class BrowserParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: "",
                engine: "",
                engineVersion: ""
            };
            for (const browser of browsers_json_1.default) {
                const match = user_agent_1.userAgentParser(browser.regex, userAgent);
                if (!match)
                    continue;
                const vrpVersion = variable_replacement_1.variableReplacement(browser.version, match);
                const version = version_1.formatVersion(vrpVersion, this.options.versionTruncation);
                const shortVersion = version && parseFloat(version_1.formatVersion(vrpVersion, 1)) || "";
                if (browser.engine) {
                    result.engine = browser.engine.default;
                    if (browser.engine && browser.engine.versions && shortVersion) {
                        const sortedEngineVersions = Object.entries(browser.engine.versions).sort((a, b) => {
                            return parseFloat(a[0]) > parseFloat(b[0]) ? 1 : -1;
                        });
                        for (const [versionThreshold, engineByVersion] of sortedEngineVersions) {
                            if (parseFloat(versionThreshold) <= shortVersion) {
                                result.engine = engineByVersion || "";
                            }
                        }
                    }
                }
                result.type = "browser";
                result.name = variable_replacement_1.variableReplacement(browser.name, match);
                result.version = version;
                break;
            }
            if (!result.engine) {
                for (const browserEngine of browser_engine_json_1.default) {
                    let match = null;
                    try {
                        match = RegExp(browserEngine.regex, "i").exec(userAgent);
                    }
                    catch (_a) {
                        // TODO: find out why it fails in some browsers
                    }
                    if (!match)
                        continue;
                    result.engine = browserEngine.name;
                    break;
                }
            }
            result.engineVersion = version_1.formatVersion(version_1.parseBrowserEngineVersion(userAgent, result.engine), this.options.versionTruncation);
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
exports["default"] = BrowserParser;
BrowserParser.getBrowserShortName = (browserName) => {
    for (const [shortName, name] of Object.entries(available_browsers_json_1.default)) {
        if (name === browserName) {
            return shortName;
        }
    }
    return "";
};
BrowserParser.isMobileOnlyBrowser = (browserName) => {
    return mobile_only_browsers_json_1.default.includes(BrowserParser.getBrowserShortName(browserName));
};


/***/ }),

/***/ 80371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const feed_readers_json_1 = __importDefault(__webpack_require__(60169));
const version_1 = __webpack_require__(87729);
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class FeedReaderParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: "",
                url: ""
            };
            for (const feedReader of feed_readers_json_1.default) {
                const match = user_agent_1.userAgentParser(feedReader.regex, userAgent);
                if (!match)
                    continue;
                result.type = "feed reader";
                result.name = variable_replacement_1.variableReplacement(feedReader.name, match);
                result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(feedReader.version, match), this.options.versionTruncation);
                result.url = feedReader.url;
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
exports["default"] = FeedReaderParser;


/***/ }),

/***/ 29401:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const browser_1 = __importDefault(__webpack_require__(36804));
const mobile_apps_1 = __importDefault(__webpack_require__(81532));
const feed_readers_1 = __importDefault(__webpack_require__(80371));
const libraries_1 = __importDefault(__webpack_require__(90006));
const media_players_1 = __importDefault(__webpack_require__(15177));
const personal_information_managers_1 = __importDefault(__webpack_require__(74490));
const clientParsers = [
    feed_readers_1.default,
    mobile_apps_1.default,
    media_players_1.default,
    personal_information_managers_1.default,
    browser_1.default,
    libraries_1.default
];
class ClientParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            for (const Parser of clientParsers) {
                const parser = new Parser(this.options);
                const client = parser.parse(userAgent);
                if (client.type !== "")
                    return client;
            }
            return null;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
exports["default"] = ClientParser;


/***/ }),

/***/ 90006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const libraries_json_1 = __importDefault(__webpack_require__(18561));
const version_1 = __webpack_require__(87729);
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class LibraryParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: "",
                url: ""
            };
            for (const library of libraries_json_1.default) {
                const match = user_agent_1.userAgentParser(library.regex, userAgent);
                if (!match)
                    continue;
                result.type = "library";
                result.name = variable_replacement_1.variableReplacement(library.name, match);
                result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(library.version, match), this.options.versionTruncation);
                result.url = library.url || "";
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
exports["default"] = LibraryParser;


/***/ }),

/***/ 15177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mediaplayers_json_1 = __importDefault(__webpack_require__(41659));
const version_1 = __webpack_require__(87729);
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class MediaPlayerParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: ""
            };
            for (const mediaPlayer of mediaplayers_json_1.default) {
                const match = user_agent_1.userAgentParser(mediaPlayer.regex, userAgent);
                if (!match)
                    continue;
                result.type = "media player";
                result.name = variable_replacement_1.variableReplacement(mediaPlayer.name, match);
                result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(mediaPlayer.version, match), this.options.versionTruncation);
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
exports["default"] = MediaPlayerParser;


/***/ }),

/***/ 81532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobile_apps_json_1 = __importDefault(__webpack_require__(92115));
const version_1 = __webpack_require__(87729);
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class MobileAppParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: ""
            };
            for (const mobileApp of mobile_apps_json_1.default) {
                const match = user_agent_1.userAgentParser(mobileApp.regex, userAgent);
                if (!match)
                    continue;
                result.type = "mobile app";
                result.name = variable_replacement_1.variableReplacement(mobileApp.name, match);
                result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(mobileApp.version, match), this.options.versionTruncation);
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
exports["default"] = MobileAppParser;


/***/ }),

/***/ 74490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const pim_json_1 = __importDefault(__webpack_require__(77182));
const version_1 = __webpack_require__(87729);
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class PersonalInformationManagerParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                type: "",
                name: "",
                version: ""
            };
            for (const personalInformationManager of pim_json_1.default) {
                const match = user_agent_1.userAgentParser(personalInformationManager.regex, userAgent);
                if (!match)
                    continue;
                result.type = "personal information manager";
                result.name = variable_replacement_1.variableReplacement(personalInformationManager.name, match);
                result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(personalInformationManager.version, match), this.options.versionTruncation);
                break;
            }
            return result;
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
exports["default"] = PersonalInformationManagerParser;


/***/ }),

/***/ 18761:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const cameras_json_1 = __importDefault(__webpack_require__(95191));
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class CameraParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, camera] of Object.entries(cameras_json_1.default)) {
                const match = user_agent_1.userAgentParser(camera.regex, userAgent);
                if (!match)
                    continue;
                result.type = "camera";
                result.brand = brand;
                if ("model" in camera && camera.model) {
                    result.model = variable_replacement_1.variableReplacement(camera.model, match).trim();
                }
                else if ("models" in camera && camera.models) {
                    for (const model of camera.models) {
                        const modelMatch = user_agent_1.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = variable_replacement_1.variableReplacement(model.model, modelMatch).trim();
                        break;
                    }
                }
                break;
            }
            return result;
        };
    }
}
exports["default"] = CameraParser;


/***/ }),

/***/ 87405:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const car_browsers_json_1 = __importDefault(__webpack_require__(5178));
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class CarParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, car] of Object.entries(car_browsers_json_1.default)) {
                const match = user_agent_1.userAgentParser(car.regex, userAgent);
                if (!match)
                    continue;
                result.type = "car";
                result.brand = brand;
                for (const model of car.models) {
                    const match = user_agent_1.userAgentParser(model.regex, userAgent);
                    if (!match)
                        continue;
                    result.model = variable_replacement_1.variableReplacement(model.model, match).trim();
                }
                break;
            }
            return result;
        };
    }
}
exports["default"] = CarParser;


/***/ }),

/***/ 73554:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const consoles_json_1 = __importDefault(__webpack_require__(78127));
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class ConsoleParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, gameConsole] of Object.entries(consoles_json_1.default)) {
                const match = user_agent_1.userAgentParser(gameConsole.regex, userAgent);
                if (!match)
                    continue;
                result.type = gameConsole.device;
                result.brand = brand;
                if ("model" in gameConsole && gameConsole.model) {
                    result.model = variable_replacement_1.variableReplacement(gameConsole.model, match).trim();
                }
                else if ("models" in gameConsole && gameConsole.models) {
                    for (const model of gameConsole.models) {
                        const modelMatch = user_agent_1.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = variable_replacement_1.variableReplacement(model.model, modelMatch).trim();
                        break;
                    }
                }
                break;
            }
            return result;
        };
    }
}
exports["default"] = ConsoleParser;


/***/ }),

/***/ 10523:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const cameras_1 = __importDefault(__webpack_require__(18761));
const mobiles_1 = __importDefault(__webpack_require__(20567));
const televisions_1 = __importDefault(__webpack_require__(95007));
const cars_1 = __importDefault(__webpack_require__(87405));
const consoles_1 = __importDefault(__webpack_require__(73554));
const notebooks_1 = __importDefault(__webpack_require__(99154));
const portable_media_players_1 = __importDefault(__webpack_require__(51565));
const deviceParsers = [
    consoles_1.default,
    cars_1.default,
    cameras_1.default,
    televisions_1.default,
    portable_media_players_1.default,
    mobiles_1.default,
    notebooks_1.default
];
class ClientParser {
    constructor() {
        this.parse = (userAgent) => {
            for (const Parser of deviceParsers) {
                const parser = new Parser();
                const device = parser.parse(userAgent);
                if (device.type !== "") {
                    return device;
                }
            }
            return null;
        };
    }
}
exports["default"] = ClientParser;


/***/ }),

/***/ 20567:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobiles_json_1 = __importDefault(__webpack_require__(47511));
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
const model_1 = __webpack_require__(51143);
class MobileParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            let resultType = "";
            for (const [brand, mobile] of Object.entries(mobiles_json_1.default)) {
                const match = user_agent_1.userAgentParser(mobile.regex, userAgent);
                if (!match)
                    continue;
                resultType = "device" in mobile && mobile.device || "";
                result.brand = brand;
                if ("model" in mobile && mobile.model) {
                    result.model = model_1.buildModel(variable_replacement_1.variableReplacement(mobile.model, match)).trim();
                }
                else if ("models" in mobile && mobile.models) {
                    for (const model of mobile.models) {
                        const modelMatch = user_agent_1.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = model_1.buildModel(variable_replacement_1.variableReplacement(model.model, modelMatch)).trim();
                        if ("device" in model && model.device) {
                            resultType = model.device;
                        }
                        if ("brand" in model) {
                            result.brand = model.brand || "";
                        }
                        break;
                    }
                }
                break;
            }
            // Sanitize device type
            if (resultType === "tv") {
                result.type = "television";
            }
            else if (resultType === "car browser") {
                result.type = "car";
            }
            else {
                result.type = resultType;
            }
            // Sanitize device brand
            if (result.brand === "Unknown") {
                result.brand = "";
            }
            return result;
        };
    }
}
exports["default"] = MobileParser;


/***/ }),

/***/ 99154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const notebooks_json_1 = __importDefault(__webpack_require__(95236));
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
const model_1 = __webpack_require__(51143);
class NotebooksParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            if (!user_agent_1.userAgentParser("FBMD/", userAgent)) {
                return result;
            }
            for (const [brand, notebook] of Object.entries(notebooks_json_1.default)) {
                const match = user_agent_1.userAgentParser(notebook.regex, userAgent);
                if (!match)
                    continue;
                result.type = "desktop";
                result.brand = brand;
                if ("model" in notebook && notebook.model) {
                    result.model = model_1.buildModel(variable_replacement_1.variableReplacement(notebook.model, match)).trim();
                }
                else if ("models" in notebook && notebook.models) {
                    for (const model of notebook.models) {
                        const match = user_agent_1.userAgentParser(model.regex, userAgent);
                        if (!match)
                            continue;
                        result.model = variable_replacement_1.variableReplacement(model.model, match).trim();
                    }
                }
                break;
            }
            return result;
        };
    }
}
exports["default"] = NotebooksParser;


/***/ }),

/***/ 51565:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const portable_media_player_json_1 = __importDefault(__webpack_require__(92437));
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
class PortableMediaPlayersParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, portableMediaPlayer] of Object.entries(portable_media_player_json_1.default)) {
                const match = user_agent_1.userAgentParser(portableMediaPlayer.regex, userAgent);
                if (!match)
                    continue;
                result.type = portableMediaPlayer.device;
                result.brand = brand;
                if ("model" in portableMediaPlayer && portableMediaPlayer.model) {
                    result.model = variable_replacement_1.variableReplacement(portableMediaPlayer.model, match).trim();
                }
                else if ("models" in portableMediaPlayer && portableMediaPlayer.models) {
                    for (const model of portableMediaPlayer.models) {
                        const modelMatch = user_agent_1.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = variable_replacement_1.variableReplacement(model.model, modelMatch).trim();
                        break;
                    }
                }
                break;
            }
            return result;
        };
    }
}
exports["default"] = PortableMediaPlayersParser;


/***/ }),

/***/ 95007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const televisions_json_1 = __importDefault(__webpack_require__(8093));
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
const model_1 = __webpack_require__(51143);
class TelevisionParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            if (!this.isHbbTv(userAgent))
                return result;
            result.type = "television";
            for (const [brand, television] of Object.entries(televisions_json_1.default)) {
                const match = user_agent_1.userAgentParser(television.regex, userAgent);
                if (!match)
                    continue;
                result.brand = brand;
                if ("model" in television && television.model) {
                    result.model = model_1.buildModel(variable_replacement_1.variableReplacement(television.model, match)).trim();
                }
                else if ("models" in television && television.models) {
                    for (const model of television.models) {
                        const modelMatch = user_agent_1.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = model_1.buildModel(variable_replacement_1.variableReplacement(model.model, modelMatch)).trim();
                        break;
                    }
                }
                break;
            }
            return result;
        };
        this.isHbbTv = (userAgent) => {
            return user_agent_1.userAgentParser("HbbTV\/([1-9]{1}(?:\.[0-9]{1}){1,2})", userAgent);
        };
    }
}
exports["default"] = TelevisionParser;


/***/ }),

/***/ 5247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const oss_json_1 = __importDefault(__webpack_require__(8949));
const version_1 = __webpack_require__(87729);
const variable_replacement_1 = __webpack_require__(90578);
const user_agent_1 = __webpack_require__(42042);
const operating_system_json_1 = __importDefault(__webpack_require__(26622));
const desktopOsArray = ["AmigaOS", "IBM", "GNU/Linux", "Mac", "Unix", "Windows", "BeOS", "Chrome OS"];
const shortOsNames = operating_system_json_1.default.operatingSystem;
const osFamilies = operating_system_json_1.default.osFamilies;
class OperatingSystemParser {
    constructor(options) {
        this.options = {
            versionTruncation: 1
        };
        this.parse = (userAgent) => {
            const result = {
                name: "",
                version: "",
                platform: this.parsePlatform(userAgent)
            };
            for (const operatingSystem of oss_json_1.default) {
                const match = user_agent_1.userAgentParser(operatingSystem.regex, userAgent);
                if (!match)
                    continue;
                result.name = variable_replacement_1.variableReplacement(operatingSystem.name, match);
                result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(operatingSystem.version, match), this.options.versionTruncation);
                if (result.name === "lubuntu") {
                    result.name = "Lubuntu";
                }
                if (result.name === "debian") {
                    result.name = "Debian";
                }
                if (result.name === "YunOS") {
                    result.name = "YunOs";
                }
                return result;
            }
            return null;
        };
        this.parsePlatform = (userAgent) => {
            if (user_agent_1.userAgentParser("arm|aarch64|Watch ?OS|Watch1,[12]", userAgent)) {
                return "ARM";
            }
            if (user_agent_1.userAgentParser("mips", userAgent)) {
                return "MIPS";
            }
            if (user_agent_1.userAgentParser("sh4", userAgent)) {
                return "SuperH";
            }
            if (user_agent_1.userAgentParser("WOW64|x64|win64|amd64|x86_?64", userAgent)) {
                return "x64";
            }
            if (user_agent_1.userAgentParser("(?:i[0-9]|x)86|i86pc", userAgent)) {
                return "x86";
            }
            return "";
        };
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
}
exports["default"] = OperatingSystemParser;
OperatingSystemParser.getDesktopOsArray = () => desktopOsArray;
OperatingSystemParser.getOsFamily = (osName) => {
    const osShortName = OperatingSystemParser.getOsShortName(osName);
    for (const [osFamily, shortNames] of Object.entries(osFamilies)) {
        if (shortNames.includes(osShortName)) {
            return osFamily;
        }
    }
    return "";
};
OperatingSystemParser.getOsShortName = (osName) => {
    for (const [shortName, name] of Object.entries(shortOsNames)) {
        if (name === osName)
            return shortName;
    }
    return "";
};


/***/ }),

/***/ 921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const vendorfragments_json_1 = __importDefault(__webpack_require__(69806));
const user_agent_1 = __webpack_require__(42042);
class VendorFragmentParser {
    constructor() {
        this.parse = (userAgent) => {
            for (const [brand, vendorFragment] of Object.entries(vendorfragments_json_1.default)) {
                for (const regex of vendorFragment) {
                    const match = user_agent_1.userAgentParser(regex, userAgent);
                    if (!match)
                        continue;
                    return brand;
                }
            }
            return "";
        };
    }
}
exports["default"] = VendorFragmentParser;


/***/ }),

/***/ 59469:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.memoryCache = () => {
    const memoryCacheBucket = {};
    const set = (key, value) => {
        memoryCacheBucket[key] = value;
    };
    const get = (key) => {
        if (memoryCacheBucket.hasOwnProperty(key)) {
            return memoryCacheBucket[key];
        }
    };
    return {
        set,
        get
    };
};


/***/ }),

/***/ 51143:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildModel = (model) => {
    model = model.replace(/_/g, " ");
    model = model.replace(RegExp(" TD$", "i"), "");
    if (model === "Build")
        return "";
    return model;
};


/***/ }),

/***/ 50359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.trim = (str, char) => {
    return str.replace(new RegExp("^[" + char + "]+|[" + char + "]+$", "g"), "");
};


/***/ }),

/***/ 42042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const memory_cache_1 = __webpack_require__(59469);
const cache = memory_cache_1.memoryCache();
const getRegexInstance = (rawRegex) => {
    const cachedRegexInstance = cache.get(rawRegex);
    if (cachedRegexInstance)
        return cachedRegexInstance.value;
    const regexInstance = RegExp(`(?:^|[^A-Z0-9\-_]|[^A-Z0-9\-]_|sprd-)(?:${rawRegex})`, "i");
    cache.set(rawRegex, {
        value: regexInstance
    });
    return regexInstance;
};
exports.userAgentParser = (rawRegex, userAgent) => {
    // TODO: find out why it fails in some browsers
    try {
        const regexInstance = getRegexInstance(rawRegex);
        const match = regexInstance.exec(userAgent);
        return match ? match.slice(1) : null;
    }
    catch (_a) {
        return null;
    }
};


/***/ }),

/***/ 90578:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.variableReplacement = (template, variables) => {
    const regex = new RegExp(`\\$\\d`, "g");
    if (template === null || template === undefined)
        return "";
    return template.replace(regex, (match) => {
        const index = parseInt(match.substr(1), 10);
        const variable = variables[index - 1];
        return variable || "";
    });
};


/***/ }),

/***/ 32862:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.versionCompare = (v1, v2, operator) => {
    //      discuss at: http://locutus.io/php/version_compare/
    //      original by: Philippe Jausions (http://pear.php.net/user/jausions)
    //      original by: Aidan Lister (http://aidanlister.com/)
    //      reimplemented by: Kankrelune (http://www.webfaktory.info/)
    //      improved by: Brett Zamir (http://brett-zamir.me)
    //      improved by: Scott Baker
    //      improved by: Theriault (https://github.com/Theriault)
    //      example 1: version_compare('8.2.5rc', '8.2.5a')
    //      returns 1: 1
    //      example 2: version_compare('8.2.50', '8.2.52', '<')
    //      returns 2: true
    //      example 3: version_compare('5.3.0-dev', '5.3.0')
    //      returns 3: -1
    //      example 4: version_compare('4.1.0.52','4.01.0.51')
    //      returns 4: 1
    // Important: compare must be initialized at 0.
    let i;
    let x;
    let compare = 0;
    // vm maps textual PHP versions to negatives so they're less than 0.
    // PHP currently defines these as CASE-SENSITIVE. It is important to
    // leave these as negatives so that they can come before numerical versions
    // and as if no letters were there to begin with.
    // (1alpha is < 1 and < 1.1 but > 1dev1)
    // If a non-numerical value can't be mapped to this table, it receives
    // -7 as its value.
    const vm = {
        "dev": -6,
        "alpha": -5,
        "a": -5,
        "beta": -4,
        "b": -4,
        "RC": -3,
        "rc": -3,
        "#": -2,
        "p": 1,
        "pl": 1
    };
    // This function will be called to prepare each version argument.
    // It replaces every _, -, and + with a dot.
    // It surrounds any nonsequence of numbers/dots with dots.
    // It replaces sequences of dots with a single dot.
    //    version_compare('4..0', '4.0') === 0
    // Important: A string of 0 length needs to be converted into a value
    // even less than an unexisting value in vm (-7), hence [-8].
    // It's also important to not strip spaces because of this.
    //   version_compare('', ' ') === 1
    const prepVersion = (v) => {
        v = ("" + v).replace(/[_\-+]/g, ".");
        v = v.replace(/([^.\d]+)/g, ".$1.").replace(/\.{2,}/g, ".");
        return (!v.length ? [-8] : v.split("."));
    };
    // This converts a version component to a number.
    // Empty component becomes 0.
    // Non-numerical component becomes a negative number.
    // Numerical component becomes itself as an integer.
    const numVersion = (v) => {
        return !v ? 0 : (isNaN(v) ? vm[v] || -7 : parseInt(v, 10));
    };
    v1 = prepVersion(v1);
    v2 = prepVersion(v2);
    x = Math.max(v1.length, v2.length);
    for (i = 0; i < x; i++) {
        if (v1[i] === v2[i]) {
            continue;
        }
        v1[i] = numVersion(v1[i]);
        v2[i] = numVersion(v2[i]);
        if (v1[i] < v2[i]) {
            compare = -1;
            break;
        }
        else if (v1[i] > v2[i]) {
            compare = 1;
            break;
        }
    }
    if (!operator) {
        return compare;
    }
    // Important: operator is CASE-SENSITIVE.
    // "No operator" seems to be treated as "<."
    // Any other values seem to make the function return null.
    switch (operator) {
        case ">":
        case "gt":
            return (compare > 0);
        case ">=":
        case "ge":
            return (compare >= 0);
        case "<=":
        case "le":
            return (compare <= 0);
        case "===":
        case "=":
        case "eq":
            return (compare === 0);
        case "<>":
        case "!==":
        case "ne":
            return (compare !== 0);
        case "":
        case "<":
        case "lt":
            return (compare < 0);
        default:
            return null;
    }
};


/***/ }),

/***/ 87729:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const trim_1 = __webpack_require__(50359);
exports.formatVersion = (version, versionTruncation) => {
    if (version === undefined)
        return "";
    const versionString = trim_1.trim(version, ". ").replace(new RegExp("_", "g"), ".");
    const versionParts = versionString.split(".");
    // Return if the string is not only digits once we removed the dots
    if (!/^\d+$/.test(versionParts.join(""))) {
        return versionString;
    }
    if (versionTruncation !== 0) {
        if (Number.isInteger(parseFloat(versionString))) {
            return parseInt(versionString, 10).toFixed(1);
        }
    }
    if (versionParts.length > 1) {
        if (versionTruncation !== null) {
            return versionParts.slice(0, versionTruncation + 1).join(".");
        }
    }
    return versionString;
};
exports.parseBrowserEngineVersion = (userAgent, engine) => {
    if (!engine)
        return "";
    if (engine === "Gecko") {
        const geckoVersionRegex = /[ ](?:rv[: ]([0-9\.]+)).*gecko\/[0-9]{8,10}/i;
        const match = userAgent.match(geckoVersionRegex);
        if (match) {
            return match.pop();
        }
    }
    const regex = new RegExp(`${engine}\\s*\\/?\\s*((?:(?=\\d+\\.\\d)\\d+[.\\d]*|\\d{1,7}(?=(?:\\D|$))))`, "i");
    const match = userAgent.match(regex);
    if (!match)
        return "";
    return match.pop();
};


/***/ }),

/***/ 64063:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(17642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 41405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 17642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 86492:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
	var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see https://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(codePoint) {
		return '&#x' + codePoint.toString(16).toUpperCase() + ';';
	};

	var decEscape = function(codePoint) {
		return '&#' + codePoint + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		var escapeCodePoint = options.decimal ? decEscape : hexEscape;

		var escapeBmpSymbol = function(symbol) {
			return escapeCodePoint(symbol.charCodeAt(0));
		};

		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return escapeBmpSymbol(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, escapeBmpSymbol);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return escapeCodePoint(codePoint);
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, escapeBmpSymbol);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false,
		'decimal' : false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
			var codePoint;
			var semicolon;
			var decDigits;
			var hexDigits;
			var reference;
			var next;

			if ($1) {
				reference = $1;
				// Note: there is no need to check `has(decodeMap, reference)`.
				return decodeMap[reference];
			}

			if ($2) {
				// Decode named character references without trailing `;`, e.g. `&amp`.
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $2;
				next = $3;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			}

			if ($4) {
				// Decode decimal escapes, e.g. `&#119558;`.
				decDigits = $4;
				semicolon = $5;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(decDigits, 10);
				return codePointToSymbol(codePoint, strict);
			}

			if ($6) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $6;
				semicolon = $7;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}

			// If we’re still here, `if ($7)` is implied; it’s an ambiguous
			// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
			if (strict) {
				parseError(
					'named character reference was not terminated by a semicolon'
				);
			}
			return $0;
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '1.2.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return he;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else { var key; }

}(this));


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 94315:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * is.js 0.8.0
 * Author: Aras Atasaygin
 */

// AMD with global, Node, or global
;(function(root, factory) {    // eslint-disable-line no-extra-semi
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            // Also create a global in case some scripts
            // that are loaded still are looking for
            // a global even when an AMD loader is in use.
            return (root.is = factory());
        }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function() {

    // Baseline
    /* -------------------------------------------------------------------------- */

    // define 'is' object and current version
    var is = {};
    is.VERSION = '0.8.0';

    // define interfaces
    is.not = {};
    is.all = {};
    is.any = {};

    // cache some methods to call later on
    var toString = Object.prototype.toString;
    var slice = Array.prototype.slice;
    var hasOwnProperty = Object.prototype.hasOwnProperty;

    // helper function which reverses the sense of predicate result
    function not(func) {
        return function() {
            return !func.apply(null, slice.call(arguments));
        };
    }

    // helper function which call predicate function per parameter and return true if all pass
    function all(func) {
        return function() {
            var params = getParams(arguments);
            var length = params.length;
            for (var i = 0; i < length; i++) {
                if (!func.call(null, params[i])) {
                    return false;
                }
            }
            return true;
        };
    }

    // helper function which call predicate function per parameter and return true if any pass
    function any(func) {
        return function() {
            var params = getParams(arguments);
            var length = params.length;
            for (var i = 0; i < length; i++) {
                if (func.call(null, params[i])) {
                    return true;
                }
            }
            return false;
        };
    }

    // build a 'comparator' object for various comparison checks
    var comparator = {
        '<': function(a, b) { return a < b; },
        '<=': function(a, b) { return a <= b; },
        '>': function(a, b) { return a > b; },
        '>=': function(a, b) { return a >= b; }
    }

    // helper function which compares a version to a range
    function compareVersion(version, range) {
        var string = (range + '');
        var n = +(string.match(/\d+/) || NaN);
        var op = string.match(/^[<>]=?|/)[0];
        return comparator[op] ? comparator[op](version, n) : (version == n || n !== n);
    }

    // helper function which extracts params from arguments
    function getParams(args) {
        var params = slice.call(args);
        var length = params.length;
        if (length === 1 && is.array(params[0])) {    // support array
            params = params[0];
        }
        return params;
    }

    // Type checks
    /* -------------------------------------------------------------------------- */

    // is a given value Arguments?
    is.arguments = function(value) {    // fallback check is for IE
        return toString.call(value) === '[object Arguments]' ||
            (value != null && typeof value === 'object' && 'callee' in value);
    };

    // is a given value Array?
    is.array = Array.isArray || function(value) {    // check native isArray first
        return toString.call(value) === '[object Array]';
    };

    // is a given value Boolean?
    is.boolean = function(value) {
        return value === true || value === false || toString.call(value) === '[object Boolean]';
    };

    // is a given value Char?
    is.char = function(value) {
        return is.string(value) && value.length === 1;
    };

    // is a given value Date Object?
    is.date = function(value) {
        return toString.call(value) === '[object Date]';
    };

    // is a given object a DOM node?
    is.domNode = function(object) {
        return is.object(object) && object.nodeType > 0;
    };

    // is a given value Error object?
    is.error = function(value) {
        return toString.call(value) === '[object Error]';
    };

    // is a given value function?
    is['function'] = function(value) {    // fallback check is for IE
        return toString.call(value) === '[object Function]' || typeof value === 'function';
    };

    // is given value a pure JSON object?
    is.json = function(value) {
        return toString.call(value) === '[object Object]';
    };

    // is a given value NaN?
    is.nan = function(value) {    // NaN is number :) Also it is the only value which does not equal itself
        return value !== value;
    };

    // is a given value null?
    is['null'] = function(value) {
        return value === null;
    };

    // is a given value number?
    is.number = function(value) {
        return is.not.nan(value) && toString.call(value) === '[object Number]';
    };

    // is a given value object?
    is.object = function(value) {
        return Object(value) === value;
    };

    // is a given value RegExp?
    is.regexp = function(value) {
        return toString.call(value) === '[object RegExp]';
    };

    // are given values same type?
    // prevent NaN, Number same type check
    is.sameType = function(value, other) {
        var tag = toString.call(value);
        if (tag !== toString.call(other)) {
            return false;
        }
        if (tag === '[object Number]') {
            return !is.any.nan(value, other) || is.all.nan(value, other);
        }
        return true;
    };
    // sameType method does not support 'all' and 'any' interfaces
    is.sameType.api = ['not'];

    // is a given value String?
    is.string = function(value) {
        return toString.call(value) === '[object String]';
    };

    // is a given value undefined?
    is.undefined = function(value) {
        return value === void 0;
    };

    // is a given value window?
    // setInterval method is only available for window object
    is.windowObject = function(value) {
        return value != null && typeof value === 'object' && 'setInterval' in value;
    };

    // Presence checks
    /* -------------------------------------------------------------------------- */

    //is a given value empty? Objects, arrays, strings
    is.empty = function(value) {
        if (is.object(value)) {
            var length = Object.getOwnPropertyNames(value).length;
            if (length === 0 || (length === 1 && is.array(value)) ||
                    (length === 2 && is.arguments(value))) {
                return true;
            }
            return false;
        }
        return value === '';
    };

    // is a given value existy?
    is.existy = function(value) {
        return value != null;
    };

    // is a given value falsy?
    is.falsy = function(value) {
        return !value;
    };

    // is a given value truthy?
    is.truthy = not(is.falsy);

    // Arithmetic checks
    /* -------------------------------------------------------------------------- */

    // is a given number above minimum parameter?
    is.above = function(n, min) {
        return is.all.number(n, min) && n > min;
    };
    // above method does not support 'all' and 'any' interfaces
    is.above.api = ['not'];

    // is a given number decimal?
    is.decimal = function(n) {
        return is.number(n) && n % 1 !== 0;
    };

    // are given values equal? supports numbers, strings, regexes, booleans
    // TODO: Add object and array support
    is.equal = function(value, other) {
        // check 0 and -0 equity with Infinity and -Infinity
        if (is.all.number(value, other)) {
            return value === other && 1 / value === 1 / other;
        }
        // check regexes as strings too
        if (is.all.string(value, other) || is.all.regexp(value, other)) {
            return '' + value === '' + other;
        }
        if (is.all.boolean(value, other)) {
            return value === other;
        }
        return false;
    };
    // equal method does not support 'all' and 'any' interfaces
    is.equal.api = ['not'];

    // is a given number even?
    is.even = function(n) {
        return is.number(n) && n % 2 === 0;
    };

    // is a given number finite?
    is.finite = isFinite || function(n) {
        return is.not.infinite(n) && is.not.nan(n);
    };

    // is a given number infinite?
    is.infinite = function(n) {
        return n === Infinity || n === -Infinity;
    };

    // is a given number integer?
    is.integer = function(n) {
        return is.number(n) && n % 1 === 0;
    };

    // is a given number negative?
    is.negative = function(n) {
        return is.number(n) && n < 0;
    };

    // is a given number odd?
    is.odd = function(n) {
        return is.number(n) && n % 2 === 1;
    };

    // is a given number positive?
    is.positive = function(n) {
        return is.number(n) && n > 0;
    };

    // is a given number above maximum parameter?
    is.under = function(n, max) {
        return is.all.number(n, max) && n < max;
    };
    // least method does not support 'all' and 'any' interfaces
    is.under.api = ['not'];

    // is a given number within minimum and maximum parameters?
    is.within = function(n, min, max) {
        return is.all.number(n, min, max) && n > min && n < max;
    };
    // within method does not support 'all' and 'any' interfaces
    is.within.api = ['not'];

    // Regexp checks
    /* -------------------------------------------------------------------------- */
    // Steven Levithan, Jan Goyvaerts: Regular Expressions Cookbook
    // Scott Gonzalez: Email address validation

    // dateString match m/d/yy and mm/dd/yyyy, allowing any combination of one or two digits for the day and month, and two or four digits for the year
    // eppPhone match extensible provisioning protocol format
    // nanpPhone match north american number plan format
    // time match hours, minutes, and seconds, 24-hour clock
    var regexes = {
        affirmative: /^(?:1|t(?:rue)?|y(?:es)?|ok(?:ay)?)$/,
        alphaNumeric: /^[A-Za-z0-9]+$/,
        caPostalCode: /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]\s?[0-9][A-Z][0-9]$/,
        creditCard: /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/,
        dateString: /^(1[0-2]|0?[1-9])([\/-])(3[01]|[12][0-9]|0?[1-9])(?:\2)(?:[0-9]{2})?[0-9]{2}$/,
        email: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, // eslint-disable-line no-control-regex
        eppPhone: /^\+[0-9]{1,3}\.[0-9]{4,14}(?:x.+)?$/,
        hexadecimal: /^(?:0x)?[0-9a-fA-F]+$/,
        hexColor: /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/,
        ipv4: /^(?:(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/,
        ipv6: /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i,
        nanpPhone: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        socialSecurityNumber: /^(?!000|666)[0-8][0-9]{2}-?(?!00)[0-9]{2}-?(?!0000)[0-9]{4}$/,
        timeString: /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/,
        ukPostCode: /^[A-Z]{1,2}[0-9RCHNQ][0-9A-Z]?\s?[0-9][ABD-HJLNP-UW-Z]{2}$|^[A-Z]{2}-?[0-9]{4}$/,
        url: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i,
        usZipCode: /^[0-9]{5}(?:-[0-9]{4})?$/
    };

    function regexpCheck(regexp, regexes) {
        is[regexp] = function(value) {
            return regexes[regexp].test(value);
        };
    }

    // create regexp checks methods from 'regexes' object
    for (var regexp in regexes) {
        if (regexes.hasOwnProperty(regexp)) {
            regexpCheck(regexp, regexes);
        }
    }

    // simplify IP checks by calling the regex helpers for IPv4 and IPv6
    is.ip = function(value) {
        return is.ipv4(value) || is.ipv6(value);
    };

    // String checks
    /* -------------------------------------------------------------------------- */

    // is a given string or sentence capitalized?
    is.capitalized = function(string) {
        if (is.not.string(string)) {
            return false;
        }
        var words = string.split(' ');
        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            if (word.length) {
                var chr = word.charAt(0);
                if (chr !== chr.toUpperCase()) {
                    return false;
                }
            }
        }
        return true;
    };

    // is string end with a given target parameter?
    is.endWith = function(string, target) {
        if (is.not.string(string)) {
            return false;
        }
        target += '';
        var position = string.length - target.length;
        return position >= 0 && string.indexOf(target, position) === position;
    };
    // endWith method does not support 'all' and 'any' interfaces
    is.endWith.api = ['not'];

    // is a given string include parameter target?
    is.include = function(string, target) {
        return string.indexOf(target) > -1;
    };
    // include method does not support 'all' and 'any' interfaces
    is.include.api = ['not'];

    // is a given string all lowercase?
    is.lowerCase = function(string) {
        return is.string(string) && string === string.toLowerCase();
    };

    // is a given string palindrome?
    is.palindrome = function(string) {
        if (is.not.string(string)) {
            return false;
        }
        string = string.replace(/[^a-zA-Z0-9]+/g, '').toLowerCase();
        var length = string.length - 1;
        for (var i = 0, half = Math.floor(length / 2); i <= half; i++) {
            if (string.charAt(i) !== string.charAt(length - i)) {
                return false;
            }
        }
        return true;
    };

    // is a given value space?
    // horizantal tab: 9, line feed: 10, vertical tab: 11, form feed: 12, carriage return: 13, space: 32
    is.space = function(value) {
        if (is.not.char(value)) {
            return false;
        }
        var charCode = value.charCodeAt(0);
        return (charCode > 8 && charCode < 14) || charCode === 32;
    };

    // is string start with a given target parameter?
    is.startWith = function(string, target) {
        return is.string(string) && string.indexOf(target) === 0;
    };
    // startWith method does not support 'all' and 'any' interfaces
    is.startWith.api = ['not'];

    // is a given string all uppercase?
    is.upperCase = function(string) {
        return is.string(string) && string === string.toUpperCase();
    };

    // Time checks
    /* -------------------------------------------------------------------------- */

    var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

    // is a given dates day equal given day parameter?
    is.day = function(date, day) {
        return is.date(date) && day.toLowerCase() === days[date.getDay()];
    };
    // day method does not support 'all' and 'any' interfaces
    is.day.api = ['not'];

    // is a given date in daylight saving time?
    is.dayLightSavingTime = function(date) {
        var january = new Date(date.getFullYear(), 0, 1);
        var july = new Date(date.getFullYear(), 6, 1);
        var stdTimezoneOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset());
        return date.getTimezoneOffset() < stdTimezoneOffset;
    };

    // is a given date future?
    is.future = function(date) {
        var now = new Date();
        return is.date(date) && date.getTime() > now.getTime();
    };

    // is date within given range?
    is.inDateRange = function(date, start, end) {
        if (is.not.date(date) || is.not.date(start) || is.not.date(end)) {
            return false;
        }
        var stamp = date.getTime();
        return stamp > start.getTime() && stamp < end.getTime();
    };
    // inDateRange method does not support 'all' and 'any' interfaces
    is.inDateRange.api = ['not'];

    // is a given date in last month range?
    is.inLastMonth = function(date) {
        return is.inDateRange(date, new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date());
    };

    // is a given date in last week range?
    is.inLastWeek = function(date) {
        return is.inDateRange(date, new Date(new Date().setDate(new Date().getDate() - 7)), new Date());
    };

    // is a given date in last year range?
    is.inLastYear = function(date) {
        return is.inDateRange(date, new Date(new Date().setFullYear(new Date().getFullYear() - 1)), new Date());
    };

    // is a given date in next month range?
    is.inNextMonth = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setMonth(new Date().getMonth() + 1)));
    };

    // is a given date in next week range?
    is.inNextWeek = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setDate(new Date().getDate() + 7)));
    };

    // is a given date in next year range?
    is.inNextYear = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setFullYear(new Date().getFullYear() + 1)));
    };

    // is the given year a leap year?
    is.leapYear = function(year) {
        return is.number(year) && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    };

    // is a given dates month equal given month parameter?
    is.month = function(date, month) {
        return is.date(date) && month.toLowerCase() === months[date.getMonth()];
    };
    // month method does not support 'all' and 'any' interfaces
    is.month.api = ['not'];

    // is a given date past?
    is.past = function(date) {
        var now = new Date();
        return is.date(date) && date.getTime() < now.getTime();
    };

    // is a given date in the parameter quarter?
    is.quarterOfYear = function(date, quarter) {
        return is.date(date) && is.number(quarter) && quarter === Math.floor((date.getMonth() + 3) / 3);
    };
    // quarterOfYear method does not support 'all' and 'any' interfaces
    is.quarterOfYear.api = ['not'];

    // is a given date indicate today?
    is.today = function(date) {
        var now = new Date();
        var todayString = now.toDateString();
        return is.date(date) && date.toDateString() === todayString;
    };

    // is a given date indicate tomorrow?
    is.tomorrow = function(date) {
        var now = new Date();
        var tomorrowString = new Date(now.setDate(now.getDate() + 1)).toDateString();
        return is.date(date) && date.toDateString() === tomorrowString;
    };

    // is a given date weekend?
    // 6: Saturday, 0: Sunday
    is.weekend = function(date) {
        return is.date(date) && (date.getDay() === 6 || date.getDay() === 0);
    };

    // is a given date weekday?
    is.weekday = not(is.weekend);

    // is a given dates year equal given year parameter?
    is.year = function(date, year) {
        return is.date(date) && is.number(year) && year === date.getFullYear();
    };
    // year method does not support 'all' and 'any' interfaces
    is.year.api = ['not'];

    // is a given date indicate yesterday?
    is.yesterday = function(date) {
        var now = new Date();
        var yesterdayString = new Date(now.setDate(now.getDate() - 1)).toDateString();
        return is.date(date) && date.toDateString() === yesterdayString;
    };

    // Environment checks
    /* -------------------------------------------------------------------------- */

    var freeGlobal = is.windowObject(typeof __webpack_require__.g == 'object' && __webpack_require__.g) && __webpack_require__.g;
    var freeSelf = is.windowObject(typeof self == 'object' && self) && self;
    var thisGlobal = is.windowObject(typeof this == 'object' && this) && this;
    var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();

    var document = freeSelf && freeSelf.document;
    var previousIs = root.is;

    // store navigator properties to use later
    var navigator = freeSelf && freeSelf.navigator;
    var appVersion = (navigator && navigator.appVersion || '').toLowerCase();
    var userAgent = (navigator && navigator.userAgent || '').toLowerCase();
    var vendor = (navigator && navigator.vendor || '').toLowerCase();

    // is current device android?
    is.android = function() {
        return /android/.test(userAgent);
    };
    // android method does not support 'all' and 'any' interfaces
    is.android.api = ['not'];

    // is current device android phone?
    is.androidPhone = function() {
        return /android/.test(userAgent) && /mobile/.test(userAgent);
    };
    // androidPhone method does not support 'all' and 'any' interfaces
    is.androidPhone.api = ['not'];

    // is current device android tablet?
    is.androidTablet = function() {
        return /android/.test(userAgent) && !/mobile/.test(userAgent);
    };
    // androidTablet method does not support 'all' and 'any' interfaces
    is.androidTablet.api = ['not'];

    // is current device blackberry?
    is.blackberry = function() {
        return /blackberry/.test(userAgent) || /bb10/.test(userAgent);
    };
    // blackberry method does not support 'all' and 'any' interfaces
    is.blackberry.api = ['not'];

    // is current browser chrome?
    // parameter is optional
    is.chrome = function(range) {
        var match = /google inc/.test(vendor) ? userAgent.match(/(?:chrome|crios)\/(\d+)/) : null;
        return match !== null && compareVersion(match[1], range);
    };
    // chrome method does not support 'all' and 'any' interfaces
    is.chrome.api = ['not'];

    // is current device desktop?
    is.desktop = function() {
        return is.not.mobile() && is.not.tablet();
    };
    // desktop method does not support 'all' and 'any' interfaces
    is.desktop.api = ['not'];

    // is current browser edge?
    // parameter is optional
    is.edge = function(range) {
        var match = userAgent.match(/edge\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // edge method does not support 'all' and 'any' interfaces
    is.edge.api = ['not'];

    // is current browser firefox?
    // parameter is optional
    is.firefox = function(range) {
        var match = userAgent.match(/(?:firefox|fxios)\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // firefox method does not support 'all' and 'any' interfaces
    is.firefox.api = ['not'];

    // is current browser internet explorer?
    // parameter is optional
    is.ie = function(range) {
        var match = userAgent.match(/(?:msie |trident.+?; rv:)(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ie method does not support 'all' and 'any' interfaces
    is.ie.api = ['not'];

    // is current device ios?
    is.ios = function() {
        return is.iphone() || is.ipad() || is.ipod();
    };
    // ios method does not support 'all' and 'any' interfaces
    is.ios.api = ['not'];

    // is current device ipad?
    // parameter is optional
    is.ipad = function(range) {
        var match = userAgent.match(/ipad.+?os (\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ipad method does not support 'all' and 'any' interfaces
    is.ipad.api = ['not'];

    // is current device iphone?
    // parameter is optional
    is.iphone = function(range) {
        // original iPhone doesn't have the os portion of the UA
        var match = userAgent.match(/iphone(?:.+?os (\d+))?/);
        return match !== null && compareVersion(match[1] || 1, range);
    };
    // iphone method does not support 'all' and 'any' interfaces
    is.iphone.api = ['not'];

    // is current device ipod?
    // parameter is optional
    is.ipod = function(range) {
        var match = userAgent.match(/ipod.+?os (\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ipod method does not support 'all' and 'any' interfaces
    is.ipod.api = ['not'];

    // is current operating system linux?
    is.linux = function() {
        return /linux/.test(appVersion);
    };
    // linux method does not support 'all' and 'any' interfaces
    is.linux.api = ['not'];

    // is current operating system mac?
    is.mac = function() {
        return /mac/.test(appVersion);
    };
    // mac method does not support 'all' and 'any' interfaces
    is.mac.api = ['not'];

    // is current device mobile?
    is.mobile = function() {
        return is.iphone() || is.ipod() || is.androidPhone() || is.blackberry() || is.windowsPhone();
    };
    // mobile method does not support 'all' and 'any' interfaces
    is.mobile.api = ['not'];

    // is current state offline?
    is.offline = not(is.online);
    // offline method does not support 'all' and 'any' interfaces
    is.offline.api = ['not'];

    // is current state online?
    is.online = function() {
        return !navigator || navigator.onLine === true;
    };
    // online method does not support 'all' and 'any' interfaces
    is.online.api = ['not'];

    // is current browser opera?
    // parameter is optional
    is.opera = function(range) {
        var match = userAgent.match(/(?:^opera.+?version|opr)\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // opera method does not support 'all' and 'any' interfaces
    is.opera.api = ['not'];

    // is current browser phantomjs?
    // parameter is optional
    is.phantom = function(range) {
        var match = userAgent.match(/phantomjs\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // phantom method does not support 'all' and 'any' interfaces
    is.phantom.api = ['not'];

    // is current browser safari?
    // parameter is optional
    is.safari = function(range) {
        var match = userAgent.match(/version\/(\d+).+?safari/);
        return match !== null && compareVersion(match[1], range);
    };
    // safari method does not support 'all' and 'any' interfaces
    is.safari.api = ['not'];

    // is current device tablet?
    is.tablet = function() {
        return is.ipad() || is.androidTablet() || is.windowsTablet();
    };
    // tablet method does not support 'all' and 'any' interfaces
    is.tablet.api = ['not'];

    // is current device supports touch?
    is.touchDevice = function() {
        return !!document && ('ontouchstart' in freeSelf ||
            ('DocumentTouch' in freeSelf && document instanceof DocumentTouch));
    };
    // touchDevice method does not support 'all' and 'any' interfaces
    is.touchDevice.api = ['not'];

    // is current operating system windows?
    is.windows = function() {
        return /win/.test(appVersion);
    };
    // windows method does not support 'all' and 'any' interfaces
    is.windows.api = ['not'];

    // is current device windows phone?
    is.windowsPhone = function() {
        return is.windows() && /phone/.test(userAgent);
    };
    // windowsPhone method does not support 'all' and 'any' interfaces
    is.windowsPhone.api = ['not'];

    // is current device windows tablet?
    is.windowsTablet = function() {
        return is.windows() && is.not.windowsPhone() && /touch/.test(userAgent);
    };
    // windowsTablet method does not support 'all' and 'any' interfaces
    is.windowsTablet.api = ['not'];

    // Object checks
    /* -------------------------------------------------------------------------- */

    // has a given object got parameterized count property?
    is.propertyCount = function(object, count) {
        if (is.not.object(object) || is.not.number(count)) {
            return false;
        }
        var n = 0;
        for (var property in object) {
            if (hasOwnProperty.call(object, property) && ++n > count) {
                return false;
            }
        }
        return n === count;
    };
    // propertyCount method does not support 'all' and 'any' interfaces
    is.propertyCount.api = ['not'];

    // is given object has parameterized property?
    is.propertyDefined = function(object, property) {
        return is.object(object) && is.string(property) && property in object;
    };
    // propertyDefined method does not support 'all' and 'any' interfaces
    is.propertyDefined.api = ['not'];

    // Array checks
    /* -------------------------------------------------------------------------- */

    // is a given item in an array?
    is.inArray = function(value, array) {
        if (is.not.array(array)) {
            return false;
        }
        for (var i = 0; i < array.length; i++) {
            if (array[i] === value) {
                return true;
            }
        }
        return false;
    };
    // inArray method does not support 'all' and 'any' interfaces
    is.inArray.api = ['not'];

    // is a given array sorted?
    is.sorted = function(array, sign) {
        if (is.not.array(array)) {
            return false;
        }
        var predicate = comparator[sign] || comparator['>='];
        for (var i = 1; i < array.length; i++) {
            if (!predicate(array[i], array[i - 1])) {
                return false;
            }
        }
        return true;
    };

    // API
    // Set 'not', 'all' and 'any' interfaces to methods based on their api property
    /* -------------------------------------------------------------------------- */

    function setInterfaces() {
        var options = is;
        for (var option in options) {
            if (hasOwnProperty.call(options, option) && is['function'](options[option])) {
                var interfaces = options[option].api || ['not', 'all', 'any'];
                for (var i = 0; i < interfaces.length; i++) {
                    if (interfaces[i] === 'not') {
                        is.not[option] = not(is[option]);
                    }
                    if (interfaces[i] === 'all') {
                        is.all[option] = all(is[option]);
                    }
                    if (interfaces[i] === 'any') {
                        is.any[option] = any(is[option]);
                    }
                }
            }
        }
    }
    setInterfaces();

    // Configuration methods
    // Intentionally added after setInterfaces function
    /* -------------------------------------------------------------------------- */

    // change namespace of library to prevent name collisions
    // var preferredName = is.setNamespace();
    // preferredName.odd(3);
    // => true
    is.setNamespace = function() {
        root.is = previousIs;
        return this;
    };

    // set optional regexes to methods
    is.setRegexp = function(regexp, name) {
        for (var r in regexes) {
            if (hasOwnProperty.call(regexes, r) && (name === r)) {
                regexes[r] = regexp;
            }
        }
    };

    return is;
}));


/***/ }),

/***/ 36808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 49090:
/***/ (function(module) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ 93096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;


/***/ }),

/***/ 30845:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["Z"] = (memoizeOne);


/***/ }),

/***/ 57824:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* unused reexport */ __webpack_require__(22741)


/***/ }),

/***/ 11752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(36616)


/***/ }),

/***/ 17499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./assets/icons/ArrowDownIcon.js



var SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '14' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '8' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    onClick: onClick,
    width: width,
    height: height,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0.707107 3.05176e-05L7.36396 6.65688L6.65685 7.36399L4.37114e-08 0.707137L0.707107 3.05176e-05Z",
      fill: "#585858"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.6038 0L5.94698 6.65685L6.65409 7.36396L13.3109 0.707107L12.6038 0Z",
      fill: "#585858"
    })]
  });
};

/* harmony default export */ var ArrowDownIcon = (SVG);
;// CONCATENATED MODULE: ./assets/icons/ArrowUpIcon.js



var ArrowUpIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    onClick: onClick,
    width: "14",
    height: "8",
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0.707107 7.99997L7.36396 1.34312L6.65685 0.636009L4.37114e-08 7.29286L0.707107 7.99997Z",
      fill: "#585858"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.6038 8L5.94698 1.34315L6.65409 0.636039L13.3109 7.29289L12.6038 8Z",
      fill: "#585858"
    })]
  });
};

/* harmony default export */ var ArrowUpIcon = (ArrowUpIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/ArrowRightGalleryIcon.js



var ArrowRightGalleryIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    width: "65",
    height: "64",
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      width: "16",
      height: "2",
      transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 40.592 32.0005)",
      fill: "#171717"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      width: "16",
      height: "2",
      transform: "matrix(-0.707107 0.707107 0.707107 0.707107 39.1778 30.5852)",
      fill: "#171717"
    })]
  });
};

/* harmony default export */ var ArrowRightGalleryIcon = (ArrowRightGalleryIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/ArrowLeftGalleryIcon.js



var ArrowLeftGalleryIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "24.136",
      y: "32.0005",
      width: "16",
      height: "2",
      transform: "rotate(-45 24.136 32.0005)",
      fill: "#171717"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "25.5502",
      y: "30.5852",
      width: "16",
      height: "2",
      transform: "rotate(45 25.5502 30.5852)",
      fill: "#171717"
    })]
  });
};

/* harmony default export */ var ArrowLeftGalleryIcon = (ArrowLeftGalleryIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/ArrowLeftIcon.js


var ArrowLeftIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "23",
    height: "9",
    viewBox: "0 0 23 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.19062 4.96328L5.47734 7.25L4.57578 8.15156L0.75 4.32578L4.57578 0.5L5.47734 1.40156L3.19062 3.68828H22.6516V4.96328H3.19062Z",
      fill: "#171717"
    })
  });
};

/* harmony default export */ var ArrowLeftIcon = (ArrowLeftIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/ArrowRightIcon.js


var ArrowRightIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "7",
    height: "13",
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0.5 12.5L6.15685 6.84315L0.5 1.18629",
      stroke: "#171717"
    })
  });
};

/* harmony default export */ var ArrowRightIcon = (ArrowRightIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/BlankIcon.js



var BlankIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.68 5.687V8.29c0 .144.002.287-.016.43l.024-.176c-.022.163-.065.321-.127.473l.066-.158a1.927 1.927 0 01-.24.414l.104-.133c-.101.13-.218.247-.349.348l.134-.103a1.927 1.927 0 01-.414.24l.157-.067c-.152.063-.31.105-.473.127l.176-.023c-.173.021-.35.015-.524.015H2.743c-.155 0-.31.004-.465-.015l.176.023a1.916 1.916 0 01-.473-.127l.157.067a1.928 1.928 0 01-.414-.24l.134.103a1.937 1.937 0 01-.349-.348l.104.133a1.926 1.926 0 01-.24-.414l.066.158a1.915 1.915 0 01-.127-.473l.024.176c-.022-.174-.016-.35-.016-.524v-.87-2.561-2.023c0-.155-.003-.31.016-.465l-.024.175c.022-.162.065-.32.127-.472l-.066.157c.062-.148.143-.286.24-.414l-.104.134c.101-.131.218-.248.349-.349l-.134.103c.128-.097.267-.177.414-.24l-.157.067c.152-.062.31-.105.473-.127l-.176.024c.255-.032.52-.016.777-.016h2.258c.36 0 .66-.3.66-.66 0-.36-.3-.66-.66-.66H2.532C1.838 0 1.149.29.678.802A2.565 2.565 0 000 2.54v5.867c0 .478.108.944.353 1.359.203.343.489.624.82.843.167.11.355.188.54.257.194.07.398.099.602.122.164.02.334.011.499.011h5.454c.279 0 .553-.01.828-.076.393-.094.741-.298 1.049-.555.153-.128.273-.282.393-.44.09-.118.163-.248.222-.384a2.539 2.539 0 00.24-1.07V8.23 5.91v-.223c0-.36-.3-.66-.66-.66-.36 0-.66.3-.66.66zM7.637 1.32h2.703c.36 0 .66-.3.66-.66 0-.36-.3-.66-.66-.66H7.636c-.359 0-.66.3-.66.66 0 .36.301.66.66.66z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11 3.363V1.369.66c0-.36-.3-.66-.66-.66-.36 0-.66.3-.66.66v2.703c0 .36.3.66.66.66.36 0 .66-.3.66-.66z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.977 5.956l.825-.825 1.775-1.775 1.673-1.672.557-.557a.666.666 0 000-.934.667.667 0 00-.934 0 25695.226 25695.226 0 00-2.6 2.6L5.6 4.466l-.557.557a.666.666 0 000 .933c.254.254.68.254.934 0z"
    })]
  });
};

/* harmony default export */ var BlankIcon = (BlankIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/Basket.js


var Basket_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#CCCDD0' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '18' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '20' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 18 20' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.0001 0.0999756C6.39847 0.0999756 5.1001 1.39835 5.1001 2.99998V3.09998H2.0001H1.0001C0.503041 3.09998 0.100098 3.50292 0.100098 3.99998C0.100098 4.49703 0.503041 4.89998 1.0001 4.89998H2.0001H2.60962L3.43377 17.1528L3.43384 17.1539C3.51509 18.4446 4.58562 19.45 5.879 19.45H12.1212C13.4146 19.45 14.4851 18.4446 14.5664 17.1539L14.5664 17.1528L15.3906 4.89998H16.0001H17.0001C17.4972 4.89998 17.9001 4.49703 17.9001 3.99998C17.9001 3.50292 17.4972 3.09998 17.0001 3.09998H16.0001H12.9001V2.99998C12.9001 1.39835 11.6017 0.0999756 10.0001 0.0999756H8.0001ZM11.1001 3.09998H6.9001V2.99998C6.9001 2.39246 7.39258 1.89998 8.0001 1.89998H10.0001C10.6076 1.89998 11.1001 2.39246 11.1001 2.99998V3.09998ZM7.59927 7.96144C7.57799 7.46484 7.15816 7.07952 6.66156 7.1008C6.16496 7.12208 5.77964 7.54191 5.80092 8.03851L6.10092 15.0385C6.12221 15.5351 6.54203 15.9204 7.03863 15.8991C7.53523 15.8779 7.92056 15.458 7.89927 14.9614L7.59927 7.96144ZM12.1993 8.03851C12.2206 7.54191 11.8352 7.12208 11.3386 7.1008C10.842 7.07952 10.4222 7.46484 10.4009 7.96144L10.1009 14.9614C10.0796 15.458 10.465 15.8779 10.9616 15.8991C11.4582 15.9204 11.878 15.5351 11.8993 15.0385L12.1993 8.03851Z",
      fill: fill
    })
  });
};

/* harmony default export */ var Basket = (Basket_SVG);
;// CONCATENATED MODULE: ./assets/icons/CarIcon.js


var CarIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7 22H5a1 1 0 01-1-1V8a1 1 0 011-1h13a1 1 0 011 1v2h4.667c1.117 0 1.6.576 1.936 1.107.594.94 1.536 2.432 2.109 3.378.188.312.288.67.288 1.035V20c0 1.089-.743 2-2 2h-1a3.001 3.001 0 01-6 0h-6a3.001 3.001 0 01-6 0zm3-1.2a1.201 1.201 0 010 2.4 1.201 1.201 0 010-2.4zm12 0a1.201 1.201 0 010 2.4 1.201 1.201 0 010-2.4zM19 18H6v2h1.765A2.99 2.99 0 0110 19a2.99 2.99 0 012.235 1h7.53A2.99 2.99 0 0122 19a2.99 2.99 0 012.235 1H26v-4.575l-1.711-2.929a1 1 0 00-.863-.496H19v6zm-2-9H6v7h11V9zm3 4v3h5l-1.427-2.496a.999.999 0 00-.868-.504H20z"
    })
  });
};

/* harmony default export */ var CarIcon = (CarIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CarIconNew.js


var CarIconNew_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#74849C' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '29' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '23' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 29 23' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M21.9612 23C21.1165 23 20.2718 22.7178 19.7087 22.2945C19.0049 21.8712 18.5825 21.1656 18.301 20.319L18.1602 20.0368H10.8398L10.699 20.319C10.4175 21.1656 9.85437 21.7301 9.29126 22.2945C8.58738 22.7178 7.74272 23 7.03883 23C6.33495 23 5.34951 22.7178 4.78641 22.2945C4.08252 21.8712 3.66019 21.1656 3.37864 20.319L3.23786 20.0368H0.985437C0.703883 20.0368 0.42233 19.8957 0.281553 19.7546C0.140777 19.4724 0 19.3313 0 19.0491V0.98773C0 0.705522 0.140777 0.423313 0.281553 0.282209C0.42233 0.141104 0.703883 0 0.985437 0H17.4563C17.7379 0 18.0194 0.141104 18.1602 0.282209C18.301 0.423313 18.4417 0.705522 18.4417 0.98773C18.4417 1.26994 18.301 1.55215 18.1602 1.69325C18.0194 1.83436 17.7379 1.97546 17.4563 1.97546H1.97087V17.9202H3.09709L3.23786 17.638C3.51942 16.7914 4.08252 16.227 4.64563 15.6626C5.34951 15.2393 6.19417 14.9571 6.89806 14.9571C7.60194 14.9571 8.58738 15.2393 9.15049 15.6626C9.85437 16.0859 10.2767 16.7914 10.5583 17.638L10.699 17.9202H17.8786L18.0194 17.638C18.301 16.7914 18.8641 16.227 19.4272 15.6626C20.1311 15.2393 20.9757 14.9571 21.6796 14.9571C22.3835 14.9571 23.3689 15.2393 23.932 15.6626C24.6359 16.0859 25.0583 16.7914 25.3398 17.638L25.4806 17.9202H26.6068V11.9939L22.665 8.04294H18.1602V11.5706C18.1602 11.8528 18.0194 12.135 17.8786 12.2761C17.7379 12.4172 17.4563 12.5583 17.1748 12.5583C16.8932 12.5583 16.8932 12.4172 16.7524 12.2761C16.6116 12.135 16.4709 11.8528 16.4709 11.5706V7.05522C16.4709 6.77301 16.6116 6.4908 16.7524 6.34969C16.8932 6.20859 17.1748 6.06749 17.4563 6.06749H23.5097C23.7913 6.06749 24.0728 6.20859 24.2136 6.34969L28.7184 10.865C28.8592 11.0061 29 11.2883 29 11.5706V19.0491C29 19.3313 28.8592 19.6135 28.7184 19.7546C28.5777 19.8957 28.2961 20.0368 28.0146 20.0368H25.9029L25.7621 20.319C25.4806 21.1656 24.9175 21.7301 24.3544 22.2945C23.6505 22.7178 22.8058 23 21.9612 23ZM21.9612 17.0736C21.3981 17.0736 20.9757 17.2147 20.5534 17.638C20.1311 18.0614 19.9903 18.4847 19.9903 19.0491C19.9903 19.6135 20.1311 20.0368 20.5534 20.4601C20.9757 20.8834 21.3981 21.0245 21.9612 21.0245C22.5243 21.0245 22.9466 20.8834 23.3689 20.4601C23.7913 20.0368 23.932 19.6135 23.932 19.0491C23.932 18.4847 23.7913 18.0614 23.3689 17.638C22.9466 17.2147 22.5243 17.0736 21.9612 17.0736ZM7.03883 17.0736C6.47573 17.0736 6.0534 17.2147 5.63107 17.638C5.20874 18.0614 5.06796 18.4847 5.06796 19.0491C5.06796 19.6135 5.20874 20.0368 5.63107 20.4601C6.0534 20.8834 6.47573 21.0245 7.03883 21.0245C7.60194 21.0245 8.02427 20.8834 8.4466 20.4601C8.86893 20.0368 9.00971 19.6135 9.00971 19.0491C9.00971 18.4847 8.86893 18.0614 8.4466 17.638C8.02427 17.2147 7.46116 17.0736 7.03883 17.0736Z",
      fill: fill
    })
  });
};

/* harmony default export */ var CarIconNew = (CarIconNew_SVG);
;// CONCATENATED MODULE: ./assets/icons/CardIcon.js



var CardIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M2.48656 5.16733H14.7752H15.923H21.5122C22.2728 5.16733 22.8525 5.74961 22.8525 6.47792V17.7805C22.8525 18.5088 22.2728 19.0926 21.5122 19.0926H15.923C15.923 19.0926 15.5 19.0929 14.7755 19.0929H2.48686C1.72812 19.0929 1.14783 18.5091 1.14783 17.7808V12.7122C1.14783 12.3859 1.14753 11.5461 1.14753 11.5461V6.47823C1.14753 5.74961 1.72781 5.16733 2.48656 5.16733ZM2.48656 4C1.12841 4 0 5.1062 0 6.47792V17.7805C0 19.1519 1.12871 20.2581 2.48656 20.2581H21.5122C22.8716 20.2581 24 19.1519 24 17.7805V6.47823C24 5.10651 22.8713 4.00031 21.5122 4.00031L2.48656 4Z",
      fill: "#292C33"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19 7C18.4031 7 17.8668 7.26319 17.5 7.67925C17.1332 7.26319 16.5969 7 16 7C14.8972 7 14 7.89719 14 9C14 10.1028 14.8972 11 16 11C16.5969 11 17.1332 10.7368 17.5 10.3208C17.8668 10.7368 18.4031 11 19 11C20.1028 11 21 10.1028 21 9C21 7.89719 20.1028 7 19 7ZM16 10C15.4486 10 15 9.55137 15 9C15 8.44863 15.4486 8 16 8C16.5514 8 17 8.44863 17 9C17 9.55137 16.5514 10 16 10ZM19 10C18.4486 10 18 9.55137 18 9C18 8.44863 18.4486 8 19 8C19.5514 8 20 8.44863 20 9C20 9.55137 19.5514 10 19 10Z",
      fill: "#292C33"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.33333 7H4.66667C3.74764 7 3 7.76907 3 8.71429V9.28571C3 10.2309 3.74764 11 4.66667 11H6.33333C7.25236 11 8 10.2309 8 9.28571V8.71429C8 7.76907 7.25236 7 6.33333 7ZM6.88889 9.28571C6.88889 9.60079 6.63965 9.85714 6.33333 9.85714H4.66667C4.36035 9.85714 4.11111 9.60079 4.11111 9.28571V8.71429C4.11111 8.39921 4.36035 8.14286 4.66667 8.14286H6.33333C6.63965 8.14286 6.88889 8.39921 6.88889 8.71429V9.28571Z",
      fill: "#292C33"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
      x1: "3.65",
      y1: "16.35",
      x2: "5.85",
      y2: "16.35",
      stroke: "#292C33",
      strokeWidth: "1.3",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
      x1: "8.65",
      y1: "16.35",
      x2: "10.85",
      y2: "16.35",
      stroke: "#292C33",
      strokeWidth: "1.3",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
      x1: "13.65",
      y1: "16.35",
      x2: "15.85",
      y2: "16.35",
      stroke: "#292C33",
      strokeWidth: "1.3",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
      x1: "18.65",
      y1: "16.35",
      x2: "20.85",
      y2: "16.35",
      stroke: "#292C33",
      strokeWidth: "1.3",
      strokeLinecap: "round"
    })]
  });
};

/* harmony default export */ var CardIcon = (CardIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CartIcon.js


var CartIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#292C33' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '19' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 19' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.6 4.423l-.01-.09h-3.385C13.679 2.143 11.995.9 10 .9 8.004.9 6.32 2.142 5.795 4.334H2.41l-.01.089L.9 17.989l-.012.111H19.112l-.013-.111-1.5-13.566zm-5.535-.09h-4.13c.199-.541.481-.922.815-1.172.36-.27.787-.391 1.25-.391.463 0 .89.122 1.25.391.334.25.616.63.815 1.173zM15.887 6.1l1.132 10.236H2.98L4.113 6.099h11.774z",
      fill: fill,
      stroke: fill,
      strokeWidth: "0.2"
    })
  });
};

/* harmony default export */ var CartIcon = (CartIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CashIcon.js



var CashIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_10725_196434)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M4.68242 15.6797C6.36325 14.789 8.35289 14.8004 10.026 15.7148L10.3546 15.8934C10.8027 16.1361 11.2971 16.2699 11.8008 16.285L15.032 16.3781L15.0321 16.3781C16.0554 16.4084 16.9855 17.0013 17.4827 17.9341L20.938 16.2224C20.9382 16.2223 20.9384 16.2222 20.9386 16.2221C22.0406 15.6411 23.3821 16.0713 23.9862 17.195C24.1142 17.4327 24.0443 17.7345 23.8238 17.8841L23.8238 17.8841L15.8541 23.2893C15.8541 23.2893 15.8541 23.2893 15.8541 23.2893C15.8344 23.3028 15.8137 23.3148 15.7921 23.3251C15.7921 23.3251 15.792 23.3252 15.7919 23.3252L15.7704 23.28C14.9891 23.6561 14.1395 23.8504 13.2799 23.8499L4.68242 15.6797ZM4.68242 15.6797L4.70066 14.985L4.70066 14.985C4.70808 14.701 4.49425 14.4603 4.21772 14.4524C4.21772 14.4524 4.21772 14.4524 4.21772 14.4524L0.67448 14.3501L0.674474 14.3501C0.397845 14.3422 0.171653 14.5701 0.164223 14.8542C0.164223 14.8542 0.164223 14.8542 0.164223 14.8542L-0.0498115 23.007L0.000171268 23.0083L4.68242 15.6797ZM17.8517 19.4987C17.8445 19.7771 17.6265 20.0029 17.3553 20.0031H17.3553H17.3429H17.3414V20.0031L12.0296 19.8498C11.7533 19.8419 11.5392 19.6013 11.5467 19.3172L11.5467 19.3172C11.5543 19.0333 11.7805 18.8051 12.0571 18.8131L16.8068 18.9506C16.6058 18.0714 15.8677 17.4409 15.0049 17.4149L11.7735 17.3217L11.7734 17.3217C11.119 17.3018 10.4776 17.1282 9.89613 16.8134L9.89607 16.8133L9.56727 16.6347L9.56717 16.6346C8.00378 15.7805 6.12278 15.8812 4.65069 16.8965L4.52777 21.581L4.92132 21.3599C5.49745 21.0351 6.17186 20.9577 6.80195 21.1444L12.282 22.7573C13.3128 22.9777 14.3837 22.8528 15.343 22.3997M17.8517 19.4987C17.8517 19.4987 17.8517 19.4987 17.8517 19.4988L17.8017 19.4974L17.8517 19.4987ZM17.8517 19.4987C17.8569 19.3043 17.8443 19.1097 17.8138 18.918M17.8138 18.918L21.3695 17.1564L21.3486 17.1109L21.3708 17.1557L21.3702 17.1561C21.3747 17.154 21.3789 17.1518 21.3819 17.1502L21.3823 17.15L21.3825 17.1499C21.8543 16.8996 22.4211 16.9707 22.8229 17.3263M17.8138 18.918L17.7807 18.9344L17.7585 18.8896L17.8078 18.8812C17.8099 18.8934 17.8119 18.9057 17.8138 18.918ZM22.8229 17.3263L15.343 22.3997M22.8229 17.3263C22.8356 17.3376 22.8482 17.3492 22.8607 17.3611L15.3679 22.4432M22.8229 17.3263L22.8655 17.2974C22.4479 16.9209 21.8534 16.8435 21.3591 17.1057L15.3679 22.4432M15.343 22.3997L15.3398 22.4018L15.3679 22.4432M15.343 22.3997C15.3442 22.3991 15.3453 22.3986 15.3465 22.398L15.3679 22.4432M0.957127 22.5173L1.14388 15.4011L3.69372 15.4746L3.50696 22.5911L0.957127 22.5173Z",
        fill: "#585858",
        stroke: "#585858",
        strokeWidth: "0.1"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("mask", {
        id: "path-2-outside-1_10725_196434",
        maskUnits: "userSpaceOnUse",
        x: "5.9375",
        y: "1.67334",
        width: "15",
        height: "12",
        fill: "black",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          fill: "white",
          x: "5.9375",
          y: "1.67334",
          width: "15",
          height: "12"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M20.0625 2.67334H6.9375V6.11865H7.59375V13.0765H19.4062V6.11865H20.0625V2.67334ZM18.75 12.3874H8.25V6.11865H18.75V12.3874ZM19.4062 5.42959H7.59375V3.3624H19.4062V5.42959Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M20.0625 2.67334H6.9375V6.11865H7.59375V13.0765H19.4062V6.11865H20.0625V2.67334ZM18.75 12.3874H8.25V6.11865H18.75V12.3874ZM19.4062 5.42959H7.59375V3.3624H19.4062V5.42959Z",
        fill: "#585858"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M20.0625 2.67334H20.2625C20.2625 2.56288 20.173 2.47334 20.0625 2.47334V2.67334ZM6.9375 2.67334V2.47334C6.82704 2.47334 6.7375 2.56288 6.7375 2.67334H6.9375ZM6.9375 6.11865H6.7375C6.7375 6.22911 6.82704 6.31865 6.9375 6.31865V6.11865ZM7.59375 6.11865H7.79375C7.79375 6.0082 7.70421 5.91865 7.59375 5.91865V6.11865ZM7.59375 13.0765H7.39375C7.39375 13.1869 7.48329 13.2765 7.59375 13.2765V13.0765ZM19.4062 13.0765V13.2765C19.5167 13.2765 19.6062 13.1869 19.6062 13.0765H19.4062ZM19.4062 6.11865V5.91865C19.2958 5.91865 19.2063 6.0082 19.2063 6.11865H19.4062ZM20.0625 6.11865V6.31865C20.173 6.31865 20.2625 6.22911 20.2625 6.11865H20.0625ZM18.75 12.3874V12.5874C18.8605 12.5874 18.95 12.4979 18.95 12.3874H18.75ZM8.25 12.3874H8.05C8.05 12.4979 8.13954 12.5874 8.25 12.5874V12.3874ZM8.25 6.11865V5.91865C8.13954 5.91865 8.05 6.0082 8.05 6.11865H8.25ZM18.75 6.11865H18.95C18.95 6.0082 18.8605 5.91865 18.75 5.91865V6.11865ZM19.4062 5.42959V5.62959C19.5167 5.62959 19.6062 5.54005 19.6062 5.42959H19.4062ZM7.59375 5.42959H7.39375C7.39375 5.54005 7.48329 5.62959 7.59375 5.62959V5.42959ZM7.59375 3.3624V3.1624C7.48329 3.1624 7.39375 3.25195 7.39375 3.3624H7.59375ZM19.4062 3.3624H19.6062C19.6062 3.25195 19.5167 3.1624 19.4062 3.1624V3.3624ZM20.0625 2.47334H6.9375V2.87334H20.0625V2.47334ZM6.7375 2.67334V6.11865H7.1375V2.67334H6.7375ZM6.9375 6.31865H7.59375V5.91865H6.9375V6.31865ZM7.39375 6.11865V13.0765H7.79375V6.11865H7.39375ZM7.59375 13.2765H19.4062V12.8765H7.59375V13.2765ZM19.6062 13.0765V6.11865H19.2063V13.0765H19.6062ZM19.4062 6.31865H20.0625V5.91865H19.4062V6.31865ZM20.2625 6.11865V2.67334H19.8625V6.11865H20.2625ZM18.75 12.1874H8.25V12.5874H18.75V12.1874ZM8.45 12.3874V6.11865H8.05V12.3874H8.45ZM8.25 6.31865H18.75V5.91865H8.25V6.31865ZM18.55 6.11865V12.3874H18.95V6.11865H18.55ZM19.4062 5.22959H7.59375V5.62959H19.4062V5.22959ZM7.79375 5.42959V3.3624H7.39375V5.42959H7.79375ZM7.59375 3.5624H19.4062V3.1624H7.59375V3.5624ZM19.2063 3.3624V5.42959H19.6062V3.3624H19.2063Z",
        fill: "#585858",
        mask: "url(#path-2-outside-1_10725_196434)"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_10725_196434",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      })
    })]
  });
};

/* harmony default export */ var CashIcon = (CashIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CircleErrorIcon.js



var CircleErrorIcon_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "9",
      cy: "9",
      r: "9",
      fill: "#FF7878"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.08473 11.6705L11.7552 5L13.1695 6.41421L6.49894 13.0847L5.08473 11.6705Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.0847 11.6705L6.41421 5L5 6.41421L11.6705 13.0847L13.0847 11.6705Z",
      fill: "white"
    })]
  });
};

/* harmony default export */ var CircleErrorIcon = (CircleErrorIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CircleQuestionIcon.js



var CircleQuestionIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '14' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '8' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    onClick: onClick,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z",
      stroke: "#EA5656",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4.54492 4.49906C4.66247 4.1649 4.8945 3.88312 5.1999 3.70363C5.5053 3.52414 5.86437 3.45853 6.21351 3.51842C6.56265 3.57831 6.87933 3.75983 7.10746 4.03083C7.33559 4.30183 7.46045 4.64483 7.45992 4.99906C7.45992 5.99906 5.95992 6.49906 5.95992 6.49906",
      stroke: "#EA5656",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6 8.5H6.00563",
      stroke: "#EA5656",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/* harmony default export */ var CircleQuestionIcon = (CircleQuestionIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CircleSuccessIcon.js



var CircleSuccessIcon_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "9",
      cy: "9",
      r: "9",
      fill: "#0FB769"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.75 7.05295L7.83866 12L5.25 9.38706L6.2657 8.33411L7.83866 9.92396L11.7343 6L12.75 7.05295Z",
      fill: "white"
    })]
  });
};

/* harmony default export */ var CircleSuccessIcon = (CircleSuccessIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CircleWarnIcon.js


var CircleWarnIcon_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9.9 13.5H8.1V11.7H9.9V13.5ZM9.9 9.9H8.1V4.5H9.9V9.9Z",
      fill: "#EA5656"
    })
  });
};

/* harmony default export */ var CircleWarnIcon = (CircleWarnIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CircleWaitIcon.js


var CircleWaitIcon_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "9",
      cy: "9",
      r: "8.5",
      stroke: "#F8F8F8"
    })
  });
};

/* harmony default export */ var CircleWaitIcon = (CircleWaitIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/Close.js


var Close_SVG = function SVG(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '17' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '16' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 17 16' : _ref$viewBox,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      className = _ref.className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? null : _ref$onClick,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? null : _ref$stroke;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.24264 0.75736L15.7279 15.2426M1.24264 15.2426L15.7279 0.757356",
      stroke: stroke ? stroke : '#BBBBBB',
      strokeWidth: "2"
    })
  });
};

/* harmony default export */ var Close = (Close_SVG);
;// CONCATENATED MODULE: ./assets/icons/CloseGalleryIcon.js



var CloseGalleryIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    width: "44",
    height: "45",
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      width: "24",
      height: "2",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 14.2218 30.7432)",
      fill: "#171717"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "29.7782",
      y: "30.7432",
      width: "24",
      height: "2",
      transform: "rotate(-135 29.7782 30.7432)",
      fill: "#171717"
    })]
  });
};

/* harmony default export */ var CloseGalleryIcon = (CloseGalleryIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CertificateIcon.js



var CertificateIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: '#171717',
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M2.487 5.167h12.288V8.37a.579.579 0 00.574.593c.32 0 .58-.267.574-.593V5.167h5.59c.76 0 1.34.583 1.34 1.31V17.78c0 .729-.58 1.313-1.34 1.313h-5.59v-3.121a.58.58 0 00-.582-.59.58.58 0 00-.566.59v3.12H2.487c-.759 0-1.34-.583-1.34-1.311v-5.069h5.558a.576.576 0 00.583-.582.578.578 0 00-.583-.584H1.148V6.478c0-.728.58-1.31 1.339-1.31zm0-1.167A2.49 2.49 0 000 6.478V17.78a2.49 2.49 0 002.487 2.478h19.025A2.49 2.49 0 0024 17.781V6.477A2.49 2.49 0 0021.512 4H2.487z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.348 9.27c.052 0 .103.003.152.01.393.058.793.392 1.048.858.256.466.326 1.026.212 1.365-.116.337-.307.566-1.04.562l-3.194-.019 1.442-1.858c.558-.72 1.012-.92 1.38-.919zm-7.995 0c.368-.002.82.197 1.38.918l1.44 1.859-3.191.019c-.736.004-.927-.225-1.04-.563-.117-.339-.046-.898.21-1.365.256-.466.654-.8 1.047-.856a.86.86 0 01.154-.013zm.006-1.165a1.913 1.913 0 00-.322.023c-.854.125-1.502.735-1.89 1.44-.387.705-.55 1.546-.29 2.316.26.769 1.056 1.354 2.13 1.35l2.591-.017a8.449 8.449 0 00-1.789 2.322c-.357.688.658 1.233 1.015.545a7.36 7.36 0 012.545-2.772 7.373 7.373 0 012.548 2.772.568.568 0 00.79.27.588.588 0 00.222-.815 8.464 8.464 0 00-1.79-2.322l2.595.016c1.073.005 1.87-.58 2.13-1.35.261-.77.096-1.61-.292-2.315-.386-.705-1.035-1.315-1.889-1.44-.852-.128-1.797.305-2.596 1.338l-1.716 2.217-1.717-2.217c-.698-.903-1.511-1.348-2.274-1.36z"
    })]
  });
};

/* harmony default export */ var CertificateIcon = (CertificateIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/CheckedIcon.js



var CheckedIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.10662 18.3492L20.4559 4L21.8701 5.41421L7.52083 19.7635L6.10662 18.3492Z",
      fill: "#0FB769"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M8.87029 18.3492L3.91421 13.3932L2.5 14.8074L7.45607 19.7635L8.87029 18.3492Z",
      fill: "#0FB769"
    })]
  });
};

/* harmony default export */ var CheckedIcon = (CheckedIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/DangerIcon.js


var DangerIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "27",
    height: "27",
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.4987 7.04427C14.2091 7.04427 14.7904 7.62552 14.7904 8.33594V13.5026C14.7904 14.213 14.2091 14.7943 13.4987 14.7943C12.7883 14.7943 12.207 14.213 12.207 13.5026V8.33594C12.207 7.62552 12.7883 7.04427 13.4987 7.04427ZM13.4858 0.585938C6.35578 0.585938 0.582031 6.3726 0.582031 13.5026C0.582031 20.6326 6.35578 26.4193 13.4858 26.4193C20.6287 26.4193 26.4154 20.6326 26.4154 13.5026C26.4154 6.3726 20.6287 0.585938 13.4858 0.585938ZM13.4987 23.8359C7.78953 23.8359 3.16536 19.2118 3.16536 13.5026C3.16536 7.79344 7.78953 3.16927 13.4987 3.16927C19.2079 3.16927 23.832 7.79344 23.832 13.5026C23.832 19.2118 19.2079 23.8359 13.4987 23.8359ZM14.7904 19.9609H12.207V17.3776H14.7904V19.9609Z",
      fill: "#EA5656"
    })
  });
};

/* harmony default export */ var DangerIcon = (DangerIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/DeliveryIcon.js


var DeliveryIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M21.6 24.3c-.6 0-1.2-.2-1.6-.5-.5-.3-.8-.8-1-1.4l-.1-.2h-5.2l-.1.2c-.2.6-.6 1-1 1.4-.5.3-1.1.5-1.6.5s-1.2-.2-1.6-.5c-.5-.3-.8-.8-1-1.4l-.1-.2H6.7c-.2 0-.4-.1-.5-.2-.1-.2-.2-.3-.2-.5V8.7c0-.2.1-.4.2-.5.1-.1.3-.2.5-.2h11.7c.2 0 .4.1.5.2.1.1.2.3.2.5s-.1.4-.2.5c-.1.1-.3.2-.5.2h-11v11.3h.8l.1-.2c.2-.6.6-1 1-1.4.5-.3 1.1-.5 1.6-.5s1.2.2 1.6.5c.5.3.8.8 1 1.4l.1.2h5.1l.1-.2c.2-.6.6-1 1-1.4.5-.3 1.1-.5 1.6-.5s1.2.2 1.6.5c.5.3.8.8 1 1.4l.1.2h.8v-4.2l-2.8-2.8h-3.2v2.5c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2s-.2-.1-.3-.2c-.1-.1-.2-.3-.2-.5V13c0-.2.1-.4.2-.5.1-.1.3-.2.5-.2h4.3c.2 0 .4.1.5.2l3.2 3.2c.1.1.2.3.2.5v5.3c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2h-1.5l-.1.2c-.2.6-.6 1-1 1.4-.5.3-1.1.5-1.7.5zm0-4.2c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4zm-10.6 0c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.7-.4-1-.4z"
    })
  });
};

/* harmony default export */ var DeliveryIcon = (DeliveryIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/DeliveryFastIcon.js



var DeliveryFastIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.4 16.388A5.496 5.496 0 016 15.68V21.5c0 .146.054.24.122.357.024.043.051.09.078.143.1.1.3.2.5.2h1.6l.1.2c.2.6.5 1.1 1 1.4.4.3 1.1.5 1.6.5s1.1-.2 1.6-.5c.4-.4.8-.8 1-1.4l.1-.2h5.2l.1.2c.2.6.5 1.1 1 1.4.4.3 1 .5 1.6.5.6 0 1.2-.2 1.7-.5.4-.4.8-.8 1-1.4l.1-.2h1.5c.2 0 .4-.1.5-.2.1-.1.2-.3.2-.5v-5.3c0-.2-.1-.4-.2-.5l-3.2-3.2c-.1-.1-.3-.2-.5-.2h-4.3c-.2 0-.4.1-.5.2-.1.1-.2.3-.2.5v3.2c0 .2.1.4.2.5a.633.633 0 01.065.079c.05.067.089.121.235.121.2 0 .4-.1.5-.2.1-.1.2-.3.2-.5v-2.5h3.2l2.8 2.8v4.2h-.8l-.1-.2c-.2-.6-.5-1.1-1-1.4-.4-.3-1.1-.5-1.6-.5s-1.1.2-1.6.5c-.4.4-.8.8-1 1.4l-.1.2h-5.1l-.1-.2c-.2-.6-.5-1.1-1-1.4-.4-.3-1.1-.5-1.6-.5s-1.1.2-1.6.5c-.4.4-.8.8-1 1.4l-.1.2h-.8v-4.312zM20.6 20.5c.3-.3.6-.4 1-.4s.7.1 1 .4c.3.3.4.6.4 1s-.1.7-.4 1c-.3.3-.6.4-1 .4s-.7-.1-1-.4c-.3-.3-.4-.6-.4-1s.1-.7.4-1zm-10.6 0c.3-.3.6-.4 1-.4.3 0 .7.1 1 .4.3.3.4.6.4 1s-.1.7-.4 1c-.3.3-.6.4-1 .4s-.7-.1-1-.4c-.3-.3-.4-.6-.4-1s.1-.7.4-1z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.388 9.4H18.4c.2 0 .4-.1.5-.2.1-.1.2-.3.2-.5s-.1-.4-.2-.5c-.1-.1-.3-.2-.5-.2h-4.72c.298.426.539.897.708 1.4z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9 5a6.01 6.01 0 00-6 6c0 3.306 2.694 6 6 6s6-2.694 6-6-2.694-6-6-6zm0 1.333A4.657 4.657 0 0113.667 11 4.657 4.657 0 019 15.667 4.657 4.657 0 014.333 11 4.657 4.657 0 019 6.333zm0 1A.667.667 0 008.333 8v3c.027.258.134.4.292.552l1.792 1.802c.26.26.687.26.948 0a.673.673 0 000-.948l-1.698-1.698V8A.667.667 0 009 7.333z"
    })]
  });
};

/* harmony default export */ var DeliveryFastIcon = (DeliveryFastIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/EditIcon.js


var EditIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#292C33' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '19' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 19' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M3 17.2501V21.0001H6.75L17.81 9.94006L14.06 6.19006L3 17.2501ZM20.71 7.04006C21.1 6.65006 21.1 6.02006 20.71 5.63006L18.37 3.29006C17.98 2.90006 17.35 2.90006 16.96 3.29006L15.13 5.12006L18.88 8.87006L20.71 7.04006Z",
      fill: "#CCCDD0"
    })
  });
};

/* harmony default export */ var EditIcon = (EditIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/EnvelopeIcon.js



var EnvelopeIcon_SVG = function SVG(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10 8L19 2.40863C18.6382 2.14616 18.1988 2.00293 17.7465 2H2.25352C1.80122 2.00293 1.36184 2.14616 1 2.40863L10 8Z",
      fill: "#0FB769"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.3857 9.80383L10.2643 9.85795H10.2071C10.1414 9.88578 10.0715 9.90402 10 9.91206C9.94071 9.91914 9.88072 9.91914 9.82143 9.91206H9.76429L9.64286 9.85795L0.0714285 4C0.0256986 4.16339 0.00170336 4.33154 0 4.50056V13.9707C0 14.5089 0.225765 15.0251 0.627628 15.4056C1.02949 15.7862 1.57454 16 2.14286 16H17.8571C18.4255 16 18.9705 15.7862 19.3724 15.4056C19.7742 15.0251 20 14.5089 20 13.9707V4.50056C19.9983 4.33154 19.9743 4.16339 19.9286 4L10.3857 9.80383Z",
      fill: "#0FB769"
    })]
  });
};

/* harmony default export */ var EnvelopeIcon = (EnvelopeIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/Exchange.js



var Exchange_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "29",
    height: "29",
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.00034 14.1349C0.987529 14.5225 1.33904 14.8666 1.85286 14.9696C2.36668 15.0725 2.91089 14.9079 3.17275 14.5703L4.56986 12.7688C6.22677 10.6324 9.52513 9.46197 12.8599 9.82703L13.0911 9.85234C13.1327 10.6158 13.1917 11.3788 13.2681 12.1412L13.3731 13.1893C13.4585 14.0416 14.7652 14.5181 15.7553 14.0579C19.0033 12.5484 21.8269 10.6033 24.0756 8.32632L24.7819 7.61124C25.0727 7.31676 25.0727 6.92012 24.7819 6.62564L24.0756 5.91055C21.8269 3.63359 19.0033 1.6885 15.7553 0.178945C14.7652 -0.281212 13.4585 0.195261 13.3731 1.04761L13.2681 2.09572C13.2065 2.71034 13.1562 3.3254 13.1172 3.94075L11.5407 3.94075C5.86626 3.94075 1.22845 7.23396 1.09206 11.3601L1.00034 14.1349ZM13.2056 8.1565C9.45955 7.74643 5.74926 8.84336 3.451 10.9589C3.85608 7.9596 7.33175 5.63009 11.5407 5.63009L14.2328 5.63009C14.8588 5.63009 15.3721 5.26929 15.3935 4.8143C15.4342 3.94846 15.4979 3.08304 15.5845 2.21854L15.5929 2.13469C18.1376 3.44298 20.3677 5.05167 22.1893 6.89615L22.4088 7.11844L22.1893 7.34073C20.3677 9.1852 18.1376 10.7939 15.5929 12.1022L15.5845 12.0183C15.487 11.0454 15.4186 10.0713 15.3792 9.09677C15.3627 8.68838 14.9467 8.34711 14.3913 8.2863L13.2056 8.1565Z",
      fill: "#74849C"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.9997 15.8074C28.0125 15.4457 27.661 15.1245 27.1471 15.0284C26.6333 14.9323 26.0891 15.086 25.8273 15.4011L24.4301 17.0824C22.7732 19.0764 19.4749 20.1688 16.1401 19.8281L15.9089 19.8045C15.8673 19.092 15.8083 18.3798 15.7319 17.6683L15.6269 16.69C15.5415 15.8945 14.2348 15.4498 13.2447 15.8793C9.99674 17.2882 7.17311 19.1036 4.92435 21.2288L4.21812 21.8962C3.92729 22.171 3.92729 22.5412 4.21812 22.8161L4.92435 23.4835C7.17311 25.6086 9.99674 27.4241 13.2447 28.833C14.2348 29.2625 15.5415 28.8178 15.6269 28.0222L15.7319 27.044C15.7935 26.4704 15.8438 25.8963 15.8828 25.322L17.4593 25.322C23.1337 25.322 27.7716 22.2483 27.9079 18.3973L27.9997 15.8074ZM15.7944 21.3873C19.5404 21.77 23.2507 20.7462 25.549 18.7717C25.1439 21.571 21.6683 23.7452 17.4593 23.7452L14.7672 23.7452C14.1412 23.7452 13.6279 24.082 13.6065 24.5067C13.5658 25.3148 13.5021 26.1225 13.4155 26.9294L13.4071 27.0076C10.8624 25.7865 8.63231 24.2851 6.81068 22.5636L6.59115 22.3561L6.81068 22.1487C8.63231 20.4271 10.8624 18.9257 13.4071 17.7046L13.4155 17.7829C13.513 18.691 13.5814 19.6001 13.6208 20.5097C13.6373 20.8908 14.0533 21.2094 14.6087 21.2661L15.7944 21.3873Z",
      fill: "#74849C"
    })]
  });
};

/* harmony default export */ var Exchange = (Exchange_SVG);
;// CONCATENATED MODULE: ./assets/icons/FacebookIcon.js


var FacebookIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '23' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 40 40' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M20.8523 0C9.81607 0 0.837402 9.03514 0.837402 20.1408C0.837402 30.2172 8.2369 38.5645 17.85 40.0297V25.1759H13.8471C13.2947 25.1759 12.8463 24.7258 12.8463 24.1689V21.1478C12.8463 20.5909 13.2947 20.1408 13.8471 20.1408H17.85V16.4832C17.85 11.6988 20.2788 9.06334 24.6891 9.06334C26.4765 9.06334 27.8865 9.18821 27.9455 9.19324C28.4619 9.23957 28.8582 9.67461 28.8582 10.1963V13.595C28.8582 14.1519 28.4099 14.602 27.8575 14.602H25.856C24.7522 14.602 23.8545 15.5054 23.8545 16.6161V20.1408H27.8575C28.1447 20.1408 28.4179 20.2646 28.608 20.4811C28.7982 20.6986 28.8862 20.9867 28.8512 21.2727L28.4759 24.2938C28.4129 24.7973 27.9866 25.1759 27.4822 25.1759H23.8545V40.0297C33.4676 38.5645 40.8671 30.2172 40.8671 20.1408C40.8671 9.03514 31.8885 0 20.8523 0Z",
      fill: "#171717"
    })
  });
};

/* harmony default export */ var FacebookIcon = (FacebookIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/FavoriteIcon.js


var FavoriteIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 'currentColor' : _ref$stroke,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "path",
      d: "M12.525 6.657c.24-.24.481-.482.802-.722 1.524-1.203 3.69-1.123 5.053.24.882.803 1.363 1.845 1.444 3.048.08 1.284-.241 2.487-1.123 3.45-.482.56-.963 1.042-1.444 1.603-.642.722-1.283 1.444-1.925 2.086-.722.802-1.524 1.604-2.246 2.406a.775.775 0 0 1-1.123 0L9.076 15.64c-.882-.963-1.845-2.005-2.727-2.968-.642-.722-1.043-1.604-1.123-2.486-.16-.963 0-1.845.4-2.727.643-1.284 1.605-2.166 3.049-2.406 1.363-.241 2.486.24 3.449 1.203l.4.4z",
      fill: fill,
      stroke: stroke,
      strokeWidth: "2"
    })
  });
};

/* harmony default export */ var FavoriteIcon = (FavoriteIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/FilterIcon.js


var FilterIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    fill: fill,
    viewBox: viewBox,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      stroke: "currentColor",
      strokeWidth: "1.3",
      strokeLinecap: "round",
      d: "M5.65 7.35h12.7M7.65 11.35h8.7M10.65 15.35h2.7"
    })
  });
};

/* harmony default export */ var FilterIcon = (FilterIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/GooglePlay.js



var GooglePlay_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '21' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '22' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 21 22' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M15.188 14.39c2.606-1.43 4.598-2.52 4.766-2.606.546-.288 1.108-1.056 0-1.652-.356-.19-2.28-1.242-4.766-2.607l-3.422 3.44 3.422 3.425z",
      fill: "#FFD900"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.765 10.968L.833 21.983c.254.034.545-.035.885-.223.716-.391 8.309-4.547 13.466-7.373l-3.419-3.419z",
      fill: "#F43249"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.766 10.968l3.422-3.44S2.486.599 1.722.19C1.434.02 1.108-.032.82.02l10.946 10.95z",
      fill: "#00EE76"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.765 10.969L.816.023C.374.123 0 .513 0 1.316V20.69c0 .73.288 1.259.833 1.31L11.765 10.97z",
      fill: "#00D3FF"
    })]
  });
};

/* harmony default export */ var GooglePlay = (GooglePlay_SVG);
;// CONCATENATED MODULE: ./assets/icons/GPSIcon.js


var GPSIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '19' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '20' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 19 20' : _ref$viewBox,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18 2L17.5 1.5L0.5 8V9L8.5 11L10.5 19H11.5L18 2Z",
      stroke: "#171717"
    })
  });
};

/* harmony default export */ var GPSIcon = (GPSIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/InputSuccessIcon.js



var InputSuccessIcon_SVG = function SVG(_ref) {
  var fill = _ref.fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '18' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '18' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 18 18' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "9",
      cy: "9",
      r: "9",
      fill: "#0FB769"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.75 7.05295L7.83866 12L5.25 9.38706L6.2657 8.33411L7.83866 9.92396L11.7343 6L12.75 7.05295Z",
      fill: "white"
    })]
  });
};

/* harmony default export */ var InputSuccessIcon = (InputSuccessIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/Giftcard.js



var Giftcard_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "29",
    height: "29",
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M3.00459 6.24451H17.8533H19.2403H25.9939C26.913 6.24451 27.6134 6.9481 27.6134 7.82814V21.4854C27.6134 22.3654 26.913 23.0709 25.9939 23.0709H19.2403C19.2403 23.0709 18.7292 23.0712 17.8537 23.0712H3.00496C2.08814 23.0712 1.38696 22.3658 1.38696 21.4857V15.3613C1.38696 14.9669 1.38659 13.9522 1.38659 13.9522V7.82851C1.38659 6.9481 2.08777 6.24451 3.00459 6.24451ZM3.00459 4.83398C1.36349 4.83398 0 6.17065 0 7.82814V21.4854C0 23.1425 1.36386 24.4791 3.00459 24.4791H25.9939C27.6365 24.4791 29 23.1425 29 21.4854V7.82851C29 6.17102 27.6361 4.83436 25.9939 4.83436L3.00459 4.83398Z",
      fill: "#74849C"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22.9557 8.45898C22.2344 8.45898 21.5864 8.777 21.1432 9.27974C20.7001 8.777 20.052 8.45898 19.3307 8.45898C17.9982 8.45898 16.9141 9.54309 16.9141 10.8757C16.9141 12.2082 17.9982 13.2923 19.3307 13.2923C20.052 13.2923 20.7001 12.9743 21.1432 12.4716C21.5864 12.9743 22.2344 13.2923 22.9557 13.2923C24.2883 13.2923 25.3724 12.2082 25.3724 10.8757C25.3724 9.54309 24.2883 8.45898 22.9557 8.45898ZM19.3307 12.084C18.6645 12.084 18.1224 11.5419 18.1224 10.8757C18.1224 10.2094 18.6645 9.66732 19.3307 9.66732C19.997 9.66732 20.5391 10.2094 20.5391 10.8757C20.5391 11.5419 19.997 12.084 19.3307 12.084ZM22.9557 12.084C22.2895 12.084 21.7474 11.5419 21.7474 10.8757C21.7474 10.2094 22.2895 9.66732 22.9557 9.66732C23.622 9.66732 24.1641 10.2094 24.1641 10.8757C24.1641 11.5419 23.622 12.084 22.9557 12.084Z",
      fill: "#74849C"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.65278 8.45898H5.63889C4.5284 8.45898 3.625 9.38828 3.625 10.5304V11.2209C3.625 12.363 4.5284 13.2923 5.63889 13.2923H7.65278C8.76327 13.2923 9.66667 12.363 9.66667 11.2209V10.5304C9.66667 9.38828 8.76327 8.45898 7.65278 8.45898ZM8.32407 11.2209C8.32407 11.6016 8.02291 11.9114 7.65278 11.9114H5.63889C5.26875 11.9114 4.96759 11.6016 4.96759 11.2209V10.5304C4.96759 10.1497 5.26875 9.83994 5.63889 9.83994H7.65278C8.02291 9.83994 8.32407 10.1497 8.32407 10.5304V11.2209Z",
      fill: "#74849C"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
      x1: "4.275",
      y1: "19.891",
      x2: "7.20417",
      y2: "19.891",
      stroke: "#74849C",
      strokeWidth: "1.3",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
      x1: "10.3141",
      y1: "19.891",
      x2: "13.2432",
      y2: "19.891",
      stroke: "#74849C",
      strokeWidth: "1.3",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
      x1: "16.3609",
      y1: "19.891",
      x2: "19.2901",
      y2: "19.891",
      stroke: "#74849C",
      strokeWidth: "1.3",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
      x1: "22.4",
      y1: "19.891",
      x2: "25.3292",
      y2: "19.891",
      stroke: "#74849C",
      strokeWidth: "1.3",
      strokeLinecap: "round"
    })]
  });
};

/* harmony default export */ var Giftcard = (Giftcard_SVG);
;// CONCATENATED MODULE: ./assets/icons/InstaIcon.js


var InstaIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '23' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 40 40' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.7881 0C6.10839 0 0.673828 5.43456 0.673828 12.1143V27.9155C0.673828 34.5952 6.10839 40.0297 12.7881 40.0297H28.5893C35.269 40.0297 40.7036 34.5952 40.7036 27.9155V12.1143C40.7036 5.43456 35.269 0 28.5893 0H12.7881ZM31.2228 7.3739C32.3869 7.3739 33.3297 8.31671 33.3297 9.48073C33.3297 10.6437 32.3869 11.5876 31.2228 11.5876C30.0588 11.5876 29.116 10.6437 29.116 9.48073C29.116 8.31671 30.0588 7.3739 31.2228 7.3739ZM20.6887 9.48073C26.4972 9.48073 31.2228 14.2063 31.2228 20.0149C31.2228 25.8234 26.4972 30.549 20.6887 30.549C14.8802 30.549 10.1546 25.8234 10.1546 20.0149C10.1546 14.2063 14.8802 9.48073 20.6887 9.48073ZM20.6887 12.641C19.7203 12.641 18.7615 12.8317 17.8668 13.2023C16.9722 13.5728 16.1593 14.116 15.4746 14.8007C14.7898 15.4855 14.2467 16.2984 13.8761 17.193C13.5055 18.0876 13.3148 19.0465 13.3148 20.0149C13.3148 20.9832 13.5055 21.9421 13.8761 22.8367C14.2467 23.7314 14.7898 24.5443 15.4746 25.229C16.1593 25.9137 16.9722 26.4569 17.8668 26.8275C18.7615 27.198 19.7203 27.3888 20.6887 27.3888C21.6571 27.3888 22.6159 27.198 23.5106 26.8275C24.4052 26.4569 25.2181 25.9137 25.9028 25.229C26.5876 24.5443 27.1307 23.7314 27.5013 22.8367C27.8719 21.9421 28.0626 20.9832 28.0626 20.0149C28.0626 19.0465 27.8719 18.0876 27.5013 17.193C27.1307 16.2984 26.5876 15.4855 25.9028 14.8007C25.2181 14.116 24.4052 13.5728 23.5106 13.2023C22.6159 12.8317 21.6571 12.641 20.6887 12.641V12.641Z",
      fill: "#171717"
    })
  });
};

/* harmony default export */ var InstaIcon = (InstaIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/IOS.js


var IOS_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '22' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '26' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 22 26' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22 19.074c-.863 2.472-3.453 6.842-6.118 6.892-1.768.033-2.338-1.032-4.358-1.032-2.02 0-2.653.999-4.325 1.065C4.366 26.106 0 19.685 0 14.085c0-5.142 3.637-7.689 6.818-7.738 1.705-.029 3.315 1.13 4.354 1.13 1.043 0 3-1.398 5.053-1.192.86.037 3.277.343 4.828 2.575-4.11 2.65-3.47 8.18.947 10.214zM16.255 0c-3.11.124-5.645 3.334-5.293 5.992 2.875.219 5.632-2.95 5.293-5.992z"
    })
  });
};

/* harmony default export */ var IOS = (IOS_SVG);
;// CONCATENATED MODULE: ./assets/icons/HeartIcon.js




var HeartIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#292C33' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '19' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 19' : _ref$viewBox,
      fullRed = _ref.fullRed;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: fullRed ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M16.0001 5.00011C16.0001 8.86611 9.00006 15 9.00006 15C9.00006 15 2.00006 10.8659 2.00006 6.99996C2.00006 3.13396 5.00006 1.00017 9.00006 3.49996C12.5001 2.50017 16.0001 1.13412 16.0001 5.00011Z",
        fill: "#EA5656"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9.02712 2.6084C9.28962 2.3459 9.55212 2.0834 9.90212 1.8209C11.5646 0.508398 13.9271 0.595898 15.4146 2.0834C16.3771 2.9584 16.9021 4.0959 16.9896 5.4084C17.0771 6.8084 16.7271 8.1209 15.7646 9.1709C15.2396 9.7834 14.7146 10.3084 14.1896 10.9209C13.4896 11.7084 12.7896 12.4959 12.0896 13.1959C11.3021 14.0709 10.4271 14.9459 9.63962 15.8209C9.28962 16.1709 8.76462 16.1709 8.41462 15.8209C7.36462 14.6834 6.31462 13.5459 5.26462 12.4084C4.30212 11.3584 3.25212 10.2209 2.28962 9.1709C1.58962 8.3834 1.15212 7.4209 1.06462 6.4584C0.889619 5.4084 1.06462 4.4459 1.50212 3.4834C2.20212 2.0834 3.25212 1.1209 4.82712 0.858398C6.31462 0.595898 7.53962 1.1209 8.58962 2.1709C8.76462 2.3459 8.85212 2.4334 9.02712 2.6084ZM9.02712 13.8084C9.72712 13.1084 10.3396 12.4084 10.9521 11.7959C12.1771 10.4834 13.3146 9.2584 14.5396 7.9459C15.5896 6.8084 15.6771 4.9709 14.7146 3.7459C13.6646 2.4334 11.9146 2.3459 10.6896 3.4834C10.3396 3.8334 10.0771 4.1834 9.72712 4.5334C9.28962 4.9709 8.76462 4.9709 8.32712 4.5334C7.98076 4.09 7.73469 3.85077 7.45212 3.4834C6.57712 2.5209 5.08962 2.3459 4.03962 3.1334C3.25212 3.6584 2.81462 4.4459 2.72712 5.4084C2.63962 6.3709 2.90212 7.2459 3.51462 7.9459C4.38962 8.9084 5.35212 9.9584 6.31462 10.9209C7.18962 11.8834 8.06462 12.8459 9.02712 13.8084Z",
        fill: fill
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.03 2.838c.3-.3.6-.6 1-.9 1.9-1.5 4.6-1.4 6.3.3 1.1 1 1.7 2.3 1.8 3.8.1 1.6-.3 3.1-1.4 4.3-.6.7-1.2 1.3-1.8 2-.8.9-1.6 1.8-2.4 2.6-.9 1-1.9 2-2.8 3-.4.4-1 .4-1.4 0l-3.6-3.9c-1.1-1.2-2.3-2.5-3.4-3.7-.8-.9-1.3-2-1.4-3.1-.2-1.2 0-2.3.5-3.4.8-1.6 2-2.7 3.8-3 1.7-.3 3.1.3 4.3 1.5l.5.5zm0 12.8c.8-.8 1.5-1.6 2.2-2.3 1.4-1.5 2.7-2.9 4.1-4.4 1.2-1.3 1.3-3.4.2-4.8-1.2-1.5-3.2-1.6-4.6-.3-.4.4-.7.8-1.1 1.2-.5.5-1.1.5-1.6 0-.395-.507-.676-.78-1-1.2-1-1.1-2.7-1.3-3.9-.4-.9.6-1.4 1.5-1.5 2.6-.1 1.1.2 2.1.9 2.9 1 1.1 2.1 2.3 3.2 3.4 1 1.1 2 2.2 3.1 3.3z",
      fill: fill
    })
  });
};

/* harmony default export */ var HeartIcon = (HeartIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/Lamp.js


var Lamp_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "20",
    height: "27",
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 1.97561C5.5148 1.97561 1.93548 5.55445 1.93548 9.89904C1.93548 12.5392 2.99474 14.8162 4.88431 16.2343C5.30077 16.5468 5.65705 17.0129 5.7935 17.6043C5.90548 18.0896 6.03365 18.681 6.1606 19.3077H9.03226V17.882C9.03226 17.6941 9.08478 17.51 9.18367 17.3515L10.2183 15.6928L7.89691 13.832C7.50564 13.5183 7.4111 12.953 7.67829 12.5246L9.18367 10.1111C9.47071 9.65094 10.0689 9.5154 10.5197 9.80839C10.9706 10.1014 11.1034 10.712 10.8163 11.1722L9.78173 12.8309L12.1031 14.6917C12.4944 15.0053 12.5889 15.5707 12.3217 15.9991L10.9677 18.1698V19.3077H13.8394C13.9663 18.681 14.0945 18.0896 14.2065 17.6043C14.3429 17.0129 14.6992 16.5468 15.1157 16.2343C17.0053 14.8162 18.0645 12.5392 18.0645 9.89904C18.0645 5.55445 14.4852 1.97561 10 1.97561ZM13.4693 21.2833H6.53068C6.67315 22.123 6.78491 22.9183 6.81876 23.4892C6.85438 24.0904 7.29453 24.6291 7.9435 24.7722L8.19637 24.828C9.38403 25.0899 10.616 25.0899 11.8036 24.828L12.0565 24.7722C12.7055 24.6291 13.1456 24.0904 13.1812 23.4892C13.2151 22.9183 13.3268 22.123 13.4693 21.2833ZM0 9.89904C0 4.40056 4.50844 0 10 0C15.4916 0 20 4.40056 20 9.89904C20 13.0914 18.7051 15.9927 16.2622 17.826C16.1508 17.9096 16.1042 17.9976 16.0904 18.0572C15.9377 18.7192 15.7516 19.5954 15.5819 20.4844C15.3461 21.7201 15.1541 22.9187 15.1132 23.6085C15.0228 25.1339 13.9233 26.3817 12.4652 26.7032L12.2124 26.759C10.7553 27.0803 9.24467 27.0803 7.78763 26.759L7.53476 26.7032C6.07666 26.3817 4.97722 25.1339 4.8868 23.6085C4.84591 22.9187 4.6539 21.7201 4.41806 20.4844C4.24839 19.5954 4.06232 18.7192 3.90956 18.0572C3.89581 17.9976 3.84923 17.9096 3.73782 17.826C1.29493 15.9927 0 13.0914 0 9.89904Z",
      fill: "#74849C"
    })
  });
};

/* harmony default export */ var Lamp = (Lamp_SVG);
;// CONCATENATED MODULE: ./assets/icons/LoginIcon.js



var LoginIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#292C33' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '15' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '15' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 15 15' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.375 0H3.125A.625.625 0 002.5.625V5a.625.625 0 101.25 0V1.25h10v12.5h-10V10a.625.625 0 00-1.25 0v4.375c0 .345.28.625.625.625h11.25c.345 0 .625-.28.625-.625V.625A.625.625 0 0014.375 0z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.808 9.558a.625.625 0 10.884.884l2.5-2.5a.64.64 0 00.041-.046l.017-.022.02-.027.016-.027.015-.025.014-.029.012-.027.01-.028.011-.03.007-.028.008-.03.005-.034.004-.027a.628.628 0 000-.124l-.004-.027-.005-.033-.008-.03-.007-.03-.01-.029-.01-.028-.013-.027-.014-.028c-.004-.01-.01-.017-.015-.026l-.016-.027c-.006-.01-.013-.018-.02-.027-.006-.007-.01-.015-.017-.022a.624.624 0 00-.04-.045l-2.501-2.5a.625.625 0 10-.884.883l1.433 1.433H.625a.625.625 0 100 1.25h6.616L5.808 9.558z"
    })]
  });
};

/* harmony default export */ var LoginIcon = (LoginIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/MailIcon.js



var MailIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4.724 6A.735.735 0 004 6.724v10.284c0 .392.333.725.724.725h14.55c.392 0 .721-.333.721-.725V6.724a.732.732 0 00-.72-.724H4.725zm.343 1.067h13.865v9.599H5.067v-9.6z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4.536 5.933a.533.533 0 00-.311.968l7.494 5.333a.533.533 0 00.621 0l7.435-5.333a.533.533 0 00-.31-.968H4.534zM6.205 7h11.602l-5.781 4.144L6.205 7z"
    })]
  });
};

/* harmony default export */ var MailIcon = (MailIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/MapIcon.js



var MapIcon_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.73112 16.5619C5.90563 16.16 6.30198 15.9 6.7401 15.9H22.1714C22.6114 15.9 23.0092 16.1623 23.1825 16.5668L23.9994 16.2167L23.1825 16.5668L26.8245 25.0668C27.1355 25.7926 26.603 26.6 25.8134 26.6H3.04894C2.25697 26.6 1.72451 25.7883 2.03997 25.0619L5.73112 16.5619Z",
      stroke: "#0FB769",
      strokeWidth: "1.8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "11.25",
      y: "13.75",
      width: "7.5",
      height: "5",
      rx: "1",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.72402 10.8952L7.82101 10.8708L7.72402 10.8952C8.10552 12.415 9.20116 14.218 10.9991 16.3075C11.535 16.9304 13.4141 18.8417 14.0257 19.3861C14.2617 19.5961 14.4153 19.7255 14.5381 19.8017C14.6684 19.8826 14.7674 19.9059 14.89 19.9076C15.0221 19.9095 15.1348 19.8803 15.2776 19.7917C15.4144 19.7068 15.5826 19.565 15.8288 19.3418C16.4753 18.7555 18.2602 16.933 18.8 16.3076C20.7363 14.0646 21.9066 12.0524 22.1539 10.5037C22.4181 8.84957 21.8005 6.69808 20.6462 5.22452C20.3769 4.88066 19.7531 4.25176 19.4125 3.98059L19.3503 4.05883L19.4125 3.98059C17.8762 2.75754 15.8795 2.20123 13.964 2.46377C11.47 2.80553 9.3614 4.36258 8.28194 6.65852C7.64722 8.00851 7.4221 9.69222 7.72402 10.8952ZM10.8067 5.66676L10.7355 5.59655L10.8067 5.66676C11.7321 4.72835 12.8683 4.15414 14.1561 3.97355L14.1561 3.97355C14.3383 3.94799 14.7018 3.94264 15.0717 3.954C15.4417 3.96537 15.803 3.99299 15.9811 4.02957C18.0552 4.45553 19.7417 5.95208 20.4024 7.95198C20.6521 8.7078 20.762 9.68953 20.6668 10.2635C20.4524 11.5573 19.4317 13.2586 17.5376 15.4368C17.2895 15.7221 16.7158 16.3247 16.1704 16.8824C15.898 17.1608 15.6335 17.4273 15.4212 17.6364C15.2065 17.848 15.0507 17.9953 14.9923 18.0404C14.9923 18.0404 14.9923 18.0404 14.9923 18.0404L14.9023 18.11L14.7695 18.0001C14.6673 17.9155 14.167 17.4263 13.6552 16.9094C11.7431 14.9782 10.4698 13.3521 9.72448 11.8971L9.63548 11.9427L9.72448 11.8971C9.23521 10.942 9.06394 10.2656 9.10736 9.50234C9.19154 8.02323 9.7697 6.71842 10.8067 5.66676Z",
      fill: "#0FB769",
      stroke: "#0FB769",
      strokeWidth: "0.2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.974 8.22091L11.974 8.22091C11.704 8.78884 11.6116 9.28011 11.6459 9.98161L11.6459 9.98162C11.6585 10.24 11.6747 10.4008 11.7146 10.5552C11.7546 10.7098 11.8195 10.8625 11.9361 11.103L11.9361 11.103C13.2221 13.7577 17.023 13.5445 18.0192 10.7593C18.1114 10.5015 18.163 10.1521 18.1692 9.79185C18.1754 9.43196 18.1362 9.0699 18.0526 8.78767M11.974 8.22091L14.274 6.50416C14.6945 6.41845 15.1189 6.42632 15.621 6.53222L15.621 6.53222C16.7991 6.78062 17.7075 7.62279 18.0526 8.78767M11.974 8.22091C12.3933 7.33886 13.2181 6.71952 14.274 6.50416L11.974 8.22091ZM18.0526 8.78767L18.1485 8.75927L18.0526 8.78768C18.0526 8.78768 18.0526 8.78767 18.0526 8.78767ZM15.6417 6.43438L15.6417 6.43438L15.6417 6.43438Z",
      fill: "#0FB769",
      stroke: "white",
      strokeWidth: "0.2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "14.9052",
      cy: "9.71184",
      rx: "1.44231",
      ry: "1.44231",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.0562 15.9609L8.65234 26.5379",
      stroke: "#0FB769",
      strokeWidth: "1.8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.7876 15.9609L20.1914 26.5379",
      stroke: "#0FB769",
      strokeWidth: "1.8"
    })]
  });
};

/* harmony default export */ var MapIcon = (MapIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/MapPinIcon.js



var MapPinIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '14' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '21' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 14 21' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "path-1-inside-1_10754_197926",
      fill: "white",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.21846 1.1176C11.3104 1.78869 13.0123 3.55324 13.6596 5.72169C14.357 8.05592 13.972 10.4789 12.6041 12.3694L7.79982 18.7559C7.39978 19.2876 6.60164 19.2877 6.20158 18.7559L1.39732 12.37C0.483301 11.1075 0 9.60298 0 8.01939C0 5.72385 1.06548 3.53903 2.85038 2.17515C4.64853 0.801786 7.00431 0.40666 9.21846 1.1176ZM7 11.2467C8.61083 11.2467 9.91667 9.91421 9.91667 8.27051C9.91667 6.6268 8.61083 5.29432 7 5.29432C5.38917 5.29432 4.08333 6.6268 4.08333 8.27051C4.08333 9.91421 5.38917 11.2467 7 11.2467Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.21846 1.1176C11.3104 1.78869 13.0123 3.55324 13.6596 5.72169C14.357 8.05592 13.972 10.4789 12.6041 12.3694L7.79982 18.7559C7.39978 19.2876 6.60164 19.2877 6.20158 18.7559L1.39732 12.37C0.483301 11.1075 0 9.60298 0 8.01939C0 5.72385 1.06548 3.53903 2.85038 2.17515C4.64853 0.801786 7.00431 0.40666 9.21846 1.1176ZM7 11.2467C8.61083 11.2467 9.91667 9.91421 9.91667 8.27051C9.91667 6.6268 8.61083 5.29432 7 5.29432C5.38917 5.29432 4.08333 6.6268 4.08333 8.27051C4.08333 9.91421 5.38917 11.2467 7 11.2467Z",
      fill: "#0FB769"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.6596 5.72169L12.7014 6.00775L12.7015 6.00794L13.6596 5.72169ZM9.21846 1.1176L8.91274 2.06972L8.913 2.0698L9.21846 1.1176ZM12.6041 12.3694L13.4032 12.9706L13.4088 12.9632L13.4143 12.9556L12.6041 12.3694ZM7.79982 18.7559L7.00069 18.1547H7.00069L7.79982 18.7559ZM6.20158 18.7559L7.00069 18.1547L7.00069 18.1547L6.20158 18.7559ZM1.39732 12.37L0.587319 12.9564L0.592698 12.9638L0.598213 12.9712L1.39732 12.37ZM2.85038 2.17515L2.2434 1.38043L2.24323 1.38057L2.85038 2.17515ZM14.6178 5.43563C13.8795 2.96251 11.9413 0.940864 9.52392 0.165393L8.913 2.0698C10.6796 2.63652 12.145 4.14396 12.7014 6.00775L14.6178 5.43563ZM13.4143 12.9556C14.9736 10.8006 15.3996 8.0525 14.6178 5.43544L12.7015 6.00794C13.3143 8.05934 12.9704 10.1573 11.794 11.7832L13.4143 12.9556ZM8.59895 19.357L13.4032 12.9706L11.805 11.7683L7.00069 18.1547L8.59895 19.357ZM5.40247 19.3571C6.20258 20.4206 7.79887 20.4206 8.59895 19.357L7.00069 18.1547H7.00069L5.40247 19.3571ZM0.598213 12.9712L5.40247 19.3571L7.00069 18.1547L2.19643 11.7688L0.598213 12.9712ZM-1 8.01939C-1 9.81002 -0.452281 11.5205 0.587319 12.9564L2.20733 11.7836C1.41888 10.6945 1 9.39594 1 8.01939H-1ZM2.24323 1.38057C0.204394 2.93848 -1 5.42031 -1 8.01939H1C1 6.02739 1.92657 4.13958 3.45754 2.96973L2.24323 1.38057ZM9.52418 0.165474C7.00669 -0.642861 4.30855 -0.19686 2.2434 1.38043L3.45736 2.96987C4.98851 1.80043 7.00193 1.45618 8.91274 2.06972L9.52418 0.165474ZM8.91667 8.27051C8.91667 9.38107 8.0396 10.2467 7 10.2467V12.2467C9.18207 12.2467 10.9167 10.4474 10.9167 8.27051H8.91667ZM7 6.29432C8.0396 6.29432 8.91667 7.15995 8.91667 8.27051H10.9167C10.9167 6.09366 9.18207 4.29432 7 4.29432V6.29432ZM5.08333 8.27051C5.08333 7.15995 5.9604 6.29432 7 6.29432V4.29432C4.81793 4.29432 3.08333 6.09366 3.08333 8.27051H5.08333ZM7 10.2467C5.9604 10.2467 5.08333 9.38107 5.08333 8.27051H3.08333C3.08333 10.4474 4.81793 12.2467 7 12.2467V10.2467Z",
      fill: "#0FB769",
      mask: "url(#path-1-inside-1_10754_197926)"
    })]
  });
};

/* harmony default export */ var MapPinIcon = (MapPinIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/MArrowUpIcon.js


var MArrowUpIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6 15L11.6569 9.34315L17.3137 15",
      stroke: "#292C33"
    })
  });
};

/* harmony default export */ var MArrowUpIcon = (MArrowUpIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/MapPointIcon.js



var MapPointIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "14",
    height: "21",
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "path-1-inside-1_11353_272987",
      fill: "white",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.21846 1.11784C11.3104 1.78894 13.0123 3.55348 13.6596 5.72194C14.357 8.05616 13.972 10.4792 12.6041 12.3697L7.79982 18.7561C7.39978 19.2879 6.60164 19.2879 6.20158 18.7561L1.39732 12.3702C0.483301 11.1077 0 9.60323 0 8.01963C0 5.72409 1.06548 3.53927 2.85038 2.17539C4.64853 0.80203 7.00431 0.406904 9.21846 1.11784ZM7 11.2469C8.61083 11.2469 9.91667 9.91446 9.91667 8.27075C9.91667 6.62705 8.61083 5.29456 7 5.29456C5.38917 5.29456 4.08333 6.62705 4.08333 8.27075C4.08333 9.91446 5.38917 11.2469 7 11.2469Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.21846 1.11784C11.3104 1.78894 13.0123 3.55348 13.6596 5.72194C14.357 8.05616 13.972 10.4792 12.6041 12.3697L7.79982 18.7561C7.39978 19.2879 6.60164 19.2879 6.20158 18.7561L1.39732 12.3702C0.483301 11.1077 0 9.60323 0 8.01963C0 5.72409 1.06548 3.53927 2.85038 2.17539C4.64853 0.80203 7.00431 0.406904 9.21846 1.11784ZM7 11.2469C8.61083 11.2469 9.91667 9.91446 9.91667 8.27075C9.91667 6.62705 8.61083 5.29456 7 5.29456C5.38917 5.29456 4.08333 6.62705 4.08333 8.27075C4.08333 9.91446 5.38917 11.2469 7 11.2469Z",
      fill: "#0FB769"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.6596 5.72194L12.7014 6.00799L12.7015 6.00819L13.6596 5.72194ZM9.21846 1.11784L8.91274 2.06996L8.913 2.07005L9.21846 1.11784ZM12.6041 12.3697L13.4032 12.9708L13.4088 12.9634L13.4143 12.9559L12.6041 12.3697ZM7.79982 18.7561L7.00069 18.155H7.00069L7.79982 18.7561ZM6.20158 18.7561L7.00069 18.155L7.00069 18.155L6.20158 18.7561ZM1.39732 12.3702L0.587319 12.9567L0.592698 12.9641L0.598213 12.9714L1.39732 12.3702ZM2.85038 2.17539L2.2434 1.38068L2.24323 1.38081L2.85038 2.17539ZM14.6178 5.43588C13.8795 2.96276 11.9413 0.941108 9.52392 0.165637L8.913 2.07005C10.6796 2.63676 12.145 4.14421 12.7014 6.00799L14.6178 5.43588ZM13.4143 12.9559C14.9736 10.8009 15.3996 8.05275 14.6178 5.43569L12.7015 6.00819C13.3143 8.05958 12.9704 10.1575 11.794 11.7835L13.4143 12.9559ZM8.59895 19.3573L13.4032 12.9708L11.805 11.7685L7.00069 18.155L8.59895 19.3573ZM5.40247 19.3573C6.20258 20.4209 7.79887 20.4208 8.59895 19.3573L7.00069 18.155H7.00069L5.40247 19.3573ZM0.598213 12.9714L5.40247 19.3573L7.00069 18.155L2.19643 11.769L0.598213 12.9714ZM-1 8.01963C-1 9.81027 -0.452281 11.5207 0.587319 12.9567L2.20733 11.7838C1.41888 10.6948 1 9.39619 1 8.01963H-1ZM2.24323 1.38081C0.204394 2.93872 -1 5.42056 -1 8.01963H1C1 6.02763 1.92657 4.13982 3.45754 2.96998L2.24323 1.38081ZM9.52418 0.165719C7.00669 -0.642617 4.30855 -0.196616 2.2434 1.38068L3.45736 2.97011C4.98851 1.80068 7.00193 1.45642 8.91274 2.06996L9.52418 0.165719ZM8.91667 8.27075C8.91667 9.38131 8.0396 10.2469 7 10.2469V12.2469C9.18207 12.2469 10.9167 10.4476 10.9167 8.27075H8.91667ZM7 6.29456C8.0396 6.29456 8.91667 7.16019 8.91667 8.27075H10.9167C10.9167 6.0939 9.18207 4.29456 7 4.29456V6.29456ZM5.08333 8.27075C5.08333 7.16019 5.9604 6.29456 7 6.29456V4.29456C4.81793 4.29456 3.08333 6.0939 3.08333 8.27075H5.08333ZM7 10.2469C5.9604 10.2469 5.08333 9.38131 5.08333 8.27075H3.08333C3.08333 10.4476 4.81793 12.2469 7 12.2469V10.2469Z",
      fill: "#0FB769",
      mask: "url(#path-1-inside-1_11353_272987)"
    })]
  });
};

/* harmony default export */ var MapPointIcon = (MapPointIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/MArrowLeftIcon.js



var MArrowLeftIcon_SVG = function SVG(_ref) {
  var fill = _ref.fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      filter: "url(#m-arrow-left-filter)",
      fill: fill,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6 12.314L15.314 3l1.414 1.414-9.314 9.314L6 12.314z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6 12.414l9.314 9.314 1.414-1.414L7.414 11 6 12.414z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "m-arrow-left-filter",
        x: "5",
        y: "3",
        width: "12.728",
        height: "20.728",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: ".5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })]
      })
    })]
  });
};

/* harmony default export */ var MArrowLeftIcon = (MArrowLeftIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/MArrowRightIcon.js



var MArrowRightIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      filter: "url(#m-arrow-right-filter)",
      fill: fill,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M18 12.314L8.686 3 7.272 4.414l9.314 9.314L18 12.314z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M18 12.414l-9.314 9.314-1.414-1.414L16.586 11 18 12.414z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "m-arrow-right-filter",
        x: "6.271",
        y: "3",
        width: "12.728",
        height: "20.728",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: ".5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })]
      })
    })]
  });
};

/* harmony default export */ var MArrowRightIcon = (MArrowRightIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/MinusIcon.js


var MinusIcon_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "6",
      y: "11",
      width: "12",
      height: "2",
      fill: "#292C33"
    })
  });
};

/* harmony default export */ var MinusIcon = (MinusIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/PinIcon.js


var PinIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12 20.856a.92.92 0 01-.738-.36c-.972-1.296-4.014-5.778-5.058-9.162a5.815 5.815 0 01-.342-1.836v-.216A6.146 6.146 0 0112 3.144c1.638 0 3.186.648 4.338 1.8a6.115 6.115 0 011.8 4.338v.234a6.369 6.369 0 01-.342 1.836c-1.044 3.366-4.086 7.848-5.058 9.144a.92.92 0 01-.738.36zm0-16.83a5.262 5.262 0 00-5.256 5.256v.18c.018.54.126 1.08.306 1.584v.018c.99 3.276 3.96 7.632 4.914 8.91 0 0 .018.018.036.018s.018-.018.036-.018c.954-1.278 3.924-5.634 4.914-8.892v-.018a5.26 5.26 0 00.306-1.584v-.198c0-1.404-.54-2.736-1.548-3.726-.972-.99-2.304-1.53-3.708-1.53zm0 8.01a2.766 2.766 0 01-2.754-2.754A2.766 2.766 0 0112 6.528a2.766 2.766 0 012.754 2.754A2.766 2.766 0 0112 12.036zm0-4.626a1.882 1.882 0 00-1.872 1.872c0 1.026.846 1.872 1.872 1.872a1.882 1.882 0 001.872-1.872A1.882 1.882 0 0012 7.41z"
    })
  });
};

/* harmony default export */ var PinIcon = (PinIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/PhoneIcon.js


var PhoneIcon_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.02198 0.0672355C2.8942 0.11284 2.70716 0.215382 2.60638 0.295076C2.21507 0.604522 1.17487 1.73057 0.911247 2.13009C-0.00314549 3.51593 -0.240918 5.17075 0.250262 6.73068C0.472946 7.43773 1.38365 9.12091 2.26526 10.4546C3.26978 11.9743 4.2525 13.1666 5.64362 14.5535C7.00904 15.9148 8.0264 16.7544 9.49944 17.7354C10.5709 18.449 11.9801 19.2507 12.6954 19.5536C14.0981 20.1476 15.6032 20.1488 17.014 19.5571C17.4424 19.3775 17.865 19.1181 18.2974 18.7693C18.7977 18.3657 19.7871 17.3447 19.8929 17.1227C20.0155 16.8652 20.0361 16.3935 19.9378 16.0911C19.8643 15.8648 19.7236 15.7126 17.8702 13.8553C15.6493 11.6297 15.6357 11.6187 15.0868 11.6206C14.5778 11.6223 14.45 11.7071 13.4198 12.7274C12.9183 13.224 12.4363 13.6675 12.3485 13.713C12.2465 13.7659 12.0945 13.795 11.9273 13.7938C11.6816 13.792 11.6371 13.773 11.1979 13.4822C10.9407 13.3119 10.5149 13.0067 10.2516 12.8041C9.82264 12.474 9.75244 12.4357 9.57525 12.4353C9.41488 12.4349 9.35685 12.4589 9.26755 12.5625C9.14028 12.7102 9.11976 12.9751 9.22411 13.1239C9.35845 13.3153 10.7454 14.3155 11.1907 14.5421C11.4748 14.6866 11.9178 14.75 12.2345 14.6916C12.7787 14.5911 12.9316 14.4828 13.9407 13.4836C14.5076 12.9223 14.9261 12.5433 14.9989 12.5253C15.0724 12.5072 15.1702 12.5225 15.2496 12.5645C15.3213 12.6023 16.2158 13.4699 17.2375 14.4924C19.0696 16.326 19.0951 16.354 19.0951 16.5352C19.0951 16.7125 19.069 16.7446 18.3544 17.4463C17.5761 18.2105 17.305 18.4173 16.7389 18.6785C16.1222 18.9629 15.6094 19.0715 14.8785 19.0723C13.8766 19.0734 13.3969 18.9311 12.1662 18.2678C8.8174 16.4629 6.1947 14.2212 3.93067 11.2287C2.78922 9.71996 1.45968 7.47569 1.14004 6.51804C0.808863 5.52575 0.844966 4.42583 1.24092 3.44716C1.5034 2.79832 1.72111 2.49674 2.49957 1.70363C2.91184 1.28363 3.2969 0.927986 3.3552 0.913376C3.41346 0.898766 3.51876 0.910645 3.58919 0.939728C3.65958 0.968857 4.56175 1.83757 5.59403 2.87018C7.4193 4.69604 7.4709 4.75253 7.4709 4.92393C7.4709 5.09229 7.4291 5.14221 6.53887 6.03764C5.72253 6.8588 5.5886 7.01409 5.45964 7.28926C5.34586 7.53199 5.3078 7.68268 5.29221 7.95208C5.26198 8.47302 5.3496 8.71092 5.83937 9.43764C6.39528 10.2626 6.49374 10.3639 6.73903 10.3639C6.89033 10.3639 6.95907 10.3358 7.06415 10.2309C7.29184 10.0035 7.25757 9.87884 6.78125 9.20256C6.29631 8.51399 6.19689 8.31878 6.19552 8.05266C6.19374 7.70275 6.29412 7.56549 7.2825 6.56674C8.32617 5.51219 8.38261 5.42672 8.38261 4.90149C8.38261 4.38901 8.32289 4.31546 6.16193 2.16472C4.8214 0.830587 4.14784 0.191851 4.00775 0.121943C3.72882 -0.0171918 3.32165 -0.0398122 3.02198 0.0672355ZM7.78617 11.1733C7.54106 11.392 7.60634 11.7674 7.91153 11.8947C8.03816 11.9475 8.10362 11.9508 8.22684 11.9102C8.54512 11.8052 8.62872 11.4219 8.38612 11.1797C8.20669 11.0005 7.98255 10.9982 7.78617 11.1733Z",
      fill: "black"
    })
  });
};

/* harmony default export */ var PhoneIcon = (PhoneIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/PlusIcon.js



var PlusIcon_SVG = function SVG(_ref) {
  var verticalClassName = _ref.verticalClassName,
      horizontalClassName = _ref.horizontalClassName;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: verticalClassName,
      d: "M6 11H18V13H6V11Z",
      fill: "#171717"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: horizontalClassName,
      d: "M13 6L13 18H11L11 6L13 6Z",
      fill: "#171717"
    })]
  });
};

/* harmony default export */ var PlusIcon = (PlusIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/PlusImageIcon.js



var PlusImageIcon_SVG = function SVG(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "51",
    height: "51",
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "25.5",
      cy: "25.5",
      r: "25.5",
      fill: "#F0F0F0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "23.9805",
      y: "13",
      width: "3.01508",
      height: "25",
      fill: "#0FB769"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "38.0508",
      y: "24",
      width: "3",
      height: "25.1256",
      transform: "rotate(90 38.0508 24)",
      fill: "#0FB769"
    })]
  });
};

/* harmony default export */ var PlusImageIcon = (PlusImageIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/PhoneIconFill.js


var PhoneIconFill_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.7455 10.3272C12.0678 9.94777 11.3779 10.1839 11.0926 10.5567L10.4959 11.3037C10.1927 11.6832 9.62621 11.6327 9.62621 11.6327C5.4919 10.5753 4.38631 6.39076 4.38631 6.39076C4.38631 6.39076 4.33556 5.82424 4.71415 5.52042L5.46036 4.92338C5.83346 4.63681 6.06939 3.9469 5.68943 3.26893C4.67437 1.49507 3.99264 0.88344 3.6456 0.413772C3.28072 -0.0280348 2.73204 -0.127541 2.16142 0.170977H2.14907C0.962551 0.842311 -0.336448 2.09874 0.0791767 3.39232C0.788346 4.75621 2.09146 9.10396 6.24497 12.389C8.1969 13.9426 11.286 15.5347 12.5973 15.9022L12.6097 15.9208C13.9018 16.3374 15.1583 15.0319 15.829 13.8497V13.8404C16.1267 13.2686 16.0279 12.7273 15.5931 12.3731C14.8222 11.646 13.659 10.8433 12.7455 10.3272Z",
      fill: fill
    })
  });
};

/* harmony default export */ var PhoneIconFill = (PhoneIconFill_SVG);
;// CONCATENATED MODULE: ./assets/icons/PhoneIconFillContacts.js


var PhoneIconFillContacts_SVG = function SVG(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    className: className,
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.7659 17.5231L19.7634 17.5257V17.5193L18.8018 18.4825C17.5582 19.7524 15.7469 20.2748 14.0254 19.8604C12.291 19.3923 10.6422 18.6471 9.14155 17.6533C7.74735 16.7548 6.4553 15.7045 5.28884 14.5212C4.21557 13.4469 3.25136 12.2672 2.41036 10.9999C1.49048 9.63627 0.762386 8.15076 0.246769 6.58564C-0.344319 4.74699 0.145499 2.72945 1.51205 1.37401L2.63811 0.238571C2.95118 -0.0785361 3.4599 -0.0796582 3.77432 0.236028L3.77684 0.238571L7.33219 3.82355C7.64667 4.13924 7.64778 4.6522 7.33471 4.96923L7.33219 4.97177L5.24451 7.07685C4.64549 7.67428 4.57017 8.62366 5.0674 9.30952C5.82248 10.3544 6.65806 11.3377 7.56631 12.2503C8.57893 13.2757 9.67978 14.2086 10.856 15.0379C11.5356 15.5159 12.4569 15.4353 13.0448 14.8466L15.0629 12.7798C15.376 12.4626 15.8847 12.4615 16.1991 12.7772L16.2016 12.7798L19.7633 16.3775C20.0779 16.6931 20.079 17.206 19.7659 17.5231Z",
      fill: "#0FB769"
    })
  });
};

/* harmony default export */ var PhoneIconFillContacts = (PhoneIconFillContacts_SVG);
;// CONCATENATED MODULE: ./assets/icons/ProductsIcon.js


var ProductsIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26 16.1L24.3 7h-6.7l-.1.7c-.1.8-.7 1.4-1.4 1.4s-1.3-.6-1.4-1.4V7h-7L6 16h3.6l-1 8.8h14.8l-1-8.7H26zm-15.7 7.2l1.2-11.4-1.4-.1-.4 2.7H7.8l1.1-6h4.5c.4 1.2 1.5 2.1 2.8 2.1 1.3 0 2.4-.9 2.8-2.1h4.2l1.1 6.1h-1.9l-.3-2.9-1.5.2 1.3 11.4H10.3z"
    })
  });
};

/* harmony default export */ var ProductsIcon = (ProductsIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/RemoveIcon.js


var RemoveIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#292C33' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '19' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 19' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.0001 2.1001C9.39847 2.1001 8.1001 3.39847 8.1001 5.0001V5.1001H5.0001H4.0001C3.50304 5.1001 3.1001 5.50304 3.1001 6.0001C3.1001 6.49715 3.50304 6.9001 4.0001 6.9001H5.0001H5.60962L6.43377 19.1529L6.43384 19.154C6.51509 20.4447 7.58562 21.4501 8.879 21.4501H15.1212C16.4146 21.4501 17.4851 20.4447 17.5664 19.154L17.5664 19.1529L18.3906 6.9001H19.0001H20.0001C20.4972 6.9001 20.9001 6.49715 20.9001 6.0001C20.9001 5.50304 20.4972 5.1001 20.0001 5.1001H19.0001H15.9001V5.0001C15.9001 3.39847 14.6017 2.1001 13.0001 2.1001H11.0001ZM14.1001 5.1001H9.9001V5.0001C9.9001 4.39258 10.3926 3.9001 11.0001 3.9001H13.0001C13.6076 3.9001 14.1001 4.39258 14.1001 5.0001V5.1001ZM10.5993 9.96156C10.578 9.46496 10.1582 9.07964 9.66156 9.10092C9.16496 9.12221 8.77964 9.54203 8.80092 10.0386L9.10092 17.0386C9.12221 17.5352 9.54203 17.9206 10.0386 17.8993C10.5352 17.878 10.9206 17.4582 10.8993 16.9616L10.5993 9.96156ZM15.1993 10.0386C15.2206 9.54203 14.8352 9.12221 14.3386 9.10092C13.842 9.07964 13.4222 9.46496 13.4009 9.96156L13.1009 16.9616C13.0796 17.4582 13.465 17.878 13.9616 17.8993C14.4582 17.9206 14.878 17.5352 14.8993 17.0386L15.1993 10.0386Z",
      fill: "#CCCDD0"
    })
  });
};

/* harmony default export */ var RemoveIcon = (RemoveIcon_SVG);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./assets/icons/RemoveImageIcon.js

var _excluded = ["fill", "width", "height", "viewBox", "className", "onClick"];



var RemoveImageIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox,
      className = _ref.className,
      onClick = _ref.onClick,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    onClick: onClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      width: "12",
      height: "12",
      rx: "6",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "0.25",
      y: "0.25",
      width: "11.5",
      height: "11.5",
      rx: "5.75",
      fill: "white",
      stroke: "#F0F0F0",
      "stroke-width": "0.5"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M3.45714 3L9 8.543L8.54301 9L3.00015 3.457L3.45714 3Z",
      fill: "#959595"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M8.54286 3L3 8.543L3.45699 9L8.99985 3.457L8.54286 3Z",
      fill: "#959595"
    })]
  });
};

/* harmony default export */ var RemoveImageIcon = (RemoveImageIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/RemoveProductIcon.js


var RemoveProductIcon_excluded = ["fill", "width", "height", "viewBox", "className", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var RemoveProductIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox,
      className = _ref.className,
      onClick = _ref.onClick,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, RemoveProductIcon_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    onClick: onClick
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.06671 0.359375L9.64318 8.93585L8.93608 9.64296L0.359602 1.06648L1.06671 0.359375Z",
      fill: "#171717"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M8.93585 0.359375L0.359375 8.93585L1.06648 9.64296L9.64296 1.06648L8.93585 0.359375Z",
      fill: "#171717"
    })]
  }));
};

/* harmony default export */ var RemoveProductIcon = (RemoveProductIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/SearchIcon.js


var SearchIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#292C33' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '18' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '19' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 18 19' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M15.426 17.794a.956.956 0 0 0 1.377.027c.385-.38.397-1.01.027-1.405l-.073.068.073-.068-3.885-4.145a7.05 7.05 0 0 0 1.537-4.407C14.482 4.026 11.438.9 7.692.9 3.943.9.9 4.026.9 7.864c0 3.837 3.044 6.964 6.791 6.964 1.377 0 2.69-.418 3.82-1.21l3.915 4.176zM7.69 2.89c2.67 0 4.846 2.228 4.846 4.973 0 2.744-2.176 4.973-4.846 4.973s-4.845-2.229-4.845-4.973c0-2.745 2.176-4.973 4.845-4.973z",
      fill: fill,
      stroke: fill,
      strokeWidth: "0.2"
    })
  });
};

/* harmony default export */ var SearchIcon = (SearchIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/ShopMapIcon.js



var ShopMapIcon_SVG = function SVG(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    width: "15",
    height: "22",
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "path-1-inside-1_11436_267735",
      fill: "white",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.87692 1.12372C12.1183 1.82837 13.9417 3.68114 14.6353 5.95802C15.3825 8.40896 14.97 10.9531 13.5044 12.9381L8.29398 19.7259C7.89371 20.2474 7.10781 20.2474 6.70752 19.726L1.49713 12.9387C0.517822 11.6131 0 10.0334 0 8.3706C0 5.96029 1.14159 3.66622 3.05398 2.23415C4.98057 0.79212 7.50461 0.377237 9.87692 1.12372ZM7.5 11.7593C9.22589 11.7593 10.625 10.3602 10.625 8.63428C10.625 6.90839 9.22589 5.50928 7.5 5.50928C5.77411 5.50928 4.375 6.90839 4.375 8.63428C4.375 10.3602 5.77411 11.7593 7.5 11.7593Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.6353 5.95802L13.6787 6.24943L13.6788 6.24962L14.6353 5.95802ZM9.87692 1.12372L9.57677 2.07761L9.57701 2.07769L9.87692 1.12372ZM13.5044 12.9381L14.2976 13.547L14.3033 13.5396L14.3089 13.5321L13.5044 12.9381ZM8.29398 19.7259L9.08722 20.3348H9.08722L8.29398 19.7259ZM6.70752 19.726L5.9143 20.3349L5.9143 20.3349L6.70752 19.726ZM1.49713 12.9387L0.69281 13.5329L0.698292 13.5403L0.703911 13.5477L1.49713 12.9387ZM3.05398 2.23415L2.45476 1.43357L2.45458 1.4337L3.05398 2.23415ZM15.5919 5.66662C14.8037 3.0791 12.738 0.974943 10.1768 0.169753L9.57701 2.07769C11.4986 2.6818 13.0797 4.28319 13.6787 6.24943L15.5919 5.66662ZM14.3089 13.5321C15.9707 11.2814 16.4271 8.40644 15.5918 5.66642L13.6788 6.24962C14.3378 8.41148 13.9693 10.6249 12.6999 12.3442L14.3089 13.5321ZM9.08722 20.3348L14.2976 13.547L12.7112 12.3292L7.50074 19.117L9.08722 20.3348ZM5.9143 20.3349C6.71488 21.3778 8.28668 21.3777 9.08722 20.3348L7.50074 19.117L5.9143 20.3349ZM0.703911 13.5477L5.9143 20.3349L7.50074 19.117L2.29035 12.3298L0.703911 13.5477ZM-1 8.3706C-1 10.2453 -0.414773 12.0337 0.69281 13.5329L2.30145 12.3445C1.45042 11.1925 1 9.82147 1 8.3706H-1ZM2.45458 1.4337C0.287354 3.0566 -1 5.64862 -1 8.3706H1C1 6.27195 1.99582 4.27585 3.65339 3.0346L2.45458 1.4337ZM10.1771 0.169832C7.50796 -0.67005 4.64743 -0.207624 2.45476 1.43357L3.65321 3.03473C5.31371 1.79186 7.50127 1.42452 9.57677 2.07761L10.1771 0.169832ZM9.625 8.63428C9.625 9.80788 8.6736 10.7593 7.5 10.7593V12.7593C9.77818 12.7593 11.625 10.9125 11.625 8.63428H9.625ZM7.5 6.50928C8.6736 6.50928 9.625 7.46067 9.625 8.63428H11.625C11.625 6.3561 9.77818 4.50928 7.5 4.50928V6.50928ZM5.375 8.63428C5.375 7.46067 6.3264 6.50928 7.5 6.50928V4.50928C5.22183 4.50928 3.375 6.3561 3.375 8.63428H5.375ZM7.5 10.7593C6.3264 10.7593 5.375 9.80788 5.375 8.63428H3.375C3.375 10.9125 5.22183 12.7593 7.5 12.7593V10.7593Z",
      fill: "#0FB769",
      mask: "url(#path-1-inside-1_11436_267735)"
    })]
  });
};

/* harmony default export */ var ShopMapIcon = (ShopMapIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/Shirt.js


var Shirt_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#74849C' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '29' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '27' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 29 27' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M29 13.79L26.535 0.595001H16.82L16.675 1.61C16.53 2.77 15.66 3.64 14.645 3.64C13.63 3.64 12.76 2.77 12.615 1.61V0.595001H2.465L0 13.645H5.22L3.77 26.405H25.23L23.78 13.79H29ZM6.235 24.23L7.975 7.7L5.945 7.555L5.365 11.47H2.61L4.205 2.77H10.73C11.31 4.51 12.905 5.815 14.79 5.815C16.675 5.815 18.27 4.51 18.85 2.77H24.94L26.535 11.615H23.78L23.345 7.41L21.17 7.7L23.055 24.23H6.235Z",
      fill: fill
    })
  });
};

/* harmony default export */ var Shirt = (Shirt_SVG);
;// CONCATENATED MODULE: ./assets/icons/SortIcon.js


var SortIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '25' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 25 24' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      stroke: "currentColor",
      strokeWidth: "1.3",
      strokeLinecap: "round",
      d: "M13.272 6.65v4.711M13.306 6l2.058 2.059M13.262 6l-2.059 2.058M16.272 16.36v-4.71M16.306 17.01l2.058-2.058M16.262 17.011l-2.059-2.059"
    })
  });
};

/* harmony default export */ var SortIcon = (SortIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/SpinnerIcon.js


var SpinnerIcon_excluded = ["fill", "width", "height", "viewBox"];

function SpinnerIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SpinnerIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SpinnerIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SpinnerIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var SpinnerIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '70' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '70' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 100 100' : _ref$viewBox,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, SpinnerIcon_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", SpinnerIcon_objectSpread(SpinnerIcon_objectSpread({
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M28.145 18.533A40 40 0 0075.25 83.194a40 44.2 53.927 01-47.105-64.661"
    })
  }));
};

/* harmony default export */ var SpinnerIcon = (SpinnerIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/SuccessIcon.js


var SuccessIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "27",
    height: "27",
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.4987 7.04427C14.2091 7.04427 14.7904 7.62552 14.7904 8.33594V13.5026C14.7904 14.213 14.2091 14.7943 13.4987 14.7943C12.7883 14.7943 12.207 14.213 12.207 13.5026V8.33594C12.207 7.62552 12.7883 7.04427 13.4987 7.04427ZM13.4858 0.585938C6.35578 0.585938 0.582031 6.3726 0.582031 13.5026C0.582031 20.6326 6.35578 26.4193 13.4858 26.4193C20.6287 26.4193 26.4154 20.6326 26.4154 13.5026C26.4154 6.3726 20.6287 0.585938 13.4858 0.585938ZM13.4987 23.8359C7.78953 23.8359 3.16536 19.2118 3.16536 13.5026C3.16536 7.79344 7.78953 3.16927 13.4987 3.16927C19.2079 3.16927 23.832 7.79344 23.832 13.5026C23.832 19.2118 19.2079 23.8359 13.4987 23.8359ZM14.7904 19.9609H12.207V17.3776H14.7904V19.9609Z",
      fill: "#0FB769"
    })
  });
};

/* harmony default export */ var SuccessIcon = (SuccessIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/ThreeRectLoader.js



var ThreeRectLoader_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '30' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 30' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("rect", {
      x: "0",
      y: "13",
      width: "4",
      height: "5",
      fill: "#333",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "5;21;5",
        begin: "0s",
        dur: "0.6s",
        repeatCount: "indefinite"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "13; 5; 13",
        begin: "0s",
        dur: "0.6s",
        repeatCount: "indefinite"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("rect", {
      x: "10",
      y: "13",
      width: "4",
      height: "5",
      fill: "#333",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "5;21;5",
        begin: "0.15s",
        dur: "0.6s",
        repeatCount: "indefinite"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "13; 5; 13",
        begin: "0.15s",
        dur: "0.6s",
        repeatCount: "indefinite"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("rect", {
      x: "20",
      y: "13",
      width: "4",
      height: "5",
      fill: "#333",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "5;21;5",
        begin: "0.3s",
        dur: "0.6s",
        repeatCount: "indefinite"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "13; 5; 13",
        begin: "0.3s",
        dur: "0.6s",
        repeatCount: "indefinite"
      })]
    })]
  });
};

/* harmony default export */ var ThreeRectLoader = (ThreeRectLoader_SVG);
;// CONCATENATED MODULE: ./assets/icons/TickIcon.js


var TickIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 1.40394L3.45155 8L0 4.51608L1.35426 3.11215L3.45155 5.23195L8.64574 0L10 1.40394Z",
      fill: "#0FB769"
    })
  });
};

/* harmony default export */ var TickIcon = (TickIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/QuestionIcon.js


var QuestionIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '4' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '6' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '1 1 4 6' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M2.327 5.522l.002.063H3.195l.001-.064c.006-.307.027-.522.062-.65a1.03 1.03 0 01.16-.342c.073-.1.231-.259.482-.481.375-.332.632-.618.766-.859.134-.24.2-.504.2-.788 0-.492-.19-.912-.568-1.257C3.92.797 3.414.627 2.79.627c-.59 0-1.072.159-1.44.482h0c-.365.324-.581.787-.654 1.383l-.008.064.065.008.79.094.063.007.01-.061c.067-.428.206-.733.411-.924a1.09 1.09 0 01.776-.29c.323 0 .592.107.813.323h0c.223.214.331.46.331.74a.84.84 0 01-.111.424c-.074.13-.24.312-.508.548a5.76 5.76 0 00-.558.541h0a1.845 1.845 0 00-.314.518 2.216 2.216 0 00-.132.805c0 .053.001.13.004.233zm-.047 1.54v.066h1.006V6.122H2.28v.94z"
    })
  });
};

/* harmony default export */ var QuestionIcon = (QuestionIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/QuestionCurrencyIcon.js



var QuestionCurrencyIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '11' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '11' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 11 11' : _ref$viewBox,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "18",
    height: "19",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "9",
      cy: "9.5",
      r: "9",
      fill: "#F0F0F0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.93066 11.5674H8.40625C8.41081 11.1436 8.44727 10.7881 8.51562 10.501C8.58398 10.2093 8.69792 9.94499 8.85742 9.70801C9.02148 9.47103 9.23796 9.22038 9.50684 8.95605C9.71647 8.75553 9.9056 8.56641 10.0742 8.38867C10.2428 8.20638 10.3773 8.01497 10.4775 7.81445C10.5778 7.60938 10.6279 7.37467 10.6279 7.11035C10.6279 6.82324 10.5801 6.57943 10.4844 6.37891C10.3887 6.17839 10.2474 6.02572 10.0605 5.9209C9.87826 5.81608 9.65039 5.76367 9.37695 5.76367C9.14909 5.76367 8.9349 5.80924 8.73438 5.90039C8.53385 5.98698 8.37207 6.1237 8.24902 6.31055C8.12598 6.49284 8.0599 6.73438 8.05078 7.03516H6.40332C6.41243 6.46094 6.54915 5.97786 6.81348 5.58594C7.0778 5.19401 7.43327 4.90007 7.87988 4.7041C8.3265 4.50814 8.82552 4.41016 9.37695 4.41016C9.98763 4.41016 10.5094 4.51497 10.9424 4.72461C11.3753 4.92969 11.7057 5.23047 11.9336 5.62695C12.166 6.01888 12.2822 6.49284 12.2822 7.04883C12.2822 7.44987 12.2025 7.81445 12.043 8.14258C11.8835 8.46615 11.6761 8.76921 11.4209 9.05176C11.1657 9.32975 10.89 9.60775 10.5938 9.88574C10.3385 10.1182 10.1654 10.3711 10.0742 10.6445C9.98307 10.9134 9.93522 11.221 9.93066 11.5674ZM8.26953 13.7002C8.26953 13.4541 8.35384 13.2467 8.52246 13.0781C8.69108 12.9049 8.92122 12.8184 9.21289 12.8184C9.50456 12.8184 9.7347 12.9049 9.90332 13.0781C10.0719 13.2467 10.1562 13.4541 10.1562 13.7002C10.1562 13.9463 10.0719 14.1559 9.90332 14.3291C9.7347 14.4977 9.50456 14.582 9.21289 14.582C8.92122 14.582 8.69108 14.4977 8.52246 14.3291C8.35384 14.1559 8.26953 13.9463 8.26953 13.7002Z",
      fill: "#585858"
    })]
  });
};

/* harmony default export */ var QuestionCurrencyIcon = (QuestionCurrencyIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/UserIcon.js


var UserIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#292C33' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '19' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 19' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M16.467 11.88l-.103.11.103-.11a9.195 9.195 0 0 0-3.194-1.962c1.263-.925 2.08-2.374 2.08-4.004 0-2.8-2.41-5.064-5.353-5.064-2.944 0-5.353 2.264-5.353 5.064 0 1.63.817 3.079 2.08 4.004a9.194 9.194 0 0 0-3.194 1.963l.103.109-.103-.11C1.804 13.514.85 15.688.85 18v.15H2.556V18c0-3.864 3.331-7.022 7.444-7.022 4.113 0 7.444 3.158 7.444 7.022v.15H19.15V18c0-2.313-.954-4.487-2.683-6.12zM10 9.35c-2.019 0-3.647-1.55-3.647-3.436S7.981 2.478 10 2.478s3.647 1.55 3.647 3.436c0 1.887-1.628 3.436-3.647 3.436z",
      fill: fill,
      stroke: fill,
      strokeWidth: "0.3"
    })
  });
};

/* harmony default export */ var UserIcon = (UserIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/VKIcon.js


var VKIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '12' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 12' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.6356 0.780506C18.7656 0.338219 18.6356 0 18.0118 0H15.9325C15.4127 0 15.1528 0.286186 15.0229 0.598388C15.0229 0.598388 13.9572 3.20008 12.4497 4.86515C11.9559 5.35948 11.748 5.51558 11.4881 5.51558C11.3581 5.51558 11.1762 5.35948 11.1762 4.91719V0.780506C11.1762 0.260169 11.0202 0 10.5784 0H7.27751C6.93962 0 6.75768 0.234152 6.75768 0.468304C6.75768 0.962624 7.51143 1.09271 7.5894 2.49762V5.56761C7.5894 6.24405 7.45944 6.37413 7.19953 6.37413C6.49777 6.37413 4.78236 3.77245 3.74272 0.806523C3.53479 0.234152 3.32686 0 2.80704 0H0.727751C0.129955 0 0 0.286186 0 0.598388C0 1.14474 0.701759 3.90253 3.30087 7.51888C5.01628 9.99048 7.45944 11.3434 9.66869 11.3434C10.9942 11.3434 11.1502 11.0572 11.1502 10.5368V8.66362C11.1502 8.06523 11.2801 7.93515 11.696 7.93515C12.0079 7.93515 12.5277 8.09125 13.7753 9.28802C15.1788 10.6929 15.4127 11.3434 16.2184 11.3434H18.2977C18.8955 11.3434 19.1814 11.0572 19.0255 10.4588C18.8435 9.86039 18.1678 9.02785 17.2581 8.0132C16.7643 7.44082 16.0365 6.81642 15.8286 6.50422C15.5167 6.11396 15.5947 5.93185 15.8286 5.56761C15.8286 5.56761 18.3757 1.97728 18.6356 0.780506Z",
      fill: fill
    })
  });
};

/* harmony default export */ var VKIcon = (VKIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/Play.js



var Play_SVG = function SVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.7143 7.38776L4.97959 2.08163C4.89796 2 4.73469 2 4.65306 2C4.57143 2 4.40816 2 4.32653 2.08163C4.16327 2.16327 4 2.40816 4 2.65306V13.3469C4 13.5918 4.16327 13.8367 4.32653 13.9184C4.40816 14 4.57143 14 4.65306 14C4.73469 14 4.89796 14 4.97959 13.9184L13.7143 8.53061C13.8776 8.44898 14.0408 8.20408 14.0408 7.95918C14.0408 7.71429 13.8776 7.55102 13.7143 7.38776ZM5.30612 12.1224V3.79592L12.1633 7.95918L5.30612 12.1224Z",
      fill: "#292C33"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.3878 8.12245L4.81633 2.81633V13.0204L13.3878 8.12245Z",
      fill: "#292C33"
    })]
  });
};

/* harmony default export */ var Play = (Play_SVG);
;// CONCATENATED MODULE: ./assets/icons/PresentIcon.js


var PresentIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'none' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '18' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '18' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 18 18' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.2458 4.30329H9.07977C9.09359 4.26307 9.10035 4.22171 9.10036 4.18667L9.10033 4.18551C9.09223 3.8371 9.20197 3.41548 9.36712 3.02739C9.53227 2.63927 9.74995 2.29144 9.95214 2.08925C10.4491 1.59224 11.2673 1.59224 11.7643 2.08925C12.2613 2.58625 12.2613 3.40437 11.7643 3.90138C11.6355 4.03016 11.4736 4.14391 11.3245 4.24339C11.2912 4.26048 11.2707 4.27873 11.2458 4.30329ZM8.25056 4.13546L8.25054 4.13546V4.13668C8.25054 4.18013 8.25686 4.21807 8.26934 4.25331H6.10312C6.1027 4.25319 6.1021 4.25301 6.1013 4.25275C6.09801 4.25165 6.09299 4.24959 6.08598 4.24609C6.07195 4.23907 6.05305 4.22783 6.02887 4.21172L6.02909 4.21139L6.0235 4.2086C5.86264 4.12817 5.71788 4.01552 5.60555 3.88715L5.60563 3.88708L5.60327 3.88472C5.10627 3.38771 5.10627 2.56959 5.60327 2.07259C5.84356 1.8323 6.16397 1.704 6.50101 1.704C6.83805 1.704 7.15846 1.8323 7.39874 2.07259C7.60096 2.2748 7.81866 2.62268 7.98385 3.00674C8.14907 3.39089 8.25864 3.80403 8.25056 4.13546ZM16.0206 7.63576H16.0206H16.0205H16.0204H16.0203H16.0202H16.0201H16.02H16.0199H16.0198H16.0197H16.0196H16.0195H16.0194H16.0193H16.0192H16.0191H16.019H16.0189H16.0188H16.0187H16.0186H16.0186H16.0185H16.0184H16.0183H16.0182H16.0181H16.018H16.0179H16.0178H16.0177H16.0176H16.0175H16.0174H16.0173H16.0172H16.0171H16.017H16.0169H16.0168H16.0167H16.0166H16.0165H16.0164H16.0163H16.0162H16.0161H16.016H16.0159H16.0158H16.0157H16.0156H16.0155H16.0154H16.0153H16.0152H16.0151H16.015H16.0149H16.0148H16.0147H16.0146H16.0145H16.0145H16.0144H16.0143H16.0142H16.0141H16.014H16.0139H16.0138H16.0137H16.0136H16.0135H16.0134H16.0133H16.0132H16.0131H16.013H16.0129H16.0128H16.0127H16.0126H16.0125H16.0124H16.0123H16.0122H16.0121H16.012H16.0119H16.0118H16.0117H16.0116H16.0115H16.0114H16.0113H16.0112H16.0111H16.011H16.0109H16.0108H16.0107H16.0106H16.0105H16.0104H16.0103H16.0103H16.0102H16.0101H16.01H16.0099H16.0098H16.0097H16.0096H16.0095H16.0094H16.0093H16.0092H16.0091H16.009H16.0089H16.0088H16.0087H16.0086H16.0085H16.0084H16.0083H16.0082H16.0081H16.008H16.0079H16.0078H16.0077H16.0076H16.0075H16.0074H16.0073H16.0072H16.0071H16.007H16.0069H16.0068H16.0067H16.0066H16.0065H16.0064H16.0063H16.0062H16.0062H16.0061H16.006H16.0059H16.0058H16.0057H16.0056H16.0055H16.0054H16.0053H16.0052H16.0051H16.005H16.0049H16.0048H16.0047H16.0046H16.0045H16.0044H16.0043H16.0042H16.0041H16.004H16.0039H16.0038H16.0037H16.0036H16.0035H16.0034H16.0033H16.0032H16.0031H16.003H16.0029H16.0028H16.0027H16.0026H16.0025H16.0024H16.0023H16.0022H16.0021H16.0021H16.002H16.0019H16.0018H16.0017H16.0016H16.0015H16.0014H16.0013H16.0012H16.0011H16.001H16.0009H16.0008H16.0007H16.0006H16.0005H16.0004H16.0003H16.0002H16.0001H16H15.9999H15.9998H15.9997H15.9996H15.9995H15.9994H15.9993H15.9992H15.9991H15.999H15.9989H15.9988H15.9987H15.9986H15.9985C15.7876 7.63576 15.6153 7.80811 15.6153 8.01901V15.3504C15.6153 15.8727 15.1878 16.3002 14.6656 16.3002H9.05036V8.38559H12.3328C12.5437 8.38559 12.7161 8.21324 12.7161 8.00234C12.7161 7.79144 12.5437 7.6191 12.3328 7.6191H9.05036V6.16949C9.05036 5.95859 8.87801 5.78624 8.66711 5.78624C8.45621 5.78624 8.28387 5.95859 8.28387 6.16949V7.6191H2.00218C1.84651 7.6191 1.71893 7.49152 1.71893 7.33585V6.00286C1.71893 5.48062 2.14643 5.05312 2.66867 5.05312H15.332C15.8543 5.05312 16.2818 5.48062 16.2818 6.00286V7.33585C16.2818 7.48952 16.1717 7.58951 16.0565 7.61972C16.0558 7.61981 16.0551 7.61992 16.0544 7.62004C16.0495 7.62084 16.0423 7.62255 16.0345 7.62646C16.0301 7.62864 16.0253 7.63166 16.0206 7.63576ZM15.332 4.28663H12.4423C13.1019 3.48326 13.0605 2.29466 12.3014 1.55182C11.499 0.749622 10.201 0.749057 9.41472 1.55216C9.14744 1.81949 8.88198 2.21566 8.68377 2.67362C8.48563 2.2158 8.22026 1.81972 7.95307 1.5524C7.57616 1.15859 7.04627 0.954166 6.50101 0.954166C5.9549 0.954166 5.44221 1.15914 5.04936 1.55199C4.65651 1.94484 4.45153 2.45753 4.45153 3.00365C4.45153 3.4788 4.61317 3.92476 4.90895 4.28663H2.66867C1.72463 4.28663 0.952441 5.05882 0.952441 6.00286V7.33585C0.952441 7.77958 1.23465 8.15499 1.61893 8.31916V8.31919V8.31929V8.31938V8.31948V8.31958V8.31968V8.31977V8.31987V8.31997V8.32007V8.32016V8.32026V8.32036V8.32046V8.32056V8.32065V8.32075V8.32085V8.32095V8.32104V8.32114V8.32124V8.32134V8.32143V8.32153V8.32163V8.32173V8.32182V8.32192V8.32202V8.32212V8.32222V8.32231V8.32241V8.32251V8.32261V8.3227V8.3228V8.3229V8.323V8.32309V8.32319V8.32329V8.32339V8.32348V8.32358V8.32368V8.32378V8.32387V8.32397V8.32407V8.32417V8.32427V8.32436V8.32446V8.32456V8.32466V8.32475V8.32485V8.32495V8.32505V8.32514V8.32524V8.32534V8.32544V8.32553V8.32563V8.32573V8.32583V8.32592V8.32602V8.32612V8.32622V8.32632V8.32641V8.32651V8.32661V8.32671V8.3268V8.3269V8.327V8.3271V8.32719V8.32729V8.32739V8.32749V8.32758V8.32768V8.32778V8.32788V8.32798V8.32807V8.32817V8.32827V8.32837V8.32846V8.32856V8.32866V8.32876V8.32885V8.32895V8.32905V8.32915V8.32924V8.32934V8.32944V8.32954V8.32964V8.32973V8.32983V8.32993V8.33003V8.33012V8.33022V8.33032V8.33042V8.33051V8.33061V8.33071V8.33081V8.3309V8.331V8.3311V8.3312V8.33129V8.33139V8.33149V8.33159V8.33169V8.33178V8.33188V8.33198V8.33208V8.33217V8.33227V8.33237V8.33247V8.33256V8.33266V8.33276V8.33286V8.33295V8.33305V8.33315V8.33325V8.33334V8.33344V8.33354V8.33364V8.33374V8.33383V8.33393V8.33403V8.33413V8.33422V8.33432V8.33442V8.33452V8.33461V8.33471V8.33481V8.33491V8.335V8.3351V8.3352V8.3353V8.3354V8.33549V8.33559V15.3338C1.61893 15.8265 1.86965 16.2561 2.22804 16.5611C2.58612 16.8659 3.05559 17.05 3.50179 17.05H14.6656C15.6096 17.05 16.3818 16.2778 16.3818 15.3338V8.31968C16.7824 8.15535 17.0483 7.77891 17.0483 7.33585V6.00286C17.0483 5.05882 16.2761 4.28663 15.332 4.28663ZM8.28387 16.2835H3.50179C3.24813 16.2835 2.96735 16.176 2.75003 16.0009C2.53261 15.8258 2.38543 15.5888 2.38543 15.3338V8.38559H8.28387V16.2835Z",
      fill: "#292C33",
      stroke: "#292C33",
      strokeWidth: "0.1"
    })
  });
};

/* harmony default export */ var PresentIcon = (PresentIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/PinterestIcon.js


var PinterestIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '23' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 40 40' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M20.241 0C9.20314 0 0.253906 8.94924 0.253906 19.9871C0.253906 28.455 5.52218 35.687 12.9574 38.5985C12.7825 37.0178 12.6243 34.5911 13.0273 32.8655C13.3904 31.3065 15.3708 22.9302 15.3708 22.9302C15.3708 22.9302 14.7729 21.7327 14.7729 19.9638C14.7729 17.1839 16.3835 15.1103 18.3889 15.1103C20.0945 15.1103 20.9173 16.3911 20.9173 17.9251C20.9173 19.6407 19.8263 22.204 19.2617 24.5792C18.7903 26.5696 20.2594 28.1918 22.2214 28.1918C25.7741 28.1918 28.504 24.4459 28.504 19.0394C28.504 14.2542 25.0663 10.908 20.1561 10.908C14.4697 10.908 11.1319 15.1736 11.1319 19.5824C11.1319 21.2996 11.7931 23.1418 12.6193 24.1444C12.7825 24.3427 12.8058 24.5159 12.7575 24.7174C12.6059 25.3487 12.2695 26.7061 12.2029 26.9843C12.1163 27.3507 11.9131 27.4273 11.535 27.2508C9.03825 26.0882 7.47759 22.4389 7.47759 19.5074C7.47759 13.2032 12.058 7.41189 20.6841 7.41189C27.6179 7.41189 33.0061 12.352 33.0061 18.9561C33.0061 25.845 28.6623 31.3881 22.6345 31.3881C20.6091 31.3881 18.7054 30.3355 18.0541 29.0929C18.0541 29.0929 17.0514 32.9088 16.8082 33.8449C16.3569 35.5804 15.1393 37.7573 14.3232 39.0848C16.1936 39.6611 18.1807 39.9742 20.241 39.9742C31.2789 39.9742 40.2282 31.025 40.2282 19.9871C40.2282 8.94924 31.2789 0 20.241 0Z",
      fill: "black"
    })
  });
};

/* harmony default export */ var PinterestIcon = (PinterestIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/LogoLanding.js



var LogoLanding_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '163' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '14' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 163 14' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill || '#292C33',
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.14063 0.301291V2.55093H2.62226V5.54376H6.85823V7.7934H2.62226V13.6987H0V0.301291H7.14063Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.0654 13.6987L16.8753 10.8867H11.4492L10.2591 13.6987H7.41499L13.2041 0.301291H15.2616L20.8894 13.6987H18.0654ZM12.2763 8.75753H16.1088L14.1925 3.93687L12.2763 8.75753Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M31.0233 1.56671L29.6516 3.35438C29.0734 2.5911 28.3405 2.20947 27.4529 2.20947C26.8075 2.20947 26.3368 2.37016 26.041 2.69154C25.7451 2.99952 25.5972 3.36107 25.5972 3.77618C25.5972 4.13773 25.7384 4.43902 26.0208 4.68006C26.2359 4.88092 26.7738 5.13534 27.6345 5.44333C28.9658 5.89861 29.8735 6.3472 30.3576 6.7891C31.1241 7.47202 31.5074 8.40937 31.5074 9.60115C31.5074 10.9134 31.0703 11.978 30.1962 12.7948C29.3356 13.5983 28.2127 14 26.8276 14C24.8912 14 23.3447 13.1564 22.1882 11.4692L23.9028 9.84218C24.1986 10.4448 24.6088 10.8934 25.1332 11.1879C25.6577 11.4825 26.1889 11.6298 26.7268 11.6298C27.3319 11.6298 27.8295 11.4625 28.2194 11.1277C28.6094 10.7795 28.8044 10.3309 28.8044 9.78192C28.8044 9.31325 28.6296 8.91153 28.28 8.57676C27.9572 8.28216 27.2647 7.95409 26.2023 7.59254C25.2072 7.25777 24.4609 6.86944 23.9633 6.42755C23.2506 5.81157 22.8942 4.98135 22.8942 3.93687C22.8942 2.85222 23.264 1.92826 24.0037 1.16499C24.7433 0.388331 25.8123 0 27.2109 0C28.7305 0 30.0012 0.522238 31.0233 1.56671Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M37.4413 0.301291V5.4835H43.1296V0.301291H45.7519V13.6987H43.1296V7.73314H37.4413V13.6987H34.8191V0.301291H37.4413Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M49.8333 0.301291H52.4555V13.6987H49.8333V0.301291Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M57.8862 1.96844C59.2309 0.656145 60.9589 0 63.0702 0C65.1815 0 66.9027 0.656145 68.234 1.96844C69.5788 3.28073 70.2512 4.96126 70.2512 7.01004C70.2512 9.05882 69.5788 10.7394 68.234 12.0517C66.9027 13.3506 65.1815 14 63.0702 14C60.9589 14 59.2309 13.3506 57.8862 12.0517C56.5549 10.7394 55.8892 9.05882 55.8892 7.01004C55.8892 4.96126 56.5549 3.28073 57.8862 1.96844ZM59.8428 10.3443C60.6765 11.2013 61.7523 11.6298 63.0702 11.6298C64.3881 11.6298 65.4639 11.2013 66.2976 10.3443C67.1313 9.47394 67.5482 8.36251 67.5482 7.01004C67.5482 5.65758 67.1246 4.54615 66.2774 3.67575C65.4437 2.80536 64.3746 2.37016 63.0702 2.37016C61.7658 2.37016 60.69 2.80536 59.8428 3.67575C59.009 4.54615 58.5922 5.65758 58.5922 7.01004C58.5922 8.36251 59.009 9.47394 59.8428 10.3443Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M76.2986 13.6987H73.6763V0.301291H75.4918L83.6813 9.2396V0.301291H86.3036V13.6987H84.4881L76.2986 4.74032V13.6987Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M98.7234 0.301291V5.4835H104.412V0.301291H107.034V13.6987H104.412V7.73314H98.7234V13.6987H96.1011V0.301291H98.7234Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M112.467 1.96844C113.812 0.656145 115.54 0 117.651 0C119.762 0 121.483 0.656145 122.815 1.96844C124.159 3.28073 124.832 4.96126 124.832 7.01004C124.832 9.05882 124.159 10.7394 122.815 12.0517C121.483 13.3506 119.762 14 117.651 14C115.54 14 113.812 13.3506 112.467 12.0517C111.135 10.7394 110.47 9.05882 110.47 7.01004C110.47 4.96126 111.135 3.28073 112.467 1.96844ZM114.423 10.3443C115.257 11.2013 116.333 11.6298 117.651 11.6298C118.969 11.6298 120.044 11.2013 120.878 10.3443C121.712 9.47394 122.129 8.36251 122.129 7.01004C122.129 5.65758 121.705 4.54615 120.858 3.67575C120.024 2.80536 118.955 2.37016 117.651 2.37016C116.346 2.37016 115.271 2.80536 114.423 3.67575C113.59 4.54615 113.173 5.65758 113.173 7.01004C113.173 8.36251 113.59 9.47394 114.423 10.3443Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M128.257 0.301291H130.879V8.71736C130.879 9.56098 131.094 10.2238 131.525 10.7059C132.036 11.3219 132.748 11.6298 133.663 11.6298C134.577 11.6298 135.29 11.3219 135.801 10.7059C136.231 10.2238 136.447 9.56098 136.447 8.71736V0.301291H139.069V8.49641C139.069 10.023 138.733 11.2147 138.06 12.0717C137.59 12.6877 136.958 13.1631 136.164 13.4978C135.384 13.8326 134.55 14 133.663 14C132.775 14 131.935 13.8326 131.141 13.4978C130.362 13.1631 129.736 12.6877 129.266 12.0717C128.593 11.2147 128.257 10.023 128.257 8.49641V0.301291Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M151.141 1.56671L149.769 3.35438C149.191 2.5911 148.458 2.20947 147.57 2.20947C146.925 2.20947 146.454 2.37016 146.159 2.69154C145.863 2.99952 145.715 3.36107 145.715 3.77618C145.715 4.13773 145.856 4.43902 146.138 4.68006C146.353 4.88092 146.891 5.13534 147.752 5.44333C149.083 5.89861 149.991 6.3472 150.475 6.7891C151.242 7.47202 151.625 8.40937 151.625 9.60115C151.625 10.9134 151.188 11.978 150.314 12.7948C149.453 13.5983 148.33 14 146.945 14C145.009 14 143.462 13.1564 142.306 11.4692L144.02 9.84218C144.316 10.4448 144.726 10.8934 145.251 11.1879C145.775 11.4825 146.306 11.6298 146.844 11.6298C147.449 11.6298 147.947 11.4625 148.337 11.1277C148.727 10.7795 148.922 10.3309 148.922 9.78192C148.922 9.31325 148.747 8.91153 148.398 8.57676C148.075 8.28216 147.382 7.95409 146.32 7.59254C145.325 7.25777 144.578 6.86944 144.081 6.42755C143.368 5.81157 143.012 4.98135 143.012 3.93687C143.012 2.85222 143.382 1.92826 144.121 1.16499C144.861 0.388331 145.93 0 147.328 0C148.848 0 150.119 0.522238 151.141 1.56671Z",
      fill: fill
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M162.4 0.301291V2.55093H157.559V5.54376H162.198V7.7934H157.559V11.4491H162.4V13.6987H154.937V0.301291H162.4Z",
      fill: fill
    })]
  });
};

/* harmony default export */ var LogoLanding = (LogoLanding_SVG);
;// CONCATENATED MODULE: ./assets/icons/Promocode.js


var Promocode_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12 1C5.95496 1 1 5.95496 1 12C1 18.045 5.95496 23 12 23C18.045 23 23 18.045 23 12C23 5.95496 18.045 1 12 1ZM12 21.8108C6.64865 21.8108 2.18919 17.4504 2.18919 12C2.18919 6.54955 6.54955 2.18919 12 2.18919C17.4504 2.18919 21.8108 6.64865 21.8108 12C21.8108 17.3514 17.3514 21.8108 12 21.8108ZM7.73874 8.53153C7.73874 7.93694 8.23423 7.44144 8.92793 7.44144C9.62162 7.44144 10.018 7.93694 10.018 8.53153C10.018 9.12613 9.52252 9.72072 8.92793 9.72072C8.33333 9.72072 7.73874 9.12613 7.73874 8.53153ZM16.5586 15.4685C16.5586 16.0631 16.0631 16.5586 15.4685 16.5586C14.8739 16.5586 14.3784 16.0631 14.3784 15.4685C14.3784 14.8739 14.8739 14.3784 15.4685 14.3784C16.0631 14.3784 16.5586 14.8739 16.5586 15.4685ZM16.955 6.84685C17.0541 6.94595 17.1532 7.14414 17.1532 7.24324C17.1532 7.44144 17.0541 7.54054 16.955 7.63964L7.93694 16.7568C7.83784 16.8559 7.63964 16.955 7.54054 16.955C7.34234 16.955 7.24324 16.8559 7.14414 16.7568C7.04504 16.6577 6.94595 16.4595 6.94595 16.3604C6.94595 16.2613 7.04504 16.0631 7.14414 15.964L16.1622 6.94595C16.2613 6.84685 16.4595 6.74775 16.5586 6.74775C16.6577 6.74775 16.8559 6.74775 16.955 6.84685Z",
      fill: "#959595"
    })
  });
};

/* harmony default export */ var Promocode = (Promocode_SVG);
;// CONCATENATED MODULE: ./assets/icons/ViberIcon.js


var ViberIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '23' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 40 40' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.362 0.00175095C31.4159 0.00175095 40.3769 8.96272 40.3769 20.0166C40.3769 31.0705 31.4159 40.0315 20.362 40.0315C9.30813 40.0315 0.347168 31.0705 0.347168 20.0166C0.347168 8.96272 9.30813 0.00175095 20.362 0.00175095ZM21.5608 8.15459C22.9217 8.32445 24.0215 8.65227 25.2281 9.24084C26.4149 9.82154 27.1745 10.3706 28.1794 11.37C29.121 12.3141 29.6432 13.0291 30.197 14.1391C30.9685 15.6876 31.4077 17.5283 31.4828 19.5548C31.5105 20.246 31.4907 20.4001 31.3324 20.5976C31.0318 20.9808 30.3711 20.9175 30.1456 20.487C30.0744 20.3448 30.0546 20.2224 30.0309 19.6693C29.9913 18.82 29.932 18.271 29.8133 17.6152C29.3465 15.0437 28.1121 12.9896 26.142 11.5161C24.5002 10.2837 22.803 9.68325 20.5797 9.55292C19.828 9.50947 19.6974 9.48186 19.5273 9.35149C19.2107 9.10262 19.195 8.51802 19.4996 8.24546C19.6855 8.07557 19.8161 8.05187 20.4609 8.07162C20.7972 8.08346 21.2917 8.12299 21.5608 8.15459ZM12.517 8.58122C12.6555 8.6286 12.8691 8.73919 12.9918 8.81821C13.7434 9.31595 15.8362 11.9902 16.5206 13.3253C16.9123 14.0877 17.0428 14.6526 16.9202 15.0713C16.7936 15.5216 16.584 15.7586 15.6463 16.5131C15.2705 16.8173 14.9183 17.1294 14.863 17.2123C14.7206 17.4177 14.6058 17.8206 14.6058 18.105C14.6098 18.7647 15.0371 19.9616 15.5989 20.882C16.034 21.597 16.8133 22.5134 17.5848 23.2166C18.4908 24.0462 19.2899 24.6109 20.1919 25.0574C21.351 25.6341 22.0592 25.7802 22.5775 25.5393C22.7081 25.48 22.8465 25.401 22.8901 25.3655C22.9296 25.3299 23.2342 24.9586 23.5666 24.5478C24.2074 23.7419 24.3538 23.6116 24.793 23.4615C25.3508 23.2719 25.9205 23.3232 26.4941 23.6155C26.9293 23.8407 27.8788 24.4293 28.492 24.8559C29.299 25.4208 31.0239 26.8271 31.2574 27.1076C31.6688 27.6132 31.74 28.2609 31.463 28.976C31.1702 29.7304 30.0309 31.1446 29.2357 31.749C28.5157 32.2941 28.0053 32.5034 27.3328 32.535C26.7789 32.5627 26.5495 32.5153 25.8413 32.223C20.2869 29.9358 15.852 26.5229 12.331 21.834C10.4915 19.3849 9.09095 16.845 8.13353 14.2102C7.57575 12.6736 7.54809 12.006 8.00695 11.2199C8.2048 10.8881 9.04744 10.0665 9.66063 9.60826C10.6814 8.84981 11.1521 8.56933 11.528 8.49035C11.7851 8.43503 12.2321 8.4785 12.517 8.58122ZM21.8337 11.0184C24.2351 11.37 26.0945 12.484 27.313 14.2931C27.9974 15.3123 28.4247 16.5092 28.5711 17.793C28.6225 18.263 28.6225 19.1202 28.5671 19.2625C28.5157 19.3967 28.3495 19.5785 28.2071 19.6535C28.0528 19.7325 27.7245 19.7246 27.5425 19.6298C27.2378 19.4758 27.1469 19.2308 27.1469 18.5672C27.1469 17.5442 26.8818 16.4657 26.4229 15.6283C25.9007 14.6723 25.1411 13.8823 24.2154 13.3332C23.4202 12.8592 22.2452 12.5077 21.1731 12.4208C20.7854 12.3892 20.5717 12.3101 20.4253 12.1403C20.1999 11.8835 20.1761 11.5359 20.366 11.2476C20.5717 10.9276 20.8882 10.8762 21.8337 11.0184ZM22.6764 14.0008C23.4557 14.1667 24.0532 14.463 24.5635 14.941C25.2202 15.5611 25.5802 16.3117 25.7384 17.3901C25.8453 18.0932 25.8018 18.3697 25.5525 18.5988C25.3191 18.8121 24.8879 18.82 24.6268 18.6185C24.4369 18.4763 24.3775 18.3262 24.334 17.9194C24.2826 17.3782 24.1877 16.999 24.0255 16.6474C23.6773 15.9008 23.0641 15.5137 22.0276 15.3873C21.5409 15.3281 21.3946 15.2728 21.2364 15.0871C20.9476 14.7435 21.0583 14.1865 21.4579 13.9811C21.6083 13.906 21.6716 13.8981 22.0038 13.9179C22.2096 13.9297 22.5142 13.9652 22.6764 14.0008Z",
      fill: "#171717"
    })
  });
};

/* harmony default export */ var ViberIcon = (ViberIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/TelegramIcon.js


var TelegramIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '23' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 40 40' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M20.5242 0C9.51597 0 0.509277 9.00669 0.509277 20.0149C0.509277 31.0231 9.51597 40.0297 20.5242 40.0297C31.5323 40.0297 40.539 31.0231 40.539 20.0149C40.539 9.00669 31.5323 0 20.5242 0ZM26.9289 30.4226C26.7288 31.2232 25.728 31.4234 25.1276 31.2232H24.9274L19.5234 27.0201L15.9207 30.0223C15.7206 30.2225 15.5204 30.2225 15.3203 30.0223L15.9207 24.0178V23.8177C15.9207 23.8177 25.728 15.0112 26.1283 14.6109C26.7288 14.4107 26.5286 14.2106 26.5286 14.2106C26.5286 13.8103 25.728 14.2106 25.728 14.2106L12.7183 22.6168L7.31433 20.8155C7.31433 20.8155 6.51374 20.6153 6.31359 19.8147C6.31359 19.2143 7.31433 18.814 7.31433 18.814L28.7302 10.2076C28.7302 10.2076 30.5316 9.40699 30.5316 10.808L26.9289 30.4226Z",
      fill: "#171717"
    })
  });
};

/* harmony default export */ var TelegramIcon = (TelegramIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/WAIcon.js


var WAIcon_SVG = function SVG(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '23' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 40 40' : _ref$viewBox;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M20.0154 0C8.97795 0 0.000495867 8.97746 0.000495867 20.0149C0.000495867 23.4617 0.891104 26.8508 2.58054 29.8387L0.031089 38.925C-0.0504933 39.2241 0.031089 39.5436 0.245243 39.7646C0.411807 39.938 0.639558 40.0297 0.870708 40.0297C0.938693 40.0297 1.01008 40.0195 1.07806 40.0059L10.562 37.6571C13.4582 39.2105 16.7181 40.0297 20.0154 40.0297C31.0528 40.0297 40.0302 31.0523 40.0302 20.0149C40.0302 8.97746 31.0528 0 20.0154 0ZM30.084 27.0785C29.6557 28.2615 27.6025 29.3459 26.6167 29.4886C25.7295 29.6178 24.6078 29.6756 23.3772 29.2881C22.6328 29.0535 21.6742 28.7408 20.4471 28.2207C15.2938 26.0214 11.9285 20.8953 11.6702 20.5588C11.4152 20.2188 9.57283 17.8087 9.57283 15.3103C9.57283 12.8152 10.8985 11.5847 11.371 11.0782C11.8435 10.5683 12.3976 10.4425 12.7409 10.4425C13.0843 10.4425 13.4276 10.4459 13.7267 10.4595C14.0429 10.4765 14.4678 10.3406 14.8825 11.3331C15.3108 12.3495 16.3408 14.8446 16.4665 15.0995C16.5957 15.3545 16.6807 15.6502 16.5107 15.9901C16.3408 16.3267 16.2558 16.5408 15.9974 16.8366C15.7391 17.1323 15.457 17.496 15.2258 17.7238C14.9675 17.9787 14.7023 18.2541 15.0015 18.7605C15.3006 19.2704 16.3306 20.9293 17.8602 22.2754C19.8216 24.0056 21.4771 24.5393 21.9903 24.7942C22.5036 25.0492 22.8028 25.005 23.1053 24.6685C23.4044 24.3285 24.3868 23.1864 24.7301 22.6765C25.0735 22.17 25.4134 22.255 25.8859 22.4249C26.3584 22.5915 28.884 23.8186 29.3973 24.0736C29.9106 24.3285 30.254 24.4543 30.3831 24.6651C30.5123 24.8758 30.5123 25.8922 30.084 27.0785Z",
      fill: "#171717"
    })
  });
};

/* harmony default export */ var WAIcon = (WAIcon_SVG);
;// CONCATENATED MODULE: ./assets/icons/index.js


function icons_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function icons_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? icons_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : icons_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















































































var Icon = function Icon(props) {
  switch (props.name) {
    case 'arrow-up':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowUpIcon, icons_objectSpread({}, props));

    case 'arrow-down':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowDownIcon, icons_objectSpread({}, props));

    case 'arrow-left':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowLeftIcon, icons_objectSpread({}, props));

    case 'arrow-right':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRightIcon, icons_objectSpread({}, props));

    case 'arrow-right-gallery':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRightGalleryIcon, icons_objectSpread({}, props));

    case 'arrow-left-gallery':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowLeftGalleryIcon, icons_objectSpread({}, props));

    case 'blank':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BlankIcon, icons_objectSpread({}, props));

    case 'basket':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Basket, icons_objectSpread({}, props));

    case 'car':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CarIcon, icons_objectSpread({}, props));

    case 'car-new':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CarIconNew, icons_objectSpread({}, props));

    case 'card':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CardIcon, icons_objectSpread({}, props));

    case 'cash':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CashIcon, icons_objectSpread({}, props));

    case 'cart':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CartIcon, icons_objectSpread({}, props));

    case 'certificate':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CertificateIcon, icons_objectSpread({}, props));

    case 'checked':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckedIcon, icons_objectSpread({}, props));

    case 'circle-success':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleSuccessIcon, icons_objectSpread({}, props));

    case 'circle-error':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleErrorIcon, icons_objectSpread({}, props));

    case 'circle-question':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleQuestionIcon, icons_objectSpread({}, props));

    case 'circle-wait':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleWaitIcon, icons_objectSpread({}, props));

    case 'circle-warn':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleWarnIcon, icons_objectSpread({}, props));

    case 'close':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Close, icons_objectSpread({}, props));

    case 'close-gallery':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CloseGalleryIcon, icons_objectSpread({}, props));

    case 'delivery':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryIcon, icons_objectSpread({}, props));

    case 'danger':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DangerIcon, icons_objectSpread({}, props));

    case 'delivery-fast':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryFastIcon, icons_objectSpread({}, props));

    case 'edit':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(EditIcon, icons_objectSpread({}, props));

    case 'exchange':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Exchange, icons_objectSpread({}, props));

    case 'envelope':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(EnvelopeIcon, icons_objectSpread({}, props));

    case 'favorite':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FavoriteIcon, icons_objectSpread({}, props));

    case 'fb':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FacebookIcon, icons_objectSpread({}, props));

    case 'pinterest':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PinterestIcon, icons_objectSpread({}, props));

    case 'filter':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterIcon, icons_objectSpread({}, props));

    case 'google-play':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(GooglePlay, icons_objectSpread({}, props));

    case 'gps':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(GPSIcon, icons_objectSpread({}, props));

    case 'input-success':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(InputSuccessIcon, icons_objectSpread({}, props));

    case 'giftcard':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Giftcard, icons_objectSpread({}, props));

    case 'insta':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(InstaIcon, icons_objectSpread({}, props));

    case 'ios':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(IOS, icons_objectSpread({}, props));

    case 'heart':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(HeartIcon, icons_objectSpread({}, props));

    case 'lamp':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Lamp, icons_objectSpread({}, props));

    case 'login':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(LoginIcon, icons_objectSpread({}, props));

    case 'mail':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MailIcon, icons_objectSpread({}, props));

    case 'minus':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MinusIcon, icons_objectSpread({}, props));

    case 'map':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MapIcon, icons_objectSpread({}, props));

    case 'map-pin':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MapPinIcon, icons_objectSpread({}, props));

    case 'm-arrow-up':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MArrowUpIcon, icons_objectSpread({}, props));

    case 'map-point':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MapPointIcon, icons_objectSpread({}, props));

    case 'm-arrow-left':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MArrowLeftIcon, icons_objectSpread({}, props));

    case 'm-arrow-right':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MArrowRightIcon, icons_objectSpread({}, props));

    case 'plus':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PlusIcon, icons_objectSpread({}, props));

    case 'pin':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PinIcon, icons_objectSpread({}, props));

    case 'phone':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneIcon, icons_objectSpread({}, props));

    case 'plus':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PlusIcon, icons_objectSpread({}, props));

    case 'plus-image':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PlusImageIcon, icons_objectSpread({}, props));

    case 'phone-fill':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneIconFill, icons_objectSpread({}, props));

    case 'phone-fill-contacts':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneIconFillContacts, icons_objectSpread({}, props));

    case 'products':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductsIcon, icons_objectSpread({}, props));

    case 'remove':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(RemoveIcon, icons_objectSpread({}, props));

    case 'remove-image':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(RemoveImageIcon, icons_objectSpread({}, props));

    case 'remove-product':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(RemoveProductIcon, icons_objectSpread({}, props));

    case 'search':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchIcon, icons_objectSpread({}, props));

    case 'shop-map':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ShopMapIcon, icons_objectSpread({}, props));

    case 'sort':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SortIcon, icons_objectSpread({}, props));

    case 'shirt':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Shirt, icons_objectSpread({}, props));

    case 'spinner':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerIcon, icons_objectSpread({}, props));

    case 'success':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessIcon, icons_objectSpread({}, props));

    case 'telegram':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TelegramIcon, icons_objectSpread({}, props));

    case 'three-rect-loader':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ThreeRectLoader, icons_objectSpread({}, props));

    case 'tick':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TickIcon, icons_objectSpread({}, props));

    case 'question':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionIcon, icons_objectSpread({}, props));

    case 'question-currency':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionCurrencyIcon, icons_objectSpread({}, props));

    case 'user':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(UserIcon, icons_objectSpread({}, props));

    case 'vk':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(VKIcon, icons_objectSpread({}, props));

    case 'play':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Play, icons_objectSpread({}, props));

    case 'present':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PresentIcon, icons_objectSpread({}, props));

    case 'LogoLanding':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(LogoLanding, icons_objectSpread({}, props));

    case 'promocode':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Promocode, icons_objectSpread({}, props));

    case 'viber':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ViberIcon, icons_objectSpread({}, props));

    case 'wa':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(WAIcon, icons_objectSpread({}, props));

    default:
      return null;
  }
};

/* harmony default export */ var icons = (Icon);

/***/ }),

/***/ 78309:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var theme = {
  text: {
    main: '#585858',
    //$black-2
    accent: '#171717',
    reverse: '#FFFFFF',
    secondary: '#959595',
    //$black-3
    extra: '#BBBBBB',
    //$black-4
    light: '#F0F0F0',
    disabled: '#F0F0F0',
    saleRed: '#FE0000',
    header: '#171717',
    link: '#59896D'
  },
  bg: {
    default: '#FFFFFF',
    accent: '#171717',
    secondary: '#3B404A',
    extra: '#BBBBBB',
    //$black-4
    light: '#F0F0F0',
    //$gray-1
    divider: '#F0F0F0',
    //$gray-1
    insistent: '#F8F8F8',
    dividerDark: '#F0F0F0',
    active: '#74849C',
    sale: '#FDE5E5',
    header: '#F8F8F8',
    newYearHeader: '#585858',
    disabled: '#CCCDD0'
  },
  input: {
    border: '#CCCDD0',
    selected: '#74849C',
    checked: '#59896D',
    hover: '#BBBBBB',
    // $black-4
    error: '#EA5656'
  },
  brand: {
    default: '#0FB769',
    //$green-1
    light: '#43A084',
    extraLight: '#1FBA8B',
    dark: '#59896D'
  },
  warn: {
    default: '#EA5656'
  },
  notification: {
    error: '#ef5a5a',
    warning: '#0FB769'
  },
  social: {
    vk: '#45668e',
    fb: '#3b5998'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (theme);

/***/ }),

/***/ 54935:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var breakpoints = {
  xsMobile: 325,
  sMobile: 429,
  mobile: 500,
  lMobile: 650,
  mTablet: 767,
  tablet: 1023,
  sDesktop: 1279,
  xmDesktop: 1365,
  mDesktop: 1439,
  desktop: 1919
};
var vars = {
  // Media
  breakpoints: breakpoints,
  // Fonts
  fonts: {
    futura: "'Futura PT', Arial, sans-serif",
    futuraBook: "'Futura PT Book', Arial, sans-serif",
    futuraDemi: "'Futura PT Demi', Arial, sans-serif"
  },
  container: {
    default: 92.53,
    tablet: 93.75,
    mTablet: 91.66,
    lMobile: 89.3
  },
  sideOffset: {
    default: 3.735,
    tablet: 3.125,
    mTablet: 4.17,
    lMobile: 5.35
  },
  // Other
  maxContentWidth: 1264,
  maxTwoColumnWidth: 1600
};
/* harmony default export */ __webpack_exports__["Z"] = (vars);

/***/ }),

/***/ 81561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_button; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/button/Button.module.scss
var Button_module = __webpack_require__(86237);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/button/Button.js






var Button = function Button(_ref) {
  var _clsx;

  var children = _ref.children,
      onClick = _ref.onClick,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      _ref$action = _ref.action,
      action = _ref$action === void 0 ? 'submit' : _ref$action,
      classNames = _ref.classNames,
      status = _ref.status,
      loading = _ref.loading,
      disabled = _ref.disabled,
      artObj = _ref.artObj,
      width = _ref.width;
  var generalClass = classNames === null || classNames === void 0 ? void 0 : classNames.general;
  var contentClass = classNames === null || classNames === void 0 ? void 0 : classNames.content;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
    style: {
      width: width ? "".concat(width, "px") : ''
    },
    onClick: onClick // eslint-disable-next-line react/button-has-type
    ,
    type: action,
    disabled: disabled || loading,
    className: (0,clsx_m/* default */.Z)((_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (Button_module_default()).button, true), (0,defineProperty/* default */.Z)(_clsx, (Button_module_default())[type], type), (0,defineProperty/* default */.Z)(_clsx, (Button_module_default())[status], status), (0,defineProperty/* default */.Z)(_clsx, (Button_module_default()).loading, loading), (0,defineProperty/* default */.Z)(_clsx, (Button_module_default()).disabled, disabled || status === 'disabled'), (0,defineProperty/* default */.Z)(_clsx, generalClass, true), _clsx)),
    children: [artObj, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (0,clsx_m/* default */.Z)((Button_module_default()).buttonContent, contentClass),
      children: children
    })]
  });
};

/* harmony default export */ var button_Button = (Button);
;// CONCATENATED MODULE: ./components/button/index.js

/* harmony default export */ var components_button = (button_Button);

/***/ }),

/***/ 70517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O$": function() { return /* reexport */ activeLink; },
  "no": function() { return /* reexport */ blocks; },
  "Ny": function() { return /* reexport */ brandInfo; },
  "OW": function() { return /* reexport */ burger; },
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "aT": function() { return /* reexport */ blocks_button; },
  "HY": function() { return /* reexport */ carousel; },
  "XZ": function() { return /* reexport */ components_checkbox; },
  "Lp": function() { return /* reexport */ clickOutside; },
  "Rb": function() { return /* reexport */ contentSlider; },
  "oT": function() { return /* reexport */ control; },
  "dy": function() { return /* reexport */ controlledRadio; },
  "OP": function() { return /* reexport */ countrySelect; },
  "fE": function() { return /* reexport */ currencyPrice; },
  "jZ": function() { return /* reexport */ divider; },
  "Wg": function() { return /* reexport */ doubleGallery; },
  "Ad": function() { return /* reexport */ fourPictures; },
  "_m": function() { return /* reexport */ components_FullWidthSlider; },
  "$2": function() { return /* reexport */ gallery; },
  "l0": function() { return /* reexport */ galleryContainer; },
  "gY": function() { return /* reexport */ gallerySlider; },
  "SH": function() { return /* reexport */ h1; },
  "Xz": function() { return /* reexport */ htmlBlock; },
  "KS": function() { return /* reexport */ htmlLinksBlock; },
  "II": function() { return /* reexport */ input; },
  "Y4": function() { return /* reexport */ lazyPicture; },
  "rU": function() { return /* reexport */ components_link; },
  "Qj": function() { return /* reexport */ linkButton; },
  "aN": function() { return /* reexport */ loader; },
  "P9": function() { return /* reexport */ logoutModal_LogoutModal; },
  "tl": function() { return /* reexport */ lookImage; },
  "yC": function() { return /* reexport */ lookImageSlider; },
  "Ys": function() { return /* reexport */ marquee; },
  "z": function() { return /* reexport */ mobileFilters["default"]; },
  "zM": function() { return /* reexport */ components_MobileNav; },
  "oD": function() { return /* reexport */ mobileSort["default"]; },
  "nN": function() { return /* reexport */ mobileUserNav; },
  "u_": function() { return /* reexport */ modal; },
  "Wd": function() { return /* reexport */ navigationPictures; },
  "fS": function() { return /* reexport */ navigationPicturesOld; },
  "nQ": function() { return /* reexport */ navigationThreePictures; },
  "Kj": function() { return /* reexport */ noResult; },
  "P_": function() { return /* reexport */ Notification; },
  "Tx": function() { return /* reexport */ NotificationHandler; },
  "vo": function() { return /* reexport */ offset; },
  "Jv": function() { return /* reexport */ oneImage; },
  "E3": function() { return /* reexport */ pageText; },
  "V1": function() { return /* reexport */ pageTitle; },
  "t": function() { return /* reexport */ picture; },
  "Oe": function() { return /* reexport */ pictureHtml; },
  "yf": function() { return /* reexport */ pictureHtmlImage; },
  "h_": function() { return /* reexport */ Portal; },
  "tA": function() { return /* reexport */ components_price; },
  "Il": function() { return /* reexport */ productCard; },
  "if": function() { return /* reexport */ productFeature; },
  "Li": function() { return /* reexport */ productGallery; },
  "L": function() { return /* reexport */ productsSlider; },
  "S4": function() { return /* reexport */ RoutedLink; },
  "Ph": function() { return /* reexport */ components_select; },
  "Ky": function() { return /* reexport */ selectBase; },
  "f5": function() { return /* reexport */ selectionsCatalog; },
  "mB": function() { return /* reexport */ share; },
  "ky": function() { return /* reexport */ shopsOnMap; },
  "ZA": function() { return /* reexport */ shortsYoutubePlayer; },
  "ZI": function() { return /* reexport */ smartBanner; },
  "XA": function() { return /* reexport */ socialList; },
  "xv": function() { return /* reexport */ components_text; },
  "O5": function() { return /* reexport */ textWithSidePicture; },
  "Dx": function() { return /* reexport */ title_Title; },
  "Ir": function() { return /* reexport */ titleDescLink; },
  "Tb": function() { return /* reexport */ components_UserNav; },
  "xp": function() { return /* reexport */ userNavItem; },
  "FP": function() { return /* reexport */ widePicture; },
  "xw": function() { return /* reexport */ widePictureNoText; },
  "yw": function() { return /* reexport */ wishlistBtn; },
  "Ov": function() { return /* reexport */ youtubePlayer; }
});

// UNUSED EXPORTS: LookSliderBlock

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/activeLink/ActiveLink.js


var _excluded = ["href", "as", "children", "shallow", "activeAs", "disableActive", "activeClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ActiveLink = function ActiveLink(_ref) {
  var _hrefPath$query;

  var hrefPath = _ref.href,
      _ref$as = _ref.as,
      asPath = _ref$as === void 0 ? hrefPath : _ref$as,
      children = _ref.children,
      _ref$shallow = _ref.shallow,
      shallow = _ref$shallow === void 0 ? false : _ref$shallow,
      _ref$activeAs = _ref.activeAs,
      activeAs = _ref$activeAs === void 0 ? 'span' : _ref$activeAs,
      _ref$disableActive = _ref.disableActive,
      disableActive = _ref$disableActive === void 0 ? false : _ref$disableActive,
      activeClassName = _ref.activeClassName,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var router = (0,next_router.useRouter)();
  var href = hrefPath.pathname || hrefPath;
  var as = asPath.pathname || asPath;
  var query = (_hrefPath$query = hrefPath === null || hrefPath === void 0 ? void 0 : hrefPath.query) !== null && _hrefPath$query !== void 0 ? _hrefPath$query : null;
  var queriesStringified = lib_default().stringify(query, {
    encode: false
  });
  var isActive = router.asPath.split('?')[0] === as;
  var componentProps = isActive ? _objectSpread({
    active: 'true',
    as: activeAs
  }, props) : _objectSpread({}, props);
  var elements = react.Children.toArray(children);

  if (elements.length > 1) {
    throw new Error('ActiveLink component accepts only one child');
  }

  var component = /*#__PURE__*/(0,react.cloneElement)(elements[0], componentProps);

  if (isActive && !disableActive) {
    return typeof component.type === 'string' ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: activeClassName,
      children: component.props.children
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: component
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: queriesStringified ? "".concat(href, "?").concat(queriesStringified) : href,
    as: queriesStringified ? "".concat(as, "?").concat(queriesStringified) : as,
    shallow: shallow,
    passHref: true,
    children: component
  });
};

/* harmony default export */ var activeLink_ActiveLink = (ActiveLink);
;// CONCATENATED MODULE: ./components/activeLink/index.js

/* harmony default export */ var activeLink = (activeLink_ActiveLink);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/burger/Burger.module.scss
var Burger_module = __webpack_require__(32425);
var Burger_module_default = /*#__PURE__*/__webpack_require__.n(Burger_module);
;// CONCATENATED MODULE: ./components/burger/Burger.js






var Burger = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var open = _ref.open,
      onClick = _ref.onClick,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((Burger_module_default()).burger, (0,defineProperty/* default */.Z)({}, (Burger_module_default()).open, open)),
    onClick: onClick,
    role: "button",
    tabIndex: 0,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Burger_module_default()).box,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Burger_module_default()).line
      })
    }), children]
  });
});
/* harmony default export */ var burger_Burger = (Burger);
;// CONCATENATED MODULE: ./components/burger/index.js

/* harmony default export */ var burger = (burger_Burger);
// EXTERNAL MODULE: ./components/checkbox/checkbox.module.scss
var checkbox_module = __webpack_require__(46769);
var checkbox_module_default = /*#__PURE__*/__webpack_require__.n(checkbox_module);
;// CONCATENATED MODULE: ./components/checkbox/Checkbox.js






var Checkbox = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var _clsx;

  var name = _ref.name,
      label = _ref.label,
      children = _ref.children,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      isError = _ref.isError,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((checkbox_module_default()).wrapper, className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      className: (0,clsx_m/* default */.Z)((checkbox_module_default()).check, disabled && (checkbox_module_default()).checkDisabled),
      htmlFor: name,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "checkbox",
        name: name,
        id: name,
        disabled: disabled,
        checked: checked,
        onChange: onChange,
        className: (checkbox_module_default()).input
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)((checkbox_module_default()).box, (_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (checkbox_module_default()).isError, isError), (0,defineProperty/* default */.Z)(_clsx, (checkbox_module_default()).boxDisabled, disabled), _clsx))
      }), label && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)((checkbox_module_default()).label, disabled && (checkbox_module_default()).disabled),
        children: label
      })]
    }), children]
  });
});
Checkbox.displayName = 'Checkbox';
/* harmony default export */ var checkbox_Checkbox = (Checkbox);
;// CONCATENATED MODULE: ./components/checkbox/index.js

/* harmony default export */ var components_checkbox = (checkbox_Checkbox);
// EXTERNAL MODULE: ./components/title/Title.module.scss
var Title_module = __webpack_require__(29478);
var Title_module_default = /*#__PURE__*/__webpack_require__.n(Title_module);
;// CONCATENATED MODULE: ./components/title/Title.js


var Title_excluded = ["children", "className", "mb", "align", "component", "invisible", "success", "fail", "dataBrand"];

function Title_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Title_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Title = function Title(_ref) {
  var children = _ref.children,
      className = _ref.className,
      mb = _ref.mb,
      align = _ref.align,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'h1' : _ref$component,
      invisible = _ref.invisible,
      success = _ref.success,
      fail = _ref.fail,
      _ref$dataBrand = _ref.dataBrand,
      dataBrand = _ref$dataBrand === void 0 ? null : _ref$dataBrand,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  var classes = (0,clsx_m/* default */.Z)((Title_module_default())[Component], (Title_module_default())[mb], (Title_module_default())[align], (0,defineProperty/* default */.Z)({}, (Title_module_default()).invisible, invisible), (0,defineProperty/* default */.Z)({}, (Title_module_default()).success, success), (0,defineProperty/* default */.Z)({}, (Title_module_default()).fail, fail), className);
  var otherParams = dataBrand ? {
    'data-brand': dataBrand
  } : {};
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Title_objectSpread(Title_objectSpread(Title_objectSpread({
    className: classes
  }, props), otherParams), {}, {
    children: children
  }));
};

/* harmony default export */ var title_Title = (Title);
;// CONCATENATED MODULE: ./components/title/index.js

// EXTERNAL MODULE: ./components/text/Text.module.scss
var Text_module = __webpack_require__(16250);
var Text_module_default = /*#__PURE__*/__webpack_require__.n(Text_module);
;// CONCATENATED MODULE: ./components/text/Text.js


var Text_excluded = ["children", "className", "size", "mb", "align", "textDecoration"];

function Text_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Text_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Text = function Text(_ref) {
  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      mb = _ref.mb,
      align = _ref.align,
      textDecoration = _ref.textDecoration,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  var classes = (0,clsx_m/* default */.Z)((Text_module_default()).text, (Text_module_default())[size], (Text_module_default())[textDecoration], (Text_module_default())[mb], (Text_module_default())[align], className);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("p", Text_objectSpread(Text_objectSpread({
    className: classes
  }, props), {}, {
    children: children
  }));
};

/* harmony default export */ var text_Text = (Text);
;// CONCATENATED MODULE: ./components/text/index.js

/* harmony default export */ var components_text = (text_Text);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./components/socialList/socialList.module.scss
var socialList_module = __webpack_require__(99807);
var socialList_module_default = /*#__PURE__*/__webpack_require__.n(socialList_module);
;// CONCATENATED MODULE: ./components/socialList/SocialList.js



 // import ecommerce from '@/seo/Ecommerce';



var SocialList = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var list = _ref.list,
      type = _ref.type,
      top = _ref.top;
  if (!list || list.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (0,clsx_m/* default */.Z)((socialList_module_default()).list, (socialList_module_default())[type], (0,defineProperty/* default */.Z)({}, (socialList_module_default()).top, top)),
    children: list.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (socialList_module_default())["list-item"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: item.href,
          target: "_blank",
          "aria-label": item.label,
          rel: "noopener noreferrer",
          onClick: function onClick() {// ecommerce.onClickExternalLink(item.href);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (socialList_module_default()).icon,
            children: item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
              name: item.icon,
              width: top ? '32' : '24',
              height: top ? '32' : '23'
            })
          })
        })
      }, item.icon);
    })
  });
});
/* harmony default export */ var socialList_SocialList = (SocialList);
;// CONCATENATED MODULE: ./components/socialList/index.js

/* harmony default export */ var socialList = (socialList_SocialList);
;// CONCATENATED MODULE: ./components/control/Control.js


var Control_excluded = ["children", "className", "tag"];

function Control_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Control_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Control_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Control_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var Control = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Control_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, Control_objectSpread(Control_objectSpread({
    ref: ref,
    className: className
  }, props), {}, {
    children: children
  }));
});
/* harmony default export */ var control_Control = (Control);
;// CONCATENATED MODULE: ./components/control/index.js

/* harmony default export */ var control = (control_Control);
;// CONCATENATED MODULE: ./components/clickOutside/ClickOutside.js


var ClickOutside_excluded = ["onClickOutside", "as", "children"];

function ClickOutside_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ClickOutside_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ClickOutside_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ClickOutside_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var ClickOutside = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var onClickOutside = _ref.onClickOutside,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, ClickOutside_excluded);

  var ref = (0,react.useRef)();
  var handleClickOutside = (0,react.useCallback)(function (e) {
    var _ref$current;

    if (ref.current && !(ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(e.target) || ref.current === e.target)) {
      onClickOutside();
    }
  }, [onClickOutside]);
  (0,react.useEffect)(function () {
    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);
  return /*#__PURE__*/(0,react.createElement)(as, ClickOutside_objectSpread(ClickOutside_objectSpread({}, props), {}, {
    ref: ref
  }), children);
});
/* harmony default export */ var clickOutside_ClickOutside = (ClickOutside);
;// CONCATENATED MODULE: ./components/clickOutside/index.js

/* harmony default export */ var clickOutside = (clickOutside_ClickOutside);
// EXTERNAL MODULE: ./lib/config.js
var config = __webpack_require__(6668);
// EXTERNAL MODULE: ./components/countrySelect/countrySelectItem/countrySelectItem.module.scss
var countrySelectItem_module = __webpack_require__(1371);
var countrySelectItem_module_default = /*#__PURE__*/__webpack_require__.n(countrySelectItem_module);
;// CONCATENATED MODULE: ./components/countrySelect/countrySelectItem/CountrySelectItem.js






var CountrySelectItem = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var countryISO = _ref.countryISO,
      name = _ref.name,
      code = _ref.code,
      selectedCountry = _ref.selectedCountry,
      onCodeClick = _ref.onCodeClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: (0,clsx_m/* default */.Z)((countrySelectItem_module_default())["country-select-item"], (0,defineProperty/* default */.Z)({}, (countrySelectItem_module_default()).active, selectedCountry === countryISO)),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      onClick: onCodeClick(countryISO),
      type: "button",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (countrySelectItem_module_default()).icon,
          style: {
            backgroundImage: "url('/images/flags/".concat(countryISO, ".png')")
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: name
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: code
      })]
    })
  });
});
CountrySelectItem.displayName = 'CountrySelectItem';
/* harmony default export */ var countrySelectItem_CountrySelectItem = (CountrySelectItem);
;// CONCATENATED MODULE: ./components/countrySelect/countrySelectItem/index.js

/* harmony default export */ var countrySelectItem = (countrySelectItem_CountrySelectItem);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./components/countrySelect/countrySelectlist/countrySelectlist.module.scss
var countrySelectlist_module = __webpack_require__(90229);
var countrySelectlist_module_default = /*#__PURE__*/__webpack_require__.n(countrySelectlist_module);
;// CONCATENATED MODULE: ./components/countrySelect/countrySelectlist/CountrySelectList.js









var CountrySelectlist = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var visible = _ref.visible,
      children = _ref.children,
      isMobile = _ref.isMobile,
      onClose = _ref.onClose,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      _ref$classNameList = _ref.classNameList,
      classNameList = _ref$classNameList === void 0 ? null : _ref$classNameList;
  var hasSmartBanner = (0,es/* useSelector */.v9)(store/* hasSmartBannerSelector */.Jd);

  if (visible && isMobile) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Portal, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((countrySelectlist_module_default())["country-modal-dialog"], hasSmartBanner && (countrySelectlist_module_default()).smartBanner, className),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (countrySelectlist_module_default())["modal-header"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0443/\u0440\u0435\u0433\u0438\u043E\u043D"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            className: (countrySelectlist_module_default())["modal-close"],
            onClick: onClose
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (countrySelectlist_module_default())["modal-inner"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: (countrySelectlist_module_default())["country-list"],
            children: children
          })
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((countrySelectlist_module_default())["country-select-dropdown"], (0,defineProperty/* default */.Z)({}, (countrySelectlist_module_default()).visible, visible), classNameList),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: (countrySelectlist_module_default())["country-select-list"],
      children: children
    })
  });
});
CountrySelectlist.displayName = 'CountrySelectlist';
/* harmony default export */ var CountrySelectList = (CountrySelectlist);
;// CONCATENATED MODULE: ./components/countrySelect/countrySelectlist/index.js

/* harmony default export */ var countrySelectlist = (CountrySelectList);
// EXTERNAL MODULE: ./hooks/use-window-size.js
var use_window_size = __webpack_require__(55876);
// EXTERNAL MODULE: ./components/countrySelect/countrySelect.module.scss
var countrySelect_module = __webpack_require__(96907);
var countrySelect_module_default = /*#__PURE__*/__webpack_require__.n(countrySelect_module);
;// CONCATENATED MODULE: ./components/countrySelect/CountrySelect.js

 // import noScroll from 'no-scroll';










var list = Object.keys(config/* countries */.hW);

var CountrySelect = function CountrySelect(_ref) {
  var countryIso = _ref.selectedCountry,
      onCountryChange = _ref.onCountryChange,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      _ref$classNameList = _ref.classNameList,
      classNameList = _ref$classNameList === void 0 ? null : _ref$classNameList;

  var _useState = (0,react.useState)(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isMobile = _useWindowSize.isMobile;

  var selectedCountry = countryIso ? countryIso : 'by';
  var onToggle = (0,react.useCallback)(function () {
    setVisible(function (prev) {
      return !prev;
    }); // if (isMobile) {
    //   noScroll.toggle();
    // }
  }, [isMobile]);
  var onOutsideClick = (0,react.useCallback)(function () {
    if (isMobile) {
      return;
    }

    setVisible(false);
  }, [isMobile]);
  var onClose = (0,react.useCallback)(function () {
    setVisible(false); // if (isMobile) {
    //   noScroll.off();
    // }
  }, [isMobile]);
  var onCodeClick = (0,react.useCallback)(function (country) {
    return function () {
      onCountryChange(country);
      onClose();
    };
  }, [onClose, onCountryChange]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(clickOutside, {
    onClickOutside: onOutsideClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (countrySelect_module_default())["country-select"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
        onClick: onToggle,
        action: "button",
        classNames: {
          general: (0,clsx_m/* default */.Z)((countrySelect_module_default())["country-select-trigger"], (0,defineProperty/* default */.Z)({}, (countrySelect_module_default()).active, visible))
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/images/flags/".concat(selectedCountry, ".png"),
          className: (countrySelect_module_default())["trigger-icon"],
          alt: selectedCountry ? config/* countries */.hW[selectedCountry].name : '',
          width: 39,
          height: 23
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(countrySelectlist, {
        visible: visible,
        onClose: onClose,
        isMobile: isMobile,
        className: className,
        classNameList: classNameList,
        children: list.map(function (country) {
          var _countries$country = config/* countries */.hW[country],
              code = _countries$country.code,
              name = _countries$country.name;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(countrySelectItem, {
            code: code,
            name: name,
            countryISO: country,
            selectedCountry: selectedCountry,
            onCodeClick: onCodeClick
          }, code + name);
        })
      })]
    })
  });
};

/* harmony default export */ var countrySelect_CountrySelect = (CountrySelect);
;// CONCATENATED MODULE: ./components/countrySelect/index.js

/* harmony default export */ var countrySelect = (countrySelect_CountrySelect);
// EXTERNAL MODULE: ./components/button/index.js + 1 modules
var components_button = __webpack_require__(81561);
// EXTERNAL MODULE: ./components/controlledRadio/ControlledRadio.module.scss
var ControlledRadio_module = __webpack_require__(15668);
var ControlledRadio_module_default = /*#__PURE__*/__webpack_require__.n(ControlledRadio_module);
;// CONCATENATED MODULE: ./components/controlledRadio/ControlledRadio.js






var ControlledRadio = function ControlledRadio(_ref) {
  var _clsx;

  var name = _ref.name,
      value = _ref.value,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      children = _ref.children;

  var handleChange = function handleChange(e) {
    var value = e.target.value;
    onChange(value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
    className: (ControlledRadio_module_default()).radio,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "radio",
      className: (ControlledRadio_module_default()).input,
      name: name,
      value: value,
      checked: checked,
      onChange: handleChange,
      disabled: disabled
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (0,clsx_m/* default */.Z)((_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (ControlledRadio_module_default()).title, true), (0,defineProperty/* default */.Z)(_clsx, (ControlledRadio_module_default()).checked, checked), (0,defineProperty/* default */.Z)(_clsx, (ControlledRadio_module_default()).focus, !checked), (0,defineProperty/* default */.Z)(_clsx, (ControlledRadio_module_default()).disabled, disabled), (0,defineProperty/* default */.Z)(_clsx, (ControlledRadio_module_default()).disabledChecked, disabled && checked), (0,defineProperty/* default */.Z)(_clsx, (ControlledRadio_module_default()).notDisabledAndChecked, !disabled & !checked), _clsx)),
      children: children
    })]
  });
};

/* harmony default export */ var controlledRadio_ControlledRadio = (ControlledRadio);
;// CONCATENATED MODULE: ./components/controlledRadio/index.js

/* harmony default export */ var controlledRadio = (controlledRadio_ControlledRadio);
// EXTERNAL MODULE: ./components/styles/index.js + 11 modules
var components_styles = __webpack_require__(92134);
;// CONCATENATED MODULE: ./components/Notification.js



function Notification(_ref) {
  var content = _ref.content,
      closable = _ref.closable,
      id = _ref.id,
      style = _ref.style,
      closeFn = _ref.closeFn;

  var handleClose = function handleClose(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    closeFn && closeFn(id);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledNotification */.HX, {
    viewType: style,
    closable: closable,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_styles/* StyledNotification.Body */.HX.Body, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledNotification.Content */.HX.Content, {
        children: content
      }), closable && /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledNotification.Close */.HX.Close, {
        onClick: handleClose
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 2 modules
var TransitionGroup = __webpack_require__(89747);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./contexts/NotificationContext.js
var NotificationContext = __webpack_require__(64318);
;// CONCATENATED MODULE: ./components/Notifications.js


function Notifications_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Notifications_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Notifications_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Notifications_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function NotificationHandler() {
  var notification = (0,NotificationContext/* useNotification */.l)();
  var list = notification.list,
      close = notification.close;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledNotifications */.dG, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledNotifications.List */.dG.List, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionGroup/* default */.Z, {
        component: null,
        children: list.map(function (item, ind) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
            in: true,
            timeout: {
              appear: 0,
              enter: 230,
              exit: 230
            },
            classNames: "on",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Notification, Notifications_objectSpread(Notifications_objectSpread({}, item), {}, {
              closeFn: function closeFn(id) {
                return close(id);
              }
            }))
          }, ind);
        })
      })
    })
  });
}
// EXTERNAL MODULE: ./node_modules/react-id-swiper/lib/index.js
var react_id_swiper_lib = __webpack_require__(88667);
var react_id_swiper_lib_default = /*#__PURE__*/__webpack_require__.n(react_id_swiper_lib);
// EXTERNAL MODULE: ./assets/styles/vars.js
var vars = __webpack_require__(54935);
;// CONCATENATED MODULE: ./components/FullWidthSlider.js


function FullWidthSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FullWidthSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FullWidthSlider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FullWidthSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var FullWidthSlider_FullWidthSlider = function FullWidthSlider(_ref) {
  var _ref$widthLimit = _ref.widthLimit,
      widthLimit = _ref$widthLimit === void 0 ? '100%' : _ref$widthLimit,
      children = _ref.children,
      _ref$noFull = _ref.noFull,
      noFull = _ref$noFull === void 0 ? false : _ref$noFull,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$isBigSlider = _ref.isBigSlider,
      isBigSlider = _ref$isBigSlider === void 0 ? false : _ref$isBigSlider,
      _ref$isCarousel = _ref.isCarousel,
      isCarousel = _ref$isCarousel === void 0 ? false : _ref$isCarousel,
      bigMargin = _ref.bigMargin,
      _ref$noSlideWidth = _ref.noSlideWidth,
      noSlideWidth = _ref$noSlideWidth === void 0 ? false : _ref$noSlideWidth,
      hideNavigationCount = _ref.hideNavigationCount,
      fullWidth = _ref.fullWidth,
      _ref$nextImagesPage = _ref.nextImagesPage,
      nextImagesPage = _ref$nextImagesPage === void 0 ? null : _ref$nextImagesPage,
      mod = _ref.mod,
      _ref$isCollection = _ref.isCollection,
      isCollection = _ref$isCollection === void 0 ? false : _ref$isCollection,
      _ref$isBrandDescripti = _ref.isBrandDescription,
      isBrandDescription = _ref$isBrandDescripti === void 0 ? false : _ref$isBrandDescripti,
      _ref$isBrandDescripti2 = _ref.isBrandDescriptionLoading,
      isBrandDescriptionLoading = _ref$isBrandDescripti2 === void 0 ? false : _ref$isBrandDescripti2,
      _ref$pagination = _ref.pagination,
      pagination = _ref$pagination === void 0 ? {} : _ref$pagination,
      _ref$infiniteTouchLoa = _ref.infiniteTouchLoading,
      infiniteTouchLoading = _ref$infiniteTouchLoa === void 0 ? false : _ref$infiniteTouchLoa;
  var swiperRef = (0,react.useRef)(null);
  var hideButtons = children.length <= hideNavigationCount;

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isMobile = _useWindowSize.isMobile,
      isLaptop = _useWindowSize.isLaptop;

  var _useState = (0,react.useState)({
    prevDisabled: true,
    nextDisabled: false,
    locked: true
  }),
      navigationState = _useState[0],
      setNavigationState = _useState[1];

  var notHaveButtons = (0,react.useMemo)(function () {
    return isBrandDescription && isMobile;
  }, [isBrandDescription, isMobile]);
  var countSlides = (0,react.useMemo)(function () {
    if (isBigSlider) {
      if (isMobile) {
        return 1;
      }

      return 2;
    }

    if (isBrandDescription) {
      return 1;
    }

    return 'auto';
  }, [isBigSlider, isMobile, isBrandDescription]);
  var spaceBetween = (0,react.useMemo)(function () {
    if (isBigSlider) {
      if (isLaptop) {
        return 24;
      }

      return 32;
    }

    return 0;
  }, [isBigSlider, isLaptop]);
  var params = {
    resistanceRatio: 0,
    slidesPerView: countSlides,
    pagination: pagination,
    watchOverflow: true,
    rebuildOnUpdate:
    /*isCollection || */
    isBrandDescriptionLoading,
    observer: isCollection ? true : false,
    spaceBetween: spaceBetween,
    watchSlidesVisibility: true,
    autoplay: isBigSlider ? {
      delay: 5000,
      disableOnInteraction: false
    } : false // allowTouchMove: !isCollection,

  };
  var updateNavigation = (0,react.useCallback)(function () {
    var swiperInstance = swiperRef.current.swiper;
    setNavigationState({
      prevDisabled: swiperInstance.isBeginning,
      nextDisabled: nextImagesPage ? false : swiperInstance.isEnd,
      locked: nextImagesPage ? false : swiperInstance.isLocked
    });
  }, [nextImagesPage]);
  (0,react.useEffect)(function () {
    if (swiperRef.current.swiper && swiperRef.current.swiper.disabled && !loading) {
      setTimeout(function () {
        swiperRef.current.swiper.disabled = false;
      }, 500);
    }
  }, [loading]);
  var goNextOnTouch = (0,react.useCallback)(function () {
    var _swiperRef$current2;

    if (!infiniteTouchLoading) return;
    if (!nextImagesPage) return;

    var onSuccessLoaded = function onSuccessLoaded(index) {
      setTimeout(function () {
        var _swiperRef$current;

        (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : _swiperRef$current.swiper.slideTo(index);
      }, 0);
      setNavigationState(function (prevState) {
        return FullWidthSlider_objectSpread(FullWidthSlider_objectSpread({}, prevState), {}, {
          prevDisabled: false
        });
      });
    };

    if (swiperRef !== null && swiperRef !== void 0 && (_swiperRef$current2 = swiperRef.current) !== null && _swiperRef$current2 !== void 0 && _swiperRef$current2.swiper) {
      var visibleSlidesCount = swiperRef.current.swiper.visibleSlidesIndexes.length;
      var sliderWidth = swiperRef.current.swiper.width;
      var slideWidth = swiperRef.current.swiper.slides[0].getBoundingClientRect().width;
      var spaceWidth = sliderWidth < 429 ? 6 : slideWidth < 250 ? 24 : 32;
      var isHalfVisibleSlide = sliderWidth <= vars/* default.breakpoints.mobile */.Z.breakpoints.mobile ? slideWidth * 3 + spaceWidth * 2 > sliderWidth : false;

      if (swiperRef.current.swiper.isEnd && !swiperRef.current.swiper.disabled) {
        swiperRef.current.swiper.disabled = true;
        var activeIndex = swiperRef.current.swiper.activeIndex;
        nextImagesPage(function () {
          onSuccessLoaded(activeIndex + (isHalfVisibleSlide ? visibleSlidesCount - 1 : visibleSlidesCount));
        });
      }
    }
  }, [infiniteTouchLoading, nextImagesPage]);
  (0,react.useEffect)(function () {
    var swiperInstance = swiperRef.current.swiper;

    if (swiperInstance) {
      updateNavigation();
      swiperInstance.on('resize', updateNavigation);
      swiperInstance.on('fromEdge', updateNavigation);
      swiperInstance.on('slideChange', updateNavigation);
      swiperInstance.on('reachEnd', updateNavigation);
      swiperInstance.on('reachBeginning', updateNavigation);
      swiperInstance.on('touchEnd', goNextOnTouch);
    }

    return function () {
      if (swiperInstance) {
        swiperInstance.off('resize', updateNavigation);
        swiperInstance.off('fromEdge', updateNavigation);
        swiperInstance.off('slideChange', updateNavigation);
        swiperInstance.off('reachEnd', updateNavigation);
        swiperInstance.off('reachBeginning', updateNavigation);
        swiperInstance.off('touchEnd', goNextOnTouch);
      }
    };
  }, [updateNavigation, goNextOnTouch]);

  var goNext = function goNext() {
    var _swiperRef$current4;

    var onSuccessLoaded = function onSuccessLoaded(newIndex) {
      setTimeout(function () {
        var _swiperRef$current3;

        (_swiperRef$current3 = swiperRef.current) === null || _swiperRef$current3 === void 0 ? void 0 : _swiperRef$current3.swiper.slideTo(newIndex);
      }, 0);
      setNavigationState(function (prevState) {
        return FullWidthSlider_objectSpread(FullWidthSlider_objectSpread({}, prevState), {}, {
          prevDisabled: false
        });
      });
    };

    if (swiperRef !== null && swiperRef !== void 0 && (_swiperRef$current4 = swiperRef.current) !== null && _swiperRef$current4 !== void 0 && _swiperRef$current4.swiper) {
      var visibleSlidesCount = swiperRef.current.swiper.visibleSlidesIndexes.length;

      if (swiperRef.current.swiper.isEnd && nextImagesPage) {
        var activeIndex = swiperRef.current.swiper.activeIndex;
        nextImagesPage(function () {
          onSuccessLoaded(activeIndex + visibleSlidesCount);
        });
      } else {
        setTimeout(function () {
          swiperRef.current.swiper.slideNext();
        }, 100);

        if (isCollection) {
          if (swiperRef.current.swiper.activeIndex === 0) {
            setNavigationState(function (prevState) {
              return FullWidthSlider_objectSpread(FullWidthSlider_objectSpread({}, prevState), {}, {
                prevDisabled: false
              });
            });
          }
        }
      }
    }
  };

  var goPrev = function goPrev() {
    var _swiperRef$current5;

    if (swiperRef !== null && swiperRef !== void 0 && (_swiperRef$current5 = swiperRef.current) !== null && _swiperRef$current5 !== void 0 && _swiperRef$current5.swiper) {
      setTimeout(function () {
        swiperRef.current.swiper.slidePrev();
      }, 0);

      if (isCollection && swiperRef.current.swiper.activeIndex === 1) {
        setNavigationState(function (prevState) {
          return FullWidthSlider_objectSpread(FullWidthSlider_objectSpread({}, prevState), {}, {
            prevDisabled: true
          });
        });
      }
    }
  };

  var isMini = mod === 'mini';

  var NavButtons = function NavButtons() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledFullWidthSlider.BtnWrap */.us.BtnWrap, {
        hide: hideButtons,
        centered: isCarousel && !isBigSlider,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledFullWidthSlider.Prev */.us.Prev, {
          disabled: loading || navigationState.prevDisabled,
          onClick: goPrev,
          isBigSlider: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
            name: "m-arrow-up"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledFullWidthSlider.BtnWrap */.us.BtnWrap, {
        right: true,
        hide: nextImagesPage ? false : hideButtons,
        centered: isCarousel && !isBigSlider,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledFullWidthSlider.Next */.us.Next, {
          disabled: loading || navigationState.nextDisabled,
          onClick: goNext,
          isBigSlider: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
            name: "m-arrow-up"
          })
        })
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_styles/* StyledFullWidthSlider */.us, {
    mod: mod,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledFullWidthSlider.Container */.us.Container, {
      noFull: noFull,
      fullWidth: fullWidth,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_styles/* StyledFullWidthSlider.Swiper */.us.Swiper, {
        locked: navigationState.locked,
        widthLimit: widthLimit,
        bigMargin: bigMargin,
        isBrandDescription: isBrandDescription,
        noSlideWidth: noSlideWidth,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((react_id_swiper_lib_default()), FullWidthSlider_objectSpread(FullWidthSlider_objectSpread({
          ref: swiperRef
        }, params), {}, {
          children: children
        })), !isMini && !notHaveButtons && /*#__PURE__*/(0,jsx_runtime.jsx)(NavButtons, {})]
      })
    }), isMini && !notHaveButtons && /*#__PURE__*/(0,jsx_runtime.jsx)(NavButtons, {
      isMini: true
    })]
  });
};

/* harmony default export */ var components_FullWidthSlider = (FullWidthSlider_FullWidthSlider);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(76627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ./components/input/Input.module.scss
var Input_module = __webpack_require__(91888);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ./components/input/statuses.js
var statuses = {
  default: 'default',
  readOnly: 'read-only',
  disabled: 'disabled',
  success: 'success',
  error: 'error'
};
/* harmony default export */ var input_statuses = (statuses);
;// CONCATENATED MODULE: ./components/input/Input.js


function Input_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Input_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Input_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Input_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var TextArea = function TextArea(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", Input_objectSpread({
    maxLength: 256
  }, props));
};

var Input = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var _clsx, _clsx2;

  var _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      _props$status = props.status,
      status = _props$status === void 0 ? 'default' : _props$status,
      freezed = props.freezed,
      value = props.value,
      disabled = props.disabled,
      readOnly = props.readOnly,
      mask = props.mask,
      label = props.label,
      onChange = props.onChange,
      changeLabelState = props.changeLabelState,
      error = props.error,
      info = props.info,
      name = props.name,
      classNames = props.classNames,
      tooltip = props.tooltip,
      loading = props.loading,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      _props$onClick = props.onClick,
      _onClick = _props$onClick === void 0 ? null : _props$onClick,
      _props$onBlur = props.onBlur,
      onBlur = _props$onBlur === void 0 ? null : _props$onBlur,
      _props$maskPlaceholde = props.maskPlaceholder,
      maskPlaceholder = _props$maskPlaceholde === void 0 ? null : _props$maskPlaceholde,
      _props$isSearch = props.isSearch,
      isSearch = _props$isSearch === void 0 ? false : _props$isSearch,
      _props$isClear = props.isClear,
      isClear = _props$isClear === void 0 ? false : _props$isClear,
      _props$clearClick = props.clearClick,
      clearClick = _props$clearClick === void 0 ? false : _props$clearClick,
      _props$maxLength = props.maxLength,
      maxLength = _props$maxLength === void 0 ? 256 : _props$maxLength;

  var refNode = (0,react.useRef)(null);

  var getGeneralStatus = function getGeneralStatus() {
    if (readOnly) {
      return input_statuses.readOnly;
    }

    if (disabled) {
      return input_statuses.disabled;
    }

    if (error) {
      return input_statuses.error;
    }

    return status || input_statuses["default"];
  };

  var generalStatus = getGeneralStatus();
  var subTextClass = classNames === null || classNames === void 0 ? void 0 : classNames.subText;
  var fieldClass = classNames === null || classNames === void 0 ? void 0 : classNames.field;
  var labelClass = classNames === null || classNames === void 0 ? void 0 : classNames.labelClass;
  var generalClass = classNames === null || classNames === void 0 ? void 0 : classNames.general;
  var tooltipHeader = tooltip === null || tooltip === void 0 ? void 0 : tooltip.header;
  var tooltipDescription = tooltip === null || tooltip === void 0 ? void 0 : tooltip.desc;

  var _useState = (0,react.useState)(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var labelIsInside = !focused && !(value !== null && value !== void 0 && value.length);
  var isFreezed = freezed || loading;
  var isDisabled = input_statuses.readOnly === generalStatus || input_statuses.disabled === generalStatus || freezed;

  var setFocusedInput = function setFocusedInput() {
    if (!disabled) {
      if (!_onClick) {
        var _refNode$current;

        (_refNode$current = refNode.current) === null || _refNode$current === void 0 ? void 0 : _refNode$current.focus();
        setFocused(true);

        if (isSearch) {
          var _refNode$current2;

          (_refNode$current2 = refNode.current) === null || _refNode$current2 === void 0 ? void 0 : _refNode$current2.setSelectionRange(0, 0);
        }

        if (changeLabelState) {
          changeLabelState(true);
        }
      } else {
        refNode.current.blur();
      }
    }
  };

  var setBluredInput = function setBluredInput() {
    setFocused(false);

    if (changeLabelState) {
      changeLabelState(false);
    }

    if (onBlur) {
      onBlur();
    }
  };

  var subText = error || info;
  var ElemToShow = null;

  if (type === 'textarea') {
    ElemToShow = TextArea;
  } else {
    ElemToShow = (react_input_mask_default());
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (Input_module_default()).input, true), (0,defineProperty/* default */.Z)(_clsx, (Input_module_default())[generalStatus], true), (0,defineProperty/* default */.Z)(_clsx, (Input_module_default())[type], true), (0,defineProperty/* default */.Z)(_clsx, (Input_module_default()).freezed, isFreezed), (0,defineProperty/* default */.Z)(_clsx, (Input_module_default()).loading, loading), _clsx), generalClass),
    onClick: function onClick(e) {
      if (_onClick) {
        e.stopPropagation();
        e.preventDefault();

        _onClick();

        setFocused(false);
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
      name: "circle-success"
    }), isSearch && /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
      name: "search",
      fill: "#BBBBBB",
      className: (Input_module_default()).search
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ElemToShow, {
      disabled: isDisabled,
      id: name,
      onBlur: setBluredInput,
      onFocus: setFocusedInput,
      inputRef: function inputRef(el) {
        refNode.current = el;
      },
      name: name,
      className: (0,clsx_m/* default */.Z)((Input_module_default()).field, fieldClass, type === 'textarea' && (Input_module_default()).textAreaInput),
      value: value,
      onChange: onChange,
      required: required,
      mask: mask,
      maskChar: maskPlaceholder || '_',
      type: type,
      maxLength: type === 'textarea' ? maxLength : null
    }), isClear && /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
      onClick: clearClick,
      name: "close",
      stroke: "#171717",
      className: (Input_module_default()).clear
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      onClick: function onClick(EO) {
        setFocusedInput();
      },
      htmlFor: name,
      className: (0,clsx_m/* default */.Z)((_clsx2 = {}, (0,defineProperty/* default */.Z)(_clsx2, (Input_module_default()).label, true), (0,defineProperty/* default */.Z)(_clsx2, (Input_module_default()).labelIsInside, labelIsInside), (0,defineProperty/* default */.Z)(_clsx2, (Input_module_default()).labelIsInsideSearch, labelIsInside && isSearch), (0,defineProperty/* default */.Z)(_clsx2, (Input_module_default()).labelError, error), _clsx2), labelClass),
      children: [label, required && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "*"
      })]
    }), subText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((Input_module_default())["info-text"], (0,defineProperty/* default */.Z)({}, (Input_module_default()).error, error), subTextClass),
      children: subText
    }), input_statuses.success === status && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Input_module_default()).tooltip,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
        className: (Input_module_default()).header,
        children: tooltipHeader
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Input_module_default()).description,
        children: tooltipDescription
      })]
    })]
  });
});
Input.displayName = 'Input';
/* harmony default export */ var input_Input = (Input);
;// CONCATENATED MODULE: ./components/input/index.js

/* harmony default export */ var input = (input_Input);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
;// CONCATENATED MODULE: ./utils/routesDict.js
/* harmony default export */ var routesDict = ([{
  reg: /^\/wishlist$/,
  route: '/wishlist'
}, {
  reg: /^\/user\/returns$/,
  route: '/user/returns'
}, {
  reg: /^\/user\/profile\/remove$/,
  route: '/user/profile/remove'
}, {
  reg: /^\/user\/profile$/,
  route: '/user/profile'
}, {
  reg: /^\/user\/orders$/,
  route: '/user/orders'
}, {
  reg: /^\/user\/order\/.+$/,
  route: '/user/order/[orderId]'
}, {
  reg: /^\/user\/newsletters$/,
  route: '/user/newsletters'
}, {
  reg: /^\/user\/discount$/,
  route: '/user/discount'
}, {
  reg: /^\/success-return\/.+$/,
  route: '/success-return/[returnId]'
}, {
  reg: /^\/special-offers$/,
  route: '/special-offers'
}, {
  reg: /^\/special-offers\/.+$/,
  route: '/special-offers/[slug]'
}, {
  reg: /^\/shops$/,
  route: '/shops'
}, {
  reg: /^\/shops\/Shops.module.scss$/,
  route: '/shops/Shops.module.scss'
}, {
  reg: /^\/search$/,
  route: '/search'
}, {
  reg: /^\/return-policy$/,
  route: '/return-policy'
}, {
  reg: /^\/product\/.+$/,
  route: '/product/[productId]'
}, {
  reg: /^\/news$/,
  route: '/news'
}, {
  reg: /^\/news\/.+$/,
  route: '/news/[slug]'
}, {
  reg: /^\/new-return$/,
  route: '/new-return'
}, {
  reg: /^\/login$/,
  route: '/login'
}, {
  reg: /^\/feedbacks$/,
  route: '/feedbacks'
}, {
  reg: /^\/contacts$/,
  route: '/contacts'
}, {
  reg: /^\/checkout\/success\/.+$/,
  route: '/checkout/success/[orderId]'
}, {
  reg: /^\/checkout\/redirect\/.+$/,
  route: '/checkout/redirect/[orderId]'
}, {
  reg: /^\/checkout$/,
  route: '/checkout'
}, {
  reg: /^\/checkout\/failure\/.+$/,
  route: '/checkout/failure/[paymentId]'
}, {
  reg: /^\/checkout\/contacts$/,
  route: '/checkout/contacts'
}, {
  reg: /^\/catalog$/,
  route: '/catalog'
}, {
  reg: /^\/cart$/,
  route: '/cart'
}, {
  reg: /^\/brands$/,
  route: '/brands'
}, {
  reg: /^\/api\/product$/,
  route: '/api/product'
}, {
  reg: /^\/api\/menu$/,
  route: '/api/menu'
}, {
  reg: /^\/api\/filters$/,
  route: '/api/filters'
}, {
  reg: /^\/api\/barcode$/,
  route: '/api/barcode'
}, {
  reg: /^\/_error$/,
  route: '/_error'
}, {
  reg: /^\/_error\/Error.module.scss$/,
  route: '/_error/Error.module.scss'
}, {
  reg: /^\/.+$/,
  route: '/[...typeSlug]'
}]);
// EXTERNAL MODULE: ./contexts/HostContext.js
var HostContext = __webpack_require__(78755);
;// CONCATENATED MODULE: ./components/RoutedLink.js


var RoutedLink_excluded = ["to", "component", "children", "shallow"];

function RoutedLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RoutedLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoutedLink_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoutedLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var TemplateLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "RoutedLink__TemplateLink",
  componentId: "sc-n7qiap-0"
})(["display:block;"]);
function RoutedLink(_ref) {
  var to = _ref.to,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? TemplateLink : _ref$component,
      children = _ref.children,
      _ref$shallow = _ref.shallow,
      shallow = _ref$shallow === void 0 ? false : _ref$shallow,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, RoutedLink_excluded);

  var host = (0,HostContext/* useHost */.$)();
  var origin = "^(http|https)://".concat(host);
  var relativeAs = to.replace(new RegExp(origin), '');
  var relativeAsWithoutQueries = relativeAs.split('?')[0] || '';
  var queries = lib_default().parse(relativeAs.split('?')[1] || '');
  var href = '';

  for (var index = 0; index < routesDict.length; index++) {
    var reg = routesDict[index].reg;

    if (reg.test(relativeAsWithoutQueries)) {
      href = routesDict[index].route;
      break;
    }
  }

  return href ? /*#__PURE__*/(0,jsx_runtime.jsx)(activeLink, {
    href: {
      pathname: href,
      query: queries || {}
    },
    as: {
      pathname: relativeAsWithoutQueries,
      query: queries || {}
    },
    shallow: shallow,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, RoutedLink_objectSpread(RoutedLink_objectSpread({}, props), {}, {
      children: children
    }))
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Component, RoutedLink_objectSpread(RoutedLink_objectSpread({
    href: to
  }, props), {}, {
    children: children
  }));
}
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/categoriesSlice.js
var categoriesSlice = __webpack_require__(11012);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/lib/index.js
var react_loading_skeleton_lib = __webpack_require__(51655);
// EXTERNAL MODULE: ./containers/index.js + 33 modules
var containers = __webpack_require__(21341);
// EXTERNAL MODULE: ./contexts/NavContext.js
var NavContext = __webpack_require__(73682);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
;// CONCATENATED MODULE: ./components/MobileNav.js


var MobileNav_excluded = ["category", "savedQuery", "title"],
    _excluded2 = ["allItemsTitle", "savedQuery", "level"];

function MobileNav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MobileNav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileNav_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileNav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var ItemLink = function ItemLink(_ref) {
  var _ref$category = _ref.category,
      path = _ref$category.path,
      link = _ref$category.link,
      type = _ref$category.type,
      savedQuery = _ref.savedQuery,
      title = _ref.title,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, MobileNav_excluded);

  var notCatalogLink = type !== 'menu' && type !== 'category' && type !== 'brand';
  var routeType = 'catalog';
  var linkHref = notCatalogLink ? link : (0,getLinkProps/* default */.Z)({
    type: routeType,
    value: path
  })[0];
  var linkAs = notCatalogLink ? null : (0,getLinkProps/* default */.Z)({
    type: routeType,
    value: path
  })[1];
  return notCatalogLink ? /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, MobileNav_objectSpread(MobileNav_objectSpread({
    to: linkHref,
    component: components_styles/* StyledMobileNav.Link */.tL.Link
  }, props), {}, {
    children: title
  })) : /*#__PURE__*/(0,jsx_runtime.jsx)(activeLink, {
    href: {
      pathname: linkHref,
      query: savedQuery || {}
    },
    as: {
      pathname: linkAs,
      query: savedQuery || {}
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.Link */.tL.Link, MobileNav_objectSpread(MobileNav_objectSpread({}, props), {}, {
      children: title
    }))
  });
};

var MobileNav = function MobileNav(_ref2) {
  var hasBanner = _ref2.hasBanner;

  var _useNav = (0,NavContext/* useNav */.Y)(),
      visibility = _useNav.visibility,
      toggleMobileNav = _useNav.toggleMobileNav;

  var sort = (0,es/* useSelector */.v9)(store/* catalogSortSelector */.tD);
  return visibility.mobileNav ? /*#__PURE__*/(0,jsx_runtime.jsx)(MemoizedMobileNav, MobileNav_objectSpread({
    visibility: visibility.mobileNav,
    toggleMobileNav: toggleMobileNav,
    hasBanner: hasBanner
  }, sort && {
    savedQuery: {
      sort: sort
    }
  })) : null;
};

var MemoizedMobileNav = /*#__PURE__*/(0,react.memo)(function (_ref3) {
  var visibility = _ref3.visibility,
      toggleMobileNav = _ref3.toggleMobileNav,
      savedQuery = _ref3.savedQuery,
      hasBanner = _ref3.hasBanner;
  var dispatch = (0,es/* useDispatch */.I0)();
  var wrapper = (0,react.useRef)(null);

  var _useState = (0,react.useState)([]),
      tree = _useState[0],
      setTree = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var onClickOutside = (0,react.useCallback)(function (e) {
    var _wrapper$current;

    if (visibility && (!(wrapper !== null && wrapper !== void 0 && (_wrapper$current = wrapper.current) !== null && _wrapper$current !== void 0 && _wrapper$current.contains(e.target)) || wrapper.current === e.target)) {
      toggleMobileNav();
    }
  }, [toggleMobileNav, visibility]);
  var onMenuLinkClick = (0,react.useCallback)(function (e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    toggleMobileNav();
  }, [toggleMobileNav]);
  (0,react.useEffect)(function () {
    setLoading(true);
    dispatch((0,categoriesSlice/* getCategoriesTree */.fc)({
      onSuccess: function onSuccess(res) {
        setLoading(false);
        setTree(res.data);
      }
    }));
  }, [dispatch]);
  (0,react.useEffect)(function () {
    window.addEventListener('click', onClickOutside);
    return function () {
      return window.removeEventListener('click', onClickOutside);
    };
  }, [visibility, onClickOutside]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav */.tL, {
    visible: visibility,
    ref: wrapper,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.Menu */.tL.Menu, {
      visible: visibility,
      hasBanner: hasBanner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.MenuInner */.tL.MenuInner, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.Level */.tL.Level, {
          visible: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_styles/* StyledMobileNav.LevelInner */.tL.LevelInner, {
            children: [loading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                padding: '16px 20px 0 0',
                width: '100%'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
                count: 10,
                height: 46,
                width: "100%",
                style: {
                  marginBottom: '8px'
                }
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.List */.tL.List, {
              children: tree.map(function (category) {
                var id = category.id;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(MobileNavSwitch, MobileNav_objectSpread(MobileNav_objectSpread({}, category), {}, {
                  onClick: onMenuLinkClick,
                  savedQuery: savedQuery
                }), id);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.ContactsOverview */.tL.ContactsOverview, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* ContactsOverview */.aP, {
                isMobile: true,
                onMenuLinkClick: onMenuLinkClick
              })
            })]
          })
        })
      })
    })
  });
});
var MobileNavSwitch = /*#__PURE__*/(0,react.memo)(function (_ref4) {
  var _ref4$allItemsTitle = _ref4.allItemsTitle,
      allItemsTitle = _ref4$allItemsTitle === void 0 ? 'Все товары' : _ref4$allItemsTitle,
      savedQuery = _ref4.savedQuery,
      level = _ref4.level,
      category = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded2);

  var _useState3 = (0,react.useState)(false),
      isVisible = _useState3[0],
      setIsVisible = _useState3[1];

  var name = category.name,
      path = category.path,
      children = category.children,
      type = category.type,
      link = category.link,
      is_blanked = category.is_blanked,
      view_type = category.view_type,
      onClick = category.onClick;

  var toggleVisible = function toggleVisible() {
    setIsVisible(function (prev) {
      return !prev;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.Item */.tL.Item, {
    level: level,
    children: children && children.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.Link */.tL.Link, {
        as: "button",
        parent: true,
        styledView: view_type,
        onClick: toggleVisible,
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
        in: isVisible,
        timeout: {
          appear: 0,
          enter: 200,
          exit: 200
        },
        classNames: "on",
        unmountOnExit: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.Level */.tL.Level, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_styles/* StyledMobileNav.LevelInner */.tL.LevelInner, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_styles/* StyledMobileNav.Back */.tL.Back, {
              onClick: toggleVisible,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.BackIcon */.tL.BackIcon, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                  width: "30",
                  height: "11",
                  viewBox: "0 0 30 11",
                  fill: "currentColor",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.254 5.951L6.304 9 5.1 10.202 0 5.101 5.101 0l1.202 1.202-3.049 3.049h25.948v1.7H3.254z"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: name
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledMobileNav.Item */.tL.Item, {
                level: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ItemLink, MobileNav_objectSpread({
                  category: {
                    path: path,
                    link: link,
                    type: type
                  },
                  onClick: onClick,
                  title: allItemsTitle,
                  savedQuery: savedQuery
                }, is_blanked && {
                  target: '_blank',
                  rel: 'noopener noreferrer'
                }))
              }), children.map(function (child) {
                var id = child.id;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(MobileNavSwitch, MobileNav_objectSpread(MobileNav_objectSpread({}, child), {}, {
                  onClick: onClick,
                  savedQuery: savedQuery,
                  level: true
                }), id);
              })]
            })]
          })
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ItemLink, MobileNav_objectSpread({
      category: {
        path: path,
        link: link,
        type: type
      },
      onClick: onClick,
      styledView: view_type,
      title: name,
      savedQuery: savedQuery
    }, is_blanked && {
      target: '_blank',
      rel: 'noopener noreferrer'
    }))
  });
});
/* harmony default export */ var components_MobileNav = (MobileNav);
// EXTERNAL MODULE: ./components/link/Link.module.scss
var Link_module = __webpack_require__(26503);
var Link_module_default = /*#__PURE__*/__webpack_require__.n(Link_module);
;// CONCATENATED MODULE: ./components/link/Link.js


var Link_excluded = ["children", "className"];

function Link_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Link_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Link_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Link_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Link = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var children = props.children,
      className = props.className,
      rest = (0,objectWithoutProperties/* default */.Z)(props, Link_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Link_objectSpread(Link_objectSpread({
    ref: ref,
    className: (0,clsx_m/* default */.Z)((Link_module_default()).link, className)
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var link_Link = (Link);
;// CONCATENATED MODULE: ./components/link/index.js

/* harmony default export */ var components_link = (link_Link);
;// CONCATENATED MODULE: ./components/linkButton/LinkButton.js


var LinkButton_excluded = ["children"];

function LinkButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LinkButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LinkButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LinkButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var LinkButton = function LinkButton(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, LinkButton_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, LinkButton_objectSpread(LinkButton_objectSpread({
    type: "primary"
  }, props), {}, {
    children: children
  }));
};

/* harmony default export */ var linkButton_LinkButton = (LinkButton);
;// CONCATENATED MODULE: ./components/linkButton/index.js

/* harmony default export */ var linkButton = (linkButton_LinkButton);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/userSlice.js
var userSlice = __webpack_require__(46789);
// EXTERNAL MODULE: ./node_modules/no-scroll/index.js
var no_scroll = __webpack_require__(70743);
var no_scroll_default = /*#__PURE__*/__webpack_require__.n(no_scroll);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/cartSlice.js
var cartSlice = __webpack_require__(78955);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/wishlistSlice.js + 1 modules
var wishlistSlice = __webpack_require__(94650);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./components/logoutModal/LogoutModal.module.scss
var LogoutModal_module = __webpack_require__(953);
var LogoutModal_module_default = /*#__PURE__*/__webpack_require__.n(LogoutModal_module);
;// CONCATENATED MODULE: ./components/logoutModal/LogoutModal.js


var LogoutModal_excluded = ["isProfile"];

function LogoutModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LogoutModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LogoutModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LogoutModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ModalTrigger = function ModalTrigger(_ref) {
  var isProfile = _ref.isProfile,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, LogoutModal_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", LogoutModal_objectSpread(LogoutModal_objectSpread({}, props), {}, {
    className: isProfile && (LogoutModal_module_default()).isProfile,
    children: "\u0412\u044B\u0445\u043E\u0434"
  }));
};

var LogoutModal = function LogoutModal(_ref2) {
  var isProfile = _ref2.isProfile;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(true),
      visible = _useState[0],
      setVisible = _useState[1];

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isMobileMenu = _useWindowSize.isMobileMenu;

  var _useState2 = (0,react.useState)(false),
      mobileVisible = _useState2[0],
      setMobileVisible = _useState2[1];

  var cancelClick = function cancelClick() {
    setVisible(false);

    if (mobileVisible && isMobileMenu) {
      no_scroll_default().toggle();
    }
  };

  var logoutClick = function logoutClick() {
    dispatch((0,userSlice/* logout */.kS)(function () {
      if ( true && sessionStorage.getItem('country')) {
        sessionStorage.removeItem('country');
      }

      dispatch((0,cartSlice/* updateCartIds */.U9)({
        ids: []
      }));
      dispatch((0,cartSlice/* updateCartCount */.N1)({
        count: 0
      }));
      dispatch((0,wishlistSlice/* updateWishlistIds */.Mu)({
        ids: []
      }));
      dispatch((0,sessionSlice/* removeToken */.gy)({
        onSuccess: function onSuccess() {
          setVisible(false);
          dispatch((0,sessionSlice/* createSession */.ed)(true));
          router_default().push({
            pathname: '/'
          }, {
            pathname: '/'
          }).then(function () {
            return window.scrollTo(0, 0);
          });
        }
      }));
    }));
  };

  (0,react.useEffect)(function () {
    if (mobileVisible && isMobileMenu) {
      no_scroll_default().toggle();
    }
  }, [mobileVisible, isMobileMenu]);
  (0,react.useEffect)(function () {
    if (!visible) {
      setVisible(true);
    }
  }, [visible]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(modal, {
      isSizeTable: true,
      generalVisible: visible,
      setMobileVisible: setMobileVisible,
      render: function render(props) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalTrigger, LogoutModal_objectSpread(LogoutModal_objectSpread({}, props), {}, {
          isProfile: isProfile
        }));
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LogoutModal_module_default()).block,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LogoutModal_module_default()).title,
          children: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0432\u044B\u0439\u0442\u0438?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (LogoutModal_module_default()).buttonContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
            onClick: cancelClick,
            classNames: {
              general: (LogoutModal_module_default()).buttonCancel
            },
            children: "\u041E\u0442\u043C\u0435\u043D\u0430"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
            onClick: logoutClick,
            type: "defaultBlack",
            classNames: {
              general: (LogoutModal_module_default()).buttonLogout
            },
            children: "\u0412\u044B\u0439\u0442\u0438"
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var logoutModal_LogoutModal = (LogoutModal);
;// CONCATENATED MODULE: ./components/logoutModal/index.js

;// CONCATENATED MODULE: ./components/lazyPicture/LazyPicture.js


var LazyPicture_excluded = ["data", "snippet", "isSafari"];

function LazyPicture_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LazyPicture_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LazyPicture_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LazyPicture_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var placeHolder = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

var LazyPicture = function LazyPicture(_ref) {
  var _props$classes, _props$classes2;

  var data = _ref.data,
      snippet = _ref.snippet,
      isSafari = _ref.isSafari,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, LazyPicture_excluded);

  var _useState = (0,react.useState)({
    x2: placeHolder,
    webp_x2: placeHolder
  }),
      imageSrc = _useState[0],
      setImageSrc = _useState[1];

  var _useState2 = (0,react.useState)(),
      imageRef = _useState2[0],
      setImageRef = _useState2[1];

  var loadClass = (props === null || props === void 0 ? void 0 : (_props$classes = props.classes) === null || _props$classes === void 0 ? void 0 : _props$classes.loaded) || 'loaded';
  var errorClass = (props === null || props === void 0 ? void 0 : (_props$classes2 = props.classes) === null || _props$classes2 === void 0 ? void 0 : _props$classes2.error) || 'error';

  var onLoad = function onLoad(event) {
    var _event$target;

    if (event.target.src !== placeHolder) (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.classList.add(loadClass);
  };

  var onError = function onError(event) {
    var _event$target2;

    if (event.target.src !== placeHolder) (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.classList.add(errorClass);
  };

  (0,react.useEffect)(function () {
    if ((imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.x2) !== placeHolder) {
      setImageSrc(data);
    }
  }, [data, imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.x2]);
  (0,react.useEffect)(function () {
    var observer;
    var didCancel = false;

    if (imageRef && (imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.x2) === placeHolder) {
      if (IntersectionObserver) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // when image is visible in the viewport + rootMargin
            if (!didCancel && (entry.intersectionRatio > 0 || entry.isIntersecting)) {
              setImageSrc(data);
              observer.unobserve(imageRef);
            }
          });
        }, {
          threshold: 0.01,
          rootMargin: '20%'
        });
        observer.observe(imageRef);
      } else {
        // Old browsers fallback
        setImageSrc(data);
      }
    }

    return function () {
      didCancel = true; // on component unmount, we remove the listner

      if (observer && observer.unobserve) {
        observer.unobserve(imageRef);
      }
    };
  }, [data, imageSrc, imageRef]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(picture, LazyPicture_objectSpread(LazyPicture_objectSpread(LazyPicture_objectSpread({
    ref: setImageRef,
    snippet: snippet
  }, imageSrc), props), {}, {
    onLoad: onLoad,
    isSafari: isSafari,
    onLoadError: onError,
    isLazy: true
  }));
};

/* harmony default export */ var lazyPicture_LazyPicture = (LazyPicture);
;// CONCATENATED MODULE: ./components/lazyPicture/index.js

/* harmony default export */ var lazyPicture = (lazyPicture_LazyPicture);
// EXTERNAL MODULE: ./components/loader/Loader.module.scss
var Loader_module = __webpack_require__(90864);
var Loader_module_default = /*#__PURE__*/__webpack_require__.n(Loader_module);
;// CONCATENATED MODULE: ./components/loader/Loader.js





var Loader = function Loader(_ref) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((Loader_module_default()).loader, visible && (Loader_module_default()).visible),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
      name: "spinner",
      width: 70,
      height: 70,
      style: {
        top: '50%'
      }
    })
  });
};

/* harmony default export */ var loader_Loader = (Loader);
;// CONCATENATED MODULE: ./components/loader/index.js

/* harmony default export */ var loader = (loader_Loader);
// EXTERNAL MODULE: ./components/mobileFilters/index.js + 1 modules
var mobileFilters = __webpack_require__(20178);
// EXTERNAL MODULE: ./components/mobileSort/index.js + 1 modules
var mobileSort = __webpack_require__(48673);
// EXTERNAL MODULE: ./components/mobileUserNav/MobileUserNav.module.scss
var MobileUserNav_module = __webpack_require__(81874);
var MobileUserNav_module_default = /*#__PURE__*/__webpack_require__.n(MobileUserNav_module);
;// CONCATENATED MODULE: ./components/mobileUserNav/MobileUserNav.js







var UserNavItem = function UserNavItem(_ref) {
  var link = _ref.link,
      onClick = _ref.onClick;
  var href = link.href,
      as = link.as,
      title = link.title,
      _link$isLogout = link.isLogout,
      isLogout = _link$isLogout === void 0 ? false : _link$isLogout;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: isLogout ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: (MobileUserNav_module_default()).profileLink,
      "aria-label": "\u0412\u044B\u0439\u0442\u0438",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(logoutModal_LogoutModal, {})
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(activeLink, {
      href: href,
      as: as,
      activeClassName: (MobileUserNav_module_default()).profileLink,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: (MobileUserNav_module_default()).profileLink,
        onClick: onClick,
        children: title
      })
    })
  });
};

var MemoizedMobileUserNav = /*#__PURE__*/(0,react.memo)(function MobileUserNav(_ref2) {
  var visibility = _ref2.visibility,
      toggleMobileUserNav = _ref2.toggleMobileUserNav,
      hasBanner = _ref2.hasBanner;
  var isVisible = visibility;
  var wrapper = (0,react.useRef)(null);

  var onClickOutside = function onClickOutside(e) {
    var _wrapper$current;

    if (isVisible && (!(wrapper !== null && wrapper !== void 0 && (_wrapper$current = wrapper.current) !== null && _wrapper$current !== void 0 && _wrapper$current.contains(e.target)) || wrapper.current === e.target)) {
      toggleMobileUserNav();
    }
  };

  var onToggleClick = (0,react.useCallback)(function (e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    toggleMobileUserNav();
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener('click', onClickOutside);
    return function () {
      return window.removeEventListener('click', onClickOutside);
    };
  }, [isVisible]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((MobileUserNav_module_default()).container, isVisible && (MobileUserNav_module_default()).visibleContainer),
    ref: wrapper,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((MobileUserNav_module_default()).menu, hasBanner && (MobileUserNav_module_default()).menuBanner),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (MobileUserNav_module_default()).menuInner,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (MobileUserNav_module_default()).level,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (MobileUserNav_module_default()).levelInner,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: (MobileUserNav_module_default()).profileList,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_UserNav, {
                render: UserNavItem,
                onClick: onToggleClick
              })
            })
          })
        })
      })
    })
  });
});

var MobileUserNav = function MobileUserNav(_ref3) {
  var hasBanner = _ref3.hasBanner;

  var _useNav = (0,NavContext/* useNav */.Y)(),
      visibility = _useNav.visibility,
      toggleMobileUserNav = _useNav.toggleMobileUserNav;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(MemoizedMobileUserNav, {
    visibility: visibility.mobileUserNav,
    toggleMobileUserNav: toggleMobileUserNav,
    hasBanner: hasBanner
  });
};

/* harmony default export */ var mobileUserNav_MobileUserNav = (MobileUserNav);
;// CONCATENATED MODULE: ./components/mobileUserNav/index.js

/* harmony default export */ var mobileUserNav = (mobileUserNav_MobileUserNav);
// EXTERNAL MODULE: ./components/modal/Modal.module.scss
var Modal_module = __webpack_require__(61140);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
;// CONCATENATED MODULE: ./components/modal/Modal.js


function Modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Modal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var TriggerDefault = function TriggerDefault(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", Modal_objectSpread(Modal_objectSpread({}, props), {}, {
    children: "Open"
  }));
};

var Modal = function Modal(_ref) {
  var children = _ref.children,
      _ref$hasTrigger = _ref.hasTrigger,
      hasTrigger = _ref$hasTrigger === void 0 ? true : _ref$hasTrigger,
      openOnTimeout = _ref.openOnTimeout,
      onOpen = _ref.onOpen,
      timeoutInSec = _ref.timeoutInSec,
      _ref$render = _ref.render,
      TriggerView = _ref$render === void 0 ? TriggerDefault : _ref$render,
      _ref$generalVisible = _ref.generalVisible,
      generalVisible = _ref$generalVisible === void 0 ? null : _ref$generalVisible,
      _ref$setMobileVisible = _ref.setMobileVisible,
      setMobileVisible = _ref$setMobileVisible === void 0 ? null : _ref$setMobileVisible,
      _ref$isSizeTable = _ref.isSizeTable,
      isSizeTable = _ref$isSizeTable === void 0 ? false : _ref$isSizeTable,
      _ref$isBrandInfo = _ref.isBrandInfo,
      isBrandInfo = _ref$isBrandInfo === void 0 ? false : _ref$isBrandInfo;

  var _useState = (0,react.useState)(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var previouslyOpened = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    if (generalVisible === false) {
      setVisible(false);

      if (setMobileVisible) {
        setMobileVisible(false);
      }
    }
  }, [generalVisible, setMobileVisible]);
  (0,react.useEffect)(function () {
    var timeoutId;

    if (openOnTimeout && timeoutInSec >= 0) {
      timeoutId = setTimeout(function () {
        if (document.documentElement.style.position === 'fixed') {
          previouslyOpened.current = true;
        }

        showModal();
        onOpen && onOpen();
      }, timeoutInSec * 1000);
    }

    return function () {
      clearTimeout(timeoutId);
      no_scroll_default().off();
    };
  }, []);

  var showModal = function showModal() {
    no_scroll_default().on();
    setVisible(true);

    if (setMobileVisible) {
      setMobileVisible(true);
    }
  };

  var closeModal = function closeModal() {
    setVisible(false);

    if (setMobileVisible) {
      setMobileVisible(false);
    }

    if (!previouslyOpened.current) {
      no_scroll_default().off();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [hasTrigger && /*#__PURE__*/(0,jsx_runtime.jsx)(TriggerView, {
      onClick: showModal
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
      in: visible,
      timeout: {
        appear: 0,
        enter: 230,
        exit: 230
      },
      classNames: {
        enter: (Modal_module_default()).onEnter,
        enterActive: (Modal_module_default()).onEnterActive,
        exit: (Modal_module_default()).onExit,
        exitActive: (Modal_module_default()).onExitActive
      },
      unmountOnExit: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Portal, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: closeModal,
          className: (0,clsx_m/* default */.Z)((Modal_module_default()).modal, isSizeTable && (Modal_module_default()).sizeTable, isBrandInfo && (Modal_module_default()).brandInfo),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Modal_module_default()).container,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Modal_module_default()).closeDialogWrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (Modal_module_default()).dialog,
                onClick: function onClick(e) {
                  e.stopPropagation();
                },
                children: children
              })
            })
          })
        })
      })
    })]
  });
};

/* harmony default export */ var modal_Modal = (Modal);
;// CONCATENATED MODULE: ./components/modal/index.js

/* harmony default export */ var modal = (modal_Modal);
// EXTERNAL MODULE: ./components/pageTitle/PageTitle.module.scss
var PageTitle_module = __webpack_require__(68832);
var PageTitle_module_default = /*#__PURE__*/__webpack_require__.n(PageTitle_module);
;// CONCATENATED MODULE: ./components/pageTitle/PageTitle.js



var PageTitle = function PageTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (PageTitle_module_default()).title,
    children: children
  });
};

/* harmony default export */ var pageTitle_PageTitle = (PageTitle);
;// CONCATENATED MODULE: ./components/pageTitle/index.js

/* harmony default export */ var pageTitle = (pageTitle_PageTitle);
// EXTERNAL MODULE: ./components/pageText/PageText.module.scss
var PageText_module = __webpack_require__(7124);
var PageText_module_default = /*#__PURE__*/__webpack_require__.n(PageText_module);
;// CONCATENATED MODULE: ./components/pageText/PageText.js




var PageText = function PageText(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((PageText_module_default()).text, className),
    children: children
  });
};

/* harmony default export */ var pageText_PageText = (PageText);
;// CONCATENATED MODULE: ./components/pageText/index.js

/* harmony default export */ var pageText = (pageText_PageText);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/picture/Picture.module.scss
var Picture_module = __webpack_require__(6326);
var Picture_module_default = /*#__PURE__*/__webpack_require__.n(Picture_module);
;// CONCATENATED MODULE: ./components/picture/Picture.js


function Picture_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Picture_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Picture_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Picture_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var base64Pixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
var Picture = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var desktop = _ref.x2,
      desktop_webp = _ref.webp_x2,
      noImageOnTouch = _ref.noImageOnTouch,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'Фото' : _ref$alt,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Заголовок' : _ref$title,
      onLoad = _ref.onLoad,
      onLoadError = _ref.onLoadError,
      googleSnippet = _ref.snippet,
      isSafari = _ref.isSafari,
      _ref$isLazy = _ref.isLazy,
      isLazy = _ref$isLazy === void 0 ? false : _ref$isLazy,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? null : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? null : _ref$height;
  var snippet = googleSnippet === null || googleSnippet === void 0 ? void 0 : googleSnippet.x2; // const loading = isSafari ? {} : {loading: 'lazy'}

  var hasImage = !!(snippet || desktop_webp || desktop);

  if (isLazy) {
    return hasImage ? /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
      children: [noImageOnTouch && /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
        media: "(hover: none) and (pointer: coarse), (hover: none) and (pointer: fine)",
        srcSet: base64Pixel,
        sizes: "100%"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        layout: "fill",
        ref: ref,
        src: snippet || desktop_webp || desktop,
        alt: alt,
        title: title,
        onLoad: onLoad,
        onError: onLoadError,
        loading: isSafari ? 'eager' : 'lazy'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        itemProp: "image",
        content: snippet || desktop_webp || desktop
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (Picture_module_default()).patternImage,
      src: "/images/svg/pattern-order-picture.svg",
      alt: "image-pattern"
    });
  } else {
    var otherProps = {
      layout: 'fill'
    };

    if (width && height) {
      otherProps = {
        width: width,
        height: height
      };
    }

    return hasImage ? /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
      children: [noImageOnTouch && /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
        media: "(hover: none) and (pointer: coarse), (hover: none) and (pointer: fine)",
        srcSet: base64Pixel,
        sizes: "100%"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), Picture_objectSpread({
        ref: ref,
        src: snippet || desktop_webp || desktop,
        alt: alt,
        title: title,
        onLoad: onLoad,
        onError: onLoadError,
        loading: isSafari ? 'eager' : 'lazy'
      }, otherProps)), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        itemProp: "image",
        content: snippet || desktop_webp || desktop
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (Picture_module_default()).patternImage,
      src: "/images/svg/pattern-order-picture.svg",
      alt: "image-pattern"
    });
  }
});
/* harmony default export */ var picture_Picture = (Picture);
;// CONCATENATED MODULE: ./components/picture/index.js

/* harmony default export */ var picture = (picture_Picture);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__(72179);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/portal/Portal.js






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var Portal = /*#__PURE__*/function (_PureComponent) {
  (0,inherits/* default */.Z)(Portal, _PureComponent);

  var _super = _createSuper(Portal);

  function Portal(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Portal);

    _this = _super.call(this, props);
    _this.el = document.createElement('div');
    return _this;
  }

  (0,createClass/* default */.Z)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,react_dom.createPortal)(this.props.children, this.el);
    }
  }]);

  return Portal;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/price/Price.module.scss
var Price_module = __webpack_require__(57777);
var Price_module_default = /*#__PURE__*/__webpack_require__.n(Price_module);
;// CONCATENATED MODULE: ./components/price/Price.js

var Price_excluded = ["price", "oldPrice", "oldPriceReason", "priceDiscount", "isCheckout", "isProductCard", "isCatalog", "isLook", "isProduct", "isCollection", "isSearch", "isProductSlider", "isWishlist", "isLookProduct"];







var Price = function Price(_ref) {
  var _ref$price = _ref.price,
      price = _ref$price === void 0 ? '' : _ref$price,
      _ref$oldPrice = _ref.oldPrice,
      oldPrice = _ref$oldPrice === void 0 ? '' : _ref$oldPrice,
      oldPriceReason = _ref.oldPriceReason,
      priceDiscount = _ref.priceDiscount,
      _ref$isCheckout = _ref.isCheckout,
      isCheckout = _ref$isCheckout === void 0 ? false : _ref$isCheckout,
      _ref$isProductCard = _ref.isProductCard,
      isProductCard = _ref$isProductCard === void 0 ? false : _ref$isProductCard,
      _ref$isCatalog = _ref.isCatalog,
      isCatalog = _ref$isCatalog === void 0 ? false : _ref$isCatalog,
      _ref$isLook = _ref.isLook,
      isLook = _ref$isLook === void 0 ? false : _ref$isLook,
      _ref$isProduct = _ref.isProduct,
      isProduct = _ref$isProduct === void 0 ? false : _ref$isProduct,
      _ref$isCollection = _ref.isCollection,
      isCollection = _ref$isCollection === void 0 ? false : _ref$isCollection,
      _ref$isSearch = _ref.isSearch,
      isSearch = _ref$isSearch === void 0 ? false : _ref$isSearch,
      _ref$isProductSlider = _ref.isProductSlider,
      isProductSlider = _ref$isProductSlider === void 0 ? false : _ref$isProductSlider,
      _ref$isWishlist = _ref.isWishlist,
      isWishlist = _ref$isWishlist === void 0 ? false : _ref$isWishlist,
      _ref$isLookProduct = _ref.isLookProduct,
      isLookProduct = _ref$isLookProduct === void 0 ? false : _ref$isLookProduct,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Price_excluded);

  var hasDiscount = price !== oldPrice;

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isMobile = _useWindowSize.isMobile,
      isSmallTablet = _useWindowSize.isSmallTablet;

  var isDiscountPosition = isCatalog || isWishlist || isProductSlider || isLook || isCollection;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Price_module_default()).priceContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((Price_module_default()).font, (Price_module_default()).oldPrice, hasDiscount && (Price_module_default()).newPrice, isCheckout && (Price_module_default()).fontCheckout, isProductCard && (Price_module_default()).fontProductPage),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(currencyPrice, {
        price: oldPrice,
        isDiscount: isMobile && isDiscountPosition || isLookProduct && isSmallTablet ? false : hasDiscount
      })
    }), hasDiscount && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((Price_module_default()).font, (Price_module_default()).discountPrice, isCheckout && (Price_module_default()).fontCheckout, isProductCard && (Price_module_default()).fontProductPage),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(currencyPrice, {
        price: price,
        isDiscount: isMobile && isDiscountPosition || isLookProduct && isSmallTablet
      })
    })]
  });
};

/* harmony default export */ var price_Price = (Price);
;// CONCATENATED MODULE: ./components/price/index.js

/* harmony default export */ var components_price = (price_Price);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/currencySlice.js
var currencySlice = __webpack_require__(74542);
// EXTERNAL MODULE: ./lib/numberWithSpaces.js
var numberWithSpaces = __webpack_require__(85364);
// EXTERNAL MODULE: ./lib/hooks/useWindowWidth.js
var useWindowWidth = __webpack_require__(27299);
// EXTERNAL MODULE: ./node_modules/@tippyjs/react/dist/tippy-react.esm.js + 53 modules
var tippy_react_esm = __webpack_require__(21282);
// EXTERNAL MODULE: ./components/currencyPrice/CurrencyPrice.module.scss
var CurrencyPrice_module = __webpack_require__(44870);
var CurrencyPrice_module_default = /*#__PURE__*/__webpack_require__.n(CurrencyPrice_module);
;// CONCATENATED MODULE: ./components/currencyPrice/CurrencyPrice.js













var mobileBreakPoint = vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1;
var CurrencyPrice_text = 'Стоимость в RUB является справочной. Расчеты будут произведены в BYN по курсу вашего банка на дату транзакции';
var PurpleTippy = (0,styled_components_browser_esm/* default */.ZP)(tippy_react_esm/* default */.ZP).withConfig({
  displayName: "CurrencyPrice__PurpleTippy",
  componentId: "sc-1ki3sqa-0"
})([".tippy-content{z-index:1000000000;}.tippy-arrow{width:16px;height:16px;}&[data-placement^='bottom'] > .tippy-arrow{top:-12px;border-bottom:11px solid white;border-top:none;}"]);

var CurrencyPrice = function CurrencyPrice(_ref) {
  var _ref$price = _ref.price,
      price = _ref$price === void 0 ? '' : _ref$price,
      _ref$isDiscount = _ref.isDiscount,
      isDiscount = _ref$isDiscount === void 0 ? false : _ref$isDiscount;
  var style = (0,react.useMemo)(function () {
    return {
      color: '#585858',
      backgroundColor: 'white',
      boxShadow: '0px 6px 20px rgb(0 0 0 / 8%)',
      padding: '12px 15px',
      textAlign: 'center',
      zIndex: 10000
    };
  }, []);
  var windowWidth = (0,useWindowWidth/* default */.Z)();

  var _useState = (0,react.useState)(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var show = function show() {
    return setVisible(true);
  };

  var hide = function hide() {
    return setVisible(false);
  };

  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);
  var handleClick = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    e.preventDefault();
    show();
  }, []);
  (0,react.useEffect)(function () {
    if (windowWidth < mobileBreakPoint) {
      document.addEventListener('touchstart', hide);
      return function () {
        document.removeEventListener('touchstart', hide);
      };
    }
  }, [windowWidth]);
  var content = (0,react.useCallback)(function (isMobile) {
    return !isDiscount ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      onClick: isMobile ? handleClick : null,
      className: (CurrencyPrice_module_default()).icon,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "question-currency"
      })
    }) : null;
  }, [handleClick, isDiscount]);

  if (true) {
    var currencyState = localStorage.getItem('currency');

    if (currencyState === 'RU' && currency && Object.keys(currency).length) {
      var count = (0,numberWithSpaces/* default */.Z)(Math.ceil(Math.ceil(parseFloat(price) * currency.BYN.RUB) / 10) * 10);
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["".concat(count, " \u20BD"), windowWidth > mobileBreakPoint ? /*#__PURE__*/(0,jsx_runtime.jsx)(PurpleTippy, {
          content: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: style,
            children: CurrencyPrice_text
          }),
          children: content(false)
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PurpleTippy, {
          visible: visible,
          onClickOutside: hide,
          content: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: style,
            children: CurrencyPrice_text
          }),
          children: content(true)
        })]
      });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "".concat((0,numberWithSpaces/* default */.Z)(price), " BYN")
  });
};

/* harmony default export */ var currencyPrice_CurrencyPrice = (CurrencyPrice);
;// CONCATENATED MODULE: ./components/currencyPrice/index.js

/* harmony default export */ var currencyPrice = (currencyPrice_CurrencyPrice);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./hooks/index.js + 2 modules
var hooks = __webpack_require__(84431);
// EXTERNAL MODULE: ./hooks/use-local-storage.js
var use_local_storage = __webpack_require__(34670);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./components/productCard/components/TextVariants/TextVariants.module.scss
var TextVariants_module = __webpack_require__(45631);
var TextVariants_module_default = /*#__PURE__*/__webpack_require__.n(TextVariants_module);
;// CONCATENATED MODULE: ./components/productCard/components/TextVariants/TextVariants.js





var TextVariants = function TextVariants(_ref) {
  var initialVariants = _ref.variants;

  var _useState = (0,react.useState)(initialVariants),
      variants = _useState[0],
      setVariants = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hidden = _useState2[0],
      setHidden = _useState2[1];

  var listRef = (0,react.useRef)(null); // const resizeTimeoutId = useRef(null);
  // const updateVariants = useCallback(() => {
  //   const listWidth = listRef?.current?.clientWidth ?? null;
  //   const scrollWidth = listRef?.current?.scrollWidth;
  //   if (scrollWidth && listWidth && (scrollWidth > listWidth)) {
  //     const listItems = Array.from(listRef.current.children);
  //     let commonItemsWidth = 0;
  //     let visibleItemsQuantity = 0;
  //     listItems.forEach(item => {
  //       const width = item.clientWidth;
  //       const mr = parseInt(getComputedStyle(item).getPropertyValue('margin-right'), 10) || 0;
  //       const size = width + mr;
  //       commonItemsWidth += size;
  //       if (commonItemsWidth <= listWidth) {
  //         visibleItemsQuantity += 1;
  //       }
  //     });
  //     const variantsRestQuantity = initialVariants.length - visibleItemsQuantity + 1;
  //     const variantsNext = initialVariants.slice(0, visibleItemsQuantity - 1);
  //     if (variantsRestQuantity > 0) {
  //       variantsNext.push({ type: 'rest', value: variantsRestQuantity });
  //     }
  //     debugger
  //     setVariants(variantsNext);
  //   }
  //   setHidden(false);
  // }, [initialVariants]);
  // const onResize = useCallback(() => {
  //   clearTimeout(resizeTimeoutId.current);
  //   resizeTimeoutId.current = setTimeout(() => {
  //     updateVariants();
  //   }, 100);
  // }, [updateVariants]);
  // useEffect(() => {
  //   window.addEventListener('resize', onResize);
  //   updateVariants();
  //   return () => {
  //     window.removeEventListener('resize', onResize);
  //   };
  // }, [updateVariants, onResize]);

  (0,react.useEffect)(function () {
    setVariants(initialVariants); // setTimeout(() => {
    //   if (listRef.current) {
    //     updateVariants();
    //   }
    // }, 200);
  }, [initialVariants]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (TextVariants_module_default()).textVariants,
    ref: listRef,
    children: variants.map(function (variant) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (TextVariants_module_default()).item,
        children: variant
      }, variant);
    })
  });
};

/* harmony default export */ var TextVariants_TextVariants = (TextVariants);
;// CONCATENATED MODULE: ./components/productCard/components/TextVariants/index.js

/* harmony default export */ var components_TextVariants = (TextVariants_TextVariants);
// EXTERNAL MODULE: ./components/productCard/ProductCard.module.scss
var ProductCard_module = __webpack_require__(64950);
var ProductCard_module_default = /*#__PURE__*/__webpack_require__.n(ProductCard_module);
;// CONCATENATED MODULE: ./components/productCard/ProductCard.js



function ProductCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductCard_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/anchor-is-valid */















var AddToCart = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8945).then(__webpack_require__.bind(__webpack_require__, 58945));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(58945)];
    }
  }
});

var ProductCard_ProductCard = function ProductCard(props) {
  var _model$slug, _clsx2;

  var _props$isLast = props.isLast,
      isLast = _props$isLast === void 0 ? false : _props$isLast,
      dependencies = props.dependencies,
      initialSlug = props.slug,
      initialBrand = props.brand,
      initialName = props.name,
      initialPrice = props.price,
      initialOldPrice = props.old_price,
      initialPriceDiffPercent = props.price_diff_percent,
      initialMedia = props.media,
      external_id = props.external_id,
      stockQuantity = props.quantity,
      cartQuantity = props.cart_quantity,
      _props$mod = props.mod,
      mod = _props$mod === void 0 ? 'default' : _props$mod,
      old_price_reason = props.old_price_reason,
      discount = props.discount,
      initialFeatures = props.features,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      switchable_attributes = props.switchable_attributes,
      _props$titleLimit = props.titleLimit,
      titleLimit = _props$titleLimit === void 0 ? false : _props$titleLimit,
      images_info = props.images_info,
      isSafari = props.isSafari,
      getWishlist = props.getWishlist,
      _props$sex = props.sex,
      sex = _props$sex === void 0 ? null : _props$sex,
      _props$pol = props.pol,
      pol = _props$pol === void 0 ? null : _props$pol,
      _props$product_group_ = props.product_group_id,
      product_group_id = _props$product_group_ === void 0 ? null : _props$product_group_,
      _props$categories = props.categories,
      categories = _props$categories === void 0 ? [] : _props$categories,
      _props$pageName = props.pageName,
      pageName = _props$pageName === void 0 ? null : _props$pageName,
      _props$name_marketing = props.name_marketing,
      name_marketing = _props$name_marketing === void 0 ? null : _props$name_marketing,
      _props$indexCard = props.indexCard,
      indexCard = _props$indexCard === void 0 ? 1 : _props$indexCard,
      _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      _props$newCurrency = props.newCurrency,
      newCurrency = _props$newCurrency === void 0 ? null : _props$newCurrency,
      gallery = props.gallery;
  var googleSnippets = props === null || props === void 0 ? void 0 : props.google_snippet;
  var firstRun = (0,react.useRef)(true);
  var currency = newCurrency ? newCurrency : (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);

  var _useState = (0,react.useState)(''),
      size = _useState[0],
      setSize = _useState[1];

  var isWishlist = mod === 'wishlist';
  var isCatalog = mod === 'catalog';
  var isMini = mod === 'mini';
  var isCheckout = mod === 'checkout';
  var isViewed = mod === 'viewed';
  var isLook = mod === 'looks';
  var isCollection = mod === 'narrowCollection';
  var isProductSlider = mod === 'productSlider';

  var _useLocalStorage = (0,use_local_storage/* default */.Z)('productInfo', null),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      _productInfo = _useLocalStorage2[0],
      setProductInfo = _useLocalStorage2[1];

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      isDesktop = _useWindowSize.isDesktop;

  var _useState2 = (0,react.useState)({
    slug: initialSlug,
    brand: initialBrand,
    name: initialName,
    price: initialPrice,
    old_price: initialOldPrice,
    price_diff_percent: initialPriceDiffPercent,
    media: initialMedia,
    features: initialFeatures,
    switchable_attributes: switchable_attributes,
    sex: sex,
    pol: pol,
    categories: categories,
    name_marketing: name_marketing,
    product_group_id: product_group_id,
    external_id: external_id
  }),
      activeProductData = _useState2[0],
      setActiveProductData = _useState2[1];

  (0,react.useEffect)(function () {
    if (isWishlist && switchable_attributes && switchable_attributes.length > 0) {
      switchable_attributes.forEach(function (_ref) {
        var attribute = _ref.attribute,
            value = _ref.value;

        if (attribute === 'Размер производителя') {
          setSize("".concat(value));
        }
      });
    }
  }, [isWishlist, switchable_attributes]);
  (0,react.useEffect)(function () {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }

    var slug = props.slug,
        brand = props.brand,
        name = props.name,
        price = props.price,
        old_price = props.old_price,
        price_diff_percent = props.price_diff_percent,
        media = props.media,
        features = props.features,
        external_id = props.external_id,
        switchable_attributes = props.switchable_attributes,
        sex = props.sex,
        pol = props.pol,
        categories = props.categories,
        name_marketing = props.name_marketing,
        product_group_id = props.product_group_id;
    setActiveProductData({
      slug: slug,
      brand: brand,
      name: name,
      price: price,
      old_price: old_price,
      price_diff_percent: price_diff_percent,
      media: media,
      features: features,
      external_id: external_id,
      switchable_attributes: switchable_attributes,
      sex: sex,
      pol: pol,
      categories: categories,
      name_marketing: name_marketing,
      product_group_id: product_group_id
    });
  }, [props]);

  var _useState3 = (0,react.useState)(+cartQuantity),
      quantity = _useState3[0],
      setQuantity = _useState3[1];

  (0,react.useEffect)(function () {
    // if on cart update quantity is out of sync
    if (stockQuantity === cartQuantity && stockQuantity !== quantity) {
      setQuantity(stockQuantity);
    }
  }, [stockQuantity, cartQuantity]);
  var slug = activeProductData.slug,
      brand = activeProductData.brand,
      name = activeProductData.name,
      price = activeProductData.price,
      old_price = activeProductData.old_price,
      price_diff_percent = activeProductData.price_diff_percent,
      media = activeProductData.media,
      features = activeProductData.features;
  var mediaFirst = isViewed && gallery ? gallery === null || gallery === void 0 ? void 0 : gallery[0] : media === null || media === void 0 ? void 0 : media[0];
  var mediaSecond = isViewed && gallery ? gallery === null || gallery === void 0 ? void 0 : gallery[1] : media === null || media === void 0 ? void 0 : media[1];
  var hasImage = !!(mediaFirst !== null && mediaFirst !== void 0 && mediaFirst.x2);
  var googleSnippetFirst = googleSnippets && googleSnippets.x2 ? googleSnippets : null;
  var pictureClasses = {
    loaded: (ProductCard_module_default()).loaded,
    error: (ProductCard_module_default()).error
  };
  var inStock = stockQuantity !== 0;

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'product',
    value: (_model$slug = model === null || model === void 0 ? void 0 : model.slug) !== null && _model$slug !== void 0 ? _model$slug : initialSlug
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
      linkHref = _getLinkProps2[0],
      linkAs = _getLinkProps2[1];

  var colorDeps = (0,react.useMemo)(function () {
    return dependencies && dependencies.length ? dependencies : [];
  }, [slug, dependencies]);
  var hasColorDeps = (0,react.useMemo)(function () {
    return (colorDeps === null || colorDeps === void 0 ? void 0 : colorDeps.length) > 0;
  }, [colorDeps]);

  var _ref2 = images_info || {},
      _ref2$alt = _ref2.alt,
      imageAlt = _ref2$alt === void 0 ? '' : _ref2$alt,
      _ref2$title = _ref2.title,
      imageTitle = _ref2$title === void 0 ? '' : _ref2$title;

  var AddToCartButton = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (ProductCard_module_default()).cartBtnContiner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AddToCart, {
        productId: external_id !== null && external_id !== void 0 ? external_id : model.slug,
        onSuccess: function onSuccess() {
          var product = activeProductData || {};
          Ecommerce/* default.viewItemList */.ZP.viewItemList([ProductCard_objectSpread(ProductCard_objectSpread({}, product), {}, {
            quantity: 1
          })], currency, 'Каталог товаров: Избранное', 'add_to_cart', indexCard);
        },
        inStock: inStock,
        bucketSmall: true,
        productInfo: {
          pageName: 'Каталог товаров: Избранное',
          indexCard: indexCard
        },
        buttonProps: {
          classNames: {
            general: (ProductCard_module_default()).cartBtn
          },
          disabled: !!(isWishlist && stockQuantity === 0)
        }
      })
    });
  }, [colorDeps, slug, activeProductData, stockQuantity, isWishlist, currency]);
  var BucketBlock = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      role: "tab",
      tabIndex: 0,
      className: (ProductCard_module_default()).buttonsContainer,
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      children: [AddToCartButton, /*#__PURE__*/(0,jsx_runtime.jsx)(wishlistBtn, {
        product: props,
        large: false,
        border: true,
        getWishlist: isWishlist ? getWishlist : null,
        index: indexCard
      })]
    });
  }, [AddToCartButton, stockQuantity, isWishlist, props]);
  var ParamsBlock = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: (0,clsx_m/* default */.Z)((0,defineProperty/* default */.Z)({}, (ProductCard_module_default()).empty, !inStock), (ProductCard_module_default()).params),
      children: [!!(switchable_attributes !== null && switchable_attributes !== void 0 && switchable_attributes.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (ProductCard_module_default()).attributes,
        children: switchable_attributes.map(function (_ref3) {
          var attribute = _ref3.attribute,
              value = _ref3.value;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
            className: (ProductCard_module_default()).attribute,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("dt", {
              children: [attribute, ":"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
              children: value
            })]
          }, value);
        })
      }), isCheckout && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (ProductCard_module_default()).quantity,
        children: [" ", quantity, " \u0448\u0442. "]
      })]
    });
  }, [inStock, switchable_attributes, quantity, isCheckout]);
  var cardClick = (0,react.useCallback)(function () {
    if (pageName && true) {
      setProductInfo({
        pageName: pageName,
        indexCard: indexCard
      });
    }
  }, [pageName, indexCard]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: (0,clsx_m/* default */.Z)((ProductCard_module_default()).main, isCheckout && (ProductCard_module_default()).checkoutMain),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (ProductCard_module_default()).click,
      onClick: cardClick,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(activeLink, {
        href: {
          pathname: linkHref,
          query: isWishlist ? {
            variant: external_id
          } : null
        },
        as: {
          pathname: linkAs
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          className: (0,clsx_m/* default */.Z)((_clsx2 = {}, (0,defineProperty/* default */.Z)(_clsx2, (ProductCard_module_default()).isCatalog, isCatalog), (0,defineProperty/* default */.Z)(_clsx2, (ProductCard_module_default()).isCheckout, isCheckout), (0,defineProperty/* default */.Z)(_clsx2, (ProductCard_module_default()).isMini, isMini), (0,defineProperty/* default */.Z)(_clsx2, (ProductCard_module_default()).outOfStock, !inStock), _clsx2), (ProductCard_module_default()).cardWrapper, isLast && (ProductCard_module_default()).lastCardWrapper),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
            className: (ProductCard_module_default()).header,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              "data-product": "ProductCard",
              className: (ProductCard_module_default()).img,
              children: mediaFirst && hasImage ? /*#__PURE__*/(0,jsx_runtime.jsx)(lazyPicture, {
                classes: pictureClasses,
                data: mediaFirst,
                snippet: !isSafari ? googleSnippetFirst : null,
                alt: imageAlt ? "".concat(imageAlt, " | \u0424\u043E\u0442\u043E 1") : 'Фото 1',
                title: imageTitle,
                isSafari: isSafari
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (0,clsx_m/* default */.Z)((ProductCard_module_default()).loaded, (ProductCard_module_default()).template),
                src: "/images/svg/pattern-order-picture.svg",
                alt: imageAlt ? "".concat(imageAlt, " | \u0424\u043E\u0442\u043E 1") : 'Фото 1'
              })
            }), mediaSecond && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (0,clsx_m/* default */.Z)((ProductCard_module_default()).img, (ProductCard_module_default()).hovered),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(lazyPicture, {
                classes: pictureClasses,
                data: mediaSecond,
                noImageOnTouch: true,
                alt: imageAlt ? "".concat(imageAlt, " | \u0424\u043E\u0442\u043E 2") : 'Фото 2',
                title: imageTitle,
                isSafari: isSafari
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (ProductCard_module_default()).signs,
              children: !(isCheckout || isMini) && !!(features !== null && features !== void 0 && features.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: (ProductCard_module_default()).featureList,
                children: features // .sort((a, b) => (Number(a.priority) > Number(b.priority) ? -1 : 1))
                .map(function (_ref4, ind) {
                  var id = _ref4.id,
                      type = _ref4.type,
                      label = _ref4.label,
                      text = _ref4.text,
                      is_catalog = _ref4.is_catalog;
                  return is_catalog ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (ProductCard_module_default()).item,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(productFeature, {
                      title: label,
                      styledType: type,
                      text: text
                    })
                  }, id || ind) : null;
                })
              })
            }), isCatalog && /*#__PURE__*/(0,jsx_runtime.jsx)(wishlistBtn, {
              product: props,
              large: false,
              border: true,
              isCatalog: true,
              index: indexCard,
              getWishlist: isWishlist ? getWishlist : null
            })]
          }), !(isViewed || isMini) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (ProductCard_module_default()).desc,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (ProductCard_module_default()).seoLink,
                itemProp: "name",
                children: [brand && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (ProductCard_module_default()).brand,
                  children: brand
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (0,clsx_m/* default */.Z)((0,defineProperty/* default */.Z)({}, (ProductCard_module_default()).titleLimit, titleLimit), (ProductCard_module_default()).title),
                  children: name
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: inStock ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: !isLook && (ProductCard_module_default()).rowWrap,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: (0,clsx_m/* default */.Z)((0,defineProperty/* default */.Z)({}, (ProductCard_module_default()).singleCell, !price_diff_percent), (ProductCard_module_default()).price),
                    itemProp: "offers",
                    itemType: "https://schema.org/Offer",
                    itemScope: true,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
                      itemProp: "url",
                      href: linkAs
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
                      itemProp: "availability",
                      content: "https://schema.org/InStock"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
                      itemProp: "priceCurrency",
                      content: "BYN"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
                      itemProp: "price",
                      content: price
                    }), !!price_diff_percent && /*#__PURE__*/(0,jsx_runtime.jsx)(productFeature, {
                      title: "".concat(price_diff_percent, "%"),
                      styledType: "sale"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_price, {
                      price: price,
                      oldPrice: old_price,
                      mod: "product-card",
                      isCatalog: isCatalog,
                      isCheckout: isCheckout,
                      isLook: isLook,
                      oldPriceReason: old_price_reason,
                      priceDiscount: discount,
                      isCollection: isCollection,
                      isProductSlider: isProductSlider,
                      isWishlist: isWishlist
                    })]
                  })
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (ProductCard_module_default()).empty,
                  children: "\u041D\u0435\u0442 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438"
                })
              }), isCheckout && ParamsBlock]
            }), (isCatalog || isWishlist) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (ProductCard_module_default()).moveable,
              children: [hasColorDeps && /*#__PURE__*/(0,jsx_runtime.jsx)(components_TextVariants, {
                variants: colorDeps
              }), size.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (ProductCard_module_default()).wishlistSize,
                children: size
              }), isDesktop && isWishlist && BucketBlock]
            })]
          })]
        })
      })
    }), isWishlist && !isDesktop && BucketBlock]
  });
};

/* harmony default export */ var productCard_ProductCard = (ProductCard_ProductCard);
;// CONCATENATED MODULE: ./components/productCard/index.js

/* harmony default export */ var productCard = (productCard_ProductCard);
// EXTERNAL MODULE: ./components/productFeature/ProductFeature.module.scss
var ProductFeature_module = __webpack_require__(5705);
var ProductFeature_module_default = /*#__PURE__*/__webpack_require__.n(ProductFeature_module);
;// CONCATENATED MODULE: ./components/productFeature/ProductFeature.js









var ProductFeature_PurpleTippy = (0,styled_components_browser_esm/* default */.ZP)(tippy_react_esm/* default */.ZP).withConfig({
  displayName: "ProductFeature__PurpleTippy",
  componentId: "sc-pn0k8m-0"
})([".tippy-arrow{width:16px;height:16px;}&[data-placement^='bottom'] > .tippy-arrow{top:-12px;border-bottom:11px solid white;border-top:none;}"]);
var ProductFeature_mobileBreakPoint = vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile;
var style = {
  color: '#585858',
  backgroundColor: 'white',
  whiteSpace: 'pre-wrap',
  boxShadow: '0px 6px 20px rgb(0 0 0 / 8%)',
  borderRadius: 18,
  padding: '12px 15px',
  ':after': {
    content: '',
    color: 'red',
    backgroundColor: 'red',
    borderTop: '10px solid red',
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent'
  }
};

var ProductFeature = function ProductFeature(_ref) {
  var title = _ref.title,
      styledType = _ref.styledType,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text;
  var windowWidth = (0,useWindowWidth/* default */.Z)();

  var _useState = (0,react.useState)(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var show = function show() {
    return setVisible(true);
  };

  var hide = function hide() {
    return setVisible(false);
  };

  var handleClick = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    e.preventDefault();
    show();
  }, []);
  (0,react.useEffect)(function () {
    if (windowWidth < ProductFeature_mobileBreakPoint) {
      document.addEventListener('touchstart', hide);
      return function () {
        document.removeEventListener('touchstart', hide);
      };
    }
  }, [windowWidth]);
  var content = (0,react.useCallback)(function (isMobile) {
    var _clsx;

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (ProductFeature_module_default()).text, styledType === 'text'), (0,defineProperty/* default */.Z)(_clsx, (ProductFeature_module_default())["new"], styledType === 'new'), (0,defineProperty/* default */.Z)(_clsx, (ProductFeature_module_default()).sale, styledType === 'sale'), (0,defineProperty/* default */.Z)(_clsx, (ProductFeature_module_default()).alternative, styledType === 'alternative'), (0,defineProperty/* default */.Z)(_clsx, (ProductFeature_module_default()).city, styledType === 'cities'), (0,defineProperty/* default */.Z)(_clsx, (ProductFeature_module_default()).accent, styledType === 'accent'), _clsx), (ProductFeature_module_default()).productFeature),
      onClick: isMobile ? handleClick : null,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (ProductFeature_module_default()).title,
        children: title
      })
    });
  }, [title, styledType, handleClick]);

  if (!text || text.length === 0) {
    return content();
  }

  return windowWidth > ProductFeature_mobileBreakPoint ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProductFeature_PurpleTippy, {
    content: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: style,
      children: text
    }),
    children: content(false)
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProductFeature_PurpleTippy, {
    visible: visible,
    onClickOutside: hide,
    content: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: style,
      children: text
    }),
    children: content(true)
  });
};

/* harmony default export */ var productFeature_ProductFeature = (ProductFeature);
;// CONCATENATED MODULE: ./components/productFeature/index.js

/* harmony default export */ var productFeature = (productFeature_ProductFeature);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/types.js
const MODULE_CAROUSEL = "carousel";
const MODULE_CONTROLLER = "controller";
const MODULE_NAVIGATION = "navigation";
const MODULE_NO_SCROLL = "no-scroll";
const MODULE_PORTAL = "portal";
const MODULE_ROOT = "root";
const MODULE_TOOLBAR = "toolbar";
const PLUGIN_CAPTIONS = "captions";
const PLUGIN_COUNTER = "counter";
const PLUGIN_DOWNLOAD = "download";
const PLUGIN_FULLSCREEN = "fullscreen";
const PLUGIN_INLINE = "inline";
const PLUGIN_SHARE = "share";
const PLUGIN_SLIDESHOW = "slideshow";
const PLUGIN_THUMBNAILS = "thumbnails";
const PLUGIN_ZOOM = "zoom";
const SLIDE_STATUS_LOADING = "loading";
const SLIDE_STATUS_PLAYING = "playing";
const SLIDE_STATUS_ERROR = "error";
const SLIDE_STATUS_COMPLETE = "complete";
const SLIDE_STATUS_PLACEHOLDER = "placeholder";
const activeSlideStatus = (status) => `active-slide-${status}`;
const ACTIVE_SLIDE_LOADING = activeSlideStatus(SLIDE_STATUS_LOADING);
const ACTIVE_SLIDE_PLAYING = activeSlideStatus(SLIDE_STATUS_PLAYING);
const ACTIVE_SLIDE_ERROR = activeSlideStatus(SLIDE_STATUS_ERROR);
const ACTIVE_SLIDE_COMPLETE = activeSlideStatus(SLIDE_STATUS_COMPLETE);
const CLASS_FULLSIZE = "fullsize";
const CLASS_FLEX_CENTER = "flex_center";
const CLASS_NO_SCROLL = "no_scroll";
const CLASS_NO_SCROLL_PADDING = "no_scroll_padding";
const ACTION_PREV = "prev";
const ACTION_NEXT = "next";
const ACTION_SWIPE = "swipe";
const ACTION_CLOSE = "close";
const EVENT_ON_POINTER_DOWN = "onPointerDown";
const EVENT_ON_POINTER_MOVE = "onPointerMove";
const EVENT_ON_POINTER_UP = "onPointerUp";
const EVENT_ON_POINTER_LEAVE = "onPointerLeave";
const EVENT_ON_POINTER_CANCEL = "onPointerCancel";
const EVENT_ON_KEY_DOWN = "onKeyDown";
const EVENT_ON_KEY_UP = "onKeyUp";
const EVENT_ON_WHEEL = "onWheel";
const VK_ESCAPE = "Escape";
const VK_ARROW_LEFT = "ArrowLeft";
const VK_ARROW_RIGHT = "ArrowRight";
const ELEMENT_BUTTON = "button";
const ELEMENT_ICON = "icon";
const IMAGE_FIT_CONTAIN = "contain";
const IMAGE_FIT_COVER = "cover";
const UNKNOWN_ACTION_TYPE = "Unknown action type";



;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/index.js
'use client';





const LightboxDefaultProps = {
    open: false,
    close: () => { },
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: { buttons: [ACTION_CLOSE] },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out",
        },
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: IMAGE_FIT_CONTAIN,
        imageProps: {},
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullDown: false,
        closeOnBackdropClick: false,
    },
    portal: {},
    on: {},
    styles: {},
    className: "",
};

function createModule(name, component) {
    return { name, component };
}
function createNode(module, children) {
    return { module, children };
}
function traverseNode(node, target, apply) {
    if (node.module.name === target) {
        return apply(node);
    }
    if (node.children) {
        return [
            createNode(node.module, node.children.flatMap((n) => { var _a; return (_a = traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : []; })),
        ];
    }
    return [node];
}
function traverse(nodes, target, apply) {
    return nodes.flatMap((node) => { var _a; return (_a = traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : []; });
}
function withPlugins(root, plugins = [], augmentations = []) {
    let config = root;
    const contains = (target) => {
        const nodes = [...config];
        while (nodes.length > 0) {
            const node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target)
                return true;
            if (node === null || node === void 0 ? void 0 : node.children)
                nodes.push(...node.children);
        }
        return false;
    };
    const addParent = (target, module) => {
        if (target === "") {
            config = [createNode(module, config)];
            return;
        }
        config = traverse(config, target, (node) => [createNode(module, [node])]);
    };
    const append = (target, module) => {
        config = traverse(config, target, (node) => [createNode(node.module, [createNode(module, node.children)])]);
    };
    const addChild = (target, module, precede) => {
        config = traverse(config, target, (node) => {
            var _a;
            return [
                createNode(node.module, [
                    ...(precede ? [createNode(module)] : []),
                    ...((_a = node.children) !== null && _a !== void 0 ? _a : []),
                    ...(!precede ? [createNode(module)] : []),
                ]),
            ];
        });
    };
    const addSibling = (target, module, precede) => {
        config = traverse(config, target, (node) => [
            ...(precede ? [createNode(module)] : []),
            node,
            ...(!precede ? [createNode(module)] : []),
        ]);
    };
    const addModule = (module) => {
        append(MODULE_CONTROLLER, module);
    };
    const replace = (target, module) => {
        config = traverse(config, target, (node) => [createNode(module, node.children)]);
    };
    const remove = (target) => {
        config = traverse(config, target, (node) => node.children);
    };
    const augment = (augmentation) => {
        augmentations.push(augmentation);
    };
    plugins.forEach((plugin) => {
        plugin({
            contains,
            addParent,
            append,
            addChild,
            addSibling,
            addModule,
            replace,
            remove,
            augment,
        });
    });
    return {
        config,
        augmentation: (props) => augmentations.reduce((acc, augmentation) => augmentation(acc), props),
    };
}

const clsx = (...classes) => [...classes].filter((cls) => Boolean(cls)).join(" ");
const cssPrefix$3 = "yarl__";
const cssClass = (name) => `${cssPrefix$3}${name}`;
const cssVar = (name) => `--${cssPrefix$3}${name}`;
const composePrefix = (base, prefix) => `${base}${prefix ? `_${prefix}` : ""}`;
const makeComposePrefix = (base) => (prefix) => composePrefix(base, prefix);
const label = (labels, lbl) => (labels && labels[lbl] ? labels[lbl] : lbl);
const cleanup = (...cleaners) => () => {
    cleaners.forEach((cleaner) => {
        cleaner();
    });
};
const makeUseContext = (name, contextName, context) => () => {
    const ctx = react.useContext(context);
    if (!ctx) {
        throw new Error(`${name} must be used within a ${contextName}.Provider`);
    }
    return ctx;
};
const hasWindow = () => typeof window !== "undefined";
function round(value, decimals = 0) {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
const isImageSlide = (slide) => slide.type === undefined || slide.type === "image";
const isImageFitCover = (image, imageFit) => image.imageFit === IMAGE_FIT_COVER || (image.imageFit !== IMAGE_FIT_CONTAIN && imageFit === IMAGE_FIT_COVER);
function parseLengthPercentage(input) {
    if (typeof input === "number") {
        return { pixel: input };
    }
    if (typeof input === "string") {
        const value = parseInt(input, 10);
        return input.endsWith("%") ? { percent: value } : { pixel: value };
    }
    return { pixel: 0 };
}
function computeSlideRect(containerRect, padding) {
    const paddingValue = parseLengthPercentage(padding);
    const paddingPixels = paddingValue.percent !== undefined ? (containerRect.width / 100) * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0),
    };
}
const devicePixelRatio = () => (hasWindow() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
const getSlideIndex = (index, slidesCount) => slidesCount > 0 ? ((index % slidesCount) + slidesCount) % slidesCount : 0;
const hasSlides = (slides) => slides.length > 0;
const getSlide = (slides, index) => slides[getSlideIndex(index, slides.length)];
const getSlideIfPresent = (slides, index) => hasSlides(slides) ? getSlide(slides, index) : undefined;
function addToolbarButton(toolbar, key, button) {
    if (!button)
        return toolbar;
    const { buttons, ...restToolbar } = toolbar;
    const index = buttons.findIndex((item) => item === key);
    const buttonWithKey = react.isValidElement(button) ? react.cloneElement(button, { key }, null) : button;
    if (index >= 0) {
        const result = [...buttons];
        result.splice(index, 1, buttonWithKey);
        return { buttons: result, ...restToolbar };
    }
    return { buttons: [buttonWithKey, ...buttons], ...restToolbar };
}
function stopNavigationEventsPropagation() {
    const stopPropagation = (event) => {
        event.stopPropagation();
    };
    return { onPointerDown: stopPropagation, onKeyDown: stopPropagation, onWheel: stopPropagation };
}
function calculatePreload(carousel, slides, minimum = 0) {
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}

const EventsContext = react.createContext(null);
const useEvents = makeUseContext("useEvents", "EventsContext", EventsContext);
function EventsProvider({ children }) {
    const [subscriptions] = react.useState({});
    react.useEffect(() => () => {
        Object.keys(subscriptions).forEach((topic) => delete subscriptions[topic]);
    }, [subscriptions]);
    const context = react.useMemo(() => {
        const unsubscribe = (topic, callback) => {
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 ? void 0 : _a.splice(0, subscriptions[topic].length, ...subscriptions[topic].filter((cb) => cb !== callback));
        };
        const subscribe = (topic, callback) => {
            if (!subscriptions[topic]) {
                subscriptions[topic] = [];
            }
            subscriptions[topic].push(callback);
            return () => unsubscribe(topic, callback);
        };
        const publish = (...[topic, event]) => {
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 ? void 0 : _a.forEach((callback) => callback(event));
        };
        return { publish, subscribe, unsubscribe };
    }, [subscriptions]);
    return react.createElement(EventsContext.Provider, { value: context }, children);
}

const LightboxPropsContext = react.createContext(null);
const useLightboxProps = makeUseContext("useLightboxProps", "LightboxPropsContext", LightboxPropsContext);
function LightboxPropsProvider({ children, ...props }) {
    return react.createElement(LightboxPropsContext.Provider, { value: props }, children);
}

const LightboxStateContext = react.createContext(null);
const useLightboxState = makeUseContext("useLightboxState", "LightboxStateContext", LightboxStateContext);
const LightboxDispatchContext = react.createContext(null);
const useLightboxDispatch = makeUseContext("useLightboxDispatch", "LightboxDispatchContext", LightboxDispatchContext);
function reducer(state, action) {
    switch (action.type) {
        case "swipe": {
            const { slides } = state;
            const increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
            const globalIndex = state.globalIndex + increment;
            const currentIndex = getSlideIndex(globalIndex, slides.length);
            const currentSlide = getSlideIfPresent(slides, currentIndex);
            const animation = increment || action.duration
                ? {
                    increment,
                    duration: action.duration,
                    easing: action.easing,
                }
                : undefined;
            return { slides, currentIndex, globalIndex, currentSlide, animation };
        }
        case "update":
            return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: getSlideIfPresent(action.slides, action.index),
            };
        default:
            throw new Error(UNKNOWN_ACTION_TYPE);
    }
}
function LightboxStateProvider({ slides, index, children }) {
    const [state, dispatch] = react.useReducer(reducer, {
        slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: getSlideIfPresent(slides, index),
    });
    react.useEffect(() => {
        dispatch({ type: "update", slides, index });
    }, [slides, index]);
    const context = react.useMemo(() => ({ ...state, state, dispatch }), [state, dispatch]);
    return (react.createElement(LightboxDispatchContext.Provider, { value: dispatch },
        react.createElement(LightboxStateContext.Provider, { value: context }, children)));
}

const TimeoutsContext = react.createContext(null);
const useTimeouts = makeUseContext("useTimeouts", "TimeoutsContext", TimeoutsContext);
function TimeoutsProvider({ children }) {
    const [timeouts] = react.useState([]);
    react.useEffect(() => () => {
        timeouts.forEach((tid) => window.clearTimeout(tid));
        timeouts.splice(0, timeouts.length);
    }, [timeouts]);
    const context = react.useMemo(() => {
        const removeTimeout = (id) => {
            timeouts.splice(0, timeouts.length, ...timeouts.filter((tid) => tid !== id));
        };
        const setTimeout = (fn, delay) => {
            const id = window.setTimeout(() => {
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        const clearTimeout = (id) => {
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return { setTimeout, clearTimeout };
    }, [timeouts]);
    return react.createElement(TimeoutsContext.Provider, { value: context }, children);
}

const IconButton = react.forwardRef(function IconButton({ label: label$1, className, icon: Icon, renderIcon, onClick, style, ...rest }, ref) {
    const { styles, labels } = useLightboxProps();
    return (react.createElement("button", { ref: ref, type: "button", "aria-label": label(labels, label$1), className: clsx(cssClass(ELEMENT_BUTTON), className), onClick: onClick, style: { ...style, ...styles.button }, ...rest }, renderIcon ? renderIcon() : react.createElement(Icon, { className: cssClass(ELEMENT_ICON), style: styles.icon })));
});

function svgIcon(name, children) {
    const icon = (props) => (react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": "true", focusable: "false", ...props }, children));
    icon.displayName = name;
    return icon;
}
function createIcon(name, glyph) {
    return svgIcon(name, react.createElement("g", { fill: "currentColor" },
        react.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
        glyph));
}
function createIconDisabled(name, glyph) {
    return svgIcon(name, react.createElement(react.Fragment, null,
        react.createElement("defs", null,
            react.createElement("mask", { id: "strike" },
                react.createElement("path", { d: "M0 0h24v24H0z", fill: "white" }),
                react.createElement("path", { d: "M0 0L24 24", stroke: "black", strokeWidth: 4 }))),
        react.createElement("path", { d: "M0.70707 2.121320L21.878680 23.292883", stroke: "currentColor", strokeWidth: 2 }),
        react.createElement("g", { fill: "currentColor", mask: "url(#strike)" },
            react.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
            glyph)));
}
const CloseIcon = createIcon("Close", react.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }));
const PreviousIcon = createIcon("Previous", react.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }));
const NextIcon = createIcon("Next", react.createElement("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }));
const LoadingIcon = createIcon("Loading", react.createElement(react.Fragment, null, Array.from({ length: 8 }).map((_, index, array) => (react.createElement("line", { key: index, x1: "12", y1: "6.5", x2: "12", y2: "1.8", strokeLinecap: "round", strokeWidth: "2.6", stroke: "currentColor", strokeOpacity: (1 / array.length) * (index + 1), transform: `rotate(${(360 / array.length) * index}, 12, 12)` })))));
const ErrorIcon = createIcon("Error", react.createElement("path", { d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z" }));

const useLayoutEffect = hasWindow() ? react.useLayoutEffect : react.useEffect;

function useMotionPreference() {
    const [reduceMotion, setReduceMotion] = react.useState(false);
    react.useEffect(() => {
        var _a, _b;
        const mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        const listener = (event) => setReduceMotion(event.matches);
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 ? void 0 : _b.call(mediaQuery, "change", listener);
        return () => { var _a; return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener); };
    }, []);
    return reduceMotion;
}

function currentTransformation(node) {
    let x = 0;
    let y = 0;
    let z = 0;
    const matrix = window.getComputedStyle(node).transform;
    const matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        const values = matcher[1].split(",").map((str) => Number.parseInt(str, 10));
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        }
        else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return { x, y, z };
}
function useAnimation(nodeRef, computeAnimation) {
    const snapshot = react.useRef();
    const animation = react.useRef();
    const reduceMotion = useMotionPreference();
    useLayoutEffect(() => {
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            const { keyframes, duration, easing, onfinish } = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), currentTransformation(nodeRef.current)) || {};
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 ? void 0 : _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, { duration, easing });
                }
                catch (err) {
                    console.error(err);
                }
                if (animation.current) {
                    animation.current.onfinish = () => {
                        animation.current = undefined;
                        onfinish === null || onfinish === void 0 ? void 0 : onfinish();
                    };
                }
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: (currentSnapshot) => {
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: () => { var _a; return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running"; },
    };
}

function useContainerRect() {
    const [containerRect, setContainerRect] = react.useState();
    const containerRef = react.useRef(null);
    const observerRef = react.useRef();
    const setContainerRef = react.useCallback((node) => {
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        const updateContainerRect = () => {
            if (node) {
                const styles = window.getComputedStyle(node);
                const parse = (value) => parseFloat(value) || 0;
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom)),
                });
            }
            else {
                setContainerRect(undefined);
            }
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return react.useMemo(() => ({
        setContainerRef,
        containerRef,
        containerRect,
    }), [setContainerRef, containerRef, containerRect]);
}

function useDelay() {
    const timeoutId = react.useRef();
    const { setTimeout, clearTimeout } = useTimeouts();
    return react.useCallback((callback, delay) => {
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [setTimeout, clearTimeout]);
}

function useEventCallback(fn) {
    const ref = react.useRef(fn);
    useLayoutEffect(() => {
        ref.current = fn;
    });
    return react.useCallback((...args) => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args); }, []);
}

function setRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
}
function useForkRef(refA, refB) {
    return react.useMemo(() => refA == null && refB == null
        ? null
        : (refValue) => {
            setRef(refA, refValue);
            setRef(refB, refValue);
        }, [refA, refB]);
}

function useLoseFocus(focus, disabled = false) {
    const focused = react.useRef();
    useLayoutEffect(() => {
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [disabled, focus]);
    const onFocus = react.useCallback(() => {
        focused.current = true;
    }, []);
    const onBlur = react.useCallback(() => {
        focused.current = false;
    }, []);
    return { onFocus, onBlur };
}

function useRTL() {
    const [isRTL, setIsRTL] = react.useState(false);
    useLayoutEffect(() => {
        setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
    }, []);
    return isRTL;
}

function useSensors() {
    const [subscribers] = react.useState({});
    return react.useMemo(() => {
        const notifySubscribers = (type, event) => {
            var _a;
            (_a = subscribers[type]) === null || _a === void 0 ? void 0 : _a.forEach((listener) => {
                if (!event.isPropagationStopped())
                    listener(event);
            });
        };
        return {
            registerSensors: {
                onPointerDown: (event) => notifySubscribers(EVENT_ON_POINTER_DOWN, event),
                onPointerMove: (event) => notifySubscribers(EVENT_ON_POINTER_MOVE, event),
                onPointerUp: (event) => notifySubscribers(EVENT_ON_POINTER_UP, event),
                onPointerLeave: (event) => notifySubscribers(EVENT_ON_POINTER_LEAVE, event),
                onPointerCancel: (event) => notifySubscribers(EVENT_ON_POINTER_CANCEL, event),
                onKeyDown: (event) => notifySubscribers(EVENT_ON_KEY_DOWN, event),
                onKeyUp: (event) => notifySubscribers(EVENT_ON_KEY_UP, event),
                onWheel: (event) => notifySubscribers(EVENT_ON_WHEEL, event),
            },
            subscribeSensors: (type, callback) => {
                if (!subscribers[type]) {
                    subscribers[type] = [];
                }
                subscribers[type].unshift(callback);
                return () => {
                    const listeners = subscribers[type];
                    if (listeners) {
                        listeners.splice(0, listeners.length, ...listeners.filter((el) => el !== callback));
                    }
                };
            },
        };
    }, [subscribers]);
}

function useThrottle(callback, delay) {
    const lastCallbackTime = react.useRef(0);
    const delayCallback = useDelay();
    const executeCallback = useEventCallback((...args) => {
        lastCallbackTime.current = Date.now();
        callback(args);
    });
    return react.useCallback((...args) => {
        delayCallback(() => {
            executeCallback(args);
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [delay, executeCallback, delayCallback]);
}

const slidePrefix = makeComposePrefix("slide");
const slideImagePrefix = makeComposePrefix("slide_image");
function ImageSlide({ slide: image, offset, render, rect, imageFit, imageProps, onClick, onLoad, style, }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const [status, setStatus] = react.useState(SLIDE_STATUS_LOADING);
    const { publish } = useEvents();
    const { setTimeout } = useTimeouts();
    const imageRef = react.useRef(null);
    react.useEffect(() => {
        if (offset === 0) {
            publish(activeSlideStatus(status));
        }
    }, [offset, status, publish]);
    const handleLoading = useEventCallback((img) => {
        ("decode" in img ? img.decode() : Promise.resolve())
            .catch(() => { })
            .then(() => {
            if (!img.parentNode) {
                return;
            }
            setStatus(SLIDE_STATUS_COMPLETE);
            setTimeout(() => {
                onLoad === null || onLoad === void 0 ? void 0 : onLoad(img);
            }, 0);
        });
    });
    const setImageRef = react.useCallback((img) => {
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) {
            handleLoading(img);
        }
    }, [handleLoading]);
    const handleOnLoad = react.useCallback((event) => {
        handleLoading(event.currentTarget);
    }, [handleLoading]);
    const onError = react.useCallback(() => {
        setStatus(SLIDE_STATUS_ERROR);
    }, []);
    const cover = isImageFitCover(image, imageFit);
    const nonInfinite = (value, fallback) => (Number.isFinite(value) ? value : fallback);
    const maxWidth = nonInfinite(Math.max(...((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map((x) => x.width)) !== null && _b !== void 0 ? _b : []).concat(image.width ? [image.width] : []).filter(Boolean)), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    const maxHeight = nonInfinite(Math.max(...((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map((x) => x.height)) !== null && _e !== void 0 ? _e : []).concat(image.height ? [image.height] : []).filter(Boolean)), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    const defaultStyle = maxWidth && maxHeight
        ? {
            maxWidth: `min(${maxWidth}px, 100%)`,
            maxHeight: `min(${maxHeight}px, 100%)`,
        }
        : {
            maxWidth: "100%",
            maxHeight: "100%",
        };
    const srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort((a, b) => a.width - b.width).map((item) => `${item.src} ${item.width}w`).join(", ");
    const estimateActualWidth = () => rect && !cover && image.width && image.height ? (rect.height / image.height) * image.width : Number.MAX_VALUE;
    const sizes = srcSet && rect && hasWindow() ? `${Math.round(Math.min(estimateActualWidth(), rect.width))}px` : undefined;
    const { style: imagePropsStyle, className: imagePropsClassName, ...restImageProps } = imageProps || {};
    return (react.createElement(react.Fragment, null,
        react.createElement("img", { ref: setImageRef, onLoad: handleOnLoad, onError: onError, onClick: onClick, draggable: false, className: clsx(cssClass(slideImagePrefix()), cover && cssClass(slideImagePrefix("cover")), status !== SLIDE_STATUS_COMPLETE && cssClass(slideImagePrefix("loading")), imagePropsClassName), style: { ...defaultStyle, ...style, ...imagePropsStyle }, ...restImageProps, alt: image.alt, sizes: sizes, srcSet: srcSet, src: image.src }),
        status !== SLIDE_STATUS_COMPLETE && (react.createElement("div", { className: cssClass(slidePrefix(SLIDE_STATUS_PLACEHOLDER)) },
            status === SLIDE_STATUS_LOADING &&
                ((render === null || render === void 0 ? void 0 : render.iconLoading) ? (render.iconLoading()) : (react.createElement(LoadingIcon, { className: clsx(cssClass(ELEMENT_ICON), cssClass(slidePrefix(SLIDE_STATUS_LOADING))) }))),
            status === SLIDE_STATUS_ERROR &&
                ((render === null || render === void 0 ? void 0 : render.iconError) ? (render.iconError()) : (react.createElement(ErrorIcon, { className: clsx(cssClass(ELEMENT_ICON), cssClass(slidePrefix(SLIDE_STATUS_ERROR))) })))))));
}

var SwipeState;
(function (SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL_DOWN"] = 2] = "PULL_DOWN";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})(SwipeState || (SwipeState = {}));

function usePointerEvents(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    react.useEffect(() => {
        if (disabled)
            return () => { };
        return cleanup(subscribeSensors(EVENT_ON_POINTER_DOWN, onPointerDown), subscribeSensors(EVENT_ON_POINTER_MOVE, onPointerMove), subscribeSensors(EVENT_ON_POINTER_UP, onPointerUp), subscribeSensors(EVENT_ON_POINTER_LEAVE, onPointerUp), subscribeSensors(EVENT_ON_POINTER_CANCEL, onPointerUp));
    }, [subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled]);
}

var Gesture;
(function (Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL_DOWN"] = 2] = "PULL_DOWN";
})(Gesture || (Gesture = {}));
const SWIPE_THRESHOLD = 30;
function usePointerSwipe(subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullDownEnabled, onPullDownStart, onPullDownProgress, onPullDownFinish, onPullDownCancel) {
    const offset = react.useRef(0);
    const pointers = react.useRef([]);
    const activePointer = react.useRef();
    const startTime = react.useRef(0);
    const gesture = react.useRef(Gesture.NONE);
    const clearPointer = react.useCallback((event) => {
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = Gesture.NONE;
        }
        const currentPointers = pointers.current;
        currentPointers.splice(0, currentPointers.length, ...currentPointers.filter((p) => p.pointerId !== event.pointerId));
    }, []);
    const addPointer = react.useCallback((event) => {
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [clearPointer]);
    const onPointerDown = useEventCallback((event) => {
        addPointer(event);
    });
    const onPointerUp = useEventCallback((event) => {
        if (pointers.current.find((x) => x.pointerId === event.pointerId) &&
            activePointer.current === event.pointerId) {
            const duration = Date.now() - startTime.current;
            const currentOffset = offset.current;
            if (gesture.current === Gesture.SWIPE) {
                if (Math.abs(currentOffset) > 0.3 * containerWidth ||
                    (Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration)) {
                    onSwipeFinish(currentOffset, duration);
                }
                else {
                    onSwipeCancel(currentOffset);
                }
            }
            else if (gesture.current === Gesture.PULL_DOWN) {
                if (currentOffset > 2 * SWIPE_THRESHOLD) {
                    onPullDownFinish(currentOffset, duration);
                }
                else {
                    onPullDownCancel(currentOffset);
                }
            }
            offset.current = 0;
            gesture.current = Gesture.NONE;
        }
        clearPointer(event);
    });
    const onPointerMove = useEventCallback((event) => {
        const pointer = pointers.current.find((p) => p.pointerId === event.pointerId);
        if (pointer) {
            const isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) {
                    onPointerUp(event);
                }
                else {
                    clearPointer(pointer);
                }
                return;
            }
            const deltaX = event.clientX - pointer.clientX;
            const deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                const startGesture = (newGesture) => {
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    startGesture(Gesture.SWIPE);
                    onSwipeStart();
                }
                else if (pullDownEnabled && Math.abs(deltaY) > Math.abs(deltaX) && deltaY > SWIPE_THRESHOLD) {
                    startGesture(Gesture.PULL_DOWN);
                    onPullDownStart();
                }
            }
            else if (isCurrentPointer) {
                if (gesture.current === Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                }
                else if (gesture.current === Gesture.PULL_DOWN) {
                    offset.current = deltaY;
                    onPullDownProgress(deltaY);
                }
            }
        }
    });
    usePointerEvents(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}

const WHEEL = "wheel";
function preventDefault(event) {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.ctrlKey) {
        event.preventDefault();
    }
}
function usePreventSwipeNavigation() {
    const ref = react.useRef(null);
    return react.useCallback((node) => {
        var _a;
        if (node) {
            node.addEventListener(WHEEL, preventDefault, { passive: false });
        }
        else {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(WHEEL, preventDefault);
        }
        ref.current = node;
    }, []);
}

function useWheelSwipe(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    const offset = react.useRef(0);
    const intent = react.useRef(0);
    const intentCleanup = react.useRef();
    const resetCleanup = react.useRef();
    const wheelResidualMomentum = react.useRef(0);
    const startTime = react.useRef(0);
    const { setTimeout, clearTimeout } = useTimeouts();
    const cancelSwipeIntentCleanup = react.useCallback(() => {
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [clearTimeout]);
    const cancelSwipeResetCleanup = react.useCallback(() => {
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [clearTimeout]);
    const handleCleanup = useEventCallback(() => {
        if (swipeState !== SwipeState.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    react.useEffect(handleCleanup, [swipeState, handleCleanup]);
    const handleCancelSwipe = useEventCallback((currentSwipeOffset) => {
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) {
            onSwipeCancel(offset.current);
        }
    });
    const onWheel = useEventCallback((event) => {
        if (event.ctrlKey) {
            return;
        }
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            return;
        }
        if (swipeState === SwipeState.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelResidualMomentum.current)) {
                wheelResidualMomentum.current = event.deltaX;
                return;
            }
            if (!isSwipeValid(-event.deltaX)) {
                return;
            }
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                wheelResidualMomentum.current = 0;
                startTime.current = Date.now();
                onSwipeStart();
            }
            else {
                const currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(() => {
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) {
                        intent.current = 0;
                    }
                }, swipeAnimationDuration);
            }
        }
        else if (swipeState === SwipeState.SWIPE) {
            let newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                wheelResidualMomentum.current = event.deltaX;
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(() => handleCancelSwipe(newSwipeOffset), 2 * swipeAnimationDuration);
        }
        else {
            wheelResidualMomentum.current = event.deltaX;
        }
    });
    react.useEffect(() => subscribeSensors(EVENT_ON_WHEEL, onWheel), [subscribeSensors, onWheel]);
}

const cssContainerPrefix = makeComposePrefix("container");
const ControllerContext = react.createContext(null);
const useController = makeUseContext("useController", "ControllerContext", ControllerContext);
function Controller({ children, ...props }) {
    var _a;
    const { carousel, animation, controller, on, styles, render } = props;
    const [toolbarWidth, setToolbarWidth] = react.useState();
    const state = useLightboxState();
    const dispatch = useLightboxDispatch();
    const [swipeState, setSwipeState] = react.useState(SwipeState.NONE);
    const swipeOffset = react.useRef(0);
    const pullDownOffset = react.useRef(0);
    const pullDownOpacity = react.useRef(1);
    const { registerSensors, subscribeSensors } = useSensors();
    const { subscribe, publish } = useEvents();
    const cleanupAnimationIncrement = useDelay();
    const cleanupSwipeOffset = useDelay();
    const cleanupPullDownOffset = useDelay();
    const { containerRef, setContainerRef, containerRect } = useContainerRect();
    const handleContainerRef = useForkRef(usePreventSwipeNavigation(), setContainerRef);
    const carouselRef = react.useRef(null);
    const setCarouselRef = useForkRef(carouselRef, undefined);
    const isRTL = useRTL();
    const rtl = (value) => (isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    const focus = useEventCallback(() => { var _a; return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus(); });
    const getLightboxProps = useEventCallback(() => props);
    const getLightboxState = useEventCallback(() => state);
    const prev = react.useCallback((params) => publish(ACTION_PREV, params), [publish]);
    const next = react.useCallback((params) => publish(ACTION_NEXT, params), [publish]);
    const close = react.useCallback(() => publish(ACTION_CLOSE), [publish]);
    const isSwipeValid = (offset) => !(carousel.finite &&
        ((rtl(offset) > 0 && state.currentIndex === 0) ||
            (rtl(offset) < 0 && state.currentIndex === state.slides.length - 1)));
    const setSwipeOffset = (offset) => {
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty(cssVar("swipe_offset"), `${Math.round(offset)}px`);
    };
    const pullDownEnabled = controller.closeOnPullDown;
    const setPullDownOffset = (offset) => {
        var _a, _b;
        pullDownOffset.current = offset;
        pullDownOpacity.current = (() => {
            const threshold = 60;
            const minOpacity = 0.5;
            return Math.min(Math.max(round(1 - (offset / threshold) * (1 - minOpacity), 2), minOpacity), 1);
        })();
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty(cssVar("pull_down_offset"), `${Math.round(offset)}px`);
        (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.style.setProperty(cssVar("pull_down_opacity"), `${pullDownOpacity.current}`);
    };
    const { prepareAnimation: preparePullDownAnimation } = useAnimation(carouselRef, (snapshot, rect, translate) => {
        if (carouselRef.current && containerRect) {
            return {
                keyframes: [
                    {
                        transform: `translate(0, ${snapshot.rect.y - rect.y + translate.y}px)`,
                        opacity: snapshot.opacity,
                    },
                    { transform: "translate(0, 0)", opacity: 1 },
                ],
                duration: snapshot.duration,
                easing: animation.easing.fade,
            };
        }
        return undefined;
    });
    const pullDown = (offset, cancel) => {
        if (pullDownEnabled) {
            setPullDownOffset(offset);
            let duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullDownAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullDownOpacity.current,
                    duration,
                });
            }
            cleanupPullDownOffset(() => {
                setPullDownOffset(0);
                setSwipeState(SwipeState.NONE);
            }, duration);
            setSwipeState(SwipeState.ANIMATION);
            if (!cancel) {
                close();
            }
        }
    };
    const { prepareAnimation, isAnimationPlaying } = useAnimation(carouselRef, (snapshot, rect, translate) => {
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            const parsedSpacing = parseLengthPercentage(carousel.spacing);
            const spacingValue = (parsedSpacing.percent
                ? (parsedSpacing.percent * containerRect.width) / 100
                : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: `translate(${rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) +
                            snapshot.rect.x -
                            rect.x +
                            translate.x}px, 0)`,
                    },
                    { transform: "translate(0, 0)" },
                ],
                duration: state.animation.duration,
                easing: state.animation.easing,
            };
        }
        return undefined;
    });
    const swipe = useEventCallback((action) => {
        var _a, _b;
        const currentSwipeOffset = action.offset || 0;
        const swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        const swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        let { direction } = action;
        const count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        let newSwipeState = SwipeState.ANIMATION;
        let newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            const containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            const elapsedTime = action.duration || 0;
            const expectedTime = containerWidth
                ? (swipeDuration / containerWidth) * Math.abs(currentSwipeOffset)
                : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) {
                    newSwipeAnimationDuration =
                        (newSwipeAnimationDuration / expectedTime) * Math.max(elapsedTime, expectedTime / 5);
                }
                else if (containerWidth) {
                    newSwipeAnimationDuration =
                        (swipeDuration / containerWidth) * (containerWidth - Math.abs(currentSwipeOffset));
                }
                direction = rtl(currentSwipeOffset) > 0 ? ACTION_PREV : ACTION_NEXT;
            }
            else {
                newSwipeAnimationDuration = swipeDuration / 2;
            }
        }
        let increment = 0;
        if (direction === ACTION_PREV) {
            if (isSwipeValid(rtl(1))) {
                increment = -count;
            }
            else {
                newSwipeState = SwipeState.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        else if (direction === ACTION_NEXT) {
            if (isSwipeValid(rtl(-1))) {
                increment = count;
            }
            else {
                newSwipeState = SwipeState.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(() => {
            setSwipeOffset(0);
            setSwipeState(SwipeState.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) {
            prepareAnimation({
                rect: carouselRef.current.getBoundingClientRect(),
                index: state.globalIndex,
            });
        }
        setSwipeState(newSwipeState);
        publish(ACTION_SWIPE, {
            type: "swipe",
            increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing,
        });
    });
    react.useEffect(() => {
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) {
            cleanupAnimationIncrement(() => dispatch({ type: "swipe", increment: 0 }), state.animation.duration);
        }
    }, [state.animation, dispatch, cleanupAnimationIncrement]);
    const swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        () => setSwipeState(SwipeState.SWIPE),
        (offset) => setSwipeOffset(offset),
        (offset, duration) => swipe({ offset, duration, count: 1 }),
        (offset) => swipe({ offset, count: 0 }),
    ];
    const pullDownParams = [
        () => {
            if (pullDownEnabled) {
                setSwipeState(SwipeState.PULL_DOWN);
            }
        },
        (offset) => setPullDownOffset(offset),
        (offset) => pullDown(offset),
        (offset) => pullDown(offset, true),
    ];
    usePointerSwipe(...swipeParams, pullDownEnabled, ...pullDownParams);
    useWheelSwipe(swipeState, ...swipeParams);
    const focusOnMount = useEventCallback(() => {
        var _a;
        if (controller.focus) {
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    });
    react.useEffect(focusOnMount, [focusOnMount]);
    const onViewCallback = useEventCallback(() => {
        var _a;
        (_a = on.view) === null || _a === void 0 ? void 0 : _a.call(on, { index: state.currentIndex });
    });
    react.useEffect(onViewCallback, [state.globalIndex, onViewCallback]);
    react.useEffect(() => cleanup(subscribe(ACTION_PREV, (action) => swipe({ direction: ACTION_PREV, ...action })), subscribe(ACTION_NEXT, (action) => swipe({ direction: ACTION_NEXT, ...action })), subscribe(ACTION_SWIPE, (action) => dispatch(action))), [subscribe, swipe, dispatch]);
    react.useEffect(() => subscribeSensors(EVENT_ON_KEY_UP, (event) => {
        if (event.key === VK_ESCAPE) {
            close();
        }
    }), [subscribeSensors, close]);
    const context = react.useMemo(() => ({
        prev,
        next,
        close,
        focus,
        slideRect: containerRect ? computeSlideRect(containerRect, carousel.padding) : { width: 0, height: 0 },
        containerRect: containerRect || { width: 0, height: 0 },
        subscribeSensors,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
    }), [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding,
    ]);
    react.useImperativeHandle(controller.ref, () => ({
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState,
    }), [prev, next, close, focus, getLightboxProps, getLightboxState]);
    return (react.createElement("div", { ref: handleContainerRef, className: clsx(cssClass(cssContainerPrefix()), cssClass(CLASS_FLEX_CENTER)), style: {
            ...(swipeState === SwipeState.SWIPE
                ? { [cssVar("swipe_offset")]: `${Math.round(swipeOffset.current)}px` }
                : null),
            ...(swipeState === SwipeState.PULL_DOWN
                ? {
                    [cssVar("pull_down_offset")]: `${Math.round(pullDownOffset.current)}px`,
                    [cssVar("pull_down_opacity")]: `${pullDownOpacity.current}`,
                }
                : null),
            ...(controller.touchAction !== "none"
                ? { [cssVar("controller_touch_action")]: controller.touchAction }
                : null),
            ...styles.container,
        }, ...(controller.aria ? { role: "presentation", "aria-live": "polite" } : null), tabIndex: -1, ...registerSensors }, containerRect && (react.createElement(ControllerContext.Provider, { value: context },
        children, (_a = render.controls) === null || _a === void 0 ? void 0 :
        _a.call(render)))));
}
const ControllerModule = createModule(MODULE_CONTROLLER, Controller);

function cssPrefix$2(value) {
    return composePrefix(MODULE_CAROUSEL, value);
}
function cssSlidePrefix(value) {
    return composePrefix("slide", value);
}
function CarouselSlide({ slide, offset }) {
    const containerRef = react.useRef(null);
    const { currentIndex } = useLightboxState();
    const { slideRect, close } = useController();
    const { render, carousel: { imageFit, imageProps }, on: { click: onClick }, controller: { closeOnBackdropClick }, styles: { slide: style }, } = useLightboxProps();
    const renderSlide = () => {
        var _a, _b, _c, _d;
        let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, { slide, offset, rect: slideRect });
        if (!rendered && isImageSlide(slide)) {
            rendered = (react.createElement(ImageSlide, { slide: slide, offset: offset, render: render, rect: slideRect, imageFit: imageFit, imageProps: imageProps, onClick: offset === 0 ? () => onClick === null || onClick === void 0 ? void 0 : onClick({ index: currentIndex }) : undefined }));
        }
        return rendered ? (react.createElement(react.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 :
            _b.call(render, { slide }),
            ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : (({ children }) => children))({ slide, children: rendered }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 :
            _d.call(render, { slide }))) : null;
    };
    const handleBackdropClick = (event) => {
        const container = containerRef.current;
        const target = event.target instanceof HTMLElement ? event.target : undefined;
        if (closeOnBackdropClick &&
            target &&
            container &&
            (target === container ||
                (Array.from(container.children).find((x) => x === target) &&
                    target.classList.contains(cssClass(CLASS_FULLSIZE))))) {
            close();
        }
    };
    return (react.createElement("div", { ref: containerRef, className: clsx(cssClass(cssSlidePrefix()), offset === 0 && cssClass(cssSlidePrefix("current")), cssClass(CLASS_FLEX_CENTER)), onClick: handleBackdropClick, style: style }, renderSlide()));
}
function Placeholder() {
    const style = useLightboxProps().styles.slide;
    return react.createElement("div", { className: cssClass("slide"), style: style });
}
function Carousel({ carousel }) {
    const { slides, currentIndex, globalIndex } = useLightboxState();
    const { setCarouselRef } = useController();
    const spacingValue = parseLengthPercentage(carousel.spacing);
    const paddingValue = parseLengthPercentage(carousel.padding);
    const items = [];
    const preload = calculatePreload(carousel, slides, 1);
    if (hasSlides(slides)) {
        for (let i = currentIndex - preload; i < currentIndex; i += 1) {
            const key = globalIndex + i - currentIndex;
            items.push(!carousel.finite || i >= 0 ? (react.createElement(CarouselSlide, { key: key, slide: slides[(i + preload * slides.length) % slides.length], offset: i - currentIndex })) : (react.createElement(Placeholder, { key: key })));
        }
        items.push(react.createElement(CarouselSlide, { key: globalIndex, slide: slides[currentIndex], offset: 0 }));
        for (let i = currentIndex + 1; i <= currentIndex + preload; i += 1) {
            const key = globalIndex + i - currentIndex;
            items.push(!carousel.finite || i <= slides.length - 1 ? (react.createElement(CarouselSlide, { key: key, slide: slides[i % slides.length], offset: i - currentIndex })) : (react.createElement(Placeholder, { key: key })));
        }
    }
    return (react.createElement("div", { ref: setCarouselRef, className: clsx(cssClass(cssPrefix$2()), items.length > 0 && cssClass(cssPrefix$2("with_slides"))), style: {
            [`${cssVar(cssPrefix$2("slides_count"))}`]: items.length,
            [`${cssVar(cssPrefix$2("spacing_px"))}`]: spacingValue.pixel || 0,
            [`${cssVar(cssPrefix$2("spacing_percent"))}`]: spacingValue.percent || 0,
            [`${cssVar(cssPrefix$2("padding_px"))}`]: paddingValue.pixel || 0,
            [`${cssVar(cssPrefix$2("padding_percent"))}`]: paddingValue.percent || 0,
        } }, items));
}
const CarouselModule = createModule(MODULE_CAROUSEL, Carousel);

function NavigationButton({ label, icon, renderIcon, action, onClick, disabled, style }) {
    return (react.createElement(IconButton, { label: label, icon: icon, renderIcon: renderIcon, className: cssClass(`navigation_${action}`), disabled: disabled, onClick: onClick, style: style, ...useLoseFocus(useController().focus, disabled) }));
}
function Navigation({ carousel: { finite }, animation, render: { buttonPrev, buttonNext, iconPrev, iconNext }, styles, }) {
    var _a;
    const { slides, currentIndex } = useLightboxState();
    const { prev, next, subscribeSensors } = useController();
    const isRTL = useRTL();
    const prevDisabled = slides.length === 0 || (finite && currentIndex === 0);
    const nextDisabled = slides.length === 0 || (finite && currentIndex === slides.length - 1);
    const throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    const prevThrottled = useThrottle(prev, throttle);
    const nextThrottled = useThrottle(next, throttle);
    const handleKeyDown = useEventCallback((event) => {
        if (event.key === VK_ARROW_LEFT && !(isRTL ? nextDisabled : prevDisabled)) {
            (isRTL ? nextThrottled : prevThrottled)();
        }
        if (event.key === VK_ARROW_RIGHT && !(isRTL ? prevDisabled : nextDisabled)) {
            (isRTL ? prevThrottled : nextThrottled)();
        }
    });
    react.useEffect(() => subscribeSensors(EVENT_ON_KEY_DOWN, handleKeyDown), [subscribeSensors, handleKeyDown]);
    return (react.createElement(react.Fragment, null,
        buttonPrev ? (buttonPrev()) : (react.createElement(NavigationButton, { label: "Previous", action: ACTION_PREV, icon: PreviousIcon, renderIcon: iconPrev, style: styles.navigationPrev, disabled: prevDisabled, onClick: prev })),
        buttonNext ? (buttonNext()) : (react.createElement(NavigationButton, { label: "Next", action: ACTION_NEXT, icon: NextIcon, renderIcon: iconNext, style: styles.navigationNext, disabled: nextDisabled, onClick: next }))));
}
const NavigationModule = createModule(MODULE_NAVIGATION, Navigation);

const noScroll = cssClass(CLASS_NO_SCROLL);
const noScrollPadding = cssClass(CLASS_NO_SCROLL_PADDING);
function isHTMLElement(element) {
    return "style" in element;
}
function padScrollbar(element, padding, rtl) {
    const styles = window.getComputedStyle(element);
    const property = rtl ? "padding-left" : "padding-right";
    const computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    const originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, `${(parseInt(computedValue, 10) || 0) + padding}px`);
    return () => {
        if (originalValue) {
            element.style.setProperty(property, originalValue);
        }
        else {
            element.style.removeProperty(property);
        }
    };
}
function NoScroll({ children }) {
    const rtl = useRTL();
    useLayoutEffect(() => {
        const cleanup = [];
        const { body, documentElement } = document;
        const scrollbar = Math.round(window.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push(padScrollbar(body, scrollbar, rtl));
            const elements = body.getElementsByTagName("*");
            for (let i = 0; i < elements.length; i += 1) {
                const element = elements[i];
                if (isHTMLElement(element) &&
                    window.getComputedStyle(element).getPropertyValue("position") === "fixed" &&
                    !element.classList.contains(noScrollPadding)) {
                    cleanup.push(padScrollbar(element, scrollbar, rtl));
                }
            }
        }
        body.classList.add(noScroll);
        return () => {
            body.classList.remove(noScroll);
            cleanup.forEach((clean) => clean());
        };
    }, [rtl]);
    return react.createElement(react.Fragment, null, children);
}
const NoScrollModule = createModule(MODULE_NO_SCROLL, NoScroll);

function cssPrefix$1(value) {
    return composePrefix(MODULE_PORTAL, value);
}
function setAttribute(element, attribute, value) {
    const previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return () => {
        if (previousValue) {
            element.setAttribute(attribute, previousValue);
        }
        else {
            element.removeAttribute(attribute);
        }
    };
}
function dist_Portal({ children, animation, styles, className, on, portal, close }) {
    const [mounted, setMounted] = react.useState(false);
    const [visible, setVisible] = react.useState(false);
    const cleanup = react.useRef([]);
    const { setTimeout } = useTimeouts();
    const { subscribe } = useEvents();
    const reduceMotion = useMotionPreference();
    const animationDuration = !reduceMotion ? animation.fade : 0;
    react.useEffect(() => {
        setMounted(true);
        return () => {
            setMounted(false);
            setVisible(false);
        };
    }, []);
    const handleClose = useEventCallback(() => {
        var _a;
        setVisible(false);
        (_a = on.exiting) === null || _a === void 0 ? void 0 : _a.call(on);
        setTimeout(() => {
            var _a;
            (_a = on.exited) === null || _a === void 0 ? void 0 : _a.call(on);
            close();
        }, animationDuration);
    });
    react.useEffect(() => subscribe(ACTION_CLOSE, handleClose), [subscribe, handleClose]);
    const handleEnter = useEventCallback((node) => {
        var _a, _b, _c;
        node.scrollTop;
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 ? void 0 : _a.call(on);
        const elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for (let i = 0; i < elements.length; i += 1) {
            const element = elements[i];
            if (["TEMPLATE", "SCRIPT", "STYLE"].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push(setAttribute(element, "inert", "true"));
                cleanup.current.push(setAttribute(element, "aria-hidden", "true"));
            }
        }
        setTimeout(() => {
            var _a;
            (_a = on.entered) === null || _a === void 0 ? void 0 : _a.call(on);
        }, animationDuration);
    });
    const handleExit = useEventCallback(() => {
        cleanup.current.forEach((clean) => clean());
        cleanup.current = [];
    });
    const handleRef = react.useCallback((node) => {
        if (node) {
            handleEnter(node);
        }
        else {
            handleExit();
        }
    }, [handleEnter, handleExit]);
    return mounted
        ? (0,react_dom.createPortal)(react.createElement("div", { ref: handleRef, className: clsx(className, cssClass("root"), cssClass(cssPrefix$1()), cssClass(CLASS_NO_SCROLL_PADDING), visible && cssClass(cssPrefix$1("open"))), role: "presentation", "aria-live": "polite", style: {
                ...(animation.fade !== LightboxDefaultProps.animation.fade
                    ? { [cssVar("fade_animation_duration")]: `${animationDuration}ms` }
                    : null),
                ...(animation.easing.fade !== LightboxDefaultProps.animation.easing.fade
                    ? { [cssVar("fade_animation_timing_function")]: animation.easing.fade }
                    : null),
                ...styles.root,
            } }, children), portal.root || document.body)
        : null;
}
const PortalModule = createModule(MODULE_PORTAL, dist_Portal);

function Root({ children }) {
    return react.createElement(react.Fragment, null, children);
}
const RootModule = createModule(MODULE_ROOT, Root);

function cssPrefix(value) {
    return composePrefix(MODULE_TOOLBAR, value);
}
function Toolbar({ toolbar: { buttons }, render: { buttonClose, iconClose }, styles }) {
    const { close, setToolbarWidth } = useController();
    const { setContainerRef, containerRect } = useContainerRect();
    useLayoutEffect(() => {
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [setToolbarWidth, containerRect === null || containerRect === void 0 ? void 0 : containerRect.width]);
    const renderCloseButton = () => {
        if (buttonClose)
            return buttonClose();
        return react.createElement(IconButton, { key: ACTION_CLOSE, label: "Close", icon: CloseIcon, renderIcon: iconClose, onClick: close });
    };
    return (react.createElement("div", { ref: setContainerRef, style: styles.toolbar, className: cssClass(cssPrefix()), ...stopNavigationEventsPropagation() }, buttons === null || buttons === void 0 ? void 0 : buttons.map((button) => (button === ACTION_CLOSE ? renderCloseButton() : button))));
}
const ToolbarModule = createModule(MODULE_TOOLBAR, Toolbar);

function renderNode(node, props) {
    var _a;
    return react.createElement(node.module.component, { key: node.module.name, ...props }, (_a = node.children) === null || _a === void 0 ? void 0 : _a.map((child) => renderNode(child, props)));
}
function mergeAnimation(defaultAnimation, animation = {}) {
    const { easing: defaultAnimationEasing, ...restDefaultAnimation } = defaultAnimation;
    const { easing, ...restAnimation } = animation;
    return {
        easing: { ...defaultAnimationEasing, ...easing },
        ...restDefaultAnimation,
        ...restAnimation,
    };
}
function Lightbox({ carousel, animation, render, toolbar, controller, on, plugins, slides, index, ...restProps }) {
    const { animation: defaultAnimation, carousel: defaultCarousel, render: defaultRender, toolbar: defaultToolbar, controller: defaultController, on: defaultOn, slides: defaultSlides, index: defaultIndex, plugins: defaultPlugins, ...restDefaultProps } = LightboxDefaultProps;
    const { config, augmentation } = withPlugins([
        createNode(PortalModule, [
            createNode(NoScrollModule, [
                createNode(ControllerModule, [
                    createNode(CarouselModule),
                    createNode(ToolbarModule),
                    createNode(NavigationModule),
                ]),
            ]),
        ]),
    ], plugins || defaultPlugins);
    const props = augmentation({
        animation: mergeAnimation(defaultAnimation, animation),
        carousel: { ...defaultCarousel, ...carousel },
        render: { ...defaultRender, ...render },
        toolbar: { ...defaultToolbar, ...toolbar },
        controller: { ...defaultController, ...controller },
        on: { ...defaultOn, ...on },
        ...restDefaultProps,
        ...restProps,
    });
    if (!props.open)
        return null;
    return (react.createElement(LightboxPropsProvider, { ...props },
        react.createElement(LightboxStateProvider, { slides: slides || defaultSlides, index: index || defaultIndex },
            react.createElement(TimeoutsProvider, null,
                react.createElement(EventsProvider, null, renderNode(createNode(RootModule, config), props))))));
}


;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/index.js




const defaultThumbnailsProps = {
    ref: null,
    position: "bottom",
    width: 120,
    height: 80,
    border: 1,
    borderRadius: 4,
    padding: 4,
    gap: 16,
    imageFit: "contain",
    vignette: true,
};
const resolveThumbnailsProps = (thumbnails) => ({
    ...defaultThumbnailsProps,
    ...thumbnails,
});
function useThumbnailsProps() {
    const { thumbnails } = useLightboxProps();
    return resolveThumbnailsProps(thumbnails);
}

const thumbnails_cssPrefix = (value) => composePrefix(PLUGIN_THUMBNAILS, value);
const cssThumbnailPrefix = (value) => thumbnails_cssPrefix(composePrefix("thumbnail", value));

const VideoThumbnailIcon = createIcon("VideoThumbnail", react.createElement("path", { d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" }));
const UnknownThumbnailIcon = createIcon("UnknownThumbnail", react.createElement("path", { d: "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z" }));
function renderThumbnail({ slide, render, rect, imageFit }) {
    var _a;
    const customThumbnail = (_a = render.thumbnail) === null || _a === void 0 ? void 0 : _a.call(render, { slide, render, rect, imageFit });
    if (customThumbnail) {
        return customThumbnail;
    }
    const thumbnailIconClass = cssClass(cssThumbnailPrefix(ELEMENT_ICON));
    if (!isImageSlide(slide)) {
        if (slide.type === "video") {
            return (react.createElement(react.Fragment, null,
                "poster" in slide && (react.createElement("img", { alt: "", src: slide.poster, className: clsx(cssClass(CLASS_FULLSIZE), cssClass(thumbnails_cssPrefix("contain_image"))) })),
                react.createElement(VideoThumbnailIcon, { className: thumbnailIconClass })));
        }
    }
    else {
        return react.createElement(ImageSlide, { slide: slide, render: render, rect: rect, imageFit: imageFit });
    }
    return react.createElement(UnknownThumbnailIcon, { className: thumbnailIconClass });
}
const activePrefix = makeComposePrefix("active");
const fadeInPrefix = makeComposePrefix("fadein");
const fadeOutPrefix = makeComposePrefix("fadeout");
const placeholderPrefix = makeComposePrefix("placeholder");
const DELAY = "delay";
const DURATION = "duration";
function Thumbnail({ slide, onClick, active, fadeIn, fadeOut, placeholder }) {
    const { render, styles } = useLightboxProps();
    const { width, height, imageFit } = useThumbnailsProps();
    const rect = { width, height };
    return (react.createElement("button", { type: "button", className: clsx(cssClass(CLASS_FLEX_CENTER), cssClass(cssThumbnailPrefix()), active && cssClass(cssThumbnailPrefix(activePrefix())), fadeIn && cssClass(cssThumbnailPrefix(fadeInPrefix())), fadeOut && cssClass(cssThumbnailPrefix(fadeOutPrefix())), placeholder && cssClass(cssThumbnailPrefix(placeholderPrefix()))), style: {
            ...(fadeIn
                ? {
                    [cssVar(cssThumbnailPrefix(fadeInPrefix(DURATION)))]: `${fadeIn.duration}ms`,
                    [cssVar(cssThumbnailPrefix(fadeInPrefix(DELAY)))]: `${fadeIn.delay}ms`,
                }
                : null),
            ...(fadeOut
                ? {
                    [cssVar(cssThumbnailPrefix(fadeOutPrefix(DURATION)))]: `${fadeOut.duration}ms`,
                    [cssVar(cssThumbnailPrefix(fadeOutPrefix(DELAY)))]: `${fadeOut.delay}ms`,
                }
                : null),
            ...styles.thumbnail,
        }, onClick: onClick }, slide && renderThumbnail({ slide, render, rect, imageFit })));
}

function isHorizontal(position) {
    return ["top", "bottom"].includes(position);
}
function boxSize(thumbnails, dimension, includeGap) {
    return dimension + 2 * (thumbnails.border + thumbnails.padding) + (includeGap ? thumbnails.gap : 0);
}
function ThumbnailsTrack({ visible, containerRef }) {
    const track = react.useRef(null);
    const { carousel, styles } = useLightboxProps();
    const { slides, globalIndex, animation } = useLightboxState();
    const { publish, subscribe } = useEvents();
    const isRTL = useRTL();
    const thumbnails = useThumbnailsProps();
    const { position, width, height, border, borderRadius, padding, gap, vignette } = thumbnails;
    const index = globalIndex;
    const animationDuration = (animation === null || animation === void 0 ? void 0 : animation.duration) || 0;
    const offset = (animationDuration > 0 && (animation === null || animation === void 0 ? void 0 : animation.increment)) || 0;
    const { prepareAnimation } = useAnimation(track, (snapshot) => ({
        keyframes: isHorizontal(position)
            ? [
                {
                    transform: `translateX(${(isRTL ? -1 : 1) * boxSize(thumbnails, width, true) * offset + snapshot}px)`,
                },
                { transform: "translateX(0)" },
            ]
            : [
                {
                    transform: `translateY(${boxSize(thumbnails, height, true) * offset + snapshot}px)`,
                },
                { transform: "translateY(0)" },
            ],
        duration: animationDuration,
        easing: animation === null || animation === void 0 ? void 0 : animation.easing,
    }));
    const handleControllerSwipe = useEventCallback(() => {
        let animationOffset = 0;
        if (containerRef.current && track.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const trackRect = track.current.getBoundingClientRect();
            animationOffset = isHorizontal(position)
                ? trackRect.left - containerRect.left - (containerRect.width - trackRect.width) / 2
                : trackRect.top - containerRect.top - (containerRect.height - trackRect.height) / 2;
        }
        prepareAnimation(animationOffset);
    });
    react.useEffect(() => cleanup(subscribe(ACTION_SWIPE, handleControllerSwipe)), [subscribe, handleControllerSwipe]);
    const preload = calculatePreload(carousel, slides);
    const items = [];
    if (hasSlides(slides)) {
        if (offset < 0) {
            for (let i = index - preload + offset; i < index - preload; i += 1) {
                items.push({ slide: null, index: i, placeholder: true });
            }
        }
        for (let i = index - preload - Math.max(offset, 0); i < index; i += 1) {
            if (!(carousel.finite && i < 0)) {
                items.push({ slide: getSlide(slides, i), index: i });
            }
            else {
                items.push({ slide: null, index: i, placeholder: true });
            }
        }
        items.push({ slide: getSlide(slides, index), index });
        for (let i = index + 1; i <= index + preload - Math.min(offset, 0); i += 1) {
            if (!carousel.finite || i <= slides.length - 1) {
                items.push({ slide: getSlide(slides, i), index: i });
            }
            else {
                items.push({ slide: null, index: i, placeholder: true });
            }
        }
        if (offset > 0) {
            for (let i = index + preload + 1; i <= index + preload + offset; i += 1) {
                items.push({ slide: null, index: i, placeholder: true });
            }
        }
    }
    const handleClick = (slideIndex) => () => {
        if (slideIndex > index) {
            publish(ACTION_NEXT, { count: slideIndex - index });
        }
        else if (slideIndex < index) {
            publish(ACTION_PREV, { count: index - slideIndex });
        }
    };
    return (react.createElement("div", { className: clsx(cssClass(thumbnails_cssPrefix("container")), cssClass(CLASS_FLEX_CENTER)), style: {
            ...(!visible ? { display: "none" } : null),
            ...(width !== defaultThumbnailsProps.width
                ? { [cssVar(cssThumbnailPrefix("width"))]: `${boxSize(thumbnails, width)}px` }
                : null),
            ...(height !== defaultThumbnailsProps.height
                ? { [cssVar(cssThumbnailPrefix("height"))]: `${boxSize(thumbnails, height)}px` }
                : null),
            ...(border !== defaultThumbnailsProps.border
                ? { [cssVar(cssThumbnailPrefix("border"))]: `${border}px` }
                : null),
            ...(borderRadius !== defaultThumbnailsProps.borderRadius
                ? { [cssVar(cssThumbnailPrefix("border_radius"))]: `${borderRadius}px` }
                : null),
            ...(padding !== defaultThumbnailsProps.padding
                ? { [cssVar(cssThumbnailPrefix("padding"))]: `${padding}px` }
                : null),
            ...(gap !== defaultThumbnailsProps.gap ? { [cssVar(cssThumbnailPrefix("gap"))]: `${gap}px` } : null),
            ...styles.thumbnailsContainer,
        } },
        react.createElement("nav", { ref: track, style: styles.thumbnailsTrack, className: clsx(cssClass(thumbnails_cssPrefix("track")), cssClass(CLASS_FLEX_CENTER)) }, items.map(({ slide, index: slideIndex, placeholder }) => {
            const fadeAnimationDuration = animationDuration / Math.abs(offset || 1);
            const fadeIn = (offset > 0 && slideIndex > index + preload - offset && slideIndex <= index + preload) ||
                (offset < 0 && slideIndex < index - preload - offset && slideIndex >= index - preload)
                ? {
                    duration: fadeAnimationDuration,
                    delay: ((offset > 0
                        ? slideIndex - (index + preload - offset)
                        : index - preload - offset - slideIndex) -
                        1) *
                        fadeAnimationDuration,
                }
                : undefined;
            const fadeOut = (offset > 0 && slideIndex < index - preload) || (offset < 0 && slideIndex > index + preload)
                ? {
                    duration: fadeAnimationDuration,
                    delay: (offset > 0
                        ? offset - (index - preload - slideIndex)
                        : -offset - (slideIndex - (index + preload))) * fadeAnimationDuration,
                }
                : undefined;
            return (react.createElement(Thumbnail, { key: slideIndex, slide: slide, active: slideIndex === index, fadeIn: fadeIn, fadeOut: fadeOut, placeholder: Boolean(placeholder), onClick: handleClick(slideIndex) }));
        })),
        vignette && react.createElement("div", { className: cssClass(thumbnails_cssPrefix("vignette")) })));
}

const ThumbnailsContext = react.createContext(null);
const useThumbnails = makeUseContext("useThumbnails", "ThumbnailsContext", ThumbnailsContext);
function ThumbnailsContextProvider({ children, ...props }) {
    const [visible, setVisible] = react.useState(true);
    const containerRef = react.useRef(null);
    const { ref, position } = resolveThumbnailsProps(props.thumbnails);
    const context = react.useMemo(() => ({
        visible,
        show: () => setVisible(true),
        hide: () => setVisible(false),
    }), [visible]);
    react.useImperativeHandle(ref, () => context, [context]);
    return (react.createElement(LightboxPropsProvider, { ...props },
        react.createElement(ThumbnailsContext.Provider, { value: context },
            react.createElement("div", { ref: containerRef, className: clsx(cssClass(thumbnails_cssPrefix()), cssClass(thumbnails_cssPrefix(`${position}`))) },
                ["start", "top"].includes(position) && (react.createElement(ThumbnailsTrack, { containerRef: containerRef, visible: visible })),
                react.createElement("div", { className: cssClass(thumbnails_cssPrefix("wrapper")) }, children),
                ["end", "bottom"].includes(position) && (react.createElement(ThumbnailsTrack, { containerRef: containerRef, visible: visible }))))));
}

const thumbnailsIcon = () => (react.createElement(react.Fragment, null,
    react.createElement("path", { strokeWidth: 2, stroke: "currentColor", strokeLinejoin: "round", fill: "none", d: "M3 5l18 0l0 14l-18 0l0-14z" }),
    react.createElement("path", { d: "M5 14h4v3h-4zM10 14h4v3h-4zM15 14h4v3h-4z" })));
const ThumbnailsVisible = createIcon("ThumbnailsVisible", thumbnailsIcon());
const ThumbnailsHidden = createIconDisabled("ThumbnailsHidden", thumbnailsIcon());
function ThumbnailsButton() {
    const { visible, show, hide } = useThumbnails();
    const { render } = useLightboxProps();
    if (render.buttonThumbnails) {
        return react.createElement(react.Fragment, null, render.buttonThumbnails({ visible, show, hide }));
    }
    return (react.createElement(IconButton, { label: visible ? "Hide thumbnails" : "Show thumbnails", icon: visible ? ThumbnailsVisible : ThumbnailsHidden, renderIcon: visible ? render.iconThumbnailsVisible : render.iconThumbnailsHidden, onClick: visible ? hide : show }));
}

function Thumbnails({ augment, contains, append, addParent }) {
    augment(({ thumbnails: thumbnailsProps, toolbar, ...restProps }) => {
        const thumbnails = resolveThumbnailsProps(thumbnailsProps);
        return {
            toolbar: addToolbarButton(toolbar, PLUGIN_THUMBNAILS, thumbnails.showToggle ? react.createElement(ThumbnailsButton, null) : null),
            thumbnails,
            ...restProps,
        };
    });
    const module = createModule(PLUGIN_THUMBNAILS, ThumbnailsContextProvider);
    if (contains(PLUGIN_FULLSCREEN)) {
        append(PLUGIN_FULLSCREEN, module);
    }
    else {
        addParent(MODULE_CONTROLLER, module);
    }
}



;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/counter/index.js




const defaultCounterProps = {
    separator: "/",
    container: {},
};
const resolveCounterProps = (counter) => ({
    ...defaultCounterProps,
    ...counter,
});

function CounterComponent({ counter }) {
    const { slides, currentIndex } = useLightboxState();
    const { separator, container: { className, ...rest }, className: legacyClassName, ...legacyRest } = resolveCounterProps(counter);
    if (slides.length === 0)
        return null;
    return (react.createElement("div", { className: clsx(cssClass("counter"), className || legacyClassName), ...legacyRest, ...rest },
        currentIndex + 1,
        " ",
        separator,
        " ",
        slides.length));
}
function Counter({ augment, addChild }) {
    augment(({ counter, ...restProps }) => ({
        counter: resolveCounterProps(counter),
        ...restProps,
    }));
    addChild(MODULE_CONTROLLER, createModule(PLUGIN_COUNTER, CounterComponent));
}



;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/zoom/index.js




const defaultZoomProps = {
    maxZoomPixelRatio: 1,
    zoomInMultiplier: 2,
    doubleTapDelay: 300,
    doubleClickDelay: 500,
    doubleClickMaxStops: 2,
    keyboardMoveDistance: 50,
    wheelZoomDistanceFactor: 100,
    pinchZoomDistanceFactor: 100,
    scrollToZoom: false,
};
const resolveZoomProps = (zoom) => ({
    ...defaultZoomProps,
    ...zoom,
});

function useZoomAnimation(zoom, offsetX, offsetY, zoomWrapperRef) {
    const zoomAnimation = react.useRef();
    const zoomAnimationStart = react.useRef();
    const { zoom: zoomAnimationDuration } = useLightboxProps().animation;
    const reduceMotion = useMotionPreference();
    const playZoomAnimation = useEventCallback(() => {
        var _a, _b, _c;
        (_a = zoomAnimation.current) === null || _a === void 0 ? void 0 : _a.cancel();
        zoomAnimation.current = undefined;
        if (zoomAnimationStart.current && (zoomWrapperRef === null || zoomWrapperRef === void 0 ? void 0 : zoomWrapperRef.current)) {
            try {
                zoomAnimation.current = (_c = (_b = zoomWrapperRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, [
                    { transform: zoomAnimationStart.current },
                    { transform: `scale(${zoom}) translateX(${offsetX}px) translateY(${offsetY}px)` },
                ], {
                    duration: !reduceMotion ? zoomAnimationDuration !== null && zoomAnimationDuration !== void 0 ? zoomAnimationDuration : 500 : 0,
                    easing: zoomAnimation.current ? "ease-out" : "ease-in-out",
                });
            }
            catch (err) {
                console.error(err);
            }
            zoomAnimationStart.current = undefined;
            if (zoomAnimation.current) {
                zoomAnimation.current.onfinish = () => {
                    zoomAnimation.current = undefined;
                };
            }
        }
    });
    useLayoutEffect(playZoomAnimation, [zoom, offsetX, offsetY, playZoomAnimation]);
    return react.useCallback(() => {
        zoomAnimationStart.current = (zoomWrapperRef === null || zoomWrapperRef === void 0 ? void 0 : zoomWrapperRef.current)
            ? window.getComputedStyle(zoomWrapperRef.current).transform
            : undefined;
    }, [zoomWrapperRef]);
}

function useZoomCallback(zoom, disabled) {
    const { on } = useLightboxProps();
    const onZoomCallback = useEventCallback(() => {
        var _a;
        if (!disabled) {
            (_a = on.zoom) === null || _a === void 0 ? void 0 : _a.call(on, { zoom });
        }
    });
    react.useEffect(onZoomCallback, [zoom, onZoomCallback]);
}

function useZoomProps() {
    const { zoom } = useLightboxProps();
    return resolveZoomProps(zoom);
}

function useZoomImageRect(slideRect, imageDimensions) {
    var _a, _b;
    let imageRect = { width: 0, height: 0 };
    let maxImageRect = { width: 0, height: 0 };
    const { slides, currentIndex } = useLightboxState();
    const { imageFit } = useLightboxProps().carousel;
    const { maxZoomPixelRatio } = useZoomProps();
    if (slideRect && currentIndex < slides.length) {
        const slide = { ...slides[currentIndex], ...imageDimensions };
        if (isImageSlide(slide)) {
            const cover = isImageFitCover(slide, imageFit);
            const width = Math.max(...(((_a = slide.srcSet) === null || _a === void 0 ? void 0 : _a.map((x) => x.width)) || []).concat(slide.width ? [slide.width] : []));
            const height = Math.max(...(((_b = slide.srcSet) === null || _b === void 0 ? void 0 : _b.map((x) => x.height)) || []).concat(slide.height ? [slide.height] : []));
            if (width > 0 && height > 0 && slideRect.width > 0 && slideRect.height > 0) {
                maxImageRect = cover
                    ? {
                        width: Math.round(Math.min(width, (slideRect.width / slideRect.height) * height)),
                        height: Math.round(Math.min(height, (slideRect.height / slideRect.width) * width)),
                    }
                    : { width, height };
                maxImageRect = {
                    width: maxImageRect.width * maxZoomPixelRatio,
                    height: maxImageRect.height * maxZoomPixelRatio,
                };
                imageRect = cover
                    ? {
                        width: Math.min(slideRect.width, maxImageRect.width, width),
                        height: Math.min(slideRect.height, maxImageRect.height, height),
                    }
                    : {
                        width: Math.round(Math.min(slideRect.width, (slideRect.height / height) * width, width)),
                        height: Math.round(Math.min(slideRect.height, (slideRect.width / width) * height, height)),
                    };
            }
        }
    }
    const maxZoom = imageRect.width ? Math.max(round(maxImageRect.width / imageRect.width, 5), 1) : 1;
    return { imageRect, maxZoom };
}

function distance(pointerA, pointerB) {
    return ((pointerA.clientX - pointerB.clientX) ** 2 + (pointerA.clientY - pointerB.clientY) ** 2) ** 0.5;
}
function useZoomSensors(zoom, maxZoom, disabled, changeZoom, changeOffsets, zoomWrapperRef) {
    const activePointers = react.useRef([]);
    const lastPointerDown = react.useRef(0);
    const pinchZoomDistance = react.useRef();
    const { globalIndex } = useLightboxState();
    const { containerRef, subscribeSensors } = useController();
    const { keyboardMoveDistance, zoomInMultiplier, wheelZoomDistanceFactor, scrollToZoom, doubleTapDelay, doubleClickDelay, doubleClickMaxStops, pinchZoomDistanceFactor, } = useZoomProps();
    const translateCoordinates = react.useCallback((event) => {
        if (containerRef.current) {
            const { pageX, pageY } = event;
            const { scrollX, scrollY } = window;
            const { left, top, width, height } = containerRef.current.getBoundingClientRect();
            return [pageX - left - scrollX - width / 2, pageY - top - scrollY - height / 2];
        }
        return [];
    }, [containerRef]);
    const onKeyDown = useEventCallback((event) => {
        const preventDefault = () => {
            event.preventDefault();
            event.stopPropagation();
        };
        if (zoom > 1) {
            const move = (deltaX, deltaY) => {
                preventDefault();
                changeOffsets(deltaX, deltaY);
            };
            if (event.key === "ArrowDown") {
                move(0, keyboardMoveDistance);
            }
            else if (event.key === "ArrowUp") {
                move(0, -keyboardMoveDistance);
            }
            else if (event.key === "ArrowLeft") {
                move(-keyboardMoveDistance, 0);
            }
            else if (event.key === "ArrowRight") {
                move(keyboardMoveDistance, 0);
            }
        }
        const handleChangeZoom = (zoomValue) => {
            preventDefault();
            changeZoom(zoomValue);
        };
        const hasMeta = () => event.getModifierState("Meta");
        if (event.key === "+" || (event.key === "=" && hasMeta())) {
            handleChangeZoom(zoom * zoomInMultiplier);
        }
        else if (event.key === "-" || (event.key === "_" && hasMeta())) {
            handleChangeZoom(zoom / zoomInMultiplier);
        }
        else if (event.key === "0" && hasMeta()) {
            handleChangeZoom(1);
        }
    });
    const onWheel = useEventCallback((event) => {
        if (event.ctrlKey || scrollToZoom) {
            if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
                event.stopPropagation();
                changeZoom(zoom * (1 - event.deltaY / wheelZoomDistanceFactor), true, ...translateCoordinates(event));
                return;
            }
        }
        if (zoom > 1) {
            event.stopPropagation();
            if (!scrollToZoom) {
                changeOffsets(event.deltaX, event.deltaY);
            }
        }
    });
    const clearPointer = react.useCallback((event) => {
        const pointers = activePointers.current;
        pointers.splice(0, pointers.length, ...pointers.filter((p) => p.pointerId !== event.pointerId));
    }, []);
    const replacePointer = react.useCallback((event) => {
        clearPointer(event);
        event.persist();
        activePointers.current.push(event);
    }, [clearPointer]);
    const onPointerDown = useEventCallback((event) => {
        var _a;
        const pointers = activePointers.current;
        if (!((_a = zoomWrapperRef === null || zoomWrapperRef === void 0 ? void 0 : zoomWrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            return;
        }
        if (zoom > 1) {
            event.stopPropagation();
        }
        const { timeStamp } = event;
        if (pointers.length === 0 &&
            timeStamp - lastPointerDown.current < (event.pointerType === "touch" ? doubleTapDelay : doubleClickDelay)) {
            lastPointerDown.current = 0;
            changeZoom(zoom !== maxZoom ? zoom * Math.max(maxZoom ** (1 / doubleClickMaxStops), zoomInMultiplier) : 1, false, ...translateCoordinates(event));
        }
        else {
            lastPointerDown.current = timeStamp;
        }
        replacePointer(event);
        if (pointers.length === 2) {
            pinchZoomDistance.current = distance(pointers[0], pointers[1]);
        }
    });
    const onPointerMove = useEventCallback((event) => {
        const pointers = activePointers.current;
        const activePointer = pointers.find((p) => p.pointerId === event.pointerId);
        if (pointers.length === 2 && pinchZoomDistance.current) {
            event.stopPropagation();
            replacePointer(event);
            const currentDistance = distance(pointers[0], pointers[1]);
            const delta = currentDistance - pinchZoomDistance.current;
            if (Math.abs(delta) > 0) {
                changeZoom(zoom * (1 + delta / pinchZoomDistanceFactor), true, ...pointers
                    .map((x) => translateCoordinates(x))
                    .reduce((acc, coordinate) => coordinate.map((x, i) => acc[i] + x / 2)));
                pinchZoomDistance.current = currentDistance;
            }
            return;
        }
        if (zoom > 1) {
            event.stopPropagation();
            if (activePointer) {
                if (pointers.length === 1) {
                    changeOffsets((activePointer.clientX - event.clientX) / zoom, (activePointer.clientY - event.clientY) / zoom);
                }
                replacePointer(event);
            }
        }
    });
    const onPointerUp = react.useCallback((event) => {
        const pointers = activePointers.current;
        if (pointers.length === 2 && pointers.find((p) => p.pointerId === event.pointerId)) {
            pinchZoomDistance.current = undefined;
        }
        clearPointer(event);
    }, [clearPointer]);
    const cleanupSensors = react.useCallback(() => {
        const pointers = activePointers.current;
        pointers.splice(0, pointers.length);
        lastPointerDown.current = 0;
        pinchZoomDistance.current = undefined;
    }, []);
    usePointerEvents(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled);
    react.useEffect(cleanupSensors, [globalIndex, cleanupSensors]);
    react.useEffect(() => {
        if (!disabled) {
            return cleanup(cleanupSensors, subscribeSensors(EVENT_ON_KEY_DOWN, onKeyDown), subscribeSensors(EVENT_ON_WHEEL, onWheel));
        }
        return () => { };
    }, [disabled, subscribeSensors, cleanupSensors, onKeyDown, onWheel]);
}

function getCurrentSource(slides, currentIndex) {
    if (currentIndex < slides.length) {
        const slide = slides[currentIndex];
        if (isImageSlide(slide))
            return slide.src;
    }
    return undefined;
}
function useZoomState(imageRect, maxZoom, zoomWrapperRef) {
    const [zoom, setZoom] = react.useState(1);
    const [offsetX, setOffsetX] = react.useState(0);
    const [offsetY, setOffsetY] = react.useState(0);
    const animate = useZoomAnimation(zoom, offsetX, offsetY, zoomWrapperRef);
    const { slides, currentIndex, globalIndex } = useLightboxState();
    const { containerRect, slideRect } = useController();
    const { zoomInMultiplier } = useZoomProps();
    const currentSource = getCurrentSource(slides, currentIndex);
    const disabled = !currentSource || !(zoomWrapperRef === null || zoomWrapperRef === void 0 ? void 0 : zoomWrapperRef.current);
    useLayoutEffect(() => {
        setZoom(1);
        setOffsetX(0);
        setOffsetY(0);
    }, [globalIndex, currentSource]);
    const changeOffsets = react.useCallback((dx, dy, targetZoom) => {
        const newZoom = targetZoom || zoom;
        const newOffsetX = offsetX - (dx || 0);
        const newOffsetY = offsetY - (dy || 0);
        const maxOffsetX = (imageRect.width * newZoom - slideRect.width) / 2 / newZoom;
        const maxOffsetY = (imageRect.height * newZoom - slideRect.height) / 2 / newZoom;
        setOffsetX(Math.min(Math.abs(newOffsetX), Math.max(maxOffsetX, 0)) * Math.sign(newOffsetX));
        setOffsetY(Math.min(Math.abs(newOffsetY), Math.max(maxOffsetY, 0)) * Math.sign(newOffsetY));
    }, [zoom, offsetX, offsetY, slideRect, imageRect.width, imageRect.height]);
    const changeZoom = react.useCallback((targetZoom, rapid, dx, dy) => {
        const newZoom = round(Math.min(Math.max(targetZoom + 0.001 < maxZoom ? targetZoom : maxZoom, 1), maxZoom), 5);
        if (newZoom === zoom)
            return;
        if (!rapid) {
            animate();
        }
        changeOffsets(dx ? dx * (1 / zoom - 1 / newZoom) : 0, dy ? dy * (1 / zoom - 1 / newZoom) : 0, newZoom);
        setZoom(newZoom);
    }, [zoom, maxZoom, changeOffsets, animate]);
    const handleControllerRectChange = useEventCallback(() => {
        if (zoom > 1) {
            if (zoom > maxZoom) {
                changeZoom(maxZoom, true);
            }
            changeOffsets();
        }
    });
    useLayoutEffect(handleControllerRectChange, [
        containerRect.width,
        containerRect.height,
        handleControllerRectChange,
    ]);
    const zoomIn = react.useCallback(() => changeZoom(zoom * zoomInMultiplier), [zoom, zoomInMultiplier, changeZoom]);
    const zoomOut = react.useCallback(() => changeZoom(zoom / zoomInMultiplier), [zoom, zoomInMultiplier, changeZoom]);
    return { zoom, offsetX, offsetY, disabled, changeOffsets, changeZoom, zoomIn, zoomOut };
}

const ZoomControllerContext = react.createContext(null);
const useZoom = makeUseContext("useZoom", "ZoomControllerContext", ZoomControllerContext);
function ZoomContextProvider({ children }) {
    const [zoomWrapper, setZoomWrapper] = react.useState();
    const { slideRect } = useController();
    const { imageRect, maxZoom } = useZoomImageRect(slideRect, zoomWrapper === null || zoomWrapper === void 0 ? void 0 : zoomWrapper.imageDimensions);
    const { zoom, offsetX, offsetY, disabled, changeZoom, changeOffsets, zoomIn, zoomOut } = useZoomState(imageRect, maxZoom, zoomWrapper === null || zoomWrapper === void 0 ? void 0 : zoomWrapper.zoomWrapperRef);
    useZoomCallback(zoom, disabled);
    useZoomSensors(zoom, maxZoom, disabled, changeZoom, changeOffsets, zoomWrapper === null || zoomWrapper === void 0 ? void 0 : zoomWrapper.zoomWrapperRef);
    const zoomRef = react.useMemo(() => ({ zoom, maxZoom, offsetX, offsetY, disabled, zoomIn, zoomOut, changeZoom }), [zoom, maxZoom, offsetX, offsetY, disabled, zoomIn, zoomOut, changeZoom]);
    react.useImperativeHandle(useZoomProps().ref, () => zoomRef, [zoomRef]);
    const context = react.useMemo(() => ({ ...zoomRef, setZoomWrapper }), [zoomRef, setZoomWrapper]);
    return react.createElement(ZoomControllerContext.Provider, { value: context }, children);
}

const ZoomInIcon = createIcon("ZoomIn", react.createElement(react.Fragment, null,
    react.createElement("path", { d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" }),
    react.createElement("path", { d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" })));
const ZoomOutIcon = createIcon("ZoomOut", react.createElement("path", { d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z" }));
const ZoomButton = react.forwardRef(function ZoomButton({ zoomIn, onLoseFocus }, ref) {
    const wasEnabled = react.useRef(false);
    const wasFocused = react.useRef(false);
    const { zoom, maxZoom, zoomIn: zoomInCallback, zoomOut: zoomOutCallback, disabled: zoomDisabled } = useZoom();
    const { render } = useLightboxProps();
    const disabled = zoomDisabled || (zoomIn ? zoom >= maxZoom : zoom <= 1);
    react.useEffect(() => {
        if (disabled && wasEnabled.current && wasFocused.current) {
            onLoseFocus();
        }
        if (!disabled) {
            wasEnabled.current = true;
        }
    }, [disabled, onLoseFocus]);
    return (react.createElement(IconButton, { ref: ref, disabled: disabled, label: zoomIn ? "Zoom in" : "Zoom out", icon: zoomIn ? ZoomInIcon : ZoomOutIcon, renderIcon: zoomIn ? render.iconZoomIn : render.iconZoomOut, onClick: zoomIn ? zoomInCallback : zoomOutCallback, onFocus: () => {
            wasFocused.current = true;
        }, onBlur: () => {
            wasFocused.current = false;
        } }));
});

function ZoomButtonsGroup() {
    const zoomInRef = react.useRef(null);
    const zoomOutRef = react.useRef(null);
    const { focus } = useController();
    const focusSibling = react.useCallback((sibling) => {
        var _a, _b;
        if (!((_a = sibling.current) === null || _a === void 0 ? void 0 : _a.disabled)) {
            (_b = sibling.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else {
            focus();
        }
    }, [focus]);
    const focusZoomIn = react.useCallback(() => focusSibling(zoomInRef), [focusSibling]);
    const focusZoomOut = react.useCallback(() => focusSibling(zoomOutRef), [focusSibling]);
    return (react.createElement(react.Fragment, null,
        react.createElement(ZoomButton, { zoomIn: true, ref: zoomInRef, onLoseFocus: focusZoomOut }),
        react.createElement(ZoomButton, { ref: zoomOutRef, onLoseFocus: focusZoomIn })));
}

function ZoomToolbarControl() {
    const { render } = useLightboxProps();
    const zoomRef = useZoom();
    if (render.buttonZoom) {
        return react.createElement(react.Fragment, null, render.buttonZoom(zoomRef));
    }
    return react.createElement(ZoomButtonsGroup, null);
}

function isResponsiveImageSlide(slide) {
    var _a;
    return (((_a = slide.srcSet) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
}
function zoom_reducer({ current, preload }, { type, source }) {
    switch (type) {
        case "fetch":
            if (!current) {
                return { current: source };
            }
            return { current, preload: source };
        case "done":
            if (source === preload) {
                return { current: source };
            }
            return { current, preload };
        default:
            throw new Error(UNKNOWN_ACTION_TYPE);
    }
}
function ResponsiveImage(props) {
    var _a, _b;
    const [{ current, preload }, dispatch] = react.useReducer(zoom_reducer, {});
    const { slide: image, rect, imageFit, render } = props;
    const srcSet = image.srcSet.sort((a, b) => a.width - b.width);
    const width = (_a = image.width) !== null && _a !== void 0 ? _a : srcSet[srcSet.length - 1].width;
    const height = (_b = image.height) !== null && _b !== void 0 ? _b : srcSet[srcSet.length - 1].height;
    const cover = isImageFitCover(image, imageFit);
    const maxWidth = Math.max(...srcSet.map((x) => x.width));
    const targetWidth = Math.min((cover ? Math.max : Math.min)(rect.width, width * (rect.height / height)), maxWidth);
    const pixelDensity = devicePixelRatio();
    const handleResize = useEventCallback(() => {
        var _a;
        const targetSource = (_a = srcSet.find((x) => x.width >= targetWidth * pixelDensity)) !== null && _a !== void 0 ? _a : srcSet[srcSet.length - 1];
        if (!current || srcSet.findIndex((x) => x.src === current) < srcSet.findIndex((x) => x === targetSource)) {
            dispatch({ type: "fetch", source: targetSource.src });
        }
    });
    useLayoutEffect(handleResize, [rect.width, rect.height, pixelDensity, handleResize]);
    const handlePreload = useEventCallback((currentPreload) => dispatch({ type: "done", source: currentPreload }));
    const style = {
        WebkitTransform: "translateZ(0)",
    };
    if (!cover) {
        Object.assign(style, rect.width / rect.height < width / height
            ? { width: "100%", height: "auto" }
            : { width: "auto", height: "100%" });
    }
    return (react.createElement(react.Fragment, null,
        preload && preload !== current && (react.createElement(ImageSlide, { key: "preload", ...props, slide: { ...image, src: preload, srcSet: undefined }, style: { position: "absolute", visibility: "hidden", ...style }, onLoad: () => handlePreload(preload), render: {
                ...render,
                iconLoading: () => null,
                iconError: () => null,
            } })),
        current && (react.createElement(ImageSlide, { key: "current", ...props, slide: { ...image, src: current, srcSet: undefined }, style: style }))));
}

function ZoomWrapper({ render, slide, offset, rect }) {
    var _a;
    const [imageDimensions, setImageDimensions] = react.useState();
    const zoomWrapperRef = react.useRef(null);
    const { zoom, maxZoom, offsetX, offsetY, setZoomWrapper } = useZoom();
    const { carousel, on } = useLightboxProps();
    const { currentIndex } = useLightboxState();
    useLayoutEffect(() => {
        if (offset === 0) {
            setZoomWrapper({ zoomWrapperRef, imageDimensions });
            return () => setZoomWrapper(undefined);
        }
        return () => { };
    }, [offset, imageDimensions, setZoomWrapper]);
    let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, { slide, offset, rect, zoom, maxZoom });
    if (!rendered && isImageSlide(slide)) {
        const slideProps = {
            slide,
            offset,
            rect,
            render,
            imageFit: carousel.imageFit,
            imageProps: carousel.imageProps,
            onClick: offset === 0 ? () => { var _a; return (_a = on.click) === null || _a === void 0 ? void 0 : _a.call(on, { index: currentIndex }); } : undefined,
        };
        rendered = isResponsiveImageSlide(slide) ? (react.createElement(ResponsiveImage, { key: slide.src, ...slideProps, slide: slide, rect: offset === 0 ? { width: rect.width * zoom, height: rect.height * zoom } : rect })) : (react.createElement(ImageSlide, { key: slide.src, onLoad: (img) => setImageDimensions({ width: img.naturalWidth, height: img.naturalHeight }), ...slideProps }));
    }
    if (!rendered)
        return null;
    return (react.createElement("div", { ref: zoomWrapperRef, className: clsx(cssClass(CLASS_FULLSIZE), cssClass(CLASS_FLEX_CENTER)), style: offset === 0
            ? { transform: `scale(${zoom}) translateX(${offsetX}px) translateY(${offsetY}px)` }
            : undefined }, rendered));
}

const Zoom = ({ augment, addModule }) => {
    augment(({ toolbar, render, zoom, ...restProps }) => ({
        zoom: resolveZoomProps(zoom),
        toolbar: addToolbarButton(toolbar, PLUGIN_ZOOM, react.createElement(ZoomToolbarControl, null)),
        render: {
            ...render,
            slide: (props) => { var _a; return isImageSlide(props.slide) ? react.createElement(ZoomWrapper, { render: render, ...props }) : (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, props); },
        },
        ...restProps,
    }));
    addModule(createModule(PLUGIN_ZOOM, ZoomContextProvider));
};



;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/video/index.js




const defaultVideoProps = {
    controls: true,
    playsInline: true,
};
const resolveVideoProps = (video) => ({
    ...defaultVideoProps,
    ...video,
});
function useVideoProps() {
    const { video } = useLightboxProps();
    return resolveVideoProps(video);
}

function VideoSlide({ slide, offset }) {
    const video = useVideoProps();
    const { publish } = useEvents();
    const { setContainerRef, containerRect } = useContainerRect();
    const videoRef = react.useRef(null);
    react.useEffect(() => {
        if (offset !== 0 && videoRef.current && !videoRef.current.paused) {
            videoRef.current.pause();
        }
    }, [offset]);
    react.useEffect(() => {
        if (offset === 0 && videoRef.current && (slide.autoPlay || video.autoPlay)) {
            publish(ACTIVE_SLIDE_LOADING);
            videoRef.current.play().catch(() => { });
        }
    }, [offset, video.autoPlay, slide.autoPlay, publish]);
    const handleVideoRef = useEventCallback((node) => {
        if (offset === 0 && (video.autoPlay || slide.autoPlay) && node.paused) {
            node.play().catch(() => { });
        }
    });
    const setVideoRef = react.useCallback((node) => {
        videoRef.current = node;
        if (node) {
            handleVideoRef(node);
        }
    }, [handleVideoRef]);
    const { width, height, poster, sources } = slide;
    const scaleWidthAndHeight = () => {
        const scalingProps = {};
        scalingProps.style = { maxWidth: "100%", maxHeight: "100%" };
        if (width && height && containerRect) {
            const widthBound = width / height > containerRect.width / containerRect.height;
            const elementWidth = widthBound ? containerRect.width : Math.round((containerRect.height / height) * width);
            const elementHeight = !widthBound
                ? containerRect.height
                : Math.round((containerRect.width / width) * height);
            scalingProps.width = elementWidth;
            scalingProps.height = elementHeight;
            scalingProps.style.width = elementWidth;
            scalingProps.style.height = elementHeight;
        }
        return scalingProps;
    };
    const resolveBoolean = (attr) => {
        if (slide[attr] === false)
            return null;
        if (slide[attr] === true)
            return { [attr]: true };
        if (video[attr] === false)
            return null;
        if (video[attr] === true)
            return { [attr]: true };
        return null;
    };
    const resolveString = (attr) => {
        if (video[attr] || slide[attr]) {
            return { [attr]: slide[attr] || video[attr] };
        }
        return null;
    };
    return (react.createElement(react.Fragment, null, sources && (react.createElement("div", { ref: setContainerRef, style: {
            width: "100%",
            height: "100%",
            ...(width ? { maxWidth: `${width}px` } : null),
        }, className: clsx(cssClass("video_container"), cssClass(CLASS_FLEX_CENTER)) }, containerRect && (react.createElement("video", { ref: setVideoRef, poster: poster, ...scaleWidthAndHeight(), ...resolveBoolean("controls"), ...resolveBoolean("playsInline"), ...resolveBoolean("loop"), ...resolveBoolean("muted"), ...resolveBoolean("playsInline"), ...resolveBoolean("disablePictureInPicture"), ...resolveBoolean("disableRemotePlayback"), ...resolveString("controlsList"), ...resolveString("crossOrigin"), ...resolveString("preload"), onPlay: () => {
            publish(ACTIVE_SLIDE_PLAYING);
        }, onEnded: () => {
            publish(ACTIVE_SLIDE_COMPLETE);
        } }, sources.map(({ src, type }, index) => (react.createElement("source", { key: index, src: src, type: type })))))))));
}

function isVideoSlide(slide) {
    return slide.type === "video";
}
function Video({ augment }) {
    augment(({ render: { slide: renderSlide, ...restRender }, video, ...restProps }) => ({
        render: {
            slide: ({ slide, offset, rect }) => {
                var _a;
                if (isVideoSlide(slide)) {
                    return (react.createElement(VideoSlide, { key: (_a = slide.sources) === null || _a === void 0 ? void 0 : _a.map((source) => source.src).join(" "), slide: slide, offset: offset }));
                }
                return renderSlide === null || renderSlide === void 0 ? void 0 : renderSlide({ slide, offset, rect });
            },
            ...restRender,
        },
        video: resolveVideoProps(video),
        ...restProps,
    }));
}



// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css
var thumbnails = __webpack_require__(53402);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/styles.css
var dist_styles = __webpack_require__(50781);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/counter/counter.css
var counter = __webpack_require__(60016);
// EXTERNAL MODULE: ./components/productGallery/ProductGallery.module.scss
var ProductGallery_module = __webpack_require__(61406);
var ProductGallery_module_default = /*#__PURE__*/__webpack_require__.n(ProductGallery_module);
;// CONCATENATED MODULE: ./components/productGallery/ProductGallery.js


function ProductGallery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductGallery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductGallery_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductGallery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var gallerySwiperParams = {
  navigation: {
    nextEl: (ProductGallery_module_default()).swiperButtonNext,
    prevEl: (ProductGallery_module_default()).swiperButtonPrev
  },
  pagination: {
    el: ".swiper-pagination.".concat((ProductGallery_module_default()).swiperPagination),
    clickable: true
  },
  renderPrevButton: function renderPrevButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductGallery_module_default()).swiperButtonPrev,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "m-arrow-left"
      })
    });
  },
  renderNextButton: function renderNextButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductGallery_module_default()).swiperButtonNext,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "m-arrow-right"
      })
    });
  },
  preventInteractionOnTransition: true,
  watchSlidesVisibility: true,
  watchOverflow: true,
  resistanceRatio: 0
};
var thumbnailSwiperParams = {
  direction: 'vertical',
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  watchSlidesVisibility: true,
  resistanceRatio: 0,
  grabCursor: true
};
var lightBoxStyle = {
  container: {
    backgroundColor: '#fff'
  },
  thumbnailsContainer: {
    backgroundColor: '#fff'
  },
  thumbnail: {
    backgroundColor: '#fff',
    border: 'none'
  }
};
/* harmony default export */ var ProductGallery = (/*#__PURE__*/(0,react.memo)(function ProductGallery(_ref) {
  var images = _ref.images,
      thumbs = _ref.thumbs,
      zoom = _ref.zoom,
      alt = _ref.alt,
      title = _ref.title,
      onLoadingError = _ref.onLoadingError;
  var refs = (0,react.useRef)(images.reduce(function (acc, _img, ind) {
    acc[ind] = /*#__PURE__*/(0,react.createRef)();
    return acc;
  }, {}));

  var _useState = (0,react.useState)(0),
      activeThumb = _useState[0],
      setActiveThumb = _useState[1];

  var _useState2 = (0,react.useState)(-1),
      zoomedImageIndex = _useState2[0],
      setZoomedImageIndex = _useState2[1];

  var _useState3 = (0,react.useState)({
    isEnd: false,
    isBeginning: true
  }),
      thumbsState = _useState3[0],
      setThumbsState = _useState3[1];

  var gallerySwiperRef = (0,react.useRef)(null);
  var thumbsSwiperRef = (0,react.useRef)(null);

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isMobile = _useWindowSize.isMobile;

  var plugins = isMobile ? [Zoom, Video, Counter] : [Thumbnails, Zoom, Video];
  var slides = (0,react.useMemo)(function () {
    return zoom.map(function (image) {
      if (image.url) {
        return {
          type: 'video',
          poster: zoom[0].x2,
          sources: [{
            src: image.url,
            type: 'video/mp4'
          }]
        };
      }

      return {
        src: image.x2
      };
    });
  }, [zoom]);

  var updateThumbsState = function updateThumbsState() {
    if (!thumbsSwiperRef.current) return;
    var thumbsInstance = thumbsSwiperRef.current.swiper;
    var totalSlides = thumbsInstance.slides.length;
    var isBeginning = activeThumb === 0;
    var isEnd = activeThumb === totalSlides - 1;
    setThumbsState({
      isEnd: isEnd,
      isBeginning: isBeginning
    });
  };

  (0,react.useEffect)(function () {
    updateThumbsState();
  }, [activeThumb]);

  var onThumbClick = function onThumbClick(pos) {
    var galleryInstance = gallerySwiperRef.current.swiper;
    var thumbsInstance = thumbsSwiperRef.current.swiper;
    var totalSlides = thumbsInstance.slides.length;

    if (pos !== activeThumb && pos >= 0 && pos <= totalSlides - 1) {
      galleryInstance.slideTo(pos, 0);
      thumbsInstance.slideTo(pos);
      setActiveThumb(pos);
    }
  };

  var onThumbNext = function onThumbNext() {
    onThumbClick(activeThumb + 1);
  };

  var onThumbPrev = function onThumbPrev() {
    onThumbClick(activeThumb - 1);
  };

  var handleZoomClick = function handleZoomClick(index) {
    setZoomedImageIndex(index);
  };

  var onGallerySlideChange = (0,react.useCallback)(function () {
    var _images$activeSlide;

    var galleryInstance = gallerySwiperRef.current.swiper;
    var thumbsInstance = thumbsSwiperRef.current.swiper;
    var activeSlide = galleryInstance.activeIndex;

    if (((_images$activeSlide = images[activeSlide]) === null || _images$activeSlide === void 0 ? void 0 : _images$activeSlide.type) === 'video') {
      var _refs$current$activeS;

      var video = (_refs$current$activeS = refs.current[activeSlide]) === null || _refs$current$activeS === void 0 ? void 0 : _refs$current$activeS.current;
      if (video) video.play();
    }

    thumbsInstance.slideTo(activeSlide);
    setActiveThumb(activeSlide);
    updateThumbsState();

    if (galleryInstance.zoom.scale > 1) {
      galleryInstance.zoom.out();
      galleryInstance.zoom.disable();
    }
  }, []);
  (0,react.useEffect)(function () {
    var galleryInstance = gallerySwiperRef.current.swiper;

    if (galleryInstance) {
      galleryInstance.on('slideChange', onGallerySlideChange);
    }

    return function () {
      if (galleryInstance) {
        galleryInstance.off('slideChange', onGallerySlideChange);
      }
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductGallery_module_default()).gallery,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductGallery_module_default()).thumbs,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((react_id_swiper_lib_default()), ProductGallery_objectSpread(ProductGallery_objectSpread({
          ref: thumbsSwiperRef
        }, thumbnailSwiperParams), {}, {
          children: (thumbs === null || thumbs === void 0 ? void 0 : thumbs.length) > 0 ? thumbs.map(function (thumb, ind) {
            var thumbAlt = alt ? "".concat(alt, " | \u0424\u043E\u0442\u043E ").concat(ind + 1) : '';
            var thumbTitle = title || '';
            var isVideo = (thumb === null || thumb === void 0 ? void 0 : thumb.type) === 'video';
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((ProductGallery_module_default()).thumb, activeThumb === ind ? (ProductGallery_module_default()).thumbActive : (ProductGallery_module_default()).thumbNotActive, isVideo && (ProductGallery_module_default()).thumbIsVideo),
              onClick: function onClick() {
                return onThumbClick(ind);
              },
              children: isVideo ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (ProductGallery_module_default()).thumbVideo,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                  name: "play"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "\u0412\u0438\u0434\u0435\u043E"
                })]
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(picture, ProductGallery_objectSpread(ProductGallery_objectSpread({}, thumb), {}, {
                alt: thumbAlt,
                title: thumbTitle,
                onLoadError: onLoadingError
              }))
            }, thumbAlt);
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((ProductGallery_module_default()).thumb, (ProductGallery_module_default()).thumbActive),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(picture, {
              src: "/images/svg/pattern-order-picture.svg",
              alt: "image-pattern"
            })
          })
        })), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (0,clsx_m/* default */.Z)((ProductGallery_module_default()).thumbNavBtn, (ProductGallery_module_default()).thumbsPrev),
          disabled: thumbsState.isBeginning,
          onClick: onThumbPrev,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
            name: "m-arrow-left"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (0,clsx_m/* default */.Z)((ProductGallery_module_default()).thumbNavBtn, (ProductGallery_module_default()).thumbsNext),
          disabled: thumbsState.isEnd,
          onClick: onThumbNext,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
            name: "m-arrow-left"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductGallery_module_default()).galleryMain,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((react_id_swiper_lib_default()), ProductGallery_objectSpread(ProductGallery_objectSpread({
          ref: gallerySwiperRef
        }, gallerySwiperParams), {}, {
          children: (images === null || images === void 0 ? void 0 : images.length) > 0 ? images.map(function (image, idx) {
            var x2 = image === null || image === void 0 ? void 0 : image.x2;
            var imageAlt = alt ? "".concat(alt, " | \u0424\u043E\u0442\u043E ").concat(idx + 1) : '';
            var imageTitle = title || '';
            var isVideo = (image === null || image === void 0 ? void 0 : image.type) === 'video';
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((ProductGallery_module_default()).galleryImg, isVideo && (ProductGallery_module_default()).blockVideo),
              video: isVideo,
              children: isVideo ? /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
                playsInline: true,
                autoplay: true,
                ref: refs.current[idx],
                muted: true,
                loop: true,
                src: image.url,
                className: (ProductGallery_module_default()).image
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  className: (ProductGallery_module_default()).image,
                  src: x2,
                  alt: imageAlt,
                  title: imageTitle,
                  onClick: function onClick() {
                    return handleZoomClick(idx);
                  },
                  onError: onLoadingError
                })
              })
            }, imageAlt);
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((ProductGallery_module_default()).galleryImg),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: (ProductGallery_module_default()).patternImage,
              src: "/images/svg/pattern-order-picture.svg",
              alt: "image-pattern"
            })
          })
        }))
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Lightbox, {
      styles: lightBoxStyle,
      index: zoomedImageIndex,
      slides: slides,
      open: zoomedImageIndex >= 0,
      close: function close() {
        return setZoomedImageIndex(-1);
      },
      plugins: plugins,
      render: {
        iconPrev: function iconPrev() {
          return isMobile ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
            className: (ProductGallery_module_default()).galleryIcon,
            name: "arrow-left-gallery"
          });
        },
        iconNext: function iconNext() {
          return isMobile ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
            className: (ProductGallery_module_default()).galleryIcon,
            name: "arrow-right-gallery"
          });
        },
        iconClose: function iconClose() {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
            name: "close-gallery"
          });
        },
        buttonZoom: function buttonZoom() {
          return null;
        }
      },
      thumbnails: {
        position: isMobile ? 'bottom' : 'start',
        vignette: false
      },
      zoom: {
        maxZoomPixelRatio: 2,
        zoomInMultiplier: 2
      },
      video: {
        controls: false,
        playsInline: true,
        autoPlay: true,
        loop: true
      },
      counter: {
        container: {
          style: {
            color: '#171717',
            filter: 'none',
            width: '96%',
            marginTop: 16,
            textAlign: 'center'
          }
        }
      }
    })]
  });
}));
;// CONCATENATED MODULE: ./components/productGallery/index.js

/* harmony default export */ var productGallery = (ProductGallery);
// EXTERNAL MODULE: ./components/smartBanner/SmartBanner.module.scss
var SmartBanner_module = __webpack_require__(86814);
var SmartBanner_module_default = /*#__PURE__*/__webpack_require__.n(SmartBanner_module);
;// CONCATENATED MODULE: ./components/smartBanner/SmartBanner.js







var domain = 'https://fh.by';
var SmartBanner = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var isVisibleBanner = _ref.isVisibleBanner,
      setIsVisibleBanner = _ref.setIsVisibleBanner;
  var router = (0,next_router.useRouter)();
  var iconClick = (0,react.useCallback)(function () {
    if (true) {
      // sessionStorage.setItem('smart-banner', true);
      setIsVisibleBanner(false);
    }
  }, []);

  var getUrl = function getUrl() {
    var path = domain + router.asPath;
    var params = '';

    if (sessionStorage.getItem('utm_source')) {
      params += "&utm_source=".concat(sessionStorage.getItem('utm_source'));
    }

    if (sessionStorage.getItem('utm_medium')) {
      params += "&utm_medium=".concat(sessionStorage.getItem('utm_medium'));
    }

    if (sessionStorage.getItem('utm_campaign')) {
      params += "&utm_campaign=".concat(sessionStorage.getItem('utm_campaign'));
    }

    if (sessionStorage.getItem('utm_content')) {
      params += "&utm_content=".concat(sessionStorage.getItem('utm_content'));
    }

    if (sessionStorage.getItem('utm_term')) {
      params += "&utm_term=".concat(sessionStorage.getItem('utm_term'));
    }

    if (sessionStorage.getItem('gclid')) {
      params += "&gclid=".concat(sessionStorage.getItem('gclid'));
    }

    var link = encodeURIComponent(path);
    return "https://link.fh.by/?isi=1518240278&ibi=com%2Ewebsecret%2Efh&efr=0&imv=3%2E7%2E0&link=".concat(link, "&amv=74&ofl=").concat(link, "&apn=com%2Ewebsecret%2Efh").concat(params);
  };

  var handleClick = function handleClick() {
    window.open(getUrl(), '_blank');
  };

  return isVisibleBanner ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SmartBanner_module_default()).banner,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SmartBanner_module_default()).appInfo,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "close",
        className: (SmartBanner_module_default()).icon,
        stroke: "#fff",
        onClick: iconClick
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SmartBanner_module_default()).logoImage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 32,
          height: 32,
          src: "/images/monogram_logo.webp",
          alt: "monogram logo"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SmartBanner_module_default()).text,
        children: "\u0412 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 FH.BY \u0435\u0449\u0435 \u0443\u0434\u043E\u0431\u043D\u0435\u0435 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u044B \u0432\u0430\u0448\u0435\u0439 \u043C\u0435\u0447\u0442\u044B"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: handleClick,
      className: (SmartBanner_module_default()).button,
      children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438"
    })]
  }) : null;
});
/* harmony default export */ var smartBanner_SmartBanner = (SmartBanner);
;// CONCATENATED MODULE: ./components/smartBanner/index.js

/* harmony default export */ var smartBanner = (smartBanner_SmartBanner);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-c7a4d7ce.esm.js + 2 modules
var index_c7a4d7ce_esm = __webpack_require__(11604);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(23157);
// EXTERNAL MODULE: ./components/select/Select.module.scss
var Select_module = __webpack_require__(57002);
var Select_module_default = /*#__PURE__*/__webpack_require__.n(Select_module);
;// CONCATENATED MODULE: ./components/select/Select.js


var Select_excluded = ["children"],
    Select_excluded2 = ["value", "name", "placeholder", "options", "onChange", "isDisabled", "isSearchable", "className", "error", "noOptionsMessage"];

function Select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Select_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ValueContainer = index_c7a4d7ce_esm.c.ValueContainer,
    Select_Placeholder = index_c7a4d7ce_esm.c.Placeholder,
    Menu = index_c7a4d7ce_esm.c.Menu;
var theme = {
  colors: {
    primary: '#59896D',
    neutral0: '#fff',
    neutral20: '#F0F0F0',
    neutral50: '#BBBBBB'
  }
};

var CustomMenuList = function CustomMenuList(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (Select_module_default()).scrollbar,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: props.children
    })
  });
};

var CustomValueContainer = function CustomValueContainer(_ref) {
  var _props$selectProps, _props$selectProps$va, _value$;

  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Select_excluded);

  var value = props.getValue();
  var disabledCurrentValue = ((_props$selectProps = props.selectProps) === null || _props$selectProps === void 0 ? void 0 : (_props$selectProps$va = _props$selectProps.value) === null || _props$selectProps$va === void 0 ? void 0 : _props$selectProps$va.has) === false;
  var bigClass = null;

  if (value && (_value$ = value[0]) !== null && _value$ !== void 0 && _value$.label) {
    if (value[0].label.length > 25) {
      bigClass = (Select_module_default()).valueContainer80;
    }

    if (value[0].label.length > 35) {
      bigClass = (Select_module_default()).valueContainer90;
    }

    if (value[0].label.length > 45) {
      bigClass = (Select_module_default()).valueContainer115;
    }

    if (value[0].label.length > 60) {
      bigClass = (Select_module_default()).valueContainer105;
    }

    if (value[0].label.length > 80) {
      bigClass = (Select_module_default()).valueContainer125;
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ValueContainer, Select_objectSpread(Select_objectSpread({}, props), {}, {
    className: value.length ? (0,clsx_m/* default */.Z)((Select_module_default()).valueContainer, bigClass, disabledCurrentValue && (Select_module_default()).valueContainerDisabled) : null,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Select_Placeholder, Select_objectSpread(Select_objectSpread({}, props), {}, {
      isFocused: props.isFocused,
      children: props.selectProps.placeholder
    })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: value.length ? value[0].label : ''
    }), children[1]]
  }));
};

var CustomOption = function CustomOption(props) {
  var _props$data, _props$currentValue;

  return /*#__PURE__*/(0,react.createElement)(index_c7a4d7ce_esm.c.Option, Select_objectSpread(Select_objectSpread({}, props), {}, {
    className: (Select_module_default()).option,
    key: props.data.label
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (Select_module_default()).optionLabel,
    children: props.data.label
  }), (props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.info) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((Select_module_default()).info, (props === null || props === void 0 ? void 0 : (_props$currentValue = props.currentValue) === null || _props$currentValue === void 0 ? void 0 : _props$currentValue.value) === props.data.value && (Select_module_default()).selected),
    children: props.data.info
  }));
};

var customStyles = {
  placeholder: function placeholder(provided, state) {
    var _state$selectProps, _state$selectProps$va, _state$selectProps2;

    var hasValue = !!((_state$selectProps = state.selectProps) !== null && _state$selectProps !== void 0 && (_state$selectProps$va = _state$selectProps.value) !== null && _state$selectProps$va !== void 0 && _state$selectProps$va.value);
    var content = (_state$selectProps2 = state.selectProps) !== null && _state$selectProps2 !== void 0 && _state$selectProps2.name.includes('size') ? {} : {
      '::after': {
        content: '"*"'
      }
    };
    return Select_objectSpread(Select_objectSpread({}, provided), {}, {
      position: 'absolute',
      top: hasValue ? -15 : provided.top,
      transition: 'top 0.1s, font-size 0.1s',
      fontSize: hasValue ? 14 : 20,
      background: hasValue && '#fff',
      paddingLeft: 2,
      paddingRight: 2
    }, content);
  },
  valueContainer: function valueContainer(_provided, state) {
    return {
      height: 44,
      display: 'flex',
      alignItems: 'center',
      marginLeft: 16,
      fontSize: 20,
      color: state.isDisabled ? '#959595' : '#171717'
    };
  },
  menu: function menu(provided, state) {
    return Select_objectSpread(Select_objectSpread({}, provided), {}, {
      marginTop: 1,
      borderRadius: 16,
      zIndex: 2
    });
  },
  control: function control(provided, state) {
    var background = state.isDisabled ? '#F8F8F8' : provided.background;
    var border = state.isDisabled ? '1px solid #BBBBBB' : provided.border;
    return Select_objectSpread(Select_objectSpread({}, provided), {}, {
      background: background,
      border: border,
      flexWrap: 'nowrap',
      borderRadius: 16,
      boxShadow: 'none'
    });
  }
};

var errorStyles = Select_objectSpread(Select_objectSpread({}, customStyles), {}, {
  control: function control(provided, state) {
    var _state$selectProps3, _state$selectProps3$v;

    var hasValue = !!((_state$selectProps3 = state.selectProps) !== null && _state$selectProps3 !== void 0 && (_state$selectProps3$v = _state$selectProps3.value) !== null && _state$selectProps3$v !== void 0 && _state$selectProps3$v.value);
    var border = '1px solid #EA5656';
    var backgroundColor = hasValue ? provided.backgroundColor : '#F8F8F8';
    return Select_objectSpread(Select_objectSpread({}, provided), {}, {
      border: border,
      backgroundColor: backgroundColor
    });
  },
  placeholder: function placeholder(provided, state) {
    var _state$selectProps4, _state$selectProps4$v;

    var hasValue = !!((_state$selectProps4 = state.selectProps) !== null && _state$selectProps4 !== void 0 && (_state$selectProps4$v = _state$selectProps4.value) !== null && _state$selectProps4$v !== void 0 && _state$selectProps4$v.value);
    var color = hasValue ? provided.color : '#EA5656';
    return Select_objectSpread(Select_objectSpread({}, provided), {}, {
      position: 'absolute',
      top: hasValue ? -15 : provided.top,
      transition: 'top 0.1s, font-size 0.1s',
      fontSize: hasValue && 14,
      background: hasValue && '#fff',
      paddingLeft: 2,
      paddingRight: 2,
      color: color,
      '::after': {
        content: '"*"'
      }
    });
  }
});

var RSelect = /*#__PURE__*/(0,react.forwardRef)(function (_ref2, ref) {
  var value = _ref2.value,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      options = _ref2.options,
      onChange = _ref2.onChange,
      isDisabled = _ref2.isDisabled,
      _ref2$isSearchable = _ref2.isSearchable,
      isSearchable = _ref2$isSearchable === void 0 ? false : _ref2$isSearchable,
      className = _ref2.className,
      error = _ref2.error,
      _noOptionsMessage = _ref2.noOptionsMessage,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, Select_excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, Select_objectSpread({
    value: value,
    ref: ref,
    className: (0,clsx_m/* default */.Z)((Select_module_default()).select, className),
    name: name,
    theme: theme,
    options: options,
    isSearchable: isSearchable !== null && isSearchable !== void 0 ? isSearchable : false,
    styles: error ? errorStyles : customStyles,
    onChange: onChange,
    isDisabled: isDisabled,
    placeholder: placeholder,
    noOptionsMessage: function noOptionsMessage() {
      return _noOptionsMessage !== null && _noOptionsMessage !== void 0 ? _noOptionsMessage : null;
    },
    components: {
      IndicatorSeparator: null,
      ValueContainer: CustomValueContainer,
      Option: function Option(props) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CustomOption, Select_objectSpread(Select_objectSpread({}, props), {}, {
          currentValue: value
        }));
      },
      MenuList: CustomMenuList
    }
  }, props));
});
/* harmony default export */ var Select = (RSelect);
;// CONCATENATED MODULE: ./components/select/index.js

/* harmony default export */ var components_select = (Select);
// EXTERNAL MODULE: ./components/selectBase/SelectBase.module.scss
var SelectBase_module = __webpack_require__(85030);
var SelectBase_module_default = /*#__PURE__*/__webpack_require__.n(SelectBase_module);
;// CONCATENATED MODULE: ./components/selectBase/SelectBase.js







var SelectBase = function SelectBase(_ref) {
  var _clsx;

  var title = _ref.title,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _ref$handleClear = _ref.handleClear,
      handleClear = _ref$handleClear === void 0 ? function () {} : _ref$handleClear,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children,
      _ref$closeOnClick = _ref.closeOnClick,
      closeOnClick = _ref$closeOnClick === void 0 ? false : _ref$closeOnClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onOpen = _ref.onOpen;
  var wrapper = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var onClickOutside = function onClickOutside(e) {
    var _wrapper$current;

    if (closeOnClick) {
      if (open) {
        setOpen(!open);
      }

      return;
    }

    if ((!(wrapper !== null && wrapper !== void 0 && (_wrapper$current = wrapper.current) !== null && _wrapper$current !== void 0 && _wrapper$current.contains(e.target)) || wrapper.current === e.target) && open) {
      setOpen(!open);
    }
  };

  (0,react.useEffect)(function () {
    if (open) {
      document.addEventListener('click', onClickOutside);
    }

    if (onOpen) {
      onOpen(open);
    }

    return function () {
      if (open) {
        document.removeEventListener('click', onClickOutside);
      }
    };
  }, [open, onClickOutside, onOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SelectBase_module_default()).select,
    ref: wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      "data-sort": "sort-field",
      className: (0,clsx_m/* default */.Z)((_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (SelectBase_module_default()).head, true), (0,defineProperty/* default */.Z)(_clsx, (SelectBase_module_default()).headHover, !disabled), (0,defineProperty/* default */.Z)(_clsx, (SelectBase_module_default()).selected, selected && !disabled), (0,defineProperty/* default */.Z)(_clsx, (SelectBase_module_default()).open, open), (0,defineProperty/* default */.Z)(_clsx, (SelectBase_module_default()).disabled, disabled), _clsx)),
      onClick: function onClick() {
        if (!disabled) {
          setOpen(!open);
        }
      },
      children: [title, /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: (0,clsx_m/* default */.Z)((SelectBase_module_default()).clear, selected && !disabled && (SelectBase_module_default()).visibleClear),
        onClick: handleClear
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((SelectBase_module_default()).body, open && (SelectBase_module_default()).visibleBody),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SelectBase_module_default()).content,
        children: children
      })
    })]
  });
};

/* harmony default export */ var selectBase_SelectBase = (SelectBase);
;// CONCATENATED MODULE: ./components/selectBase/index.js

/* harmony default export */ var selectBase = (selectBase_SelectBase);
;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/assert.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/objectToGetParams.js
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return encodeURIComponent(key) + "=" + encodeURIComponent(String(value));
    });
    return params.length > 0 ? "?" + params.join('&') : '';
}

// EXTERNAL MODULE: ./node_modules/react-share/node_modules/classnames/index.js
var classnames = __webpack_require__(97567);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/react-share/es/ShareButton.js
var ShareButton_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height,
        width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return key + "=" + config[key]; })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    ShareButton_extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-" + networkName;
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/VKShareButton.js



function vkLink(url, _a) {
    var title = _a.title, image = _a.image, noParse = _a.noParse, noVkLinks = _a.noVkLinks;
    assert(url, 'vk.url');
    return ('https://vk.com/share.php' +
        objectToGetParams({
            url: url,
            title: title,
            image: image,
            noparse: noParse ? 1 : 0,
            no_vk_links: noVkLinks ? 1 : 0,
        }));
}
var VKShareButton = hocs_createShareButton('vk', vkLink, function (props) { return ({
    title: props.title,
    image: props.image,
    noParse: props.noParse,
    noVkLinks: props.noVkLinks,
}); }, {
    windowWidth: 660,
    windowHeight: 460,
});
/* harmony default export */ var es_VKShareButton = (VKShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createIcon.js
var createIcon_assign = (undefined && undefined.__assign) || function () {
    createIcon_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createIcon_assign.apply(this, arguments);
};
var createIcon_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

function createIcon_createIcon(iconConfig) {
    var Icon = function (_a) {
        var bgStyle = _a.bgStyle, borderRadius = _a.borderRadius, iconFillColor = _a.iconFillColor, round = _a.round, size = _a.size, rest = createIcon_rest(_a, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
        return (react.createElement("svg", createIcon_assign({ viewBox: "0 0 64 64", width: size, height: size }, rest),
            round ? (react.createElement("circle", { cx: "32", cy: "32", r: "31", fill: iconConfig.color, style: bgStyle })) : (react.createElement("rect", { width: "64", height: "64", rx: borderRadius, ry: borderRadius, fill: iconConfig.color, style: bgStyle })),
            react.createElement("path", { d: iconConfig.path, fill: iconFillColor })));
    };
    Icon.defaultProps = {
        bgStyle: {},
        borderRadius: 0,
        iconFillColor: 'white',
        size: 64,
    };
    return Icon;
}

;// CONCATENATED MODULE: ./node_modules/react-share/es/VKIcon.js

var VKIcon = createIcon_createIcon({
    color: '#45668e',
    networkName: 'vk',
    path: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
});
/* harmony default export */ var es_VKIcon = (VKIcon);

;// CONCATENATED MODULE: ./node_modules/react-share/es/FacebookShareButton.js



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    assert(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        objectToGetParams({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = hocs_createShareButton('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_FacebookShareButton = (FacebookShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/FacebookIcon.js

var FacebookIcon = createIcon_createIcon({
    color: '#3b5998',
    networkName: 'facebook',
    path: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
});
/* harmony default export */ var es_FacebookIcon = (FacebookIcon);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TwitterShareButton.js



function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    assert(url, 'twitter.url');
    assert(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    assert(Array.isArray(related), 'twitter.related is not an array');
    return ('https://twitter.com/share' +
        objectToGetParams({
            url: url,
            text: title,
            via: via,
            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
            related: related.length > 0 ? related.join(',') : undefined,
        }));
}
var TwitterShareButton = hocs_createShareButton('twitter', twitterLink, function (props) { return ({
    hashtags: props.hashtags,
    title: props.title,
    via: props.via,
    related: props.related,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TwitterShareButton = (TwitterShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TwitterIcon.js

var TwitterIcon = createIcon_createIcon({
    color: '#00aced',
    networkName: 'twitter',
    path: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
});
/* harmony default export */ var es_TwitterIcon = (TwitterIcon);

;// CONCATENATED MODULE: ./node_modules/react-share/es/ViberShareButton.js



function viberLink(url, _a) {
    var title = _a.title, separator = _a.separator;
    assert(url, 'viber.url');
    return ('viber://forward' +
        objectToGetParams({
            text: title ? title + separator + url : url,
        }));
}
var ViberShareButton = hocs_createShareButton('viber', viberLink, function (props) { return ({
    title: props.title,
    separator: props.separator || ' ',
}); }, {
    windowWidth: 660,
    windowHeight: 460,
});
/* harmony default export */ var es_ViberShareButton = (ViberShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/ViberIcon.js

var ViberIcon = createIcon_createIcon({
    color: '#7C529E',
    networkName: 'viber',
    path: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
});
/* harmony default export */ var es_ViberIcon = (ViberIcon);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TelegramShareButton.js



function telegramLink(url, _a) {
    var title = _a.title;
    assert(url, 'telegram.url');
    return ('https://telegram.me/share/url' +
        objectToGetParams({
            url: url,
            text: title,
        }));
}
var TelegramShareButton = hocs_createShareButton('telegram', telegramLink, function (props) { return ({
    title: props.title,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TelegramShareButton = (TelegramShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TelegramIcon.js

var TelegramIcon = createIcon_createIcon({
    color: '#37aee2',
    networkName: 'telegram',
    path: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
});
/* harmony default export */ var es_TelegramIcon = (TelegramIcon);

// EXTERNAL MODULE: ./components/share/Share.module.scss
var Share_module = __webpack_require__(99809);
var Share_module_default = /*#__PURE__*/__webpack_require__.n(Share_module);
;// CONCATENATED MODULE: ./components/share/Share.js






var Share = function Share(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (Share_module_default()).title,
      children: "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: (Share_module_default()).list,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (0,clsx_m/* default */.Z)((Share_module_default()).item, (Share_module_default()).vk),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_VKShareButton, {
          url: url,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_VKIcon, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (0,clsx_m/* default */.Z)((Share_module_default()).item, (Share_module_default()).fb),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_FacebookShareButton, {
          url: url,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_FacebookIcon, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (Share_module_default()).item,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_TwitterShareButton, {
          url: url,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_TwitterIcon, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (Share_module_default()).item,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_ViberShareButton, {
          url: url,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_ViberIcon, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (Share_module_default()).item,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_TelegramShareButton, {
          url: url,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_TelegramIcon, {})
        })
      })]
    })]
  });
};

/* harmony default export */ var share_Share = (Share);
;// CONCATENATED MODULE: ./components/share/index.js

/* harmony default export */ var share = (share_Share);
;// CONCATENATED MODULE: ./components/UserNav.js



var UserNav_excluded = ["render"];

function UserNav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UserNav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UserNav_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UserNav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ViewDefault = function ViewDefault(_ref) {
  var link = _ref.link;
  var href = link.href,
      as = link.as,
      title = link.title,
      _link$isLogout = link.isLogout,
      isLogout = _link$isLogout === void 0 ? false : _link$isLogout;
  return isLogout ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    type: "button",
    children: title
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: href,
    as: as,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      children: title
    })
  });
};

var UserNav = function UserNav(_ref2) {
  var _ref2$render = _ref2.render,
      View = _ref2$render === void 0 ? ViewDefault : _ref2$render,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, UserNav_excluded);

  var types = ['user-profile', 'user-orders', 'user-discount', 'user-newsletters', 'user-returns'];
  var links = types.map(function (type) {
    var _getLinkProps = (0,getLinkProps/* default */.Z)({
      type: type
    }),
        _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 3),
        href = _getLinkProps2[0],
        as = _getLinkProps2[1],
        title = _getLinkProps2[2];

    return {
      href: href,
      as: as,
      title: title
    };
  });
  links.push({
    title: 'Выход',
    isLogout: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: links.map(function (link) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(View, UserNav_objectSpread({
        link: link
      }, props), link.title);
    })
  });
};

/* harmony default export */ var components_UserNav = (UserNav);
;// CONCATENATED MODULE: ./components/userNavItem/UserNavItem.js





var UserNavItem_UserNavItem = function UserNavItem(_ref) {
  var link = _ref.link;
  var href = link.href,
      as = link.as,
      title = link.title,
      _link$isLogout = link.isLogout,
      isLogout = _link$isLogout === void 0 ? false : _link$isLogout;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledPage.NavItem */.Ft.NavItem, {
    children: isLogout ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledPage.NavLink */.Ft.NavLink, {
      as: "button",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(logoutModal_LogoutModal, {
        isProfile: true
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(activeLink, {
      href: href,
      as: as,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_styles/* StyledPage.NavLink */.Ft.NavLink, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: title
        })
      })
    })
  });
};

/* harmony default export */ var userNavItem_UserNavItem = (UserNavItem_UserNavItem);
;// CONCATENATED MODULE: ./components/userNavItem/index.js

/* harmony default export */ var userNavItem = (userNavItem_UserNavItem);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./lib/getProductWithoutQuantity.js
var lib_getProductWithoutQuantity = __webpack_require__(3506);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./components/wishlistBtn/WishlistBtn.js













var WishlistBtn = function WishlistBtn(_ref) {
  var product = _ref.product,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? true : _ref$large,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? false : _ref$border,
      _ref$getWishlist = _ref.getWishlist,
      getWishlist = _ref$getWishlist === void 0 ? null : _ref$getWishlist,
      _ref$isCatalog = _ref.isCatalog,
      isCatalog = _ref$isCatalog === void 0 ? false : _ref$isCatalog,
      _ref$isHideSizes = _ref.isHideSizes,
      isHideSizes = _ref$isHideSizes === void 0 ? false : _ref$isHideSizes,
      _ref$isCart = _ref.isCart,
      isCart = _ref$isCart === void 0 ? false : _ref$isCart,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 1 : _ref$index,
      _ref$currentSize = _ref.currentSize,
      currentSize = _ref$currentSize === void 0 ? null : _ref$currentSize,
      _ref$ids = _ref.ids,
      configIds = _ref$ids === void 0 ? null : _ref$ids,
      _ref$pageName = _ref.pageName,
      pageName = _ref$pageName === void 0 ? null : _ref$pageName,
      _ref$favoriteId = _ref.favoriteId,
      favoriteId = _ref$favoriteId === void 0 ? null : _ref$favoriteId,
      selectedVariantId = _ref.selectedVariantId;
  var dispatch = (0,es/* useDispatch */.I0)();
  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);
  var productId = isHideSizes ? product.model.id : selectedVariantId || product.external_id || product.id;
  var ids = (0,es/* useSelector */.v9)(store/* wishlistIdsSelector */._7);
  var isActive = (configIds || ids).some(function (item) {
    return currentSize && currentSize.value !== 'none' && !isHideSizes ? item.product_id == productId : item.model_id == product.model.id;
  });

  var _useState = (0,react.useState)(isActive),
      active = _useState[0],
      setActive = _useState[1];

  var mindboxDeviceUUID = js_cookie_default().get('mindboxDeviceUUID');
  (0,react.useEffect)(function () {
    setActive(isActive);
  }, [isActive]);

  var toggle = function toggle(e) {
    e.preventDefault();
    e.stopPropagation(); // const favorites = products.slice().filter(item => item.external_id !== product.external_id);

    if (!active) {
      var putIntoWishlist = function putIntoWishlist() {
        dispatch((0,wishlistSlice/* createInWishlist */.JY)({
          id: !isHideSizes && currentSize ? productId : null,
          modelId: product.model.id,
          mindboxDeviceUUID: mindboxDeviceUUID || '',
          onSuccess: function onSuccess() {
            var name = pageName !== null && pageName !== void 0 ? pageName : 'Страница товара';

            if (isCatalog) {
              name = 'Каталог товаров';
            } else if (isCart) {
              name = 'Корзина';
            }

            Ecommerce/* default.viewItemList */.ZP.viewItemList((0,lib_getProductWithoutQuantity/* default */.Z)([product]), currency, name, 'add_to_wishlist', index);
          },
          onError: function onError() {
            setActive(false);
            dispatch((0,sessionSlice/* createSession */.ed)(true, undefined, {
              forceRefresh: true
            }));
          }
        }));
      };

      setActive(function (prev) {
        return !prev;
      });
      var newIds = ids.filter(function (item) {
        return item.model_id != product.model.id;
      });
      dispatch((0,wishlistSlice/* updateWishlistIds */.Mu)({
        ids: [].concat((0,toConsumableArray/* default */.Z)(newIds), [currentSize ? {
          product_id: productId,
          model_id: product.model.id
        } : {
          model_id: product.model.id
        }])
      }));
      putIntoWishlist(); // favorites.push(product);
    } else {
      setActive(function (prev) {
        return !prev;
      });
      dispatch((0,wishlistSlice/* updateWishlistIds */.Mu)({
        ids: ids.filter(function (item) {
          return !isHideSizes && currentSize ? item.product_id != productId : item.model_id != product.model.id;
        })
      }));
      dispatch((0,wishlistSlice/* removeFromWishlist */.$f)({
        id: !isHideSizes && currentSize ? productId : null,
        modelId: product.model.id,
        favoriteId: favoriteId ? favoriteId : null,
        mindboxDeviceUUID: mindboxDeviceUUID || '',
        onSuccess: function onSuccess() {
          if (getWishlist) {
            getWishlist();
          }
        },
        onError: function onError() {
          setActive(true);
          dispatch((0,sessionSlice/* createSession */.ed)(true, undefined, {
            forceRefresh: true
          }));
        }
      }));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* LikeButton */.dJ, {
    active: active,
    onClick: toggle,
    large: large,
    border: border,
    isCatalog: isCatalog
  });
};

/* harmony default export */ var wishlistBtn_WishlistBtn = (WishlistBtn);
;// CONCATENATED MODULE: ./components/wishlistBtn/index.js

/* harmony default export */ var wishlistBtn = (wishlistBtn_WishlistBtn);
// EXTERNAL MODULE: ./components/blocks/Blocks.module.scss
var Blocks_module = __webpack_require__(77984);
var Blocks_module_default = /*#__PURE__*/__webpack_require__.n(Blocks_module);
;// CONCATENATED MODULE: ./utils/getShortsId.js
var getShortsId = function getShortsId(link) {
  var lastSlashIndex = link.lastIndexOf('/');
  return link.slice(lastSlashIndex + 1);
};

/* harmony default export */ var utils_getShortsId = (getShortsId);
;// CONCATENATED MODULE: ./components/blocks/index.js


var blocks_excluded = ["type", "is_active", "id", "data"];

function blocks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function blocks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? blocks_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : blocks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Blocks = function Blocks(_ref) {
  var _ref$blocks = _ref.blocks,
      blocks = _ref$blocks === void 0 ? [] : _ref$blocks,
      _ref$isCatalog = _ref.isCatalog,
      isCatalog = _ref$isCatalog === void 0 ? false : _ref$isCatalog;
  // Please, don't move this object outside, thank you
  var components = {
    one_slider: gallery,
    button: blocks_button,
    two_sliders: doubleGallery,
    wysiwyg: htmlBlock,
    map_with_shops: shopsOnMap,
    marquee: marquee,
    separator: divider,
    title_desc_link: titleDescLink,
    youtube: youtubePlayer,
    one_picture: navigationPicturesOld,
    one_picture_different_device: oneImage,
    two_pictures: navigationPictures,
    three_pictures: navigationThreePictures,
    wide_picture: widePicture,
    text_with_picture: textWithSidePicture,
    wide_picture_no_text: widePictureNoText,
    picture_wysiwyg: pictureHtml,
    products: productsSlider,
    selections_products: productsSlider,
    look_with_image: lookImage,
    look_slider: productsSlider,
    look_slider_with_image: lookImageSlider,
    'brand-info': brandInfo,
    four_pictures: fourPictures,
    no_result_text_for_search: noResult,
    catalog_based_on_selections: selectionsCatalog,
    h1: h1,
    offset: offset,
    carousel: carousel,
    big_slides: carousel,
    text_with_links: htmlLinksBlock
  };

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isSmallMobile = _useWindowSize.isSmallMobile;

  var _useState = (0,react.useState)(false),
      isMobile = _useState[0],
      setIsMobile = _useState[1];

  (0,react.useEffect)(function () {
    setIsMobile(isSmallMobile);
  }, [isSmallMobile]); // console.log("🚀 ~ {blocks.map ~ blocks:", blocks)

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: !isCatalog ? (Blocks_module_default()).blocks : undefined,
    children: blocks.map(function (block, ind) {
      var _blocks;

      var _ref2 = block || {},
          type = _ref2.type,
          is_active = _ref2.is_active,
          id = _ref2.id,
          _ref2$data = _ref2.data,
          data = _ref2$data === void 0 ? {} : _ref2$data,
          other = (0,objectWithoutProperties/* default */.Z)(_ref2, blocks_excluded);

      var Component = components[type]; // const blockPosition = ind + 1;
      // const isCustomOffsetBlock =
      //   isCustomOffsetRoute && positionsForCustomOffsets.includes(blockPosition);

      if (!Component || !is_active) {
        return null;
      }

      if (type === 'one_picture' && ((_blocks = blocks[ind - 1]) === null || _blocks === void 0 ? void 0 : _blocks.type) === 'offset') {
        return /*#__PURE__*/(0,react.createElement)(Component, blocks_objectSpread(blocks_objectSpread(blocks_objectSpread({}, data), other), {}, {
          key: id || ind,
          noMargin: true
        }));
      }

      if (type === 'youtube') {
        // for mobile
        if (isMobile) {
          if (!data.shorts && !data.video_url) {
            return null;
          }

          if (data.shorts) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Blocks_module_default()).customWrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(shortsYoutubePlayer, {
                id: utils_getShortsId(data.shorts)
              })
            }, id || ind);
          }
        } // for desktop


        if (!data.video_url) {
          return null;
        }

        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Blocks_module_default()).customWrapper,
          children: /*#__PURE__*/(0,react.createElement)(Component, blocks_objectSpread(blocks_objectSpread(blocks_objectSpread({}, data), other), {}, {
            key: id || ind
          }))
        }, id || ind);
      }

      if (type === 'one_picture') {
        var onePictureData = {
          items: [{
            image: data.image.links,
            title: data.title.text,
            description: data.description.text,
            url: data.url.link
          }]
        };
        return /*#__PURE__*/(0,react.createElement)(Component, blocks_objectSpread(blocks_objectSpread(blocks_objectSpread({}, onePictureData), other), {}, {
          key: id || ind,
          noMargin: true
        }));
      }

      if (type === 'big_slides') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Blocks_module_default()).customWrapper,
          children: /*#__PURE__*/(0,react.createElement)(Component, blocks_objectSpread(blocks_objectSpread(blocks_objectSpread({}, data), other), {}, {
            isBigSlider: true,
            key: id || ind
          }))
        }, id || ind);
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Blocks_module_default()).customWrapper,
        children: /*#__PURE__*/(0,react.createElement)(Component, blocks_objectSpread(blocks_objectSpread(blocks_objectSpread({}, data), other), {}, {
          key: id || ind
        }))
      }, id || ind);
    })
  });
};

/* harmony default export */ var blocks = (Blocks);
// EXTERNAL MODULE: ./components/blocks/brandInfo/BrandInfo.module.scss
var BrandInfo_module = __webpack_require__(30860);
var BrandInfo_module_default = /*#__PURE__*/__webpack_require__.n(BrandInfo_module);
;// CONCATENATED MODULE: ./components/blocks/brandInfo/BrandInfo.js













var Html = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6066)]).then(__webpack_require__.bind(__webpack_require__, 26066));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26066)];
    }
  }
});
var regexp = /href="(.+)"/g;

var getAbsoluteUrl = function getAbsoluteUrl(text, levelUp) {
  var hasLink = text === null || text === void 0 ? void 0 : text.match(regexp);

  if (!hasLink) {
    return text;
  }

  return text.replaceAll(regexp, 'href="/$1"');
};

var BrandBlock = function BrandBlock(_ref) {
  var _data$image, _data$image2, _data$image3, _data$image4;

  var data = _ref.data,
      onClickLink = _ref.onClickLink,
      changeFavorites = _ref.changeFavorites,
      _ref$imageMobileVisib = _ref.imageMobileVisible,
      imageMobileVisible = _ref$imageMobileVisib === void 0 ? false : _ref$imageMobileVisib,
      _ref$isFavorite = _ref.isFavorite,
      isFavorite = _ref$isFavorite === void 0 ? false : _ref$isFavorite,
      _ref$urlLevel = _ref.urlLevel,
      urlLevel = _ref$urlLevel === void 0 ? 1 : _ref$urlLevel;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (BrandInfo_module_default()).main,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (BrandInfo_module_default()).mainText,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (BrandInfo_module_default()).textBlock,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (BrandInfo_module_default()).title,
          children: data.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (BrandInfo_module_default()).text,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Html, {
            html: getAbsoluteUrl(data.text, urlLevel)
          })
        }), data.button === 'link' ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (BrandInfo_module_default()).buttonBlock,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
            type: "defaultBlack",
            classNames: {
              general: (BrandInfo_module_default()).button
            },
            onClick: function onClick() {
              onClickLink(data.link_url);
            },
            children: data.link_text
          })
        }) : data.button !== null && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (BrandInfo_module_default()).buttonBlock,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
            type: isFavorite ? 'primaryBlack' : 'defaultBlack',
            classNames: {
              general: (BrandInfo_module_default()).button
            },
            onClick: function onClick() {
              changeFavorites(data.brand_subscription[0].value);
            },
            children: isFavorite ? 'Добавлен в любимые бренды' : 'Добавить в любимые бренды'
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((BrandInfo_module_default()).imageBlock, imageMobileVisible && (BrandInfo_module_default()).imageBlockVisible),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        title: (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.name,
        alt: (_data$image3 = data.image) === null || _data$image3 === void 0 ? void 0 : _data$image3.name,
        src: (_data$image4 = data.image) === null || _data$image4 === void 0 ? void 0 : _data$image4.url
      }, (_data$image2 = data.image) === null || _data$image2 === void 0 ? void 0 : _data$image2.uid)
    })]
  });
};

var BrandInfo = function BrandInfo(_ref2) {
  var _Cookie$get, _router$query;

  var blocks = _ref2.blocks,
      loadingProducts = _ref2.loading;
  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(true),
      loading = _useState[0],
      setLoading = _useState[1];

  var favoriteBrands = (0,es/* useSelector */.v9)(store/* favoriteBrandsSelector */.mN);
  var mindboxDeviceUUID = (_Cookie$get = js_cookie_default().get('mindboxDeviceUUID')) !== null && _Cookie$get !== void 0 ? _Cookie$get : '';
  var onClickLink = (0,react.useCallback)(function (url) {
    setLoading(true);
    router.push(url);
  }, []);
  var addedToFavorites = (0,react.useCallback)(function (id) {
    dispatch((0,userSlice/* addedFavoriteBrand */.At)({
      params: {
        brand_id: id,
        mindboxDeviceUUID: mindboxDeviceUUID
      },
      onSuccess: function onSuccess() {},
      onError: function onError() {}
    }));
  }, []);
  var deleteFromFavorites = (0,react.useCallback)(function (id) {
    dispatch((0,userSlice/* removeFavoriteBrand */.B4)({
      params: {
        brand_id: id,
        mindboxDeviceUUID: mindboxDeviceUUID
      },
      onSuccess: function onSuccess() {},
      onError: function onError() {}
    }));
  }, []);
  (0,react.useEffect)(function () {
    if (!loadingProducts) {
      setTimeout(function () {
        setLoading(false);
      }, 250);
    }
  }, [router, loadingProducts]);
  (0,react.useEffect)(function () {
    if (loadingProducts) {
      setLoading(true);
    }
  }, [loadingProducts]);

  if (loading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
      className: (0,clsx_m/* default */.Z)((BrandInfo_module_default()).mainBlock, (BrandInfo_module_default()).loader),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {})
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    className: (BrandInfo_module_default()).mainBlock,
    children: blocks.length > 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_FullWidthSlider, {
      bigMargin: true,
      widthLimit: "100%",
      isBrandDescription: true,
      isBrandDescriptionLoading: loading,
      isCarousel: true,
      fullWidth: true,
      noSlideWidth: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      children: blocks.map(function (block, idx) {
        var _block$image, _block$image2;

        var isFavorite = block.button === 'subscription' && favoriteBrands.includes(block.brand_subscription[0].value);
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(BrandBlock, {
            data: block,
            isFavorite: isFavorite,
            onClickLink: onClickLink,
            changeFavorites: isFavorite ? deleteFromFavorites : addedToFavorites,
            imageMobileVisible: block.mobile_visible == 'true'
          }, (block === null || block === void 0 ? void 0 : (_block$image2 = block.image) === null || _block$image2 === void 0 ? void 0 : _block$image2.uid) || idx)
        }, (block === null || block === void 0 ? void 0 : (_block$image = block.image) === null || _block$image === void 0 ? void 0 : _block$image.uid) || idx);
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(BrandBlock, {
      data: blocks[0],
      isFavorite: blocks[0].button === 'subscription' && favoriteBrands.includes(blocks[0].brand_subscription[0].value),
      onClickLink: onClickLink,
      addedToFavorites: addedToFavorites,
      changeFavorites: blocks[0].button === 'subscription' && favoriteBrands.includes(blocks[0].brand_subscription[0].value) ? deleteFromFavorites : addedToFavorites,
      imageMobileVisible: blocks[0].mobile_visible == 'true',
      urlLevel: ((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.typeSlug.length) - 1
    })
  });
};

/* harmony default export */ var brandInfo_BrandInfo = (BrandInfo);
;// CONCATENATED MODULE: ./components/blocks/brandInfo/index.js

/* harmony default export */ var brandInfo = (brandInfo_BrandInfo);
// EXTERNAL MODULE: ./components/blocks/noResult/NoResult.module.scss
var NoResult_module = __webpack_require__(33281);
var NoResult_module_default = /*#__PURE__*/__webpack_require__.n(NoResult_module);
;// CONCATENATED MODULE: ./components/blocks/noResult/NoResult.js









var NoResult = function NoResult(_ref) {
  var button_textBlock = _ref.button_text,
      descriptionBlock = _ref.description,
      titleBlock = _ref.title;

  var _useLocalStorage = (0,use_local_storage/* default */.Z)('searchString', ''),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      searchString = _useLocalStorage2[0],
      _setSearchString = _useLocalStorage2[1];

  var buttonText = button_textBlock ? button_textBlock : 'Изменить запрос';
  var description = descriptionBlock ? descriptionBlock : 'К сожалению, в данный момент по вашему запросу ничего не нашлось. Но мы подготовили для вас много интересных рекомендаций, которые должны вам понравится.';
  var title = titleBlock ? titleBlock : 'Результаты поиска';

  var handleClick = function handleClick() {
    var search = document.getElementById('search-button');
    search.click();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      className: (NoResult_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (NoResult_module_default()).textBlock,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (NoResult_module_default()).title,
          children: [title, " ", searchString && searchString.length > 0 ? "\xAB".concat(searchString, "\xBB") : '']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (NoResult_module_default()).description,
          children: description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (NoResult_module_default()).buttonBlock,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
          type: "defaultBlack",
          classNames: {
            general: (NoResult_module_default()).button
          },
          onClick: handleClick,
          children: buttonText
        })
      })]
    })
  });
};

/* harmony default export */ var noResult_NoResult = (NoResult);
;// CONCATENATED MODULE: ./components/blocks/noResult/index.js

/* harmony default export */ var noResult = (noResult_NoResult);
// EXTERNAL MODULE: ./components/blocks/button/Button.module.scss
var Button_module = __webpack_require__(85299);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./components/blocks/button/Button.js






var BButton = function BButton(_ref) {
  var title = _ref.title,
      url = _ref.url;
  var router = (0,next_router.useRouter)();

  var handleClick = function handleClick() {
    router.push(url);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
        classNames: {
          general: (Button_module_default()).button
        },
        type: "defaultBlack",
        onClick: handleClick,
        children: title
      })
    })
  });
};

/* harmony default export */ var Button = (BButton);
;// CONCATENATED MODULE: ./components/blocks/button/index.js

/* harmony default export */ var blocks_button = (Button);
// EXTERNAL MODULE: ./components/blocks/divider/Divider.module.scss
var Divider_module = __webpack_require__(70981);
var Divider_module_default = /*#__PURE__*/__webpack_require__.n(Divider_module);
;// CONCATENATED MODULE: ./components/blocks/divider/Divider.js




var Divider = function Divider() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Divider_module_default()).divider
      })
    })
  });
};

/* harmony default export */ var divider_Divider = (Divider);
;// CONCATENATED MODULE: ./components/blocks/divider/index.js

/* harmony default export */ var divider = (divider_Divider);
;// CONCATENATED MODULE: ./components/blocks/gallery/Gallery.js

 // import ecommerce from '@/seo/Ecommerce';



var Gallery = function Gallery(_ref) {
  var slides = _ref.slides;
  if (!slides || slides.length === 0) return null; // const onClickSlide = () => {
  //   ecommerce.onClickMainBanner();
  // };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(galleryContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(gallerySlider, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(contentSlider, {
            onClick: function onClick() {},
            slides: slides
          })
        })
      })
    })
  });
};

/* harmony default export */ var gallery_Gallery = (Gallery);
;// CONCATENATED MODULE: ./components/blocks/gallery/index.js

/* harmony default export */ var gallery = (gallery_Gallery);
// EXTERNAL MODULE: ./components/blocks/gallery/galleryContainer/GalleryContainer.module.scss
var GalleryContainer_module = __webpack_require__(75052);
var GalleryContainer_module_default = /*#__PURE__*/__webpack_require__.n(GalleryContainer_module);
;// CONCATENATED MODULE: ./components/blocks/gallery/galleryContainer/GalleryContainer.js



var GalleryContainer = function GalleryContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (GalleryContainer_module_default()).gallery,
    children: children
  });
};

/* harmony default export */ var galleryContainer_GalleryContainer = (GalleryContainer);
;// CONCATENATED MODULE: ./components/blocks/gallery/galleryContainer/index.js

/* harmony default export */ var galleryContainer = (galleryContainer_GalleryContainer);
// EXTERNAL MODULE: ./components/blocks/gallery/gallerySlider/GallerySlider.module.scss
var GallerySlider_module = __webpack_require__(37445);
var GallerySlider_module_default = /*#__PURE__*/__webpack_require__.n(GallerySlider_module);
;// CONCATENATED MODULE: ./components/blocks/gallery/gallerySlider/GallerySlider.js



var GallerySlider = function GallerySlider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (GallerySlider_module_default()).slider,
    children: children
  });
};

/* harmony default export */ var gallerySlider_GallerySlider = (GallerySlider);
;// CONCATENATED MODULE: ./components/blocks/gallery/gallerySlider/index.js

/* harmony default export */ var gallerySlider = (gallerySlider_GallerySlider);
// EXTERNAL MODULE: ./components/blocks/gallery/doubleGallery/DoubleGallery.module.scss
var DoubleGallery_module = __webpack_require__(90214);
var DoubleGallery_module_default = /*#__PURE__*/__webpack_require__.n(DoubleGallery_module);
;// CONCATENATED MODULE: ./components/blocks/gallery/doubleGallery/DoubleGallery.js


var DoubleGallery_excluded = ["children"];

function DoubleGallery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DoubleGallery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DoubleGallery_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DoubleGallery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var GalleryContent = function GalleryContent(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, DoubleGallery_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", DoubleGallery_objectSpread(DoubleGallery_objectSpread({
    className: (DoubleGallery_module_default())["double-gallery-content"]
  }, props), {}, {
    children: children
  }));
};

var DoubleGallery = function DoubleGallery(_ref2) {
  var sliders = _ref2.items;

  if (!sliders || sliders.length === 0) {
    return null;
  }

  if (sliders.some(function (slider) {
    return !(slider !== null && slider !== void 0 && slider.images) || (slider === null || slider === void 0 ? void 0 : slider.images.length) === 0;
  })) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(galleryContainer, {
        children: sliders.map(function (slider) {
          var images = slider.images,
              title = slider.title,
              description = slider.description,
              url = slider.url,
              url_text = slider.url_text;
          var slides = images.map(function (image) {
            return {
              image: image,
              url: url
            };
          });
          var hasContent = title || description || url_text;
          var ContentComponent = url ? RoutedLink : GalleryContent;
          var contentComponentProps = url ? {
            to: url,
            component: GalleryContent,
            as: 'a'
          } : null;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(gallerySlider, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(contentSlider, {
              slides: slides
            }), hasContent && /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentComponent, DoubleGallery_objectSpread(DoubleGallery_objectSpread({}, contentComponentProps), {}, {
              children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (DoubleGallery_module_default())["double-gallery-title"],
                children: title
              }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (DoubleGallery_module_default())["double-gallery-description"],
                children: description
              }), url_text && url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (DoubleGallery_module_default())["double-gallery-button"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
                  type: "primary",
                  children: url_text
                })
              })]
            }))]
          }, title);
        })
      })
    })
  });
};

/* harmony default export */ var doubleGallery_DoubleGallery = (DoubleGallery);
;// CONCATENATED MODULE: ./components/blocks/gallery/doubleGallery/index.js

/* harmony default export */ var doubleGallery = (doubleGallery_DoubleGallery);
// EXTERNAL MODULE: ./components/blocks/htmlBlock/HtmlBlock.module.scss
var HtmlBlock_module = __webpack_require__(40676);
var HtmlBlock_module_default = /*#__PURE__*/__webpack_require__.n(HtmlBlock_module);
;// CONCATENATED MODULE: ./components/blocks/htmlBlock/HtmlBlock.js






var HtmlBlock_Html = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6066)]).then(__webpack_require__.bind(__webpack_require__, 26066));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26066)];
    }
  }
});

var HtmlBlock = function HtmlBlock(props) {
  var html = props.html;
  if (!html) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (HtmlBlock_module_default()).addToCartPopMechanic,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock_Html, {
          html: html
        })
      })
    })
  });
};

/* harmony default export */ var htmlBlock_HtmlBlock = (HtmlBlock);
;// CONCATENATED MODULE: ./components/blocks/htmlBlock/index.js

/* harmony default export */ var htmlBlock = (htmlBlock_HtmlBlock);
// EXTERNAL MODULE: ./components/blocks/marquee/Marquee.module.scss
var Marquee_module = __webpack_require__(63206);
var Marquee_module_default = /*#__PURE__*/__webpack_require__.n(Marquee_module);
;// CONCATENATED MODULE: ./components/blocks/marquee/Marquee.js




var Marquee = function Marquee(props) {
  var text = props.text;

  if (!text) {
    return null;
  }

  var animationDuration = (text.length / 14).toFixed(0);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Marquee_module_default()).marquee,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Marquee_module_default())["marquee-content"],
        style: {
          animationDuration: "".concat(animationDuration >= 20 ? animationDuration : 20, "s")
        },
        children: text
      })
    })
  });
};

/* harmony default export */ var marquee_Marquee = (Marquee);
;// CONCATENATED MODULE: ./components/blocks/marquee/index.js

/* harmony default export */ var marquee = (marquee_Marquee);
// EXTERNAL MODULE: ./components/blocks/navigationPictures/NavigationPictures.module.scss
var NavigationPictures_module = __webpack_require__(96351);
var NavigationPictures_module_default = /*#__PURE__*/__webpack_require__.n(NavigationPictures_module);
;// CONCATENATED MODULE: ./components/blocks/navigationPictures/NavigationPictures.js


function NavigationPictures_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NavigationPictures_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NavigationPictures_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NavigationPictures_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var NavigationPictures = function NavigationPictures(_ref) {
  var items = _ref.items,
      noMargin = _ref.noMargin;
  if (!items || items.length === 0) return null;
  if (items.some(function (item) {
    return !item.image;
  })) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    noMargin: noMargin,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (NavigationPictures_module_default()).main,
        children: items.map(function (item, index) {
          var _ref2 = item || {},
              url = _ref2.url,
              _ref2$url_text = _ref2.url_text,
              url_text = _ref2$url_text === void 0 ? '' : _ref2$url_text,
              title = _ref2.title,
              description = _ref2.description,
              image = _ref2.image;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (NavigationPictures_module_default()).item,
            children: [url && /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
              title: url_text,
              to: url,
              component: components_link
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
              className: (NavigationPictures_module_default()).image,
              children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, NavigationPictures_objectSpread(NavigationPictures_objectSpread({}, image), {}, {
                title: url_text
              }))
            }), (title || description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (NavigationPictures_module_default()).content,
              children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (NavigationPictures_module_default()).title,
                children: title
              }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (NavigationPictures_module_default()).desc,
                children: description
              })]
            })]
          }, "".concat(image, "-").concat(url, "-").concat(title, "-").concat(index));
        })
      })
    })
  });
};

/* harmony default export */ var navigationPictures_NavigationPictures = (NavigationPictures);
;// CONCATENATED MODULE: ./components/blocks/navigationPictures/index.js

/* harmony default export */ var navigationPictures = (navigationPictures_NavigationPictures);
// EXTERNAL MODULE: ./components/blocks/navigationThreePictures/NavigationThreePictures.module.scss
var NavigationThreePictures_module = __webpack_require__(48704);
var NavigationThreePictures_module_default = /*#__PURE__*/__webpack_require__.n(NavigationThreePictures_module);
;// CONCATENATED MODULE: ./components/blocks/navigationThreePictures/NavigationThreePictures.js


function NavigationThreePictures_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NavigationThreePictures_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NavigationThreePictures_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NavigationThreePictures_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var NavigationThreePictures = function NavigationThreePictures(_ref) {
  var items = _ref.items,
      noMargin = _ref.noMargin,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? {} : _ref$title,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? {} : _ref$description,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? {} : _ref$url;
  if (!items || items.length === 0) return null;
  if (items.some(function (item) {
    return !item.image;
  })) return null;
  var router = (0,next_router.useRouter)();
  var _title$text = title.text,
      textTitle = _title$text === void 0 ? null : _title$text,
      _title$size = title.size,
      TitleComponent = _title$size === void 0 ? 'h2' : _title$size;
  var _description$text = description.text,
      textDescription = _description$text === void 0 ? null : _description$text,
      _description$size = description.size,
      DescriptionComponent = _description$size === void 0 ? 'h3' : _description$size;
  var _url$link = url.link,
      link = _url$link === void 0 ? null : _url$link,
      _url$text = url.text,
      text = _url$text === void 0 ? null : _url$text;

  var handleClick = function handleClick() {
    router.push(link);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    noMargin: noMargin,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      className: (NavigationThreePictures_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (NavigationThreePictures_module_default()).main,
        children: items.map(function (item, index) {
          var _ref2 = item || {},
              url = _ref2.url,
              _ref2$url_text = _ref2.url_text,
              url_text = _ref2$url_text === void 0 ? '' : _ref2$url_text,
              title = _ref2.title,
              description = _ref2.description,
              image = _ref2.image;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (NavigationThreePictures_module_default()).item,
            children: [url && /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
              title: url_text,
              to: url,
              component: components_link
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
              className: (NavigationThreePictures_module_default()).image,
              children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, NavigationThreePictures_objectSpread(NavigationThreePictures_objectSpread({}, image), {}, {
                title: url_text
              }))
            }), (title || description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (NavigationThreePictures_module_default()).contentSlider,
              children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (NavigationThreePictures_module_default()).title,
                children: title
              }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (NavigationThreePictures_module_default()).desc,
                children: description
              })]
            })]
          }, "".concat(image, "-").concat(url, "-").concat(title, "-").concat(index));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (NavigationThreePictures_module_default()).slider,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FullWidthSlider, {
          bigMargin: true,
          children: items.map(function (_ref3) {
            var image = _ref3.image,
                title = _ref3.title,
                _ref3$url_text = _ref3.url_text,
                url_text = _ref3$url_text === void 0 ? '' : _ref3$url_text,
                url = _ref3.url,
                description = _ref3.description;

            var imageComponent = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (NavigationThreePictures_module_default()).image,
                title: url_text,
                alt: title,
                src: image === null || image === void 0 ? void 0 : image.x2
              }, title), (title || description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (NavigationThreePictures_module_default()).contentSlider,
                children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (NavigationThreePictures_module_default()).title,
                  children: title
                }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (NavigationThreePictures_module_default()).desc,
                  children: description
                })]
              })]
            });

            return url ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (NavigationThreePictures_module_default()).link,
              href: url,
              children: imageComponent
            }, title) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (NavigationThreePictures_module_default()).link,
              children: imageComponent
            });
          })
        })
      }), (textTitle || textDescription) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((NavigationThreePictures_module_default()).content, (NavigationThreePictures_module_default())["".concat(TitleComponent, "-content")]),
        children: [textTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TitleComponent, {
          className: (0,clsx_m/* default */.Z)((NavigationThreePictures_module_default()).title, (NavigationThreePictures_module_default())["".concat(TitleComponent, "-title")]),
          children: textTitle
        }), textDescription && /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionComponent, {
          className: (NavigationThreePictures_module_default()).desc,
          children: textDescription
        }), link && link.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
          type: "defaultBlack",
          classNames: {
            general: (NavigationThreePictures_module_default()).button
          },
          onClick: handleClick,
          children: text
        })]
      })]
    })
  });
};

/* harmony default export */ var navigationThreePictures_NavigationThreePictures = (NavigationThreePictures);
;// CONCATENATED MODULE: ./components/blocks/navigationThreePictures/index.js

/* harmony default export */ var navigationThreePictures = (navigationThreePictures_NavigationThreePictures);
// EXTERNAL MODULE: ./components/blocks/navigationPicturesOld/NavigationPicturesOld.module.scss
var NavigationPicturesOld_module = __webpack_require__(7331);
var NavigationPicturesOld_module_default = /*#__PURE__*/__webpack_require__.n(NavigationPicturesOld_module);
;// CONCATENATED MODULE: ./components/blocks/navigationPicturesOld/NavigationPicturesOld.js


function NavigationPicturesOld_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NavigationPicturesOld_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NavigationPicturesOld_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NavigationPicturesOld_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var NavigationPicturesOld = function NavigationPicturesOld(_ref) {
  var items = _ref.items,
      noMargin = _ref.noMargin;
  if (!items || items.length === 0) return null;
  if (items.some(function (item) {
    return !item.image;
  })) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    noMargin: noMargin,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (NavigationPicturesOld_module_default()).main,
        children: items.map(function (item, index) {
          var _ref2 = item || {},
              url = _ref2.url,
              _ref2$url_text = _ref2.url_text,
              url_text = _ref2$url_text === void 0 ? '' : _ref2$url_text,
              title = _ref2.title,
              description = _ref2.description,
              image = _ref2.image;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (NavigationPicturesOld_module_default()).item,
            children: [url && /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
              title: url_text,
              to: url,
              component: components_link
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
              className: (NavigationPicturesOld_module_default()).image,
              children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, NavigationPicturesOld_objectSpread(NavigationPicturesOld_objectSpread({}, image), {}, {
                title: url_text
              }))
            }), (title || description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (NavigationPicturesOld_module_default()).content,
              children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (NavigationPicturesOld_module_default()).title,
                children: title
              }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (NavigationPicturesOld_module_default()).desc,
                children: description
              })]
            })]
          }, "".concat(image, "-").concat(url, "-").concat(title, "-").concat(index));
        })
      })
    })
  });
};

/* harmony default export */ var navigationPicturesOld_NavigationPicturesOld = (NavigationPicturesOld);
;// CONCATENATED MODULE: ./components/blocks/navigationPicturesOld/index.js

/* harmony default export */ var navigationPicturesOld = (navigationPicturesOld_NavigationPicturesOld);
// EXTERNAL MODULE: ./components/blocks/oneImage/OneImage.module.scss
var OneImage_module = __webpack_require__(12090);
var OneImage_module_default = /*#__PURE__*/__webpack_require__.n(OneImage_module);
;// CONCATENATED MODULE: ./components/blocks/oneImage/OneImage.js


function OneImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OneImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OneImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OneImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var OneImage = function OneImage(_ref) {
  var items = _ref.items,
      noMargin = _ref.noMargin;
  if (!items || items.length === 0) return null;
  if (items.some(function (item) {
    return !item.image_desktop;
  })) return null; // console.log("🚀 ~ OneImage ~ items:", items)

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    noMargin: noMargin,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (OneImage_module_default()).main,
        children: items.map(function (item, index) {
          var _ref2 = item || {},
              url = _ref2.url,
              _ref2$url_text = _ref2.url_text,
              url_text = _ref2$url_text === void 0 ? '' : _ref2$url_text,
              title = _ref2.title,
              description = _ref2.description,
              image_desktop = _ref2.image_desktop,
              image_mobile = _ref2.image_mobile,
              title_size = _ref2.title_size,
              description_size = _ref2.description_size,
              _ref2$img_title = _ref2.img_title,
              img_title = _ref2$img_title === void 0 ? '' : _ref2$img_title;

          var ComponentTitle = title_size || 'h2';
          var ComponentDescription = description_size || 'h3';
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (OneImage_module_default()).item,
            children: [url && /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
              title: img_title,
              to: url,
              component: components_link
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("figure", {
              className: (OneImage_module_default()).image,
              children: [image_desktop && (image_desktop === null || image_desktop === void 0 ? void 0 : image_desktop.x2) && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, OneImage_objectSpread(OneImage_objectSpread({}, image_desktop), {}, {
                title: img_title
              })), image_mobile && (image_mobile === null || image_mobile === void 0 ? void 0 : image_mobile.x2) && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, OneImage_objectSpread(OneImage_objectSpread({}, image_mobile), {}, {
                title: img_title
              }))]
            }), (title || description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (0,clsx_m/* default */.Z)((OneImage_module_default()).content, (OneImage_module_default())["".concat(ComponentTitle, "-content")]),
              children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(ComponentTitle, {
                className: (0,clsx_m/* default */.Z)((OneImage_module_default()).title, (OneImage_module_default())["".concat(ComponentTitle, "-title")]),
                children: title
              }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(ComponentDescription, {
                className: (OneImage_module_default()).desc,
                children: description
              }), url_text && url_text.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
                classNames: {
                  general: (OneImage_module_default()).button
                },
                children: url_text
              })]
            })]
          }, "".concat(url, "-").concat(title, "-").concat(index));
        })
      })
    })
  });
};

/* harmony default export */ var oneImage_OneImage = (OneImage);
;// CONCATENATED MODULE: ./components/blocks/oneImage/index.js

/* harmony default export */ var oneImage = (oneImage_OneImage);
// EXTERNAL MODULE: ./components/blocks/pictureHtml/PictureHtml.module.scss
var PictureHtml_module = __webpack_require__(28620);
var PictureHtml_module_default = /*#__PURE__*/__webpack_require__.n(PictureHtml_module);
;// CONCATENATED MODULE: ./components/blocks/pictureHtml/PictureHtml.js


function PictureHtml_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PictureHtml_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PictureHtml_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PictureHtml_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var PictureHtml_Html = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6066)]).then(__webpack_require__.bind(__webpack_require__, 26066));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26066)];
    }
  }
});

var PictureHtml = function PictureHtml(_ref) {
  var html = _ref.html,
      image = _ref.image,
      _ref$imagePos = _ref.imagePos,
      imagePos = _ref$imagePos === void 0 ? 'left' : _ref$imagePos;
  if (!html || !image) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (PictureHtml_module_default()).main,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(pictureHtmlImage, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(picture, PictureHtml_objectSpread({}, image))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)(imagePos === 'right' && (PictureHtml_module_default()).content),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PictureHtml_Html, {
            html: html
          })
        })]
      })
    })
  });
};

/* harmony default export */ var pictureHtml_PictureHtml = (PictureHtml);
;// CONCATENATED MODULE: ./components/blocks/pictureHtml/index.js

/* harmony default export */ var pictureHtml = (pictureHtml_PictureHtml);
// EXTERNAL MODULE: ./components/blocks/productsSlider/ProductsSlider.module.scss
var ProductsSlider_module = __webpack_require__(83961);
var ProductsSlider_module_default = /*#__PURE__*/__webpack_require__.n(ProductsSlider_module);
;// CONCATENATED MODULE: ./components/blocks/productsSlider/ProductsSlider.js


function ProductsSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductsSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductsSlider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductsSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var ProductsSlider = function ProductsSlider(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      url_text = props.url_text,
      full_row = props.full_row,
      products = props.products,
      hideNavigationCount = props.hideNavigationCount;
  var withLink = url && url_text;
  if (!products || products.length === null) return null;
  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);
  (0,react.useEffect)(function () {
    if (Object.keys(currency).length > 0 && products && products.length) {
      Ecommerce/* default.viewItemList */.ZP.viewItemList((0,lib_getProductWithoutQuantity/* default */.Z)(products), currency, title);
    }
  }, [currency]);

  var handleClickCard = function handleClickCard(product, index) {
    var newProducts = (0,lib_getProductWithoutQuantity/* default */.Z)([product]);
    Ecommerce/* default.viewItemList */.ZP.viewItemList(newProducts, currency, title, 'select_item', index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Block */.gO, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(pageTitle, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(title_Title, {
          mb: "none",
          component: "h1",
          children: title
        })
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(pageText, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_text, {
          size: "size-large",
          children: description
        })
      })]
    }), products && products.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductsSlider_module_default())["products-slider"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FullWidthSlider, {
        hideNavigationCount: hideNavigationCount,
        noFull: full_row,
        children: products.map(function (product, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              handleClickCard(product, index + 1);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(productCard, ProductsSlider_objectSpread(ProductsSlider_objectSpread({}, product), {}, {
              mod: "productSlider",
              pageName: title !== null && title !== void 0 ? title : 'Страница товара',
              indexCard: index + 1
            }))
          }, product === null || product === void 0 ? void 0 : product.external_id);
        })
      })
    }), withLink && /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      center: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductsSlider_module_default())["products-slider-link"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
          extraPaddings: true,
          to: url,
          component: linkButton,
          as: "a",
          children: url_text
        })
      })
    })]
  });
};

/* harmony default export */ var productsSlider_ProductsSlider = (ProductsSlider);
;// CONCATENATED MODULE: ./components/blocks/productsSlider/index.js

/* harmony default export */ var productsSlider = (productsSlider_ProductsSlider);
;// CONCATENATED MODULE: ./components/blocks/shopsOnMap/ShopsOnMap.js





var ShopsMap = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8728).then(__webpack_require__.bind(__webpack_require__, 78728));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(78728)];
    }
  }
});

var ShopsOnMap = function ShopsOnMap(_ref) {
  var shops = _ref.shops;
  if (!shops || shops.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    shopsOnMap: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShopsMap, {
      shops: shops,
      hiddenTabs: true
    })
  });
};

/* harmony default export */ var shopsOnMap_ShopsOnMap = (ShopsOnMap);
;// CONCATENATED MODULE: ./components/blocks/shopsOnMap/index.js

/* harmony default export */ var shopsOnMap = (shopsOnMap_ShopsOnMap);
// EXTERNAL MODULE: ./components/blocks/titleDescLink/TitleDescLink.module.scss
var TitleDescLink_module = __webpack_require__(19719);
var TitleDescLink_module_default = /*#__PURE__*/__webpack_require__.n(TitleDescLink_module);
;// CONCATENATED MODULE: ./components/blocks/titleDescLink/TitleDescLink.js





var SHOPS_ADDRESS_TITLE = 'Адреса магазинов';
var SHOPS_URL = '/shops';

var TitleDescLink = function TitleDescLink(props) {
  var title = props.title,
      description = props.description,
      linkTitle = props.url_text,
      linkUrl = props.url,
      indent = props.indent;
  var withLink = linkTitle && linkUrl;
  if (!title && !description && !withLink) return null;
  var redirectLink = linkTitle.indexOf(SHOPS_ADDRESS_TITLE) !== -1 && linkUrl.indexOf(SHOPS_URL) !== -1 ? SHOPS_URL : linkUrl;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TitleDescLink_module_default())["content-limiter"],
        children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(pageTitle, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(title_Title, {
            mb: "none",
            align: "center",
            component: "h1",
            children: title
          })
        }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(pageText, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_text, {
            size: "size-large",
            mb: "none",
            align: "center",
            children: description
          })
        }), withLink && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (TitleDescLink_module_default()).link,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
            to: redirectLink,
            component: linkButton,
            as: "a",
            children: linkTitle
          })
        })]
      })
    })
  });
};

/* harmony default export */ var titleDescLink_TitleDescLink = (TitleDescLink);
;// CONCATENATED MODULE: ./components/blocks/titleDescLink/index.js

/* harmony default export */ var titleDescLink = (titleDescLink_TitleDescLink);
// EXTERNAL MODULE: ./components/blocks/widePictures/widePicture/WidePicture.module.scss
var WidePicture_module = __webpack_require__(17136);
var WidePicture_module_default = /*#__PURE__*/__webpack_require__.n(WidePicture_module);
// EXTERNAL MODULE: ./components/blocks/widePictures/WidePictures.module.scss
var WidePictures_module = __webpack_require__(85206);
var WidePictures_module_default = /*#__PURE__*/__webpack_require__.n(WidePictures_module);
;// CONCATENATED MODULE: ./components/blocks/widePictures/widePicture/WidePicture.js


function WidePicture_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WidePicture_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WidePicture_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WidePicture_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var WidePicture = function WidePicture(props) {
  var title = props.title,
      description = props.description,
      linkText = props.url_text,
      linkUrl = props.url,
      image = props.image;
  if (!image) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    styledType: "wide-picture",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (WidePictures_module_default())["outer-container"],
        children: [linkUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
          to: linkUrl,
          component: components_link
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (WidePictures_module_default()).image,
          children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, WidePicture_objectSpread({}, image))
        }), (title || description || linkText) && /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
          className: (WidePicture_module_default())["inner-container"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (WidePicture_module_default()).content,
            children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (WidePicture_module_default()).title,
              children: title
            }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (WidePicture_module_default()).description,
              children: description
            }), linkText && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (WidePicture_module_default()).text,
              children: linkText
            })]
          })
        })]
      })
    })
  });
};

/* harmony default export */ var widePicture_WidePicture = (WidePicture);
;// CONCATENATED MODULE: ./components/blocks/widePictures/widePicture/index.js

/* harmony default export */ var widePicture = (widePicture_WidePicture);
// EXTERNAL MODULE: ./components/blocks/textWithSidePicture/TextWithSidePicture.module.scss
var TextWithSidePicture_module = __webpack_require__(60661);
var TextWithSidePicture_module_default = /*#__PURE__*/__webpack_require__.n(TextWithSidePicture_module);
;// CONCATENATED MODULE: ./components/blocks/textWithSidePicture/TextWithSidePicture.js


function TextWithSidePicture_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TextWithSidePicture_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TextWithSidePicture_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TextWithSidePicture_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var TextWithSidePicture = function TextWithSidePicture(props) {
  var title = props.title,
      description = props.description,
      linkText = props.url_text,
      linkUrl = props.url,
      image = props.image,
      noMargin = props.noMargin,
      _props$imagePos = props.imagePos,
      imagePos = _props$imagePos === void 0 ? 'left' : _props$imagePos,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? 'Фото' : _props$alt,
      _props$title_img = props.title_img,
      title_img = _props$title_img === void 0 ? 'Фото' : _props$title_img;

  if (!image) {
    return null;
  }

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isSmallMobile = _useWindowSize.isSmallMobile;

  var imageBlock = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (TextWithSidePicture_module_default()).image,
      children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, TextWithSidePicture_objectSpread(TextWithSidePicture_objectSpread({}, image), {}, {
        alt: alt,
        title: title_img
      }))
    });
  }, [image, alt, title_img]);
  var contentBlock = (0,react.useMemo)(function () {
    if (title || description || linkText) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (TextWithSidePicture_module_default()).contentBlock,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (TextWithSidePicture_module_default()).content,
          children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(title_Title, {
            component: "h2",
            className: (TextWithSidePicture_module_default()).title,
            children: title
          }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (TextWithSidePicture_module_default()).description,
            children: description
          }), linkText && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (TextWithSidePicture_module_default()).text,
            children: linkText
          })]
        })
      });
    }

    return null;
  }, [title, description, linkText]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    noMargin: noMargin,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TextWithSidePicture_module_default()).main,
        children: [linkUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
          to: linkUrl,
          component: components_link
        }), imagePos === 'left' || isSmallMobile ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [imageBlock, contentBlock]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [contentBlock, imageBlock]
        })]
      })
    })
  });
};

/* harmony default export */ var textWithSidePicture_TextWithSidePicture = (TextWithSidePicture);
;// CONCATENATED MODULE: ./components/blocks/textWithSidePicture/index.js

/* harmony default export */ var textWithSidePicture = (textWithSidePicture_TextWithSidePicture);
// EXTERNAL MODULE: ./components/blocks/widePictures/widePictureNoText/WidePictureNoText.module.scss
var WidePictureNoText_module = __webpack_require__(56544);
var WidePictureNoText_module_default = /*#__PURE__*/__webpack_require__.n(WidePictureNoText_module);
;// CONCATENATED MODULE: ./components/blocks/widePictures/widePictureNoText/WidePictureNoText.js


function WidePictureNoText_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WidePictureNoText_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WidePictureNoText_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WidePictureNoText_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var WidePictureNoText = function WidePictureNoText(props) {
  var linkUrl = props.url,
      image = props.image;
  if (!image) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (WidePictures_module_default())["outer-container"],
        children: [linkUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
          to: linkUrl,
          component: components_link
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((WidePictures_module_default()).image, (WidePictureNoText_module_default()).image),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(picture, WidePictureNoText_objectSpread({}, image))
        })]
      })
    })
  });
};

/* harmony default export */ var widePictureNoText_WidePictureNoText = (WidePictureNoText);
;// CONCATENATED MODULE: ./components/blocks/widePictures/widePictureNoText/index.js

/* harmony default export */ var widePictureNoText = (widePictureNoText_WidePictureNoText);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(64063);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
// EXTERNAL MODULE: ./node_modules/youtube-player/dist/index.js
var dist = __webpack_require__(11062);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./node_modules/react-youtube/dist/index.esm.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function index_esm_createSuper(Derived) { var hasNativeReflectConstruct = index_esm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function index_esm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function index_esm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function index_esm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { index_esm_ownKeys(Object(source), true).forEach(function (key) { index_esm_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { index_esm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function index_esm_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */

function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  } // Otherwise, a change in the start/end time playerVars also requires a player
  // update.


  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};
  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}
/**
 * Neutralize API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */


function filterResetOptions(opts) {
  return index_esm_objectSpread(index_esm_objectSpread({}, opts), {}, {
    height: 0,
    width: 0,
    playerVars: index_esm_objectSpread(index_esm_objectSpread({}, opts.playerVars), {}, {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}
/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */


function shouldResetPlayer(prevProps, props) {
  return prevProps.videoId !== props.videoId || !fast_deep_equal_default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}
/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */


function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id !== props.id || prevProps.className !== props.className || prevProps.opts.width !== props.opts.width || prevProps.opts.height !== props.opts.height || prevProps.title !== props.title;
}

var YouTube = /*#__PURE__*/function (_React$Component) {
  _inherits(YouTube, _React$Component);

  var _super = index_esm_createSuper(YouTube);

  /**
   * Expose PlayerState constants for convenience. These constants can also be
   * accessed through the global YT object after the YouTube IFrame API is instantiated.
   * https://developers.google.com/youtube/iframe_api_reference#onStateChange
   */
  function YouTube(props) {
    var _this;

    _classCallCheck(this, YouTube);

    _this = _super.call(this, props);

    index_esm_defineProperty(_assertThisInitialized(_this), "onPlayerReady", function (event) {
      return _this.props.onReady(event);
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "onPlayerError", function (event) {
      return _this.props.onError(event);
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "onPlayerStateChange", function (event) {
      _this.props.onStateChange(event);

      switch (event.data) {
        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);

          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);

          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);

          break;

        default:
      }
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackRateChange", function (event) {
      return _this.props.onPlaybackRateChange(event);
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackQualityChange", function (event) {
      return _this.props.onPlaybackQualityChange(event);
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "createPlayer", function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return; // create player

      var playerOpts = index_esm_objectSpread(index_esm_objectSpread({}, _this.props.opts), {}, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });

      _this.internalPlayer = dist_default()(_this.container, playerOpts); // attach event handlers

      _this.internalPlayer.on('ready', _this.onPlayerReady);

      _this.internalPlayer.on('error', _this.onPlayerError);

      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);

      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);

      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "resetPlayer", function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "updatePlayer", function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
        if (_this.props.opts && _this.props.opts.width) iframe.setAttribute('width', _this.props.opts.width);else iframe.removeAttribute('width');
        if (_this.props.opts && _this.props.opts.height) iframe.setAttribute('height', _this.props.opts.height);else iframe.removeAttribute('height');
        if (typeof _this.props.title === 'string') iframe.setAttribute('title', _this.props.title);else iframe.setAttribute('title', 'YouTube video player');
      });
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
      return _this.internalPlayer;
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "updateVideo", function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();

        return;
      } // set queueing options


      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };

      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;

        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }

        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      } // if autoplay is enabled loadVideoById


      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);

        return;
      } // default behaviour just cues the video


      _this.internalPlayer.cueVideoById(opts);
    });

    index_esm_defineProperty(_assertThisInitialized(_this), "refContainer", function (container) {
      _this.container = container;
    });

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  _createClass(YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all YouTube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }
    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/react.createElement("div", {
        className: this.props.containerClassName
      }, /*#__PURE__*/react.createElement("div", {
        id: this.props.id,
        className: this.props.className,
        ref: this.refContainer,
        loading: this.props.loading
      }));
    }
  }]);

  return YouTube;
}(react.Component);

index_esm_defineProperty(YouTube, "PlayerState", {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
});

YouTube.propTypes = {
  videoId: (prop_types_default()).string,
  // custom ID for player element
  id: (prop_types_default()).string,
  // custom class name for player element
  className: (prop_types_default()).string,
  // custom class name for player container element
  containerClassName: (prop_types_default()).string,
  // custom title for the iFrame, see https://www.w3.org/TR/WCAG20-TECHS/H64.html
  title: (prop_types_default()).string,
  // custom loading for player element
  loading: prop_types_default().oneOf(['lazy', 'eager', 'auto']),
  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: prop_types_default().objectOf((prop_types_default()).any),
  // event subscriptions
  onReady: (prop_types_default()).func,
  onError: (prop_types_default()).func,
  onPlay: (prop_types_default()).func,
  onPause: (prop_types_default()).func,
  onEnd: (prop_types_default()).func,
  onStateChange: (prop_types_default()).func,
  onPlaybackRateChange: (prop_types_default()).func,
  onPlaybackQualityChange: (prop_types_default()).func
};
YouTube.defaultProps = {
  videoId: null,
  id: null,
  className: null,
  loading: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {},
  title: null
};
/* harmony default export */ var index_esm = (YouTube);

// EXTERNAL MODULE: ./components/blocks/youtubePlayer/YoutubePlayer.module.scss
var YoutubePlayer_module = __webpack_require__(2929);
var YoutubePlayer_module_default = /*#__PURE__*/__webpack_require__.n(YoutubePlayer_module);
;// CONCATENATED MODULE: ./components/blocks/youtubePlayer/YoutubePlayer.js





var YoutubePlayer = function YoutubePlayer(_ref) {
  var id = _ref.id;
  if (id === null) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (YoutubePlayer_module_default()).youtube,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm, {
          videoId: id,
          containerClassName: (YoutubePlayer_module_default())["video-wrapper"],
          className: (YoutubePlayer_module_default()).video,
          opts: {
            width: '100%',
            height: '100%'
          }
        })
      })
    })
  });
};

/* harmony default export */ var youtubePlayer_YoutubePlayer = (YoutubePlayer);
;// CONCATENATED MODULE: ./components/blocks/youtubePlayer/index.js

/* harmony default export */ var youtubePlayer = (youtubePlayer_YoutubePlayer);
// EXTERNAL MODULE: ./components/blocks/fourPictures/FourPictures.module.scss
var FourPictures_module = __webpack_require__(98406);
var FourPictures_module_default = /*#__PURE__*/__webpack_require__.n(FourPictures_module);
;// CONCATENATED MODULE: ./components/blocks/fourPictures/FourPictures.js






var FourPictures = function FourPictures(_ref) {
  var items = _ref.items,
      blockTitle = _ref.title,
      alignment = _ref.alignment;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Block */.gO, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: blockTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(pageTitle, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(title_Title, {
          mb: "none",
          component: "h1",
          align: alignment,
          children: blockTitle
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FourPictures_module_default())["fp-products-slider"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FullWidthSlider, {
        bigMargin: true,
        children: items.map(function (_ref2) {
          var image = _ref2.image,
              title = _ref2.title,
              _ref2$url_text = _ref2.url_text,
              url_text = _ref2$url_text === void 0 ? '' : _ref2$url_text,
              url = _ref2.url;

          var imageComponent = /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            title: url_text,
            alt: title,
            src: image === null || image === void 0 ? void 0 : image.x2
          }, title);

          return url ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: url,
            children: imageComponent
          }, title) : imageComponent;
        })
      })
    })]
  });
};

/* harmony default export */ var fourPictures_FourPictures = (FourPictures);
;// CONCATENATED MODULE: ./components/blocks/fourPictures/index.js

/* harmony default export */ var fourPictures = (fourPictures_FourPictures);
;// CONCATENATED MODULE: ./components/blocks/h1/H1.js

 // заменить StyledTitle



var H1 = function H1(_ref) {
  var h1 = _ref.h1;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(title_Title, {
        component: "h1",
        mb: "large",
        align: "center",
        children: h1
      })
    })
  });
};

/* harmony default export */ var h1_H1 = (H1);
;// CONCATENATED MODULE: ./components/blocks/h1/index.js

/* harmony default export */ var h1 = (h1_H1);
// EXTERNAL MODULE: ./components/blocks/htmlLinksBlock/HtmlLinksBlock.module.scss
var HtmlLinksBlock_module = __webpack_require__(22763);
var HtmlLinksBlock_module_default = /*#__PURE__*/__webpack_require__.n(HtmlLinksBlock_module);
;// CONCATENATED MODULE: ./components/blocks/htmlLinksBlock/HtmlLinksBlock.js









var HtmlLinksBlock_Html = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6066)]).then(__webpack_require__.bind(__webpack_require__, 26066));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26066)];
    }
  }
});

var HtmlLinksBlock = function HtmlLinksBlock(_ref) {
  var _ref$size = _ref.size,
      TitleComponent = _ref$size === void 0 ? 'h2' : _ref$size,
      title = _ref.title,
      html = _ref.html,
      _ref$posTitle = _ref.posTitle,
      posTitle = _ref$posTitle === void 0 ? 'center' : _ref$posTitle,
      widthText = _ref.widthText,
      url = _ref.url;
  var titleBlock = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(TitleComponent, {
      className: (0,clsx_m/* default */.Z)((HtmlLinksBlock_module_default())[TitleComponent], (HtmlLinksBlock_module_default())[posTitle], (HtmlLinksBlock_module_default()).title),
      children: title
    });
  }, [title]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      className: widthText === 'compressed' && (HtmlLinksBlock_module_default()).container,
      children: [url && url.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: url,
        className: (HtmlLinksBlock_module_default()).link,
        children: titleBlock
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: titleBlock
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlLinksBlock_Html, {
        html: html
      })]
    })
  });
};

/* harmony default export */ var htmlLinksBlock_HtmlLinksBlock = (HtmlLinksBlock);
;// CONCATENATED MODULE: ./components/blocks/htmlLinksBlock/index.js

/* harmony default export */ var htmlLinksBlock = (htmlLinksBlock_HtmlLinksBlock);
;// CONCATENATED MODULE: ./components/blocks/lookSlider/LookSlider.js


function LookSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LookSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LookSlider_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LookSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var LookSlider_LookSlider = function LookSlider(_ref) {
  var products = _ref.products;
  if (!products || products.length === null) return null;
  var currency = useSelector(getCurrency);
  useEffect(function () {
    if (Object.keys(currency).length > 0 && products && products.length) {
      ecommerce.viewItemList(getProductWithoutQuantity(products), currency, 'Идеи для образа');
    }
  }, [currency]);

  var handleClickCard = function handleClickCard(product, index) {
    var newProducts = getProductWithoutQuantity([product]);
    ecommerce.viewItemList(newProducts, currency, 'Идеи для образа', 'select_item', index);
  };

  return /*#__PURE__*/_jsx(Block, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(FullWidthSlider, {
        fullWidth: true,
        children: products.map(function (product, index) {
          return /*#__PURE__*/_jsx("div", {
            className: styles.cart,
            onClick: function onClick() {
              handleClickCard(product, index + 1);
            },
            children: /*#__PURE__*/_jsx(ProductCard, LookSlider_objectSpread(LookSlider_objectSpread({}, product), {}, {
              mod: "looks",
              pageName: 'Идеи для образа',
              indexCard: index + 1
            }))
          }, product === null || product === void 0 ? void 0 : product.external_id);
        })
      })
    })
  });
};

/* harmony default export */ var lookSlider_LookSlider = ((/* unused pure expression or super */ null && (LookSlider_LookSlider)));
;// CONCATENATED MODULE: ./components/blocks/lookSlider/index.js

/* harmony default export */ var lookSlider = ((/* unused pure expression or super */ null && (LookSlider)));
// EXTERNAL MODULE: ./components/blocks/lookImageSlider/LookImageSlider.module.scss
var LookImageSlider_module = __webpack_require__(38988);
var LookImageSlider_module_default = /*#__PURE__*/__webpack_require__.n(LookImageSlider_module);
;// CONCATENATED MODULE: ./components/blocks/lookImageSlider/LookImageSlider.js


function LookImageSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LookImageSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LookImageSlider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LookImageSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var LooksModal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2436).then(__webpack_require__.bind(__webpack_require__, 12436));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(12436)];
    }
  }
});

var LookImageSlider = function LookImageSlider(_ref) {
  var products = _ref.products,
      image = _ref.image,
      selection = _ref.selection,
      productPage = _ref.productPage,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment;

  var _useState = (0,react.useState)(false),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);
  var handleCloseModal = (0,react.useCallback)(function () {
    setOpenModal(false);
  }, []);
  var handleOpenModal = (0,react.useCallback)(function () {
    setOpenModal(true);
  }, []);

  var handleClickCard = function handleClickCard(product, index) {
    var newProducts = (0,lib_getProductWithoutQuantity/* default */.Z)([product]);
    Ecommerce/* default.viewItemList */.ZP.viewItemList(newProducts, currency, 'Идеи для образа', 'select_item', index);
  };

  (0,react.useEffect)(function () {
    if (products && products.length) {
      Ecommerce/* default.viewItemList */.ZP.viewItemList((0,lib_getProductWithoutQuantity/* default */.Z)(products), currency, 'Идеи для образа');
    }
  }, []);
  var Slider = (products === null || products === void 0 ? void 0 : products.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(title_Title, {
      component: "h2",
      className: (LookImageSlider_module_default()).collectionTitle,
      children: "\u0418\u0434\u0435\u0438 \u0434\u043B\u044F \u043E\u0431\u0440\u0430\u0437\u0430"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((LookImageSlider_module_default()).container, alignment && alignment === 'right' && (LookImageSlider_module_default()).reverseContainer),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((LookImageSlider_module_default()).imageBlock, alignment && alignment === 'right' && (LookImageSlider_module_default()).rightSideImage),
          children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, LookImageSlider_objectSpread({}, image.card))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (0,clsx_m/* default */.Z)((LookImageSlider_module_default()).lookSlider, productPage && (LookImageSlider_module_default()).lookSliderProductPage),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_FullWidthSlider, {
            fullWidth: true,
            hideNavigationCount: 3,
            children: products.map(function (product, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (LookImageSlider_module_default()).cart,
                onClick: function onClick() {
                  handleClickCard(product, index + 1);
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(productCard, LookImageSlider_objectSpread(LookImageSlider_objectSpread({}, product), {}, {
                  mod: "looks",
                  pageName: 'Идеи для образа',
                  isSafari: true,
                  indexCard: index + 1
                }))
              }, product === null || product === void 0 ? void 0 : product.external_id);
            })
          }), openModal && /*#__PURE__*/(0,jsx_runtime.jsx)(LooksModal, {
            showDialog: openModal,
            onDismiss: handleCloseModal,
            id: selection
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_button/* default */.Z, {
        classNames: {
          general: (LookImageSlider_module_default()).button
        },
        type: "primary",
        as: "button",
        onClick: handleOpenModal,
        children: "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0435\u0441\u044C \u043E\u0431\u0440\u0430\u0437"
      })]
    })]
  }) : null;
  return productPage ? Slider : /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: Slider
  });
};

/* harmony default export */ var lookImageSlider_LookImageSlider = (LookImageSlider);
;// CONCATENATED MODULE: ./components/blocks/lookImageSlider/index.js

/* harmony default export */ var lookImageSlider = (lookImageSlider_LookImageSlider);
// EXTERNAL MODULE: ./components/blocks/lookImage/LookImage.module.scss
var LookImage_module = __webpack_require__(26368);
var LookImage_module_default = /*#__PURE__*/__webpack_require__.n(LookImage_module);
;// CONCATENATED MODULE: ./components/blocks/lookImage/LookImage.js



function LookImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LookImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LookImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LookImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var LookImage_LooksModal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2436).then(__webpack_require__.bind(__webpack_require__, 12436));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(12436)];
    }
  }
});

var LookImage = function LookImage(_ref) {
  var products = _ref.products,
      image = _ref.image,
      selection = _ref.selection;

  var _useState = (0,react.useState)(false),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var handleCloseModal = (0,react.useCallback)(function () {
    setOpenModal(false);
  }, []);
  var handleOpenModal = (0,react.useCallback)(function () {
    setOpenModal(true);
  }, []);
  return (products === null || products === void 0 ? void 0 : products.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LookImage_module_default()).lookImageLabelsBlock,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LookImage_module_default()).lookImagePictureHtml,
          children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(pictureHtmlImage, {
            isLook: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(picture, LookImage_objectSpread({}, image.index))
          })
        }), products.map(function (_ref2) {
          var params = _ref2.params,
              model = _ref2.model,
              price = _ref2.price;

          var _getLinkProps = (0,getLinkProps/* default */.Z)({
            type: 'product',
            value: model.slug
          }),
              _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
              linkHref = _getLinkProps2[0],
              linkAs = _getLinkProps2[1];

          return (params === null || params === void 0 ? void 0 : params.x) && (params === null || params === void 0 ? void 0 : params.y) && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: {
              pathname: linkHref
            },
            as: {
              pathname: linkAs
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (0,clsx_m/* default */.Z)((LookImage_module_default()).lookImageLabel, params.x < 50 ? (LookImage_module_default()).left : (LookImage_module_default()).right),
              style: {
                left: "".concat(params.x, "%"),
                top: "".concat(params.y, "%")
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (LookImage_module_default()).text,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(currencyPrice, {
                  price: price
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                alt: "arrow",
                src: "/images/svg/price-arrow.svg"
              })]
            })
          }, model.slug);
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_button/* default */.Z, {
          classNames: {
            general: (LookImage_module_default()).lookImageButton,
            content: (LookImage_module_default()).content
          },
          type: "primary",
          image: true,
          isImage: true,
          onClick: handleOpenModal,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: " \u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0435\u0441\u044C \u043E\u0431\u0440\u0430\u0437"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            style: {
              marginLeft: '8px'
            },
            alt: "arrow",
            src: "/images/svg/price-arrow.svg"
          })]
        }), openModal && /*#__PURE__*/(0,jsx_runtime.jsx)(LookImage_LooksModal, {
          showDialog: openModal,
          onDismiss: handleCloseModal,
          id: selection
        })]
      })
    })
  }) : null;
};

/* harmony default export */ var lookImage_LookImage = (LookImage);
;// CONCATENATED MODULE: ./components/blocks/lookImage/index.js

/* harmony default export */ var lookImage = (lookImage_LookImage);
// EXTERNAL MODULE: ./components/blocks/offset/Offset.module.scss
var Offset_module = __webpack_require__(37215);
var Offset_module_default = /*#__PURE__*/__webpack_require__.n(Offset_module);
;// CONCATENATED MODULE: ./components/blocks/offset/Offset.js



var Offset = function Offset() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (Offset_module_default()).offset
  });
};

/* harmony default export */ var offset_Offset = (Offset);
;// CONCATENATED MODULE: ./components/blocks/offset/index.js

/* harmony default export */ var offset = (offset_Offset);
// EXTERNAL MODULE: ./components/blocks/carousel/Carousel.module.scss
var Carousel_module = __webpack_require__(46598);
var Carousel_module_default = /*#__PURE__*/__webpack_require__.n(Carousel_module);
;// CONCATENATED MODULE: ./components/blocks/carousel/Carousel.js










var Carousel_Carousel = function Carousel(_ref) {
  var pictures = _ref.pictures,
      title = _ref.title,
      _ref$isBigSlider = _ref.isBigSlider,
      isBigSlider = _ref$isBigSlider === void 0 ? false : _ref$isBigSlider,
      slides = _ref.slides,
      _ref$url = _ref.url,
      titleUrl = _ref$url === void 0 ? '' : _ref$url;
  var hasSubtitle = (0,react.useMemo)(function () {
    return pictures === null || pictures === void 0 ? void 0 : pictures.some(function (picture) {
      return picture.subtitle;
    });
  }, [pictures]);

  var getCarouselImage = function getCarouselImage(carouselImage, url) {
    var isActiveLink = url && url.length > 0;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: (0,clsx_m/* default */.Z)(!isBigSlider && (Carousel_module_default()).link, hasSubtitle && (Carousel_module_default()).linkWithSubtitle, !isActiveLink && (Carousel_module_default()).notActiveLink, isBigSlider && (Carousel_module_default()).bigSliderLink),
      href: url,
      children: carouselImage
    }, url);
  };

  var titleComponent = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (Carousel_module_default()).title,
      children: title
    });
  }, [title]);
  var images = (0,react.useMemo)(function () {
    return (pictures || slides).filter(function (_ref2) {
      var image = _ref2.image;
      return !!(image !== null && image !== void 0 && image.webp_x2 || image !== null && image !== void 0 && image.x2);
    });
  }, [pictures, slides]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Block */.gO, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(pageTitle, {
        children: isBigSlider && (titleUrl === null || titleUrl === void 0 ? void 0 : titleUrl.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: titleUrl,
          children: titleComponent
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: titleComponent
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((Carousel_module_default()).carouselProductsSlider, isBigSlider && (Carousel_module_default()).carouselProductsBigSlider),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FullWidthSlider, {
        bigMargin: true,
        widthLimit: "100%",
        isBigSlider: isBigSlider,
        isCarousel: true,
        children: images.map(function (_ref3) {
          var image = _ref3.image,
              _ref3$url = _ref3.url,
              url = _ref3$url === void 0 ? '' : _ref3$url,
              padding = _ref3.padding,
              _ref3$url_text = _ref3.url_text,
              url_text = _ref3$url_text === void 0 ? '' : _ref3$url_text,
              subtitle = _ref3.subtitle;

          var carouselImage = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()) // style={{ padding }}
            , {
              padding: padding,
              layout: "fill",
              alt: url_text,
              title: url_text,
              src: (image === null || image === void 0 ? void 0 : image.webp_x2) || (image === null || image === void 0 ? void 0 : image.x2)
            }, "".concat(url, "-image")), subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Carousel_module_default()).subtitle,
              children: subtitle
            })]
          });

          return getCarouselImage(carouselImage, url);
        })
      })
    })]
  });
};

/* harmony default export */ var carousel_Carousel = (Carousel_Carousel);
;// CONCATENATED MODULE: ./components/blocks/carousel/index.js

/* harmony default export */ var carousel = (carousel_Carousel);
// EXTERNAL MODULE: ./components/blocks/pictureHtmlImage/PictureHtmlImage.module.scss
var PictureHtmlImage_module = __webpack_require__(84075);
var PictureHtmlImage_module_default = /*#__PURE__*/__webpack_require__.n(PictureHtmlImage_module);
;// CONCATENATED MODULE: ./components/blocks/pictureHtmlImage/PictureHtmlImage.js





var PictureHtmlImage = function PictureHtmlImage(_ref) {
  var _clsx;

  var children = _ref.children,
      isLook = _ref.isLook,
      heightStretch = _ref.heightStretch;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (PictureHtmlImage_module_default()).isLook, isLook), (0,defineProperty/* default */.Z)(_clsx, (PictureHtmlImage_module_default()).heightStretch, heightStretch), _clsx), (PictureHtmlImage_module_default()).image),
    children: children
  });
};

/* harmony default export */ var pictureHtmlImage_PictureHtmlImage = (PictureHtmlImage);
;// CONCATENATED MODULE: ./components/blocks/pictureHtmlImage/index.js

/* harmony default export */ var pictureHtmlImage = (pictureHtmlImage_PictureHtmlImage);
// EXTERNAL MODULE: ./components/blocks/selectionsCatalog/SelectionsCatalog.module.scss
var SelectionsCatalog_module = __webpack_require__(77618);
var SelectionsCatalog_module_default = /*#__PURE__*/__webpack_require__.n(SelectionsCatalog_module);
;// CONCATENATED MODULE: ./components/blocks/selectionsCatalog/SelectionsCatalog.js


function SelectionsCatalog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectionsCatalog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectionsCatalog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectionsCatalog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ScrollBtn = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 885).then(__webpack_require__.bind(__webpack_require__, 40885));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(40885)];
    }
  }
});

var SelectionsCatalog = function SelectionsCatalog(_ref) {
  var products = _ref.products;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      className: (SelectionsCatalog_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: (SelectionsCatalog_module_default()).productList,
        children: products.map(function (product) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(productCard, SelectionsCatalog_objectSpread(SelectionsCatalog_objectSpread({}, product), {}, {
              mod: "catalog"
            }))
          }, product.model.id);
        })
      }), !!(products !== null && products !== void 0 && products.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollBtn, {})]
    })
  });
};

/* harmony default export */ var selectionsCatalog_SelectionsCatalog = (SelectionsCatalog);
;// CONCATENATED MODULE: ./components/blocks/selectionsCatalog/index.js

/* harmony default export */ var selectionsCatalog = (selectionsCatalog_SelectionsCatalog);
// EXTERNAL MODULE: ./components/blocks/gallery/contentSlider/ContentSlider.module.scss
var ContentSlider_module = __webpack_require__(58232);
var ContentSlider_module_default = /*#__PURE__*/__webpack_require__.n(ContentSlider_module);
;// CONCATENATED MODULE: ./components/blocks/gallery/contentSlider/ContentSlider.js


function ContentSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ContentSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ContentSlider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var getRandom = function getRandom(min, max) {
  var newMin = Math.ceil(min);
  var newMax = Math.floor(max);
  return +(Math.random() * (newMax - newMin + 1) + newMin).toFixed(1);
};

var ContentSlider = function ContentSlider(_ref) {
  var slides = _ref.slides,
      onClick = _ref.onClick;
  var gallerySliderRef = (0,react.useRef)(null);
  var disabledClass = slides.length <= 1 ? ' disabled' : '';
  var params = {
    loop: true,
    speed: 300,
    effect: 'fade',
    keyboard: true,
    autoplay: {
      delay: 1000 * getRandom(2.5, 3),
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".swiper-button-next".concat(disabledClass),
      prevEl: ".swiper-button-prev".concat(disabledClass)
    },
    pagination: {
      el: ".swiper-pagination".concat(disabledClass),
      type: 'bullets',
      clickable: true
    },
    slidesPerView: 1,
    resistanceRatio: 0.2,
    watchOverflow: true
  };

  var onMouseEnter = function onMouseEnter() {
    var _gallerySliderRef$cur;

    gallerySliderRef === null || gallerySliderRef === void 0 ? void 0 : (_gallerySliderRef$cur = gallerySliderRef.current) === null || _gallerySliderRef$cur === void 0 ? void 0 : _gallerySliderRef$cur.swiper.autoplay.stop();
  };

  var onMouseLeave = function onMouseLeave() {
    var _gallerySliderRef$cur2;

    gallerySliderRef === null || gallerySliderRef === void 0 ? void 0 : (_gallerySliderRef$cur2 = gallerySliderRef.current) === null || _gallerySliderRef$cur2 === void 0 ? void 0 : _gallerySliderRef$cur2.swiper.autoplay.start();
  };

  var onClickSlide = function onClickSlide() {
    if (onClick) {
      onClick();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ContentSlider_module_default()).main,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((react_id_swiper_lib_default()), ContentSlider_objectSpread(ContentSlider_objectSpread({}, params), {}, {
      ref: function ref(el) {
        gallerySliderRef.current = el;
        return el;
      },
      children: slides.map(function (slide, index) {
        var image = slide.image,
            url = slide.url;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ContentSlider_module_default()).slide,
          role: "button",
          tabIndex: 0,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          onClick: onClickSlide,
          children: [url && /*#__PURE__*/(0,jsx_runtime.jsx)(RoutedLink, {
            to: url,
            component: components_link
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ContentSlider_module_default()).image,
            children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(picture, ContentSlider_objectSpread({}, image))
          })]
        }, "".concat(image, "-").concat(url, "-").concat(index));
      })
    }))
  });
};

/* harmony default export */ var contentSlider_ContentSlider = (ContentSlider);
;// CONCATENATED MODULE: ./components/blocks/gallery/contentSlider/index.js

/* harmony default export */ var contentSlider = (contentSlider_ContentSlider);
;// CONCATENATED MODULE: ./lib/hooks/useWindowSize.js

function useWindowSize() {
  var isClient = true;

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  var _useState = (0,react.useState)(getSize),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  (0,react.useEffect)(function () {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}
// EXTERNAL MODULE: ./components/blocks/shortsYoutubePlayer/ShortsYoutubePlayer.module.scss
var ShortsYoutubePlayer_module = __webpack_require__(56952);
var ShortsYoutubePlayer_module_default = /*#__PURE__*/__webpack_require__.n(ShortsYoutubePlayer_module);
;// CONCATENATED MODULE: ./components/blocks/shortsYoutubePlayer/ShortsYoutubePlayer.js






var ShortsYoutubePlayer = function ShortsYoutubePlayer(_ref) {
  var id = _ref.id;
  if (id === null) return null;
  var windowSize = useWindowSize();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ShortsYoutubePlayer_module_default()).shorts,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm, {
          videoId: id,
          containerClassName: (ShortsYoutubePlayer_module_default())["video-wrapper"],
          opts: {
            height: windowSize.height - 60 - 0.1 * windowSize.height,
            width: '100%'
          }
        })
      })
    })
  });
};

/* harmony default export */ var shortsYoutubePlayer_ShortsYoutubePlayer = (ShortsYoutubePlayer);
;// CONCATENATED MODULE: ./components/blocks/shortsYoutubePlayer/index.js

/* harmony default export */ var shortsYoutubePlayer = (shortsYoutubePlayer_ShortsYoutubePlayer);
;// CONCATENATED MODULE: ./components/index.js
/* eslint-disable import/no-cycle */
// export { default as Accordion } from './accordion';
 // export { default as AddressSelector } from './addressSelector';
// export { default as AddToCart } from './addToCart';
// export { default as AppliedFilters } from './appliedFilters';

 // export { default as StickyContainer } from './stickyContainer';





 // export { default as Contacts } from './contacts';




 // export { default as Datepicker } from './datepicker';
// export { default as Dialog } from './dialog';
// export { default as Drawer } from './drawer';
// export { default as DrumSelector } from './drumSelector';


 // export { default as FilterMultiple } from './filters/filterMultiple';
// export {
//   default as FilterMultipleCollapsableSearchable,
// } from './filters/FilterMultipleCollapsableSearchable';
// export { default as FilterRadio } from './filters/FilterRadio';
// export { default as FilterRange } from './filters/FilterRange';
// export { default as Filters } from './filters';
// export { default as FormError } from './formError';
// export { default as FullScreenTip } from './FullScreenTip';

 // export { default as Help } from './help';
// export { default as Html } from './html';


 // export { LoginLink, LoginForm } from '../containers/login';










 // export { default as NextNProgress } from './nextNProgress';


 // export { default as Pagination } from './pagination';



 // export { default as OrderStatus } from './orderStatus';


 // export { TextVariants } from './productCard/components';


 // export { default as ProductShop } from './productShop';
// export { default as PersonalDataModal } from './personalDataModal';
// export { default as PersonalDataWarningModal } from './personalDataWarningModal';
// export { default as ProductConfig } from './productConfig';
// export { default as PurchaseSelfDelivery } from './purchaseSelfDelivery';
// export { default as Promocode } from './promocode';
// export { default as ReturnableItems } from './returnableItems';
// export { default as RowSlider } from './rowSlider';



 // export { default as SelectSort } from './selectSort';
// export { default as ScrollBtn } from './scrollBtn';
// export { default as SizeModal } from './sizeModal';
// export { default as SizeTable } from './sizeTable';

 // export { ShopsList, ShopsMap } from './shopsMap';
// export { default as ShopsViews } from './shopsView';
// export { default as Tabs } from './tabs';
// export { default as Timer } from './timer';



 // blocks




































/* eslint-enable import/no-cycle */

/***/ }),

/***/ 20178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mobileFilters; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./lib/wordEnd.js
var wordEnd = __webpack_require__(62547);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./components/mobileFilters/MobileFilters.module.scss
var MobileFilters_module = __webpack_require__(70923);
var MobileFilters_module_default = /*#__PURE__*/__webpack_require__.n(MobileFilters_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/mobileFilters/MobileFilters.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var FilterRange = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7768).then(__webpack_require__.bind(__webpack_require__, 37768));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37768)];
    }
  }
});
var FilterMultipleCollapsableSearchable = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8633).then(__webpack_require__.bind(__webpack_require__, 48633));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48633)];
    }
  }
});
var Accordion = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6962).then(__webpack_require__.bind(__webpack_require__, 6962));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6962)];
    }
  }
});
var FullScreenTip = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1682)];
    }
  }
});

var MobileFilters = function MobileFilters(_ref) {
  var filters = _ref.filters,
      selectedFilters = _ref.selectedFilters,
      onFiltersChange = _ref.onFiltersChange,
      total = _ref.total,
      loading = _ref.loading,
      visibility = _ref.visibility,
      toggleMobileFilter = _ref.toggleMobileFilter,
      _ref$isSearchPage = _ref.isSearchPage,
      isSearchPage = _ref$isSearchPage === void 0 ? false : _ref$isSearchPage;
  var hasSmartBanner = (0,es/* useSelector */.v9)(store/* hasSmartBannerSelector */.Jd);
  var isVisible = visibility;
  var wrapper = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      disabled = _useState[0],
      setDisabled = _useState[1];

  (0,react.useEffect)(function () {
    window.addEventListener('click', onClickOutside);
    window.addEventListener('orientationchange', onOrientationChange);
    return function () {
      window.removeEventListener('click', onClickOutside);
      window.removeEventListener('orientationchange', onOrientationChange);
    };
  }, [isVisible]);
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    var handleRouteChange = function handleRouteChange(url) {
      if (isVisible) {
        if (!url.includes('filters') && url.slice(0, 4) !== router.asPath.slice(0, 4)) {
          toggleMobileFilter();
        }
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return function () {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [isVisible, toggleMobileFilter]);

  var onClickOutside = function onClickOutside(e) {
    if (isVisible && wrapper.current === e.target) {
      toggleMobileFilter();
    }
  };

  var onOrientationChange = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    if (isVisible) toggleMobileFilter();
  }, [isVisible, toggleMobileFilter]);
  var onToggleClick = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    toggleMobileFilter();
  }, [toggleMobileFilter]);
  var hasSelectedFilters = Object.keys(selectedFilters).length > 0;

  var handleFilterChange = function handleFilterChange(value) {
    setDisabled(value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      onClick: onToggleClick,
      className: (MobileFilters_module_default()).filterContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "filter",
        className: (MobileFilters_module_default()).filterIcon
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B"
      }), hasSelectedFilters && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (MobileFilters_module_default()).filterTitleTotal,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (MobileFilters_module_default()).filterTitleTotalCount,
          children: Object.keys(selectedFilters).length
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
      in: isVisible,
      timeout: {
        appear: 0,
        enter: 180,
        exit: 180
      },
      classNames: {
        enter: (MobileFilters_module_default()).onEnter,
        enterActive: (MobileFilters_module_default()).onEnterActive,
        enterDone: (MobileFilters_module_default()).onEnterDone,
        exit: (MobileFilters_module_default()).onExit,
        exitActive: (MobileFilters_module_default()).onExitActive
      },
      unmountOnExit: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Portal */.h_, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((MobileFilters_module_default()).wrapper, hasSmartBanner && (MobileFilters_module_default()).smartBanner),
          ref: wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (MobileFilters_module_default()).container,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (MobileFilters_module_default()).header,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (MobileFilters_module_default()).title,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: "\u0424\u0438\u043B\u044C\u0442\u0440"
                }), hasSelectedFilters && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (MobileFilters_module_default()).filterTitleTotal,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (MobileFilters_module_default()).filterTitleTotalCount,
                    children: Object.keys(selectedFilters).length
                  })
                })]
              }), hasSelectedFilters && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
                classNames: {
                  general: (MobileFilters_module_default()).clearAll
                },
                onClick: function onClick(e) {
                  e.stopPropagation();
                  onFiltersChange({});
                },
                children: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (MobileFilters_module_default()).main,
              children: filters && filters.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: filters.map(function (filter, index) {
                  var type = filter.type,
                      id = filter.id;
                  var filterKey = id || index;

                  switch (type) {
                    case 'checkbox':
                      {
                        var slug = filter.slug,
                            title = filter.name,
                            items = filter.options,
                            info = filter.info;
                        if (!items || items.length === 0) return null; // move items with positive count on top

                        var sortedItems = (0,toConsumableArray/* default */.Z)(items).sort(function (a, b) {
                          if (a.count === 0 && b.count > 0) {
                            return 1;
                          }

                          if (b.count === 0 && a.count > 0) {
                            return -1;
                          }

                          return 0;
                        });

                        return /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion, {
                          title: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: (MobileFilters_module_default()).filterTitle,
                            children: title
                          }),
                          unmountOnClose: true,
                          isFilter: true,
                          headChild: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [info && /*#__PURE__*/(0,jsx_runtime.jsxs)(FullScreenTip, {
                              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: title
                              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                children: info
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
                              visible: selectedFilters[slug],
                              onClick: function onClick(e) {
                                e.stopPropagation();

                                var nextFilters = _objectSpread({}, selectedFilters);

                                delete nextFilters[slug];
                                onFiltersChange(nextFilters);
                              },
                              classNames: {
                                general: (0,clsx_m/* default */.Z)((MobileFilters_module_default()).clearButton, selectedFilters[slug] && (MobileFilters_module_default()).clearButtonVisible)
                              },
                              children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"
                            })]
                          }),
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: disabled || loading ? (MobileFilters_module_default()).disabled : null,
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FilterMultipleCollapsableSearchable, {
                              name: slug,
                              isMobile: true,
                              items: sortedItems,
                              selectedFilters: selectedFilters,
                              onChange: onFiltersChange,
                              isSearchPage: isSearchPage,
                              title: title
                            })
                          })
                        }, filterKey);
                      }

                    case 'range':
                      {
                        var _slug = filter.slug,
                            min = filter.min,
                            max = filter.max,
                            _title = filter.name,
                            _info = filter.info;
                        return /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion, {
                          title: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: (MobileFilters_module_default()).filterTitle,
                            children: _title
                          }),
                          mod: index === 0 && 'firstBorder',
                          isFilter: true,
                          unmountOnClose: true,
                          headChild: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [_info && /*#__PURE__*/(0,jsx_runtime.jsxs)(FullScreenTip, {
                              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: _title
                              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                children: _info
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
                              onClick: function onClick(e) {
                                e.stopPropagation();

                                var nextFilters = _objectSpread({}, selectedFilters);

                                delete nextFilters[_slug];
                                onFiltersChange(nextFilters);
                              },
                              classNames: {
                                general: (0,clsx_m/* default */.Z)((MobileFilters_module_default()).clearButton, selectedFilters[_slug] && (MobileFilters_module_default()).clearButtonVisible)
                              },
                              children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"
                            })]
                          }),
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FilterRange, {
                            name: _slug,
                            onChange: onFiltersChange,
                            selectedFilters: selectedFilters,
                            range: [min, max],
                            isSearchPage: isSearchPage,
                            disabledClick: handleFilterChange
                          })
                        }, filterKey);
                      }
                  }
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (MobileFilters_module_default()).footer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, _objectSpread(_objectSpread({
                withLoader: true,
                onClick: onToggleClick
              }, loading && {
                className: 'loading',
                disabled: true
              }), {}, {
                classNames: {
                  general: (MobileFilters_module_default()).showAllButton
                },
                type: "primary",
                children: +total > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: ["\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C ", total, " ", (0,wordEnd/* default */.Z)(+total, ['товар', 'товара', 'товаров'])]
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
                })
              }))
            })]
          })
        })
      })
    })]
  });
};

/* harmony default export */ var mobileFilters_MobileFilters = (MobileFilters);
;// CONCATENATED MODULE: ./components/mobileFilters/index.js

/* harmony default export */ var mobileFilters = (mobileFilters_MobileFilters);

/***/ }),

/***/ 48673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mobileSort; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/mobileSort/MobileSort.module.scss
var MobileSort_module = __webpack_require__(49005);
var MobileSort_module_default = /*#__PURE__*/__webpack_require__.n(MobileSort_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/mobileSort/MobileSort.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var FilterRadio = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5008).then(__webpack_require__.bind(__webpack_require__, 45008));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(45008)];
    }
  }
});
var MemoizedMobileSort = /*#__PURE__*/(0,react.memo)(function MobileSort(_ref) {
  var sortItems = _ref.sortItems,
      sortName = _ref.sortName,
      selectedSorting = _ref.selectedSorting,
      onSortChange = _ref.onSortChange,
      loading = _ref.loading,
      visibility = _ref.visibility,
      toggleMobileSort = _ref.toggleMobileSort;
  var hasSmartBanner = (0,es/* useSelector */.v9)(store/* hasSmartBannerSelector */.Jd);
  var isVisible = visibility;
  var wrapper = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    window.addEventListener('click', onClickOutside);
    window.addEventListener('orientationchange', onOrientationChange);
    return function () {
      window.removeEventListener('click', onClickOutside);
      window.removeEventListener('orientationchange', onOrientationChange);
    };
  }, [isVisible]);

  var onClickOutside = function onClickOutside(e) {
    var _wrapper$current;

    if (isVisible && (!(wrapper !== null && wrapper !== void 0 && (_wrapper$current = wrapper.current) !== null && _wrapper$current !== void 0 && _wrapper$current.contains(e.target)) || wrapper.current === e.target)) {
      toggleMobileSort(e);
    }
  };

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    var handleRouteChange = function handleRouteChange(url) {
      if (isVisible) {
        if (!url.includes('sort') && url.slice(0, 4) !== router.asPath.slice(0, 4)) {
          toggleMobileSort();
        }
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return function () {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [isVisible]);
  var onOrientationChange = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    if (isVisible) toggleMobileSort();
  }, [isVisible]);
  var onToggleClick = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    toggleMobileSort();
  }, []);
  var sortingName = (0,react.useMemo)(function () {
    if (!selectedSorting) {
      var _sortItems$;

      return (_sortItems$ = sortItems[0]) === null || _sortItems$ === void 0 ? void 0 : _sortItems$.name;
    }

    for (var i = 0; i < sortItems.length; i++) {
      var item = sortItems[i];

      if (item.value === selectedSorting) {
        return item.name;
      }
    }
  }, [selectedSorting, sortItems]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      onClick: onToggleClick,
      className: (MobileSort_module_default()).sortContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "sort",
        className: (MobileSort_module_default()).tabletIcon
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (MobileSort_module_default()).titleSorted,
        children: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (MobileSort_module_default()).titleSortedName,
        children: sortingName
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "arrow-down",
        className: (MobileSort_module_default()).arrowDownIcon,
        width: "11"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "sort",
        className: (MobileSort_module_default()).mobileIcon
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
      in: isVisible,
      timeout: {
        appear: 0,
        enter: 180,
        exit: 180
      },
      classNames: {
        enter: (MobileSort_module_default()).onEnter,
        enterActive: (MobileSort_module_default()).onEnterActive,
        enterDone: (MobileSort_module_default()).onEnterDone,
        exit: (MobileSort_module_default()).onExit,
        exitActive: (MobileSort_module_default()).onExitActive
      },
      unmountOnExit: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Portal */.h_, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((MobileSort_module_default()).wrapper, hasSmartBanner && (MobileSort_module_default()).smartBanner),
          ref: wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (MobileSort_module_default()).container,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (MobileSort_module_default()).header,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (MobileSort_module_default()).title,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (MobileSort_module_default()).main,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FilterRadio, {
                name: sortName,
                items: sortItems,
                activeItem: selectedSorting,
                onChange: onSortChange
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (MobileSort_module_default()).footer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, _objectSpread(_objectSpread({
                withLoader: true,
                onClick: onToggleClick
              }, loading && {
                className: 'loading',
                disabled: true
              }), {}, {
                classNames: {
                  general: (MobileSort_module_default()).showAllButton
                },
                type: "primary",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C"
                })
              }))
            })]
          })
        })
      })
    })]
  });
});
/* harmony default export */ var MobileSort = (MemoizedMobileSort);
;// CONCATENATED MODULE: ./components/mobileSort/index.js

/* harmony default export */ var mobileSort = (MobileSort);

/***/ }),

/***/ 92134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W2": function() { return /* reexport */ styles_Container; },
  "us": function() { return /* reexport */ StyledFullWidthSlider; },
  "tL": function() { return /* reexport */ styles_StyledMobileNav; },
  "HX": function() { return /* reexport */ styles_StyledNotification; },
  "dG": function() { return /* reexport */ styles_StyledNotifications; },
  "Ft": function() { return /* reexport */ StyledPage; }
});

// UNUSED EXPORTS: StyledSection, StyledTabs, StyledTitle

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
// EXTERNAL MODULE: ./assets/styles/theme.js
var theme = __webpack_require__(78309);
;// CONCATENATED MODULE: ./assets/styles/mixins.css.js


var maxWidth = function maxWidth(breakpoint) {
  return function () {
    return (0,styled_components_browser_esm/* css */.iv)(["@media only screen and (max-width:", "px){", ";}"], breakpoint, styled_components_browser_esm/* css.apply */.iv.apply(void 0, arguments));
  };
};
var minWidth = function minWidth(breakpoint) {
  return function () {
    return (0,styled_components_browser_esm/* css */.iv)(["@media only screen and (min-width:", "px){", ";}"], breakpoint, styled_components_browser_esm/* css.apply */.iv.apply(void 0, arguments));
  };
};
var noTouch = function noTouch() {
  return function () {
    return (0,styled_components_browser_esm/* css */.iv)(["@media not all and (-moz-touch-enabled:1),not all and (pointer:coarse),not all and (-ms-high-contrast:none) and (max-width:600px){", ";}"], styled_components_browser_esm/* css.apply */.iv.apply(void 0, arguments));
  };
};
var scrollBar = function scrollBar() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$barColor = _ref.barColor,
      barColor = _ref$barColor === void 0 ? "".concat(theme/* default.bg.default */.Z.bg["default"]) : _ref$barColor,
      _ref$thumbColor = _ref.thumbColor,
      thumbColor = _ref$thumbColor === void 0 ? "".concat(theme/* default.bg.dividerDark */.Z.bg.dividerDark) : _ref$thumbColor,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? '0px' : _ref$radius,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '6px' : _ref$size;

  return (0,styled_components_browser_esm/* css */.iv)(["scrollbar-color:", " ", ";scrollbar-width:thin;&::-webkit-scrollbar{background-color:", ";width:", ";height:", ";border-radius:", ";}&::-webkit-scrollbar-thumb{border-radius:", ";background-color:", ";}"], thumbColor, barColor, barColor, size, size, radius, radius, thumbColor);
};
var rgba = function rgba(hex, alpha) {
  var rgb = hexToRgb(hex);
  return "rgba(".concat(rgb, ", ").concat(alpha, ")");
};

function hexToRgb(args) {
  var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);

  if (!match) {
    return [0, 0, 0];
  }

  var colorString = match[0];

  if (match[0].length === 3) {
    colorString = colorString.split('').map(function (char) {
      return char + char;
    }).join('');
  }

  var integer = parseInt(colorString, 16);
  var r = integer >> 16 & 0xff;
  var g = integer >> 8 & 0xff;
  var b = integer & 0xff;
  return [r, g, b];
}
// EXTERNAL MODULE: ./assets/styles/vars.js
var vars = __webpack_require__(54935);
;// CONCATENATED MODULE: ./components/styles/Container.js


var _templateObject, _templateObject2, _templateObject3;




var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Container",
  componentId: "sc-1yngns1-0"
})(["min-width:280px;width:", "%;max-width:", "px;margin-left:auto;margin-right:auto;", " ", " ", " ", " ", ""], vars/* default.container.default */.Z.container["default"], vars/* default.maxContentWidth */.Z.maxContentWidth, maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t  width: ", "%;\n  "])), vars/* default.container.tablet */.Z.container.tablet), maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet + 1)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t  width: ", "%;\n  "])), vars/* default.container.mTablet */.Z.container.mTablet), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile + 1)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    width: ", "%;\n  "])), vars/* default.container.lMobile */.Z.container.lMobile), function (props) {
  return props.maxWidth && (0,styled_components_browser_esm/* css */.iv)(["max-width:", ";"], props.maxWidth);
}, function (props) {
  return props.align && (0,styled_components_browser_esm/* css */.iv)(["text-align:", ";"], props.align);
});
/* harmony default export */ var styles_Container = (Container);
;// CONCATENATED MODULE: ./components/styles/StyledFullWidthSlider.js


var StyledFullWidthSlider_templateObject, StyledFullWidthSlider_templateObject2, StyledFullWidthSlider_templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;





var FullWidthSlider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledFullWidthSlider__FullWidthSlider",
  componentId: "sc-1s3dm87-0"
})(["", ";"], function (props) {
  return props.mod === 'mini' && (0,styled_components_browser_esm/* css */.iv)(["", "{.swiper-slide{width:101px;margin:0;", " ", " &:first-child{margin-left:0px !important;}&:not(:last-child){margin-right:16px;", " ", "}}}", "{left:-22px;svg{display:inline-block !important;transform:rotate(-90deg);}}", "{right:0;svg{display:inline-block !important;transform:rotate(90deg);}}", "{box-shadow:none;&::after{display:none;}&:hover{svg{path{stroke:#fff;}}}}"], FullWidthSlider.Swiper, maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledFullWidthSlider_templateObject || (StyledFullWidthSlider_templateObject = _taggedTemplateLiteral(["\n                width: 158px;\n                margin: 0;\n            "]))), maxWidth(vars/* default.breakpoints.sMobile */.Z.breakpoints.sMobile)(StyledFullWidthSlider_templateObject2 || (StyledFullWidthSlider_templateObject2 = _taggedTemplateLiteral(["\n                width: 101px;\n                margin: 0;\n            "]))), maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledFullWidthSlider_templateObject3 || (StyledFullWidthSlider_templateObject3 = _taggedTemplateLiteral(["\n                margin-right: 24px;\n            "]))), maxWidth(vars/* default.breakpoints.sMobile */.Z.breakpoints.sMobile)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                margin-right: 16px;\n            "]))), FullWidthSlider.Prev, FullWidthSlider.Next, FullWidthSlider.Btn);
});
FullWidthSlider.Container = (0,styled_components_browser_esm/* default */.ZP)(styles_Container).withConfig({
  displayName: "StyledFullWidthSlider__Container",
  componentId: "sc-1s3dm87-1"
})(["position:relative;", " ", " ", " ", ";", ";"], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        width: 100%;\n\n        .swiper-slide{\n        &:first-child {\n            margin-left: ", "%;\n        }\n        }\n    "])), vars/* default.sideOffset.tablet */.Z.sideOffset.tablet), maxWidth(vars/* default.breakpoints.mobile */.Z.breakpoints.mobile)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        .swiper-slide{\n        &:first-child {\n            margin-left: ", "%;\n        }\n        }\n    "])), vars/* default.sideOffset.lMobile */.Z.sideOffset.lMobile), minWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        overflow: hidden;\n    "]))), function (props) {
  return props.noFull && (0,styled_components_browser_esm/* css */.iv)(["", ""], minWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            overflow: hidden;\n        "]))));
}, function (props) {
  return props.fullWidth && (0,styled_components_browser_esm/* css */.iv)(["width:100%;"]);
});
FullWidthSlider.Swiper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledFullWidthSlider__Swiper",
  componentId: "sc-1s3dm87-2"
})(["position:relative;overflow:hidden;.swiper-container{overflow:visible;}.swiper-slide{width:292px;&:not(:last-child){margin-right:32px;", " ", " ", "}", "}}", " ", " ", " ", " ", " ", " ", ";", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            margin-right: 24px;\n        "]))), maxWidth(vars/* default.breakpoints.sMobile */.Z.breakpoints.sMobile)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            margin-right: 6px;\n        "]))), function (props) {
  return props.bigMargin && (0,styled_components_browser_esm/* css */.iv)(["margin-right:32px;"]);
}, function (props) {
  return props.isBrandDescription && (0,styled_components_browser_esm/* css */.iv)(["margin-right:0 !important;margin-left:0 !important;"]);
}, maxWidth(vars/* default.breakpoints.sDesktop */.Z.breakpoints.sDesktop)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        .swiper-slide {\n        \twidth: 250px;\n        }\n    "]))), maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        .swiper-slide {\n        \twidth: 206px;\n        }\n    "]))), maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet + 1)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n        .swiper-slide {\n        \twidth: 190px;\n        }\n    "]))), maxWidth(vars/* default.breakpoints.mobile */.Z.breakpoints.mobile)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        .swiper-slide {\n        \twidth: 158px;\n        }\n    "]))), maxWidth(vars/* default.breakpoints.sMobile */.Z.breakpoints.sMobile - 1)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n        .swiper-slide {\n        \twidth: 158px;\n        }\n    "]))), function (props) {
  return props.noSlideWidth && (0,styled_components_browser_esm/* css */.iv)([".swiper-slide{width:auto;}"]);
}, function (props) {
  return props.widthLimit && (0,styled_components_browser_esm/* css */.iv)(["max-width:", ";margin-left:auto;margin-right:auto;"], props.widthLimit || '100%');
}, function (props) {
  return props.locked && (0,styled_components_browser_esm/* css */.iv)(["", ",", "{display:none;}"], FullWidthSlider.Prev, FullWidthSlider.Next);
});
FullWidthSlider.BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledFullWidthSlider__BtnWrap",
  componentId: "sc-1s3dm87-3"
})(["position:absolute;top:50%;left:0;pointer-events:none;", ";", ";&::after{content:'';display:block;width:100%;padding-top:150%;}", ";"], function (props) {
  return props.hide && (0,styled_components_browser_esm/* css */.iv)(["display:none;"]);
}, function (props) {
  return props.centered && (0,styled_components_browser_esm/* css */.iv)(["top:168px;", " ", " ", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n        top: 155px;\n    "]))), maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet + 1)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n        top: 143px;\n    "]))), maxWidth(vars/* default.breakpoints.mobile */.Z.breakpoints.mobile + 1)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n        top: 98px;\n    "]))));
}, function (props) {
  return props.right && (0,styled_components_browser_esm/* css */.iv)(["left:auto;right:0;"]);
});
FullWidthSlider.Btn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "StyledFullWidthSlider__Btn",
  componentId: "sc-1s3dm87-4"
})(["position:absolute;top:50%;z-index:1;display:flex;justify-content:center;align-items:center;width:32px;height:32px;border-radius:50%;overflow:hidden;background:", ";box-shadow:0px 2px 2px rgba(0,0,0,0.05);transition:background 0.25s ease;pointer-events:all;box-shadow:1px 1px 24px rgba(0,0,0,0.16);svg{display:none;}&::after{content:'';display:block;width:7px;height:7px;border-right:", ";border-bottom:", ";transition:border-color 0.25s ease;}", " ", " ", ""], function (themeProps) {
  return themeProps.theme.bg.default;
}, function (props) {
  return "1px solid ".concat(props.theme.bg.accent);
}, function (props) {
  return "1px solid ".concat(props.theme.bg.accent);
}, maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n        display: ", ";\n    "])), function (props) {
  return props.isBigSlider ? 'block' : 'none';
}), noTouch()(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n        &:hover {\n        background: ", ";\n\n        &::after {\n            border-color: ", ";\n        }\n        }\n    "])), function (props) {
  return !props.disabled && props.theme.bg.accent;
}, function (props) {
  return !props.disabled && props.theme.bg.default;
}), function (props) {
  return props.disabled && (0,styled_components_browser_esm/* css */.iv)(["opacity:0;&::after{border-color:", ";}"], function (themeProps) {
    return themeProps.theme.bg.divider;
  });
});
FullWidthSlider.Prev = (0,styled_components_browser_esm/* default */.ZP)(FullWidthSlider.Btn).withConfig({
  displayName: "StyledFullWidthSlider__Prev",
  componentId: "sc-1s3dm87-5"
})(["left:15px;transform:translateY(-50%);&::after{transform:translateX(2px) rotate(-225deg);", "}"], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n        transform: translateX(12px) rotate(-225deg);\n        "]))));
FullWidthSlider.Next = (0,styled_components_browser_esm/* default */.ZP)(FullWidthSlider.Btn).withConfig({
  displayName: "StyledFullWidthSlider__Next",
  componentId: "sc-1s3dm87-6"
})(["right:15px;transform:translateY(-50%);&::after{transform:translateX(-2px) rotate(-45deg);", "}"], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n        transform: translateX(10px) rotate(-45deg);\n        "]))));
/* harmony default export */ var StyledFullWidthSlider = (FullWidthSlider);
;// CONCATENATED MODULE: ./components/styles/StyledMobileNav.js


var StyledMobileNav_templateObject, StyledMobileNav_templateObject2, StyledMobileNav_templateObject3, StyledMobileNav_templateObject4, StyledMobileNav_templateObject5, StyledMobileNav_templateObject6, StyledMobileNav_templateObject7, StyledMobileNav_templateObject8;





var StyledMobileNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledMobileNav",
  componentId: "sc-xmkguj-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;overflow:hidden;pointer-events:none;z-index:9997;visibility:hidden;opacity:0;cursor:pointer;background:", ";transition:visibility 0s 0.25s,opacity 0.25s ease;-ms-scroll-chaining:none;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;user-select:none;", ""], rgba(theme/* default.bg.accent */.Z.bg.accent, 0.8), maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(StyledMobileNav_templateObject || (StyledMobileNav_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (props) {
  return props.visible && (0,styled_components_browser_esm/* css */.iv)(["opacity:1;visibility:visible;pointer-events:all;transition:none;transition:visibility 0s,opacity 0.25s ease;", "{opacity:1;transform:none;transition:transform 0.25s ease-out,opacity 0.25s linear;}"], StyledMobileNav.Menu);
}));
StyledMobileNav.Menu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledMobileNav__Menu",
  componentId: "sc-xmkguj-1"
})(["position:relative;height:100%;min-width:250px;width:100%;max-width:500px;padding-top:58px;margin-right:auto;background:", ";opacity:0;overflow:hidden;cursor:default;transform:translateX(-100%);transition:transform 0.25s ease-in,opacity 0.25s linear;", ""], theme/* default.bg.default */.Z.bg["default"], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledMobileNav_templateObject2 || (StyledMobileNav_templateObject2 = _taggedTemplateLiteral(["\n    padding-top: 56px;\n\n    ", "\n  "])), function (props) {
  return props.hasBanner && (0,styled_components_browser_esm/* css */.iv)(["padding-top:114px;"]);
}));
StyledMobileNav.MenuInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledMobileNav__MenuInner",
  componentId: "sc-xmkguj-2"
})(["position:relative;width:100%;height:100%;overflow:hidden;background:", ";"], theme/* default.bg.default */.Z.bg["default"]);
StyledMobileNav.Level = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledMobileNav__Level",
  componentId: "sc-xmkguj-3"
})(["position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;width:100%;height:100%;color:", ";background:", ";box-shadow:2px 0px 2px 0px ", ";overflow:hidden;transition:opacity 200ms,transform 200ms;&.on-enter{opacity:0;transform:translateX(-100%);}&.on-enter-active,&.on-enter-done{opacity:1;transform:translateX(0);}&.on-exit{opacity:1;transform:translateX(-100%);}&.on-exit-active,&.on-exit-done{opacity:0;transform:translateX(-100%);}"], theme/* default.text.accent */.Z.text.accent, theme/* default.bg.default */.Z.bg["default"], theme/* default.bg.light */.Z.bg.light);
StyledMobileNav.LevelInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledMobileNav__LevelInner",
  componentId: "sc-xmkguj-4"
})(["width:100%;height:100%;padding-left:32px;overflow-x:hidden;overflow-y:auto;", " -ms-scroll-chaining:none;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;user-select:none;", ""], scrollBar({
  barColor: theme/* default.bg.insistent */.Z.bg.insistent,
  size: '4px',
  radius: '2px'
}), maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledMobileNav_templateObject3 || (StyledMobileNav_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: 20px;\n  "]))));
StyledMobileNav.List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "StyledMobileNav__List",
  componentId: "sc-xmkguj-5"
})(["min-height:550px;", " & > ", "{&:first-child{border-top:none !important;}}"], maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledMobileNav_templateObject4 || (StyledMobileNav_templateObject4 = _taggedTemplateLiteral(["\n    padding-right: 20px;\n  "]))), StyledMobileNav.Item);
StyledMobileNav.Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "StyledMobileNav__Item",
  componentId: "sc-xmkguj-6"
})(["cursor:default;border-bottom:1px solid ", ";", ""], theme/* default.bg.light */.Z.bg.light, function (props) {
  return props.level && (0,styled_components_browser_esm/* css */.iv)(["", "{font-size:20px;line-height:130%;font-weight:normal;font-family:", ";}"], StyledMobileNav.Link, vars/* default.fonts.futuraBook */.Z.fonts.futuraBook);
});
StyledMobileNav.Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "StyledMobileNav__Link",
  componentId: "sc-xmkguj-7"
})(["position:relative;display:flex;align-items:center;width:calc(100% + 32px);margin-left:-32px;padding:16px 20px 19px 32px;height:100%;color:", ";font-family:", ";font-size:18px;line-height:130%;font-weight:450;text-align:left;", " ", " ", " ", ""], theme/* default.text.main */.Z.text.main, vars/* default.fonts.futura */.Z.fonts.futura, function (props) {
  return props.parent && (0,styled_components_browser_esm/* css */.iv)(["&::after{content:'';position:absolute;top:22px;right:20px;width:7px;height:7px;border-top:1px solid ", ";border-right:1px solid ", ";transform:rotate(45deg);}"], theme/* default.text.secondary */.Z.text.secondary, theme/* default.text.secondary */.Z.text.secondary);
}, function (props) {
  return props.active && (0,styled_components_browser_esm/* css */.iv)(["font-weight:500;"]);
}, function (_ref) {
  var styledView = _ref.styledView;

  switch (styledView) {
    case 'premium':
      return (0,styled_components_browser_esm/* css */.iv)(["font-family:", ";font-weight:500;font-size:16px;letter-spacing:0.12em;text-transform:uppercase;color:", ";"], vars/* default.fonts.futura */.Z.fonts.futura, theme/* default.bg.active */.Z.bg.active);

    case 'sale':
      return (0,styled_components_browser_esm/* css */.iv)(["font-family:", ";font-weight:500;font-size:16px;letter-spacing:0.12em;text-transform:uppercase;color:", ";"], vars/* default.fonts.futura */.Z.fonts.futura, theme/* default.warn.default */.Z.warn["default"]);

    default:
      break;
  }
}, maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledMobileNav_templateObject5 || (StyledMobileNav_templateObject5 = _taggedTemplateLiteral(["\n    width: calc(100% + 20px);\n    margin-left: -20px;\n    padding-left: 20px;\n  "]))));
StyledMobileNav.SubList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "StyledMobileNav__SubList",
  componentId: "sc-xmkguj-8"
})(["padding-top:25px;padding-bottom:25px;"]);
StyledMobileNav.SubLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "StyledMobileNav__SubLink",
  componentId: "sc-xmkguj-9"
})(["display:block;padding:5px 0 6px;font-size:18px;color:", ";", ""], theme/* default.text.secondary */.Z.text.secondary, function (props) {
  return props.active && (0,styled_components_browser_esm/* css */.iv)(["cursor:default;font-family:", ";font-weight:500;"], vars/* default.fonts.futura */.Z.fonts.futura);
});
StyledMobileNav.Back = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "StyledMobileNav__Back",
  componentId: "sc-xmkguj-10"
})(["position:relative;display:flex;align-items:center;color:", ";width:100%;padding-top:18px;padding-bottom:29px;font-family:", ";font-weight:450;font-size:18px;line-height:130%;text-align:left;"], theme/* default.text.main */.Z.text.main, vars/* default.fonts.futura */.Z.fonts.futura);
StyledMobileNav.BackIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "StyledMobileNav__BackIcon",
  componentId: "sc-xmkguj-11"
})(["flex-shrink:0;margin-right:10px;color:", ";"], theme/* default.bg.accent */.Z.bg.accent);
StyledMobileNav.ProfileList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "StyledMobileNav__ProfileList",
  componentId: "sc-xmkguj-12"
})(["padding-top:12px;padding-bottom:12px;"]);
StyledMobileNav.ProfileLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "StyledMobileNav__ProfileLink",
  componentId: "sc-xmkguj-13"
})(["display:block;width:calc(100% + 32px);margin-left:-32px;padding:11px 32px;font-size:20px;color:", ";text-align:left;", ""], theme/* default.text.accent */.Z.text.accent, maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledMobileNav_templateObject6 || (StyledMobileNav_templateObject6 = _taggedTemplateLiteral(["\n    width: calc(100% + 20px);\n    margin-left: -20px;\n    padding-left: 20px;\n    padding-right: 20px;\n  "]))));
StyledMobileNav.Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledMobileNav__Divider",
  componentId: "sc-xmkguj-14"
})(["width:calc(100% - 32px);height:1px;margin-bottom:20px;background:", ";", ""], theme/* default.bg.divider */.Z.bg.divider, maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledMobileNav_templateObject7 || (StyledMobileNav_templateObject7 = _taggedTemplateLiteral(["\n    width: calc(100% - 20px);\n  "]))));
StyledMobileNav.ContactsOverview = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledMobileNav__ContactsOverview",
  componentId: "sc-xmkguj-15"
})(["padding-right:32px;", ""], maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledMobileNav_templateObject8 || (StyledMobileNav_templateObject8 = _taggedTemplateLiteral(["\n    padding-right: 20px;\n  "]))));
/* harmony default export */ var styles_StyledMobileNav = (StyledMobileNav);
;// CONCATENATED MODULE: ./components/styles/StyledNotification.js


var StyledNotification_templateObject, StyledNotification_templateObject2;




var StyledNotification = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledNotification",
  componentId: "sc-19eh0ok-0"
})(["pointer-events:all;", ";", ";&.on-enter{opacity:0;transform:scale(0.95);}&.on-enter-active{opacity:1;transform:scale(1);transition:opacity 0.23s ease-out,transform 0.23s ease-out;}&.on-exit{opacity:1;transform:scale(1);}&.on-exit-active{opacity:0;transform:scale(0.95);transition:opacity 0.23s ease-in,transform 0.23s ease-in;}"], function (_ref) {
  var viewType = _ref.viewType;

  switch (viewType) {
    case 'warning':
      {
        return (0,styled_components_browser_esm/* css */.iv)(["--notification-bg-color:", ";"], theme/* default.notification.warning */.Z.notification.warning);
      }

    case 'error':
      {
        return (0,styled_components_browser_esm/* css */.iv)(["--notification-bg-color:", ";"], theme/* default.notification.error */.Z.notification.error);
      }

    default:
      break;
  }
}, function (props) {
  return !props.closable && (0,styled_components_browser_esm/* css */.iv)(["", "{padding-right:24px;}"], StyledNotification.Content);
});
StyledNotification.Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledNotification__Body",
  componentId: "sc-19eh0ok-1"
})(["display:flex;font-size:17px;color:#fff;background-color:var(--notification-bg-color,", ");border-radius:12px;"], theme/* default.notification.error */.Z.notification.error);
StyledNotification.Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledNotification__Content",
  componentId: "sc-19eh0ok-2"
})(["flex-grow:1;padding:20px 0px 24px 24px;"]);
StyledNotification.Close = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "StyledNotification__Close",
  componentId: "sc-19eh0ok-3"
})(["flex-shrink:0;display:block;width:48px;height:62px;background-image:url(\"data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.065.358l8.577 8.577-.707.707L.358 1.066l.707-.708z' fill='%23fff'/%3E%3Cpath d='M8.935.358L.358 8.935l.707.707 8.577-8.576-.707-.708z' fill='%23fff'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:50% 50%;opacity:0.7;transition:opacity 0.23s ease;", ""], noTouch()(StyledNotification_templateObject || (StyledNotification_templateObject = _taggedTemplateLiteral(["\n    &:hover {\n      opacity: 1;\n    }\n  "]))));
StyledNotification.Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "StyledNotification__Button",
  componentId: "sc-19eh0ok-4"
})(["display:inline-block;padding:1px 8px 3px;font-size:14px;color:#fff;border:1px solid #ffffff;border-radius:4px;transition:opacity 0.16s;&:not(:first-child){margin-top:16px;}", ""], noTouch()(StyledNotification_templateObject2 || (StyledNotification_templateObject2 = _taggedTemplateLiteral(["\n    &:hover {\n      opacity: 0.7;\n    }\n  "]))));
/* harmony default export */ var styles_StyledNotification = (StyledNotification);
;// CONCATENATED MODULE: ./components/styles/StyledNotifications.js


var StyledNotifications_templateObject, StyledNotifications_templateObject2, StyledNotifications_templateObject3;




var StyledNotifications = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledNotifications",
  componentId: "sc-1u1xryn-0"
})(["position:fixed;left:0;bottom:0;z-index:99999;width:100%;height:100%;max-height:100vh;overflow:hidden;pointer-events:none;"]);
StyledNotifications.List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledNotifications__List",
  componentId: "sc-1u1xryn-1"
})(["position:absolute;left:0;bottom:0;display:grid;grid-template-columns:minmax(0,360px);grid-gap:10px;width:100%;padding:32px;", " ", " ", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledNotifications_templateObject || (StyledNotifications_templateObject = _taggedTemplateLiteral(["\n    padding: 24px calc((100 - ", ") / 2 * 1%);\n  "])), vars/* default.container.tablet */.Z.container.tablet), maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledNotifications_templateObject2 || (StyledNotifications_templateObject2 = _taggedTemplateLiteral(["\n     padding: 24px calc((100 - ", ") / 2 * 1%);\n   "])), vars/* default.container.mTablet */.Z.container.mTablet), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledNotifications_templateObject3 || (StyledNotifications_templateObject3 = _taggedTemplateLiteral(["\n     padding: 24px calc((100 - ", ") / 2 * 1%);\n   "])), vars/* default.container.lMobile */.Z.container.lMobile));
/* harmony default export */ var styles_StyledNotifications = (StyledNotifications);
;// CONCATENATED MODULE: ./components/styles/StyledSection.js


var StyledSection_templateObject, StyledSection_templateObject2, StyledSection_templateObject3, StyledSection_templateObject4, StyledSection_templateObject5, StyledSection_templateObject6, StyledSection_templateObject7, StyledSection_templateObject8, StyledSection_templateObject9, StyledSection_templateObject10, StyledSection_templateObject11, StyledSection_templateObject12, StyledSection_templateObject13, StyledSection_templateObject14, StyledSection_templateObject15, StyledSection_templateObject16;




var StyledSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "StyledSection",
  componentId: "sc-137nmq0-0"
})(["& + &{margin-top:0;}", " ", " ", " ", " ", ""], function (props) {
  return props.align === 'center' && (0,styled_components_browser_esm/* css */.iv)(["display:flex;justify-content:center;align-items:center;align-content:center;flex-wrap:wrap;flex-grow:1;text-align:center;"]);
}, function (props) {
  return props.maxWidth && (0,styled_components_browser_esm/* css */.iv)(["max-width:", ";"], props.maxWidth);
}, function (_ref) {
  var pt = _ref.pt;

  switch (pt) {
    case 'xl-large':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-top:96px;", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledSection_templateObject || (StyledSection_templateObject = _taggedTemplateLiteral(["\n            margin-top: 64px;\n          "]))));

    case 'x-large':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-top:56px;", " ", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledSection_templateObject2 || (StyledSection_templateObject2 = _taggedTemplateLiteral(["\n            margin-top: 48px;\n          "]))), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject3 || (StyledSection_templateObject3 = _taggedTemplateLiteral(["\n            margin-top: 40px;\n          "]))));

    case 'large':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-top:64px;", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledSection_templateObject4 || (StyledSection_templateObject4 = _taggedTemplateLiteral(["\n            margin-top: 48px;\n          "]))));

    case 'small':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-top:32px;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject5 || (StyledSection_templateObject5 = _taggedTemplateLiteral(["\n            margin-top: 24px;\n          "]))));

    case 'none':
      return;

    case 'medium':
    default:
      return (0,styled_components_browser_esm/* css */.iv)(["margin-top:40px;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject6 || (StyledSection_templateObject6 = _taggedTemplateLiteral(["\n            margin-top: 32px;\n          "]))));
  }
}, function (_ref2) {
  var pb = _ref2.pb;

  switch (pb) {
    case 'xl-large':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:64px;", " ", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(StyledSection_templateObject7 || (StyledSection_templateObject7 = _taggedTemplateLiteral(["\n            margin-bottom: 48px;\n          "]))), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject8 || (StyledSection_templateObject8 = _taggedTemplateLiteral(["\n            margin-bottom: 40px;\n          "]))));

    case 'x-large':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:56px;", " ", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledSection_templateObject9 || (StyledSection_templateObject9 = _taggedTemplateLiteral(["\n            margin-bottom: 48px;\n          "]))), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject10 || (StyledSection_templateObject10 = _taggedTemplateLiteral(["\n            margin-bottom: 40px;\n          "]))));

    case 'large':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:48px;", " ", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledSection_templateObject11 || (StyledSection_templateObject11 = _taggedTemplateLiteral(["\n            margin-bottom: 40px;\n          "]))), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject12 || (StyledSection_templateObject12 = _taggedTemplateLiteral(["\n            margin-bottom: 32px;\n          "]))));

    case 'small':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:32px;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject13 || (StyledSection_templateObject13 = _taggedTemplateLiteral(["\n            margin-bottom: 24px;\n          "]))));

    case 'none':
      return;

    case 'medium':
    default:
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:40px;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject14 || (StyledSection_templateObject14 = _taggedTemplateLiteral(["\n            margin-bottom: 32px;\n          "]))));
  }
}, function (_ref3) {
  var mb = _ref3.mb;

  switch (mb) {
    case 'x-large':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:72px;", " ", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledSection_templateObject15 || (StyledSection_templateObject15 = _taggedTemplateLiteral(["\n            margin-bottom: 48px;\n          "]))), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledSection_templateObject16 || (StyledSection_templateObject16 = _taggedTemplateLiteral(["\n            margin-bottom: 32px;\n          "]))));

    default:
      break;
  }
});
/* harmony default export */ var styles_StyledSection = (StyledSection);
;// CONCATENATED MODULE: ./components/styles/StyledTitle.js


var StyledTitle_templateObject, StyledTitle_templateObject2, StyledTitle_templateObject3, StyledTitle_templateObject4, StyledTitle_templateObject5, StyledTitle_templateObject6, StyledTitle_templateObject7, StyledTitle_templateObject8, StyledTitle_templateObject9, StyledTitle_templateObject10, StyledTitle_templateObject11, StyledTitle_templateObject12, StyledTitle_templateObject13;





var StyledTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "StyledTitle",
  componentId: "sc-syg0a-0"
})(["display:block;font-family:", ";font-weight:500;color:", ";", ";", " ", " ", " ", " ", " ", " ", ""], vars/* default.fonts.futura */.Z.fonts.futura, theme/* default.text.accent */.Z.text.accent, function (props) {
  return props.invisible && (0,styled_components_browser_esm/* css */.iv)(["position:absolute;width:1px;height:1px;margin:-1px;border:0;padding:0;clip:rect(0 0 0 0);clip-path:inset(50%);overflow:hidden;pointer-events:none;white-space:nowrap;"]);
}, function (_ref) {
  var font = _ref.font;

  switch (font) {
    case 'normal':
      {
        return (0,styled_components_browser_esm/* css */.iv)(["font-family:", ";font-weight:400;"], vars/* default.fonts.futuraBook */.Z.fonts.futuraBook);
      }

    default:
      break;
  }
}, function (_ref2) {
  var size = _ref2.size;

  switch (size) {
    case 'x-large':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:48px;line-height:1.1;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject || (StyledTitle_templateObject = _taggedTemplateLiteral(["\n            font-size: 32px;\n          "]))));

    case 'large':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:40px;line-height:1.1;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject2 || (StyledTitle_templateObject2 = _taggedTemplateLiteral(["\n            font-size: 32px;\n          "]))));

    case 'medium':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:32px;line-height:1.1;", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledTitle_templateObject3 || (StyledTitle_templateObject3 = _taggedTemplateLiteral(["\n            font-size: 24px;\n          "]))));

    case 'small':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:24px;line-height:1.3;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject4 || (StyledTitle_templateObject4 = _taggedTemplateLiteral(["\n            font-size: 18px;\n          "]))));

    case 'x-small':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:20px;line-height:1.3;"]);

    case 'xx-small':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:18px;line-height:1.3;"]);

    case 'custom':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:var(--title-fz,18px);"]);

    default:
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:32px;line-height:1.2;", ""], maxWidth(vars/* default.breakpoints.sMobile */.Z.breakpoints.sMobile)(StyledTitle_templateObject5 || (StyledTitle_templateObject5 = _taggedTemplateLiteral(["\n            font-size: 30px;\n          "]))));
  }
}, function (_ref3) {
  var mb = _ref3.mb;

  switch (mb) {
    case 'large':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:48px;", " ", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledTitle_templateObject6 || (StyledTitle_templateObject6 = _taggedTemplateLiteral(["\n            margin-bottom: 40px;\n          "]))), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject7 || (StyledTitle_templateObject7 = _taggedTemplateLiteral(["\n            margin-bottom: 32px;\n          "]))));

    case 'small':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:32px;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject8 || (StyledTitle_templateObject8 = _taggedTemplateLiteral(["\n            margin-bottom: 24px;\n          "]))));

    case 'x-small':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:24px;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject9 || (StyledTitle_templateObject9 = _taggedTemplateLiteral(["\n            margin-bottom: 16px;\n          "]))));

    case 'xx-small':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:18px;"]);

    case 'none':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:0;"]);

    case 'custom':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:var(--title-mb,16px);"]);

    case 'medium':
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:40px;", ""], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject10 || (StyledTitle_templateObject10 = _taggedTemplateLiteral(["\n            margin-bottom: 32px;\n          "]))));

    default:
  }
}, function (_ref4) {
  var align = _ref4.align;

  switch (align) {
    case 'center':
      return (0,styled_components_browser_esm/* css */.iv)(["text-align:center;"]);

    case 'left':
    default:
      return (0,styled_components_browser_esm/* css */.iv)(["text-align:left;"]);
  }
}, function (props) {
  return props.special && (0,styled_components_browser_esm/* css */.iv)(["letter-spacing:0.15em;text-transform:uppercase;"]);
}, function (props) {
  return props.success && (0,styled_components_browser_esm/* css */.iv)(["color:", ";&::before{content:'';display:inline-block;vertical-align:top;width:40px;height:14px;margin-right:19px;background:0 0;border-bottom:4px solid currentColor;border-left:4px solid currentColor;transform:translate(4px,14px) rotate(-45deg);", "}"], theme/* default.brand.default */.Z.brand["default"], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject11 || (StyledTitle_templateObject11 = _taggedTemplateLiteral(["\n          width: 34px;\n          height: 12px;\n          border-width: 3px;\n          transform: translate(3px,9px) rotate(-45deg);\n        "]))));
}, function (props) {
  return props.fail && (0,styled_components_browser_esm/* css */.iv)(["position:relative;padding-left:60px;color:", ";&::before,&::after{content:'';position:absolute;top:21px;left:4px;display:block;width:40px;height:4px;background-color:currentColor;", "}&::before{transform:rotate(45deg);}&::after{transform:rotate(-45deg);}", ""], theme/* default.text.accent */.Z.text.accent, maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject12 || (StyledTitle_templateObject12 = _taggedTemplateLiteral(["\n          top: 17px;\n          left: -2px;\n          width: 30px;\n          height: 3px;\n        "]))), maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledTitle_templateObject13 || (StyledTitle_templateObject13 = _taggedTemplateLiteral(["\n        padding-left: 42px;\n      "]))));
});
/* harmony default export */ var styles_StyledTitle = (StyledTitle);
;// CONCATENATED MODULE: ./components/styles/StyledPage.js


var StyledPage_templateObject, StyledPage_templateObject2, StyledPage_templateObject3, StyledPage_templateObject4, StyledPage_templateObject5, StyledPage_templateObject6, StyledPage_templateObject7, StyledPage_templateObject8, StyledPage_templateObject9, StyledPage_templateObject10, StyledPage_templateObject11;








var Page = (0,styled_components_browser_esm/* default */.ZP)(styles_StyledSection).withConfig({
  displayName: "StyledPage__Page",
  componentId: "sc-e2r6yv-0"
})(["margin-top:16px;"]);
Page.Container = (0,styled_components_browser_esm/* default */.ZP)(styles_Container).withConfig({
  displayName: "StyledPage__Container",
  componentId: "sc-e2r6yv-1"
})(["", ";"], function (props) {
  return props.center === true && (0,styled_components_browser_esm/* css */.iv)(["justify-content:center;display:flex;"]);
});
Page.Columns = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__Columns",
  componentId: "sc-e2r6yv-2"
})(["display:grid;", ""], function (_ref) {
  var styledType = _ref.styledType;

  switch (styledType) {
    case 'user':
      return (0,styled_components_browser_esm/* css */.iv)(["grid-template-columns:284px minmax(0,1fr);grid-gap:40px;", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(StyledPage_templateObject || (StyledPage_templateObject = _taggedTemplateLiteral(["\n            grid-template-columns: minmax(0, 1fr);\n            grid-gap: 0;\n          "]))));

    default:
      break;
  }
});
Page.Main = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__Main",
  componentId: "sc-e2r6yv-3"
})([""]);
Page.ContentLimiter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__ContentLimiter",
  componentId: "sc-e2r6yv-4"
})(["max-width:832px;margin:0 auto;"]);
Page.Nav = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "StyledPage__Nav",
  componentId: "sc-e2r6yv-5"
})(["margin-top:-4px;", ""], maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet + 1)(StyledPage_templateObject2 || (StyledPage_templateObject2 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
Page.NavItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "StyledPage__NavItem",
  componentId: "sc-e2r6yv-6"
})([""]);
Page.NavLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "StyledPage__NavLink",
  componentId: "sc-e2r6yv-7"
})(["display:block;padding:5px 0;font-size:18px;line-height:1.22;color:", ";& > span{border-bottom:1px solid ", ";transition:border-color 0.2s ease;padding-left:8px;padding-right:8px;", "}", " ", ""], theme/* default.text.accent */.Z.text.accent, theme/* default.text.reverse */.Z.text.reverse, function (props) {
  return props.active && (0,styled_components_browser_esm/* css */.iv)(["border-left:2px solid ", ";border-radius:2px;"], theme/* default.brand.default */.Z.brand["default"]);
}, noTouch()(StyledPage_templateObject3 || (StyledPage_templateObject3 = _taggedTemplateLiteral(["\n    &:hover {\n      & > span {\n        border-bottom-color: ", ";\n      }\n    }\n  "])), function (props) {
  return !props.active && theme/* default.text.extra */.Z.text.extra;
}), function (props) {
  return props.active && (0,styled_components_browser_esm/* css */.iv)(["display:inline-block;font-family:", ";font-weight:500;cursor:default;"], vars/* default.fonts.futura */.Z.fonts.futura);
});
Page.CustomWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__CustomWrapper",
  componentId: "sc-e2r6yv-8"
})(["margin-top:", ";", " ", " &:last-child{margin-bottom:144px;}"], function (props) {
  return props.isCustomOffsetBlock ? '96px' : '0px';
}, maxWidth(vars/* default.breakpoints.tablet */.Z.breakpoints.tablet)(StyledPage_templateObject4 || (StyledPage_templateObject4 = _taggedTemplateLiteral(["\n      margin-top: ", ";\n    "])), function (props) {
  return props.isCustomOffsetBlock ? '72px' : '0px';
}), maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledPage_templateObject5 || (StyledPage_templateObject5 = _taggedTemplateLiteral(["\n      margin-top: ", ";\n    "])), function (props) {
  return props.isCustomOffsetBlock ? '64px' : '0px';
}));
Page.BreadCrumbs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__BreadCrumbs",
  componentId: "sc-e2r6yv-9"
})(["&:not(:last-child){margin-bottom:24px;}"]);
Page.Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__Title",
  componentId: "sc-e2r6yv-10"
})(["&:not(:last-child){margin-bottom:24px;}"]);
Page.Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__Text",
  componentId: "sc-e2r6yv-11"
})(["&:not(:last-child){margin-bottom:32px;}"]);
Page.ArticleTitle = (0,styled_components_browser_esm/* default */.ZP)(styles_StyledTitle).attrs({
  as: 'h1',
  size: 'x-large',
  mb: 'large',
  align: 'center'
}).withConfig({
  displayName: "StyledPage__ArticleTitle",
  componentId: "sc-e2r6yv-12"
})([""]);
Page.SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__SubTitle",
  componentId: "sc-e2r6yv-13"
})(["font-size:24px;text-align:center;margin-bottom:56px;", " ", " + &{margin-top:-12px;}"], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledPage_templateObject6 || (StyledPage_templateObject6 = _taggedTemplateLiteral(["\n    margin-bottom: 40px;\n  "]))), Page.ArticleTitle);
Page.Link = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__Link",
  componentId: "sc-e2r6yv-14"
})(["display:flex;justify-content:center;--button-m-horizontal:0;", ";", " ~ &{margin-top:32px;}"], function (props) {
  return props.styledAlign === 'left' && (0,styled_components_browser_esm/* css */.iv)(["justify-content:flex-start;"]);
}, Page.Title);
Page.ProductsSlider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__ProductsSlider",
  componentId: "sc-e2r6yv-15"
})(["&:not(:first-child){margin-top:48px;", ";", " ", "}&:not(:last-child){margin-bottom:32px;}"], function (props) {
  return props.withoutUpperMargin && (0,styled_components_browser_esm/* css */.iv)(["margin-top:0px;"]);
}, maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledPage_templateObject7 || (StyledPage_templateObject7 = _taggedTemplateLiteral(["\n      margin-top: 32px;\n    "]))), maxWidth(vars/* default.breakpoints.mobile */.Z.breakpoints.mobile)(StyledPage_templateObject8 || (StyledPage_templateObject8 = _taggedTemplateLiteral(["\n      margin-top: 24px;\n    "]))));
Page.Type = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "StyledPage__Type",
  componentId: "sc-e2r6yv-16"
})(["margin-bottom:8px;font-family:", ";font-weight:500;letter-spacing:0.15em;text-transform:uppercase;text-align:center;color:", ";"], vars/* default.fonts.futura */.Z.fonts.futura, theme/* default.text.secondary */.Z.text.secondary);
Page.Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__Image",
  componentId: "sc-e2r6yv-17"
})(["position:relative;margin-bottom:40px;", " &::after{content:'';padding-top:66.66%;display:inline-block;vertical-align:top;}& img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;}"], maxWidth(vars/* default.breakpoints.lMobile */.Z.breakpoints.lMobile)(StyledPage_templateObject9 || (StyledPage_templateObject9 = _taggedTemplateLiteral(["\n    margin-bottom: 32px;\n  "]))));
Page.CarouselImageLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "StyledPage__CarouselImageLink",
  componentId: "sc-e2r6yv-18"
})(["cursor:pointer;"]);
Page.CarouselImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "StyledPage__CarouselImage",
  componentId: "sc-e2r6yv-19"
})(["", ";"], function (props) {
  return props.padding && (0,styled_components_browser_esm/* css */.iv)(["padding:", "px;"], props.padding);
});
Page.Share = (0,styled_components_browser_esm/* default */.ZP)(styles_StyledSection).attrs({
  pt: 'none',
  pb: 'xl-large'
}).withConfig({
  displayName: "StyledPage__Share",
  componentId: "sc-e2r6yv-20"
})([""]);
Page.Articles = (0,styled_components_browser_esm/* default */.ZP)(styles_StyledSection).attrs({
  pt: 'medium',
  pb: 'xl-large'
}).withConfig({
  displayName: "StyledPage__Articles",
  componentId: "sc-e2r6yv-21"
})(["border-top:1px solid ", ";"], theme/* default.bg.divider */.Z.bg.divider);
Page.Date = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
  displayName: "StyledPage__Date",
  componentId: "sc-e2r6yv-22"
})(["display:block;margin-bottom:32px;font-size:14px;color:", ";text-align:center;", " + &{margin-top:-16px;}", " + &{margin-top:-18px;}"], theme/* default.text.extra */.Z.text.extra, Page.ArticleTitle, Page.SubTitle);
Page.Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledPage__Label",
  componentId: "sc-e2r6yv-23"
})(["position:absolute;display:flex;background:#292c33;color:#ffffff;opacity:0.9;border-radius:4px;font-size:22px;line-height:32px;padding:4px 8px;cursor:pointer;transform:translateY(50%);", " ", " & > span{order:1;}", ";", ";", ";", ";"], maxWidth(vars/* default.breakpoints.mTablet */.Z.breakpoints.mTablet)(StyledPage_templateObject10 || (StyledPage_templateObject10 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 24px;\n  "]))), maxWidth(vars/* default.breakpoints.sMobile */.Z.breakpoints.sMobile)(StyledPage_templateObject11 || (StyledPage_templateObject11 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 18px;\n  "]))), function (props) {
  return props.y && (0,styled_components_browser_esm/* css */.iv)(["top:", "%;"], props.y);
}, function (props) {
  return props.x && (0,styled_components_browser_esm/* css */.iv)(["left:", "%;"], props.x);
}, function (props) {
  return props.position === 'left' && (0,styled_components_browser_esm/* css */.iv)(["img{transform:rotate(180deg);order:0;margin-right:8px;}"]);
}, function (props) {
  return props.position === 'right' && (0,styled_components_browser_esm/* css */.iv)(["transform:translate(-100%,50%);img{order:2;margin-left:8px;}"]);
});
/* harmony default export */ var StyledPage = (Page);
;// CONCATENATED MODULE: ./components/styles/StyledTabs.js


var StyledTabs_templateObject, StyledTabs_templateObject2, StyledTabs_templateObject3, StyledTabs_templateObject4;





var StyledTabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledTabs",
  componentId: "sc-1hch4y4-0"
})([""]);
StyledTabs.Buttons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledTabs__Buttons",
  componentId: "sc-1hch4y4-1"
})(["display:flex;padding-bottom:2px;margin-bottom:var(--tabs-buttons-mb,30px);overflow-x:auto;", ""], maxWidth(vars/* default.breakpoints.mobile */.Z.breakpoints.mobile)(StyledTabs_templateObject || (StyledTabs_templateObject = _taggedTemplateLiteral(["\n    flex-wrap: wrap;\n  "]))));
StyledTabs.Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "StyledTabs__Button",
  componentId: "sc-1hch4y4-2"
})(["display:block;padding:9px 16px 11px;color:", ";font-family:", ";font-weight:500;font-size:14px;letter-spacing:0.15em;text-transform:uppercase;text-align:center;border:1px solid ", ";border-right:none;background:", ";transition:color 0.25s ease,background 0.25s ease,border-color 0.25s ease;&:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px;}&:last-child{border-right:", ";border-top-right-radius:4px;border-bottom-right-radius:4px;}", " ", " ", ""], theme/* default.text.accent */.Z.text.accent, vars/* default.fonts.futura */.Z.fonts.futura, theme/* default.input.border */.Z.input.border, theme/* default.bg.default */.Z.bg["default"], function (props) {
  return !props.active && "1px solid ".concat(theme/* default.input.border */.Z.input.border);
}, function (props) {
  return props.active && (0,styled_components_browser_esm/* css */.iv)(["color:", ";background:", ";border-color:", ";cursor:default;& + &{border-left:none;padding-left:17px;", "}"], theme/* default.text.reverse */.Z.text.reverse, theme/* default.input.selected */.Z.input.selected, theme/* default.input.selected */.Z.input.selected, maxWidth(vars/* default.breakpoints.mobile */.Z.breakpoints.mobile)(StyledTabs_templateObject2 || (StyledTabs_templateObject2 = _taggedTemplateLiteral(["\n          border-left: 1px solid ", ";\n          padding-left: 16px;\n          border-top: none;\n          padding-top: 9px;\n        "])), theme/* default.input.border */.Z.input.border));
}, noTouch()(StyledTabs_templateObject3 || (StyledTabs_templateObject3 = _taggedTemplateLiteral(["\n    &:hover {\n      border-color: ", ";\n    }\n  "])), function (props) {
  return !props.active && theme/* default.input.hover */.Z.input.hover;
}), maxWidth(vars/* default.breakpoints.mobile */.Z.breakpoints.mobile)(StyledTabs_templateObject4 || (StyledTabs_templateObject4 = _taggedTemplateLiteral(["\n    width: 100%;\n    border-bottom: none;\n    border-right: ", ";\n\n    &:first-child {\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 0px;\n      border-top-right-radius: 4px;\n    }\n\n    &:last-child {\n      border-bottom: ", ";\n      border-top-right-radius: 0px;\n      border-bottom-right-radius: 4px;\n      border-bottom-left-radius: 4px;\n    }\n  "])), function (props) {
  return props.active ? "1px solid ".concat(theme/* default.input.selected */.Z.input.selected) : "1px solid ".concat(theme/* default.input.border */.Z.input.border);
}, function (props) {
  return !props.active && "1px solid ".concat(theme/* default.input.border */.Z.input.border);
}));
StyledTabs.Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledTabs__Content",
  componentId: "sc-1hch4y4-3"
})(["&.on-enter{opacity:0;transform:translateY(10px);}&.on-enter-active{opacity:1;transform:none;transition:opacity 0.2s ease-in,transform 0.2s ease-in;}&.on-exit{opacity:1;}&.on-exit-active{opacity:0;transition:opacity 0.2s ease-out,transform 0.2s ease-out;}"]);
/* harmony default export */ var styles_StyledTabs = ((/* unused pure expression or super */ null && (StyledTabs)));
;// CONCATENATED MODULE: ./components/styles/index.js










/***/ }),

/***/ 84799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ categoryTreeMobile_CategoryTreeMobile; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./containers/categoryTreeMobile/CategoryTreeMobile.module.scss
var CategoryTreeMobile_module = __webpack_require__(84593);
var CategoryTreeMobile_module_default = /*#__PURE__*/__webpack_require__.n(CategoryTreeMobile_module);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./utils/sorting.js
var sorting = __webpack_require__(45980);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/categoryTreeMobile/CategoryTreeMobile.js









var CategoryTreeMobile = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var sidebar = _ref.sidebar,
      savedQuery = _ref.savedQuery,
      _ref$isSearch = _ref.isSearch,
      isSearch = _ref$isSearch === void 0 ? false : _ref$isSearch;

  var _useState = (0,react.useState)([]),
      currentSidebar = _useState[0],
      setCurrentSidebar = _useState[1];

  var favoriteBrands = (0,es/* useSelector */.v9)(store/* favoriteBrandsSelector */.mN);
  (0,react.useEffect)(function () {
    // if (isSearch) {
    //   setCurrentSidebar(sidebar);
    // } else {
    for (var i = 0; i < sidebar.length; i++) {
      var item = sidebar[i];

      if (item.childrens) {
        if (favoriteBrands.length > 0 && item.childrens.length > 0) {
          var sortedByFavBrands = (0,sorting/* sortingByFavBrands */.j)(item.childrens, favoriteBrands);
          setCurrentSidebar(sortedByFavBrands);
        } else {
          setCurrentSidebar(item.childrens);
        }

        break;
      }
    } // }

  }, [sidebar]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (CategoryTreeMobile_module_default()).main,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CategoryTreeMobile_module_default()).wrap,
      children: currentSidebar.map(function (_ref2) {
        var slug = _ref2.slug,
            name = _ref2.name;

        var _getLinkProps = (0,getLinkProps/* default */.Z)({
          type: isSearch ? 'search' : 'catalog',
          value: slug
        }),
            _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
            linkHref = _getLinkProps2[0],
            linkAs = _getLinkProps2[1];

        return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
          href: {
            pathname: linkHref,
            query: savedQuery || {}
          },
          as: {
            pathname: linkAs,
            query: savedQuery || {}
          },
          shallow: true,
          disableActive: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
            className: (CategoryTreeMobile_module_default()).point,
            children: name
          })
        }, slug);
      })
    })
  });
});
/* harmony default export */ var categoryTreeMobile_CategoryTreeMobile = (CategoryTreeMobile);
;// CONCATENATED MODULE: ./containers/categoryTreeMobile/index.js


/***/ }),

/***/ 17338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ errorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__(72179);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./containers/errorBoundary/ErrorBoundary.module.scss
var ErrorBoundary_module = __webpack_require__(91002);
var ErrorBoundary_module_default = /*#__PURE__*/__webpack_require__.n(ErrorBoundary_module);
// EXTERNAL MODULE: ./containers/footer/index.js + 5 modules
var footer = __webpack_require__(24449);
// EXTERNAL MODULE: ./containers/header/index.js + 9 modules
var header = __webpack_require__(89520);
// EXTERNAL MODULE: ./containers/navPopular/index.js + 1 modules
var navPopular = __webpack_require__(9995);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/errorBoundary/ErrorBoundary.js






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }















var ErrorBoundary = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _user$id, _user$email, _user$phone;

      var user = this.props.user;
      esm/* captureException */.Tb({
        error: error,
        errorInfo: errorInfo
      });
      esm/* setUser */.av({
        id: (_user$id = user === null || user === void 0 ? void 0 : user.id) !== null && _user$id !== void 0 ? _user$id : '',
        email: (_user$email = user === null || user === void 0 ? void 0 : user.email) !== null && _user$email !== void 0 ? _user$email : '',
        username: (_user$phone = user === null || user === void 0 ? void 0 : user.phone) !== null && _user$phone !== void 0 ? _user$phone : ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
              children: "\u041F\u043E\u0445\u043E\u0436\u0435, \u0447\u0442\u043E-\u0442\u043E \u0441\u043B\u043E\u043C\u0430\u043B\u043E\u0441\u044C..."
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (ErrorBoundary_module_default()).wrapp,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: (ErrorBoundary_module_default()).image,
              src: "/images/svg/frontend_error.svg",
              alt: "error"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              className: (ErrorBoundary_module_default()).title,
              children: "\u041F\u043E\u0445\u043E\u0436\u0435, \u0447\u0442\u043E-\u0442\u043E \u0441\u043B\u043E\u043C\u0430\u043B\u043E\u0441\u044C..."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (ErrorBoundary_module_default()).text,
              children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434 \u0438\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (ErrorBoundary_module_default()).btnContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
                type: "primary",
                onClick: function onClick() {
                  window.location.assign('/');
                },
                classNames: {
                  general: (ErrorBoundary_module_default()).btn
                },
                children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.Z, {})]
        });
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react.Component);

var mapState = function mapState(state) {
  return {
    user: state.user.user
  };
};

/* harmony default export */ var errorBoundary_ErrorBoundary = ((0,es/* connect */.$j)(mapState)(ErrorBoundary));
;// CONCATENATED MODULE: ./containers/errorBoundary/index.js

/* harmony default export */ var errorBoundary = (errorBoundary_ErrorBoundary);

/***/ }),

/***/ 24449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/cartSlice.js
var cartSlice = __webpack_require__(78955);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/config.js
var config = __webpack_require__(6668);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./containers/footer/linksList/linkList.module.scss
var linkList_module = __webpack_require__(86000);
var linkList_module_default = /*#__PURE__*/__webpack_require__.n(linkList_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/footer/linksList/LinksList.js




var MenuLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var href = _ref.href,
      title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: href,
    ref: ref,
    className: (linkList_module_default()).link,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: title
    })
  });
});

var Linklist = function Linklist(_ref2) {
  var links = _ref2.links;
  if (!links || links.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (linkList_module_default()).list,
    children: links.map(function (item, ind) {
      var title = item.title,
          url = item.url;
      var itemId = title + ind;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (linkList_module_default()).item,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: url,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuLink, {
            title: title
          })
        })
      }, itemId);
    })
  });
};

/* harmony default export */ var LinksList = (Linklist);
;// CONCATENATED MODULE: ./containers/footer/linksList/index.js

/* harmony default export */ var linksList = (LinksList);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/userSlice.js
var userSlice = __webpack_require__(46789);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./containers/footer/subscribe/Subscribe.module.scss
var Subscribe_module = __webpack_require__(66292);
var Subscribe_module_default = /*#__PURE__*/__webpack_require__.n(Subscribe_module);
;// CONCATENATED MODULE: ./containers/footer/subscribe/Subscribe.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var Subscribe = function Subscribe() {
  var dispatch = (0,es/* useDispatch */.I0)();
  var emailRef = (0,react.useRef)(null);

  var _useSelector = (0,es/* useSelector */.v9)(userSlice/* getAuthData */.nr),
      subscribeError = _useSelector.subscribeError;

  var errorText = (0,react.useMemo)(function () {
    var _subscribeError$error;

    var error = 'Произошла ошибка, попробуйте позже';

    if (subscribeError !== null && subscribeError !== void 0 && (_subscribeError$error = subscribeError.errors) !== null && _subscribeError$error !== void 0 && _subscribeError$error.email) {
      var _subscribeError$error2;

      error = subscribeError === null || subscribeError === void 0 ? void 0 : (_subscribeError$error2 = subscribeError.errors) === null || _subscribeError$error2 === void 0 ? void 0 : _subscribeError$error2.email[0];
    }

    return error;
  }, [subscribeError]);

  var _useState = (0,react.useState)(''),
      error = _useState[0],
      setError = _useState[1];

  var _useState2 = (0,react.useState)(''),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = (0,react.useState)({
    visible: false,
    type: 'success'
  }),
      formSubmitState = _useState3[0],
      setFormSubmitState = _useState3[1];

  (0,react.useEffect)(function () {
    if (subscribeError) {
      setError(errorText);
      setFormSubmitState({
        visible: true,
        type: 'error'
      });
    } else {
      setError('');
    }
  }, [errorText, subscribeError]);

  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    var mindboxDeviceUUID = js_cookie_default().get('mindboxDeviceUUID');
    setFormSubmitState(_objectSpread(_objectSpread({}, formSubmitState), {}, {
      visible: false
    }));
    dispatch((0,userSlice/* subscribeByEmail */.ox)({
      email: email,
      mindboxDeviceUUID: mindboxDeviceUUID || '',
      onSuccess: function onSuccess() {
        setError('');
        setFormSubmitState({
          visible: true,
          type: 'success'
        });
        setEmail('');
        Ecommerce/* default.setSubscribe */.ZP.setSubscribe();
      }
    }));
  };

  var onChange = function onChange(e) {
    var _e$target;

    if (formSubmitState.visible) {
      setFormSubmitState(_objectSpread(_objectSpread({}, formSubmitState), {}, {
        visible: false
      }));
    }

    var value = (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) || '';
    setEmail(value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Subscribe_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Text */.xv, {
      mb: "mb-x-small",
      size: "size-small",
      className: (Subscribe_module_default()).label,
      children: "\u041F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E\u0431\xA0\u0430\u043A\u0446\u0438\u044F\u0445 \u0438 \u0441\u043A\u0438\u0434\u043A\u0430\u0445:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      action: "/",
      onSubmit: onSubmit,
      noValidate: true,
      className: (Subscribe_module_default())["subscribe-form"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "email",
        name: "email",
        ref: emailRef,
        "aria-label": "email",
        placeholder: "\u0412\u0430\u0448 e-mail",
        value: email,
        onChange: onChange,
        className: (Subscribe_module_default()).input
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "submit",
        "aria-label": "subscribe",
        className: (Subscribe_module_default())["subscribe-btn"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          width: "6",
          height: "9",
          fill: "currentColor",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M.707.707a1 1 0 0 1 1.414 0l3.114 3.114a1 1 0 0 1-1.414 1.414L.707 2.121a1 1 0 0 1 0-1.414z"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M.707 8.35a1 1 0 0 0 1.414 0l3.114-3.115a1 1 0 0 0-1.414-1.414L.707 6.935a1 1 0 0 0 0 1.414z"
          })]
        })
      }), formSubmitState.visible && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Text */.xv, {
        className: (0,clsx_m/* default */.Z)((Subscribe_module_default()).text, (Subscribe_module_default())["submit-".concat(formSubmitState.type)]),
        children: formSubmitState.type === 'success' ? 'Вы успешно подписались на рассылку.' : error
      })]
    })]
  });
};

/* harmony default export */ var subscribe_Subscribe = (Subscribe);
;// CONCATENATED MODULE: ./containers/footer/subscribe/index.js

/* harmony default export */ var subscribe = (subscribe_Subscribe);
// EXTERNAL MODULE: ./containers/footer/footer.module.scss
var footer_module = __webpack_require__(87659);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./containers/footer/Footer.js



















var Accordion = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6962).then(__webpack_require__.bind(__webpack_require__, 6962));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6962)];
    }
  }
});

var getHeight = function getHeight(index) {
  var height = '12px';

  switch (index) {
    case 1:
      height = '22px';
      break;

    case 2:
      height = '20px';
      break;

    case 3:
      height = '13px';
      break;

    case 4:
      height = '23px';
      break;

    case 5:
      height = '12px';
      break;

    case 6:
      height = '32px';
      break;

    case 7:
      height = '21px';
      break;

    case 8:
      height = '18px';
      break;

    case 9:
      height = '9px';
      break;

    case 10:
      height = '44px';
      break;

    default:
      break;
  }

  return height;
};

var getWidth = function getWidth(index) {
  var width = '34px';

  switch (index) {
    case 1:
      width = '32px';
      break;

    case 2:
      width = '30px';
      break;

    case 3:
      width = '40px';
      break;

    case 4:
      width = '20px';
      break;

    case 5:
      width = '48px';
      break;

    case 6:
      width = '33px';
      break;

    case 7:
      width = '32px';
      break;

    case 8:
      width = '32px';
      break;

    case 9:
      width = '38px';
      break;

    case 10:
      width = '66px';
      break;

    default:
      break;
  }

  return width;
};

var Footer = function Footer() {
  var _footer$find$links, _footer$find, _footer$find$links2, _footer$find2, _footer$find$links3, _footer$find3, _currentCity$name, _currentCity$name2, _currentCity$name3, _currentCity$name4;

  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();
  var footer = (0,es/* useSelector */.v9)(store/* menuFooterSelector */.wA);
  var sessionData = (0,es/* useSelector */.v9)(sessionSlice/* getSessionData */.gP);
  var citiesData = (0,es/* useSelector */.v9)(store/* getCitiesSelector */.rr);
  var sessionID = (0,es/* useSelector */.v9)(store/* sessionIdSelector */.c9);

  var _useState = (0,react.useState)(false),
      locationModalOpen = _useState[0],
      setLocationModalOpen = _useState[1];

  var currentCity = (0,react.useMemo)(function () {
    var _citiesData$find2;

    if (!sessionData.regionId) {
      var _citiesData$find;

      return (_citiesData$find = citiesData.find(function (city) {
        return city.name === 'Минск';
      })) !== null && _citiesData$find !== void 0 ? _citiesData$find : null;
    }

    return (_citiesData$find2 = citiesData.find(function (city) {
      return city.id === sessionData.regionId;
    })) !== null && _citiesData$find2 !== void 0 ? _citiesData$find2 : null;
  }, [sessionData.regionId, citiesData]);
  var otherCity = (0,react.useMemo)(function () {
    return citiesData.find(function (city) {
      return city.id !== (currentCity === null || currentCity === void 0 ? void 0 : currentCity.id);
    });
  }, [currentCity, sessionData.regionId]);
  var firstColLinks = (_footer$find$links = (_footer$find = footer.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item._id) === 'first_col';
  })) === null || _footer$find === void 0 ? void 0 : _footer$find.links) !== null && _footer$find$links !== void 0 ? _footer$find$links : [];
  var secondColLinks = (_footer$find$links2 = (_footer$find2 = footer.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item._id) === 'second_col';
  })) === null || _footer$find2 === void 0 ? void 0 : _footer$find2.links) !== null && _footer$find$links2 !== void 0 ? _footer$find$links2 : [];
  var thirdColLinks = (_footer$find$links3 = (_footer$find3 = footer.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item._id) === 'third_col';
  })) === null || _footer$find3 === void 0 ? void 0 : _footer$find3.links) !== null && _footer$find$links3 !== void 0 ? _footer$find$links3 : [];

  var handleCurrentCityClick = function handleCurrentCityClick(e) {
    e.stopPropagation();

    if (currentCity && sessionData.regionId !== currentCity.id) {
      dispatch((0,sessionSlice/* setRegion */.TF)({
        regionId: currentCity.id,
        onSuccess: function onSuccess() {
          if (router.pathname === '/cart' && sessionID) {
            dispatch((0,cartSlice/* fetchCart */.x7)({
              onSuccess: function onSuccess() {
                dispatch(createSession(true, undefined, {
                  forceRefresh: true
                }));
              }
            }));
          }
        }
      }));
    }

    setLocationModalOpen(false);
  };

  var handleOtherCityClick = function handleOtherCityClick(e) {
    e.stopPropagation();

    if (otherCity) {
      dispatch((0,sessionSlice/* setRegion */.TF)({
        regionId: otherCity.id,
        onSuccess: function onSuccess() {
          if (router.pathname === '/cart' && sessionID) {
            dispatch((0,cartSlice/* fetchCart */.x7)({
              onSuccess: function onSuccess() {
                dispatch(createSession(true, undefined, {
                  forceRefresh: true
                }));
              }
            }));
          }
        }
      }));
    }

    setLocationModalOpen(false);
  }; // const onClickPhone = () => {
  //   ecommerce.onClickPhoneNumber();
  // };


  return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
    id: "footer",
    className: (footer_module_default()).footer,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (footer_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).links, (footer_module_default())["order-1"], (footer_module_default()).desktopLinks),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
          component: "h3",
          className: (footer_module_default()).title,
          children: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (footer_module_default()).content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(linksList, {
            links: firstColLinks
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (footer_module_default()).location,
            onClick: function onClick() {
              return setLocationModalOpen(true);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
              name: "gps"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (footer_module_default()).locationTitle,
              children: "\u0421\u0430\u043C\u043E\u0432\u044B\u0432\u043E\u0437: \u0433. ".concat((_currentCity$name = currentCity === null || currentCity === void 0 ? void 0 : currentCity.name) !== null && _currentCity$name !== void 0 ? _currentCity$name : '')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((footer_module_default()).controlDropdown, locationModalOpen && (footer_module_default()).active),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (footer_module_default()).controlInner,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (footer_module_default()).question,
                  children: ["\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u044B, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u043A\xA0\u0441\u0430\u043C\u043E\u0432\u044B\u0432\u043E\u0437\u0443 \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u0437", ' ', "\u0433. ".concat((_currentCity$name2 = currentCity === null || currentCity === void 0 ? void 0 : currentCity.name) !== null && _currentCity$name2 !== void 0 ? _currentCity$name2 : '', "?")]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (footer_module_default()).btns,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (0,clsx_m/* default */.Z)((footer_module_default()).btn, (footer_module_default()).active),
                    onClick: handleCurrentCityClick,
                    children: "\u0414\u0430, \u0432\u0441\u0451 \u0432\u0435\u0440\u043D\u043E"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (0,clsx_m/* default */.Z)((footer_module_default()).btn),
                    onClick: handleOtherCityClick,
                    children: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0433. ".concat(otherCity === null || otherCity === void 0 ? void 0 : otherCity.name)
                  })]
                })]
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).links, (footer_module_default())["order-2"], (footer_module_default()).desktopLinks),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
          component: "h3",
          className: (footer_module_default()).title,
          children: "\u041F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F\u043C"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(linksList, {
          links: secondColLinks
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).links, (footer_module_default())["order-3"], (footer_module_default()).desktopLinks),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
          component: "h3",
          className: (footer_module_default()).title,
          children: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(linksList, {
          links: thirdColLinks
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).links, (footer_module_default())["order-1"], (footer_module_default()).mobileLinks),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion, {
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
            component: "h3",
            className: (footer_module_default()).title,
            children: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438"
          }),
          unmountOnClose: true,
          isFooter: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(linksList, {
            links: firstColLinks
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).links, (footer_module_default())["order-2"], (footer_module_default()).mobileLinks),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion, {
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
            component: "h3",
            className: (footer_module_default()).title,
            children: "\u041F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F\u043C"
          }),
          unmountOnClose: true,
          isFooter: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(linksList, {
            links: secondColLinks
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).links, (footer_module_default())["order-3"], (footer_module_default()).mobileLinks),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion, {
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
            component: "h3",
            className: (footer_module_default()).title,
            children: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"
          }),
          unmountOnClose: true,
          isFooter: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(linksList, {
            links: thirdColLinks
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).links, (footer_module_default())["order-5"], (footer_module_default()).mobileLinks),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion, {
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
            component: "h3",
            className: (footer_module_default()).title,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (footer_module_default()).mobileLocationTitle,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                name: "gps"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "\u0421\u0430\u043C\u043E\u0432\u044B\u0432\u043E\u0437: \u0433. ".concat((_currentCity$name3 = currentCity === null || currentCity === void 0 ? void 0 : currentCity.name) !== null && _currentCity$name3 !== void 0 ? _currentCity$name3 : '')
              })]
            })
          }),
          unmountOnClose: true,
          isFooter: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (footer_module_default()).modileLocationContent,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (footer_module_default()).question,
              children: ["\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u044B, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u043A\xA0\u0441\u0430\u043C\u043E\u0432\u044B\u0432\u043E\u0437\u0443 \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u0437", ' ', "\u0433. ".concat((_currentCity$name4 = currentCity === null || currentCity === void 0 ? void 0 : currentCity.name) !== null && _currentCity$name4 !== void 0 ? _currentCity$name4 : '', "?")]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (footer_module_default()).btns,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)((footer_module_default()).btn, (footer_module_default()).active),
                onClick: handleCurrentCityClick,
                children: "\u0414\u0430, \u0432\u0441\u0451 \u0432\u0435\u0440\u043D\u043E"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)((footer_module_default()).btn),
                onClick: handleOtherCityClick,
                children: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0433. ".concat(otherCity === null || otherCity === void 0 ? void 0 : otherCity.name)
              })]
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (footer_module_default()).info,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (footer_module_default()).workAndSubscribe,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (footer_module_default()).work,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              href: "tel:+375296332633",
              onClick: function onClick() {},
              className: (footer_module_default()).phone,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                name: "phone-fill",
                width: 16,
                height: 16,
                viewBox: "0 0 16 16"
              }), "+375 (29) 633-2-633"]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* Text */.xv, {
              className: (footer_module_default())["work-time"],
              children: ["\u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B: \u043F\u043D-\u0432\u0441 \u0441 09:00 \u0434\u043E 21:00,", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " \u0417\u0430\u043A\u0430\u0437\u044B \u0447\u0435\u0440\u0435\u0437 \u043A\u043E\u0440\u0437\u0438\u043D\u0443 \u043A\u0440\u0443\u0433\u043B\u043E\u0441\u0443\u0442\u043E\u0447\u043D\u043E"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(subscribe, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (footer_module_default()).socialList,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SocialList */.XA, {
            list: [].concat((0,toConsumableArray/* default */.Z)(config/* messengersList */.YP), (0,toConsumableArray/* default */.Z)(config/* socialList */.Ok)),
            type: "messengers"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (footer_module_default()).app,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (footer_module_default())["app-content"],
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (footer_module_default()).appLinks,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                href: "https://apps.apple.com/us/app/id1518240278",
                rel: "noopener noreferrer",
                target: "_blank",
                className: (footer_module_default())["app-link"],
                onClick: function onClick() {},
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                  name: "ios"
                }), "\u0421\u043A\u0430\u0447\u0430\u0442\u044C", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0432 App Store"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                href: "https://play.google.com/store/apps/details?id=com.websecret.fh",
                rel: "noopener noreferrer",
                target: "_blank",
                className: (footer_module_default())["app-link"],
                onClick: function onClick() {},
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                  name: "google-play"
                }), "\u0421\u043A\u0430\u0447\u0430\u0442\u044C", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0432 Google Play"]
              })]
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (footer_module_default()).features,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (footer_module_default())["features-text"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (footer_module_default()).text,
            children: "\u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u043C\u0430\u0433\u0430\u0437\u0438\u043D \u043E\u0434\u0435\u0436\u0434\u044B, \u043E\u0431\u0443\u0432\u0438 \u0438 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u043E\u0432 \u043C\u0438\u0440\u043E\u0432\u044B\u0445 \u0431\u0440\u0435\u043D\u0434\u043E\u0432. \u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u0441 \u043F\u0440\u0438\u043C\u0435\u0440\u043A\u043E\u0439 \u043F\u043E \u0432\u0441\u0435\u0439 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u0438*. \u0421\u0430\u043C\u043E\u0432\u044B\u0432\u043E\u0437 \u0438\u0437 \u0444\u0438\u0440\u043C\u0435\u043D\u043D\u044B\u0445 \u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u0441\u0435\u0442\u0438. \u0411\u044B\u0441\u0442\u0440\u0430\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u0432 \u0420\u043E\u0441\u0441\u0438\u044E."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (footer_module_default()).text,
            children: ["*\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \xAB", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RoutedLink */.S4, {
              to: "/delivery",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u0438 \u043E\u043F\u043B\u0430\u0442\u0430"
              })
            }), "\xBB"]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (footer_module_default()).payment,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: (footer_module_default()).paymentList,
          children: config/* paymentImages.map */.v6.map(function (image, ind) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: (0,clsx_m/* default */.Z)((footer_module_default()).paymentListItem, ind === 9 && (footer_module_default()).bePaid),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: getWidth(ind),
                height: getHeight(ind),
                src: image.src,
                alt: image.alt,
                className: (footer_module_default()).paymentImg,
                layout: "intrinsic"
              })
            }, image.alt);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).divider, (footer_module_default()).second)
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (footer_module_default()).legal,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (footer_module_default()).copy,
          children: ["\xA9 ", new Date().getFullYear(), " FH.BY", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/catalog",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "\u041A\u0430\u0440\u0442\u0430 \u0441\u0430\u0439\u0442\u0430"
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (footer_module_default()).copyText,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u041E\u0431\u0449\u0435\u0441\u0442\u0432\u043E \u0441 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u044E \xAB\u0411\u0435\u043B\u0412\u0438\u0440\u0438\u043D\u0435\u044F\xBB \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E 06.04.2006 \u041C\u0438\u043D\u0441\u043A\u0438\u043C \u0433\u043E\u0440\u0438\u0441\u043F\u043E\u043B\u043A\u043E\u043C\u043E\u043C. \u0423\u041D\u041F 190706320. \u042E\u0440.\u0430\u0434\u0440\u0435\u0441: \u0433. \u041C\u0438\u043D\u0441\u043A, \u0443\u043B. \u041D\u0435\u043C\u0438\u0433\u0430, 5, \u043F\u043E\u043C. 39. \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u043C\u0430\u0433\u0430\u0437\u0438\u043D fh.by \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0422\u043E\u0440\u0433\u043E\u0432\u043E\u043C \u0440\u0435\u0435\u0441\u0442\u0440\u0435 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C 14.11.2019 \u0433\u043E\u0434\u0430. \u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 465593. \u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u041F\u043D-\u0412\u0441, \u043A\u0440\u0443\u0433\u043B\u043E\u0441\u0443\u0442\u043E\u0447\u043D\u043E. \u0422\u0435\u043B.: +375 (29) 633-2-633, +375 (17) 328-60-79. E-mail: fh@fh.by"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B \u043B\u0438\u0446\u0430, \u0443\u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0441\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439 \u043E \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0438 \u043F\u0440\u0430\u0432, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u043E \u0437\u0430\u0449\u0438\u0442\u0435 \u043F\u0440\u0430\u0432 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0435\u0439: \u0442\u0435\u043B.: +375 (17) 243-20-79, e-mail: o.boris@fh.by"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B \u043E\u0442\u0434\u0435\u043B\u0430 \u0442\u043E\u0440\u0433\u043E\u0432\u043B\u0438 \u0438 \u0443\u0441\u043B\u0443\u0433 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0440\u0430\u0439\u043E\u043D\u0430 \u0433. \u041C\u0438\u043D\u0441\u043A\u0430 \u0434\u043B\u044F \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0439 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439: \u0442\u0435\u043B.: +375 (17) 390-42-95, \u0442\u0435\u043B./\u0444\u0430\u043A\u0441: +375 (17) 234-42-65, +375 (17) 272-53-46."
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var footer_Footer = (Footer);
;// CONCATENATED MODULE: ./containers/footer/index.js

/* harmony default export */ var footer = (footer_Footer);

/***/ }),

/***/ 89520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/userSlice.js
var userSlice = __webpack_require__(46789);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./contexts/NavContext.js
var NavContext = __webpack_require__(73682);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./containers/index.js + 33 modules
var containers = __webpack_require__(21341);
// EXTERNAL MODULE: ./hooks/use-window-size.js
var use_window_size = __webpack_require__(55876);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/searchSlice.js
var searchSlice = __webpack_require__(98029);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/currencySlice.js
var currencySlice = __webpack_require__(74542);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./hooks/index.js + 2 modules
var hooks = __webpack_require__(84431);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./containers/header/search/search.module.scss
var search_module = __webpack_require__(72356);
var search_module_default = /*#__PURE__*/__webpack_require__.n(search_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/header/search/Search.js



var _excluded = ["visible", "hideSearch"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var Html = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6066)]).then(__webpack_require__.bind(__webpack_require__, 26066));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26066)];
    }
  }
});
var Dialog = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2128), __webpack_require__.e(6674)]).then(__webpack_require__.bind(__webpack_require__, 96674));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(96674)];
    }
  }
});

var Search = function Search(_ref) {
  var visible = _ref.visible,
      hideSearch = _ref.hideSearch,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var router = (0,next_router.useRouter)();

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      isCollectionMobile = _useWindowSize.isCollectionMobile;

  var dispatch = (0,es/* useDispatch */.I0)();
  var hasSmartBanner = (0,es/* useSelector */.v9)(store/* hasSmartBannerSelector */.Jd);

  var _useSelector = (0,es/* useSelector */.v9)(searchSlice/* getSearchData */.Im),
      results = _useSelector.results;

  var _results$categories = results.categories,
      categories = _results$categories === void 0 ? [] : _results$categories,
      _results$products = results.products,
      products = _results$products === void 0 ? [] : _results$products,
      _results$redirectUrl = results.redirectUrl,
      redirectUrl = _results$redirectUrl === void 0 ? '' : _results$redirectUrl,
      query = results.query,
      brands = results.brands,
      searchOften = results.searchOften,
      correction = results.correction;

  var _useState = (0,react.useState)(''),
      searchQuery = _useState[0],
      setSearchQuery = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var input = (0,react.useRef)();
  var requestTimeoutId = (0,react.useRef)();
  var isSmallWindow = (0,react.useMemo)(function () {
    return redirectUrl.length > 0 && redirectUrl !== '/search/no-result';
  }, [redirectUrl]);
  var withoutResults = (0,react.useMemo)(function () {
    return !categories && !products;
  }, [categories, products]);
  var countResults = isCollectionMobile ? 3 : 4;
  (0,react.useEffect)(function () {
    setTimeout(function () {
      var isSearchPage = router.pathname.includes('search');

      if (visible && !isSearchPage) {
        dispatch((0,searchSlice/* newFetchSearchResults */.CB)({
          query: '',
          onSuccess: function onSuccess() {
            setLoading(false);
          }
        }));
        setSearchQuery('');
      }
    }, 0);
  }, [visible]);
  (0,react.useEffect)(function () {
    if (!loading && (results === null || results === void 0 ? void 0 : results.query) !== '' && !isSmallWindow) {
      var _window, _window$Digi;

      (_window = window) === null || _window === void 0 ? void 0 : (_window$Digi = _window.Digi) === null || _window$Digi === void 0 ? void 0 : _window$Digi.api.sendSearchEvent({
        searchTerm: results.query,
        correction: results.correction,
        pageProducts: results.products ? results.products.map(function (_ref2) {
          var model = _ref2.model;
          return model.slug;
        }) : []
      });
    }
  }, [loading, results]);
  (0,react.useEffect)(function () {
    var handleRouteChange = function handleRouteChange(url) {
      if (visible) {
        hideSearch();
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return function () {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [visible, hideSearch]);

  var search = function search(value) {
    clearTimeout(requestTimeoutId.current);
    var query = value; // if (query.trim().length === 0) {
    //     dispatch(resetSearch());
    //     return;
    // }

    requestTimeoutId.current = setTimeout(function () {
      dispatch((0,searchSlice/* newFetchSearchResults */.CB)({
        query: query,
        onSuccess: function onSuccess() {
          setLoading(false);
        }
      }));
      Ecommerce/* default.setSearch */.ZP.setSearch(query);
    }, 300);
  };

  var onResetSearch = function onResetSearch(e) {
    setSearchQuery('');
    dispatch((0,searchSlice/* newFetchSearchResults */.CB)({
      query: ''
    }));
  };

  var onChange = function onChange(e) {
    var _e$target$value, _e$target;

    if (e) {
      e.preventDefault();
    }

    var value = (_e$target$value = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) !== null && _e$target$value !== void 0 ? _e$target$value : '';
    setSearchQuery(value);
    search(value);
  };

  var isNotOnlySpaces = (0,react.useMemo)(function () {
    if (searchQuery.length > 0) {
      return searchQuery.split('').some(function (item) {
        return item !== ' ';
      });
    }

    return true;
  }, [searchQuery]);
  var goToResults = (0,react.useCallback)(function () {
    if (isNotOnlySpaces) {
      hideSearch(); // setSearchString(searchQuery);
      // if (redirectUrl.length === 0) {

      if (searchQuery.length > 0) {
        if (isSmallWindow) {
          var _window2, _window2$Digi;

          (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$Digi = _window2.Digi) === null || _window2$Digi === void 0 ? void 0 : _window2$Digi.api.sendAutocompleteRedirectEvent({
            searchTerm: searchQuery,
            correction: correction,
            item: searchQuery
          });
        }

        router.push("/search?q=".concat(searchQuery));
      }
    } // } else {
    //     router.push(redirectUrl);
    // }

  }, [searchQuery, router, hideSearch, isSmallWindow, correction]);
  var onKeyDown = (0,react.useCallback)(function (event) {
    var _ref3 = event || {},
        keyCode = _ref3.keyCode,
        target = _ref3.target;

    if (keyCode === 13 && (target === null || target === void 0 ? void 0 : target.name) === 'search-string') {
      event === null || event === void 0 ? void 0 : event.preventDefault();
      goToResults();
    }
  }, [goToResults, query]);
  (0,react.useEffect)(function () {
    document.addEventListener('keydown', onKeyDown, false);
    return function () {
      document.removeEventListener('keydown', onKeyDown, false);
    };
  }, [onKeyDown]);
  (0,react.useEffect)(function () {
    var isSearchPage = router.pathname.includes('search');
    var searchString = localStorage.getItem('searchString');
    setLoading(true);

    if (isSearchPage && visible) {
      setTimeout(function () {
        setSearchQuery(searchString);
      }, 0);
      search(searchString);
    }
  }, [router.pathname, visible]);
  var goods = (0,react.useMemo)(function () {
    var handleProductClick = function handleProductClick(name, id) {
      var _window3, _window3$Digi;

      (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$Digi = _window3.Digi) === null || _window3$Digi === void 0 ? void 0 : _window3$Digi.api.sendAutocompleteProductClickEvent({
        searchTerm: searchQuery,
        correction: correction,
        item: name,
        productId: "".concat(id)
      });
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (search_module_default()).goods,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (search_module_default()).blockTitle,
        children: "\u0422\u043E\u0432\u0430\u0440\u044B"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: (search_module_default()).results,
        children: products === null || products === void 0 ? void 0 : products.map(function (result, index) {
          var name = result.name,
              model = result.model,
              meta = result.meta,
              brand = result.brand,
              price = result.price,
              old_price = result.old_price,
              media = result.media,
              price_diff_percent = result.price_diff_percent,
              external_id = result.external_id;

          var _getLinkProps = (0,getLinkProps/* default */.Z)({
            type: 'product',
            value: model.slug
          }),
              _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
              href = _getLinkProps2[0],
              as = _getLinkProps2[1];

          return index < countResults ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            onClick: function onClick() {
              handleProductClick(name, model.slug);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: href,
              as: as,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* Control */.oT, {
                className: (0,clsx_m/* default */.Z)((search_module_default()).result),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (search_module_default()).image,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Picture */.t, _objectSpread({}, media === null || media === void 0 ? void 0 : media[0]))
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (search_module_default()).brand,
                    children: brand
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Text */.xv, {
                    className: (0,clsx_m/* default */.Z)((search_module_default()).resultTitle, !!price_diff_percent && (search_module_default()).noMargin),
                    children: name
                  }), price && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)((search_module_default()).price, (0,defineProperty/* default */.Z)({}, (search_module_default()).withDiscount, price < old_price)),
                    children: [!!price_diff_percent && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ProductFeature */["if"], {
                      title: "".concat(price_diff_percent, "%"),
                      styledType: "sale"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Price */.tA, {
                      price: price,
                      oldPrice: old_price,
                      isSearch: true
                    })]
                  })]
                })]
              })
            })
          }, "".concat(name, "-").concat(model.slug)) : null;
        })
      }), searchQuery.length > 0 && products && products.length && isNotOnlySpaces && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        classNames: {
          general: (search_module_default()).allResults
        },
        type: "primary",
        onClick: goToResults,
        disabled: searchQuery.length < 1,
        children: "\u0412\u0441\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B"
      })]
    });
  }, [products, goToResults, searchQuery, isNotOnlySpaces]);
  var catalog = (0,react.useMemo)(function () {
    var handleCategoryClick = function handleCategoryClick(name) {
      var _window4, _window4$Digi;

      (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$Digi = _window4.Digi) === null || _window4$Digi === void 0 ? void 0 : _window4$Digi.api.sendAutocompleteCategoryClickEvent({
        searchTerm: searchQuery,
        correction: correction,
        item: name
      });
    };

    var handleBrandClick = function handleBrandClick(name) {
      var _window5, _window5$Digi;

      (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$Digi = _window5.Digi) === null || _window5$Digi === void 0 ? void 0 : _window5$Digi.api.sendAutocompleteBrandClickEvent({
        searchTerm: searchQuery,
        correction: correction,
        item: name
      });
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (search_module_default()).catalog,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).categories,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (search_module_default()).blockTitle,
          children: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: (search_module_default()).categoriesList,
          children: categories === null || categories === void 0 ? void 0 : categories.map(function (_ref4, index) {
            var name = _ref4.name,
                slug = _ref4.slug;
            return index < countResults ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              onClick: function onClick() {
                handleCategoryClick(name);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                href: slug,
                className: (search_module_default()).catalogLink,
                children: [name, /*#__PURE__*/(0,jsx_runtime.jsx)("button", {})]
              })
            }, slug) : null;
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).brands,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (search_module_default()).blockTitle,
          children: "\u0411\u0440\u0435\u043D\u0434\u044B"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          children: brands === null || brands === void 0 ? void 0 : brands.map(function (_ref5, index) {
            var name = _ref5.name,
                slug = _ref5.slug;
            return index < countResults ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              onClick: function onClick() {
                handleBrandClick(name);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                href: slug,
                className: (search_module_default()).catalogLink,
                children: [name, /*#__PURE__*/(0,jsx_runtime.jsx)("button", {})]
              })
            }, slug) : null;
          })
        })]
      })]
    });
  }, [categories, brands]);
  var oftenSearches = (0,react.useMemo)(function () {
    var handleOftenSearchClick = function handleOftenSearchClick(name) {
      var _window6, _window6$Digi;

      (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$Digi = _window6.Digi) === null || _window6$Digi === void 0 ? void 0 : _window6$Digi.api.sendAutocompleteQueryClickEvent({
        searchTerm: searchQuery,
        correction: correction,
        item: name
      });
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (search_module_default()).oftenSearch,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (search_module_default()).blockTitle,
        children: "\u0427\u0430\u0441\u0442\u043E \u0438\u0449\u0443\u0442"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        children: searchOften === null || searchOften === void 0 ? void 0 : searchOften.map(function (_ref6, index) {
          var name = _ref6.name;
          var newName = name;
          var indexStart = name.indexOf(searchQuery);

          if (searchQuery.length > 0 && indexStart !== -1) {
            newName = name.substr(0, indexStart) + '<b>' + name.substr(indexStart, searchQuery.length) + '</b>' + name.substr(indexStart + searchQuery.length);
          }

          return index < countResults ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            onClick: function onClick() {
              handleOftenSearchClick(name);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "/search?q=".concat(name),
              className: (search_module_default()).catalogLink,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Html, {
                html: newName
              })
            })
          }, name) : null;
        })
      })]
    });
  }, [searchOften, searchQuery]);
  var main = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Block */.gO, {
      className: (search_module_default()).mainBlock,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (search_module_default()).inputBlock,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Input */.II, {
            onChange: onChange,
            value: searchQuery,
            label: "\u041F\u043E\u0438\u0441\u043A",
            name: "search-string",
            ref: input,
            isClear: true,
            clearClick: onResetSearch,
            classNames: {
              general: (search_module_default()).inputGeneral,
              field: (search_module_default()).inputField
            },
            isSearch: true
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
            classNames: {
              general: (search_module_default()).cancelSearch
            },
            type: "link",
            onClick: hideSearch,
            children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
          })]
        }), withoutResults ? /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: (search_module_default()).warningInfo,
          children: "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043F\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((search_module_default()).resultBlock, (search_module_default()).resultBlockDesktop),
            children: [oftenSearches, goods, catalog]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((search_module_default()).resultBlock, (search_module_default()).resultBlockMobile),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (search_module_default()).resultCatInfoBlock,
              children: [oftenSearches, catalog]
            }), goods]
          })]
        })]
      })
    });
  }, [searchQuery, goods, catalog, oftenSearches, withoutResults]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((search_module_default()).container, props.className),
    tabIndex: "-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog, {
      showDialog: visible,
      onDismiss: hideSearch,
      rootClassName: (0,clsx_m/* default */.Z)((search_module_default()).dialogRoot, hasSmartBanner && (search_module_default()).smartBanner),
      dialogClassName: (0,clsx_m/* default */.Z)((search_module_default()).dialog, isSmallWindow && (search_module_default()).smallDialog),
      mainClassName: (search_module_default()).dialogMain,
      main: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {}) : main
    })
  });
};

/* harmony default export */ var search_Search = (Search);
;// CONCATENATED MODULE: ./containers/header/search/index.js

/* harmony default export */ var search = (search_Search);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./containers/header/searchControl/SearchControl.module.scss
var SearchControl_module = __webpack_require__(87611);
var SearchControl_module_default = /*#__PURE__*/__webpack_require__.n(SearchControl_module);
;// CONCATENATED MODULE: ./containers/header/searchControl/SearchControl.js










var SearchControl = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var label = _ref.label,
      type = _ref.type,
      isShowSearch = _ref.isShowSearch,
      onToggleSearch = _ref.onToggleSearch,
      hideSearch = _ref.hideSearch,
      onUnVisibleSearch = _ref.onUnVisibleSearch,
      showSearch = _ref.showSearch,
      searchVisible = _ref.searchVisible;
  var router = (0,next_router.useRouter)();
  var isSearchPage = router.asPath.includes('search?');

  var handleShowSearch = function handleShowSearch() {
    showSearch();
  };

  if (type === 'mobile') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(search, {
        visible: searchVisible,
        onReset: onUnVisibleSearch,
        onResultClick: onUnVisibleSearch,
        className: (SearchControl_module_default()).searchFieldMobile,
        hideSearch: onUnVisibleSearch
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (0,clsx_m/* default */.Z)((SearchControl_module_default()).search, (SearchControl_module_default())[type]),
        "aria-label": "search",
        onClick: onToggleSearch,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (SearchControl_module_default()).showSearch,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
            name: "search",
            fill: isSearchPage ? '#0D9A58' : ''
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (0,clsx_m/* default */.Z)((SearchControl_module_default()).text, isSearchPage && (SearchControl_module_default()).greenText),
            children: label
          })]
        })
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((SearchControl_module_default()).search, (SearchControl_module_default())[type], (0,defineProperty/* default */.Z)({}, (SearchControl_module_default()).show, isShowSearch)),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(search, {
      visible: isShowSearch,
      hideSearch: hideSearch
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      type: "button",
      "aria-label": "search",
      id: "search-button",
      className: (0,clsx_m/* default */.Z)((SearchControl_module_default()).showSearch, (0,defineProperty/* default */.Z)({}, (SearchControl_module_default()).hidden, isShowSearch)),
      onClick: handleShowSearch,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "search",
        fill: isSearchPage ? '#0D9A58' : ''
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)(isSearchPage && (SearchControl_module_default()).greenText),
        children: label
      })]
    })]
  });
});
/* harmony default export */ var searchControl_SearchControl = (SearchControl);
;// CONCATENATED MODULE: ./containers/header/searchControl/index.js

/* harmony default export */ var searchControl = (searchControl_SearchControl);
// EXTERNAL MODULE: ./containers/header/userNavItem/UserNavItem.module.scss
var UserNavItem_module = __webpack_require__(57170);
var UserNavItem_module_default = /*#__PURE__*/__webpack_require__.n(UserNavItem_module);
;// CONCATENATED MODULE: ./containers/header/userNavItem/UserNavItem.js




var UserNavItem = function UserNavItem(_ref) {
  var link = _ref.link;
  var href = link.href,
      as = link.as,
      title = link.title,
      _link$isLogout = link.isLogout,
      isLogout = _link$isLogout === void 0 ? false : _link$isLogout;
  return isLogout ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
    tag: "button",
    type: "button",
    className: (UserNavItem_module_default())["control-link"],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LogoutModal */.P9, {})
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
    href: href,
    as: as,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
      className: (UserNavItem_module_default())["control-link"],
      children: title
    })
  });
};

/* harmony default export */ var userNavItem_UserNavItem = (UserNavItem);
;// CONCATENATED MODULE: ./containers/header/userNavItem/index.js

/* harmony default export */ var userNavItem = (userNavItem_UserNavItem);
// EXTERNAL MODULE: ./containers/header/userControl/UserControl.module.scss
var UserControl_module = __webpack_require__(9272);
var UserControl_module_default = /*#__PURE__*/__webpack_require__.n(UserControl_module);
;// CONCATENATED MODULE: ./containers/header/userControl/UserControl.js











var UserControl = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var label = _ref.label,
      iconName = _ref.iconName,
      href = _ref.href,
      as = _ref.as,
      itemsQuantity = _ref.itemsQuantity,
      fullRed = _ref.fullRed,
      loginType = _ref.loginType,
      onClickMobileProfile = _ref.onClickMobileProfile,
      phoneType = _ref.phoneType;

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isDesktop = _useWindowSize.isDesktop;

  var router = (0,next_router.useRouter)();
  var disabled = (0,react.useMemo)(function () {
    return router.pathname === href;
  }, [href, router.pathname]);

  var handleClick = function handleClick() {
    if (!disabled) {
      router.push(href);
    }
  };

  if (phoneType) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (0,clsx_m/* default */.Z)((UserControl_module_default()).control, (UserControl_module_default()).controlPhone),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        "data-nav": "Phone",
        type: "button",
        className: (0,clsx_m/* default */.Z)((UserControl_module_default()).controlTrigger, (UserControl_module_default()).arrow),
        children: label
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (UserControl_module_default()).controlDropdown,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (UserControl_module_default()).controlInner,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* ContactsOverview */.aP, {})
        })
      })]
    });
  }

  if (loginType) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* Control */.oT, {
      tag: "div",
      role: "button",
      tabIndex: 0,
      "aria-label": label,
      onClick: !isDesktop ? onClickMobileProfile : null,
      className: (0,clsx_m/* default */.Z)((UserControl_module_default()).control, (UserControl_module_default()).controlUser),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (UserControl_module_default()).controlTrigger,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
          name: iconName,
          fill: ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (UserControl_module_default()).text,
          children: label
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((UserControl_module_default()).controlDropdown, (UserControl_module_default()).login),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (UserControl_module_default()).controlInner,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* UserNav */.Tb, {
            render: userNavItem
          })
        })
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (UserControl_module_default()).link,
    onClick: handleClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
      "aria-label": label,
      className: (0,clsx_m/* default */.Z)((UserControl_module_default()).control, (UserControl_module_default()).controlUser, disabled && (UserControl_module_default()).disabled),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        "data-nav": label,
        className: (UserControl_module_default()).controlTrigger,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
          name: iconName,
          fullRed: fullRed,
          fill: ""
        }), itemsQuantity > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-label": iconName,
          className: (UserControl_module_default()).quantity,
          children: itemsQuantity
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          "data-label": label,
          className: (UserControl_module_default()).text,
          children: label
        })]
      })
    })
  });
});
/* harmony default export */ var userControl_UserControl = (UserControl);
;// CONCATENATED MODULE: ./containers/header/userControl/index.js

/* harmony default export */ var userControl = (userControl_UserControl);
// EXTERNAL MODULE: ./containers/header/header.module.scss
var header_module = __webpack_require__(45760);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ./containers/header/Header.js



















var Header = function Header(_ref) {
  var hasServerBanner = _ref.hasServerBanner;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'wishlist'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
      wishlistHref = _getLinkProps2[0],
      wishlistAs = _getLinkProps2[1];

  var _getLinkProps3 = (0,getLinkProps/* default */.Z)({
    type: 'login'
  }),
      _getLinkProps4 = (0,slicedToArray/* default */.Z)(_getLinkProps3, 2),
      loginHref = _getLinkProps4[0],
      loginAs = _getLinkProps4[1];

  var _useState = (0,react.useState)(false),
      searchVisible = _useState[0],
      setSearchVisible = _useState[1];

  var _getLinkProps5 = (0,getLinkProps/* default */.Z)({
    type: 'cart'
  }),
      _getLinkProps6 = (0,slicedToArray/* default */.Z)(_getLinkProps5, 2),
      cartHref = _getLinkProps6[0],
      cartAs = _getLinkProps6[1];

  var loggedIn = (0,es/* useSelector */.v9)(store/* isLoggedInSelector */.dd);

  var _useWindowSize = (0,use_window_size/* default */.Z)(),
      isMobile = _useWindowSize.isMobile;

  var wishlistItemsQuantity = (0,es/* useSelector */.v9)(store/* wishlistCountSelector */.T6);
  var cartItemsQuantity = (0,es/* useSelector */.v9)(store/* cartCountSelector */.Ri);

  var _useNav = (0,NavContext/* useNav */.Y)(),
      toggleMobileUserNav = _useNav.toggleMobileUserNav,
      visibility = _useNav.visibility,
      toggleMobileNav = _useNav.toggleMobileNav;

  var _useState2 = (0,react.useState)(false),
      isShowSearch = _useState2[0],
      setIsShowSearch = _useState2[1];

  var _useState3 = (0,react.useState)(hasServerBanner),
      isVisibleBanner = _useState3[0],
      setIsVisibleBanner = _useState3[1];

  var showSearch = (0,react.useCallback)(function () {
    setIsShowSearch(true);
  }, []);
  var hideSearch = (0,react.useCallback)(function () {
    setIsShowSearch(false);
  }, []);
  var onClickMobileProfile = (0,react.useCallback)(function (e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    toggleMobileUserNav();
  }, [toggleMobileUserNav]);
  var onClickBurger = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    toggleMobileNav();
  }, [toggleMobileNav]);
  var onToggleSearch = (0,react.useCallback)(function () {
    setSearchVisible(function (prev) {
      return !prev;
    });
  }, []);
  var onUnVisibleSearch = (0,react.useCallback)(function () {
    setSearchVisible(false);
  }, []); // useEffect(() => {
  // 	if (typeof window !== 'undefined') {
  // 		console.log('!!!! ---- ', !!sessionStorage.getItem('smart-banner'))
  // 		debugger
  // 		setIsVisibleBanner(!!sessionStorage.getItem('smart-banner'));
  // 	}
  // }, []);

  var hasBanner = (0,react.useMemo)(function () {
    return isMobile && isVisibleBanner;
  }, [isMobile, isVisibleBanner]);
  var loadBanner = (0,react.useMemo)(function () {
    if (true) {
      return isMobile;
    }

    return hasServerBanner;
  }, [isMobile, hasServerBanner]);
  (0,react.useEffect)(function () {
    dispatch((0,userSlice/* changeBannerState */.dH)(hasBanner));
  }, [hasBanner, dispatch]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
    id: "header-id",
    className: (0,clsx_m/* default */.Z)((header_module_default()).header, (0,defineProperty/* default */.Z)({}, (header_module_default()).banner, hasBanner)),
    children: [loadBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SmartBanner */.ZI, {
      isVisibleBanner: isVisibleBanner,
      setIsVisibleBanner: setIsVisibleBanner
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (header_module_default()).bar,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (header_module_default()).left,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (header_module_default())["mobile-nav-toggle"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Burger */.OW, {
              open: visibility.mobileNav,
              onClick: onClickBurger
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (header_module_default())["nav-wrapper"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Navigate */.Fg, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(userControl, {
            label: "+375 (29) 633-2-633",
            phoneType: true
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (header_module_default()).logo,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
            href: "/",
            as: "/",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (header_module_default()).logoImg,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: "/images/fhby.webp",
                  height: 24,
                  width: 77,
                  alt: "FH.BY - \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u043C\u0430\u0433\u0430\u0437\u0438\u043D \u043E\u0434\u0435\u0436\u0434\u044B, \u043E\u0431\u0443\u0432\u0438 \u0438 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u043E\u0432 \u043C\u0438\u0440\u043E\u0432\u044B\u0445 \u0431\u0440\u0435\u043D\u0434\u043E\u0432"
                })
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (header_module_default()).controls,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(searchControl, {
            label: "\u041F\u043E\u0438\u0441\u043A",
            type: "desktop",
            hideSearch: hideSearch,
            showSearch: showSearch,
            isShowSearch: isShowSearch,
            onUnVisibleSearch: onUnVisibleSearch
          }), loggedIn ? /*#__PURE__*/(0,jsx_runtime.jsx)(userControl, {
            label: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
            iconName: "user",
            loginType: true,
            onClickMobileProfile: onClickMobileProfile
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(userControl, {
            label: "\u0412\u043E\u0439\u0442\u0438",
            iconName: "login",
            href: loginHref,
            as: loginAs
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(userControl, {
            label: "\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435",
            iconName: "heart",
            href: wishlistHref,
            as: wishlistAs,
            itemsQuantity: wishlistItemsQuantity
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(userControl, {
            label: "\u041A\u043E\u0440\u0437\u0438\u043D\u0430",
            iconName: "cart",
            href: cartHref,
            as: cartAs,
            itemsQuantity: cartItemsQuantity
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(searchControl, {
            label: "\u041F\u043E\u0438\u0441\u043A",
            type: "mobile",
            searchVisible: searchVisible,
            hideSearch: hideSearch,
            onUnVisibleSearch: onUnVisibleSearch,
            onToggleSearch: onToggleSearch
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var header_Header = (Header);
;// CONCATENATED MODULE: ./containers/header/index.js

/* harmony default export */ var header = (header_Header);

/***/ }),

/***/ 21341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gO": function() { return /* reexport */ block_Block; },
  "bu": function() { return /* reexport */ breadCrumbs_BreadCrumbs; },
  "vz": function() { return /* reexport */ categoryTreeMobile["default"]; },
  "aP": function() { return /* reexport */ contactsOverview; },
  "W2": function() { return /* reexport */ container_Container; },
  "$_": function() { return /* reexport */ footer/* default */.Z; },
  "Fb": function() { return /* reexport */ Head; },
  "h4": function() { return /* reexport */ header/* default */.Z; },
  "dJ": function() { return /* reexport */ likeButton_LikeButton; },
  "U0": function() { return /* reexport */ loginForm; },
  "U4": function() { return /* reexport */ metaData_MetaData; },
  "p7": function() { return /* reexport */ navPopular/* default */.Z; },
  "Fg": function() { return /* reexport */ containers_navigate; },
  "Sq": function() { return /* reexport */ news; },
  "T7": function() { return /* reexport */ specialOffers; }
});

// UNUSED EXPORTS: ErrorBoundary

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./containers/likeButton/LikeButton.module.scss
var LikeButton_module = __webpack_require__(5215);
var LikeButton_module_default = /*#__PURE__*/__webpack_require__.n(LikeButton_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/likeButton/LikeButton.js




var ICONS = {
  UNACTIVE: '/images/svg/unlike.svg',
  ACTIVE: '/images/svg/like.svg',
  HOVER: '/images/svg/like-hover.svg'
};

var LikeButton = function LikeButton(_ref) {
  var onClick = _ref.onClick,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? true : _ref$large,
      border = _ref.border,
      loading = _ref.loading,
      _ref$isCatalog = _ref.isCatalog,
      isCatalog = _ref$isCatalog === void 0 ? false : _ref$isCatalog;
  var UNACTIVE = ICONS.UNACTIVE,
      ACTIVE = ICONS.ACTIVE,
      HOVER = ICONS.HOVER;

  var _useState = (0,react.useState)(ACTIVE),
      activeIcon = _useState[0],
      setActiveIcon = _useState[1];

  var handleMouseEnter = (0,react.useCallback)(function () {
    setActiveIcon(HOVER);
  }, [HOVER]);
  var handleMouseLeave = (0,react.useCallback)(function () {
    setActiveIcon(ACTIVE);
  }, [ACTIVE]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    className: (0,clsx_m/* default */.Z)((LikeButton_module_default()).button, large && (LikeButton_module_default()).large, border && (LikeButton_module_default()).border, isCatalog && (LikeButton_module_default()).catalogLike),
    type: "button",
    disabled: loading,
    onClick: onClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (0,clsx_m/* default */.Z)((LikeButton_module_default()).img, large && (LikeButton_module_default()).largeImg),
      src: active ? activeIcon : UNACTIVE,
      alt: "like"
    })
  });
};

/* harmony default export */ var likeButton_LikeButton = (LikeButton);
;// CONCATENATED MODULE: ./containers/likeButton/index.js

// EXTERNAL MODULE: ./containers/categoryTreeMobile/index.js + 1 modules
var categoryTreeMobile = __webpack_require__(84799);
// EXTERNAL MODULE: ./containers/footer/index.js + 5 modules
var footer = __webpack_require__(24449);
// EXTERNAL MODULE: ./containers/header/index.js + 9 modules
var header = __webpack_require__(89520);
// EXTERNAL MODULE: ./containers/container/Container.module.scss
var Container_module = __webpack_require__(77361);
var Container_module_default = /*#__PURE__*/__webpack_require__.n(Container_module);
;// CONCATENATED MODULE: ./containers/container/Container.js




var Container = function Container(_ref) {
  var children = _ref.children,
      className = _ref.className,
      center = _ref.center;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((Container_module_default()).container, center && (Container_module_default()).center, className),
    children: children
  });
};

/* harmony default export */ var container_Container = (Container);
;// CONCATENATED MODULE: ./containers/container/index.js

// EXTERNAL MODULE: ./containers/block/Block.module.scss
var Block_module = __webpack_require__(20867);
var Block_module_default = /*#__PURE__*/__webpack_require__.n(Block_module);
;// CONCATENATED MODULE: ./containers/block/Block.js




var Block = function Block(_ref) {
  var children = _ref.children,
      noMargin = _ref.noMargin,
      className = _ref.className,
      shopsOnMap = _ref.shopsOnMap;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((Block_module_default()).block, noMargin && (Block_module_default()).noMargin, shopsOnMap && (Block_module_default())["shops-on-map"], className),
    children: children
  });
};

/* harmony default export */ var block_Block = (Block);
;// CONCATENATED MODULE: ./containers/block/index.js

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var lib_getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./containers/breadCrumbs/BreadCrumbs.module.scss
var BreadCrumbs_module = __webpack_require__(32896);
var BreadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(BreadCrumbs_module);
;// CONCATENATED MODULE: ./containers/breadCrumbs/BreadCrumbs.js



/* eslint-disable jsx-a11y/anchor-is-valid */






var BreadCrumbs = function BreadCrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'catalog' : _ref$type;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (BreadCrumbs_module_default()).list,
    children: [{
      slug: '/',
      as: '/',
      name: 'FH.BY'
    }].concat((0,toConsumableArray/* default */.Z)(breadcrumbs)).map(function (_ref2, ind) {
      var name = _ref2.name,
          slug = _ref2.slug;

      var _getLinkProps = (0,lib_getLinkProps/* default */.Z)({
        type: ind === 0 ? 'home' : type,
        value: slug
      }),
          _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
          href = _getLinkProps2[0],
          as = _getLinkProps2[1];

      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (BreadCrumbs_module_default()).item,
        children: ind === breadcrumbs.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (0,clsx_m/* default */.Z)((BreadCrumbs_module_default()).link, (BreadCrumbs_module_default()).last),
          children: name
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: href,
          as: as,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (BreadCrumbs_module_default()).link,
            children: name
          })
        })
      }, "".concat(slug).concat(ind));
    })
  });
};

/* harmony default export */ var breadCrumbs_BreadCrumbs = (BreadCrumbs);
;// CONCATENATED MODULE: ./containers/breadCrumbs/index.js

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./lib/config.js
var config = __webpack_require__(6668);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./containers/contactsOverview/ContactsOverview.module.scss
var ContactsOverview_module = __webpack_require__(47419);
var ContactsOverview_module_default = /*#__PURE__*/__webpack_require__.n(ContactsOverview_module);
;// CONCATENATED MODULE: ./containers/contactsOverview/ContactsOverview.js











var links = ['shops-list', 'news', 'special-offers'];
var ContactsOverview = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var onMenuLinkClick = _ref.onMenuLinkClick,
      isMobile = _ref.isMobile;

  // const onClickPhone = () => {
  //   ecommerce.onClickPhoneNumber();
  // };
  var onLinkClick = function onLinkClick() {
    if (onMenuLinkClick) {
      onMenuLinkClick();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((ContactsOverview_module_default()).wrapper, (0,defineProperty/* default */.Z)({}, (ContactsOverview_module_default()).mobile, isMobile)),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ContactsOverview_module_default()).header,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: (ContactsOverview_module_default()).phone,
        href: "tel:+375296332633",
        children: "+375 (29) 633-2-633"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Text */.xv, {
        className: (ContactsOverview_module_default())["work-time"],
        children: "\u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B: \u043F\u043D-\u0432\u0441, \u0441\xA009:00 \u0434\u043E 21:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SocialList */.XA, {
        list: config/* messengersList */.YP,
        top: true,
        type: "messengers"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ContactsOverview_module_default()).content,
      children: links.map(function (type) {
        var _getLinkProps = (0,lib_getLinkProps/* default */.Z)({
          type: type
        }),
            _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 3),
            href = _getLinkProps2[0],
            as = _getLinkProps2[1],
            title = _getLinkProps2[2];

        return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
          href: href,
          as: as,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
            className: (ContactsOverview_module_default()).link,
            onClick: onLinkClick,
            children: title
          })
        }, type);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ContactsOverview_module_default()).footer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SocialList */.XA, {
        list: config/* socialList */.Ok,
        top: true,
        type: "socials"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: (ContactsOverview_module_default())["app-links"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: (ContactsOverview_module_default())["app-links-item"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            href: "https://apps.apple.com/us/app/id1518240278",
            target: "_blank",
            rel: "noreferrer noopener" // onClick={() => ecommerce.onClickSocialLink(ecommerce.SOCIAL_BANNER_TYPE.APP_STORE)}
            ,
            onClick: function onClick() {},
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
              name: "ios"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              children: ["\u0421\u043A\u0430\u0447\u0430\u0442\u044C", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " \u0432 App Store"]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: (ContactsOverview_module_default())["app-links-item"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            href: "https://play.google.com/store/apps/details?id=com.websecret.fh",
            target: "_blank",
            rel: "noreferrer noopener" // onClick={() => ecommerce.onClickSocialLink(ecommerce.SOCIAL_BANNER_TYPE.GOOGLE_PLAY)}
            ,
            onClick: function onClick() {},
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
              name: "google-play"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              children: ["\u0421\u043A\u0430\u0447\u0430\u0442\u044C", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " \u0432 Google Play"]
            })]
          })
        })]
      })]
    })]
  });
});
/* harmony default export */ var contactsOverview_ContactsOverview = (ContactsOverview);
;// CONCATENATED MODULE: ./containers/contactsOverview/index.js

/* harmony default export */ var contactsOverview = (contactsOverview_ContactsOverview);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./contexts/NavContext.js
var NavContext = __webpack_require__(73682);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/categoriesSlice.js
var categoriesSlice = __webpack_require__(11012);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/lib/index.js
var lib = __webpack_require__(51655);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./containers/navigate/itemWithDropdown/ItemWithDropdown.module.scss
var ItemWithDropdown_module = __webpack_require__(48274);
var ItemWithDropdown_module_default = /*#__PURE__*/__webpack_require__.n(ItemWithDropdown_module);
;// CONCATENATED MODULE: ./containers/navigate/itemWithDropdown/ItemWithDropdown.js


var _excluded = ["category", "savedQuery", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var MAX_NAV_LEVEL = 3;

var ItemLink = function ItemLink(_ref) {
  var _ref$category = _ref.category,
      path = _ref$category.path,
      link = _ref$category.link,
      type = _ref$category.type,
      savedQuery = _ref.savedQuery,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var notCatalogLink = type !== 'menu' && type !== 'category' && type !== 'brand';
  var routeType = 'catalog';
  var linkHref = notCatalogLink ? link : (0,lib_getLinkProps/* default */.Z)({
    type: routeType,
    value: path
  })[0];
  var linkAs = notCatalogLink ? null : (0,lib_getLinkProps/* default */.Z)({
    type: routeType,
    value: path
  })[1];
  return notCatalogLink ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RoutedLink */.S4, _objectSpread(_objectSpread({
    to: linkHref,
    component: components/* Control */.oT
  }, props), {}, {
    children: children
  })) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
    href: {
      pathname: linkHref,
      query: savedQuery || {}
    },
    as: {
      pathname: linkAs,
      query: savedQuery || {}
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

var ItemWithDropdown = /*#__PURE__*/(0,react.memo)(function (props) {
  var _useState = (0,react.useState)({}),
      openedAll = _useState[0],
      setOpenedAll = _useState[1];

  var id = props.id,
      name = props.name,
      path = props.path,
      children = props.children,
      type = props.type,
      link = props.link,
      onClick = props.onClick,
      lastItemId = props.lastItemId,
      setLastItemId = props.setLastItemId,
      is_blanked = props.is_blanked,
      view_type = props.view_type,
      banner = props.banner,
      savedQuery = props.savedQuery,
      color = props.color;
  var visible = id === lastItemId.opened;
  var openTimeoutId = (0,react.useRef)(null);
  var closeTimeoutId = (0,react.useRef)(null);

  var onLinkEnter = function onLinkEnter() {
    if (closeTimeoutId.current) {
      // enter the same link again, clear close timeout
      clearTimeout(closeTimeoutId.current);
      openTimeoutId.current = null;
      closeTimeoutId.current = null;
    } else {
      openTimeoutId.current = setTimeout(function () {
        // open menu
        setLastItemId(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            opened: id
          });
        });
        openTimeoutId.current = null;
      }, 150);
    }
  };

  var onLinkLeave = function onLinkLeave() {
    if (openTimeoutId.current) {
      // leave before open
      clearTimeout(openTimeoutId.current);
      openTimeoutId.current = null;
      closeTimeoutId.current = null;
    } else {
      setLastItemId(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          leaved: id
        });
      });
      closeTimeoutId.current = setTimeout(function () {
        // close menu
        openTimeoutId.current = null;
        closeTimeoutId.current = null;
        setLastItemId(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            opened: id
          });
        });
      }, 150);
    }
  };

  var onClickItem = function onClickItem() {
    clearTimeout(openTimeoutId.current);
    clearTimeout(closeTimeoutId.current);
    openTimeoutId.current = null;
    closeTimeoutId.current = null;

    if (onClick) {
      onClick();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    className: (ItemWithDropdown_module_default()).item,
    onMouseLeave: onLinkLeave,
    onMouseEnter: onLinkEnter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemLink, _objectSpread(_objectSpread({
      category: {
        path: path,
        type: type,
        link: link
      },
      className: (0,clsx_m/* default */.Z)((ItemWithDropdown_module_default()).link, (ItemWithDropdown_module_default()).level1, (ItemWithDropdown_module_default())[view_type], (0,defineProperty/* default */.Z)({}, (ItemWithDropdown_module_default()).isOpened, id === lastItemId.opened || lastItemId.opened === null && id === lastItemId.leaved && visible)),
      onClick: onClickItem
    }, is_blanked && {
      target: '_blank',
      rel: 'noopener noreferrer'
    }), {}, {
      savedQuery: savedQuery,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        style: color ? {
          color: color
        } : {},
        children: name
      })
    })), function renderCategories(categories, level, catId, bannerData) {
      if (level > MAX_NAV_LEVEL) return;
      return children && children.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((ItemWithDropdown_module_default())["listWrap".concat(level)], (0,defineProperty/* default */.Z)({}, (ItemWithDropdown_module_default()).visible, visible), (0,defineProperty/* default */.Z)({}, (ItemWithDropdown_module_default()).leaved, id === lastItemId.leaved)),
        children: visible && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ItemWithDropdown_module_default())["listScroll".concat(level)],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: (ItemWithDropdown_module_default())["list".concat(level)],
            children: categories.map(function (category, idx) {
              var id = category.id,
                  name = category.name,
                  path = category.path,
                  children = category.children,
                  type = category.type,
                  link = category.link,
                  is_blanked = category.is_blanked,
                  view_type = category.view_type,
                  color = category.color;
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: (0,clsx_m/* default */.Z)((ItemWithDropdown_module_default()).item, (0,defineProperty/* default */.Z)({}, (ItemWithDropdown_module_default()).hidden, idx > 4 && level === 3 && !openedAll[catId])),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemLink, _objectSpread(_objectSpread({
                  category: {
                    path: path,
                    type: type,
                    link: link
                  },
                  className: (0,clsx_m/* default */.Z)((ItemWithDropdown_module_default()).link, (ItemWithDropdown_module_default())["level".concat(level)], (ItemWithDropdown_module_default())[view_type]),
                  onClick: onClickItem,
                  savedQuery: savedQuery
                }, is_blanked && {
                  target: '_blank',
                  rel: 'noopener noreferrer'
                }), {}, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    style: color && color !== '' ? {
                      color: color
                    } : {},
                    children: name
                  })
                })), children && children.length > 0 && renderCategories(children, level + 1, category.id), children.length > 5 && level === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (ItemWithDropdown_module_default()).btnContainer,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
                    type: "link",
                    action: "button",
                    classNames: {
                      general: (ItemWithDropdown_module_default()).sectionButton
                    },
                    onClick: function onClick() {
                      setOpenedAll(function (prev) {
                        return _objectSpread(_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, category.id, !prev[category.id]));
                      });
                    },
                    children: openedAll[id] ? 'Свернуть разделы' : 'Все разделы'
                  })
                })]
              }, id);
            })
          })
        })
      }) : null;
    }(children, 2, banner)]
  }, id);
});
/* harmony default export */ var itemWithDropdown_ItemWithDropdown = (ItemWithDropdown);
;// CONCATENATED MODULE: ./containers/navigate/itemWithDropdown/index.js

/* harmony default export */ var itemWithDropdown = (itemWithDropdown_ItemWithDropdown);
// EXTERNAL MODULE: ./containers/navigate/navList/NavList.module.scss
var NavList_module = __webpack_require__(40864);
var NavList_module_default = /*#__PURE__*/__webpack_require__.n(NavList_module);
;// CONCATENATED MODULE: ./containers/navigate/navList/NavList.js


function NavList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NavList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NavList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NavList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var NavList = function NavList(_ref) {
  var toggleVisibility = _ref.toggleVisibility,
      savedQuery = _ref.savedQuery,
      visible = _ref.visible;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)([]),
      tree = _useState[0],
      setTree = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)({
    opened: tree && tree.length > 0 ? tree[0].id : null,
    leaved: null
  }),
      lastItemId = _useState3[0],
      setLastItemId = _useState3[1];

  (0,react.useEffect)(function () {
    if (visible) {
      setLoading(true);
      dispatch((0,categoriesSlice/* getCategoriesTree */.fc)({
        onSuccess: function onSuccess(res) {
          setLoading(false);
          setTree(res.data);
        }
      }));
    }
  }, [visible, dispatch]);
  (0,react.useEffect)(function () {
    if (tree && tree.length > 0) {
      setLastItemId({
        opened: tree[0].id,
        leaved: null
      });
    }
  }, [tree]);

  if (loading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        marginTop: '31px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
        count: 10,
        height: 23,
        width: "90%",
        style: {
          marginBottom: '16px'
        }
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (NavList_module_default()).list,
    children: tree.map(function (category, ind) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(itemWithDropdown, NavList_objectSpread(NavList_objectSpread({}, category), {}, {
        onClick: toggleVisibility,
        lastItemId: lastItemId,
        initiallyVisible: ind === 0,
        setLastItemId: setLastItemId,
        savedQuery: savedQuery,
        is_active: true
      }), category.id);
    })
  });
};

/* harmony default export */ var navList_NavList = (NavList);
;// CONCATENATED MODULE: ./containers/navigate/navList/index.js

/* harmony default export */ var navList = (navList_NavList);
// EXTERNAL MODULE: ./containers/navigate/Navigate.module.scss
var Navigate_module = __webpack_require__(16194);
var Navigate_module_default = /*#__PURE__*/__webpack_require__.n(Navigate_module);
;// CONCATENATED MODULE: ./containers/navigate/Navigate.js












var Navigate = /*#__PURE__*/(0,react.memo)(function () {
  var _useNav = (0,NavContext/* useNav */.Y)(),
      visibility = _useNav.visibility,
      toggleMenu = _useNav.toggleMenu;

  var sort = (0,es/* useSelector */.v9)(store/* catalogSortSelector */.tD);
  var visible = visibility.menu;
  var onOpenMenu = (0,react.useCallback)(function () {
    if (!visible) {
      toggleMenu();
    }
  }, [visible, toggleMenu]);
  var onCloseMenu = (0,react.useCallback)(function () {
    if (visible) {
      toggleMenu();
    }
  }, [visible, toggleMenu]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
    className: (Navigate_module_default()).nav,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Navigate_module_default()).toggle,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Burger */.OW, {
        open: visible,
        onClick: onOpenMenu,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "\u041A\u0430\u0442\u0430\u043B\u043E\u0433"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((Navigate_module_default()).wrapper, (0,defineProperty/* default */.Z)({}, (Navigate_module_default()).visible, visible)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(container_Container, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ClickOutside */.Lp, {
          onClickOutside: onCloseMenu,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Navigate_module_default()).listWrapp,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Navigate_module_default()).listScroll,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(navList, {
                toggleVisibility: onCloseMenu,
                savedQuery: sort || {},
                visible: visible
              })
            })
          })
        })
      })
    })]
  });
});
/* harmony default export */ var navigate_Navigate = (Navigate);
;// CONCATENATED MODULE: ./containers/navigate/index.js

/* harmony default export */ var containers_navigate = (navigate_Navigate);
// EXTERNAL MODULE: ./containers/errorBoundary/index.js + 1 modules
var errorBoundary = __webpack_require__(17338);
// EXTERNAL MODULE: ./lib/getDate.js
var getDate = __webpack_require__(10468);
// EXTERNAL MODULE: ./containers/news/News.module.scss
var News_module = __webpack_require__(957);
var News_module_default = /*#__PURE__*/__webpack_require__.n(News_module);
;// CONCATENATED MODULE: ./containers/news/News.js



function News_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function News_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? News_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : News_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var News = function News(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (News_module_default()).news,
    children: items === null || items === void 0 ? void 0 : items.map(function (item, ind) {
      var id = item.id,
          title = item.title,
          image = item.image,
          slug = item.slug,
          published_at = item.published_at;

      var _getDate = (0,getDate/* default */.Z)(published_at),
          day = _getDate.day,
          month_rus = _getDate.month_rus,
          year = _getDate.year;

      var _getLinkProps = (0,lib_getLinkProps/* default */.Z)({
        type: 'news-item',
        value: slug
      }),
          _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
          href = _getLinkProps2[0],
          as = _getLinkProps2[1];

      var special = ind % 3 === 0;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (0,clsx_m/* default */.Z)((News_module_default()).item, special && (News_module_default()).special),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: href,
          as: as,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: (News_module_default()).link,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (News_module_default()).content,
              children: [special ? /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: (News_module_default()).title,
                children: title
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                className: (News_module_default()).title,
                children: title
              }), published_at && /*#__PURE__*/(0,jsx_runtime.jsxs)("time", {
                className: (News_module_default()).date,
                dateTime: published_at,
                children: [day, " ", month_rus, " ", year]
              })]
            }), image && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (News_module_default()).img,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Picture */.t, News_objectSpread(News_objectSpread({}, image), {}, {
                alt: title,
                title: title
              }))
            })]
          })
        })
      }, id);
    })
  });
};

/* harmony default export */ var news_News = (News);
;// CONCATENATED MODULE: ./containers/news/index.js

/* harmony default export */ var news = (news_News);
// EXTERNAL MODULE: ./containers/specialOffers/SpecialOffers.module.scss
var SpecialOffers_module = __webpack_require__(26859);
var SpecialOffers_module_default = /*#__PURE__*/__webpack_require__.n(SpecialOffers_module);
;// CONCATENATED MODULE: ./containers/specialOffers/SpecialOffers.js



function SpecialOffers_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SpecialOffers_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SpecialOffers_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SpecialOffers_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var SpecialOffers = function SpecialOffers(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (SpecialOffers_module_default()).specialOffers,
    children: items === null || items === void 0 ? void 0 : items.map(function (item) {
      var id = item.id,
          title = item.title,
          sub_title = item.sub_title,
          image = item.image,
          slug = item.slug;

      var _getLinkProps = (0,lib_getLinkProps/* default */.Z)({
        type: 'special-offer',
        value: slug
      }),
          _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
          href = _getLinkProps2[0],
          as = _getLinkProps2[1];

      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: href,
          as: as,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            children: [image && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (SpecialOffers_module_default()).img,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Picture */.t, SpecialOffers_objectSpread(SpecialOffers_objectSpread({}, image), {}, {
                alt: title,
                title: title
              }))
            }), sub_title && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (SpecialOffers_module_default()).subTitle,
              children: ["\u0410\u043A\u0446\u0438\u044F; ", sub_title]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: (SpecialOffers_module_default()).title,
              children: title
            })]
          })
        })
      }, id);
    })
  });
};

/* harmony default export */ var specialOffers_SpecialOffers = (SpecialOffers);
;// CONCATENATED MODULE: ./containers/specialOffers/index.js

/* harmony default export */ var specialOffers = (specialOffers_SpecialOffers);
// EXTERNAL MODULE: ./containers/navPopular/index.js + 1 modules
var navPopular = __webpack_require__(9995);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./seo/JsonLd.js
var JsonLd = __webpack_require__(37286);
;// CONCATENATED MODULE: ./containers/head/Head.js







var NextHead = function NextHead() {
  var router = (0,next_router.useRouter)();
  var breadCrumbsItems = router.asPath.split('/').filter(function (item) {
    return !!item;
  }).map(function (item) {
    var _getLinkProps;

    return {
      name: ((_getLinkProps = (0,lib_getLinkProps/* default */.Z)({
        type: item
      })) === null || _getLinkProps === void 0 ? void 0 : _getLinkProps[2]) || item,
      value: item
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      httpEquiv: "X-UA-Compatible",
      content: "IE=Edge"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "p:domain_verify",
      content: "774e464036290d45593e55029e98cc2c"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "format-detection",
      content: "telephone=no"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "google-play-app",
      content: "app-id=com.websecret.fh"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "facebook-domain-verification",
      content: "ujpoxr2n3xvd4m69jri8wt8f7499q8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "facebook-domain-verification",
      content: "e4atw2laylyv7on7efiacx8ljs4jvi"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "/apple-touch-icon.webp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      sizes: "180x180",
      href: "/android-chrome-192x192.webp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon-32x32.webp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon-16x16.webp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "manifest",
      href: "/site.webmanifest"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "mask-icon",
      href: "/safari-pinned-tab.svg",
      color: "#0FB769"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "/favicon.ico"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "msapplication-TileColor",
      content: "#292c33"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "msapplication-config",
      content: "/browserconfig.xml"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "theme-color",
      content: "#292c33"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify([JsonLd/* default.webSite */.Z.webSite, JsonLd/* default.organization */.Z.organization, JsonLd/* default.breadCrumbsList */.Z.breadCrumbsList(breadCrumbsItems)])
      }
    }, 'json-ld')]
  });
};

/* harmony default export */ var Head = (NextHead);
;// CONCATENATED MODULE: ./containers/head/index.js

// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
// EXTERNAL MODULE: ./contexts/HostContext.js
var HostContext = __webpack_require__(78755);
// EXTERNAL MODULE: ./utils/index.js + 3 modules
var utils = __webpack_require__(70214);
;// CONCATENATED MODULE: ./containers/metaData/MetaData.js









var getArticleMetaData = function getArticleMetaData(data) {
  var _data$published_at, _data$modified_at;

  var publishedDate = (_data$published_at = data === null || data === void 0 ? void 0 : data.published_at) !== null && _data$published_at !== void 0 ? _data$published_at : null;
  var modifiedDate = (_data$modified_at = data === null || data === void 0 ? void 0 : data.modified_at) !== null && _data$modified_at !== void 0 ? _data$modified_at : null;
  var type = data === null || data === void 0 ? void 0 : data.type;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "article:author",
      content: " "
    }), publishedDate && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "published_time",
      content: publishedDate
    }), modifiedDate && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "modified_time",
      content: modifiedDate
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "article:section",
      content: type === 'article' ? 'Новости' : 'Акции'
    })]
  });
};

var getProductMetaData = function getProductMetaData(data) {
  var _data$sku, _data$old_price, _data$breadcrumbs, _breadCrumbs$name, _breadCrumbs;

  var sku = (_data$sku = data === null || data === void 0 ? void 0 : data.sku) !== null && _data$sku !== void 0 ? _data$sku : null;
  var price = (_data$old_price = data === null || data === void 0 ? void 0 : data.old_price) !== null && _data$old_price !== void 0 ? _data$old_price : null;
  var onSale = (data === null || data === void 0 ? void 0 : data.old_price) !== (data === null || data === void 0 ? void 0 : data.price);
  var salePrice = data === null || data === void 0 ? void 0 : data.price;
  var brand = data === null || data === void 0 ? void 0 : data.brand;
  var inStock = (data === null || data === void 0 ? void 0 : data.quantity) !== 0;
  var breadCrumbs = (_data$breadcrumbs = data === null || data === void 0 ? void 0 : data.breadcrumbs) !== null && _data$breadcrumbs !== void 0 ? _data$breadcrumbs : [];
  var category = (_breadCrumbs$name = breadCrumbs === null || breadCrumbs === void 0 ? void 0 : (_breadCrumbs = breadCrumbs[breadCrumbs.length - 2]) === null || _breadCrumbs === void 0 ? void 0 : _breadCrumbs.name) !== null && _breadCrumbs$name !== void 0 ? _breadCrumbs$name : null;
  var currency = 'BYN';

  if ( true && localStorage.getItem('currency') === 'RU') {
    currency = '₽';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [sku && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "product:retailer_part_no",
      content: sku
    }), category && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "product:category",
      content: category
    }), price && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "product:price:amount",
      content: price
    }), onSale && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "product:sale_price:amount",
      content: salePrice
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "product:price:currency",
      content: currency
    }), brand && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "product:brand",
      content: brand
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "product:availability",
      content: inStock ? 'В наличии' : 'Нет в наличии'
    })]
  });
};

var MetaData = function MetaData(_ref) {
  var _router$query;

  var titleFromProps = _ref.title,
      descriptionFromProps = _ref.description,
      _ref$seo = _ref.seo,
      seo = _ref$seo === void 0 ? {} : _ref$seo,
      ogTitleFromProps = _ref.ogTitle,
      ogDescriptionFromProps = _ref.ogDescription,
      image = _ref.image,
      imageSmall = _ref.imageSmall,
      _ref$withPage = _ref.withPage,
      withPage = _ref$withPage === void 0 ? false : _ref$withPage,
      type = _ref.type,
      articleData = _ref.articleData,
      productData = _ref.productData,
      robotsContent = _ref.robotsContent;
  var host = (0,HostContext/* useHost */.$)();
  var origin = "https://".concat(host);
  var router = (0,next_router.useRouter)();
  var path = router.asPath.split('?')[0];
  var url = "".concat(origin).concat(path);
  var srsltid = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.srsltid;
  var defaultImages = {
    rect: "".concat(origin, "/images/og_image_rect.webp"),
    square: "".concat(origin, "/images/og_image_sq.webp")
  };
  var defaultImageRect = defaultImages.rect,
      defaultImageSquare = defaultImages.square;
  var title = titleFromProps || 'FH.BY';
  var description = descriptionFromProps || 'Магазины модной одежды';
  var ogTitle = ogTitleFromProps || title;
  var ogDescription = ogDescriptionFromProps || description;

  if (withPage) {
    var page = router.query.page || '1';

    if (+page !== 1) {
      title = "".concat(title, " | \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ").concat(page);
      ogTitle = "".concat(ogTitle, " | \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ").concat(page);
      description = "".concat(description, " | \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ").concat(page);
      ogDescription = "".concat(ogDescription, " | \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ").concat(page);
    }
  }

  var imageRect = image || defaultImageRect;
  var imageSquare = imageSmall || defaultImageSquare;
  var decodedSeoTitle = (0,he.decode)(seo && seo.title ? (0,utils/* getCorrectName */.tx)(seo.title) : title);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: decodedSeoTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "canonical",
      href: url
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:title",
      content: ogTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:title",
      content: ogTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:type",
      content: type || 'website'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:site_name",
      content: "fh.by"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:url",
      content: url
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:locale",
      content: "ru_RU"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: seo && seo.description ? (0,utils/* getCorrectName */.tx)(seo.description) : description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:description",
      content: ogDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:description",
      content: ogDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image",
      content: imageRect
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image:secure_url",
      content: imageRect
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image:width",
      content: "1200"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image:height",
      content: "630"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image:type",
      content: "image/jpeg"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image",
      content: imageSquare
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image:secure_url",
      content: imageSquare
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image:width",
      content: "300"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image:height",
      content: "300"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image:type",
      content: "image/jpeg"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:card",
      content: "summary"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "twitter:image",
      content: imageSquare
    }), articleData && getArticleMetaData(articleData), productData && getProductMetaData(productData), srsltid ? /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "robots",
      content: "noindex, follow"
    }) : robotsContent && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "robots",
      content: robotsContent
    })]
  });
};

/* harmony default export */ var metaData_MetaData = (MetaData);
;// CONCATENATED MODULE: ./containers/metaData/index.js

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/userSlice.js
var userSlice = __webpack_require__(46789);
// EXTERNAL MODULE: ./containers/login/phoneForm/phoneForm.module.scss
var phoneForm_module = __webpack_require__(94822);
var phoneForm_module_default = /*#__PURE__*/__webpack_require__.n(phoneForm_module);
;// CONCATENATED MODULE: ./containers/login/phoneForm/PhoneForm.js




function PhoneForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PhoneForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PhoneForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhoneForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var PHONE_REPLACE_MASK = /[^\d]+/g;
var FormError = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5695).then(__webpack_require__.bind(__webpack_require__, 35695));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(35695)];
    }
  }
});

var PhoneForm = function PhoneForm(_ref) {
  var onPhoneSubmit = _ref.onPhoneSubmit;

  var _useSelector = (0,es/* useSelector */.v9)(userSlice/* getAuthData */.nr),
      codeSending = _useSelector.codeSending,
      error = _useSelector.error;

  var phoneRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)({
    phone: '',
    phoneFull: '',
    country: 'by',
    inputFocused: false
  }),
      state = _useState[0],
      setState = _useState[1];

  var errors = (0,react.useMemo)(function () {
    var _error$errors;

    return (_error$errors = error === null || error === void 0 ? void 0 : error.errors) !== null && _error$errors !== void 0 ? _error$errors : {};
  }, [error === null || error === void 0 ? void 0 : error.errors]);
  var phone = (0,react.useMemo)(function () {
    return state.phone.replace(PHONE_REPLACE_MASK, '');
  }, [state.phone]);
  var selectedCountry = state.country;
  var maskNumbers = config/* countries */.hW[selectedCountry].mask.replace(PHONE_REPLACE_MASK, '');

  var _useState2 = (0,react.useState)(null),
      phoneError = _useState2[0],
      setPhoneError = _useState2[1];

  var _useState3 = (0,react.useState)(errors[0]),
      submitError = _useState3[0],
      setSubmitError = _useState3[1];

  (0,react.useEffect)(function () {
    if (errors && errors.length > 0) {
      setSubmitError(errors[0]);
    }
  }, [errors]);
  (0,react.useEffect)(function () {
    if (errors !== null && errors !== void 0 && errors.phone) {
      setSubmitError(errors === null || errors === void 0 ? void 0 : errors.phone);
      setPhoneError(null);
    }
  }, [errors === null || errors === void 0 ? void 0 : errors.phone]);
  (0,react.useEffect)(function () {
    setTimeout(function () {
      var _phoneRef$current, _sessionStorage;

      phoneRef === null || phoneRef === void 0 ? void 0 : (_phoneRef$current = phoneRef.current) === null || _phoneRef$current === void 0 ? void 0 : _phoneRef$current.focus();

      if ( true && (_sessionStorage = sessionStorage) !== null && _sessionStorage !== void 0 && _sessionStorage.getItem('country')) {
        var country = sessionStorage.getItem('country').toLowerCase();

        if (config/* countries */.hW[country]) {
          setState(function (prevState) {
            return PhoneForm_objectSpread(PhoneForm_objectSpread({}, prevState), {}, {
              country: country
            });
          });
        }
      }
    }, 0);
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var phoneNumbers, _phoneRef$current2, _phoneRef$current3;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              phoneNumbers = phone;

              if (!(phoneNumbers.length === 0)) {
                _context.next = 7;
                break;
              }

              setPhoneError('Введите номер телефона');
              setSubmitError(null);
              (_phoneRef$current2 = phoneRef.current) === null || _phoneRef$current2 === void 0 ? void 0 : _phoneRef$current2.focus();
              return _context.abrupt("return");

            case 7:
              if (!(phoneNumbers.length < maskNumbers.length)) {
                _context.next = 12;
                break;
              }

              setPhoneError('Недостаточное количество символов');
              setSubmitError(null);
              (_phoneRef$current3 = phoneRef.current) === null || _phoneRef$current3 === void 0 ? void 0 : _phoneRef$current3.focus();
              return _context.abrupt("return");

            case 12:
              _context.next = 14;
              return onPhoneSubmit({
                phone: state.phoneFull
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onPhoneChange = (0,react.useCallback)(function (e) {
    var value = e.target.value;
    var fixedValue = value.replace(/[^\d+]+/g, '');

    if (fixedValue.replace('+', '').length === maskNumbers.length) {
      setPhoneError(null);
    }

    setState(function (prev) {
      return PhoneForm_objectSpread(PhoneForm_objectSpread({}, prev), {}, {
        phone: fixedValue,
        phoneFull: value
      });
    });
  }, [maskNumbers.length]);
  var onCountryChange = (0,react.useCallback)(function (country) {
    setState(function (prev) {
      return PhoneForm_objectSpread(PhoneForm_objectSpread({}, prev), {}, {
        phone: '',
        country: country
      });
    });
    setPhoneError(null);
  }, []);

  var changeLabelState = function changeLabelState(focused) {
    setState(function (prev) {
      return PhoneForm_objectSpread(PhoneForm_objectSpread({}, prev), {}, {
        inputFocused: focused
      });
    });
  };

  var inputLabel = state.inputFocused || state.phone.length > config/* countries */.hW[selectedCountry].code.length ? 'Номер телефона' : config/* countries */.hW[selectedCountry].placeholder;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    autoComplete: "off",
    className: (phoneForm_module_default())["phone-form"],
    onSubmit: onSubmit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (0,clsx_m/* default */.Z)((phoneForm_module_default())["form-control-wrapper"], (0,defineProperty/* default */.Z)({}, (phoneForm_module_default()).withError, submitError)),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (phoneForm_module_default())["form-control"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* CountrySelect */.OP, {
          selectedCountry: selectedCountry,
          onCountryChange: onCountryChange
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Input */.II, {
            label: inputLabel,
            name: "phone",
            value: state.phone,
            onChange: onPhoneChange,
            changeLabelState: changeLabelState,
            mask: config/* countries */.hW[selectedCountry].mask,
            error: phoneError,
            ref: phoneRef,
            classNames: {
              subText: phoneError && phoneError.length > 25 && (phoneForm_module_default()).errorText,
              labelClass: (phoneForm_module_default()).label
            }
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormError, {
        error: submitError
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
      type: "primary",
      action: "submit",
      classNames: {
        general: (phoneForm_module_default())["submit-btn"]
      },
      disabled: codeSending || phone.length < maskNumbers.length,
      loading: codeSending,
      children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E SMS"
    })]
  });
};

/* harmony default export */ var phoneForm_PhoneForm = (PhoneForm);
;// CONCATENATED MODULE: ./containers/login/phoneForm/index.js

/* harmony default export */ var phoneForm = (phoneForm_PhoneForm);
// EXTERNAL MODULE: ./containers/login/codeForm/codeForm.module.scss
var codeForm_module = __webpack_require__(44570);
var codeForm_module_default = /*#__PURE__*/__webpack_require__.n(codeForm_module);
;// CONCATENATED MODULE: ./containers/login/codeForm/CodeForm.js













var CodeForm_FormError = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5695).then(__webpack_require__.bind(__webpack_require__, 35695));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(35695)];
    }
  }
});
var Timer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6346).then(__webpack_require__.bind(__webpack_require__, 36346));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(36346)];
    }
  }
});

var CodeForm = function CodeForm(_ref) {
  var _error$additional, _error$message;

  var onCodeSubmit = _ref.onCodeSubmit,
      onCodeResend = _ref.onCodeResend;

  var _useSelector = (0,es/* useSelector */.v9)(store/* userLoadingInfoSelector */.Rs),
      loggingIn = _useSelector.loggingIn,
      error = _useSelector.error;

  var seconds = error === null || error === void 0 ? void 0 : (_error$additional = error.additional) === null || _error$additional === void 0 ? void 0 : _error$additional.seconds;

  var _useState = (0,react.useState)(60),
      smsBan = _useState[0],
      setSmsBan = _useState[1];

  var _useState2 = (0,react.useState)((_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : ''),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var codeRef = (0,react.useRef)(null);

  var _useState3 = (0,react.useState)(''),
      code = _useState3[0],
      setCode = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      dropdownVisible = _useState4[0],
      setDropdownVisible = _useState4[1];

  (0,react.useEffect)(function () {
    var _error$errors;

    if (error !== null && error !== void 0 && (_error$errors = error.errors) !== null && _error$errors !== void 0 && _error$errors.verification_code) {
      setErrors(error.errors.verification_code[0]);
    } else if (error !== null && error !== void 0 && error.errors && error.errors.length) {
      setErrors(error.errors[0]);
    } else {
      var _error$message2;

      setErrors((_error$message2 = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message2 !== void 0 ? _error$message2 : '');
    }
  }, [error]);
  (0,react.useEffect)(function () {
    var codeError = errors !== null && errors !== void 0 ? errors : null;

    if (codeError) {
      var _codeRef$current;

      codeRef === null || codeRef === void 0 ? void 0 : (_codeRef$current = codeRef.current) === null || _codeRef$current === void 0 ? void 0 : _codeRef$current.focus();
    }
  }, [errors]);
  (0,react.useEffect)(function () {
    if (seconds && seconds >= 0) {
      setSmsBan(seconds);
    }
  }, [seconds]);
  (0,react.useEffect)(function () {
    var _codeRef$current2;

    codeRef === null || codeRef === void 0 ? void 0 : (_codeRef$current2 = codeRef.current) === null || _codeRef$current2 === void 0 ? void 0 : _codeRef$current2.focus();
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              _context.next = 3;
              return onCodeSubmit({
                code: code
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onFieldChange = (0,react.useCallback)(function (e) {
    var value = e.target.value;
    setCode(value);
    setErrors('');
  }, []);
  var onTimerFinish = (0,react.useCallback)(function () {
    setSmsBan(-1);
  }, []);
  var onCodeResendClick = (0,react.useCallback)(function () {
    setSmsBan(60);
    setCode('');
    onCodeResend();
  }, [onCodeResend]);
  var handleToggleDropdownVisible = (0,react.useCallback)(function () {
    setDropdownVisible(function (prev) {
      return !prev;
    });
  }, []);
  var handleCloseDropdownVisible = (0,react.useCallback)(function () {
    setDropdownVisible(false);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    className: (codeForm_module_default())["code-form"],
    autoComplete: "off",
    onSubmit: onSubmit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (codeForm_module_default())["form-control"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Input */.II, {
        label: "\u041A\u043E\u0434 \u0438\u0437 SMS",
        name: "verification_code",
        value: code,
        onChange: onFieldChange,
        ref: codeRef,
        classNames: {
          labelClass: (codeForm_module_default()).label
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CodeForm_FormError, {
        error: errors
      }), smsBan > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (codeForm_module_default())["form-info"],
        children: ["\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u0435\u0449\u0435 \u0440\u0430\u0437 \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u0447\u0435\u0440\u0435\u0437", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Timer, {
          seconds: smsBan,
          render: LoginTimer,
          onFinish: onTimerFinish
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        type: "link",
        action: "button",
        onClick: onCodeResendClick,
        classNames: {
          general: (codeForm_module_default())["resend-code-btn"]
        },
        children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u0435\u0449\u0435 \u0440\u0430\u0437"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
      type: "primary",
      action: "submit",
      disabled: loggingIn,
      loading: loggingIn,
      classNames: {
        general: (codeForm_module_default())["submit-btn"]
      },
      children: "\u0412\u043E\u0439\u0442\u0438"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ClickOutside */.Lp, {
      onClickOutside: handleCloseDropdownVisible,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (codeForm_module_default())["tip-container"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
          action: "button",
          type: "link",
          classNames: {
            general: (codeForm_module_default())["tip-btn"]
          },
          onClick: handleToggleDropdownVisible,
          children: "\u041D\u0435 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442 SMS"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (0,clsx_m/* default */.Z)((codeForm_module_default())["tip-dropdown"], (0,defineProperty/* default */.Z)({}, (codeForm_module_default()).visible, dropdownVisible)),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435, \u0447\u0442\u043E: ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "- \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0432\u043A\u043B\u044E\u0447\u0435\u043D \u0438 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0437\u043E\u043D\u0435 \u043F\u0440\u0438\u0435\u043C\u0430 \u0441\u0435\u0442\u0438; ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "- \u0432\u044B \u0432\u0432\u0435\u043B\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430; ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "- \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043D\u0435 \u043F\u043E\u043F\u0430\u043B\u043E \u0432 \u0441\u043F\u0430\u043C, \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 (\u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0435); ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "- \u0443 \u0432\u0430\u0441 \u043D\u0435 \u0441\u0442\u043E\u0438\u0442 \u0437\u0430\u043F\u0440\u0435\u0442 \u043D\u0430 \u043F\u0440\u0438\u0435\u043C SMS \u0441\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u044B \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430."]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u0418\u043D\u043E\u0433\u0434\u0430 SMS \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442 \u043D\u0435 \u0441\u0440\u0430\u0437\u0443. \u0415\u0441\u043B\u0438 SMS \u043D\u0435\u0442 20 \u043C\u0438\u043D\u0443\u0442, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434 \u0435\u0449\u0435 \u0440\u0430\u0437."
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var codeForm_CodeForm = (CodeForm);
;// CONCATENATED MODULE: ./containers/login/codeForm/index.js

/* harmony default export */ var codeForm = (codeForm_CodeForm);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/checkoutSlice.js
var checkoutSlice = __webpack_require__(10604);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/cartSlice.js
var cartSlice = __webpack_require__(78955);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(53416);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./contexts/NotificationContext.js
var NotificationContext = __webpack_require__(64318);
// EXTERNAL MODULE: ./containers/login/loginForm/loginForm.module.scss
var loginForm_module = __webpack_require__(6943);
var loginForm_module_default = /*#__PURE__*/__webpack_require__.n(loginForm_module);
;// CONCATENATED MODULE: ./containers/login/loginForm/LoginForm.js




function LoginForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LoginForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LoginForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LoginForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var PersonalDataModal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2101).then(__webpack_require__.bind(__webpack_require__, 82101));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(82101)];
    }
  }
});
var LoginForm_PHONE_REPLACE_MASK = /[^\d]+/g;

var Login = function Login() {
  var error = (0,es/* useSelector */.v9)(store/* userErrorSelector */.EI);
  var redirectUrl = (0,es/* useSelector */.v9)(store/* redirectUrlSelector */.E6);
  var errors = (0,react.useMemo)(function () {
    var _error$errors;

    return (_error$errors = error === null || error === void 0 ? void 0 : error.errors) !== null && _error$errors !== void 0 ? _error$errors : {};
  }, [error === null || error === void 0 ? void 0 : error.errors]);

  var _useState = (0,react.useState)({
    phone: '',
    code: ''
  }),
      state = _useState[0],
      setState = _useState[1];

  var _useState2 = (0,react.useState)('phone'),
      screen = _useState2[0],
      setScreen = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isPersonalDataModalShow = _useState3[0],
      setIsPersonalDataModalShow = _useState3[1];

  var notification = (0,NotificationContext/* useNotification */.l)();
  var dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    var _errors$phone, _errors$verification_;

    var phoneError = (_errors$phone = errors === null || errors === void 0 ? void 0 : errors.phone) !== null && _errors$phone !== void 0 ? _errors$phone : null;
    var codeError = (_errors$verification_ = errors === null || errors === void 0 ? void 0 : errors.verification_code) !== null && _errors$verification_ !== void 0 ? _errors$verification_ : null;

    if (phoneError) {
      setScreen('phone');
    }

    if (codeError) {
      setScreen('code');
    }
  }, [errors]);

  var onPhoneSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
      var phone, phoneNumbers;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              phone = _ref.phone;
              phoneNumbers = phone.replace(LoginForm_PHONE_REPLACE_MASK, '');
              setState(function (prev) {
                return LoginForm_objectSpread(LoginForm_objectSpread({}, prev), {}, {
                  phone: phone
                });
              });
              _context.next = 5;
              return dispatch((0,userSlice/* sendCode */.Yo)({
                phone: phoneNumbers,
                onSuccess: function onSuccess() {
                  // ecommerce.onConfirmPhoneNumber();
                  setScreen('code');
                }
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onPhoneSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onPhoneChange = function onPhoneChange() {
    setScreen('phone');
  };

  var onCodeResend = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var phoneNumbers;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              phoneNumbers = state.phone.replace(LoginForm_PHONE_REPLACE_MASK, '');
              _context2.next = 3;
              return dispatch((0,userSlice/* sendCode */.Yo)({
                phone: phoneNumbers
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onCodeResend() {
      return _ref3.apply(this, arguments);
    };
  }();

  var addNotification = (0,react.useCallback)(function () {
    var id = "login-products-".concat((0,index_browser/* nanoid */.x0)());

    var handleClick = function handleClick() {
      notification.close(id);
    };

    notification.add({
      id: id,
      style: 'warning',
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "\u041C\u044B \u043E\u0431\u044A\u0435\u0434\u0438\u043D\u0438\u043B\u0438 \u0442\u043E\u0432\u0430\u0440\u044B \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u043C \u0438 \u043A\u043E\u0440\u0437\u0438\u043D\u0435 \u0441\u043E \u0432\u0441\u0435\u0445 \u0432\u0430\u0448\u0438\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
          action: "button",
          onClick: handleClick,
          classNames: {
            general: (loginForm_module_default())["combine-products-btn"]
          },
          children: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E"
        })]
      }),
      closable: true
    });
  }, [notification]);

  var redirect = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var href, asPath, query;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(redirectUrl.href === '/cart')) {
                _context3.next = 3;
                break;
              }

              _context3.next = 3;
              return dispatch((0,cartSlice/* fetchCart */.x7)());

            case 3:
              href = redirectUrl.href, asPath = redirectUrl.asPath, query = redirectUrl.query;
              router_default().push({
                pathname: href,
                query: query
              }, {
                pathname: asPath,
                query: query
              });

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function redirect() {
      return _ref4.apply(this, arguments);
    };
  }();

  var onCodeSubmit = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref5) {
      var code, phoneNumbers, mindboxDeviceUUID;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              code = _ref5.code;
              phoneNumbers = state.phone.replace(LoginForm_PHONE_REPLACE_MASK, '');
              mindboxDeviceUUID = js_cookie_default().get('mindboxDeviceUUID');
              _context5.next = 5;
              return dispatch((0,userSlice/* login */.x4)({
                phone: phoneNumbers,
                verification_code: code,
                mindboxDeviceUUID: mindboxDeviceUUID,
                onSuccess: function () {
                  var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref7) {
                    var hasNewProducts, isNewUser, user;
                    return regenerator_default().wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            hasNewProducts = _ref7.hasNewProducts, isNewUser = _ref7.isNewUser, user = _ref7.user;
                            dispatch((0,checkoutSlice/* resetCheckoutData */.Fc)());
                            Ecommerce/* default.setLogin */.ZP.setLogin(isNewUser ? 'sign_up' : 'login', user.id);

                            if (hasNewProducts) {
                              addNotification();
                            }

                            if (window && window.generalPixel) {
                              window.generalPixel.postClick('a2');
                            }

                            if (!(user !== null && user !== void 0 && user.is_personal_data)) {
                              setIsPersonalDataModalShow(true);
                            } else {
                              redirect();
                            }

                            dispatch((0,sessionSlice/* createSession */.ed)(true, undefined, {
                              forceRefresh: true
                            }));

                          case 7:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  function onSuccess(_x3) {
                    return _onSuccess.apply(this, arguments);
                  }

                  return onSuccess;
                }()
              }));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function onCodeSubmit(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  return screen === 'phone' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (loginForm_module_default())["form-title"],
      children: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(phoneForm, {
      onPhoneSubmit: onPhoneSubmit
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonalDataModal, {
      showDialog: isPersonalDataModalShow,
      onDismiss: function onDismiss() {
        setIsPersonalDataModalShow(false);
      },
      onShow: function onShow() {
        setIsPersonalDataModalShow(true);
      },
      redirect: redirect
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (loginForm_module_default())["form-title"],
      children: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u0437 SMS"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (loginForm_module_default())["form-text"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u043D\u043E\u043C\u0435\u0440:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [state.phone, /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
          type: "link",
          action: "button",
          onClick: onPhoneChange,
          classNames: {
            general: (loginForm_module_default())["change-btn"]
          },
          children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(codeForm, {
      onCodeSubmit: onCodeSubmit,
      onCodeResend: onCodeResend
    })]
  });
};

/* harmony default export */ var LoginForm = (Login);
;// CONCATENATED MODULE: ./containers/login/loginForm/index.js

/* harmony default export */ var loginForm = (LoginForm);
;// CONCATENATED MODULE: ./containers/login/LoginLink.js








function LoginLink(_ref) {
  var children = _ref.children;
  var router = useRouter();
  var href = router.pathname;
  var asPath = router.asPath.split('?')[0];
  var query = router.query;
  var dispatch = useDispatch();

  var _getLinkProps = getLinkProps({
    type: 'login'
  }),
      _getLinkProps2 = _slicedToArray(_getLinkProps, 2),
      loginHref = _getLinkProps2[0],
      loginAs = _getLinkProps2[1];

  var onClick = function onClick() {
    var queryNext = {};
    Object.keys(query).forEach(function (key) {
      if (href.indexOf("[".concat(key, "]")) === -1 && href.indexOf("[...".concat(key, "]")) === -1) {
        queryNext[key] = query[key];
      }
    });
    dispatch(changeRedirectUrl({
      href: href,
      asPath: asPath,
      query: queryNext
    }));
  };

  return /*#__PURE__*/_jsx(ActiveLink, {
    href: loginHref,
    as: loginAs,
    children: Children.map(children, function (child) {
      return /*#__PURE__*/cloneElement(child, {
        onClick: onClick
      });
    })
  });
}
;// CONCATENATED MODULE: ./containers/login/LoginTimer.js

function LoginTimer(_ref) {
  var minutes = _ref.minutes,
      seconds = _ref.seconds;
  var arr = [];
  arr.push(minutes < 10 ? "0".concat(minutes) : minutes);
  arr.push(seconds < 10 ? "0".concat(seconds) : seconds);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: arr.join(':')
  });
}
;// CONCATENATED MODULE: ./containers/login/index.js





;// CONCATENATED MODULE: ./containers/index.js
 // export { default as BucketModal } from './bucketModal';
// export { default as LooksModal } from './looksModal';

 // export { default as CategoryTree } from './categoryTree';
// export { default as Brands } from './brands';




 // export { default as TagsRow } from './tagsRow';



 // export { default as Address } from './address';
// export { default as AddressPopup } from './addressPopup';

 // export { default as Cart } from './cart';

 // export { default as Product } from './product';
// export { default as Products } from './products';

 // export { default as UserDiscount } from './user/userDiscount';
// export { default as UserProfile } from './user/userProfile';
// export { default as UserNewsletters } from './user/userNewsletters';
// export { default as UserOrders } from './user/userOrders';
// export { default as UserReturns } from './user/userReturns';
// export { default as Checkout } from './checkout';
// export { default as Returns } from './returns';
// export { default as Orders } from './orders';
// export { default as Viewed } from './viewed';




 // export { default as Wishlist } from './wishlist';

/***/ }),

/***/ 9995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ navPopular; }
});

// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./containers/navPopular/NavPopular.module.scss
var NavPopular_module = __webpack_require__(7403);
var NavPopular_module_default = /*#__PURE__*/__webpack_require__.n(NavPopular_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/navPopular/NavPopular.js
/* eslint-disable jsx-a11y/anchor-is-valid */







var NavPopular = /*#__PURE__*/(0,react.memo)(function () {
  var top = (0,es/* useSelector */.v9)(store/* menuTopSelector */.I4);
  var hasSmartBanner = (0,es/* useSelector */.v9)(store/* hasSmartBannerSelector */.Jd);

  var isSaleSlug = function isSaleSlug(slug) {
    return slug && (slug.toLowerCase().includes('sale') || slug.toLowerCase().includes('blackfriday'));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((NavPopular_module_default()).container, hasSmartBanner && (NavPopular_module_default()).smartBanner),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: (NavPopular_module_default()).list,
      children: top.map(function (item) {
        var name = item.name,
            slug = item.slug,
            id = item.id;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: (NavPopular_module_default()).item,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
            href: "".concat(slug),
            as: "".concat(slug),
            activeClassName: (0,clsx_m/* default */.Z)((NavPopular_module_default()).link, isSaleSlug(slug) && (NavPopular_module_default()).sale, (NavPopular_module_default()).activeLink),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (0,clsx_m/* default */.Z)((NavPopular_module_default()).link, isSaleSlug(slug) && (NavPopular_module_default()).sale),
              children: name
            })
          })
        }, id);
      })
    })
  });
});
/* harmony default export */ var navPopular_NavPopular = (NavPopular);
;// CONCATENATED MODULE: ./containers/navPopular/index.js

/* harmony default export */ var navPopular = (navPopular_NavPopular);

/***/ }),

/***/ 53013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l5": function() { return /* binding */ ChannelsProvider; },
  "yN": function() { return /* binding */ usePrivateChannels; }
});

// UNUSED EXPORTS: useChannels

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/laravel-echo/dist/echo.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/**
 * This class represents a basic channel.
 */
var Channel = /*#__PURE__*/function () {
  function Channel() {
    _classCallCheck(this, Channel);
  }

  _createClass(Channel, [{
    key: "listenForWhisper",
    value:
    /**
     * Listen for a whisper event on the channel instance.
     */
    function listenForWhisper(event, callback) {
      return this.listen('.client-' + event, callback);
    }
    /**
     * Listen for an event on the channel instance.
     */

  }, {
    key: "notification",
    value: function notification(callback) {
      return this.listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', callback);
    }
    /**
     * Stop listening for a whisper event on the channel instance.
     */

  }, {
    key: "stopListeningForWhisper",
    value: function stopListeningForWhisper(event, callback) {
      return this.stopListening('.client-' + event, callback);
    }
  }]);

  return Channel;
}();

/**
 * Event name formatter
 */
var EventFormatter = /*#__PURE__*/function () {
  /**
   * Create a new class instance.
   */
  function EventFormatter(namespace) {
    _classCallCheck(this, EventFormatter);

    this.namespace = namespace; //
  }
  /**
   * Format the given event name.
   */


  _createClass(EventFormatter, [{
    key: "format",
    value: function format(event) {
      if (event.charAt(0) === '.' || event.charAt(0) === '\\') {
        return event.substr(1);
      } else if (this.namespace) {
        event = this.namespace + '.' + event;
      }

      return event.replace(/\./g, '\\');
    }
    /**
     * Set the event namespace.
     */

  }, {
    key: "setNamespace",
    value: function setNamespace(value) {
      this.namespace = value;
    }
  }]);

  return EventFormatter;
}();

/**
 * This class represents a Pusher channel.
 */

var PusherChannel = /*#__PURE__*/function (_Channel) {
  _inherits(PusherChannel, _Channel);

  var _super = _createSuper(PusherChannel);

  /**
   * Create a new class instance.
   */
  function PusherChannel(pusher, name, options) {
    var _this;

    _classCallCheck(this, PusherChannel);

    _this = _super.call(this);
    _this.name = name;
    _this.pusher = pusher;
    _this.options = options;
    _this.eventFormatter = new EventFormatter(_this.options.namespace);

    _this.subscribe();

    return _this;
  }
  /**
   * Subscribe to a Pusher channel.
   */


  _createClass(PusherChannel, [{
    key: "subscribe",
    value: function subscribe() {
      this.subscription = this.pusher.subscribe(this.name);
    }
    /**
     * Unsubscribe from a Pusher channel.
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.pusher.unsubscribe(this.name);
    }
    /**
     * Listen for an event on the channel instance.
     */

  }, {
    key: "listen",
    value: function listen(event, callback) {
      this.on(this.eventFormatter.format(event), callback);
      return this;
    }
    /**
     * Listen for all events on the channel instance.
     */

  }, {
    key: "listenToAll",
    value: function listenToAll(callback) {
      var _this2 = this;

      this.subscription.bind_global(function (event, data) {
        if (event.startsWith('pusher:')) {
          return;
        }

        var namespace = _this2.options.namespace.replace(/\./g, '\\');

        var formattedEvent = event.startsWith(namespace) ? event.substring(namespace.length + 1) : '.' + event;
        callback(formattedEvent, data);
      });
      return this;
    }
    /**
     * Stop listening for an event on the channel instance.
     */

  }, {
    key: "stopListening",
    value: function stopListening(event, callback) {
      if (callback) {
        this.subscription.unbind(this.eventFormatter.format(event), callback);
      } else {
        this.subscription.unbind(this.eventFormatter.format(event));
      }

      return this;
    }
    /**
     * Stop listening for all events on the channel instance.
     */

  }, {
    key: "stopListeningToAll",
    value: function stopListeningToAll(callback) {
      if (callback) {
        this.subscription.unbind_global(callback);
      } else {
        this.subscription.unbind_global();
      }

      return this;
    }
    /**
     * Register a callback to be called anytime a subscription succeeds.
     */

  }, {
    key: "subscribed",
    value: function subscribed(callback) {
      this.on('pusher:subscription_succeeded', function () {
        callback();
      });
      return this;
    }
    /**
     * Register a callback to be called anytime a subscription error occurs.
     */

  }, {
    key: "error",
    value: function error(callback) {
      this.on('pusher:subscription_error', function (status) {
        callback(status);
      });
      return this;
    }
    /**
     * Bind a channel to an event.
     */

  }, {
    key: "on",
    value: function on(event, callback) {
      this.subscription.bind(event, callback);
      return this;
    }
  }]);

  return PusherChannel;
}(Channel);

/**
 * This class represents a Pusher private channel.
 */

var PusherPrivateChannel = /*#__PURE__*/function (_PusherChannel) {
  _inherits(PusherPrivateChannel, _PusherChannel);

  var _super = _createSuper(PusherPrivateChannel);

  function PusherPrivateChannel() {
    _classCallCheck(this, PusherPrivateChannel);

    return _super.apply(this, arguments);
  }

  _createClass(PusherPrivateChannel, [{
    key: "whisper",
    value:
    /**
     * Send a whisper event to other clients in the channel.
     */
    function whisper(eventName, data) {
      this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
      return this;
    }
  }]);

  return PusherPrivateChannel;
}(PusherChannel);

/**
 * This class represents a Pusher private channel.
 */

var PusherEncryptedPrivateChannel = /*#__PURE__*/function (_PusherChannel) {
  _inherits(PusherEncryptedPrivateChannel, _PusherChannel);

  var _super = _createSuper(PusherEncryptedPrivateChannel);

  function PusherEncryptedPrivateChannel() {
    _classCallCheck(this, PusherEncryptedPrivateChannel);

    return _super.apply(this, arguments);
  }

  _createClass(PusherEncryptedPrivateChannel, [{
    key: "whisper",
    value:
    /**
     * Send a whisper event to other clients in the channel.
     */
    function whisper(eventName, data) {
      this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
      return this;
    }
  }]);

  return PusherEncryptedPrivateChannel;
}(PusherChannel);

/**
 * This class represents a Pusher presence channel.
 */

var PusherPresenceChannel = /*#__PURE__*/function (_PusherChannel) {
  _inherits(PusherPresenceChannel, _PusherChannel);

  var _super = _createSuper(PusherPresenceChannel);

  function PusherPresenceChannel() {
    _classCallCheck(this, PusherPresenceChannel);

    return _super.apply(this, arguments);
  }

  _createClass(PusherPresenceChannel, [{
    key: "here",
    value:
    /**
     * Register a callback to be called anytime the member list changes.
     */
    function here(callback) {
      this.on('pusher:subscription_succeeded', function (data) {
        callback(Object.keys(data.members).map(function (k) {
          return data.members[k];
        }));
      });
      return this;
    }
    /**
     * Listen for someone joining the channel.
     */

  }, {
    key: "joining",
    value: function joining(callback) {
      this.on('pusher:member_added', function (member) {
        callback(member.info);
      });
      return this;
    }
    /**
     * Send a whisper event to other clients in the channel.
     */

  }, {
    key: "whisper",
    value: function whisper(eventName, data) {
      this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
      return this;
    }
    /**
     * Listen for someone leaving the channel.
     */

  }, {
    key: "leaving",
    value: function leaving(callback) {
      this.on('pusher:member_removed', function (member) {
        callback(member.info);
      });
      return this;
    }
  }]);

  return PusherPresenceChannel;
}(PusherChannel);

/**
 * This class represents a Socket.io channel.
 */

var SocketIoChannel = /*#__PURE__*/function (_Channel) {
  _inherits(SocketIoChannel, _Channel);

  var _super = _createSuper(SocketIoChannel);

  /**
   * Create a new class instance.
   */
  function SocketIoChannel(socket, name, options) {
    var _this;

    _classCallCheck(this, SocketIoChannel);

    _this = _super.call(this);
    /**
     * The event callbacks applied to the socket.
     */

    _this.events = {};
    /**
     * User supplied callbacks for events on this channel.
     */

    _this.listeners = {};
    _this.name = name;
    _this.socket = socket;
    _this.options = options;
    _this.eventFormatter = new EventFormatter(_this.options.namespace);

    _this.subscribe();

    return _this;
  }
  /**
   * Subscribe to a Socket.io channel.
   */


  _createClass(SocketIoChannel, [{
    key: "subscribe",
    value: function subscribe() {
      this.socket.emit('subscribe', {
        channel: this.name,
        auth: this.options.auth || {}
      });
    }
    /**
     * Unsubscribe from channel and ubind event callbacks.
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.unbind();
      this.socket.emit('unsubscribe', {
        channel: this.name,
        auth: this.options.auth || {}
      });
    }
    /**
     * Listen for an event on the channel instance.
     */

  }, {
    key: "listen",
    value: function listen(event, callback) {
      this.on(this.eventFormatter.format(event), callback);
      return this;
    }
    /**
     * Stop listening for an event on the channel instance.
     */

  }, {
    key: "stopListening",
    value: function stopListening(event, callback) {
      this.unbindEvent(this.eventFormatter.format(event), callback);
      return this;
    }
    /**
     * Register a callback to be called anytime a subscription succeeds.
     */

  }, {
    key: "subscribed",
    value: function subscribed(callback) {
      this.on('connect', function (socket) {
        callback(socket);
      });
      return this;
    }
    /**
     * Register a callback to be called anytime an error occurs.
     */

  }, {
    key: "error",
    value: function error(callback) {
      return this;
    }
    /**
     * Bind the channel's socket to an event and store the callback.
     */

  }, {
    key: "on",
    value: function on(event, callback) {
      var _this2 = this;

      this.listeners[event] = this.listeners[event] || [];

      if (!this.events[event]) {
        this.events[event] = function (channel, data) {
          if (_this2.name === channel && _this2.listeners[event]) {
            _this2.listeners[event].forEach(function (cb) {
              return cb(data);
            });
          }
        };

        this.socket.on(event, this.events[event]);
      }

      this.listeners[event].push(callback);
      return this;
    }
    /**
     * Unbind the channel's socket from all stored event callbacks.
     */

  }, {
    key: "unbind",
    value: function unbind() {
      var _this3 = this;

      Object.keys(this.events).forEach(function (event) {
        _this3.unbindEvent(event);
      });
    }
    /**
     * Unbind the listeners for the given event.
     */

  }, {
    key: "unbindEvent",
    value: function unbindEvent(event, callback) {
      this.listeners[event] = this.listeners[event] || [];

      if (callback) {
        this.listeners[event] = this.listeners[event].filter(function (cb) {
          return cb !== callback;
        });
      }

      if (!callback || this.listeners[event].length === 0) {
        if (this.events[event]) {
          this.socket.removeListener(event, this.events[event]);
          delete this.events[event];
        }

        delete this.listeners[event];
      }
    }
  }]);

  return SocketIoChannel;
}(Channel);

/**
 * This class represents a Socket.io private channel.
 */

var SocketIoPrivateChannel = /*#__PURE__*/function (_SocketIoChannel) {
  _inherits(SocketIoPrivateChannel, _SocketIoChannel);

  var _super = _createSuper(SocketIoPrivateChannel);

  function SocketIoPrivateChannel() {
    _classCallCheck(this, SocketIoPrivateChannel);

    return _super.apply(this, arguments);
  }

  _createClass(SocketIoPrivateChannel, [{
    key: "whisper",
    value:
    /**
     * Send a whisper event to other clients in the channel.
     */
    function whisper(eventName, data) {
      this.socket.emit('client event', {
        channel: this.name,
        event: "client-".concat(eventName),
        data: data
      });
      return this;
    }
  }]);

  return SocketIoPrivateChannel;
}(SocketIoChannel);

/**
 * This class represents a Socket.io presence channel.
 */

var SocketIoPresenceChannel = /*#__PURE__*/function (_SocketIoPrivateChann) {
  _inherits(SocketIoPresenceChannel, _SocketIoPrivateChann);

  var _super = _createSuper(SocketIoPresenceChannel);

  function SocketIoPresenceChannel() {
    _classCallCheck(this, SocketIoPresenceChannel);

    return _super.apply(this, arguments);
  }

  _createClass(SocketIoPresenceChannel, [{
    key: "here",
    value:
    /**
     * Register a callback to be called anytime the member list changes.
     */
    function here(callback) {
      this.on('presence:subscribed', function (members) {
        callback(members.map(function (m) {
          return m.user_info;
        }));
      });
      return this;
    }
    /**
     * Listen for someone joining the channel.
     */

  }, {
    key: "joining",
    value: function joining(callback) {
      this.on('presence:joining', function (member) {
        return callback(member.user_info);
      });
      return this;
    }
    /**
     * Send a whisper event to other clients in the channel.
     */

  }, {
    key: "whisper",
    value: function whisper(eventName, data) {
      this.socket.emit('client event', {
        channel: this.name,
        event: "client-".concat(eventName),
        data: data
      });
      return this;
    }
    /**
     * Listen for someone leaving the channel.
     */

  }, {
    key: "leaving",
    value: function leaving(callback) {
      this.on('presence:leaving', function (member) {
        return callback(member.user_info);
      });
      return this;
    }
  }]);

  return SocketIoPresenceChannel;
}(SocketIoPrivateChannel);

/**
 * This class represents a null channel.
 */

var NullChannel = /*#__PURE__*/function (_Channel) {
  _inherits(NullChannel, _Channel);

  var _super = _createSuper(NullChannel);

  function NullChannel() {
    _classCallCheck(this, NullChannel);

    return _super.apply(this, arguments);
  }

  _createClass(NullChannel, [{
    key: "subscribe",
    value:
    /**
     * Subscribe to a channel.
     */
    function subscribe() {//
    }
    /**
     * Unsubscribe from a channel.
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {//
    }
    /**
     * Listen for an event on the channel instance.
     */

  }, {
    key: "listen",
    value: function listen(event, callback) {
      return this;
    }
    /**
     * Listen for all events on the channel instance.
     */

  }, {
    key: "listenToAll",
    value: function listenToAll(callback) {
      return this;
    }
    /**
     * Stop listening for an event on the channel instance.
     */

  }, {
    key: "stopListening",
    value: function stopListening(event, callback) {
      return this;
    }
    /**
     * Register a callback to be called anytime a subscription succeeds.
     */

  }, {
    key: "subscribed",
    value: function subscribed(callback) {
      return this;
    }
    /**
     * Register a callback to be called anytime an error occurs.
     */

  }, {
    key: "error",
    value: function error(callback) {
      return this;
    }
    /**
     * Bind a channel to an event.
     */

  }, {
    key: "on",
    value: function on(event, callback) {
      return this;
    }
  }]);

  return NullChannel;
}(Channel);

/**
 * This class represents a null private channel.
 */

var NullPrivateChannel = /*#__PURE__*/function (_NullChannel) {
  _inherits(NullPrivateChannel, _NullChannel);

  var _super = _createSuper(NullPrivateChannel);

  function NullPrivateChannel() {
    _classCallCheck(this, NullPrivateChannel);

    return _super.apply(this, arguments);
  }

  _createClass(NullPrivateChannel, [{
    key: "whisper",
    value:
    /**
     * Send a whisper event to other clients in the channel.
     */
    function whisper(eventName, data) {
      return this;
    }
  }]);

  return NullPrivateChannel;
}(NullChannel);

/**
 * This class represents a null presence channel.
 */

var NullPresenceChannel = /*#__PURE__*/function (_NullChannel) {
  _inherits(NullPresenceChannel, _NullChannel);

  var _super = _createSuper(NullPresenceChannel);

  function NullPresenceChannel() {
    _classCallCheck(this, NullPresenceChannel);

    return _super.apply(this, arguments);
  }

  _createClass(NullPresenceChannel, [{
    key: "here",
    value:
    /**
     * Register a callback to be called anytime the member list changes.
     */
    function here(callback) {
      return this;
    }
    /**
     * Listen for someone joining the channel.
     */

  }, {
    key: "joining",
    value: function joining(callback) {
      return this;
    }
    /**
     * Send a whisper event to other clients in the channel.
     */

  }, {
    key: "whisper",
    value: function whisper(eventName, data) {
      return this;
    }
    /**
     * Listen for someone leaving the channel.
     */

  }, {
    key: "leaving",
    value: function leaving(callback) {
      return this;
    }
  }]);

  return NullPresenceChannel;
}(NullChannel);

var Connector = /*#__PURE__*/function () {
  /**
   * Create a new class instance.
   */
  function Connector(options) {
    _classCallCheck(this, Connector);

    /**
     * Default connector options.
     */
    this._defaultOptions = {
      auth: {
        headers: {}
      },
      authEndpoint: '/broadcasting/auth',
      userAuthentication: {
        endpoint: '/broadcasting/user-auth',
        headers: {}
      },
      broadcaster: 'pusher',
      csrfToken: null,
      bearerToken: null,
      host: null,
      key: null,
      namespace: 'App.Events'
    };
    this.setOptions(options);
    this.connect();
  }
  /**
   * Merge the custom options with the defaults.
   */


  _createClass(Connector, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = _extends(this._defaultOptions, options);
      var token = this.csrfToken();

      if (token) {
        this.options.auth.headers['X-CSRF-TOKEN'] = token;
        this.options.userAuthentication.headers['X-CSRF-TOKEN'] = token;
      }

      token = this.options.bearerToken;

      if (token) {
        this.options.auth.headers['Authorization'] = 'Bearer ' + token;
        this.options.userAuthentication.headers['Authorization'] = 'Bearer ' + token;
      }

      return options;
    }
    /**
     * Extract the CSRF token from the page.
     */

  }, {
    key: "csrfToken",
    value: function csrfToken() {
      var selector;

      if (typeof window !== 'undefined' && window['Laravel'] && window['Laravel'].csrfToken) {
        return window['Laravel'].csrfToken;
      } else if (this.options.csrfToken) {
        return this.options.csrfToken;
      } else if (typeof document !== 'undefined' && typeof document.querySelector === 'function' && (selector = document.querySelector('meta[name="csrf-token"]'))) {
        return selector.getAttribute('content');
      }

      return null;
    }
  }]);

  return Connector;
}();

/**
 * This class creates a connector to Pusher.
 */

var PusherConnector = /*#__PURE__*/function (_Connector) {
  _inherits(PusherConnector, _Connector);

  var _super = _createSuper(PusherConnector);

  function PusherConnector() {
    var _this;

    _classCallCheck(this, PusherConnector);

    _this = _super.apply(this, arguments);
    /**
     * All of the subscribed channel names.
     */

    _this.channels = {};
    return _this;
  }
  /**
   * Create a fresh Pusher connection.
   */


  _createClass(PusherConnector, [{
    key: "connect",
    value: function connect() {
      if (typeof this.options.client !== 'undefined') {
        this.pusher = this.options.client;
      } else if (this.options.Pusher) {
        this.pusher = new this.options.Pusher(this.options.key, this.options);
      } else {
        this.pusher = new Pusher(this.options.key, this.options);
      }
    }
    /**
     * Sign in the user via Pusher user authentication (https://pusher.com/docs/channels/using_channels/user-authentication/).
     */

  }, {
    key: "signin",
    value: function signin() {
      this.pusher.signin();
    }
    /**
     * Listen for an event on a channel instance.
     */

  }, {
    key: "listen",
    value: function listen(name, event, callback) {
      return this.channel(name).listen(event, callback);
    }
    /**
     * Get a channel instance by name.
     */

  }, {
    key: "channel",
    value: function channel(name) {
      if (!this.channels[name]) {
        this.channels[name] = new PusherChannel(this.pusher, name, this.options);
      }

      return this.channels[name];
    }
    /**
     * Get a private channel instance by name.
     */

  }, {
    key: "privateChannel",
    value: function privateChannel(name) {
      if (!this.channels['private-' + name]) {
        this.channels['private-' + name] = new PusherPrivateChannel(this.pusher, 'private-' + name, this.options);
      }

      return this.channels['private-' + name];
    }
    /**
     * Get a private encrypted channel instance by name.
     */

  }, {
    key: "encryptedPrivateChannel",
    value: function encryptedPrivateChannel(name) {
      if (!this.channels['private-encrypted-' + name]) {
        this.channels['private-encrypted-' + name] = new PusherEncryptedPrivateChannel(this.pusher, 'private-encrypted-' + name, this.options);
      }

      return this.channels['private-encrypted-' + name];
    }
    /**
     * Get a presence channel instance by name.
     */

  }, {
    key: "presenceChannel",
    value: function presenceChannel(name) {
      if (!this.channels['presence-' + name]) {
        this.channels['presence-' + name] = new PusherPresenceChannel(this.pusher, 'presence-' + name, this.options);
      }

      return this.channels['presence-' + name];
    }
    /**
     * Leave the given channel, as well as its private and presence variants.
     */

  }, {
    key: "leave",
    value: function leave(name) {
      var _this2 = this;

      var channels = [name, 'private-' + name, 'private-encrypted-' + name, 'presence-' + name];
      channels.forEach(function (name, index) {
        _this2.leaveChannel(name);
      });
    }
    /**
     * Leave the given channel.
     */

  }, {
    key: "leaveChannel",
    value: function leaveChannel(name) {
      if (this.channels[name]) {
        this.channels[name].unsubscribe();
        delete this.channels[name];
      }
    }
    /**
     * Get the socket ID for the connection.
     */

  }, {
    key: "socketId",
    value: function socketId() {
      return this.pusher.connection.socket_id;
    }
    /**
     * Disconnect Pusher connection.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      this.pusher.disconnect();
    }
  }]);

  return PusherConnector;
}(Connector);

/**
 * This class creates a connnector to a Socket.io server.
 */

var SocketIoConnector = /*#__PURE__*/function (_Connector) {
  _inherits(SocketIoConnector, _Connector);

  var _super = _createSuper(SocketIoConnector);

  function SocketIoConnector() {
    var _this;

    _classCallCheck(this, SocketIoConnector);

    _this = _super.apply(this, arguments);
    /**
     * All of the subscribed channel names.
     */

    _this.channels = {};
    return _this;
  }
  /**
   * Create a fresh Socket.io connection.
   */


  _createClass(SocketIoConnector, [{
    key: "connect",
    value: function connect() {
      var _this2 = this;

      var io = this.getSocketIO();
      this.socket = io(this.options.host, this.options);
      this.socket.on('reconnect', function () {
        Object.values(_this2.channels).forEach(function (channel) {
          channel.subscribe();
        });
      });
      return this.socket;
    }
    /**
     * Get socket.io module from global scope or options.
     */

  }, {
    key: "getSocketIO",
    value: function getSocketIO() {
      if (typeof this.options.client !== 'undefined') {
        return this.options.client;
      }

      if (typeof io !== 'undefined') {
        return io;
      }

      throw new Error('Socket.io client not found. Should be globally available or passed via options.client');
    }
    /**
     * Listen for an event on a channel instance.
     */

  }, {
    key: "listen",
    value: function listen(name, event, callback) {
      return this.channel(name).listen(event, callback);
    }
    /**
     * Get a channel instance by name.
     */

  }, {
    key: "channel",
    value: function channel(name) {
      if (!this.channels[name]) {
        this.channels[name] = new SocketIoChannel(this.socket, name, this.options);
      }

      return this.channels[name];
    }
    /**
     * Get a private channel instance by name.
     */

  }, {
    key: "privateChannel",
    value: function privateChannel(name) {
      if (!this.channels['private-' + name]) {
        this.channels['private-' + name] = new SocketIoPrivateChannel(this.socket, 'private-' + name, this.options);
      }

      return this.channels['private-' + name];
    }
    /**
     * Get a presence channel instance by name.
     */

  }, {
    key: "presenceChannel",
    value: function presenceChannel(name) {
      if (!this.channels['presence-' + name]) {
        this.channels['presence-' + name] = new SocketIoPresenceChannel(this.socket, 'presence-' + name, this.options);
      }

      return this.channels['presence-' + name];
    }
    /**
     * Leave the given channel, as well as its private and presence variants.
     */

  }, {
    key: "leave",
    value: function leave(name) {
      var _this3 = this;

      var channels = [name, 'private-' + name, 'presence-' + name];
      channels.forEach(function (name) {
        _this3.leaveChannel(name);
      });
    }
    /**
     * Leave the given channel.
     */

  }, {
    key: "leaveChannel",
    value: function leaveChannel(name) {
      if (this.channels[name]) {
        this.channels[name].unsubscribe();
        delete this.channels[name];
      }
    }
    /**
     * Get the socket ID for the connection.
     */

  }, {
    key: "socketId",
    value: function socketId() {
      return this.socket.id;
    }
    /**
     * Disconnect Socketio connection.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      this.socket.disconnect();
    }
  }]);

  return SocketIoConnector;
}(Connector);

/**
 * This class creates a null connector.
 */

var NullConnector = /*#__PURE__*/function (_Connector) {
  _inherits(NullConnector, _Connector);

  var _super = _createSuper(NullConnector);

  function NullConnector() {
    var _this;

    _classCallCheck(this, NullConnector);

    _this = _super.apply(this, arguments);
    /**
     * All of the subscribed channel names.
     */

    _this.channels = {};
    return _this;
  }
  /**
   * Create a fresh connection.
   */


  _createClass(NullConnector, [{
    key: "connect",
    value: function connect() {//
    }
    /**
     * Listen for an event on a channel instance.
     */

  }, {
    key: "listen",
    value: function listen(name, event, callback) {
      return new NullChannel();
    }
    /**
     * Get a channel instance by name.
     */

  }, {
    key: "channel",
    value: function channel(name) {
      return new NullChannel();
    }
    /**
     * Get a private channel instance by name.
     */

  }, {
    key: "privateChannel",
    value: function privateChannel(name) {
      return new NullPrivateChannel();
    }
    /**
     * Get a private encrypted channel instance by name.
     */

  }, {
    key: "encryptedPrivateChannel",
    value: function encryptedPrivateChannel(name) {
      return new NullPrivateChannel();
    }
    /**
     * Get a presence channel instance by name.
     */

  }, {
    key: "presenceChannel",
    value: function presenceChannel(name) {
      return new NullPresenceChannel();
    }
    /**
     * Leave the given channel, as well as its private and presence variants.
     */

  }, {
    key: "leave",
    value: function leave(name) {//
    }
    /**
     * Leave the given channel.
     */

  }, {
    key: "leaveChannel",
    value: function leaveChannel(name) {//
    }
    /**
     * Get the socket ID for the connection.
     */

  }, {
    key: "socketId",
    value: function socketId() {
      return 'fake-socket-id';
    }
    /**
     * Disconnect the connection.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {//
    }
  }]);

  return NullConnector;
}(Connector);

/**
 * This class is the primary API for interacting with broadcasting.
 */

var Echo = /*#__PURE__*/function () {
  /**
   * Create a new class instance.
   */
  function Echo(options) {
    _classCallCheck(this, Echo);

    this.options = options;
    this.connect();

    if (!this.options.withoutInterceptors) {
      this.registerInterceptors();
    }
  }
  /**
   * Get a channel instance by name.
   */


  _createClass(Echo, [{
    key: "channel",
    value: function channel(_channel) {
      return this.connector.channel(_channel);
    }
    /**
     * Create a new connection.
     */

  }, {
    key: "connect",
    value: function connect() {
      if (this.options.broadcaster == 'pusher') {
        this.connector = new PusherConnector(this.options);
      } else if (this.options.broadcaster == 'socket.io') {
        this.connector = new SocketIoConnector(this.options);
      } else if (this.options.broadcaster == 'null') {
        this.connector = new NullConnector(this.options);
      } else if (typeof this.options.broadcaster == 'function') {
        this.connector = new this.options.broadcaster(this.options);
      }
    }
    /**
     * Disconnect from the Echo server.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      this.connector.disconnect();
    }
    /**
     * Get a presence channel instance by name.
     */

  }, {
    key: "join",
    value: function join(channel) {
      return this.connector.presenceChannel(channel);
    }
    /**
     * Leave the given channel, as well as its private and presence variants.
     */

  }, {
    key: "leave",
    value: function leave(channel) {
      this.connector.leave(channel);
    }
    /**
     * Leave the given channel.
     */

  }, {
    key: "leaveChannel",
    value: function leaveChannel(channel) {
      this.connector.leaveChannel(channel);
    }
    /**
     * Leave all channels.
     */

  }, {
    key: "leaveAllChannels",
    value: function leaveAllChannels() {
      for (var channel in this.connector.channels) {
        this.leaveChannel(channel);
      }
    }
    /**
     * Listen for an event on a channel instance.
     */

  }, {
    key: "listen",
    value: function listen(channel, event, callback) {
      return this.connector.listen(channel, event, callback);
    }
    /**
     * Get a private channel instance by name.
     */

  }, {
    key: "private",
    value: function _private(channel) {
      return this.connector.privateChannel(channel);
    }
    /**
     * Get a private encrypted channel instance by name.
     */

  }, {
    key: "encryptedPrivate",
    value: function encryptedPrivate(channel) {
      return this.connector.encryptedPrivateChannel(channel);
    }
    /**
     * Get the Socket ID for the connection.
     */

  }, {
    key: "socketId",
    value: function socketId() {
      return this.connector.socketId();
    }
    /**
     * Register 3rd party request interceptiors. These are used to automatically
     * send a connections socket id to a Laravel app with a X-Socket-Id header.
     */

  }, {
    key: "registerInterceptors",
    value: function registerInterceptors() {
      if (typeof Vue === 'function' && Vue.http) {
        this.registerVueRequestInterceptor();
      }

      if (typeof axios === 'function') {
        this.registerAxiosRequestInterceptor();
      }

      if (typeof jQuery === 'function') {
        this.registerjQueryAjaxSetup();
      }

      if ((typeof Turbo === "undefined" ? "undefined" : _typeof(Turbo)) === 'object') {
        this.registerTurboRequestInterceptor();
      }
    }
    /**
     * Register a Vue HTTP interceptor to add the X-Socket-ID header.
     */

  }, {
    key: "registerVueRequestInterceptor",
    value: function registerVueRequestInterceptor() {
      var _this = this;

      Vue.http.interceptors.push(function (request, next) {
        if (_this.socketId()) {
          request.headers.set('X-Socket-ID', _this.socketId());
        }

        next();
      });
    }
    /**
     * Register an Axios HTTP interceptor to add the X-Socket-ID header.
     */

  }, {
    key: "registerAxiosRequestInterceptor",
    value: function registerAxiosRequestInterceptor() {
      var _this2 = this;

      axios.interceptors.request.use(function (config) {
        if (_this2.socketId()) {
          config.headers['X-Socket-Id'] = _this2.socketId();
        }

        return config;
      });
    }
    /**
     * Register jQuery AjaxPrefilter to add the X-Socket-ID header.
     */

  }, {
    key: "registerjQueryAjaxSetup",
    value: function registerjQueryAjaxSetup() {
      var _this3 = this;

      if (typeof jQuery.ajax != 'undefined') {
        jQuery.ajaxPrefilter(function (options, originalOptions, xhr) {
          if (_this3.socketId()) {
            xhr.setRequestHeader('X-Socket-Id', _this3.socketId());
          }
        });
      }
    }
    /**
     * Register the Turbo Request interceptor to add the X-Socket-ID header.
     */

  }, {
    key: "registerTurboRequestInterceptor",
    value: function registerTurboRequestInterceptor() {
      var _this4 = this;

      document.addEventListener('turbo:before-fetch-request', function (event) {
        event.detail.fetchOptions.headers['X-Socket-Id'] = _this4.socketId();
      });
    }
  }]);

  return Echo;
}();



// EXTERNAL MODULE: ./node_modules/pusher-js/dist/web/pusher.js
var pusher = __webpack_require__(86606);
var pusher_default = /*#__PURE__*/__webpack_require__.n(pusher);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./contexts/ChannelsContext.js









var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var wsHost = publicRuntimeConfig.host;
var wsPort = 80;
var forceTLS = true;
var newChannels = null;
var privateChannels = null;
var newAuthToken = null;
var pusherConfig = {
  key: 'app',
  cluster: 'mt1',
  authEndpoint: (forceTLS ? 'https' : 'http') + "://".concat(wsHost, "/api/broadcasting/auth")
};
var ChannelsContext = /*#__PURE__*/react.createContext(undefined);

var getChannels = function getChannels(pusherConfig, authToken, dispatch, setChannels) {
  if (newChannels) {
    return newChannels;
  }

  var client = new (pusher_default())(pusherConfig.key, {
    cluster: pusherConfig.cluster,
    forceTLS: forceTLS,
    authEndpoint: pusherConfig.authEndpoint,
    auth: authToken ? {
      headers: {
        Authorization: "Bearer ".concat(authToken)
      }
    } : undefined,
    wsHost: wsHost,
    pongTimeout: 10000,
    activityTimeout: 10000,
    wsPort: wsPort
  });
  client.connection.bind('connected', function () {
    privateChannels = null;
    dispatch((0,sessionSlice/* createSocketId */.g1)({
      socketId: newChannels.socketId()
    }));
  });
  client.connection.bind('state_change', function (state) {
    console.log('Connection state', state);

    if (state.current === 'disconnected') {
      if (document.hidden) {
        window.location.reload();
      } else {
        setTimeout(function () {
          var reconnectedChannels = getChannels(pusherConfig, newAuthToken, dispatch, setChannels);
          setChannels(reconnectedChannels);
        }, 3000);
      }
    }
  });
  newChannels = new Echo({
    broadcaster: 'pusher',
    client: client
  });
  return newChannels;
};

var useChannels = function useChannels() {
  var channels = react.useContext(ChannelsContext);
  return channels;
};
var usePrivateChannels = function usePrivateChannels(authUserId, dispatch) {
  var channels = useChannels();

  if (!authUserId) {
    return;
  }

  if (privateChannels) {
    return privateChannels;
  }

  privateChannels = channels && channels.private('session.' + authUserId).subscribed(function () {
    dispatch((0,sessionSlice/* subscribedChannel */.P6)());
  });
  return privateChannels;
};
var ChannelsProvider = function ChannelsProvider(_ref) {
  var children = _ref.children,
      authUser = _ref.authUser,
      authToken = _ref.authToken;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(undefined),
      channels = _useState[0],
      setChannels = _useState[1];

  var sessionID = (0,es/* useSelector */.v9)(store/* sessionIdSelector */.c9);
  (0,react.useEffect)(function () {
    if (sessionID) {
      privateChannels = null;
    }
  }, [sessionID]);
  (0,react.useEffect)(function () {
    setTimeout(function () {
      if (newAuthToken !== authToken) {
        newChannels = null;
        newAuthToken = authToken;
      }

      var channels = getChannels(pusherConfig, authToken, dispatch, setChannels);
      setChannels(channels);
    }, 0);
  }, [authUser, authToken]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ChannelsContext.Provider, {
    value: channels,
    children: children
  });
};

/***/ }),

/***/ 78755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useHost; },
/* harmony export */   "T": function() { return /* binding */ HostProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var HostContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
var HostProvider = function HostProvider(_ref) {
  var host = _ref.host,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HostContext.Provider, {
    value: host,
    children: children
  });
};
var useHost = function useHost() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HostContext);
};

/***/ }),

/***/ 73682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ NavProvider; },
/* harmony export */   "Y": function() { return /* binding */ useNav; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var no_scroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70743);
/* harmony import */ var no_scroll__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(no_scroll__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */



var NavContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var NavProvider = function NavProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    menu: false,
    mobileNav: false,
    mobileFilter: false,
    mobileSort: false,
    mobileUserNav: false
  }),
      visibility = _useState[0],
      setVisibility = _useState[1];

  var toggleVisibility = function toggleVisibility(item) {
    return function (cb) {
      var shouldToggleScroll = true;
      setVisibility(function (prevState) {
        var newState = Object.keys(prevState).reduce(function (acc, key) {
          if (prevState[key] && key !== item) {
            shouldToggleScroll = false;
          }

          if (key === item) {
            acc[key] = !acc[key];
            return acc;
          }

          acc[key] = false;
          return acc;
        }, _objectSpread({}, prevState));
        if (shouldToggleScroll) no_scroll__WEBPACK_IMPORTED_MODULE_2___default().toggle(); // if (cb) cb?.(newState[item]);

        return _objectSpread(_objectSpread({}, prevState), newState);
      });
    };
  };

  var toggleMenu = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(toggleVisibility('menu'), [visibility.menu]);
  var toggleMobileNav = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(toggleVisibility('mobileNav'), [visibility.mobileNav]);
  var toggleMobileFilter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(toggleVisibility('mobileFilter'), [visibility.mobileFilter]);
  var toggleMobileSort = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(toggleVisibility('mobileSort'), [visibility.mobileSort]);
  var toggleMobileUserNav = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(toggleVisibility('mobileUserNav'), [visibility.mobileUserNav]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(NavContext.Provider, {
    /* eslint-disable-next-line react/jsx-no-constructed-context-values */
    value: {
      visibility: visibility,
      toggleMenu: toggleMenu,
      toggleMobileNav: toggleMobileNav,
      toggleMobileFilter: toggleMobileFilter,
      toggleMobileSort: toggleMobileSort,
      toggleMobileUserNav: toggleMobileUserNav
    },
    children: children
  });
};
var useNav = function useNav() {
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(NavContext);
};

/***/ }),

/***/ 64318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ NotificationProvider; },
/* harmony export */   "l": function() { return /* binding */ useNotification; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53416);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var NotificationContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();

var getNotificationConfig = function getNotificationConfig(config) {
  var _config$closable;

  return {
    content: config.content || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
    id: config.id || (0,nanoid__WEBPACK_IMPORTED_MODULE_2__/* .nanoid */ .x0)(),
    closable: (_config$closable = config.closable) !== null && _config$closable !== void 0 ? _config$closable : true,
    onClose: config.onClose || null,
    duration: config.duration || null,
    style: config.style || 'error' // 'error' || 'warning'

  };
};

var NotificationProvider = function NotificationProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      notifications = _useState[0],
      setNotifications = _useState[1];

  var close = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (id) {
    var onClose = null;
    setNotifications(function (prev) {
      return prev.filter(function (item) {
        if (item.id === id) {
          onClose = item.onClose;
          return false;
        }

        return true;
      });
    });
    if (onClose) onClose();
  }, []);
  var add = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (config) {
    var cfg = getNotificationConfig(config);

    if (cfg.duration) {
      setTimeout(function () {
        close(cfg.id);
      }, cfg.duration);
    }

    setNotifications(function (prev) {
      return [].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(prev), [cfg]);
    });
  }, [close]);
  return (
    /*#__PURE__*/

    /* eslint-disable-next-line react/jsx-no-constructed-context-values */
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NotificationContext.Provider, {
      value: {
        list: notifications,
        add: add,
        close: close
      },
      children: children
    })
  );
};
var useNotification = function useNotification() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(NotificationContext);
};

/***/ }),

/***/ 84431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nr": function() { return /* reexport */ hooks_useDebounce; },
  "_": function() { return /* reexport */ use_local_storage/* default */.Z; },
  "iJ": function() { return /* reexport */ hooks_useVisibility; },
  "iP": function() { return /* reexport */ use_window_size/* default */.Z; }
});

// UNUSED EXPORTS: useEventListener

// EXTERNAL MODULE: ./hooks/use-event-listener.js
var use_event_listener = __webpack_require__(10428);
// EXTERNAL MODULE: ./hooks/use-window-size.js
var use_window_size = __webpack_require__(55876);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useDebounce.js


var useDebounce = function useDebounce(value, delay) {
  var _useState = (0,react.useState)(value),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  (0,react.useEffect)(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

/* harmony default export */ var hooks_useDebounce = (useDebounce);
// EXTERNAL MODULE: ./hooks/use-local-storage.js
var use_local_storage = __webpack_require__(34670);
;// CONCATENATED MODULE: ./hooks/useVisibility.js


var useVisibility = function useVisibility(triggerRef) {
  var _useState = (0,react.useState)(false),
      visible = _useState[0],
      setVisible = _useState[1];

  (0,react.useEffect)(function () {
    var observer;
    var didCancel = false;

    if (triggerRef) {
      if (IntersectionObserver) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!didCancel && !entry.isIntersecting) {
              setVisible(true);
            }

            if (!didCancel && entry.isIntersecting) {
              setVisible(false);
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px'
        });
        observer.observe(triggerRef);
      } else {
        setVisible(true);
      }
    }

    return function () {
      didCancel = true;

      if (observer && observer.unobserve) {
        observer.unobserve(triggerRef);
      }
    };
  }, [setVisible, triggerRef]);
  return {
    visible: visible
  };
};

/* harmony default export */ var hooks_useVisibility = (useVisibility);
;// CONCATENATED MODULE: ./hooks/index.js






/***/ }),

/***/ 10428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useEventListener = function useEventListener(eventName, handler, element, options) {
  var storedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    storedCallback.current = handler;
  }, [handler]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var isSupported = element && element.addEventListener;

    if (!isSupported) {
      return;
    }

    var eventListener = function eventListener(event) {
      return storedCallback.current && storedCallback.current(event);
    };

    element.addEventListener(eventName, eventListener, options);
    return function () {
      element.removeEventListener(eventName, eventListener, options);
    };
  }, [eventName, element, options]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useEventListener);

/***/ }),

/***/ 34670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useLocalStorage = function useLocalStorage(key, initialValue) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
    if (false) {}

    try {
      var item = window.localStorage.getItem(key);

      if (item) {
        return typeof initialValue === 'string' ? item : JSON.parse(item);
      }

      return initialValue;
    } catch (error) {
      console.warn(error);
      return initialValue;
    }
  }),
      storedValue = _useState[0],
      setStoredValue = _useState[1];

  var setValue = function setValue(value) {
    try {
      var valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);

      if (true) {
        window.localStorage.setItem(key, typeof valueToStore === 'string' ? valueToStore : JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.log(error);
    }
  };

  return [storedValue, setValue];
};

/* harmony default export */ __webpack_exports__["Z"] = (useLocalStorage);

/***/ }),

/***/ 55876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_event_listener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10428);


var FPS = 1000 / 60;
var initialWindowWidth = 9999;

var useWindowSize = function useWindowSize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)( true ? window.innerWidth : 0),
      windowWidth = _useState[0],
      setWindowWidth = _useState[1];

  var lastUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(Date.now());
  var raf = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  var handleResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (false) {}

    if (Date.now() - lastUpdate.current < FPS) {
      raf.current = requestAnimationFrame(handleResize);
      return;
    }

    cancelAnimationFrame(raf.current);
    document.documentElement.style.setProperty('--vh', "".concat(window.innerHeight / 100, "px"));
    setWindowWidth(window.innerWidth || 0);
    lastUpdate.current = Date.now();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    handleResize();
  }, [handleResize]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if ( true && window.innerWidth !== windowWidth) {
      setWindowWidth(window.innerWidth);
    }
  }, [windowWidth]);
  (0,_use_event_listener__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('resize', handleResize,  true ? window : 0);
  var isSmallMobile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth <= 500;
  }, [windowWidth]);
  var isCollectionMobile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth <= 650;
  }, [windowWidth]);
  var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth <= 767;
  }, [windowWidth]);
  var isMobileTablet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth <= 768;
  }, [windowWidth]);
  var isMobileMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth <= 1024;
  }, [windowWidth]);
  var isSmallTablet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth >= 768 && windowWidth < 883;
  }, [windowWidth]);
  var isLaptop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth >= 768 && windowWidth <= 1024;
  }, [windowWidth]);
  var isTablet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth >= 768 && windowWidth < 1280;
  }, [windowWidth]);
  var isDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return windowWidth >= 1280;
  }, [windowWidth]);
  var isWidthForSnowflakesCount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return isTablet || windowWidth < 650 && windowWidth > 520 || windowWidth >= 1440;
  }, [windowWidth, isTablet]);
  return {
    isDesktop: isDesktop,
    isTablet: isTablet,
    isMobile: isMobile,
    isSmallMobile: isSmallMobile,
    isMobileTablet: isMobileTablet,
    isSmallTablet: isSmallTablet,
    isCollectionMobile: isCollectionMobile,
    isLaptop: isLaptop,
    windowWidth: windowWidth,
    isMobileMenu: isMobileMenu,
    initialWindowWidth: initialWindowWidth,
    isWidthForSnowflakesCount: isWidthForSnowflakesCount
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);

/***/ }),

/***/ 75842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* reexport */ layouts_CartPage; },
  "h4": function() { return /* reexport */ layouts_CatalogPage; },
  "Xs": function() { return /* reexport */ layouts_LoginPage; },
  "T3": function() { return /* reexport */ layouts_Page; },
  "KC": function() { return /* reexport */ layouts_Scripts; },
  "xU": function() { return /* reexport */ layouts_TextPage; },
  "lU": function() { return /* reexport */ layouts_WishlistPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/cartSlice.js
var cartSlice = __webpack_require__(78955);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/currencySlice.js
var currencySlice = __webpack_require__(74542);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./containers/index.js + 33 modules
var containers = __webpack_require__(21341);
// EXTERNAL MODULE: ./seo/Mindbox.js
var Mindbox = __webpack_require__(22182);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./contexts/ChannelsContext.js + 1 modules
var ChannelsContext = __webpack_require__(53013);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./layouts/CartPage/CartPage.module.scss
var CartPage_module = __webpack_require__(75247);
var CartPage_module_default = /*#__PURE__*/__webpack_require__.n(CartPage_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./layouts/CartPage/CartPage.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var Cart = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1831).then(__webpack_require__.bind(__webpack_require__, 41831));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(41831)];
    }
  }
});
var events = {
  CART_REFRESH: 'SessionCartRefreshEvent',
  CART_UNAVAILABLE: 'SessionCartChangeUnavailableEvent'
};

var getProducts = function getProducts(firstProducts, secondProducts) {
  return firstProducts.map(function (product) {
    for (var i = 0; i < secondProducts.length; i++) {
      if (product.external_id === secondProducts[i].external_id) {
        return _objectSpread(_objectSpread({}, product), secondProducts[i]);
      }
    }

    return null;
  }).filter(function (product) {
    return product != null;
  });
};

var CartPage = function CartPage() {
  var cart = (0,es/* useSelector */.v9)(cartSlice/* getCartData */.TW);
  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);
  var cartItemsQuantity = (0,es/* useSelector */.v9)(store/* cartCountSelector */.Ri);
  var isSubscribedChannel = (0,es/* useSelector */.v9)(store/* sessionIsSubscribedChannel */.t9);
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(true),
      totalAmount = _useState[0],
      setTotalAmount = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(10),
      seconds = _useState3[0],
      setSeconds = _useState3[1];

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'cart'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 3),
      cartHref = _getLinkProps2[0],
      _cartAs = _getLinkProps2[1],
      cartTitle = _getLinkProps2[2];

  var breadCrumbsCart = [{
    slug: cartHref,
    name: cartTitle
  }];
  var isEmpty = cart.data.products.length === 0;
  var isLoading = cart.firstLoading;
  var sessionID = (0,es/* useSelector */.v9)(store/* sessionIdSelector */.c9);
  var channels = (0,ChannelsContext/* usePrivateChannels */.yN)(sessionID, dispatch);
  var refreshCart = (0,react.useCallback)(function (e) {
    setLoading(true);
    dispatch((0,cartSlice/* fetchCart */.x7)());
  }, [dispatch]);
  var onChange = (0,react.useCallback)(function (e) {
    if (!cart.loading) {
      var _e$cart$products, _cart$data$products;

      if (((_e$cart$products = e.cart.products) === null || _e$cart$products === void 0 ? void 0 : _e$cart$products.length) > ((_cart$data$products = cart.data.products) === null || _cart$data$products === void 0 ? void 0 : _cart$data$products.length)) {
        refreshCart();
      }

      var newCartData = _objectSpread(_objectSpread(_objectSpread({}, cart.data), e.cart), {}, {
        products: getProducts(cart.data.products, e.cart.products),
        count: cartItemsQuantity
      });

      dispatch((0,cartSlice/* setNewCartData */.Ko)(newCartData));
      setLoading(false);
    }
  }, [dispatch, cart, cartItemsQuantity, refreshCart]);
  (0,react.useEffect)(function () {
    if (true) {
      setTimeout(function () {
        var cartId = localStorage.getItem('cartId');

        if (!cartId) {
          localStorage.setItem('cartId', Math.random().toString().slice(2));
        }
      }, 0);
    }
  }, []);
  (0,react.useEffect)(function () {
    if (channels) {
      channels.listen(".".concat(events.CART_REFRESH), onChange);
      channels.listen(".".concat(events.CART_UNAVAILABLE), refreshCart);
      return function () {
        channels.stopListening(".".concat(events.CART_REFRESH));
        channels.stopListening(".".concat(events.CART_UNAVAILABLE));
      };
    }
  }, [channels, onChange, refreshCart]);
  (0,react.useEffect)(function () {
    if (isEmpty) {
      modules/* animateScroll.scrollToTop */.NY.scrollToTop();
    }
  }, [isEmpty]);

  var handleCartRefreshTimeout = function handleCartRefreshTimeout() {
    setLoading(false);
  };

  (0,react.useEffect)(function () {
    if (loading) {
      if (seconds > 0) {
        var timer = setTimeout(function () {
          setSeconds(seconds - 1);
        }, 1000);
        return function () {
          return clearTimeout(timer);
        };
      }

      handleCartRefreshTimeout();
    } else {
      setSeconds(10);
    }
  }, [seconds, loading, dispatch, cart.loading]);
  (0,react.useEffect)(function () {
    if (sessionID && isSubscribedChannel) {
      Mindbox/* default.viewPage */.ZP.viewPage({
        page: 'Cart'
      });
      setLoading(true);
      dispatch((0,cartSlice/* fetchCart */.x7)({
        onSuccess: function onSuccess() {
          dispatch((0,sessionSlice/* createSession */.ed)(true, undefined, {
            forceRefresh: true
          }));
        }
      }));
    }
  }, [sessionID, isSubscribedChannel, dispatch]);
  (0,react.useEffect)(function () {
    setTimeout(function () {
      if (cart && cart.data && cart.data.total_amount_with_discount && totalAmount && totalAmount !== cart.data.total_amount_with_discount) {
        Ecommerce/* default.viewItemList */.ZP.viewItemList(cart.data.products.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            external_id: item.model.slug
          });
        }), currency, 'Корзина', 'view_cart', null, cart.data.total_amount_with_discount);
        setTotalAmount(cart.data.total_amount_with_discount);
      }
    }, 0);
  }, [cart.data, totalAmount, currency]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (CartPage_module_default()).cartSection,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CartPage_module_default()).breadCrumbs,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
          type: "cart",
          breadcrumbs: breadCrumbsCart
        })
      })
    }), !isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      className: (0,clsx_m/* default */.Z)(isEmpty && (CartPage_module_default()).cartContainer),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, _objectSpread(_objectSpread({
        mb: "large",
        component: "h1"
      }, isEmpty ? {
        align: 'center'
      } : {
        align: 'left'
      }), {}, {
        className: (CartPage_module_default()).title,
        children: isEmpty ? 'В корзине нет товаров' : 'Корзина'
      })), isEmpty ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* PageText */.E3, {
          className: (CartPage_module_default()).emptyText,
          children: "\u041F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u044B \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438 \u0437\u0430\u043A\u0430\u0437\u0435 \u0447\u0435\u0440\u0435\u0437 \u043D\u0430\u0448 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u043C\u0430\u0433\u0430\u0437\u0438\u043D."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          as: "/",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
            type: "primary",
            children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Cart, _objectSpread(_objectSpread({}, cart), {}, {
        loading: loading,
        setLoading: setLoading
      }))]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {
      visible: true
    })]
  });
};

/* harmony default export */ var CartPage_CartPage = (CartPage);
;// CONCATENATED MODULE: ./layouts/CartPage/index.js

/* harmony default export */ var layouts_CartPage = (CartPage_CartPage);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/categoriesSlice.js
var categoriesSlice = __webpack_require__(11012);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/catalogSlice.js
var catalogSlice = __webpack_require__(35955);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/viewedSlice.js
var viewedSlice = __webpack_require__(89780);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./lib/handleError.js
var handleError = __webpack_require__(67408);
// EXTERNAL MODULE: ./utils/index.js + 3 modules
var utils = __webpack_require__(70214);
// EXTERNAL MODULE: ./hooks/index.js + 2 modules
var hooks = __webpack_require__(84431);
// EXTERNAL MODULE: ./seo/PopMechanicData.js
var PopMechanicData = __webpack_require__(76671);
// EXTERNAL MODULE: ./contexts/NavContext.js
var NavContext = __webpack_require__(73682);
// EXTERNAL MODULE: ./seo/JsonLd.js
var JsonLd = __webpack_require__(37286);
// EXTERNAL MODULE: ./lib/wordEnd.js
var wordEnd = __webpack_require__(62547);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./layouts/CatalogPage/CatalogPage.module.scss
var CatalogPage_module = __webpack_require__(16179);
var CatalogPage_module_default = /*#__PURE__*/__webpack_require__.n(CatalogPage_module);
;// CONCATENATED MODULE: ./layouts/CatalogPage/CatalogPageView.js


function CatalogPageView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CatalogPageView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CatalogPageView_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CatalogPageView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ScrollBtn = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 885).then(__webpack_require__.bind(__webpack_require__, 40885));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(40885)];
    }
  }
});
var AppliedFilters = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1316).then(__webpack_require__.bind(__webpack_require__, 51316));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(51316)];
    }
  }
});
var SelectSort = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2125).then(__webpack_require__.bind(__webpack_require__, 52125));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(52125)];
    }
  }
});
var Filters = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3776).then(__webpack_require__.bind(__webpack_require__, 3776));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(3776)];
    }
  }
});
var Products = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4352).then(__webpack_require__.bind(__webpack_require__, 14352));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(14352)];
    }
  }
});
var Pagination = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4436).then(__webpack_require__.bind(__webpack_require__, 64436));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(64436)];
    }
  }
});
var CategoryTree = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8046).then(__webpack_require__.bind(__webpack_require__, 98046));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(98046)];
    }
  }
});
var Viewed = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7710).then(__webpack_require__.bind(__webpack_require__, 47710));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(47710)];
    }
  }
});
var TagsRow = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2344).then(__webpack_require__.bind(__webpack_require__, 62344));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(62344)];
    }
  }
});

var CatalogMobileFilters = function CatalogMobileFilters(props) {
  var _useNav = (0,NavContext/* useNav */.Y)(),
      visibility = _useNav.visibility,
      toggleMobileFilter = _useNav.toggleMobileFilter;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MobileFilters */.z, CatalogPageView_objectSpread(CatalogPageView_objectSpread({}, props), {}, {
    visibility: visibility.mobileFilter,
    toggleMobileFilter: toggleMobileFilter
  }));
};

var CatalogMobileSort = function CatalogMobileSort(props) {
  var _useNav2 = (0,NavContext/* useNav */.Y)(),
      visibility = _useNav2.visibility,
      toggleMobileSort = _useNav2.toggleMobileSort;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MobileSort */.oD, CatalogPageView_objectSpread(CatalogPageView_objectSpread({}, props), {}, {
    visibility: visibility.mobileSort,
    toggleMobileSort: toggleMobileSort
  }));
};

var CatalogPageView = function CatalogPageView(_ref) {
  var _products$, _meta$total, _meta$total2, _meta$total3;

  var metaTitle = _ref.metaTitle,
      categoryTitle = _ref.categoryTitle,
      metaDescription = _ref.metaDescription,
      seo = _ref.seo,
      ogTitle = _ref.ogTitle,
      ogDescription = _ref.ogDescription,
      ogImageRect = _ref.ogImageRect,
      ogImageSquare = _ref.ogImageSquare,
      meta = _ref.meta,
      state = _ref.state,
      isBrandsCategory = _ref.isBrandsCategory,
      savedSort = _ref.savedSort,
      newSelectedSorting = _ref.newSelectedSorting,
      filters = _ref.filters,
      newSelectedFilters = _ref.newSelectedFilters,
      handleChange = _ref.handleChange,
      loadingProducts = _ref.loadingProducts,
      loadingFilters = _ref.loadingFilters,
      isDesktop = _ref.isDesktop,
      blocks = _ref.blocks,
      page = _ref.page,
      sortFields = _ref.sortFields,
      currency = _ref.currency,
      storageCurrency = _ref.storageCurrency,
      products = _ref.products,
      loadingCategory = _ref.loadingCategory,
      isSafari = _ref.isSafari,
      history = _ref.history,
      setFirstProductId = _ref.setFirstProductId,
      firstProductId = _ref.firstProductId,
      textBlock = _ref.textBlock,
      newProductsLoading = _ref.newProductsLoading;
  var ref = (0,react.useRef)(null);
  var breadcrumbs = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CatalogPage_module_default()).breadCrumbs,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
        breadcrumbs: state.breadcrumbs
      })
    });
  }, [state.breadcrumbs]);
  var tags = (0,react.useMemo)(function () {
    return state.tags && state.tags.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CatalogPage_module_default()).tags,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagsRow, {
        tags: state.tags,
        parentId: state.current.id
      })
    }) : null;
  }, [state.tags, state.current]);
  var textBlockUI = (0,react.useMemo)(function () {
    return textBlock && page === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CatalogPage_module_default()).seo,
      dangerouslySetInnerHTML: {
        __html: textBlock
      }
    }) : null;
  }, [textBlock, page]);
  (0,react.useEffect)(function () {
    var _ref$current;

    ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }, [state.sidebar]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* MetaData */.U4, CatalogPageView_objectSpread({
      title: metaTitle || categoryTitle,
      description: metaDescription,
      seo: seo,
      ogTitle: ogTitle,
      ogDescription: ogDescription,
      image: ogImageRect,
      imageSmall: ogImageSquare,
      type: "product.group",
      withPage: true // eslint-disable-next-line no-unsafe-optional-chaining

    }, +(meta === null || meta === void 0 ? void 0 : meta.total) === 0 && {
      robotsContent: 'noindex, follow'
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(JsonLd/* JsonLdData */.j, {
      category: state.current,
      totalProducts: meta === null || meta === void 0 ? void 0 : meta.total
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CatalogPage_module_default()).page,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
        children: [breadcrumbs, !!(blocks !== null && blocks !== void 0 && blocks.length) && page === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Blocks */.no, {
          blocks: blocks,
          isCatalog: true
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (CatalogPage_module_default()).header,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (CatalogPage_module_default()).left,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
              component: "h1",
              className: (CatalogPage_module_default()).title,
              dataBrand: isBrandsCategory && products !== null && products !== void 0 && products.length ? (_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.brand : null,
              "data-test": "h1",
              children: seo && seo.h1 ? (0,utils/* getCorrectName */.tx)(seo.h1) : categoryTitle
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Text */.xv, {
              className: (CatalogPage_module_default()).productsQuantity,
              children: +((_meta$total = meta === null || meta === void 0 ? void 0 : meta.total) !== null && _meta$total !== void 0 ? _meta$total : 0) > 0 ? "".concat(meta.total, " ").concat((0,wordEnd/* default */.Z)(+((_meta$total2 = meta === null || meta === void 0 ? void 0 : meta.total) !== null && _meta$total2 !== void 0 ? _meta$total2 : 0), ['товар', 'товара', 'товаров'])) : 'Ничего не найдено'
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (CatalogPage_module_default()).right,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
              name: "sort"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (CatalogPage_module_default()).sortLabel,
              children: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430:"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectSort, {
              name: "catalog-sort",
              items: sortFields,
              selectedSorting: newSelectedSorting,
              onChange: handleChange('sort'),
              onOpen: function onOpen() {}
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CatalogPage_module_default()).treeMobile,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* CategoryTreeMobile */.vz, CatalogPageView_objectSpread({
            sidebar: state.sidebar
          }, savedSort && {
            savedQuery: {
              sort: savedSort
            }
          }))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (CatalogPage_module_default()).content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CatalogPage_module_default()).aside,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              ref: ref,
              className: (0,clsx_m/* default */.Z)((CatalogPage_module_default()).scrollBox, (loadingProducts || loadingFilters) && (CatalogPage_module_default()).disabledBlock),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CategoryTree, CatalogPageView_objectSpread({
                sidebar: state.sidebar,
                parent: state.parent,
                currentSlug: state.current.slug
              }, newSelectedSorting && {
                savedQuery: {
                  sort: newSelectedSorting
                }
              })), !!(filters !== null && filters !== void 0 && filters.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(Filters, {
                filters: filters,
                selectedFilters: newSelectedFilters,
                onChange: handleChange('filters'),
                loading: loadingProducts || loadingFilters
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (CatalogPage_module_default()).main,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (CatalogPage_module_default()).filterToggles,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CatalogMobileFilters, {
                selectedFilters: newSelectedFilters,
                filters: filters,
                onFiltersChange: handleChange('filters'),
                total: (_meta$total3 = meta === null || meta === void 0 ? void 0 : meta.total) !== null && _meta$total3 !== void 0 ? _meta$total3 : 0,
                loading: loadingProducts || loadingFilters
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogMobileSort, {
                sortName: "catalog-sort-mobile",
                sortItems: sortFields,
                selectedSorting: newSelectedSorting,
                onSortChange: handleChange('sort'),
                loading: loadingProducts || loadingFilters
              })]
            }), !!(filters !== null && filters !== void 0 && filters.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CatalogPage_module_default()).appliedFilters,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppliedFilters, {
                filters: filters,
                selectedFilters: newSelectedFilters,
                onChange: handleChange('filters'),
                currency: currency,
                isRU: storageCurrency == 'RU'
              })
            }), products !== null && products !== void 0 && products.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CatalogPage_module_default()).products,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Products, {
                products: products,
                loading: loadingProducts || loadingCategory || newProductsLoading,
                isSafari: isSafari,
                slug: state.current.slug,
                productCardProps: {
                  mod: 'catalog'
                },
                currency: currency
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((CatalogPage_module_default()).products, (CatalogPage_module_default()).productsEmpty, loadingProducts && (CatalogPage_module_default()).productsLoading)
            }), meta && meta.total > meta.per_page && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination, {
                lastPage: meta.last_page,
                currentPage: page
              })
            })]
          })]
        }), tags, state.current.slug !== '/brands' && textBlockUI, history.products && history.products.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Viewed, {
          products: history.products,
          currency: currency,
          setFirstProductId: setFirstProductId,
          firstProductId: firstProductId
        }), !!(products !== null && products !== void 0 && products.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollBtn, {})]
      })
    })]
  });
};

/* harmony default export */ var CatalogPage_CatalogPageView = (CatalogPageView);
;// CONCATENATED MODULE: ./layouts/CatalogPage/CatalogPage.js





function CatalogPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CatalogPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CatalogPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CatalogPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var isEqualIds = function isEqualIds(ids, historyIds) {
  return ids.every(function (id) {
    return historyIds[id];
  });
};

var CatalogPage = function CatalogPage(_ref) {
  var data = _ref.data,
      isSafariSSR = _ref.isSafari;
  var isSafari = false;

  if (true) {
    isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  } else {}

  var _useState = (0,react.useState)({
    breadcrumbs: data.breadcrumbs,
    sidebar: data.sidebar,
    current: data.current,
    parent: data.parent,
    tags: data.tags
  }),
      state = _useState[0],
      setState = _useState[1];

  var _useSelector = (0,es/* useSelector */.v9)(catalogSlice/* getCatalogData */.zm),
      _useSelector$products = _useSelector.products,
      products = _useSelector$products.data,
      meta = _useSelector$products.meta,
      blocks = _useSelector$products.blocks,
      loadingProducts = _useSelector$products.loading,
      loadingCash = _useSelector$products.loadingCash,
      _useSelector$filters = _useSelector.filters,
      filters = _useSelector$filters.data,
      loadingFilters = _useSelector$filters.loading,
      savedSort = _useSelector.sort;

  var _useSelector2 = (0,es/* useSelector */.v9)(categoriesSlice/* getLoading */.Kv),
      loadingCategory = _useSelector2.loading;

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      isDesktop = _useWindowSize.isDesktop;

  var router = (0,next_router.useRouter)();
  var query = router.query;
  var dispatch = (0,es/* useDispatch */.I0)();
  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);

  var _useState2 = (0,react.useState)(-1),
      firstProductId = _useState2[0],
      setFirstProductId = _useState2[1];

  var _useLocalStorage = (0,hooks/* useLocalStorage */._)('history', {
    count: 0,
    ids: {},
    products: []
  }),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      history = _useLocalStorage2[0],
      setHistory = _useLocalStorage2[1];

  var _useLocalStorage3 = (0,hooks/* useLocalStorage */._)('currency', 'BY'),
      _useLocalStorage4 = (0,slicedToArray/* default */.Z)(_useLocalStorage3, 2),
      storageCurrency = _useLocalStorage4[0],
      _setCurrency = _useLocalStorage4[1];

  var _useState3 = (0,react.useState)(false),
      newProductsLoading = _useState3[0],
      setNewProductsLoading = _useState3[1];

  var _useSelector3 = (0,es/* useSelector */.v9)(viewedSlice/* getViewedData */.En),
      count = _useSelector3.count,
      ids = _useSelector3.ids,
      isFromSession = _useSelector3.isFromSession;

  var _useState4 = (0,react.useState)({
    page: 1,
    selectedFilters: '{}'
  }),
      queryData = _useState4[0],
      setQueryData = _useState4[1];

  (0,react.useEffect)(function () {
    if (isFromSession && (history.count !== count || !isEqualIds(ids, history.ids))) {
      dispatch((0,viewedSlice/* fetchHistory */.eL)({
        onSuccess: function onSuccess(items) {
          var newIds = items.map(function (item) {
            return item.model.id;
          });
          var idsObj = (0,utils/* getObjectFromArray */.PX)(newIds);
          dispatch((0,viewedSlice/* updateHistoryIds */._h)({
            ids: newIds,
            count: newIds.length
          }));
          setHistory({
            count: newIds.length,
            ids: idsObj,
            products: items
          });
        }
      }));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [ids, history, dispatch, count, isFromSession]);

  var _qs$parse = lib_default().parse(query, {
    arrayLimit: 100
  }),
      typeSlug = _qs$parse.typeSlug,
      _qs$parse$page = _qs$parse.page,
      page = _qs$parse$page === void 0 ? 1 : _qs$parse$page,
      selectedSorting = _qs$parse.sort,
      _qs$parse$filters = _qs$parse.filters,
      selectedFilters = _qs$parse$filters === void 0 ? {} : _qs$parse$filters;

  var categorySlug = typeSlug.join('/');
  var _state$current = state.current,
      _state$current$sort_f = _state$current.sort_fields,
      sortFields = _state$current$sort_f === void 0 ? [] : _state$current$sort_f,
      _state$current$descri = _state$current.description,
      description = _state$current$descri === void 0 ? null : _state$current$descri,
      _state$current$meta_t = _state$current.meta_title,
      metaTitle = _state$current$meta_t === void 0 ? '' : _state$current$meta_t,
      _state$current$meta_d = _state$current.meta_description,
      metaDescription = _state$current$meta_d === void 0 ? '' : _state$current$meta_d,
      _state$current$name = _state$current.name,
      categoryTitle = _state$current$name === void 0 ? '' : _state$current$name,
      _state$current$og = _state$current.og,
      og = _state$current$og === void 0 ? {} : _state$current$og,
      seo = _state$current.seo;
  var _og$title = og.title,
      ogTitle = _og$title === void 0 ? '' : _og$title,
      _og$description = og.description,
      ogDescription = _og$description === void 0 ? '' : _og$description,
      _og$image_big = og.image_big,
      ogImageRect = _og$image_big === void 0 ? null : _og$image_big,
      _og$image_small = og.image_small,
      ogImageSquare = _og$image_small === void 0 ? null : _og$image_small;
  var isBrandsCategory = (0,react.useMemo)(function () {
    return categorySlug.includes('brands');
  }, [categorySlug]); // eslint-disable-next-line no-shadow

  var withEncodedBrands = (0,react.useCallback)(function (filters) {
    return filters.hasOwnProperty('brand') ? CatalogPage_objectSpread(CatalogPage_objectSpread({}, filters), {}, {
      brand: filters.brand.map(function (brand) {
        return encodeURIComponent(brand);
      })
    }) : filters;
  }, []);

  var sendToEcomerce = function sendToEcomerce() {
    if (Object.keys(currency).length > 0 && products) {
      var nameSlug = 'Категории';

      if (state.current.slug.includes('brand')) {
        nameSlug = 'Бренды';
      } else if (state.current.slug.includes('sale')) {
        nameSlug = 'Распродажи/Sale';
      }

      Ecommerce/* default.viewItemList */.ZP.viewItemList(products, currency, "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u0442\u043E\u0432\u0430\u0440\u043E\u0432: ".concat(nameSlug));
    }
  };

  (0,react.useEffect)(function () {
    sendToEcomerce();
  }, [products, currency]);

  var _useState5 = (0,react.useState)(page),
      newPage = _useState5[0],
      setNewPage = _useState5[1];

  var _useState6 = (0,react.useState)(selectedFilters),
      newSelectedFilters = _useState6[0],
      setSelectedFilters = _useState6[1];

  var _useState7 = (0,react.useState)(selectedSorting),
      newSelectedSorting = _useState7[0],
      setSelectedSorting = _useState7[1];

  (0,react.useEffect)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setQueryData(function (prevState) {
              return CatalogPage_objectSpread(CatalogPage_objectSpread({}, prevState), {}, {
                page: 1,
                selectedFilters: '{}'
              });
            });
            setNewProductsLoading(true);
            _context.next = 4;
            return dispatch((0,categoriesSlice/* getCategoryTreeBySlug */.P1)({
              slug: "/".concat(categorySlug),
              onSuccess: function onSuccess(res) {
                if (res.page.pageType === 'redirect') {
                  router_default().push(res.page.data.to);
                } else {
                  setState({
                    breadcrumbs: res === null || res === void 0 ? void 0 : res.page.data.breadcrumbs,
                    sidebar: res === null || res === void 0 ? void 0 : res.page.data.sidebar,
                    current: res === null || res === void 0 ? void 0 : res.page.data.current,
                    parent: res === null || res === void 0 ? void 0 : res.page.data.parent,
                    tags: res === null || res === void 0 ? void 0 : res.page.data.tags
                  });
                }
              },
              onError: function onError(err) {
                (0,handleError/* handleError */.S)(err);
              }
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [categorySlug, dispatch]);
  (0,react.useEffect)(function () {
    setNewPage(page);
  }, [page]);
  (0,react.useEffect)(function () {
    var strNewSelectedFilters = JSON.stringify(newSelectedFilters);
    var strSelectedFilters = JSON.stringify(selectedFilters);

    if (strNewSelectedFilters !== strSelectedFilters) {
      setSelectedFilters(selectedFilters);
    }
  }, [selectedFilters]);
  (0,react.useEffect)(function () {
    if (newSelectedSorting !== selectedSorting) {
      setSelectedSorting(selectedSorting);
    }
  }, [selectedSorting]);
  (0,react.useEffect)(function () {
    var _state$current2 = state.current,
        hash = _state$current2.hash,
        external_id = _state$current2.external_id,
        name = _state$current2.name;

    var _ref3 = queryData || {},
        selectedFilters = _ref3.selectedFilters,
        selectedSorting = _ref3.selectedSorting,
        page = _ref3.page;

    var hasDifferences = hash && (hash !== (queryData === null || queryData === void 0 ? void 0 : queryData.hash) || newPage !== page || JSON.stringify(newSelectedFilters) !== selectedFilters || newSelectedSorting !== selectedSorting);

    if (hasDifferences) {
      modules/* animateScroll.scrollToTop */.NY.scrollToTop();
      newSelectedSorting !== savedSort && dispatch((0,catalogSlice/* saveSort */.jI)(newSelectedSorting));
      var sortValue = sortFields.some(function (field) {
        return field.value === newSelectedSorting;
      }) ? newSelectedSorting : sortFields.length > 0 ? sortFields[0].value : 'new';
      var baseParams = {
        hash: hash,
        filters: newSelectedFilters
      };

      var fetchProductsParams = CatalogPage_objectSpread(CatalogPage_objectSpread({}, baseParams), {}, {
        page: newPage,
        sort: sortValue,
        onSuccess: function onSuccess() {
          return setNewProductsLoading(false);
        },
        onError: function onError() {
          return setNewProductsLoading(false);
        }
      });

      dispatch((0,catalogSlice/* fetchProducts */.t2)(fetchProductsParams));
      (JSON.stringify(newSelectedFilters) !== selectedFilters || hash !== (queryData === null || queryData === void 0 ? void 0 : queryData.hash)) && dispatch((0,catalogSlice/* fetchFilters */.a$)(baseParams));
      setQueryData({
        hash: hash,
        page: newPage,
        selectedFilters: JSON.stringify(newSelectedFilters),
        selectedSorting: newSelectedSorting
      });
      Mindbox/* default */.ZP === null || Mindbox/* default */.ZP === void 0 ? void 0 : Mindbox/* default.displayCategory */.ZP.displayCategory({
        category: state.current
      });
      (0,PopMechanicData/* setCategoryData */.lW)({
        id: external_id,
        name: name
      });
    }
  }, [queryData, dispatch, newPage, savedSort, newSelectedFilters, newSelectedSorting, sortFields, state.current, currency]);
  (0,react.useEffect)(function () {
    setState({
      breadcrumbs: data.breadcrumbs,
      sidebar: data.sidebar,
      current: data.current,
      parent: data.parent,
      tags: data.tags
    });
  }, [data]);
  var handleChange = (0,react.useCallback)(function (type) {
    return function (values) {
      var isFiltersType = type === 'filters';
      var filters = withEncodedBrands(isFiltersType ? values : newSelectedFilters);
      var sort = isFiltersType ? newSelectedSorting : values;

      if (isFiltersType && storageCurrency !== 'BY' && filters.price && Object.keys(currency).length) {
        var _qs$parse2 = lib_default().parse(query, {
          arrayLimit: 100
        }),
            _qs$parse2$filters = _qs$parse2.filters,
            selectedFiltersCurrency = _qs$parse2$filters === void 0 ? {} : _qs$parse2$filters;

        ['min', 'max'].forEach(function (key) {
          var _selectedFiltersCurre;

          if (filters.price[key] && (!((_selectedFiltersCurre = selectedFiltersCurrency.price) !== null && _selectedFiltersCurre !== void 0 && _selectedFiltersCurre[key]) || filters.price[key] !== selectedFiltersCurrency.price[key])) {
            filters.price[key] = (parseFloat(filters.price[key]) * currency.RUB.BYN).toFixed(2);
          }
        });
      }

      var queriesStringified = lib_default().stringify(CatalogPage_objectSpread({
        filters: filters
      }, sort && {
        sort: sort
      }), {
        encode: false
      });
      var baseUrl = queriesStringified ? "".concat(router.pathname, "?").concat(queriesStringified) : router.pathname;
      var asPath = queriesStringified ? "".concat(window.location.pathname, "?").concat(queriesStringified) : window.location.pathname;
      router.push(baseUrl, asPath, {
        shallow: true,
        scroll: false
      });
    };
  }, [currency, storageCurrency, newSelectedFilters, withEncodedBrands]);
  var textBlock = (0,react.useMemo)(function () {
    return seo && seo.text_block ? (0,utils/* getCorrectName */.tx)(seo.text_block) : description;
  }, [seo, description]);
  var brandBlocks = (0,react.useMemo)(function () {
    if (blocks && !!blocks.length) {
      var newBlock = {
        is_active: true,
        type: 'brand-info',
        id: 'brand-info',
        data: {
          blocks: blocks.map(function (_ref4) {
            var data = _ref4.data;
            return CatalogPage_objectSpread({}, data);
          }),
          loading: loadingProducts || loadingCash
        }
      };
      return [newBlock];
    }

    return [];
  }, [blocks, loadingProducts, loadingCash]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogPage_CatalogPageView, {
    metaTitle: metaTitle,
    categoryTitle: categoryTitle,
    metaDescription: metaDescription,
    seo: seo,
    ogTitle: ogTitle,
    ogDescription: ogDescription,
    ogImageRect: ogImageRect,
    ogImageSquare: ogImageSquare,
    meta: meta,
    state: state,
    isBrandsCategory: isBrandsCategory,
    savedSort: savedSort,
    newSelectedSorting: newSelectedSorting,
    filters: filters,
    newSelectedFilters: newSelectedFilters,
    handleChange: handleChange,
    loadingProducts: loadingProducts,
    loadingFilters: loadingFilters,
    isDesktop: isDesktop,
    blocks: brandBlocks,
    page: newPage,
    sortFields: sortFields.length > 0 ? sortFields : [{
      value: 'new',
      name: 'По новинкам',
      active: true
    }],
    currency: currency,
    storageCurrency: storageCurrency,
    products: products,
    loadingCategory: loadingCategory,
    isSafari: isSafari,
    history: history,
    setFirstProductId: setFirstProductId,
    firstProductId: firstProductId,
    textBlock: textBlock,
    newProductsLoading: newProductsLoading
  });
};

/* harmony default export */ var CatalogPage_CatalogPage = (CatalogPage);
;// CONCATENATED MODULE: ./layouts/CatalogPage/index.js

/* harmony default export */ var layouts_CatalogPage = (CatalogPage_CatalogPage);
// EXTERNAL MODULE: ./layouts/LoginPage/LoginPage.module.scss
var LoginPage_module = __webpack_require__(48775);
var LoginPage_module_default = /*#__PURE__*/__webpack_require__.n(LoginPage_module);
;// CONCATENATED MODULE: ./layouts/LoginPage/LoginPage.js





var LoginPage = function LoginPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (LoginPage_module_default()).section,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      className: (LoginPage_module_default()).container,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* LoginForm */.U0, {})
    })
  });
};

/* harmony default export */ var LoginPage_LoginPage = (LoginPage);
;// CONCATENATED MODULE: ./layouts/LoginPage/index.js

/* harmony default export */ var layouts_LoginPage = (LoginPage_LoginPage);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/pagesSlice.js
var pagesSlice = __webpack_require__(66681);
// EXTERNAL MODULE: ./lib/getDate.js
var getDate = __webpack_require__(10468);
// EXTERNAL MODULE: ./layouts/TextPage/TextPage.module.scss
var TextPage_module = __webpack_require__(47700);
var TextPage_module_default = /*#__PURE__*/__webpack_require__.n(TextPage_module);
;// CONCATENATED MODULE: ./layouts/TextPage/TextPage.js



function TextPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TextPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TextPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TextPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var ProductsModal = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2128), __webpack_require__.e(6800)]).then(__webpack_require__.bind(__webpack_require__, 76800));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76800)];
    }
  }
});

var camelize = function camelize(str) {
  return str.replace(/#|_|-/g, ' ').replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return '';
    return index === 0 ? match === null || match === void 0 ? void 0 : match.toLowerCase() : match.toUpperCase();
  });
};

var ShareBlock = function ShareBlock(_ref) {
  var hasBlocks = _ref.hasBlocks;

  var _useState = (0,react.useState)(''),
      shareUrl = _useState[0],
      setShareUrl = _useState[1];

  (0,react.useEffect)(function () {
    setShareUrl(document.location.href);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (0,clsx_m/* default */.Z)((TextPage_module_default()).share, !hasBlocks && (TextPage_module_default()).shareEmpty),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Share */.mB, {
        url: shareUrl
      })
    })
  });
};

var ArticlesBlock = function ArticlesBlock(_ref2) {
  var articles = _ref2.articles;

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'news'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
      href = _getLinkProps2[0],
      as = _getLinkProps2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (TextPage_module_default()).articles,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
        component: "h2",
        className: (TextPage_module_default())["articles-title"],
        children: "\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* News */.Sq, {
        items: articles
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (TextPage_module_default())["link-button"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: href,
          as: as,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
            type: "primary",
            children: "\u0412\u0441\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438"
          })
        })
      })]
    })
  });
};

var TextPage = function TextPage(_ref3) {
  var _data$og_title, _data$og_description, _data$og_image_big, _data$og_image_small;

  var isMain = _ref3.isMain,
      slug = _ref3.slug,
      data = _ref3.data,
      redirectTo = _ref3.redirectTo;

  var _ref4 = data || {},
      title = _ref4.title,
      sub_title = _ref4.sub_title,
      blocks = _ref4.blocks,
      meta_description = _ref4.meta_description,
      meta_title = _ref4.meta_title,
      seo = _ref4.seo,
      type = _ref4.type,
      image = _ref4.image,
      articles = _ref4.articles,
      published_at = _ref4.published_at,
      index = _ref4.index,
      follow = _ref4.follow,
      id = _ref4.id;

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (redirectTo) {
      router.push(redirectTo);
    }
  }, [redirectTo]);
  var dispatch = (0,es/* useDispatch */.I0)();
  var query = router.query;

  var _useState2 = (0,react.useState)(false),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      products = _useState4[0],
      setProducts = _useState4[1];

  var _qs$parse = lib_default().parse(query),
      _qs$parse$model_ids = _qs$parse.model_ids,
      model_ids = _qs$parse$model_ids === void 0 ? null : _qs$parse$model_ids;

  var isNews = type === 'article';
  var isSpecialOffer = type === 'special_offer';

  var _getLinkProps3 = (0,getLinkProps/* default */.Z)({
    type: 'news'
  }),
      _getLinkProps4 = (0,slicedToArray/* default */.Z)(_getLinkProps3, 3),
      newsHref = _getLinkProps4[0],
      newsTitle = _getLinkProps4[2];

  var _getLinkProps5 = (0,getLinkProps/* default */.Z)({
    type: 'special-offers'
  }),
      _getLinkProps6 = (0,slicedToArray/* default */.Z)(_getLinkProps5, 3),
      specialOffersHref = _getLinkProps6[0],
      specialOffersTitle = _getLinkProps6[2];

  var breadCrumbsNews = [{
    slug: newsHref,
    name: newsTitle
  }, {
    slug: newsHref,
    name: title
  }];
  var breadCrumbsSpecialOffers = [{
    slug: specialOffersHref,
    name: specialOffersTitle
  }, {
    slug: specialOffersHref,
    name: title
  }];

  var _getDate = (0,getDate/* default */.Z)(published_at),
      day = _getDate.day,
      month_rus = _getDate.month_rus,
      year = _getDate.year;

  var robotsContent = [index, follow].reduce(function (acc, cur) {
    return cur ? acc.concat(cur) : acc;
  }, []).join(', ');
  var ogTitle = (_data$og_title = data === null || data === void 0 ? void 0 : data.og_title) !== null && _data$og_title !== void 0 ? _data$og_title : '';
  var ogDescription = (_data$og_description = data === null || data === void 0 ? void 0 : data.og_description) !== null && _data$og_description !== void 0 ? _data$og_description : '';
  var ogImageRect = (_data$og_image_big = data === null || data === void 0 ? void 0 : data.og_image_big) !== null && _data$og_image_big !== void 0 ? _data$og_image_big : null;
  var ogImageSquare = (_data$og_image_small = data === null || data === void 0 ? void 0 : data.og_image_small) !== null && _data$og_image_small !== void 0 ? _data$og_image_small : null;
  var breadCrumbsType = (0,react.useMemo)(function () {
    if (type === 'article') {
      return 'news';
    }

    if (type === 'special_offer') {
      return 'special-offers';
    }
  }, [type]);
  var handleOpenModal = (0,react.useCallback)(function () {
    setOpenModal(true);
  }, []);
  var handleCloseModal = (0,react.useCallback)(function () {
    setOpenModal(false);
  }, []);
  (0,react.useEffect)(function () {
    if (model_ids) {
      setLoading(true);
      dispatch((0,pagesSlice/* fetchMarketProducts */.kS)({
        ids: model_ids,
        onSuccess: function onSuccess(productList) {
          setLoading(false);

          if (productList.length) {
            setProducts(productList);
            handleOpenModal();
          }
        },
        onError: function onError() {
          setLoading(false);
        }
      }));
    }
  }, [model_ids, handleOpenModal]);
  (0,react.useEffect)(function () {
    if (isNews) {
      Mindbox/* default */.ZP === null || Mindbox/* default */.ZP === void 0 ? void 0 : Mindbox/* default.viewPageNews */.ZP.viewPageNews({
        article: data
      });
    } else if (slug) {
      Mindbox/* default */.ZP === null || Mindbox/* default */.ZP === void 0 ? void 0 : Mindbox/* default.viewCustomPage */.ZP.viewCustomPage(id);
    }
  }, [isNews, slug, data, id]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* MetaData */.U4, TextPage_objectSpread(TextPage_objectSpread(TextPage_objectSpread({
      title: meta_title || title,
      description: meta_description,
      seo: seo,
      ogTitle: ogTitle,
      ogDescription: ogDescription,
      image: ogImageRect,
      imageSmall: ogImageSquare
    }, image && {
      image: image === null || image === void 0 ? void 0 : image.x2
    }), (isNews || isSpecialOffer) && {
      articleData: data,
      type: 'article'
    }), robotsContent && {
      robotsContent: robotsContent
    })), (isNews || isSpecialOffer) && /*#__PURE__*/(0,jsx_runtime.jsx)(JsonLd/* JsonLdData */.j, {
      newsArticle: TextPage_objectSpread(TextPage_objectSpread({}, data), {}, {
        meta_description: meta_description
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [!isMain && /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
        children: [!isNews && !isSpecialOffer && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (TextPage_module_default())["bread-crumbs"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
            breadcrumbs: [{
              slug: data === null || data === void 0 ? void 0 : data.slug,
              name: title
            }]
          })
        }), (isNews || isSpecialOffer) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (TextPage_module_default())["bread-crumbs"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
            type: breadCrumbsType,
            breadcrumbs: isNews ? breadCrumbsNews : breadCrumbsSpecialOffers
          })
        }), sub_title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (TextPage_module_default())["sub-title"],
          children: sub_title
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (TextPage_module_default())["text-page-article"],
          children: [(isNews || isSpecialOffer) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (TextPage_module_default()).type,
            children: isNews ? 'Новость;' : 'Акция;'
          }), published_at && (isNews || isSpecialOffer) && /*#__PURE__*/(0,jsx_runtime.jsxs)("time", {
            className: (TextPage_module_default()).date,
            dateTime: published_at,
            children: [day, " ", month_rus, " ", year]
          })]
        })]
      }), isMain && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
        component: "h1",
        invisible: true,
        children: seo && seo.h1 ? (0,utils/* getCorrectName */.tx)(seo.h1) : title
      }), blocks && blocks.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((TextPage_module_default()).blocks, (isNews || isSpecialOffer) && (TextPage_module_default())["news-blocks"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Blocks */.no, {
          blocks: blocks
        })
      }), (isNews || isSpecialOffer) && /*#__PURE__*/(0,jsx_runtime.jsx)(ShareBlock, {
        hasBlocks: blocks.length > 0
      }), articles && articles.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ArticlesBlock, {
        articles: articles
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductsModal, {
        showDialog: openModal,
        onDismiss: handleCloseModal,
        products: products,
        loading: loading
      })]
    })]
  });
};

/* harmony default export */ var TextPage_TextPage = (TextPage);
;// CONCATENATED MODULE: ./layouts/TextPage/index.js

/* harmony default export */ var layouts_TextPage = (TextPage_TextPage);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/wishlistSlice.js + 1 modules
var wishlistSlice = __webpack_require__(94650);
// EXTERNAL MODULE: ./lib/getProductWithoutQuantity.js
var getProductWithoutQuantity = __webpack_require__(3506);
// EXTERNAL MODULE: ./layouts/WishlistPage/WishlistPage.module.scss
var WishlistPage_module = __webpack_require__(58267);
var WishlistPage_module_default = /*#__PURE__*/__webpack_require__.n(WishlistPage_module);
;// CONCATENATED MODULE: ./layouts/WishlistPage/WishlistPage.js



function WishlistPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WishlistPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WishlistPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WishlistPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var Wishlist = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3731).then(__webpack_require__.bind(__webpack_require__, 13731));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(13731)];
    }
  }
});
var WishlistPage_ScrollBtn = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 885).then(__webpack_require__.bind(__webpack_require__, 40885));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(40885)];
    }
  }
});
var WishlistPage_Pagination = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4436).then(__webpack_require__.bind(__webpack_require__, 64436));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(64436)];
    }
  }
});

var WishlistPage = function WishlistPage() {
  var _useSelector = (0,es/* useSelector */.v9)(wishlistSlice/* getWishlistData */.jb),
      products = _useSelector.products,
      meta = _useSelector.meta,
      isLoading = _useSelector.firstLoading,
      loading = _useSelector.loading,
      updating = _useSelector.updating,
      ids = _useSelector.ids;

  var router = (0,next_router.useRouter)();
  var query = router.query;

  var _qs$parse = lib_default().parse(query),
      _qs$parse$page = _qs$parse.page,
      page = _qs$parse$page === void 0 ? 1 : _qs$parse$page;

  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);
  var pagination = (0,react.useMemo)(function () {
    if (meta && meta.total > meta.per_page) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (WishlistPage_module_default()).wishlistPagination,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WishlistPage_Pagination, {
          lastPage: meta.last_page,
          currentPage: page
        })
      });
    }

    return null;
  }, [meta, page]);

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'wishlist'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 3),
      wishlistHref = _getLinkProps2[0],
      _wishlistAs = _getLinkProps2[1],
      wishlistTitle = _getLinkProps2[2];

  var breadCrumbsWishlist = [{
    slug: wishlistHref,
    name: wishlistTitle
  }];
  var isEmpty = products.length === 0;
  var dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    Mindbox/* default */.ZP === null || Mindbox/* default */.ZP === void 0 ? void 0 : Mindbox/* default.viewPage */.ZP.viewPage({
      page: 'Wishlist'
    });
    dispatch((0,sessionSlice/* createSession */.ed)(true, undefined, {
      forceRefresh: true
    }));
  }, []);
  (0,react.useEffect)(function () {
    setTimeout(function () {
      if (!isLoading && products) {
        Ecommerce/* default.viewItemList */.ZP.viewItemList((0,getProductWithoutQuantity/* default */.Z)(products.map(function (item) {
          return item.product;
        })), currency, 'Каталог товаров: Избранное');
      }
    }, 0);
  }, [isLoading, products, currency]);
  (0,react.useEffect)(function () {
    if (isEmpty) {
      modules/* animateScroll.scrollToTop */.NY.scrollToTop();
    }
  }, [isEmpty]);
  (0,react.useEffect)(function () {
    if (loading || updating) {
      modules/* animateScroll.scrollToTop */.NY.scrollToTop();
    }
  }, [loading, updating]);
  var getWishlist = (0,react.useCallback)(function () {
    dispatch((0,wishlistSlice/* fetchWishlist */.BW)({
      page: page
    }));
  }, [dispatch, page]);
  (0,react.useEffect)(function () {
    if (page !== 1 || meta && meta.current_page && meta.current_page !== 1) {
      getWishlist();
    }
  }, [page, getWishlist]);
  (0,react.useEffect)(function () {
    if (page == 1) {
      getWishlist();
    }
  }, []);

  var refreshWishlist = function refreshWishlist() {
    if (page != 1 && products.length === 1) {
      router_default().push({
        pathname: '/wishlist',
        query: {
          page: page - 1
        }
      });
    } else {
      getWishlist();
    }
  }; //  !isLoading


  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (WishlistPage_module_default()).wishlistSection,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (WishlistPage_module_default()).breadCrumbs,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
          type: "wishlist",
          breadcrumbs: breadCrumbsWishlist
        })
      })
    }), !loading && !isLoading && !updating ? /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      className: (0,clsx_m/* default */.Z)(isEmpty && (WishlistPage_module_default()).wishlistContainer),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, WishlistPage_objectSpread(WishlistPage_objectSpread({
        mb: "large",
        component: "h1"
      }, isEmpty ? {
        align: 'center'
      } : {
        align: 'left'
      }), {}, {
        children: isEmpty ? 'Список желаний пуст' : 'Избранное'
      })), isEmpty ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* PageText */.E3, {
          className: (WishlistPage_module_default()).emptyText,
          children: "\u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0439\u0442\u0435 \u043F\u043E\u043D\u0440\u0430\u0432\u0438\u0432\u0448\u0438\u0435\u0441\u044F \u0442\u043E\u0432\u0430\u0440\u044B \u043D\u0430\u0436\u0430\u0432 \u2661 \u043D\u0430 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0435 \u0442\u043E\u0432\u0430\u0440\u0430."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          as: "/",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
            type: "primary",
            children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Wishlist, {
          products: products,
          currency: currency,
          getWishlist: refreshWishlist,
          ids: ids
        }), pagination, /*#__PURE__*/(0,jsx_runtime.jsx)(WishlistPage_ScrollBtn, {
          isWishlist: true
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {
      visible: true
    })]
  });
};

/* harmony default export */ var WishlistPage_WishlistPage = (WishlistPage);
;// CONCATENATED MODULE: ./layouts/WishlistPage/index.js

/* harmony default export */ var layouts_WishlistPage = (WishlistPage_WishlistPage);
// EXTERNAL MODULE: ./layouts/Page/Page.module.scss
var Page_module = __webpack_require__(74816);
var Page_module_default = /*#__PURE__*/__webpack_require__.n(Page_module);
;// CONCATENATED MODULE: ./components/bottomDrawer/BottomDrawer.js








var BottomDrawer_BottomDrawer = function BottomDrawer(_ref) {
  var _clsx;

  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      children = _ref.children;

  var _useState = useState(true),
      isShownContent = _useState[0],
      setIsShownContent = _useState[1];

  var _useState2 = useState(false),
      isShownDialog = _useState2[0],
      setIsShownDialog = _useState2[1];

  var dialogRef = useRef(null);

  var close = function close() {
    setIsShownContent(false);
    setTimeout(function () {
      setIsShownDialog(false);
    }, 300);
  };

  var open = function open() {
    setIsShownContent(true);
    setIsShownDialog(true);
  };

  useEffect(function () {
    if (isOpen) {
      open();
    } else {
      close();
    }
  }, [isOpen]);
  return /*#__PURE__*/_jsx(DialogOverlay, {
    isOpen: isShownDialog,
    "aria-label": undefined,
    className: styles.root,
    onClick: onClose,
    children: /*#__PURE__*/_jsx(DialogContent, {
      "aria-labelledby": "cookies details",
      className: styles.dialog,
      children: /*#__PURE__*/_jsx("div", {
        id: "drawer-container",
        ref: dialogRef,
        className: clsx((_clsx = {}, _defineProperty(_clsx, styles['drawer-content'], true), _defineProperty(_clsx, styles.hide, !isShownContent), _clsx)),
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx("div", {
            className: styles.contentBlock,
            children: /*#__PURE__*/React.cloneElement(children, {
              onClose: close
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var bottomDrawer_BottomDrawer = ((/* unused pure expression or super */ null && (BottomDrawer_BottomDrawer)));
;// CONCATENATED MODULE: ./components/bottomDrawer/index.js

/* harmony default export */ var bottomDrawer = ((/* unused pure expression or super */ null && (BottomDrawer)));
// EXTERNAL MODULE: ./components/button/index.js + 1 modules
var components_button = __webpack_require__(81561);
;// CONCATENATED MODULE: ./node_modules/react-switch/dist/index.prod.mjs
function s(){return s=Object.assign?Object.assign.bind():function(t){for(var i=1;i<arguments.length;i++){var s=arguments[i];for(var n in s)Object.prototype.hasOwnProperty.call(s,n)&&(t[n]=s[n])}return t},s.apply(this,arguments)}var n=react.createElement("svg",{viewBox:"-2 -5 14 20",height:"100%",width:"100%",style:{position:"absolute",top:0}},react.createElement("path",{d:"M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",fill:"#fff",fillRule:"evenodd"})),o=react.createElement("svg",{height:"100%",width:"100%",viewBox:"-2 -5 17 21",style:{position:"absolute",top:0}},react.createElement("path",{d:"M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",fill:"#fff",fillRule:"evenodd"}));function h(t){if(7===t.length)return t;for(var i="#",s=1;s<4;s+=1)i+=t[s]+t[s];return i}function e(t,i,s,n,o){return function(t,i,s,n,o){var h=(t-s)/(i-s);if(0===h)return n;if(1===h)return o;for(var e="#",a=1;a<6;a+=2){var r=parseInt(n.substr(a,2),16),l=parseInt(o.substr(a,2),16),c=Math.round((1-h)*r+h*l).toString(16);1===c.length&&(c="0"+c),e+=c}return e}(t,i,s,h(n),h(o))}var a=function(i){function n(t){i.call(this,t);var s=t.height,n=t.width,o=t.checked;this.t=t.handleDiameter||s-2,this.i=Math.max(n-s,n-(s+this.t)/2),this.o=Math.max(0,(s-this.t)/2),this.state={h:o?this.i:this.o},this.l=0,this.u=0,this.p=this.p.bind(this),this.v=this.v.bind(this),this.k=this.k.bind(this),this.m=this.m.bind(this),this.M=this.M.bind(this),this.T=this.T.bind(this),this.$=this.$.bind(this),this.C=this.C.bind(this),this.D=this.D.bind(this),this.O=this.O.bind(this),this.S=this.S.bind(this),this.W=this.W.bind(this)}return i&&(n.__proto__=i),(n.prototype=Object.create(i&&i.prototype)).constructor=n,n.prototype.componentDidMount=function(){this.I=!0},n.prototype.componentDidUpdate=function(t){t.checked!==this.props.checked&&this.setState({h:this.props.checked?this.i:this.o})},n.prototype.componentWillUnmount=function(){this.I=!1},n.prototype.H=function(t){this.R.focus(),this.setState({j:t,B:!0,L:Date.now()})},n.prototype.N=function(t){var i=this.state,s=i.j,n=i.h,o=(this.props.checked?this.i:this.o)+t-s;i.U||t===s||this.setState({U:!0});var h=Math.min(this.i,Math.max(this.o,o));h!==n&&this.setState({h:h})},n.prototype.A=function(t){var i=this.state,s=i.h,n=i.U,o=i.L,h=this.props.checked,e=(this.i+this.o)/2;this.setState({h:this.props.checked?this.i:this.o});var a=Date.now()-o;(!n||a<250||(h&&s<=e||!h&&s>=e))&&this.X(t),this.I&&this.setState({U:!1,B:!1}),this.l=Date.now()},n.prototype.p=function(t){t.preventDefault(),"number"==typeof t.button&&0!==t.button||(this.H(t.clientX),window.addEventListener("mousemove",this.v),window.addEventListener("mouseup",this.k))},n.prototype.v=function(t){t.preventDefault(),this.N(t.clientX)},n.prototype.k=function(t){this.A(t),window.removeEventListener("mousemove",this.v),window.removeEventListener("mouseup",this.k)},n.prototype.m=function(t){this.F=null,this.H(t.touches[0].clientX)},n.prototype.M=function(t){this.N(t.touches[0].clientX)},n.prototype.T=function(t){t.preventDefault(),this.A(t)},n.prototype.C=function(t){Date.now()-this.l>50&&(this.X(t),Date.now()-this.u>50&&this.I&&this.setState({B:!1}))},n.prototype.D=function(){this.u=Date.now()},n.prototype.O=function(){this.setState({B:!0})},n.prototype.S=function(){this.setState({B:!1})},n.prototype.W=function(t){this.R=t},n.prototype.$=function(t){t.preventDefault(),this.R.focus(),this.X(t),this.I&&this.setState({B:!1})},n.prototype.X=function(t){var i=this.props;(0,i.onChange)(!i.checked,t,i.id)},n.prototype.render=function(){var i=this.props,n=i.checked,o=i.disabled,h=i.className,a=i.offColor,r=i.onColor,l=i.offHandleColor,c=i.onHandleColor,u=i.checkedIcon,d=i.uncheckedIcon,f=i.checkedHandleIcon,p=i.uncheckedHandleIcon,b=i.boxShadow,v=i.activeBoxShadow,g=i.height,y=i.width,w=i.borderRadius,k=function(t,i){var s={};for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&-1===i.indexOf(n)&&(s[n]=t[n]);return s}(i,["checked","disabled","className","offColor","onColor","offHandleColor","onHandleColor","checkedIcon","uncheckedIcon","checkedHandleIcon","uncheckedHandleIcon","boxShadow","activeBoxShadow","height","width","borderRadius","handleDiameter"]),m=this.state,M=m.h,T=m.U,x=m.B,$={position:"relative",display:"inline-block",textAlign:"left",opacity:o?.5:1,direction:"ltr",borderRadius:g/2,WebkitTransition:"opacity 0.25s",MozTransition:"opacity 0.25s",transition:"opacity 0.25s",touchAction:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none"},C={height:g,width:y,margin:Math.max(0,(this.t-g)/2),position:"relative",background:e(M,this.i,this.o,a,r),borderRadius:"number"==typeof w?w:g/2,cursor:o?"default":"pointer",WebkitTransition:T?null:"background 0.25s",MozTransition:T?null:"background 0.25s",transition:T?null:"background 0.25s"},D={height:g,width:Math.min(1.5*g,y-(this.t+g)/2+1),position:"relative",opacity:(M-this.o)/(this.i-this.o),pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},O={height:g,width:Math.min(1.5*g,y-(this.t+g)/2+1),position:"absolute",opacity:1-(M-this.o)/(this.i-this.o),right:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},S={height:this.t,width:this.t,background:e(M,this.i,this.o,l,c),display:"inline-block",cursor:o?"default":"pointer",borderRadius:"number"==typeof w?w-1:"50%",position:"absolute",transform:"translateX("+M+"px)",top:Math.max(0,(g-this.t)/2),outline:0,boxShadow:x?v:b,border:0,WebkitTransition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",MozTransition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",transition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s"},W={height:this.t,width:this.t,opacity:Math.max(2*(1-(M-this.o)/(this.i-this.o)-.5),0),position:"absolute",left:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},z={height:this.t,width:this.t,opacity:Math.max(2*((M-this.o)/(this.i-this.o)-.5),0),position:"absolute",left:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"};return react.createElement("div",{className:h,style:$},react.createElement("div",{className:"react-switch-bg",style:C,onClick:o?null:this.$,onMouseDown:function(t){return t.preventDefault()}},u&&react.createElement("div",{style:D},u),d&&react.createElement("div",{style:O},d)),react.createElement("div",{className:"react-switch-handle",style:S,onClick:function(t){return t.preventDefault()},onMouseDown:o?null:this.p,onTouchStart:o?null:this.m,onTouchMove:o?null:this.M,onTouchEnd:o?null:this.T,onTouchCancel:o?null:this.S},p&&react.createElement("div",{style:W},p),f&&react.createElement("div",{style:z},f)),react.createElement("input",s({},{type:"checkbox",role:"switch","aria-checked":n,checked:n,disabled:o,style:{border:0,clip:"rect(0 0 0 0)",height:1,margin:-1,overflow:"hidden",padding:0,position:"absolute",width:1}},k,{ref:this.W,onFocus:this.O,onBlur:this.S,onKeyUp:this.D,onChange:this.C})))},n}(react.Component);a.defaultProps={disabled:!1,offColor:"#888",onColor:"#080",offHandleColor:"#fff",onHandleColor:"#fff",uncheckedIcon:n,checkedIcon:o,boxShadow:null,activeBoxShadow:"0 0 2px 3px #3bf",height:28,width:56};

;// CONCATENATED MODULE: ./components/switcher/Switcher.js






var Switcher_Switcher = function Switcher(_ref) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      name = _ref.name,
      onChange = _ref.onChange;
  return /*#__PURE__*/_jsx(Switch, {
    onChange: onChange,
    checked: checked,
    id: name,
    disabled: disabled,
    checkedIcon: false,
    uncheckedIcon: false,
    handleDiameter: 24,
    width: 44,
    height: 28,
    className: clsx(styles.switcher, checked && styles.checked)
  });
};

/* harmony default export */ var switcher_Switcher = ((/* unused pure expression or super */ null && (Switcher_Switcher)));
;// CONCATENATED MODULE: ./components/switcher/index.js

/* harmony default export */ var switcher = ((/* unused pure expression or super */ null && (Switcher)));
;// CONCATENATED MODULE: ./components/cookies/Cookies.js











var CookiesContent = function CookiesContent(_ref) {
  var functionalValue = _ref.functionalValue,
      analiticalValue = _ref.analiticalValue,
      onDismiss = _ref.onDismiss,
      onAgree = _ref.onAgree,
      onClose = _ref.onClose;

  var _useState = useState(false),
      showSettings = _useState[0],
      setShowSettings = _useState[1];

  var _useState2 = useState(functionalValue),
      isFuctional = _useState2[0],
      setIsFunctional = _useState2[1];

  var _useState3 = useState(analiticalValue),
      isAnalitical = _useState3[0],
      setIsAnalitical = _useState3[1];

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.cookies,
      children: [showSettings && /*#__PURE__*/_jsx("div", {
        className: styles.settings,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        children: /*#__PURE__*/_jsxs("ul", {
          className: styles.list,
          children: [/*#__PURE__*/_jsx("li", {
            className: styles.listItem,
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.listItemKey,
              children: [/*#__PURE__*/_jsx("h4", {
                className: styles.title,
                children: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0435 (\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435) \u0444\u0430\u0439\u043B\u044B cookie. \u0412\u0441\u0435\u0433\u0434\u0430 \u0430\u043A\u0442\u0438\u0432\u043D\u044B"
              }), /*#__PURE__*/_jsx("p", {
                className: styles.description,
                children: "\u042D\u0442\u0438 \u0444\u0430\u0439\u043B\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B \u0434\u043B\u044F \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0430\u0439\u0442\u0430 \u0438 \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u0432 \u043D\u0430\u0448\u0438\u0445 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0445. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0442\u0430\u043A, \u0447\u0442\u043E\u0431\u044B \u043E\u043D \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043B \u0438\u0445 \u0438\u043B\u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u044F\u043B \u0432\u0430\u0441 \u043E\u0431 \u0438\u0445 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438, \u043D\u043E \u0432 \u0442\u0430\u043A\u043E\u043C \u0441\u043B\u0443\u0447\u0430\u0435 \u0441\u0430\u0439\u0442 \u043C\u043E\u0436\u0435\u0442 \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E."
              })]
            })
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.listItem,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.listItemKey,
              children: [/*#__PURE__*/_jsx("h4", {
                className: styles.title,
                children: "\u0424\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0444\u0430\u0439\u043B\u044B cookie"
              }), /*#__PURE__*/_jsx("p", {
                className: styles.description,
                children: "\u042F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043A\u0440\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0432\u0430\u0436\u043D\u044B\u043C\u0438 \u0434\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0441\u0430\u0439\u0442\u0430 \u0438 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u044E\u0442 \u0440\u0430\u0431\u043E\u0442\u0443 \u043F\u043E\u043B\u0435\u0437\u043D\u044B\u0445 \u0444\u0443\u043D\u043A\u0446\u0438\u0439."
              })]
            }), /*#__PURE__*/_jsx(Switcher, {
              checked: isFuctional,
              name: "functional",
              onChange: function onChange() {
                return setIsFunctional(!isFuctional);
              }
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.listItem,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.listItemKey,
              children: [/*#__PURE__*/_jsx("h4", {
                className: styles.title,
                children: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0444\u0430\u0439\u043B\u044B cookie"
              }), /*#__PURE__*/_jsx("p", {
                className: styles.description,
                children: "\u041C\u043E\u0433\u0443\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 \u043E \u0432\u0430\u0448\u0438\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0430\u0445, \u043F\u043E\u0441\u0435\u0449\u0430\u0435\u043C\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445 \u0438 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0445 \u0442\u0440\u0430\u0444\u0438\u043A\u0430, \u0447\u0442\u043E\u0431\u044B \u043E\u0446\u0435\u043D\u0438\u0432\u0430\u0442\u044C \u0438 \u0443\u043B\u0443\u0447\u0448\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0441\u0430\u0439\u0442\u0430."
              })]
            }), /*#__PURE__*/_jsx(Switcher, {
              checked: isAnalitical,
              name: "analitical",
              onChange: function onChange() {
                return setIsAnalitical(!isAnalitical);
              }
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.agreement,
        children: [/*#__PURE__*/_jsxs("p", {
          className: styles.content,
          children: ["\u041C\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C \u0444\u0430\u0439\u043B\u044B cookie \u0434\u043B\u044F \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u044B \u0441\u0430\u0439\u0442\u0430 \u0438 \u0441\u0431\u043E\u0440\u0430 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0438.", ' ', /*#__PURE__*/_jsx("u", {
            onClick: function onClick() {
              return setShowSettings(true);
            },
            children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C cookie"
          }), ". \u041D\u0430\u0436\u0438\u043C\u0430\u044F \xAB\u041F\u0440\u0438\u043D\u044F\u0442\u044C\xBB, \u0432\u044B \u0434\u0430\u0451\u0442\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u0438\u0445 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0444\u0430\u0439\u043B\u043E\u0432 cookie."]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.btns,
          children: [!showSettings ? /*#__PURE__*/_jsx(Button, {
            onClick: function onClick() {
              onDismiss();
              onClose();
            },
            type: "defaultBlack",
            children: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C"
          }) : /*#__PURE__*/_jsx(Button, {
            onClick: function onClick() {
              return setShowSettings(false);
            },
            type: "defaultBlack",
            children: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C"
          }), /*#__PURE__*/_jsx(Button, {
            onClick: function onClick() {
              return onAgree(isFuctional, isAnalitical);
            },
            type: "primary",
            children: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C"
          })]
        })]
      })]
    })
  });
};

var Cookies_Cookies = function Cookies() {
  var _useState4 = useState(true),
      showCookiesModal = _useState4[0],
      setShowCookiesModal = _useState4[1];

  var _useLocalStorage = useLocalStorage('fh-cookie', '{}'),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      cookie = _useLocalStorage2[0],
      setCookie = _useLocalStorage2[1];

  var cookiesAgreement = useMemo(function () {
    var _JSON$parse;

    return (_JSON$parse = JSON.parse(cookie)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.agreement;
  }, [cookie]);
  var cookiesSettings = useMemo(function () {
    var _JSON$parse2;

    return (_JSON$parse2 = JSON.parse(cookie)) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.settings;
  }, [cookie]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: cookiesAgreement === undefined && /*#__PURE__*/_jsx(BottomDrawer, {
      isOpen: showCookiesModal,
      onClose: function onClose() {
        return setShowCookiesModal(false);
      },
      children: /*#__PURE__*/_jsx(CookiesContent, {
        functionalValue: cookiesSettings === undefined ? true : cookiesSettings === null || cookiesSettings === void 0 ? void 0 : cookiesSettings.functional,
        analiticalValue: cookiesSettings === undefined ? true : cookiesSettings === null || cookiesSettings === void 0 ? void 0 : cookiesSettings.analitical,
        onDismiss: function onDismiss() {
          setShowCookiesModal(false);
          setCookie(JSON.stringify({
            agreement: false,
            settings: {
              functional: false,
              analitical: false
            }
          }));
        },
        onAgree: function onAgree(value1, value2) {
          setShowCookiesModal(false);
          setCookie(JSON.stringify({
            agreement: true,
            settings: {
              functional: value1,
              analitical: value2
            }
          }));
        }
      })
    })
  });
};

/* harmony default export */ var cookies_Cookies = ((/* unused pure expression or super */ null && (Cookies_Cookies)));
;// CONCATENATED MODULE: ./components/cookies/index.js

/* harmony default export */ var cookies = ((/* unused pure expression or super */ null && (Cookies)));
;// CONCATENATED MODULE: ./layouts/Page/Page.js













var Page = function Page(_ref) {
  var isMobile = _ref.isMobile,
      children = _ref.children;
  var hasSmartBanner = (0,es/* useSelector */.v9)(store/* hasSmartBannerSelector */.Jd);

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      isDesktop = _useWindowSize.isDesktop;

  var router = (0,next_router.useRouter)();
  var isReturnProcess = router.pathname.includes('new-return') || router.pathname.includes('success-return');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Page_module_default()).container,
    children: [!isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MobileNav */.zM, {
      hasBanner: hasSmartBanner
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MobileUserNav */.nN, {
      hasBanner: hasSmartBanner
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Header */.h4, {
      hasServerBanner: isMobile
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
      className: (Page_module_default()).content,
      children: [!isReturnProcess && /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* NavPopular */.p7, {}), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Footer */.$_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Notifications */.Tx, {})]
  });
};

/* harmony default export */ var Page_Page = (/*#__PURE__*/(0,react.memo)(Page));
;// CONCATENATED MODULE: ./layouts/Page/index.js

/* harmony default export */ var layouts_Page = (Page_Page);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./layouts/Scripts/Scripts.js







var Scripts = function Scripts() {
  var isGTMEnable = !!Ecommerce/* CONTAINER_ID */.WK;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "popmechanic-script",
      strategy: "lazyOnload",
      src: "https://static.popmechanic.ru/service/loader.js?c=30980",
      onError: function onError(err) {
        console.error('Error', err);
      },
      onLoad: function onLoad() {
        console.log('popmechanic upload success');
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "diginetica-script",
      strategy: "lazyOnload",
      src: "//cdn.diginetica.net/3205/client.js?ts=".concat(Date.now()),
      onError: function onError(err) {
        console.error('Error', err);
      },
      onLoad: function onLoad() {
        console.log('diginetica upload success');
      }
    }), isGTMEnable && /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      strategy: "afterInteractive",
      dangerouslySetInnerHTML: {
        __html: "\n                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                                'https://www.googletagmanager.com/gtm.js?id='+i+dl;setTimeout(function(){f?.parentNode?.insertBefore(j,f)}, 3*1000);\n                            })(window,document,'script','dataLayer', '".concat(Ecommerce/* CONTAINER_ID */.WK, "');\n                        ")
      }
    })]
  });
};

/* harmony default export */ var Scripts_Scripts = (/*#__PURE__*/(0,react.memo)(Scripts));
;// CONCATENATED MODULE: ./layouts/Scripts/index.js

/* harmony default export */ var layouts_Scripts = (Scripts_Scripts);
;// CONCATENATED MODULE: ./layouts/index.js
// pages
 // export { default as SuccessReturnPage } from './SuccessReturnPage';

 // export { default as ContactsPage } from './ContactsPage';
// export { default as CheckoutSuccessPage } from './CheckoutSuccessPage';
// export { default as CheckoutRedirectPage } from './CheckoutRedirectPage';
// export { default as CheckoutFailurePage } from './CheckoutFailurePage';

 // export { default as NewsPage } from './NewsPage';
// export { default as ProductPage } from './ProductPage';
// export { default as OrderPage } from './OrderPage';
// export { default as RemoveProfilePage } from './RemoveProfilePage';
// export { default as SpecialOffersPage } from './SpecialOffersPage';

 // export { default as UserPage } from './UserPage';

 // export { default as ReturnProcessPage } from './ReturnProcessPage';
// export { default as CatalogSeoPage } from './CatalogSeoPage';
// export { default as ReturnPolicyPage } from './ReturnPolicyPage';




/***/ }),

/***/ 6668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ok": function() { return /* binding */ socialList; },
/* harmony export */   "Vi": function() { return /* binding */ getMask; },
/* harmony export */   "YP": function() { return /* binding */ messengersList; },
/* harmony export */   "a9": function() { return /* binding */ marketplaceFeatures; },
/* harmony export */   "gx": function() { return /* binding */ getEmoji; },
/* harmony export */   "hW": function() { return /* binding */ countries; },
/* harmony export */   "rr": function() { return /* binding */ messengersQualityList; },
/* harmony export */   "v6": function() { return /* binding */ paymentImages; }
/* harmony export */ });
/* unused harmony exports footerLinks, profileLinks, regExp */
var footerLinks = [{
  title: 'Доставка и оплата',
  href: '/delivery'
}, {
  title: 'Новости',
  href: '/news'
}, {
  title: 'Акции',
  href: '/special-offers'
}, {
  title: 'Адреса магазинов',
  href: '/shops'
}, {
  title: 'Наши контакты',
  href: '/contacts'
}];
var marketplaceFeatures = [{
  icon: 'delivery-fast',
  text: 'Бесплатная доставка за 2 часа по Минску'
}, {
  icon: 'delivery',
  text: 'Быстрая доставка по Беларуси и России'
}, {
  icon: 'products',
  text: 'Количество товаров без ограничений'
}];
var paymentImages = [{
  src: '/images/pay_system/visa.svg',
  alt: 'visa'
}, {
  src: '/images/pay_system/verified_by_visa.svg',
  alt: 'verified by visa'
}, {
  src: '/images/pay_system/mastercard.svg',
  alt: 'mastercard'
}, {
  src: '/images/pay_system/mastercard_securedcode.svg',
  alt: 'mastercard secured code'
}, {
  src: '/images/pay_system/belcard.svg',
  alt: 'belcard'
}, {
  src: '/images/pay_system/belcard_parol.svg',
  alt: 'belcard parol'
}, {
  src: '/images/pay_system/pay.svg',
  alt: 'pay'
}, {
  src: '/images/pay_system/apple_pay.svg',
  alt: 'apple pay'
}, {
  src: '/images/pay_system/google_pay.svg',
  alt: 'google pay'
}, {
  src: '/images/pay_system/bepaid.svg',
  alt: 'bepaid'
} // {
// 	src: '/images/pay_system/mir.webp',
// 	alt: 'mir',
// },
];
var profileLinks = [{
  title: 'Заказы',
  href: '/orders'
}, {
  title: 'Мои данные',
  href: '/profile'
}, {
  title: 'Дисконтная карта',
  href: '/discount-card'
}];
var regExp = {
  phone: /^\+375\s\((29|25|44|33|17)\)\s\d{3}(-\d{2}){2}$/,
  email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  // eslint-disable-next-line no-useless-escape
  date: /^(((0[1-9]|[12]\d|3[01])\-(0[13578]|1[02])\-((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\-(0[13456789]|1[012])\-((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\-02\-((19|[2-9]\d)\d{2}))|(29\-02\-((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/
};
var socialList = [{
  href: 'https://www.instagram.com/fh.by/',
  icon: 'insta',
  label: 'Наш Instagram'
}, // { href: '', icon: 'vk', label: 'Наша VK группа' },
{
  href: 'https://www.facebook.com/fh.belarus',
  icon: 'fb',
  label: 'Наш Facebook'
}, {
  href: 'https://www.pinterest.com/fh_by/',
  icon: 'pinterest',
  label: 'Наш Pinterest'
}];
var messengersList = [{
  href: 'viber://pa?chatURI=fh_by_bot',
  icon: 'viber',
  label: 'Наш Viber'
}, {
  href: 'https://t.me/fh_by_bot',
  icon: 'telegram',
  label: 'Наш Telegram'
}, {
  href: 'https://wa.me/375296332633',
  icon: 'wa',
  label: 'Наш WhatsApp'
}];
var messengersQualityList = [{
  href: 'viber://chat?number=%2B375445849765',
  icon: 'viber',
  label: 'Наш Viber'
}, {
  href: 'https://t.me/+375445849765',
  icon: 'telegram',
  label: 'Наш Telegram'
}, {
  href: 'https://wa.me/375445849765',
  icon: 'wa',
  label: 'Наш WhatsApp'
}];
var getEmoji = function getEmoji(name) {
  var list = {
    checkMark: '2714',
    deliveryTruck: '1F69A'
  };
  var unifiedValue = list[name];
  if (!unifiedValue) return '';
  var emoji = "0x".concat(unifiedValue);
  emoji = String.fromCodePoint(emoji);
  return emoji;
};
var countries = {
  am: {
    name: 'Армения',
    code: '+374',
    mask: '+374 (99) 999-999',
    placeholder: '+374 (__) ___-___',
    icon: ''
  },
  by: {
    name: 'Беларусь',
    code: '+375',
    mask: '+375 (99) 999-99-99',
    placeholder: '+375 (__) ___-__-__',
    icon: ''
  },
  il: {
    name: 'Израиль',
    code: '+972',
    mask: '+\\9\\72 (99) 999-99-99',
    placeholder: '+972 (__) ___-__-__',
    icon: ''
  },
  kz: {
    name: 'Казахстан',
    code: '+7',
    mask: '+7 (999) 999-99-99',
    placeholder: '+7 (___) ___-__-__',
    icon: ''
  },
  kg: {
    name: 'Кыргызстан',
    code: '+996',
    mask: '+\\9\\96 (999) 999-999',
    placeholder: '+996 (___) ___-___',
    icon: ''
  },
  ae: {
    name: 'ОАЭ',
    code: '+971',
    mask: '+\\9\\71 (99) 999-99-99',
    placeholder: '+971 (__) ___-__-__',
    icon: ''
  },
  ru: {
    name: 'Россия',
    code: '+7',
    mask: '+7 (999) 999-99-99',
    placeholder: '+7 (___) ___-__-__',
    icon: ''
  },
  us: {
    name: 'США',
    code: '+1',
    mask: '+1 (999) 999-99-99',
    placeholder: '+1 (___) ___-__-__',
    icon: ''
  },
  tr: {
    name: 'Турция',
    code: '+90',
    mask: '+\\9\\0 (999) 999-99-99',
    placeholder: '+90 (___) ___-__-__',
    icon: ''
  }
};
var getMask = function getMask(phone) {
  if (phone.indexOf('375') === 0) {
    return countries['by'].mask;
  }

  if (phone.indexOf('374') === 0) {
    return countries['am'].mask;
  }

  if (phone.indexOf('996') === 0) {
    return countries['kg'].mask;
  }

  if (phone.indexOf('972') === 0) {
    return countries['il'].mask;
  }

  if (phone.indexOf('971') === 0) {
    return countries['ae'].mask;
  }

  if (phone.indexOf('90') === 0) {
    return countries['tr'].mask;
  }

  if (phone.indexOf('1') === 0) {
    return countries['us'].mask;
  }

  return countries['ru'].mask;
};

/***/ }),

/***/ 10468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDate; }
/* harmony export */ });
function getDate(date) {
  var withLeadingZeros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var result = {};
  var dateObj = new Date(date);
  result.day = dateObj.getDate();
  result.month = dateObj.getMonth() + 1;

  switch (result.month) {
    case 1:
      result.month_rus = 'января';
      break;

    case 2:
      result.month_rus = 'февраля';
      break;

    case 3:
      result.month_rus = 'марта';
      break;

    case 4:
      result.month_rus = 'апреля';
      break;

    case 5:
      result.month_rus = 'мая';
      break;

    case 6:
      result.month_rus = 'июня';
      break;

    case 7:
      result.month_rus = 'июля';
      break;

    case 8:
      result.month_rus = 'августа';
      break;

    case 9:
      result.month_rus = 'сентября';
      break;

    case 10:
      result.month_rus = 'октября';
      break;

    case 11:
      result.month_rus = 'ноября';
      break;

    case 12:
      result.month_rus = 'декабря';
      break;

    default:
      break;
  }

  result.year = dateObj.getFullYear();
  result.hours = dateObj.getHours();
  result.minutes = dateObj.getMinutes();

  if (withLeadingZeros) {
    result.day = result.day >= 10 ? result.day : "0".concat(result.day);
    result.month = result.month >= 10 ? result.month : "0".concat(result.month);
    result.hours = result.hours >= 10 ? result.hours : "0".concat(result.hours);
    result.minutes = result.minutes >= 10 ? result.minutes : "0".concat(result.minutes);
  }

  return result;
}

/***/ }),

/***/ 89729:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getLinkProps = function getLinkProps(_ref) {
  var type = _ref.type,
      valueFromProps = _ref.value,
      propsTitle = _ref.title;
  var href = '';
  var as = '';
  var title = '';
  var value;

  if (typeof valueFromProps === 'string') {
    value = valueFromProps !== null && valueFromProps !== void 0 && valueFromProps.startsWith('/') ? valueFromProps === null || valueFromProps === void 0 ? void 0 : valueFromProps.slice(1) : valueFromProps;
  } else {
    value = valueFromProps;
  }

  switch (type) {
    case 'home':
      href = '/';
      as = '/';
      break;

    case 'wishlist':
      href = '/wishlist';
      as = '/wishlist';
      title = 'Избранное';
      break;

    case 'cart':
      href = '/cart';
      as = '/cart';
      title = 'Корзина';
      break;

    case 'catalog':
      href = value ? '/[...typeSlug]' : '/';
      as = "/".concat(value);
      title = propsTitle || '';
      break;

    case 'product':
      href = '/product/[productId]';
      as = "/product/".concat(value);
      break;

    case 'login':
      href = '/login';
      as = '/login';
      title = 'Авторизация';
      break;

    case 'shops-map':
    case 'shops':
      href = '/shops';
      as = '/shops';
      title = 'Адреса магазинов';
      break;

    case 'shops-list':
      href = '/store-addresses';
      as = '/store-addresses';
      title = 'Адреса магазинов';
      break;

    case 'checkout':
      href = '/checkout';
      as = '/checkout';
      title = 'Оформление заказа';
      break;

    case 'checkout-contacts':
      href = '/checkout/contacts';
      as = '/checkout/contacts';
      title = 'Личная информация';
      break;

    case 'checkout-delivery':
      href = '/checkout/delivery';
      as = '/checkout/delivery';
      title = 'Способ доставки';
      break;

    case 'checkout-payment':
      href = '/checkout/payment';
      as = '/checkout/payment';
      title = 'Способ оплаты';
      break;

    case 'last-order':
      href = "/checkout/success/".concat(value);
      as = "/checkout/success/".concat(value);
      break;

    case 'search':
      href = "".concat(value);
      as = "".concat(value);
      break;

    case 'user-profile':
      href = '/user/profile';
      as = '/user/profile';
      title = 'Мои данные';
      break;

    case 'profile-remove':
      href = '/user/profile/remove';
      as = '/user/profile/remove';
      title = 'Удаление профиля';
      break;

    case 'user-discount':
      href = '/user/discount';
      as = '/user/discount';
      title = 'Персональная скидка';
      break;

    case 'user-newsletters':
      href = '/user/newsletters';
      as = '/user/newsletters';
      title = 'Рассылки';
      break;

    case 'user-returns':
      href = '/user/returns';
      as = '/user/returns';
      title = 'Возврат товара';
      break;

    case 'user-orders':
      href = '/user/orders';
      as = '/user/orders';
      title = 'Заказы';
      break;

    case 'news':
      href = '/news';
      as = '/news';
      title = 'Новости';
      break;

    case 'contacts':
      href = '/contacts';
      as = '/contacts';
      title = 'Наши контакты';
      break;

    case 'news-item':
      href = '/news/[slug]';
      as = "/news/".concat(value);
      break;

    case 'special-offers':
      href = '/special-offers';
      as = '/special-offers';
      title = 'Акции';
      break;

    case 'special-offer':
      href = '/special-offers[slug]';
      as = "/special-offers/".concat(value);
      break;

    case 'brands':
      href = '/brands';
      as = "/brands";
      title = 'Бренды';
      break;

    case 'order':
      href = '/user/order/[orderId]';
      as = "/user/order/".concat(value);
      break;

    case 'return-policy':
      href = '/return-policy';
      as = "/return-policy";
      break;

    case 'new-return':
      href = '/new-return';
      as = "/new-return";
      break;

    case 'success-return':
      href = '/success-return[hash]';
      as = "/success-return/".concat(value);
      break;

    default:
      break;
  }

  return [href, as, title];
};

/* harmony default export */ __webpack_exports__["Z"] = (getLinkProps);

/***/ }),

/***/ 3506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4730);


var _excluded = ["quantity", "cart_quantity"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getProductWithoutQuantity = function getProductWithoutQuantity(products) {
  return products.map(function (_ref) {
    var _ref$quantity = _ref.quantity,
        quantity = _ref$quantity === void 0 ? 0 : _ref$quantity,
        _ref$cart_quantity = _ref.cart_quantity,
        cart_quantity = _ref$cart_quantity === void 0 ? 0 : _ref$cart_quantity,
        product = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

    return _objectSpread({}, product);
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (getProductWithoutQuantity);

/***/ }),

/***/ 67408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ handleError; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82262);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92777);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81531);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72179);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_wrapNativeSuper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46576);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39666);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var ApiError = /*#__PURE__*/function (_Error) {
  (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ApiError, _Error);

  var _super = _createSuper(ApiError);

  function ApiError(message, statusCode) {
    var _this;

    (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ApiError);

    _this = _super.call(this, message);
    _this.statusCode = statusCode;
    return _this;
  }

  return (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ApiError);
}( /*#__PURE__*/(0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_wrapNativeSuper_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Error));

var getConfigInfo = function getConfigInfo(_ref) {
  var url = _ref.url,
      params = _ref.params,
      method = _ref.method;
  return "".concat(url ? ", URL = ".concat(url) : '').concat(params ? ", PARAMS = ".concat(JSON.stringify(params)) : '').concat(method ? ", METHOD = ".concat(method) : '');
};

var getMessage = function getMessage(error, isSentry) {
  if (typeof error === 'string') {
    return "".concat(isSentry ? '' : '. ').concat(error);
  }

  if (error.message && typeof error.message === 'string') {
    return "".concat(isSentry ? '' : '. ').concat(error.message);
  }

  return '';
}; // eslint-disable-next-line import/prefer-default-export


var handleError = function handleError(error) {
  var _error$config;

  if (!error) return;
  var statusCode = error === null || error === void 0 ? void 0 : error.statusCode;
  var config = (_error$config = error === null || error === void 0 ? void 0 : error.config) !== null && _error$config !== void 0 ? _error$config : {};

  if (statusCode != 404) {
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .captureException */ .Tb(new ApiError(getMessage(error, true), statusCode));
  }

  if (statusCode) {
    throw new ApiError("Not Found, StatusCode = ".concat(statusCode).concat(getConfigInfo(config)).concat(getMessage(error)), statusCode);
  } else {
    throw new ApiError("Internal Error, StatusCode = 500".concat(getConfigInfo(config)).concat(getMessage(error)), 500);
  }
};

/***/ }),

/***/ 27299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useWindowWidth = function useWindowWidth() {
  var isClient = true;
  var getWidth = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return isClient ? window.innerWidth : undefined;
  }, [isClient]);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getWidth),
      windowWidth = _useState[0],
      setWindowWidth = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!isClient) {
      return false;
    }

    var handleResize = function handleResize() {
      setWindowWidth(getWidth);
    };

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [getWidth, isClient]);
  return windowWidth;
};

/* harmony default export */ __webpack_exports__["Z"] = (useWindowWidth);

/***/ }),

/***/ 85364:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var numberWithSpaces = function numberWithSpaces(x) {
  var floatSep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var number = x !== null && x !== void 0 ? x : 0;
  var parts = number.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join(floatSep);
};

/* harmony default export */ __webpack_exports__["Z"] = (numberWithSpaces);

/***/ }),

/***/ 42782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ parseCookies; }
/* harmony export */ });
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76489);

function parseCookies(req) {
  return cookie__WEBPACK_IMPORTED_MODULE_0__.parse(req ? req.headers.cookie || '' : document.cookie);
}

/***/ }),

/***/ 62547:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var wordEnd = function wordEnd(number) {
  var textFormsFor125 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var num = Math.abs(number) % 100;
  var num1 = num % 10;

  if (num > 10 && num < 20) {
    return textFormsFor125[2];
  }

  if (num1 > 1 && num1 < 5) {
    return textFormsFor125[1];
  }

  if (num1 === 1) {
    return textFormsFor125[0];
  }

  return textFormsFor125[2];
};

/* harmony default export */ __webpack_exports__["Z"] = (wordEnd);

/***/ }),

/***/ 44019:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 78566:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _defineProperty = __webpack_require__(930);

var _slicedToArray = __webpack_require__(85696);

var _toConsumableArray = __webpack_require__(7980);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Image;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _head = _interop_require_default(__webpack_require__(72717));

var _imageConfig = __webpack_require__(48187);

var _useIntersection = __webpack_require__(90639);

var _imageConfigContext = __webpack_require__(89239);

var _utils = __webpack_require__(99475);

var _normalizeTrailingSlash = __webpack_require__(24969);

function Image(_param) {
  var _linkProps;

  var src = _param.src,
      sizes = _param.sizes,
      _param$unoptimized = _param.unoptimized,
      unoptimized = _param$unoptimized === void 0 ? false : _param$unoptimized,
      _param$priority = _param.priority,
      priority = _param$priority === void 0 ? false : _param$priority,
      loading = _param.loading,
      _param$lazyRoot = _param.lazyRoot,
      lazyRoot = _param$lazyRoot === void 0 ? null : _param$lazyRoot,
      lazyBoundary = _param.lazyBoundary,
      className = _param.className,
      quality = _param.quality,
      width = _param.width,
      height = _param.height,
      style = _param.style,
      objectFit = _param.objectFit,
      objectPosition = _param.objectPosition,
      onLoadingComplete = _param.onLoadingComplete,
      _param$placeholder = _param.placeholder,
      placeholder = _param$placeholder === void 0 ? 'empty' : _param$placeholder,
      blurDataURL = _param.blurDataURL,
      all = _object_without_properties_loose(_param, ["src", "sizes", "unoptimized", "priority", "loading", "lazyRoot", "lazyBoundary", "className", "quality", "width", "height", "style", "objectFit", "objectPosition", "onLoadingComplete", "placeholder", "blurDataURL"]);

  var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
  var config = (0, _react).useMemo(function () {
    var c = configEnv || configContext || _imageConfig.imageConfigDefault;
    var allSizes = [].concat(_toConsumableArray(c.deviceSizes), _toConsumableArray(c.imageSizes)).sort(function (a, b) {
      return a - b;
    });
    var deviceSizes = c.deviceSizes.sort(function (a, b) {
      return a - b;
    });
    return _extends({}, c, {
      allSizes: allSizes,
      deviceSizes: deviceSizes
    });
  }, [configContext]);
  var rest = all;
  var layout = sizes ? 'responsive' : 'intrinsic';

  if ('layout' in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout; // Remove property so it's not spread on <img>:

    delete rest.layout;
  }

  var loader = defaultImageLoader;

  if ('loader' in rest) {
    if (rest.loader) {
      var customImageLoader = rest.loader;

      var _tmp;

      _tmp = function _tmp(obj) {
        var _ = obj.config,
            opts = _object_without_properties_loose(obj, ["config"]); // The config object is internal only so we must
        // not pass it to the user-defined loader()


        return customImageLoader(opts);
      }, loader = _tmp, _tmp;
    } // Remove property so it's not spread on <img>


    delete rest.loader;
  }

  var staticSrc = '';

  if (isStaticImport(src)) {
    var staticImageData = isStaticRequire(src) ? src.default : src;

    if (!staticImageData.src) {
      throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
    }

    blurDataURL = blurDataURL || staticImageData.blurDataURL;
    staticSrc = staticImageData.src;

    if (!layout || layout !== 'fill') {
      height = height || staticImageData.height;
      width = width || staticImageData.width;

      if (!staticImageData.height || !staticImageData.width) {
        throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
      }
    }
  }

  src = typeof src === 'string' ? src : staticSrc;
  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src.startsWith('data:') || src.startsWith('blob:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  if ( true && loadedImageURLs.has(src)) {
    isLazy = false;
  }

  if (config.unoptimized) {
    unoptimized = true;
  }

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      blurComplete = _useState2[0],
      setBlurComplete = _useState2[1];

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootRef: lazyRoot,
    rootMargin: lazyBoundary || '200px',
    disabled: !isLazy
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersection = _useIntersection3[0],
      isIntersected = _useIntersection3[1],
      resetIntersected = _useIntersection3[2];

  var isVisible = !isLazy || isIntersected;
  var wrapperStyle = {
    boxSizing: 'border-box',
    display: 'block',
    overflow: 'hidden',
    width: 'initial',
    height: 'initial',
    background: 'none',
    opacity: 1,
    border: 0,
    margin: 0,
    padding: 0
  };
  var sizerStyle = {
    boxSizing: 'border-box',
    display: 'block',
    width: 'initial',
    height: 'initial',
    background: 'none',
    opacity: 1,
    border: 0,
    margin: 0,
    padding: 0
  };
  var hasSizer = false;
  var sizerSvgUrl;
  var layoutStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    objectFit: objectFit,
    objectPosition: objectPosition
  };
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);

  if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }

  var imgStyle = Object.assign({}, style, layoutStyle);
  var blurStyle = placeholder === 'blur' && !blurComplete ? {
    backgroundSize: objectFit || 'cover',
    backgroundPosition: objectPosition || '0% 0%',
    filter: 'blur(20px)',
    backgroundImage: "url(\"".concat(blurDataURL, "\")")
  } : {};

  if (layout === 'fill') {
    // <Image src="i.png" layout="fill" />
    wrapperStyle.display = 'block';
    wrapperStyle.position = 'absolute';
    wrapperStyle.top = 0;
    wrapperStyle.left = 0;
    wrapperStyle.bottom = 0;
    wrapperStyle.right = 0;
  } else if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined') {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");

    if (layout === 'responsive') {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle.display = 'block';
      wrapperStyle.position = 'relative';
      hasSizer = true;
      sizerStyle.paddingTop = paddingTop;
    } else if (layout === 'intrinsic') {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle.display = 'inline-block';
      wrapperStyle.position = 'relative';
      wrapperStyle.maxWidth = '100%';
      hasSizer = true;
      sizerStyle.maxWidth = '100%';
      sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
    } else if (layout === 'fixed') {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle.display = 'inline-block';
      wrapperStyle.position = 'relative';
      wrapperStyle.width = widthInt;
      wrapperStyle.height = heightInt;
    }
  } else {
    // <Image src="i.png" />
    if (false) {}
  }

  var imgAttributes = {
    src: emptyDataURL,
    srcSet: undefined,
    sizes: undefined
  };

  if (isVisible) {
    imgAttributes = generateImgAttrs({
      config: config,
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes,
      loader: loader
    });
  }

  var srcString = src;

  if (false) { var fullUrl; }

  var imageSrcSetPropName = 'imagesrcset';
  var imageSizesPropName = 'imagesizes';

  if (false) {}

  var linkProps = (_linkProps = {}, _defineProperty(_linkProps, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_linkProps, imageSizesPropName, imgAttributes.sizes), _defineProperty(_linkProps, "crossOrigin", rest.crossOrigin), _linkProps);
  var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
  var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
  var previousImageSrc = (0, _react).useRef(src);
  (0, _react).useEffect(function () {
    onLoadingCompleteRef.current = onLoadingComplete;
  }, [onLoadingComplete]);
  useLayoutEffect(function () {
    if (previousImageSrc.current !== src) {
      resetIntersected();
      previousImageSrc.current = src;
    }
  }, [resetIntersected, src]);

  var imgElementArgs = _extends({
    isLazy: isLazy,
    imgAttributes: imgAttributes,
    heightInt: heightInt,
    widthInt: widthInt,
    qualityInt: qualityInt,
    layout: layout,
    className: className,
    imgStyle: imgStyle,
    blurStyle: blurStyle,
    loading: loading,
    config: config,
    unoptimized: unoptimized,
    placeholder: placeholder,
    loader: loader,
    srcString: srcString,
    onLoadingCompleteRef: onLoadingCompleteRef,
    setBlurComplete: setBlurComplete,
    setIntersection: setIntersection,
    isVisible: isVisible,
    noscriptSizes: sizes
  }, rest);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    style: wrapperStyle
  }, hasSizer ? /*#__PURE__*/_react.default.createElement("span", {
    style: sizerStyle
  }, sizerSvgUrl ? /*#__PURE__*/_react.default.createElement("img", {
    style: {
      display: 'block',
      maxWidth: '100%',
      width: 'initial',
      height: 'initial',
      background: 'none',
      opacity: 1,
      border: 0,
      margin: 0,
      padding: 0
    },
    alt: "",
    "aria-hidden": true,
    src: sizerSvgUrl
  }) : null) : null, /*#__PURE__*/_react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // Note how we omit the `href` attribute, as it would only be relevant
  // for browsers that do not support `imagesrcset`, and in those cases
  // it would likely cause the incorrect image to be preloaded.
  //
  // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset

  /*#__PURE__*/
  _react.default.createElement(_head.default, null, /*#__PURE__*/_react.default.createElement("link", Object.assign({
    key: '__nimg-' + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
    rel: "preload",
    as: "image",
    href: imgAttributes.srcSet ? undefined : imgAttributes.src
  }, linkProps))) : null);
}

'client';

function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

if (false) {}

var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && (['lazy', 'eager', undefined]));

function imgixLoader(_ref) {
  var config = _ref.config,
      src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
  var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
  var params = url.searchParams; // auto params can be combined with comma separation, or reiteration

  params.set('auto', params.getAll('auto').join(',') || 'format');
  params.set('fit', params.get('fit') || 'max');
  params.set('w', params.get('w') || width.toString());

  if (quality) {
    params.set('q', quality.toString());
  }

  return url.href;
}

function akamaiLoader(_ref2) {
  var config = _ref2.config,
      src = _ref2.src,
      width = _ref2.width;
  return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}

function cloudinaryLoader(_ref3) {
  var config = _ref3.config,
      src = _ref3.src,
      width = _ref3.width,
      quality = _ref3.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ['f_auto', 'c_limit', 'w_' + width, 'q_' + (quality || 'auto')];
  var paramsString = params.join(',') + '/';
  return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}

function customLoader(_ref4) {
  var src = _ref4.src;
  throw new Error("Image with src \"".concat(src, "\" is missing \"loader\" prop.") + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}

function defaultLoader(_ref5) {
  var config = _ref5.config,
      src = _ref5.src,
      width = _ref5.width,
      quality = _ref5.quality;

  if (false) { var _require, hasMatch, parsedSrc, missingValues; }

  if (src.endsWith('.svg') && !config.dangerouslyAllowSVG) {
    // Special case to make svg serve as-is to avoid proxying
    // through the built-in Image Optimization API.
    return src;
  }

  return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

var loaders = new Map([['default', defaultLoader], ['imgix', imgixLoader], ['cloudinary', cloudinaryLoader], ['akamai', akamaiLoader], ['custom', customLoader]]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && (['fill', 'fixed', 'intrinsic', 'responsive', undefined]));

function isStaticRequire(src) {
  return src.default !== undefined;
}

function isStaticImageData(src) {
  return src.src !== undefined;
}

function isStaticImport(src) {
  return typeof src === 'object' && (isStaticRequire(src) || isStaticImageData(src));
}

function getWidths(_ref6, width, layout, sizes) {
  var deviceSizes = _ref6.deviceSizes,
      allSizes = _ref6.allSizes;

  if (sizes && (layout === 'fill' || layout === 'responsive')) {
    // Find all the "vw" percent sizes used in the sizes prop
    var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
    var percentSizes = [];

    for (var match; match = viewportWidthRe.exec(sizes); match) {
      percentSizes.push(parseInt(match[2]));
    }

    if (percentSizes.length) {
      var smallestRatio = Math.min.apply(Math, percentSizes) * 0.01;
      return {
        widths: allSizes.filter(function (s) {
          return s >= deviceSizes[0] * smallestRatio;
        }),
        kind: 'w'
      };
    }

    return {
      widths: allSizes,
      kind: 'w'
    };
  }

  if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
    return {
      widths: deviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set( // > This means that most OLED screens that say they are 3x resolution,
  // > are actually 3x in the green color, but only 1.5x in the red and
  // > blue colors. Showing a 3x resolution image in the app vs a 2x
  // > resolution image will be visually the same, though the 3x image
  // > takes significantly more data. Even true 3x resolution screens are
  // > wasteful as the human eye cannot see that level of detail without
  // > something like a magnifying glass.
  // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
  [width, width * 2
  /*, width * 3*/
  ].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function generateImgAttrs(_ref7) {
  var config = _ref7.config,
      src = _ref7.src,
      unoptimized = _ref7.unoptimized,
      layout = _ref7.layout,
      width = _ref7.width,
      quality = _ref7.quality,
      sizes = _ref7.sizes,
      loader = _ref7.loader;

  if (unoptimized) {
    return {
      src: src,
      srcSet: undefined,
      sizes: undefined
    };
  }

  var _getWidths = getWidths(config, width, layout, sizes),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  return {
    sizes: !sizes && kind === 'w' ? '100vw' : sizes,
    srcSet: widths.map(function (w, i) {
      return "".concat(loader({
        config: config,
        src: src,
        quality: quality,
        width: w
      }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
    }).join(', '),
    // It's intended to keep `src` the last attribute because React updates
    // attributes in order. If we keep `src` the first one, Safari will
    // immediately start to fetch `src`, before `sizes` and `srcSet` are even
    // updated by React. That causes multiple unnecessary requests if `srcSet`
    // and `sizes` are defined.
    // This bug cannot be reproduced in Chrome or Firefox.
    src: loader({
      config: config,
      src: src,
      quality: quality,
      width: widths[last]
    })
  };
}

function getInt(x) {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x === 'string') {
    return parseInt(x, 10);
  }

  return undefined;
}

function defaultImageLoader(loaderProps) {
  var ref;
  var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || 'default';
  var load = loaders.get(loaderKey);

  if (load) {
    return load(loaderProps);
  }

  throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(loaderKey));
} // See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.


function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
  if (!img || img.src === emptyDataURL || img['data-loaded-src'] === src) {
    return;
  }

  img['data-loaded-src'] = src;
  var p = 'decode' in img ? img.decode() : Promise.resolve();
  p.catch(function () {}).then(function () {
    if (!img.parentNode) {
      // Exit early in case of race condition:
      // - onload() is called
      // - decode() is called but incomplete
      // - unmount is called
      // - decode() completes
      return;
    }

    loadedImageURLs.add(src);

    if (placeholder === 'blur') {
      setBlurComplete(true);
    }

    if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
      var naturalWidth = img.naturalWidth,
          naturalHeight = img.naturalHeight; // Pass back read-only primitive values but not the
      // underlying DOM element because it could be misused.

      onLoadingCompleteRef.current({
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight
      });
    }

    if (false) { var parent, ref; }
  });
}

var ImageElement = function ImageElement(_param) {
  var imgAttributes = _param.imgAttributes,
      heightInt = _param.heightInt,
      widthInt = _param.widthInt,
      qualityInt = _param.qualityInt,
      layout = _param.layout,
      className = _param.className,
      imgStyle = _param.imgStyle,
      blurStyle = _param.blurStyle,
      isLazy = _param.isLazy,
      placeholder = _param.placeholder,
      loading = _param.loading,
      srcString = _param.srcString,
      config = _param.config,
      unoptimized = _param.unoptimized,
      loader = _param.loader,
      onLoadingCompleteRef = _param.onLoadingCompleteRef,
      setBlurComplete = _param.setBlurComplete,
      setIntersection = _param.setIntersection,
      _onLoad = _param.onLoad,
      _onError = _param.onError,
      isVisible = _param.isVisible,
      noscriptSizes = _param.noscriptSizes,
      rest = _object_without_properties_loose(_param, ["imgAttributes", "heightInt", "widthInt", "qualityInt", "layout", "className", "imgStyle", "blurStyle", "isLazy", "placeholder", "loading", "srcString", "config", "unoptimized", "loader", "onLoadingCompleteRef", "setBlurComplete", "setIntersection", "onLoad", "onError", "isVisible", "noscriptSizes"]);

  loading = isLazy ? 'lazy' : loading;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    "data-nimg": layout,
    className: className,
    style: _extends({}, imgStyle, blurStyle),
    ref: (0, _react).useCallback(function (img) {
      if (false) {}

      setIntersection(img);

      if (img == null ? void 0 : img.complete) {
        handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
      }
    }, [setIntersection, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete]),
    onLoad: function onLoad(event) {
      var img = event.currentTarget;
      handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);

      if (_onLoad) {
        _onLoad(event);
      }
    },
    onError: function onError(event) {
      if (placeholder === 'blur') {
        // If the real image fails to load, this will still remove the placeholder.
        setBlurComplete(true);
      }

      if (_onError) {
        _onError(event);
      }
    }
  })), (isLazy || placeholder === 'blur') && /*#__PURE__*/_react.default.createElement("noscript", null, /*#__PURE__*/_react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
    config: config,
    src: srcString,
    unoptimized: unoptimized,
    layout: layout,
    width: widthInt,
    quality: qualityInt,
    sizes: noscriptSizes,
    loader: loader
  }), {
    decoding: "async",
    "data-nimg": layout,
    style: imgStyle,
    className: className,
    // @ts-ignore - TODO: upgrade to `@types/react@17`
    loading: loading
  }))));
};

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(64957);

var _addLocale = __webpack_require__(57995);

var _routerContext = __webpack_require__(30647);

var _appRouterContext = __webpack_require__(51992);

var _useIntersection = __webpack_require__(90639);

var _getDomainLocale = __webpack_require__(44019);

var _addBasePath = __webpack_require__(70227);

'client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options)).catch(function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react.default.startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react.default.forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react.default.createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react.default.useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react.default.useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react.default.useRef(href);

  var previousAs = _react.default.useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react.default.Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react.default.useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react.default.useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react.default.cloneElement(child, childProps) : /*#__PURE__*/_react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(26286);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements.delete(element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 22741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

var _regeneratorRuntime = __webpack_require__(87794);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "AppInitialProps", ({
  enumerable: true,
  get: function get() {
    return _utils.AppInitialProps;
  }
}));
Object.defineProperty(exports, "NextWebVitalsMetric", ({
  enumerable: true,
  get: function get() {
    return _utils.NextWebVitalsMetric;
  }
}));
Object.defineProperty(exports, "AppType", ({
  enumerable: true,
  get: function get() {
    return _utils.AppType;
  }
}));
exports["default"] = void 0;

var _async_to_generator = (__webpack_require__(60932)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _utils = __webpack_require__(99475);

function appGetInitialProps(_) {
  return _appGetInitialProps.apply(this, arguments);
}

function _appGetInitialProps() {
  _appGetInitialProps =
  /**
  * `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
  * This allows for keeping state between navigation, custom error handling, injecting additional data.
  */
  _async_to_generator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Component, ctx, pageProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.next = 3;
            return (0, _utils).loadGetInitialProps(Component, ctx);

          case 3:
            pageProps = _context.sent;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _appGetInitialProps.apply(this, arguments);
}

var _Component;

var App = /*#__PURE__*/function (_Component2) {
  _inherits(App, _Component2);

  var _super = _createSuper(App);

  function App() {
    _classCallCheck(this, App);

    return _super.apply(this, arguments);
  }

  _createClass(App, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps;
      return /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, pageProps));
    }
  }]);

  return App;
}(_Component = _react.default.Component);

App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
exports["default"] = App;

/***/ }),

/***/ 78000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AmpStateContext = _react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 9470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AppRouterContext = _react.default.createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react.default.createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react.default.createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react.default.createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 73579:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _loadable = _interop_require_default(__webpack_require__(23668));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable.default;
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if ( true && loadableOptions.suspense) {
    throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
  }

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

'client';
var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react.default.createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 72717:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _sideEffect = _interop_require_default(__webpack_require__(11585));

var _ampContext = __webpack_require__(78000);

var _headManagerContext = __webpack_require__(15850);

var _ampMode = __webpack_require__(9470);

var _utils = __webpack_require__(99475);

'client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react.default.cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var LoadableContext = _react.default.createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _loadableContext = __webpack_require__(3982);

var _ref =  false ? 0 : __webpack_require__(61688),
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react.default.lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react.default.useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react.default.useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react.default.useMemo(function () {
      if (state.loading || state.error) {
        return _react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react.default.createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react.default.createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react.default.forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      }).catch(function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks.delete(callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 11585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.delete(props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 8384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store_0 = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/currencySlice.js
var currencySlice = __webpack_require__(74542);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/userSlice.js
var userSlice = __webpack_require__(46789);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 4 modules
var redux_toolkit_esm = __webpack_require__(35357);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/menuSlice.js



var menuInitialState = {
  footer: [],
  middle: [],
  top: [],
  loaded: false,
  loading: false,
  error: null
};
var menu = (0,redux_toolkit_esm/* createSlice */.oM)({
  name: 'menu',
  initialState: menuInitialState,
  reducers: {
    requestMenu: function requestMenu(state) {
      state.loading = true;
    },
    successMenu: function successMenu(state, _ref) {
      var payload = _ref.payload;

      if (payload) {
        var _payload$footer, _payload$middle, _payload$top;

        var footer = (_payload$footer = payload === null || payload === void 0 ? void 0 : payload.footer) !== null && _payload$footer !== void 0 ? _payload$footer : [];
        var middle = (_payload$middle = payload === null || payload === void 0 ? void 0 : payload.middle) !== null && _payload$middle !== void 0 ? _payload$middle : [];
        var top = (_payload$top = payload === null || payload === void 0 ? void 0 : payload.top) !== null && _payload$top !== void 0 ? _payload$top : [];
        state.top = top;
        state.middle = middle;
        state.footer = footer;
        state.loaded = true;
      }

      state.loading = false;
      state.error = null;
    },
    failureMenu: function failureMenu(state, _ref2) {
      var payload = _ref2.payload;
      state.loading = false;
      state.error = payload;
    }
  }
});
var fetchMenu = function fetchMenu() {
  return /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dispatch, getState, _ref3) {
      var api, _menu, resp, _resp$result, result, _menu2, footer, top, middle;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref3.api;
              _context.prev = 1;
              _menu = getState().menu;

              if (!_menu.loaded) {
                _context.next = 8;
                break;
              }

              dispatch(successMenu());
              return _context.abrupt("return");

            case 8:
              dispatch(requestMenu());
              _context.next = 11;
              return api.menu();

            case 11:
              resp = _context.sent;
              _resp$result = resp.result, result = _resp$result === void 0 ? 'success' : _resp$result, _menu2 = resp.menu;

              if (result === 'success') {
                footer = _menu2.footer, top = _menu2.top, middle = _menu2.middle;
                dispatch(successMenu({
                  footer: footer,
                  top: top,
                  middle: middle
                }));
              } else {
                dispatch(failureMenu(resp));
              }

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              dispatch(failureMenu(_context.t0.toString()));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getMenu = (0,es/* createSelector */.P1)(function (state) {
  return state.menu;
}, function (menu) {
  var footer = menu.footer,
      top = menu.top,
      middle = menu.middle;
  return {
    footer: footer,
    top: top,
    middle: middle
  };
});
var _menu$actions = menu.actions,
    requestMenu = _menu$actions.requestMenu,
    successMenu = _menu$actions.successMenu,
    failureMenu = _menu$actions.failureMenu;

/* harmony default export */ var menuSlice = (menu.reducer);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var react_redux_es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(53416);
// EXTERNAL MODULE: ./node_modules/device-detector-js/dist/index.js
var dist = __webpack_require__(63494);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/categoriesSlice.js
var categoriesSlice = __webpack_require__(11012);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/catalogSlice.js
var catalogSlice = __webpack_require__(35955);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/productSlice.js
var productSlice = __webpack_require__(73278);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/checkoutSlice.js
var checkoutSlice = __webpack_require__(10604);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/wishlistSlice.js + 1 modules
var wishlistSlice = __webpack_require__(94650);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/viewedSlice.js
var viewedSlice = __webpack_require__(89780);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/shopsSlice.js
var shopsSlice = __webpack_require__(76137);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/cartSlice.js
var cartSlice = __webpack_require__(78955);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/pagesSlice.js
var pagesSlice = __webpack_require__(66681);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/searchSlice.js
var searchSlice = __webpack_require__(98029);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/profileSlice.js
var profileSlice = __webpack_require__(82025);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/lookSlice.js
var lookSlice = __webpack_require__(53662);
;// CONCATENATED MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/subscribeSlice.js



var initialState = {
  data: {},
  loading: false,
  error: null
};
var subscribe = (0,redux_toolkit_esm/* createSlice */.oM)({
  name: 'subscribe',
  initialState: initialState,
  reducers: {
    requestSubscribe: function requestSubscribe(state) {
      state.loading = true;
    },
    successSubscribe: function successSubscribe(state, _ref) {
      var payload = _ref.payload;
      state.data = payload;
      state.loading = false;
      state.error = null;
    },
    failureSubscribe: function failureSubscribe(state, _ref2) {
      var payload = _ref2.payload;
      state.loading = false;
      state.error = payload;
    }
  }
});
var subscribeToBlackFriday = function subscribeToBlackFriday(params) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref3) {
      var api, resp, _resp$result, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref3.api;
              _context.prev = 1;
              dispatch(requestSubscribe());
              _context.next = 5;
              return api.subscriptionsSubscribe(params);

            case 5:
              resp = _context.sent;
              _resp$result = resp.result, result = _resp$result === void 0 ? 'success' : _resp$result;

              if (result === 'success') {
                dispatch(successSubscribe(resp));
              } else {
                dispatch(failureSubscribe(resp));
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              dispatch(failureSubscribe(_context.t0.toString()));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getSubscribeState = (0,es/* createSelector */.P1)(function (state) {
  return state.subscribe;
}, function (subscribe) {
  var loading = subscribe.loading,
      error = subscribe.error,
      data = subscribe.data;
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var _subscribe$actions = subscribe.actions,
    requestSubscribe = _subscribe$actions.requestSubscribe,
    successSubscribe = _subscribe$actions.successSubscribe,
    failureSubscribe = _subscribe$actions.failureSubscribe;

/* harmony default export */ var subscribeSlice = (subscribe.reducer);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/node_modules/axios/index.js
var axios = __webpack_require__(35114);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./node_modules/@fh-components/fh-js-api-core/api/index.js




var _excluded = ["cancelToken", "inlineSlug"],
    _excluded2 = ["cancelToken", "params"],
    _excluded3 = ["cancelToken", "params"],
    _excluded4 = ["cancelToken"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





(axios_default()).defaults.paramsSerializer = function (params) {
  return lib_default().stringify(params);
};

var Api = /*#__PURE__*/function () {
  function Api(baseUrl, appBuildVersion, deviceType) {
    var _this = this;

    (0,classCallCheck/* default */.Z)(this, Api);

    (0,defineProperty/* default */.Z)(this, "fullUrl", function (url, inlineSlug) {
      return inlineSlug ? "".concat(_this.baseUrl, "/").concat(url, "/").concat(inlineSlug) : "".concat(_this.baseUrl, "/").concat(url);
    });

    this.getState = null;
    this.baseUrl = baseUrl;
    this.appBuildVersion = appBuildVersion;
    this.deviceType = deviceType;
    this.menu = this._get('v2/page/layout/menu');
    this.getSession = this._get('v2/session-new');
    this.getSessionSettings = this._get('v2/session-new/settings');
    this.products = this._get('v2/catalog');
    this.filters = this._get('v2/catalog/filters');
    this.catalogSearch = this._get('v2/catalog/search');
    this.product = this._get('product');
    this.productBack = this._get('v2/product');
    this.newProductBack = this._get('v2/product/model');
    this.productCollections = this._get('v2/product/model/collections');
    this.productFromCollections = this._get('v2/product/model/collections/paginate');
    this.productLooks = this._get('v2/product/model/look');
    this.productShops = this._get('v2/product/model/shops');
    this.countriesOfDelivery = this._get('v2/delivery/countries');
    this.currencyRates = this._get('back/currency');
    this.login = this._post('v2/auth/login');
    this.pushToken = this._post('v2/push-tokens/put');
    this.deletePushToken = this._post('v2/push-tokens/delete');
    this.logout = this._post('v2/auth/logout');
    this.removeProfile = this._post('v2/auth/remove');
    this.sendSmsCode = this._post('v2/auth/sms');
    this.shops = this._get('back/shops');
    this.validateCheckoutPersonalData = this._post('back/order/personal-info');
    this.validateCheckoutDelivery = this._post('back/order/delivery');
    this.checkout = this._post('back/order');
    this.getLastOrder = this._get('v2/order/success');
    this.getErrorPaymentInfo = this._get('v2/service/payment/info');
    this.emailVerify = this._post('v2/client/email-verify');
    this.getRedirectInfo = this._get('v2/service/payment/redirect');
    this.userProfileUpdate = this._post('v2/client/profile');
    this.profileSubscriptions = this._get('v2/client/profile/subscriptions');
    this.addressDelete = this._post('back/profile/address/delete');
    this.userOrders = this._get('v2/client/order');
    this.userOrder = this._get('v2/client/order/show');
    this.userDiscount = this._get('v2/client/profile/discount');
    this.userRefunds = this._get('v2/client/refund');
    this.returnableProducts = this._get('v2/client/order/products');
    this.sendRefund = this._post('v2/order/refund');
    this.createFavoriteBrand = this._post('v2/favorite-brands/create');
    this.deleteFavoriteBrand = this._post('v2/favorite-brands/delete');
    this.refundInfo = this._get('v2/order/refund/hash');
    this.pages = this._get('back/pages');
    this.news = this._get('v2/articles');
    this.specialOffers = this._get('v2/special-offers');
    this.promocode = this._post('v2/order/promo-code/apply');
    this.newSearch = this._get('search/autocomplete');
    this.search = this._get('back/search');
    this.searchPage = this._get('search');
    this.barcode = this._get('barcode');
    this.subscribeByEmail = this._post('back/subscribe/email');
    this.certificateApply = this._post('v2/order/certificate/apply');
    this.certificateRemove = this._post('v2/order/certificate/remove');
    this.allCertificateRemove = this._post('v2/order/certificate/remove/all');
    this.brands = this._get('v2/brands');
    this.look = this._get('back/looks');
    this.subscriptions = this._get('v2/subscription-popups');
    this.phoneValidate = this._post('v2/validate/phone');
    this.emailValidate = this._post('v2/validate/email');
    this.subscriptionsSubscribe = this._post('v2/subscription-popups/subscribe');
    this.categoryTreeBySlug = this._get('v2/page/layout');
    this.categoryTreeRoots = this._get('v2/page/layout/root');
    this.categoryTree = this._get('v2/page/catalog');
    this.newCheckout = this._post('v2/order/checkout');
    this.shopsNew = this._get('v2/order/shops');
    this.timeSlots = this._post('v2/delivery/slots');
    this.wishlist = this._get('v2/session-new/favorites/new');
    this.addToWishlist = this._post('v2/session-new/favorites/new/create');
    this.removeFromWishlist = this._post('v2/session-new/favorites/new/delete');
    this.updateWishlist = this._post('v2/session-new/favorites/new/update');
    this.history = this._get('v2/session-new/history');
    this.addProductToViewed = this._post('v2/session-new/history/put');
    this.cart = this._get('v2/session-new/cart/dispatch');
    this.asyncCart = this._get('v2/session-new/cart');
    this.addToCart = this._post('v2/session-new/cart/put');
    this.removeFromCart = this._post('v2/session-new/cart/delete');
    this.updateCart = this._post('v2/session-new/cart/update');
    this.addLookToCart = this._post('v2/session-new/cart/put-batch');
    this.deliveryInfo = this._get('v2/session-new/cart/delivery-info');
    this.feedback = this._get('v2/feedback');
    this.marketProducts = this._get('v2/product/model/list');
    this.postFeedback = this._post('v2/feedback/create');
    this.getRegions = this._get('v2/regions');
    this.setRegion = this._post('v2/regions/set-region');
  }

  (0,createClass/* default */.Z)(Api, [{
    key: "setStateReceivingFunction",
    value: function setStateReceivingFunction(f) {
      this.getState = f;
    }
  }, {
    key: "_get",
    value: function _get(url) {
      var _this2 = this;

      return function () {
        var _getSessionToken, _getSessionSocketId;

        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var token = (_getSessionToken = (0,sessionSlice/* getSessionToken */.YW)(_this2.getState())) !== null && _getSessionToken !== void 0 ? _getSessionToken : null;
        var socketId = (_getSessionSocketId = (0,sessionSlice/* getSessionSocketId */.NW)(_this2.getState())) !== null && _getSessionSocketId !== void 0 ? _getSessionSocketId : null;

        var _query$cancelToken = query.cancelToken,
            cancelToken = _query$cancelToken === void 0 ? axios_default().CancelToken.source().token : _query$cancelToken,
            _query$inlineSlug = query.inlineSlug,
            inlineSlug = _query$inlineSlug === void 0 ? '' : _query$inlineSlug,
            params = (0,objectWithoutProperties/* default */.Z)(query, _excluded);

        var headers = {
          'Device-Type': _this2.deviceType
        };

        if (token) {
          headers = _objectSpread(_objectSpread({}, headers), {}, {
            Authorization: "Bearer ".concat(token)
          });
        }

        if (_this2.appBuildVersion) {
          headers = _objectSpread(_objectSpread({}, headers), {}, {
            'X-Client-Version': _this2.appBuildVersion
          });
        }

        if (socketId) {
          headers = _objectSpread(_objectSpread({}, headers), {}, {
            'X-Socket-ID': socketId
          });
        }

        return axios_default().get(_this2.fullUrl(url, inlineSlug), {
          cancelToken: cancelToken,
          params: params,
          headers: headers
        }).then(function (response) {
          return response.data;
        }).catch(function (error) {
          var _error$response, _error$response2, _error$response3;

          var config = ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.config) || {};
          var method = config.method,
              url = config.url,
              params = config.params;
          return {
            result: 'error',
            statusCode: (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status,
            config: {
              method: method,
              url: url,
              params: params
            },
            data: (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data,
            message: error.message
          };
        });
      };
    }
  }, {
    key: "_post",
    value: function _post(url) {
      var _this3 = this;

      return function () {
        var _getSessionToken2, _getSessionSocketId2;

        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var token = (_getSessionToken2 = (0,sessionSlice/* getSessionToken */.YW)(_this3.getState())) !== null && _getSessionToken2 !== void 0 ? _getSessionToken2 : null;
        var socketId = (_getSessionSocketId2 = (0,sessionSlice/* getSessionSocketId */.NW)(_this3.getState())) !== null && _getSessionSocketId2 !== void 0 ? _getSessionSocketId2 : null;

        var _query$cancelToken2 = query.cancelToken,
            cancelToken = _query$cancelToken2 === void 0 ? axios_default().CancelToken.source().token : _query$cancelToken2,
            params = query.params,
            data = (0,objectWithoutProperties/* default */.Z)(query, _excluded2);

        var headers = {
          'Device-Type': _this3.deviceType
        };

        if (token) {
          headers = _objectSpread(_objectSpread({}, headers), {}, {
            Authorization: "Bearer ".concat(token)
          });
        }

        if (_this3.appBuildVersion) {
          headers = _objectSpread(_objectSpread({}, headers), {}, {
            'X-Client-Version': _this3.appBuildVersion
          });
        }

        if (socketId) {
          headers = _objectSpread(_objectSpread({}, headers), {}, {
            'X-Socket-ID': "".concat(socketId)
          });
        }

        return axios_default().post(_this3.fullUrl(url), data, {
          cancelToken: cancelToken,
          headers: headers,
          params: params
        }).then(function (response) {
          return response.data;
        }).catch(function (error) {
          var _error$response4, _error$response5, _error$response6, _error$response6$data;

          return _objectSpread(_objectSpread({
            result: 'error',
            statusCode: (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status
          }, (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.data), {}, {
            message: ((_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.message) || error.message
          });
        });
      };
    }
  }, {
    key: "_put",
    value: function _put(url) {
      var _this4 = this;

      return function () {
        var _getSessionToken3;

        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var token = (_getSessionToken3 = (0,sessionSlice/* getSessionToken */.YW)(_this4.getState())) !== null && _getSessionToken3 !== void 0 ? _getSessionToken3 : null;

        var _query$cancelToken3 = query.cancelToken,
            cancelToken = _query$cancelToken3 === void 0 ? axios_default().CancelToken.source().token : _query$cancelToken3,
            params = query.params,
            data = (0,objectWithoutProperties/* default */.Z)(query, _excluded3);

        var headers = {};

        if (token) {
          headers = {
            Authorization: "Bearer ".concat(token)
          };
        }

        if (_this4.appBuildVersion) {
          headers = _objectSpread(_objectSpread({}, headers), {}, {
            'X-Client-Version': _this4.appBuildVersion
          });
        }

        return axios_default().put(_this4.fullUrl(url), data, {
          cancelToken: cancelToken,
          headers: headers,
          params: params
        }).then(function (response) {
          return response.data;
        }).catch(function (error) {
          var _error$response7, _error$response8, _error$response9, _error$response9$data;

          return _objectSpread(_objectSpread({
            result: 'error',
            statusCode: (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : _error$response7.status
          }, (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : _error$response8.data), {}, {
            message: ((_error$response9 = error.response) === null || _error$response9 === void 0 ? void 0 : (_error$response9$data = _error$response9.data) === null || _error$response9$data === void 0 ? void 0 : _error$response9$data.message) || error.message
          });
        });
      };
    }
  }, {
    key: "_delete",
    value: function _delete(url) {
      var _this5 = this;

      return function () {
        var _getSessionToken4;

        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var token = (_getSessionToken4 = (0,sessionSlice/* getSessionToken */.YW)(_this5.getState())) !== null && _getSessionToken4 !== void 0 ? _getSessionToken4 : null;

        var _query$cancelToken4 = query.cancelToken,
            cancelToken = _query$cancelToken4 === void 0 ? axios_default().CancelToken.source().token : _query$cancelToken4,
            data = (0,objectWithoutProperties/* default */.Z)(query, _excluded4);

        var headers = {};

        if (token) {
          headers = {
            Authorization: "Bearer ".concat(token)
          };
        }

        if (_this5.appBuildVersion) {
          headers = _objectSpread(_objectSpread({}, headers), {}, {
            'X-Client-Version': _this5.appBuildVersion
          });
        }

        return axios_default()["delete"]("".concat(_this5.fullUrl(url)), data, {
          cancelToken: cancelToken,
          headers: headers
        }).then(function (response) {
          return response.data;
        }).catch(function (error) {
          var _error$response10, _error$response11, _error$response12, _error$response12$dat;

          return _objectSpread(_objectSpread({
            result: 'error',
            statusCode: (_error$response10 = error.response) === null || _error$response10 === void 0 ? void 0 : _error$response10.status
          }, (_error$response11 = error.response) === null || _error$response11 === void 0 ? void 0 : _error$response11.data), {}, {
            message: ((_error$response12 = error.response) === null || _error$response12 === void 0 ? void 0 : (_error$response12$dat = _error$response12.data) === null || _error$response12$dat === void 0 ? void 0 : _error$response12$dat.message) || error.message
          });
        });
      };
    }
  }]);

  return Api;
}();
;// CONCATENATED MODULE: ./node_modules/@fh-components/fh-js-api-core/store/index.js



















function createStore(preloadedState, _ref) {
  var baseUrl = _ref.baseUrl,
      storage = _ref.storage,
      tokenGenerator = _ref.tokenGenerator,
      appBuildVersion = _ref.appBuildVersion,
      deviceType = _ref.deviceType;
  var api = new Api(baseUrl, appBuildVersion, deviceType);
  var store = (0,redux_toolkit_esm/* configureStore */.xC)({
    reducer: {
      categories: categoriesSlice/* default */.ZP,
      catalog: catalogSlice/* default */.ZP,
      cart: cartSlice/* default */.ZP,
      product: productSlice/* default */.ZP,
      checkout: checkoutSlice/* default */.ZP,
      user: userSlice/* default */.ZP,
      session: sessionSlice/* default */.ZP,
      wishlist: wishlistSlice/* default */.ZP,
      viewed: viewedSlice/* default */.ZP,
      shops: shopsSlice/* default */.ZP,
      pages: pagesSlice/* default */.ZP,
      search: searchSlice/* default */.ZP,
      profile: profileSlice/* default */.ZP,
      currency: currencySlice/* default */.ZP,
      look: lookSlice/* default */.ZP,
      subscribe: subscribeSlice,
      menu: menuSlice
    },
    preloadedState: preloadedState,
    middleware: (0,redux_toolkit_esm/* getDefaultMiddleware */.Bx)({
      thunk: {
        extraArgument: {
          api: api,
          storage: storage,
          tokenGenerator: tokenGenerator
        }
      }
    })
  });
  api.setStateReceivingFunction(store.getState);
  return store;
}
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./contexts/NotificationContext.js
var NotificationContext = __webpack_require__(64318);
// EXTERNAL MODULE: ./layouts/index.js + 22 modules
var layouts = __webpack_require__(75842);
// EXTERNAL MODULE: ./contexts/HostContext.js
var HostContext = __webpack_require__(78755);
// EXTERNAL MODULE: ./contexts/NavContext.js
var NavContext = __webpack_require__(73682);
// EXTERNAL MODULE: ./contexts/ChannelsContext.js + 1 modules
var ChannelsContext = __webpack_require__(53013);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./contexts/EventsContext.js








var EventsContext = /*#__PURE__*/react.createContext(undefined);
var events = {
  FAVORITE_ADD: 'SessionFavoriteAddEvent',
  FAVORITE_REMOVE: 'SessionFavoriteRemoveEvent',
  FAVORITE_UPDATE: 'SessionFavoriteUpdateEvent',
  FAVORITE_UNAVAILABLE: 'SessionFavoriteChangeUnavailableEvent',
  CART_ADD: 'SessionCartAddEvent',
  CART_REMOVE: 'SessionCartRemoveEvent',
  CART_UPDATE: 'SessionCartUpdateEvent',
  CART_REFRESH: 'SessionCartRefreshEvent',
  CART_FAVORITE_REFRESH: 'SessionCartFavoriteRefreshRequiredEvent'
};
var EventsProvider = function EventsProvider(_ref) {
  var children = _ref.children;
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();
  var sessionID = (0,react_redux_es/* useSelector */.v9)(store_0/* sessionIdSelector */.c9);
  var channels = (0,ChannelsContext/* usePrivateChannels */.yN)(sessionID, dispatch);
  var cartItemsQuantity = (0,react_redux_es/* useSelector */.v9)(store_0/* cartCountSelector */.Ri);
  var onChange = (0,react.useCallback)(function (e, type) {
    console.log('event type --- ', type);
    console.log('event value --- ', e);
    var isFavorites = router.pathname.includes('wishlist');
    var isCart = router.pathname.includes('cart');

    switch (type) {
      case events.FAVORITE_ADD:
        {
          dispatch((0,wishlistSlice/* addWishlistId */.mV)({
            id: {
              product_id: e.value,
              model_id: e.model_id
            }
          }));

          if (isFavorites) {
            dispatch((0,wishlistSlice/* fetchWishlist */.BW)({
              page: 1
            }));
          }

          break;
        }

      case events.FAVORITE_REMOVE:
        {
          dispatch((0,wishlistSlice/* removeWishlistId */.GL)({
            id: e.value ? e.value : e.model_id,
            isVariation: !!e.value
          }));

          if (isFavorites) {
            dispatch((0,wishlistSlice/* fetchWishlist */.BW)({
              page: 1
            }));
          }

          break;
        }

      case events.FAVORITE_UPDATE:
        {
          dispatch((0,wishlistSlice/* removeWishlistId */.GL)({
            id: e.old_value ? e.old_value : e.model_id,
            isVariation: !!e.old_value
          }));
          dispatch((0,wishlistSlice/* addWishlistId */.mV)({
            id: {
              product_id: e.value,
              model_id: e.model_id
            }
          }));

          if (isFavorites) {
            dispatch((0,wishlistSlice/* fetchWishlist */.BW)({
              page: 1
            }));
          }

          break;
        }

      case events.FAVORITE_UNAVAILABLE:
        {
          if (isFavorites) {
            dispatch((0,wishlistSlice/* fetchWishlist */.BW)({
              page: 1
            }));
          }

          break;
        }

      case events.CART_ADD:
        {
          dispatch((0,cartSlice/* addCartId */.at)({
            id: e.value
          }));
          dispatch((0,cartSlice/* updateCartCount */.N1)({
            count: cartItemsQuantity + 1
          }));

          if (isCart) {
            dispatch((0,cartSlice/* fetchCart */.x7)());
          }

          break;
        }

      case events.CART_REMOVE:
        {
          dispatch((0,cartSlice/* removeCartId */.Gz)({
            id: e.value
          }));
          dispatch((0,cartSlice/* updateCartCount */.N1)({
            count: cartItemsQuantity - 1
          }));
          break;
        }

      case events.CART_UPDATE:
        {
          dispatch((0,cartSlice/* updateCartCount */.N1)({
            count: e.total_quantity
          }));
          break;
        }

      case events.CART_FAVORITE_REFRESH:
        {
          dispatch((0,wishlistSlice/* updateWishlistIds */.Mu)({
            ids: e.favorites
          }));
          dispatch((0,cartSlice/* updateCartCount */.N1)({
            count: e.cartCount
          }));
          dispatch((0,cartSlice/* updateCartIds */.U9)({
            ids: e.cartProducts
          }));

          if (isFavorites) {
            dispatch((0,wishlistSlice/* fetchWishlist */.BW)({
              page: 1
            }));
          }

          break;
        }

      default:
    }
  }, [dispatch, cartItemsQuantity, router]);
  (0,react.useEffect)(function () {
    if (channels) {
      channels.listen(".".concat(events.FAVORITE_ADD), function (e) {
        return onChange(e, events.FAVORITE_ADD);
      });
      channels.listen(".".concat(events.FAVORITE_REMOVE), function (e) {
        return onChange(e, events.FAVORITE_REMOVE);
      });
      channels.listen(".".concat(events.FAVORITE_UPDATE), function (e) {
        return onChange(e, events.FAVORITE_UPDATE);
      });
      channels.listen(".".concat(events.FAVORITE_UNAVAILABLE), function (e) {
        return onChange(e, events.FAVORITE_UNAVAILABLE);
      });
      channels.listen(".".concat(events.CART_ADD), function (e) {
        return onChange(e, events.CART_ADD);
      });
      channels.listen(".".concat(events.CART_REMOVE), function (e) {
        return onChange(e, events.CART_REMOVE);
      });
      channels.listen(".".concat(events.CART_UPDATE), function (e) {
        return onChange(e, events.CART_UPDATE);
      });
      channels.listen(".".concat(events.CART_FAVORITE_REFRESH), function (e) {
        return onChange(e, events.CART_FAVORITE_REFRESH);
      });
      return function () {
        channels.stopListening(".".concat(events.FAVORITE_ADD));
        channels.stopListening(".".concat(events.FAVORITE_REMOVE));
        channels.stopListening(".".concat(events.FAVORITE_UPDATE));
        channels.stopListening(".".concat(events.FAVORITE_UNAVAILABLE));
        channels.stopListening(".".concat(events.CART_ADD));
        channels.stopListening(".".concat(events.CART_REMOVE));
        channels.stopListening(".".concat(events.CART_UPDATE));
        channels.stopListening(".".concat(events.CART_FAVORITE_REFRESH));
      };
    }
  }, [channels, onChange]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(EventsContext.Provider, {
    children: children
  });
};
// EXTERNAL MODULE: ./lib/parseCookies.js
var parseCookies = __webpack_require__(42782);
// EXTERNAL MODULE: ./assets/styles/theme.js
var theme = __webpack_require__(78309);
;// CONCATENATED MODULE: ./seo/YM.js
var YM_TRACKING_ID = '56654761'; // https://yandex.ru/support/metrica/objects/hit.html

var pageview = function pageview(url) {
  try {
    window.ym(YM_TRACKING_ID, 'hit', url);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

/* harmony default export */ var YM = ({
  pageview: pageview
});
// EXTERNAL MODULE: ./seo/Mindbox.js
var Mindbox = __webpack_require__(22182);
// EXTERNAL MODULE: ./containers/errorBoundary/index.js + 1 modules
var errorBoundary = __webpack_require__(17338);
// EXTERNAL MODULE: ./containers/index.js + 33 modules
var containers = __webpack_require__(21341);
;// CONCATENATED MODULE: ./lib/getHost.js


var _getConfig = config_default()(),
    host = _getConfig.publicRuntimeConfig.host;

function getHost(req) {
  if (false) {}

  return req ? "".concat(req.hostname) : window.location.host;
}
// EXTERNAL MODULE: ./node_modules/sourcebuster/dist/sourcebuster.js
var sourcebuster = __webpack_require__(40196);
var sourcebuster_default = /*#__PURE__*/__webpack_require__.n(sourcebuster);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
var node_modules_axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
;// CONCATENATED MODULE: ./utils/settingGlobalParams.js


var settingGlobalParams = function settingGlobalParams(_ref) {
  var deliveryUrl = _ref.deliveryUrl,
      query = _ref.query,
      clientIp = _ref.clientIp;
  setTimeout(function () {
    if (!localStorage.getItem('currency') || !sessionStorage.getItem('country')) {
      node_modules_axios_default().get("".concat(deliveryUrl, "/geocode/geoip"), {
        ip: clientIp
      }).then(function (response) {
        var iso = response.data.message.country.iso;

        if (!localStorage.getItem('currency')) {
          localStorage.setItem('currency', iso === 'RU' ? iso : 'BY');
        }

        if (!sessionStorage.getItem('country')) {
          sessionStorage.setItem('country', iso);
        }
      }).catch(function (err) {
        console.error(err);
      });
    }

    if (!((sourcebuster_default()) !== null && (sourcebuster_default()) !== void 0 && (sourcebuster_default()).get)) {
      sourcebuster_default().init();
    }

    if (Object.keys(query).length > 0) {
      if (query !== null && query !== void 0 && query.utm_source || query !== null && query !== void 0 && query.utm_medium || query !== null && query !== void 0 && query.utm_campaign || query !== null && query !== void 0 && query.utm_content || query !== null && query !== void 0 && query.utm_term) {
        var _query$utm_source, _sbjs$get, _sbjs$get$current, _query$utm_medium, _query$utm_campaign, _query$utm_content, _query$utm_term;

        sessionStorage.setItem('utm_source', (_query$utm_source = query === null || query === void 0 ? void 0 : query.utm_source) !== null && _query$utm_source !== void 0 ? _query$utm_source : (sourcebuster_default()) !== null && (sourcebuster_default()) !== void 0 && (_sbjs$get = (sourcebuster_default()).get) !== null && _sbjs$get !== void 0 && (_sbjs$get$current = _sbjs$get.current) !== null && _sbjs$get$current !== void 0 && _sbjs$get$current.src && (sourcebuster_default()).get.current.src !== '(direct)' ? (sourcebuster_default()).get.current.src : 'google');
        sessionStorage.setItem('utm_medium', (_query$utm_medium = query === null || query === void 0 ? void 0 : query.utm_medium) !== null && _query$utm_medium !== void 0 ? _query$utm_medium : null);
        sessionStorage.setItem('utm_campaign', (_query$utm_campaign = query === null || query === void 0 ? void 0 : query.utm_campaign) !== null && _query$utm_campaign !== void 0 ? _query$utm_campaign : null);
        sessionStorage.setItem('utm_content', (_query$utm_content = query === null || query === void 0 ? void 0 : query.utm_content) !== null && _query$utm_content !== void 0 ? _query$utm_content : null);
        sessionStorage.setItem('utm_term', (_query$utm_term = query === null || query === void 0 ? void 0 : query.utm_term) !== null && _query$utm_term !== void 0 ? _query$utm_term : null);
      }

      if (query !== null && query !== void 0 && query.gclid) {
        var _query$utm_source2, _sbjs$get2, _sbjs$get2$current;

        sessionStorage.setItem('gclid', query.gclid);
        sessionStorage.setItem('utm_source', (_query$utm_source2 = query === null || query === void 0 ? void 0 : query.utm_source) !== null && _query$utm_source2 !== void 0 ? _query$utm_source2 : ((sourcebuster_default()) === null || (sourcebuster_default()) === void 0 ? void 0 : (_sbjs$get2 = (sourcebuster_default()).get) === null || _sbjs$get2 === void 0 ? void 0 : (_sbjs$get2$current = _sbjs$get2.current) === null || _sbjs$get2$current === void 0 ? void 0 : _sbjs$get2$current.src) || 'google');
      }
    }
  }, 0);
};
// EXTERNAL MODULE: ./pages/_error/index.js
var _error = __webpack_require__(65249);
// EXTERNAL MODULE: ./assets/styles/global.scss
var global = __webpack_require__(57268);
// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet.css
var leaflet = __webpack_require__(65729);
// EXTERNAL MODULE: ./node_modules/leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css
var leaflet_defaulticon_compatibility = __webpack_require__(17329);
;// CONCATENATED MODULE: ./pages/_app.js




function _app_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _app_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _app_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _app_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



































 // npx prettier --write "**/*.{js,jsx,scss, json}"



var deviceDetector = new (dist_default())();

var requestIp = __webpack_require__(98723);

var _app_getConfig = config_default()(),
    publicRuntimeConfig = _app_getConfig.publicRuntimeConfig;

var isClient = function isClient() {
  return true;
};

var isServer = function isServer() {
  return !isClient();
};

var isProductionMode = true;
router_default().events.on('routeChangeComplete', function (url) {
  if (isProductionMode) {
    YM.pageview(url);
  }

  if (isClient() && Mindbox/* default */.ZP) {
    Mindbox/* default */.ZP === null || Mindbox/* default */.ZP === void 0 ? void 0 : Mindbox/* default.webpushSubscribe */.ZP.webpushSubscribe();
  }
});

var getStore = function () {
  var store = null;

  var tokenGenerator = function tokenGenerator() {
    return {
      source: 'web',
      token: (0,index_browser/* nanoid */.x0)() + "".concat(new Date().getTime())
    };
  };

  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        initialState = _ref.initialState,
        req = _ref.req,
        res = _ref.res,
        _ref$deviceType = _ref.deviceType,
        deviceType = _ref$deviceType === void 0 ? 'web-desktop' : _ref$deviceType;

    if (isServer()) {
      return createStore(initialState, {
        baseUrl: publicRuntimeConfig.apiUrl,
        deviceType: deviceType,
        isMobile: false,
        storage: {
          get: function get(name) {
            return (0,parseCookies/* default */.Z)(req)[name];
          },
          set: function set(name, value) {
            res.cookie(name, value, {
              path: '/',
              expires: new Date(Date.now() + 3600 * 1000 * 24 * 365)
            });
          }
        },
        tokenGenerator: tokenGenerator
      });
    }

    if (!store) {
      store = createStore(initialState, {
        baseUrl: publicRuntimeConfig.browserApiUrl,
        deviceType: deviceType,
        isMobile: false,
        storage: {
          get: function get(name) {
            return js_cookie_default().get(name);
          },
          set: function set(name, value) {
            js_cookie_default().set(name, value);
          }
        },
        tokenGenerator: tokenGenerator
      });
    }

    return store;
  };
}();

var MyApp = function MyApp(props) {
  var _useState = (0,react.useState)(getStore({
    initialState: props.initialReduxState,
    deviceType: props.deviceType
  })),
      reduxStore = _useState[0];

  (0,react.useEffect)(function () {
    var isLoaded = (0,store_0/* isSessionLoadedSelector */.i9)(reduxStore.getState());

    if (!isLoaded) {
      reduxStore.dispatch((0,sessionSlice/* createSession */.ed)(false, function (client) {
        if (client) {
          Ecommerce/* default.setLogin */.ZP.setLogin('login', client.id);
        }
      }));
    }

    reduxStore.dispatch((0,currencySlice/* fetchCurrency */.kn)());
    reduxStore.dispatch((0,sessionSlice/* getRegions */.JL)({}));
  }, []);
  var Component = props.Component,
      pageProps = props.pageProps,
      host = props.host,
      errorStatus = props.errorStatus,
      hasError = props.hasError,
      deviceType = props.deviceType;
  var store = reduxStore;
  var token = (0,store_0/* sessionTokenSelector */.hg)(reduxStore.getState());
  var user = (0,store_0/* userSelector */.np)(reduxStore.getState());

  if (true) {
    setTimeout(function () {
      settingGlobalParams({
        deliveryUrl: publicRuntimeConfig.deliveryUrl,
        query: (router_default()).query,
        clientIp: pageProps === null || pageProps === void 0 ? void 0 : pageProps.clientIp
      });
    }, 0);
  }

  return hasError ? /*#__PURE__*/(0,jsx_runtime.jsx)(react_redux_es/* Provider */.zt, {
    store: store,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
      theme: theme/* default */.Z,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavContext/* NavProvider */.N, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(_error["default"], _app_objectSpread(_app_objectSpread({}, pageProps), {}, {
          statusCode: errorStatus
        }))
      })
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react_redux_es/* Provider */.zt, {
    store: store,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Head */.Fb, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(layouts/* Scripts */.KC, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(errorBoundary/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HostContext/* HostProvider */.T, {
        host: host,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
          theme: theme/* default */.Z,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ChannelsContext/* ChannelsProvider */.l5, {
            authUser: user,
            authToken: token,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(EventsProvider, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationContext/* NotificationProvider */.J, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavContext/* NavProvider */.N, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(layouts/* Page */.T3, {
                    isMobile: deviceType === 'web-mobile',
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps))
                  })
                })
              })
            })
          })
        })
      })
    })]
  });
};

MyApp.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
    var _window, _window$navigator, _ctx$req, _device$device;

    var Component, ctx, userAgent, isSafari, device, deviceType, reduxStore, hasGotIP, clientIp, pageProps, errorStatus, hasError;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref2.Component, ctx = _ref2.ctx;
            userAgent =  true ? (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent : 0;
            isSafari = userAgent.length > 0 ? /^((?!chrome|android).)*safari/i.test(userAgent) : null;
            device = deviceDetector.parse(userAgent);
            deviceType = 'web-desktop';

            if (device.device && ((_device$device = device.device) === null || _device$device === void 0 ? void 0 : _device$device.type) === 'smartphone') {
              deviceType = 'web-mobile';
            }

            reduxStore = getStore({
              req: ctx.req,
              res: ctx.res,
              deviceType: deviceType
            });
            _context.next = 9;
            return reduxStore.dispatch((0,sessionSlice/* createToken */.V3)());

          case 9:
            hasGotIP = (0,store_0/* hasGotIPSelector */.XV)(reduxStore.getState());
            clientIp = '';

            if (hasGotIP) {
              _context.next = 15;
              break;
            }

            _context.next = 14;
            return reduxStore.dispatch((0,userSlice/* getIP */.tE)());

          case 14:
            clientIp = requestIp.getClientIp(ctx.req);

          case 15:
            pageProps = {};
            hasError = false;

            if (ctx.err) {
              // eslint-disable-next-line no-console
              console.warn('[ctx error]:', ctx.err);
              errorStatus = ctx.err.statusCode;
            } else {
              errorStatus = ctx.res ? ctx.res.statusCode : null;
            }

            _context.next = 20;
            return reduxStore.dispatch(fetchMenu());

          case 20:
            if (!Component.getInitialProps) {
              _context.next = 33;
              break;
            }

            _context.prev = 21;
            _context.next = 24;
            return Component.getInitialProps(_app_objectSpread(_app_objectSpread({}, ctx), {}, {
              reduxStore: reduxStore
            }));

          case 24:
            pageProps = _context.sent;

            if (pageProps.data) {
              pageProps.isSafari = isSafari;
              pageProps.clientIp = clientIp;
            }

            _context.next = 33;
            break;

          case 28:
            _context.prev = 28;
            _context.t0 = _context["catch"](21);
            errorStatus = _context.t0.statusCode || 500;
            hasError = true;

            if (ctx.res) {
              ctx.res.status(errorStatus);
            } // eslint-disable-next-line no-console
            // console.error('[Initial props error]: ', error.message);


          case 33:
            return _context.abrupt("return", {
              host: getHost(ctx.req),
              pageProps: pageProps,
              initialReduxState: reduxStore.getState(),
              hasError: Component === _error["default"] || hasError,
              errorStatus: errorStatus,
              deviceType: deviceType
            });

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[21, 28]]);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ var _app = (MyApp);

/***/ }),

/***/ 65249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74865);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39666);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70517);
/* harmony import */ var _containers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21341);
/* harmony import */ var _Error_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75053);
/* harmony import */ var _Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Error_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);






 // import Header from '@/containers/header/OldHeader';







var Error = function Error(_ref) {
  var _ref$statusCode = _ref.statusCode,
      statusCode = _ref$statusCode === void 0 ? 500 : _ref$statusCode;
  var is404page = +statusCode === 404;
  var title404 = 'Ошибка 404. Страница не найдена';
  var title500 = 'Ошибка обращения к серверу';
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    nprogress__WEBPACK_IMPORTED_MODULE_0___default().done(true);
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("title", {
        children: is404page ? title404 : title500
      })
    }), is404page && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .MobileNav */ .zM, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .MobileUserNav */ .nN, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_containers__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h4, {})]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().error),
      children: [!is404page && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().logo),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ActiveLink */ .O$, {
          href: "/",
          as: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Control */ .oT, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
              src: "/images/fhby.webp",
              className: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().logoImg),
              alt: "FH.BY - \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u043C\u0430\u0433\u0430\u0437\u0438\u043D \u043E\u0434\u0435\u0436\u0434\u044B, \u043E\u0431\u0443\u0432\u0438 \u0438 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u043E\u0432 \u043C\u0438\u0440\u043E\u0432\u044B\u0445 \u0431\u0440\u0435\u043D\u0434\u043E\u0432"
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_containers__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, {
        className: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().number),
          children: is404page ? '404' : '500'
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
          component: "h2",
          className: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title500),
          children: title500
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text500),
          children: is404page ? 'Возможно, она была удалена или ее адрес введен неверно. Попробуйте перейти на другую страницу или вернуться на главную.' : 'Мы уже устраняем неисправность, попробуйте обновить страницу через некоторое время. Приносим извинения за временные неудобства.'
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
          type: "primary",
          onClick: function onClick() {
            if (is404page) {
              next_router__WEBPACK_IMPORTED_MODULE_2___default().push('/');
            } else {
              next_router__WEBPACK_IMPORTED_MODULE_2___default().reload();
            }
          },
          classNames: {
            general: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button500)
          },
          children: is404page ? 'Вернуться на главную' : 'Обновить страницу'
        }), !is404page && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          href: "/",
          className: (_Error_module_scss__WEBPACK_IMPORTED_MODULE_7___default().link),
          children: "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
        })]
      }), is404page && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_containers__WEBPACK_IMPORTED_MODULE_5__/* .Footer */ .$_, {})]
    })]
  });
};

Error.getInitialProps = function (_ref2) {
  var res = _ref2.res,
      err = _ref2.err;
  var statusCode;

  if (err) {
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .captureException */ .Tb(err);
  }

  if (res) {
    statusCode = res.statusCode;
  } else {
    statusCode = err ? err.statusCode : 404;
  }

  return {
    statusCode: statusCode
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Error);

/***/ }),

/***/ 15187:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// NAMESPACE OBJECT: ./node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return FunctionToString; },
  "InboundFilters": function() { return InboundFilters; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return Breadcrumbs; },
  "Dedupe": function() { return Dedupe; },
  "GlobalHandlers": function() { return GlobalHandlers; },
  "LinkedErrors": function() { return LinkedErrors; },
  "TryCatch": function() { return TryCatch; },
  "UserAgent": function() { return UserAgent; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js + 1 modules
var object = __webpack_require__(68252);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js

var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = (0,object/* getOriginalFunction */.HK)(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(25252);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js + 1 modules
var esm_hub = __webpack_require__(39472);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(68518);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        (0,esm_scope/* addGlobalEventProcessor */.c)(function (event) {
            var hub = (0,esm_hub/* getCurrentHub */.Gd)();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                // This checks prevents most of the occurrences of the bug linked below:
                // https://github.com/getsentry/sentry-javascript/issues/2622
                // The bug is caused by multiple SDK instances, where one is minified and one is using non-mangled code.
                // Unfortunatelly we cannot fix it reliably (thus reserved property in rollup's terser config),
                // as we cannot force people using multiple instances in their apps to sync SDK versions.
                var options = typeof self._mergeOptions === 'function' ? self._mergeOptions(clientOptions) : {};
                if (typeof self._shouldDropEvent !== 'function') {
                    return event;
                }
                return self._shouldDropEvent(event, options) ? null : event;
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.warn */.k.warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0,misc/* getEventDescription */.jH)(event));
            }
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.warn */.k.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0,misc/* getEventDescription */.jH)(event));
            }
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.warn */.k.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0,misc/* getEventDescription */.jH)(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            }
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.warn */.k.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0,misc/* getEventDescription */.jH)(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            }
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            // @ts-ignore can't be a sentry error if undefined
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return event.exception.values[0].type === 'SentryError';
        }
        catch (e) {
            // ignore
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return (0,string/* isMatchingPattern */.zC)(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return (0,string/* isMatchingPattern */.zC)(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return (0,string/* isMatchingPattern */.zC)(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            allowUrls: (0,tslib_es6/* __spread */.fl)((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: (0,tslib_es6/* __spread */.fl)((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: (0,tslib_es6/* __spread */.fl)((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                if ((0,env/* isDebugBuild */.c)()) {
                    esm_logger/* logger.error */.k.error("Cannot extract message for event " + (0,misc/* getEventDescription */.jH)(event));
                }
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getLastValidUrl = function (frames) {
        if (frames === void 0) { frames = []; }
        for (var i = frames.length - 1; i >= 0; i--) {
            var frame = frames[i];
            if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
                return frame.filename || null;
            }
        }
        return null;
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                return this._getLastValidUrl(event.stacktrace.frames);
            }
            var frames_1;
            try {
                // @ts-ignore we only care about frames if the whole thing here is defined
                frames_1 = event.exception.values[0].stacktrace.frames;
            }
            catch (e) {
                // ignore
            }
            return frames_1 ? this._getLastValidUrl(frames_1) : null;
        }
        catch (oO) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.error */.k.error("Cannot extract url for event " + (0,misc/* getEventDescription */.jH)(event));
            }
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(82991);
;// CONCATENATED MODULE: ./node_modules/@sentry/types/esm/severity.js
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// TODO: in v7, these can disappear, because they now also exist in `@sentry/utils`. (Having them there rather than here
// is nice because then it enforces the idea that only types are exported from `@sentry/types`.)
var SeverityLevels = (/* unused pure expression or super */ null && (['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical']));
//# sourceMappingURL=severity.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var esm_stacktrace = __webpack_require__(30360);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js

// global reference to slice
var UNKNOWN_FUNCTION = '?';
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true,
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function (line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function (line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function (line) {
    var parts = winjsRegex.exec(line);
    return parts
        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
        : undefined;
};
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function (line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function (line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
        ]
        : [func, filename];
};
//# sourceMappingURL=stack-parsers.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/parsers.js


/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex),
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0,object/* extractExceptionKeysForMessage */.zf)(exception),
                },
            ],
        },
        extra: {
            __serialized__: (0,object/* normalizeToSize */.Qy)(exception),
        },
    };
    if (syntheticException) {
        event.stacktrace = {
            frames: parseStackFrames(syntheticException),
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromError(ex) {
    return {
        exception: {
            values: [exceptionFromError(ex)],
        },
    };
}
/** Parses stack frames from an error */
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        // The order of the parsers in important
        return (0,esm_stacktrace/* createStackParser */.pE)(opera10, opera11, chrome, winjs, gecko)(stacktrace, popSize);
    }
    catch (e) {
        // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=parsers.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js




/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(options, exception, hint) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
    event.level = Severity.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(options, message, level, hint) {
    if (level === void 0) { level = Severity.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if ((0,is/* isErrorEvent */.VW)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception)) {
        var domException = exception;
        if ('stack' in exception) {
            event = eventFromError(exception);
        }
        else {
            var name_1 = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, options);
            (0,misc/* addExceptionTypeValue */.Db)(event, message);
        }
        if ('code' in domException) {
            event.tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if ((0,is/* isError */.VZ)(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(exception);
    }
    if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, options.isRejection);
        (0,misc/* addExceptionMechanism */.EG)(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    (0,misc/* addExceptionTypeValue */.Db)(event, "" + exception, undefined);
    (0,misc/* addExceptionMechanism */.EG)(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        event.stacktrace = {
            frames: parseStackFrames(syntheticException),
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/polyfill.js
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js



/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword) {
    if (withPassword === void 0) { withPassword = false; }
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
        ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
}
function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        throw new SentryError("Invalid Sentry Dsn: " + str);
    }
    var _a = (0,tslib_es6/* __read */.CR)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) {
            projectId = projectMatch[0];
        }
    }
    return dsnFromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
}
function dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) {
        components.publicKey = components.user;
    }
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId,
    };
}
function validateDsn(dsn) {
    if (!(0,env/* isDebugBuild */.c)()) {
        return;
    }
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
    requiredComponents.forEach(function (component) {
        if (!dsn[component]) {
            throw new SentryError("Invalid Sentry Dsn: " + component + " missing");
        }
    });
    if (!projectId.match(/^\d+$/)) {
        throw new SentryError("Invalid Sentry Dsn: Invalid projectId " + projectId);
    }
    if (!isValidProtocol(protocol)) {
        throw new SentryError("Invalid Sentry Dsn: Invalid protocol " + protocol);
    }
    if (port && isNaN(parseInt(port, 10))) {
        throw new SentryError("Invalid Sentry Dsn: Invalid port " + port);
    }
    return true;
}
/** The Sentry Dsn, identifying a Sentry instance and project. */
function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    validateDsn(components);
    return components;
}
//# sourceMappingURL=dsn.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js

var SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn, metadata, tunnel) {
        if (metadata === void 0) { metadata = {}; }
        this.dsn = dsn;
        this._dsnObject = makeDsn(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */
    API.prototype.forceEnvelope = function () {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        return getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return getStoreEndpointWithUrlEncodedAuth(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return getEnvelopeEndpointWithUrlEncodedAuth(this._dsnObject, this._tunnel);
    };
    return API;
}());

/** Initializes API Details */
function initAPIDetails(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: makeDsn(dsn),
        tunnel: tunnel,
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn, target) {
    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn) {
    return (0,object/* urlEncode */._j)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION,
    });
}
/** Returns the store endpoint URL. */
function getStoreEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'store');
}
/**
 * Returns the store endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getStoreEndpointWithUrlEncodedAuth(dsn) {
    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */
function _getEnvelopeEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'envelope');
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/**
 * Returns an object that can be used in request headers.
 * This is needed for node and the old /store endpoint in sentry
 */
function getRequestHeaders(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) {
        header.push("sentry_secret=" + dsn.pass);
    }
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', '),
    };
}
/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = makeDsn(dsnLike);
    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + dsnToString(dsn);
    for (var key in dialogOptions) {
        if (key === 'dsn') {
            continue;
        }
        if (key === 'user') {
            if (!dialogOptions.user) {
                continue;
            }
            if (dialogOptions.user.name) {
                encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            }
            if (dialogOptions.user.email) {
                encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
            }
        }
        else {
            encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
        }
    }
    return endpoint + "?" + encodedOptions;
}
//# sourceMappingURL=api.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js



var global = (0,esm_global/* getGlobalObject */.R)();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            return wrapper;
        }
        // We don't wanna wrap it twice
        if ((0,object/* getOriginalFunction */.HK)(fn)) {
            return fn;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            (0,esm/* withScope */.$e)(function (scope) {
                scope.addEventProcessor(function (event) {
                    if (options.mechanism) {
                        (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
                        (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
                    }
                    event.extra = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.extra), { arguments: args });
                    return event;
                });
                (0,esm/* captureException */.Tb)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);
    (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!global.document) {
        return;
    }
    if (!options.eventId) {
        if ((0,env/* isDebugBuild */.c)()) {
            esm_logger/* logger.error */.k.error("Missing eventId option in showReportDialog call");
        }
        return;
    }
    if (!options.dsn) {
        if ((0,env/* isDebugBuild */.c)()) {
            esm_logger/* logger.error */.k.error("Missing dsn option in showReportDialog call");
        }
        return;
    }
    var script = global.document.createElement('script');
    script.async = true;
    script.src = getReportDialogEndpoint(options.dsn, options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = global.document.head || global.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */





/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */
        this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
        };
        this._options = (0,tslib_es6/* __assign */.pi)({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for (var key in options) {
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

/** JSDoc */
function _installGlobalOnErrorHandler() {
    (0,instrument/* addInstrumentationHandler */.o)('error', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (data) {
        var _a = (0,tslib_es6/* __read */.CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return;
        }
        var event = error === undefined && (0,is/* isString */.HD)(msg)
            ? _eventFromIncompleteOnError(msg, url, line, column)
            : _enhanceEventWithInitialFrame(eventFromUnknownInput(error || msg, undefined, {
                attachStacktrace: attachStacktrace,
                isRejection: false,
            }), url, line, column);
        event.level = Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
    (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e) {
        var _a = (0,tslib_es6/* __read */.CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return true;
        }
        var event = (0,is/* isPrimitive */.pt)(error)
            ? _eventFromRejectionWithPrimitive(error)
            : eventFromUnknownInput(error, undefined, {
                attachStacktrace: attachStacktrace,
                isRejection: true,
            });
        event.level = Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason),
                },
            ],
        },
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message,
                },
            ],
        },
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = (event.exception = event.exception || {});
    // event.exception.values
    var ev = (e.values = e.values || []);
    // event.exception.values[0]
    var ev0 = (ev[0] = ev[0] || {});
    // event.exception.values[0].stacktrace
    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
    // event.exception.values[0].stacktrace.frames
    var ev0sf = (ev0s.frames = ev0s.frames || []);
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: '?',
            in_app: true,
            lineno: lineno,
        });
    }
    return event;
}
function globalHandlerLog(type) {
    if ((0,env/* isDebugBuild */.c)()) {
        esm_logger/* logger.log */.k.log("Global Handler attached: " + type);
    }
}
function addMechanismAndCapture(hub, error, event, type) {
    (0,misc/* addExceptionMechanism */.EG)(event, {
        handled: false,
        type: type,
    });
    hub.captureEvent(event, {
        originalException: error,
    });
}
function getHubAndAttachStacktrace() {
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [hub, attachStacktrace];
}
//# sourceMappingURL=globalhandlers.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = (0,tslib_es6/* __assign */.pi)({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = (0,esm_global/* getGlobalObject */.R)();
        if (this._options.setTimeout) {
            (0,object/* fill */.hl)(global, 'setTimeout', _wrapTimeFunction);
        }
        if (this._options.setInterval) {
            (0,object/* fill */.hl)(global, 'setInterval', _wrapTimeFunction);
        }
        if (this._options.requestAnimationFrame) {
            (0,object/* fill */.hl)(global, 'requestAnimationFrame', _wrapRAF);
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
        }
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/** JSDoc */
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var originalCallback = args[0];
        args[0] = wrap(originalCallback, {
            mechanism: {
                data: { function: (0,esm_stacktrace/* getFunctionName */.$P)(original) },
                handled: true,
                type: 'instrument',
            },
        });
        return original.apply(this, args);
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.call(this, wrap(callback, {
            mechanism: {
                data: {
                    function: 'requestAnimationFrame',
                    handler: (0,esm_stacktrace/* getFunctionName */.$P)(original),
                },
                handled: true,
                type: 'instrument',
            },
        }));
    };
}
/** JSDoc */
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
        xmlHttpRequestProps.forEach(function (prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,object/* fill */.hl)(xhr, prop, function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0,esm_stacktrace/* getFunctionName */.$P)(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = (0,object/* getOriginalFunction */.HK)(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = (0,esm_stacktrace/* getFunctionName */.$P)(originalFunction);
                    }
                    // Otherwise wrap directly
                    return wrap(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0,esm_global/* getGlobalObject */.R)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
        return;
    }
    (0,object/* fill */.hl)(proto, 'addEventListener', function (original) {
        return function (eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') {
                    fn.handleEvent = wrap(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: (0,esm_stacktrace/* getFunctionName */.$P)(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
            }
            catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.call(this, eventName, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            wrap(fn, {
                mechanism: {
                    data: {
                        function: 'addEventListener',
                        handler: (0,esm_stacktrace/* getFunctionName */.$P)(fn),
                        target: target,
                    },
                    handled: true,
                    type: 'instrument',
                },
            }), options);
        };
    });
    (0,object/* fill */.hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
        return function (eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            }
            catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
//# sourceMappingURL=trycatch.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/enums.js
var enums_SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js


function isSupportedSeverity(level) {
    return enums_SeverityLevels.indexOf(level) !== -1;
}
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
    if (level === 'warn')
        return Severity.Warning;
    if (isSupportedSeverity(level)) {
        return level;
    }
    return Severity.Log;
}
//# sourceMappingURL=severity.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = (0,tslib_es6/* __assign */.pi)({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0,misc/* getEventDescription */.jH)(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
        }
        if (this._options.dom) {
            (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this._options.dom));
        }
        if (this._options.xhr) {
            (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
        }
        if (this._options.fetch) {
            (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
        }
        if (this._options.history) {
            (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? (0,browser/* htmlTreeAsString */.R)(handlerData.event.target, keyAttrs)
                : (0,browser/* htmlTreeAsString */.R)(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console',
        },
        level: severityFromString(handlerData.level),
        message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        }
        else {
            // Don't capture a breadcrumb for passed assertions
            return;
        }
    }
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level,
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            return;
        }
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code,
            },
            type: 'http',
        }, {
            xhr: handlerData.xhr,
            input: body,
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
        return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
    }
    if (handlerData.error) {
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: Severity.Error,
            type: 'http',
        }, {
            data: handlerData.error,
            input: handlerData.args,
        });
    }
    else {
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'fetch',
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { status_code: handlerData.response.status }),
            type: 'http',
        }, {
            input: handlerData.args,
            response: handlerData.response,
        });
    }
}
/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0,misc/* parseUrl */.en)(global.location.href);
    var parsedFrom = (0,misc/* parseUrl */.en)(from);
    var parsedTo = (0,misc/* parseUrl */.en)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) {
        parsedFrom = parsedLoc;
    }
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
        to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
        from = parsedFrom.relative;
    }
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to,
        },
    });
}
//# sourceMappingURL=breadcrumbs.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        (0,esm_scope/* addGlobalEventProcessor */.c)(function (event, hint) {
            var self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

/**
 * @inheritDoc
 */
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
        return event;
    }
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = (0,tslib_es6/* __spread */.fl)(linkedErrors, event.exception.values);
    return event;
}
/**
 * JSDOC
 */
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) { stack = []; }
    if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
        return stack;
    }
    var exception = exceptionFromError(error[key]);
    return _walkErrorTree(limit, error[key], key, (0,tslib_es6/* __spread */.fl)([exception], stack));
}
//# sourceMappingURL=linkederrors.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/useragent.js



var useragent_global = (0,esm_global/* getGlobalObject */.R)();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        (0,esm_scope/* addGlobalEventProcessor */.c)(function (event) {
            if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!useragent_global.navigator && !useragent_global.location && !useragent_global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = (event.request && event.request.url) || (useragent_global.location && useragent_global.location.href);
                var referrer = (useragent_global.document || {}).referrer;
                var userAgent = (useragent_global.navigator || {}).userAgent;
                var headers = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (url && { url: url })), { headers: headers });
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js

/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
                        esm_logger/* logger.warn */.k.warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());

/** JSDoc */
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename ||
            frameA.lineno !== frameB.lineno ||
            frameA.colno !== frameB.colno ||
            frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    }
    catch (_oO) {
        return false;
    }
}
/** JSDoc */
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-ignore Object could be undefined
            return exception.values[0].stacktrace.frames;
        }
        catch (_oO) {
            return undefined;
        }
    }
    else if (event.stacktrace) {
        return event.stacktrace.frames;
    }
    return undefined;
}
//# sourceMappingURL=dedupe.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/index.js






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = (0,esm_global/* getGlobalObject */.R)();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, windowIntegrations), integrations_namespaceObject), esm_integrations_namespaceObject);

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/version.js
var SDK_VERSION = '6.17.9';
//# sourceMappingURL=version.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        esm_logger/* logger.enable */.k.enable();
    }
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    var scope = hub.getScope();
    if (scope) {
        scope.update(options.initialScope);
    }
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js



var installedIntegrations = [];
/**
 * @private
 */
function filterDuplicates(integrations) {
    return integrations.reduce(function (acc, integrations) {
        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
            acc.push(integrations);
        }
        return acc;
    }, []);
}
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && (0,tslib_es6/* __spread */.fl)(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = (0,tslib_es6/* __spread */.fl)(filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) {
        // Filter out integrations that are also included in user options
        integrations = (0,tslib_es6/* __spread */.fl)(integrations.filter(function (integrations) {
            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
        }), filterDuplicates(userIntegrations));
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, (0,tslib_es6/* __spread */.fl)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
    esm_logger/* logger.log */.k.log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0,object/* addNonEnumerableProperty */.xp)(integrations, 'initialized', true);
    return integrations;
}
//# sourceMappingURL=integration.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js

/* eslint-disable max-lines */



var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of calls being processed */
        this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = makeDsn(options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
            esm_logger/* logger.log */.k.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0,is/* isPrimitive */.pt)(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
            esm_logger/* logger.log */.k.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!this._isEnabled()) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.warn */.k.warn('SDK not enabled, will not capture session.');
            }
            return;
        }
        if (!(typeof session.release === 'string')) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.warn */.k.warn('Discarded session because of missing or non-string release');
            }
        }
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({ init: false });
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getTransport = function () {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
            return _this.getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled() && !this._integrations.initialized) {
            this._integrations = setupIntegrations(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            esm_logger/* logger.warn */.k.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = (0,tslib_es6/* __values */.XA)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
        if (shouldUpdateAndSend) {
            session.update((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (crashed && { status: 'crashed' })), { errors: session.errors || Number(errored || crashed) }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
        var _this = this;
        return new syncpromise/* SyncPromise */.cW(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)()), timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (evt) {
                // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
                // it is only attached as extra data to the event if the event somehow skips being normalized
                evt.sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, evt.sdkProcessingMetadata), { normalizeDepth: (0,object/* normalize */.Fv)(normalizeDepth) });
            }
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth) {
        if (!event) {
            return null;
        }
        var normalized = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, b), (b.data && {
                data: (0,object/* normalize */.Fv)(b.data, depth),
            }))); }),
        })), (event.user && {
            user: (0,object/* normalize */.Fv)(event.user, depth),
        })), (event.contexts && {
            contexts: (0,object/* normalize */.Fv)(event.contexts, depth),
        })), (event.extra && {
            extra: (0,object/* normalize */.Fv)(event.extra, depth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        event.sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.sdkProcessingMetadata), { baseClientNormalized: true });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0,tslib_es6/* __spread */.fl)((event.sdk.integrations || []), integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            esm_logger/* logger.error */.k.error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) {
                transport.recordLostEvent(outcome, category);
            }
        }
        if (!this._isEnabled()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new SentryError('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            return _ensureBeforeSendRv(beforeSendResult);
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new SentryError('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof SentryError) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._numProcessing += 1;
        void promise.then(function (value) {
            _this._numProcessing -= 1;
            return value;
        }, function (reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());

/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0,is/* isThenable */.J8)(rv)) {
        return rv.then(function (event) {
            if (!((0,is/* isPlainObject */.PO)(event) || event === null)) {
                throw new SentryError(nullErr);
            }
            return event;
        }, function (e) {
            throw new SentryError("beforeSend rejected with " + e);
        });
    }
    else if (!((0,is/* isPlainObject */.PO)(rv) || rv === null)) {
        throw new SentryError(nullErr);
    }
    return rv;
}
//# sourceMappingURL=baseclient.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/noop.js

/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return (0,syncpromise/* resolvedSyncPromise */.WD)({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: 'skipped',
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/basebackend.js


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            esm_logger/* logger.warn */.k.warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new SentryError('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new SentryError('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        void this._transport.sendEvent(event).then(null, function (reason) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.error */.k.error("Error while sending event: " + reason);
            }
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.warn */.k.warn("Dropping session because custom transport doesn't implement sendSession");
            }
            return;
        }
        void this._transport.sendSession(session).then(null, function (reason) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.error */.k.error("Error while sending session: " + reason);
            }
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new NoopTransport();
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/request.js



/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) {
        return;
    }
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return { name: name, version: version };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0,tslib_es6/* __spread */.fl)((event.sdk.integrations || []), (sdkInfo.integrations || []));
    event.sdk.packages = (0,tslib_es6/* __spread */.fl)((event.sdk.packages || []), (sdkInfo.packages || []));
    return event;
}
/** Creates a SentryRequest from a Session. */
function sessionToSentryRequest(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = JSON.stringify((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) })));
    // I know this is hacky but we don't want to add `session` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    var itemHeaders = JSON.stringify({
        type: type,
    });
    return {
        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
        type: type,
        url: getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel),
    };
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    }
    catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0,object/* normalize */.Fv)(event));
        }
        catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: { message: innerErr.message, stack: innerErr.stack },
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope
            ? getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel)
            : getStoreEndpointWithUrlEncodedAuth(api.dsn),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) })));
        var itemHeaders = JSON.stringify({
            type: eventType,
            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
            // explicitly-set sampling decisions). Are we good with that?
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js


/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */
    function add(taskProducer) {
        if (!isReady()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise due to buffer limit reached.'));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) {
            buffer.push(task);
        }
        void task
            .then(function () { return remove(task); })
            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
            // have promises, so TS has to polyfill when down-compiling.)
            .then(null, function () {
            return remove(task).then(null, function () {
                // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */
    function drain(timeout) {
        return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
            var counter = buffer.length;
            if (!counter) {
                return resolve(true);
            }
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function (item) {
                void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(function () {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain,
    };
}
//# sourceMappingURL=promisebuffer.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/status.js
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */
function eventStatusFromHttpCode(code) {
    if (code >= 200 && code < 300) {
        return 'success';
    }
    if (code === 429) {
        return 'rate_limit';
    }
    if (code >= 400 && code < 500) {
        return 'invalid';
    }
    if (code >= 500) {
        return 'failed';
    }
    return 'unknown';
}
//# sourceMappingURL=status.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/async.js
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    void promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js

var utils_global = (0,esm_global/* getGlobalObject */.R)();
var cachedFetchImpl;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */
    // Fast path to avoid DOM I/O
    if ((0,supports/* isNativeFetch */.Du)(utils_global.fetch)) {
        return (cachedFetchImpl = utils_global.fetch.bind(utils_global));
    }
    var document = utils_global.document;
    var fetchImpl = utils_global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") {
        try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) {
                fetchImpl = contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
            if ((0,env/* isDebugBuild */.c)()) {
                esm_logger/* logger.warn */.k.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
            }
        }
    }
    return (cachedFetchImpl = fetchImpl.bind(utils_global));
    /* eslint-enable @typescript-eslint/unbound-method */
}
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
    var isRealNavigator = Object.prototype.toString.call(utils_global && utils_global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof utils_global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = utils_global.navigator.sendBeacon.bind(utils_global.navigator);
        return sendBeacon(url, body);
    }
    if ((0,supports/* supportsFetch */.Ak)()) {
        var fetch_1 = getNativeFetchImplementation();
        return forget(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true,
        }));
    }
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/base.js




function requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var base_global = (0,esm_global/* getGlobalObject */.R)();
/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = makePromiseBuffer(30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._outcomes = {};
        this._api = initAPIDetails(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = getStoreEndpointWithUrlEncodedAuth(this._api.dsn);
        if (this.options.sendClientReports && base_global.document) {
            base_global.document.addEventListener('visibilitychange', function () {
                if (base_global.document.visibilityState === 'hidden') {
                    _this._flushOutcomes();
                }
            });
        }
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendSession = function (session) {
        return this._sendRequest(sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.recordLostEvent = function (reason, category) {
        var _a;
        if (!this.options.sendClientReports) {
            return;
        }
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = requestTypeToCategory(category) + ":" + reason;
        esm_logger/* logger.log */.k.log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
    };
    /**
     * Send outcomes as an envelope
     */
    BaseTransport.prototype._flushOutcomes = function () {
        if (!this.options.sendClientReports) {
            return;
        }
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            esm_logger/* logger.log */.k.log('No outcomes to flush');
            return;
        }
        esm_logger/* logger.log */.k.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = getEnvelopeEndpointWithUrlEncodedAuth(this._api.dsn, this._api.tunnel);
        // Envelope header is required to be at least an empty object
        var envelopeHeader = JSON.stringify((0,tslib_es6/* __assign */.pi)({}, (this._api.tunnel && { dsn: dsnToString(this._api.dsn) })));
        var itemHeaders = JSON.stringify({
            type: 'client_report',
        });
        var item = JSON.stringify({
            timestamp: (0,time/* dateTimestampInSeconds */.yW)(),
            discarded_events: Object.keys(outcomes).map(function (key) {
                var _a = (0,tslib_es6/* __read */.CR)(key.split(':'), 2), category = _a[0], reason = _a[1];
                return {
                    reason: reason,
                    category: category,
                    quantity: outcomes[key],
                };
            }),
        });
        var envelope = envelopeHeader + "\n" + itemHeaders + "\n" + item;
        try {
            sendReport(url, envelope);
        }
        catch (e) {
            esm_logger/* logger.error */.k.error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = eventStatusFromHttpCode(response.status);
        /**
         * "The name is case-insensitive."
         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
         */
        var limited = this._handleRateLimit(headers);
        if (limited && (0,env/* isDebugBuild */.c)()) {
            esm_logger/* logger.warn */.k.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        }
        if (status === 'success') {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     */
    BaseTransport.prototype._disabledUntil = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return this._rateLimits[category] || this._rateLimits.all;
    };
    /**
     * Checks if a category is rate limited
     */
    BaseTransport.prototype._isRateLimited = function (requestType) {
        return this._disabledUntil(requestType) > new Date(Date.now());
    };
    /**
     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
     */
    BaseTransport.prototype._handleRateLimit = function (headers) {
        var e_1, _a, e_2, _b;
        var now = Date.now();
        var rlHeader = headers['x-sentry-rate-limits'];
        var raHeader = headers['retry-after'];
        if (rlHeader) {
            try {
                // rate limit headers are of the form
                //     <header>,<header>,..
                // where each <header> is of the form
                //     <retry_after>: <categories>: <scope>: <reason_code>
                // where
                //     <retry_after> is a delay in ms
                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
                //         <category>;<category>;...
                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
                for (var _c = (0,tslib_es6/* __values */.XA)(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var limit = _d.value;
                    var parameters = limit.split(':', 2);
                    var headerDelay = parseInt(parameters[0], 10);
                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                    try {
                        for (var _e = (e_2 = void 0, (0,tslib_es6/* __values */.XA)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            this._rateLimits[category || 'all'] = new Date(now + delay);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        }
        else if (raHeader) {
            this._rateLimits.all = new Date(now + (0,misc/* parseRetryAfterHeader */.JY)(now, raHeader));
            return true;
        }
        return false;
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) { fetchImpl = getNativeFetchImplementation(); }
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: ((0,supports/* supportsReferrerPolicy */.hv)() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer
            .add(function () {
            return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
                void _this._fetch(sentryRequest.url, options)
                    .then(function (response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After'),
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject,
                    });
                })
                    .catch(reject);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof SentryError) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return FetchTransport;
}(BaseTransport));

//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer
            .add(function () {
            return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function () {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After'),
                        };
                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                    }
                };
                request.open('POST', sentryRequest.url);
                for (var header in _this.options.headers) {
                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
                        request.setRequestHeader(header, _this.options.headers[header]);
                    }
                }
                request.send(sentryRequest.body);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof SentryError) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return XHRTransport;
}(BaseTransport));

//# sourceMappingURL=xhr.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/backend.js






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return eventFromException(this._options, exception, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = Severity.Info; }
        return eventFromMessage(this._options, message, level, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if ((0,supports/* supportsFetch */.Ak)()) {
            return new FetchTransport(transportOptions);
        }
        return new XHRTransport(transportOptions);
    };
    return BrowserBackend;
}(BaseBackend));

//# sourceMappingURL=backend.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js






/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: SDK_VERSION,
                },
            ],
            version: SDK_VERSION,
        };
        _this = _super.call(this, BrowserBackend, options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = (0,esm_global/* getGlobalObject */.R)().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            esm_logger/* logger.error */.k.error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        injectReportDialog((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(Breadcrumbs);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(BaseClient));

//# sourceMappingURL=client.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js






var defaultIntegrations = [
    new InboundFilters(),
    new FunctionToString(),
    new TryCatch(),
    new Breadcrumbs(),
    new GlobalHandlers(),
    new LinkedErrors(),
    new Dedupe(),
    new UserAgent(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = (0,esm_global/* getGlobalObject */.R)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    initAndBind(BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    var hub = getCurrentHub();
    var scope = hub.getScope();
    if (scope) {
        options.user = __assign(__assign({}, scope.getUser()), options.user);
    }
    if (!options.eventId) {
        options.eventId = hub.lastEventId();
    }
    var client = hub.getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return getCurrentHub().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
    var client = getCurrentHub().getClient();
    if (client) {
        return client.flush(timeout);
    }
    if (isDebugBuild()) {
        logger.warn('Cannot flush events. No client defined.');
    }
    return resolvedSyncPromise(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
    var client = getCurrentHub().getClient();
    if (client) {
        return client.close(timeout);
    }
    if (isDebugBuild()) {
        logger.warn('Cannot flush events and disable SDK. No client defined.');
    }
    return resolvedSyncPromise(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
    return internalWrap(fn)();
}
function startSessionOnHub(hub) {
    hub.startSession({ ignoreDuration: true });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = (0,esm_global/* getGlobalObject */.R)();
    var document = window.document;
    if (typeof document === 'undefined') {
        if ((0,env/* isDebugBuild */.c)()) {
            esm_logger/* logger.warn */.k.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        }
        return;
    }
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) {
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0,instrument/* addInstrumentationHandler */.o)('history', function (_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) {
            startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
        }
    });
}
//# sourceMappingURL=sdk.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js

/**
 * Inits the React SDK
 */
function sdk_init(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: 'sentry.javascript.react',
        packages: [
            {
                name: 'npm:@sentry/react',
                version: SDK_VERSION,
            },
        ],
        version: SDK_VERSION,
    };
    init(options);
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(62758);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/constants.js
var constants = __webpack_require__(26257);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/backgroundtab.js



var backgroundtab_global = (0,esm_global/* getGlobalObject */.R)();
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
    if (backgroundtab_global && backgroundtab_global.document) {
        backgroundtab_global.document.addEventListener('visibilitychange', function () {
            var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
            if (backgroundtab_global.document.hidden && activeTransaction) {
                var statusType = 'cancelled';
                esm_logger/* logger.log */.k.log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!activeTransaction.status) {
                    activeTransaction.setStatus(statusType);
                }
                activeTransaction.setTag('visibilitychange', 'document.hidden');
                activeTransaction.setTag(constants/* FINISH_REASON_TAG */.d, constants/* IDLE_TRANSACTION_FINISH_REASONS.2 */.x[2]);
                activeTransaction.finish();
            }
        });
    }
    else {
        esm_logger/* logger.warn */.k.warn('[Tracing] Could not set up background tab detection due to lack of global document');
    }
}
//# sourceMappingURL=backgroundtab.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__(61422);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bindReporter = function (callback, metric, reportAllChanges) {
    var prevValue;
    return function (forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || prevValue === undefined) {
                    prevValue = metric.value;
                    callback(metric);
                }
            }
        }
    };
};
//# sourceMappingURL=bindReporter.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = function () {
    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};
//# sourceMappingURL=generateUniqueID.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var initMetric = function (name, value) {
    return {
        name: name,
        value: (value !== null && value !== void 0 ? value : -1),
        delta: 0,
        entries: [],
        id: generateUniqueID(),
    };
};
//# sourceMappingURL=initMetric.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = function (type, callback) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            // More extensive feature detect needed for Firefox due to:
            // https://github.com/GoogleChrome/web-vitals/issues/142
            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
                return;
            }
            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
            po.observe({ type: type, buffered: true });
            return po;
        }
    }
    catch (e) {
        // Do nothing.
    }
    return;
};
//# sourceMappingURL=observe.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var onHidden = function (cb, once) {
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' || (0,esm_global/* getGlobalObject */.R)().document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};
//# sourceMappingURL=onHidden.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var getCLS = function (onReport, reportAllChanges) {
    var metric = initMetric('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    var entryHandler = function (entry) {
        // Only count layout shifts without recent user input.
        // TODO: Figure out why entry can be undefined
        if (entry && !entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
            // If the entry occurred less than 1 second after the previous entry and
            // less than 5 seconds after the first entry in the session, include the
            // entry in the current session. Otherwise, start a new session.
            if (sessionValue &&
                sessionEntries.length !== 0 &&
                entry.startTime - lastSessionEntry.startTime < 1000 &&
                entry.startTime - firstSessionEntry.startTime < 5000) {
                sessionValue += entry.value;
                sessionEntries.push(entry);
            }
            else {
                sessionValue = entry.value;
                sessionEntries = [entry];
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                if (report) {
                    report();
                }
            }
        }
    };
    var po = observe('layout-shift', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            report(true);
        });
    }
};
//# sourceMappingURL=getCLS.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var firstHiddenTime = -1;
var initHiddenTime = function () {
    return (0,esm_global/* getGlobalObject */.R)().document.visibilityState === 'hidden' ? 0 : Infinity;
};
var trackChanges = function () {
    // Update the time if/when the document becomes hidden.
    onHidden(function (_a) {
        var timeStamp = _a.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function () {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        firstHiddenTime = initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime() {
            return firstHiddenTime;
        },
    };
};
//# sourceMappingURL=getVisibilityWatcher.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var getFID = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('FID');
    var report;
    var entryHandler = function (entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var po = observe('first-input', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            po.disconnect();
        }, true);
    }
};
//# sourceMappingURL=getFID.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var reportedMetricIDs = {};
var getLCP = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('LCP');
    var report;
    var entryHandler = function (entry) {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < visibilityWatcher.firstHiddenTime) {
            metric.value = value;
            metric.entries.push(entry);
        }
        if (report) {
            report();
        }
    };
    var po = observe('largest-contentful-paint', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        var stopListening_1 = function () {
            if (!reportedMetricIDs[metric.id]) {
                po.takeRecords().map(entryHandler);
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        ['keydown', 'click'].forEach(function (type) {
            addEventListener(type, stopListening_1, { once: true, capture: true });
        });
        onHidden(stopListening_1, true);
    }
};
//# sourceMappingURL=getLCP.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics.js







var metrics_global = (0,esm_global/* getGlobalObject */.R)();
/** Class tracking metrics  */
var MetricsInstrumentation = /** @class */ (function () {
    function MetricsInstrumentation(_reportAllChanges) {
        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
        this._reportAllChanges = _reportAllChanges;
        this._measurements = {};
        this._performanceCursor = 0;
        if (!(0,node/* isNodeEnv */.KV)() && metrics_global && metrics_global.performance && metrics_global.document) {
            if (metrics_global.performance.mark) {
                metrics_global.performance.mark('sentry-tracing-init');
            }
            this._trackCLS();
            this._trackLCP();
            this._trackFID();
        }
    }
    /** Add performance related spans to a transaction */
    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
        var _this = this;
        if (!metrics_global || !metrics_global.performance || !metrics_global.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
            // Gatekeeper if performance API not available
            return;
        }
        esm_logger/* logger.log */.k.log('[Tracing] Adding & adjusting spans using Performance API');
        var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
        var responseStartTimestamp;
        var requestStartTimestamp;
        metrics_global.performance
            .getEntries()
            .slice(this._performanceCursor)
            .forEach(function (entry) {
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            var duration = (0,utils/* msToSec */.XL)(entry.duration);
            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
                return;
            }
            switch (entry.entryType) {
                case 'navigation': {
                    addNavigationSpans(transaction, entry, timeOrigin);
                    responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
                    requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
                    break;
                }
                case 'mark':
                case 'paint':
                case 'measure': {
                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = getVisibilityWatcher();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        esm_logger/* logger.log */.k.log('[Measurements] Adding FP');
                        _this._measurements['fp'] = { value: entry.startTime };
                        _this._measurements['mark.fp'] = { value: startTimestamp };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        esm_logger/* logger.log */.k.log('[Measurements] Adding FCP');
                        _this._measurements['fcp'] = { value: entry.startTime };
                        _this._measurements['mark.fcp'] = { value: startTimestamp };
                    }
                    break;
                }
                case 'resource': {
                    var resourceName = entry.name.replace(metrics_global.location.origin, '');
                    addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
                default:
                // Ignore other entry types.
            }
        });
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
        this._trackNavigator(transaction);
        // Measurements are only available for pageload transactions
        if (transaction.op === 'pageload') {
            // normalize applicable web vital values to be relative to transaction.startTimestamp
            var timeOrigin_1 = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
            // start of the response in milliseconds
            if (typeof responseStartTimestamp === 'number') {
                esm_logger/* logger.log */.k.log('[Measurements] Adding TTFB');
                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
                    // Capture the time spent making the request and receiving the first byte of the response.
                    // This is the time between the start of the request and the start of the response in milliseconds.
                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
                }
            }
            ['fcp', 'fp', 'lcp'].forEach(function (name) {
                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
                    return;
                }
                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
                // to be adjusted to be relative to transaction.startTimestamp.
                var oldValue = _this._measurements[name].value;
                var measurementTimestamp = timeOrigin_1 + (0,utils/* msToSec */.XL)(oldValue);
                // normalizedValue should be in milliseconds
                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
                var delta = normalizedValue - oldValue;
                esm_logger/* logger.log */.k.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
                _this._measurements[name].value = normalizedValue;
            });
            if (this._measurements['mark.fid'] && this._measurements['fid']) {
                // create span for FID
                _startChild(transaction, {
                    description: 'first input delay',
                    endTimestamp: this._measurements['mark.fid'].value + (0,utils/* msToSec */.XL)(this._measurements['fid'].value),
                    op: 'web.vitals',
                    startTimestamp: this._measurements['mark.fid'].value,
                });
            }
            // If FCP is not recorded we should not record the cls value
            // according to the new definition of CLS.
            if (!('fcp' in this._measurements)) {
                delete this._measurements.cls;
            }
            transaction.setMeasurements(this._measurements);
            tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
        }
    };
    /**
     * Capture the information of the user agent.
     */
    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
        var navigator = metrics_global.navigator;
        if (!navigator) {
            return;
        }
        // track network connectivity
        var connection = navigator.connection;
        if (connection) {
            if (connection.effectiveType) {
                transaction.setTag('effectiveConnectionType', connection.effectiveType);
            }
            if (connection.type) {
                transaction.setTag('connectionType', connection.type);
            }
            if (isMeasurementValue(connection.rtt)) {
                this._measurements['connection.rtt'] = { value: connection.rtt };
            }
            if (isMeasurementValue(connection.downlink)) {
                this._measurements['connection.downlink'] = { value: connection.downlink };
            }
        }
        if (isMeasurementValue(navigator.deviceMemory)) {
            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
        }
        if (isMeasurementValue(navigator.hardwareConcurrency)) {
            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
        }
    };
    /** Starts tracking the Cumulative Layout Shift on the current page. */
    MetricsInstrumentation.prototype._trackCLS = function () {
        var _this = this;
        // See:
        // https://web.dev/evolving-cls/
        // https://web.dev/cls-web-tooling/
        getCLS(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            esm_logger/* logger.log */.k.log('[Measurements] Adding CLS');
            _this._measurements['cls'] = { value: metric.value };
            _this._clsEntry = entry;
        });
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */
    MetricsInstrumentation.prototype._trackLCP = function () {
        var _this = this;
        getLCP(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            esm_logger/* logger.log */.k.log('[Measurements] Adding LCP');
            _this._measurements['lcp'] = { value: metric.value };
            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
            _this._lcpEntry = entry;
        }, this._reportAllChanges);
    };
    /** Starts tracking the First Input Delay on the current page. */
    MetricsInstrumentation.prototype._trackFID = function () {
        var _this = this;
        getFID(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            esm_logger/* logger.log */.k.log('[Measurements] Adding FID');
            _this._measurements['fid'] = { value: metric.value };
            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
        });
    };
    return MetricsInstrumentation;
}());

/** Instrument navigation entries */
function addNavigationSpans(transaction, entry, timeOrigin) {
    ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
        addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */
function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp,
    });
    return measureStartTimestamp;
}
/** Create resource-related spans */
function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
        return;
    }
    var data = {};
    if ('transferSize' in entry) {
        data['Transfer Size'] = entry.transferSize;
    }
    if ('encodedBodySize' in entry) {
        data['Encoded Body Size'] = entry.encodedBodySize;
    }
    if ('decodedBodySize' in entry) {
        data['Decoded Body Size'] = entry.decodedBodySize;
    }
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
        startTimestamp: startTimestamp,
        data: data,
    });
}
/** Create performance navigation related spans */
function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        op: 'browser',
        description: (description !== null && description !== void 0 ? description : event),
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
    });
}
/** Create request and response related spans */
function addRequest(transaction, entry, timeOrigin) {
    _startChild(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd),
    });
    _startChild(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd),
    });
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = (0,tslib_es6/* __rest */._T)(_a, ["startTimestamp"]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        transaction.startTimestamp = startTimestamp;
    }
    return transaction.startChild((0,tslib_es6/* __assign */.pi)({ startTimestamp: startTimestamp }, ctx));
}
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/** Add LCP / CLS data to transaction to allow debugging */
function tagMetricInfo(transaction, lcpEntry, clsEntry) {
    if (lcpEntry) {
        esm_logger/* logger.log */.k.log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if (lcpEntry.element) {
            transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.R)(lcpEntry.element));
        }
        if (lcpEntry.id) {
            transaction.setTag('lcp.id', lcpEntry.id);
        }
        if (lcpEntry.url) {
            // Trim URL to the first 200 characters.
            transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
        }
        transaction.setTag('lcp.size', lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (clsEntry && clsEntry.sources) {
        esm_logger/* logger.log */.k.log('[Measurements] Adding CLS Data');
        clsEntry.sources.forEach(function (source, index) {
            return transaction.setTag("cls.source." + (index + 1), (0,browser/* htmlTreeAsString */.R)(source.node));
        });
    }
}
//# sourceMappingURL=metrics.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/request.js



var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: DEFAULT_TRACING_ORIGINS,
};
/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function (url) {
        if (urlMap[url]) {
            return urlMap[url];
        }
        var origins = tracingOrigins;
        urlMap[url] =
            origins.some(function (origin) { return (0,string/* isMatchingPattern */.zC)(url, origin); }) &&
                !(0,string/* isMatchingPattern */.zC)(url, 'sentry_key');
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === 'function') {
        shouldCreateSpan = function (url) {
            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
        };
    }
    var spans = {};
    if (traceFetch) {
        (0,instrument/* addInstrumentationHandler */.o)('fetch', function (handlerData) {
            fetchCallback(handlerData, shouldCreateSpan, spans);
        });
    }
    if (traceXHR) {
        (0,instrument/* addInstrumentationHandler */.o)('xhr', function (handlerData) {
            xhrCallback(handlerData, shouldCreateSpan, spans);
        });
    }
}
/**
 * Create and track fetch request spans
 */
function fetchCallback(handlerData, shouldCreateSpan, spans) {
    if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
        return;
    }
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
            }
            else if (handlerData.error) {
                span.setStatus('internal_error');
            }
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { type: 'fetch' }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: 'http.client',
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = (handlerData.args[0] = handlerData.args[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = (handlerData.args[1] = handlerData.args[1] || {});
        var headers = options.headers;
        if ((0,is/* isInstanceOf */.V9)(request, Request)) {
            headers = request.headers;
        }
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                headers.append('sentry-trace', span.toTraceparent());
            }
            else if (Array.isArray(headers)) {
                headers = (0,tslib_es6/* __spread */.fl)(headers, [['sentry-trace', span.toTraceparent()]]);
            }
            else {
                headers = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, headers), { 'sentry-trace': span.toTraceparent() });
            }
        }
        else {
            headers = { 'sentry-trace': span.toTraceparent() };
        }
        options.headers = headers;
    }
}
/**
 * Create and track xhr request spans
 */
function xhrCallback(handlerData, shouldCreateSpan, spans) {
    if (!(0,utils/* hasTracingEnabled */.zu)() ||
        (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
        return;
    }
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
            description: xhr.method + " " + xhr.url,
            op: 'http.client',
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) {
            try {
                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            }
            catch (_) {
                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
            }
        }
    }
}
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/router.js

var router_global = (0,esm_global/* getGlobalObject */.R)();
/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    if (!router_global || !router_global.location) {
        esm_logger/* logger.warn */.k.warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = router_global.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = customStartTransaction({ name: router_global.location.pathname, op: 'pageload' });
    }
    if (startTransactionOnLocationChange) {
        (0,instrument/* addInstrumentationHandler */.o)('history', function (_a) {
            var to = _a.to, from = _a.from;
            /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */
            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    esm_logger/* logger.log */.k.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.finish();
                }
                activeTransaction = customStartTransaction({ name: router_global.location.pathname, op: 'navigation' });
            }
        });
    }
}
//# sourceMappingURL=router.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/browsertracing.js









var DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
var DEFAULT_BROWSER_TRACING_OPTIONS = (0,tslib_es6/* __assign */.pi)({ idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT, markBackgroundTransactions: true, maxTransactionDuration: DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, defaultRequestInstrumentationOptions);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
var BrowserTracing = /** @class */ (function () {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */
        this.name = BrowserTracing.id;
        this._emitOptionsWarning = false;
        /** Store configured idle timeout so that it can be added as a tag to transactions */
        this._configuredIdleTimeout = undefined;
        var tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options) {
            this._configuredIdleTimeout = _options.idleTimeout;
            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
                tracingOrigins = _options.tracingOrigins;
            }
            else {
                this._emitOptionsWarning = true;
            }
        }
        this.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
        var _metricOptions = this.options._metricOptions;
        this._metrics = new MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
    }
    /**
     * @inheritDoc
     */
    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            esm_logger/* logger.warn */.k.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
            esm_logger/* logger.warn */.k.warn("[Tracing] We added a reasonable default for you: " + defaultRequestInstrumentationOptions.tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) {
            registerBackgroundTabDetection();
        }
        instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
    };
    /** Create routing idle transaction. */
    BrowserTracing.prototype._createRouteTransaction = function (context) {
        var _this = this;
        if (!this._getCurrentHub) {
            esm_logger/* logger.warn */.k.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
        var expandedContext = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), parentContextFromHeader), { trimEnd: true });
        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, expandedContext), { sampled: false }) : modifiedContext;
        if (finalContext.sampled === false) {
            esm_logger/* logger.log */.k.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
        }
        esm_logger/* logger.log */.k.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
        var hub = this._getCurrentHub();
        var location = (0,esm_global/* getGlobalObject */.R)().location;
        var idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(hub, finalContext, idleTimeout, true, { location: location });
        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            adjustTransactionDuration((0,utils/* secToMs */.WB)(maxTransactionDuration), transaction, endTimestamp);
        });
        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */
    BrowserTracing.id = 'BrowserTracing';
    return BrowserTracing;
}());

/**
 * Gets transaction context from a sentry-trace meta.
 *
 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
 */
function getHeaderContext() {
    var header = getMetaContent('sentry-trace');
    if (header) {
        return (0,utils/* extractTraceparentData */.qG)(header);
    }
    return undefined;
}
/** Returns the value of a meta tag */
function getMetaContent(metaName) {
    var el = (0,esm_global/* getGlobalObject */.R)().document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute('content') : null;
}
/** Adjusts transaction value based on max transaction duration */
function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus('deadline_exceeded');
        transaction.setTag('maxTransactionDurationExceeded', 'true');
    }
}
//# sourceMappingURL=browsertracing.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js



// This is already exported as part of `Integrations` above (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
//
// Previously we expected users to import tracing integrations like
//
// import { Integrations } from '@sentry/tracing';
// const instance = new Integrations.BrowserTracing();
//
// This makes the integrations unable to be treeshaken though. To address this, we now have
// this individual export. We now expect users to consume BrowserTracing like so:
//
// import { BrowserTracing } from '@sentry/tracing';
// const instance = new BrowserTracing();
//
// For an example of of the new usage of BrowserTracing, see @sentry/nextjs index.client.ts


// eslint-disable-next-line deprecation/deprecation





// We are patching the global object with our hub extension methods
(0,hubextensions/* addExtensionMethods */.ro)();


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/performance/client.js
/* eslint-disable @typescript-eslint/no-explicit-any */



var client_global = (0,esm_global/* getGlobalObject */.R)();
var DEFAULT_TAGS = {
    'routing.instrumentation': 'next-router',
};
var activeTransaction = undefined;
var prevTransactionName = undefined;
var startTransaction = undefined;
/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    startTransaction = startTransactionCb;
    router_default().ready(function () {
        // We can only start the pageload transaction when we have access to the parameterized
        // route name. Setting the transaction name after the transaction is started could lead
        // to possible race conditions with the router, so this approach was taken.
        if (startTransactionOnPageLoad) {
            prevTransactionName = (router_default()).route !== null ? (0,misc/* stripUrlQueryAndFragment */.rt)((router_default()).route) : client_global.location.pathname;
            activeTransaction = startTransactionCb({
                name: prevTransactionName,
                op: 'pageload',
                tags: DEFAULT_TAGS,
            });
        }
        // Spans that aren't attached to any transaction are lost; so if transactions aren't
        // created (besides potentially the onpageload transaction), no need to wrap the router.
        if (!startTransactionOnLocationChange)
            return;
        // `withRouter` uses `useRouter` underneath:
        // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/with-router.tsx#L21
        // Router events also use the router:
        // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/router.ts#L92
        // `Router.changeState` handles the router state changes, so it may be enough to only wrap it
        // (instead of wrapping all of the Router's functions).
        var routerPrototype = Object.getPrototypeOf((router_default()).router);
        (0,object/* fill */.hl)(routerPrototype, 'changeState', changeStateWrapper);
    });
}
/**
 * Wraps Router.changeState()
 * https://github.com/vercel/next.js/blob/da97a18dafc7799e63aa7985adc95f213c2bf5f3/packages/next/next-server/lib/router/router.ts#L1204
 * Start a navigation transaction every time the router changes state.
 */
function changeStateWrapper(originalChangeStateWrapper) {
    var wrapper = function (method, 
    // The parameterized url, ex. posts/[id]/[comment]
    url, 
    // The actual url, ex. posts/85/my-comment
    as, options) {
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        var args = [];
        for (
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        var _i = 4; 
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        _i < arguments.length; 
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        _i++) {
            // At the moment there are no additional arguments (meaning the rest parameter is empty).
            // This is meant to protect from future additions to Next.js API, especially since this is an
            // internal API.
            args[_i - 4] = arguments[_i];
        }
        var newTransactionName = (0,misc/* stripUrlQueryAndFragment */.rt)(url);
        // do not start a transaction if it's from the same page
        if (startTransaction !== undefined && prevTransactionName !== newTransactionName) {
            if (activeTransaction) {
                activeTransaction.finish();
            }
            var tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, DEFAULT_TAGS), { method: method }), options);
            if (prevTransactionName) {
                tags.from = prevTransactionName;
            }
            prevTransactionName = newTransactionName;
            activeTransaction = startTransaction({
                name: prevTransactionName,
                op: 'navigation',
                tags: tags,
            });
        }
        return originalChangeStateWrapper.call.apply(originalChangeStateWrapper, (0,tslib_es6/* __spread */.fl)([this, method, url, as, options], args));
    };
    return wrapper;
}
//# sourceMappingURL=client.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/metadata.js

var PACKAGE_NAME_PREFIX = 'npm:@sentry/';
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
    options._metadata = options._metadata || {};
    options._metadata.sdk =
        options._metadata.sdk ||
            {
                name: 'sentry.javascript.nextjs',
                packages: names.map(function (name) { return ({
                    name: "" + PACKAGE_NAME_PREFIX + name,
                    version: SDK_VERSION,
                }); }),
                version: SDK_VERSION,
            };
}
//# sourceMappingURL=metadata.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/userIntegrations.js

/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
    // Ex. foo.bar.zoop will extract foo and bar.zoop
    var match = keyPath.match(/([a-z]+)\.(.*)/i);
    if (match === null) {
        obj[keyPath] = value;
    }
    else {
        setNestedKey(obj[match[1]], match[2], value);
    }
}
/**
 * Retrieves the patched integrations with the provided integration.
 *
 * The integration must be present in the final user integrations, and they are compared
 * by integration name. If the user has defined one, there's nothing to patch; if not,
 * the provided integration is added.
 *
 * @param integration The integration to patch, if necessary.
 * @param userIntegrations Integrations defined by the user.
 * @param options options to update for a particular integration
 * @returns Final integrations, patched if necessary.
 */
function addIntegration(integration, userIntegrations, options) {
    if (options === void 0) { options = {}; }
    if (Array.isArray(userIntegrations)) {
        return addIntegrationToArray(integration, userIntegrations, options);
    }
    else {
        return addIntegrationToFunction(integration, userIntegrations, options);
    }
}
function addIntegrationToArray(integration, userIntegrations, options) {
    var includesName = false;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var x = 0; x < userIntegrations.length; x++) {
        if (userIntegrations[x].name === integration.name) {
            includesName = true;
        }
        var op = options[userIntegrations[x].name];
        if (op) {
            setNestedKey(userIntegrations[x], op.keyPath, op.value);
        }
    }
    if (includesName) {
        return userIntegrations;
    }
    return (0,tslib_es6/* __spread */.fl)(userIntegrations, [integration]);
}
function addIntegrationToFunction(integration, userIntegrationsFunc, options) {
    var wrapper = function (defaultIntegrations) {
        var userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
        return addIntegrationToArray(integration, userFinalIntegrations, options);
    };
    return wrapper;
}
//# sourceMappingURL=userIntegrations.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js








var Integrations = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, INTEGRATIONS), { BrowserTracing: BrowserTracing });
// This is already exported as part of `Integrations` above (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
//
// Previously we expected users to import `BrowserTracing` like this:
//
// import { Integrations } from '@sentry/nextjs';
// const instance = new Integrations.BrowserTracing();
//
// This makes the integrations unable to be treeshaken though. To address this, we now have
// this individual export. We now expect users to consume BrowserTracing like so:
//
// import { BrowserTracing } from '@sentry/nextjs';
// const instance = new BrowserTracing();

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
    buildMetadata(options, ['nextjs', 'react']);
    options.environment = options.environment || "production";
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    var integrations = options.tracesSampleRate === undefined && options.tracesSampler === undefined
        ? options.integrations
        : createClientIntegrations(options.integrations);
    sdk_init((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { integrations: integrations }));
    (0,esm/* configureScope */.e)(function (scope) {
        scope.setTag('runtime', 'browser');
        scope.addEventProcessor(function (event) { return (event.type === 'transaction' && event.transaction === '/404' ? null : event); });
    });
}
var defaultBrowserTracingIntegration = new BrowserTracing({
    tracingOrigins: (0,tslib_es6/* __spread */.fl)(defaultRequestInstrumentationOptions.tracingOrigins, [/^(api\/)/]),
    routingInstrumentation: nextRouterInstrumentation,
});
function createClientIntegrations(integrations) {
    if (integrations) {
        return addIntegration(defaultBrowserTracingIntegration, integrations, {
            BrowserTracing: { keyPath: 'options.routingInstrumentation', value: nextRouterInstrumentation },
        });
    }
    else {
        return [defaultBrowserTracingIntegration];
    }
}
//# sourceMappingURL=index.client.js.map
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./sentry.client.config.js


var sentry_client_config_config = config_default()();

if (sentry_client_config_config && sentry_client_config_config.publicRuntimeConfig) {
  index_client_init({
    dsn: sentry_client_config_config.publicRuntimeConfig.features.sentryDSN,
    tracesSampleRate: 0.1,
    environment: sentry_client_config_config.publicRuntimeConfig.environment,
    release: sentry_client_config_config.publicRuntimeConfig.version,
    autoSessionTracking: false,
    // beforeSend: (event, hint) => {
    //   console.warn('client');
    //   return event;
    // },
    // debug: true,
    sampleRate: 1,
    ignoreErrors: [/lastVisibilityStart/, /eventParam.trigger/, /Unexpected token '.'/, /DeviceUUID not set/, /t is undefined/, /runCustomize/, /processRandomSelector/, /illegal character U+009E/]
  });
} else {
  console.warn("publicRuntimeConfig not found. Sentry doesn't work");
}

/***/ }),

/***/ 31893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WK": function() { return /* binding */ CONTAINER_ID; }
/* harmony export */ });
/* unused harmony export disabledMetrics */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable */


var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var CONTAINER_ID = publicRuntimeConfig.trackers.GTMTrackingId;
var disabledMetrics = publicRuntimeConfig.trackers.disabledMetrics;
var isGTMEnable = !!CONTAINER_ID;
var PAGE_TYPES = {
  HOME: 'home',
  SEARCH_RESULTS: 'search',
  CATEGORY: 'category',
  BRAND: 'brand',
  PRODUCT: 'product',
  CART: 'cart',
  CHECKOUT: 'checkout',
  PURCHASE: 'purchase',
  PROFILE: 'profile',
  WISHLIST: 'wishlist',
  SPECIAL: 'special',
  NEWS: 'news',
  CONTACTS: 'contacts',
  OTHER: 'other'
};
var SOCIAL_BANNER_TYPE = {
  GOOGLE_PLAY: 'google play',
  APP_STORE: 'appstore'
};

var convertBYNToUSD = function convertBYNToUSD(price, currency) {
  return currency && Object.keys(currency).length > 0 ? Math.round(price / currency.USD.BYN * 100) / 100 : price;
};

var withErrorHandler = function withErrorHandler(f) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ecommerce';

  if (isGTMEnable) {
    try {
      f();
    } catch (error) {
      console.error("Can't track ".concat(name, " event:"), error);
    }
  }
};

var subscribeByEmail = function subscribeByEmail() {
  withErrorHandler(function () {
    setDataLayer({
      event: 'onSubscribe'
    });
  }, 'onSubscribe');
};

var viewItemList = function viewItemList(products, currency, listName, event, index, value) {
  var successInfo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  withErrorHandler(function () {
    var listNameObj = {
      item_list_name: listName
    };
    var itemListName = event === 'view_cart' || event === 'begin_checkout' ? {} : listNameObj;
    var itemListNameProduct = event === 'view_cart' || event === 'begin_checkout' ? listNameObj : {};
    var valueObj = value ? {
      value: convertBYNToUSD(value, currency)
    } : {};
    var items = products.map(function (_ref, idx) {
      var external_id = _ref.external_id,
          name = _ref.name,
          price = _ref.price,
          old_price = _ref.old_price,
          price_diff_percent = _ref.price_diff_percent,
          brand = _ref.brand,
          _ref$category = _ref.category,
          category = _ref$category === void 0 ? '' : _ref$category,
          categoriesList = _ref.categories,
          _ref$switchable_attri = _ref.switchable_attributes,
          switchable_attributes = _ref$switchable_attri === void 0 ? [] : _ref$switchable_attri,
          _ref$quantity = _ref.quantity,
          quantity = _ref$quantity === void 0 ? null : _ref$quantity,
          _ref$cart_quantity = _ref.cart_quantity,
          cart_quantity = _ref$cart_quantity === void 0 ? null : _ref$cart_quantity,
          _ref$sex = _ref.sex,
          sex = _ref$sex === void 0 ? null : _ref$sex,
          _ref$pol = _ref.pol,
          pol = _ref$pol === void 0 ? null : _ref$pol,
          _ref$name_marketing = _ref.name_marketing,
          name_marketing = _ref$name_marketing === void 0 ? null : _ref$name_marketing,
          _ref$meta = _ref.meta,
          meta = _ref$meta === void 0 ? null : _ref$meta,
          model = _ref.model;
      var categories = {
        item_category: sex || pol,
        item_category2: '',
        item_category3: '',
        item_category4: ''
      };

      if (meta && Object.keys(meta).length > 0 && event !== 'remove_from_cart') {
        itemListNameProduct = {
          item_list_name: meta !== null && meta !== void 0 && meta.pageName ? meta.pageName : 'Страница товара',
          index: meta !== null && meta !== void 0 && meta.indexCard ? meta.indexCard : index
        };
      }

      var counter = 4;

      if (categoriesList && categoriesList.length === 2) {
        counter = 3;
      } else if (categoriesList && categoriesList.length === 1) {
        counter = 2;
      }

      if (categoriesList && categoriesList.length) {
        for (var i = categoriesList.length - 1, j = counter; i >= 0, j > 1; i--, j--) {
          if (categoriesList[i]) {
            categories["item_category".concat(j)] = categoriesList[i];
          }
        }
      }

      var item_variant = {};

      if (switchable_attributes !== null && switchable_attributes !== void 0 && switchable_attributes.length) {
        var itemVariant = '';

        for (var _i = 0; _i < switchable_attributes.length; _i++) {
          if (_i !== 0) {
            itemVariant += '-';
          }

          itemVariant += switchable_attributes[_i].value;
        }

        item_variant = {
          item_variant: itemVariant
        };
      }

      var quantityObj = quantity || cart_quantity ? {
        quantity: cart_quantity || quantity
      } : {};
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        item_id: (model === null || model === void 0 ? void 0 : model.slug) || external_id,
        item_name: name_marketing || name,
        price: convertBYNToUSD(price, currency),
        discount: convertBYNToUSD(old_price - price, currency),
        item_brand: brand,
        item_category: category === null || category === void 0 ? void 0 : category.name
      }, categories), {}, {
        coupon: price_diff_percent ? "".concat(price_diff_percent, "%") : '0%'
      }, quantityObj), item_variant), {}, {
        index: index ? index : idx + 1
      }, itemListNameProduct);
    });
    setDataLayer({
      event: event ? event : 'view_item_list',
      ecommerce: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        currency: 'USD'
      }, valueObj), itemListName), successInfo), {}, {
        items: items
      }),
      _clear: true
    });
  }, 'viewItemList');
};

var setPageType = function setPageType(pageType) {
  withErrorHandler(function () {
    setDataLayer({
      pageType: pageType
    });
  }, 'setPageType');
};

var setLogin = function setLogin(event, user_id) {
  withErrorHandler(function () {
    setDataLayer({
      event: event,
      user_id: user_id
    });
  }, 'setLogin');
};

var setSubscribe = function setSubscribe(check) {
  withErrorHandler(function () {
    setDataLayer({
      event: check ? 'subscribe' : 'unsubscribe'
    });
  }, 'setSubscribe');
};

var setSearch = function setSearch(searchString) {
  withErrorHandler(function () {
    setDataLayer({
      event: 'search',
      search_term: searchString
    });
  }, 'setSearch');
};

var setDataLayer = function setDataLayer(config) {
  if (true) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(config);
  }
};

/* harmony default export */ __webpack_exports__["ZP"] = ({
  PAGE_TYPES: PAGE_TYPES,
  SOCIAL_BANNER_TYPE: SOCIAL_BANNER_TYPE,
  subscribeByEmail: subscribeByEmail,
  setPageType: setPageType,
  viewItemList: viewItemList,
  setLogin: setLogin,
  setSubscribe: setSubscribe,
  setSearch: setSearch
});

/***/ }),

/***/ 37286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ JsonLdData; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6668);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var socialLinks = _lib_config__WEBPACK_IMPORTED_MODULE_2__/* .socialList.map */ .Ok.map(function (item) {
  return item === null || item === void 0 ? void 0 : item.href;
});
var webSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'FH.BY',
  url: 'https://fh.by',
  sameAs: socialLinks
};
var organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'FH.BY',
  url: 'https://fh.by',
  logo: 'https://fh.by/android-chrome-512x512.png',
  sameAs: socialLinks,
  contactPoint: [{
    '@type': 'ContactPoint',
    telephone: '+375 (29) 633-2-633',
    contactType: 'FH.BY',
    areaServed: 'BY'
  }, {
    '@type': 'ContactPoint',
    telephone: '+375 (17) 328-60-79',
    email: 'fh@fh.by',
    contactType: 'По общим вопросам',
    areaServed: 'BY'
  }, {
    '@type': 'ContactPoint',
    contactType: 'По вопросам рекламы',
    email: 'reklama@fh.by',
    areaServed: 'BY'
  }, {
    '@type': 'ContactPoint',
    email: 'otzyv@fh.by',
    contactType: 'По вопросам замечаний и предложений',
    areaServed: 'BY'
  }, {
    '@type': 'ContactPoint',
    email: 'personal@fh.by',
    telephone: '+375 (44) 768-66-50',
    contactType: 'По вопросам трудоустройства',
    areaServed: 'BY'
  }, {
    '@type': 'ContactPoint',
    email: 'personal@fh.by',
    telephone: '+375 (44) 566-47-66',
    contactType: 'По вопросам трудоустройства',
    areaServed: 'BY'
  }, {
    '@type': 'ContactPoint',
    email: 'personal@fh.by',
    telephone: '+375 (44) 768-66-50',
    contactType: 'По вопросам трудоустройства',
    areaServed: 'BY'
  }, {
    '@type': 'ContactPoint',
    email: 'personal@fh.by',
    telephone: '+375 (17) 328-63-27',
    contactType: 'По вопросам трудоустройства',
    areaServed: 'BY'
  }]
};

var breadCrumbsList = function breadCrumbsList() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var join = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var startId = 'https://fh.by';
  var listElements = list.reduce(function (acc, item, ind) {
    var name = item.name,
        value = item.value;
    var nextId = "".concat(startId, "/").concat(value);
    if (join) startId = nextId;
    return acc.concat({
      '@type': 'ListItem',
      position: ind + 2,
      item: {
        '@id': nextId,
        name: name
      }
    });
  }, [{
    '@type': 'ListItem',
    position: 1,
    item: {
      '@id': startId,
      name: 'FH.BY'
    }
  }]);
  return {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: listElements
  };
};

var getImageFromPic = function getImageFromPic(pic) {
  var _pic$x;

  return (_pic$x = pic === null || pic === void 0 ? void 0 : pic.x2) !== null && _pic$x !== void 0 ? _pic$x : '';
};

var productData = function productData(data) {
  var _ref = data || {},
      name = _ref.name,
      brand = _ref.brand,
      description = _ref.description,
      gallery = _ref.gallery,
      external_id = _ref.external_id,
      slug = _ref.slug,
      price = _ref.price,
      old_price = _ref.old_price,
      quantity = _ref.quantity,
      attributes = _ref.attributes;

  var inStock = quantity !== 0;
  var trimmedDescription = (description || '').trim();
  var infoAttributes = (attributes || []).filter(function (attr) {
    return attr.type === 'info';
  });
  var productDescription = infoAttributes.reduce(function (acc, attr) {
    var _ref2 = attr || {},
        attrName = _ref2.name,
        value = _ref2.value;

    return acc.concat(" ".concat(attrName, ": ").concat(value, "."));
  }, trimmedDescription.endsWith('.') ? trimmedDescription : trimmedDescription.concat('.'));
  var currency = 'BYN';

  if ( true && localStorage.getItem('currency') === 'RU') {
    currency = '₽';
  }

  return {
    '@context': 'http://www.schema.org',
    '@type': 'Product',
    name: name,
    brand: {
      '@type': 'Brand',
      name: brand
    },
    description: productDescription,
    image: getImageFromPic(gallery === null || gallery === void 0 ? void 0 : gallery[0]),
    productID: external_id,
    sku: external_id,
    itemCondition: 'https://schema.org/NewCondition',
    offers: {
      '@type': 'Offer',
      priceCurrency: currency,
      price: Number(price),
      priceSpecification: {
        '@type': 'UnitPriceSpecification',
        priceType: 'https://schema.org/StrikethroughPrice',
        price: Number(old_price),
        priceCurrency: 'BYN'
      },
      url: "https://fh.by/product/".concat(slug),
      availability: "https://schema.org/".concat(inStock ? 'InStock' : 'OutOfStock'),
      seller: {
        '@type': 'Organization',
        name: 'FH.BY',
        logo: {
          '@type': 'ImageObject',
          url: 'https://fh.by/android-chrome-512x512.png'
        }
      }
    }
  };
};

var categoryData = function categoryData(_ref3) {
  var _category$name, _category$seo$agregat, _category$seo, _category$seo$agregat2, _category$seo$agregat3, _category$seo2, _category$seo2$agrega, _category$min_price, _category$max_price;

  var category = _ref3.category,
      totalProducts = _ref3.totalProducts;
  var currency = 'BYN';

  if ( true && localStorage && localStorage.getItem('currency') === 'RU') {
    currency = '₽';
  }

  return {
    '@context': 'http://www.schema.org',
    '@type': 'Product',
    name: (_category$name = category === null || category === void 0 ? void 0 : category.name) !== null && _category$name !== void 0 ? _category$name : '',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: (_category$seo$agregat = category === null || category === void 0 ? void 0 : (_category$seo = category.seo) === null || _category$seo === void 0 ? void 0 : (_category$seo$agregat2 = _category$seo.agregate_rating) === null || _category$seo$agregat2 === void 0 ? void 0 : _category$seo$agregat2.rating_value) !== null && _category$seo$agregat !== void 0 ? _category$seo$agregat : 0,
      ratingCount: (_category$seo$agregat3 = category === null || category === void 0 ? void 0 : (_category$seo2 = category.seo) === null || _category$seo2 === void 0 ? void 0 : (_category$seo2$agrega = _category$seo2.agregate_rating) === null || _category$seo2$agrega === void 0 ? void 0 : _category$seo2$agrega.rating_count) !== null && _category$seo$agregat3 !== void 0 ? _category$seo$agregat3 : 0
    },
    image: 'https://fh.by/android-chrome-512x512.png',
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: currency,
      offerCount: totalProducts || 0,
      lowPrice: (_category$min_price = category === null || category === void 0 ? void 0 : category.min_price) !== null && _category$min_price !== void 0 ? _category$min_price : 0,
      highPrice: (_category$max_price = category === null || category === void 0 ? void 0 : category.max_price) !== null && _category$max_price !== void 0 ? _category$max_price : 0
    }
  };
};

var newsArticleData = function newsArticleData(data) {
  var _ref4 = data || {},
      title = _ref4.title,
      image = _ref4.image,
      type = _ref4.type,
      slug = _ref4.slug,
      published_at = _ref4.published_at,
      modified_at = _ref4.modified_at,
      meta_description = _ref4.meta_description;

  var fixedSlug = slug === null || slug === void 0 ? void 0 : slug.split('/').join('');
  return _objectSpread(_objectSpread({
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': "https://fh.by/".concat(type === 'article' ? "news/".concat(fixedSlug) : "special-offers/".concat(fixedSlug))
    },
    headline: title,
    datePublished: published_at,
    dateModified: modified_at,
    author: {
      '@type': 'Organization',
      name: 'FH.BY',
      logo: {
        '@type': 'ImageObject',
        url: 'https://fh.by/android-chrome-512x512.png'
      }
    },
    publisher: {
      '@type': 'Organization',
      name: 'FH.BY',
      logo: {
        '@type': 'ImageObject',
        url: 'https://fh.by/android-chrome-512x512.png'
      }
    }
  }, image && {
    image: getImageFromPic(image)
  }), meta_description && {
    description: meta_description
  });
};

/* harmony default export */ __webpack_exports__["Z"] = ({
  webSite: webSite,
  organization: organization,
  breadCrumbsList: breadCrumbsList,
  productData: productData
});
var JsonLdData = function JsonLdData(_ref5) {
  var breadCrumbsProps = _ref5.breadCrumbsProps,
      product = _ref5.product,
      category = _ref5.category,
      totalProducts = _ref5.totalProducts,
      newsArticle = _ref5.newsArticle;
  // eslint-disable-next-line no-nested-ternary
  var type = product ? 'product' : category ? 'category' : newsArticle ? 'newsArticle' : null;
  var data = [];

  switch (type) {
    case 'product':
      {
        var _product$breadcrumbs;

        var breadCrumbs = ((_product$breadcrumbs = product === null || product === void 0 ? void 0 : product.breadcrumbs) !== null && _product$breadcrumbs !== void 0 ? _product$breadcrumbs : []).map(function (item, ind, arr) {
          return ind === arr.length - 1 ? {
            name: item === null || item === void 0 ? void 0 : item.name,
            value: "product/".concat(product === null || product === void 0 ? void 0 : product.slug)
          } : {
            name: item === null || item === void 0 ? void 0 : item.name,
            value: item === null || item === void 0 ? void 0 : item.slug
          };
        });
        data = [webSite, organization, productData(product), breadCrumbsList(breadCrumbs, false)];
        break;
      }

    case 'newsArticle':
      {
        var articleType = newsArticle.articleType,
            title = newsArticle.title,
            slug = newsArticle.slug;
        var _breadCrumbs = [{
          name: articleType === 'article' ? 'Новости' : 'Акции',
          value: articleType === 'article' ? 'news' : 'special-offers'
        }, {
          name: title,
          value: slug === null || slug === void 0 ? void 0 : slug.split('/').join('')
        }];
        data = [webSite, organization, newsArticleData(newsArticle), breadCrumbsList(_breadCrumbs, false)];
        break;
      }

    case 'category':
      {
        var _ref6 = category || {},
            name = _ref6.name,
            path = _ref6.path;

        var _breadCrumbs2 = [{
          name: name,
          value: path
        }];
        data = [webSite, organization, categoryData({
          category: category,
          totalProducts: totalProducts
        }), breadCrumbsList(_breadCrumbs2)];
        break;
      }

    default:
      {
        data = [webSite, organization, breadCrumbsList(breadCrumbsProps)];
        break;
      }
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("script", {
      type: "application/ld+json"
      /* eslint-disable-next-line react/no-danger */
      ,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    }, 'json-ld')
  });
};

/***/ }),

/***/ 22182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MINDBOX_ENDPOINT_ID, MINDBOX_SENDER_ID */
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);



var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var MINDBOX_ENDPOINT_ID = publicRuntimeConfig.trackers.MindboxEndpointId;
var MINDBOX_SENDER_ID = publicRuntimeConfig.trackers.MindboxSenderId;
var COOKIE_MINDBOX_SUBSCRIBE_LOCK = 'fh_subscribe_lock';
var isMindboxEnable = !!MINDBOX_ENDPOINT_ID;

var send = function send() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'mindbox';
  var data = arguments.length > 1 ? arguments[1] : undefined;

  if (isMindboxEnable) {
    try {
      window.mindbox('sync', {
        operation: name,
        data: data
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Can't track mindbox ".concat(name, " event:"), error);
    }
  }
};

var displayProductDetail = function displayProductDetail(_ref) {
  var product = _ref.product;

  if (product.uuid) {
    send('Website.ViewProduct', {
      viewProduct: {
        product: {
          ids: {
            eRP: product.uuid
          }
        }
      }
    });
  }
};

var displayCategory = function displayCategory(_ref2) {
  var category = _ref2.category;

  if (category && category.route) {
    var routeInfo = category.route;
    var params = {
      pointOfContact: routeInfo !== null && routeInfo !== void 0 && routeInfo.menu_id ? "menu".concat(routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.menu_id) : 'Site'
    };

    if (routeInfo !== null && routeInfo !== void 0 && routeInfo.category_id) {
      params.viewProductCategory = {
        productCategory: {
          ids: {
            eRP: routeInfo.category_id
          }
        }
      };

      if (routeInfo !== null && routeInfo !== void 0 && routeInfo.brand_name) {
        params.viewProductCategory.customerAction = {
          customFields: {
            brand: routeInfo.brand_name
          }
        };
      }

      send('Website.ViewCategory', params);
    } else {
      if (routeInfo !== null && routeInfo !== void 0 && routeInfo.brand_name) {
        params.customerAction = {
          customFields: {
            brand: routeInfo.brand_name
          }
        };
      }

      send('Website.ViewSectionCatalog', params);
    }
  }
};

var viewPage = function viewPage(_ref3) {
  var page = _ref3.page;

  if (page) {
    send("Website.ViewPage".concat(page.charAt(0).toUpperCase() + page.slice(1)), {});
  }
};

var viewCustomPage = function viewCustomPage(id) {
  if (id) {
    send("Website.ViewPage", {
      pointOfContact: "page".concat(id)
    });
  }
};

var viewPageNews = function viewPageNews(_ref4) {
  var article = _ref4.article;

  if (article) {
    send('Website.ViewPageNews', {
      pointOfContact: "page".concat(article.id)
    });
  }
};

var viewNews = function viewNews() {
  send('Website.ViewNews', {});
};

var webpushSubscribe = function webpushSubscribe() {
  if (isMindboxEnable) {
    try {
      if (!js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get(COOKIE_MINDBOX_SUBSCRIBE_LOCK)) {
        window.mindbox('webpush.subscribe', {
          getSubscriptionOperation: 'Website.GetWebPushSubscription',
          subscribeOperation: 'Website.SubscribeToWebPush',
          onGranted: function onGranted() {},
          onDenied: function onDenied() {}
        });
        js_cookie__WEBPACK_IMPORTED_MODULE_1___default().set(COOKIE_MINDBOX_SUBSCRIBE_LOCK, true, {
          expires: 3
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Mindbox webpush subscribe error:", error);
    }
  }
};

/* harmony default export */ __webpack_exports__["ZP"] = ({
  displayProductDetail: displayProductDetail,
  displayCategory: displayCategory,
  viewPage: viewPage,
  viewPageNews: viewPageNews,
  viewNews: viewNews,
  webpushSubscribe: webpushSubscribe,
  viewCustomPage: viewCustomPage
});

/***/ }),

/***/ 76671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lW": function() { return /* binding */ setCategoryData; },
/* harmony export */   "sm": function() { return /* binding */ setPageProductData; }
/* harmony export */ });
/* unused harmony exports setCartData, addToCartPopMechanic */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16835);
/* harmony import */ var _lib_getLinkProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89729);



var getProductInfo = function getProductInfo(_ref) {
  var _media$;

  var id = _ref._id,
      price = _ref.price,
      quantity = _ref.quantity,
      media = _ref.media,
      slug = _ref.slug,
      brand = _ref.brand,
      name = _ref.name,
      category = _ref.category,
      old_price = _ref.old_price,
      price_diff_percent = _ref.price_diff_percent,
      brand_id = _ref.brand_id;

  var _getLinkProps = (0,_lib_getLinkProps__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    type: 'product',
    value: slug
  }),
      _getLinkProps2 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_getLinkProps, 2),
      linkHref = _getLinkProps2[0],
      linkAs = _getLinkProps2[1];

  return {
    id: id,
    price: old_price,
    priceWithDiscount: price,
    name: name,
    quantity: quantity,
    pictureUrl: media && media.length && ((_media$ = media[0]) === null || _media$ === void 0 ? void 0 : _media$.x2) > 0 ? media[0].x2 : null,
    url: linkHref,
    brand: brand,
    brandId: brand_id,
    hasDiscount: price_diff_percent > 0,
    category: category && category.name ? category.name : null,
    categoryId: category && category.external_menu_item_id ? category.external_menu_item_id : null
  };
};

var setCartData = function setCartData(data) {// if (data) {
  //   const { total_amount, total_amount_with_discount, products } = data;
  //   window.PopMechanicCartData = {
  //     total: total_amount,
  //     totalWithDiscount: total_amount_with_discount,
  //     products: products.map(product => {
  //       return getProductInfo(product);
  //     }),
  //   };
  //   if (window.PopMechanic && window.PopMechanic.update) {
  //     window.PopMechanic.update();
  //   }
  // }
};
var addToCartPopMechanic = function addToCartPopMechanic(data) {
  if (data && window.PopMechanicAddToCart && data.products.length > 0) {
    var products = data.products;
    window.PopMechanicAddToCart(getProductInfo(products[products.length - 1]));
  }
};
var setPageProductData = function setPageProductData(product) {
  window.PopMechanicPageData = {
    type: 'product',
    product: getProductInfo(product)
  };
};
var setCategoryData = function setCategoryData(categoryData) {
  window.PopMechanicPageData = {
    type: 'category',
    category: categoryData
  };

  if (window.PopMechanic && window.PopMechanic.update) {
    window.PopMechanic.update();
  }
};

/***/ }),

/***/ 12325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ri": function() { return /* reexport */ cartCountSelector; },
  "TP": function() { return /* reexport */ cartDataSelector; },
  "He": function() { return /* reexport */ cartIdsSelector; },
  "wg": function() { return /* reexport */ cartInfoSelector; },
  "BK": function() { return /* reexport */ cartLoadingDataSelector; },
  "CO": function() { return /* reexport */ cartTemporaryPromocodeSelector; },
  "tD": function() { return /* reexport */ catalogSortSelector; },
  "mN": function() { return /* reexport */ favoriteBrandsSelector; },
  "rr": function() { return /* reexport */ getCitiesSelector; },
  "XV": function() { return /* reexport */ hasGotIPSelector; },
  "Jd": function() { return /* reexport */ hasSmartBannerSelector; },
  "dd": function() { return /* reexport */ isLoggedInSelector; },
  "i9": function() { return /* reexport */ isSessionLoadedSelector; },
  "wA": function() { return /* reexport */ menuFooterSelector; },
  "I4": function() { return /* reexport */ menuTopSelector; },
  "Fe": function() { return /* reexport */ productDataSelector; },
  "Mg": function() { return /* reexport */ productErrorSelector; },
  "OT": function() { return /* reexport */ productShopsSelector; },
  "E6": function() { return /* reexport */ redirectUrlSelector; },
  "c9": function() { return /* reexport */ sessionIdSelector; },
  "t9": function() { return /* reexport */ sessionIsSubscribedChannel; },
  "hg": function() { return /* reexport */ sessionTokenSelector; },
  "G1": function() { return /* reexport */ userAndProfileSelector; },
  "EI": function() { return /* reexport */ userErrorSelector; },
  "Rs": function() { return /* reexport */ userLoadingInfoSelector; },
  "np": function() { return /* reexport */ userSelector; },
  "T6": function() { return /* reexport */ wishlistCountSelector; },
  "_7": function() { return /* reexport */ wishlistIdsSelector; }
});

// UNUSED EXPORTS: cartErrorSelector, cartLoadingSelector, isLoggingInSelector, menuMiddleSelector, productDataStateSelector, productLookLoadingSelector, profileSelector, userPhoneSelector

// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./store/userSelectors.js

var isLoggedInSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$user$loggedIn;

  return (_state$user$loggedIn = state.user.loggedIn) !== null && _state$user$loggedIn !== void 0 ? _state$user$loggedIn : false;
}, function (loggedIn) {
  return loggedIn;
});
var hasSmartBannerSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$user$hasBanner;

  return (_state$user$hasBanner = state.user.hasBanner) !== null && _state$user$hasBanner !== void 0 ? _state$user$hasBanner : false;
}, function (hasBanner) {
  return hasBanner;
});
var isLoggingInSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$user$loggingIn;

  return (_state$user$loggingIn = state.user.loggingIn) !== null && _state$user$loggingIn !== void 0 ? _state$user$loggingIn : false;
}, function (loggingIn) {
  return loggingIn;
});
var userSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$user;

  return ((_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.user) || {};
}, function (user) {
  return user;
});
var hasGotIPSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.user.hasGotIP || {};
}, function (hasGotIP) {
  return hasGotIP;
});
var favoriteBrandsSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.user.favoriteBrands.data || [];
}, function (favoriteBrands) {
  return favoriteBrands.map(function (item) {
    return "".concat(item);
  });
});
var userPhoneSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$user$user;

  return ((_state$user$user = state.user.user) === null || _state$user$user === void 0 ? void 0 : _state$user$user.phone) || null;
}, function (phone) {
  return phone;
});
var userErrorSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$user$error;

  return (_state$user$error = state.user.error) !== null && _state$user$error !== void 0 ? _state$user$error : null;
}, function (error) {
  return error;
});
var profileSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.user.profile || {};
}, function (profile) {
  return profile;
});
var redirectUrlSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.user.redirectUrl;
}, function (redirectUrl) {
  return redirectUrl;
});
var userLoadingInfoSelector = (0,es/* createSelector */.P1)(userSelector, isLoggingInSelector, userErrorSelector, function (user, loggingIn, error) {
  return {
    user: user,
    loggingIn: loggingIn,
    error: error
  };
});
var userAndProfileSelector = (0,es/* createSelector */.P1)(userSelector, profileSelector, function (user, profile) {
  return {
    user: user,
    profile: profile
  };
});
;// CONCATENATED MODULE: ./store/cartSelectors.js

var cartDataSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.cart.data;
}, function (data) {
  return data;
});
var cartLoadingSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.cart.loading;
}, function (loading) {
  return loading;
});
var cartCountSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.cart.count;
}, function (count) {
  return count;
});
var cartTemporaryPromocodeSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.cart.temporaryPromocode;
}, function (temporaryPromocode) {
  return temporaryPromocode;
});
var cartErrorSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.cart.error;
}, function (error) {
  return error;
});
var cartIdsSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.cart.ids;
}, function (ids) {
  return ids;
});
var cartInfoSelector = (0,es/* createSelector */.P1)(cartIdsSelector, cartCountSelector, cartLoadingSelector, function (ids, count, loading) {
  return {
    count: count,
    ids: ids,
    loading: loading
  };
});
var cartLoadingDataSelector = (0,es/* createSelector */.P1)(cartDataSelector, cartLoadingSelector, function (data, loading) {
  return {
    data: data,
    loading: loading
  };
});
;// CONCATENATED MODULE: ./store/productSelectors.js

var productLookLoadingSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.product.loadingLooks;
}, function (loading) {
  return loading;
});
var productDataSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.product.cachedQueries[state.product.currentQuery];
}, function (data) {
  return data;
});
var productErrorSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.product.errorsInfo[state.product.currentQuery] || null;
}, function (error) {
  return error;
});
var productDataStateSelector = (0,es/* createSelector */.P1)(productDataSelector, function (state) {
  var _state$product$loadin;

  return (_state$product$loadin = state.product.loadingInfo[state.product.currentQuery]) !== null && _state$product$loadin !== void 0 ? _state$product$loadin : false;
}, productErrorSelector, function (data, loading, error) {
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var productShopsSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.product.cachedShopsQueries[state.product.currentQuery];
}, function (state) {
  var _state$product$loadin2;

  return (_state$product$loadin2 = state.product.loadingShopsInfo[state.product.currentQuery]) !== null && _state$product$loadin2 !== void 0 ? _state$product$loadin2 : false;
}, function (state) {
  return state.product.errorsShopsInfo[state.product.currentQuery] || null;
}, function (data, loading, error) {
  return {
    data: data,
    loading: loading,
    error: error
  };
});
;// CONCATENATED MODULE: ./store/menuSelectors.js

var menuTopSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.menu.top;
}, function (top) {
  return top;
});
var menuMiddleSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.menu.middle;
}, function (middle) {
  return middle;
});
var menuFooterSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.menu.footer;
}, function (footer) {
  return footer;
});
;// CONCATENATED MODULE: ./store/sessionSelectors.js

var isSessionLoadedSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$session$isLoad;

  return (_state$session$isLoad = state.session.isLoaded) !== null && _state$session$isLoad !== void 0 ? _state$session$isLoad : false;
}, function (isLoaded) {
  return isLoaded;
});
var sessionTokenSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$session$token;

  return (_state$session$token = state.session.token) !== null && _state$session$token !== void 0 ? _state$session$token : null;
}, function (token) {
  return token;
});
var sessionIdSelector = (0,es/* createSelector */.P1)(function (state) {
  var _state$session$id;

  return (_state$session$id = state.session.id) !== null && _state$session$id !== void 0 ? _state$session$id : null;
}, function (id) {
  return id;
});
var sessionIsSubscribedChannel = (0,es/* createSelector */.P1)(function (state) {
  var _state$session$isSubs;

  return (_state$session$isSubs = state.session.isSubscribedChannel) !== null && _state$session$isSubs !== void 0 ? _state$session$isSubs : false;
}, function (isSubscribedChannel) {
  return isSubscribedChannel;
});
var getCitiesSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.session;
}, function (session) {
  var _session$regions;

  return (_session$regions = session.regions) !== null && _session$regions !== void 0 ? _session$regions : [];
});
;// CONCATENATED MODULE: ./store/wishlistSelectors.js

var wishlistIdsSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.wishlist.ids || [];
}, function (ids) {
  return ids;
});
var wishlistCountSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.wishlist.count || 0;
}, function (count) {
  return count;
});
;// CONCATENATED MODULE: ./store/catalogSelectors.js

var catalogSortSelector = (0,es/* createSelector */.P1)(function (state) {
  return state.catalog.sort;
}, function (sort) {
  return sort;
});
;// CONCATENATED MODULE: ./store/index.js








/***/ }),

/***/ 70214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zX": function() { return /* reexport */ formValidation; },
  "tx": function() { return /* reexport */ utils_getCorrectName; },
  "PX": function() { return /* reexport */ utils_getObjectFromArray; }
});

// UNUSED EXPORTS: getPrettifiedPhone, orderBy

// EXTERNAL MODULE: ./lib/wordEnd.js
var wordEnd = __webpack_require__(62547);
;// CONCATENATED MODULE: ./utils/getCorrectName.js


var getCorrectName = function getCorrectName(str) {
  if (str.includes('endword')) {
    var arrayString = str.split(' ');
    var correctArray = [];
    var newStr = str;
    arrayString.forEach(function (item, ind) {
      var endWordIndex = item.indexOf('endword');

      if (endWordIndex !== -1) {
        var wordVariants = " ".concat(arrayString[ind + 1], " ").concat(arrayString[ind + 2], " ").concat(arrayString[ind + 3]);
        var tempStr = item.substr(8) + wordVariants.substr(0, wordVariants.lastIndexOf(')'));
        var splittedString = tempStr.split(',');
        correctArray.push({
          oldVariant: "".concat(item).concat(wordVariants.substr(0, wordVariants.lastIndexOf(')') + 1)),
          newVariant: "".concat(splittedString[0]).concat((0,wordEnd/* default */.Z)(splittedString[0], splittedString.slice(1)))
        });
      }
    });
    correctArray.forEach(function (_ref) {
      var oldVariant = _ref.oldVariant,
          newVariant = _ref.newVariant;
      newStr = newStr.replace(oldVariant, newVariant);
    });
    return newStr;
  }

  return str;
};

/* harmony default export */ var utils_getCorrectName = (getCorrectName);
;// CONCATENATED MODULE: ./utils/getObjectFromArray.js
var getObjectFromArray = function getObjectFromArray(array) {
  return array.reduce(function (acc, cur) {
    acc[cur] = true;
    return acc;
  }, {});
};

/* harmony default export */ var utils_getObjectFromArray = (getObjectFromArray);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./utils/formValidation.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var validateEmail = function validateEmail(value) {
  return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value);
};
var validatePhone = function validatePhone(value) {
  return value.replace(/[^\d;]/g, '').length >= 11 && value.indexOf('_') === -1;
};
var clearErrors = function clearErrors(errors, scheme) {
  var newErrors = _objectSpread({}, errors);

  scheme.forEach(function (item) {
    newErrors === null || newErrors === void 0 ? true : delete newErrors[item.field];
  });
  return newErrors;
};

var validateRequired = function validateRequired(value) {
  return !!value;
};

/* harmony default export */ var formValidation = ({
  validatePhone: validatePhone,
  validateEmail: validateEmail,
  clearErrors: clearErrors,
  validateRequired: validateRequired
});
;// CONCATENATED MODULE: ./utils/index.js






/***/ }),

/***/ 45980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ sortingByFavBrands; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

var sortingByFavBrands = function sortingByFavBrands(items, favoriteBrands) {
  var sortedByFavBrands = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(items).sort(function (a, b) {
    if (favoriteBrands.includes(String(a.brandId)) && favoriteBrands.includes(String(b.brandId))) {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    }

    if (favoriteBrands.includes(String(a.brandId))) {
      return -1;
    }

    if (favoriteBrands.includes(String(b.brandId))) {
      return 1;
    }

    return 0;
  });

  return sortedByFavBrands;
};

/***/ }),

/***/ 78955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ createLookInCart; },
/* harmony export */   "DG": function() { return /* binding */ removePromocode; },
/* harmony export */   "Gz": function() { return /* binding */ removeCartId; },
/* harmony export */   "Ko": function() { return /* binding */ setNewCartData; },
/* harmony export */   "N1": function() { return /* binding */ updateCartCount; },
/* harmony export */   "Rx": function() { return /* binding */ applyPromocode; },
/* harmony export */   "TW": function() { return /* binding */ getCartData; },
/* harmony export */   "U9": function() { return /* binding */ updateCartIds; },
/* harmony export */   "ag": function() { return /* binding */ removeCertificate; },
/* harmony export */   "at": function() { return /* binding */ addCartId; },
/* harmony export */   "h2": function() { return /* binding */ removeFromCart; },
/* harmony export */   "hY": function() { return /* binding */ getCartDataLoading; },
/* harmony export */   "iD": function() { return /* binding */ applyCertificate; },
/* harmony export */   "n5": function() { return /* binding */ setLoadingRequest; },
/* harmony export */   "p$": function() { return /* binding */ createInCart; },
/* harmony export */   "sp": function() { return /* binding */ removeAllCertificates; },
/* harmony export */   "x7": function() { return /* binding */ fetchCart; },
/* harmony export */   "xu": function() { return /* binding */ updateCart; }
/* harmony export */ });
/* unused harmony exports getCartPromocode, getCartCertificatesAvaialble, applyTemporaryPromocode, applyTemporaryCertificate, fetchAsyncCart, mergeCartData, setMobileApp, requestCart, udpatingCart, updateIds, updateIdsObj, firstRequestCart, endRequestCart, endUpdatingCart, failureUpdatingCart, removeCartProduct, successCart, failureCart, updateCount, requestPromocode, successPromocode, failurePromocode, requestCertificate, successCertificate, failureCertificate, saveTemporaryPromocode, resetTemporaryPromocode, saveTemporaryCertificate, resetTemporaryCertificate, resetCart */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27812);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sessionSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28770);
/* harmony import */ var _checkoutSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10604);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68697);
/* harmony import */ var _userSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46789);




var _extraReducers;



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var idsArrayToObj = function idsArrayToObj(ids) {
  return (ids === null || ids === void 0 ? void 0 : ids.reduce(function (acc, el) {
    acc[el] = true;
    return acc;
  }, {})) || {};
};

var initialState = {
  mobileApp: false,
  data: {
    products: []
  },
  count: 0,
  ids: [],
  idsObj: {},
  loading: false,
  firstLoading: false,
  updating: false,
  updatingIds: {},
  error: null,
  promocodeError: null,
  certificateError: null,
  temporaryPromocode: null,
  temporaryCertificate: null
};
var cart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
  name: 'cart',
  initialState: initialState,
  reducers: {
    setMobileApp: function setMobileApp(state) {
      state.mobileApp = true;
    },
    requestCart: function requestCart(state) {
      state.loading = true;
      state.error = null;
    },
    udpatingCart: function udpatingCart(state, _ref) {
      var payload = _ref.payload;
      var id = payload === null || payload === void 0 ? void 0 : payload.id;

      if (id) {
        state.updatingIds[id] = true;
      }

      state.updating = true;
      state.error = null;
    },
    removeCartProduct: function removeCartProduct(state, _ref2) {
      var _state$data, _state$data$products;

      var payload = _ref2.payload;
      var id = payload === null || payload === void 0 ? void 0 : payload.id;
      if (!id || !((_state$data = state.data) !== null && _state$data !== void 0 && (_state$data$products = _state$data.products) !== null && _state$data$products !== void 0 && _state$data$products.length)) return;
      state.data.products = state.data.products.filter(function (el) {
        return el.external_id !== id;
      });
    },
    endUpdatingCart: function endUpdatingCart(state, _ref3) {
      var payload = _ref3.payload;
      var id = payload === null || payload === void 0 ? void 0 : payload.id;

      if (id) {
        state.updatingIds[id] = false;
      }

      state.updating = false;
    },
    failureUpdatingCart: function failureUpdatingCart(state, _ref4) {
      var payload = _ref4.payload;
      var id = payload === null || payload === void 0 ? void 0 : payload.id;

      if (id) {
        state.updatingIds[id] = false;
      }

      state.updating = false;
      state.error = payload === null || payload === void 0 ? void 0 : payload.error;
    },
    firstRequestCart: function firstRequestCart(state) {
      state.firstLoading = true;
    },
    endRequestCart: function endRequestCart(state) {
      state.loading = false;
    },
    successCart: function successCart(state, _ref5) {
      var _payload$stopLoader, _payload$count;

      var payload = _ref5.payload;
      var cart = payload;
      var stopLoader = (_payload$stopLoader = payload === null || payload === void 0 ? void 0 : payload.stopLoader) !== null && _payload$stopLoader !== void 0 ? _payload$stopLoader : true;
      state.count = (_payload$count = payload.count) !== null && _payload$count !== void 0 ? _payload$count : state.count;
      state.data = cart;
      state.firstLoading = false;

      if (stopLoader) {
        state.loading = false;
      }

      state.error = null;
    },
    failureCart: function failureCart(state, _ref6) {
      var payload = _ref6.payload;
      state.loading = false;
      state.firstLoading = false;
      state.error = payload;
    },
    requestPromocode: function requestPromocode(state) {
      state.loading = true;
    },
    successPromocode: function successPromocode(state, _ref7) {
      var payload = _ref7.payload;
      var cart = payload === null || payload === void 0 ? void 0 : payload.cart;
      state.data = cart;
      state.loading = false;
      state.promocodeError = null;
    },
    failurePromocode: function failurePromocode(state, _ref8) {
      var payload = _ref8.payload;
      state.loading = false;
      state.promocodeError = payload;
    },
    requestCertificate: function requestCertificate(state) {
      state.loading = true;
    },
    successCertificate: function successCertificate(state, _ref9) {
      var payload = _ref9.payload;
      var cart = payload === null || payload === void 0 ? void 0 : payload.cart;
      state.data = cart;
      state.loading = false;
      state.certificateError = null;
    },
    failureCertificate: function failureCertificate(state, _ref10) {
      var payload = _ref10.payload;
      state.loading = false;
      state.certificateError = payload;
    },
    saveTemporaryPromocode: function saveTemporaryPromocode(state, _ref11) {
      var payload = _ref11.payload;
      state.temporaryPromocode = payload;
    },
    resetTemporaryPromocode: function resetTemporaryPromocode(state) {
      state.temporaryPromocode = null;
    },
    saveTemporaryCertificate: function saveTemporaryCertificate(state, _ref12) {
      var payload = _ref12.payload;
      state.temporaryCertificate = payload;
    },
    resetTemporaryCertificate: function resetTemporaryCertificate(state) {
      state.temporaryCertificate = null;
    },
    updateIds: function updateIds(state, _ref13) {
      var payload = _ref13.payload;
      state.ids = payload;
    },
    updateIdsObj: function updateIdsObj(state, _ref14) {
      var payload = _ref14.payload;
      state.idsObj = payload;
    },
    updateCount: function updateCount(state, _ref15) {
      var payload = _ref15.payload;
      state.count = payload;
    },
    resetCart: function resetCart() {
      return _objectSpread({}, initialState);
    }
  },
  extraReducers: (_extraReducers = {}, (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_extraReducers, _sessionSlice__WEBPACK_IMPORTED_MODULE_2__/* .successSession */ .C4, _getCartFromSession), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_extraReducers, _userSlice__WEBPACK_IMPORTED_MODULE_4__/* .successLogin */ .Ei, _getCartFromSession), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_extraReducers, _checkoutSlice__WEBPACK_IMPORTED_MODULE_3__/* .successOrderCreate */ .nK, _getCartFromSession), _extraReducers)
});

function _getCartFromSession(state, _ref16) {
  var _payload$cart, _payload$cart_count;

  var payload = _ref16.payload;
  var cart = (_payload$cart = payload === null || payload === void 0 ? void 0 : payload.cart) !== null && _payload$cart !== void 0 ? _payload$cart : null;
  var cart_count = (_payload$cart_count = payload === null || payload === void 0 ? void 0 : payload.cart_count) !== null && _payload$cart_count !== void 0 ? _payload$cart_count : null;

  if (cart) {
    state.ids = cart;
    state.idsObj = idsArrayToObj(cart);
  }

  if (cart_count !== null) {
    state.count = cart_count;
  }

  state.loading = false;
}

var getCartPromocode = function getCartPromocode(data) {
  var promoCode = data === null || data === void 0 ? void 0 : data.promo_code;
  var promoCodeDiscount = data === null || data === void 0 ? void 0 : data.total_promocard_discount_key;
  return promoCode && promoCodeDiscount && promoCodeDiscount > 0 ? promoCode : null;
};
var getCartCertificatesAvaialble = function getCartCertificatesAvaialble(data, temporaryCertificate) {
  var certificates = (data === null || data === void 0 ? void 0 : data.certificates) || [];
  return [].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(certificates), [{
    certificate: temporaryCertificate,
    temporary: true
  }]).reduce(function (acc, cur) {
    if (cur !== null && cur !== void 0 && cur.isAvailable || cur.temporary && cur.certificate) {
      acc.push(_objectSpread({}, cur));
    }

    return acc;
  }, []);
};
var getCartData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(function (state) {
  return state.cart;
}, function (cartState) {
  var data = cartState.data,
      loading = cartState.loading,
      updating = cartState.updating,
      error = cartState.error,
      promocodeError = cartState.promocodeError,
      temporaryPromocode = cartState.temporaryPromocode,
      temporaryCertificate = cartState.temporaryCertificate,
      count = cartState.count,
      ids = cartState.ids,
      idsObj = cartState.idsObj,
      firstLoading = cartState.firstLoading;
  return {
    data: _objectSpread(_objectSpread({}, data), {}, {
      promo_code: getCartPromocode(data),
      certificates_available: getCartCertificatesAvaialble(data, temporaryCertificate)
    }),
    // prevent any issues/changes on the frontend
    loading: loading || updating,
    error: error,
    promocodeError: promocodeError,
    temporaryPromocode: temporaryPromocode,
    ids: ids,
    idsObj: idsObj,
    firstLoading: firstLoading,
    count: count
  };
});
var getCartDataLoading = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(function (state) {
  return state.cart;
}, function (cartState) {
  return cartState.loading;
});
var applyPromocode = function applyPromocode(_ref17) {
  var code = _ref17.code,
      onSuccess = _ref17.onSuccess,
      onError = _ref17.onError;
  return /*#__PURE__*/function () {
    var _ref19 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState, _ref18) {
      var api, _data$external_fetchi, response, result, data;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref18.api;
              _context.prev = 1;
              dispatch(requestPromocode());
              _context.next = 5;
              return api.promocode({
                promo_code: code
              });

            case 5:
              response = _context.sent;
              result = response.result, data = response.data;

              if (result === 'success' && ((_data$external_fetchi = data === null || data === void 0 ? void 0 : data.external_fetching) !== null && _data$external_fetchi !== void 0 ? _data$external_fetchi : false) && (data === null || data === void 0 ? void 0 : data.total_promocard_discount_key) > 0) {
                dispatch(successPromocode({
                  cart: data
                }));
                if (onSuccess) onSuccess();
              } else {
                dispatch(failurePromocode(response));
                if (onError) onError();
              }

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              dispatch(failurePromocode(_context.t0.toString()));
              if (onError) onError();

            case 14:
              _context.prev = 14;
              dispatch(resetTemporaryPromocode());
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10, 14, 17]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref19.apply(this, arguments);
    };
  }();
};
var applyTemporaryPromocode = function applyTemporaryPromocode(_ref20) {
  var code = _ref20.code;
  return function (dispatch) {
    dispatch(saveTemporaryPromocode(code));
  };
};
var removePromocode = function removePromocode(_ref21) {
  var onSuccess = _ref21.onSuccess,
      onError = _ref21.onError;
  return /*#__PURE__*/function () {
    var _ref23 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(dispatch, getState, _ref22) {
      var api, _data$external_fetchi2, response, result, data;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref22.api;
              _context2.prev = 1;
              dispatch(requestPromocode());
              _context2.next = 5;
              return api.promocode({
                promo_code: null
              });

            case 5:
              response = _context2.sent;
              result = response.result, data = response.data;

              if (result === 'success' && ((_data$external_fetchi2 = data === null || data === void 0 ? void 0 : data.external_fetching) !== null && _data$external_fetchi2 !== void 0 ? _data$external_fetchi2 : false)) {
                dispatch(successPromocode({
                  cart: data
                }));
                if (onSuccess) onSuccess();
              } else {
                dispatch(failurePromocode(response));
                if (onError) onError();
              }

              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              dispatch(failurePromocode(_context2.t0.toString()));
              if (onError) onError();

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 10]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref23.apply(this, arguments);
    };
  }();
};
var applyCertificate = function applyCertificate(_ref24) {
  var code = _ref24.code,
      onSuccess = _ref24.onSuccess,
      onError = _ref24.onError;
  return /*#__PURE__*/function () {
    var _ref26 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(dispatch, getState, _ref25) {
      var api, _data$certificates$fi, _data$certificates, _data$external_fetchi3, response, result, data, newCertificateData;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref25.api;
              _context3.prev = 1;
              dispatch(requestCertificate());
              _context3.next = 5;
              return api.certificateApply({
                certificate: code
              });

            case 5:
              response = _context3.sent;
              result = response.result, data = response.data;
              newCertificateData = (_data$certificates$fi = data === null || data === void 0 ? void 0 : (_data$certificates = data.certificates) === null || _data$certificates === void 0 ? void 0 : _data$certificates.find(function (cert) {
                return cert.certificate === code;
              })) !== null && _data$certificates$fi !== void 0 ? _data$certificates$fi : {};

              if (result === 'success' && ((_data$external_fetchi3 = data === null || data === void 0 ? void 0 : data.external_fetching) !== null && _data$external_fetchi3 !== void 0 ? _data$external_fetchi3 : false) && newCertificateData !== null && newCertificateData !== void 0 && newCertificateData.isAvailable) {
                dispatch(resetTemporaryCertificate());
                dispatch(successCertificate({
                  cart: data
                }));
                if (onSuccess) onSuccess(newCertificateData);
              } else {
                dispatch(resetTemporaryCertificate());

                if (result == 'error' && response.statusCode == 422) {
                  dispatch(failureCertificate(response));
                  if (onError) onError({
                    status: 'validation',
                    message: response.errors.certificate[0]
                  }, response);
                } else {
                  dispatch(failureCertificate(response));
                  if (onError) onError(newCertificateData, response);
                }
              }

              _context3.next = 15;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              dispatch(failureCertificate(_context3.t0.toString()));
              if (onError) onError();

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 11]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref26.apply(this, arguments);
    };
  }();
};
var applyTemporaryCertificate = function applyTemporaryCertificate(_ref27) {
  var code = _ref27.code;
  return function (dispatch) {
    dispatch(saveTemporaryCertificate(code));
  };
};
var removeCertificate = function removeCertificate(_ref28) {
  var code = _ref28.code,
      onSuccess = _ref28.onSuccess,
      onError = _ref28.onError;
  return /*#__PURE__*/function () {
    var _ref30 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(dispatch, getState, _ref29) {
      var api, _data$external_fetchi4, response, result, data;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              api = _ref29.api;
              _context4.prev = 1;
              dispatch(requestCertificate());
              _context4.next = 5;
              return api.certificateRemove({
                certificate: code
              });

            case 5:
              response = _context4.sent;
              result = response.result, data = response.data;

              if (result === 'success' && ((_data$external_fetchi4 = data === null || data === void 0 ? void 0 : data.external_fetching) !== null && _data$external_fetchi4 !== void 0 ? _data$external_fetchi4 : false)) {
                dispatch(successCertificate({
                  cart: data
                }));
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureCertificate(response));
                if (onError) onError();
              }

              _context4.next = 14;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](1);
              dispatch(failureCertificate(_context4.t0.toString()));
              if (onError) onError();

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 10]]);
    }));

    return function (_x10, _x11, _x12) {
      return _ref30.apply(this, arguments);
    };
  }();
};
var removeAllCertificates = function removeAllCertificates(_ref31) {
  var _ref31$onSuccess = _ref31.onSuccess,
      onSuccess = _ref31$onSuccess === void 0 ? null : _ref31$onSuccess,
      _ref31$onError = _ref31.onError,
      onError = _ref31$onError === void 0 ? null : _ref31$onError;
  return /*#__PURE__*/function () {
    var _ref33 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(dispatch, getState, _ref32) {
      var api, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = _ref32.api;
              _context5.prev = 1;
              _context5.next = 4;
              return api.allCertificateRemove();

            case 4:
              response = _context5.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                dispatch(successCart(data));
                if (onSuccess) onSuccess();
              } else {
                if (onError) onError();
              }

              _context5.next = 12;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](1);
              if (onError) onError(_context5.t0);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 9]]);
    }));

    return function (_x13, _x14, _x15) {
      return _ref33.apply(this, arguments);
    };
  }();
};

var getCartCount = function getCartCount(cart) {
  var count = 0;
  cart.products.forEach(function (_ref34) {
    var cart_quantity = _ref34.cart_quantity;

    if (cart_quantity) {
      count += cart_quantity;
    } else {
      count += 1;
    }
  });
  return count;
};

var fetchCart = function fetchCart() {
  var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onSuccess = _ref35.onSuccess;

  return /*#__PURE__*/function () {
    var _ref37 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(dispatch, getState, _ref36) {
      var api, resp, _resp$result, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              api = _ref36.api;
              dispatch(requestCart());
              _context6.prev = 2;
              _context6.next = 5;
              return api.cart();

            case 5:
              resp = _context6.sent;
              _resp$result = resp.result, result = _resp$result === void 0 ? 'success' : _resp$result;

              if (result === 'success') {
                // we don't need that for now
                // const response = await api.deliveryInfo()
                // const { resultDelivery = 'success'} = response
                // if (resultDelivery === 'success') {
                //   dispatch(successCart({ ...resp.data, deliveryDates: response.delivery_dates, count }))
                // } else {
                //   dispatch(successCart({ ...resp.data, count }))
                // }
                dispatch(successCart(_objectSpread(_objectSpread({}, resp.data), {}, {
                  count: getCartCount(resp.data)
                })));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(resp.data);
              } else {
                dispatch(failureCart(resp));
              }

              _context6.next = 13;
              break;

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](2);
              dispatch(failureCart(_context6.t0.toString()));

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 10]]);
    }));

    return function (_x16, _x17, _x18) {
      return _ref37.apply(this, arguments);
    };
  }();
};
var fetchAsyncCart = function fetchAsyncCart() {
  var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onSuccess = _ref38.onSuccess;

  return /*#__PURE__*/function () {
    var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState, _ref39) {
      var api, resp, _resp$result2, result;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              api = _ref39.api;
              dispatch(requestCart());
              _context7.prev = 2;
              _context7.next = 5;
              return api.asyncCart();

            case 5:
              resp = _context7.sent;
              _resp$result2 = resp.result, result = _resp$result2 === void 0 ? 'success' : _resp$result2;

              if (result === 'success') {
                dispatch(successCart(_objectSpread(_objectSpread({}, resp.data), {}, {
                  count: getCartCount(resp.data)
                })));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(resp.data);
              } else {
                dispatch(failureCart(resp));
              }

              _context7.next = 13;
              break;

            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](2);
              dispatch(failureCart(_context7.t0.toString()));

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[2, 10]]);
    }));

    return function (_x19, _x20, _x21) {
      return _ref40.apply(this, arguments);
    };
  }();
};
var mergeCartData = function mergeCartData(_ref41) {
  var cartData = _ref41.cartData;
  return function (dispatch, getState) {
    dispatch(requestCart());

    try {
      var _cartData$products;

      if (!cartData) return;
      var prevData = getState().cart.data;
      var newProductsObj = ((_cartData$products = cartData.products) === null || _cartData$products === void 0 ? void 0 : _cartData$products.reduce(function (acc, el) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, el.external_id, el));
      }, {})) || {};

      var newData = _objectSpread(_objectSpread(_objectSpread({}, prevData), cartData), {}, {
        products: prevData.products.map(function (el) {
          return _objectSpread(_objectSpread({}, el), newProductsObj[el.external_id]);
        })
      });

      dispatch(successCart(_objectSpread(_objectSpread({}, newData), {}, {
        count: getCartCount(cartData)
      })));
    } catch (err) {
      dispatch(failureCart(err.toString()));
    }
  };
};
var setLoadingRequest = function setLoadingRequest() {
  return /*#__PURE__*/function () {
    var _ref43 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(dispatch, getState, _ref42) {
      var api;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              api = _ref42.api;
              dispatch(firstRequestCart());

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x22, _x23, _x24) {
      return _ref43.apply(this, arguments);
    };
  }();
};
var createInCart = function createInCart(_ref44) {
  var id = _ref44.id,
      quantity = _ref44.quantity,
      mindboxDeviceUUID = _ref44.mindboxDeviceUUID,
      onSuccess = _ref44.onSuccess,
      onError = _ref44.onError,
      meta = _ref44.meta;
  return /*#__PURE__*/function () {
    var _ref46 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(dispatch, getState, _ref45) {
      var api, resp, _resp$result3, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              api = _ref45.api;
              // we don't use udpatingCart here 'cause createInCart is used outside of cart
              dispatch(requestCart());
              _context9.prev = 2;
              _context9.next = 5;
              return api.addToCart({
                id: id,
                quantity: quantity,
                mindboxDeviceUUID: mindboxDeviceUUID,
                meta: meta
              });

            case 5:
              resp = _context9.sent;
              _resp$result3 = resp.result, result = _resp$result3 === void 0 ? 'success' : _resp$result3;

              if (result === 'success') {
                dispatch(endRequestCart());
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureCart(resp));
                onError === null || onError === void 0 ? void 0 : onError(resp);
              }

              _context9.next = 14;
              break;

            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9["catch"](2);
              dispatch(failureCart(_context9.t0.toString()));
              onError === null || onError === void 0 ? void 0 : onError(_context9.t0);

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 10]]);
    }));

    return function (_x25, _x26, _x27) {
      return _ref46.apply(this, arguments);
    };
  }();
};
var removeFromCart = function removeFromCart(_ref47) {
  var id = _ref47.id,
      mindboxDeviceUUID = _ref47.mindboxDeviceUUID,
      onSuccess = _ref47.onSuccess,
      onError = _ref47.onError;
  return /*#__PURE__*/function () {
    var _ref49 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(dispatch, getState, _ref48) {
      var api, resp, _resp$result4, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              api = _ref48.api;
              dispatch(udpatingCart({
                id: id
              }));
              _context10.prev = 2;
              _context10.next = 5;
              return api.removeFromCart({
                product_id: id,
                mindboxDeviceUUID: mindboxDeviceUUID
              });

            case 5:
              resp = _context10.sent;
              _resp$result4 = resp.result, result = _resp$result4 === void 0 ? 'success' : _resp$result4;

              if (result === 'success') {
                dispatch(endUpdatingCart({
                  id: id
                }));
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureUpdatingCart({
                  error: resp,
                  id: id
                }));
                if (onError) onError(resp);
              }

              _context10.next = 14;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](2);
              dispatch(failureUpdatingCart({
                error: _context10.t0.toString(),
                id: id
              }));
              if (onError) onError(_context10.t0);

            case 14:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[2, 10]]);
    }));

    return function (_x28, _x29, _x30) {
      return _ref49.apply(this, arguments);
    };
  }();
};
var updateCart = function updateCart(_ref50) {
  var id = _ref50.id,
      quantity = _ref50.quantity,
      onSuccess = _ref50.onSuccess,
      onError = _ref50.onError,
      mindboxDeviceUUID = _ref50.mindboxDeviceUUID;
  return /*#__PURE__*/function () {
    var _ref52 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(dispatch, getState, _ref51) {
      var api, resp, _resp$result5, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              api = _ref51.api;
              dispatch(udpatingCart({
                id: id
              }));
              _context11.prev = 2;
              _context11.next = 5;
              return api.updateCart({
                id: id,
                quantity: quantity,
                mindboxDeviceUUID: mindboxDeviceUUID
              });

            case 5:
              resp = _context11.sent;
              _resp$result5 = resp.result, result = _resp$result5 === void 0 ? 'success' : _resp$result5;

              if (result === 'success') {
                dispatch(endUpdatingCart({
                  id: id
                }));
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureUpdatingCart({
                  error: resp,
                  id: id
                }));
                if (onError) onError();
              }

              _context11.next = 14;
              break;

            case 10:
              _context11.prev = 10;
              _context11.t0 = _context11["catch"](2);
              dispatch(failureUpdatingCart({
                error: _context11.t0.toString(),
                id: id
              }));
              if (onError) onError();

            case 14:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[2, 10]]);
    }));

    return function (_x31, _x32, _x33) {
      return _ref52.apply(this, arguments);
    };
  }();
};
var createLookInCart = function createLookInCart(_ref53) {
  var products = _ref53.products,
      mindboxDeviceUUID = _ref53.mindboxDeviceUUID,
      onSuccess = _ref53.onSuccess,
      onError = _ref53.onError,
      meta = _ref53.meta,
      _ref53$originalError = _ref53.originalError,
      originalError = _ref53$originalError === void 0 ? false : _ref53$originalError;
  return /*#__PURE__*/function () {
    var _ref55 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee12(dispatch, getState, _ref54) {
      var api, resp, _resp$result6, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              api = _ref54.api;
              dispatch(requestCart());
              _context12.prev = 2;
              _context12.next = 5;
              return api.addLookToCart({
                products: products,
                mindboxDeviceUUID: mindboxDeviceUUID,
                meta: meta
              });

            case 5:
              resp = _context12.sent;
              _resp$result6 = resp.result, result = _resp$result6 === void 0 ? 'success' : _resp$result6;

              if (result === 'success') {
                dispatch(endRequestCart());
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureCart(resp));
                onError === null || onError === void 0 ? void 0 : onError(resp);
              }

              _context12.next = 14;
              break;

            case 10:
              _context12.prev = 10;
              _context12.t0 = _context12["catch"](2);
              dispatch(failureCart(originalError ? _context12.t0 : _context12.t0.toString()));
              onError === null || onError === void 0 ? void 0 : onError(originalError ? _context12.t0 : _context12.t0.toString());

            case 14:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[2, 10]]);
    }));

    return function (_x34, _x35, _x36) {
      return _ref55.apply(this, arguments);
    };
  }();
};
var updateCartIds = function updateCartIds(_ref56) {
  var ids = _ref56.ids;
  return function (dispatch, getState) {
    dispatch(updateIds(ids));
  };
};
var updateCartCount = function updateCartCount(_ref57) {
  var count = _ref57.count;
  return function (dispatch, getState) {
    dispatch(updateCount(count));
  };
};
var removeCartId = function removeCartId(_ref58) {
  var id = _ref58.id;
  return function (dispatch, getState) {
    var state = getState().cart;
    var ids = state.ids;
    dispatch(updateIds(ids.filter(function (item) {
      return item != id;
    })));
  };
};
var addCartId = function addCartId(_ref59) {
  var id = _ref59.id;
  return function (dispatch, getState) {
    var state = getState().cart;
    var ids = state.ids;
    var hasId = ids.some(function (item) {
      return item == id;
    });

    if (!hasId) {
      dispatch(updateIds([].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ids), [id])));
    }
  };
};
var setNewCartData = function setNewCartData(data) {
  return /*#__PURE__*/function () {
    var _ref61 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee13(dispatch, _getState, _ref60) {
      var api;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              api = _ref60.api;
              dispatch(successCart(data));

            case 2:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x37, _x38, _x39) {
      return _ref61.apply(this, arguments);
    };
  }();
};
var _cart$actions = cart.actions,
    setMobileApp = _cart$actions.setMobileApp,
    requestCart = _cart$actions.requestCart,
    udpatingCart = _cart$actions.udpatingCart,
    updateIds = _cart$actions.updateIds,
    updateIdsObj = _cart$actions.updateIdsObj,
    firstRequestCart = _cart$actions.firstRequestCart,
    endRequestCart = _cart$actions.endRequestCart,
    endUpdatingCart = _cart$actions.endUpdatingCart,
    failureUpdatingCart = _cart$actions.failureUpdatingCart,
    removeCartProduct = _cart$actions.removeCartProduct,
    successCart = _cart$actions.successCart,
    failureCart = _cart$actions.failureCart,
    updateCount = _cart$actions.updateCount,
    requestPromocode = _cart$actions.requestPromocode,
    successPromocode = _cart$actions.successPromocode,
    failurePromocode = _cart$actions.failurePromocode,
    requestCertificate = _cart$actions.requestCertificate,
    successCertificate = _cart$actions.successCertificate,
    failureCertificate = _cart$actions.failureCertificate,
    saveTemporaryPromocode = _cart$actions.saveTemporaryPromocode,
    resetTemporaryPromocode = _cart$actions.resetTemporaryPromocode,
    saveTemporaryCertificate = _cart$actions.saveTemporaryCertificate,
    resetTemporaryCertificate = _cart$actions.resetTemporaryCertificate,
    resetCart = _cart$actions.resetCart;

/* harmony default export */ __webpack_exports__["ZP"] = (cart.reducer);

/***/ }),

/***/ 35955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a$": function() { return /* binding */ fetchFilters; },
/* harmony export */   "jI": function() { return /* binding */ saveSort; },
/* harmony export */   "t2": function() { return /* binding */ fetchProducts; },
/* harmony export */   "zm": function() { return /* binding */ getCatalogData; }
/* harmony export */ });
/* unused harmony exports requestProducts, requestProductsCash, successProducts, failureProducts, requestFilters, successFilters, failureFilters */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);



var _excluded = ["onSuccess", "onCachedSuccess", "onError", "refresh", "errToString", "updateTimeIfExists"],
    _excluded2 = ["refresh", "errToString"],
    _excluded3 = ["cachedQueries", "currentQuery"],
    _excluded4 = ["cachedQueries", "currentQuery"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var maxCashLength = 100;
var initialState = {
  products: {
    cachedQueries: {},
    cachedTimes: {},
    loading: false,
    currentQuery: null,
    loadingCash: false
  },
  page: 1,
  sort: null,
  filters: {
    cachedQueries: {},
    loading: false,
    error: null,
    currentQuery: null
  },
  error: null
};

var getOldestKey = function getOldestKey(cachedQueries, cachedTimes) {
  var time = Date.now();
  var oldestKey;

  for (var key in cachedQueries) {
    if (cachedTimes[key] && cachedTimes[key] < time) {
      time = cachedTimes[key];
      oldestKey = key;
    }
  }

  return oldestKey;
};

var catalog = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
  name: 'catalog',
  initialState: initialState,
  reducers: {
    requestProducts: function requestProducts(state, _ref) {
      var payload = _ref.payload;
      var cachedQueries = state.products.cachedQueries;

      var _ref2 = payload || {},
          key = _ref2.key;

      state.products.loading = true;

      if (key) {
        cachedQueries[key] = _objectSpread(_objectSpread({}, cachedQueries[key]), {}, {
          loading: true,
          error: null
        });
      }
    },
    requestProductsCash: function requestProductsCash(state, _ref3) {
      var payload = _ref3.payload;
      state.products.loadingCash = true;
    },
    successProducts: function successProducts(state, _ref4) {
      var _cachedQueries$key, _cachedQueries$key2;

      var payload = _ref4.payload;
      var key = payload.key,
          data = payload.data,
          refresh = payload.refresh;
      var _state$products = state.products,
          cachedQueries = _state$products.cachedQueries,
          cachedTimes = _state$products.cachedTimes;
      state.products.currentQuery = key;

      if (data && (!((_cachedQueries$key = cachedQueries[key]) !== null && _cachedQueries$key !== void 0 && _cachedQueries$key.result) || refresh || (_cachedQueries$key2 = cachedQueries[key]) !== null && _cachedQueries$key2 !== void 0 && _cachedQueries$key2.loading)) {
        var cachedQueriesLength = Object.keys(cachedQueries).length;

        if (cachedQueriesLength >= maxCashLength) {
          var oldestKey = getOldestKey(cachedQueries, cachedTimes);
          delete cachedQueries[oldestKey];
          delete cachedTimes[oldestKey];
        }

        cachedQueries[key] = data || cachedQueries[key];
        cachedQueries[key].loading = false;
        cachedQueries[key].error = null;
      }

      cachedTimes[key] = Date.now();
      state.products.loading = false;
      state.products.loadingCash = false;
      state.error = null;
    },
    failureProducts: function failureProducts(state, _ref5) {
      var payload = _ref5.payload;
      var key = payload.key,
          data = payload.data;
      var cachedQueries = state.products.cachedQueries;
      state.products.currentQuery = key;
      state.products.loading = false;
      state.error = data;

      if (!cachedQueries[key]) {
        cachedQueries[key] = {};
      }

      cachedQueries[key].loading = false;
      state.products.loadingCash = false;
      cachedQueries[key].error = data;
    },
    requestFilters: function requestFilters(state) {
      state.filters.loading = true;
    },
    successFilters: function successFilters(state, _ref6) {
      var payload = _ref6.payload;
      var key = payload.key,
          data = payload.data,
          refresh = payload.refresh;
      var cachedQueries = state.filters.cachedQueries;
      state.filters.currentQuery = key;

      if (data && (!cachedQueries[key] || refresh)) {
        cachedQueries[key] = data || [];
      }

      state.filters.loading = false;
      state.filters.error = null;
    },
    failureFilters: function failureFilters(state, _ref7) {
      var payload = _ref7.payload;
      var key = payload.key,
          data = payload.data;
      state.filters.currentQuery = key;
      state.filters.loading = false;
      state.filters.error = data;
    },
    saveSort: function saveSort(state, _ref8) {
      var payload = _ref8.payload;
      state.sort = payload !== null && payload !== void 0 ? payload : null;
    }
  }
});
var fetchProducts = function fetchProducts() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var onSuccess = _ref9.onSuccess,
      onCachedSuccess = _ref9.onCachedSuccess,
      onError = _ref9.onError,
      _ref9$refresh = _ref9.refresh,
      refresh = _ref9$refresh === void 0 ? false : _ref9$refresh,
      _ref9$errToString = _ref9.errToString,
      errToString = _ref9$errToString === void 0 ? true : _ref9$errToString,
      _ref9$updateTimeIfExi = _ref9.updateTimeIfExists,
      updateTimeIfExists = _ref9$updateTimeIfExi === void 0 ? true : _ref9$updateTimeIfExi,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref9, _excluded);

  return /*#__PURE__*/function () {
    var _ref11 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState, _ref10) {
      var _state$products$cache;

      var api, state, key, _state$products$cache2, _response$result, response, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref10.api;
              state = getState().catalog;
              key = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(params);

              if (!((_state$products$cache = state.products.cachedQueries[key]) !== null && _state$products$cache !== void 0 && _state$products$cache.loading)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              _context.prev = 5;

              if (!(!refresh && (_state$products$cache2 = state.products.cachedQueries[key]) !== null && _state$products$cache2 !== void 0 && _state$products$cache2.result)) {
                _context.next = 14;
                break;
              }

              dispatch(requestProductsCash());
              if (updateTimeIfExists) dispatch(successProducts({
                key: key
              }));
              onCachedSuccess === null || onCachedSuccess === void 0 ? void 0 : onCachedSuccess(state.products.cachedQueries[key]);
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
              return _context.abrupt("return");

            case 14:
              dispatch(requestProducts({
                key: key
              }));
              _context.next = 17;
              return api.products(params);

            case 17:
              response = _context.sent;
              result = (_response$result = response === null || response === void 0 ? void 0 : response.result) !== null && _response$result !== void 0 ? _response$result : 'success';

              if (result === 'success') {
                dispatch(successProducts({
                  key: key,
                  data: response,
                  refresh: refresh
                }));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
              } else {
                onError === null || onError === void 0 ? void 0 : onError(response);
                dispatch(failureProducts({
                  key: key,
                  data: response
                }));
              }

            case 20:
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](5);
              onError === null || onError === void 0 ? void 0 : onError(_context.t0);
              dispatch(failureProducts({
                key: key,
                data: errToString ? _context.t0.toString() : _context.t0
              }));

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 22]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref11.apply(this, arguments);
    };
  }();
};
var fetchFilters = function fetchFilters(_ref12) {
  var _ref12$refresh = _ref12.refresh,
      refresh = _ref12$refresh === void 0 ? false : _ref12$refresh,
      _ref12$errToString = _ref12.errToString,
      errToString = _ref12$errToString === void 0 ? true : _ref12$errToString,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref12, _excluded2);

  return /*#__PURE__*/function () {
    var _ref14 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(dispatch, getState, _ref13) {
      var api, state, key, _yield$api$filters, data, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref13.api;
              state = getState().catalog;
              key = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(params);
              _context2.prev = 3;

              if (!(!refresh && state.filters.cachedQueries[key])) {
                _context2.next = 9;
                break;
              }

              dispatch(successFilters({
                key: key
              }));
              return _context2.abrupt("return");

            case 9:
              dispatch(requestFilters());
              _context2.next = 12;
              return api.filters(params);

            case 12:
              _yield$api$filters = _context2.sent;
              data = _yield$api$filters.data;
              result = _yield$api$filters.result;

              if (result === 'success') {
                dispatch(successFilters({
                  key: key,
                  data: data,
                  refresh: refresh
                }));
              } else {
                dispatch(failureFilters({
                  key: key,
                  data: data
                }));
              }

            case 16:
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](3);
              dispatch(failureFilters({
                key: key,
                data: errToString ? _context2.t0.toString() : _context2.t0
              }));

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 18]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref14.apply(this, arguments);
    };
  }();
};
var getCatalogData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.catalog;
}, function (catalog) {
  var products = catalog.products,
      filters = catalog.filters,
      page = catalog.page,
      sort = catalog.sort,
      error = catalog.error;

  var productsCachedQueries = products.cachedQueries,
      productsCurrentQuery = products.currentQuery,
      productsState = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(products, _excluded3);

  var filtersCachedQueries = filters.cachedQueries,
      filtersCurrentQuery = filters.currentQuery,
      filtersState = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(filters, _excluded4);

  var productsCachedQueryData = productsCachedQueries[productsCurrentQuery];
  var filtersCachedQueryData = filtersCachedQueries[filtersCurrentQuery] || [];
  return {
    products: _objectSpread(_objectSpread({}, productsCachedQueryData), productsState),
    filters: _objectSpread({
      data: filtersCachedQueryData
    }, filtersState),
    page: page,
    sort: sort,
    error: error
  };
});
var _catalog$actions = catalog.actions,
    requestProducts = _catalog$actions.requestProducts,
    requestProductsCash = _catalog$actions.requestProductsCash,
    successProducts = _catalog$actions.successProducts,
    failureProducts = _catalog$actions.failureProducts,
    requestFilters = _catalog$actions.requestFilters,
    successFilters = _catalog$actions.successFilters,
    failureFilters = _catalog$actions.failureFilters,
    saveSort = _catalog$actions.saveSort;

/* harmony default export */ __webpack_exports__["ZP"] = (catalog.reducer);

/***/ }),

/***/ 11012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kv": function() { return /* binding */ getLoading; },
/* harmony export */   "P1": function() { return /* binding */ getCategoryTreeBySlug; },
/* harmony export */   "fc": function() { return /* binding */ getCategoriesTree; }
/* harmony export */ });
/* unused harmony exports getCategoriesTreeRoots, getCategories, selCategoriesRoots, requestCategories, successCategories, failureCategories, successSlug, failureSlug, successData, requestRoots, successRoots, failureRoots, requestSlug */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82262);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92777);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81531);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72179);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37247);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_wrapNativeSuper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46576);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68697);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var ApiError = /*#__PURE__*/function (_Error) {
  (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ApiError, _Error);

  var _super = _createSuper(ApiError);

  function ApiError(message, statusCode) {
    var _this;

    (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ApiError);

    _this = _super.call(this, message);
    _this.statusCode = statusCode;
    return _this;
  }

  return (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ApiError);
}( /*#__PURE__*/(0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_wrapNativeSuper_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(Error));

var maxCashLength = 100;
var initialState = {
  data: [],
  loaded: false,
  loading: false,
  error: null,
  cachedSlug: {},
  cachedTimes: {},
  cachedData: {},
  cachedRoots: {}
};

var getOldestKey = function getOldestKey(cachedQueries, cachedTimes) {
  var time = Date.now();
  var oldestKey;

  for (var key in cachedQueries) {
    if (cachedTimes[key] && cachedTimes[key] < time && key !== '/') {
      time = cachedTimes[key];
      oldestKey = key;
    }
  }

  return oldestKey;
};

var categories = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
  name: 'categories',
  initialState: initialState,
  reducers: {
    requestCategories: function requestCategories(state) {
      state.loading = true;
    },
    successCategories: function successCategories(state, _ref) {
      var payload = _ref.payload;

      if (payload) {
        var _payload$categories;

        var _categories = (_payload$categories = payload === null || payload === void 0 ? void 0 : payload.categories) !== null && _payload$categories !== void 0 ? _payload$categories : [];

        state.data = _categories;
        state.loaded = true;
      }

      state.loading = false;
      state.error = null;
    },
    failureCategories: function failureCategories(state, _ref2) {
      var payload = _ref2.payload;
      state.loading = false;
      state.error = payload;
    },
    requestSlug: function requestSlug(state, _ref3) {
      var payload = _ref3.payload;

      var _ref4 = payload || {},
          slug = _ref4.slug;

      state.loading = true;
      state.error = null;

      if (slug) {
        state.cachedSlug[slug] = _objectSpread(_objectSpread({}, state.cachedSlug[slug]), {}, {
          loading: true,
          error: null
        });
      }
    },
    successSlug: function successSlug(state, _ref5) {
      var _cachedSlug$slug, _cachedSlug$slug2;

      var payload = _ref5.payload;
      var slug = payload.slug,
          response = payload.response,
          refresh = payload.refresh;
      var cachedSlug = state.cachedSlug,
          cachedTimes = state.cachedTimes;

      if (response && (!((_cachedSlug$slug = cachedSlug[slug]) !== null && _cachedSlug$slug !== void 0 && _cachedSlug$slug.result) || (_cachedSlug$slug2 = cachedSlug[slug]) !== null && _cachedSlug$slug2 !== void 0 && _cachedSlug$slug2.loading || refresh)) {
        var cachedSlugLength = Object.keys(cachedSlug).length;

        if (cachedSlugLength >= maxCashLength) {
          var oldestKey = getOldestKey(cachedSlug, cachedTimes);
          delete cachedSlug[oldestKey];
          delete cachedTimes[oldestKey];
        }

        cachedSlug[slug] = response || cachedSlug[slug];
        cachedSlug[slug].loading = false;
        cachedSlug[slug].error = null;
      }

      cachedTimes[slug] = Date.now();
      state.loading = false;
    },
    failureSlug: function failureSlug(state, _ref6) {
      var payload = _ref6.payload;
      var slug = payload.slug,
          error = payload.error;
      state.loading = false;
      state.cachedSlug[slug] = _objectSpread(_objectSpread({}, state.cachedSlug[slug]), {}, {
        loading: false,
        error: error
      });
    },
    successData: function successData(state, _ref7) {
      var payload = _ref7.payload;
      var response = payload.response,
          refresh = payload.refresh;

      if (!state.cachedData.data || refresh) {
        state.cachedData = response;
      }
    },
    requestRoots: function requestRoots(state) {
      var _state$cachedRoots;

      if ((_state$cachedRoots = state.cachedRoots) !== null && _state$cachedRoots !== void 0 && _state$cachedRoots.error) {
        state.cachedRoots = initialState.cachedRoots;
      }
    },
    successRoots: function successRoots(state, _ref8) {
      var payload = _ref8.payload;
      state.cachedRoots = payload.response;
    },
    failureRoots: function failureRoots(state, _ref9) {
      var payload = _ref9.payload;
      state.cachedRoots = {
        error: (payload === null || payload === void 0 ? void 0 : payload.error) || null
      };
    }
  }
});
var getCategoryTreeBySlug = function getCategoryTreeBySlug(_ref10) {
  var slug = _ref10.slug,
      _ref10$refresh = _ref10.refresh,
      refresh = _ref10$refresh === void 0 ? false : _ref10$refresh,
      onSuccess = _ref10.onSuccess,
      onError = _ref10.onError,
      _ref10$originalError = _ref10.originalError,
      originalError = _ref10$originalError === void 0 ? false : _ref10$originalError;
  return /*#__PURE__*/function () {
    var _ref12 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(dispatch, getState, _ref11) {
      var api, state, _state$cachedSlug$slu, response, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref11.api;
              state = getState().categories;
              _context.prev = 2;

              if (!((_state$cachedSlug$slu = state.cachedSlug[slug]) !== null && _state$cachedSlug$slu !== void 0 && _state$cachedSlug$slu.result && !refresh)) {
                _context.next = 8;
                break;
              }

              dispatch(successSlug({
                slug: slug
              }));
              if (onSuccess) onSuccess(state.cachedSlug[slug]);
              _context.next = 22;
              break;

            case 8:
              dispatch(requestSlug({
                slug: slug
              }));
              _context.next = 11;
              return api.categoryTreeBySlug({
                slug: slug,
                version: 1
              });

            case 11:
              response = _context.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (!(result === 'success')) {
                _context.next = 18;
                break;
              }

              dispatch(successSlug({
                slug: slug,
                response: response,
                refresh: refresh
              }));
              if (onSuccess) onSuccess(response);
              _context.next = 22;
              break;

            case 18:
              if (!onError) {
                _context.next = 22;
                break;
              }

              if (!(originalError || response.data)) {
                _context.next = 21;
                break;
              }

              throw response;

            case 21:
              throw new ApiError('Page Not Found', 404);

            case 22:
              _context.next = 29;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              onError === null || onError === void 0 ? void 0 : onError(_context.t0);
              dispatch(failureSlug({
                slug: slug,
                error: _context.t0
              }));

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 24]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var getCategoriesTree = function getCategoriesTree(_ref13) {
  var _ref13$refresh = _ref13.refresh,
      refresh = _ref13$refresh === void 0 ? false : _ref13$refresh,
      onSuccess = _ref13.onSuccess,
      onError = _ref13.onError;
  return /*#__PURE__*/function () {
    var _ref15 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(dispatch, getState, _ref14) {
      var api, state, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref14.api;
              state = getState().categories;
              _context2.prev = 2;

              if (!(state.cachedData.data && !refresh)) {
                _context2.next = 7;
                break;
              }

              if (onSuccess) onSuccess(state.cachedData);
              _context2.next = 12;
              break;

            case 7:
              _context2.next = 9;
              return api.categoryTree();

            case 9:
              response = _context2.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                dispatch(successData({
                  response: response,
                  refresh: refresh
                }));
                if (onSuccess) onSuccess(response);
              } else {
                console.error('getCategoryTree failed');
                if (onError) onError();
              }

            case 12:
              _context2.next = 17;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](2);
              console.error(_context2.t0);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 14]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref15.apply(this, arguments);
    };
  }();
};
var getCategoriesTreeRoots = function getCategoriesTreeRoots() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref16$refresh = _ref16.refresh,
      refresh = _ref16$refresh === void 0 ? false : _ref16$refresh,
      onSuccess = _ref16.onSuccess,
      onError = _ref16.onError;

  return /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref17) {
      var api, state, _state$cachedRoots2, _state$cachedRoots2$d, response;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref17.api;
              state = getState().categories;
              _context3.prev = 2;

              if (!((_state$cachedRoots2 = state.cachedRoots) !== null && _state$cachedRoots2 !== void 0 && (_state$cachedRoots2$d = _state$cachedRoots2.data) !== null && _state$cachedRoots2$d !== void 0 && _state$cachedRoots2$d.length && !refresh)) {
                _context3.next = 7;
                break;
              }

              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(state.cachedRoots);
              _context3.next = 12;
              break;

            case 7:
              dispatch(requestRoots());
              _context3.next = 10;
              return api.categoryTreeRoots();

            case 10:
              response = _context3.sent;

              if ((response === null || response === void 0 ? void 0 : response.result) === 'success') {
                dispatch(successRoots({
                  response: response,
                  refresh: refresh
                }));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
              } else {
                console.error('getCategoriesTreeRoots failed');
                dispatch(failureRoots({
                  error: response
                }));
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

            case 12:
              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](2);
              console.error(_context3.t0);
              onError === null || onError === void 0 ? void 0 : onError(_context3.t0);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 14]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref18.apply(this, arguments);
    };
  }();
};
var getCategories = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSelector */ .P1)(function (state) {
  return state.categories;
}, function (categories) {
  var data = categories.data;
  return {
    categories: data
  };
});
var getLoading = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSelector */ .P1)(function (state) {
  return state.categories;
}, function (categories) {
  var loading = categories.loading;
  return {
    loading: loading
  };
});
var selCategoriesRoots = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSelector */ .P1)(function (state) {
  return state.categories.cachedRoots;
}, function (cachedRoots) {
  return {
    categoriesRoots: (cachedRoots === null || cachedRoots === void 0 ? void 0 : cachedRoots.data) || [],
    error: cachedRoots === null || cachedRoots === void 0 ? void 0 : cachedRoots.error
  };
});
var _categories$actions = categories.actions,
    requestCategories = _categories$actions.requestCategories,
    successCategories = _categories$actions.successCategories,
    failureCategories = _categories$actions.failureCategories,
    successSlug = _categories$actions.successSlug,
    failureSlug = _categories$actions.failureSlug,
    successData = _categories$actions.successData,
    requestRoots = _categories$actions.requestRoots,
    successRoots = _categories$actions.successRoots,
    failureRoots = _categories$actions.failureRoots,
    requestSlug = _categories$actions.requestSlug;

/* harmony default export */ __webpack_exports__["ZP"] = (categories.reducer);

/***/ }),

/***/ 10604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ timeSlotsSelector; },
/* harmony export */   "Ee": function() { return /* binding */ getErrorPaymentInfo; },
/* harmony export */   "Fc": function() { return /* binding */ resetCheckoutData; },
/* harmony export */   "GE": function() { return /* binding */ getPersonalData; },
/* harmony export */   "IW": function() { return /* binding */ fetchPaymentErrorInfo; },
/* harmony export */   "KT": function() { return /* binding */ deliveryServiceSelector; },
/* harmony export */   "KW": function() { return /* binding */ fetchLastOrder; },
/* harmony export */   "S6": function() { return /* binding */ getLastOrderData; },
/* harmony export */   "Si": function() { return /* binding */ fetchRedirectInfo; },
/* harmony export */   "WY": function() { return /* binding */ deliveryMaxItemsSelector; },
/* harmony export */   "aN": function() { return /* binding */ getTimeSlots; },
/* harmony export */   "cf": function() { return /* binding */ validatePaymentData; },
/* harmony export */   "iI": function() { return /* binding */ getRedirectPaymentData; },
/* harmony export */   "mx": function() { return /* binding */ getPaymentData; },
/* harmony export */   "nK": function() { return /* binding */ successOrderCreate; },
/* harmony export */   "pm": function() { return /* binding */ getNonDeliverableItems; },
/* harmony export */   "q$": function() { return /* binding */ resetError; },
/* harmony export */   "u6": function() { return /* binding */ getShops; },
/* harmony export */   "ye": function() { return /* binding */ getDeliveryData; },
/* harmony export */   "zK": function() { return /* binding */ PARAMS; }
/* harmony export */ });
/* unused harmony exports PAYMENT_TYPES, DELIVERY_TYPES, DEFAULTS, validatePersonalData, validateDeliveryData, getCheckoutError, requestErrorPaymentInfo, successErrorPaymentInfo, failureErrorPaymentInfo, requestRedirectPaymentData, successRedirectPaymentData, failureRedirectPaymentData, requestPersonalDataValidation, successPersonalDataValidation, failurePersonalDataValidation, requestDeliveryDataValidation, successDeliveryDataValidation, failureDeliveryDataValidation, requestPaymentDataValidation, successPaymentDataValidation, failurePaymentDataValidation, successGetShops, initGetTimeslots, successGetTimeslots, errorGetTimeslots, requestLastOrder, successLastOrder, failureLastOrder */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36864);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);




var _excluded = ["refresh"],
    _excluded2 = ["refresh"],
    _excluded3 = (/* unused pure expression or super */ null && (["result", "statusCode"])),
    _excluded4 = ["result"],
    _excluded5 = (/* unused pure expression or super */ null && (["result", "statusCode"])),
    _excluded6 = ["result", "statusCode"];

var _PAYMENT_TYPES, _DELIVERY_TYPES;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var initialState = {
  desiredDates: {},
  pickupPoints: [],
  deliveryCosts: {},
  deliveryTypes: [],
  nonDeliverableItems: [],
  paymentTypes: {},
  paymentTypeDescriptions: {},
  personalData: {
    loading: false,
    data: null
  },
  deliveryData: {
    loading: false,
    data: null
  },
  paymentData: {
    loading: false,
    data: null
  },
  lastOrder: {
    data: null,
    loading: false,
    error: null
  },
  redirectPaymentData: {
    data: null,
    loading: false,
    error: null
  },
  errorPaymentInfo: {
    data: null,
    loading: false,
    error: null
  },
  timeSlots: {
    data: [],
    loading: false,
    error: null,
    onlySendOrder: false
  },
  service: '',
  maxItems: 15,
  error: null,
  onlySendOrder: false,
  onlySelfPickup: false,
  productsFromMinsk: false
};
var PARAMS = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  PHONE: 'phone',
  EMAIL: 'email',
  COMMENT: 'order_comments',
  AGREEMENT: 'agreement',
  DELIVERY_TYPE: 'delivery_type',
  DELIVERY_TYPE_PICKUP: 'pickup',
  DELIVERY_TYPE_COURIER: 'local_delivery',
  DELIVERY_TYPE_BELARUS: 'delivery_by_country',
  SHOP_ID: 'shop_id',
  ADDRESS: 'address',
  DELIVERY_DATE: 'delivery_date',
  DELIVERY_TIME: 'delivery_time',
  PAYMENT_TYPE: 'payment_type',
  PAYMENT_TYPE_CASH: 'cash',
  PAYMENT_TYPE_CARD: 'courier_terminal',
  PAYMENT_TYPE_CARD_ONLINE: 'online',
  PAYMENT_TYPE_CERTIFICATE: 'certificate'
};
var PAYMENT_TYPES = (_PAYMENT_TYPES = {}, (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_PAYMENT_TYPES, PARAMS.PAYMENT_TYPE_CASH, 'Наличными'), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_PAYMENT_TYPES, PARAMS.PAYMENT_TYPE_CARD, 'Банковской картой'), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_PAYMENT_TYPES, PARAMS.PAYMENT_TYPE_CARD_ONLINE, 'Банковской картой онлайн'), _PAYMENT_TYPES);
var DELIVERY_TYPES = (_DELIVERY_TYPES = {}, (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_DELIVERY_TYPES, PARAMS.DELIVERY_TYPE_PICKUP, 'Самовывоз г. Минск'), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_DELIVERY_TYPES, PARAMS.DELIVERY_TYPE_COURIER, 'Доставка курьером по г. Минску'), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_DELIVERY_TYPES, PARAMS.DELIVERY_TYPE_BELARUS, 'Доставка по Беларуси'), _DELIVERY_TYPES);
var DEFAULTS = {
  DELIVERY_TYPE: PARAMS.DELIVERY_TYPE_PICKUP,
  PAYMENT_TYPE: PARAMS.PAYMENT_TYPE_CASH,
  PAYMENT_TYPE_DELIVERY_BELARUS: PARAMS.PAYMENT_TYPE_CARD_ONLINE
};
var checkout = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
  name: 'checkout',
  initialState: initialState,
  reducers: {
    requestPersonalDataValidation: function requestPersonalDataValidation(state) {
      state.personalData.loading = true;
    },
    successPersonalDataValidation: function successPersonalDataValidation(state, _ref) {
      var _nextStepData$desired, _nextStepData$shops, _nextStepData$deliver, _nextStepData$deliver2;

      var payload = _ref.payload;
      var params = payload.params,
          nextStepData = payload.nextStepData;
      state.personalData.loading = false;
      state.error = null;
      state.personalData.data = params;
      state.desiredDates = (_nextStepData$desired = nextStepData === null || nextStepData === void 0 ? void 0 : nextStepData.desired_dates) !== null && _nextStepData$desired !== void 0 ? _nextStepData$desired : {};
      state.pickupPoints = (_nextStepData$shops = nextStepData === null || nextStepData === void 0 ? void 0 : nextStepData.shops) !== null && _nextStepData$shops !== void 0 ? _nextStepData$shops : [];
      state.deliveryCosts = (_nextStepData$deliver = nextStepData === null || nextStepData === void 0 ? void 0 : nextStepData.delivery_costs) !== null && _nextStepData$deliver !== void 0 ? _nextStepData$deliver : {};
      state.deliveryTypes = (_nextStepData$deliver2 = nextStepData === null || nextStepData === void 0 ? void 0 : nextStepData.delivery_types) !== null && _nextStepData$deliver2 !== void 0 ? _nextStepData$deliver2 : [];
    },
    successGetShops: function successGetShops(state, _ref2) {
      var _payload$shops, _payload$onlySelfPick, _payload$productsFrom;

      var payload = _ref2.payload;
      state.pickupPoints = (_payload$shops = payload === null || payload === void 0 ? void 0 : payload.shops) !== null && _payload$shops !== void 0 ? _payload$shops : [];
      state.onlySelfPickup = (_payload$onlySelfPick = payload === null || payload === void 0 ? void 0 : payload.onlySelfPickup) !== null && _payload$onlySelfPick !== void 0 ? _payload$onlySelfPick : false;
      state.productsFromMinsk = (_payload$productsFrom = payload === null || payload === void 0 ? void 0 : payload.productsFromMinsk) !== null && _payload$productsFrom !== void 0 ? _payload$productsFrom : false;
    },
    initGetTimeslots: function initGetTimeslots(state) {
      state.timeSlots.loading = true;
      state.timeSlots.error = null;
    },
    successGetTimeslots: function successGetTimeslots(state, _ref3) {
      var _payload$desired_date, _payload$service, _payload$payment_type, _payload$non_delivera, _payload$payment_type2, _payload$maxItems, _payload$onlySendOrde, _payload$onlySendOrde2;

      var payload = _ref3.payload;
      state.timeSlots.data = (_payload$desired_date = payload === null || payload === void 0 ? void 0 : payload.desired_dates) !== null && _payload$desired_date !== void 0 ? _payload$desired_date : [];
      state.service = (_payload$service = payload === null || payload === void 0 ? void 0 : payload.service) !== null && _payload$service !== void 0 ? _payload$service : '';
      state.paymentTypes = (_payload$payment_type = payload === null || payload === void 0 ? void 0 : payload.payment_types) !== null && _payload$payment_type !== void 0 ? _payload$payment_type : {};
      state.nonDeliverableItems = (_payload$non_delivera = payload === null || payload === void 0 ? void 0 : payload.non_deliverable_items) !== null && _payload$non_delivera !== void 0 ? _payload$non_delivera : [];
      state.paymentTypeDescriptions = (_payload$payment_type2 = payload === null || payload === void 0 ? void 0 : payload.payment_type_descriptions) !== null && _payload$payment_type2 !== void 0 ? _payload$payment_type2 : {};
      state.maxItems = (_payload$maxItems = payload === null || payload === void 0 ? void 0 : payload.maxItems) !== null && _payload$maxItems !== void 0 ? _payload$maxItems : 15;
      state.timeSlots.loading = false;
      state.timeSlots.onlySendOrder = (_payload$onlySendOrde = payload === null || payload === void 0 ? void 0 : payload.onlySendOrder) !== null && _payload$onlySendOrde !== void 0 ? _payload$onlySendOrde : false;
      state.timeSlots.error = null;
      state.onlySendOrder = (_payload$onlySendOrde2 = payload === null || payload === void 0 ? void 0 : payload.onlySendOrder) !== null && _payload$onlySendOrde2 !== void 0 ? _payload$onlySendOrde2 : false;
    },
    errorGetTimeslots: function errorGetTimeslots(state, _ref4) {
      var payload = _ref4.payload;
      state.timeSlots.loading = false;
      state.timeSlots.error = payload;
    },
    failurePersonalDataValidation: function failurePersonalDataValidation(state, _ref5) {
      var payload = _ref5.payload;
      state.personalData.loading = false;
      state.error = payload;
    },
    requestDeliveryDataValidation: function requestDeliveryDataValidation(state) {
      state.deliveryData.loading = true;
    },
    successDeliveryDataValidation: function successDeliveryDataValidation(state, _ref6) {
      var _nextStepData$payment, _nextStepData$payment2;

      var payload = _ref6.payload;
      var params = payload.params,
          nextStepData = payload.nextStepData;
      state.deliveryData.loading = false;
      state.error = null;
      state.deliveryData.data = params;
      state.paymentTypes = (_nextStepData$payment = nextStepData === null || nextStepData === void 0 ? void 0 : nextStepData.payment_types) !== null && _nextStepData$payment !== void 0 ? _nextStepData$payment : {};
      state.paymentTypeDescriptions = (_nextStepData$payment2 = nextStepData === null || nextStepData === void 0 ? void 0 : nextStepData.payment_type_descriptions) !== null && _nextStepData$payment2 !== void 0 ? _nextStepData$payment2 : {};
    },
    failureDeliveryDataValidation: function failureDeliveryDataValidation(state, _ref7) {
      var payload = _ref7.payload;
      state.deliveryData.loading = false;
      state.error = payload;

      if (payload !== null && payload !== void 0 && payload.desired_dates) {
        state.desiredDates = payload.desired_dates;
      }
    },
    requestPaymentDataValidation: function requestPaymentDataValidation(state) {
      state.paymentData.loading = true;
    },
    successPaymentDataValidation: function successPaymentDataValidation(state, _ref8) {
      var payload = _ref8.payload;
      state.paymentData.loading = false;
      state.error = null;
      state.paymentData.data = payload;
    },
    failurePaymentDataValidation: function failurePaymentDataValidation(state, _ref9) {
      var payload = _ref9.payload;
      state.paymentData.loading = false;
      state.error = payload;
    },
    successOrderCreate: function successOrderCreate(state) {
      state.lastOrder.data = null;
    },
    resetError: function resetError(state) {
      state.error = null;
    },
    resetCheckoutData: function resetCheckoutData(state) {
      state.desiredDates = {};
      state.pickupPoints = [];
      state.deliveryCosts = {};
      state.deliveryTypes = [];
      state.paymentTypes = {};
      state.paymentTypeDescriptions = {};
      state.personalData.data = null;
      state.deliveryData.data = null;
      state.paymentData.data = null;
      state.lastOrder.data = null;
    },
    requestLastOrder: function requestLastOrder(state) {
      state.lastOrder.loading = true;
    },
    successLastOrder: function successLastOrder(state, _ref10) {
      var payload = _ref10.payload;

      if (payload) {
        state.lastOrder.data = payload;
      }

      state.lastOrder.loading = false;
      state.lastOrder.error = null;
    },
    failureLastOrder: function failureLastOrder(state, _ref11) {
      var payload = _ref11.payload;
      state.lastOrder.loading = false;
      state.lastOrder.error = payload;
    },
    requestRedirectPaymentData: function requestRedirectPaymentData(state) {
      state.redirectPaymentData.loading = true;
    },
    successRedirectPaymentData: function successRedirectPaymentData(state, _ref12) {
      var payload = _ref12.payload;

      if (payload) {
        state.redirectPaymentData.data = payload;
      }

      state.redirectPaymentData.loading = false;
      state.redirectPaymentData.error = null;
    },
    failureRedirectPaymentData: function failureRedirectPaymentData(state, _ref13) {
      var payload = _ref13.payload;
      state.redirectPaymentData.loading = false;
      state.redirectPaymentData.error = payload;
    },
    requestErrorPaymentInfo: function requestErrorPaymentInfo(state) {
      state.errorPaymentInfo.loading = true;
    },
    successErrorPaymentInfo: function successErrorPaymentInfo(state, _ref14) {
      var payload = _ref14.payload;

      if (payload) {
        state.errorPaymentInfo.data = payload;
      }

      state.errorPaymentInfo.loading = false;
      state.errorPaymentInfo.error = null;
    },
    failureErrorPaymentInfo: function failureErrorPaymentInfo(state, _ref15) {
      var payload = _ref15.payload;
      state.errorPaymentInfo.loading = false;
      state.errorPaymentInfo.error = payload;
    }
  }
});
var fetchLastOrder = function fetchLastOrder() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref16$refresh = _ref16.refresh,
      refresh = _ref16$refresh === void 0 ? false : _ref16$refresh,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref16, _excluded);

  return /*#__PURE__*/function () {
    var _ref18 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(dispatch, getState, _ref17) {
      var api, _getState$checkout$la, _getState$checkout$la2, lastOrderData, response, result, order;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref17.api;
              _context.prev = 1;
              lastOrderData = (_getState$checkout$la = (_getState$checkout$la2 = getState().checkout.lastOrder) === null || _getState$checkout$la2 === void 0 ? void 0 : _getState$checkout$la2.data) !== null && _getState$checkout$la !== void 0 ? _getState$checkout$la : null;

              if (!(!refresh && lastOrderData && (lastOrderData === null || lastOrderData === void 0 ? void 0 : lastOrderData.id) == (params === null || params === void 0 ? void 0 : params.order_id))) {
                _context.next = 8;
                break;
              }

              dispatch(successLastOrder());
              return _context.abrupt("return");

            case 8:
              dispatch(requestLastOrder());
              _context.next = 11;
              return api.getLastOrder(params);

            case 11:
              response = _context.sent;
              result = response.result, order = response.order;

              if (result === 'success') {
                dispatch(successLastOrder(order));
              } else {
                dispatch(failureLastOrder(response));
              }

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              dispatch(failureLastOrder(_context.t0.toString()));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref18.apply(this, arguments);
    };
  }();
};
var fetchRedirectInfo = function fetchRedirectInfo(params) {
  return /*#__PURE__*/function () {
    var _ref20 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(dispatch, getState, _ref19) {
      var api, _getState$checkout$re, _getState$checkout$re2, _redirectPaymentData$, redirectPaymentData, response, result, order, payment;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref19.api;
              _context2.prev = 1;
              redirectPaymentData = (_getState$checkout$re = (_getState$checkout$re2 = getState().checkout.redirectPaymentData) === null || _getState$checkout$re2 === void 0 ? void 0 : _getState$checkout$re2.data) !== null && _getState$checkout$re !== void 0 ? _getState$checkout$re : null;

              if (!(redirectPaymentData && (redirectPaymentData === null || redirectPaymentData === void 0 ? void 0 : (_redirectPaymentData$ = redirectPaymentData.order) === null || _redirectPaymentData$ === void 0 ? void 0 : _redirectPaymentData$.id) == (params === null || params === void 0 ? void 0 : params.order_id))) {
                _context2.next = 8;
                break;
              }

              dispatch(successRedirectPaymentData());
              return _context2.abrupt("return");

            case 8:
              dispatch(requestRedirectPaymentData());
              _context2.next = 11;
              return api.getRedirectInfo(params);

            case 11:
              response = _context2.sent;
              result = response.result, order = response.order, payment = response.payment;

              if (result === 'success') {
                dispatch(successRedirectPaymentData({
                  order: order,
                  payment: payment
                }));
              } else {
                dispatch(failureRedirectPaymentData(response));
              }

            case 14:
              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](1);
              dispatch(failureRedirectPaymentData(_context2.t0.toString()));

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 16]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref20.apply(this, arguments);
    };
  }();
};
var fetchPaymentErrorInfo = function fetchPaymentErrorInfo() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref21$refresh = _ref21.refresh,
      refresh = _ref21$refresh === void 0 ? false : _ref21$refresh,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref21, _excluded2);

  return /*#__PURE__*/function () {
    var _ref23 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(dispatch, getState, _ref22) {
      var api, _getState$checkout$er, _getState$checkout$er2, _errorPaymentInfo$pay, errorPaymentInfo, response, result, payment, payment_url;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref22.api;
              _context3.prev = 1;
              errorPaymentInfo = (_getState$checkout$er = (_getState$checkout$er2 = getState().checkout.errorPaymentInfo) === null || _getState$checkout$er2 === void 0 ? void 0 : _getState$checkout$er2.data) !== null && _getState$checkout$er !== void 0 ? _getState$checkout$er : null;

              if (!(!refresh && errorPaymentInfo && (errorPaymentInfo === null || errorPaymentInfo === void 0 ? void 0 : (_errorPaymentInfo$pay = errorPaymentInfo.payment) === null || _errorPaymentInfo$pay === void 0 ? void 0 : _errorPaymentInfo$pay.id) == (params === null || params === void 0 ? void 0 : params.payment_id))) {
                _context3.next = 8;
                break;
              }

              dispatch(successErrorPaymentInfo());
              return _context3.abrupt("return");

            case 8:
              dispatch(requestErrorPaymentInfo());
              _context3.next = 11;
              return api.getErrorPaymentInfo(params);

            case 11:
              response = _context3.sent;
              result = response.result, payment = response.payment, payment_url = response.payment_url;

              if (result === 'success') {
                dispatch(successErrorPaymentInfo({
                  payment: payment,
                  payment_url: payment_url
                }));
              } else {
                dispatch(failureErrorPaymentInfo(response));
              }

            case 14:
              _context3.next = 19;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](1);
              dispatch(failureErrorPaymentInfo(_context3.t0.toString()));

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 16]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref23.apply(this, arguments);
    };
  }();
};
var validatePersonalData = function validatePersonalData(_ref24) {
  var params = _ref24.params,
      onSuccess = _ref24.onSuccess;
  return /*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref25) {
      var api, response, result, statusCode, data, _error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              api = _ref25.api;
              _context4.prev = 1;
              dispatch(requestPersonalDataValidation());
              _context4.next = 5;
              return api.validateCheckoutPersonalData(params);

            case 5:
              response = _context4.sent;
              result = response.result, statusCode = response.statusCode, data = _objectWithoutProperties(response, _excluded3);

              if (result === 'success') {
                dispatch(successPersonalDataValidation({
                  params: params,
                  nextStepData: data
                }));
                if (onSuccess) onSuccess();
              } else {
                _error = +statusCode === 500 ? {
                  errors: {
                    catched: data.toString()
                  }
                } : data;
                dispatch(failurePersonalDataValidation(_error));
              }

              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](1);
              dispatch(failurePersonalDataValidation({
                errors: {
                  catched: _context4.t0.toString()
                }
              }));

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 10]]);
    }));

    return function (_x10, _x11, _x12) {
      return _ref26.apply(this, arguments);
    };
  }();
};
var getShops = function getShops() {
  var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onError = _ref27.onError,
      onSuccess = _ref27.onSuccess;

  return /*#__PURE__*/function () {
    var _ref29 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5(dispatch, getState, _ref28) {
      var api, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = _ref28.api;
              _context5.prev = 1;
              _context5.next = 4;
              return api.shopsNew();

            case 4:
              response = _context5.sent;
              result = response.result, data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(response, _excluded4);

              if (result === 'success') {
                dispatch(successGetShops(data));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
              } else {
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

              _context5.next = 13;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](1);
              console.error(_context5.t0);
              onError === null || onError === void 0 ? void 0 : onError(error);

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 9]]);
    }));

    return function (_x13, _x14, _x15) {
      return _ref29.apply(this, arguments);
    };
  }();
};
var getTimeSlots = function getTimeSlots(_ref30) {
  var params = _ref30.params;
  return /*#__PURE__*/function () {
    var _ref32 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee6(dispatch, getState, _ref31) {
      var api, response, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              api = _ref31.api;
              _context6.prev = 1;
              dispatch(initGetTimeslots());
              _context6.next = 5;
              return api.timeSlots(params);

            case 5:
              response = _context6.sent;
              data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, response);

              if (data.result === 'success') {
                dispatch(successGetTimeslots(data));
              } else {
                dispatch(errorGetTimeslots(response));
              }

              _context6.next = 13;
              break;

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](1);
              dispatch(errorGetTimeslots(_context6.t0));

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 10]]);
    }));

    return function (_x16, _x17, _x18) {
      return _ref32.apply(this, arguments);
    };
  }();
};
var validateDeliveryData = function validateDeliveryData(_ref33) {
  var params = _ref33.params,
      onSuccess = _ref33.onSuccess;
  return /*#__PURE__*/function () {
    var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState, _ref34) {
      var api, response, result, statusCode, data, _error2;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              api = _ref34.api;
              _context7.prev = 1;
              dispatch(requestDeliveryDataValidation());
              _context7.next = 5;
              return api.validateCheckoutDelivery(params);

            case 5:
              response = _context7.sent;
              result = response.result, statusCode = response.statusCode, data = _objectWithoutProperties(response, _excluded5);

              if (result === 'success') {
                dispatch(successDeliveryDataValidation({
                  params: params,
                  nextStepData: data
                }));
                if (onSuccess) onSuccess();
              } else {
                _error2 = +statusCode === 500 ? {
                  errors: {
                    catched: data.toString()
                  }
                } : data;
                dispatch(failureDeliveryDataValidation(_error2));
              }

              _context7.next = 13;
              break;

            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](1);
              dispatch(failureDeliveryDataValidation({
                errors: {
                  catched: _context7.t0.toString()
                }
              }));

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 10]]);
    }));

    return function (_x19, _x20, _x21) {
      return _ref35.apply(this, arguments);
    };
  }();
};
var validatePaymentData = function validatePaymentData(_ref36) {
  var params = _ref36.params,
      onSuccess = _ref36.onSuccess,
      cleanOrders = _ref36.cleanOrders;
  return /*#__PURE__*/function () {
    var _ref38 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee8(dispatch, getState, _ref37) {
      var api, state, allParams, response, _response, result, statusCode, data, _error3;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              api = _ref37.api;
              _context8.prev = 1;
              dispatch(requestPaymentDataValidation());
              state = getState().checkout;
              allParams = _objectSpread(_objectSpread(_objectSpread({}, state.personalData.data), state.deliveryData.data), params);

              if (allParams[PARAMS.PAYMENT_TYPE] === PARAMS.PAYMENT_TYPE_CERTIFICATE) {
                allParams[PARAMS.PAYMENT_TYPE] = PARAMS.PAYMENT_TYPE_CASH;
              }

              response = null;

              if (!(params !== null && params !== void 0 && params.isNewCheckout)) {
                _context8.next = 14;
                break;
              }

              params === null || params === void 0 ? true : delete params.isNewCheckout;
              _context8.next = 11;
              return api.newCheckout(_objectSpread({}, allParams));

            case 11:
              response = _context8.sent;
              _context8.next = 17;
              break;

            case 14:
              _context8.next = 16;
              return api.checkout(_objectSpread({}, allParams));

            case 16:
              response = _context8.sent;

            case 17:
              _response = response, result = _response.result, statusCode = _response.statusCode, data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_response, _excluded6);

              if (result === 'success') {
                dispatch(successPaymentDataValidation(params));
                dispatch(successOrderCreate(_objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.session), {}, {
                  cleanOrders: cleanOrders
                })));
                if (onSuccess) onSuccess({
                  redirectUrl: data === null || data === void 0 ? void 0 : data.redirect_url,
                  order: data === null || data === void 0 ? void 0 : data.order,
                  session: data === null || data === void 0 ? void 0 : data.session,
                  redirectPageUrl: data === null || data === void 0 ? void 0 : data.redirect_page_url
                });
              } else {
                _error3 = +statusCode === 500 ? {
                  errors: {
                    catched: data.toString()
                  }
                } : data;
                dispatch(failurePaymentDataValidation(_error3));
              }

              _context8.next = 24;
              break;

            case 21:
              _context8.prev = 21;
              _context8.t0 = _context8["catch"](1);
              dispatch(failurePaymentDataValidation({
                errors: {
                  catched: _context8.t0.toString()
                }
              }));

            case 24:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[1, 21]]);
    }));

    return function (_x22, _x23, _x24) {
      return _ref38.apply(this, arguments);
    };
  }();
};
var getLastOrderData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return _objectSpread({}, checkout.lastOrder);
});
var getRedirectPaymentData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return _objectSpread({}, checkout.redirectPaymentData);
});
var getErrorPaymentInfo = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return _objectSpread({}, checkout.errorPaymentInfo);
});
var getPersonalData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return _objectSpread(_objectSpread({}, checkout.personalData), {}, {
    error: checkout.error
  });
});
var getDeliveryData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return _objectSpread(_objectSpread({}, checkout.deliveryData), {}, {
    desiredDates: checkout.desiredDates,
    pickupPoints: checkout.pickupPoints,
    deliveryCosts: checkout.deliveryCosts,
    deliveryTypes: checkout.deliveryTypes,
    error: checkout.error
  });
});
var getPaymentData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return _objectSpread(_objectSpread({}, checkout.paymentData), {}, {
    paymentTypes: checkout.paymentTypes,
    paymentTypeDescriptions: checkout.paymentTypeDescriptions,
    error: checkout.error
  });
});
var timeSlotsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return {
    timeSlots: checkout.timeSlots
  };
});
var deliveryServiceSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return {
    service: checkout.service
  };
});
var deliveryMaxItemsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return {
    maxItems: checkout.maxItems
  };
});
var getNonDeliverableItems = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return {
    nonDeliverableItems: checkout.nonDeliverableItems
  };
});
var getCheckoutError = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.checkout;
}, function (checkout) {
  return checkout.error;
});
var _checkout$actions = checkout.actions,
    requestErrorPaymentInfo = _checkout$actions.requestErrorPaymentInfo,
    successErrorPaymentInfo = _checkout$actions.successErrorPaymentInfo,
    failureErrorPaymentInfo = _checkout$actions.failureErrorPaymentInfo,
    requestRedirectPaymentData = _checkout$actions.requestRedirectPaymentData,
    successRedirectPaymentData = _checkout$actions.successRedirectPaymentData,
    failureRedirectPaymentData = _checkout$actions.failureRedirectPaymentData,
    requestPersonalDataValidation = _checkout$actions.requestPersonalDataValidation,
    successPersonalDataValidation = _checkout$actions.successPersonalDataValidation,
    failurePersonalDataValidation = _checkout$actions.failurePersonalDataValidation,
    requestDeliveryDataValidation = _checkout$actions.requestDeliveryDataValidation,
    successDeliveryDataValidation = _checkout$actions.successDeliveryDataValidation,
    failureDeliveryDataValidation = _checkout$actions.failureDeliveryDataValidation,
    requestPaymentDataValidation = _checkout$actions.requestPaymentDataValidation,
    successPaymentDataValidation = _checkout$actions.successPaymentDataValidation,
    failurePaymentDataValidation = _checkout$actions.failurePaymentDataValidation,
    successOrderCreate = _checkout$actions.successOrderCreate,
    successGetShops = _checkout$actions.successGetShops,
    initGetTimeslots = _checkout$actions.initGetTimeslots,
    successGetTimeslots = _checkout$actions.successGetTimeslots,
    errorGetTimeslots = _checkout$actions.errorGetTimeslots,
    resetCheckoutData = _checkout$actions.resetCheckoutData,
    resetError = _checkout$actions.resetError,
    requestLastOrder = _checkout$actions.requestLastOrder,
    successLastOrder = _checkout$actions.successLastOrder,
    failureLastOrder = _checkout$actions.failureLastOrder;

/* harmony default export */ __webpack_exports__["ZP"] = (checkout.reducer);

/***/ }),

/***/ 74542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kn": function() { return /* binding */ fetchCurrency; },
/* harmony export */   "zC": function() { return /* binding */ getCurrency; }
/* harmony export */ });
/* unused harmony exports requestCurrency, successCurrency, failureCurrency */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var initialState = {
  currency: {},
  loading: false,
  error: null
};
var currency = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
  name: 'currency',
  initialState: initialState,
  reducers: {
    requestCurrency: function requestCurrency(state) {
      state.loading = true;
    },
    successCurrency: function successCurrency(state, _ref) {
      var payload = _ref.payload;
      state.loading = false;
      state.error = null;
      state.currency = payload === null || payload === void 0 ? void 0 : payload.currency;
    },
    failureCurrency: function failureCurrency(state, _ref2) {
      var payload = _ref2.payload;
      state.loading = false;
      state.error = payload === null || payload === void 0 ? void 0 : payload.data;
    }
  }
});
var fetchCurrency = function fetchCurrency() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$getFromCache = _ref3.getFromCache,
      getFromCache = _ref3$getFromCache === void 0 ? true : _ref3$getFromCache,
      _ref3$storage = _ref3.storage,
      storage = _ref3$storage === void 0 ? sessionStorage : _ref3$storage;

  return /*#__PURE__*/function () {
    var _ref5 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState, _ref4) {
      var api, _currency, fromCache, isStorageTime, time, now;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref4.api;
              _context.prev = 1;
              dispatch(requestCurrency());
              _currency = undefined;
              fromCache = false;
              isStorageTime = false;
              time = null;

              if (!getFromCache) {
                _context.next = 14;
                break;
              }

              _context.t0 = JSON;
              _context.next = 11;
              return storage.getItem('currency');

            case 11:
              _context.t1 = _context.sent;
              _currency = _context.t0.parse.call(_context.t0, _context.t1);
              fromCache = !!_currency;

            case 14:
              now = new Date().getHours();

              if (_currency && _currency.result !== 'error') {
                isStorageTime = _currency.time && (_currency.time > now || _currency.time < now - 2) || !_currency.time;
              }

              if (!(!_currency || _currency.result === 'error' || isStorageTime)) {
                _context.next = 21;
                break;
              }

              _context.next = 19;
              return api.currencyRates();

            case 19:
              _currency = _context.sent;
              time = now;

            case 21:
              if (!(_currency && _currency.result !== 'error')) {
                _context.next = 28;
                break;
              }

              dispatch(successCurrency({
                currency: _currency
              }));

              if (fromCache) {
                _context.next = 26;
                break;
              }

              _context.next = 26;
              return storage.setItem('currency', JSON.stringify(_objectSpread(_objectSpread({}, _currency), {}, {
                time: time ? time : _currency.time
              })));

            case 26:
              _context.next = 29;
              break;

            case 28:
              dispatch(failureCurrency({
                data: _currency
              }));

            case 29:
              _context.next = 34;
              break;

            case 31:
              _context.prev = 31;
              _context.t2 = _context["catch"](1);
              dispatch(failureCurrency({
                data: _context.t2.toString()
              }));

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 31]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var getCurrency = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function (state) {
  return state.currency;
}, function (data) {
  return data.currency;
});
var _currency$actions = currency.actions,
    requestCurrency = _currency$actions.requestCurrency,
    successCurrency = _currency$actions.successCurrency,
    failureCurrency = _currency$actions.failureCurrency;

/* harmony default export */ __webpack_exports__["ZP"] = (currency.reducer);

/***/ }),

/***/ 53662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kc": function() { return /* binding */ getLookDataByKey; },
/* harmony export */   "vC": function() { return /* binding */ fetchLook; }
/* harmony export */ });
/* unused harmony exports requestLook, successLook, failureLook */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35357);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);



var _excluded = ["refresh", "errToString"],
    _excluded2 = ["cachedQueries", "currentQuery"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var initialState = {
  cachedQueries: {},
  loading: false,
  error: null,
  currentQuery: null
};
var look = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
  name: 'look',
  initialState: initialState,
  reducers: {
    requestLook: function requestLook(state) {
      state.loading = true;
      state.error = null;
    },
    successLook: function successLook(state, _ref) {
      var payload = _ref.payload;
      var key = payload.key,
          look = payload.look,
          _payload$refresh = payload.refresh,
          refresh = _payload$refresh === void 0 ? false : _payload$refresh;
      var cachedQueries = state.cachedQueries;
      state.currentQuery = key;

      if (!cachedQueries[key] || refresh) {
        cachedQueries[key] = look;
      }

      state.loading = false;
      state.error = null;
    },
    failureLook: function failureLook(state, _ref2) {
      var payload = _ref2.payload;
      var key = payload.key,
          look = payload.look,
          data = payload.data;
      state.currentQuery = key;
      state.loading = false;
      state.error = data || look;
    }
  }
});
var fetchLook = function fetchLook(_ref3) {
  var _ref3$refresh = _ref3.refresh,
      refresh = _ref3$refresh === void 0 ? false : _ref3$refresh,
      _ref3$errToString = _ref3.errToString,
      errToString = _ref3$errToString === void 0 ? true : _ref3$errToString,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref3, _excluded);

  return /*#__PURE__*/function () {
    var _ref5 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(dispatch, getState, _ref4) {
      var api, state, key, response, result, _look;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref4.api;
              state = getState().look;
              key = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(params);
              _context.prev = 3;

              if (!(!refresh && state.cachedQueries[key])) {
                _context.next = 9;
                break;
              }

              dispatch(successLook({
                key: key
              }));
              return _context.abrupt("return");

            case 9:
              dispatch(requestLook());
              _context.next = 12;
              return api.look(params);

            case 12:
              response = _context.sent;
              result = response.result, _look = response.look;

              if (result === 'success') {
                dispatch(successLook({
                  key: key,
                  look: _look,
                  refresh: refresh
                }));
              } else {
                dispatch(failureLook({
                  key: key,
                  data: response
                }));
              }

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              dispatch(failureLook({
                key: key,
                data: errToString ? _context.t0.toString() : _context.t0
              }));

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 17]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var getLookDataByKey = function getLookDataByKey(params) {
  return function (state) {
    var key = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(params);
    var look = state.look;

    var cachedQueries = look.cachedQueries,
        currentQuery = look.currentQuery,
        lookState = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(look, _excluded2);

    var cachedQueryData = cachedQueries[key];
    return _objectSpread({
      data: cachedQueryData
    }, lookState);
  };
};
var _look$actions = look.actions,
    requestLook = _look$actions.requestLook,
    successLook = _look$actions.successLook,
    failureLook = _look$actions.failureLook;

/* harmony default export */ __webpack_exports__["ZP"] = (look.reducer);

/***/ }),

/***/ 66681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DP": function() { return /* binding */ getSpecialOffersData; },
/* harmony export */   "Jx": function() { return /* binding */ getNewsData; },
/* harmony export */   "VR": function() { return /* binding */ fetchFeedbacks; },
/* harmony export */   "Zg": function() { return /* binding */ fetchSpecialOffers; },
/* harmony export */   "aL": function() { return /* binding */ fetchNews; },
/* harmony export */   "d2": function() { return /* binding */ getFeedbacksData; },
/* harmony export */   "kS": function() { return /* binding */ fetchMarketProducts; },
/* harmony export */   "qr": function() { return /* binding */ postFeedback; }
/* harmony export */ });
/* unused harmony exports fetchSubscriptions, fetchPageData, getSubscriptionsData, requestPage, successPage, failurePage, requestNews, successNews, successOldNews, failureNews, requestFeedbacks, successFeedbacks, successOldFeedbacks, failureFeedbacks, successSubscriptions, requestSubscriptions, failureSubscriptions, requestSpecialOffers, successSpecialOffers, successOldSpecialOffers, failureSpecialOffers */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27812);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68697);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);




var _excluded = ["refresh"],
    _excluded2 = ["refresh"],
    _excluded3 = ["onSucces", "onError"],
    _excluded4 = ["refresh"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var initialState = {
  cachedQueries: {},
  loading: false,
  currentQuery: null,
  news: {
    cachedQueries: {},
    currentQuery: null
  },
  subscriptions: {
    cachedQueries: {},
    loading: false,
    currentQuery: null
  },
  specialOffers: {
    cachedQueries: {},
    currentQuery: null
  },
  blackFriday: {
    cachedQueries: {},
    loading: false,
    currentQuery: null
  },
  feedbacks: {
    cachedQueries: {},
    loading: false,
    currentQuery: null,
    filters: []
  }
};
var pages = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
  name: 'pages',
  initialState: initialState,
  reducers: {
    requestPage: function requestPage(state) {
      state.loading = true;
    },
    successPage: function successPage(state, _ref) {
      var payload = _ref.payload;
      var key = payload.key,
          data = payload.data;
      var cachedQueries = state.cachedQueries;
      state.currentQuery = key;

      if (!cachedQueries[key]) {
        cachedQueries[key] = {
          data: data,
          error: null
        };
      }

      state.loading = false;
    },
    failurePage: function failurePage(state, _ref2) {
      var payload = _ref2.payload;
      var key = payload.key,
          data = payload.data;
      var cachedQueries = state.cachedQueries;
      state.currentQuery = key;

      if (!cachedQueries[key]) {
        cachedQueries[key] = {
          data: null,
          error: data
        };
      }

      state.loading = false;
    },
    requestNews: function requestNews(state, _ref3) {
      var payload = _ref3.payload;
      var key = payload.key;
      state.news.currentQuery = key;
      state.news.cachedQueries[key] = {
        data: null,
        loading: true,
        error: null
      };
    },
    successNews: function successNews(state, _ref4) {
      var _cachedQueries$key;

      var payload = _ref4.payload;
      var key = payload.key,
          data = payload.data;
      var cachedQueries = state.news.cachedQueries;
      state.news.currentQuery = key;
      var newData = data || ((_cachedQueries$key = cachedQueries[key]) === null || _cachedQueries$key === void 0 ? void 0 : _cachedQueries$key.data) || null;
      cachedQueries[key] = {
        data: newData,
        error: null,
        loading: false
      };
    },
    successOldNews: function successOldNews(state, _ref5) {
      var payload = _ref5.payload;
      var key = payload.key;
      state.news.currentQuery = key;
    },
    failureNews: function failureNews(state, _ref6) {
      var payload = _ref6.payload;
      var key = payload.key,
          data = payload.data;
      state.news.currentQuery = key;
      state.news.cachedQueries[key] = {
        data: null,
        error: data,
        loading: false
      };
    },
    requestFeedbacks: function requestFeedbacks(state, _ref7) {
      var payload = _ref7.payload;
      var key = payload.key;
      state.feedbacks.currentQuery = key;
      state.feedbacks.cachedQueries[key] = {
        data: null,
        loading: true,
        error: null
      };
    },
    successFeedbacks: function successFeedbacks(state, _ref8) {
      var _cachedQueries$key2;

      var payload = _ref8.payload;
      var key = payload.key,
          data = payload.data;
      var cachedQueries = state.feedbacks.cachedQueries;
      state.feedbacks.currentQuery = key;
      var newData = data || ((_cachedQueries$key2 = cachedQueries[key]) === null || _cachedQueries$key2 === void 0 ? void 0 : _cachedQueries$key2.data) || null;
      cachedQueries[key] = {
        data: newData,
        error: null,
        loading: false
      };

      if (!state.feedbacks.filters.length) {
        state.feedbacks.filters = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(data.filters);
      }
    },
    successOldFeedbacks: function successOldFeedbacks(state, _ref9) {
      var payload = _ref9.payload;
      var key = payload.key;
      state.feedbacks.currentQuery = key;
    },
    failureFeedbacks: function failureFeedbacks(state, _ref10) {
      var payload = _ref10.payload;
      var key = payload.key,
          data = payload.data;
      state.feedbacks.currentQuery = key;
      state.feedbacks.cachedQueries[key] = {
        data: null,
        error: data,
        loading: false
      };
    },
    requestSubscriptions: function requestSubscriptions(state) {
      state.subscriptions.loading = true;
    },
    successSubscriptions: function successSubscriptions(state, _ref11) {
      var payload = _ref11.payload;
      var key = payload.key,
          data = payload.data;
      var cachedQueries = state.subscriptions.cachedQueries;
      state.subscriptions.currentQuery = key;

      if (!cachedQueries[key]) {
        cachedQueries[key] = {
          data: data,
          error: null
        };
      }

      state.subscriptions.loading = false;
    },
    failureSubscriptions: function failureSubscriptions(state, _ref12) {
      var payload = _ref12.payload;
      var key = payload.key,
          data = payload.data;
      var cachedQueries = state.subscriptions.cachedQueries;
      state.subscriptions.currentQuery = key;

      if (!cachedQueries[key]) {
        cachedQueries[key] = {
          data: null,
          error: data
        };
      }

      state.subscriptions.loading = false;
    },
    requestSpecialOffers: function requestSpecialOffers(state, _ref13) {
      var payload = _ref13.payload;
      var key = payload.key;
      state.specialOffers.currentQuery = key;
      state.specialOffers.cachedQueries[key] = {
        data: null,
        loading: true,
        error: null
      };
    },
    successSpecialOffers: function successSpecialOffers(state, _ref14) {
      var _cachedQueries$key3;

      var payload = _ref14.payload;
      var key = payload.key,
          data = payload.data;
      var cachedQueries = state.specialOffers.cachedQueries;
      state.specialOffers.currentQuery = key;
      var newData = data || ((_cachedQueries$key3 = cachedQueries[key]) === null || _cachedQueries$key3 === void 0 ? void 0 : _cachedQueries$key3.data) || null;
      cachedQueries[key] = {
        data: newData,
        error: null,
        loading: false
      };
    },
    successOldSpecialOffers: function successOldSpecialOffers(state, _ref15) {
      var payload = _ref15.payload;
      var key = payload.key;
      state.specialOffers.currentQuery = key;
    },
    failureSpecialOffers: function failureSpecialOffers(state, _ref16) {
      var payload = _ref16.payload;
      var key = payload.key,
          data = payload.data;
      state.specialOffers.currentQuery = key;
      state.specialOffers.cachedQueries[key] = {
        data: null,
        error: data,
        loading: false
      };
    }
  }
});
var fetchNews = function fetchNews() {
  var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref17$refresh = _ref17.refresh,
      refresh = _ref17$refresh === void 0 ? false : _ref17$refresh,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref17, _excluded);

  return /*#__PURE__*/function () {
    var _ref19 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(dispatch, getState, _ref18) {
      var api, state, key, _state$cachedQueries$, _state$cachedQueries$2, _response$result, response, result, data, meta;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref18.api;
              state = getState().pages.news;
              key = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(params);
              _context.prev = 3;

              if (!(!refresh && (_state$cachedQueries$ = state.cachedQueries[key]) !== null && _state$cachedQueries$ !== void 0 && _state$cachedQueries$.data && !((_state$cachedQueries$2 = state.cachedQueries[key]) !== null && _state$cachedQueries$2 !== void 0 && _state$cachedQueries$2.error))) {
                _context.next = 9;
                break;
              }

              dispatch(successOldNews({
                key: key
              }));
              return _context.abrupt("return");

            case 9:
              dispatch(requestNews({
                key: key
              }));
              _context.next = 12;
              return api.news(params);

            case 12:
              response = _context.sent;
              result = (_response$result = response === null || response === void 0 ? void 0 : response.result) !== null && _response$result !== void 0 ? _response$result : 'success';

              if (result === 'success') {
                data = response.data, meta = response.meta;
                dispatch(successNews({
                  key: key,
                  data: {
                    articles: data || [],
                    meta: meta
                  }
                }));
              } else {
                dispatch(failureNews({
                  key: key,
                  data: response
                }));
              }

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              dispatch(failureNews({
                key: key,
                data: _context.t0.toString()
              }));

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 17]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref19.apply(this, arguments);
    };
  }();
};
var fetchFeedbacks = function fetchFeedbacks() {
  var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref20$refresh = _ref20.refresh,
      refresh = _ref20$refresh === void 0 ? false : _ref20$refresh,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref20, _excluded2);

  return /*#__PURE__*/function () {
    var _ref22 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(dispatch, getState, _ref21) {
      var api, state, key, _state$cachedQueries$3, _state$cachedQueries$4, _response$result2, response, result, data, meta, filters;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref21.api;
              state = getState().pages.feedbacks;
              key = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(params);
              _context2.prev = 3;

              if (!(!refresh && (_state$cachedQueries$3 = state.cachedQueries[key]) !== null && _state$cachedQueries$3 !== void 0 && _state$cachedQueries$3.data && !((_state$cachedQueries$4 = state.cachedQueries[key]) !== null && _state$cachedQueries$4 !== void 0 && _state$cachedQueries$4.error))) {
                _context2.next = 9;
                break;
              }

              dispatch(successOldFeedbacks({
                key: key
              }));
              return _context2.abrupt("return");

            case 9:
              dispatch(requestFeedbacks({
                key: key
              }));
              _context2.next = 12;
              return api.feedback(params);

            case 12:
              response = _context2.sent;
              result = (_response$result2 = response === null || response === void 0 ? void 0 : response.result) !== null && _response$result2 !== void 0 ? _response$result2 : 'success';

              if (result === 'success') {
                data = response.data, meta = response.meta, filters = response.filters;
                dispatch(successFeedbacks({
                  key: key,
                  data: {
                    articles: data || [],
                    meta: meta,
                    filters: filters
                  }
                }));
              } else {
                dispatch(failureFeedbacks({
                  key: key,
                  data: response
                }));
              }

            case 15:
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](3);
              dispatch(failureFeedbacks({
                key: key,
                data: _context2.t0.toString()
              }));

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 17]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref22.apply(this, arguments);
    };
  }();
};
var postFeedback = function postFeedback() {
  var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref23$onSucces = _ref23.onSucces,
      onSucces = _ref23$onSucces === void 0 ? null : _ref23$onSucces,
      _ref23$onError = _ref23.onError,
      onError = _ref23$onError === void 0 ? null : _ref23$onError,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref23, _excluded3);

  return /*#__PURE__*/function () {
    var _ref25 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(dispatch, getState, _ref24) {
      var api, _response$result3, response, result;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref24.api;
              _context3.prev = 1;
              _context3.next = 4;
              return api.postFeedback(params);

            case 4:
              response = _context3.sent;
              result = (_response$result3 = response === null || response === void 0 ? void 0 : response.result) !== null && _response$result3 !== void 0 ? _response$result3 : 'success';

              if (result === 'success') {
                onSucces === null || onSucces === void 0 ? void 0 : onSucces();
              } else {
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](1);
              onError === null || onError === void 0 ? void 0 : onError(_context3.t0.toString());

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 9]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref25.apply(this, arguments);
    };
  }();
};
var fetchSubscriptions = function fetchSubscriptions(params) {
  return /*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref26) {
      var api, state, key, _response$result4, response, result;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              api = _ref26.api;
              state = getState().pages.subscriptions;
              key = qs.stringify(params);
              _context4.prev = 3;

              if (!state.cachedQueries[key]) {
                _context4.next = 9;
                break;
              }

              dispatch(successSubscriptions({
                key: key
              }));
              return _context4.abrupt("return");

            case 9:
              dispatch(requestSubscriptions());
              _context4.next = 12;
              return api.subscriptions(params);

            case 12:
              response = _context4.sent;
              result = (_response$result4 = response === null || response === void 0 ? void 0 : response.result) !== null && _response$result4 !== void 0 ? _response$result4 : 'success';

              if (result === 'success') {
                dispatch(successSubscriptions({
                  key: key,
                  data: response
                }));
              } else {
                dispatch(failureSubscriptions({
                  key: key,
                  data: response
                }));
              }

            case 15:
              _context4.next = 20;
              break;

            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4["catch"](3);
              dispatch(failureSubscriptions({
                key: key,
                data: _context4.t0.toString()
              }));

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 17]]);
    }));

    return function (_x10, _x11, _x12) {
      return _ref27.apply(this, arguments);
    };
  }();
};
var fetchSpecialOffers = function fetchSpecialOffers() {
  var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref28$refresh = _ref28.refresh,
      refresh = _ref28$refresh === void 0 ? false : _ref28$refresh,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref28, _excluded4);

  return /*#__PURE__*/function () {
    var _ref30 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5(dispatch, getState, _ref29) {
      var api, state, key, _state$cachedQueries$5, _state$cachedQueries$6, _response$result5, response, result, data, meta;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = _ref29.api;
              state = getState().pages.specialOffers;
              key = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(params);
              _context5.prev = 3;

              if (!(!refresh && (_state$cachedQueries$5 = state.cachedQueries[key]) !== null && _state$cachedQueries$5 !== void 0 && _state$cachedQueries$5.data && !((_state$cachedQueries$6 = state.cachedQueries[key]) !== null && _state$cachedQueries$6 !== void 0 && _state$cachedQueries$6.error))) {
                _context5.next = 9;
                break;
              }

              dispatch(successOldSpecialOffers({
                key: key
              }));
              return _context5.abrupt("return");

            case 9:
              dispatch(requestSpecialOffers({
                key: key
              }));
              _context5.next = 12;
              return api.specialOffers(params);

            case 12:
              response = _context5.sent;
              result = (_response$result5 = response === null || response === void 0 ? void 0 : response.result) !== null && _response$result5 !== void 0 ? _response$result5 : 'success';

              if (result === 'success') {
                data = response.data, meta = response.meta;
                dispatch(successSpecialOffers({
                  key: key,
                  data: {
                    articles: data || [],
                    meta: meta
                  }
                }));
              } else {
                dispatch(failureSpecialOffers({
                  key: key,
                  data: response
                }));
              }

            case 15:
              _context5.next = 20;
              break;

            case 17:
              _context5.prev = 17;
              _context5.t0 = _context5["catch"](3);
              dispatch(failureSpecialOffers({
                key: key,
                data: _context5.t0.toString()
              }));

            case 20:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 17]]);
    }));

    return function (_x13, _x14, _x15) {
      return _ref30.apply(this, arguments);
    };
  }();
};
var fetchPageData = function fetchPageData(_ref31) {
  var slug = _ref31.slug,
      _ref31$type = _ref31.type,
      type = _ref31$type === void 0 ? 'page' : _ref31$type,
      access = _ref31.access;
  return /*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState, _ref32) {
      var api, state, params, key, response, _ref34, _ref34$result, result, page, articles;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              api = _ref32.api;
              state = getState().pages;
              params = {
                slug: "/".concat(slug),
                type: type
              };
              if (access) params.access = access;
              key = qs.stringify(params);
              _context6.prev = 5;

              if (!state.cachedQueries[key]) {
                _context6.next = 11;
                break;
              }

              dispatch(successPage({
                key: key
              }));
              return _context6.abrupt("return");

            case 11:
              dispatch(requestPage());
              _context6.next = 14;
              return api.pages(params);

            case 14:
              response = _context6.sent;
              _ref34 = response || {}, _ref34$result = _ref34.result, result = _ref34$result === void 0 ? 'success' : _ref34$result, page = _ref34.page, articles = _ref34.articles;

              if (result === 'success') {
                dispatch(successPage({
                  key: key,
                  data: _objectSpread(_objectSpread({}, page !== null && page !== void 0 ? page : {}), {}, {
                    articles: articles || []
                  })
                }));
              } else {
                dispatch(failurePage({
                  key: key,
                  data: response
                }));
              }

            case 17:
              _context6.next = 22;
              break;

            case 19:
              _context6.prev = 19;
              _context6.t0 = _context6["catch"](5);
              dispatch(failurePage({
                key: key,
                data: _context6.t0.toString()
              }));

            case 22:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[5, 19]]);
    }));

    return function (_x16, _x17, _x18) {
      return _ref33.apply(this, arguments);
    };
  }();
};
var fetchMarketProducts = function fetchMarketProducts(_ref35) {
  var _ref35$onSuccess = _ref35.onSuccess,
      onSuccess = _ref35$onSuccess === void 0 ? null : _ref35$onSuccess,
      _ref35$onError = _ref35.onError,
      onError = _ref35$onError === void 0 ? null : _ref35$onError,
      ids = _ref35.ids;
  return /*#__PURE__*/function () {
    var _ref37 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee7(dispatch, getState, _ref36) {
      var api, _response$result6, response, result, _response$data;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              api = _ref36.api;
              _context7.prev = 1;
              _context7.next = 4;
              return api.marketProducts({
                ids: ids
              });

            case 4:
              response = _context7.sent;
              result = (_response$result6 = response === null || response === void 0 ? void 0 : response.result) !== null && _response$result6 !== void 0 ? _response$result6 : 'success';

              if (result === 'success') {
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess((_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : []);
              } else {
                onError === null || onError === void 0 ? void 0 : onError();
              }

              _context7.next = 12;
              break;

            case 9:
              _context7.prev = 9;
              _context7.t0 = _context7["catch"](1);
              onError === null || onError === void 0 ? void 0 : onError(_context7.t0);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 9]]);
    }));

    return function (_x19, _x20, _x21) {
      return _ref37.apply(this, arguments);
    };
  }();
};
var getNewsData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(function (state) {
  return state.pages.news;
}, function (news) {
  var cachedQueries = news.cachedQueries,
      currentQuery = news.currentQuery;
  return cachedQueries[currentQuery] || {
    data: null,
    loading: false,
    error: null
  };
});
var getFeedbacksData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(function (state) {
  return state.pages.feedbacks;
}, function (feedbacks) {
  var cachedQueries = feedbacks.cachedQueries,
      currentQuery = feedbacks.currentQuery,
      filters = feedbacks.filters;
  return _objectSpread(_objectSpread({}, cachedQueries[currentQuery]), {}, {
    filters: filters
  }) || {
    data: null,
    loading: false,
    error: null,
    filters: filters
  };
});
var getSubscriptionsData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(function (state) {
  return state.pages.subscriptions;
}, function (subscriptions) {
  var _cachedQueries$curren, _cachedQueries$curren2;

  var cachedQueries = subscriptions.cachedQueries,
      currentQuery = subscriptions.currentQuery,
      loading = subscriptions.loading;
  var cachedQueryData = (_cachedQueries$curren = cachedQueries[currentQuery]) === null || _cachedQueries$curren === void 0 ? void 0 : _cachedQueries$curren.data;
  var cachedQueryError = (_cachedQueries$curren2 = cachedQueries[currentQuery]) === null || _cachedQueries$curren2 === void 0 ? void 0 : _cachedQueries$curren2.error;
  return {
    data: cachedQueryData,
    loading: loading,
    error: cachedQueryError
  };
});
var getSpecialOffersData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(function (state) {
  return state.pages.specialOffers;
}, function (specialOffers) {
  var cachedQueries = specialOffers.cachedQueries,
      currentQuery = specialOffers.currentQuery;
  return cachedQueries[currentQuery] || {
    data: null,
    loading: false,
    error: null
  };
});
var _pages$actions = pages.actions,
    requestPage = _pages$actions.requestPage,
    successPage = _pages$actions.successPage,
    failurePage = _pages$actions.failurePage,
    requestNews = _pages$actions.requestNews,
    successNews = _pages$actions.successNews,
    successOldNews = _pages$actions.successOldNews,
    failureNews = _pages$actions.failureNews,
    requestFeedbacks = _pages$actions.requestFeedbacks,
    successFeedbacks = _pages$actions.successFeedbacks,
    successOldFeedbacks = _pages$actions.successOldFeedbacks,
    failureFeedbacks = _pages$actions.failureFeedbacks,
    successSubscriptions = _pages$actions.successSubscriptions,
    requestSubscriptions = _pages$actions.requestSubscriptions,
    failureSubscriptions = _pages$actions.failureSubscriptions,
    requestSpecialOffers = _pages$actions.requestSpecialOffers,
    successSpecialOffers = _pages$actions.successSpecialOffers,
    successOldSpecialOffers = _pages$actions.successOldSpecialOffers,
    failureSpecialOffers = _pages$actions.failureSpecialOffers;

/* harmony default export */ __webpack_exports__["ZP"] = (pages.reducer);

/***/ }),

/***/ 73278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ fetchProductLooks; },
/* harmony export */   "MZ": function() { return /* binding */ fetchProductShops; },
/* harmony export */   "Rc": function() { return /* binding */ fetchProductCollections; },
/* harmony export */   "Z3": function() { return /* binding */ fetchProductsFromCollections; },
/* harmony export */   "mr": function() { return /* binding */ fetchProductPage; }
/* harmony export */ });
/* unused harmony exports fetchProduct, requestProduct, successProduct, failureProduct, requestProductCollections, successProductCollections, failureProductCollections, requestProductShops, successProductShops, failureProductShops, requestProductLooks, successProductLooks, failureProductLooks */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35357);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


var _excluded = (/* unused pure expression or super */ null && (["refresh"])),
    _excluded2 = ["refresh"],
    _excluded3 = ["refresh", "onSuccess", "onError"],
    _excluded4 = ["refresh", "onSuccess", "onError"],
    _excluded5 = ["onSuccess", "onError"],
    _excluded6 = ["refresh", "errToString"];



var initialState = {
  cachedQueries: {},
  cachedCollectionsQueries: {},
  cachedLooksQueries: {},
  cachedShopsQueries: {},
  loading: false,
  loadingCollections: false,
  loadingLooks: false,
  loadingShops: false,
  error: null,
  errorCollections: null,
  errorLooks: null,
  errorShops: null,
  currentQuery: null,
  currentQueryCatalogGroup: null,
  loadingInfo: {},
  loadingCollectionsInfo: {},
  loadingLooksInfo: {},
  loadingShopsInfo: {},
  errorsInfo: {},
  errorsCollectionsInfo: {},
  errorsLooksInfo: {},
  errorsShopsInfo: {}
};
var product = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
  name: 'product',
  initialState: initialState,
  reducers: {
    requestProduct: function requestProduct(state, _ref) {
      var payload = _ref.payload;

      var _ref2 = payload || {},
          key = _ref2.key;

      state.loading = true;

      if (key) {
        state.loadingInfo[key] = true;
        state.errorsInfo[key] = null;
      }
    },
    requestProductCollections: function requestProductCollections(state, _ref3) {
      var payload = _ref3.payload;

      var _ref4 = payload || {},
          key = _ref4.key;

      state.loadingCollections = true;

      if (key) {
        state.loadingCollectionsInfo[key] = true;
        state.errorsCollectionsInfo[key] = null;
      }
    },
    requestProductLooks: function requestProductLooks(state, _ref5) {
      var payload = _ref5.payload;

      var _ref6 = payload || {},
          key = _ref6.key;

      state.loadingLooks = true;

      if (key) {
        state.loadingLooksInfo[key] = true;
        state.errorsLooksInfo[key] = null;
      }
    },
    requestProductShops: function requestProductShops(state, _ref7) {
      var payload = _ref7.payload;

      var _ref8 = payload || {},
          key = _ref8.key;

      state.loadingShops = true;

      if (key) {
        state.loadingShopsInfo[key] = true;
        state.errorsShopsInfo[key] = null;
      }
    },
    successProduct: function successProduct(state, _ref9) {
      var payload = _ref9.payload;
      var key = payload.key,
          data = payload.data,
          _payload$refresh = payload.refresh,
          refresh = _payload$refresh === void 0 ? false : _payload$refresh;
      var cachedQueries = state.cachedQueries;
      state.currentQuery = key;

      if (data && (refresh || !cachedQueries[key])) {
        cachedQueries[key] = data;
      }

      state.currentQueryCatalogGroup = null;
      state.loading = false;
      state.error = null;
      state.loadingInfo[key] = false;
      state.errorsInfo[key] = null;
    },
    successProductCollections: function successProductCollections(state, _ref10) {
      var payload = _ref10.payload;
      var key = payload.key,
          data = payload.data;
      state.cachedCollectionsQueries[key] = data || state.cachedCollectionsQueries[key] || {};
      state.currentQueryCatalogGroup = key;
      state.loadingCollections = false;
      state.errorCollections = null;
      state.loadingCollectionsInfo[key] = false;
      state.errorsCollectionsInfo[key] = null;
    },
    successProductLooks: function successProductLooks(state, _ref11) {
      var payload = _ref11.payload;
      var key = payload.key,
          data = payload.data;
      state.cachedLooksQueries[key] = data || state.cachedLooksQueries[key] || null;
      state.currentQueryCatalogGroup = key;
      state.loadingLooks = false;
      state.errorLooks = null;
      state.loadingLooksInfo[key] = false;
      state.errorsLooksInfo[key] = null;
    },
    successProductShops: function successProductShops(state, _ref12) {
      var payload = _ref12.payload;
      var key = payload.key,
          data = payload.data;
      state.cachedShopsQueries[key] = data || state.cachedShopsQueries[key];
      state.loadingShops = false;
      state.errorShops = null;
      state.loadingShopsInfo[key] = false;
      state.errorsShopsInfo[key] = null;
    },
    failureProduct: function failureProduct(state, _ref13) {
      var payload = _ref13.payload;
      var key = payload.key,
          data = payload.data;
      state.currentQuery = key;
      state.loading = false;
      state.error = data;
      state.loadingInfo[key] = false;
      state.errorsInfo[key] = data;
    },
    failureProductCollections: function failureProductCollections(state, _ref14) {
      var payload = _ref14.payload;
      var data = payload.data,
          key = payload.key;
      state.loadingCollections = false;
      state.currentQueryCatalogGroup = key;
      state.errorCollections = data;
      state.loadingCollectionsInfo[key] = false;
      state.errorsCollectionsInfo[key] = data;
    },
    failureProductLooks: function failureProductLooks(state, _ref15) {
      var payload = _ref15.payload;
      var data = payload.data,
          key = payload.key;
      state.loadingLooks = false;
      state.currentQueryCatalogGroup = key;
      state.errorLooks = data;
      state.loadingLooksInfo[key] = false;
      state.errorsLooksInfo[key] = data;
    },
    failureProductShops: function failureProductShops(state, _ref16) {
      var payload = _ref16.payload;
      var data = payload.data,
          key = payload.key;
      state.loadingShops = false;
      state.errorShops = data;
      state.loadingShopsInfo[key] = false;
      state.errorsShopsInfo[key] = data;
    }
  }
});
var fetchProduct = function fetchProduct(_ref17) {
  var _ref17$refresh = _ref17.refresh,
      refresh = _ref17$refresh === void 0 ? false : _ref17$refresh,
      params = _objectWithoutProperties(_ref17, _excluded);

  return /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref18) {
      var api, state, key, response, result, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref18.api;
              state = getState().product;
              key = qs.stringify(params);
              _context.prev = 3;

              if (!(!refresh && state.cachedQueries[key])) {
                _context.next = 9;
                break;
              }

              dispatch(successProduct({
                key: key
              }));
              return _context.abrupt("return");

            case 9:
              dispatch(requestProduct({
                key: key
              }));
              _context.next = 12;
              return api.productBack(params);

            case 12:
              response = _context.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                dispatch(successProduct({
                  key: key,
                  data: data,
                  refresh: refresh
                }));
              } else {
                dispatch(failureProduct({
                  key: key,
                  data: response
                }));
              }

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              dispatch(failureProduct({
                key: key,
                data: _context.t0.toString()
              }));

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 17]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref19.apply(this, arguments);
    };
  }();
};
var fetchProductPage = function fetchProductPage(_ref20) {
  var _ref20$refresh = _ref20.refresh,
      refresh = _ref20$refresh === void 0 ? false : _ref20$refresh,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref20, _excluded2);

  return /*#__PURE__*/function () {
    var _ref22 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(dispatch, getState, _ref21) {
      var api, state, key, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref21.api;
              state = getState().product;
              key = qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(params);
              _context2.prev = 3;

              if (!(!refresh && state.cachedQueries[key])) {
                _context2.next = 9;
                break;
              }

              dispatch(successProduct({
                key: key
              }));
              return _context2.abrupt("return");

            case 9:
              dispatch(requestProduct({
                key: key
              }));
              _context2.next = 12;
              return api.newProductBack(params);

            case 12:
              response = _context2.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                dispatch(successProduct({
                  key: key,
                  data: data
                }));
              } else {
                dispatch(failureProduct({
                  key: key,
                  data: response
                }));
              }

            case 15:
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](3);
              dispatch(failureProduct({
                key: key,
                data: _context2.t0.toString()
              }));

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 17]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref22.apply(this, arguments);
    };
  }();
};
var fetchProductCollections = function fetchProductCollections(_ref23) {
  var _ref23$refresh = _ref23.refresh,
      refresh = _ref23$refresh === void 0 ? false : _ref23$refresh,
      onSuccess = _ref23.onSuccess,
      onError = _ref23.onError,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref23, _excluded3);

  return /*#__PURE__*/function () {
    var _ref25 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(dispatch, getState, _ref24) {
      var api, state, key, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref24.api;
              state = getState().product;
              key = qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(params);
              _context3.prev = 3;

              if (!(!refresh && state.cachedCollectionsQueries[key])) {
                _context3.next = 10;
                break;
              }

              dispatch(successProductCollections({
                key: key
              }));
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(state.cachedCollectionsQueries[key]);
              return _context3.abrupt("return");

            case 10:
              dispatch(requestProductCollections({
                key: key
              }));
              _context3.next = 13;
              return api.productFromCollections(params);

            case 13:
              response = _context3.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                dispatch(successProductCollections({
                  key: key,
                  data: data
                }));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
              } else {
                dispatch(failureProductCollections({
                  key: key,
                  data: response
                }));
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

            case 16:
              _context3.next = 22;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](3);
              dispatch(failureProductCollections({
                key: key,
                data: _context3.t0.toString()
              }));
              onError === null || onError === void 0 ? void 0 : onError(_context3.t0.toString());

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 18]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref25.apply(this, arguments);
    };
  }();
};
var fetchProductLooks = function fetchProductLooks(_ref26) {
  var _ref26$refresh = _ref26.refresh,
      refresh = _ref26$refresh === void 0 ? false : _ref26$refresh,
      onSuccess = _ref26.onSuccess,
      onError = _ref26.onError,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref26, _excluded4);

  return /*#__PURE__*/function () {
    var _ref28 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(dispatch, getState, _ref27) {
      var api, state, key, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              api = _ref27.api;
              state = getState().product;
              key = qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(params);
              _context4.prev = 3;

              if (!(!refresh && state.cachedLooksQueries[key])) {
                _context4.next = 10;
                break;
              }

              dispatch(successProductLooks({
                key: key
              }));
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(state.cachedLooksQueries[key]);
              return _context4.abrupt("return");

            case 10:
              dispatch(requestProductLooks({
                key: key
              }));
              _context4.next = 13;
              return api.productLooks(params);

            case 13:
              response = _context4.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                dispatch(successProductLooks({
                  key: key,
                  data: data
                }));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
              } else {
                dispatch(failureProductLooks({
                  key: key,
                  data: response
                }));
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

            case 16:
              _context4.next = 22;
              break;

            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](3);
              dispatch(failureProductLooks({
                key: key,
                data: _context4.t0.toString()
              }));
              onError === null || onError === void 0 ? void 0 : onError(_context4.t0.toString());

            case 22:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 18]]);
    }));

    return function (_x10, _x11, _x12) {
      return _ref28.apply(this, arguments);
    };
  }();
};
var fetchProductsFromCollections = function fetchProductsFromCollections(_ref29) {
  var onSuccess = _ref29.onSuccess,
      onError = _ref29.onError,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref29, _excluded5);

  return /*#__PURE__*/function () {
    var _ref31 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(_dispatch, _getState, _ref30) {
      var api, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = _ref30.api;
              _context5.prev = 1;
              _context5.next = 4;
              return api.productFromCollections(params);

            case 4:
              response = _context5.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data.products);
              } else {
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

              _context5.next = 12;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](1);
              onError === null || onError === void 0 ? void 0 : onError(_context5.t0.toString());

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 9]]);
    }));

    return function (_x13, _x14, _x15) {
      return _ref31.apply(this, arguments);
    };
  }();
};
var fetchProductShops = function fetchProductShops(_ref32) {
  var _ref32$refresh = _ref32.refresh,
      refresh = _ref32$refresh === void 0 ? false : _ref32$refresh,
      _ref32$errToString = _ref32.errToString,
      errToString = _ref32$errToString === void 0 ? true : _ref32$errToString,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref32, _excluded6);

  return /*#__PURE__*/function () {
    var _ref34 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(dispatch, getState, _ref33) {
      var api, state, key, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              api = _ref33.api;
              state = getState().product;
              key = qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(params);
              _context6.prev = 3;

              if (!(!refresh && state.cachedShopsQueries[key])) {
                _context6.next = 9;
                break;
              }

              dispatch(successProductShops({
                key: key
              }));
              return _context6.abrupt("return");

            case 9:
              dispatch(requestProductShops({
                key: key
              }));
              _context6.next = 12;
              return api.productShops(params);

            case 12:
              response = _context6.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                dispatch(successProductShops({
                  key: key,
                  data: data
                }));
              } else {
                dispatch(failureProductShops({
                  key: key,
                  data: response
                }));
              }

            case 15:
              _context6.next = 20;
              break;

            case 17:
              _context6.prev = 17;
              _context6.t0 = _context6["catch"](3);
              dispatch(failureProductShops({
                key: key,
                data: errToString ? _context6.t0.toString() : _context6.t0
              }));

            case 20:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[3, 17]]);
    }));

    return function (_x16, _x17, _x18) {
      return _ref34.apply(this, arguments);
    };
  }();
};
var _product$actions = product.actions,
    requestProduct = _product$actions.requestProduct,
    successProduct = _product$actions.successProduct,
    failureProduct = _product$actions.failureProduct,
    requestProductCollections = _product$actions.requestProductCollections,
    successProductCollections = _product$actions.successProductCollections,
    failureProductCollections = _product$actions.failureProductCollections,
    requestProductShops = _product$actions.requestProductShops,
    successProductShops = _product$actions.successProductShops,
    failureProductShops = _product$actions.failureProductShops,
    requestProductLooks = _product$actions.requestProductLooks,
    successProductLooks = _product$actions.successProductLooks,
    failureProductLooks = _product$actions.failureProductLooks;

/* harmony default export */ __webpack_exports__["ZP"] = (product.reducer);

/***/ }),

/***/ 82025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S0": function() { return /* binding */ fetchBrands; },
/* harmony export */   "vp": function() { return /* binding */ getBrands; }
/* harmony export */ });
/* unused harmony exports requestBrands, successBrands, failureBrands */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);



var initialState = {
  brands: [],
  seo: {},
  loading: false,
  error: null
};
var profile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
  name: 'profile',
  initialState: initialState,
  reducers: {
    requestBrands: function requestBrands(state) {
      state.loading = true;
    },
    successBrands: function successBrands(state, _ref) {
      var payload = _ref.payload;
      state.loading = false;
      state.error = null;
      state.brands = payload === null || payload === void 0 ? void 0 : payload.brands;
      state.seo = (payload === null || payload === void 0 ? void 0 : payload.seo) || {};
    },
    failureBrands: function failureBrands(state, _ref2) {
      var payload = _ref2.payload;
      state.loading = false;
      state.error = payload === null || payload === void 0 ? void 0 : payload.data;
    }
  }
});
var fetchBrands = function fetchBrands() {
  return /*#__PURE__*/function () {
    var _ref4 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState, _ref3) {
      var api, response, result, brands, seo;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref3.api;
              _context.prev = 1;
              dispatch(requestBrands());
              _context.next = 5;
              return api.brands();

            case 5:
              response = _context.sent;
              result = response.result, brands = response.brands, seo = response.seo;

              if (result === 'success') {
                dispatch(successBrands({
                  brands: brands,
                  seo: seo
                }));
              } else {
                dispatch(failureBrands({
                  data: response
                }));
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              dispatch(failureBrands({
                data: _context.t0.toString()
              }));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getBrands = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(function (state) {
  return state.profile;
}, function (profile) {
  return profile.brands;
});
var _profile$actions = profile.actions,
    requestBrands = _profile$actions.requestBrands,
    successBrands = _profile$actions.successBrands,
    failureBrands = _profile$actions.failureBrands;

/* harmony default export */ __webpack_exports__["ZP"] = (profile.reducer);

/***/ }),

/***/ 98029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CB": function() { return /* binding */ newFetchSearchResults; },
/* harmony export */   "GM": function() { return /* binding */ fetchSearchPageResults; },
/* harmony export */   "Im": function() { return /* binding */ getSearchData; },
/* harmony export */   "f_": function() { return /* binding */ getSearchPageData; }
/* harmony export */ });
/* unused harmony exports fetchSearchResults, fetchBarcodeResult, requestSearch, requestNewSearch, successSearch, failureSearch, requestSearchPage, successSearchPage, failureSearchPage, resetSearchPage, resetSearch, requestBarcode, successBarcode, failureBarcode, resetBarcode */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);



var _excluded = ["onSuccess", "onError", "refresh"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var initialState = {
  results: {},
  barcodeResult: null,
  loaded: false,
  loading: false,
  error: null,
  errorPage: null,
  loadingPage: false,
  currentQuery: null,
  data: {}
};
var search = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
  name: 'search',
  initialState: initialState,
  reducers: {
    requestSearch: function requestSearch(state) {
      state.loading = true;
      state.loaded = false;
    },
    requestNewSearch: function requestNewSearch(state) {
      state.loading = true;
    },
    successSearch: function successSearch(state, _ref) {
      var payload = _ref.payload;
      state.results = payload;
      state.loading = false;
      state.loaded = true;
      state.error = null;
    },
    failureSearch: function failureSearch(state, _ref2) {
      var payload = _ref2.payload;
      state.loading = false;
      state.error = payload;
    },
    resetSearch: function resetSearch(state) {
      state.results = [];
      state.loaded = false;
    },
    requestBarcode: function requestBarcode(state) {
      state.loading = true;
      state.loaded = false;
    },
    successBarcode: function successBarcode(state, _ref3) {
      var payload = _ref3.payload;
      state.barcodeResult = payload;
      state.loading = false;
      state.loaded = true;
      state.error = null;
    },
    failureBarcode: function failureBarcode(state, _ref4) {
      var payload = _ref4.payload;
      state.loading = false;
      state.error = payload;
    },
    resetBarcode: function resetBarcode(state) {
      state.barcodeResult = [];
      state.loaded = false;
      state.error = null;
    },
    requestSearchPage: function requestSearchPage(state) {
      state.loadingPage = true;
    },
    successSearchPage: function successSearchPage(state, _ref5) {
      var payload = _ref5.payload;
      var key = payload.key,
          response = payload.response,
          refresh = payload.refresh;
      var data = state.data;
      state.currentQuery = key;

      if (response) {
        var _data$key;

        if (refresh) {
          state.data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, key, response || data[key]);
        } else if (!((_data$key = data[key]) !== null && _data$key !== void 0 && _data$key.result)) {
          state.data[key] = response || data[key];
        }
      }

      state.loadingPage = false;
      state.errorPage = null;
      state.loaded = true;
    },
    failureSearchPage: function failureSearchPage(state, _ref6) {
      var payload = _ref6.payload;
      state.currentQuery = payload.key;
      state.loadingPage = false;
      state.errorPage = payload.response;
      state.loaded = true;
    },
    resetSearchPage: function resetSearchPage(state) {
      state.loaded = false;
      state.data = {};
      state.errorPage = null;
    }
  }
});
var fetchSearchResults = function fetchSearchResults(_ref7) {
  var query = _ref7.query,
      onSuccess = _ref7.onSuccess;
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref8) {
      var api, response, result, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref8.api;
              _context.prev = 1;
              dispatch(requestSearch());
              _context.next = 5;
              return api.search({
                query: query
              });

            case 5:
              response = _context.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                dispatch(successSearch(data));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
              } else {
                dispatch(failureSearch(data));
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              dispatch(failureSearch(_context.t0.toString()));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var newFetchSearchResults = function newFetchSearchResults(_ref10) {
  var query = _ref10.query,
      onSuccess = _ref10.onSuccess;
  return /*#__PURE__*/function () {
    var _ref12 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(dispatch, getState, _ref11) {
      var api, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref11.api;
              _context2.prev = 1;
              dispatch(requestNewSearch());
              _context2.next = 5;
              return api.newSearch({
                q: query
              });

            case 5:
              response = _context2.sent;
              result = response.result, data = response.data;

              if (result === 'success') {
                dispatch(successSearch(data));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
              } else {
                dispatch(failureSearch(data));
              }

              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              dispatch(failureSearch(_context2.t0.toString()));

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 10]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var fetchSearchPageResults = function fetchSearchPageResults(_ref13) {
  var onSuccess = _ref13.onSuccess,
      onError = _ref13.onError,
      _ref13$refresh = _ref13.refresh,
      refresh = _ref13$refresh === void 0 ? false : _ref13$refresh,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref13, _excluded);

  return /*#__PURE__*/function () {
    var _ref15 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(dispatch, getState, _ref14) {
      var api, state, key, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref14.api;
              state = getState().search;
              key = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(params);
              _context3.prev = 3;

              if (!(!refresh && state.data[key])) {
                _context3.next = 9;
                break;
              }

              dispatch(successSearchPage({
                key: key,
                refresh: refresh
              }));
              if (onSuccess) onSuccess(state.data[key]);
              _context3.next = 15;
              break;

            case 9:
              dispatch(requestSearchPage());
              _context3.next = 12;
              return api.searchPage(params);

            case 12:
              response = _context3.sent;
              result = response.result;

              if (result === 'success') {
                dispatch(successSearchPage({
                  response: response,
                  key: key,
                  refresh: refresh
                }));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
              } else {
                dispatch(failureSearchPage({
                  response: response,
                  key: key
                }));
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

            case 15:
              _context3.next = 21;
              break;

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](3);
              dispatch(failureSearchPage({
                response: _context3.t0.toString(),
                key: key
              }));
              onError === null || onError === void 0 ? void 0 : onError(_context3.t0);

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 17]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref15.apply(this, arguments);
    };
  }();
};
var fetchBarcodeResult = function fetchBarcodeResult(_ref16) {
  var _ref16$originalError = _ref16.originalError,
      originalError = _ref16$originalError === void 0 ? false : _ref16$originalError,
      barcode = _ref16.barcode;
  return /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref17) {
      var api, response, result, data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              api = _ref17.api;
              _context4.prev = 1;
              dispatch(requestBarcode());
              _context4.next = 5;
              return api.catalogSearch({
                barcode: barcode
              });

            case 5:
              response = _context4.sent;
              result = response.result, data = response.data;

              if (result === 'success' && (data === null || data === void 0 ? void 0 : data.length) > 0) {
                dispatch(successBarcode(data));
              } else {
                dispatch(failureBarcode('Товар не найден'));
              }

              return _context4.abrupt("return", data);

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](1);
              dispatch(failureBarcode(originalError ? _context4.t0 : _context4.t0.toString()));

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 11]]);
    }));

    return function (_x10, _x11, _x12) {
      return _ref18.apply(this, arguments);
    };
  }();
};
var getSearchData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.search;
}, function (search) {
  return _objectSpread({}, search);
});
var getSearchPageData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function (state) {
  return state.search;
}, function (search) {
  var data = search.data,
      loadingPage = search.loadingPage,
      errorPage = search.errorPage,
      loaded = search.loaded;
  return {
    data: data[search.currentQuery],
    loading: loadingPage,
    loaded: loaded,
    error: errorPage
  };
});
var _search$actions = search.actions,
    requestSearch = _search$actions.requestSearch,
    requestNewSearch = _search$actions.requestNewSearch,
    successSearch = _search$actions.successSearch,
    failureSearch = _search$actions.failureSearch,
    requestSearchPage = _search$actions.requestSearchPage,
    successSearchPage = _search$actions.successSearchPage,
    failureSearchPage = _search$actions.failureSearchPage,
    resetSearchPage = _search$actions.resetSearchPage,
    resetSearch = _search$actions.resetSearch,
    requestBarcode = _search$actions.requestBarcode,
    successBarcode = _search$actions.successBarcode,
    failureBarcode = _search$actions.failureBarcode,
    resetBarcode = _search$actions.resetBarcode;

/* harmony default export */ __webpack_exports__["ZP"] = (search.reducer);

/***/ }),

/***/ 28770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ed": function() { return /* binding */ createSession; },
  "g1": function() { return /* binding */ createSocketId; },
  "V3": function() { return /* binding */ createToken; },
  "ZP": function() { return /* binding */ sessionSlice; },
  "JL": function() { return /* binding */ getRegions; },
  "gP": function() { return /* binding */ getSessionData; },
  "NW": function() { return /* binding */ getSessionSocketId; },
  "YW": function() { return /* binding */ getSessionToken; },
  "Gw": function() { return /* binding */ getSettings; },
  "gy": function() { return /* binding */ removeToken; },
  "TF": function() { return /* binding */ setRegion; },
  "P6": function() { return /* binding */ subscribedChannel; },
  "uL": function() { return /* binding */ successRegionId; },
  "C4": function() { return /* binding */ successSession; }
});

// UNUSED EXPORTS: failureRegions, failureSession, requestSession, requestSessionDone, setSettings, successHashedKey, successRegions, successSocketId, successSubscribedChannel, successToken

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 4 modules
var redux_toolkit_esm = __webpack_require__(35357);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./node_modules/js-base64/base64.mjs
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */
const version = '3.7.2';
/**
 * @deprecated use lowercase `version`.
 */
const VERSION = version;
const _hasatob = typeof atob === 'function';
const _hasbtoa = typeof btoa === 'function';
const _hasBuffer = typeof Buffer === 'function';
const _TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
const _TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
const b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const b64chs = Array.prototype.slice.call(b64ch);
const b64tab = ((a) => {
    let tab = {};
    a.forEach((c, i) => tab[c] = i);
    return tab;
})(b64chs);
const b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const _fromCC = String.fromCharCode.bind(String);
const _U8Afrom = typeof Uint8Array.from === 'function'
    ? Uint8Array.from.bind(Uint8Array)
    : (it, fn = (x) => x) => new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
const _mkUriSafe = (src) => src
    .replace(/=/g, '').replace(/[+\/]/g, (m0) => m0 == '+' ? '-' : '_');
const _tidyB64 = (s) => s.replace(/[^A-Za-z0-9\+\/]/g, '');
/**
 * polyfill version of `btoa`
 */
const btoaPolyfill = (bin) => {
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = '';
    const pad = bin.length % 3;
    for (let i = 0; i < bin.length;) {
        if ((c0 = bin.charCodeAt(i++)) > 255 ||
            (c1 = bin.charCodeAt(i++)) > 255 ||
            (c2 = bin.charCodeAt(i++)) > 255)
            throw new TypeError('invalid character found');
        u32 = (c0 << 16) | (c1 << 8) | c2;
        asc += b64chs[u32 >> 18 & 63]
            + b64chs[u32 >> 12 & 63]
            + b64chs[u32 >> 6 & 63]
            + b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */
const _btoa = _hasbtoa ? (bin) => btoa(bin)
    : _hasBuffer ? (bin) => Buffer.from(bin, 'binary').toString('base64')
        : btoaPolyfill;
const _fromUint8Array = _hasBuffer
    ? (u8a) => Buffer.from(u8a).toString('base64')
    : (u8a) => {
        // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
        const maxargs = 0x1000;
        let strs = [];
        for (let i = 0, l = u8a.length; i < l; i += maxargs) {
            strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
        }
        return _btoa(strs.join(''));
    };
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */
const fromUint8Array = (u8a, urlsafe = false) => urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const cb_utob = (c) => {
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c
            : cc < 0x800 ? (_fromCC(0xc0 | (cc >>> 6))
                + _fromCC(0x80 | (cc & 0x3f)))
                : (_fromCC(0xe0 | ((cc >>> 12) & 0x0f))
                    + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
                    + _fromCC(0x80 | (cc & 0x3f)));
    }
    else {
        var cc = 0x10000
            + (c.charCodeAt(0) - 0xD800) * 0x400
            + (c.charCodeAt(1) - 0xDC00);
        return (_fromCC(0xf0 | ((cc >>> 18) & 0x07))
            + _fromCC(0x80 | ((cc >>> 12) & 0x3f))
            + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
            + _fromCC(0x80 | (cc & 0x3f)));
    }
};
const re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */
const utob = (u) => u.replace(re_utob, cb_utob);
//
const _encode = _hasBuffer
    ? (s) => Buffer.from(s, 'utf8').toString('base64')
    : _TE
        ? (s) => _fromUint8Array(_TE.encode(s))
        : (s) => _btoa(utob(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */
const encode = (src, urlsafe = false) => urlsafe
    ? _mkUriSafe(_encode(src))
    : _encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */
const base64_encodeURI = (src) => encode(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const cb_btou = (cccc) => {
    switch (cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                | ((0x3f & cccc.charCodeAt(1)) << 12)
                | ((0x3f & cccc.charCodeAt(2)) << 6)
                | (0x3f & cccc.charCodeAt(3)), offset = cp - 0x10000;
            return (_fromCC((offset >>> 10) + 0xD800)
                + _fromCC((offset & 0x3FF) + 0xDC00));
        case 3:
            return _fromCC(((0x0f & cccc.charCodeAt(0)) << 12)
                | ((0x3f & cccc.charCodeAt(1)) << 6)
                | (0x3f & cccc.charCodeAt(2)));
        default:
            return _fromCC(((0x1f & cccc.charCodeAt(0)) << 6)
                | (0x3f & cccc.charCodeAt(1)));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */
const btou = (b) => b.replace(re_btou, cb_btou);
/**
 * polyfill version of `atob`
 */
const atobPolyfill = (asc) => {
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!b64re.test(asc))
        throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    let u24, bin = '', r1, r2;
    for (let i = 0; i < asc.length;) {
        u24 = b64tab[asc.charAt(i++)] << 18
            | b64tab[asc.charAt(i++)] << 12
            | (r1 = b64tab[asc.charAt(i++)]) << 6
            | (r2 = b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? _fromCC(u24 >> 16 & 255)
            : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255)
                : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */
const _atob = _hasatob ? (asc) => atob(_tidyB64(asc))
    : _hasBuffer ? (asc) => Buffer.from(asc, 'base64').toString('binary')
        : atobPolyfill;
//
const _toUint8Array = _hasBuffer
    ? (a) => _U8Afrom(Buffer.from(a, 'base64'))
    : (a) => _U8Afrom(_atob(a), c => c.charCodeAt(0));
/**
 * converts a Base64 string to a Uint8Array.
 */
const toUint8Array = (a) => _toUint8Array(_unURI(a));
//
const _decode = _hasBuffer
    ? (a) => Buffer.from(a, 'base64').toString('utf8')
    : _TD
        ? (a) => _TD.decode(_toUint8Array(a))
        : (a) => btou(_atob(a));
const _unURI = (a) => _tidyB64(a.replace(/[-_]/g, (m0) => m0 == '-' ? '+' : '/'));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */
const decode = (src) => _decode(_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */
const isValid = (src) => {
    if (typeof src !== 'string')
        return false;
    const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const _noEnum = (v) => {
    return {
        value: v, enumerable: false, writable: true, configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */
const extendString = function () {
    const _add = (name, body) => Object.defineProperty(String.prototype, name, _noEnum(body));
    _add('fromBase64', function () { return decode(this); });
    _add('toBase64', function (urlsafe) { return encode(this, urlsafe); });
    _add('toBase64URI', function () { return encode(this, true); });
    _add('toBase64URL', function () { return encode(this, true); });
    _add('toUint8Array', function () { return toUint8Array(this); });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */
const extendUint8Array = function () {
    const _add = (name, body) => Object.defineProperty(Uint8Array.prototype, name, _noEnum(body));
    _add('toBase64', function (urlsafe) { return fromUint8Array(this, urlsafe); });
    _add('toBase64URI', function () { return fromUint8Array(this, true); });
    _add('toBase64URL', function () { return fromUint8Array(this, true); });
};
/**
 * extend Builtin prototypes with relevant methods
 */
const extendBuiltins = () => {
    extendString();
    extendUint8Array();
};
const gBase64 = {
    version: version,
    VERSION: VERSION,
    atob: _atob,
    atobPolyfill: atobPolyfill,
    btoa: _btoa,
    btoaPolyfill: btoaPolyfill,
    fromBase64: decode,
    toBase64: encode,
    encode: encode,
    encodeURI: base64_encodeURI,
    encodeURL: base64_encodeURI,
    utob: utob,
    btou: btou,
    decode: decode,
    isValid: isValid,
    fromUint8Array: fromUint8Array,
    toUint8Array: toUint8Array,
    extendString: extendString,
    extendUint8Array: extendUint8Array,
    extendBuiltins: extendBuiltins,
};
// makecjs:CUT //




















// and finally,


;// CONCATENATED MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var initialState = {
  token: null,
  socketId: null,
  hashed_key: null,
  isLoaded: false,
  isSubscribedChannel: false,
  isLoading: false,
  error: null,
  settings: null,
  id: null,
  regions: null,
  regionId: null
};
var tokenStorageKey = 'fh_session_token';
var session = (0,redux_toolkit_esm/* createSlice */.oM)({
  name: 'session',
  initialState: initialState,
  reducers: {
    requestSession: function requestSession(state) {
      state.isLoading = true;
      state.error = null;
    },
    requestSessionDone: function requestSessionDone(state) {
      state.isLoading = false;
    },
    successToken: function successToken(state, _ref) {
      var _payload$token;

      var payload = _ref.payload;
      var token = (_payload$token = payload === null || payload === void 0 ? void 0 : payload.token) !== null && _payload$token !== void 0 ? _payload$token : null;
      state.token = token;
    },
    successSocketId: function successSocketId(state, _ref2) {
      var payload = _ref2.payload;
      var socketId = payload.socketId;
      state.socketId = socketId;
    },
    successSubscribedChannel: function successSubscribedChannel(state, _ref3) {
      var payload = _ref3.payload;
      state.isSubscribedChannel = payload;
    },
    successHashedKey: function successHashedKey(state, _ref4) {
      var _payload$hashed_key;

      var payload = _ref4.payload;
      state.hashed_key = (_payload$hashed_key = payload === null || payload === void 0 ? void 0 : payload.hashed_key) !== null && _payload$hashed_key !== void 0 ? _payload$hashed_key : null;
    },
    successSession: function successSession(state, _ref5) {
      var _payload$region_id;

      var payload = _ref5.payload;
      state.id = payload.id;
      state.regionId = (_payload$region_id = payload.region_id) !== null && _payload$region_id !== void 0 ? _payload$region_id : null;
      state.isLoaded = true;
      state.isLoading = false;
      state.error = null;
    },
    successRegionId: function successRegionId(state, _ref6) {
      var _payload$regionId;

      var payload = _ref6.payload;
      state.regionId = (_payload$regionId = payload === null || payload === void 0 ? void 0 : payload.regionId) !== null && _payload$regionId !== void 0 ? _payload$regionId : null;
    },
    setSettings: function setSettings(state, _ref7) {
      var payload = _ref7.payload;
      state.settings = payload;
    },
    failureSession: function failureSession(state, _ref8) {
      var payload = _ref8.payload;
      state.isLoading = false;
      state.error = payload;
    },
    successRegions: function successRegions(state, _ref9) {
      var payload = _ref9.payload;
      state.regions = payload;
    },
    failureRegions: function failureRegions(state, _ref10) {
      var payload = _ref10.payload;
      state.isLoading = false;
      state.errorRegions = payload;
    }
  }
});
var createToken = function createToken() {
  return /*#__PURE__*/function () {
    var _ref12 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dispatch, getState, _ref11) {
      var storage, tokenGenerator, token, _token, base64Token;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              storage = _ref11.storage, tokenGenerator = _ref11.tokenGenerator;

              if (!getState().session.token) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return storage.get(tokenStorageKey);

            case 5:
              token = _context.sent;

              if (!token) {
                _context.next = 10;
                break;
              }

              dispatch(successToken({
                token: token
              }));
              _context.next = 17;
              break;

            case 10:
              _context.next = 12;
              return tokenGenerator();

            case 12:
              _token = _context.sent;
              base64Token = gBase64.encode(JSON.stringify(_objectSpread(_objectSpread({}, _token), {}, {
                timestamp: new Date().getTime()
              })));
              _context.next = 16;
              return storage.set(tokenStorageKey, base64Token);

            case 16:
              dispatch(successToken({
                token: base64Token
              }));

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var createSocketId = function createSocketId(_ref13) {
  var socketId = _ref13.socketId;
  return /*#__PURE__*/function () {
    var _ref14 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(dispatch, getState) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(successSocketId({
                socketId: socketId
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5) {
      return _ref14.apply(this, arguments);
    };
  }();
};
var subscribedChannel = function subscribedChannel() {
  return /*#__PURE__*/function () {
    var _ref15 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(dispatch, getState) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(successSubscribedChannel(true));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x6, _x7) {
      return _ref15.apply(this, arguments);
    };
  }();
};
var removeToken = function removeToken(_ref16) {
  var onSuccess = _ref16.onSuccess;
  return /*#__PURE__*/function () {
    var _ref18 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(dispatch, getState, _ref17) {
      var storage, tokenGenerator, token, base64Token;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              storage = _ref17.storage, tokenGenerator = _ref17.tokenGenerator;
              _context4.next = 3;
              return tokenGenerator();

            case 3:
              token = _context4.sent;
              base64Token = gBase64.encode(JSON.stringify(_objectSpread(_objectSpread({}, token), {}, {
                timestamp: new Date().getTime()
              })));
              _context4.next = 7;
              return storage.set(tokenStorageKey, base64Token);

            case 7:
              dispatch(successToken({
                token: base64Token
              }));
              if (onSuccess) onSuccess();

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x8, _x9, _x10) {
      return _ref18.apply(this, arguments);
    };
  }();
};
var createSession = function createSession() {
  var withRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var onSuccess = arguments.length > 1 ? arguments[1] : undefined;

  var _ref19 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref19$forceRefresh = _ref19.forceRefresh,
      forceRefresh = _ref19$forceRefresh === void 0 ? false : _ref19$forceRefresh;

  return /*#__PURE__*/function () {
    var _ref21 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(dispatch, getState, _ref20) {
      var api, _getState$session, isLoaded, hashed_key, error, params, response, responseSettings, settings, _session;

      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = _ref20.api;
              _getState$session = getState().session, isLoaded = _getState$session.isLoaded, hashed_key = _getState$session.hashed_key, error = _getState$session.error;

              if (!(!forceRefresh && !withRefresh && isLoaded && !error)) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return");

            case 4:
              _context5.prev = 4;
              dispatch(requestSession());
              params = withRefresh ? {
                refresh: 1
              } : {};

              if (!forceRefresh && hashed_key) {
                params.hashed_key = hashed_key;
              }

              _context5.next = 10;
              return api.getSession(params);

            case 10:
              response = _context5.sent;
              _context5.next = 13;
              return api.getSessionSettings(params);

            case 13:
              responseSettings = _context5.sent;

              // save settings
              if (responseSettings.result === 'success') {
                settings = responseSettings.settings;
                dispatch(setSettings(settings));
              }

              if (response.result === 'success' && responseSettings.result === 'success') {
                _session = response.session;
                dispatch(successSession(_objectSpread({}, _session)));
                dispatch(successHashedKey({
                  hashed_key: response.hashed_key
                }));

                if (onSuccess) {
                  onSuccess(_session.client);
                } // 304 - data wasn't changed, we don't need to save error

              } else if (response.statusCode === 304) {
                dispatch(requestSessionDone());
              } else {
                dispatch(failureSession(response));
              }

              _context5.next = 21;
              break;

            case 18:
              _context5.prev = 18;
              _context5.t0 = _context5["catch"](4);
              dispatch(failureSession(_context5.t0.toString()));

            case 21:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[4, 18]]);
    }));

    return function (_x11, _x12, _x13) {
      return _ref21.apply(this, arguments);
    };
  }();
};
var getRegions = function getRegions(_ref22) {
  var _ref22$refresh = _ref22.refresh,
      refresh = _ref22$refresh === void 0 ? false : _ref22$refresh,
      _ref22$throwError = _ref22.throwError,
      throwError = _ref22$throwError === void 0 ? false : _ref22$throwError;
  return /*#__PURE__*/function () {
    var _ref24 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(dispatch, getState, _ref23) {
      var api, state, response;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              api = _ref23.api;
              _context6.prev = 1;
              state = getState().session;

              if (!(!refresh && state.regions)) {
                _context6.next = 5;
                break;
              }

              return _context6.abrupt("return");

            case 5:
              _context6.next = 7;
              return api.getRegions();

            case 7:
              response = _context6.sent;

              if (response.result === 'success') {
                dispatch(successRegions(response.data || []));
              }

              _context6.next = 16;
              break;

            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](1);
              dispatch(failureRegions(_context6.t0));

              if (!throwError) {
                _context6.next = 16;
                break;
              }

              throw _context6.t0;

            case 16:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 11]]);
    }));

    return function (_x14, _x15, _x16) {
      return _ref24.apply(this, arguments);
    };
  }();
};
var setRegion = function setRegion(_ref25) {
  var regionId = _ref25.regionId,
      onSuccess = _ref25.onSuccess;
  return /*#__PURE__*/function () {
    var _ref27 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(dispatch, getState, _ref26) {
      var api, state, prevRegionId, revertRegion, response;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              api = _ref26.api;
              state = getState().session;
              prevRegionId = state.regionId;

              if (!(prevRegionId === regionId)) {
                _context7.next = 5;
                break;
              }

              return _context7.abrupt("return");

            case 5:
              revertRegion = function revertRegion() {
                dispatch(successRegionId({
                  regionId: prevRegionId
                }));
              };

              _context7.prev = 6;
              dispatch(successRegionId({
                regionId: regionId
              }));
              _context7.next = 10;
              return api.setRegion({
                region_id: regionId
              });

            case 10:
              response = _context7.sent;

              if (response.result !== 'success') {
                revertRegion();
              } else {
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
              }

              _context7.next = 18;
              break;

            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](6);
              revertRegion();
              throw _context7.t0;

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[6, 14]]);
    }));

    return function (_x17, _x18, _x19) {
      return _ref27.apply(this, arguments);
    };
  }();
};
var getSessionToken = (0,es/* createSelector */.P1)(function (state) {
  return state.session;
}, function (session) {
  return session.token;
});
var getSessionSocketId = (0,es/* createSelector */.P1)(function (state) {
  return state.session;
}, function (session) {
  return session.socketId;
});
var getSessionData = (0,es/* createSelector */.P1)(function (state) {
  return state.session;
}, function (session) {
  return session;
});
var getSettings = (0,es/* createSelector */.P1)(function (state) {
  return state.session.settings;
}, function (session) {
  return session;
});
var _session$actions = session.actions,
    requestSession = _session$actions.requestSession,
    requestSessionDone = _session$actions.requestSessionDone,
    successSession = _session$actions.successSession,
    successHashedKey = _session$actions.successHashedKey,
    failureSession = _session$actions.failureSession,
    successToken = _session$actions.successToken,
    setSettings = _session$actions.setSettings,
    successSocketId = _session$actions.successSocketId,
    successSubscribedChannel = _session$actions.successSubscribedChannel,
    successRegionId = _session$actions.successRegionId,
    successRegions = _session$actions.successRegions,
    failureRegions = _session$actions.failureRegions;

/* harmony default export */ var sessionSlice = (session.reducer);

/***/ }),

/***/ 76137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NB": function() { return /* binding */ fetchShops; },
/* harmony export */   "gf": function() { return /* binding */ getShopsData; }
/* harmony export */ });
/* unused harmony exports requestShops, successShops, failureShops */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);



var _excluded = ["result"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var initialState = {
  data: {
    shops: [],
    brands: []
  },
  loaded: false,
  loading: false,
  error: null
};
var shops = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
  name: 'shops',
  initialState: initialState,
  reducers: {
    requestShops: function requestShops(state) {
      state.loading = true;
      state.error = null;
    },
    successShops: function successShops(state, _ref) {
      var payload = _ref.payload;

      var _ref2 = payload || {},
          data = _ref2.data;

      if (data) {
        state.data = data;
      }

      state.loading = false;
      state.loaded = true;
      state.error = null;
    },
    failureShops: function failureShops(state, _ref3) {
      var payload = _ref3.payload;
      var data = payload.data;
      state.loading = false;
      state.error = data;
    }
  }
});
var fetchShops = function fetchShops() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$refresh = _ref4.refresh,
      refresh = _ref4$refresh === void 0 ? false : _ref4$refresh,
      _ref4$errToString = _ref4.errToString,
      errToString = _ref4$errToString === void 0 ? true : _ref4$errToString;

  return /*#__PURE__*/function () {
    var _ref6 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(dispatch, getState, _ref5) {
      var api, _shops, response, _response$result, result, data;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref5.api;
              _context.prev = 1;
              _shops = getState().shops;

              if (!(_shops.loaded && !refresh)) {
                _context.next = 8;
                break;
              }

              dispatch(successShops());
              return _context.abrupt("return");

            case 8:
              dispatch(requestShops());
              _context.next = 11;
              return api.shops();

            case 11:
              response = _context.sent;
              _response$result = response.result, result = _response$result === void 0 ? 'success' : _response$result, data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(response, _excluded);

              if (result === 'success') {
                dispatch(successShops({
                  data: data
                }));
              } else {
                dispatch(failureShops({
                  data: response
                }));
              }

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              dispatch(failureShops({
                data: errToString ? _context.t0.toString() : _context.t0
              }));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var getShopsData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(function (state) {
  return state.shops;
}, function (shops) {
  return _objectSpread({}, shops);
});
var _shops$actions = shops.actions,
    requestShops = _shops$actions.requestShops,
    successShops = _shops$actions.successShops,
    failureShops = _shops$actions.failureShops;

/* harmony default export */ __webpack_exports__["ZP"] = (shops.reducer);

/***/ }),

/***/ 46789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ fetchUserRefunds; },
/* harmony export */   "$y": function() { return /* binding */ getSentRefundInfo; },
/* harmony export */   "At": function() { return /* binding */ addedFavoriteBrand; },
/* harmony export */   "B4": function() { return /* binding */ removeFavoriteBrand; },
/* harmony export */   "C2": function() { return /* binding */ fetchSendRefund; },
/* harmony export */   "Ei": function() { return /* binding */ successLogin; },
/* harmony export */   "G7": function() { return /* binding */ fetchOrder; },
/* harmony export */   "Gi": function() { return /* binding */ fetchRefundInfo; },
/* harmony export */   "HP": function() { return /* binding */ changeReturnableItem; },
/* harmony export */   "JH": function() { return /* binding */ fetchDiscount; },
/* harmony export */   "NF": function() { return /* binding */ removeProfile; },
/* harmony export */   "Sb": function() { return /* binding */ resetProfileError; },
/* harmony export */   "UD": function() { return /* binding */ getRefundInfo; },
/* harmony export */   "Yo": function() { return /* binding */ sendCode; },
/* harmony export */   "ZA": function() { return /* binding */ changeRedirectUrl; },
/* harmony export */   "Zf": function() { return /* binding */ fetchCountriesOfDelivery; },
/* harmony export */   "ck": function() { return /* binding */ updateProfile; },
/* harmony export */   "co": function() { return /* binding */ getOrder; },
/* harmony export */   "dH": function() { return /* binding */ changeBannerState; },
/* harmony export */   "dT": function() { return /* binding */ fetchUserOrders; },
/* harmony export */   "fL": function() { return /* binding */ getDiscount; },
/* harmony export */   "fU": function() { return /* binding */ getUserRefunds; },
/* harmony export */   "h": function() { return /* binding */ fetchReturnableProducts; },
/* harmony export */   "kS": function() { return /* binding */ logout; },
/* harmony export */   "nr": function() { return /* binding */ getAuthData; },
/* harmony export */   "ox": function() { return /* binding */ subscribeByEmail; },
/* harmony export */   "rt": function() { return /* binding */ emailVerify; },
/* harmony export */   "tE": function() { return /* binding */ getIP; },
/* harmony export */   "tJ": function() { return /* binding */ getSubscriptions; },
/* harmony export */   "uI": function() { return /* binding */ getUserOrders; },
/* harmony export */   "v2": function() { return /* binding */ getCountriesOfDelivery; },
/* harmony export */   "x4": function() { return /* binding */ login; },
/* harmony export */   "yJ": function() { return /* binding */ getReturnableProducts; },
/* harmony export */   "zK": function() { return /* binding */ PARAMS; }
/* harmony export */ });
/* unused harmony exports pushToken, deletePushToken, deleteAddress, validateEmail, sendSubscription, validatePhone, requestChangeFavoriteBrands, successChangeFavoriteBrands, failureChangeFavoriteBrands, changeBanner, requestCode, successCode, failureCode, requestCountriesOfDelivery, successCountriesOfDelivery, failureCountriesOfDelivery, requestSendRefund, successSendRefund, failureSendRefund, requestRefundInfo, successRefundInfo, failureRefundInfo, requestReturnableProducts, successReturnableProducts, failureReturnableProducts, resetSendCodeState, requestLogin, failureLogin, requestLogout, successLogout, requestRemoveProfile, successRemoveProfile, failureRemoveProfile, requestDiscount, successDiscount, failureDiscount, failureLogout, requestProfileUpdate, successProfileUpdate, failureProfileUpdate, changeNewProducts, changeNewUserStatus, requestUserOrders, successUserOrders, failureUserOrders, requestUserRefunds, successUserRefunds, failureUserRefunds, requestOrder, successOrder, failureOrder, failureSubscribe, failureValidateEmail, failureValidatePhone, successGotIP */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27812);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68697);
/* harmony import */ var _sessionSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28770);
/* harmony import */ var _checkoutSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10604);





var _extraReducers;

var _excluded = ["mergeResult"],
    _excluded2 = ["mergeResult"],
    _excluded3 = ["mergeResult"],
    _excluded4 = ["onSuccess", "toSHA256"],
    _excluded5 = ["onSuccess"],
    _excluded6 = ["result"],
    _excluded7 = ["mergeResult"],
    _excluded8 = ["mergeResult"],
    _excluded9 = ["mergeResult"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var public_key = 'qlwkxuquiw5xdniuwhx3xx3yygsdT57tyg';

var sha256 = /*#__PURE__*/function () {
  var _ref = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(text) {
    var _ref2,
        toSHA256,
        message,
        msgBuffer,
        hashBuffer,
        hashArray,
        hashHex,
        _args = arguments;

    return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, toSHA256 = _ref2.toSHA256;
            message = public_key + text;

            if (!toSHA256) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", toSHA256(message));

          case 4:
            msgBuffer = new TextEncoder('utf-8').encode(message);
            _context.next = 7;
            return crypto.subtle.digest('SHA-256', msgBuffer);

          case 7:
            hashBuffer = _context.sent;
            hashArray = Array.from(new Uint8Array(hashBuffer));
            hashHex = hashArray.map(function (b) {
              return ('00' + b.toString(16)).slice(-2);
            }).join('');
            return _context.abrupt("return", hashHex);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sha256(_x) {
    return _ref.apply(this, arguments);
  };
}();

var PARAMS = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  PHONE: 'phone',
  EMAIL: 'email',
  SEX: 'sex',
  SEX_WOMEN: 'women',
  SEX_MEN: 'men',
  BIRTHDAY: 'birthday',
  DISCOUNT_CARD: 'discount_card',
  CLOTHING_SIZE: 'clothing_size',
  SHOE_SIZE: 'shoe_size',
  HEIGHT: 'height',
  WEIGHT: 'weight',
  BRAND_IDS: 'brand_ids',
  CURRENCY: 'currency'
};
var initialState = {
  user: null,
  loggedIn: false,
  loggingIn: false,
  loggingOut: false,
  removingProfile: false,
  codeSending: false,
  codeSent: false,
  error: null,
  removingProfileError: null,
  hasBanner: false,
  redirectUrl: {
    href: '/',
    asPath: '/',
    query: {}
  },
  hasNewProducts: false,
  isNewUser: false,
  subscribeError: null,
  emailValidateError: null,
  phoneValidateError: null,
  returnableItem: null,
  hasGotIP: false,
  favoriteBrands: {
    data: [],
    loading: false,
    error: null
  },
  profile: {
    loading: false,
    error: null
  },
  refund: {
    loading: false,
    error: null
  },
  refundInfo: {
    data: null,
    loading: false,
    error: null
  },
  countriesOfDelivery: {
    data: [],
    loading: false,
    error: null
  },
  ordersHistory: {
    data: null,
    loading: false,
    error: null
  },
  refundsHistory: {
    data: null,
    loading: false,
    error: null
  },
  returnableProducts: {
    data: null,
    loading: false,
    error: null
  },
  order: {
    data: null,
    loading: false,
    error: null
  },
  discount: {
    data: null,
    loading: false,
    error: null
  }
};
var user = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
  name: 'user',
  initialState: initialState,
  reducers: {
    requestChangeFavoriteBrands: function requestChangeFavoriteBrands(state) {
      state.favoriteBrands.loading = true;
      state.error = null;
    },
    successChangeFavoriteBrands: function successChangeFavoriteBrands(state, _ref3) {
      var payload = _ref3.payload;
      state.favoriteBrands.data = payload;
      state.favoriteBrands.loading = false;
      state.error = null;
    },
    failureChangeFavoriteBrands: function failureChangeFavoriteBrands(state, _ref4) {
      var payload = _ref4.payload;
      state.favoriteBrands.loading = false;
      state.error = payload;
    },
    requestCode: function requestCode(state) {
      state.codeSending = true;
      state.error = null;
    },
    successCode: function successCode(state) {
      state.codeSending = false;
      state.codeSent = true;
      state.error = null;
    },
    failureCode: function failureCode(state, _ref5) {
      var payload = _ref5.payload;
      state.codeSending = false;
      state.codeSent = false;
      state.error = payload;
    },
    resetSendCodeState: function resetSendCodeState(state) {
      state.codeSent = false;
    },
    requestLogin: function requestLogin(state) {
      state.loggingIn = true;
    },
    successLogin: function successLogin(state, _ref6) {
      var payload = _ref6.payload;
      var user = payload === null || payload === void 0 ? void 0 : payload.client;
      state.user = user;
      state.favoriteBrands.data = payload.favorite_brands;
      state.loggingIn = false;
      state.loggedIn = true;
      state.error = null;
    },
    failureLogin: function failureLogin(state, _ref7) {
      var payload = _ref7.payload;
      state.loggingIn = false;
      state.error = payload;
    },
    requestLogout: function requestLogout(state) {
      state.loggingOut = true;
    },
    successLogout: function successLogout(state) {
      state.user = null;
      state.loggedIn = false;
      state.loggingOut = false;
    },
    failureLogout: function failureLogout(state, _ref8) {
      var payload = _ref8.payload;
      state.loggingOut = false;
      state.error = payload;
    },
    requestRemoveProfile: function requestRemoveProfile(state) {
      state.removingProfile = true;
    },
    successRemoveProfile: function successRemoveProfile(state) {
      state.removingProfile = false;
    },
    failureRemoveProfile: function failureRemoveProfile(state, _ref9) {
      var payload = _ref9.payload;
      state.removingProfile = false;
      state.removingProfileError = payload;
    },
    changeRedirectUrl: function changeRedirectUrl(state, _ref10) {
      var payload = _ref10.payload;
      state.redirectUrl = payload || {
        href: '/',
        asPath: '/',
        query: {}
      };
    },
    changeReturnableItem: function changeReturnableItem(state, _ref11) {
      var payload = _ref11.payload;
      state.returnableItem = payload ? payload : null;
    },
    requestProfileUpdate: function requestProfileUpdate(state) {
      state.profile.loading = true;
      state.profile.error = null;
    },
    successProfileUpdate: function successProfileUpdate(state, _ref12) {
      var payload = _ref12.payload;
      state.user = payload.user;
      state.profile.loading = false;
      state.profile.error = null;
    },
    failureProfileUpdate: function failureProfileUpdate(state, _ref13) {
      var payload = _ref13.payload;
      state.profile.loading = false;
      state.profile.error = payload;
    },
    changeNewProducts: function changeNewProducts(state, _ref14) {
      var payload = _ref14.payload;
      state.hasNewProducts = payload;
    },
    changeNewUserStatus: function changeNewUserStatus(state, _ref15) {
      var payload = _ref15.payload;
      state.isNewUser = payload;
    },
    requestUserOrders: function requestUserOrders(state) {
      state.ordersHistory.loading = true;
      state.ordersHistory.error = null;
    },
    successUserOrders: function successUserOrders(state, _ref16) {
      var payload = _ref16.payload;

      if (payload) {
        var _payload$mergeResult = payload.mergeResult,
            mergeResult = _payload$mergeResult === void 0 ? false : _payload$mergeResult,
            data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(payload, _excluded);

        if (mergeResult) {
          var _state$ordersHistory, _state$ordersHistory$;

          var mergedItems = [].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(((_state$ordersHistory = state.ordersHistory) === null || _state$ordersHistory === void 0 ? void 0 : (_state$ordersHistory$ = _state$ordersHistory.data) === null || _state$ordersHistory$ === void 0 ? void 0 : _state$ordersHistory$.data) || []), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((data === null || data === void 0 ? void 0 : data.data) || []));
          state.ordersHistory.data = _objectSpread(_objectSpread({}, data), {}, {
            data: mergedItems
          });
        } else {
          state.ordersHistory.data = data;
        }
      }

      state.ordersHistory.loading = false;
      state.ordersHistory.error = null;
    },
    failureUserOrders: function failureUserOrders(state, _ref17) {
      var payload = _ref17.payload;
      state.ordersHistory.loading = false;
      state.ordersHistory.error = payload;
    },
    requestUserRefunds: function requestUserRefunds(state) {
      state.refundsHistory.loading = true;
      state.refundsHistory.error = null;
    },
    successUserRefunds: function successUserRefunds(state, _ref18) {
      var payload = _ref18.payload;

      if (payload) {
        var _payload$mergeResult2 = payload.mergeResult,
            mergeResult = _payload$mergeResult2 === void 0 ? false : _payload$mergeResult2,
            data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(payload, _excluded2);

        if (mergeResult) {
          var _state$refundsHistory, _state$refundsHistory2;

          var mergedItems = [].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(((_state$refundsHistory = state.refundsHistory) === null || _state$refundsHistory === void 0 ? void 0 : (_state$refundsHistory2 = _state$refundsHistory.data) === null || _state$refundsHistory2 === void 0 ? void 0 : _state$refundsHistory2.data) || []), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((data === null || data === void 0 ? void 0 : data.data) || []));
          state.refundsHistory.data = _objectSpread(_objectSpread({}, data), {}, {
            data: mergedItems
          });
        } else {
          state.refundsHistory.data = data;
        }
      }

      state.refundsHistory.loading = false;
      state.refundsHistory.error = null;
    },
    failureUserRefunds: function failureUserRefunds(state, _ref19) {
      var payload = _ref19.payload;
      state.refundsHistory.loading = false;
      state.refundsHistory.error = payload;
    },
    requestReturnableProducts: function requestReturnableProducts(state) {
      state.returnableProducts.loading = true;
      state.returnableProducts.error = null;
    },
    successReturnableProducts: function successReturnableProducts(state, _ref20) {
      var payload = _ref20.payload;

      if (payload) {
        var _payload$mergeResult3 = payload.mergeResult,
            mergeResult = _payload$mergeResult3 === void 0 ? false : _payload$mergeResult3,
            data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(payload, _excluded3);

        if (mergeResult) {
          var _state$returnableProd, _state$returnableProd2;

          var mergedItems = [].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(((_state$returnableProd = state.returnableProducts) === null || _state$returnableProd === void 0 ? void 0 : (_state$returnableProd2 = _state$returnableProd.data) === null || _state$returnableProd2 === void 0 ? void 0 : _state$returnableProd2.data) || []), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((data === null || data === void 0 ? void 0 : data.data) || []));
          state.returnableProducts.data = _objectSpread(_objectSpread({}, data), {}, {
            data: mergedItems
          });
        } else {
          state.returnableProducts.data = data;
        }
      }

      state.returnableProducts.loading = false;
      state.returnableProducts.error = null;
    },
    failureReturnableProducts: function failureReturnableProducts(state, _ref21) {
      var payload = _ref21.payload;
      state.returnableProducts.loading = false;
      state.returnableProducts.error = payload;
    },
    requestSendRefund: function requestSendRefund(state) {
      state.refund.loading = true;
    },
    successSendRefund: function successSendRefund(state, _ref22) {
      var payload = _ref22.payload;
      state.refund.loading = false;
      state.refund.error = null;
    },
    failureSendRefund: function failureSendRefund(state, _ref23) {
      var payload = _ref23.payload;
      state.refund.loading = false;
      state.refund.error = payload;
    },
    requestCountriesOfDelivery: function requestCountriesOfDelivery(state) {
      state.countriesOfDelivery.loading = true;
      state.countriesOfDelivery.error = null;
    },
    successCountriesOfDelivery: function successCountriesOfDelivery(state, _ref24) {
      var payload = _ref24.payload;
      state.countriesOfDelivery.data = payload;
      state.countriesOfDelivery.loading = false;
      state.countriesOfDelivery.error = null;
    },
    failureCountriesOfDelivery: function failureCountriesOfDelivery(state, _ref25) {
      var payload = _ref25.payload;
      state.countriesOfDelivery.loading = false;
      state.countriesOfDelivery.error = payload;
    },
    requestRefundInfo: function requestRefundInfo(state) {
      state.refundInfo.loading = true;
    },
    successRefundInfo: function successRefundInfo(state, _ref26) {
      var payload = _ref26.payload;

      if (payload) {
        state.refundInfo.data = payload;
      }

      state.refundInfo.loading = false;
      state.refundInfo.error = null;
    },
    failureRefundInfo: function failureRefundInfo(state, _ref27) {
      var payload = _ref27.payload;
      state.refundInfo.data = null;
      state.refundInfo.loading = false;
      state.refundInfo.error = payload;
    },
    requestOrder: function requestOrder(state) {
      state.order.loading = true;
      state.order.error = null;
    },
    successOrder: function successOrder(state, _ref28) {
      var payload = _ref28.payload;

      if (payload) {
        state.order.data = payload;
      }

      state.order.loading = false;
      state.order.error = null;
    },
    failureOrder: function failureOrder(state, _ref29) {
      var payload = _ref29.payload;
      state.order.data = null;
      state.order.loading = false;
      state.order.error = payload;
    },
    successGotIP: function successGotIP(state) {
      state.hasGotIP = true;
    },
    failureSubscribe: function failureSubscribe(state, _ref30) {
      var payload = _ref30.payload;
      state.subscribeError = payload;
    },
    failureValidateEmail: function failureValidateEmail(state, _ref31) {
      var payload = _ref31.payload;
      state.emailValidateError = payload;
    },
    failureValidatePhone: function failureValidatePhone(state, _ref32) {
      var payload = _ref32.payload;
      state.phoneValidateError = payload;
    },
    resetProfileError: function resetProfileError(state) {
      state.profile.error = null;
    },
    requestDiscount: function requestDiscount(state) {
      state.discount.loading = true;
      state.discount.error = null;
    },
    successDiscount: function successDiscount(state, _ref33) {
      var payload = _ref33.payload;

      if (payload) {
        state.discount.data = payload;
      }

      state.discount.loading = false;
      state.discount.error = null;
    },
    failureDiscount: function failureDiscount(state, _ref34) {
      var payload = _ref34.payload;
      state.discount.data = null;
      state.discount.loading = false;
      state.discount.error = payload;
    },
    changeBanner: function changeBanner(state, _ref35) {
      var payload = _ref35.payload;
      state.hasBanner = payload;
    }
  },
  extraReducers: (_extraReducers = {}, (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_extraReducers, _sessionSlice__WEBPACK_IMPORTED_MODULE_2__/* .successSession */ .C4, function (state, _ref36) {
    var _payload$client, _payload$favorite_bra;

    var payload = _ref36.payload;
    var client = (_payload$client = payload === null || payload === void 0 ? void 0 : payload.client) !== null && _payload$client !== void 0 ? _payload$client : null;
    var favoriteBrands = (_payload$favorite_bra = payload === null || payload === void 0 ? void 0 : payload.favorite_brands) !== null && _payload$favorite_bra !== void 0 ? _payload$favorite_bra : null;

    if (client) {
      state.user = client;
      state.loggedIn = true;
    }

    if (favoriteBrands) {
      state.favoriteBrands.data = favoriteBrands;
    }
  }), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_extraReducers, _checkoutSlice__WEBPACK_IMPORTED_MODULE_3__/* .successOrderCreate */ .nK, function (state, _ref37) {
    var _payload$client2, _payload$cleanOrders;

    var payload = _ref37.payload;
    var client = (_payload$client2 = payload === null || payload === void 0 ? void 0 : payload.client) !== null && _payload$client2 !== void 0 ? _payload$client2 : null;
    var cleanOrders = (_payload$cleanOrders = payload === null || payload === void 0 ? void 0 : payload.cleanOrders) !== null && _payload$cleanOrders !== void 0 ? _payload$cleanOrders : true;

    if (client) {
      state.user = client;
    }

    if (cleanOrders) {
      state.ordersHistory.data = null;
    }
  }), _extraReducers)
});
var sendCode = function sendCode(_ref38) {
  var onSuccess = _ref38.onSuccess,
      toSHA256 = _ref38.toSHA256,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref38, _excluded4);

  return /*#__PURE__*/function () {
    var _ref40 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(dispatch, getState, _ref39) {
      var api, hash, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref39.api;
              dispatch(requestCode());
              _context2.next = 4;
              return sha256(params.phone, {
                toSHA256: toSHA256
              });

            case 4:
              hash = _context2.sent;
              _context2.next = 7;
              return api.sendSmsCode(_objectSpread(_objectSpread({}, params), {}, {
                hash: hash
              }));

            case 7:
              response = _context2.sent;
              result = response.result;

              if (result === 'success') {
                dispatch(successCode());
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureCode(response));
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3, _x4) {
      return _ref40.apply(this, arguments);
    };
  }();
};
var login = function login(_ref41) {
  var onSuccess = _ref41.onSuccess,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref41, _excluded5);

  return /*#__PURE__*/function () {
    var _ref43 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(dispatch, getState, _ref42) {
      var api, response, result, _response$hasNewProdu, _response$registered, hasNewProducts, isNewUser, session;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref42.api;
              dispatch(requestLogin());
              _context3.next = 4;
              return api.login(params);

            case 4:
              response = _context3.sent;
              result = response.result;

              if (result === 'success') {
                hasNewProducts = (_response$hasNewProdu = response === null || response === void 0 ? void 0 : response.hasNewProducts) !== null && _response$hasNewProdu !== void 0 ? _response$hasNewProdu : false;
                isNewUser = (_response$registered = response === null || response === void 0 ? void 0 : response.registered) !== null && _response$registered !== void 0 ? _response$registered : false;
                session = response.session;
                dispatch(changeNewProducts(hasNewProducts));
                dispatch(changeNewUserStatus(isNewUser));
                dispatch((0,_sessionSlice__WEBPACK_IMPORTED_MODULE_2__/* .successRegionId */ .uL)({
                  regionId: session.region_id
                }));
                dispatch(successLogin(session));
                if (onSuccess) onSuccess({
                  isNewUser: isNewUser,
                  hasNewProducts: hasNewProducts,
                  user: session.client
                });
              } else {
                dispatch(failureLogin(response));
              }

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5, _x6, _x7) {
      return _ref43.apply(this, arguments);
    };
  }();
};
var pushToken = function pushToken(params) {
  return /*#__PURE__*/function () {
    var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref44) {
      var api, response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              api = _ref44.api;
              _context4.prev = 1;
              _context4.next = 4;
              return api.pushToken(params);

            case 4:
              response = _context4.sent;
              _context4.next = 9;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](1);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 7]]);
    }));

    return function (_x8, _x9, _x10) {
      return _ref45.apply(this, arguments);
    };
  }();
};
var getIP = function getIP() {
  return /*#__PURE__*/function () {
    var _ref47 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5(dispatch, getState, _ref46) {
      var api;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = _ref46.api;
              dispatch(successGotIP());

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x11, _x12, _x13) {
      return _ref47.apply(this, arguments);
    };
  }();
};
var deletePushToken = function deletePushToken(params) {
  return /*#__PURE__*/function () {
    var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState, _ref48) {
      var api, response;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              api = _ref48.api;
              _context6.prev = 1;
              _context6.next = 4;
              return api.deletePushToken(params);

            case 4:
              response = _context6.sent;
              _context6.next = 9;
              break;

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](1);

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 7]]);
    }));

    return function (_x14, _x15, _x16) {
      return _ref49.apply(this, arguments);
    };
  }();
};
var logout = function logout(onSuccess, onError) {
  return /*#__PURE__*/function () {
    var _ref51 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee7(dispatch, getState, _ref50) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              api = _ref50.api;
              dispatch(requestLogout());
              _context7.next = 4;
              return api.logout();

            case 4:
              response = _context7.sent;
              result = response.result;

              if (result === 'success') {
                dispatch(successLogout());
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureLogout(response));
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x17, _x18, _x19) {
      return _ref51.apply(this, arguments);
    };
  }();
};
var removeProfile = function removeProfile() {
  var _ref52 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onSuccess = _ref52.onSuccess,
      onError = _ref52.onError;

  return /*#__PURE__*/function () {
    var _ref54 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee8(dispatch, getState, _ref53) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              api = _ref53.api;
              dispatch(requestRemoveProfile());
              _context8.next = 4;
              return api.removeProfile();

            case 4:
              response = _context8.sent;
              result = response.result;

              if (result === 'success') {
                dispatch(successRemoveProfile());
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
              } else {
                dispatch(failureRemoveProfile(response));
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x20, _x21, _x22) {
      return _ref54.apply(this, arguments);
    };
  }();
};
var updateProfile = function updateProfile(_ref55) {
  var params = _ref55.params,
      onSuccess = _ref55.onSuccess,
      onError = _ref55.onError;
  return /*#__PURE__*/function () {
    var _ref57 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee9(dispatch, getState, _ref56) {
      var api, response, result, data, _user;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              api = _ref56.api;
              _context9.prev = 1;
              dispatch(requestProfileUpdate());
              _context9.next = 5;
              return api.userProfileUpdate(params);

            case 5:
              response = _context9.sent;
              result = response.result, data = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(response, _excluded6);

              if (result === 'success') {
                _user = response.client;
                dispatch(successProfileUpdate({
                  user: _user
                }));
                onSuccess && onSuccess(_user);
              } else {
                dispatch(failureProfileUpdate(response));
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

              _context9.next = 14;
              break;

            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9["catch"](1);
              dispatch(failureProfileUpdate(_context9.t0.toString()));
              onError === null || onError === void 0 ? void 0 : onError(_context9.t0);

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[1, 10]]);
    }));

    return function (_x23, _x24, _x25) {
      return _ref57.apply(this, arguments);
    };
  }();
};
var emailVerify = function emailVerify(_ref58) {
  var _ref58$onSuccess = _ref58.onSuccess,
      onSuccess = _ref58$onSuccess === void 0 ? null : _ref58$onSuccess,
      _ref58$onError = _ref58.onError,
      onError = _ref58$onError === void 0 ? null : _ref58$onError;
  return /*#__PURE__*/function () {
    var _ref60 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee10(dispatch, getState, _ref59) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              api = _ref59.api;
              _context10.prev = 1;
              _context10.next = 4;
              return api.emailVerify();

            case 4:
              response = _context10.sent;
              result = response.result;

              if (result === 'success') {
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
              } else {
                onError === null || onError === void 0 ? void 0 : onError(response);
              }

              _context10.next = 12;
              break;

            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10["catch"](1);
              onError === null || onError === void 0 ? void 0 : onError(_context10.t0);

            case 12:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[1, 9]]);
    }));

    return function (_x26, _x27, _x28) {
      return _ref60.apply(this, arguments);
    };
  }();
};
var deleteAddress = function deleteAddress(params) {
  return /*#__PURE__*/function () {
    var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dispatch, getState, _ref61) {
      var api, response, result, _user2;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              api = _ref61.api;
              _context11.prev = 1;
              _context11.next = 4;
              return api.addressDelete(params);

            case 4:
              response = _context11.sent;
              result = response.result;

              if (result === 'success') {
                _user2 = response.client;
                dispatch(successProfileUpdate({
                  user: _user2
                }));
              } else {
                dispatch(failureProfileUpdate(response));
              }

              _context11.next = 12;
              break;

            case 9:
              _context11.prev = 9;
              _context11.t0 = _context11["catch"](1);
              dispatch(failureProfileUpdate(_context11.t0.toString()));

            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[1, 9]]);
    }));

    return function (_x29, _x30, _x31) {
      return _ref62.apply(this, arguments);
    };
  }();
};
var subscribeByEmail = function subscribeByEmail(_ref63) {
  var email = _ref63.email,
      mindboxDeviceUUID = _ref63.mindboxDeviceUUID,
      onSuccess = _ref63.onSuccess;
  return /*#__PURE__*/function () {
    var _ref65 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee12(dispatch, getState, _ref64) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              api = _ref64.api;
              _context12.prev = 1;
              _context12.next = 4;
              return api.subscribeByEmail({
                email: email,
                mindboxDeviceUUID: mindboxDeviceUUID
              });

            case 4:
              response = _context12.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureSubscribe(response));
              }

              _context12.next = 12;
              break;

            case 9:
              _context12.prev = 9;
              _context12.t0 = _context12["catch"](1);
              dispatch(failureSubscribe(_context12.t0.toString()));

            case 12:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[1, 9]]);
    }));

    return function (_x32, _x33, _x34) {
      return _ref65.apply(this, arguments);
    };
  }();
};
var validateEmail = function validateEmail(_ref66) {
  var email = _ref66.email,
      onSuccess = _ref66.onSuccess;
  return /*#__PURE__*/function () {
    var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(dispatch, getState, _ref67) {
      var api, response, result;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              api = _ref67.api;
              _context13.prev = 1;
              _context13.next = 4;
              return api.emailValidate({
                email: email
              });

            case 4:
              response = _context13.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                dispatch(failureValidateEmail(null));
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureValidateEmail(response));
              }

              _context13.next = 12;
              break;

            case 9:
              _context13.prev = 9;
              _context13.t0 = _context13["catch"](1);
              dispatch(failureValidateEmail(_context13.t0.toString()));

            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[1, 9]]);
    }));

    return function (_x35, _x36, _x37) {
      return _ref68.apply(this, arguments);
    };
  }();
};
var sendSubscription = function sendSubscription(_ref69) {
  var data = _ref69.data,
      onSuccess = _ref69.onSuccess,
      onError = _ref69.onError;
  return /*#__PURE__*/function () {
    var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(dispatch, getState, _ref70) {
      var api, response, result;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              api = _ref70.api;
              _context14.prev = 1;
              _context14.next = 4;
              return api.subscriptionsSubscribe(data);

            case 4:
              response = _context14.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                if (onSuccess) onSuccess();
              } else {
                if (onError) onError(response === null || response === void 0 ? void 0 : response.errors);
              }

              _context14.next = 12;
              break;

            case 9:
              _context14.prev = 9;
              _context14.t0 = _context14["catch"](1);
              onError();

            case 12:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[1, 9]]);
    }));

    return function (_x38, _x39, _x40) {
      return _ref71.apply(this, arguments);
    };
  }();
};
var getSubscriptions = function getSubscriptions(_ref72) {
  var _ref72$originalError = _ref72.originalError,
      originalError = _ref72$originalError === void 0 ? false : _ref72$originalError,
      onSuccess = _ref72.onSuccess,
      onError = _ref72.onError;
  return /*#__PURE__*/function () {
    var _ref74 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee15(dispatch, getState, _ref73) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              api = _ref73.api;
              _context15.prev = 1;
              _context15.next = 4;
              return api.profileSubscriptions();

            case 4:
              response = _context15.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                if (onSuccess) onSuccess(response === null || response === void 0 ? void 0 : response.data);
              } else {
                if (onError) onError(originalError ? response : response === null || response === void 0 ? void 0 : response.errors);
              }

              _context15.next = 12;
              break;

            case 9:
              _context15.prev = 9;
              _context15.t0 = _context15["catch"](1);
              if (onError) onError();

            case 12:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[1, 9]]);
    }));

    return function (_x41, _x42, _x43) {
      return _ref74.apply(this, arguments);
    };
  }();
};
var validatePhone = function validatePhone(_ref75) {
  var phone = _ref75.phone,
      onSuccess = _ref75.onSuccess;
  return /*#__PURE__*/function () {
    var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(dispatch, getState, _ref76) {
      var api, response, result;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              api = _ref76.api;
              _context16.prev = 1;
              _context16.next = 4;
              return api.phoneValidate({
                phone: phone
              });

            case 4:
              response = _context16.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                dispatch(failureValidatePhone(null));
                if (onSuccess) onSuccess();
              } else {
                dispatch(failureValidatePhone(response));
              }

              _context16.next = 12;
              break;

            case 9:
              _context16.prev = 9;
              _context16.t0 = _context16["catch"](1);
              dispatch(failureValidatePhone(_context16.t0.toString()));

            case 12:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, null, [[1, 9]]);
    }));

    return function (_x44, _x45, _x46) {
      return _ref77.apply(this, arguments);
    };
  }();
};
var changeBannerState = function changeBannerState(newState) {
  return function (dispatch) {
    dispatch(changeBanner(newState));
  };
};
var fetchUserOrders = function fetchUserOrders() {
  var _ref78 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mergeResult = _ref78.mergeResult,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref78, _excluded7);

  return /*#__PURE__*/function () {
    var _ref80 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee17(dispatch, getState, _ref79) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              api = _ref79.api;
              _context17.prev = 1;
              dispatch(requestUserOrders());
              _context17.next = 5;
              return api.userOrders(params);

            case 5:
              response = _context17.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                dispatch(successUserOrders(_objectSpread(_objectSpread({}, response), {}, {
                  mergeResult: mergeResult
                })));
              } else {
                dispatch(failureUserOrders(response));
              }

              _context17.next = 13;
              break;

            case 10:
              _context17.prev = 10;
              _context17.t0 = _context17["catch"](1);
              dispatch(failureUserOrders(_context17.t0.toString()));

            case 13:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, null, [[1, 10]]);
    }));

    return function (_x47, _x48, _x49) {
      return _ref80.apply(this, arguments);
    };
  }();
};
var fetchOrder = function fetchOrder(params) {
  return /*#__PURE__*/function () {
    var _ref82 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee18(dispatch, _getState, _ref81) {
      var api, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              api = _ref81.api;
              _context18.prev = 1;
              dispatch(requestOrder());
              _context18.next = 5;
              return api.userOrder(params);

            case 5:
              response = _context18.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                data = response.data;
                dispatch(successOrder(data));
              } else {
                dispatch(failureOrder(response));
              }

              _context18.next = 13;
              break;

            case 10:
              _context18.prev = 10;
              _context18.t0 = _context18["catch"](1);
              dispatch(failureOrder(_context18.t0.toString()));

            case 13:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, null, [[1, 10]]);
    }));

    return function (_x50, _x51, _x52) {
      return _ref82.apply(this, arguments);
    };
  }();
};
var fetchDiscount = function fetchDiscount() {
  return /*#__PURE__*/function () {
    var _ref84 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee19(dispatch, _getState, _ref83) {
      var api, response, result, discount;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              api = _ref83.api;
              _context19.prev = 1;
              dispatch(requestDiscount());
              _context19.next = 5;
              return api.userDiscount();

            case 5:
              response = _context19.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                discount = response.discount;
                dispatch(successDiscount(discount));
              } else {
                dispatch(failureDiscount(response));
              }

              _context19.next = 13;
              break;

            case 10:
              _context19.prev = 10;
              _context19.t0 = _context19["catch"](1);
              dispatch(failureDiscount(_context19.t0.toString()));

            case 13:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, null, [[1, 10]]);
    }));

    return function (_x53, _x54, _x55) {
      return _ref84.apply(this, arguments);
    };
  }();
};
var fetchUserRefunds = function fetchUserRefunds() {
  var _ref85 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mergeResult = _ref85.mergeResult,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref85, _excluded8);

  return /*#__PURE__*/function () {
    var _ref87 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee20(dispatch, getState, _ref86) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              api = _ref86.api;
              _context20.prev = 1;
              dispatch(requestUserRefunds());
              _context20.next = 5;
              return api.userRefunds(params);

            case 5:
              response = _context20.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                dispatch(successUserRefunds(_objectSpread(_objectSpread({}, response), {}, {
                  mergeResult: mergeResult
                })));
              } else {
                dispatch(failureUserRefunds(response));
              }

              _context20.next = 13;
              break;

            case 10:
              _context20.prev = 10;
              _context20.t0 = _context20["catch"](1);
              dispatch(failureUserRefunds(_context20.t0.toString()));

            case 13:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, null, [[1, 10]]);
    }));

    return function (_x56, _x57, _x58) {
      return _ref87.apply(this, arguments);
    };
  }();
};
var fetchReturnableProducts = function fetchReturnableProducts() {
  var _ref88 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mergeResult = _ref88.mergeResult,
      params = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref88, _excluded9);

  return /*#__PURE__*/function () {
    var _ref90 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee21(dispatch, getState, _ref89) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              api = _ref89.api;
              _context21.prev = 1;
              dispatch(requestReturnableProducts());
              _context21.next = 5;
              return api.returnableProducts(params);

            case 5:
              response = _context21.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                dispatch(successReturnableProducts(_objectSpread(_objectSpread({}, response), {}, {
                  mergeResult: mergeResult
                })));
              } else {
                dispatch(failureReturnableProducts(response));
              }

              _context21.next = 13;
              break;

            case 10:
              _context21.prev = 10;
              _context21.t0 = _context21["catch"](1);
              dispatch(failureReturnableProducts(_context21.t0.toString()));

            case 13:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, null, [[1, 10]]);
    }));

    return function (_x59, _x60, _x61) {
      return _ref90.apply(this, arguments);
    };
  }();
};
var fetchSendRefund = function fetchSendRefund(_ref91) {
  var params = _ref91.params,
      onSuccess = _ref91.onSuccess,
      onError = _ref91.onError;
  return /*#__PURE__*/function () {
    var _ref93 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee22(dispatch, getState, _ref92) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              api = _ref92.api;
              _context22.prev = 1;
              dispatch(requestSendRefund());
              _context22.next = 5;
              return api.sendRefund(params);

            case 5:
              response = _context22.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                dispatch(successSendRefund());
                if (onSuccess) onSuccess(response.data.hash);
              } else {
                if (onError) onError();
                dispatch(failureSendRefund(response));
              }

              _context22.next = 14;
              break;

            case 10:
              _context22.prev = 10;
              _context22.t0 = _context22["catch"](1);
              if (onError) onError();
              dispatch(failureSendRefund(_context22.t0.toString()));

            case 14:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, null, [[1, 10]]);
    }));

    return function (_x62, _x63, _x64) {
      return _ref93.apply(this, arguments);
    };
  }();
};
var fetchRefundInfo = function fetchRefundInfo(_ref94) {
  var hash = _ref94.hash;
  return /*#__PURE__*/function () {
    var _ref96 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee23(dispatch, getState, _ref95) {
      var api, response, result;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              api = _ref95.api;
              _context23.prev = 1;
              dispatch(requestRefundInfo());
              _context23.next = 5;
              return api.refundInfo({
                inlineSlug: hash
              });

            case 5:
              response = _context23.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                dispatch(successRefundInfo({
                  data: response.data,
                  products: response.products
                }));
              } else {
                dispatch(failureRefundInfo(response));
              }

              _context23.next = 13;
              break;

            case 10:
              _context23.prev = 10;
              _context23.t0 = _context23["catch"](1);
              dispatch(failureRefundInfo(_context23.t0.toString()));

            case 13:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, null, [[1, 10]]);
    }));

    return function (_x65, _x66, _x67) {
      return _ref96.apply(this, arguments);
    };
  }();
};
var fetchCountriesOfDelivery = function fetchCountriesOfDelivery() {
  return /*#__PURE__*/function () {
    var _ref98 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee24(dispatch, getState, _ref97) {
      var api, state, response, result, data;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              api = _ref97.api;
              state = getState().user.countriesOfDelivery;
              _context24.prev = 2;

              if (state.data.length) {
                _context24.next = 10;
                break;
              }

              dispatch(requestCountriesOfDelivery());
              _context24.next = 7;
              return api.countriesOfDelivery();

            case 7:
              response = _context24.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                data = response.data;
                dispatch(successCountriesOfDelivery(data));
              } else {
                dispatch(failureCountriesOfDelivery(response));
              }

            case 10:
              _context24.next = 15;
              break;

            case 12:
              _context24.prev = 12;
              _context24.t0 = _context24["catch"](2);
              dispatch(failureCountriesOfDelivery(_context24.t0.toString()));

            case 15:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, null, [[2, 12]]);
    }));

    return function (_x68, _x69, _x70) {
      return _ref98.apply(this, arguments);
    };
  }();
};
var addedFavoriteBrand = function addedFavoriteBrand(_ref99) {
  var params = _ref99.params,
      onSuccess = _ref99.onSuccess,
      onError = _ref99.onError;
  return /*#__PURE__*/function () {
    var _ref101 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee25(dispatch, getState, _ref100) {
      var api, response, result, prevData;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              api = _ref100.api;
              _context25.prev = 1;
              dispatch(requestChangeFavoriteBrands());
              _context25.next = 5;
              return api.createFavoriteBrand(params);

            case 5:
              response = _context25.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                prevData = getState().user.favoriteBrands.data;
                dispatch(successChangeFavoriteBrands([].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(prevData), [response.data[0].brand_id])));
                if (onSuccess) onSuccess();
              } else {
                if (onError) onError();
                dispatch(failureChangeFavoriteBrands(response));
              }

              _context25.next = 14;
              break;

            case 10:
              _context25.prev = 10;
              _context25.t0 = _context25["catch"](1);
              if (onError) onError();
              dispatch(failureChangeFavoriteBrands(_context25.t0.toString()));

            case 14:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, null, [[1, 10]]);
    }));

    return function (_x71, _x72, _x73) {
      return _ref101.apply(this, arguments);
    };
  }();
};
var removeFavoriteBrand = function removeFavoriteBrand(_ref102) {
  var params = _ref102.params,
      onSuccess = _ref102.onSuccess,
      onError = _ref102.onError;
  return /*#__PURE__*/function () {
    var _ref104 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee26(dispatch, getState, _ref103) {
      var api, response, result, prevData;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              api = _ref103.api;
              _context26.prev = 1;
              dispatch(requestChangeFavoriteBrands());
              _context26.next = 5;
              return api.deleteFavoriteBrand(params);

            case 5:
              response = _context26.sent;
              result = response === null || response === void 0 ? void 0 : response.result;

              if (result === 'success') {
                prevData = getState().user.favoriteBrands.data;
                dispatch(successChangeFavoriteBrands(prevData.filter(function (item) {
                  return item != params.brand_id;
                })));
                if (onSuccess) onSuccess();
              } else {
                if (onError) onError();
                dispatch(failureChangeFavoriteBrands(response));
              }

              _context26.next = 14;
              break;

            case 10:
              _context26.prev = 10;
              _context26.t0 = _context26["catch"](1);
              if (onError) onError();
              dispatch(failureChangeFavoriteBrands(_context26.t0.toString()));

            case 14:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26, null, [[1, 10]]);
    }));

    return function (_x74, _x75, _x76) {
      return _ref104.apply(this, arguments);
    };
  }();
};
var getAuthData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var loggedIn = user.loggedIn,
      loggingIn = user.loggingIn,
      loggingOut = user.loggingOut,
      codeSending = user.codeSending,
      codeSent = user.codeSent,
      error = user.error,
      userData = user.user,
      redirectUrl = user.redirectUrl,
      returnableItem = user.returnableItem,
      profile = user.profile,
      hasNewProducts = user.hasNewProducts,
      isNewUser = user.isNewUser,
      subscribeError = user.subscribeError,
      emailValidateError = user.emailValidateError,
      phoneValidateError = user.phoneValidateError,
      hasGotIP = user.hasGotIP;
  return {
    loggedIn: loggedIn,
    loggingIn: loggingIn,
    loggingOut: loggingOut,
    codeSending: codeSending,
    codeSent: codeSent,
    error: error,
    user: userData,
    redirectUrl: redirectUrl,
    returnableItem: returnableItem,
    profile: profile,
    hasNewProducts: hasNewProducts,
    isNewUser: isNewUser,
    subscribeError: subscribeError,
    emailValidateError: emailValidateError,
    phoneValidateError: phoneValidateError,
    hasGotIP: hasGotIP
  };
});
var getUserOrders = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var _user$ordersHistory = user.ordersHistory,
      data = _user$ordersHistory.data,
      loading = _user$ordersHistory.loading,
      error = _user$ordersHistory.error;
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var getOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var _user$order = user.order,
      data = _user$order.data,
      loading = _user$order.loading,
      error = _user$order.error;
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var getDiscount = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var _user$discount = user.discount,
      data = _user$discount.data,
      loading = _user$discount.loading,
      error = _user$discount.error;
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var getUserRefunds = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var _user$refundsHistory = user.refundsHistory,
      data = _user$refundsHistory.data,
      loading = _user$refundsHistory.loading,
      error = _user$refundsHistory.error;
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var getSentRefundInfo = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var _user$refund = user.refund,
      loading = _user$refund.loading,
      error = _user$refund.error;
  return {
    loading: loading,
    error: error
  };
});
var getRefundInfo = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var _user$refundInfo = user.refundInfo,
      loading = _user$refundInfo.loading,
      error = _user$refundInfo.error,
      data = _user$refundInfo.data;
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var getCountriesOfDelivery = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var _user$countriesOfDeli = user.countriesOfDelivery,
      data = _user$countriesOfDeli.data,
      loading = _user$countriesOfDeli.loading,
      error = _user$countriesOfDeli.error;
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var getReturnableProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.user;
}, function (user) {
  var _user$returnableProdu = user.returnableProducts,
      data = _user$returnableProdu.data,
      loading = _user$returnableProdu.loading,
      error = _user$returnableProdu.error;
  return {
    data: data,
    loading: loading,
    error: error
  };
});
var _user$actions = user.actions,
    requestChangeFavoriteBrands = _user$actions.requestChangeFavoriteBrands,
    successChangeFavoriteBrands = _user$actions.successChangeFavoriteBrands,
    failureChangeFavoriteBrands = _user$actions.failureChangeFavoriteBrands,
    changeBanner = _user$actions.changeBanner,
    requestCode = _user$actions.requestCode,
    successCode = _user$actions.successCode,
    failureCode = _user$actions.failureCode,
    requestCountriesOfDelivery = _user$actions.requestCountriesOfDelivery,
    successCountriesOfDelivery = _user$actions.successCountriesOfDelivery,
    failureCountriesOfDelivery = _user$actions.failureCountriesOfDelivery,
    requestSendRefund = _user$actions.requestSendRefund,
    successSendRefund = _user$actions.successSendRefund,
    failureSendRefund = _user$actions.failureSendRefund,
    requestRefundInfo = _user$actions.requestRefundInfo,
    successRefundInfo = _user$actions.successRefundInfo,
    failureRefundInfo = _user$actions.failureRefundInfo,
    requestReturnableProducts = _user$actions.requestReturnableProducts,
    successReturnableProducts = _user$actions.successReturnableProducts,
    failureReturnableProducts = _user$actions.failureReturnableProducts,
    resetSendCodeState = _user$actions.resetSendCodeState,
    requestLogin = _user$actions.requestLogin,
    successLogin = _user$actions.successLogin,
    failureLogin = _user$actions.failureLogin,
    requestLogout = _user$actions.requestLogout,
    successLogout = _user$actions.successLogout,
    requestRemoveProfile = _user$actions.requestRemoveProfile,
    successRemoveProfile = _user$actions.successRemoveProfile,
    failureRemoveProfile = _user$actions.failureRemoveProfile,
    requestDiscount = _user$actions.requestDiscount,
    successDiscount = _user$actions.successDiscount,
    failureDiscount = _user$actions.failureDiscount,
    failureLogout = _user$actions.failureLogout,
    changeRedirectUrl = _user$actions.changeRedirectUrl,
    changeReturnableItem = _user$actions.changeReturnableItem,
    requestProfileUpdate = _user$actions.requestProfileUpdate,
    successProfileUpdate = _user$actions.successProfileUpdate,
    failureProfileUpdate = _user$actions.failureProfileUpdate,
    changeNewProducts = _user$actions.changeNewProducts,
    changeNewUserStatus = _user$actions.changeNewUserStatus,
    requestUserOrders = _user$actions.requestUserOrders,
    successUserOrders = _user$actions.successUserOrders,
    failureUserOrders = _user$actions.failureUserOrders,
    requestUserRefunds = _user$actions.requestUserRefunds,
    successUserRefunds = _user$actions.successUserRefunds,
    failureUserRefunds = _user$actions.failureUserRefunds,
    requestOrder = _user$actions.requestOrder,
    successOrder = _user$actions.successOrder,
    failureOrder = _user$actions.failureOrder,
    failureSubscribe = _user$actions.failureSubscribe,
    failureValidateEmail = _user$actions.failureValidateEmail,
    failureValidatePhone = _user$actions.failureValidatePhone,
    successGotIP = _user$actions.successGotIP,
    resetProfileError = _user$actions.resetProfileError;

/* harmony default export */ __webpack_exports__["ZP"] = (user.reducer);

/***/ }),

/***/ 89780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "En": function() { return /* binding */ getViewedData; },
/* harmony export */   "Zo": function() { return /* binding */ updateViewed; },
/* harmony export */   "_h": function() { return /* binding */ updateHistoryIds; },
/* harmony export */   "eL": function() { return /* binding */ fetchHistory; }
/* harmony export */ });
/* unused harmony exports requestViewed, successViewed, failureViewed, updateIds, addViewedProduct, resetViewed */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27812);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sessionSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28770);
/* harmony import */ var _checkoutSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10604);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35357);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68697);
/* harmony import */ var _userSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46789);




var _extraReducers;



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var initialState = {
  count: 0,
  ids: [],
  items: [],
  loading: false,
  isFromSession: false,
  error: null,
  cacheTime: null
};
var viewed = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
  name: 'viewed',
  initialState: initialState,
  reducers: {
    requestViewed: function requestViewed(state) {
      state.loading = true;
    },
    successViewed: function successViewed(state, _ref) {
      var payload = _ref.payload;
      state.loading = false;
      state.items = payload;
      state.error = null;
      state.cacheTime = Date.now();
    },
    failureViewed: function failureViewed(state, _ref2) {
      var payload = _ref2.payload;
      state.loading = false;
      state.error = payload;
    },
    updateIds: function updateIds(state, _ref3) {
      var payload = _ref3.payload;
      state.ids = payload.ids;
      state.count = payload.count;
    },
    addViewedProduct: function addViewedProduct(state, _ref4) {
      var _payload$model, _payload$model3;

      var payload = _ref4.payload;
      if (!(payload !== null && payload !== void 0 && (_payload$model = payload.model) !== null && _payload$model !== void 0 && _payload$model.id)) return state;
      state.items = [payload].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state.items.filter(function (item) {
        var _item$model, _payload$model2;

        return ((_item$model = item.model) === null || _item$model === void 0 ? void 0 : _item$model.id) !== ((_payload$model2 = payload.model) === null || _payload$model2 === void 0 ? void 0 : _payload$model2.id);
      })));
      state.ids = [(_payload$model3 = payload.model) === null || _payload$model3 === void 0 ? void 0 : _payload$model3.id].concat((0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state.ids.filter(function (_id) {
        var _payload$model4;

        return _id !== ((_payload$model4 = payload.model) === null || _payload$model4 === void 0 ? void 0 : _payload$model4.id);
      })));
      state.count = state.ids.length;
    },
    resetViewed: function resetViewed() {
      return _objectSpread({}, initialState);
    }
  },
  extraReducers: (_extraReducers = {}, (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_extraReducers, _sessionSlice__WEBPACK_IMPORTED_MODULE_2__/* .successSession */ .C4, _getProductsFromSession), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_extraReducers, _userSlice__WEBPACK_IMPORTED_MODULE_4__/* .successLogin */ .Ei, _getProductsFromSession), (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_extraReducers, _checkoutSlice__WEBPACK_IMPORTED_MODULE_3__/* .successOrderCreate */ .nK, _getProductsFromSession), _extraReducers)
});

function _getProductsFromSession(state, _ref5) {
  var _payload$views_histor, _payload$views_histor2;

  var payload = _ref5.payload;
  state.ids = (_payload$views_histor = payload === null || payload === void 0 ? void 0 : payload.views_history) !== null && _payload$views_histor !== void 0 ? _payload$views_histor : [];
  state.count = (_payload$views_histor2 = payload === null || payload === void 0 ? void 0 : payload.views_history_count) !== null && _payload$views_histor2 !== void 0 ? _payload$views_histor2 : 0;
  state.isFromSession = true;
}

var updateViewed = function updateViewed(params) {
  return function (_dispatch, _getState, _ref6) {
    var api = _ref6.api;
    api.addProductToViewed(params);
  };
};
var fetchHistory = function fetchHistory() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onSuccess = _ref7.onSuccess;

  return /*#__PURE__*/function () {
    var _ref9 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState, _ref8) {
      var api, resp, _resp$result, result, items;

      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref8.api;
              _context.prev = 1;
              _context.next = 4;
              return api.history();

            case 4:
              resp = _context.sent;
              _resp$result = resp.result, result = _resp$result === void 0 ? 'success' : _resp$result;

              if (result === 'success') {
                items = (resp === null || resp === void 0 ? void 0 : resp.data) || [];
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(items);
                dispatch(successViewed(items));
              } else {
                dispatch(failureViewed(resp));
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              dispatch(failureViewed(_context.t0.message || JSON.stringify(_context.t0)));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var updateHistoryIds = function updateHistoryIds(_ref10) {
  var ids = _ref10.ids,
      count = _ref10.count;
  return function (dispatch, getState) {
    dispatch(updateIds({
      ids: ids,
      count: count
    }));
  };
};
var getViewedData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function (state) {
  return state.viewed;
}, function (viewedState) {
  var loading = viewedState.loading,
      error = viewedState.error,
      count = viewedState.count,
      ids = viewedState.ids,
      isFromSession = viewedState.isFromSession,
      items = viewedState.items;
  return {
    loading: loading,
    error: error,
    count: count,
    ids: ids,
    isFromSession: isFromSession,
    items: items
  };
});
var _viewed$actions = viewed.actions,
    requestViewed = _viewed$actions.requestViewed,
    successViewed = _viewed$actions.successViewed,
    failureViewed = _viewed$actions.failureViewed,
    updateIds = _viewed$actions.updateIds,
    addViewedProduct = _viewed$actions.addViewedProduct,
    resetViewed = _viewed$actions.resetViewed;

/* harmony default export */ __webpack_exports__["ZP"] = (viewed.reducer);

/***/ }),

/***/ 94650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mV": function() { return /* binding */ addWishlistId; },
  "JY": function() { return /* binding */ createInWishlist; },
  "ZP": function() { return /* binding */ wishlistSlice; },
  "BW": function() { return /* binding */ fetchWishlist; },
  "jb": function() { return /* binding */ getWishlistData; },
  "$f": function() { return /* binding */ removeFromWishlist; },
  "GL": function() { return /* binding */ removeWishlistId; },
  "n5": function() { return /* binding */ setLoadingRequest; },
  "m9": function() { return /* binding */ updateProductInWishlist; },
  "Mu": function() { return /* binding */ updateWishlistIds; }
});

// UNUSED EXPORTS: cancelSync, failureUpdatingWishlist, failureWishlist, firstRequestWishlist, idsObjArrayToIdsObj, requestWishlist, resetWishlist, startUpdatingWishlist, successRequestWishlist, successUpdatingWishlist, successWishlist, updateIds, updateIdsObj

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/sessionSlice.js + 1 modules
var sessionSlice = __webpack_require__(28770);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/checkoutSlice.js
var checkoutSlice = __webpack_require__(10604);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 4 modules
var redux_toolkit_esm = __webpack_require__(35357);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/userSlice.js
var userSlice = __webpack_require__(46789);
;// CONCATENATED MODULE: ./node_modules/@fh-components/fh-js-api-core/utils/index.js
var getUniqItems = function getUniqItems(items, getId) {
  var existingItems = {};
  return items.filter(function (item) {
    var id = getId(item);
    if (existingItems[id]) return false;
    existingItems[id] = true;
    return true;
  });
};
;// CONCATENATED MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/wishlistSlice.js




var _extraReducers;



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var idsObjArrayToIdsObj = function idsObjArrayToIdsObj(ids) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (ids === null || ids === void 0 ? void 0 : ids.reduce(function (acc, el) {
    Object.values(el).forEach(function (id) {
      if (id) {
        acc[id] = value;
      }
    });
    return acc;
  }, {})) || {};
};
var initialState = {
  products: [],
  links: {},
  meta: {},
  count: 0,
  firstLoading: false,
  ids: [],
  idsObj: {},
  loading: false,
  updating: false,
  syncTimeoutId: null,
  error: null,
  updateError: null
};
var wishlist = (0,redux_toolkit_esm/* createSlice */.oM)({
  name: 'wishlist',
  initialState: initialState,
  reducers: {
    requestWishlist: function requestWishlist(state) {
      state.loading = true;
      state.error = null;
      state.updateError = null;
    },
    successWishlist: function successWishlist(state, _ref) {
      var _payload$mergeResult, _payload$meta, _payload$links;

      var payload = _ref.payload;
      var mergeResult = (_payload$mergeResult = payload === null || payload === void 0 ? void 0 : payload.mergeResult) !== null && _payload$mergeResult !== void 0 ? _payload$mergeResult : false;

      if (mergeResult) {
        var _payload$favorites;

        var result = [].concat((0,toConsumableArray/* default */.Z)(state.products), (0,toConsumableArray/* default */.Z)((_payload$favorites = payload === null || payload === void 0 ? void 0 : payload.favorites) !== null && _payload$favorites !== void 0 ? _payload$favorites : []));
        state.products = getUniqItems(result, function (item) {
          return item.id;
        });
      } else {
        var _payload$favorites2;

        state.products = (_payload$favorites2 = payload === null || payload === void 0 ? void 0 : payload.favorites) !== null && _payload$favorites2 !== void 0 ? _payload$favorites2 : [];
      }

      state.meta = (_payload$meta = payload === null || payload === void 0 ? void 0 : payload.meta) !== null && _payload$meta !== void 0 ? _payload$meta : {};
      state.links = (_payload$links = payload === null || payload === void 0 ? void 0 : payload.links) !== null && _payload$links !== void 0 ? _payload$links : {};
      state.firstLoading = false;
      state.loading = false;
      state.error = null;
    },
    firstRequestWishlist: function firstRequestWishlist(state) {
      state.firstLoading = true;
    },
    failureWishlist: function failureWishlist(state, _ref2) {
      var payload = _ref2.payload;
      state.loading = false;
      state.firstLoading = false;
      state.error = payload;
    },
    updateIds: function updateIds(state, _ref3) {
      var payload = _ref3.payload;
      state.ids = payload;
      state.count = payload.length;
    },
    updateIdsObj: function updateIdsObj(state, _ref4) {
      var payload = _ref4.payload;
      state.idsObj = payload;
    },
    cancelSync: function cancelSync(state) {
      clearTimeout(state.syncTimeoutId);
    },
    successRequestWishlist: function successRequestWishlist(state) {
      state.loading = false;
    },
    resetWishlist: function resetWishlist() {
      return _objectSpread({}, initialState);
    },
    startUpdatingWishlist: function startUpdatingWishlist(state) {
      state.updating = true;
      state.updateError = null;
    },
    successUpdatingWishlist: function successUpdatingWishlist(state) {
      state.updating = false;
    },
    failureUpdatingWishlist: function failureUpdatingWishlist(state, _ref5) {
      var payload = _ref5.payload;
      state.updating = false;
      state.updateError = payload;
    }
  },
  extraReducers: (_extraReducers = {}, (0,defineProperty/* default */.Z)(_extraReducers, sessionSlice/* successSession */.C4, _getProductsFromSession), (0,defineProperty/* default */.Z)(_extraReducers, userSlice/* successLogin */.Ei, _getProductsFromSession), (0,defineProperty/* default */.Z)(_extraReducers, checkoutSlice/* successOrderCreate */.nK, _getProductsFromSession), _extraReducers)
});

function _getProductsFromSession(state, _ref6) {
  var _payload$favorites3, _payload$favorites_co;

  var payload = _ref6.payload;
  var favorites = (_payload$favorites3 = payload === null || payload === void 0 ? void 0 : payload.favorites) !== null && _payload$favorites3 !== void 0 ? _payload$favorites3 : null;
  var favorites_count = (_payload$favorites_co = payload === null || payload === void 0 ? void 0 : payload.favorites_count) !== null && _payload$favorites_co !== void 0 ? _payload$favorites_co : null;

  if (favorites) {
    state.ids = favorites;
    state.idsObj = idsObjArrayToIdsObj(favorites);
  }

  if (favorites_count !== null) {
    state.count = favorites_count;
  }
}

var setLoadingRequest = function setLoadingRequest() {
  return /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dispatch, getState, _ref7) {
      var api;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref7.api;
              dispatch(firstRequestWishlist());

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var fetchWishlist = function fetchWishlist(_ref9) {
  var onSuccess = _ref9.onSuccess,
      page = _ref9.page,
      mergeResult = _ref9.mergeResult,
      _ref9$errorToString = _ref9.errorToString,
      errorToString = _ref9$errorToString === void 0 ? true : _ref9$errorToString;
  return /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(dispatch, getState, _ref10) {
      var api, resp, _resp$result, result, data, links, meta;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref10.api;
              dispatch(requestWishlist());
              _context2.prev = 2;
              _context2.next = 5;
              return api.wishlist({
                page: page
              });

            case 5:
              resp = _context2.sent;
              _resp$result = resp.result, result = _resp$result === void 0 ? 'success' : _resp$result, data = resp.data, links = resp.links, meta = resp.meta;

              if (result === 'success') {
                dispatch(successWishlist({
                  favorites: data,
                  links: links,
                  meta: meta,
                  mergeResult: mergeResult
                }));
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
              } else {
                dispatch(failureWishlist(resp));
              }

              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](2);
              dispatch(failureWishlist(errorToString ? _context2.t0.toString() : _context2.t0));

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 10]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref11.apply(this, arguments);
    };
  }();
};
var createInWishlist = function createInWishlist(_ref12) {
  var id = _ref12.id,
      modelId = _ref12.modelId,
      onSuccess = _ref12.onSuccess,
      onError = _ref12.onError,
      mindboxDeviceUUID = _ref12.mindboxDeviceUUID,
      _ref12$errorToString = _ref12.errorToString,
      errorToString = _ref12$errorToString === void 0 ? true : _ref12$errorToString;
  return /*#__PURE__*/function () {
    var _ref14 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(dispatch, getState, _ref13) {
      var api, resp, _resp$result2, result;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref13.api;
              dispatch(startUpdatingWishlist());
              _context3.prev = 2;
              _context3.next = 5;
              return api.addToWishlist({
                product_id: id,
                model_id: modelId,
                mindboxDeviceUUID: mindboxDeviceUUID
              });

            case 5:
              resp = _context3.sent;
              _resp$result2 = resp.result, result = _resp$result2 === void 0 ? 'success' : _resp$result2;

              if (result === 'success') {
                if (onSuccess) onSuccess();
                dispatch(successUpdatingWishlist());
              } else {
                dispatch(failureUpdatingWishlist(resp));
                onError === null || onError === void 0 ? void 0 : onError(resp);
              }

              _context3.next = 14;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](2);
              dispatch(failureUpdatingWishlist(errorToString ? _context3.t0.toString() : _context3.t0));
              onError === null || onError === void 0 ? void 0 : onError(_context3.t0);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 10]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref14.apply(this, arguments);
    };
  }();
};
var updateProductInWishlist = function updateProductInWishlist(_ref15) {
  var id = _ref15.id,
      modelId = _ref15.modelId,
      newId = _ref15.newId,
      favoriteId = _ref15.favoriteId,
      onSuccess = _ref15.onSuccess,
      onError = _ref15.onError,
      mindboxDeviceUUID = _ref15.mindboxDeviceUUID;
  return /*#__PURE__*/function () {
    var _ref17 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_dispatch, _getState, _ref16) {
      var api, resp, _resp$result3, result;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              api = _ref16.api;
              _context4.prev = 1;
              _context4.next = 4;
              return api.updateWishlist({
                model_id: modelId,
                product_id: id,
                new_product_id: newId,
                mindboxDeviceUUID: mindboxDeviceUUID,
                favorite_id: favoriteId
              });

            case 4:
              resp = _context4.sent;
              _resp$result3 = resp.result, result = _resp$result3 === void 0 ? 'success' : _resp$result3;

              if (result === 'success') {
                if (onSuccess) onSuccess(resp);
              } else {
                onError === null || onError === void 0 ? void 0 : onError(resp);
              }

              _context4.next = 12;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](1);
              onError === null || onError === void 0 ? void 0 : onError(_context4.t0);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 9]]);
    }));

    return function (_x10, _x11, _x12) {
      return _ref17.apply(this, arguments);
    };
  }();
};
var removeFromWishlist = function removeFromWishlist(_ref18) {
  var id = _ref18.id,
      modelId = _ref18.modelId,
      favoriteId = _ref18.favoriteId,
      onSuccess = _ref18.onSuccess,
      onError = _ref18.onError,
      mindboxDeviceUUID = _ref18.mindboxDeviceUUID,
      _ref18$errorToString = _ref18.errorToString,
      errorToString = _ref18$errorToString === void 0 ? true : _ref18$errorToString;
  return /*#__PURE__*/function () {
    var _ref20 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(dispatch, _getState, _ref19) {
      var api, resp, _resp$result4, result;

      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = _ref19.api;
              dispatch(startUpdatingWishlist());
              _context5.prev = 2;
              _context5.next = 5;
              return api.removeFromWishlist({
                product_id: id,
                model_id: modelId,
                mindboxDeviceUUID: mindboxDeviceUUID,
                favorite_id: favoriteId
              });

            case 5:
              resp = _context5.sent;
              _resp$result4 = resp.result, result = _resp$result4 === void 0 ? 'success' : _resp$result4;

              if (result === 'success') {
                if (onSuccess) onSuccess();
                dispatch(successUpdatingWishlist());
              } else {
                dispatch(failureUpdatingWishlist(resp));
                onError === null || onError === void 0 ? void 0 : onError(resp);
              }

              _context5.next = 14;
              break;

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](2);
              dispatch(failureUpdatingWishlist(errorToString ? _context5.t0.toString() : _context5.t0));
              onError === null || onError === void 0 ? void 0 : onError(_context5.t0);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 10]]);
    }));

    return function (_x13, _x14, _x15) {
      return _ref20.apply(this, arguments);
    };
  }();
};
var updateWishlistIds = function updateWishlistIds(_ref21) {
  var ids = _ref21.ids;
  return function (dispatch, _getState) {
    dispatch(updateIds(ids));
  };
};
var removeWishlistId = function removeWishlistId(_ref22) {
  var id = _ref22.id,
      isVariation = _ref22.isVariation;
  return function (dispatch, getState) {
    var state = getState().wishlist;
    var ids = state.ids;
    dispatch(updateIds(ids.filter(function (item) {
      return isVariation ? item.product_id != id : item.model_id != id;
    })));
  };
};
var addWishlistId = function addWishlistId(_ref23) {
  var id = _ref23.id;
  return function (dispatch, getState) {
    var state = getState().wishlist;
    var ids = state.ids;
    dispatch(updateIds([].concat((0,toConsumableArray/* default */.Z)(ids), [id])));
  };
};
var getWishlistData = (0,es/* createSelector */.P1)(function (state) {
  return state.wishlist;
}, function (wishlistState) {
  var products = wishlistState.products,
      loading = wishlistState.loading,
      updating = wishlistState.updating,
      error = wishlistState.error,
      count = wishlistState.count,
      meta = wishlistState.meta,
      links = wishlistState.links,
      ids = wishlistState.ids,
      idsObj = wishlistState.idsObj,
      firstLoading = wishlistState.firstLoading;
  return {
    products: products,
    loading: loading,
    updating: updating,
    error: error,
    count: count,
    meta: meta,
    links: links,
    ids: ids,
    idsObj: idsObj,
    firstLoading: firstLoading
  };
});
var _wishlist$actions = wishlist.actions,
    requestWishlist = _wishlist$actions.requestWishlist,
    successWishlist = _wishlist$actions.successWishlist,
    firstRequestWishlist = _wishlist$actions.firstRequestWishlist,
    successRequestWishlist = _wishlist$actions.successRequestWishlist,
    failureWishlist = _wishlist$actions.failureWishlist,
    cancelSync = _wishlist$actions.cancelSync,
    updateIds = _wishlist$actions.updateIds,
    updateIdsObj = _wishlist$actions.updateIdsObj,
    resetWishlist = _wishlist$actions.resetWishlist,
    startUpdatingWishlist = _wishlist$actions.startUpdatingWishlist,
    successUpdatingWishlist = _wishlist$actions.successUpdatingWishlist,
    failureUpdatingWishlist = _wishlist$actions.failureUpdatingWishlist;

/* harmony default export */ var wishlistSlice = (wishlist.reducer);

/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 91118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(8384);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 930:
/***/ (function(module) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 21876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 77984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customWrapper":"Blocks_customWrapper__nCslr","blocks":"Blocks_blocks___l5Rp"};

/***/ }),

/***/ 30860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainBlock":"BrandInfo_mainBlock__GM5oK","loader":"BrandInfo_loader__OSNCW","main":"BrandInfo_main__OoMZB","mainText":"BrandInfo_mainText__tlebu","textBlock":"BrandInfo_textBlock__RPREO","title":"BrandInfo_title__aL0jX","text":"BrandInfo_text__yHnhJ","buttonBlock":"BrandInfo_buttonBlock__dREx8","button":"BrandInfo_button__6ECZw","imageBlock":"BrandInfo_imageBlock__4PN7j","imageBlockVisible":"BrandInfo_imageBlockVisible___uPgF","load":"BrandInfo_load__wk_cf"};

/***/ }),

/***/ 85299:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__PmZtq","load":"Button_load__HhDyt"};

/***/ }),

/***/ 46598:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Carousel_title__Beo_I","carouselProductsSlider":"Carousel_carouselProductsSlider__QtC4Z","link":"Carousel_link__u6qbT","linkWithSubtitle":"Carousel_linkWithSubtitle__P_FSk","subtitle":"Carousel_subtitle__gKBwu","notActiveLink":"Carousel_notActiveLink__mbJtk","bigSliderLink":"Carousel_bigSliderLink__hr0ws","carouselProductsBigSlider":"Carousel_carouselProductsBigSlider__Qmf4a","load":"Carousel_load__irQR0"};

/***/ }),

/***/ 70981:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__y9xkj"};

/***/ }),

/***/ 98406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fp-products-slider":"FourPictures_fp-products-slider__YGB2X","load":"FourPictures_load__kIei3"};

/***/ }),

/***/ 58232:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"ContentSlider_main__ppgQn","swiper-pagination-bullet":"ContentSlider_swiper-pagination-bullet__8aijG","slide":"ContentSlider_slide__0eC9b","link":"ContentSlider_link__OQflF","image":"ContentSlider_image__TFBl9"};

/***/ }),

/***/ 90214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"double-gallery-title":"DoubleGallery_double-gallery-title__O9OgL","double-gallery-description":"DoubleGallery_double-gallery-description__ICOe_","double-gallery-button":"DoubleGallery_double-gallery-button__ieWMK","double-gallery-content":"DoubleGallery_double-gallery-content__nvmqS","load":"DoubleGallery_load__5kHg7"};

/***/ }),

/***/ 75052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery":"GalleryContainer_gallery___Jr29","load":"GalleryContainer_load__96LIW"};

/***/ }),

/***/ 37445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"GallerySlider_slider__HWr0s"};

/***/ }),

/***/ 40676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"HtmlBlock_main__9_jF7","load":"HtmlBlock_load__ID1M7"};

/***/ }),

/***/ 22763:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"center":"HtmlLinksBlock_center__xVXF8","left":"HtmlLinksBlock_left__i524n","right":"HtmlLinksBlock_right__qGChn","title":"HtmlLinksBlock_title__f_urd","h1":"HtmlLinksBlock_h1__h541N","h2":"HtmlLinksBlock_h2__d1xrD","h3":"HtmlLinksBlock_h3__BdnHo","container":"HtmlLinksBlock_container__vur14","link":"HtmlLinksBlock_link__i38OC","load":"HtmlLinksBlock_load__AAE0y"};

/***/ }),

/***/ 26368:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lookImageLabelsBlock":"LookImage_lookImageLabelsBlock__057sl","lookImagePictureHtml":"LookImage_lookImagePictureHtml__n15Cz","lookImageLabel":"LookImage_lookImageLabel__tX1GC","left":"LookImage_left__XgtB1","right":"LookImage_right__DOlxB","text":"LookImage_text__Jt9NP","lookImageButton":"LookImage_lookImageButton__17lEo","content":"LookImage_content__m19Rn","load":"LookImage_load___5XET"};

/***/ }),

/***/ 38988:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"LookImageSlider_container__Bq9VL","imageBlock":"LookImageSlider_imageBlock__PyTLV","rightSideImage":"LookImageSlider_rightSideImage__u38Ni","lookSlider":"LookImageSlider_lookSlider__b09Vf","cart":"LookImageSlider_cart__HQa0o","lookSliderProductPage":"LookImageSlider_lookSliderProductPage__UYI5O","reverseContainer":"LookImageSlider_reverseContainer__m5tDj","button":"LookImageSlider_button__EFcBc","collectionTitle":"LookImageSlider_collectionTitle__oLGuI","load":"LookImageSlider_load__ZYOR5"};

/***/ }),

/***/ 63206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"marquee":"Marquee_marquee__eeMe_","marquee-content":"Marquee_marquee-content__KBzeQ","marqueeAnimation":"Marquee_marqueeAnimation__04pyA","load":"Marquee_load__nivQJ"};

/***/ }),

/***/ 96351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"NavigationPictures_main__mAV9P","item":"NavigationPictures_item__tAzQ0","image":"NavigationPictures_image__ccJcu","content":"NavigationPictures_content__Kt6RR","title":"NavigationPictures_title__mSNAI","desc":"NavigationPictures_desc__CX8Jm","load":"NavigationPictures_load__5h6md"};

/***/ }),

/***/ 7331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"NavigationPicturesOld_main__TcSLu","item":"NavigationPicturesOld_item__WFfX_","image":"NavigationPicturesOld_image__emOfi","content":"NavigationPicturesOld_content__wV3HY","title":"NavigationPicturesOld_title__XDZ8_","desc":"NavigationPicturesOld_desc___pgJp","load":"NavigationPicturesOld_load__77dQR"};

/***/ }),

/***/ 48704:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"NavigationThreePictures_main__Ut7cB","container":"NavigationThreePictures_container__0LtMv","slider":"NavigationThreePictures_slider__hFR3_","link":"NavigationThreePictures_link__foVnG","image":"NavigationThreePictures_image__2xkQ6","content":"NavigationThreePictures_content__UzPG_","title":"NavigationThreePictures_title__b6lab","desc":"NavigationThreePictures_desc__5I824","button":"NavigationThreePictures_button__28d_3","h1-content":"NavigationThreePictures_h1-content___wued","h2-content":"NavigationThreePictures_h2-content__ZjBc_","h3-content":"NavigationThreePictures_h3-content__tbF1F","h1-title":"NavigationThreePictures_h1-title__qrQEx","h2-title":"NavigationThreePictures_h2-title__uMwM4","h3-title":"NavigationThreePictures_h3-title__G2cxm","item":"NavigationThreePictures_item__tt_Qg","contentSlider":"NavigationThreePictures_contentSlider__XDbJO","load":"NavigationThreePictures_load__hgbgp"};

/***/ }),

/***/ 33281:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NoResult_container__W7lKj","textBlock":"NoResult_textBlock__FZb2G","title":"NoResult_title__a1I9t","description":"NoResult_description__VsWol","buttonBlock":"NoResult_buttonBlock__ZzWU_","button":"NoResult_button__t8Z40","load":"NoResult_load__2phk0"};

/***/ }),

/***/ 37215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offset":"Offset_offset__kC9qa","load":"Offset_load__WjUdb"};

/***/ }),

/***/ 12090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"OneImage_main__E_uU5","item":"OneImage_item__M1c_C","image":"OneImage_image__M5_wC","content":"OneImage_content__qte2u","title":"OneImage_title___prEg","desc":"OneImage_desc__sgVR8","button":"OneImage_button__UYRfk","h1-title":"OneImage_h1-title__10Fj9","h2-title":"OneImage_h2-title__5Zxwa","h3-title":"OneImage_h3-title__5tRqV","h1-content":"OneImage_h1-content__wD3y4","h2-content":"OneImage_h2-content__IRjNO","h3-content":"OneImage_h3-content__0y1H5","load":"OneImage_load__vAOYZ"};

/***/ }),

/***/ 28620:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"PictureHtml_main__spAnP","content":"PictureHtml_content__oq8Yk","load":"PictureHtml_load__NpR33"};

/***/ }),

/***/ 84075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"PictureHtmlImage_image__O8WgI","isLook":"PictureHtmlImage_isLook__2HRYt"};

/***/ }),

/***/ 83961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"products-slider":"ProductsSlider_products-slider__clNvR","products-slider-link":"ProductsSlider_products-slider-link__kgT2j","load":"ProductsSlider_load__OThP_"};

/***/ }),

/***/ 77618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectionsCatalog_container__QBba_","productList":"SelectionsCatalog_productList__7uY03","load":"SelectionsCatalog_load__1bzty"};

/***/ }),

/***/ 56952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shorts":"ShortsYoutubePlayer_shorts__Ot3td","video-wrapper":"ShortsYoutubePlayer_video-wrapper__k4cDt"};

/***/ }),

/***/ 60661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"TextWithSidePicture_main__DrU3_","image":"TextWithSidePicture_image__Y4Qcq","contentBlock":"TextWithSidePicture_contentBlock__AcpDy","content":"TextWithSidePicture_content__VcOmh","title":"TextWithSidePicture_title__Owlxb","description":"TextWithSidePicture_description__FqE2I","text":"TextWithSidePicture_text__e3Q_w","load":"TextWithSidePicture_load__LuuZJ"};

/***/ }),

/***/ 19719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content-limiter":"TitleDescLink_content-limiter__XurkH","link":"TitleDescLink_link__isc3H","load":"TitleDescLink_load__pPpqD"};

/***/ }),

/***/ 85206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outer-container":"WidePictures_outer-container__073OT","image":"WidePictures_image__wZ7Oe","load":"WidePictures_load___O9Ce"};

/***/ }),

/***/ 17136:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inner-container":"WidePicture_inner-container__evH75","content":"WidePicture_content__4Pmir","title":"WidePicture_title__D4Gii","description":"WidePicture_description__nqQgZ","text":"WidePicture_text__1wZk5","load":"WidePicture_load__Rg0Df"};

/***/ }),

/***/ 56544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"WidePictureNoText_image__Zivoo","load":"WidePictureNoText_load__gnNpy"};

/***/ }),

/***/ 2929:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"youtube":"YoutubePlayer_youtube__6jw73","video-wrapper":"YoutubePlayer_video-wrapper__gi0hE","video":"YoutubePlayer_video__ekr_B"};

/***/ }),

/***/ 32425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__1_CI6","open":"Burger_open__d0QXk","line":"Burger_line__KQfcE","box":"Burger_box__LsNB8","load":"Burger_load__ZhRx4"};

/***/ }),

/***/ 86237:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__C3lOm","primary":"Button_primary__ebHoX","disabled":"Button_disabled__h6fts","primaryBlack":"Button_primaryBlack__TfZzK","default":"Button_default__9bvnc","defaultBlack":"Button_defaultBlack__K1d87","link":"Button_link__Jpyw5","error":"Button_error__KF8VQ","buttonContent":"Button_buttonContent__JqpZX","loading":"Button_loading__ombDY","spinner":"Button_spinner__7Y0iu","load":"Button_load__yxQbU"};

/***/ }),

/***/ 46769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"checkbox_wrapper__1hPu_","check":"checkbox_check__Byzsq","checkDisabled":"checkbox_checkDisabled__b62qz","input":"checkbox_input__8OHRc","box":"checkbox_box__HV6Ef","isError":"checkbox_isError__Q52oc","boxDisabled":"checkbox_boxDisabled__MhdyT","label":"checkbox_label__V5gon","disabled":"checkbox_disabled__yZVR8","load":"checkbox_load__Pktzx"};

/***/ }),

/***/ 15668:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio":"ControlledRadio_radio__aUqsA","title":"ControlledRadio_title__jNGQA","input":"ControlledRadio_input__gZO1V","checked":"ControlledRadio_checked__oeSJG","focus":"ControlledRadio_focus__KbDPg","disabled":"ControlledRadio_disabled__8jlhM","disabledChecked":"ControlledRadio_disabledChecked__WLdSy","notDisabledAndChecked":"ControlledRadio_notDisabledAndChecked__wHMCv","load":"ControlledRadio_load__J3mRY"};

/***/ }),

/***/ 96907:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"country-select":"countrySelect_country-select__xbn2i","country-select-trigger":"countrySelect_country-select-trigger__wjiiG","active":"countrySelect_active___JL9V"};

/***/ }),

/***/ 1371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"country-select-item":"countrySelectItem_country-select-item__er7g4","icon":"countrySelectItem_icon__eVGQr","active":"countrySelectItem_active__hFAFZ"};

/***/ }),

/***/ 90229:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"country-select-dropdown":"countrySelectlist_country-select-dropdown__Kt_ov","country-select-list":"countrySelectlist_country-select-list__MkPD8","visible":"countrySelectlist_visible__w0Hei","country-modal-dialog":"countrySelectlist_country-modal-dialog__jwenv","smartBanner":"countrySelectlist_smartBanner__9K15p","modal-header":"countrySelectlist_modal-header__rYKNX","modal-close":"countrySelectlist_modal-close__yCEXW","modal-inner":"countrySelectlist_modal-inner__jHQFn","country-list":"countrySelectlist_country-list__GQIGd"};

/***/ }),

/***/ 44870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"CurrencyPrice_icon__RiWII","load":"CurrencyPrice_load__XlWNp"};

/***/ }),

/***/ 91888:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__aT3TM","tooltip":"Input_tooltip__xuSdH","loading":"Input_loading__DmmJ9","slide":"Input_slide__BW_LD","textarea":"Input_textarea__eDf5L","textAreaInput":"Input_textAreaInput__GP2i1","search":"Input_search__guInI","clear":"Input_clear__SVrGH","label":"Input_label__MdCPJ","labelIsInside":"Input_labelIsInside__yPQBT","labelIsInsideSearch":"Input_labelIsInsideSearch__rfLcB","field":"Input_field__RCZiC","info-text":"Input_info-text__QRW1T","error":"Input_error__T2mLE","read-only":"Input_read-only__P9lMy","disabled":"Input_disabled__8orTA","success":"Input_success__1CH84","freezed":"Input_freezed__v4IkI","header":"Input_header__PHm4f","labelError":"Input_labelError__xwQ9Z"};

/***/ }),

/***/ 26503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__NkjsQ"};

/***/ }),

/***/ 90864:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__ZKOIP","rotate":"Loader_rotate__beEiN","visible":"Loader_visible__UKgK0","load":"Loader_load__LVaAv"};

/***/ }),

/***/ 953:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"isProfile":"LogoutModal_isProfile__6Y1RQ","block":"LogoutModal_block__rWxWq","title":"LogoutModal_title__metO6","buttonContainer":"LogoutModal_buttonContainer__2dUB1","buttonCancel":"LogoutModal_buttonCancel__9mQEC","buttonLogout":"LogoutModal_buttonLogout__Hwgsh","load":"LogoutModal_load__MAXQG"};

/***/ }),

/***/ 70923:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"snowflakesWrapp":"MobileFilters_snowflakesWrapp__wRaJh","snowFlakesForBtn":"MobileFilters_snowFlakesForBtn__LnRIw","smartBanner":"MobileFilters_smartBanner__7ImMP","wrapper":"MobileFilters_wrapper__ivL9Q","onEnter":"MobileFilters_onEnter__g2Cvx","onEnterActive":"MobileFilters_onEnterActive__Jlnyt","onExit":"MobileFilters_onExit___mNYT","onExitActive":"MobileFilters_onExitActive__vhWi0","onEnterDone":"MobileFilters_onEnterDone__0BdQL","container":"MobileFilters_container__X2jxc","loading":"MobileFilters_loading__2bZbx","header":"MobileFilters_header__iQb5T","title":"MobileFilters_title__q95pS","filterTitleTotal":"MobileFilters_filterTitleTotal__WyKYE","filterTitleTotalCount":"MobileFilters_filterTitleTotalCount__cL9uC","clearAll":"MobileFilters_clearAll__ESe_b","close":"MobileFilters_close__uMaoG","main":"MobileFilters_main__tmk1e","disabled":"MobileFilters_disabled__OX_Mj","filterTitle":"MobileFilters_filterTitle__5Vm3r","clearButton":"MobileFilters_clearButton__tB_vX","clearButtonVisible":"MobileFilters_clearButtonVisible__qt5kw","footer":"MobileFilters_footer__x__3A","showAllButton":"MobileFilters_showAllButton__9AwrV","filterContainer":"MobileFilters_filterContainer__7GTg6","filterIcon":"MobileFilters_filterIcon__esVir","contentButton":"MobileFilters_contentButton__HRsxM","load":"MobileFilters_load__ZQNUf"};

/***/ }),

/***/ 49005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"snowflakesWrapp":"MobileSort_snowflakesWrapp__MGSLe","snowFlakesForBtn":"MobileSort_snowFlakesForBtn__HfApV","smartBanner":"MobileSort_smartBanner__FNwXP","wrapper":"MobileSort_wrapper__lNh_X","onEnter":"MobileSort_onEnter___O2op","onEnterActive":"MobileSort_onEnterActive__ObM0P","onExit":"MobileSort_onExit__97TzP","onExitActive":"MobileSort_onExitActive__WMohH","onEnterDone":"MobileSort_onEnterDone__Ze882","container":"MobileSort_container__DKj5a","loading":"MobileSort_loading__Df1ys","header":"MobileSort_header__a56rT","title":"MobileSort_title__V_uKc","close":"MobileSort_close__w11R3","main":"MobileSort_main__AZsVO","footer":"MobileSort_footer__kYg6o","showAllButton":"MobileSort_showAllButton__WQ4ld","sortContainer":"MobileSort_sortContainer__T3cfh","titleSorted":"MobileSort_titleSorted__6KuMQ","titleSortedName":"MobileSort_titleSortedName__mtifZ","tabletIcon":"MobileSort_tabletIcon__KNl_V","mobileIcon":"MobileSort_mobileIcon__K8caG","arrowDownIcon":"MobileSort_arrowDownIcon__rYDa5","contentButton":"MobileSort_contentButton__qCybr","load":"MobileSort_load__37KLx"};

/***/ }),

/***/ 81874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileUserNav_container__D_DrQ","menu":"MobileUserNav_menu__JUGyU","menuBanner":"MobileUserNav_menuBanner__upTjW","menuInner":"MobileUserNav_menuInner__8Eie0","level":"MobileUserNav_level__F1WGA","levelInner":"MobileUserNav_levelInner__anGDQ","profileList":"MobileUserNav_profileList__tTdR9","profileLink":"MobileUserNav_profileLink__JI_Wx","visibleContainer":"MobileUserNav_visibleContainer__dmJG3","load":"MobileUserNav_load___775Q"};

/***/ }),

/***/ 61140:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"onEnter":"Modal_onEnter__3j5yt","onEnterActive":"Modal_onEnterActive__HnyU_","onExit":"Modal_onExit__SLISo","onExitActive":"Modal_onExitActive__9FENk","modal":"Modal_modal__uY_fg","brandInfo":"Modal_brandInfo__6Id0_","sizeTable":"Modal_sizeTable__gp1_7","container":"Modal_container__YJ8nD","closeDialogWrapper":"Modal_closeDialogWrapper__3CSz8","dialog":"Modal_dialog__0dlSb","load":"Modal_load__bREJb"};

/***/ }),

/***/ 7124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"PageText_text___Bb5L","load":"PageText_load__DEMzO"};

/***/ }),

/***/ 68832:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"PageTitle_title__plAft","load":"PageTitle_load__eEU3j"};

/***/ }),

/***/ 6326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"patternImage":"Picture_patternImage___5_oO"};

/***/ }),

/***/ 57777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"Price_priceContainer__oBndf","font":"Price_font__eN9sO","oldPrice":"Price_oldPrice__sAYAY","newPrice":"Price_newPrice__kec1A","discountPrice":"Price_discountPrice__bg3Xn","fontCheckout":"Price_fontCheckout__9dagI","fontProductPage":"Price_fontProductPage__YsM_S","load":"Price_load__EEEOJ"};

/***/ }),

/***/ 64950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkoutMain":"ProductCard_checkoutMain__MvdEI","main":"ProductCard_main__OZbl5","cardWrapper":"ProductCard_cardWrapper__wqqHk","moveable":"ProductCard_moveable__Bncni","isCatalog":"ProductCard_isCatalog__B8RSQ","desc":"ProductCard_desc__i7KGm","seoLink":"ProductCard_seoLink__8S0T_","brand":"ProductCard_brand__FN89e","title":"ProductCard_title__qqiuX","isCheckout":"ProductCard_isCheckout__xVggt","quantity":"ProductCard_quantity__rtzF6","params":"ProductCard_params__nd3hA","header":"ProductCard_header__MUyI_","img":"ProductCard_img__ZmYBB","price":"ProductCard_price__HeZFg","isMini":"ProductCard_isMini__WCUen","lastCardWrapper":"ProductCard_lastCardWrapper__lXTtR","outOfStock":"ProductCard_outOfStock__FM1fP","cart":"ProductCard_cart__uaO2G","rowWrap":"ProductCard_rowWrap__uPeAf","styledPrice":"ProductCard_styledPrice__Tm4AW","removeButton":"ProductCard_removeButton__65_UI","click":"ProductCard_click__gnZT_","buttons":"ProductCard_buttons__wyC8u","buttonsContainer":"ProductCard_buttonsContainer__ToZxW","cartBtnContiner":"ProductCard_cartBtnContiner__e4KPP","cartBtn":"ProductCard_cartBtn__sz0oB","wishlistSize":"ProductCard_wishlistSize__icun9","loaded":"ProductCard_loaded__53NwH","template":"ProductCard_template__KyrIQ","error":"ProductCard_error__Kg6La","hovered":"ProductCard_hovered__mqb61","singleCell":"ProductCard_singleCell__ApRUS","empty":"ProductCard_empty__hGOOL","quantityWrapper":"ProductCard_quantityWrapper__n33_X","quantityController":"ProductCard_quantityController__T0MmB","disabled":"ProductCard_disabled__vuHiz","quantityInput":"ProductCard_quantityInput__W0xaW","loading":"ProductCard_loading__diTst","load":"ProductCard_load__CeD7h","divider":"ProductCard_divider__a6PWU","attributes":"ProductCard_attributes___Y0B6","attribute":"ProductCard_attribute__9qgvh","signs":"ProductCard_signs__87Z1h","featureList":"ProductCard_featureList__NIYBA","item":"ProductCard_item__D2WrC","fav":"ProductCard_fav__FdGYO"};

/***/ }),

/***/ 45631:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textVariants":"TextVariants_textVariants__yJ6_n","hidden":"TextVariants_hidden__9R4Pp","item":"TextVariants_item__n8auc","rest":"TextVariants_rest__hC51o","load":"TextVariants_load__VGxGW"};

/***/ }),

/***/ 5705:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productFeature":"ProductFeature_productFeature__HBw3O","text":"ProductFeature_text__2SJ0o","new":"ProductFeature_new__Yyq_0","sale":"ProductFeature_sale___YGT_","alternative":"ProductFeature_alternative__q4jHV","city":"ProductFeature_city__suDoh","accent":"ProductFeature_accent__6JzIo","title":"ProductFeature_title__xA2Lh","load":"ProductFeature_load__0QLgz"};

/***/ }),

/***/ 61406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"ProductGallery_image__Bm_0i","gallery":"ProductGallery_gallery__E0FWT","thumbs":"ProductGallery_thumbs__5orTV","thumb":"ProductGallery_thumb__yaWqe","thumbIsVideo":"ProductGallery_thumbIsVideo__EZW7a","thumbActive":"ProductGallery_thumbActive__0rgxL","thumbNotActive":"ProductGallery_thumbNotActive__5jn4g","thumbVideo":"ProductGallery_thumbVideo__m3aUq","galleryIcon":"ProductGallery_galleryIcon__sWXvx","thumbNavBtn":"ProductGallery_thumbNavBtn__B1vix","thumbsPrev":"ProductGallery_thumbsPrev__43iNS","thumbsNext":"ProductGallery_thumbsNext__ufUET","galleryMain":"ProductGallery_galleryMain__nyp8E","swiperButtonPrev":"ProductGallery_swiperButtonPrev__1Utfw","swiperButtonNext":"ProductGallery_swiperButtonNext__KtftI","swiperPagination":"ProductGallery_swiperPagination__adN42","galleryImg":"ProductGallery_galleryImg__pQOaz","patternImage":"ProductGallery_patternImage__tVb1r","blockVideo":"ProductGallery_blockVideo__eSJly","load":"ProductGallery_load__ihEuT"};

/***/ }),

/***/ 57002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"valueContainerDisabled":"Select_valueContainerDisabled__PKcZ0","option":"Select_option__kK9NU","info":"Select_info__tto1k","selected":"Select_selected__pUdKq","select":"Select_select__KbxsM","scrollbar":"Select_scrollbar__Eo6fR","valueContainer80":"Select_valueContainer80__jE1tg","valueContainer90":"Select_valueContainer90__0cNpR","valueContainer115":"Select_valueContainer115__9GEVy","valueContainer105":"Select_valueContainer105__hj6Xs","valueContainer125":"Select_valueContainer125__4ozsC","load":"Select_load__RnExR"};

/***/ }),

/***/ 85030:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectBase_select__froMM","head":"SelectBase_head__7vFpg","headHover":"SelectBase_headHover__Yl9vx","selected":"SelectBase_selected__gqxjP","open":"SelectBase_open__Gz4zj","disabled":"SelectBase_disabled__s4sFx","clear":"SelectBase_clear__YmaTH","visibleClear":"SelectBase_visibleClear__iPDB6","body":"SelectBase_body__Lf5HQ","visibleBody":"SelectBase_visibleBody__VmjUZ","content":"SelectBase_content__xLpMm","load":"SelectBase_load__EpnFW"};

/***/ }),

/***/ 99809:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Share_title__7lfVt","list":"Share_list__d1ozv","item":"Share_item__nINae","vk":"Share_vk__Ky_vQ","fb":"Share_fb__9iHGt","load":"Share_load__X52p5"};

/***/ }),

/***/ 86814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"SmartBanner_banner__a8HxT","appInfo":"SmartBanner_appInfo__n8bRU","icon":"SmartBanner_icon__Zx0O7","logoImage":"SmartBanner_logoImage__gFjFL","text":"SmartBanner_text__JAHE8","button":"SmartBanner_button__mNUcb","load":"SmartBanner_load__5BGFX"};

/***/ }),

/***/ 99807:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"socialList_list__23vD0","list-item":"socialList_list-item___nQ3t","icon":"socialList_icon___9WpQ","messengers":"socialList_messengers__RndZz","socials":"socialList_socials__m5Nm8","top":"socialList_top__hvT3o","load":"socialList_load__iE3NX"};

/***/ }),

/***/ 16250:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__6lK4x","size-large":"Text_size-large__da567","size-medium":"Text_size-medium__7hI9q","size-small":"Text_size-small__ysj__","size-x-small":"Text_size-x-small__XN_vT","center":"Text_center__w9NNS","left":"Text_left__pBlBL","right":"Text_right__ukM1m","mb-large":"Text_mb-large__VyNH_","mb-medium":"Text_mb-medium__279e1","mb-small":"Text_mb-small__w_1r_","mb-x-small":"Text_mb-x-small__t7gsl","mb-xx-small":"Text_mb-xx-small__eQaW0","mb-xxx-small":"Text_mb-xxx-small__mrjEA","mb-none":"Text_mb-none__0saq_","underline":"Text_underline__6gM5C","line-through":"Text_line-through__QVTK0","load":"Text_load__b8Ruu"};

/***/ }),

/***/ 29478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"Title_h1__KjnSK","h2":"Title_h2__HBvDe","h3":"Title_h3__lDNRn","h4":"Title_h4__IfVMM","large":"Title_large__ACTh4","medium":"Title_medium__A_iD3","small":"Title_small__r1rUT","x-small":"Title_x-small__VjblP","xx-small":"Title_xx-small__pOmUf","none":"Title_none__IBgM0","center":"Title_center__mL3Mp","left":"Title_left__vPAyx","right":"Title_right__NKu2t","invisible":"Title_invisible__figdq","success":"Title_success__mo56Z","fail":"Title_fail__NXZI_","load":"Title_load__cAkCg"};

/***/ }),

/***/ 20867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__YhpDz","noMargin":"Block_noMargin__RPq5X","shops-on-map":"Block_shops-on-map__HmhGR","load":"Block_load__dGkjO"};

/***/ }),

/***/ 32896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"BreadCrumbs_list__rosqJ","item":"BreadCrumbs_item__d6FXE","link":"BreadCrumbs_link__judCI","last":"BreadCrumbs_last__Fn6uu","load":"BreadCrumbs_load___axQW"};

/***/ }),

/***/ 84593:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"CategoryTreeMobile_main__wdRIi","wrap":"CategoryTreeMobile_wrap__jxxAb","point":"CategoryTreeMobile_point__hEE1r","load":"CategoryTreeMobile_load__7t7YG"};

/***/ }),

/***/ 47419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContactsOverview_wrapper__sHszu","mobile":"ContactsOverview_mobile__l1vN1","work-time":"ContactsOverview_work-time__b8xx4","content":"ContactsOverview_content__lbjxN","footer":"ContactsOverview_footer__UhimG","app-links":"ContactsOverview_app-links__gBGi_","app-links-item":"ContactsOverview_app-links-item__bui9r","header":"ContactsOverview_header__8cRsn","phone":"ContactsOverview_phone__88XsW","link":"ContactsOverview_link__BPFps"};

/***/ }),

/***/ 77361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__ma_Hy","center":"Container_center__ssxyF","load":"Container_load__giqL5"};

/***/ }),

/***/ 91002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapp":"ErrorBoundary_wrapp__kDfyN","image":"ErrorBoundary_image__it2c2","title":"ErrorBoundary_title__rgzyO","text":"ErrorBoundary_text__3lZIb","btnContainer":"ErrorBoundary_btnContainer__wXG0d","btn":"ErrorBoundary_btn__jnaua","load":"ErrorBoundary_load__aHyUg"};

/***/ }),

/***/ 87659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__vNXf1","new-year-bg":"footer_new-year-bg__XfKvG","container":"footer_container___sKPk","links":"footer_links__1wpHa","order-1":"footer_order-1__xe3jC","order-2":"footer_order-2__0EawL","order-3":"footer_order-3__rZlhZ","order-5":"footer_order-5__NLzZa","desktopLinks":"footer_desktopLinks__4f12j","content":"footer_content__DR4vb","location":"footer_location__oL9Cc","locationTitle":"footer_locationTitle__Lh1bA","controlDropdown":"footer_controlDropdown__S3kSG","active":"footer_active__2hfKp","controlInner":"footer_controlInner__gVkQy","title":"footer_title__QvFaM","question":"footer_question__M3jSV","btns":"footer_btns__QTfXp","btn":"footer_btn__L6BiI","info":"footer_info__DT6Aa","work":"footer_work__lkhlP","phone":"footer_phone___ZHGL","work-time":"footer_work-time__p_0kb","divider":"footer_divider__36Ub7","first":"footer_first__0FV3X","second":"footer_second__H6mlr","features":"footer_features__vqGEd","features-text":"footer_features-text__mMvyg","feature":"footer_feature__ne5ML","payment":"footer_payment__PCZiC","paymentList":"footer_paymentList__5RfZO","paymentListItem":"footer_paymentListItem__gMyvy","paymentImg":"footer_paymentImg__EAXwV","bePaid":"footer_bePaid__EM61J","app":"footer_app__QkJZD","app-content":"footer_app-content__nEDcD","appLinks":"footer_appLinks__Qo5zs","app-link":"footer_app-link__ry2GF","legal":"footer_legal__CGInB","copy":"footer_copy__tL9rl","copyText":"footer_copyText__726It","dev":"footer_dev__IXMW5","text":"footer_text__yFwpE","workAndSubscribe":"footer_workAndSubscribe__dKaGQ","socialList":"footer_socialList__JCNI5","mobileLinks":"footer_mobileLinks__w4CQQ","mobileLocationTitle":"footer_mobileLocationTitle__eaNuK","modileLocationContent":"footer_modileLocationContent__M9_qG","load":"footer_load__YKE0_"};

/***/ }),

/***/ 86000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"linkList_list__NOznH","item":"linkList_item__CZKnm","link":"linkList_link__KtFzB"};

/***/ }),

/***/ 66292:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Subscribe_wrapper__zILTB","label":"Subscribe_label__nf7kW","subscribe-form":"Subscribe_subscribe-form__PV7DZ","input":"Subscribe_input__tzjAm","subscribe-btn":"Subscribe_subscribe-btn__j3_c4","text":"Subscribe_text__Qturl","submit-success":"Subscribe_submit-success__nQQqW","submit-error":"Subscribe_submit-error__7KEZo","load":"Subscribe_load__Qye4E"};

/***/ }),

/***/ 45760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__mNEqE","new-year-bg":"header_new-year-bg__NTEKS","banner":"header_banner__rwrqb","bar":"header_bar__i3VKC","left":"header_left__26Srp","nav-wrapper":"header_nav-wrapper__cf93h","mobile-nav-toggle":"header_mobile-nav-toggle__1OMmS","logo":"header_logo__QOLGA","logo-link":"header_logo-link__3Wwvf","logoImg":"header_logoImg__EpI68","controls":"header_controls__otnxS","load":"header_load__Zl9fv"};

/***/ }),

/***/ 72356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__9QwSY","form":"search_form__Ihk2o","visible":"search_visible__SLnPb","newYear":"search_newYear__k1fs3","input":"search_input___9LMw","resetBtn":"search_resetBtn__2bOpc","submitBtn":"search_submitBtn__jV26_","dialogRoot":"search_dialogRoot__ratrR","dialog":"search_dialog__YVHgI","dialogMain":"search_dialogMain__Je99o","smallDialog":"search_smallDialog__yWR0P","mainBlock":"search_mainBlock___7c29","warningInfo":"search_warningInfo__zaLX1","inputBlock":"search_inputBlock__pitgj","inputGeneral":"search_inputGeneral__NLmFB","inputField":"search_inputField__iqzPT","cancelSearch":"search_cancelSearch__TvnOu","resultBlock":"search_resultBlock__DpfGh","resultBlockDesktop":"search_resultBlockDesktop__dNV_O","resultBlockMobile":"search_resultBlockMobile__aXQwM","resultCatInfoBlock":"search_resultCatInfoBlock__eGb_1","blockTitle":"search_blockTitle__4Z8Qq","result":"search_result__QfBF_","image":"search_image__Fs75e","brand":"search_brand__kGaaU","resultTitle":"search_resultTitle__TPX0J","price":"search_price__pwdjj","withDiscount":"search_withDiscount__GJuGv","oftenSearch":"search_oftenSearch__wTtsT","goods":"search_goods__e0zfH","allResults":"search_allResults__V_qMc","catalog":"search_catalog__uPpgm","categories":"search_categories__KIYG7","brands":"search_brands__NTd_V","catalogLink":"search_catalogLink__46eAx","smartBanner":"search_smartBanner__zfcIq","noMargin":"search_noMargin__Qs9ZK","load":"search_load__oDNFE"};

/***/ }),

/***/ 87611:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchControl_search__9FYsw","show":"SearchControl_show__CMcA5","showSearch":"SearchControl_showSearch__xS5ih","text":"SearchControl_text__y3OJW","hidden":"SearchControl_hidden__ikxaV","desktop":"SearchControl_desktop__SGjzT","mobile":"SearchControl_mobile__Z13NG","searchFieldMobile":"SearchControl_searchFieldMobile__z6vFi","greenText":"SearchControl_greenText__xzUPr","load":"SearchControl_load__PdHDU"};

/***/ }),

/***/ 9272:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"UserControl_link__Ho6Wy","control":"UserControl_control__WYyW_","disabled":"UserControl_disabled__j4AIG","controlTrigger":"UserControl_controlTrigger__EwR0O","controlUser":"UserControl_controlUser__3fqqC","text":"UserControl_text__Qz6CM","newYear":"UserControl_newYear__6vq7C","controlPhone":"UserControl_controlPhone__R9P3_","quantity":"UserControl_quantity__825KZ","controlDropdown":"UserControl_controlDropdown__CAGUu","login":"UserControl_login__sPi43","controlInner":"UserControl_controlInner__A_XP9","load":"UserControl_load__WBgou"};

/***/ }),

/***/ 57170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"control-link":"UserNavItem_control-link__jnJuR"};

/***/ }),

/***/ 5215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"LikeButton_button__fz4wJ","large":"LikeButton_large__xuqAG","small":"LikeButton_small__iqpuV","img":"LikeButton_img___r9hM","largeImg":"LikeButton_largeImg__umMZz","border":"LikeButton_border__FTip_","catalogLike":"LikeButton_catalogLike__cKkzi","load":"LikeButton_load__YNlIV"};

/***/ }),

/***/ 44570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"code-form":"codeForm_code-form__erMI7","label":"codeForm_label__Ixqb0","form-control":"codeForm_form-control__VWU9X","form-info":"codeForm_form-info__dgr1D","resend-code-btn":"codeForm_resend-code-btn__2rTaG","submit-btn":"codeForm_submit-btn__NngaO","tip-container":"codeForm_tip-container__3Emzj","tip-btn":"codeForm_tip-btn__bO_ff","tip-dropdown":"codeForm_tip-dropdown__pJJId","visible":"codeForm_visible__mTX4U"};

/***/ }),

/***/ 6943:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form-title":"loginForm_form-title__ZkQZB","form-text":"loginForm_form-text__upGGb","change-btn":"loginForm_change-btn__hjJBr","combine-products-btn":"loginForm_combine-products-btn__GLs3W"};

/***/ }),

/***/ 94822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"phone-form":"phoneForm_phone-form__e7Crt","form-control-wrapper":"phoneForm_form-control-wrapper__NbqCv","withError":"phoneForm_withError__159fE","label":"phoneForm_label__h0SRy","form-control":"phoneForm_form-control__E3jqc","errorText":"phoneForm_errorText__8o0QV","agree-txt":"phoneForm_agree-txt__0MDtD","submit-btn":"phoneForm_submit-btn__QkpUJ","load":"phoneForm_load__5AWg3"};

/***/ }),

/***/ 7403:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NavPopular_container__Dobu7","smartBanner":"NavPopular_smartBanner__yVoSz","list":"NavPopular_list__lWFtm","item":"NavPopular_item__Yujgr","link":"NavPopular_link__Kvtqu","activeLink":"NavPopular_activeLink__qJdO1","sale":"NavPopular_sale__EfDnW","load":"NavPopular_load__vFWyF"};

/***/ }),

/***/ 16194:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigate_nav__JNSJ_","toggle":"Navigate_toggle__nckV9","wrapper":"Navigate_wrapper__vHiIQ","visible":"Navigate_visible__Uyqn0","listWrapp":"Navigate_listWrapp__bIGXk","listScroll":"Navigate_listScroll__8koHJ","load":"Navigate_load__xnVpg"};

/***/ }),

/***/ 48274:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"ItemWithDropdown_item__zHm2W","listWrap2":"ItemWithDropdown_listWrap2__vC4dv","leaved":"ItemWithDropdown_leaved__w6Jl5","visible":"ItemWithDropdown_visible__Wg_tU","listScroll2":"ItemWithDropdown_listScroll2__4BOtw","listScroll3":"ItemWithDropdown_listScroll3__rN_nq","hidden":"ItemWithDropdown_hidden__3qK5F","open":"ItemWithDropdown_open__TySpH","list2":"ItemWithDropdown_list2__FGtyc","link":"ItemWithDropdown_link__cMonZ","level1":"ItemWithDropdown_level1__iEFUn","isOpened":"ItemWithDropdown_isOpened__ia57J","level2":"ItemWithDropdown_level2__A_rG5","level3":"ItemWithDropdown_level3__wsMlA","premium":"ItemWithDropdown_premium__ln5dj","sale":"ItemWithDropdown_sale__c8fFF","btnContainer":"ItemWithDropdown_btnContainer__J8dpq","sectionButton":"ItemWithDropdown_sectionButton__3Q4wi","load":"ItemWithDropdown_load__MApy_"};

/***/ }),

/***/ 40864:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"NavList_list__rANRU"};

/***/ }),

/***/ 957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__8FmCd","link":"News_link__tEzQI","content":"News_content__Dr3nC","title":"News_title__xN0dp","date":"News_date__fEhWS","img":"News_img__Olw0u","item":"News_item__JFLxp","special":"News_special__JX6oR","load":"News_load__FitJ6"};

/***/ }),

/***/ 26859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"specialOffers":"SpecialOffers_specialOffers__jBiI3","img":"SpecialOffers_img__MN66r","title":"SpecialOffers_title__Zo8Hk","subTitle":"SpecialOffers_subTitle__3MK__","load":"SpecialOffers_load__5nHXU"};

/***/ }),

/***/ 75247:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"CartPage_breadCrumbs__6dlfR","title":"CartPage_title__b8Xze","cartSection":"CartPage_cartSection__RvChU","cartContainer":"CartPage_cartContainer__IkTzZ","emptyText":"CartPage_emptyText__dXHYC"};

/***/ }),

/***/ 16179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"CatalogPage_page__kvIfX","seo":"CatalogPage_seo__PNQtb","breadCrumbs":"CatalogPage_breadCrumbs__PEP6C","header":"CatalogPage_header__YtUJn","left":"CatalogPage_left__rtuqm","title":"CatalogPage_title__i2fgb","productsQuantity":"CatalogPage_productsQuantity__C2bkn","right":"CatalogPage_right__q_Nf7","sortLabel":"CatalogPage_sortLabel__0wSuw","content":"CatalogPage_content__NMWg0","aside":"CatalogPage_aside__4M__M","scrollBox":"CatalogPage_scrollBox__Fp4FD","main":"CatalogPage_main__a3qnq","treeMobile":"CatalogPage_treeMobile__X8JWb","filterToggles":"CatalogPage_filterToggles__gTae2","tags":"CatalogPage_tags__q2kMc","appliedFilters":"CatalogPage_appliedFilters__wv4ux","products":"CatalogPage_products__u7lW_","productsEmpty":"CatalogPage_productsEmpty__5lQ9P","productsLoading":"CatalogPage_productsLoading__9Cx9W","disabledBlock":"CatalogPage_disabledBlock__PGJcK","load":"CatalogPage_load__r5QPn"};

/***/ }),

/***/ 48775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"LoginPage_section__TPorQ","container":"LoginPage_container__pQCfz","load":"LoginPage_load__8NhUU"};

/***/ }),

/***/ 74816:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__Rr1r1","content":"Page_content__jBY5h"};

/***/ }),

/***/ 47700:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"share":"TextPage_share__z8fFy","shareEmpty":"TextPage_shareEmpty__1rBzr","bread-crumbs":"TextPage_bread-crumbs__lfojr","blocks":"TextPage_blocks__fnKSy","news-blocks":"TextPage_news-blocks__PzWt6","sub-title":"TextPage_sub-title___BotZ","type":"TextPage_type__60HN2","date":"TextPage_date__rFWdJ","text-page-article":"TextPage_text-page-article__1hQE8","articles":"TextPage_articles__0ctgA","articles-title":"TextPage_articles-title__xQ3XN","link-button":"TextPage_link-button__sgX9G","load":"TextPage_load__6oo6v"};

/***/ }),

/***/ 58267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"WishlistPage_breadCrumbs__sLEM8","wishlistSection":"WishlistPage_wishlistSection__BEtzo","wishlistPagination":"WishlistPage_wishlistPagination__7Ssnf","wishlistContainer":"WishlistPage_wishlistContainer__XSqo1","emptyText":"WishlistPage_emptyText__9IWgZ","load":"WishlistPage_load__X1XND"};

/***/ }),

/***/ 75053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__juwf2","container":"Error_container___c02m","title":"Error_title__9lInM","text":"Error_text__Jz3d8","button":"Error_button__dAdhR","logo":"Error_logo__SsLx3","logo-link":"Error_logo-link__rDINA","logoImg":"Error_logoImg__LqIQj","number":"Error_number__K29h9","title500":"Error_title500__Suzze","text500":"Error_text500__USc8h","button500":"Error_button500___IT5r","link":"Error_link__QsA53","load":"Error_load__CLdTd"};

/***/ }),

/***/ 17329:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 65729:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 60016:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 53402:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 50781:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57268:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(78566)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(69898)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ }),

/***/ 70743:
/***/ (function(module) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if ( true && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),

/***/ 74865:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 70631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var inspectCustom = (__webpack_require__(24654).custom);
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if ('cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 86606:
/***/ (function(module) {

/*!
 * Pusher JavaScript Library v8.3.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_669__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_669__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_669__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_669__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_669__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_669__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_669__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_669__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_669__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_669__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_669__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_669__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_669__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_669__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_669__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_669__(__nested_webpack_require_669__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package base64 implements Base64 encoding and decoding.
 */
// Invalid character used in decoding to indicate
// that the character to decode is out of range of
// alphabet and cannot be decoded.
var INVALID_BYTE = 256;
/**
 * Implements standard Base64 encoding.
 *
 * Operates in constant time.
 */
var Coder = /** @class */ (function () {
    // TODO(dchest): methods to encode chunk-by-chunk.
    function Coder(_paddingCharacter) {
        if (_paddingCharacter === void 0) { _paddingCharacter = "="; }
        this._paddingCharacter = _paddingCharacter;
    }
    Coder.prototype.encodedLength = function (length) {
        if (!this._paddingCharacter) {
            return (length * 8 + 5) / 6 | 0;
        }
        return (length + 2) / 3 * 4 | 0;
    };
    Coder.prototype.encode = function (data) {
        var out = "";
        var i = 0;
        for (; i < data.length - 2; i += 3) {
            var c = (data[i] << 16) | (data[i + 1] << 8) | (data[i + 2]);
            out += this._encodeByte((c >>> 3 * 6) & 63);
            out += this._encodeByte((c >>> 2 * 6) & 63);
            out += this._encodeByte((c >>> 1 * 6) & 63);
            out += this._encodeByte((c >>> 0 * 6) & 63);
        }
        var left = data.length - i;
        if (left > 0) {
            var c = (data[i] << 16) | (left === 2 ? data[i + 1] << 8 : 0);
            out += this._encodeByte((c >>> 3 * 6) & 63);
            out += this._encodeByte((c >>> 2 * 6) & 63);
            if (left === 2) {
                out += this._encodeByte((c >>> 1 * 6) & 63);
            }
            else {
                out += this._paddingCharacter || "";
            }
            out += this._paddingCharacter || "";
        }
        return out;
    };
    Coder.prototype.maxDecodedLength = function (length) {
        if (!this._paddingCharacter) {
            return (length * 6 + 7) / 8 | 0;
        }
        return length / 4 * 3 | 0;
    };
    Coder.prototype.decodedLength = function (s) {
        return this.maxDecodedLength(s.length - this._getPaddingLength(s));
    };
    Coder.prototype.decode = function (s) {
        if (s.length === 0) {
            return new Uint8Array(0);
        }
        var paddingLength = this._getPaddingLength(s);
        var length = s.length - paddingLength;
        var out = new Uint8Array(this.maxDecodedLength(length));
        var op = 0;
        var i = 0;
        var haveBad = 0;
        var v0 = 0, v1 = 0, v2 = 0, v3 = 0;
        for (; i < length - 4; i += 4) {
            v0 = this._decodeChar(s.charCodeAt(i + 0));
            v1 = this._decodeChar(s.charCodeAt(i + 1));
            v2 = this._decodeChar(s.charCodeAt(i + 2));
            v3 = this._decodeChar(s.charCodeAt(i + 3));
            out[op++] = (v0 << 2) | (v1 >>> 4);
            out[op++] = (v1 << 4) | (v2 >>> 2);
            out[op++] = (v2 << 6) | v3;
            haveBad |= v0 & INVALID_BYTE;
            haveBad |= v1 & INVALID_BYTE;
            haveBad |= v2 & INVALID_BYTE;
            haveBad |= v3 & INVALID_BYTE;
        }
        if (i < length - 1) {
            v0 = this._decodeChar(s.charCodeAt(i));
            v1 = this._decodeChar(s.charCodeAt(i + 1));
            out[op++] = (v0 << 2) | (v1 >>> 4);
            haveBad |= v0 & INVALID_BYTE;
            haveBad |= v1 & INVALID_BYTE;
        }
        if (i < length - 2) {
            v2 = this._decodeChar(s.charCodeAt(i + 2));
            out[op++] = (v1 << 4) | (v2 >>> 2);
            haveBad |= v2 & INVALID_BYTE;
        }
        if (i < length - 3) {
            v3 = this._decodeChar(s.charCodeAt(i + 3));
            out[op++] = (v2 << 6) | v3;
            haveBad |= v3 & INVALID_BYTE;
        }
        if (haveBad !== 0) {
            throw new Error("Base64Coder: incorrect characters for decoding");
        }
        return out;
    };
    // Standard encoding have the following encoded/decoded ranges,
    // which we need to convert between.
    //
    // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  +   /
    // Index:   0 - 25                    26 - 51              52 - 61   62  63
    // ASCII:  65 - 90                    97 - 122             48 - 57   43  47
    //
    // Encode 6 bits in b into a new character.
    Coder.prototype._encodeByte = function (b) {
        // Encoding uses constant time operations as follows:
        //
        // 1. Define comparison of A with B using (A - B) >>> 8:
        //          if A > B, then result is positive integer
        //          if A <= B, then result is 0
        //
        // 2. Define selection of C or 0 using bitwise AND: X & C:
        //          if X == 0, then result is 0
        //          if X != 0, then result is C
        //
        // 3. Start with the smallest comparison (b >= 0), which is always
        //    true, so set the result to the starting ASCII value (65).
        //
        // 4. Continue comparing b to higher ASCII values, and selecting
        //    zero if comparison isn't true, otherwise selecting a value
        //    to add to result, which:
        //
        //          a) undoes the previous addition
        //          b) provides new value to add
        //
        var result = b;
        // b >= 0
        result += 65;
        // b > 25
        result += ((25 - b) >>> 8) & ((0 - 65) - 26 + 97);
        // b > 51
        result += ((51 - b) >>> 8) & ((26 - 97) - 52 + 48);
        // b > 61
        result += ((61 - b) >>> 8) & ((52 - 48) - 62 + 43);
        // b > 62
        result += ((62 - b) >>> 8) & ((62 - 43) - 63 + 47);
        return String.fromCharCode(result);
    };
    // Decode a character code into a byte.
    // Must return 256 if character is out of alphabet range.
    Coder.prototype._decodeChar = function (c) {
        // Decoding works similar to encoding: using the same comparison
        // function, but now it works on ranges: result is always incremented
        // by value, but this value becomes zero if the range is not
        // satisfied.
        //
        // Decoding starts with invalid value, 256, which is then
        // subtracted when the range is satisfied. If none of the ranges
        // apply, the function returns 256, which is then checked by
        // the caller to throw error.
        var result = INVALID_BYTE; // start with invalid character
        // c == 43 (c > 42 and c < 44)
        result += (((42 - c) & (c - 44)) >>> 8) & (-INVALID_BYTE + c - 43 + 62);
        // c == 47 (c > 46 and c < 48)
        result += (((46 - c) & (c - 48)) >>> 8) & (-INVALID_BYTE + c - 47 + 63);
        // c > 47 and c < 58
        result += (((47 - c) & (c - 58)) >>> 8) & (-INVALID_BYTE + c - 48 + 52);
        // c > 64 and c < 91
        result += (((64 - c) & (c - 91)) >>> 8) & (-INVALID_BYTE + c - 65 + 0);
        // c > 96 and c < 123
        result += (((96 - c) & (c - 123)) >>> 8) & (-INVALID_BYTE + c - 97 + 26);
        return result;
    };
    Coder.prototype._getPaddingLength = function (s) {
        var paddingLength = 0;
        if (this._paddingCharacter) {
            for (var i = s.length - 1; i >= 0; i--) {
                if (s[i] !== this._paddingCharacter) {
                    break;
                }
                paddingLength++;
            }
            if (s.length < 4 || paddingLength > 2) {
                throw new Error("Base64Coder: incorrect padding");
            }
        }
        return paddingLength;
    };
    return Coder;
}());
exports.Coder = Coder;
var stdCoder = new Coder();
function encode(data) {
    return stdCoder.encode(data);
}
exports.encode = encode;
function decode(s) {
    return stdCoder.decode(s);
}
exports.decode = decode;
/**
 * Implements URL-safe Base64 encoding.
 * (Same as Base64, but '+' is replaced with '-', and '/' with '_').
 *
 * Operates in constant time.
 */
var URLSafeCoder = /** @class */ (function (_super) {
    __extends(URLSafeCoder, _super);
    function URLSafeCoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // URL-safe encoding have the following encoded/decoded ranges:
    //
    // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  -   _
    // Index:   0 - 25                    26 - 51              52 - 61   62  63
    // ASCII:  65 - 90                    97 - 122             48 - 57   45  95
    //
    URLSafeCoder.prototype._encodeByte = function (b) {
        var result = b;
        // b >= 0
        result += 65;
        // b > 25
        result += ((25 - b) >>> 8) & ((0 - 65) - 26 + 97);
        // b > 51
        result += ((51 - b) >>> 8) & ((26 - 97) - 52 + 48);
        // b > 61
        result += ((61 - b) >>> 8) & ((52 - 48) - 62 + 45);
        // b > 62
        result += ((62 - b) >>> 8) & ((62 - 45) - 63 + 95);
        return String.fromCharCode(result);
    };
    URLSafeCoder.prototype._decodeChar = function (c) {
        var result = INVALID_BYTE;
        // c == 45 (c > 44 and c < 46)
        result += (((44 - c) & (c - 46)) >>> 8) & (-INVALID_BYTE + c - 45 + 62);
        // c == 95 (c > 94 and c < 96)
        result += (((94 - c) & (c - 96)) >>> 8) & (-INVALID_BYTE + c - 95 + 63);
        // c > 47 and c < 58
        result += (((47 - c) & (c - 58)) >>> 8) & (-INVALID_BYTE + c - 48 + 52);
        // c > 64 and c < 91
        result += (((64 - c) & (c - 91)) >>> 8) & (-INVALID_BYTE + c - 65 + 0);
        // c > 96 and c < 123
        result += (((96 - c) & (c - 123)) >>> 8) & (-INVALID_BYTE + c - 97 + 26);
        return result;
    };
    return URLSafeCoder;
}(Coder));
exports.URLSafeCoder = URLSafeCoder;
var urlSafeCoder = new URLSafeCoder();
function encodeURLSafe(data) {
    return urlSafeCoder.encode(data);
}
exports.encodeURLSafe = encodeURLSafe;
function decodeURLSafe(s) {
    return urlSafeCoder.decode(s);
}
exports.decodeURLSafe = decodeURLSafe;
exports.encodedLength = function (length) {
    return stdCoder.encodedLength(length);
};
exports.maxDecodedLength = function (length) {
    return stdCoder.maxDecodedLength(length);
};
exports.decodedLength = function (s) {
    return stdCoder.decodedLength(s);
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package utf8 implements UTF-8 encoding and decoding.
 */
var INVALID_UTF16 = "utf8: invalid string";
var INVALID_UTF8 = "utf8: invalid source encoding";
/**
 * Encodes the given string into UTF-8 byte array.
 * Throws if the source string has invalid UTF-16 encoding.
 */
function encode(s) {
    // Calculate result length and allocate output array.
    // encodedLength() also validates string and throws errors,
    // so we don't need repeat validation here.
    var arr = new Uint8Array(encodedLength(s));
    var pos = 0;
    for (var i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i);
        if (c < 0x80) {
            arr[pos++] = c;
        }
        else if (c < 0x800) {
            arr[pos++] = 0xc0 | c >> 6;
            arr[pos++] = 0x80 | c & 0x3f;
        }
        else if (c < 0xd800) {
            arr[pos++] = 0xe0 | c >> 12;
            arr[pos++] = 0x80 | (c >> 6) & 0x3f;
            arr[pos++] = 0x80 | c & 0x3f;
        }
        else {
            i++; // get one more character
            c = (c & 0x3ff) << 10;
            c |= s.charCodeAt(i) & 0x3ff;
            c += 0x10000;
            arr[pos++] = 0xf0 | c >> 18;
            arr[pos++] = 0x80 | (c >> 12) & 0x3f;
            arr[pos++] = 0x80 | (c >> 6) & 0x3f;
            arr[pos++] = 0x80 | c & 0x3f;
        }
    }
    return arr;
}
exports.encode = encode;
/**
 * Returns the number of bytes required to encode the given string into UTF-8.
 * Throws if the source string has invalid UTF-16 encoding.
 */
function encodedLength(s) {
    var result = 0;
    for (var i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i);
        if (c < 0x80) {
            result += 1;
        }
        else if (c < 0x800) {
            result += 2;
        }
        else if (c < 0xd800) {
            result += 3;
        }
        else if (c <= 0xdfff) {
            if (i >= s.length - 1) {
                throw new Error(INVALID_UTF16);
            }
            i++; // "eat" next character
            result += 4;
        }
        else {
            throw new Error(INVALID_UTF16);
        }
    }
    return result;
}
exports.encodedLength = encodedLength;
/**
 * Decodes the given byte array from UTF-8 into a string.
 * Throws if encoding is invalid.
 */
function decode(arr) {
    var chars = [];
    for (var i = 0; i < arr.length; i++) {
        var b = arr[i];
        if (b & 0x80) {
            var min = void 0;
            if (b < 0xe0) {
                // Need 1 more byte.
                if (i >= arr.length) {
                    throw new Error(INVALID_UTF8);
                }
                var n1 = arr[++i];
                if ((n1 & 0xc0) !== 0x80) {
                    throw new Error(INVALID_UTF8);
                }
                b = (b & 0x1f) << 6 | (n1 & 0x3f);
                min = 0x80;
            }
            else if (b < 0xf0) {
                // Need 2 more bytes.
                if (i >= arr.length - 1) {
                    throw new Error(INVALID_UTF8);
                }
                var n1 = arr[++i];
                var n2 = arr[++i];
                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) {
                    throw new Error(INVALID_UTF8);
                }
                b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | (n2 & 0x3f);
                min = 0x800;
            }
            else if (b < 0xf8) {
                // Need 3 more bytes.
                if (i >= arr.length - 2) {
                    throw new Error(INVALID_UTF8);
                }
                var n1 = arr[++i];
                var n2 = arr[++i];
                var n3 = arr[++i];
                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) {
                    throw new Error(INVALID_UTF8);
                }
                b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | (n3 & 0x3f);
                min = 0x10000;
            }
            else {
                throw new Error(INVALID_UTF8);
            }
            if (b < min || (b >= 0xd800 && b <= 0xdfff)) {
                throw new Error(INVALID_UTF8);
            }
            if (b >= 0x10000) {
                // Surrogate pair.
                if (b > 0x10ffff) {
                    throw new Error(INVALID_UTF8);
                }
                b -= 0x10000;
                chars.push(String.fromCharCode(0xd800 | (b >> 10)));
                b = 0xdc00 | (b & 0x3ff);
            }
        }
        chars.push(String.fromCharCode(b));
    }
    return chars.join("");
}
exports.decode = decode;


/***/ }),
/* 2 */
/***/ (function(module, exports, __nested_webpack_require_19901__) {

// required so we don't have to do require('pusher').default etc.
module.exports = __nested_webpack_require_19901__(3).default;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_20105__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_20105__.r(__webpack_exports__);

// CONCATENATED MODULE: ./src/runtimes/web/dom/script_receiver_factory.ts
class ScriptReceiverFactory {
    constructor(prefix, name) {
        this.lastId = 0;
        this.prefix = prefix;
        this.name = name;
    }
    create(callback) {
        this.lastId++;
        var number = this.lastId;
        var id = this.prefix + number;
        var name = this.name + '[' + number + ']';
        var called = false;
        var callbackWrapper = function () {
            if (!called) {
                callback.apply(null, arguments);
                called = true;
            }
        };
        this[number] = callbackWrapper;
        return { number: number, id: id, name: name, callback: callbackWrapper };
    }
    remove(receiver) {
        delete this[receiver.number];
    }
}
var ScriptReceivers = new ScriptReceiverFactory('_pusher_script_', 'Pusher.ScriptReceivers');

// CONCATENATED MODULE: ./src/core/defaults.ts
var Defaults = {
    VERSION: "8.3.0",
    PROTOCOL: 7,
    wsPort: 80,
    wssPort: 443,
    wsPath: '',
    httpHost: 'sockjs.pusher.com',
    httpPort: 80,
    httpsPort: 443,
    httpPath: '/pusher',
    stats_host: 'stats.pusher.com',
    authEndpoint: '/pusher/auth',
    authTransport: 'ajax',
    activityTimeout: 120000,
    pongTimeout: 30000,
    unavailableTimeout: 10000,
    userAuthentication: {
        endpoint: '/pusher/user-auth',
        transport: 'ajax'
    },
    channelAuthorization: {
        endpoint: '/pusher/auth',
        transport: 'ajax'
    },
    cdn_http: "http://js.pusher.com",
    cdn_https: "https://js.pusher.com",
    dependency_suffix: ""
};
/* harmony default export */ var defaults = (Defaults);

// CONCATENATED MODULE: ./src/runtimes/web/dom/dependency_loader.ts


class dependency_loader_DependencyLoader {
    constructor(options) {
        this.options = options;
        this.receivers = options.receivers || ScriptReceivers;
        this.loading = {};
    }
    load(name, options, callback) {
        var self = this;
        if (self.loading[name] && self.loading[name].length > 0) {
            self.loading[name].push(callback);
        }
        else {
            self.loading[name] = [callback];
            var request = runtime.createScriptRequest(self.getPath(name, options));
            var receiver = self.receivers.create(function (error) {
                self.receivers.remove(receiver);
                if (self.loading[name]) {
                    var callbacks = self.loading[name];
                    delete self.loading[name];
                    var successCallback = function (wasSuccessful) {
                        if (!wasSuccessful) {
                            request.cleanup();
                        }
                    };
                    for (var i = 0; i < callbacks.length; i++) {
                        callbacks[i](error, successCallback);
                    }
                }
            });
            request.send(receiver);
        }
    }
    getRoot(options) {
        var cdn;
        var protocol = runtime.getDocument().location.protocol;
        if ((options && options.useTLS) || protocol === 'https:') {
            cdn = this.options.cdn_https;
        }
        else {
            cdn = this.options.cdn_http;
        }
        return cdn.replace(/\/*$/, '') + '/' + this.options.version;
    }
    getPath(name, options) {
        return this.getRoot(options) + '/' + name + this.options.suffix + '.js';
    }
}

// CONCATENATED MODULE: ./src/runtimes/web/dom/dependencies.ts



var DependenciesReceivers = new ScriptReceiverFactory('_pusher_dependencies', 'Pusher.DependenciesReceivers');
var Dependencies = new dependency_loader_DependencyLoader({
    cdn_http: defaults.cdn_http,
    cdn_https: defaults.cdn_https,
    version: defaults.VERSION,
    suffix: defaults.dependency_suffix,
    receivers: DependenciesReceivers
});

// CONCATENATED MODULE: ./src/core/utils/url_store.ts
const urlStore = {
    baseUrl: 'https://pusher.com',
    urls: {
        authenticationEndpoint: {
            path: '/docs/channels/server_api/authenticating_users'
        },
        authorizationEndpoint: {
            path: '/docs/channels/server_api/authorizing-users/'
        },
        javascriptQuickStart: {
            path: '/docs/javascript_quick_start'
        },
        triggeringClientEvents: {
            path: '/docs/client_api_guide/client_events#trigger-events'
        },
        encryptedChannelSupport: {
            fullUrl: 'https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support'
        }
    }
};
const buildLogSuffix = function (key) {
    const urlPrefix = 'See:';
    const urlObj = urlStore.urls[key];
    if (!urlObj)
        return '';
    let url;
    if (urlObj.fullUrl) {
        url = urlObj.fullUrl;
    }
    else if (urlObj.path) {
        url = urlStore.baseUrl + urlObj.path;
    }
    if (!url)
        return '';
    return `${urlPrefix} ${url}`;
};
/* harmony default export */ var url_store = ({ buildLogSuffix });

// CONCATENATED MODULE: ./src/core/auth/options.ts
var AuthRequestType;
(function (AuthRequestType) {
    AuthRequestType["UserAuthentication"] = "user-authentication";
    AuthRequestType["ChannelAuthorization"] = "channel-authorization";
})(AuthRequestType || (AuthRequestType = {}));

// CONCATENATED MODULE: ./src/core/errors.ts
class BadEventName extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class BadChannelName extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class RequestTimedOut extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class TransportPriorityTooLow extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class TransportClosed extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class UnsupportedFeature extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class UnsupportedTransport extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class UnsupportedStrategy extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class HTTPAuthError extends Error {
    constructor(status, msg) {
        super(msg);
        this.status = status;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

// CONCATENATED MODULE: ./src/runtimes/isomorphic/auth/xhr_auth.ts




const ajax = function (context, query, authOptions, authRequestType, callback) {
    const xhr = runtime.createXHR();
    xhr.open('POST', authOptions.endpoint, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    for (var headerName in authOptions.headers) {
        xhr.setRequestHeader(headerName, authOptions.headers[headerName]);
    }
    if (authOptions.headersProvider != null) {
        let dynamicHeaders = authOptions.headersProvider();
        for (var headerName in dynamicHeaders) {
            xhr.setRequestHeader(headerName, dynamicHeaders[headerName]);
        }
    }
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                let data;
                let parsed = false;
                try {
                    data = JSON.parse(xhr.responseText);
                    parsed = true;
                }
                catch (e) {
                    callback(new HTTPAuthError(200, `JSON returned from ${authRequestType.toString()} endpoint was invalid, yet status code was 200. Data was: ${xhr.responseText}`), null);
                }
                if (parsed) {
                    callback(null, data);
                }
            }
            else {
                let suffix = '';
                switch (authRequestType) {
                    case AuthRequestType.UserAuthentication:
                        suffix = url_store.buildLogSuffix('authenticationEndpoint');
                        break;
                    case AuthRequestType.ChannelAuthorization:
                        suffix = `Clients must be authorized to join private or presence channels. ${url_store.buildLogSuffix('authorizationEndpoint')}`;
                        break;
                }
                callback(new HTTPAuthError(xhr.status, `Unable to retrieve auth string from ${authRequestType.toString()} endpoint - ` +
                    `received status: ${xhr.status} from ${authOptions.endpoint}. ${suffix}`), null);
            }
        }
    };
    xhr.send(query);
    return xhr;
};
/* harmony default export */ var xhr_auth = (ajax);

// CONCATENATED MODULE: ./src/core/base64.ts
function encode(s) {
    return btoa(utob(s));
}
var fromCharCode = String.fromCharCode;
var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
var b64tab = {};
for (var base64_i = 0, l = b64chars.length; base64_i < l; base64_i++) {
    b64tab[b64chars.charAt(base64_i)] = base64_i;
}
var cb_utob = function (c) {
    var cc = c.charCodeAt(0);
    return cc < 0x80
        ? c
        : cc < 0x800
            ? fromCharCode(0xc0 | (cc >>> 6)) + fromCharCode(0x80 | (cc & 0x3f))
            : fromCharCode(0xe0 | ((cc >>> 12) & 0x0f)) +
                fromCharCode(0x80 | ((cc >>> 6) & 0x3f)) +
                fromCharCode(0x80 | (cc & 0x3f));
};
var utob = function (u) {
    return u.replace(/[^\x00-\x7F]/g, cb_utob);
};
var cb_encode = function (ccc) {
    var padlen = [0, 2, 1][ccc.length % 3];
    var ord = (ccc.charCodeAt(0) << 16) |
        ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8) |
        (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
    var chars = [
        b64chars.charAt(ord >>> 18),
        b64chars.charAt((ord >>> 12) & 63),
        padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
        padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
    ];
    return chars.join('');
};
var btoa = window.btoa ||
    function (b) {
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };

// CONCATENATED MODULE: ./src/core/utils/timers/abstract_timer.ts
class Timer {
    constructor(set, clear, delay, callback) {
        this.clear = clear;
        this.timer = set(() => {
            if (this.timer) {
                this.timer = callback(this.timer);
            }
        }, delay);
    }
    isRunning() {
        return this.timer !== null;
    }
    ensureAborted() {
        if (this.timer) {
            this.clear(this.timer);
            this.timer = null;
        }
    }
}
/* harmony default export */ var abstract_timer = (Timer);

// CONCATENATED MODULE: ./src/core/utils/timers/index.ts

function timers_clearTimeout(timer) {
    window.clearTimeout(timer);
}
function timers_clearInterval(timer) {
    window.clearInterval(timer);
}
class timers_OneOffTimer extends abstract_timer {
    constructor(delay, callback) {
        super(setTimeout, timers_clearTimeout, delay, function (timer) {
            callback();
            return null;
        });
    }
}
class timers_PeriodicTimer extends abstract_timer {
    constructor(delay, callback) {
        super(setInterval, timers_clearInterval, delay, function (timer) {
            callback();
            return timer;
        });
    }
}

// CONCATENATED MODULE: ./src/core/util.ts

var Util = {
    now() {
        if (Date.now) {
            return Date.now();
        }
        else {
            return new Date().valueOf();
        }
    },
    defer(callback) {
        return new timers_OneOffTimer(0, callback);
    },
    method(name, ...args) {
        var boundArguments = Array.prototype.slice.call(arguments, 1);
        return function (object) {
            return object[name].apply(object, boundArguments.concat(arguments));
        };
    }
};
/* harmony default export */ var util = (Util);

// CONCATENATED MODULE: ./src/core/utils/collections.ts


function extend(target, ...sources) {
    for (var i = 0; i < sources.length; i++) {
        var extensions = sources[i];
        for (var property in extensions) {
            if (extensions[property] &&
                extensions[property].constructor &&
                extensions[property].constructor === Object) {
                target[property] = extend(target[property] || {}, extensions[property]);
            }
            else {
                target[property] = extensions[property];
            }
        }
    }
    return target;
}
function stringify() {
    var m = ['Pusher'];
    for (var i = 0; i < arguments.length; i++) {
        if (typeof arguments[i] === 'string') {
            m.push(arguments[i]);
        }
        else {
            m.push(safeJSONStringify(arguments[i]));
        }
    }
    return m.join(' : ');
}
function arrayIndexOf(array, item) {
    var nativeIndexOf = Array.prototype.indexOf;
    if (array === null) {
        return -1;
    }
    if (nativeIndexOf && array.indexOf === nativeIndexOf) {
        return array.indexOf(item);
    }
    for (var i = 0, l = array.length; i < l; i++) {
        if (array[i] === item) {
            return i;
        }
    }
    return -1;
}
function objectApply(object, f) {
    for (var key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            f(object[key], key, object);
        }
    }
}
function keys(object) {
    var keys = [];
    objectApply(object, function (_, key) {
        keys.push(key);
    });
    return keys;
}
function values(object) {
    var values = [];
    objectApply(object, function (value) {
        values.push(value);
    });
    return values;
}
function apply(array, f, context) {
    for (var i = 0; i < array.length; i++) {
        f.call(context || window, array[i], i, array);
    }
}
function map(array, f) {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        result.push(f(array[i], i, array, result));
    }
    return result;
}
function mapObject(object, f) {
    var result = {};
    objectApply(object, function (value, key) {
        result[key] = f(value);
    });
    return result;
}
function filter(array, test) {
    test =
        test ||
            function (value) {
                return !!value;
            };
    var result = [];
    for (var i = 0; i < array.length; i++) {
        if (test(array[i], i, array, result)) {
            result.push(array[i]);
        }
    }
    return result;
}
function filterObject(object, test) {
    var result = {};
    objectApply(object, function (value, key) {
        if ((test && test(value, key, object, result)) || Boolean(value)) {
            result[key] = value;
        }
    });
    return result;
}
function flatten(object) {
    var result = [];
    objectApply(object, function (value, key) {
        result.push([key, value]);
    });
    return result;
}
function any(array, test) {
    for (var i = 0; i < array.length; i++) {
        if (test(array[i], i, array)) {
            return true;
        }
    }
    return false;
}
function collections_all(array, test) {
    for (var i = 0; i < array.length; i++) {
        if (!test(array[i], i, array)) {
            return false;
        }
    }
    return true;
}
function encodeParamsObject(data) {
    return mapObject(data, function (value) {
        if (typeof value === 'object') {
            value = safeJSONStringify(value);
        }
        return encodeURIComponent(encode(value.toString()));
    });
}
function buildQueryString(data) {
    var params = filterObject(data, function (value) {
        return value !== undefined;
    });
    var query = map(flatten(encodeParamsObject(params)), util.method('join', '=')).join('&');
    return query;
}
function decycleObject(object) {
    var objects = [], paths = [];
    return (function derez(value, path) {
        var i, name, nu;
        switch (typeof value) {
            case 'object':
                if (!value) {
                    return null;
                }
                for (i = 0; i < objects.length; i += 1) {
                    if (objects[i] === value) {
                        return { $ref: paths[i] };
                    }
                }
                objects.push(value);
                paths.push(path);
                if (Object.prototype.toString.apply(value) === '[object Array]') {
                    nu = [];
                    for (i = 0; i < value.length; i += 1) {
                        nu[i] = derez(value[i], path + '[' + i + ']');
                    }
                }
                else {
                    nu = {};
                    for (name in value) {
                        if (Object.prototype.hasOwnProperty.call(value, name)) {
                            nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']');
                        }
                    }
                }
                return nu;
            case 'number':
            case 'string':
            case 'boolean':
                return value;
        }
    })(object, '$');
}
function safeJSONStringify(source) {
    try {
        return JSON.stringify(source);
    }
    catch (e) {
        return JSON.stringify(decycleObject(source));
    }
}

// CONCATENATED MODULE: ./src/core/logger.ts


class logger_Logger {
    constructor() {
        this.globalLog = (message) => {
            if (window.console && window.console.log) {
                window.console.log(message);
            }
        };
    }
    debug(...args) {
        this.log(this.globalLog, args);
    }
    warn(...args) {
        this.log(this.globalLogWarn, args);
    }
    error(...args) {
        this.log(this.globalLogError, args);
    }
    globalLogWarn(message) {
        if (window.console && window.console.warn) {
            window.console.warn(message);
        }
        else {
            this.globalLog(message);
        }
    }
    globalLogError(message) {
        if (window.console && window.console.error) {
            window.console.error(message);
        }
        else {
            this.globalLogWarn(message);
        }
    }
    log(defaultLoggingFunction, ...args) {
        var message = stringify.apply(this, arguments);
        if (core_pusher.log) {
            core_pusher.log(message);
        }
        else if (core_pusher.logToConsole) {
            const log = defaultLoggingFunction.bind(this);
            log(message);
        }
    }
}
/* harmony default export */ var logger = (new logger_Logger());

// CONCATENATED MODULE: ./src/runtimes/web/auth/jsonp_auth.ts

var jsonp = function (context, query, authOptions, authRequestType, callback) {
    if (authOptions.headers !== undefined ||
        authOptions.headersProvider != null) {
        logger.warn(`To send headers with the ${authRequestType.toString()} request, you must use AJAX, rather than JSONP.`);
    }
    var callbackName = context.nextAuthCallbackID.toString();
    context.nextAuthCallbackID++;
    var document = context.getDocument();
    var script = document.createElement('script');
    context.auth_callbacks[callbackName] = function (data) {
        callback(null, data);
    };
    var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
    script.src =
        authOptions.endpoint +
            '?callback=' +
            encodeURIComponent(callback_name) +
            '&' +
            query;
    var head = document.getElementsByTagName('head')[0] || document.documentElement;
    head.insertBefore(script, head.firstChild);
};
/* harmony default export */ var jsonp_auth = (jsonp);

// CONCATENATED MODULE: ./src/runtimes/web/dom/script_request.ts
class ScriptRequest {
    constructor(src) {
        this.src = src;
    }
    send(receiver) {
        var self = this;
        var errorString = 'Error loading ' + self.src;
        self.script = document.createElement('script');
        self.script.id = receiver.id;
        self.script.src = self.src;
        self.script.type = 'text/javascript';
        self.script.charset = 'UTF-8';
        if (self.script.addEventListener) {
            self.script.onerror = function () {
                receiver.callback(errorString);
            };
            self.script.onload = function () {
                receiver.callback(null);
            };
        }
        else {
            self.script.onreadystatechange = function () {
                if (self.script.readyState === 'loaded' ||
                    self.script.readyState === 'complete') {
                    receiver.callback(null);
                }
            };
        }
        if (self.script.async === undefined &&
            document.attachEvent &&
            /opera/i.test(navigator.userAgent)) {
            self.errorScript = document.createElement('script');
            self.errorScript.id = receiver.id + '_error';
            self.errorScript.text = receiver.name + "('" + errorString + "');";
            self.script.async = self.errorScript.async = false;
        }
        else {
            self.script.async = true;
        }
        var head = document.getElementsByTagName('head')[0];
        head.insertBefore(self.script, head.firstChild);
        if (self.errorScript) {
            head.insertBefore(self.errorScript, self.script.nextSibling);
        }
    }
    cleanup() {
        if (this.script) {
            this.script.onload = this.script.onerror = null;
            this.script.onreadystatechange = null;
        }
        if (this.script && this.script.parentNode) {
            this.script.parentNode.removeChild(this.script);
        }
        if (this.errorScript && this.errorScript.parentNode) {
            this.errorScript.parentNode.removeChild(this.errorScript);
        }
        this.script = null;
        this.errorScript = null;
    }
}

// CONCATENATED MODULE: ./src/runtimes/web/dom/jsonp_request.ts


class jsonp_request_JSONPRequest {
    constructor(url, data) {
        this.url = url;
        this.data = data;
    }
    send(receiver) {
        if (this.request) {
            return;
        }
        var query = buildQueryString(this.data);
        var url = this.url + '/' + receiver.number + '?' + query;
        this.request = runtime.createScriptRequest(url);
        this.request.send(receiver);
    }
    cleanup() {
        if (this.request) {
            this.request.cleanup();
        }
    }
}

// CONCATENATED MODULE: ./src/runtimes/web/timeline/jsonp_timeline.ts


var getAgent = function (sender, useTLS) {
    return function (data, callback) {
        var scheme = 'http' + (useTLS ? 's' : '') + '://';
        var url = scheme + (sender.host || sender.options.host) + sender.options.path;
        var request = runtime.createJSONPRequest(url, data);
        var receiver = runtime.ScriptReceivers.create(function (error, result) {
            ScriptReceivers.remove(receiver);
            request.cleanup();
            if (result && result.host) {
                sender.host = result.host;
            }
            if (callback) {
                callback(error, result);
            }
        });
        request.send(receiver);
    };
};
var jsonp_timeline_jsonp = {
    name: 'jsonp',
    getAgent
};
/* harmony default export */ var jsonp_timeline = (jsonp_timeline_jsonp);

// CONCATENATED MODULE: ./src/core/transports/url_schemes.ts

function getGenericURL(baseScheme, params, path) {
    var scheme = baseScheme + (params.useTLS ? 's' : '');
    var host = params.useTLS ? params.hostTLS : params.hostNonTLS;
    return scheme + '://' + host + path;
}
function getGenericPath(key, queryString) {
    var path = '/app/' + key;
    var query = '?protocol=' +
        defaults.PROTOCOL +
        '&client=js' +
        '&version=' +
        defaults.VERSION +
        (queryString ? '&' + queryString : '');
    return path + query;
}
var ws = {
    getInitial: function (key, params) {
        var path = (params.httpPath || '') + getGenericPath(key, 'flash=false');
        return getGenericURL('ws', params, path);
    }
};
var http = {
    getInitial: function (key, params) {
        var path = (params.httpPath || '/pusher') + getGenericPath(key);
        return getGenericURL('http', params, path);
    }
};
var sockjs = {
    getInitial: function (key, params) {
        return getGenericURL('http', params, params.httpPath || '/pusher');
    },
    getPath: function (key, params) {
        return getGenericPath(key);
    }
};

// CONCATENATED MODULE: ./src/core/events/callback_registry.ts

class callback_registry_CallbackRegistry {
    constructor() {
        this._callbacks = {};
    }
    get(name) {
        return this._callbacks[prefix(name)];
    }
    add(name, callback, context) {
        var prefixedEventName = prefix(name);
        this._callbacks[prefixedEventName] =
            this._callbacks[prefixedEventName] || [];
        this._callbacks[prefixedEventName].push({
            fn: callback,
            context: context
        });
    }
    remove(name, callback, context) {
        if (!name && !callback && !context) {
            this._callbacks = {};
            return;
        }
        var names = name ? [prefix(name)] : keys(this._callbacks);
        if (callback || context) {
            this.removeCallback(names, callback, context);
        }
        else {
            this.removeAllCallbacks(names);
        }
    }
    removeCallback(names, callback, context) {
        apply(names, function (name) {
            this._callbacks[name] = filter(this._callbacks[name] || [], function (binding) {
                return ((callback && callback !== binding.fn) ||
                    (context && context !== binding.context));
            });
            if (this._callbacks[name].length === 0) {
                delete this._callbacks[name];
            }
        }, this);
    }
    removeAllCallbacks(names) {
        apply(names, function (name) {
            delete this._callbacks[name];
        }, this);
    }
}
function prefix(name) {
    return '_' + name;
}

// CONCATENATED MODULE: ./src/core/events/dispatcher.ts


class dispatcher_Dispatcher {
    constructor(failThrough) {
        this.callbacks = new callback_registry_CallbackRegistry();
        this.global_callbacks = [];
        this.failThrough = failThrough;
    }
    bind(eventName, callback, context) {
        this.callbacks.add(eventName, callback, context);
        return this;
    }
    bind_global(callback) {
        this.global_callbacks.push(callback);
        return this;
    }
    unbind(eventName, callback, context) {
        this.callbacks.remove(eventName, callback, context);
        return this;
    }
    unbind_global(callback) {
        if (!callback) {
            this.global_callbacks = [];
            return this;
        }
        this.global_callbacks = filter(this.global_callbacks || [], c => c !== callback);
        return this;
    }
    unbind_all() {
        this.unbind();
        this.unbind_global();
        return this;
    }
    emit(eventName, data, metadata) {
        for (var i = 0; i < this.global_callbacks.length; i++) {
            this.global_callbacks[i](eventName, data);
        }
        var callbacks = this.callbacks.get(eventName);
        var args = [];
        if (metadata) {
            args.push(data, metadata);
        }
        else if (data) {
            args.push(data);
        }
        if (callbacks && callbacks.length > 0) {
            for (var i = 0; i < callbacks.length; i++) {
                callbacks[i].fn.apply(callbacks[i].context || window, args);
            }
        }
        else if (this.failThrough) {
            this.failThrough(eventName, data);
        }
        return this;
    }
}

// CONCATENATED MODULE: ./src/core/transports/transport_connection.ts





class transport_connection_TransportConnection extends dispatcher_Dispatcher {
    constructor(hooks, name, priority, key, options) {
        super();
        this.initialize = runtime.transportConnectionInitializer;
        this.hooks = hooks;
        this.name = name;
        this.priority = priority;
        this.key = key;
        this.options = options;
        this.state = 'new';
        this.timeline = options.timeline;
        this.activityTimeout = options.activityTimeout;
        this.id = this.timeline.generateUniqueID();
    }
    handlesActivityChecks() {
        return Boolean(this.hooks.handlesActivityChecks);
    }
    supportsPing() {
        return Boolean(this.hooks.supportsPing);
    }
    connect() {
        if (this.socket || this.state !== 'initialized') {
            return false;
        }
        var url = this.hooks.urls.getInitial(this.key, this.options);
        try {
            this.socket = this.hooks.getSocket(url, this.options);
        }
        catch (e) {
            util.defer(() => {
                this.onError(e);
                this.changeState('closed');
            });
            return false;
        }
        this.bindListeners();
        logger.debug('Connecting', { transport: this.name, url });
        this.changeState('connecting');
        return true;
    }
    close() {
        if (this.socket) {
            this.socket.close();
            return true;
        }
        else {
            return false;
        }
    }
    send(data) {
        if (this.state === 'open') {
            util.defer(() => {
                if (this.socket) {
                    this.socket.send(data);
                }
            });
            return true;
        }
        else {
            return false;
        }
    }
    ping() {
        if (this.state === 'open' && this.supportsPing()) {
            this.socket.ping();
        }
    }
    onOpen() {
        if (this.hooks.beforeOpen) {
            this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
        }
        this.changeState('open');
        this.socket.onopen = undefined;
    }
    onError(error) {
        this.emit('error', { type: 'WebSocketError', error: error });
        this.timeline.error(this.buildTimelineMessage({ error: error.toString() }));
    }
    onClose(closeEvent) {
        if (closeEvent) {
            this.changeState('closed', {
                code: closeEvent.code,
                reason: closeEvent.reason,
                wasClean: closeEvent.wasClean
            });
        }
        else {
            this.changeState('closed');
        }
        this.unbindListeners();
        this.socket = undefined;
    }
    onMessage(message) {
        this.emit('message', message);
    }
    onActivity() {
        this.emit('activity');
    }
    bindListeners() {
        this.socket.onopen = () => {
            this.onOpen();
        };
        this.socket.onerror = error => {
            this.onError(error);
        };
        this.socket.onclose = closeEvent => {
            this.onClose(closeEvent);
        };
        this.socket.onmessage = message => {
            this.onMessage(message);
        };
        if (this.supportsPing()) {
            this.socket.onactivity = () => {
                this.onActivity();
            };
        }
    }
    unbindListeners() {
        if (this.socket) {
            this.socket.onopen = undefined;
            this.socket.onerror = undefined;
            this.socket.onclose = undefined;
            this.socket.onmessage = undefined;
            if (this.supportsPing()) {
                this.socket.onactivity = undefined;
            }
        }
    }
    changeState(state, params) {
        this.state = state;
        this.timeline.info(this.buildTimelineMessage({
            state: state,
            params: params
        }));
        this.emit(state, params);
    }
    buildTimelineMessage(message) {
        return extend({ cid: this.id }, message);
    }
}

// CONCATENATED MODULE: ./src/core/transports/transport.ts

class transport_Transport {
    constructor(hooks) {
        this.hooks = hooks;
    }
    isSupported(environment) {
        return this.hooks.isSupported(environment);
    }
    createConnection(name, priority, key, options) {
        return new transport_connection_TransportConnection(this.hooks, name, priority, key, options);
    }
}

// CONCATENATED MODULE: ./src/runtimes/isomorphic/transports/transports.ts




var WSTransport = new transport_Transport({
    urls: ws,
    handlesActivityChecks: false,
    supportsPing: false,
    isInitialized: function () {
        return Boolean(runtime.getWebSocketAPI());
    },
    isSupported: function () {
        return Boolean(runtime.getWebSocketAPI());
    },
    getSocket: function (url) {
        return runtime.createWebSocket(url);
    }
});
var httpConfiguration = {
    urls: http,
    handlesActivityChecks: false,
    supportsPing: true,
    isInitialized: function () {
        return true;
    }
};
var streamingConfiguration = extend({
    getSocket: function (url) {
        return runtime.HTTPFactory.createStreamingSocket(url);
    }
}, httpConfiguration);
var pollingConfiguration = extend({
    getSocket: function (url) {
        return runtime.HTTPFactory.createPollingSocket(url);
    }
}, httpConfiguration);
var xhrConfiguration = {
    isSupported: function () {
        return runtime.isXHRSupported();
    }
};
var XHRStreamingTransport = new transport_Transport((extend({}, streamingConfiguration, xhrConfiguration)));
var XHRPollingTransport = new transport_Transport(extend({}, pollingConfiguration, xhrConfiguration));
var Transports = {
    ws: WSTransport,
    xhr_streaming: XHRStreamingTransport,
    xhr_polling: XHRPollingTransport
};
/* harmony default export */ var transports = (Transports);

// CONCATENATED MODULE: ./src/runtimes/web/transports/transports.ts






var SockJSTransport = new transport_Transport({
    file: 'sockjs',
    urls: sockjs,
    handlesActivityChecks: true,
    supportsPing: false,
    isSupported: function () {
        return true;
    },
    isInitialized: function () {
        return window.SockJS !== undefined;
    },
    getSocket: function (url, options) {
        return new window.SockJS(url, null, {
            js_path: Dependencies.getPath('sockjs', {
                useTLS: options.useTLS
            }),
            ignore_null_origin: options.ignoreNullOrigin
        });
    },
    beforeOpen: function (socket, path) {
        socket.send(JSON.stringify({
            path: path
        }));
    }
});
var xdrConfiguration = {
    isSupported: function (environment) {
        var yes = runtime.isXDRSupported(environment.useTLS);
        return yes;
    }
};
var XDRStreamingTransport = new transport_Transport((extend({}, streamingConfiguration, xdrConfiguration)));
var XDRPollingTransport = new transport_Transport(extend({}, pollingConfiguration, xdrConfiguration));
transports.xdr_streaming = XDRStreamingTransport;
transports.xdr_polling = XDRPollingTransport;
transports.sockjs = SockJSTransport;
/* harmony default export */ var transports_transports = (transports);

// CONCATENATED MODULE: ./src/runtimes/web/net_info.ts

class net_info_NetInfo extends dispatcher_Dispatcher {
    constructor() {
        super();
        var self = this;
        if (window.addEventListener !== undefined) {
            window.addEventListener('online', function () {
                self.emit('online');
            }, false);
            window.addEventListener('offline', function () {
                self.emit('offline');
            }, false);
        }
    }
    isOnline() {
        if (window.navigator.onLine === undefined) {
            return true;
        }
        else {
            return window.navigator.onLine;
        }
    }
}
var net_info_Network = new net_info_NetInfo();

// CONCATENATED MODULE: ./src/core/transports/assistant_to_the_transport_manager.ts


class assistant_to_the_transport_manager_AssistantToTheTransportManager {
    constructor(manager, transport, options) {
        this.manager = manager;
        this.transport = transport;
        this.minPingDelay = options.minPingDelay;
        this.maxPingDelay = options.maxPingDelay;
        this.pingDelay = undefined;
    }
    createConnection(name, priority, key, options) {
        options = extend({}, options, {
            activityTimeout: this.pingDelay
        });
        var connection = this.transport.createConnection(name, priority, key, options);
        var openTimestamp = null;
        var onOpen = function () {
            connection.unbind('open', onOpen);
            connection.bind('closed', onClosed);
            openTimestamp = util.now();
        };
        var onClosed = closeEvent => {
            connection.unbind('closed', onClosed);
            if (closeEvent.code === 1002 || closeEvent.code === 1003) {
                this.manager.reportDeath();
            }
            else if (!closeEvent.wasClean && openTimestamp) {
                var lifespan = util.now() - openTimestamp;
                if (lifespan < 2 * this.maxPingDelay) {
                    this.manager.reportDeath();
                    this.pingDelay = Math.max(lifespan / 2, this.minPingDelay);
                }
            }
        };
        connection.bind('open', onOpen);
        return connection;
    }
    isSupported(environment) {
        return this.manager.isAlive() && this.transport.isSupported(environment);
    }
}

// CONCATENATED MODULE: ./src/core/connection/protocol/protocol.ts
const Protocol = {
    decodeMessage: function (messageEvent) {
        try {
            var messageData = JSON.parse(messageEvent.data);
            var pusherEventData = messageData.data;
            if (typeof pusherEventData === 'string') {
                try {
                    pusherEventData = JSON.parse(messageData.data);
                }
                catch (e) { }
            }
            var pusherEvent = {
                event: messageData.event,
                channel: messageData.channel,
                data: pusherEventData
            };
            if (messageData.user_id) {
                pusherEvent.user_id = messageData.user_id;
            }
            return pusherEvent;
        }
        catch (e) {
            throw { type: 'MessageParseError', error: e, data: messageEvent.data };
        }
    },
    encodeMessage: function (event) {
        return JSON.stringify(event);
    },
    processHandshake: function (messageEvent) {
        var message = Protocol.decodeMessage(messageEvent);
        if (message.event === 'pusher:connection_established') {
            if (!message.data.activity_timeout) {
                throw 'No activity timeout specified in handshake';
            }
            return {
                action: 'connected',
                id: message.data.socket_id,
                activityTimeout: message.data.activity_timeout * 1000
            };
        }
        else if (message.event === 'pusher:error') {
            return {
                action: this.getCloseAction(message.data),
                error: this.getCloseError(message.data)
            };
        }
        else {
            throw 'Invalid handshake';
        }
    },
    getCloseAction: function (closeEvent) {
        if (closeEvent.code < 4000) {
            if (closeEvent.code >= 1002 && closeEvent.code <= 1004) {
                return 'backoff';
            }
            else {
                return null;
            }
        }
        else if (closeEvent.code === 4000) {
            return 'tls_only';
        }
        else if (closeEvent.code < 4100) {
            return 'refused';
        }
        else if (closeEvent.code < 4200) {
            return 'backoff';
        }
        else if (closeEvent.code < 4300) {
            return 'retry';
        }
        else {
            return 'refused';
        }
    },
    getCloseError: function (closeEvent) {
        if (closeEvent.code !== 1000 && closeEvent.code !== 1001) {
            return {
                type: 'PusherError',
                data: {
                    code: closeEvent.code,
                    message: closeEvent.reason || closeEvent.message
                }
            };
        }
        else {
            return null;
        }
    }
};
/* harmony default export */ var protocol_protocol = (Protocol);

// CONCATENATED MODULE: ./src/core/connection/connection.ts




class connection_Connection extends dispatcher_Dispatcher {
    constructor(id, transport) {
        super();
        this.id = id;
        this.transport = transport;
        this.activityTimeout = transport.activityTimeout;
        this.bindListeners();
    }
    handlesActivityChecks() {
        return this.transport.handlesActivityChecks();
    }
    send(data) {
        return this.transport.send(data);
    }
    send_event(name, data, channel) {
        var event = { event: name, data: data };
        if (channel) {
            event.channel = channel;
        }
        logger.debug('Event sent', event);
        return this.send(protocol_protocol.encodeMessage(event));
    }
    ping() {
        if (this.transport.supportsPing()) {
            this.transport.ping();
        }
        else {
            this.send_event('pusher:ping', {});
        }
    }
    close() {
        this.transport.close();
    }
    bindListeners() {
        var listeners = {
            message: (messageEvent) => {
                var pusherEvent;
                try {
                    pusherEvent = protocol_protocol.decodeMessage(messageEvent);
                }
                catch (e) {
                    this.emit('error', {
                        type: 'MessageParseError',
                        error: e,
                        data: messageEvent.data
                    });
                }
                if (pusherEvent !== undefined) {
                    logger.debug('Event recd', pusherEvent);
                    switch (pusherEvent.event) {
                        case 'pusher:error':
                            this.emit('error', {
                                type: 'PusherError',
                                data: pusherEvent.data
                            });
                            break;
                        case 'pusher:ping':
                            this.emit('ping');
                            break;
                        case 'pusher:pong':
                            this.emit('pong');
                            break;
                    }
                    this.emit('message', pusherEvent);
                }
            },
            activity: () => {
                this.emit('activity');
            },
            error: error => {
                this.emit('error', error);
            },
            closed: closeEvent => {
                unbindListeners();
                if (closeEvent && closeEvent.code) {
                    this.handleCloseEvent(closeEvent);
                }
                this.transport = null;
                this.emit('closed');
            }
        };
        var unbindListeners = () => {
            objectApply(listeners, (listener, event) => {
                this.transport.unbind(event, listener);
            });
        };
        objectApply(listeners, (listener, event) => {
            this.transport.bind(event, listener);
        });
    }
    handleCloseEvent(closeEvent) {
        var action = protocol_protocol.getCloseAction(closeEvent);
        var error = protocol_protocol.getCloseError(closeEvent);
        if (error) {
            this.emit('error', error);
        }
        if (action) {
            this.emit(action, { action: action, error: error });
        }
    }
}

// CONCATENATED MODULE: ./src/core/connection/handshake/index.ts



class handshake_Handshake {
    constructor(transport, callback) {
        this.transport = transport;
        this.callback = callback;
        this.bindListeners();
    }
    close() {
        this.unbindListeners();
        this.transport.close();
    }
    bindListeners() {
        this.onMessage = m => {
            this.unbindListeners();
            var result;
            try {
                result = protocol_protocol.processHandshake(m);
            }
            catch (e) {
                this.finish('error', { error: e });
                this.transport.close();
                return;
            }
            if (result.action === 'connected') {
                this.finish('connected', {
                    connection: new connection_Connection(result.id, this.transport),
                    activityTimeout: result.activityTimeout
                });
            }
            else {
                this.finish(result.action, { error: result.error });
                this.transport.close();
            }
        };
        this.onClosed = closeEvent => {
            this.unbindListeners();
            var action = protocol_protocol.getCloseAction(closeEvent) || 'backoff';
            var error = protocol_protocol.getCloseError(closeEvent);
            this.finish(action, { error: error });
        };
        this.transport.bind('message', this.onMessage);
        this.transport.bind('closed', this.onClosed);
    }
    unbindListeners() {
        this.transport.unbind('message', this.onMessage);
        this.transport.unbind('closed', this.onClosed);
    }
    finish(action, params) {
        this.callback(extend({ transport: this.transport, action: action }, params));
    }
}

// CONCATENATED MODULE: ./src/core/timeline/timeline_sender.ts

class timeline_sender_TimelineSender {
    constructor(timeline, options) {
        this.timeline = timeline;
        this.options = options || {};
    }
    send(useTLS, callback) {
        if (this.timeline.isEmpty()) {
            return;
        }
        this.timeline.send(runtime.TimelineTransport.getAgent(this, useTLS), callback);
    }
}

// CONCATENATED MODULE: ./src/core/channels/channel.ts





class channel_Channel extends dispatcher_Dispatcher {
    constructor(name, pusher) {
        super(function (event, data) {
            logger.debug('No callbacks on ' + name + ' for ' + event);
        });
        this.name = name;
        this.pusher = pusher;
        this.subscribed = false;
        this.subscriptionPending = false;
        this.subscriptionCancelled = false;
    }
    authorize(socketId, callback) {
        return callback(null, { auth: '' });
    }
    trigger(event, data) {
        if (event.indexOf('client-') !== 0) {
            throw new BadEventName("Event '" + event + "' does not start with 'client-'");
        }
        if (!this.subscribed) {
            var suffix = url_store.buildLogSuffix('triggeringClientEvents');
            logger.warn(`Client event triggered before channel 'subscription_succeeded' event . ${suffix}`);
        }
        return this.pusher.send_event(event, data, this.name);
    }
    disconnect() {
        this.subscribed = false;
        this.subscriptionPending = false;
    }
    handleEvent(event) {
        var eventName = event.event;
        var data = event.data;
        if (eventName === 'pusher_internal:subscription_succeeded') {
            this.handleSubscriptionSucceededEvent(event);
        }
        else if (eventName === 'pusher_internal:subscription_count') {
            this.handleSubscriptionCountEvent(event);
        }
        else if (eventName.indexOf('pusher_internal:') !== 0) {
            var metadata = {};
            this.emit(eventName, data, metadata);
        }
    }
    handleSubscriptionSucceededEvent(event) {
        this.subscriptionPending = false;
        this.subscribed = true;
        if (this.subscriptionCancelled) {
            this.pusher.unsubscribe(this.name);
        }
        else {
            this.emit('pusher:subscription_succeeded', event.data);
        }
    }
    handleSubscriptionCountEvent(event) {
        if (event.data.subscription_count) {
            this.subscriptionCount = event.data.subscription_count;
        }
        this.emit('pusher:subscription_count', event.data);
    }
    subscribe() {
        if (this.subscribed) {
            return;
        }
        this.subscriptionPending = true;
        this.subscriptionCancelled = false;
        this.authorize(this.pusher.connection.socket_id, (error, data) => {
            if (error) {
                this.subscriptionPending = false;
                logger.error(error.toString());
                this.emit('pusher:subscription_error', Object.assign({}, {
                    type: 'AuthError',
                    error: error.message
                }, error instanceof HTTPAuthError ? { status: error.status } : {}));
            }
            else {
                this.pusher.send_event('pusher:subscribe', {
                    auth: data.auth,
                    channel_data: data.channel_data,
                    channel: this.name
                });
            }
        });
    }
    unsubscribe() {
        this.subscribed = false;
        this.pusher.send_event('pusher:unsubscribe', {
            channel: this.name
        });
    }
    cancelSubscription() {
        this.subscriptionCancelled = true;
    }
    reinstateSubscription() {
        this.subscriptionCancelled = false;
    }
}

// CONCATENATED MODULE: ./src/core/channels/private_channel.ts

class private_channel_PrivateChannel extends channel_Channel {
    authorize(socketId, callback) {
        return this.pusher.config.channelAuthorizer({
            channelName: this.name,
            socketId: socketId
        }, callback);
    }
}

// CONCATENATED MODULE: ./src/core/channels/members.ts

class members_Members {
    constructor() {
        this.reset();
    }
    get(id) {
        if (Object.prototype.hasOwnProperty.call(this.members, id)) {
            return {
                id: id,
                info: this.members[id]
            };
        }
        else {
            return null;
        }
    }
    each(callback) {
        objectApply(this.members, (member, id) => {
            callback(this.get(id));
        });
    }
    setMyID(id) {
        this.myID = id;
    }
    onSubscription(subscriptionData) {
        this.members = subscriptionData.presence.hash;
        this.count = subscriptionData.presence.count;
        this.me = this.get(this.myID);
    }
    addMember(memberData) {
        if (this.get(memberData.user_id) === null) {
            this.count++;
        }
        this.members[memberData.user_id] = memberData.user_info;
        return this.get(memberData.user_id);
    }
    removeMember(memberData) {
        var member = this.get(memberData.user_id);
        if (member) {
            delete this.members[memberData.user_id];
            this.count--;
        }
        return member;
    }
    reset() {
        this.members = {};
        this.count = 0;
        this.myID = null;
        this.me = null;
    }
}

// CONCATENATED MODULE: ./src/core/channels/presence_channel.ts
var __awaiter = ( false) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




class presence_channel_PresenceChannel extends private_channel_PrivateChannel {
    constructor(name, pusher) {
        super(name, pusher);
        this.members = new members_Members();
    }
    authorize(socketId, callback) {
        super.authorize(socketId, (error, authData) => __awaiter(this, void 0, void 0, function* () {
            if (!error) {
                authData = authData;
                if (authData.channel_data != null) {
                    var channelData = JSON.parse(authData.channel_data);
                    this.members.setMyID(channelData.user_id);
                }
                else {
                    yield this.pusher.user.signinDonePromise;
                    if (this.pusher.user.user_data != null) {
                        this.members.setMyID(this.pusher.user.user_data.id);
                    }
                    else {
                        let suffix = url_store.buildLogSuffix('authorizationEndpoint');
                        logger.error(`Invalid auth response for channel '${this.name}', ` +
                            `expected 'channel_data' field. ${suffix}, ` +
                            `or the user should be signed in.`);
                        callback('Invalid auth response');
                        return;
                    }
                }
            }
            callback(error, authData);
        }));
    }
    handleEvent(event) {
        var eventName = event.event;
        if (eventName.indexOf('pusher_internal:') === 0) {
            this.handleInternalEvent(event);
        }
        else {
            var data = event.data;
            var metadata = {};
            if (event.user_id) {
                metadata.user_id = event.user_id;
            }
            this.emit(eventName, data, metadata);
        }
    }
    handleInternalEvent(event) {
        var eventName = event.event;
        var data = event.data;
        switch (eventName) {
            case 'pusher_internal:subscription_succeeded':
                this.handleSubscriptionSucceededEvent(event);
                break;
            case 'pusher_internal:subscription_count':
                this.handleSubscriptionCountEvent(event);
                break;
            case 'pusher_internal:member_added':
                var addedMember = this.members.addMember(data);
                this.emit('pusher:member_added', addedMember);
                break;
            case 'pusher_internal:member_removed':
                var removedMember = this.members.removeMember(data);
                if (removedMember) {
                    this.emit('pusher:member_removed', removedMember);
                }
                break;
        }
    }
    handleSubscriptionSucceededEvent(event) {
        this.subscriptionPending = false;
        this.subscribed = true;
        if (this.subscriptionCancelled) {
            this.pusher.unsubscribe(this.name);
        }
        else {
            this.members.onSubscription(event.data);
            this.emit('pusher:subscription_succeeded', this.members);
        }
    }
    disconnect() {
        this.members.reset();
        super.disconnect();
    }
}

// EXTERNAL MODULE: ./node_modules/@stablelib/utf8/lib/utf8.js
var utf8 = __nested_webpack_require_20105__(1);

// EXTERNAL MODULE: ./node_modules/@stablelib/base64/lib/base64.js
var base64 = __nested_webpack_require_20105__(0);

// CONCATENATED MODULE: ./src/core/channels/encrypted_channel.ts





class encrypted_channel_EncryptedChannel extends private_channel_PrivateChannel {
    constructor(name, pusher, nacl) {
        super(name, pusher);
        this.key = null;
        this.nacl = nacl;
    }
    authorize(socketId, callback) {
        super.authorize(socketId, (error, authData) => {
            if (error) {
                callback(error, authData);
                return;
            }
            let sharedSecret = authData['shared_secret'];
            if (!sharedSecret) {
                callback(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                return;
            }
            this.key = Object(base64["decode"])(sharedSecret);
            delete authData['shared_secret'];
            callback(null, authData);
        });
    }
    trigger(event, data) {
        throw new UnsupportedFeature('Client events are not currently supported for encrypted channels');
    }
    handleEvent(event) {
        var eventName = event.event;
        var data = event.data;
        if (eventName.indexOf('pusher_internal:') === 0 ||
            eventName.indexOf('pusher:') === 0) {
            super.handleEvent(event);
            return;
        }
        this.handleEncryptedEvent(eventName, data);
    }
    handleEncryptedEvent(event, data) {
        if (!this.key) {
            logger.debug('Received encrypted event before key has been retrieved from the authEndpoint');
            return;
        }
        if (!data.ciphertext || !data.nonce) {
            logger.error('Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: ' +
                data);
            return;
        }
        let cipherText = Object(base64["decode"])(data.ciphertext);
        if (cipherText.length < this.nacl.secretbox.overheadLength) {
            logger.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${cipherText.length}`);
            return;
        }
        let nonce = Object(base64["decode"])(data.nonce);
        if (nonce.length < this.nacl.secretbox.nonceLength) {
            logger.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${nonce.length}`);
            return;
        }
        let bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
        if (bytes === null) {
            logger.debug('Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...');
            this.authorize(this.pusher.connection.socket_id, (error, authData) => {
                if (error) {
                    logger.error(`Failed to make a request to the authEndpoint: ${authData}. Unable to fetch new key, so dropping encrypted event`);
                    return;
                }
                bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                if (bytes === null) {
                    logger.error(`Failed to decrypt event with new key. Dropping encrypted event`);
                    return;
                }
                this.emit(event, this.getDataToEmit(bytes));
                return;
            });
            return;
        }
        this.emit(event, this.getDataToEmit(bytes));
    }
    getDataToEmit(bytes) {
        let raw = Object(utf8["decode"])(bytes);
        try {
            return JSON.parse(raw);
        }
        catch (_a) {
            return raw;
        }
    }
}

// CONCATENATED MODULE: ./src/core/connection/connection_manager.ts





class connection_manager_ConnectionManager extends dispatcher_Dispatcher {
    constructor(key, options) {
        super();
        this.state = 'initialized';
        this.connection = null;
        this.key = key;
        this.options = options;
        this.timeline = this.options.timeline;
        this.usingTLS = this.options.useTLS;
        this.errorCallbacks = this.buildErrorCallbacks();
        this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks);
        this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
        var Network = runtime.getNetwork();
        Network.bind('online', () => {
            this.timeline.info({ netinfo: 'online' });
            if (this.state === 'connecting' || this.state === 'unavailable') {
                this.retryIn(0);
            }
        });
        Network.bind('offline', () => {
            this.timeline.info({ netinfo: 'offline' });
            if (this.connection) {
                this.sendActivityCheck();
            }
        });
        this.updateStrategy();
    }
    connect() {
        if (this.connection || this.runner) {
            return;
        }
        if (!this.strategy.isSupported()) {
            this.updateState('failed');
            return;
        }
        this.updateState('connecting');
        this.startConnecting();
        this.setUnavailableTimer();
    }
    send(data) {
        if (this.connection) {
            return this.connection.send(data);
        }
        else {
            return false;
        }
    }
    send_event(name, data, channel) {
        if (this.connection) {
            return this.connection.send_event(name, data, channel);
        }
        else {
            return false;
        }
    }
    disconnect() {
        this.disconnectInternally();
        this.updateState('disconnected');
    }
    isUsingTLS() {
        return this.usingTLS;
    }
    startConnecting() {
        var callback = (error, handshake) => {
            if (error) {
                this.runner = this.strategy.connect(0, callback);
            }
            else {
                if (handshake.action === 'error') {
                    this.emit('error', {
                        type: 'HandshakeError',
                        error: handshake.error
                    });
                    this.timeline.error({ handshakeError: handshake.error });
                }
                else {
                    this.abortConnecting();
                    this.handshakeCallbacks[handshake.action](handshake);
                }
            }
        };
        this.runner = this.strategy.connect(0, callback);
    }
    abortConnecting() {
        if (this.runner) {
            this.runner.abort();
            this.runner = null;
        }
    }
    disconnectInternally() {
        this.abortConnecting();
        this.clearRetryTimer();
        this.clearUnavailableTimer();
        if (this.connection) {
            var connection = this.abandonConnection();
            connection.close();
        }
    }
    updateStrategy() {
        this.strategy = this.options.getStrategy({
            key: this.key,
            timeline: this.timeline,
            useTLS: this.usingTLS
        });
    }
    retryIn(delay) {
        this.timeline.info({ action: 'retry', delay: delay });
        if (delay > 0) {
            this.emit('connecting_in', Math.round(delay / 1000));
        }
        this.retryTimer = new timers_OneOffTimer(delay || 0, () => {
            this.disconnectInternally();
            this.connect();
        });
    }
    clearRetryTimer() {
        if (this.retryTimer) {
            this.retryTimer.ensureAborted();
            this.retryTimer = null;
        }
    }
    setUnavailableTimer() {
        this.unavailableTimer = new timers_OneOffTimer(this.options.unavailableTimeout, () => {
            this.updateState('unavailable');
        });
    }
    clearUnavailableTimer() {
        if (this.unavailableTimer) {
            this.unavailableTimer.ensureAborted();
        }
    }
    sendActivityCheck() {
        this.stopActivityCheck();
        this.connection.ping();
        this.activityTimer = new timers_OneOffTimer(this.options.pongTimeout, () => {
            this.timeline.error({ pong_timed_out: this.options.pongTimeout });
            this.retryIn(0);
        });
    }
    resetActivityCheck() {
        this.stopActivityCheck();
        if (this.connection && !this.connection.handlesActivityChecks()) {
            this.activityTimer = new timers_OneOffTimer(this.activityTimeout, () => {
                this.sendActivityCheck();
            });
        }
    }
    stopActivityCheck() {
        if (this.activityTimer) {
            this.activityTimer.ensureAborted();
        }
    }
    buildConnectionCallbacks(errorCallbacks) {
        return extend({}, errorCallbacks, {
            message: message => {
                this.resetActivityCheck();
                this.emit('message', message);
            },
            ping: () => {
                this.send_event('pusher:pong', {});
            },
            activity: () => {
                this.resetActivityCheck();
            },
            error: error => {
                this.emit('error', error);
            },
            closed: () => {
                this.abandonConnection();
                if (this.shouldRetry()) {
                    this.retryIn(1000);
                }
            }
        });
    }
    buildHandshakeCallbacks(errorCallbacks) {
        return extend({}, errorCallbacks, {
            connected: (handshake) => {
                this.activityTimeout = Math.min(this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
                this.clearUnavailableTimer();
                this.setConnection(handshake.connection);
                this.socket_id = this.connection.id;
                this.updateState('connected', { socket_id: this.socket_id });
            }
        });
    }
    buildErrorCallbacks() {
        let withErrorEmitted = callback => {
            return (result) => {
                if (result.error) {
                    this.emit('error', { type: 'WebSocketError', error: result.error });
                }
                callback(result);
            };
        };
        return {
            tls_only: withErrorEmitted(() => {
                this.usingTLS = true;
                this.updateStrategy();
                this.retryIn(0);
            }),
            refused: withErrorEmitted(() => {
                this.disconnect();
            }),
            backoff: withErrorEmitted(() => {
                this.retryIn(1000);
            }),
            retry: withErrorEmitted(() => {
                this.retryIn(0);
            })
        };
    }
    setConnection(connection) {
        this.connection = connection;
        for (var event in this.connectionCallbacks) {
            this.connection.bind(event, this.connectionCallbacks[event]);
        }
        this.resetActivityCheck();
    }
    abandonConnection() {
        if (!this.connection) {
            return;
        }
        this.stopActivityCheck();
        for (var event in this.connectionCallbacks) {
            this.connection.unbind(event, this.connectionCallbacks[event]);
        }
        var connection = this.connection;
        this.connection = null;
        return connection;
    }
    updateState(newState, data) {
        var previousState = this.state;
        this.state = newState;
        if (previousState !== newState) {
            var newStateDescription = newState;
            if (newStateDescription === 'connected') {
                newStateDescription += ' with new socket ID ' + data.socket_id;
            }
            logger.debug('State changed', previousState + ' -> ' + newStateDescription);
            this.timeline.info({ state: newState, params: data });
            this.emit('state_change', { previous: previousState, current: newState });
            this.emit(newState, data);
        }
    }
    shouldRetry() {
        return this.state === 'connecting' || this.state === 'connected';
    }
}

// CONCATENATED MODULE: ./src/core/channels/channels.ts




class channels_Channels {
    constructor() {
        this.channels = {};
    }
    add(name, pusher) {
        if (!this.channels[name]) {
            this.channels[name] = createChannel(name, pusher);
        }
        return this.channels[name];
    }
    all() {
        return values(this.channels);
    }
    find(name) {
        return this.channels[name];
    }
    remove(name) {
        var channel = this.channels[name];
        delete this.channels[name];
        return channel;
    }
    disconnect() {
        objectApply(this.channels, function (channel) {
            channel.disconnect();
        });
    }
}
function createChannel(name, pusher) {
    if (name.indexOf('private-encrypted-') === 0) {
        if (pusher.config.nacl) {
            return factory.createEncryptedChannel(name, pusher, pusher.config.nacl);
        }
        let errMsg = 'Tried to subscribe to a private-encrypted- channel but no nacl implementation available';
        let suffix = url_store.buildLogSuffix('encryptedChannelSupport');
        throw new UnsupportedFeature(`${errMsg}. ${suffix}`);
    }
    else if (name.indexOf('private-') === 0) {
        return factory.createPrivateChannel(name, pusher);
    }
    else if (name.indexOf('presence-') === 0) {
        return factory.createPresenceChannel(name, pusher);
    }
    else if (name.indexOf('#') === 0) {
        throw new BadChannelName('Cannot create a channel with name "' + name + '".');
    }
    else {
        return factory.createChannel(name, pusher);
    }
}

// CONCATENATED MODULE: ./src/core/utils/factory.ts









var Factory = {
    createChannels() {
        return new channels_Channels();
    },
    createConnectionManager(key, options) {
        return new connection_manager_ConnectionManager(key, options);
    },
    createChannel(name, pusher) {
        return new channel_Channel(name, pusher);
    },
    createPrivateChannel(name, pusher) {
        return new private_channel_PrivateChannel(name, pusher);
    },
    createPresenceChannel(name, pusher) {
        return new presence_channel_PresenceChannel(name, pusher);
    },
    createEncryptedChannel(name, pusher, nacl) {
        return new encrypted_channel_EncryptedChannel(name, pusher, nacl);
    },
    createTimelineSender(timeline, options) {
        return new timeline_sender_TimelineSender(timeline, options);
    },
    createHandshake(transport, callback) {
        return new handshake_Handshake(transport, callback);
    },
    createAssistantToTheTransportManager(manager, transport, options) {
        return new assistant_to_the_transport_manager_AssistantToTheTransportManager(manager, transport, options);
    }
};
/* harmony default export */ var factory = (Factory);

// CONCATENATED MODULE: ./src/core/transports/transport_manager.ts

class transport_manager_TransportManager {
    constructor(options) {
        this.options = options || {};
        this.livesLeft = this.options.lives || Infinity;
    }
    getAssistant(transport) {
        return factory.createAssistantToTheTransportManager(this, transport, {
            minPingDelay: this.options.minPingDelay,
            maxPingDelay: this.options.maxPingDelay
        });
    }
    isAlive() {
        return this.livesLeft > 0;
    }
    reportDeath() {
        this.livesLeft -= 1;
    }
}

// CONCATENATED MODULE: ./src/core/strategies/sequential_strategy.ts



class sequential_strategy_SequentialStrategy {
    constructor(strategies, options) {
        this.strategies = strategies;
        this.loop = Boolean(options.loop);
        this.failFast = Boolean(options.failFast);
        this.timeout = options.timeout;
        this.timeoutLimit = options.timeoutLimit;
    }
    isSupported() {
        return any(this.strategies, util.method('isSupported'));
    }
    connect(minPriority, callback) {
        var strategies = this.strategies;
        var current = 0;
        var timeout = this.timeout;
        var runner = null;
        var tryNextStrategy = (error, handshake) => {
            if (handshake) {
                callback(null, handshake);
            }
            else {
                current = current + 1;
                if (this.loop) {
                    current = current % strategies.length;
                }
                if (current < strategies.length) {
                    if (timeout) {
                        timeout = timeout * 2;
                        if (this.timeoutLimit) {
                            timeout = Math.min(timeout, this.timeoutLimit);
                        }
                    }
                    runner = this.tryStrategy(strategies[current], minPriority, { timeout, failFast: this.failFast }, tryNextStrategy);
                }
                else {
                    callback(true);
                }
            }
        };
        runner = this.tryStrategy(strategies[current], minPriority, { timeout: timeout, failFast: this.failFast }, tryNextStrategy);
        return {
            abort: function () {
                runner.abort();
            },
            forceMinPriority: function (p) {
                minPriority = p;
                if (runner) {
                    runner.forceMinPriority(p);
                }
            }
        };
    }
    tryStrategy(strategy, minPriority, options, callback) {
        var timer = null;
        var runner = null;
        if (options.timeout > 0) {
            timer = new timers_OneOffTimer(options.timeout, function () {
                runner.abort();
                callback(true);
            });
        }
        runner = strategy.connect(minPriority, function (error, handshake) {
            if (error && timer && timer.isRunning() && !options.failFast) {
                return;
            }
            if (timer) {
                timer.ensureAborted();
            }
            callback(error, handshake);
        });
        return {
            abort: function () {
                if (timer) {
                    timer.ensureAborted();
                }
                runner.abort();
            },
            forceMinPriority: function (p) {
                runner.forceMinPriority(p);
            }
        };
    }
}

// CONCATENATED MODULE: ./src/core/strategies/best_connected_ever_strategy.ts


class best_connected_ever_strategy_BestConnectedEverStrategy {
    constructor(strategies) {
        this.strategies = strategies;
    }
    isSupported() {
        return any(this.strategies, util.method('isSupported'));
    }
    connect(minPriority, callback) {
        return connect(this.strategies, minPriority, function (i, runners) {
            return function (error, handshake) {
                runners[i].error = error;
                if (error) {
                    if (allRunnersFailed(runners)) {
                        callback(true);
                    }
                    return;
                }
                apply(runners, function (runner) {
                    runner.forceMinPriority(handshake.transport.priority);
                });
                callback(null, handshake);
            };
        });
    }
}
function connect(strategies, minPriority, callbackBuilder) {
    var runners = map(strategies, function (strategy, i, _, rs) {
        return strategy.connect(minPriority, callbackBuilder(i, rs));
    });
    return {
        abort: function () {
            apply(runners, abortRunner);
        },
        forceMinPriority: function (p) {
            apply(runners, function (runner) {
                runner.forceMinPriority(p);
            });
        }
    };
}
function allRunnersFailed(runners) {
    return collections_all(runners, function (runner) {
        return Boolean(runner.error);
    });
}
function abortRunner(runner) {
    if (!runner.error && !runner.aborted) {
        runner.abort();
        runner.aborted = true;
    }
}

// CONCATENATED MODULE: ./src/core/strategies/websocket_prioritized_cached_strategy.ts




class websocket_prioritized_cached_strategy_WebSocketPrioritizedCachedStrategy {
    constructor(strategy, transports, options) {
        this.strategy = strategy;
        this.transports = transports;
        this.ttl = options.ttl || 1800 * 1000;
        this.usingTLS = options.useTLS;
        this.timeline = options.timeline;
    }
    isSupported() {
        return this.strategy.isSupported();
    }
    connect(minPriority, callback) {
        var usingTLS = this.usingTLS;
        var info = fetchTransportCache(usingTLS);
        var cacheSkipCount = info && info.cacheSkipCount ? info.cacheSkipCount : 0;
        var strategies = [this.strategy];
        if (info && info.timestamp + this.ttl >= util.now()) {
            var transport = this.transports[info.transport];
            if (transport) {
                if (['ws', 'wss'].includes(info.transport) || cacheSkipCount > 3) {
                    this.timeline.info({
                        cached: true,
                        transport: info.transport,
                        latency: info.latency
                    });
                    strategies.push(new sequential_strategy_SequentialStrategy([transport], {
                        timeout: info.latency * 2 + 1000,
                        failFast: true
                    }));
                }
                else {
                    cacheSkipCount++;
                }
            }
        }
        var startTimestamp = util.now();
        var runner = strategies
            .pop()
            .connect(minPriority, function cb(error, handshake) {
            if (error) {
                flushTransportCache(usingTLS);
                if (strategies.length > 0) {
                    startTimestamp = util.now();
                    runner = strategies.pop().connect(minPriority, cb);
                }
                else {
                    callback(error);
                }
            }
            else {
                storeTransportCache(usingTLS, handshake.transport.name, util.now() - startTimestamp, cacheSkipCount);
                callback(null, handshake);
            }
        });
        return {
            abort: function () {
                runner.abort();
            },
            forceMinPriority: function (p) {
                minPriority = p;
                if (runner) {
                    runner.forceMinPriority(p);
                }
            }
        };
    }
}
function getTransportCacheKey(usingTLS) {
    return 'pusherTransport' + (usingTLS ? 'TLS' : 'NonTLS');
}
function fetchTransportCache(usingTLS) {
    var storage = runtime.getLocalStorage();
    if (storage) {
        try {
            var serializedCache = storage[getTransportCacheKey(usingTLS)];
            if (serializedCache) {
                return JSON.parse(serializedCache);
            }
        }
        catch (e) {
            flushTransportCache(usingTLS);
        }
    }
    return null;
}
function storeTransportCache(usingTLS, transport, latency, cacheSkipCount) {
    var storage = runtime.getLocalStorage();
    if (storage) {
        try {
            storage[getTransportCacheKey(usingTLS)] = safeJSONStringify({
                timestamp: util.now(),
                transport: transport,
                latency: latency,
                cacheSkipCount: cacheSkipCount
            });
        }
        catch (e) {
        }
    }
}
function flushTransportCache(usingTLS) {
    var storage = runtime.getLocalStorage();
    if (storage) {
        try {
            delete storage[getTransportCacheKey(usingTLS)];
        }
        catch (e) {
        }
    }
}

// CONCATENATED MODULE: ./src/core/strategies/delayed_strategy.ts

class delayed_strategy_DelayedStrategy {
    constructor(strategy, { delay: number }) {
        this.strategy = strategy;
        this.options = { delay: number };
    }
    isSupported() {
        return this.strategy.isSupported();
    }
    connect(minPriority, callback) {
        var strategy = this.strategy;
        var runner;
        var timer = new timers_OneOffTimer(this.options.delay, function () {
            runner = strategy.connect(minPriority, callback);
        });
        return {
            abort: function () {
                timer.ensureAborted();
                if (runner) {
                    runner.abort();
                }
            },
            forceMinPriority: function (p) {
                minPriority = p;
                if (runner) {
                    runner.forceMinPriority(p);
                }
            }
        };
    }
}

// CONCATENATED MODULE: ./src/core/strategies/if_strategy.ts
class IfStrategy {
    constructor(test, trueBranch, falseBranch) {
        this.test = test;
        this.trueBranch = trueBranch;
        this.falseBranch = falseBranch;
    }
    isSupported() {
        var branch = this.test() ? this.trueBranch : this.falseBranch;
        return branch.isSupported();
    }
    connect(minPriority, callback) {
        var branch = this.test() ? this.trueBranch : this.falseBranch;
        return branch.connect(minPriority, callback);
    }
}

// CONCATENATED MODULE: ./src/core/strategies/first_connected_strategy.ts
class FirstConnectedStrategy {
    constructor(strategy) {
        this.strategy = strategy;
    }
    isSupported() {
        return this.strategy.isSupported();
    }
    connect(minPriority, callback) {
        var runner = this.strategy.connect(minPriority, function (error, handshake) {
            if (handshake) {
                runner.abort();
            }
            callback(error, handshake);
        });
        return runner;
    }
}

// CONCATENATED MODULE: ./src/runtimes/web/default_strategy.ts







function testSupportsStrategy(strategy) {
    return function () {
        return strategy.isSupported();
    };
}
var getDefaultStrategy = function (config, baseOptions, defineTransport) {
    var definedTransports = {};
    function defineTransportStrategy(name, type, priority, options, manager) {
        var transport = defineTransport(config, name, type, priority, options, manager);
        definedTransports[name] = transport;
        return transport;
    }
    var ws_options = Object.assign({}, baseOptions, {
        hostNonTLS: config.wsHost + ':' + config.wsPort,
        hostTLS: config.wsHost + ':' + config.wssPort,
        httpPath: config.wsPath
    });
    var wss_options = Object.assign({}, ws_options, {
        useTLS: true
    });
    var sockjs_options = Object.assign({}, baseOptions, {
        hostNonTLS: config.httpHost + ':' + config.httpPort,
        hostTLS: config.httpHost + ':' + config.httpsPort,
        httpPath: config.httpPath
    });
    var timeouts = {
        loop: true,
        timeout: 15000,
        timeoutLimit: 60000
    };
    var ws_manager = new transport_manager_TransportManager({
        minPingDelay: 10000,
        maxPingDelay: config.activityTimeout
    });
    var streaming_manager = new transport_manager_TransportManager({
        lives: 2,
        minPingDelay: 10000,
        maxPingDelay: config.activityTimeout
    });
    var ws_transport = defineTransportStrategy('ws', 'ws', 3, ws_options, ws_manager);
    var wss_transport = defineTransportStrategy('wss', 'ws', 3, wss_options, ws_manager);
    var sockjs_transport = defineTransportStrategy('sockjs', 'sockjs', 1, sockjs_options);
    var xhr_streaming_transport = defineTransportStrategy('xhr_streaming', 'xhr_streaming', 1, sockjs_options, streaming_manager);
    var xdr_streaming_transport = defineTransportStrategy('xdr_streaming', 'xdr_streaming', 1, sockjs_options, streaming_manager);
    var xhr_polling_transport = defineTransportStrategy('xhr_polling', 'xhr_polling', 1, sockjs_options);
    var xdr_polling_transport = defineTransportStrategy('xdr_polling', 'xdr_polling', 1, sockjs_options);
    var ws_loop = new sequential_strategy_SequentialStrategy([ws_transport], timeouts);
    var wss_loop = new sequential_strategy_SequentialStrategy([wss_transport], timeouts);
    var sockjs_loop = new sequential_strategy_SequentialStrategy([sockjs_transport], timeouts);
    var streaming_loop = new sequential_strategy_SequentialStrategy([
        new IfStrategy(testSupportsStrategy(xhr_streaming_transport), xhr_streaming_transport, xdr_streaming_transport)
    ], timeouts);
    var polling_loop = new sequential_strategy_SequentialStrategy([
        new IfStrategy(testSupportsStrategy(xhr_polling_transport), xhr_polling_transport, xdr_polling_transport)
    ], timeouts);
    var http_loop = new sequential_strategy_SequentialStrategy([
        new IfStrategy(testSupportsStrategy(streaming_loop), new best_connected_ever_strategy_BestConnectedEverStrategy([
            streaming_loop,
            new delayed_strategy_DelayedStrategy(polling_loop, { delay: 4000 })
        ]), polling_loop)
    ], timeouts);
    var http_fallback_loop = new IfStrategy(testSupportsStrategy(http_loop), http_loop, sockjs_loop);
    var wsStrategy;
    if (baseOptions.useTLS) {
        wsStrategy = new best_connected_ever_strategy_BestConnectedEverStrategy([
            ws_loop,
            new delayed_strategy_DelayedStrategy(http_fallback_loop, { delay: 2000 })
        ]);
    }
    else {
        wsStrategy = new best_connected_ever_strategy_BestConnectedEverStrategy([
            ws_loop,
            new delayed_strategy_DelayedStrategy(wss_loop, { delay: 2000 }),
            new delayed_strategy_DelayedStrategy(http_fallback_loop, { delay: 5000 })
        ]);
    }
    return new websocket_prioritized_cached_strategy_WebSocketPrioritizedCachedStrategy(new FirstConnectedStrategy(new IfStrategy(testSupportsStrategy(ws_transport), wsStrategy, http_fallback_loop)), definedTransports, {
        ttl: 1800000,
        timeline: baseOptions.timeline,
        useTLS: baseOptions.useTLS
    });
};
/* harmony default export */ var default_strategy = (getDefaultStrategy);

// CONCATENATED MODULE: ./src/runtimes/web/transports/transport_connection_initializer.ts

/* harmony default export */ var transport_connection_initializer = (function () {
    var self = this;
    self.timeline.info(self.buildTimelineMessage({
        transport: self.name + (self.options.useTLS ? 's' : '')
    }));
    if (self.hooks.isInitialized()) {
        self.changeState('initialized');
    }
    else if (self.hooks.file) {
        self.changeState('initializing');
        Dependencies.load(self.hooks.file, { useTLS: self.options.useTLS }, function (error, callback) {
            if (self.hooks.isInitialized()) {
                self.changeState('initialized');
                callback(true);
            }
            else {
                if (error) {
                    self.onError(error);
                }
                self.onClose();
                callback(false);
            }
        });
    }
    else {
        self.onClose();
    }
});

// CONCATENATED MODULE: ./src/runtimes/web/http/http_xdomain_request.ts

var http_xdomain_request_hooks = {
    getRequest: function (socket) {
        var xdr = new window.XDomainRequest();
        xdr.ontimeout = function () {
            socket.emit('error', new RequestTimedOut());
            socket.close();
        };
        xdr.onerror = function (e) {
            socket.emit('error', e);
            socket.close();
        };
        xdr.onprogress = function () {
            if (xdr.responseText && xdr.responseText.length > 0) {
                socket.onChunk(200, xdr.responseText);
            }
        };
        xdr.onload = function () {
            if (xdr.responseText && xdr.responseText.length > 0) {
                socket.onChunk(200, xdr.responseText);
            }
            socket.emit('finished', 200);
            socket.close();
        };
        return xdr;
    },
    abortRequest: function (xdr) {
        xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
        xdr.abort();
    }
};
/* harmony default export */ var http_xdomain_request = (http_xdomain_request_hooks);

// CONCATENATED MODULE: ./src/core/http/http_request.ts


const MAX_BUFFER_LENGTH = 256 * 1024;
class http_request_HTTPRequest extends dispatcher_Dispatcher {
    constructor(hooks, method, url) {
        super();
        this.hooks = hooks;
        this.method = method;
        this.url = url;
    }
    start(payload) {
        this.position = 0;
        this.xhr = this.hooks.getRequest(this);
        this.unloader = () => {
            this.close();
        };
        runtime.addUnloadListener(this.unloader);
        this.xhr.open(this.method, this.url, true);
        if (this.xhr.setRequestHeader) {
            this.xhr.setRequestHeader('Content-Type', 'application/json');
        }
        this.xhr.send(payload);
    }
    close() {
        if (this.unloader) {
            runtime.removeUnloadListener(this.unloader);
            this.unloader = null;
        }
        if (this.xhr) {
            this.hooks.abortRequest(this.xhr);
            this.xhr = null;
        }
    }
    onChunk(status, data) {
        while (true) {
            var chunk = this.advanceBuffer(data);
            if (chunk) {
                this.emit('chunk', { status: status, data: chunk });
            }
            else {
                break;
            }
        }
        if (this.isBufferTooLong(data)) {
            this.emit('buffer_too_long');
        }
    }
    advanceBuffer(buffer) {
        var unreadData = buffer.slice(this.position);
        var endOfLinePosition = unreadData.indexOf('\n');
        if (endOfLinePosition !== -1) {
            this.position += endOfLinePosition + 1;
            return unreadData.slice(0, endOfLinePosition);
        }
        else {
            return null;
        }
    }
    isBufferTooLong(buffer) {
        return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
    }
}

// CONCATENATED MODULE: ./src/core/http/state.ts
var State;
(function (State) {
    State[State["CONNECTING"] = 0] = "CONNECTING";
    State[State["OPEN"] = 1] = "OPEN";
    State[State["CLOSED"] = 3] = "CLOSED";
})(State || (State = {}));
/* harmony default export */ var state = (State);

// CONCATENATED MODULE: ./src/core/http/http_socket.ts



var autoIncrement = 1;
class http_socket_HTTPSocket {
    constructor(hooks, url) {
        this.hooks = hooks;
        this.session = randomNumber(1000) + '/' + randomString(8);
        this.location = getLocation(url);
        this.readyState = state.CONNECTING;
        this.openStream();
    }
    send(payload) {
        return this.sendRaw(JSON.stringify([payload]));
    }
    ping() {
        this.hooks.sendHeartbeat(this);
    }
    close(code, reason) {
        this.onClose(code, reason, true);
    }
    sendRaw(payload) {
        if (this.readyState === state.OPEN) {
            try {
                runtime.createSocketRequest('POST', getUniqueURL(getSendURL(this.location, this.session))).start(payload);
                return true;
            }
            catch (e) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    reconnect() {
        this.closeStream();
        this.openStream();
    }
    onClose(code, reason, wasClean) {
        this.closeStream();
        this.readyState = state.CLOSED;
        if (this.onclose) {
            this.onclose({
                code: code,
                reason: reason,
                wasClean: wasClean
            });
        }
    }
    onChunk(chunk) {
        if (chunk.status !== 200) {
            return;
        }
        if (this.readyState === state.OPEN) {
            this.onActivity();
        }
        var payload;
        var type = chunk.data.slice(0, 1);
        switch (type) {
            case 'o':
                payload = JSON.parse(chunk.data.slice(1) || '{}');
                this.onOpen(payload);
                break;
            case 'a':
                payload = JSON.parse(chunk.data.slice(1) || '[]');
                for (var i = 0; i < payload.length; i++) {
                    this.onEvent(payload[i]);
                }
                break;
            case 'm':
                payload = JSON.parse(chunk.data.slice(1) || 'null');
                this.onEvent(payload);
                break;
            case 'h':
                this.hooks.onHeartbeat(this);
                break;
            case 'c':
                payload = JSON.parse(chunk.data.slice(1) || '[]');
                this.onClose(payload[0], payload[1], true);
                break;
        }
    }
    onOpen(options) {
        if (this.readyState === state.CONNECTING) {
            if (options && options.hostname) {
                this.location.base = replaceHost(this.location.base, options.hostname);
            }
            this.readyState = state.OPEN;
            if (this.onopen) {
                this.onopen();
            }
        }
        else {
            this.onClose(1006, 'Server lost session', true);
        }
    }
    onEvent(event) {
        if (this.readyState === state.OPEN && this.onmessage) {
            this.onmessage({ data: event });
        }
    }
    onActivity() {
        if (this.onactivity) {
            this.onactivity();
        }
    }
    onError(error) {
        if (this.onerror) {
            this.onerror(error);
        }
    }
    openStream() {
        this.stream = runtime.createSocketRequest('POST', getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
        this.stream.bind('chunk', chunk => {
            this.onChunk(chunk);
        });
        this.stream.bind('finished', status => {
            this.hooks.onFinished(this, status);
        });
        this.stream.bind('buffer_too_long', () => {
            this.reconnect();
        });
        try {
            this.stream.start();
        }
        catch (error) {
            util.defer(() => {
                this.onError(error);
                this.onClose(1006, 'Could not start streaming', false);
            });
        }
    }
    closeStream() {
        if (this.stream) {
            this.stream.unbind_all();
            this.stream.close();
            this.stream = null;
        }
    }
}
function getLocation(url) {
    var parts = /([^\?]*)\/*(\??.*)/.exec(url);
    return {
        base: parts[1],
        queryString: parts[2]
    };
}
function getSendURL(url, session) {
    return url.base + '/' + session + '/xhr_send';
}
function getUniqueURL(url) {
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 't=' + +new Date() + '&n=' + autoIncrement++;
}
function replaceHost(url, hostname) {
    var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
    return urlParts[1] + hostname + urlParts[3];
}
function randomNumber(max) {
    return runtime.randomInt(max);
}
function randomString(length) {
    var result = [];
    for (var i = 0; i < length; i++) {
        result.push(randomNumber(32).toString(32));
    }
    return result.join('');
}
/* harmony default export */ var http_socket = (http_socket_HTTPSocket);

// CONCATENATED MODULE: ./src/core/http/http_streaming_socket.ts
var http_streaming_socket_hooks = {
    getReceiveURL: function (url, session) {
        return url.base + '/' + session + '/xhr_streaming' + url.queryString;
    },
    onHeartbeat: function (socket) {
        socket.sendRaw('[]');
    },
    sendHeartbeat: function (socket) {
        socket.sendRaw('[]');
    },
    onFinished: function (socket, status) {
        socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
    }
};
/* harmony default export */ var http_streaming_socket = (http_streaming_socket_hooks);

// CONCATENATED MODULE: ./src/core/http/http_polling_socket.ts
var http_polling_socket_hooks = {
    getReceiveURL: function (url, session) {
        return url.base + '/' + session + '/xhr' + url.queryString;
    },
    onHeartbeat: function () {
    },
    sendHeartbeat: function (socket) {
        socket.sendRaw('[]');
    },
    onFinished: function (socket, status) {
        if (status === 200) {
            socket.reconnect();
        }
        else {
            socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
        }
    }
};
/* harmony default export */ var http_polling_socket = (http_polling_socket_hooks);

// CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http_xhr_request.ts

var http_xhr_request_hooks = {
    getRequest: function (socket) {
        var Constructor = runtime.getXHRAPI();
        var xhr = new Constructor();
        xhr.onreadystatechange = xhr.onprogress = function () {
            switch (xhr.readyState) {
                case 3:
                    if (xhr.responseText && xhr.responseText.length > 0) {
                        socket.onChunk(xhr.status, xhr.responseText);
                    }
                    break;
                case 4:
                    if (xhr.responseText && xhr.responseText.length > 0) {
                        socket.onChunk(xhr.status, xhr.responseText);
                    }
                    socket.emit('finished', xhr.status);
                    socket.close();
                    break;
            }
        };
        return xhr;
    },
    abortRequest: function (xhr) {
        xhr.onreadystatechange = null;
        xhr.abort();
    }
};
/* harmony default export */ var http_xhr_request = (http_xhr_request_hooks);

// CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http.ts





var HTTP = {
    createStreamingSocket(url) {
        return this.createSocket(http_streaming_socket, url);
    },
    createPollingSocket(url) {
        return this.createSocket(http_polling_socket, url);
    },
    createSocket(hooks, url) {
        return new http_socket(hooks, url);
    },
    createXHR(method, url) {
        return this.createRequest(http_xhr_request, method, url);
    },
    createRequest(hooks, method, url) {
        return new http_request_HTTPRequest(hooks, method, url);
    }
};
/* harmony default export */ var http_http = (HTTP);

// CONCATENATED MODULE: ./src/runtimes/web/http/http.ts


http_http.createXDR = function (method, url) {
    return this.createRequest(http_xdomain_request, method, url);
};
/* harmony default export */ var web_http_http = (http_http);

// CONCATENATED MODULE: ./src/runtimes/web/runtime.ts












var Runtime = {
    nextAuthCallbackID: 1,
    auth_callbacks: {},
    ScriptReceivers: ScriptReceivers,
    DependenciesReceivers: DependenciesReceivers,
    getDefaultStrategy: default_strategy,
    Transports: transports_transports,
    transportConnectionInitializer: transport_connection_initializer,
    HTTPFactory: web_http_http,
    TimelineTransport: jsonp_timeline,
    getXHRAPI() {
        return window.XMLHttpRequest;
    },
    getWebSocketAPI() {
        return window.WebSocket || window.MozWebSocket;
    },
    setup(PusherClass) {
        window.Pusher = PusherClass;
        var initializeOnDocumentBody = () => {
            this.onDocumentBody(PusherClass.ready);
        };
        if (!window.JSON) {
            Dependencies.load('json2', {}, initializeOnDocumentBody);
        }
        else {
            initializeOnDocumentBody();
        }
    },
    getDocument() {
        return document;
    },
    getProtocol() {
        return this.getDocument().location.protocol;
    },
    getAuthorizers() {
        return { ajax: xhr_auth, jsonp: jsonp_auth };
    },
    onDocumentBody(callback) {
        if (document.body) {
            callback();
        }
        else {
            setTimeout(() => {
                this.onDocumentBody(callback);
            }, 0);
        }
    },
    createJSONPRequest(url, data) {
        return new jsonp_request_JSONPRequest(url, data);
    },
    createScriptRequest(src) {
        return new ScriptRequest(src);
    },
    getLocalStorage() {
        try {
            return window.localStorage;
        }
        catch (e) {
            return undefined;
        }
    },
    createXHR() {
        if (this.getXHRAPI()) {
            return this.createXMLHttpRequest();
        }
        else {
            return this.createMicrosoftXHR();
        }
    },
    createXMLHttpRequest() {
        var Constructor = this.getXHRAPI();
        return new Constructor();
    },
    createMicrosoftXHR() {
        return new ActiveXObject('Microsoft.XMLHTTP');
    },
    getNetwork() {
        return net_info_Network;
    },
    createWebSocket(url) {
        var Constructor = this.getWebSocketAPI();
        return new Constructor(url);
    },
    createSocketRequest(method, url) {
        if (this.isXHRSupported()) {
            return this.HTTPFactory.createXHR(method, url);
        }
        else if (this.isXDRSupported(url.indexOf('https:') === 0)) {
            return this.HTTPFactory.createXDR(method, url);
        }
        else {
            throw 'Cross-origin HTTP requests are not supported';
        }
    },
    isXHRSupported() {
        var Constructor = this.getXHRAPI();
        return (Boolean(Constructor) && new Constructor().withCredentials !== undefined);
    },
    isXDRSupported(useTLS) {
        var protocol = useTLS ? 'https:' : 'http:';
        var documentProtocol = this.getProtocol();
        return (Boolean(window['XDomainRequest']) && documentProtocol === protocol);
    },
    addUnloadListener(listener) {
        if (window.addEventListener !== undefined) {
            window.addEventListener('unload', listener, false);
        }
        else if (window.attachEvent !== undefined) {
            window.attachEvent('onunload', listener);
        }
    },
    removeUnloadListener(listener) {
        if (window.addEventListener !== undefined) {
            window.removeEventListener('unload', listener, false);
        }
        else if (window.detachEvent !== undefined) {
            window.detachEvent('onunload', listener);
        }
    },
    randomInt(max) {
        const random = function () {
            const crypto = window.crypto || window['msCrypto'];
            const random = crypto.getRandomValues(new Uint32Array(1))[0];
            return random / Math.pow(2, 32);
        };
        return Math.floor(random() * max);
    }
};
/* harmony default export */ var runtime = (Runtime);

// CONCATENATED MODULE: ./src/core/timeline/level.ts
var TimelineLevel;
(function (TimelineLevel) {
    TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
    TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
    TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
})(TimelineLevel || (TimelineLevel = {}));
/* harmony default export */ var timeline_level = (TimelineLevel);

// CONCATENATED MODULE: ./src/core/timeline/timeline.ts



class timeline_Timeline {
    constructor(key, session, options) {
        this.key = key;
        this.session = session;
        this.events = [];
        this.options = options || {};
        this.sent = 0;
        this.uniqueID = 0;
    }
    log(level, event) {
        if (level <= this.options.level) {
            this.events.push(extend({}, event, { timestamp: util.now() }));
            if (this.options.limit && this.events.length > this.options.limit) {
                this.events.shift();
            }
        }
    }
    error(event) {
        this.log(timeline_level.ERROR, event);
    }
    info(event) {
        this.log(timeline_level.INFO, event);
    }
    debug(event) {
        this.log(timeline_level.DEBUG, event);
    }
    isEmpty() {
        return this.events.length === 0;
    }
    send(sendfn, callback) {
        var data = extend({
            session: this.session,
            bundle: this.sent + 1,
            key: this.key,
            lib: 'js',
            version: this.options.version,
            cluster: this.options.cluster,
            features: this.options.features,
            timeline: this.events
        }, this.options.params);
        this.events = [];
        sendfn(data, (error, result) => {
            if (!error) {
                this.sent++;
            }
            if (callback) {
                callback(error, result);
            }
        });
        return true;
    }
    generateUniqueID() {
        this.uniqueID++;
        return this.uniqueID;
    }
}

// CONCATENATED MODULE: ./src/core/strategies/transport_strategy.ts




class transport_strategy_TransportStrategy {
    constructor(name, priority, transport, options) {
        this.name = name;
        this.priority = priority;
        this.transport = transport;
        this.options = options || {};
    }
    isSupported() {
        return this.transport.isSupported({
            useTLS: this.options.useTLS
        });
    }
    connect(minPriority, callback) {
        if (!this.isSupported()) {
            return failAttempt(new UnsupportedStrategy(), callback);
        }
        else if (this.priority < minPriority) {
            return failAttempt(new TransportPriorityTooLow(), callback);
        }
        var connected = false;
        var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
        var handshake = null;
        var onInitialized = function () {
            transport.unbind('initialized', onInitialized);
            transport.connect();
        };
        var onOpen = function () {
            handshake = factory.createHandshake(transport, function (result) {
                connected = true;
                unbindListeners();
                callback(null, result);
            });
        };
        var onError = function (error) {
            unbindListeners();
            callback(error);
        };
        var onClosed = function () {
            unbindListeners();
            var serializedTransport;
            serializedTransport = safeJSONStringify(transport);
            callback(new TransportClosed(serializedTransport));
        };
        var unbindListeners = function () {
            transport.unbind('initialized', onInitialized);
            transport.unbind('open', onOpen);
            transport.unbind('error', onError);
            transport.unbind('closed', onClosed);
        };
        transport.bind('initialized', onInitialized);
        transport.bind('open', onOpen);
        transport.bind('error', onError);
        transport.bind('closed', onClosed);
        transport.initialize();
        return {
            abort: () => {
                if (connected) {
                    return;
                }
                unbindListeners();
                if (handshake) {
                    handshake.close();
                }
                else {
                    transport.close();
                }
            },
            forceMinPriority: p => {
                if (connected) {
                    return;
                }
                if (this.priority < p) {
                    if (handshake) {
                        handshake.close();
                    }
                    else {
                        transport.close();
                    }
                }
            }
        };
    }
}
function failAttempt(error, callback) {
    util.defer(function () {
        callback(error);
    });
    return {
        abort: function () { },
        forceMinPriority: function () { }
    };
}

// CONCATENATED MODULE: ./src/core/strategies/strategy_builder.ts





const { Transports: strategy_builder_Transports } = runtime;
var strategy_builder_defineTransport = function (config, name, type, priority, options, manager) {
    var transportClass = strategy_builder_Transports[type];
    if (!transportClass) {
        throw new UnsupportedTransport(type);
    }
    var enabled = (!config.enabledTransports ||
        arrayIndexOf(config.enabledTransports, name) !== -1) &&
        (!config.disabledTransports ||
            arrayIndexOf(config.disabledTransports, name) === -1);
    var transport;
    if (enabled) {
        options = Object.assign({ ignoreNullOrigin: config.ignoreNullOrigin }, options);
        transport = new transport_strategy_TransportStrategy(name, priority, manager ? manager.getAssistant(transportClass) : transportClass, options);
    }
    else {
        transport = strategy_builder_UnsupportedStrategy;
    }
    return transport;
};
var strategy_builder_UnsupportedStrategy = {
    isSupported: function () {
        return false;
    },
    connect: function (_, callback) {
        var deferred = util.defer(function () {
            callback(new UnsupportedStrategy());
        });
        return {
            abort: function () {
                deferred.ensureAborted();
            },
            forceMinPriority: function () { }
        };
    }
};

// CONCATENATED MODULE: ./src/core/options.ts

function validateOptions(options) {
    if (options == null) {
        throw 'You must pass an options object';
    }
    if (options.cluster == null) {
        throw 'Options object must provide a cluster';
    }
    if ('disableStats' in options) {
        logger.warn('The disableStats option is deprecated in favor of enableStats');
    }
}

// CONCATENATED MODULE: ./src/core/auth/user_authenticator.ts


const composeChannelQuery = (params, authOptions) => {
    var query = 'socket_id=' + encodeURIComponent(params.socketId);
    for (var key in authOptions.params) {
        query +=
            '&' +
                encodeURIComponent(key) +
                '=' +
                encodeURIComponent(authOptions.params[key]);
    }
    if (authOptions.paramsProvider != null) {
        let dynamicParams = authOptions.paramsProvider();
        for (var key in dynamicParams) {
            query +=
                '&' +
                    encodeURIComponent(key) +
                    '=' +
                    encodeURIComponent(dynamicParams[key]);
        }
    }
    return query;
};
const UserAuthenticator = (authOptions) => {
    if (typeof runtime.getAuthorizers()[authOptions.transport] === 'undefined') {
        throw `'${authOptions.transport}' is not a recognized auth transport`;
    }
    return (params, callback) => {
        const query = composeChannelQuery(params, authOptions);
        runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.UserAuthentication, callback);
    };
};
/* harmony default export */ var user_authenticator = (UserAuthenticator);

// CONCATENATED MODULE: ./src/core/auth/channel_authorizer.ts


const channel_authorizer_composeChannelQuery = (params, authOptions) => {
    var query = 'socket_id=' + encodeURIComponent(params.socketId);
    query += '&channel_name=' + encodeURIComponent(params.channelName);
    for (var key in authOptions.params) {
        query +=
            '&' +
                encodeURIComponent(key) +
                '=' +
                encodeURIComponent(authOptions.params[key]);
    }
    if (authOptions.paramsProvider != null) {
        let dynamicParams = authOptions.paramsProvider();
        for (var key in dynamicParams) {
            query +=
                '&' +
                    encodeURIComponent(key) +
                    '=' +
                    encodeURIComponent(dynamicParams[key]);
        }
    }
    return query;
};
const ChannelAuthorizer = (authOptions) => {
    if (typeof runtime.getAuthorizers()[authOptions.transport] === 'undefined') {
        throw `'${authOptions.transport}' is not a recognized auth transport`;
    }
    return (params, callback) => {
        const query = channel_authorizer_composeChannelQuery(params, authOptions);
        runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.ChannelAuthorization, callback);
    };
};
/* harmony default export */ var channel_authorizer = (ChannelAuthorizer);

// CONCATENATED MODULE: ./src/core/auth/deprecated_channel_authorizer.ts
const ChannelAuthorizerProxy = (pusher, authOptions, channelAuthorizerGenerator) => {
    const deprecatedAuthorizerOptions = {
        authTransport: authOptions.transport,
        authEndpoint: authOptions.endpoint,
        auth: {
            params: authOptions.params,
            headers: authOptions.headers
        }
    };
    return (params, callback) => {
        const channel = pusher.channel(params.channelName);
        const channelAuthorizer = channelAuthorizerGenerator(channel, deprecatedAuthorizerOptions);
        channelAuthorizer.authorize(params.socketId, callback);
    };
};

// CONCATENATED MODULE: ./src/core/config.ts





function getConfig(opts, pusher) {
    let config = {
        activityTimeout: opts.activityTimeout || defaults.activityTimeout,
        cluster: opts.cluster,
        httpPath: opts.httpPath || defaults.httpPath,
        httpPort: opts.httpPort || defaults.httpPort,
        httpsPort: opts.httpsPort || defaults.httpsPort,
        pongTimeout: opts.pongTimeout || defaults.pongTimeout,
        statsHost: opts.statsHost || defaults.stats_host,
        unavailableTimeout: opts.unavailableTimeout || defaults.unavailableTimeout,
        wsPath: opts.wsPath || defaults.wsPath,
        wsPort: opts.wsPort || defaults.wsPort,
        wssPort: opts.wssPort || defaults.wssPort,
        enableStats: getEnableStatsConfig(opts),
        httpHost: getHttpHost(opts),
        useTLS: shouldUseTLS(opts),
        wsHost: getWebsocketHost(opts),
        userAuthenticator: buildUserAuthenticator(opts),
        channelAuthorizer: buildChannelAuthorizer(opts, pusher)
    };
    if ('disabledTransports' in opts)
        config.disabledTransports = opts.disabledTransports;
    if ('enabledTransports' in opts)
        config.enabledTransports = opts.enabledTransports;
    if ('ignoreNullOrigin' in opts)
        config.ignoreNullOrigin = opts.ignoreNullOrigin;
    if ('timelineParams' in opts)
        config.timelineParams = opts.timelineParams;
    if ('nacl' in opts) {
        config.nacl = opts.nacl;
    }
    return config;
}
function getHttpHost(opts) {
    if (opts.httpHost) {
        return opts.httpHost;
    }
    if (opts.cluster) {
        return `sockjs-${opts.cluster}.pusher.com`;
    }
    return defaults.httpHost;
}
function getWebsocketHost(opts) {
    if (opts.wsHost) {
        return opts.wsHost;
    }
    return getWebsocketHostFromCluster(opts.cluster);
}
function getWebsocketHostFromCluster(cluster) {
    return `ws-${cluster}.pusher.com`;
}
function shouldUseTLS(opts) {
    if (runtime.getProtocol() === 'https:') {
        return true;
    }
    else if (opts.forceTLS === false) {
        return false;
    }
    return true;
}
function getEnableStatsConfig(opts) {
    if ('enableStats' in opts) {
        return opts.enableStats;
    }
    if ('disableStats' in opts) {
        return !opts.disableStats;
    }
    return false;
}
function buildUserAuthenticator(opts) {
    const userAuthentication = Object.assign(Object.assign({}, defaults.userAuthentication), opts.userAuthentication);
    if ('customHandler' in userAuthentication &&
        userAuthentication['customHandler'] != null) {
        return userAuthentication['customHandler'];
    }
    return user_authenticator(userAuthentication);
}
function buildChannelAuth(opts, pusher) {
    let channelAuthorization;
    if ('channelAuthorization' in opts) {
        channelAuthorization = Object.assign(Object.assign({}, defaults.channelAuthorization), opts.channelAuthorization);
    }
    else {
        channelAuthorization = {
            transport: opts.authTransport || defaults.authTransport,
            endpoint: opts.authEndpoint || defaults.authEndpoint
        };
        if ('auth' in opts) {
            if ('params' in opts.auth)
                channelAuthorization.params = opts.auth.params;
            if ('headers' in opts.auth)
                channelAuthorization.headers = opts.auth.headers;
        }
        if ('authorizer' in opts)
            channelAuthorization.customHandler = ChannelAuthorizerProxy(pusher, channelAuthorization, opts.authorizer);
    }
    return channelAuthorization;
}
function buildChannelAuthorizer(opts, pusher) {
    const channelAuthorization = buildChannelAuth(opts, pusher);
    if ('customHandler' in channelAuthorization &&
        channelAuthorization['customHandler'] != null) {
        return channelAuthorization['customHandler'];
    }
    return channel_authorizer(channelAuthorization);
}

// CONCATENATED MODULE: ./src/core/watchlist.ts


class watchlist_WatchlistFacade extends dispatcher_Dispatcher {
    constructor(pusher) {
        super(function (eventName, data) {
            logger.debug(`No callbacks on watchlist events for ${eventName}`);
        });
        this.pusher = pusher;
        this.bindWatchlistInternalEvent();
    }
    handleEvent(pusherEvent) {
        pusherEvent.data.events.forEach(watchlistEvent => {
            this.emit(watchlistEvent.name, watchlistEvent);
        });
    }
    bindWatchlistInternalEvent() {
        this.pusher.connection.bind('message', pusherEvent => {
            var eventName = pusherEvent.event;
            if (eventName === 'pusher_internal:watchlist_events') {
                this.handleEvent(pusherEvent);
            }
        });
    }
}

// CONCATENATED MODULE: ./src/core/utils/flat_promise.ts
function flatPromise() {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return { promise, resolve, reject };
}
/* harmony default export */ var flat_promise = (flatPromise);

// CONCATENATED MODULE: ./src/core/user.ts





class user_UserFacade extends dispatcher_Dispatcher {
    constructor(pusher) {
        super(function (eventName, data) {
            logger.debug('No callbacks on user for ' + eventName);
        });
        this.signin_requested = false;
        this.user_data = null;
        this.serverToUserChannel = null;
        this.signinDonePromise = null;
        this._signinDoneResolve = null;
        this._onAuthorize = (err, authData) => {
            if (err) {
                logger.warn(`Error during signin: ${err}`);
                this._cleanup();
                return;
            }
            this.pusher.send_event('pusher:signin', {
                auth: authData.auth,
                user_data: authData.user_data
            });
        };
        this.pusher = pusher;
        this.pusher.connection.bind('state_change', ({ previous, current }) => {
            if (previous !== 'connected' && current === 'connected') {
                this._signin();
            }
            if (previous === 'connected' && current !== 'connected') {
                this._cleanup();
                this._newSigninPromiseIfNeeded();
            }
        });
        this.watchlist = new watchlist_WatchlistFacade(pusher);
        this.pusher.connection.bind('message', event => {
            var eventName = event.event;
            if (eventName === 'pusher:signin_success') {
                this._onSigninSuccess(event.data);
            }
            if (this.serverToUserChannel &&
                this.serverToUserChannel.name === event.channel) {
                this.serverToUserChannel.handleEvent(event);
            }
        });
    }
    signin() {
        if (this.signin_requested) {
            return;
        }
        this.signin_requested = true;
        this._signin();
    }
    _signin() {
        if (!this.signin_requested) {
            return;
        }
        this._newSigninPromiseIfNeeded();
        if (this.pusher.connection.state !== 'connected') {
            return;
        }
        this.pusher.config.userAuthenticator({
            socketId: this.pusher.connection.socket_id
        }, this._onAuthorize);
    }
    _onSigninSuccess(data) {
        try {
            this.user_data = JSON.parse(data.user_data);
        }
        catch (e) {
            logger.error(`Failed parsing user data after signin: ${data.user_data}`);
            this._cleanup();
            return;
        }
        if (typeof this.user_data.id !== 'string' || this.user_data.id === '') {
            logger.error(`user_data doesn't contain an id. user_data: ${this.user_data}`);
            this._cleanup();
            return;
        }
        this._signinDoneResolve();
        this._subscribeChannels();
    }
    _subscribeChannels() {
        const ensure_subscribed = channel => {
            if (channel.subscriptionPending && channel.subscriptionCancelled) {
                channel.reinstateSubscription();
            }
            else if (!channel.subscriptionPending &&
                this.pusher.connection.state === 'connected') {
                channel.subscribe();
            }
        };
        this.serverToUserChannel = new channel_Channel(`#server-to-user-${this.user_data.id}`, this.pusher);
        this.serverToUserChannel.bind_global((eventName, data) => {
            if (eventName.indexOf('pusher_internal:') === 0 ||
                eventName.indexOf('pusher:') === 0) {
                return;
            }
            this.emit(eventName, data);
        });
        ensure_subscribed(this.serverToUserChannel);
    }
    _cleanup() {
        this.user_data = null;
        if (this.serverToUserChannel) {
            this.serverToUserChannel.unbind_all();
            this.serverToUserChannel.disconnect();
            this.serverToUserChannel = null;
        }
        if (this.signin_requested) {
            this._signinDoneResolve();
        }
    }
    _newSigninPromiseIfNeeded() {
        if (!this.signin_requested) {
            return;
        }
        if (this.signinDonePromise && !this.signinDonePromise.done) {
            return;
        }
        const { promise, resolve, reject: _ } = flat_promise();
        promise.done = false;
        const setDone = () => {
            promise.done = true;
        };
        promise.then(setDone).catch(setDone);
        this.signinDonePromise = promise;
        this._signinDoneResolve = resolve;
    }
}

// CONCATENATED MODULE: ./src/core/pusher.ts













class pusher_Pusher {
    static ready() {
        pusher_Pusher.isReady = true;
        for (var i = 0, l = pusher_Pusher.instances.length; i < l; i++) {
            pusher_Pusher.instances[i].connect();
        }
    }
    static getClientFeatures() {
        return keys(filterObject({ ws: runtime.Transports.ws }, function (t) {
            return t.isSupported({});
        }));
    }
    constructor(app_key, options) {
        checkAppKey(app_key);
        validateOptions(options);
        this.key = app_key;
        this.config = getConfig(options, this);
        this.channels = factory.createChannels();
        this.global_emitter = new dispatcher_Dispatcher();
        this.sessionID = runtime.randomInt(1000000000);
        this.timeline = new timeline_Timeline(this.key, this.sessionID, {
            cluster: this.config.cluster,
            features: pusher_Pusher.getClientFeatures(),
            params: this.config.timelineParams || {},
            limit: 50,
            level: timeline_level.INFO,
            version: defaults.VERSION
        });
        if (this.config.enableStats) {
            this.timelineSender = factory.createTimelineSender(this.timeline, {
                host: this.config.statsHost,
                path: '/timeline/v2/' + runtime.TimelineTransport.name
            });
        }
        var getStrategy = (options) => {
            return runtime.getDefaultStrategy(this.config, options, strategy_builder_defineTransport);
        };
        this.connection = factory.createConnectionManager(this.key, {
            getStrategy: getStrategy,
            timeline: this.timeline,
            activityTimeout: this.config.activityTimeout,
            pongTimeout: this.config.pongTimeout,
            unavailableTimeout: this.config.unavailableTimeout,
            useTLS: Boolean(this.config.useTLS)
        });
        this.connection.bind('connected', () => {
            this.subscribeAll();
            if (this.timelineSender) {
                this.timelineSender.send(this.connection.isUsingTLS());
            }
        });
        this.connection.bind('message', event => {
            var eventName = event.event;
            var internal = eventName.indexOf('pusher_internal:') === 0;
            if (event.channel) {
                var channel = this.channel(event.channel);
                if (channel) {
                    channel.handleEvent(event);
                }
            }
            if (!internal) {
                this.global_emitter.emit(event.event, event.data);
            }
        });
        this.connection.bind('connecting', () => {
            this.channels.disconnect();
        });
        this.connection.bind('disconnected', () => {
            this.channels.disconnect();
        });
        this.connection.bind('error', err => {
            logger.warn(err);
        });
        pusher_Pusher.instances.push(this);
        this.timeline.info({ instances: pusher_Pusher.instances.length });
        this.user = new user_UserFacade(this);
        if (pusher_Pusher.isReady) {
            this.connect();
        }
    }
    channel(name) {
        return this.channels.find(name);
    }
    allChannels() {
        return this.channels.all();
    }
    connect() {
        this.connection.connect();
        if (this.timelineSender) {
            if (!this.timelineSenderTimer) {
                var usingTLS = this.connection.isUsingTLS();
                var timelineSender = this.timelineSender;
                this.timelineSenderTimer = new timers_PeriodicTimer(60000, function () {
                    timelineSender.send(usingTLS);
                });
            }
        }
    }
    disconnect() {
        this.connection.disconnect();
        if (this.timelineSenderTimer) {
            this.timelineSenderTimer.ensureAborted();
            this.timelineSenderTimer = null;
        }
    }
    bind(event_name, callback, context) {
        this.global_emitter.bind(event_name, callback, context);
        return this;
    }
    unbind(event_name, callback, context) {
        this.global_emitter.unbind(event_name, callback, context);
        return this;
    }
    bind_global(callback) {
        this.global_emitter.bind_global(callback);
        return this;
    }
    unbind_global(callback) {
        this.global_emitter.unbind_global(callback);
        return this;
    }
    unbind_all(callback) {
        this.global_emitter.unbind_all();
        return this;
    }
    subscribeAll() {
        var channelName;
        for (channelName in this.channels.channels) {
            if (this.channels.channels.hasOwnProperty(channelName)) {
                this.subscribe(channelName);
            }
        }
    }
    subscribe(channel_name) {
        var channel = this.channels.add(channel_name, this);
        if (channel.subscriptionPending && channel.subscriptionCancelled) {
            channel.reinstateSubscription();
        }
        else if (!channel.subscriptionPending &&
            this.connection.state === 'connected') {
            channel.subscribe();
        }
        return channel;
    }
    unsubscribe(channel_name) {
        var channel = this.channels.find(channel_name);
        if (channel && channel.subscriptionPending) {
            channel.cancelSubscription();
        }
        else {
            channel = this.channels.remove(channel_name);
            if (channel && channel.subscribed) {
                channel.unsubscribe();
            }
        }
    }
    send_event(event_name, data, channel) {
        return this.connection.send_event(event_name, data, channel);
    }
    shouldUseTLS() {
        return this.config.useTLS;
    }
    signin() {
        this.user.signin();
    }
}
pusher_Pusher.instances = [];
pusher_Pusher.isReady = false;
pusher_Pusher.logToConsole = false;
pusher_Pusher.Runtime = runtime;
pusher_Pusher.ScriptReceivers = runtime.ScriptReceivers;
pusher_Pusher.DependenciesReceivers = runtime.DependenciesReceivers;
pusher_Pusher.auth_callbacks = runtime.auth_callbacks;
/* harmony default export */ var core_pusher = __webpack_exports__["default"] = (pusher_Pusher);
function checkAppKey(key) {
    if (key === null || key === undefined) {
        throw 'You must pass your app key when you instantiate Pusher.';
    }
}
runtime.setup(pusher_Pusher);


/***/ })
/******/ ]);
});
//# sourceMappingURL=pusher.js.map

/***/ }),

/***/ 55798:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 54403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(67294));
var swiper_1 = __importDefault(__webpack_require__(25462));
var object_assign_1 = __importDefault(__webpack_require__(96086));
var utils_1 = __webpack_require__(23631);
var hooks_1 = __webpack_require__(21167);
var ReactIdSwiper = react_1.forwardRef(function (props, externalRef) {
    var activeSlideKey = props.activeSlideKey, ContainerEl = props.ContainerEl, children = props.children, containerClass = props.containerClass, navigation = props.navigation, noSwiping = props.noSwiping, pagination = props.pagination, parallax = props.parallax, parallaxEl = props.parallaxEl, WrapperEl = props.WrapperEl, wrapperClass = props.wrapperClass, rebuildOnUpdate = props.rebuildOnUpdate, renderScrollbar = props.renderScrollbar, renderPagination = props.renderPagination, renderPrevButton = props.renderPrevButton, renderNextButton = props.renderNextButton, renderParallax = props.renderParallax, rtl = props.rtl, scrollbar = props.scrollbar, shouldSwiperUpdate = props.shouldSwiperUpdate, slideClass = props.slideClass, loop = props.loop;
    // Define swiper instance ref
    var swiperInstanceRef = react_1.useRef(null);
    // Internal ref
    var swiperNodeRef = react_1.useRef(null);
    // Forked ref
    var ref = hooks_1.useForkRef(swiperNodeRef, externalRef);
    // Get current active slide key
    var getActiveSlideIndexFromProps = react_1.useCallback(function () {
        if (!activeSlideKey) {
            return null;
        }
        var activeSlideId = 0;
        // In loop mode first slide index should be 1
        var id = loop ? 1 : 0;
        react_1.Children.forEach(children, function (child) {
            if (react_1.isValidElement(child)) {
                if (child.key === activeSlideKey) {
                    activeSlideId = id;
                }
                id += 1;
            }
        });
        return activeSlideId;
    }, [activeSlideKey, children, loop]);
    // Destroy swiper
    var destroySwiper = react_1.useCallback(function () {
        if (swiperInstanceRef.current !== null) {
            swiperInstanceRef.current.destroy(true, true);
            utils_1.setRef(swiperInstanceRef, null);
        }
    }, []);
    // Initialize swiper
    var buildSwiper = react_1.useCallback(function () {
        if (swiperNodeRef.current && swiperInstanceRef.current === null) {
            utils_1.setRef(swiperInstanceRef, new swiper_1.default(swiperNodeRef.current, object_assign_1.default({}, props)));
        }
    }, [props]);
    // Render slides
    var renderContent = function (e) {
        if (!utils_1.isReactElement(e)) {
            return null;
        }
        var slideClassNames = [slideClass, e.props.className];
        if (noSwiping) {
            slideClassNames.push('swiper-no-swiping');
        }
        return react_1.cloneElement(e, __assign(__assign({}, e.props), { className: slideClassNames.join(' ').trim() }));
    };
    // Destroy Swiper instance when component is unmounted
    react_1.useEffect(function () {
        return function () { return destroySwiper(); };
    }, [destroySwiper]);
    react_1.useEffect(function () {
        buildSwiper();
        if (swiperInstanceRef.current !== null) {
            if (rebuildOnUpdate) {
                destroySwiper();
                buildSwiper();
            }
            else if (shouldSwiperUpdate) {
                swiperInstanceRef.current.update();
            }
            var numSlides = swiperInstanceRef.current.slides.length;
            if (numSlides <= swiperInstanceRef.current.activeIndex) {
                var index = Math.max(numSlides - 1, 0);
                swiperInstanceRef.current.slideTo(index);
            }
            var slideToIndex = getActiveSlideIndexFromProps();
            if (slideToIndex !== null) {
                swiperInstanceRef.current.slideTo(slideToIndex);
            }
        }
    }, [
        destroySwiper,
        getActiveSlideIndexFromProps,
        rebuildOnUpdate,
        shouldSwiperUpdate,
        buildSwiper
    ]);
    // No render if wrapper elements are not provided
    if (!children || !ContainerEl || !WrapperEl) {
        return null;
    }
    // Validate children props
    if (!utils_1.validateChildren(children)) {
        if (false) {}
        return null;
    }
    return (react_1.default.createElement(ContainerEl, { className: containerClass, dir: rtl && 'rtl', ref: ref },
        parallax && parallaxEl && renderParallax && renderParallax(props),
        react_1.default.createElement(WrapperEl, { className: wrapperClass }, react_1.Children.map(children, renderContent)),
        pagination && pagination.el && renderPagination && renderPagination(props),
        scrollbar && scrollbar.el && renderScrollbar && renderScrollbar(props),
        navigation && navigation.nextEl && renderNextButton && renderNextButton(props),
        navigation && navigation.prevEl && renderPrevButton && renderPrevButton(props)));
});
// Default props
ReactIdSwiper.defaultProps = {
    containerClass: 'swiper-container',
    wrapperClass: 'swiper-wrapper',
    slideClass: 'swiper-slide',
    ContainerEl: 'div',
    WrapperEl: 'div',
    renderScrollbar: function (_a) {
        var scrollbar = _a.scrollbar;
        return scrollbar ? react_1.default.createElement("div", { className: utils_1.classNames(scrollbar.el) }) : null;
    },
    renderPagination: function (_a) {
        var pagination = _a.pagination;
        return pagination ? react_1.default.createElement("div", { className: utils_1.classNames(pagination.el) }) : null;
    },
    renderPrevButton: function (_a) {
        var navigation = _a.navigation;
        return navigation ? react_1.default.createElement("div", { className: utils_1.classNames(navigation.prevEl) }) : null;
    },
    renderNextButton: function (_a) {
        var navigation = _a.navigation;
        return navigation ? react_1.default.createElement("div", { className: utils_1.classNames(navigation.nextEl) }) : null;
    },
    renderParallax: function (_a) {
        var parallaxEl = _a.parallaxEl;
        return parallaxEl ? (react_1.default.createElement("div", { className: utils_1.classNames(parallaxEl.el), "data-swiper-parallax": parallaxEl.value })) : null;
    }
};
ReactIdSwiper.displayName = 'ReactIdSwiper';
exports["default"] = ReactIdSwiper;


/***/ }),

/***/ 21167:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useForkRef = void 0;
var react_1 = __webpack_require__(67294);
var utils_1 = __webpack_require__(23631);
exports.useForkRef = function (refA, refB) {
    return react_1.useMemo(function () {
        if (refA == null && refB == null) {
            return null;
        }
        return function (refValue) {
            utils_1.setRef(refA, refValue);
            utils_1.setRef(refB, refValue);
        };
    }, [refA, refB]);
};


/***/ }),

/***/ 88667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var ReactIdSwiper_1 = __importDefault(__webpack_require__(54403));
// React-id-swiper
exports["default"] = ReactIdSwiper_1.default;


/***/ }),

/***/ 23631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setRef = exports.isModuleAvailable = exports.isReactElement = exports.validateChildren = exports.classNames = void 0;
var react_1 = __webpack_require__(67294);
exports.classNames = function (el) {
    if (typeof el === 'string') {
        return el.split('.').join(' ').trim();
    }
    else if (el instanceof HTMLElement) {
        return el.className;
    }
    return '';
};
exports.validateChildren = function (children) {
    var isValid = true;
    if (Array.isArray(children)) {
        react_1.Children.forEach(children, function (child) {
            if (!react_1.isValidElement(child)) {
                isValid = false;
            }
        });
    }
    else {
        isValid = react_1.isValidElement(children);
    }
    return isValid;
};
exports.isReactElement = function (element) {
    return react_1.isValidElement(element) &&
        (typeof element.type === 'string' ||
            typeof element.type === 'function' ||
            typeof element.type === 'object');
};
exports.isModuleAvailable = function (modules, moduleName) {
    var moduleAvailable = false;
    for (var i = 0; i < modules.length; i++) {
        if (modules[i].name === moduleName) {
            moduleAvailable = true;
            break;
        }
    }
    return moduleAvailable;
};
exports.setRef = function (ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
};


/***/ }),

/***/ 76627:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(53462);
} else {}


/***/ }),

/***/ 53462:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(__webpack_require__(67294)),reactDom=__webpack_require__(73935);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r)}return e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else{var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select()}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else{var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length))}return{start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return{maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1)}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return-1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return!1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return!u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return!0;if(++s>=l.length)return!1}var t,n,a,i;return!isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return!1;var t,n;return(isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h)}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return"function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return(!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e)}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop)},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop()},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null)},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e)},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t)},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t)}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)})},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e)},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return{mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return!0}catch(r){}return!f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized(_assertThisInitialized(f)).beforePasteState,n=_assertThisInitialized(_assertThisInitialized(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end)},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else{var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end)}f.runSaveSelectionLoop()}isFunction(f.props.onFocus)&&f.props.onFocus(e)},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e)}isFunction(f.props.onBlur)&&f.props.onBlur(e)},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd()}};document.addEventListener("mouseup",r)}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e)},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""))},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e)};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value))},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p))}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end)}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate())},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop()},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1)}else t=React.createElement("input",_extends({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);module.exports=InputElement;


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 51655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "ZP", ({
  enumerable: true,
  get: function get() {
    return _skeleton.default;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _skeletonTheme.default;
  }
});

var _skeleton = _interopRequireDefault(__webpack_require__(59020));

var _skeletonTheme = _interopRequireDefault(__webpack_require__(65201));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 65201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _core = __webpack_require__(62568);

var _skeleton = __webpack_require__(59020);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SkeletonTheme =
/*#__PURE__*/
function (_Component) {
  _inherits(SkeletonTheme, _Component);

  function SkeletonTheme() {
    _classCallCheck(this, SkeletonTheme);

    return _possibleConstructorReturn(this, _getPrototypeOf(SkeletonTheme).apply(this, arguments));
  }

  _createClass(SkeletonTheme, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          highlightColor = _this$props.highlightColor,
          children = _this$props.children;
      var themeStyles =
      /*#__PURE__*/
      (0, _core.css)(".react-loading-skeleton{background-color:", color, ";background-image:linear-gradient( 90deg,", color, ",", highlightColor, ",", color, " );};label:SkeletonTheme;" + ( true ? "" : 0));
      return (0, _core.jsx)("div", {
        css: themeStyles
      }, children);
    }
  }]);

  return SkeletonTheme;
}(_react.Component);

exports["default"] = SkeletonTheme;

_defineProperty(SkeletonTheme, "defaultProps", {
  color: _skeleton.defaultBaseColor,
  highlightColor: _skeleton.defaultHighlightColor
});

/***/ }),

/***/ 59020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Skeleton;
exports.skeletonStyles = exports.skeletonKeyframes = exports.defaultHighlightColor = exports.defaultBaseColor = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _core = __webpack_require__(62568);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    background-position: -200px 0;\n  }\n  ", "\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultBaseColor = "#eee";
exports.defaultBaseColor = defaultBaseColor;
var defaultHighlightColor = "#f5f5f5";
exports.defaultHighlightColor = defaultHighlightColor;

var skeletonKeyframes = function skeletonKeyframes(duration, delay) {
  return (0, _core.keyframes)(_templateObject(), delay > 0 ? "".concat(Math.floor(1 / (duration + delay) * duration * 100), "% {\n    background-position: calc(200px + 100%) 0;\n  }") : undefined);
};

exports.skeletonKeyframes = skeletonKeyframes;
var skeletonStyles =
/*#__PURE__*/
(0, _core.css)("background-color:", defaultBaseColor, ";background-image:linear-gradient( 90deg,", defaultBaseColor, ",", defaultHighlightColor, ",", defaultBaseColor, " );background-size:200px 100%;background-repeat:no-repeat;border-radius:4px;display:inline-block;line-height:1;width:100%;;label:skeletonStyles;" + ( true ? "" : 0));
exports.skeletonStyles = skeletonStyles;

function Skeleton(_ref) {
  var count = _ref.count,
      duration = _ref.duration,
      width = _ref.width,
      Wrapper = _ref.wrapper,
      height = _ref.height,
      circle = _ref.circle,
      delay = _ref.delay,
      customStyle = _ref.style,
      customClassName = _ref.className;
  var elements = [];

  for (var i = 0; i < count; i++) {
    var style = {};

    if (width !== null) {
      style.width = width;
    }

    if (height !== null) {
      style.height = height;
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = "50%";
    }

    var className = "react-loading-skeleton";

    if (customClassName) {
      className += " " + customClassName;
    }

    elements.push((0, _core.jsx)("span", {
      key: i,
      className: className,
      css:
      /*#__PURE__*/
      (0, _core.css)(skeletonStyles, " animation:", skeletonKeyframes(duration, delay), " ", duration + delay, "s ease-in-out infinite;label:Skeleton;" + ( true ? "" : 0)),
      style: _objectSpread({}, customStyle, {}, style)
    }, "\u200C"));
  }

  return (0, _core.jsx)("span", null, Wrapper ? elements.map(function (element, i) {
    return (0, _core.jsx)(Wrapper, {
      key: i
    }, element, "\u200C");
  }) : elements);
}

Skeleton.defaultProps = {
  count: 1,
  duration: 1.2,
  width: null,
  wrapper: null,
  height: null,
  circle: false,
  delay: 0
};

/***/ }),

/***/ 14416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "$j": function() { return /* reexport */ connect; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = createSubscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js

var selectorFactory_excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, selectorFactory_excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js


var connect_excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,esm_extends/* default */.Z)({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/createConnect());
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore = context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestStoreState = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 48477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(ButtonElement);

/***/ }),

/***/ 35343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(18000);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(52987);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports["default"] = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),

/***/ 68939:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(LinkElement);

/***/ }),

/***/ 66261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.NY = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.W_ = __webpack_unused_export__ = exports.rU = undefined;

var _Link = __webpack_require__(68939);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(48477);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(35343);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(87606);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(53200);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(18000);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(98482);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.rU = _Link2.default;
__webpack_unused_export__ = _Button2.default;
exports.W_ = _Element2.default;
__webpack_unused_export__ = _scroller2.default;
__webpack_unused_export__ = _scrollEvents2.default;
__webpack_unused_export__ = _scrollSpy2.default;
exports.NY = _animateScroll2.default;
__webpack_unused_export__ = _scrollLink2.default;
__webpack_unused_export__ = _scrollElement2.default;
__webpack_unused_export__ = _Helpers2.default;
__webpack_unused_export__ = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),

/***/ 98482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(67294);
var ReactDOM = __webpack_require__(73935);

var utils = __webpack_require__(54259);
var scrollSpy = __webpack_require__(87606);
var defaultScroller = __webpack_require__(82628);
var PropTypes = __webpack_require__(52987);
var scrollHash = __webpack_require__(29678);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),

/***/ 53200:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(89765);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(50140);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports["default"] = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ 50140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports["default"] = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),

/***/ 55236:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),

/***/ 18000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(52987);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports["default"] = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),

/***/ 64592:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports["default"] = Events;

/***/ }),

/***/ 29678:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports["default"] = scrollHash;

/***/ }),

/***/ 31093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(87606);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(52987);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(29678);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports["default"] = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),

/***/ 87606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _lodash = __webpack_require__(93096);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(55236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports["default"] = scrollSpy;

/***/ }),

/***/ 82628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(53200);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports["default"] = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),

/***/ 89765:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ 54259:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(null, "", urlToPush) : history.replaceState(null, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports["default"] = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),

/***/ 68423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(38606);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 52987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68423)();
}


/***/ }),

/***/ 38606:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 89570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ Select; }
});

// UNUSED EXPORTS: a, b, c, d, g, m

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-c7a4d7ce.esm.js + 2 modules
var index_c7a4d7ce_esm = __webpack_require__(11604);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(30845);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/react-select/dist/Select-126cf1dd.esm.js












function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref =  true ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : 0;

var A11yText = function A11yText(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", (0,esm_extends/* default */.Z)({
    css: _ref
  }, props));
};

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
        isMulti = props.isMulti,
        isDisabled = props.isDisabled,
        tabSelectsValue = props.tabSelectsValue,
        context = props.context;

    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';

      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
        _props$label = props.label,
        label = _props$label === void 0 ? '' : _props$label,
        labels = props.labels,
        isDisabled = props.isDisabled;

    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");

      case 'clear':
        return 'All selected options have been cleared.';

      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");

      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");

      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
        focused = props.focused,
        options = props.options,
        _props$label2 = props.label,
        label = _props$label2 === void 0 ? '' : _props$label2,
        selectValue = props.selectValue,
        isDisabled = props.isDisabled,
        isSelected = props.isSelected;

    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };

    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }

    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }

    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
        resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
      focusedOption = props.focusedOption,
      focusedValue = props.focusedValue,
      focusableOptions = props.focusableOptions,
      isFocused = props.isFocused,
      selectValue = props.selectValue,
      selectProps = props.selectProps,
      id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
      getOptionLabel = selectProps.getOptionLabel,
      inputValue = selectProps.inputValue,
      isMulti = selectProps.isMulti,
      isOptionDisabled = selectProps.isOptionDisabled,
      isSearchable = selectProps.isSearchable,
      menuIsOpen = selectProps.menuIsOpen,
      options = selectProps.options,
      screenReaderStatus = selectProps.screenReaderStatus,
      tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes

  var messages = (0,react.useMemo)(function () {
    return (0,index_c7a4d7ce_esm.a)((0,index_c7a4d7ce_esm.a)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]); // Update aria live selected option when prop changes

  var ariaSelected = (0,react.useMemo)(function () {
    var message = '';

    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
          selectedOptions = ariaSelection.options,
          removedValue = ariaSelection.removedValue,
          removedValues = ariaSelection.removedValues,
          value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value

      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      }; // If there is just one item from the action then get its label


      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : ''; // If there are multiple items from the action then return an array of labels

      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];

      var onChangeProps = (0,index_c7a4d7ce_esm.a)({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);

      message = messages.onChange(onChangeProps);
    }

    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = (0,react.useMemo)(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));

    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: options,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }

    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, options, selectValue]);
  var ariaResults = (0,react.useMemo)(function () {
    var resultsMsg = '';

    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }

    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = (0,react.useMemo)(function () {
    var guidanceMsg = '';

    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }

    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    id: "aria-selection"
  }, ariaSelected), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(A11yText, {
    id: id
  }, isInitialFocus && ScreenReaderText), (0,emotion_react_browser_esm/* jsx */.tZ)(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = (0,memoize_one_esm/* default */.Z)(stripDiacritics);

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;

    var _ignoreCase$ignoreAcc = (0,index_c7a4d7ce_esm.a)({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _excluded = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, props, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    },  true ? "" : 0,  true ? "" : 0)
  }));
}

var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};

function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var isBottom = (0,react.useRef)(false);
  var isTop = (0,react.useRef)(false);
  var touchStart = (0,react.useRef)(0);
  var scrollTarget = (0,react.useRef)(null);
  var handleEventDelta = (0,react.useCallback)(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
        scrollTop = _scrollTarget$current.scrollTop,
        scrollHeight = _scrollTarget$current.scrollHeight,
        clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false; // reset bottom/top flags

    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }

    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    } // bottom limit


    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }

      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true; // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }

      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    } // cancel scroll


    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = (0,react.useCallback)(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = (0,react.useCallback)(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = (0,react.useCallback)(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = index_c7a4d7ce_esm.s ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface


function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
      _ref$accountForScroll = _ref.accountForScrollbars,
      accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = (0,react.useRef)({});
  var scrollTarget = (0,react.useRef)(null);
  var addScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    } // apply the lock styles and padding if this is the first scroll lock


    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });

      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    } // account for touch devices


    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions); // Allow scroll on provided target

      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    } // increment active scroll locks


    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style; // safely decrement active scroll locks

    activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    } // remove touch listeners


    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};

var _ref2 =  true ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : 0;

function ScrollManager(_ref) {
  var children = _ref.children,
      lockEnabled = _ref.lockEnabled,
      _ref$captureEnabled = _ref.captureEnabled,
      captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });

  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, lockEnabled && (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    onClick: blurSelectInput,
    css: _ref2
  }), children(targetRef));
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: index_c7a4d7ce_esm.b,
  container: index_c7a4d7ce_esm.d,
  control: index_c7a4d7ce_esm.e,
  dropdownIndicator: index_c7a4d7ce_esm.f,
  group: index_c7a4d7ce_esm.g,
  groupHeading: index_c7a4d7ce_esm.h,
  indicatorsContainer: index_c7a4d7ce_esm.i,
  indicatorSeparator: index_c7a4d7ce_esm.j,
  input: index_c7a4d7ce_esm.k,
  loadingIndicator: index_c7a4d7ce_esm.l,
  loadingMessage: index_c7a4d7ce_esm.m,
  menu: index_c7a4d7ce_esm.n,
  menuList: index_c7a4d7ce_esm.o,
  menuPortal: index_c7a4d7ce_esm.p,
  multiValue: index_c7a4d7ce_esm.q,
  multiValueLabel: index_c7a4d7ce_esm.r,
  multiValueRemove: index_c7a4d7ce_esm.t,
  noOptionsMessage: index_c7a4d7ce_esm.u,
  option: index_c7a4d7ce_esm.v,
  placeholder: index_c7a4d7ce_esm.w,
  singleValue: index_c7a4d7ce_esm.x,
  valueContainer: index_c7a4d7ce_esm.y
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _objectSpread2({}, source); // massage in target styles


  Object.keys(target).forEach(function (keyAsString) {
    var key = keyAsString;

    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: (0,index_c7a4d7ce_esm.z)(),
  captureMenuScroll: !(0,index_c7a4d7ce_esm.z)(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !(0,index_c7a4d7ce_esm.A)(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};

function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);

  var isSelected = _isOptionSelected(props, option, selectValue);

  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}

function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }

    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(index_c7a4d7ce_esm.G);
}

function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }

    return optionsAccumulator;
  }, []);
}

function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}

function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
      inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
      isSelected = categorizedOption.isSelected,
      label = categorizedOption.label,
      value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}

function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
      lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }

  return null;
}

function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}

var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};

var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};

function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}

function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;

  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }

  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}

function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}

var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
      isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};

var instanceId = 1;

var Select = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Select, _Component);

  var _super = (0,index_c7a4d7ce_esm._)(Select);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Select);

    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      actionMeta.name = name;

      _this.ariaOnChange(newValue, actionMeta);

      onChange(newValue, actionMeta);
    };

    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti,
          inputValue = _this$props2.inputValue;

      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });

      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.setState({
        clearFocusValueOnUpdate: true
      });

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti,
          name = _this$props3.name;
      var selectValue = _this.state.selectValue;

      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);

      var isDisabled = _this.isOptionDisabled(newValue, selectValue);

      if (deselected) {
        var candidate = _this.getOptionValue(newValue);

        _this.setValue((0,index_c7a4d7ce_esm.B)(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue((0,index_c7a4d7ce_esm.B)([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue((0,index_c7a4d7ce_esm.C)(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange((0,index_c7a4d7ce_esm.C)(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });

        return;
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = (0,index_c7a4d7ce_esm.D)(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;

      _this.onChange((0,index_c7a4d7ce_esm.D)(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };

    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = (0,index_c7a4d7ce_esm.D)(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return index_c7a4d7ce_esm.E.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };

    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getComponents = function () {
      return (0,index_c7a4d7ce_esm.F)(_this.props);
    };

    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };

    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };

    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };

    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };

    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: (0,index_c7a4d7ce_esm.a)({
          value: value
        }, actionMeta)
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.preventDefault();
      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && (0,index_c7a4d7ce_esm.H)(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;

      _this.setState({
        inputIsHiddenAfterUpdate: false
      });

      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;

      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };

    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
          isMulti = _this$props5.isMulti,
          backspaceRemovesValue = _this$props5.backspaceRemovesValue,
          escapeClearsValue = _this$props5.escapeClearsValue,
          inputValue = _this$props5.inputValue,
          isClearable = _this$props5.isClearable,
          isDisabled = _this$props5.isDisabled,
          menuIsOpen = _this$props5.menuIsOpen,
          onKeyDown = _this$props5.onKeyDown,
          tabSelectsValue = _this$props5.tabSelectsValue,
          openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
          focusedOption = _this$state.focusedOption,
          focusedValue = _this$state.focusedValue,
          selectValue = _this$state.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });

            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = (0,index_c7a4d7ce_esm.I)(_props.value);
    return _this;
  }

  (0,createClass/* default */.Z)(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
          isDisabled = _this$props6.isDisabled,
          menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        (0,index_c7a4d7ce_esm.J)(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    } // ==============================
    // Consumer Handlers
    // ==============================

  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state2 = this.state,
          selectValue = _this$state2.selectValue,
          isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;

      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing

      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: // ==============================
    // Getters
    // ==============================
    function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return (0,index_c7a4d7ce_esm.a)((0,index_c7a4d7ce_esm.a)({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          selectOption = this.selectOption,
          setValue = this.setValue,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
          isClearable = _this$props7.isClearable,
          isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    value: // ==============================
    // Composition Handlers
    // ==============================
    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: // ==============================
    // Touch Handlers
    // ==============================
    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
          isDisabled = _this$props8.isDisabled,
          isSearchable = _this$props8.isSearchable,
          inputId = _this$props8.inputId,
          inputValue = _this$props8.inputValue,
          tabIndex = _this$props8.tabIndex,
          form = _this$props8.form,
          menuIsOpen = _this$props8.menuIsOpen;

      var _this$getComponents = this.getComponents(),
          Input = _this$getComponents.Input;

      var _this$state4 = this.state,
          inputIsHidden = _this$state4.inputIsHidden,
          ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = (0,index_c7a4d7ce_esm.a)((0,index_c7a4d7ce_esm.a)({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-controls': this.getElementId('listbox'),
        'aria-owns': this.getElementId('listbox'),
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        role: 'combobox'
      }, !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/react.createElement(DummyInput, (0,esm_extends/* default */.Z)({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: index_c7a4d7ce_esm.K,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }

      return /*#__PURE__*/react.createElement(Input, (0,esm_extends/* default */.Z)({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;

      var _this$getComponents2 = this.getComponents(),
          MultiValue = _this$getComponents2.MultiValue,
          MultiValueContainer = _this$getComponents2.MultiValueContainer,
          MultiValueLabel = _this$getComponents2.MultiValueLabel,
          MultiValueRemove = _this$getComponents2.MultiValueRemove,
          SingleValue = _this$getComponents2.SingleValue,
          Placeholder = _this$getComponents2.Placeholder;

      var commonProps = this.commonProps;
      var _this$props9 = this.props,
          controlShouldRenderValue = _this$props9.controlShouldRenderValue,
          isDisabled = _this$props9.isDisabled,
          isMulti = _this$props9.isMulti,
          inputValue = _this$props9.inputValue,
          placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
          selectValue = _this$state5.selectValue,
          focusedValue = _this$state5.focusedValue,
          isFocused = _this$state5.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/react.createElement(Placeholder, (0,esm_extends/* default */.Z)({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }

      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/react.createElement(MultiValue, (0,esm_extends/* default */.Z)({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return /*#__PURE__*/react.createElement(SingleValue, (0,esm_extends/* default */.Z)({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
          ClearIndicator = _this$getComponents3.ClearIndicator;

      var commonProps = this.commonProps;
      var _this$props10 = this.props,
          isDisabled = _this$props10.isDisabled,
          isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(ClearIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
          LoadingIndicator = _this$getComponents4.LoadingIndicator;

      var commonProps = this.commonProps;
      var _this$props11 = this.props,
          isDisabled = _this$props11.isDisabled,
          isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(LoadingIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
          DropdownIndicator = _this$getComponents5.DropdownIndicator,
          IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator


      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/react.createElement(IndicatorSeparator, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
          DropdownIndicator = _this$getComponents6.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(DropdownIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;

      var _this$getComponents7 = this.getComponents(),
          Group = _this$getComponents7.Group,
          GroupHeading = _this$getComponents7.GroupHeading,
          Menu = _this$getComponents7.Menu,
          MenuList = _this$getComponents7.MenuList,
          MenuPortal = _this$getComponents7.MenuPortal,
          LoadingMessage = _this$getComponents7.LoadingMessage,
          NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
          Option = _this$getComponents7.Option;

      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
          captureMenuScroll = _this$props12.captureMenuScroll,
          inputValue = _this$props12.inputValue,
          isLoading = _this$props12.isLoading,
          loadingMessage = _this$props12.loadingMessage,
          minMenuHeight = _this$props12.minMenuHeight,
          maxMenuHeight = _this$props12.maxMenuHeight,
          menuIsOpen = _this$props12.menuIsOpen,
          menuPlacement = _this$props12.menuPlacement,
          menuPosition = _this$props12.menuPosition,
          menuPortalTarget = _this$props12.menuPortalTarget,
          menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
          noOptionsMessage = _this$props12.noOptionsMessage,
          onMenuScrollToTop = _this$props12.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props, id) {
        var type = props.type,
            data = props.data,
            isDisabled = props.isDisabled,
            isSelected = props.isSelected,
            label = props.label,
            value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/react.createElement(Option, (0,esm_extends/* default */.Z)({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
                options = item.options,
                groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/react.createElement(Group, (0,esm_extends/* default */.Z)({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/react.createElement(index_c7a4d7ce_esm.M, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
            _ref4$placerProps = _ref4.placerProps,
            placement = _ref4$placerProps.placement,
            maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/react.createElement(Menu, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId('listbox')
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/react.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/react.createElement(MenuList, (0,esm_extends/* default */.Z)({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);

              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/react.createElement(MenuPortal, (0,esm_extends/* default */.Z)({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;

      var _this$props13 = this.props,
          delimiter = _this$props13.delimiter,
          isDisabled = _this$props13.isDisabled,
          isMulti = _this$props13.isMulti,
          name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/react.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/react.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return /*#__PURE__*/react.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
          ariaSelection = _this$state6.ariaSelection,
          focusedOption = _this$state6.focusedOption,
          focusedValue = _this$state6.focusedValue,
          isFocused = _this$state6.isFocused,
          selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/react.createElement(LiveRegion, (0,esm_extends/* default */.Z)({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
          Control = _this$getComponents8.Control,
          IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
          SelectContainer = _this$getComponents8.SelectContainer,
          ValueContainer = _this$getComponents8.ValueContainer;

      var _this$props14 = this.props,
          className = _this$props14.className,
          id = _this$props14.id,
          isDisabled = _this$props14.isDisabled,
          menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/react.createElement(SelectContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/react.createElement(Control, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/react.createElement(ValueContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/react.createElement(IndicatorsContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
          clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
          inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
          ariaSelection = state.ariaSelection,
          isFocused = state.isFocused,
          prevWasFocused = state.prevWasFocused;
      var options = props.options,
          value = props.value,
          menuIsOpen = props.menuIsOpen,
          inputValue = props.inputValue,
          isMulti = props.isMulti;
      var selectValue = (0,index_c7a4d7ce_esm.I)(value);
      var newMenuOptionsState = {};

      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      } // some updates should toggle the state of the input visibility


      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;

      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: (0,index_c7a4d7ce_esm.D)(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      } // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null


      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }

      return (0,index_c7a4d7ce_esm.a)((0,index_c7a4d7ce_esm.a)((0,index_c7a4d7ce_esm.a)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);

  return Select;
}(react.Component);

Select.defaultProps = defaultProps;




/***/ }),

/***/ 11604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ isMobileDevice; },
  "B": function() { return /* binding */ multiValueAsValue; },
  "C": function() { return /* binding */ singleValueAsValue; },
  "D": function() { return /* binding */ valueTernary; },
  "E": function() { return /* binding */ classNames; },
  "F": function() { return /* binding */ defaultComponents; },
  "G": function() { return /* binding */ notNullish; },
  "H": function() { return /* binding */ isDocumentElement; },
  "I": function() { return /* binding */ cleanValue; },
  "J": function() { return /* binding */ scrollIntoView; },
  "K": function() { return /* binding */ noop; },
  "L": function() { return /* binding */ handleInputChange; },
  "M": function() { return /* binding */ MenuPlacer; },
  "_": function() { return /* binding */ _createSuper; },
  "a": function() { return /* binding */ _objectSpread2; },
  "b": function() { return /* binding */ clearIndicatorCSS; },
  "c": function() { return /* binding */ components; },
  "d": function() { return /* binding */ containerCSS; },
  "e": function() { return /* binding */ css$1; },
  "f": function() { return /* binding */ dropdownIndicatorCSS; },
  "g": function() { return /* binding */ groupCSS; },
  "h": function() { return /* binding */ groupHeadingCSS; },
  "i": function() { return /* binding */ indicatorsContainerCSS; },
  "j": function() { return /* binding */ indicatorSeparatorCSS; },
  "k": function() { return /* binding */ inputCSS; },
  "l": function() { return /* binding */ loadingIndicatorCSS; },
  "m": function() { return /* binding */ loadingMessageCSS; },
  "n": function() { return /* binding */ menuCSS; },
  "o": function() { return /* binding */ menuListCSS; },
  "p": function() { return /* binding */ menuPortalCSS; },
  "q": function() { return /* binding */ multiValueCSS; },
  "r": function() { return /* binding */ multiValueLabelCSS; },
  "s": function() { return /* binding */ supportsPassiveEvents; },
  "t": function() { return /* binding */ multiValueRemoveCSS; },
  "u": function() { return /* binding */ noOptionsMessageCSS; },
  "v": function() { return /* binding */ optionCSS; },
  "w": function() { return /* binding */ placeholderCSS; },
  "x": function() { return /* binding */ css; },
  "y": function() { return /* binding */ valueContainerCSS; },
  "z": function() { return /* binding */ isTouchCapable; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-select/dist/index-c7a4d7ce.esm.js












function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
      props.clearValue;
      props.cx;
      props.getStyles;
      props.getValue;
      props.hasValue;
      props.isMulti;
      props.isRtl;
      props.options;
      props.selectOption;
      props.selectProps;
      props.setValue;
      props.theme;
      var innerProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded$3);

  return _objectSpread2({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);

    if (typeof _newValue === 'string') return _newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return document.documentElement;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36

var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }

}; // check for SSR

var w = typeof window !== 'undefined' ? window : {};

if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}

var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  }

  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, (0,defineProperty/* default */.Z)(_ref3, alignToControl(placement), '100%'), (0,defineProperty/* default */.Z)(_ref3, "backgroundColor", colors.neutral0), (0,defineProperty/* default */.Z)(_ref3, "borderRadius", borderRadius), (0,defineProperty/* default */.Z)(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), (0,defineProperty/* default */.Z)(_ref3, "marginBottom", spacing.menuGutter), (0,defineProperty/* default */.Z)(_ref3, "marginTop", spacing.menuGutter), (0,defineProperty/* default */.Z)(_ref3, "position", 'absolute'), (0,defineProperty/* default */.Z)(_ref3, "width", '100%'), (0,defineProperty/* default */.Z)(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/(0,react.createContext)({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(MenuPlacer, _Component);

  var _super = _createSuper(MenuPlacer);

  function MenuPlacer() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2(_objectSpread2({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  (0,createClass/* default */.Z)(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(react.Component);
MenuPlacer.contextType = PortalPlacementContext;

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      isMulti = props.isMulti;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  (0,inherits/* default */.Z)(MenuPortal, _Component2);

  var _super2 = _createSuper(MenuPortal);

  function MenuPortal() {
    var _this2;

    (0,classCallCheck/* default */.Z)(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  (0,createClass/* default */.Z)(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          className = _this$props2.className,
          controlElement = _this$props2.controlElement,
          cx = _this$props2.cx,
          innerProps = _this$props2.innerProps,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
        css: getStyles('menuPortal', state),
        className: cx({
          'menu-portal': true
        }, className)
      }, innerProps), children);
      return (0,emotion_react_browser_esm/* jsx */.tZ)(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/(0,react_dom.createPortal)(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(react.Component);

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing,
      isMulti = _ref2.isMulti,
      hasValue = _ref2.hasValue,
      controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return {
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      getStyles = props.getStyles;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};

var _templateObject;

var _excluded$2 = ["size"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : 0;

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded$2);

  return (0,emotion_react_browser_esm/* jsx */.tZ)("svg", (0,esm_extends/* default */.Z)({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }, innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }, innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", (0,esm_extends/* default */.Z)({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : 0,  true ? "" : 0)
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }, innerProps), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 160,
    offset: true
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      innerProps = props.innerProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, innerProps), (0,emotion_react_browser_esm/* jsx */.tZ)(Heading, (0,esm_extends/* default */.Z)({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var getStyles = props.getStyles,
      cx = props.cx,
      className = props.className;

  var _cleanCommonProps = cleanCommonProps(props);
      _cleanCommonProps.data;
      var innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, _excluded$1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('groupHeading', props),
    className: cx({
      'group-heading': true
    }, className)
  }, innerProps));
};

var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      value = _ref.value,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle);
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};

var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};

var Input = function Input(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      value = props.value;

  var _cleanCommonProps = cleanCommonProps(props),
      innerRef = _cleanCommonProps.innerRef,
      isDisabled = _cleanCommonProps.isDisabled,
      isHidden = _cleanCommonProps.isHidden,
      inputClassName = _cleanCommonProps.inputClassName,
      innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, _excluded);

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: cx({
      'input-container': true
    }, className),
    css: getStyles('input', props),
    "data-value": value || ''
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    role: "button"
  }, innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* ClassNames */.ms, null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }, innerProps),
      selectProps: selectProps
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), (0,emotion_react_browser_esm/* jsx */.tZ)(Remove, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className)),
        'aria-label': "Remove ".concat(children || 'option')
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};




/***/ }),

/***/ 23157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NonceProvider */
/* harmony import */ var _useStateManager_783b07d5_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94310);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Select_126cf1dd_esm_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89570);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60136);
/* harmony import */ var _index_c7a4d7ce_esm_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11604);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54880);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84683);
/* harmony import */ var memoize_one__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30845);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);























var StateManagedSelect = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
  var baseSelectProps = (0,_useStateManager_783b07d5_esm_js__WEBPACK_IMPORTED_MODULE_3__.u)(props);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Select_126cf1dd_esm_js__WEBPACK_IMPORTED_MODULE_4__.S, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    ref: ref
  }, baseSelectProps));
});

var NonceProvider = /*#__PURE__*/function (_Component) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(NonceProvider, _Component);

  var _super = (0,_index_c7a4d7ce_esm_js__WEBPACK_IMPORTED_MODULE_7__._)(NonceProvider);

  function NonceProvider(props) {
    var _this;

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, NonceProvider);

    _this = _super.call(this, props);

    _this.createEmotionCache = function (nonce, key) {
      return (0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        nonce: nonce,
        key: key
      });
    };

    _this.createEmotionCache = (0,memoize_one__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_this.createEmotionCache);
    return _this;
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_11__.C, {
        value: emotionCache
      }, this.props.children);
    }
  }]);

  return NonceProvider;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

/* harmony default export */ __webpack_exports__["ZP"] = (StateManagedSelect);



/***/ }),

/***/ 94310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useStateManager; }
/* harmony export */ });
/* harmony import */ var _index_c7a4d7ce_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11604);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86854);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);





var _excluded = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
      defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
      _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
      defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      propsInputValue = _ref.inputValue,
      propsMenuIsOpen = _ref.menuIsOpen,
      propsOnChange = _ref.onChange,
      propsOnInputChange = _ref.onInputChange,
      propsOnMenuClose = _ref.onMenuClose,
      propsOnMenuOpen = _ref.onMenuOpen,
      propsValue = _ref.value,
      restSelectProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
      _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useState, 2),
      stateInputValue = _useState2[0],
      setStateInputValue = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
      _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useState3, 2),
      stateMenuIsOpen = _useState4[0],
      setStateMenuIsOpen = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(propsValue !== undefined ? propsValue : defaultValue),
      _useState6 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useState5, 2),
      stateValue = _useState6[0],
      setStateValue = _useState6[1];

  var onChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }

    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value, actionMeta) {
    var newValue;

    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }

    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }

    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }

    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return (0,_index_c7a4d7ce_esm_js__WEBPACK_IMPORTED_MODULE_3__.a)((0,_index_c7a4d7ce_esm_js__WEBPACK_IMPORTED_MODULE_3__.a)({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}




/***/ }),

/***/ 97567:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 76743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_CSSTransition; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["classNames"]);

    return /*#__PURE__*/react.createElement(Transition/* default */.ZP, (0,esm_extends/* default */.Z)({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition);

/***/ }),

/***/ 98885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cn": function() { return /* binding */ ENTERED; },
  "d0": function() { return /* binding */ ENTERING; },
  "Ix": function() { return /* binding */ EXITING; },
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: EXITED, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 89747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_TransitionGroup; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = (0,esm_extends/* default */.Z)({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);

/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 98723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var is = __webpack_require__(94315);
/**
 * Parse x-forwarded-for headers.
 *
 * @param {string} value - The value to be parsed.
 * @return {string|null} First known IP address, if any.
 */


function getClientIpFromXForwardedFor(value) {
  if (!is.existy(value)) {
    return null;
  }

  if (is.not.string(value)) {
    throw new TypeError("Expected a string, got \"".concat(_typeof(value), "\""));
  } // x-forwarded-for may return multiple IP addresses in the format:
  // "client IP, proxy 1 IP, proxy 2 IP"
  // Therefore, the right-most IP address is the IP address of the most recent proxy
  // and the left-most IP address is the IP address of the originating client.
  // source: http://docs.aws.amazon.com/elasticloadbalancing/latest/classic/x-forwarded-headers.html
  // Azure Web App's also adds a port for some reason, so we'll only use the first part (the IP)


  var forwardedIps = value.split(',').map(function (e) {
    var ip = e.trim();

    if (ip.includes(':')) {
      var splitted = ip.split(':'); // make sure we only use this if it's ipv4 (ip:port)

      if (splitted.length === 2) {
        return splitted[0];
      }
    }

    return ip;
  }); // Sometimes IP addresses in this header can be 'unknown' (http://stackoverflow.com/a/11285650).
  // Therefore taking the left-most IP address that is not unknown
  // A Squid configuration directive can also set the value to "unknown" (http://www.squid-cache.org/Doc/config/forwarded_for/)

  return forwardedIps.find(is.ip);
}
/**
 * Determine client IP address.
 *
 * @param req
 * @returns {string} ip - The IP address if known, defaulting to empty string if unknown.
 */


function getClientIp(req) {
  // Server is probably behind a proxy.
  if (req.headers) {
    // Standard headers used by Amazon EC2, Heroku, and others.
    if (is.ip(req.headers['x-client-ip'])) {
      return req.headers['x-client-ip'];
    } // Load-balancers (AWS ELB) or proxies.


    var xForwardedFor = getClientIpFromXForwardedFor(req.headers['x-forwarded-for']);

    if (is.ip(xForwardedFor)) {
      return xForwardedFor;
    } // Cloudflare.
    // @see https://support.cloudflare.com/hc/en-us/articles/200170986-How-does-Cloudflare-handle-HTTP-Request-headers-
    // CF-Connecting-IP - applied to every request to the origin.


    if (is.ip(req.headers['cf-connecting-ip'])) {
      return req.headers['cf-connecting-ip'];
    } // Fastly and Firebase hosting header (When forwared to cloud function)


    if (is.ip(req.headers['fastly-client-ip'])) {
      return req.headers['fastly-client-ip'];
    } // Akamai and Cloudflare: True-Client-IP.


    if (is.ip(req.headers['true-client-ip'])) {
      return req.headers['true-client-ip'];
    } // Default nginx proxy/fcgi; alternative to x-forwarded-for, used by some proxies.


    if (is.ip(req.headers['x-real-ip'])) {
      return req.headers['x-real-ip'];
    } // (Rackspace LB and Riverbed's Stingray)
    // http://www.rackspace.com/knowledge_center/article/controlling-access-to-linux-cloud-sites-based-on-the-client-ip-address
    // https://splash.riverbed.com/docs/DOC-1926


    if (is.ip(req.headers['x-cluster-client-ip'])) {
      return req.headers['x-cluster-client-ip'];
    }

    if (is.ip(req.headers['x-forwarded'])) {
      return req.headers['x-forwarded'];
    }

    if (is.ip(req.headers['forwarded-for'])) {
      return req.headers['forwarded-for'];
    }

    if (is.ip(req.headers.forwarded)) {
      return req.headers.forwarded;
    }
  } // Remote address checks.


  if (is.existy(req.connection)) {
    if (is.ip(req.connection.remoteAddress)) {
      return req.connection.remoteAddress;
    }

    if (is.existy(req.connection.socket) && is.ip(req.connection.socket.remoteAddress)) {
      return req.connection.socket.remoteAddress;
    }
  }

  if (is.existy(req.socket) && is.ip(req.socket.remoteAddress)) {
    return req.socket.remoteAddress;
  }

  if (is.existy(req.info) && is.ip(req.info.remoteAddress)) {
    return req.info.remoteAddress;
  } // AWS Api Gateway + Lambda


  if (is.existy(req.requestContext) && is.existy(req.requestContext.identity) && is.ip(req.requestContext.identity.sourceIp)) {
    return req.requestContext.identity.sourceIp;
  }

  return null;
}
/**
 * Expose request IP as a middleware.
 *
 * @param {object} [options] - Configuration.
 * @param {string} [options.attributeName] - Name of attribute to augment request object with.
 * @return {*}
 */


function mw(options) {
  // Defaults.
  var configuration = is.not.existy(options) ? {} : options; // Validation.

  if (is.not.object(configuration)) {
    throw new TypeError('Options must be an object!');
  }

  var attributeName = configuration.attributeName || 'clientIp';
  return function (req, res, next) {
    var ip = getClientIp(req);
    Object.defineProperty(req, attributeName, {
      get: function get() {
        return ip;
      },
      configurable: true
    });
    next();
  };
}

module.exports = {
  getClientIpFromXForwardedFor: getClientIpFromXForwardedFor,
  getClientIp: getClientIp,
  mw: mw
};



/***/ }),

/***/ 68697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P1": function() { return /* binding */ createSelector; }
});

// UNUSED EXPORTS: createSelectorCreator, createStructuredSelector, defaultEqualityCheck, defaultMemoize

;// CONCATENATED MODULE: ./node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ./node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function () {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ }),

/***/ 96774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 37478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(21924);
var inspect = __webpack_require__(70631);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 33988:
/***/ (function(module) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),

/***/ 40196:
/***/ (function(module) {

!function(e){if(true)module.exports=e();else { var f; }}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=undefined;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=undefined;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";

var init = _dereq_('./init');

var sbjs = {
  init: function(prefs) {
    this.get = init(prefs);
    if (prefs && prefs.callback && typeof prefs.callback === 'function') {
      prefs.callback(this.get);
    }
  }
};

module.exports = sbjs;
},{"./init":6}],2:[function(_dereq_,module,exports){
"use strict";

var terms = _dereq_('./terms'),
    utils = _dereq_('./helpers/utils');

var data = {

  containers: {
    current:          'sbjs_current',
    current_extra:    'sbjs_current_add',
    first:            'sbjs_first',
    first_extra:      'sbjs_first_add',
    session:          'sbjs_session',
    udata:            'sbjs_udata',
    promocode:        'sbjs_promo'
  },

  service: {
    migrations:       'sbjs_migrations'
  },

  delimiter:          '|||',

  aliases: {

    main: {
      type:           'typ',
      source:         'src',
      medium:         'mdm',
      campaign:       'cmp',
      content:        'cnt',
      term:           'trm'
    },

    extra: {
      fire_date:      'fd',
      entrance_point: 'ep',
      referer:        'rf'
    },

    session: {
      pages_seen:     'pgs',
      current_page:   'cpg'
    },

    udata: {
      visits:         'vst',
      ip:             'uip',
      agent:          'uag'
    },

    promo:            'code'

  },

  pack: {

    main: function(sbjs) {
      return (
        data.aliases.main.type      + '=' + sbjs.type     + data.delimiter +
        data.aliases.main.source    + '=' + sbjs.source   + data.delimiter +
        data.aliases.main.medium    + '=' + sbjs.medium   + data.delimiter +
        data.aliases.main.campaign  + '=' + sbjs.campaign + data.delimiter +
        data.aliases.main.content   + '=' + sbjs.content  + data.delimiter +
        data.aliases.main.term      + '=' + sbjs.term
      );
    },

    extra: function(timezone_offset) {
      return (
        data.aliases.extra.fire_date      + '=' + utils.setDate(new Date, timezone_offset) + data.delimiter +
        data.aliases.extra.entrance_point + '=' + document.location.href                   + data.delimiter +
        data.aliases.extra.referer        + '=' + (document.referrer || terms.none)
      );
    },

    user: function(visits, user_ip) {
      return (
        data.aliases.udata.visits + '=' + visits  + data.delimiter +
        data.aliases.udata.ip     + '=' + user_ip + data.delimiter +
        data.aliases.udata.agent  + '=' + navigator.userAgent
      );
    },

    session: function(pages) {
      return (
      data.aliases.session.pages_seen   + '=' + pages + data.delimiter +
      data.aliases.session.current_page + '=' + document.location.href
      );
    },

    promo: function(promo) {
      return (
        data.aliases.promo + '=' + utils.setLeadingZeroToInt(utils.randomInt(promo.min, promo.max), promo.max.toString().length)
      );
    }

  }
};

module.exports = data;
},{"./helpers/utils":5,"./terms":9}],3:[function(_dereq_,module,exports){
"use strict";

var delimiter = _dereq_('../data').delimiter;

module.exports = {

  encodeData: function(s) {
    return encodeURIComponent(s).replace(/\!/g, '%21')
                                .replace(/\~/g, '%7E')
                                .replace(/\*/g, '%2A')
                                .replace(/\'/g, '%27')
                                .replace(/\(/g, '%28')
                                .replace(/\)/g, '%29');
  },

  decodeData: function(s) {
    try {
      return decodeURIComponent(s).replace(/\%21/g, '!')
                                  .replace(/\%7E/g, '~')
                                  .replace(/\%2A/g, '*')
                                  .replace(/\%27/g, "'")
                                  .replace(/\%28/g, '(')
                                  .replace(/\%29/g, ')');
    } catch(err1) {
      // try unescape for backward compatibility
      try { return unescape(s); } catch(err2) { return ''; }
    }
  },

  set: function(name, value, minutes, domain, excl_subdomains) {
    var expires, basehost;

    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }
    if (domain && !excl_subdomains) {
      basehost = ';domain=.' + domain;
    } else {
      basehost = '';
    }
    document.cookie = this.encodeData(name) + '=' + this.encodeData(value) + expires + basehost + '; path=/';
  },

  get: function(name) {
    var nameEQ = this.encodeData(name) + '=',
        ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') { c = c.substring(1, c.length); }
      if (c.indexOf(nameEQ) === 0) {
        return this.decodeData(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  },

  destroy: function(name, domain, excl_subdomains) {
    this.set(name, '', -1, domain, excl_subdomains);
  },

  parse: function(yummy) {

    var cookies = [],
        data    = {};

    if (typeof yummy === 'string') {
      cookies.push(yummy);
    } else {
      for (var prop in yummy) {
        if (yummy.hasOwnProperty(prop)) {
          cookies.push(yummy[prop]);
        }
      }
    }

    for (var i1 = 0; i1 < cookies.length; i1++) {
      var cookie_array;
      data[this.unsbjs(cookies[i1])] = {};
      if (this.get(cookies[i1])) {
        cookie_array = this.get(cookies[i1]).split(delimiter);
      } else {
        cookie_array = [];
      }
      for (var i2 = 0; i2 < cookie_array.length; i2++) {
        var tmp_array = cookie_array[i2].split('='),
            result_array = tmp_array.splice(0, 1);
        result_array.push(tmp_array.join('='));
        data[this.unsbjs(cookies[i1])][result_array[0]] = this.decodeData(result_array[1]);
      }
    }

    return data;

  },

  unsbjs: function (string) {
    return string.replace('sbjs_', '');
  }

};

},{"../data":2}],4:[function(_dereq_,module,exports){
"use strict";

module.exports = {

  parse: function(str) {
    var o = this.parseOptions,
        m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str),
        uri = {},
        i = 14;

    while (i--) { uri[o.key[i]] = m[i] || ''; }

    uri[o.q.name] = {};
    uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
      if ($1) { uri[o.q.name][$1] = $2; }
    });

    return uri;
  },

  parseOptions: {
    strictMode: false,
    key: ['source','protocol','authority','userInfo','user','password','host','port','relative','path','directory','file','query','anchor'],
    q: {
      name:   'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }
  },

  getParam: function(custom_params) {
    var query_string = {},
        query = custom_params ? custom_params : window.location.search.substring(1),
        vars = query.split('&');

    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (typeof query_string[pair[0]] === 'undefined') {
        query_string[pair[0]] = pair[1];
      } else if (typeof query_string[pair[0]] === 'string') {
        var arr = [ query_string[pair[0]], pair[1] ];
        query_string[pair[0]] = arr;
      } else {
        query_string[pair[0]].push(pair[1]);
      }
    }
    return query_string;
  },

  getHost: function(request) {
    return this.parse(request).host.replace('www.', '');
  }

};
},{}],5:[function(_dereq_,module,exports){
"use strict";

module.exports = {

  escapeRegexp: function(string) {
    return string.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  },

  setDate: function(date, offset) {
    var utc_offset    = date.getTimezoneOffset() / 60,
        now_hours     = date.getHours(),
        custom_offset = offset || offset === 0 ? offset : -utc_offset;

    date.setHours(now_hours + utc_offset + custom_offset);

    var year    = date.getFullYear(),
        month   = this.setLeadingZeroToInt(date.getMonth() + 1,   2),
        day     = this.setLeadingZeroToInt(date.getDate(),        2),
        hour    = this.setLeadingZeroToInt(date.getHours(),       2),
        minute  = this.setLeadingZeroToInt(date.getMinutes(),     2),
        second  = this.setLeadingZeroToInt(date.getSeconds(),     2);

    return (year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second);
  },

  setLeadingZeroToInt: function(num, size) {
    var s = num + '';
    while (s.length < size) { s = '0' + s; }
    return s;
  },

  randomInt: function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

};

},{}],6:[function(_dereq_,module,exports){
"use strict";

var data        = _dereq_('./data'),
    terms       = _dereq_('./terms'),
    cookies     = _dereq_('./helpers/cookies'),
    uri         = _dereq_('./helpers/uri'),
    utils       = _dereq_('./helpers/utils'),
    params      = _dereq_('./params'),
    migrations  = _dereq_('./migrations');

module.exports = function(prefs) {

  var p         = params.fetch(prefs);
  var get_param = uri.getParam();
  var domain    = p.domain.host,
      isolate   = p.domain.isolate,
      lifetime  = p.lifetime;

  migrations.go(lifetime, domain, isolate);

  var __sbjs_type,
      __sbjs_source,
      __sbjs_medium,
      __sbjs_campaign,
      __sbjs_content,
      __sbjs_term;

  function mainData() {
    var sbjs_data;
    if (
        typeof get_param.utm_source        !== 'undefined' ||
        typeof get_param.utm_medium        !== 'undefined' ||
        typeof get_param.utm_campaign      !== 'undefined' ||
        typeof get_param.utm_content       !== 'undefined' ||
        typeof get_param.utm_term          !== 'undefined' ||
        typeof get_param.gclid             !== 'undefined' ||
        typeof get_param.yclid             !== 'undefined' ||
        typeof get_param[p.campaign_param] !== 'undefined'
      ) {
      setFirstAndCurrentExtraData();
      sbjs_data = getData(terms.traffic.utm);
    } else if (checkReferer(terms.traffic.organic)) {
      setFirstAndCurrentExtraData();
      sbjs_data = getData(terms.traffic.organic);
    } else if (!cookies.get(data.containers.session) && checkReferer(terms.traffic.referral)) {
      setFirstAndCurrentExtraData();
      sbjs_data = getData(terms.traffic.referral);
    } else if (!cookies.get(data.containers.first) && !cookies.get(data.containers.current)) {
      setFirstAndCurrentExtraData();
      sbjs_data = getData(terms.traffic.typein);
    } else {
      return cookies.get(data.containers.current);
    }

    return sbjs_data;
  }

  function getData(type) {

    switch (type) {

      case terms.traffic.utm:

        __sbjs_type = terms.traffic.utm;

        if (typeof get_param.utm_source !== 'undefined') {
          __sbjs_source = get_param.utm_source;
        } else if (typeof get_param.gclid !== 'undefined') {
          __sbjs_source = 'google';
        } else if (typeof get_param.yclid !== 'undefined') {
          __sbjs_source = 'yandex';  
        } else {
          __sbjs_source = terms.none;
        }

        if (typeof get_param.utm_medium !== 'undefined') {
          __sbjs_medium = get_param.utm_medium;
        } else if (typeof get_param.gclid !== 'undefined') {
          __sbjs_medium = 'cpc';
        } else if (typeof get_param.yclid !== 'undefined') {
          __sbjs_medium = 'cpc';  
        } else {
          __sbjs_medium = terms.none;
        }

        if (typeof get_param.utm_campaign !== 'undefined') {
          __sbjs_campaign = get_param.utm_campaign;
        } else if (typeof get_param[p.campaign_param] !== 'undefined') {
          __sbjs_campaign = get_param[p.campaign_param];
        } else if (typeof get_param.gclid !== 'undefined') {
          __sbjs_campaign = 'google_cpc';
        } else if (typeof get_param.yclid !== 'undefined') {
          __sbjs_campaign = 'yandex_cpc';  
        } else {
          __sbjs_campaign = terms.none;
        }

        __sbjs_content  = get_param.utm_content || terms.none;
        __sbjs_term     = getUtmTerm()          || terms.none;
        break;

      case terms.traffic.organic:
        __sbjs_type     = terms.traffic.organic;
        __sbjs_source   = __sbjs_source || uri.getHost(document.referrer);
        __sbjs_medium   = terms.referer.organic;
        __sbjs_campaign = terms.none;
        __sbjs_content  = terms.none;
        __sbjs_term     = terms.none;
        break;

      case terms.traffic.referral:
        __sbjs_type     = terms.traffic.referral;
        __sbjs_source   = __sbjs_source || uri.getHost(document.referrer);
        __sbjs_medium   = __sbjs_medium || terms.referer.referral;
        __sbjs_campaign = terms.none;
        __sbjs_content  = uri.parse(document.referrer).path;
        __sbjs_term     = terms.none;
        break;

      case terms.traffic.typein:
        __sbjs_type     = terms.traffic.typein;
        __sbjs_source   = p.typein_attributes.source;
        __sbjs_medium   = p.typein_attributes.medium;
        __sbjs_campaign = terms.none;
        __sbjs_content  = terms.none;
        __sbjs_term     = terms.none;
        break;

      default:
        __sbjs_type     = terms.oops;
        __sbjs_source   = terms.oops;
        __sbjs_medium   = terms.oops;
        __sbjs_campaign = terms.oops;
        __sbjs_content  = terms.oops;
        __sbjs_term     = terms.oops;
    }
    var sbjs_data = {
      type:             __sbjs_type,
      source:           __sbjs_source,
      medium:           __sbjs_medium,
      campaign:         __sbjs_campaign,
      content:          __sbjs_content,
      term:             __sbjs_term
    };

    return data.pack.main(sbjs_data);

  }

  function getUtmTerm() {
    var referer = document.referrer;
    if (get_param.utm_term) {
      return get_param.utm_term;
    } else if (referer && uri.parse(referer).host && uri.parse(referer).host.match(/^(?:.*\.)?yandex\..{2,9}$/i)) {
      try {
        return uri.getParam(uri.parse(document.referrer).query).text;
      } catch (err) {
        return false;
      }
    } else {
      return false;
    }
  }

  function checkReferer(type) {
    var referer = document.referrer;
    switch(type) {
      case terms.traffic.organic:
        return (!!referer && checkRefererHost(referer) && isOrganic(referer));
      case terms.traffic.referral:
        return (!!referer && checkRefererHost(referer) && isReferral(referer));
      default:
        return false;
    }
  }

  function checkRefererHost(referer) {
    if (p.domain) {
      if (!isolate) {
        var host_regex = new RegExp('^(?:.*\\.)?' + utils.escapeRegexp(domain) + '$', 'i');
        return !(uri.getHost(referer).match(host_regex));
      } else {
        return (uri.getHost(referer) !== uri.getHost(domain));
      }
    } else {
      return (uri.getHost(referer) !== uri.getHost(document.location.href));
    }
  }

  function isOrganic(referer) {

    var y_host  = 'yandex',
        y_param = 'text',
        g_host  = 'google';

    var y_host_regex  = new RegExp('^(?:.*\\.)?'  + utils.escapeRegexp(y_host)  + '\\..{2,9}$'),
        y_param_regex = new RegExp('.*'           + utils.escapeRegexp(y_param) + '=.*'),
        g_host_regex  = new RegExp('^(?:www\\.)?' + utils.escapeRegexp(g_host)  + '\\..{2,9}$');

    if (
        !!uri.parse(referer).query &&
        !!uri.parse(referer).host.match(y_host_regex) &&
        !!uri.parse(referer).query.match(y_param_regex)
      ) {
      __sbjs_source = y_host;
      return true;
    } else if (!!uri.parse(referer).host.match(g_host_regex)) {
      __sbjs_source = g_host;
      return true;
    } else if (!!uri.parse(referer).query) {
      for (var i = 0; i < p.organics.length; i++) {
        if (
            uri.parse(referer).host.match(new RegExp('^(?:.*\\.)?' + utils.escapeRegexp(p.organics[i].host)  + '$', 'i')) &&
            uri.parse(referer).query.match(new RegExp('.*'         + utils.escapeRegexp(p.organics[i].param) + '=.*', 'i'))
          ) {
          __sbjs_source = p.organics[i].display || p.organics[i].host;
          return true;
        }
        if (i + 1 === p.organics.length) {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  function isReferral(referer) {
    if (p.referrals.length > 0) {
      for (var i = 0; i < p.referrals.length; i++) {
        if (uri.parse(referer).host.match(new RegExp('^(?:.*\\.)?' + utils.escapeRegexp(p.referrals[i].host) + '$', 'i'))) {
          __sbjs_source = p.referrals[i].display  || p.referrals[i].host;
          __sbjs_medium = p.referrals[i].medium   || terms.referer.referral;
          return true;
        }
        if (i + 1 === p.referrals.length) {
          __sbjs_source = uri.getHost(referer);
          return true;
        }
      }
    } else {
      __sbjs_source = uri.getHost(referer);
      return true;
    }
  }

  function setFirstAndCurrentExtraData() {
    cookies.set(data.containers.current_extra, data.pack.extra(p.timezone_offset), lifetime, domain, isolate);
    if (!cookies.get(data.containers.first_extra)) {
      cookies.set(data.containers.first_extra, data.pack.extra(p.timezone_offset), lifetime, domain, isolate);
    }
  }

  (function setData() {

    // Main data
    cookies.set(data.containers.current, mainData(), lifetime, domain, isolate);
    if (!cookies.get(data.containers.first)) {
      cookies.set(data.containers.first, cookies.get(data.containers.current), lifetime, domain, isolate);
    }

    // User data
    var visits, udata;
    if (!cookies.get(data.containers.udata)) {
      visits  = 1;
      udata   = data.pack.user(visits, p.user_ip);
    } else {
      visits  = parseInt(cookies.parse(data.containers.udata)[cookies.unsbjs(data.containers.udata)][data.aliases.udata.visits]) || 1;
      visits  = cookies.get(data.containers.session) ? visits : visits + 1;
      udata   = data.pack.user(visits, p.user_ip);
    }
    cookies.set(data.containers.udata, udata, lifetime, domain, isolate);

    // Session
    var pages_count;
    if (!cookies.get(data.containers.session)) {
      pages_count = 1;
    } else {
      pages_count = parseInt(cookies.parse(data.containers.session)[cookies.unsbjs(data.containers.session)][data.aliases.session.pages_seen]) || 1;
      pages_count += 1;
    }
    cookies.set(data.containers.session, data.pack.session(pages_count), p.session_length, domain, isolate);

    // Promocode
    if (p.promocode && !cookies.get(data.containers.promocode)) {
      cookies.set(data.containers.promocode, data.pack.promo(p.promocode), lifetime, domain, isolate);
    }

  })();

  return cookies.parse(data.containers);

};
},{"./data":2,"./helpers/cookies":3,"./helpers/uri":4,"./helpers/utils":5,"./migrations":7,"./params":8,"./terms":9}],7:[function(_dereq_,module,exports){
"use strict";

var data    = _dereq_('./data'),
    cookies = _dereq_('./helpers/cookies');

module.exports = {

  go: function(lifetime, domain, isolate) {

    var migrate = this.migrations,
        _with   = { l: lifetime, d: domain, i: isolate };

    var i;

    if (!cookies.get(data.containers.first) && !cookies.get(data.service.migrations)) {

      var mids = [];
      for (i = 0; i < migrate.length; i++) { mids.push(migrate[i].id); }

      var advance = '';
      for (i = 0; i < mids.length; i++) {
        advance += mids[i] + '=1';
        if (i < mids.length - 1) { advance += data.delimiter; }
      }
      cookies.set(data.service.migrations, advance, _with.l, _with.d, _with.i);

    } else if (!cookies.get(data.service.migrations)) {

      // We have only one migration for now, so just
      for (i = 0; i < migrate.length; i++) {
        migrate[i].go(migrate[i].id, _with);
      }

    }

  },

  migrations: [

    {
      id: '1418474375998',
      version: '1.0.0-beta',
      go: function(mid, _with) {

        var success = mid + '=1',
            fail    = mid + '=0';

        var safeReplace = function($0, $1, $2) {
          return ($1 || $2 ? $0 : data.delimiter);
        };

        try {

          // Switch delimiter and renew cookies
          var _in = [];
          for (var prop in data.containers) {
            if (data.containers.hasOwnProperty(prop)) {
              _in.push(data.containers[prop]);
            }
          }

          for (var i = 0; i < _in.length; i++) {
            if (cookies.get(_in[i])) {
              var buffer = cookies.get(_in[i]).replace(/(\|)?\|(\|)?/g, safeReplace);
              cookies.destroy(_in[i], _with.d, _with.i);
              cookies.destroy(_in[i], _with.d, !_with.i);
              cookies.set(_in[i], buffer, _with.l, _with.d, _with.i);
            }
          }

          // Update `session`
          if (cookies.get(data.containers.session)) {
            cookies.set(data.containers.session, data.pack.session(0), _with.l, _with.d, _with.i);
          }

          // Yay!
          cookies.set(data.service.migrations, success, _with.l, _with.d, _with.i);

        } catch (err) {
          // Oops
          cookies.set(data.service.migrations, fail, _with.l, _with.d, _with.i);
        }
      }
    }

  ]

};
},{"./data":2,"./helpers/cookies":3}],8:[function(_dereq_,module,exports){
"use strict";

var terms = _dereq_('./terms'),
    uri   = _dereq_('./helpers/uri');

module.exports = {

  fetch: function(prefs) {

    var user   = prefs || {},
        params = {};

    // Set `lifetime of the cookie` in months
    params.lifetime = this.validate.checkFloat(user.lifetime) || 6;
    params.lifetime = parseInt(params.lifetime * 30 * 24 * 60);

    // Set `session length` in minutes
    params.session_length = this.validate.checkInt(user.session_length) || 30;

    // Set `timezone offset` in hours
    params.timezone_offset = this.validate.checkInt(user.timezone_offset);

    // Set `campaign param` for AdWords links
    params.campaign_param = user.campaign_param || false;

    // Set `user ip`
    params.user_ip = user.user_ip || terms.none;

    // Set `promocode`
    if (user.promocode) {
      params.promocode = {};
      params.promocode.min = parseInt(user.promocode.min) || 100000;
      params.promocode.max = parseInt(user.promocode.max) || 999999;
    } else {
      params.promocode = false;
    }

    // Set `typein attributes`
    if (user.typein_attributes && user.typein_attributes.source && user.typein_attributes.medium) {
      params.typein_attributes = {};
      params.typein_attributes.source = user.typein_attributes.source;
      params.typein_attributes.medium = user.typein_attributes.medium;
    } else {
      params.typein_attributes = { source: '(direct)', medium: '(none)' };
    }

    // Set `domain`
    if (user.domain && this.validate.isString(user.domain)) {
      params.domain = { host: user.domain, isolate: false };
    } else if (user.domain && user.domain.host) {
      params.domain = user.domain;
    } else {
      params.domain = { host: uri.getHost(document.location.hostname), isolate: false };
    }

    // Set `referral sources`
    params.referrals = [];

    if (user.referrals && user.referrals.length > 0) {
      for (var ir = 0; ir < user.referrals.length; ir++) {
        if (user.referrals[ir].host) {
          params.referrals.push(user.referrals[ir]);
        }
      }
    }

    // Set `organic sources`
    params.organics = [];

    if (user.organics && user.organics.length > 0) {
      for (var io = 0; io < user.organics.length; io++) {
        if (user.organics[io].host && user.organics[io].param) {
          params.organics.push(user.organics[io]);
        }
      }
    }

    params.organics.push({ host: 'bing.com',      param: 'q',     display: 'bing'            });
    params.organics.push({ host: 'yahoo.com',     param: 'p',     display: 'yahoo'           });
    params.organics.push({ host: 'about.com',     param: 'q',     display: 'about'           });
    params.organics.push({ host: 'aol.com',       param: 'q',     display: 'aol'             });
    params.organics.push({ host: 'ask.com',       param: 'q',     display: 'ask'             });
    params.organics.push({ host: 'globososo.com', param: 'q',     display: 'globo'           });
    params.organics.push({ host: 'go.mail.ru',    param: 'q',     display: 'go.mail.ru'      });
    params.organics.push({ host: 'rambler.ru',    param: 'query', display: 'rambler'         });
    params.organics.push({ host: 'tut.by',        param: 'query', display: 'tut.by'          });

    params.referrals.push({ host: 't.co',                         display: 'twitter.com'     });
    params.referrals.push({ host: 'plus.url.google.com',          display: 'plus.google.com' });


    return params;

  },

  validate: {

    checkFloat: function(v) {
      return v && this.isNumeric(parseFloat(v)) ? parseFloat(v) : false;
    },

    checkInt: function(v) {
      return v && this.isNumeric(parseInt(v)) ? parseInt(v) : false;
    },

    isNumeric: function(v){
      return !isNaN(v);
    },

    isString: function(v) {
      return Object.prototype.toString.call(v) === '[object String]';
    }

  }

};
},{"./helpers/uri":4,"./terms":9}],9:[function(_dereq_,module,exports){
"use strict";

module.exports = {

  traffic: {
    utm:        'utm',
    organic:    'organic',
    referral:   'referral',
    typein:     'typein'
  },

  referer: {
    referral:   'referral',
    organic:    'organic',
    social:     'social'
  },

  none:         '(none)',
  oops:         '(Houston, we have a problem)'

};

},{}]},{},[1])(1)
});

/***/ }),

/***/ 59016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Fe; },
  "iv": function() { return /* binding */ Ce; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, createGlobalStyle, isStyledComponent, keyframes, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(96774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
// EXTERNAL MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
var stylis_browser_esm = __webpack_require__(48285);
// EXTERNAL MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(40351);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
var memoize_browser_esm = __webpack_require__(12717);
;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = (0,memoize_browser_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(83454);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.3",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.3"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return"undefined"!=typeof window&&void 0!==window.__webpack_nonce__?window.__webpack_nonce__:null},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.3");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.3"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new stylis_browser_esm/* default */.Z(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react.createContext(),le=ue.Consumer,de=react.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react.useContext)(ue)||he}function me(){return (0,react.useContext)(de)||pe}function ye(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ue.Provider,{value:u},react.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm/* default */.Z?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react.createContext(),Le=Ge.Consumer;function Fe(e){var t=(0,react.useContext)(Ge),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.3"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,is_prop_valid_browser_esm,_):!N||is_prop_valid_browser_esm(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),C.toString=function(){return"."+C.styledComponentId},i&&hoist_non_react_statics_cjs_default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is.isValidElementType)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=s(Ge),l=c(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),d((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.3"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.3",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 25462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ swiper_esm_bundle; }
});

;// CONCATENATED MODULE: ./node_modules/ssr-window/dist/ssr-window.esm.js
/**
 * SSR Window 2.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: May 12, 2020
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject(src[key]) &&
            isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var doc = typeof document !== 'undefined' ? document : {};
var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
extend(doc, ssrDocument);

var win = typeof window !== 'undefined' ? window : {};
var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
};
extend(win, ssrWindow);



;// CONCATENATED MODULE: ./node_modules/dom7/dist/dom7.modular.js
/**
 * Dom7 2.1.5
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * http://framework7.io/docs/dom.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 *
 * Released on: May 15, 2020
 */


class Dom7 {
  constructor(arr) {
    const self = this;
    // Create array-like object
    for (let i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  }
}

function $(selector, context) {
  const arr = [];
  let i = 0;
  if (selector && !context) {
    if (selector instanceof Dom7) {
      return selector;
    }
  }
  if (selector) {
      // String
    if (typeof selector === 'string') {
      let els;
      let tempParent;
      const html = selector.trim();
      if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
        let toCreate = 'div';
        if (html.indexOf('<li') === 0) toCreate = 'ul';
        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
        if (html.indexOf('<tbody') === 0) toCreate = 'table';
        if (html.indexOf('<option') === 0) toCreate = 'select';
        tempParent = doc.createElement(toCreate);
        tempParent.innerHTML = html;
        for (i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
          // Pure ID selector
          els = [doc.getElementById(selector.trim().split('#')[1])];
        } else {
          // Other selectors
          els = (context || doc).querySelectorAll(selector.trim());
        }
        for (i = 0; i < els.length; i += 1) {
          if (els[i]) arr.push(els[i]);
        }
      }
    } else if (selector.nodeType || selector === win || selector === doc) {
      // Node/element
      arr.push(selector);
    } else if (selector.length > 0 && selector[0].nodeType) {
      // Array of elements or instance of Dom
      for (i = 0; i < selector.length; i += 1) {
        arr.push(selector[i]);
      }
    }
  }
  return new Dom7(arr);
}

$.fn = Dom7.prototype;
$.Class = Dom7;
$.Dom7 = Dom7;

function unique(arr) {
  const uniqueArray = [];
  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }
  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, (match, group1) => group1.toUpperCase());
}

function requestAnimationFrame(callback) {
  if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
  else if (window.webkitRequestAnimationFrame) return window.webkitRequestAnimationFrame(callback);
  return window.setTimeout(callback, 1000 / 60);
}
function cancelAnimationFrame(id) {
  if (window.cancelAnimationFrame) return window.cancelAnimationFrame(id);
  else if (window.webkitCancelAnimationFrame) return window.webkitCancelAnimationFrame(id);
  return window.clearTimeout(id);
}

// Classes and attributes
function addClass(className) {
  if (typeof className === 'undefined') {
    return this;
  }
  const classes = className.split(' ');
  for (let i = 0; i < classes.length; i += 1) {
    for (let j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
    }
  }
  return this;
}
function removeClass(className) {
  const classes = className.split(' ');
  for (let i = 0; i < classes.length; i += 1) {
    for (let j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
    }
  }
  return this;
}
function hasClass(className) {
  if (!this[0]) return false;
  return this[0].classList.contains(className);
}
function toggleClass(className) {
  const classes = className.split(' ');
  for (let i = 0; i < classes.length; i += 1) {
    for (let j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
    }
  }
  return this;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  }

  // Set attrs
  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      // eslint-disable-next-line
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
// eslint-disable-next-line
function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }
  return this;
}
// eslint-disable-next-line
function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (let i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        // eslint-disable-next-line
        for (const propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }
    return this;
  }
}
function data(key, value) {
  let el;
  if (typeof value === 'undefined') {
    el = this[0];
    // Get value
    if (el) {
      if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
        return el.dom7ElementDataStorage[key];
      }

      const dataKey = el.getAttribute(`data-${key}`);
      if (dataKey) {
        return dataKey;
      }
      return undefined;
    }
    return undefined;
  }

  // Set value
  for (let i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }
  return this;
}
function removeData(key) {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}
function dataset() {
  const el = this[0];
  if (!el) return undefined;
  const dataset = {}; // eslint-disable-line
  if (el.dataset) {
    // eslint-disable-next-line
    for (const dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (let i = 0; i < el.attributes.length; i += 1) {
      // eslint-disable-next-line
      const attr = el.attributes[i];
      if (attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
      }
    }
  }
  // eslint-disable-next-line
  for (const key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;
    else if (dataset[key] === 'true') dataset[key] = true;
    else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }
  return dataset;
}
function val(value) {
  const dom = this;
  if (typeof value === 'undefined') {
    if (dom[0]) {
      if (dom[0].multiple && dom[0].nodeName.toLowerCase() === 'select') {
        const values = [];
        for (let i = 0; i < dom[0].selectedOptions.length; i += 1) {
          values.push(dom[0].selectedOptions[i].value);
        }
        return values;
      }
      return dom[0].value;
    }
    return undefined;
  }

  for (let i = 0; i < dom.length; i += 1) {
    const el = dom[i];
    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (let j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }
  return dom;
}
// Transforms
// eslint-disable-next-line
function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    const elStyle = this[i].style;
    elStyle.webkitTransform = transform;
    elStyle.transform = transform;
  }
  return this;
}
function transition(duration) {
  if (typeof duration !== 'string') {
    duration = `${duration}ms`; // eslint-disable-line
  }
  for (let i = 0; i < this.length; i += 1) {
    const elStyle = this[i].style;
    elStyle.webkitTransitionDuration = duration;
    elStyle.transitionDuration = duration;
  }
  return this;
}
// Events
function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }
  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    if ($(target).is(targetSelector)) listener.apply(target, eventData);
    else {
      const parents = $(target).parents(); // eslint-disable-line
      for (let k = 0; k < parents.length; k += 1) {
        if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }
  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    listener.apply(this, eventData);
  }
  const events = eventType.split(' ');
  let j;
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent,
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent,
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }
  if (!capture) capture = false;

  const events = eventType.split(' ');
  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;
      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }
      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];
          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }
  return this;
}
function once(...args) {
  const dom = this;
  let [eventName, targetSelector, listener, capture] = args;
  if (typeof args[1] === 'function') {
    [eventName, listener, capture] = args;
    targetSelector = undefined;
  }
  function onceHandler(...eventArgs) {
    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);
    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }
  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
  const events = args[0].split(' ');
  const eventData = args[1];
  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let evt;
      try {
        evt = new win.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true,
        });
      } catch (e) {
        evt = doc.createEvent('Event');
        evt.initEvent(event, true, true);
        evt.detail = eventData;
      }
      // eslint-disable-next-line
      el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
      el.dispatchEvent(evt);
      el.dom7EventData = [];
      delete el.dom7EventData;
    }
  }
  return this;
}
function transitionEnd(callback) {
  const events = ['webkitTransitionEnd', 'transitionend'];
  const dom = this;
  let i;
  function fireCallBack(e) {
    /* jshint validthis:true */
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
function animationEnd(callback) {
  const events = ['webkitAnimationEnd', 'animationend'];
  const dom = this;
  let i;
  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
// Sizing/Styles
function width() {
  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}
function dom7_modular_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function height() {
  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}
function dom7_modular_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = doc.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === win ? win.scrollY : el.scrollTop;
    const scrollLeft = el === win ? win.scrollX : el.scrollLeft;
    return {
      top: (box.top + scrollTop) - clientTop,
      left: (box.left + scrollLeft) - clientLeft,
    };
  }

  return null;
}
function hide() {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }
  return this;
}
function show() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (el.style.display === 'none') {
      el.style.display = '';
    }
    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }
  return this;
}
function styles() {
  if (this[0]) return win.getComputedStyle(this[0], null);
  return {};
}
function css(props, value) {
  let i;
  if (arguments.length === 1) {
    if (typeof props === 'string') {
      if (this[0]) return win.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i = 0; i < this.length; i += 1) {
        // eslint-disable-next-line
        for (let prop in props) {
          this[i].style[prop] = props[prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === 'string') {
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }
    return this;
  }
  return this;
}

// Dom manipulation
function toArray() {
  const arr = [];
  for (let i = 0; i < this.length; i += 1) {
    arr.push(this[i]);
  }
  return arr;
}
// Iterate over the collection passing elements to `callback`
function each(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (let i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], i, this[i]) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function forEach(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (let i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], this[i], i) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function filter(callback) {
  const matchedItems = [];
  const dom = this;
  for (let i = 0; i < dom.length; i += 1) {
    if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
  }
  return new Dom7(matchedItems);
}
function map(callback) {
  const modifiedItems = [];
  const dom = this;
  for (let i = 0; i < dom.length; i += 1) {
    modifiedItems.push(callback.call(dom[i], i, dom[i]));
  }
  return new Dom7(modifiedItems);
}
// eslint-disable-next-line
function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : undefined;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }
  return this;
}
// eslint-disable-next-line
function dom7_modular_text(text) {
  if (typeof text === 'undefined') {
    if (this[0]) {
      return this[0].textContent.trim();
    }
    return null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }
  return this;
}
function is(selector) {
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;
  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);

    compareWith = $(selector);
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  } else if (selector === doc) return el === doc;
  else if (selector === win) return el === win;

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  }
  return false;
}
function indexOf(el) {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i] === el) return i;
  }
  return -1;
}
function index() {
  let child = this[0];
  let i;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
// eslint-disable-next-line
function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;
  let returnIndex;
  if (index > length - 1) {
    return new Dom7([]);
  }
  if (index < 0) {
    returnIndex = length + index;
    if (returnIndex < 0) return new Dom7([]);
    return new Dom7([this[returnIndex]]);
  }
  return new Dom7([this[index]]);
}
function append(...args) {
  let newChild;

  for (let k = 0; k < args.length; k += 1) {
    newChild = args[k];
    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}
// eslint-disable-next-line
function appendTo(parent) {
  $(parent).append(this);
  return this;
}
function prepend(newChild) {
  let i;
  let j;
  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = doc.createElement('div');
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }
  return this;
}
// eslint-disable-next-line
function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}
function insertBefore(selector) {
  const before = $(selector);
  for (let i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (let j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}
function insertAfter(selector) {
  const after = $(selector);
  for (let i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (let j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}
function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return new Dom7([this[0].nextElementSibling]);
      }
      return new Dom7([]);
    }

    if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return new Dom7([]);
  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if ($(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return new Dom7(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    const el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return new Dom7([el.previousElementSibling]);
      }
      return new Dom7([]);
    }

    if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return new Dom7([]);
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if ($(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return new Dom7(prevEls);
}
function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}
function dom7_modular_parent(selector) {
  const parents = []; // eslint-disable-line
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }
  return $(unique(parents));
}
function parents(selector) {
  const parents = []; // eslint-disable-line
  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line
    while (parent) {
      if (selector) {
        if ($(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }
      parent = parent.parentNode;
    }
  }
  return $(unique(parents));
}
function closest(selector) {
  let closest = this; // eslint-disable-line
  if (typeof selector === 'undefined') {
    return new Dom7([]);
  }
  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }
  return closest;
}
function find(selector) {
  const foundElements = [];
  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);
    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return new Dom7(foundElements);
}
function children(selector) {
  const children = []; // eslint-disable-line
  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].childNodes;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector) {
        if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
      } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }
  return new Dom7(unique(children));
}
function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }
  return this;
}
function detach() {
  return this.remove();
}
function add(...args) {
  const dom = this;
  let i;
  let j;
  for (i = 0; i < args.length; i += 1) {
    const toAdd = $(args[i]);
    for (j = 0; j < toAdd.length; j += 1) {
      dom[dom.length] = toAdd[j];
      dom.length += 1;
    }
  }
  return dom;
}
function empty() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (el.nodeType === 1) {
      for (let j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }
      el.textContent = '';
    }
  }
  return this;
}

function scrollTo(...args) {
  let [left, top, duration, easing, callback] = args;
  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    [left, top, duration, callback, easing] = args;
  }
  if (typeof easing === 'undefined') easing = 'swing';

  return this.each(function animate() {
    const el = this;
    let currentTop;
    let currentLeft;
    let maxTop;
    let maxLeft;
    let newTop;
    let newLeft;
    let scrollTop; // eslint-disable-line
    let scrollLeft; // eslint-disable-line
    let animateTop = top > 0 || top === 0;
    let animateLeft = left > 0 || left === 0;
    if (typeof easing === 'undefined') {
      easing = 'swing';
    }
    if (animateTop) {
      currentTop = el.scrollTop;
      if (!duration) {
        el.scrollTop = top;
      }
    }
    if (animateLeft) {
      currentLeft = el.scrollLeft;
      if (!duration) {
        el.scrollLeft = left;
      }
    }
    if (!duration) return;
    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }
    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }
    let startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;
    function render(time = new Date().getTime()) {
      if (startTime === null) {
        startTime = time;
      }
      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = easing === 'linear' ? progress : (0.5 - (Math.cos(progress * Math.PI) / 2));
      let done;
      if (animateTop) scrollTop = currentTop + (easeProgress * (newTop - currentTop));
      if (animateLeft) scrollLeft = currentLeft + (easeProgress * (newLeft - currentLeft));
      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }
      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }
      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
  });
}
// scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
  let [top, duration, easing, callback] = args;
  if (args.length === 3 && typeof easing === 'function') {
    [top, duration, callback, easing] = args;
  }
  const dom = this;
  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }
  return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
  let [left, duration, easing, callback] = args;
  if (args.length === 3 && typeof easing === 'function') {
    [left, duration, callback, easing] = args;
  }
  const dom = this;
  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }
  return dom.scrollTo(left, undefined, duration, easing, callback);
}

function animate(initialProps, initialParams) {
  const els = this;
  const a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing', // or 'linear'
      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */
    }, initialParams),

    elements: els,
    animating: false,
    que: [],

    easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - (Math.cos(progress * Math.PI) / 2);
      }
      if (typeof easing === 'function') {
        return easing(progress);
      }
      return progress;
    },
    stop() {
      if (a.frameId) {
        cancelAnimationFrame(a.frameId);
      }
      a.animating = false;
      a.elements.each((index, el) => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },
    done(complete) {
      a.animating = false;
      a.elements.each((index, el) => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);
      if (a.que.length > 0) {
        const que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },
    animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }
      const elements = [];

      // Define & Cache Initials & Units
      a.elements.each((index, el) => {
        let initialFullValue;
        let initialValue;
        let unit;
        let finalValue;
        let finalFullValue;

        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;

        elements[index] = {
          container: el,
        };
        Object.keys(props).forEach((prop) => {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue,
            initialValue,
            unit,
            finalValue,
            finalFullValue,
            currentValue: initialValue,
          };
        });
      });

      let startTime = null;
      let time;
      let elementsDone = 0;
      let propsDone = 0;
      let done;
      let began = false;

      a.animating = true;

      function render() {
        time = new Date().getTime();
        let progress;
        let easeProgress;
        // let el;
        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }
        if (startTime === null) {
          startTime = time;
        }
        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), ((startTime + params.duration) - time < 0 ? 0 : (startTime + params.duration) - time), startTime);
        }

        elements.forEach((element) => {
          const el = element;
          if (done || el.done) return;
          Object.keys(props).forEach((prop) => {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            const { initialValue, finalValue, unit } = el[prop];
            el[prop].currentValue = initialValue + (easeProgress * (finalValue - initialValue));
            const currentValue = el[prop].currentValue;

            if (
              (finalValue > initialValue && currentValue >= finalValue) ||
              (finalValue < initialValue && currentValue <= finalValue)) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;
              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }
              if (elementsDone === elements.length) {
                done = true;
              }
            }
            if (done) {
              a.done(params.complete);
              return;
            }
            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return;
        // Then call
        a.frameId = requestAnimationFrame(render);
      }
      a.frameId = requestAnimationFrame(render);
      return a;
    },
  };

  if (a.elements.length === 0) {
    return els;
  }

  let animateInstance;
  for (let i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }
  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  const els = this;
  for (let i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

const noTrigger = ('resize scroll').split(' ');
function eventShortcut(name, ...args) {
  if (typeof args[0] === 'undefined') {
    for (let i = 0; i < this.length; i += 1) {
      if (noTrigger.indexOf(name) < 0) {
        if (name in this[i]) this[i][name]();
        else {
          $(this[i]).trigger(name);
        }
      }
    }
    return this;
  }
  return this.on(name, ...args);
}

function click(...args) {
  return eventShortcut.bind(this)('click', ...args);
}
function dom7_modular_blur(...args) {
  return eventShortcut.bind(this)('blur', ...args);
}
function dom7_modular_focus(...args) {
  return eventShortcut.bind(this)('focus', ...args);
}
function focusin(...args) {
  return eventShortcut.bind(this)('focusin', ...args);
}
function focusout(...args) {
  return eventShortcut.bind(this)('focusout', ...args);
}
function keyup(...args) {
  return eventShortcut.bind(this)('keyup', ...args);
}
function keydown(...args) {
  return eventShortcut.bind(this)('keydown', ...args);
}
function keypress(...args) {
  return eventShortcut.bind(this)('keypress', ...args);
}
function dom7_modular_submit(...args) {
  return eventShortcut.bind(this)('submit', ...args);
}
function change(...args) {
  return eventShortcut.bind(this)('change', ...args);
}
function mousedown(...args) {
  return eventShortcut.bind(this)('mousedown', ...args);
}
function mousemove(...args) {
  return eventShortcut.bind(this)('mousemove', ...args);
}
function mouseup(...args) {
  return eventShortcut.bind(this)('mouseup', ...args);
}
function mouseenter(...args) {
  return eventShortcut.bind(this)('mouseenter', ...args);
}
function mouseleave(...args) {
  return eventShortcut.bind(this)('mouseleave', ...args);
}
function mouseout(...args) {
  return eventShortcut.bind(this)('mouseout', ...args);
}
function mouseover(...args) {
  return eventShortcut.bind(this)('mouseover', ...args);
}
function touchstart(...args) {
  return eventShortcut.bind(this)('touchstart', ...args);
}
function touchend(...args) {
  return eventShortcut.bind(this)('touchend', ...args);
}
function touchmove(...args) {
  return eventShortcut.bind(this)('touchmove', ...args);
}
function resize(...args) {
  return eventShortcut.bind(this)('resize', ...args);
}
function dom7_modular_scroll(...args) {
  return eventShortcut.bind(this)('scroll', ...args);
}



;// CONCATENATED MODULE: ./node_modules/swiper/js/swiper.esm.bundle.js
/**
 * Swiper 5.4.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 16, 2020
 */




const Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  data: data,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: dom7_modular_outerWidth,
  outerHeight: dom7_modular_outerHeight,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: dom7_modular_text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: dom7_modular_parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove,
  add: add,
  styles: styles,
};

Object.keys(Methods).forEach((methodName) => {
  $.fn[methodName] = $.fn[methodName] || Methods[methodName];
});

const Utils = {
  deleteProps(obj) {
    const object = obj;
    Object.keys(object).forEach((key) => {
      try {
        object[key] = null;
      } catch (e) {
        // no getter for object
      }
      try {
        delete object[key];
      } catch (e) {
        // something got wrong
      }
    });
  },
  nextTick(callback, delay = 0) {
    return setTimeout(callback, delay);
  },
  now() {
    return Date.now();
  },
  getTranslate(el, axis = 'x') {
    let matrix;
    let curTransform;
    let transformMatrix;

    const curStyle = win.getComputedStyle(el, null);

    if (win.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(',').length > 6) {
        curTransform = curTransform.split(', ').map((a) => a.replace(',', '.')).join(', ');
      }
      // Some old versions of Webkit choke when 'none' is passed; pass
      // empty string instead in this case
      transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
      matrix = transformMatrix.toString().split(',');
    }

    if (axis === 'x') {
      // Latest Chrome and webkits Fix
      if (win.WebKitCSSMatrix) curTransform = transformMatrix.m41;
      // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
      // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
      // Latest Chrome and webkits Fix
      if (win.WebKitCSSMatrix) curTransform = transformMatrix.m42;
      // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
      // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  },
  parseUrlQuery(url) {
    const query = {};
    let urlToParse = url || win.location.href;
    let i;
    let params;
    let param;
    let length;
    if (typeof urlToParse === 'string' && urlToParse.length) {
      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
      params = urlToParse.split('&').filter((paramsPart) => paramsPart !== '');
      length = params.length;

      for (i = 0; i < length; i += 1) {
        param = params[i].replace(/#\S+/g, '').split('=');
        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
      }
    }
    return query;
  },
  isObject(o) {
    return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
  },
  extend(...args) {
    const to = Object(args[0]);
    for (let i = 1; i < args.length; i += 1) {
      const nextSource = args[i];
      if (nextSource !== undefined && nextSource !== null) {
        const keysArray = Object.keys(Object(nextSource));
        for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          const nextKey = keysArray[nextIndex];
          const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              to[nextKey] = {};
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  },
};

const Support = (function Support() {
  return {
    touch: !!(("ontouchstart" in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch)),

    pointerEvents: !!win.PointerEvent && ("maxTouchPoints" in win.navigator) && win.navigator.maxTouchPoints >= 0,

    observer: (function checkObserver() {
      return ("MutationObserver" in win || "WebkitMutationObserver" in win);
    }()),

    passiveListener: (function checkPassiveListener() {
      let supportsPassive = false;
      try {
        const opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          },
        });
        win.addEventListener('testPassiveListener', null, opts);
      } catch (e) {
        // No support
      }
      return supportsPassive;
    }()),

    gestures: (function checkGestures() {
      return "ongesturestart" in win;
    }()),
  };
}());

class SwiperClass {
  constructor(params = {}) {
    const self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach((eventName) => {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  }

  on(events, handler, priority) {
    const self = this;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach((event) => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  }

  once(events, handler, priority) {
    const self = this;
    if (typeof handler !== 'function') return self;
    function onceHandler(...args) {
      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
      handler.apply(self, args);
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  }

  off(events, handler) {
    const self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach((event) => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  }

  emit(...args) {
    const self = this;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach((event) => {
      if (self.eventsListeners && self.eventsListeners[event]) {
        const handlers = [];
        self.eventsListeners[event].forEach((eventHandler) => {
          handlers.push(eventHandler);
        });
        handlers.forEach((eventHandler) => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

  useModulesParams(instanceParams) {
    const instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach((moduleName) => {
      const module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  }

  useModules(modulesParams = {}) {
    const instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach((moduleName) => {
      const module = instance.modules[moduleName];
      const moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach((modulePropName) => {
          const moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach((moduleEventName) => {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }

  static set components(components) {
    const Class = this;
    if (!Class.use) return;
    Class.use(components);
  }

  static installModule(module, ...params) {
    const Class = this;
    if (!Class.prototype.modules) Class.prototype.modules = {};
    const name = module.name || (`${Object.keys(Class.prototype.modules).length}_${Utils.now()}`);
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach((key) => {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach((key) => {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  }

  static use(module, ...params) {
    const Class = this;
    if (Array.isArray(module)) {
      module.forEach((m) => Class.installModule(m));
      return Class;
    }
    return Class.installModule(module, ...params);
  }
}

function updateSize () {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;
  if (typeof swiper.params.width !== 'undefined') {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined') {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }
  if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
    return;
  }

  // Subtract paddings
  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

  Utils.extend(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height,
  });
}

function updateSlides () {
  const swiper = this;
  const params = swiper.params;

  const {
    $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL,
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];

  function slidesForMargin(slideIndex) {
    if (!params.cssMode) return true;
    if (slideIndex === slides.length - 1) {
      return false;
    }
    return true;
  }

  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.snapGrid.length;

  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
  }

  swiper.virtualSize = -spaceBetween;

  // reset margins
  if (rtl) slides.css({ marginLeft: '', marginTop: '' });
  else slides.css({ marginRight: '', marginBottom: '' });

  let slidesNumberEvenToRows;
  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }
    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  }

  // Calc slides
  let slideSize;
  const slidesPerColumn = params.slidesPerColumn;
  const slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  const numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides.eq(i);
    if (params.slidesPerColumn > 1) {
      // Set slides order
      let newSlideOrderIndex;
      let column;
      let row;
      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        const groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        const slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        const columnsInGroup = groupIndex === 0
          ? params.slidesPerGroup
          : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = (slideIndexInGroup - row * columnsInGroup) + groupIndex * params.slidesPerGroup;

        newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
        slide
          .css({
            '-webkit-box-ordinal-group': newSlideOrderIndex,
            '-moz-box-ordinal-group': newSlideOrderIndex,
            '-ms-flex-order': newSlideOrderIndex,
            '-webkit-order': newSlideOrderIndex,
            order: newSlideOrderIndex,
          });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - (column * slidesPerColumn);
        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
          row += 1;
          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - (row * slidesPerRow);
      }
      slide.css(
        `margin-${swiper.isHorizontal() ? 'top' : 'left'}`,
        (row !== 0 && params.spaceBetween) && (`${params.spaceBetween}px`)
      );
    }
    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      const slideStyles = win.getComputedStyle(slide[0], null);
      const currentTransform = slide[0].style.transform;
      const currentWebKitTransform = slide[0].style.webkitTransform;
      if (currentTransform) {
        slide[0].style.transform = 'none';
      }
      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal()
          ? slide.outerWidth(true)
          : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        if (swiper.isHorizontal()) {
          const width = parseFloat(slideStyles.getPropertyValue('width'));
          const paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
          const paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
          const marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
          const marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
          const boxSizing = slideStyles.getPropertyValue('box-sizing');
          if (boxSizing && boxSizing === 'border-box') {
            slideSize = width + marginLeft + marginRight;
          } else {
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
          }
        } else {
          const height = parseFloat(slideStyles.getPropertyValue('height'));
          const paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
          const paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
          const marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
          const marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
          const boxSizing = slideStyles.getPropertyValue('box-sizing');
          if (boxSizing && boxSizing === 'border-box') {
            slideSize = height + marginTop + marginBottom;
          } else {
            slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
          }
        }
      }
      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        if (swiper.isHorizontal()) {
          slides[i].style.width = `${slideSize}px`;
        } else {
          slides[i].style.height = `${slideSize}px`;
        }
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);


    if (params.centeredSlides) {
      slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - (swiperSize / 2) - spaceBetween;
      if (i === 0) slidePosition = slidePosition - (swiperSize / 2) - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index) % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;

    prevSlideSize = slideSize;

    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  let newSlidesGrid;

  if (
    rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
  }
  if (params.setWrapperSize) {
    if (swiper.isHorizontal()) $wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
    else $wrapperEl.css({ height: `${swiper.virtualSize + params.spaceBetween}px` });
  }

  if (params.slidesPerColumn > 1) {
    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    if (swiper.isHorizontal()) $wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
    else $wrapperEl.css({ height: `${swiper.virtualSize + params.spaceBetween}px` });
    if (params.centeredSlides) {
      newSlidesGrid = [];
      for (let i = 0; i < snapGrid.length; i += 1) {
        let slidesGridItem = snapGrid[i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }
      snapGrid = newSlidesGrid;
    }
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    if (swiper.isHorizontal()) {
      if (rtl) slides.filter(slidesForMargin).css({ marginLeft: `${spaceBetween}px` });
      else slides.filter(slidesForMargin).css({ marginRight: `${spaceBetween}px` });
    } else slides.filter(slidesForMargin).css({ marginBottom: `${spaceBetween}px` });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map((snap) => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Utils.extend(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid,
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight (speed) {
  const swiper = this;
  const activeSlides = [];
  let newHeight = 0;
  let i;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each((index, slide) => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length) break;
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    }
  } else {
    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight) swiper.$wrapperEl.css('height', `${newHeight}px`);
}

function updateSlidesOffset () {
  const swiper = this;
  const slides = swiper.slides;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress (translate = (this && this.translate) || 0) {
  const swiper = this;
  const params = swiper.params;

  const { slides, rtlTranslate: rtl } = swiper;

  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();

  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate;

  // Visible Slides
  slides.removeClass(params.slideVisibleClass);

  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    const slideProgress = (
      (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
    ) / (slide.swiperSlideSize + params.spaceBetween);
    if (params.watchSlidesVisibility || (params.centeredSlides && params.autoHeight)) {
      const slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      const isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                || (slideAfter > 1 && slideAfter <= swiper.size)
                || (slideBefore <= 0 && slideAfter >= swiper.size);
      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }
    slide.progress = rtl ? -slideProgress : slideProgress;
  }
  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress (translate) {
  const swiper = this;
  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    // eslint-disable-next-line
    translate = (swiper && swiper.translate && (swiper.translate * multiplier)) || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let { progress, isBeginning, isEnd } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / (translatesDiff);
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }
  Utils.extend(swiper, {
    progress,
    isBeginning,
    isEnd,
  });

  if (params.watchSlidesProgress || params.watchSlidesVisibility || (params.centeredSlides && params.autoHeight)) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses () {
  const swiper = this;

  const {
    slides, params, $wrapperEl, activeIndex, realIndex,
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;

  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);

  let activeSlide;
  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  }

  // Active classes
  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl
        .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`)
        .addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl
        .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`)
        .addClass(params.slideDuplicateActiveClass);
    }
  }
  // Next Slide
  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  }
  // Prev Slide
  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }
  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl
        .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`)
        .addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl
        .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`)
        .addClass(params.slideDuplicateNextClass);
    }
    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl
        .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`)
        .addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl
        .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`)
        .addClass(params.slideDuplicatePrevClass);
    }
  }
}

function updateActiveIndex (newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid, snapGrid, params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex,
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  if (typeof activeIndex === 'undefined') {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }

  // Get real index
  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

  Utils.extend(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex,
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide (e) {
  const swiper = this;
  const params = swiper.params;
  const slide = $(e.target).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) slideFound = true;
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = $(slide).index();
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide,
};

function getTranslate (axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;

  const {
    params, rtlTranslate: rtl, translate, $wrapperEl,
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }

  let currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;

  return currentTranslate || 0;
}

function setTranslate (translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl, params, $wrapperEl, wrapperEl, progress,
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;

  // Check if we need to update progress
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate () {
  return (-this.snapGrid[0]);
}

function maxTranslate () {
  return (-this.snapGrid[this.snapGrid.length - 1]);
}

function translateTo (translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;

  const {
    params,
    wrapperEl,
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
  else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
  else newTranslate = translate;

  // Update progress
  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        wrapperEl.scrollTo({
          [isH ? 'left' : 'top']: -newTranslate,
          behavior: 'smooth',
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }
    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo,
};

function setTransition (duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionStart (runCallbacks = true, direction) {
  const swiper = this;
  const { activeIndex, params, previousIndex } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';
    else if (activeIndex < previousIndex) dir = 'prev';
    else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }
    swiper.emit('slideChangeTransitionStart');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function swiper_esm_bundle_transitionEnd (runCallbacks = true, direction) {
  const swiper = this;
  const { activeIndex, previousIndex, params } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);

  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';
    else if (activeIndex < previousIndex) dir = 'prev';
    else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }
    swiper.emit('slideChangeTransitionEnd');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var swiper_esm_bundle_transition = {
  setTransition,
  transitionStart,
  transitionEnd: swiper_esm_bundle_transitionEnd,
};

function slideTo (index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;

  const {
    params, snapGrid, slidesGrid, previousIndex, activeIndex, rtlTranslate: rtl, wrapperEl,
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  const translate = -snapGrid[snapIndex];

  // Update progress
  swiper.updateProgress(translate);

  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  let direction;
  if (slideIndex > activeIndex) direction = 'next';
  else if (slideIndex < activeIndex) direction = 'prev';
  else direction = 'reset';


  // Update Index
  if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    let t = -translate;
    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        wrapperEl.scrollTo({
          [isH ? 'left' : 'top']: t,
          behavior: 'smooth',
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }
    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop (index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  let newIndex = index;
  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext (speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const { params, animating } = swiper;
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
  if (params.loop) {
    if (animating) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev (speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params, animating, snapGrid, slidesGrid, rtlTranslate,
  } = swiper;

  if (params.loop) {
    if (animating) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  const translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
  const normalizedSlidesGrid = slidesGrid.map((val) => normalize(val));

  const currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach((snap) => {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }
  let prevIndex;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset (speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest (speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);

  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if ((translate - currentSnap) > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if ((translate - prevSnap) <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);

  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide () {
  const swiper = this;
  const { params, $wrapperEl } = swiper;

  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (
        (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
        || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
      ) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`)
          .eq(0)
          .index();

        Utils.nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl
        .children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`)
        .eq(0)
        .index();

      Utils.nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide,
};

function loopCreate () {
  const swiper = this;
  const { params, $wrapperEl } = swiper;
  // Remove duplicated slides
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();

  let slides = $wrapperEl.children(`.${params.slideClass}`);

  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = $(doc.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $wrapperEl.append(blankNode);
      }
      slides = $wrapperEl.children(`.${params.slideClass}`);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;

  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;
  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  const prependSlides = [];
  const appendSlides = [];
  slides.each((index, el) => {
    const slide = $(el);
    if (index < swiper.loopedSlides) appendSlides.push(el);
    if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
    slide.attr('data-swiper-slide-index', index);
  });
  for (let i = 0; i < appendSlides.length; i += 1) {
    $wrapperEl.append($(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $wrapperEl.prepend($(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix () {
  const swiper = this;

  swiper.emit('beforeLoopFix');

  const {
    activeIndex, slides, loopedSlides, allowSlidePrev, allowSlideNext, snapGrid, rtlTranslate: rtl,
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;

  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate();

  // Fix For Negative Oversliding
  if (activeIndex < loopedSlides) {
    newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  swiper.emit('loopFix');
}

function loopDestroy () {
  const swiper = this;
  const { $wrapperEl, params, slides } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate,
  loopFix,
  loopDestroy,
};

function setGrabCursor (moving) {
  const swiper = this;
  if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) return;
  const el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor () {
  const swiper = this;
  if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) return;
  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor,
  unsetGrabCursor,
};

function appendSlide (slides) {
  const swiper = this;
  const { $wrapperEl, params } = swiper;
  if (params.loop) {
    swiper.loopDestroy();
  }
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
}

function prependSlide (slides) {
  const swiper = this;
  const { params, $wrapperEl, activeIndex } = swiper;

  if (params.loop) {
    swiper.loopDestroy();
  }
  let newActiveIndex = activeIndex + 1;
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }
    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide (index, slides) {
  const swiper = this;
  const { $wrapperEl, params, activeIndex } = swiper;
  let activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
  }
  const baseLength = swiper.slides.length;
  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }
  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }
  let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

  const slidesBuffer = [];
  for (let i = baseLength - 1; i >= index; i -= 1) {
    const currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (let i = 0; i < slidesBuffer.length; i += 1) {
    $wrapperEl.append(slidesBuffer[i]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide (slidesIndexes) {
  const swiper = this;
  const { params, $wrapperEl, activeIndex } = swiper;

  let activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
  }
  let newActiveIndex = activeIndexBuffer;
  let indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (let i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }
    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides () {
  const swiper = this;

  const slidesIndexes = [];
  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide,
  prependSlide,
  addSlide,
  removeSlide,
  removeAllSlides,
};

const Device = (function Device() {
  const platform = win.navigator.platform;
  const ua = win.navigator.userAgent;

  const device = {
    ios: false,
    android: false,
    androidChrome: false,
    desktop: false,
    iphone: false,
    ipod: false,
    ipad: false,
    edge: false,
    ie: false,
    firefox: false,
    macos: false,
    windows: false,
    cordova: !!(win.cordova || win.phonegap),
    phonegap: !!(win.cordova || win.phonegap),
    electron: false,
  };

  const screenWidth = win.screen.width;
  const screenHeight = win.screen.height;

  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const ie = ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
  const edge = ua.indexOf('Edge/') >= 0;
  const firefox = ua.indexOf('Gecko/') >= 0 && ua.indexOf('Firefox/') >= 0;
  const windows = platform === 'Win32';
  const electron = ua.toLowerCase().indexOf('electron') >= 0;
  let macos = platform === 'MacIntel';

  // iPadOs 13 fix
  if (!ipad
    && macos
    && Support.touch
    && (
      (screenWidth === 1024 && screenHeight === 1366) // Pro 12.9
      || (screenWidth === 834 && screenHeight === 1194) // Pro 11
      || (screenWidth === 834 && screenHeight === 1112) // Pro 10.5
      || (screenWidth === 768 && screenHeight === 1024) // other
    )
  ) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    macos = false;
  }

  device.ie = ie;
  device.edge = edge;
  device.firefox = firefox;

  // Android
  if (android && !windows) {
    device.os = 'android';
    device.osVersion = android[2];
    device.android = true;
    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }
  // iOS
  if (iphone && !ipod) {
    device.osVersion = iphone[2].replace(/_/g, '.');
    device.iphone = true;
  }
  if (ipad) {
    device.osVersion = ipad[2].replace(/_/g, '.');
    device.ipad = true;
  }
  if (ipod) {
    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    device.ipod = true;
  }
  // iOS 8+ changed UA
  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
    if (device.osVersion.split('.')[0] === '10') {
      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
    }
  }

  // Webview
  device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone))
    || (win.matchMedia && win.matchMedia('(display-mode: standalone)').matches);
  device.webview = device.webView;
  device.standalone = device.webView;

  // Desktop
  device.desktop = !(device.ios || device.android) || electron;
  if (device.desktop) {
    device.electron = electron;
    device.macos = macos;
    device.windows = windows;
    if (device.macos) {
      device.os = 'macos';
    }
    if (device.windows) {
      device.os = 'windows';
    }
  }

  // Pixel Ratio
  device.pixelRatio = win.devicePixelRatio || 1;

  // Export object
  return device;
}());

function onTouchStart (event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const { params, touches } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  const $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }
  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;
  if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`)[0]) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (
    edgeSwipeDetection
    && ((startX <= edgeSwipeThreshold)
    || (startX >= win.screen.width - edgeSwipeThreshold))
  ) {
    return;
  }

  Utils.extend(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined,
  });

  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = Utils.now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  if (e.type !== 'touchstart') {
    let preventDefault = true;
    if ($targetEl.is(data.formElements)) preventDefault = false;
    if (
      doc.activeElement
      && $(doc.activeElement).is(data.formElements)
      && doc.activeElement !== $targetEl[0]
    ) {
      doc.activeElement.blur();
    }

    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if (params.touchStartForcePreventDefault || shouldPreventDefault) {
      e.preventDefault();
    }
  }
  swiper.emit('touchStart', e);
}

function onTouchMove (event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const { params, touches, rtlTranslate: rtl } = swiper;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  if (data.isTouchEvent && e.type !== 'touchmove') return;
  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;
    if (data.isTouched) {
      Utils.extend(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY,
      });
      data.touchStartTime = Utils.now();
    }
    return;
  }
  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (
        (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
        || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
      ) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (
      (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
      || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
    ) {
      return;
    }
  }
  if (data.isTouchEvent && doc.activeElement) {
    if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  if (e.targetTouches && e.targetTouches.length > 1) return;

  touches.currentX = pageX;
  touches.currentY = pageY;

  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt((diffX ** 2) + (diffY ** 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;
    if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if ((diffX * diffX) + (diffY * diffY) >= 25) {
        touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;

  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;

  diff *= params.touchRatio;
  if (rtl) diff = -diff;

  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;

  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = (swiper.minTranslate() - 1) + ((-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = (swiper.maxTranslate() + 1) - ((swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }


  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return;

  // Update active index in free mode
  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime,
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: Utils.now(),
    });
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd (event) {
  const swiper = this;
  const data = swiper.touchEventsData;

  const {
    params, touches, rtlTranslate: rtl, $wrapperEl, slidesGrid, snapGrid,
  } = swiper;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  const touchEndTime = Utils.now();
  const timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = Utils.now();
  Utils.nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;

  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();

        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeModeMomentumVelocityRatio;

      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeModeMomentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;

      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;

      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      let needsLoopFix;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        let nextSlide;
        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        swiper.once('transitionEnd', () => {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(() => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(() => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    return;
  }

  // Find current slide
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += (i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup)) {
    const increment = (i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup);
    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  // Find current slide size
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = (stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup);

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
      else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > (1 - params.longSwipesRatio)) swiper.slideTo(stopIndex + increment);
      else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize () {
  const swiper = this;

  const { params, el } = swiper;

  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  const { allowSlideNext, allowSlidePrev, snapGrid } = swiper;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;

  swiper.updateSize();
  swiper.updateSlides();

  swiper.updateSlidesClasses();
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick (e) {
  const swiper = this;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll () {
  const swiper = this;
  const { wrapperEl, rtlTranslate } = swiper;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = ((wrapperEl.scrollWidth - wrapperEl.offsetWidth) - wrapperEl.scrollLeft);
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  // eslint-disable-next-line
  if (swiper.translate === -0) swiper.translate = 0;

  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();

  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / (translatesDiff);
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

let dummyEventAttached = false;
function dummyEventListener() {}

function attachEvents() {
  const swiper = this;
  const {
    params, touchEvents, el, wrapperEl,
  } = swiper;

  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  const capture = !!params.nested;

  // Touch Events
  if (!Support.touch && Support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (Support.touch) {
      const passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
      if (!dummyEventAttached) {
        doc.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }
    if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      doc.addEventListener('mousemove', swiper.onTouchMove, capture);
      doc.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  }
  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  }

  // Resize handler
  if (params.updateOnWindowResize) {
    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  const swiper = this;

  const {
    params, touchEvents, el, wrapperEl,
  } = swiper;

  const capture = !!params.nested;

  // Touch Events
  if (!Support.touch && Support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (Support.touch) {
      const passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }
    if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
      doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  }
  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  }

  // Resize handler
  swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
}

var events = {
  attachEvents,
  detachEvents,
};

function setBreakpoint () {
  const swiper = this;
  const {
    activeIndex, initialized, loopedSlides = 0, params, $el,
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) return;

  // Get breakpoint for window width and update parameters
  const breakpoint = swiper.getBreakpoint(breakpoints);

  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    if (breakpointOnlyParams) {
      ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach((param) => {
        const paramValue = breakpointOnlyParams[param];
        if (typeof paramValue === 'undefined') return;
        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
          breakpointOnlyParams[param] = 'auto';
        } else if (param === 'slidesPerView') {
          breakpointOnlyParams[param] = parseFloat(paramValue);
        } else {
          breakpointOnlyParams[param] = parseInt(paramValue, 10);
        }
      });
    }

    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = params.slidesPerColumn > 1;
    const isMultiRow = breakpointParams.slidesPerColumn > 1;
    if (wasMultiRow && !isMultiRow) {
      $el.removeClass(`${params.containerModifierClass}multirow ${params.containerModifierClass}multirow-column`);
    } else if (!wasMultiRow && isMultiRow) {
      $el.addClass(`${params.containerModifierClass}multirow`);
      if (breakpointParams.slidesPerColumnFill === 'column') {
        $el.addClass(`${params.containerModifierClass}multirow-column`);
      }
    }

    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

    if (directionChanged && initialized) {
      swiper.changeDirection();
    }

    Utils.extend(swiper.params, breakpointParams);

    Utils.extend(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
    });

    swiper.currentBreakpoint = breakpoint;

    if (needsReLoop && initialized) {
      swiper.loopDestroy();
      swiper.loopCreate();
      swiper.updateSlides();
      swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
    }

    swiper.emit('breakpoint', breakpointParams);
  }
}

function getBreakpoint (breakpoints) {
  // Get breakpoint for window width
  if (!breakpoints) return undefined;
  let breakpoint = false;

  const points = Object.keys(breakpoints).map((point) => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = win.innerHeight * minRatio;
      return { value, point };
    }
    return { value: point, point };
  });

  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const { point, value } = points[i];
    if (value <= win.innerWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = { setBreakpoint, getBreakpoint };

function addClasses () {
  const swiper = this;
  const {
    classNames, params, rtl, $el,
  } = swiper;
  const suffixes = [];

  suffixes.push('initialized');
  suffixes.push(params.direction);

  if (params.freeMode) {
    suffixes.push('free-mode');
  }
  if (params.autoHeight) {
    suffixes.push('autoheight');
  }
  if (rtl) {
    suffixes.push('rtl');
  }
  if (params.slidesPerColumn > 1) {
    suffixes.push('multirow');
    if (params.slidesPerColumnFill === 'column') {
      suffixes.push('multirow-column');
    }
  }
  if (Device.android) {
    suffixes.push('android');
  }
  if (Device.ios) {
    suffixes.push('ios');
  }

  if (params.cssMode) {
    suffixes.push('css-mode');
  }

  suffixes.forEach((suffix) => {
    classNames.push(params.containerModifierClass + suffix);
  });

  $el.addClass(classNames.join(' '));
}

function removeClasses () {
  const swiper = this;
  const { $el, classNames } = swiper;

  $el.removeClass(classNames.join(' '));
}

var classes = { addClasses, removeClasses };

function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
  let image;
  function onReady() {
    if (callback) callback();
  }
  const isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new win.Image();
      image.onload = onReady;
      image.onerror = onReady;
      if (sizes) {
        image.sizes = sizes;
      }
      if (srcset) {
        image.srcset = srcset;
      }
      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages () {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');
  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }
  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(
      imageEl,
      imageEl.currentSrc || imageEl.getAttribute('src'),
      imageEl.srcset || imageEl.getAttribute('srcset'),
      imageEl.sizes || imageEl.getAttribute('sizes'),
      true,
      onReady
    );
  }
}

var swiper_esm_bundle_images = {
  loadImage,
  preloadImages,
};

function checkOverflow() {
  const swiper = this;
  const params = swiper.params;
  const wasLocked = swiper.isLocked;
  const lastSlidePosition = swiper.slides.length > 0 && (params.slidesOffsetBefore + (params.spaceBetween * (swiper.slides.length - 1)) + ((swiper.slides[0]).offsetWidth) * swiper.slides.length);

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked;

  // events
  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

var checkOverflow$1 = { checkOverflow };

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  //
  preventInteractionOnTransition: false,

  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,

  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,

  // Autoheight
  autoHeight: false,

  // Set wrapper width
  setWrapperSize: false,

  // Virtual Translate
  virtualTranslate: false,

  // Effects
  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,

  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0, // in px
  slidesOffsetAfter: 0, // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,

  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,

  // Round length
  roundLengths: false,

  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,

  // Unique Navigation Elements
  uniqueNavElements: true,

  // Resistance
  resistance: true,
  resistanceRatio: 0.85,

  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,

  // Cursor
  grabCursor: false,

  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,

  // Images
  preloadImages: true,
  updateOnImagesReady: true,

  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,

  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null, // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,

  // Passive Listeners
  passiveListeners: true,

  // NS
  containerModifierClass: 'swiper-container-', // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',

  // Callbacks
  runCallbacksOnInit: true,
};

/* eslint no-param-reassign: "off" */

const prototypes = {
  update,
  translate,
  transition: swiper_esm_bundle_transition,
  slide,
  loop,
  grabCursor,
  manipulation,
  events,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes,
  images: swiper_esm_bundle_images,
};

const extendedDefaults = {};

class Swiper extends SwiperClass {
  constructor(...args) {
    let el;
    let params;
    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};

    params = Utils.extend({}, params);
    if (el && !params.el) params.el = el;

    super(params);

    Object.keys(prototypes).forEach((prototypeGroup) => {
      Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
        if (!Swiper.prototype[protoMethod]) {
          Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
        }
      });
    });

    // Swiper Instance
    const swiper = this;
    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }
    Object.keys(swiper.modules).forEach((moduleName) => {
      const module = swiper.modules[moduleName];
      if (module.params) {
        const moduleParamName = Object.keys(module.params)[0];
        const moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) return;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
        if (params[moduleParamName] === true) {
          params[moduleParamName] = { enabled: true };
        }
        if (
          typeof params[moduleParamName] === 'object'
          && !('enabled' in params[moduleParamName])
        ) {
          params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName]) params[moduleParamName] = { enabled: false };
      }
    });

    // Extend defaults with modules params
    const swiperParams = Utils.extend({}, defaults);
    swiper.useModulesParams(swiperParams);

    // Extend defaults with passed params
    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = Utils.extend({}, swiper.params);
    swiper.passedParams = Utils.extend({}, params);

    // Save Dom lib
    swiper.$ = $;

    // Find el
    const $el = $(swiper.params.el);
    el = $el[0];

    if (!el) {
      return undefined;
    }

    if ($el.length > 1) {
      const swipers = [];
      $el.each((index, containerEl) => {
        const newParams = Utils.extend({}, params, { el: containerEl });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    }

    el.swiper = swiper;
    $el.data('swiper', swiper);

    // Find Wrapper
    let $wrapperEl;
    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
      $wrapperEl = $(el.shadowRoot.querySelector(`.${swiper.params.wrapperClass}`));
      // Children needs to return slot items
      $wrapperEl.children = (options) => $el.children(options);
    } else {
      $wrapperEl = $el.children(`.${swiper.params.wrapperClass}`);
    }
    // Extend Swiper
    Utils.extend(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],

      // Classes
      classNames: [],

      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // RTL
      rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box',

      // Indexes
      activeIndex: 0,
      realIndex: 0,

      //
      isBeginning: true,
      isEnd: false,

      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,

      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,

      // Touch Events
      touchEvents: (function touchEvents() {
        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        let desktop = ['mousedown', 'mousemove', 'mouseup'];
        if (Support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3],
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2],
        };
        return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }()),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        formElements: 'input, select, option, textarea, button, video, label',
        // Last click time
        lastClickTime: Utils.now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined,
      },

      // Clicks
      allowClick: true,

      // Touches
      allowTouchMove: swiper.params.allowTouchMove,

      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0,
      },

      // Images
      imagesToLoad: [],
      imagesLoaded: 0,

    });

    // Install Modules
    swiper.useModules();

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    return swiper;
  }

  slidesPerViewDynamic() {
    const swiper = this;
    const {
      params, slides, slidesGrid, size: swiperSize, activeIndex,
    } = swiper;
    let spv = 1;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slidesGrid[i] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }
    return spv;
  }

  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const { snapGrid, params } = swiper;
    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (swiper.params.freeMode) {
      setTranslate();
      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }
    if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
      return swiper;
    }

    swiper.$el
      .removeClass(`${swiper.params.containerModifierClass}${currentDirection}`)
      .addClass(`${swiper.params.containerModifierClass}${newDirection}`);

    swiper.params.direction = newDirection;

    swiper.slides.each((slideIndex, slideEl) => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });

    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();

    return swiper;
  }

  init() {
    const swiper = this;
    if (swiper.initialized) return;

    swiper.emit('beforeInit');

    // Set breakpoint
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Add Classes
    swiper.addClasses();

    // Create loop
    if (swiper.params.loop) {
      swiper.loopCreate();
    }

    // Update size
    swiper.updateSize();

    // Update slides
    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }

    // Set Grab Cursor
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    }

    // Slide To Initial Slide
    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
    }

    // Attach events
    swiper.attachEvents();

    // Init Flag
    swiper.initialized = true;

    // Emit
    swiper.emit('init');
  }

  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params, $el, $wrapperEl, slides,
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy');

    // Init Flag
    swiper.initialized = false;

    // Detach events
    swiper.detachEvents();

    // Destroy loop
    if (params.loop) {
      swiper.loopDestroy();
    }

    // Cleanup styles
    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');
      if (slides && slides.length) {
        slides
          .removeClass([
            params.slideVisibleClass,
            params.slideActiveClass,
            params.slideNextClass,
            params.slidePrevClass,
          ].join(' '))
          .removeAttr('style')
          .removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy');

    // Detach emitter events
    Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      swiper.$el.data('swiper', null);
      Utils.deleteProps(swiper);
    }
    swiper.destroyed = true;

    return null;
  }

  static extendDefaults(newDefaults) {
    Utils.extend(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return defaults;
  }

  static get Class() {
    return SwiperClass;
  }

  static get $() {
    return $;
  }
}

var Device$1 = {
  name: 'device',
  proto: {
    device: Device,
  },
  static: {
    device: Device,
  },
};

var Support$1 = {
  name: 'support',
  proto: {
    support: Support,
  },
  static: {
    support: Support,
  },
};

const Browser = (function Browser() {
  function isSafari() {
    const ua = win.navigator.userAgent.toLowerCase();
    return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
  }
  return {
    isEdge: !!win.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
  };
}());

var Browser$1 = {
  name: 'browser',
  proto: {
    browser: Browser,
  },
  static: {
    browser: Browser,
  },
};

var Resize = {
  name: 'resize',
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      resize: {
        resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        },
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      // Emit resize
      win.addEventListener('resize', swiper.resize.resizeHandler);

      // Emit orientationchange
      win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy() {
      const swiper = this;
      win.removeEventListener('resize', swiper.resize.resizeHandler);
      win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
  },
};

const Observer = {
  func: win.MutationObserver || win.WebkitMutationObserver,
  attach(target, options = {}) {
    const swiper = this;

    const ObserverFunc = Observer.func;
    const observer = new ObserverFunc((mutations) => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (win.requestAnimationFrame) {
        win.requestAnimationFrame(observerUpdate);
      } else {
        win.setTimeout(observerUpdate, 0);
      }
    });

    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
    });

    swiper.observer.observers.push(observer);
  },
  init() {
    const swiper = this;
    if (!Support.observer || !swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();
      for (let i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    }
    // Observe container
    swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

    // Observe wrapper
    swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
  },
  destroy() {
    const swiper = this;
    swiper.observer.observers.forEach((observer) => {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  },
};

var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false,
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      observer: {
        init: Observer.init.bind(swiper),
        attach: Observer.attach.bind(swiper),
        destroy: Observer.destroy.bind(swiper),
        observers: [],
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      swiper.observer.init();
    },
    destroy() {
      const swiper = this;
      swiper.observer.destroy();
    },
  },
};

const Virtual = {
  update(force) {
    const swiper = this;
    const { slidesPerView, slidesPerGroup, centeredSlides } = swiper.params;
    const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      renderSlide,
      offset: previousOffset,
    } = swiper.virtual;
    swiper.updateActiveIndex();
    const activeIndex = swiper.activeIndex || 0;

    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';
    else offsetProp = swiper.isHorizontal() ? 'left' : 'top';

    let slidesAfter;
    let slidesBefore;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
      slidesBefore = slidesPerGroup + addSlidesAfter;
    }
    const from = Math.max((activeIndex || 0) - slidesBefore, 0);
    const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

    Utils.extend(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid,
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, `${offset}px`);
      }
      swiper.updateProgress();
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: (function getSlides() {
          const slidesToRender = [];
          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()),
      });
      onRendered();
      return;
    }
    const prependIndexes = [];
    const appendIndexes = [];
    if (force) {
      swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
      }
    }
    for (let i = 0; i < slides.length; i += 1) {
      if (i >= from && i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(i);
        } else {
          if (i > previousTo) appendIndexes.push(i);
          if (i < previousFrom) prependIndexes.push(i);
        }
      }
    }
    appendIndexes.forEach((index) => {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort((a, b) => b - a).forEach((index) => {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
    onRendered();
  },
  renderSlide(slide, index) {
    const swiper = this;
    const params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }
    const $slideEl = params.renderSlide
      ? $(params.renderSlide.call(swiper, slide, index))
      : $(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  },
  appendSlide(slides) {
    const swiper = this;
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }
    swiper.virtual.update(true);
  },
  prependSlide(slides) {
    const swiper = this;
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }
      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }
    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach((cachedIndex) => {
        const $cachedEl = cache[cachedIndex];
        const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
        }
        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }
    swiper.virtual.update(true);
    swiper.slideTo(newActiveIndex, 0);
  },
  removeSlide(slidesIndexes) {
    const swiper = this;
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;
    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }
        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);
      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }
      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }
    swiper.virtual.update(true);
    swiper.slideTo(activeIndex, 0);
  },
  removeAllSlides() {
    const swiper = this;
    swiper.virtual.slides = [];
    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }
    swiper.virtual.update(true);
    swiper.slideTo(0, 0);
  },
};

var Virtual$1 = {
  name: 'virtual',
  params: {
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      addSlidesBefore: 0,
      addSlidesAfter: 0,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      virtual: {
        update: Virtual.update.bind(swiper),
        appendSlide: Virtual.appendSlide.bind(swiper),
        prependSlide: Virtual.prependSlide.bind(swiper),
        removeSlide: Virtual.removeSlide.bind(swiper),
        removeAllSlides: Virtual.removeAllSlides.bind(swiper),
        renderSlide: Virtual.renderSlide.bind(swiper),
        slides: swiper.params.virtual.slides,
        cache: {},
      },
    });
  },
  on: {
    beforeInit() {
      const swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
      const overwriteParams = {
        watchSlidesProgress: true,
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);

      if (!swiper.params.initialSlide) {
        swiper.virtual.update();
      }
    },
    setTranslate() {
      const swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.virtual.update();
    },
  },
};

const Keyboard = {
  handle(event) {
    const swiper = this;
    const { rtlTranslate: rtl } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40;
    // Directions locks
    if (!swiper.allowSlideNext && ((swiper.isHorizontal() && isArrowRight) || (swiper.isVertical() && isArrowDown) || isPageDown)) {
      return false;
    }
    if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && isArrowLeft) || (swiper.isVertical() && isArrowUp) || isPageUp)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }
    if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }
    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false;
      // Check that swiper should be inside of visible area of window
      if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }
      const windowWidth = win.innerWidth;
      const windowHeight = win.innerHeight;
      const swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      const swiperCoord = [
        [swiperOffset.left, swiperOffset.top],
        [swiperOffset.left + swiper.width, swiperOffset.top],
        [swiperOffset.left, swiperOffset.top + swiper.height],
        [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height],
      ];
      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];
        if (
          point[0] >= 0 && point[0] <= windowWidth
          && point[1] >= 0 && point[1] <= windowHeight
        ) {
          inView = true;
        }
      }
      if (!inView) return undefined;
    }
    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
      }
      if (((isPageDown || isArrowRight) && !rtl) || ((isPageUp || isArrowLeft) && rtl)) swiper.slideNext();
      if (((isPageUp || isArrowLeft) && !rtl) || ((isPageDown || isArrowRight) && rtl)) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
      }
      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }
    swiper.emit('keyPress', kc);
    return undefined;
  },
  enable() {
    const swiper = this;
    if (swiper.keyboard.enabled) return;
    $(doc).on('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = true;
  },
  disable() {
    const swiper = this;
    if (!swiper.keyboard.enabled) return;
    $(doc).off('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = false;
  },
};

var Keyboard$1 = {
  name: 'keyboard',
  params: {
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      keyboard: {
        enabled: false,
        enable: Keyboard.enable.bind(swiper),
        disable: Keyboard.disable.bind(swiper),
        handle: Keyboard.handle.bind(swiper),
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      if (swiper.params.keyboard.enabled) {
        swiper.keyboard.enable();
      }
    },
    destroy() {
      const swiper = this;
      if (swiper.keyboard.enabled) {
        swiper.keyboard.disable();
      }
    },
  },
};

function isEventSupported() {
  const eventName = 'onwheel';
  let isSupported = eventName in doc;

  if (!isSupported) {
    const element = doc.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported
    && doc.implementation
    && doc.implementation.hasFeature
    // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    && doc.implementation.hasFeature('', '') !== true
  ) {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}
const Mousewheel = {
  lastScrollTime: Utils.now(),
  lastEventBeforeSnap: undefined,
  recentWheelEvents: [],
  event() {
    if (win.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
    return isEventSupported() ? 'wheel' : 'mousewheel';
  },
  normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;

    let sX = 0;
    let sY = 0; // spinX, spinY
    let pX = 0;
    let pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) { // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) { // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else { // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = (pX < 1) ? -1 : 1;
    }
    if (pY && !sY) {
      sY = (pY < 1) ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY,
    };
  },
  handleMouseEnter() {
    const swiper = this;
    swiper.mouseEntered = true;
  },
  handleMouseLeave() {
    const swiper = this;
    swiper.mouseEntered = false;
  },
  handle(event) {
    let e = event;
    const swiper = this;
    const params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    let target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarged);
    }
    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;

    if (e.originalEvent) e = e.originalEvent; // jquery fix
    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;

    const data = Mousewheel.normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
        else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
      else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;

    if (params.invert) delta = -delta;

    if (!swiper.params.freeMode) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: Utils.now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event,
      };

      // Keep the most recent events
      const recentWheelEvents = swiper.mousewheel.recentWheelEvents;
      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }
      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent);

      // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.
      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          swiper.mousewheel.animateSlider(newEvent);
        }
      } else {
        swiper.mousewheel.animateSlider(newEvent);
      }

      // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.
      if (swiper.mousewheel.releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:

      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = { time: Utils.now(), delta: Math.abs(delta), direction: Math.sign(delta) };
      const { lastEventBeforeSnap } = swiper.mousewheel;
      const ignoreWheelEvents = lastEventBeforeSnap
        && newEvent.time < lastEventBeforeSnap.time + 500
        && newEvent.delta <= lastEventBeforeSnap.delta
        && newEvent.direction === lastEventBeforeSnap.direction;
      if (!ignoreWheelEvents) {
        swiper.mousewheel.lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }
        let position = swiper.getTranslate() + (delta * params.sensitivity);
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;

        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = undefined;
          const recentWheelEvents = swiper.mousewheel.recentWheelEvents;
          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }
          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);
          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15
              && newEvent.time - firstEvent.time < 500
              && firstEvent.delta - newEvent.delta >= 1
              && newEvent.delta <= 6
          ) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            swiper.mousewheel.lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            swiper.mousewheel.timeout = Utils.nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }
          if (!swiper.mousewheel.timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            swiper.mousewheel.timeout = Utils.nextTick(() => {
              const snapToThreshold = 0.5;
              swiper.mousewheel.lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        }

        // Emit event
        if (!ignoreWheelEvents) swiper.emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();
    else e.returnValue = false;
    return false;
  },
  animateSlider(newEvent) {
    const swiper = this;
    // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).
    if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
      // Return false as a default
      return true;
    }
    // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.
    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        swiper.emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      swiper.emit('scroll', newEvent.raw);
    }
    // If you got here is because an animation has been triggered so store the current time
    swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
    // Return false as a default
    return false;
  },
  releaseScroll(newEvent) {
    const swiper = this;
    const params = swiper.params.mousewheel;
    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }
    return false;
  },
  enable() {
    const swiper = this;
    const event = Mousewheel.event();
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
      return true;
    }
    if (!event) return false;
    if (swiper.mousewheel.enabled) return false;
    let target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarged);
    }
    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
    target.on(event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = true;
    return true;
  },
  disable() {
    const swiper = this;
    const event = Mousewheel.event();
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
      return true;
    }
    if (!event) return false;
    if (!swiper.mousewheel.enabled) return false;
    let target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarged);
    }
    target.off(event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = false;
    return true;
  },
};

var Mousewheel$1 = {
  name: 'mousewheel',
  params: {
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarged: 'container',
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      mousewheel: {
        enabled: false,
        enable: Mousewheel.enable.bind(swiper),
        disable: Mousewheel.disable.bind(swiper),
        handle: Mousewheel.handle.bind(swiper),
        handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
        handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
        animateSlider: Mousewheel.animateSlider.bind(swiper),
        releaseScroll: Mousewheel.releaseScroll.bind(swiper),
        lastScrollTime: Utils.now(),
        lastEventBeforeSnap: undefined,
        recentWheelEvents: [],
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
        swiper.mousewheel.disable();
      }
      if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
    },
    destroy() {
      const swiper = this;
      if (swiper.params.cssMode) {
        swiper.mousewheel.enable();
      }
      if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
    },
  },
};

const Navigation = {
  update() {
    // Update Navigation Buttons
    const swiper = this;
    const params = swiper.params.navigation;

    if (swiper.params.loop) return;
    const { $nextEl, $prevEl } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        $prevEl.addClass(params.disabledClass);
      } else {
        $prevEl.removeClass(params.disabledClass);
      }
      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        $nextEl.addClass(params.disabledClass);
      } else {
        $nextEl.removeClass(params.disabledClass);
      }
      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  onPrevClick(e) {
    const swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick(e) {
    const swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init() {
    const swiper = this;
    const params = swiper.params.navigation;
    if (!(params.nextEl || params.prevEl)) return;

    let $nextEl;
    let $prevEl;
    if (params.nextEl) {
      $nextEl = $(params.nextEl);
      if (
        swiper.params.uniqueNavElements
        && typeof params.nextEl === 'string'
        && $nextEl.length > 1
        && swiper.$el.find(params.nextEl).length === 1
      ) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }
    if (params.prevEl) {
      $prevEl = $(params.prevEl);
      if (
        swiper.params.uniqueNavElements
        && typeof params.prevEl === 'string'
        && $prevEl.length > 1
        && swiper.$el.find(params.prevEl).length === 1
      ) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }
    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    Utils.extend(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0],
    });
  },
  destroy() {
    const swiper = this;
    const { $nextEl, $prevEl } = swiper.navigation;
    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }
    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  },
};

var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,

      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      navigation: {
        init: Navigation.init.bind(swiper),
        update: Navigation.update.bind(swiper),
        destroy: Navigation.destroy.bind(swiper),
        onNextClick: Navigation.onNextClick.bind(swiper),
        onPrevClick: Navigation.onPrevClick.bind(swiper),
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge() {
      const swiper = this;
      swiper.navigation.update();
    },
    fromEdge() {
      const swiper = this;
      swiper.navigation.update();
    },
    destroy() {
      const swiper = this;
      swiper.navigation.destroy();
    },
    click(e) {
      const swiper = this;
      const { $nextEl, $prevEl } = swiper.navigation;
      if (
        swiper.params.navigation.hideOnClick
        && !$(e.target).is($prevEl)
        && !$(e.target).is($nextEl)
      ) {
        let isHidden;
        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }
        if (isHidden === true) {
          swiper.emit('navigationShow', swiper);
        } else {
          swiper.emit('navigationHide', swiper);
        }
        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    },
  },
};

const Pagination = {
  update() {
    // Render || Update Pagination bullets/items
    const swiper = this;
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    // Current/Total
    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
      if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
        current -= (slidesLength - (swiper.loopedSlides * 2));
      }
      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)}px`);
        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
          if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }
        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.removeClass(`${params.bulletActiveClass} ${params.bulletActiveClass}-next ${params.bulletActiveClass}-next-next ${params.bulletActiveClass}-prev ${params.bulletActiveClass}-prev-prev ${params.bulletActiveClass}-main`);
      if ($el.length > 1) {
        bullets.each((index, bullet) => {
          const $bullet = $(bullet);
          const bulletIndex = $bullet.index();
          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }
            if (bulletIndex === firstIndex) {
              $bullet
                .prev()
                .addClass(`${params.bulletActiveClass}-prev`)
                .prev()
                .addClass(`${params.bulletActiveClass}-prev-prev`);
            }
            if (bulletIndex === lastIndex) {
              $bullet
                .next()
                .addClass(`${params.bulletActiveClass}-next`)
                .next()
                .addClass(`${params.bulletActiveClass}-next-next`);
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);
        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }
          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }
              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              $firstDisplayedBullet
                .prev()
                .addClass(`${params.bulletActiveClass}-prev`)
                .prev()
                .addClass(`${params.bulletActiveClass}-prev-prev`);
              $lastDisplayedBullet
                .next()
                .addClass(`${params.bulletActiveClass}-next`)
                .next()
                .addClass(`${params.bulletActiveClass}-next-next`);
            }
          } else {
            $firstDisplayedBullet
              .prev()
              .addClass(`${params.bulletActiveClass}-prev`)
              .prev()
              .addClass(`${params.bulletActiveClass}-prev-prev`);
            $lastDisplayedBullet
              .next()
              .addClass(`${params.bulletActiveClass}-next`)
              .next()
              .addClass(`${params.bulletActiveClass}-next-next`);
          }
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
        const offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
      }
    }
    if (params.type === 'fraction') {
      $el.find(`.${params.currentClass}`).text(params.formatFractionCurrent(current + 1));
      $el.find(`.${params.totalClass}`).text(params.formatFractionTotal(total));
    }
    if (params.type === 'progressbar') {
      let progressbarDirection;
      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }
      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;
      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }
      $el.find(`.${params.progressbarFillClass}`).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }
    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', swiper, $el[0]);
    } else {
      swiper.emit('paginationUpdate', swiper, $el[0]);
    }
    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  },
  render() {
    // Render Container
    const swiper = this;
    const params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

    const $el = swiper.pagination.$el;
    let paginationHTML = '';
    if (params.type === 'bullets') {
      const numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(`.${params.bulletClass}`);
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>`
        + ' / '
        + `<span class="${params.totalClass}"></span>`;
      }
      $el.html(paginationHTML);
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
      $el.html(paginationHTML);
    }
    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init() {
    const swiper = this;
    const params = swiper.params.pagination;
    if (!params.el) return;

    let $el = $(params.el);
    if ($el.length === 0) return;

    if (
      swiper.params.uniqueNavElements
      && typeof params.el === 'string'
      && $el.length > 1
    ) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      swiper.pagination.dynamicBulletIndex = 0;
      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }
    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', `.${params.bulletClass}`, function onClick(e) {
        e.preventDefault();
        let index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Utils.extend(swiper.pagination, {
      $el,
      el: $el[0],
    });
  },
  destroy() {
    const swiper = this;
    const params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    const $el = swiper.pagination.$el;

    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
    if (params.clickable) {
      $el.off('click', `.${params.bulletClass}`);
    }
  },
};

var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: (number) => number,
      formatFractionTotal: (number) => number,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-', // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable', // NEW
      lockClass: 'swiper-pagination-lock',
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      pagination: {
        init: Pagination.init.bind(swiper),
        render: Pagination.render.bind(swiper),
        update: Pagination.update.bind(swiper),
        destroy: Pagination.destroy.bind(swiper),
        dynamicBulletIndex: 0,
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange() {
      const swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange() {
      const swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange() {
      const swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange() {
      const swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy() {
      const swiper = this;
      swiper.pagination.destroy();
    },
    click(e) {
      const swiper = this;
      if (
        swiper.params.pagination.el
        && swiper.params.pagination.hideOnClick
        && swiper.pagination.$el.length > 0
        && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
      ) {
        const isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
        if (isHidden === true) {
          swiper.emit('paginationShow', swiper);
        } else {
          swiper.emit('paginationHide', swiper);
        }
        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    },
  },
};

const Scrollbar = {
  setTranslate() {
    const swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const { scrollbar, rtlTranslate: rtl, progress } = swiper;
    const {
      dragSize, trackSize, $dragEl, $el,
    } = scrollbar;
    const params = swiper.params.scrollbar;

    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
      $dragEl[0].style.width = `${newSize}px`;
    } else {
      $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
      $dragEl[0].style.height = `${newSize}px`;
    }
    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition(duration) {
    const swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize() {
    const swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;

    const { scrollbar } = swiper;
    const { $dragEl, $el } = scrollbar;

    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    const trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

    const divider = swiper.size / swiper.virtualSize;
    const moveDivider = divider * (trackSize / swiper.size);
    let dragSize;
    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = `${dragSize}px`;
    } else {
      $dragEl[0].style.height = `${dragSize}px`;
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }
    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }
    Utils.extend(scrollbar, {
      trackSize,
      divider,
      moveDivider,
      dragSize,
    });
    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
  },
  getPointerPosition(e) {
    const swiper = this;
    if (swiper.isHorizontal()) {
      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientX : e.clientX);
    }
    return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientY : e.clientY);
  },
  setDragPosition(e) {
    const swiper = this;
    const { scrollbar, rtlTranslate: rtl } = swiper;
    const {
      $el,
      dragSize,
      trackSize,
      dragStartPos,
    } = scrollbar;

    let positionRatio;
    positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
      - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    const position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart(e) {
    const swiper = this;
    const params = swiper.params.scrollbar;
    const { scrollbar, $wrapperEl } = swiper;
    const { $el, $dragEl } = scrollbar;
    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
      ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();

    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);

    clearTimeout(swiper.scrollbar.dragTimeout);

    $el.transition(0);
    if (params.hide) {
      $el.css('opacity', 1);
    }
    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }
    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove(e) {
    const swiper = this;
    const { scrollbar, $wrapperEl } = swiper;
    const { $el, $dragEl } = scrollbar;

    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();
    else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd(e) {
    const swiper = this;

    const params = swiper.params.scrollbar;
    const { scrollbar, $wrapperEl } = swiper;
    const { $el } = scrollbar;

    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;
    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }
    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = Utils.nextTick(() => {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }
    swiper.emit('scrollbarDragEnd', e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable() {
    const swiper = this;
    if (!swiper.params.scrollbar.el) return;
    const {
      scrollbar, touchEventsTouch, touchEventsDesktop, params,
    } = swiper;
    const $el = scrollbar.$el;
    const target = $el[0];
    const activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
    const passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
    if (!Support.touch) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  disableDraggable() {
    const swiper = this;
    if (!swiper.params.scrollbar.el) return;
    const {
      scrollbar, touchEventsTouch, touchEventsDesktop, params,
    } = swiper;
    const $el = scrollbar.$el;
    const target = $el[0];
    const activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
    const passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
    if (!Support.touch) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  init() {
    const swiper = this;
    if (!swiper.params.scrollbar.el) return;
    const { scrollbar, $el: $swiperEl } = swiper;
    const params = swiper.params.scrollbar;

    let $el = $(params.el);
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
    if ($dragEl.length === 0) {
      $dragEl = $(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
      $el.append($dragEl);
    }

    Utils.extend(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0],
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }
  },
  destroy() {
    const swiper = this;
    swiper.scrollbar.disableDraggable();
  },
};

var Scrollbar$1 = {
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      scrollbar: {
        init: Scrollbar.init.bind(swiper),
        destroy: Scrollbar.destroy.bind(swiper),
        updateSize: Scrollbar.updateSize.bind(swiper),
        setTranslate: Scrollbar.setTranslate.bind(swiper),
        setTransition: Scrollbar.setTransition.bind(swiper),
        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
        getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
        onDragStart: Scrollbar.onDragStart.bind(swiper),
        onDragMove: Scrollbar.onDragMove.bind(swiper),
        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
        isTouched: false,
        timeout: null,
        dragTimeout: null,
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update() {
      const swiper = this;
      swiper.scrollbar.updateSize();
    },
    resize() {
      const swiper = this;
      swiper.scrollbar.updateSize();
    },
    observerUpdate() {
      const swiper = this;
      swiper.scrollbar.updateSize();
    },
    setTranslate() {
      const swiper = this;
      swiper.scrollbar.setTranslate();
    },
    setTransition(duration) {
      const swiper = this;
      swiper.scrollbar.setTransition(duration);
    },
    destroy() {
      const swiper = this;
      swiper.scrollbar.destroy();
    },
  },
};

const Parallax = {
  setTransform(el, progress) {
    const swiper = this;
    const { rtl } = swiper;

    const $el = $(el);
    const rtlFactor = rtl ? -1 : 1;

    const p = $el.attr('data-swiper-parallax') || '0';
    let x = $el.attr('data-swiper-parallax-x');
    let y = $el.attr('data-swiper-parallax-y');
    const scale = $el.attr('data-swiper-parallax-scale');
    const opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if ((x).indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }
    if ((y).indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
      $el[0].style.opacity = currentOpacity;
    }
    if (typeof scale === 'undefined' || scale === null) {
      $el.transform(`translate3d(${x}, ${y}, 0px)`);
    } else {
      const currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
      $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
    }
  },
  setTranslate() {
    const swiper = this;
    const {
      $el, slides, progress, snapGrid,
    } = swiper;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
      .each((index, el) => {
        swiper.parallax.setTransform(el, progress);
      });
    slides.each((slideIndex, slideEl) => {
      let slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each((index, el) => {
          swiper.parallax.setTransform(el, slideProgress);
        });
    });
  },
  setTransition(duration = this.params.speed) {
    const swiper = this;
    const { $el } = swiper;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
      .each((index, parallaxEl) => {
        const $parallaxEl = $(parallaxEl);
        let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
        if (duration === 0) parallaxDuration = 0;
        $parallaxEl.transition(parallaxDuration);
      });
  },
};

var Parallax$1 = {
  name: 'parallax',
  params: {
    parallax: {
      enabled: false,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      parallax: {
        setTransform: Parallax.setTransform.bind(swiper),
        setTranslate: Parallax.setTranslate.bind(swiper),
        setTransition: Parallax.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit() {
      const swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    init() {
      const swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTranslate() {
      const swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTransition(duration) {
      const swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTransition(duration);
    },
  },
};

const Zoom = {
  // Calc Scale From Multi-touches
  getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    const x1 = e.targetTouches[0].pageX;
    const y1 = e.targetTouches[0].pageY;
    const x2 = e.targetTouches[1].pageX;
    const y2 = e.targetTouches[1].pageY;
    const distance = Math.sqrt(((x2 - x1) ** 2) + ((y2 - y1) ** 2));
    return distance;
  },
  // Events
  onGestureStart(e) {
    const swiper = this;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const { gesture } = zoom;
    zoom.fakeGestureTouched = false;
    zoom.fakeGestureMoved = false;
    if (!Support.gestures) {
      if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
        return;
      }
      zoom.fakeGestureTouched = true;
      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }
    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }
    swiper.zoom.isScaling = true;
  },
  onGestureChange(e) {
    const swiper = this;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const { gesture } = zoom;
    if (!Support.gestures) {
      if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
        return;
      }
      zoom.fakeGestureMoved = true;
      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (Support.gestures) {
      zoom.scale = e.scale * zoom.currentScale;
    } else {
      zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
    }
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = (gesture.maxRatio - 1) + (((zoom.scale - gesture.maxRatio) + 1) ** 0.5);
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = (params.minRatio + 1) - (((params.minRatio - zoom.scale) + 1) ** 0.5);
    }
    gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  },
  onGestureEnd(e) {
    const swiper = this;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const { gesture } = zoom;
    if (!Support.gestures) {
      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
        return;
      }
      if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
        return;
      }
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    zoom.currentScale = zoom.scale;
    zoom.isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  },
  onTouchStart(e) {
    const swiper = this;
    const zoom = swiper.zoom;
    const { gesture, image } = zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (Device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  },
  onTouchMove(e) {
    const swiper = this;
    const zoom = swiper.zoom;
    const { gesture, image, velocity } = zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
      if (swiper.rtl) {
        image.startX = -image.startX;
        image.startY = -image.startY;
      }
    }
    // Define if we need image drag
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;

    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;

    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
    image.maxX = -image.minX;
    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
    image.maxY = -image.minY;

    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !zoom.isScaling) {
      if (
        swiper.isHorizontal()
        && (
          (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
          || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
        )
      ) {
        image.isTouched = false;
        return;
      } if (
        !swiper.isHorizontal()
        && (
          (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
          || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
        )
      ) {
        image.isTouched = false;
        return;
      }
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    e.stopPropagation();

    image.isMoved = true;
    image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
    image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = (image.minX + 1) - (((image.minX - image.currentX) + 1) ** 0.8);
    }
    if (image.currentX > image.maxX) {
      image.currentX = (image.maxX - 1) + (((image.currentX - image.maxX) + 1) ** 0.8);
    }

    if (image.currentY < image.minY) {
      image.currentY = (image.minY + 1) - (((image.minY - image.currentY) + 1) ** 0.8);
    }
    if (image.currentY > image.maxY) {
      image.currentY = (image.maxY - 1) + (((image.currentY - image.maxY) + 1) ** 0.8);
    }

    // Velocity
    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();

    gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  },
  onTouchEnd() {
    const swiper = this;
    const zoom = swiper.zoom;
    const { gesture, image, velocity } = zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY;

    // Fix duration
    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);

    image.currentX = newPositionX;
    image.currentY = newPositionY;

    // Define if we need image drag
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
    image.maxX = -image.minX;
    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

    gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  },
  onTransitionEnd() {
    const swiper = this;
    const zoom = swiper.zoom;
    const { gesture } = zoom;
    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }
      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      zoom.currentScale = 1;

      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  },
  // Toggle Zoom
  toggle(e) {
    const swiper = this;
    const zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoom.out();
    } else {
      // Zoom In
      zoom.in(e);
    }
  },
  in(e) {
    const swiper = this;

    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    const { gesture, image } = zoom;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);

    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left;
      offsetY = gesture.$slideEl.offset().top;
      diffX = (offsetX + (slideWidth / 2)) - touchX;
      diffY = (offsetY + (slideHeight / 2)) - touchY;

      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;

      translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
      translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;

      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
    gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  },
  out() {
    const swiper = this;

    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    const { gesture } = zoom;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    zoom.scale = 1;
    zoom.currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
    gesture.$slideEl = undefined;
  },
  // Attach/Detach Events
  enable() {
    const swiper = this;
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;

    const passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
    const activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;

    const slideSelector = `.${swiper.params.slideClass}`;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.on('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
      }
    }

    // Move image
    swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, zoom.onTouchMove, activeListenerWithCapture);
  },
  disable() {
    const swiper = this;
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;

    swiper.zoom.enabled = false;

    const passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
    const activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;

    const slideSelector = `.${swiper.params.slideClass}`;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.off('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
      }
    }

    // Move image
    swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, zoom.onTouchMove, activeListenerWithCapture);
  },
};

var Zoom$1 = {
  name: 'zoom',
  params: {
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed',
    },
  },
  create() {
    const swiper = this;
    const zoom = {
      enabled: false,
      scale: 1,
      currentScale: 1,
      isScaling: false,
      gesture: {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3,
      },
      image: {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {},
      },
      velocity: {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined,
      },
    };

    ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach((methodName) => {
      zoom[methodName] = Zoom[methodName].bind(swiper);
    });
    Utils.extend(swiper, {
      zoom,
    });

    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
      get() {
        return scale;
      },
      set(value) {
        if (scale !== value) {
          const imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
          const slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
          swiper.emit('zoomChange', value, imageEl, slideEl);
        }
        scale = value;
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      if (swiper.params.zoom.enabled) {
        swiper.zoom.enable();
      }
    },
    destroy() {
      const swiper = this;
      swiper.zoom.disable();
    },
    touchStart(e) {
      const swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchStart(e);
    },
    touchEnd(e) {
      const swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchEnd(e);
    },
    doubleTap(e) {
      const swiper = this;
      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
        swiper.zoom.toggle(e);
      }
    },
    transitionEnd() {
      const swiper = this;
      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
        swiper.zoom.onTransitionEnd();
      }
    },
    slideChange() {
      const swiper = this;
      if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
        swiper.zoom.onTransitionEnd();
      }
    },
  },
};

const Lazy = {
  loadInSlide(index, loadInDuplicate = true) {
    const swiper = this;
    const params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

    const $slideEl = isVirtual
      ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`)
      : swiper.slides.eq(index);

    let $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images = $images.add($slideEl[0]);
    }
    if ($images.length === 0) return;

    $images.each((imageIndex, imageEl) => {
      const $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);

      const background = $imageEl.attr('data-background');
      const src = $imageEl.attr('data-src');
      const srcset = $imageEl.attr('data-srcset');
      const sizes = $imageEl.attr('data-sizes');
      const $pictureEl = $imageEl.parent('picture');

      swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, () => {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) return;
        if (background) {
          $imageEl.css('background-image', `url("${background}")`);
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }
          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }
          if ($pictureEl.length) {
            $pictureEl.children('source').each((sourceIndex, sourceEl) => {
              const $source = $(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }
          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(`.${params.preloaderClass}`).remove();
        if (swiper.params.loop && loadInDuplicate) {
          const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
            swiper.lazy.loadInSlide(originalSlide.index(), false);
          } else {
            const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
          }
        }
        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });

      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  },
  load() {
    const swiper = this;
    const {
      $wrapperEl, params: swiperParams, slides, activeIndex,
    } = swiper;
    const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    const params = swiperParams.lazy;

    let slidesPerView = swiperParams.slidesPerView;
    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
          return true;
        }
      } else if (slides[index]) return true;
      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return $(slideEl).attr('data-swiper-slide-index');
      }
      return $(slideEl).index();
    }

    if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
    if (swiper.params.watchSlidesVisibility) {
      $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((elIndex, slideEl) => {
        const index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
        swiper.lazy.loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) swiper.lazy.loadInSlide(i);
      }
    } else {
      swiper.lazy.loadInSlide(activeIndex);
    }
    if (params.loadPrevNext) {
      if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
        const amount = params.loadPrevNextAmount;
        const spv = slidesPerView;
        const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
        // Next Slides
        for (let i = activeIndex + slidesPerView; i < maxIndex; i += 1) {
          if (slideExist(i)) swiper.lazy.loadInSlide(i);
        }
        // Prev Slides
        for (let i = minIndex; i < activeIndex; i += 1) {
          if (slideExist(i)) swiper.lazy.loadInSlide(i);
        }
      } else {
        const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
        if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));

        const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
        if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
      }
    }
  },
};

var Lazy$1 = {
  name: 'lazy',
  params: {
    lazy: {
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,

      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader',
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      lazy: {
        initialImageLoaded: false,
        load: Lazy.load.bind(swiper),
        loadInSlide: Lazy.loadInSlide.bind(swiper),
      },
    });
  },
  on: {
    beforeInit() {
      const swiper = this;
      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    },
    init() {
      const swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
        swiper.lazy.load();
      }
    },
    scroll() {
      const swiper = this;
      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
        swiper.lazy.load();
      }
    },
    resize() {
      const swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    scrollbarDragMove() {
      const swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    transitionStart() {
      const swiper = this;
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
          swiper.lazy.load();
        }
      }
    },
    transitionEnd() {
      const swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
        swiper.lazy.load();
      }
    },
    slideChange() {
      const swiper = this;
      if (swiper.params.lazy.enabled && swiper.params.cssMode) {
        swiper.lazy.load();
      }
    },
  },
};

/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

const Controller = {
  LinearSpline: function LinearSpline(x, y) {
    const binarySearch = (function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }());
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    let i1;
    let i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
    };
    return this;
  },
  // xxx: for now i will just save one spline function to to
  getInterpolateFunction(c) {
    const swiper = this;
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop
        ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
        : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  },
  setTranslate(setTranslate, byController) {
    const swiper = this;
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        swiper.controller.getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  },
  setTransition(duration, byController) {
    const swiper = this;
    const controlled = swiper.controller.control;
    let i;
    function setControlledTransition(c) {
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          Utils.nextTick(() => {
            c.updateAutoHeight();
          });
        }
        c.$wrapperEl.transitionEnd(() => {
          if (!controlled) return;
          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  },
};
var Controller$1 = {
  name: 'controller',
  params: {
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide', // or 'container'
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      controller: {
        control: swiper.params.controller.control,
        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
        setTranslate: Controller.setTranslate.bind(swiper),
        setTransition: Controller.setTransition.bind(swiper),
      },
    });
  },
  on: {
    update() {
      const swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    resize() {
      const swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    observerUpdate() {
      const swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    setTranslate(translate, byController) {
      const swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTranslate(translate, byController);
    },
    setTransition(duration, byController) {
      const swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTransition(duration, byController);
    },
  },
};

const a11y = {
  makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
    return $el;
  },
  addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterKey(e) {
    const swiper = this;
    const params = swiper.params.a11y;
    if (e.keyCode !== 13) return;
    const $targetEl = $(e.target);
    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }
      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }
    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }
      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }
    if (swiper.pagination && $targetEl.is(`.${swiper.params.pagination.bulletClass}`)) {
      $targetEl[0].click();
    }
  },
  notify(message) {
    const swiper = this;
    const notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation() {
    const swiper = this;

    if (swiper.params.loop || !swiper.navigation) return;
    const { $nextEl, $prevEl } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
        swiper.a11y.makeElNotFocusable($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
        swiper.a11y.makeElFocusable($prevEl);
      }
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
        swiper.a11y.makeElNotFocusable($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
        swiper.a11y.makeElFocusable($nextEl);
      }
    }
  },
  updatePagination() {
    const swiper = this;
    const params = swiper.params.a11y;
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each((bulletIndex, bulletEl) => {
        const $bulletEl = $(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);
        swiper.a11y.addElRole($bulletEl, 'button');
        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
      });
    }
  },
  init() {
    const swiper = this;

    swiper.$el.append(swiper.a11y.liveRegion);

    // Navigation
    const params = swiper.params.a11y;
    let $nextEl;
    let $prevEl;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      swiper.a11y.makeElFocusable($nextEl);
      swiper.a11y.addElRole($nextEl, 'button');
      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      $nextEl.on('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      swiper.a11y.makeElFocusable($prevEl);
      swiper.a11y.addElRole($prevEl, 'button');
      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      $prevEl.on('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', `.${swiper.params.pagination.bulletClass}`, swiper.a11y.onEnterKey);
    }
  },
  destroy() {
    const swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();

    let $nextEl;
    let $prevEl;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', `.${swiper.params.pagination.bulletClass}`, swiper.a11y.onEnterKey);
    }
  },
};
var A11y = {
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      a11y: {
        liveRegion: $(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`),
      },
    });
    Object.keys(a11y).forEach((methodName) => {
      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
    });
  },
  on: {
    init() {
      const swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge() {
      const swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge() {
      const swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate() {
      const swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy() {
      const swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    },
  },
};

const History = {
  init() {
    const swiper = this;
    if (!swiper.params.history) return;
    if (!win.history || !win.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    const history = swiper.history;
    history.initialized = true;
    history.paths = History.getPathValues();
    if (!history.paths.key && !history.paths.value) return;
    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      win.addEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  destroy() {
    const swiper = this;
    if (!swiper.params.history.replaceState) {
      win.removeEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  setHistoryPopState() {
    const swiper = this;
    swiper.history.paths = History.getPathValues();
    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
  },
  getPathValues() {
    const pathArray = win.location.pathname.slice(1).split('/').filter((part) => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return { key, value };
  },
  setHistory(key, index) {
    const swiper = this;
    if (!swiper.history.initialized || !swiper.params.history.enabled) return;
    const slide = swiper.slides.eq(index);
    let value = History.slugify(slide.attr('data-history'));
    if (!win.location.pathname.includes(key)) {
      value = `${key}/${value}`;
    }
    const currentState = win.history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      win.history.replaceState({ value }, null, value);
    } else {
      win.history.pushState({ value }, null, value);
    }
  },
  slugify(text) {
    return text.toString()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  },
  scrollToSlide(speed, value, runCallbacks) {
    const swiper = this;
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHistory = History.slugify(slide.attr('data-history'));
        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  },
};

var History$1 = {
  name: 'history',
  params: {
    history: {
      enabled: false,
      replaceState: false,
      key: 'slides',
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      history: {
        init: History.init.bind(swiper),
        setHistory: History.setHistory.bind(swiper),
        setHistoryPopState: History.setHistoryPopState.bind(swiper),
        scrollToSlide: History.scrollToSlide.bind(swiper),
        destroy: History.destroy.bind(swiper),
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.init();
      }
    },
    destroy() {
      const swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.destroy();
      }
    },
    transitionEnd() {
      const swiper = this;
      if (swiper.history.initialized) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    },
    slideChange() {
      const swiper = this;
      if (swiper.history.initialized && swiper.params.cssMode) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    },
  },
};

const HashNavigation = {
  onHashCange() {
    const swiper = this;
    swiper.emit('hashChange');
    const newHash = doc.location.hash.replace('#', '');
    const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
    if (newHash !== activeSlideHash) {
      const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  },
  setHash() {
    const swiper = this;
    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
    if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
      win.history.replaceState(null, null, (`#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || ''));
      swiper.emit('hashSet');
    } else {
      const slide = swiper.slides.eq(swiper.activeIndex);
      const hash = slide.attr('data-hash') || slide.attr('data-history');
      doc.location.hash = hash || '';
      swiper.emit('hashSet');
    }
  },
  init() {
    const swiper = this;
    if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) return;
    swiper.hashNavigation.initialized = true;
    const hash = doc.location.hash.replace('#', '');
    if (hash) {
      const speed = 0;
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHash = slide.attr('data-hash') || slide.attr('data-history');
        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }
    if (swiper.params.hashNavigation.watchState) {
      $(win).on('hashchange', swiper.hashNavigation.onHashCange);
    }
  },
  destroy() {
    const swiper = this;
    if (swiper.params.hashNavigation.watchState) {
      $(win).off('hashchange', swiper.hashNavigation.onHashCange);
    }
  },
};
var HashNavigation$1 = {
  name: 'hash-navigation',
  params: {
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      hashNavigation: {
        initialized: false,
        init: HashNavigation.init.bind(swiper),
        destroy: HashNavigation.destroy.bind(swiper),
        setHash: HashNavigation.setHash.bind(swiper),
        onHashCange: HashNavigation.onHashCange.bind(swiper),
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.init();
      }
    },
    destroy() {
      const swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.destroy();
      }
    },
    transitionEnd() {
      const swiper = this;
      if (swiper.hashNavigation.initialized) {
        swiper.hashNavigation.setHash();
      }
    },
    slideChange() {
      const swiper = this;
      if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
        swiper.hashNavigation.setHash();
      }
    },
  },
};

/* eslint no-underscore-dangle: "off" */

const Autoplay = {
  run() {
    const swiper = this;
    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;
    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }
    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = Utils.nextTick(() => {
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }
      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
    }, delay);
  },
  start() {
    const swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop() {
    const swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }
    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause(speed) {
    const swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;
    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
    }
  },
};

var Autoplay$1 = {
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      autoplay: {
        running: false,
        paused: false,
        run: Autoplay.run.bind(swiper),
        start: Autoplay.start.bind(swiper),
        stop: Autoplay.stop.bind(swiper),
        pause: Autoplay.pause.bind(swiper),
        onVisibilityChange() {
          if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
            swiper.autoplay.pause();
          }
          if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            swiper.autoplay.run();
            swiper.autoplay.paused = false;
          }
        },
        onTransitionEnd(e) {
          if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
          swiper.autoplay.paused = false;
          if (!swiper.autoplay.running) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.run();
          }
        },
      },
    });
  },
  on: {
    init() {
      const swiper = this;
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
      }
    },
    beforeTransitionStart(speed, internal) {
      const swiper = this;
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove() {
      const swiper = this;
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    touchEnd() {
      const swiper = this;
      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.run();
      }
    },
    destroy() {
      const swiper = this;
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
    },
  },
};

const Fade = {
  setTranslate() {
    const swiper = this;
    const { slides } = swiper;
    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = swiper.slides.eq(i);
      const offset = $slideEl[0].swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      const slideOpacity = swiper.params.fadeEffect.crossFade
        ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
        : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl
        .css({
          opacity: slideOpacity,
        })
        .transform(`translate3d(${tx}px, ${ty}px, 0px)`);
    }
  },
  setTransition(duration) {
    const swiper = this;
    const { slides, $wrapperEl } = swiper;
    slides.transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      let eventTriggered = false;
      slides.transitionEnd(() => {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (let i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  },
};

var EffectFade = {
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      fadeEffect: {
        setTranslate: Fade.setTranslate.bind(swiper),
        setTransition: Fade.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit() {
      const swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push(`${swiper.params.containerModifierClass}fade`);
      const overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true,
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate() {
      const swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition(duration) {
      const swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    },
  },
};

const Cube = {
  setTranslate() {
    const swiper = this;
    const {
      $el, $wrapperEl, slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize,
    } = swiper;
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let $cubeShadowEl;
    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }
        $cubeShadowEl.css({ height: `${swiperWidth}px` });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }
    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }
      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + (round * 4 * swiperSize);
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = (3 * swiperSize) + (swiperSize * 4 * round);
      }
      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
      if (progress <= 1 && progress > -1) {
        wrapperRotate = (slideIndex * 90) + (progress * 90);
        if (rtl) wrapperRotate = (-slideIndex * 90) - (progress * 90);
      }
      $slideEl.transform(transform);
      if (params.slideShadows) {
        // Set shadows
        let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
    }
    $wrapperEl.css({
      '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
      '-moz-transform-origin': `50% 50% -${swiperSize / 2}px`,
      '-ms-transform-origin': `50% 50% -${swiperSize / 2}px`,
      'transform-origin': `50% 50% -${swiperSize / 2}px`,
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform(`translate3d(0px, ${(swiperWidth / 2) + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
        const multiplier = 1.5 - (
          (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
          + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
        );
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${(swiperHeight / 2) + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
      }
    }
    const zFactor = (Browser.isSafari || Browser.isWebView) ? (-swiperSize / 2) : 0;
    $wrapperEl
      .transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
  },
  setTransition(duration) {
    const swiper = this;
    const { $el, slides } = swiper;
    slides
      .transition(duration)
      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
      .transition(duration);
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  },
};

var EffectCube = {
  name: 'effect-cube',
  params: {
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      cubeEffect: {
        setTranslate: Cube.setTranslate.bind(swiper),
        setTransition: Cube.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit() {
      const swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.classNames.push(`${swiper.params.containerModifierClass}cube`);
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
      const overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        resistanceRatio: 0,
        spaceBetween: 0,
        centeredSlides: false,
        virtualTranslate: true,
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate() {
      const swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTranslate();
    },
    setTransition(duration) {
      const swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTransition(duration);
    },
  },
};

const Flip = {
  setTranslate() {
    const swiper = this;
    const { slides, rtlTranslate: rtl } = swiper;
    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let progress = $slideEl[0].progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }
      const offset = $slideEl[0].swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = -offset;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (swiper.params.flipEffect.slideShadows) {
        // Set shadows
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = $(`<div class="swiper-slide-shadow-${swiper.isHorizontal() ? 'left' : 'top'}"></div>`);
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = $(`<div class="swiper-slide-shadow-${swiper.isHorizontal() ? 'right' : 'bottom'}"></div>`);
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
      $slideEl
        .transform(`translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`);
    }
  },
  setTransition(duration) {
    const swiper = this;
    const { slides, activeIndex, $wrapperEl } = swiper;
    slides
      .transition(duration)
      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
      .transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      let eventTriggered = false;
      // eslint-disable-next-line
      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
        eventTriggered = true;
        swiper.animating = false;
        const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (let i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  },
};

var EffectFlip = {
  name: 'effect-flip',
  params: {
    flipEffect: {
      slideShadows: true,
      limitRotation: true,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      flipEffect: {
        setTranslate: Flip.setTranslate.bind(swiper),
        setTransition: Flip.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit() {
      const swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.classNames.push(`${swiper.params.containerModifierClass}flip`);
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
      const overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true,
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate() {
      const swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTranslate();
    },
    setTransition(duration) {
      const swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTransition(duration);
    },
  },
};

const Coverflow = {
  setTranslate() {
    const swiper = this;
    const {
      width: swiperWidth, height: swiperHeight, slides, $wrapperEl, slidesSizesGrid,
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth;
    // Each slide offset from center
    for (let i = 0, length = slides.length; i < length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideSize = slidesSizesGrid[i];
      const slideOffset = $slideEl[0].swiperSlideOffset;
      const offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      // var rotateZ = 0
      let translateZ = -translate * Math.abs(offsetMultiplier);

      let stretch = params.stretch;
      // Allow percentage to make a relative stretch for responsive sliders
      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = ((parseFloat(params.stretch) / 100) * slideSize);
      }
      let translateY = isHorizontal ? 0 : stretch * (offsetMultiplier);
      let translateX = isHorizontal ? stretch * (offsetMultiplier) : 0;

      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;

      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;

      $slideEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        // Set shadows
        let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
          $slideEl.append($shadowBeforeEl);
        }
        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
          $slideEl.append($shadowAfterEl);
        }
        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
      }
    }

    // Set correct perspective for IE10
    if (Support.pointerEvents || Support.prefixedPointerEvents) {
      const ws = $wrapperEl[0].style;
      ws.perspectiveOrigin = `${center}px 50%`;
    }
  },
  setTransition(duration) {
    const swiper = this;
    swiper.slides
      .transition(duration)
      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
      .transition(duration);
  },
};

var EffectCoverflow = {
  name: 'effect-coverflow',
  params: {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true,
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      coverflowEffect: {
        setTranslate: Coverflow.setTranslate.bind(swiper),
        setTransition: Coverflow.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit() {
      const swiper = this;
      if (swiper.params.effect !== 'coverflow') return;

      swiper.classNames.push(`${swiper.params.containerModifierClass}coverflow`);
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);

      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    setTranslate() {
      const swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTranslate();
    },
    setTransition(duration) {
      const swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTransition(duration);
    },
  },
};

const Thumbs = {
  init() {
    const swiper = this;
    const { thumbs: thumbsParams } = swiper.params;
    const SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Utils.extend(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false,
      });
      Utils.extend(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false,
      });
    } else if (Utils.isObject(thumbsParams.swiper)) {
      swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: false,
      }));
      swiper.thumbs.swiperCreated = true;
    }
    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
  },
  onThumbClick() {
    const swiper = this;
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      let currentIndex = swiper.activeIndex;
      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }
      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
      else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
      else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
      else slideToIndex = prevIndex;
    }
    swiper.slideTo(slideToIndex);
  },
  update(initial) {
    const swiper = this;
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;

    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
      ? thumbsSwiper.slidesPerViewDynamic()
      : thumbsSwiper.params.slidesPerView;

    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      let currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;
      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix();
          // eslint-disable-next-line
          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        }
        // Find actual thumbs index to slide to
        const prevThumbsIndex = thumbsSwiper.slides
          .eq(currentThumbsIndex)
          .prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0)
          .index();
        const nextThumbsIndex = thumbsSwiper.slides
          .eq(currentThumbsIndex)
          .nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0)
          .index();
        if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
        else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
        else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;
        else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
        else newThumbsIndex = prevThumbsIndex;
        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }
      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex) {
          newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }
        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }

    // Activate thumbs
    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);

    thumbsSwiper.slides.removeClass(thumbActiveClass);
    if (thumbsSwiper.params.loop || (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
      }
    }
  },
};
var Thumbs$1 = {
  name: 'thumbs',
  params: {
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-container-thumbs',
    },
  },
  create() {
    const swiper = this;
    Utils.extend(swiper, {
      thumbs: {
        swiper: null,
        init: Thumbs.init.bind(swiper),
        update: Thumbs.update.bind(swiper),
        onThumbClick: Thumbs.onThumbClick.bind(swiper),
      },
    });
  },
  on: {
    beforeInit() {
      const swiper = this;
      const { thumbs } = swiper.params;
      if (!thumbs || !thumbs.swiper) return;
      swiper.thumbs.init();
      swiper.thumbs.update(true);
    },
    slideChange() {
      const swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    update() {
      const swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    resize() {
      const swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    observerUpdate() {
      const swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    setTransition(duration) {
      const swiper = this;
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      thumbsSwiper.setTransition(duration);
    },
    beforeDestroy() {
      const swiper = this;
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
        thumbsSwiper.destroy();
      }
    },
  },
};

// Swiper Class

const components = [
  Device$1,
  Support$1,
  Browser$1,
  Resize,
  Observer$1,
  Virtual$1,
  Keyboard$1,
  Mousewheel$1,
  Navigation$1,
  Pagination$1,
  Scrollbar$1,
  Parallax$1,
  Zoom$1,
  Lazy$1,
  Controller$1,
  A11y,
  History$1,
  HashNavigation$1,
  Autoplay$1,
  EffectFade,
  EffectCube,
  EffectFlip,
  EffectCoverflow,
  Thumbs$1
];

if (typeof Swiper.use === 'undefined') {
  Swiper.use = Swiper.Class.use;
  Swiper.installModule = Swiper.Class.installModule;
}

Swiper.use(components);

/* harmony default export */ var swiper_esm_bundle = (Swiper);
//# sourceMappingURL=swiper.esm.bundle.js.map


/***/ }),

/***/ 70655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CR": function() { return /* binding */ __read; },
/* harmony export */   "XA": function() { return /* binding */ __values; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "fl": function() { return /* binding */ __spread; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 66006:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _PlayerStates = __webpack_require__(22275);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),

/***/ 89125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _debug = __webpack_require__(11227);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(28255);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(65279);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(66006);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports["default"] = YouTubePlayer;
module.exports = exports['default'];

/***/ }),

/***/ 22275:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),

/***/ 65279:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports["default"] = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),

/***/ 28255:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports["default"] = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),

/***/ 11062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(33988);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(55900);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(89125);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports["default"] = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),

/***/ 55900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _loadScript = __webpack_require__(49090);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 86854:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 53416:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x0": function() { return /* binding */ nanoid; }
/* harmony export */ });
/* unused harmony exports customAlphabet, customRandom, random */

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)
  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)
let nanoid = (size = 21) => {
  let id = ''
  let bytes = crypto.getRandomValues(new Uint8Array(size))
  while (size--) {
    let byte = bytes[size] & 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte < 63) {
      id += '_'
    } else {
      id += '-'
    }
  }
  return id
}



/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 59499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 36864:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 37247:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 81531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90607);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 72179:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _possibleConstructorReturn; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(14027);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (helpers_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

/***/ }),

/***/ 90607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 46576:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _wrapNativeSuper; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(90607);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/***/ }),

/***/ 24829:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"360Spider(-Image|-Video)?","name":"360Spider","category":"Search bot","url":"https://www.so.com/help/help_3_2.html","producer":{"name":"Online Media Group, Inc.","url":""}},{"regex":"Aboundex","name":"Aboundexbot","category":"Search bot","url":"http://www.aboundex.com/crawler/","producer":{"name":"Aboundex.com","url":"http://www.aboundex.com"}},{"regex":"AcoonBot","name":"Acoon","category":"Search bot","url":"http://www.acoon.de/robot.asp","producer":{"name":"Acoon GmbH","url":"http://www.acoon.de"}},{"regex":"AddThis\\\\.com","name":"AddThis.com","category":"Social Media Agent","url":"","producer":{"name":"Clearspring Technologies, Inc.","url":"http://www.clearspring.com"}},{"regex":"AhrefsBot","name":"aHrefs Bot","category":"Crawler","url":"https://ahrefs.com/robot","producer":{"name":"Ahrefs Pte Ltd","url":"https://ahrefs.com/robot"}},{"regex":"ia_archiver|alexabot|verifybot","name":"Alexa Crawler","category":"Search bot","url":"https://support.alexa.com/hc/en-us/sections/200100794-Crawlers","producer":{"name":"Alexa Internet","url":"https://www.alexa.com"}},{"regex":"alexa site audit","name":"Alexa Site Audit","category":"Site Monitor","url":"https://support.alexa.com/hc/en-us/articles/200450194","producer":{"name":"Alexa Internet","url":"https://www.alexa.com"}},{"regex":"Amazon[ -]Route ?53[ -]Health[ -]Check[ -]Service","name":"Amazon Route53 Health Check","category":"Service Agent","producer":{"name":"Amazon Web Services","url":"https://aws.amazon.com/"}},{"regex":"AmorankSpider","name":"Amorank Spider","category":"Crawler","url":"http://amorank.com/webcrawler.html","producer":{"name":"Amorank","url":"http://www.amorank.com"}},{"regex":"ApacheBench","name":"ApacheBench","category":"Benchmark","url":"https://httpd.apache.org/docs/2.4/programs/ab.html","producer":{"name":"The Apache Software Foundation","url":"https://www.apache.org/foundation/"}},{"regex":"Applebot","name":"Applebot","category":"Crawler","url":"https://support.apple.com/en-us/HT204683","producer":{"name":"Apple Inc","url":"https://www.apple.com"}},{"regex":"AppSignalBot","name":"AppSignalBot","category":"Site Monitor","url":"https://docs.appsignal.com/uptime-monitoring/","producer":{"name":"AppSignal","url":"https://appsignal.com/"}},{"regex":"Arachni","name":"Arachni","category":"Security Checker","url":"https://www.arachni-scanner.com/","producer":{"name":"Sarosys LLC","url":"https://www.sarosys.com/"}},{"regex":"AspiegelBot","name":"AspiegelBot","category":"Crawler","url":"https://aspiegel.com/","producer":{"name":"Huawei","url":"https://www.huawei.com/"}},{"regex":"Castro 2, Episode Duration Lookup","name":"Castro 2","category":"Service Agent","url":"http://supertop.co/castro/","producer":{"name":"Supertop","url":"http://supertop.co"}},{"regex":"Curious George","name":"Analytics SEO Crawler","category":"Crawler","url":"http://www.analyticsseo.com/crawler","producer":{"name":"Analytics SEO","url":"http://www.analyticsseo.com"}},{"regex":"archive\\\\.org_bot|special_archiver","name":"archive.org bot","category":"Crawler","url":"https://archive.org/details/archive.org_bot","producer":{"name":"The Internet Archive","url":"https://archive.org"}},{"regex":"Ask Jeeves/Teoma","name":"Ask Jeeves","category":"Search bot","url":"","producer":{"name":"Ask Jeeves Inc.","url":"http://www.ask.com"}},{"regex":"Backlink-Check\\\\.de","name":"Backlink-Check.de","category":"Crawler","url":"http://www.backlink-check.de/bot.html","producer":{"name":"Mediagreen Medienservice","url":"http://www.backlink-check.de"}},{"regex":"BacklinkCrawler","name":"BacklinkCrawler","category":"Crawler","url":"http://www.backlinktest.com/crawler.html","producer":{"name":"2.0Promotion GbR","url":"http://www.backlinktest.com"}},{"regex":"baiduspider(-image)?|baidu Transcoder|baidu.*spider","name":"Baidu Spider","category":"Search bot","url":"http://www.baidu.com/search/spider.htm","producer":{"name":"Baidu","url":"http://www.baidu.com"}},{"regex":"BazQux","name":"BazQux Reader","url":"https://bazqux.com/fetcher","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"MSNBot|msrbot|bingbot|BingPreview|msnbot-(UDiscovery|NewsBlogs)|adidxbot","name":"BingBot","category":"Search bot","url":"http://search.msn.com/msnbot.htmn","producer":{"name":"Microsoft Corporation","url":"http://www.microsoft.com"}},{"regex":"Blekkobot","name":"Blekkobot","category":"Search bot","url":"http://blekko.com/about/blekkobot","producer":{"name":"Blekko","url":"http://blekko.com"}},{"regex":"BLEXBot(Test)?","name":"BLEXBot Crawler","category":"Crawler","url":"http://webmeup-crawler.com","producer":{"name":"WebMeUp","url":"http://webmeup.com"}},{"regex":"Bloglovin","name":"Bloglovin","url":"http://www.bloglovin.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"Blogtrottr","name":"Blogtrottr","url":"","category":"Feed Fetcher","producer":{"name":"Blogtrottr Ltd","url":"https://blogtrottr.com/"}},{"regex":"BoardReader Blog Indexer","name":"BoardReader Blog Indexer","category":"Crawler","producer":{"name":"BoardReader","url":"https://boardreader.com/"}},{"regex":"BountiiBot","name":"Bountii Bot","category":"Search bot","url":"http://bountii.com/contact.php","producer":{"name":"Bountii Inc.","url":"http://bountii.com"}},{"regex":"Browsershots","name":"Browsershots","category":"Service Agent","url":"http://browsershots.org/faq","producer":{"name":"Browsershots.org","url":"http://browsershots.org"}},{"regex":"BUbiNG","name":"BUbiNG","category":"Crawler","url":"http://law.di.unimi.it/BUbiNG.html","producer":{"name":"The Laboratory for Web Algorithmics (LAW)","url":"http://law.di.unimi.it/software.php#buging"}},{"regex":"(?<!HTC)[ _]Butterfly/","name":"Butterfly Robot","category":"Search bot","url":"http://labs.topsy.com/butterfly","producer":{"name":"Topsy Labs","url":"http://labs.topsy.com"}},{"regex":"CareerBot","name":"CareerBot","category":"Crawler","url":"http://www.career-x.de/bot.html","producer":{"name":"career-x GmbH","url":"http://www.career-x.de"}},{"regex":"CCBot","name":"ccBot crawler","category":"Crawler","url":"http://commoncrawl.org/faq/","producer":{"name":"reddit inc.","url":"http://www.reddit.com"}},{"regex":"Cliqzbot","name":"Cliqzbot","category":"Crawler","url":"http://cliqz.com/company/cliqzbot","producer":{"name":"10betterpages GmbH","url":"http://cliqz.com"}},{"regex":"Cloudflare-AMP","name":"CloudFlare AMP Fetcher","category":"Crawler","url":"https://amp.cloudflare.com/doc/fetcher.html","producer":{"name":"CloudFlare","url":"http://www.cloudflare.com"}},{"regex":"CloudflareDiagnostics","name":"Cloudflare Diagnostics","category":"Site Monitor","url":"https://www.cloudflare.com/","producer":{"name":"Cloudflare","url":"https://www.cloudflare.com"}},{"regex":"CloudFlare-AlwaysOnline","name":"CloudFlare Always Online","category":"Site Monitor","url":"http://www.cloudflare.com/always-online","producer":{"name":"CloudFlare","url":"http://www.cloudflare.com"}},{"regex":"coccoc.com","name":"Cốc Cốc Bot","url":"https://help.coccoc.com/en/search-engine/coccoc-robots","category":"Search bot","producer":{"name":"Cốc Cốc","url":"https://coccoc.com/"}},{"regex":"collectd","name":"Collectd","url":"https://collectd.org/","category":"Site Monitor","producer":{"name":"Collectd","url":"https://collectd.org/"}},{"regex":"CommaFeed","name":"CommaFeed","url":"http://www.commafeed.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"CSS Certificate Spider","name":"CSS Certificate Spider","category":"Crawler","url":"http://www.css-security.com/certificatespider/","producer":{"name":"Certified Security Solutions","url":"https://www.css-security.com/company/about-us/"}},{"regex":"Datadog Agent","name":"Datadog Agent","url":"https://github.com/DataDog/dd-agent","category":"Site Monitor","producer":{"name":"Datadog","url":"https://www.datadoghq.com/"}},{"regex":"Datanyze","name":"Datanyze","url":"","category":"Crawler","producer":{"name":"Datanyze","url":"https://www.datanyze.com"}},{"regex":"Dataprovider","name":"Dataprovider","category":"Crawler","url":"","producer":{"name":"Dataprovider B.V.","url":"https://www.dataprovider.com/"}},{"regex":"Daum(oa)?[ /][0-9]","name":"Daum","category":"Search bot","url":"http://tab.search.daum.net/aboutWebSearch_en.html","producer":{"name":"Daum Communications Corp.","url":"http://www.kakaocorp.com/main"}},{"regex":"Dazoobot","name":"Dazoobot","category":"Search bot","url":"","producer":{"name":"DAZOO.FR","url":"http://dazoo.fr"}},{"regex":"discobot(-news)?","name":"Discobot","category":"Search bot","url":"http://discoveryengine.com/discobot.html","producer":{"name":"Discovery Engine","url":"http://discoveryengine.com"}},{"regex":"Domain Re-Animator Bot|support@domainreanimator.com","name":"Domain Re-Animator Bot","category":"Crawler","url":"","producer":{"name":"Domain Re-Animator, LLC","url":"http://domainreanimator.com"}},{"regex":"DotBot","name":"DotBot","category":"Crawler","url":"http://www.opensiteexplorer.org/dotbot","producer":{"name":"SEOmoz, Inc.","url":"http://moz.com/"}},{"regex":"DuckDuck(?:Go-Favicons-)?Bot","name":"DuckDuckGo Bot","category":"Search bot","url":"https://duckduckgo.com/duckduckbot","producer":{"name":"DuckDuckGo","url":"https://duckduckgo.com/"}},{"regex":"EasouSpider","name":"Easou Spider","category":"Search bot","url":"http://www.easou.com/search/spider.html","producer":{"name":"easou ICP","url":"http://www.easou.com"}},{"regex":"eCairn-Grabber","name":"eCairn-Grabber","category":"Crawler","producer":{"name":"eCairn","url":"https://ecairn.com"}},{"regex":"EMail Exractor","name":"EMail Exractor","category":"Crawler","url":"","producer":{"name":"","url":""}},{"regex":"evc-batch","name":"evc-batch","category":"Crawler","url":"","producer":{"name":"eVenture Capital Partners II, LLC","url":"http://www.eventures.vc/"}},{"regex":"Exabot(-Thumbnails|-Images)?|ExaleadCloudview","name":"ExaBot","category":"Crawler","url":"http://www.exabot.com/go/robot","producer":{"name":"Dassault Systèmes","url":"http://www.3ds.com"}},{"regex":"ExactSeek Crawler","name":"ExactSeek Crawler","category":"Search bot","url":"http://www.exactseek.com","producer":{"name":"Jayde Online, Inc.","url":"http://www.jaydeonlineinc.com"}},{"regex":"Ezooms","name":"Ezooms","category":"Crawler","url":"","producer":{"name":"SEOmoz, Inc.","url":"http://moz.com/"}},{"regex":"facebookexternalhit|facebookplatform|facebookexternalua","name":"Facebook External Hit","category":"Social Media Agent","url":"https://www.facebook.com/externalhit_uatext.php","producer":{"name":"Facebook","url":"http://www.facebook.com"}},{"regex":"Feedbin","name":"Feedbin","url":"http://feedbin.com/","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"FeedBurner","name":"FeedBurner","url":"http://www.feedburner.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"Feed Wrangler","name":"Feed Wrangler","url":"https://feedwrangler.net/","category":"Feed Fetcher","producer":{"name":"David Smith & Developing Perspective, LLC","url":"https://david-smith.org"}},{"regex":"(Meta)?Feedly(Bot|App)?","name":"Feedly","url":"http://www.feedly.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"Feedspot","name":"Feedspot","url":"http://www.feedspot.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"Fever/[0-9]","name":"Fever","url":"http://feedafever.com/","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"FlipboardProxy|FlipboardRSS","name":"Flipboard","url":"http://flipboard.com/browserproxy","category":"Feed Fetcher","producer":{"name":"Flipboard","url":"http://flipboard.com/"}},{"regex":"Findxbot","name":"Findxbot","category":"Crawler","url":"http://www.findxbot.com"},{"regex":"FreshRSS","name":"FreshRSS","category":"Feed Fetcher","url":"https://freshrss.org/"},{"regex":"Genieo","name":"Genieo Web filter","category":"","url":"http://www.genieo.com/webfilter.html","producer":{"name":"Genieo","url":"http://www.genieo.com"}},{"regex":"GigablastOpenSource","name":"Gigablast","category":"Search bot","url":"https://github.com/gigablast/open-source-search-engine","producer":{"name":"Matt Wells","url":"http://www.gigablast.com/faq.html"}},{"regex":"Gluten Free Crawler","name":"Gluten Free Crawler","category":"Crawler","url":"http://glutenfreepleasure.com/","producer":{"name":"","url":""}},{"regex":"ichiro/mobile goo","name":"Goo","category":"Search bot","url":"http://search.goo.ne.jp/option/use/sub4/sub4-1","producer":{"name":"NTT Resonant","url":"http://goo.ne.jp"}},{"regex":"Google Favicon","name":"Google Favicon","category":"Crawler"},{"regex":"Google Search Console","name":"Google Search Console","category":"Crawler","url":"https://search.google.com/search-console/about","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"Google Page Speed Insights","name":"Google PageSpeed Insights","category":"Site Monitor","url":"http://developers.google.com/speed/pagespeed/insights/","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"google_partner_monitoring","name":"Google Partner Monitoring","category":"Site Monitor","url":"","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"Google-Cloud-Scheduler","name":"Google Cloud Scheduler","category":"Crawler","url":"https://cloud.google.com/scheduler","producer":{"name":"Google Inc.","url":"https://www.google.com"}},{"regex":"Google-Structured-Data-Testing-Tool","name":"Google Structured Data Testing Tool","category":"Validator","url":"https://search.google.com/structured-data/testing-tool","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"GoogleStackdriverMonitoring","name":"Google Stackdriver Monitoring","category":"Site Monitor","url":"https://cloud.google.com/monitoring","producer":{"name":"Google Inc.","url":"https://www.google.com"}},{"regex":"via ggpht\\\\.com GoogleImageProxy","name":"Gmail Image Proxy","category":"Crawler","url":"","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"SeznamEmailProxy","name":"Seznam Email Proxy","category":"Crawler","url":"","producer":{"name":"Seznam.cz, a.s.","url":"http://www.seznam.cz/"}},{"regex":"Seznam-Zbozi-robot","name":"Seznam Zbozi.cz","category":"Crawler","url":"","producer":{"name":"Seznam.cz, a.s.","url":"https://www.zbozi.cz/"}},{"regex":"Heurekabot-Feed","name":"Heureka Feed","category":"Crawler","url":"https://sluzby.heureka.cz/napoveda/heurekabot/","producer":{"name":"Heureka.cz, a.s.","url":"https://www.heureka.cz/"}},{"regex":"ShopAlike","name":"ShopAlike","category":"Crawler","url":"","producer":{"name":"Visual Meta","url":"https://www.shopalike.cz/"}},{"regex":"AdsBot-Google(-Mobile)?|Adwords-(DisplayAds|Express|Instant)|Google Web Preview|Google[ -]Publisher[ -]Plugin|Google-(Ads-Qualify|Adwords|AMPHTML|Assess|HotelAdsVerifier|Read-Aloud|Shopping-Quality|Site-Verification|speakr|Test|Youtube-Links)|(APIs|DuplexWeb|Feedfetcher|Mediapartners)-Google|Googlebot(-Mobile|-Image|-Video|-News)?|GoogleProducer|Google.*/\\\\+/web/snippet","name":"Googlebot","category":"Search bot","url":"http://www.google.com/bot.html","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"heritrix","name":"Heritrix","category":"Crawler","url":"https://webarchive.jira.com/wiki/display/Heritrix/Heritrix","producer":{"name":"The Internet Archive","url":"https://archive.org"}},{"regex":"HubSpot ","name":"HubSpot","category":"Crawler","producer":{"name":"HubSpot Inc.","url":"https://www.hubspot.com"}},{"regex":"HTTPMon","name":"HTTPMon","category":"Site Monitor","url":"http://www.httpmon.com","producer":{"name":"towards GmbH","url":"http://www.towards.ch/"}},{"regex":"ICC-Crawler","name":"ICC-Crawler","category":"Crawler","url":"http://www.nict.go.jp/en/univ-com/plan/crawl.html","producer":{"name":"","url":""}},{"regex":"inoreader.com","name":"inoreader","category":"Feed Reader","url":"https://www.inoreader.com"},{"regex":"iisbot","name":"IIS Site Analysis","category":"Crawler","url":"http://www.iis.net/iisbot.html","producer":{"name":"Microsoft Corporation","url":"http://www.microsoft.com"}},{"regex":"ips-agent","name":"IPS Agent","category":"Crawler","producer":{"name":"VeriSign, Inc","url":"http://www.verisign.com/"}},{"regex":"IP-Guide\\\\.com","name":"IP-Guide Crawler","category":"Crawler","url":"","producer":{"name":"","url":"https://ip-guide.com"}},{"regex":"kouio","name":"Kouio","url":"http://kouio.com/","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"larbin","name":"Larbin web crawler","category":"Crawler","url":"http://larbin.sourceforge.net","producer":{"name":"","url":""}},{"regex":"([A-z0-9]*)-Lighthouse","name":"Lighthouse","category":"Site Monitor","url":"https://developers.google.com/web/tools/lighthouse","producer":{"name":"Lighthouse","url":"https://developers.google.com/web/tools/lighthouse"}},{"regex":"linkdexbot(-mobile)?|linkdex\\\\.com","name":"Linkdex Bot","category":"Search bot","url":"http://www.linkdex.com/bots","producer":{"name":"Mojeek Ltd.","url":"http://www.mojeek.com"}},{"regex":"LinkedInBot","name":"LinkedIn Bot","category":"Social Media Agent","url":"http://www.linkedin.com","producer":{"name":"LinkedIn","url":"http://www.linkedin.com"}},{"regex":"ltx71","name":"LTX71","url":"http://ltx71.com/","producer":{"name":"","url":""}},{"regex":"Mail\\\\.RU(_Bot)?","name":"Mail.Ru Bot","category":"Search bot","url":"http://help.mail.ru/webmaster/indexing/robots/types_robots","producer":{"name":"Mail.Ru Group","url":"http://corp.mail.ru"}},{"regex":"magpie-crawler","name":"Magpie-Crawler","category":"Social Media Agent","url":"http://www.brandwatch.com/magpie-crawler/","producer":{"name":"Brandwatch","url":"http://www.brandwatch.com"}},{"regex":"MagpieRSS","name":"MagpieRSS","url":"http://magpierss.sourceforge.net/","category":"Feed Parser","producer":{"name":"","url":""}},{"regex":"masscan","name":"masscan","url":"https://github.com/robertdavidgraham/masscan","category":"Crawler","producer":{"name":"Robert Graham","url":"https://github.com/robertdavidgraham"}},{"regex":"Mastodon/","name":"Mastodon Bot","category":"Social Media Agent"},{"regex":"meanpathbot","name":"Meanpath Bot","category":"Search bot","url":"http://www.meanpath.com/meanpathbot.html","producer":{"name":"Meanpath","url":"http://www.meanpath.com"}},{"regex":"MetaJobBot","name":"MetaJobBot","category":"Crawler","url":"http://www.metajob.at/the/crawler","producer":{"name":"MetaJob","url":"http://www.metajob.at"}},{"regex":"MetaInspector","name":"MetaInspector","category":"Crawler","url":"https://github.com/jaimeiniesta/metainspector"},{"regex":"MixrankBot","name":"Mixrank Bot","category":"Crawler","url":"http://mixrank.com","producer":{"name":"Online Media Group, Inc.","url":""}},{"regex":"MJ12bot","name":"MJ12 Bot","category":"Search bot","url":"http://majestic12.co.uk/bot.php","producer":{"name":"Majestic-12","url":"http://majestic12.co.uk"}},{"regex":"Mnogosearch","name":"Mnogosearch","category":"Search bot","url":"http://www.mnogosearch.org/","producer":{"name":"Lavtech.Com Corp.","url":""}},{"regex":"MojeekBot","name":"MojeekBot","category":"Search bot","url":"http://www.mojeek.com/bot.html","producer":{"name":"Mojeek Ltd.","url":"http://www.mojeek.com"}},{"regex":"munin","name":"Munin","category":"Site Monitor","url":"http://munin-monitoring.org/","producer":{"name":"Munin","url":"http://munin-monitoring.org/"}},{"regex":"NalezenCzBot","name":"NalezenCzBot","category":"Crawler","url":"http://www.nalezen.cz/about-crawler","producer":{"name":"Jaroslav Kuboš","url":""}},{"regex":"check_http/v","name":"Nagios check_http","category":"Site Monitor","url":"https://nagios.org","producer":{"name":"Nagios Plugins Development Team","url":"https://nagios.org"}},{"regex":"nbertaupete95\\\\(at\\\\)gmail.com","name":"nbertaupete95","category":"Crawler"},{"regex":"Netcraft( Web Server Survey| SSL Server Survey|SurveyAgent)","name":"Netcraft Survey Bot","category":"Search bot","url":"","producer":{"name":"Netcraft","url":"http://www.netcraft.com"}},{"regex":"netEstate NE Crawler","name":"netEstate","category":"Crawler","url":"http://www.website-datenbank.de/Impressum","producer":{"name":"netEstate GmbH","url":"https://www.netestate.de/en/"}},{"regex":"Netvibes","name":"Netvibes","url":"http://www.netvibes.com/","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"NewsBlur .*(Fetcher|Finder)","name":"NewsBlur","url":"http://www.newsblur.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"NewsGatorOnline","name":"NewsGator","url":"http://www.newsgator.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"nlcrawler","name":"NLCrawler","category":"Crawler","url":"","producer":{"name":"Northern Light","url":"http://northernlight.com"}},{"regex":"Nmap Scripting Engine","name":"Nmap","category":"Security Checker","url":"https://nmap.org/book/nse.html","producer":{"name":"Nmap","url":"https://nmap.org/"}},{"regex":"Nuzzel","name":"Nuzzel","category":"Crawler","producer":{"name":"Nuzzel","url":"https://www.nuzzel.com/"}},{"regex":"Octopus [0-9]","name":"Octopus"},{"regex":"omgili(?:bot)?","name":"Omgili bot","category":"Search bot","url":"http://www.omgili.com/Crawler.html","producer":{"name":"Omgili","url":"http://www.omgili.com"}},{"regex":"OpenindexSpider","name":"Openindex Spider","category":"Search bot","url":"http://www.openindex.io/en/webmasters/spider.html","producer":{"name":"Openindex B.V.","url":"http://www.openindex.io"}},{"regex":"spbot","name":"OpenLinkProfiler","category":"Crawler","url":"http://openlinkprofiler.org/bot","producer":{"name":"Axandra GmbH","url":"http://www.axandra.com"}},{"regex":"OpenWebSpider","name":"OpenWebSpider","category":"Crawler","url":"http://www.openwebspider.org","producer":{"name":"OpenWebSpider Lab","url":"http://lab.openwebspider.org"}},{"regex":"OrangeBot|VoilaBot","name":"Orange Bot","category":"Search bot","url":"http://lemoteur.orange.fr","producer":{"name":"Orange","url":"http://www.orange.fr"}},{"regex":"PaperLiBot","name":"PaperLiBot","category":"Search bot","url":"http://support.paper.li/entries/20023257-what-is-paper-li","producer":{"name":"Smallrivers SA","url":"http://www.paper.li"}},{"regex":"phantomas/","name":"Phantomas","category":"Site Monitor","url":"https://github.com/macbre/phantomas"},{"regex":"phpservermon","name":"PHP Server Monitor","category":"Site Monitor","url":"https://github.com/phpservermon/phpservermon","producer":{"name":"PHP Server Monitor","url":"http://www.phpservermonitor.org/"}},{"regex":"PocketParser","name":"PocketParser","category":"Read-it-later Service","url":"https://getpocket.com/pocketparser_ua","producer":{"name":"Pocket","url":"https://getpocket.com/"}},{"regex":"PritTorrent","name":"PritTorrent","category":"Crawler","url":"https://github.com/astro/prittorrent","producer":{"name":"Bitlove","url":"http://bitlove.org/"}},{"regex":"PRTG Network Monitor","name":"PRTG Network Monitor","category":"Network Monitor","url":"https://www.paessler.com/prtg","producer":{"name":"Paessler AG","url":"https://www.paessler.com"}},{"regex":"psbot(-page)?","name":"Picsearch bot","category":"Search bot","url":"http://www.picsearch.com/bot.html","producer":{"name":"Picsearch","url":"http://www.picsearch.com"}},{"regex":"Pingdom(?:\\\\.com|TMS)","name":"Pingdom Bot","category":"Site Monitor","url":"","producer":{"name":"Pingdom AB","url":"https://www.pingdom.com"}},{"regex":"Quora Link Preview","name":"Quora Link Preview","category":"Crawler","url":"","producer":{"name":"Quora","url":"http://www.quora.com"}},{"regex":"Quora-Bot","name":"Quora Bot","category":"Crawler","url":"","producer":{"name":"Quora","url":"https://www.quora.com/"}},{"regex":"RamblerMail","name":"RamblerMail Image Proxy","category":"Crawler","url":"","producer":{"name":"Rambler&Co","url":"https://rambler-co.ru/"}},{"regex":"QuerySeekerSpider","name":"QuerySeekerSpider","category":"Crawler","url":"http://queryseeker.com/bot.html","producer":{"name":"QueryEye Inc.","url":"http://queryeye.com"}},{"regex":"Qwantify","name":"Qwantify","category":"Crawler","url":"https://www.qwant.com/","producer":{"name":"Qwant Corporation","url":"https://www.qwant.com/"}},{"regex":"Rainmeter","name":"Rainmeter","category":"Crawler","url":"https://www.rainmeter.net"},{"regex":"redditbot","name":"Reddit Bot","category":"Social Media Agent","url":"http://www.reddit.com/feedback","producer":{"name":"reddit inc.","url":"http://www.reddit.com"}},{"regex":"Riddler","name":"Riddler","category":"Security search bot","url":"https://riddler.io/about","producer":{"name":"F-Secure","url":"https://www.f-secure.com"}},{"regex":"rogerbot","name":"Rogerbot","category":"Crawler","url":"http://moz.com/help/pro/what-is-rogerbot-","producer":{"name":"SEOmoz, Inc.","url":"http://moz.com/"}},{"regex":"ROI Hunter","name":"ROI Hunter","category":"Crawler","url":"","producer":{"name":"Roihunter a.s.","url":"http://roihunter.com/"}},{"regex":"SafeDNSBot","name":"SafeDNSBot","category":"Crawler","url":"https://www.safedns.com/searchbot","producer":{"name":"SafeDNS, Inc.","url":"https://www.safedns.com/"}},{"regex":"Scrapy","name":"Scrapy","category":"Crawler","url":"http://scrapy.org"},{"regex":"Screaming Frog SEO Spider","name":"Screaming Frog SEO Spider","category":"Crawler","url":"http://www.screamingfrog.co.uk/seo-spider","producer":{"name":"Screaming Frog Ltd","url":"http://www.screamingfrog.co.uk"}},{"regex":"ScreenerBot","name":"ScreenerBot","category":"Crawler","url":"http://www.screenerbot.com","producer":{"name":"","url":""}},{"regex":"SemrushBot","name":"Semrush Bot","category":"Crawler","url":"http://www.semrush.com/bot.html","producer":{"name":"SEMrush","url":"http://www.semrush.com"}},{"regex":"SensikaBot","name":"Sensika Bot","category":"","url":"","producer":{"name":"Sensika","url":"http://sensika.com"}},{"regex":"SEOENG(World)?Bot","name":"SEOENGBot","category":"Crawler","url":"http://www.seoengine.com/seoengbot.htm","producer":{"name":"SEO Engine","url":"http://www.seoengine.com"}},{"regex":"SEOkicks-Robot","name":"SEOkicks-Robot","category":"Crawler","url":"http://www.seokicks.de/robot.html","producer":{"name":"SEOkicks","url":"https://www.seokicks.de/"}},{"regex":"seoscanners\\\\.net","name":"Seoscanners.net","category":"Crawler","url":""},{"regex":"SkypeUriPreview","name":"Skype URI Preview","category":"Service Agent","url":"","producer":{"name":"Skype Communications S.à.r.l.","url":"https://www.skype.com"}},{"regex":"SeznamBot|SklikBot|Seznam screenshot-generator","name":"Seznam Bot","category":"Search bot","url":"http://www.mapy.cz/cz/seznambot.html","producer":{"name":"Seznam.cz, a.s.","url":"http://www.seznam.cz/"}},{"regex":"shopify-partner-homepage-scraper","name":"Shopify Partner","category":"Crawler","url":"https://www.shopify.com/partners","producer":{"name":"Shopify","url":"https://www.shopify.com/"}},{"regex":"ShopWiki","name":"ShopWiki","category":"Search tools","url":"http://www.shopwiki.com/wiki/Help:Bot","producer":{"name":"ShopWiki Corp.","url":"http://www.shopwiki.com"}},{"regex":"SilverReader","name":"SilverReader","url":"http://silverreader.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"SimplePie","name":"SimplePie","url":"http://www.simplepie.org","category":"Feed Parser","producer":{"name":"","url":""}},{"regex":"SISTRIX Crawler","name":"SISTRIX Crawler","category":"Crawler","url":"http://crawler.sistrix.net","producer":{"name":"SISTRIX GmbH","url":"http://www.sistrix.de"}},{"regex":"compatible; (?:SISTRIX )?Optimizer","name":"SISTRIX Optimizer","category":"Crawler","url":"https://optimizer.sistrix.com","producer":{"name":"SISTRIX GmbH","url":"http://www.sistrix.de"}},{"regex":"SiteSucker","name":"SiteSucker","category":"Crawler","url":"http://ricks-apps.com/osx/sitesucker/"},{"regex":"sixy.ch","name":"Sixy.ch","category":"Site Monitor","url":"http://sixy.ch","producer":{"name":"Manuel Kasper","url":"https://neon1.net/"}},{"regex":"Slackbot|Slack-ImgProxy","name":"Slackbot","category":"Crawler","url":"https://api.slack.com/robots","producer":{"name":"Slack Technologies","url":"http://slack.com"}},{"regex":"(Sogou (web|inst|Pic) spider)|New-Sogou-Spider","name":"Sogou Spider","category":"Search bot","url":"http://www.sogou.com/docs/help/webmasters.htm","producer":{"name":"Sohu, Inc.","url":"http://www.sogou.com"}},{"regex":"Sosospider|Sosoimagespider","name":"Soso Spider","category":"Search bot","url":"http://help.soso.com/webspider.htm","producer":{"name":"Tencent Holdings","url":"http://www.soso.com"}},{"regex":"Sprinklr","name":"Sprinklr","category":"Crawler","url":"","producer":{"name":"Sprinklr, Inc.","url":"https://www.sprinklr.com/"}},{"regex":"sqlmap/","name":"sqlmap","category":"Security Checker","url":"http://sqlmap.org/","producer":{"name":"sqlmap","url":"http://sqlmap.org/"}},{"regex":"SSL Labs","name":"SSL Labs","category":"Validator","url":"https://www.ssllabs.com/about/assessment.html","producer":{"name":"SSL Labs","url":"https://www.ssllabs.com/about/assessment.html"}},{"regex":"StatusCake","name":"StatusCake","category":"Site Monitor","url":"https://www.statuscake.com","producer":{"name":"StatusCake","url":"https://www.statuscake.com"}},{"regex":"Superfeedr bot","name":"Superfeedr Bot","category":"Feed Fetcher","url":"","producer":{"name":"Superfeedr","url":"https://superfeedr.com/"}},{"regex":"Sparkler/[0-9]","name":"Sparkler","category":"Crawler","url":"https://github.com/USCDataScience/sparkler"},{"regex":"Spinn3r","name":"Spinn3r","category":"Crawler","url":"http://spinn3r.com/robot","producer":{"name":"Tailrank Inc","url":"http://spinn3r.com"}},{"regex":"SputnikBot","name":"Sputnik Bot","category":"Crawler","url":""},{"regex":"SputnikFaviconBot","name":"Sputnik Favicon Bot","category":"Crawler","url":""},{"regex":"SputnikImageBot","name":"Sputnik Image Bot","category":"Crawler","url":""},{"regex":"SurveyBot","name":"Survey Bot","category":"Search bot","url":"http://www.domaintools.com/webmasters/surveybot.php","producer":{"name":"Domain Tools","url":"http://www.domaintools.com"}},{"regex":"TarmotGezgin","name":"Tarmot Gezgin","url":"http://www.tarmot.com/gezgin/","category":"Search bot"},{"regex":"TelegramBot","name":"TelegramBot","url":"https://telegram.org/blog/bot-revolution"},{"regex":"TLSProbe","name":"TLSProbe","url":"https://scan.trustnet.venafi.com/","category":"Security search bot","producer":{"name":"Venafi TrustNet","url":"https://www.venafi.com"}},{"regex":"TinEye-bot","name":"TinEye Crawler","category":"Search bot","url":"http://www.tineye.com/crawler.html","producer":{"name":"Idée Inc.","url":"http://ideeinc.com"}},{"regex":"Tiny Tiny RSS","name":"Tiny Tiny RSS","url":"http://tt-rss.org","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"theoldreader.com","name":"theoldreader","category":"Feed Reader","url":"https://theoldreader.com"},{"regex":"trendictionbot","name":"Trendiction Bot","category":"Crawler","url":"http://www.trendiction.de/bot","producer":{"name":"Talkwalker Inc.","url":"http://www.talkwalker.com"}},{"regex":"TurnitinBot","name":"TurnitinBot","category":"Crawler","url":"http://www.turnitin.com/robot/crawlerinfo.html","producer":{"name":"iParadigms, LLC.","url":"http://www.turnitin.com"}},{"regex":"TweetedTimes Bot","name":"TweetedTimes Bot","category":"Crawler","url":"http://tweetedtimes.com","producer":{"name":"TweetedTimes","url":"http://tweetedtimes.com/"}},{"regex":"TweetmemeBot","name":"Tweetmeme Bot","category":"Crawler","url":"http://tweetmeme.com/","producer":{"name":"Mediasift","url":""}},{"regex":"Twingly Recon","name":"Twingly Recon","category":"Crawler","producer":{"name":"Twingly","url":"https://www.twingly.com"}},{"regex":"Twitterbot","name":"Twitterbot","category":"Social Media Agent","url":"https://dev.twitter.com/docs/cards/getting-started","producer":{"name":"Twitter","url":"http://www.twitter.com"}},{"regex":"UniversalFeedParser","name":"UniversalFeedParser","category":"Feed Fetcher","url":"https://github.com/kurtmckee/feedparser","producer":{"name":"Kurt McKee","url":"https://github.com/kurtmckee"}},{"regex":"via secureurl\\\\.fwdcdn\\\\.com","name":"UkrNet Mail Proxy","category":"Crawler","url":"","producer":{"name":"UkrNet Ltd","url":"https://www.ukr.net/"}},{"regex":"Uptimebot","name":"Uptimebot","category":"Site Monitor","url":"https://uptime.com/uptimebot","producer":{"name":"Uptime","url":"https://uptime.com"}},{"regex":"UptimeRobot","name":"Uptime Robot","category":"Site Monitor","url":"","producer":{"name":"Uptime Robot","url":"http://uptimerobot.com"}},{"regex":"URLAppendBot","name":"URLAppendBot","category":"Crawler","url":"http://www.profound.net/urlappendbot.html","producer":{"name":"Profound Networks","url":"http://www.profound.net"}},{"regex":"Vagabondo","name":"Vagabondo","category":"Crawler","url":"","producer":{"name":"WiseGuys","url":"http://www.wise-guys.nl/"}},{"regex":"vkShare; ","name":"VK Share Button","category":"Crawler","url":"http://vk.com/dev/Share","producer":{"name":"VK","url":"http://vk.com/"}},{"regex":"VSMCrawler","name":"Visual Site Mapper Crawler","category":"Crawler","url":"http://www.visualsitemapper.com/crawler","producer":{"name":"Alentum Software Ltd.","url":"http://www.alentum.com"}},{"regex":"Jigsaw","name":"W3C CSS Validator","category":"Validator","url":"http://jigsaw.w3.org/css-validator","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C_I18n-Checker","name":"W3C I18N Checker","category":"Validator","url":"http://validator.w3.org/i18n-checker","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C-checklink","name":"W3C Link Checker","category":"Validator","url":"http://validator.w3.org/checklink","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C_Validator|Validator.nu","name":"W3C Markup Validation Service","category":"Validator","url":"http://validator.w3.org/services","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C-mobileOK","name":"W3C MobileOK Checker","category":"Validator","url":"http://validator.w3.org/mobile","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C_Unicorn","name":"W3C Unified Validator","category":"Validator","url":"http://validator.w3.org/unicorn","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"Wappalyzer","name":"Wappalyzer","url":"https://github.com/AliasIO/Wappalyzer","producer":{"name":"AliasIO","url":"https://github.com/AliasIO"}},{"regex":"PTST/","name":"WebPageTest","category":"Site Monitor","url":"https://www.webpagetest.org"},{"regex":"WeSEE(:Search)?","name":"WeSEE:Search","category":"Search bot","url":"http://www.wesee.com/bot","producer":{"name":"WeSEE Ltd","url":"http://www.wesee.com"}},{"regex":"WebbCrawler","name":"WebbCrawler","category":"Crawler","url":"http://badcheese.com/crawler.html","producer":{"name":"Steve Webb","url":"http://badcheese.com"}},{"regex":"websitepulse[+ ]checker","name":"WebSitePulse","category":"Site Monitor","url":"http://badcheese.com/crawler.html","producer":{"name":"WebSitePulse","url":"http://www.websitepulse.com/"}},{"regex":"WordPress","name":"WordPress","category":"Service Agent","url":"https://wordpress.org/","producer":{"name":"Wordpress.org","url":"https://wordpress.org/"}},{"regex":"Wotbox","name":"Wotbox","category":"Search bot","url":"http://www.wotbox.com/bot/","producer":{"name":"Wotbox","url":"http://www.wotbox.com"}},{"regex":"XenForo","name":"XenForo","category":"Service Agent","url":"https://xenforo.com/","producer":{"name":"XenForo Ltd.","url":"https://xenforo.com/"}},{"regex":"yacybot","name":"YaCy","category":"Search bot","url":"http://yacy.net/bot.html","producer":{"name":"YaCy","url":"http://yacy.net"}},{"regex":"Yahoo! Slurp|Yahoo!-AdCrawler","name":"Yahoo! Slurp","category":"Search bot","url":"http://help.yahoo.com/ysearch/slurp","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":"Yahoo Link Preview|Yahoo:LinkExpander:Slingstone","name":"Yahoo! Link Preview","category":"Crawler","url":"https://help.yahoo.com/kb/mail/yahoo-link-preview-SLN23615.html","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":"YahooMailProxy","name":"Yahoo! Mail Proxy","category":"Service Agent","url":"https://help.yahoo.com/kb/yahoo-mail-proxy-SLN28749.html","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":"YahooCacheSystem","name":"Yahoo! Cache System","category":"Crawler","url":"","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":"Y!J-BRW","name":"Yahoo! Japan BRW","category":"Crawler","url":"https://www.yahoo-help.jp/app/answers/detail/p/595/a_id/42716/~/ウェブページにアクセスするシステムのユーザーエージェントについて","producer":{"name":"Yahoo! Japan Corp.","url":"https://www.yahoo.co.jp/"}},{"regex":"Yandex(SpravBot|ScreenshotBot|MobileBot|AccessibilityBot|ForDomain|Vertis|Market|Catalog|Calendar|Sitelinks|AdNet|Pagechecker|Webmaster|Media|Video|Bot|Images|Antivirus|Direct|Blogs|Favicons|ImageResizer|Verticals|News(links)?|Metrika|\\\\.Gazeta Bot)|YaDirectFetcher|YandexTurbo|YandexTracker|YandexSearchShop|YandexRCA|YandexPartner|YandexOntoDBAPI|YandexOntoDB|YandexMobileScreenShotBot","name":"Yandex Bot","category":"Search bot","url":"http://www.yandex.com/bots","producer":{"name":"Yandex LLC","url":"http://company.yandex.com"}},{"regex":"Yeti|NaverJapan","name":"Yeti/Naverbot","category":"Search bot","url":"http://help.naver.com/robots/","producer":{"name":"Naver","url":"http://www.naver.com"}},{"regex":"YoudaoBot","name":"Youdao Bot","category":"Search bot","url":"http://www.youdao.com/help/webmaster/spider","producer":{"name":"NetEase, Inc.","url":"http://corp.163.com"}},{"regex":"YOURLS v[0-9]","name":"Yourls","category":"Crawler","url":"http://yourls.org"},{"regex":"YRSpider|YYSpider","name":"Yunyun Bot","category":"Search bot","url":"http://www.yunyun.com/SiteInfo.php?r=about","producer":{"name":"YunYun","url":"http://www.yunyun.com"}},{"regex":"zgrab","name":"zgrab","category":"Security Checker","url":"https://github.com/zmap/zgrab"},{"regex":"Zookabot","name":"Zookabot","category":"Crawler","url":"http://zookabot.com","producer":{"name":"Hwacha ApS","url":"http://hwacha.dk"}},{"regex":"ZumBot","name":"ZumBot","category":"Search bot","url":"http://help.zum.com/inquiry","producer":{"name":"ZUM internet","url":"http://www.zuminternet.com/"}},{"regex":"YottaaMonitor","name":"Yottaa Site Monitor","category":"Site Monitor","url":"http://www.yottaa.com/products/site-monitor","producer":{"name":"Yottaa","url":"http://www.yottaa.com/"}},{"regex":"Yahoo Ad monitoring.*yahoo-ad-monitoring-SLN24857.*","name":"Yahoo Gemini","category":"Crawler","url":"https://help.yahoo.com/kb/yahoo-ad-monitoring-SLN24857.html","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":".*Java.*outbrain","name":"Outbrain","category":"Crawler","url":"","producer":{"name":"Outbrain","url":"http://www.outbrain.com/"}},{"regex":"HubPages.*crawlingpolicy","name":"HubPages","category":"Crawler","url":"http://hubpages.com/help/crawlingpolicy","producer":{"name":"HubPages","url":"http://hubpages.com/"}},{"regex":"Pinterest(bot)?/\\\\d\\\\.\\\\d.*www\\\\.pinterest\\\\.com.*","name":"Pinterest","url":"http://www.pinterest.com/bot.html","category":"Crawler","producer":{"name":"Pinterest","url":"http://www.pinterest.com/"}},{"regex":"Site24x7","name":"Site24x7 Website Monitoring","category":"Site Monitor","url":"https://www.site24x7.com/site24x7-faq.html","producer":{"name":"Site24x7","url":"https://www.site24x7.com"}},{"regex":"s~snapchat-proxy","name":"Snapchat Proxy","category":"Crawler","url":"https://www.snapchat.com","producer":{"name":"Snapchat Inc.","url":"https://www.snapchat.com"}},{"regex":"Let\'s Encrypt validation server","name":"Let\'s Encrypt Validation","category":"Service Agent","url":"https://letsencrypt.org/how-it-works/","producer":{"name":"Let\'s Encrypt","url":"https://letsencrypt.org"}},{"regex":"GrapeshotCrawler","name":"Grapeshot","category":"Crawler","url":"https://www.grapeshot.com/crawler","producer":{"name":"Grapeshot","url":"https://www.grapeshot.com"}},{"regex":"www\\\\.monitor\\\\.us","name":"Monitor.Us","category":"Site Monitor","url":"http://www.monitor.us","producer":{"name":"Monitor.Us","url":"http://www.monitor.us"}},{"regex":"Catchpoint( bot)?","name":"Catchpoint","category":"Site Monitor","url":"","producer":{"name":"Catchpoint Systems","url":"http://www.catchpoint.com/"}},{"regex":"bitlybot","name":"BitlyBot","category":"Crawler","url":"https://bitly.com","producer":{"name":"Bitly, Inc.","url":"https://bitly.com"}},{"regex":"Zao/","name":"Zao","category":"Crawler"},{"regex":"lycos","name":"Lycos"},{"regex":"Slurp","name":"Inktomi Slurp"},{"regex":"Speedy Spider","name":"Speedy"},{"regex":"ScoutJet","name":"ScoutJet"},{"regex":"nrsbot|netresearch","name":"NetResearchServer"},{"regex":"scooter","name":"Scooter"},{"regex":"gigabot","name":"Gigabot"},{"regex":"charlotte","name":"Charlotte"},{"regex":"Pompos","name":"Pompos"},{"regex":"ichiro","name":"ichiro"},{"regex":"PagePeeker","name":"PagePeeker"},{"regex":"WebThumbnail","name":"WebThumbnail"},{"regex":"Willow Internet Crawler","name":"Willow Internet Crawler"},{"regex":"EmailWolf","name":"EmailWolf"},{"regex":"NetLyzer FastProbe","name":"NetLyzer FastProbe"},{"regex":"AdMantX.*admantx\\\\.com","name":"ADMantX"},{"regex":"Server Density Service Monitoring.*","name":"Server Density"},{"regex":"RSSRadio \\\\(Push Notification Scanner;support@dorada\\\\.co\\\\.uk\\\\)","name":"RSSRadio Bot"},{"regex":"(A6-Indexer|nuhk|TsolCrawler|Yammybot|Openbot|Gulper Web Bot|grub-client|Download Demon|SearchExpress|Microsoft URL Control|borg|altavista|dataminr.com|tweetedtimes.com|TrendsmapResolver|teoma|blitzbot|oegp|furlbot|http%20client|polybot|htdig|mogimogi|larbin|scrubby|searchsight|seekbot|semanticdiscovery|snappy|vortex(?! Build)|zeal|fast-webcrawler|converacrawler|dataparksearch|findlinks|BrowserMob|HttpMonitor|ThumbShotsBot|URL2PNG|ZooShot|GomezA|Google SketchUp|Read%20Later|RackspaceBot|robots|SeopultContentAnalyzer|7Siters|centuryb.o.t9|InterNaetBoten|EasyBib AutoCite|Bidtellect|tomnomnom/meg)","name":"Generic Bot"},{"regex":"^sentry","name":"Sentry Bot","producer":{"name":"Sentry","url":"https://sentry.io"}},{"regex":"^Spotify","name":"Spotify","producer":{"name":"Spotify","url":"https://www.spotify.com"}},{"regex":"The Knowledge AI","name":"The Knowledge AI","category":"Crawler"},{"regex":"Embedly","name":"Embedly","category":"Crawler","url":"https://support.embed.ly/hc/en-us","producer":{"name":"A Medium, Corp.","url":"https://medium.com/"}},{"regex":"BrandVerity","name":"BrandVerity","category":"Crawler","url":"https://www.brandverity.com/why-is-brandverity-visiting-me","producer":{"name":"BrandVerity, Inc.","url":"https://www.brandverity.com/"}},{"regex":"Kaspersky Lab CFR link resolver","name":"Kaspersky","category":"Security Checker","url":"https://www.kaspersky.com/","producer":{"name":"AO Kaspersky Lab","url":"https://www.kaspersky.com/"}},{"regex":"eZ Publish Link Validator","name":"eZ Publish Link Validator","category":"Crawler","url":"https://ez.no/","producer":{"name":"eZ Systems AS","url":"https://ez.no/"}},{"regex":"woorankreview","name":"WooRank","category":"Search bot","url":"https://www.woorank.com/","producer":{"name":"WooRank sprl","url":"https://www.woorank.com/"}},{"regex":"(Match|LinkCheck) by Siteimprove.com","name":"Siteimprove","category":"Search bot","url":"https://siteimprove.com/","producer":{"name":"Siteimprove GmbH","url":"https://siteimprove.com/"}},{"regex":"CATExplorador","name":"CATExplorador","category":"Search bot","url":"https://fundacio.cat/ca/domini/","producer":{"name":"Fundació puntCAT","url":"https://fundacio.cat/ca/domini/"}},{"regex":"Buck","name":"Buck","category":"Search bot","url":"https://hypefactors.com/","producer":{"name":"Hypefactors A/S","url":"https://hypefactors.com/"}},{"regex":"tracemyfile","name":"TraceMyFile","category":"Search bot","url":"https://www.tracemyfile.com/","producer":{"name":"Idee Inc.","url":"http://ideeinc.com/"}},{"regex":"zelist.ro feed parser","name":"Ze List","url":"https://www.zelist.ro/","category":"Feed Fetcher","producer":{"name":"Treeworks SRL","url":"https://www.tree.ro/"}},{"regex":"weborama-fetcher","name":"Weborama","category":"Search bot","url":"https://weborama.com/","producer":{"name":"Weborama SA","url":"https://weborama.com/"}},{"regex":"BoardReader Favicon Fetcher","name":"BoardReader","category":"Search bot","url":"https://boardreader.com/","producer":{"name":"Effyis Inc","url":"https://boardreader.com/"}},{"regex":"IDG/IT","name":"IDG/IT","category":"Search bot","url":"https://spaziodati.eu/","producer":{"name":"SpazioDati S.r.l.","url":"https://spaziodati.eu/"}},{"regex":"Bytespider","name":"Bytespider","category":"Search bot","url":"https://bytedance.com/","producer":{"name":"ByteDance Ltd.","url":"https://bytedance.com/"}},{"regex":"WikiDo","name":"WikiDo","category":"Search bot","url":"https://www.wikido.com/","producer":{"name":"Fotolitografie Fiorentine di Becchi Antonio s.n.c.","url":"https://www.wikido.com/"}},{"regex":"AwarioSmartBot","name":"Awario","category":"Search bot","url":"https://awario.com/bots.html","producer":{"name":"Awario","url":"https://awario.com/"}},{"regex":"AwarioRssBot","name":"Awario","category":"Feed Fetcher","url":"https://awario.com/bots.html","producer":{"name":"Awario","url":"https://awario.com/"}},{"regex":"oBot","name":"oBot","category":"Search bot","url":"https://www.xforce-security.com/crawler/","producer":{"name":"IBM Germany Research & Development GmbH","url":"https://exchange.xforce.ibmcloud.com/"}},{"regex":"SMTBot","name":"SMTBot","category":"Search bot","url":"https://www.similartech.com/smtbot","producer":{"name":"SimilarTech Ltd.","url":"https://www.similartech.com/"}},{"regex":"LCC","name":"LCC","category":"Search bot","url":"https://corpora.uni-leipzig.de/crawler_faq.html","producer":{"name":"Universität Leipzig","url":"https://www.uni-leipzig.de/"}},{"regex":"Startpagina-Linkchecker","name":"Startpagina Linkchecker","category":"Search bot","url":"https://www.startpagina.nl/linkchecker","producer":{"name":"Startpagina B.V.","url":"https://www.startpagina.nl/"}},{"regex":"GTmetrix","name":"GTmetrix","category":"Crawler","url":"https://gtmetrix.com/","producer":{"name":"Carbon60 Operating Co. Ltd.","url":"https://www.carbon60.com/"}},{"regex":"Nutch","name":"Nutch-based Bot","category":"Crawler","url":"https://nutch.apache.org","producer":{"name":"The Apache Software Foundation","url":"https://www.apache.org/foundation/"}},{"regex":"Seobility","name":"Seobility","category":"Crawler","url":"https://www.seobility.net/en/faq/?category=crawling#!aboutourbot"},{"regex":"Vercelbot","name":"Vercel Bot","category":"Service bot","url":"https://vercel.com"},{"regex":"Grammarly","name":"Grammarly","category":"Service bot","url":"https://www.grammarly.com"},{"regex":"Robozilla","name":"Robozilla","category":"Crawler"},{"regex":"Domains Project","name":"Domains Project","category":"Crawler","url":"https://domainsproject.org"},{"regex":"PetalBot","name":"Petal Bot","category":"Crawler","url":"https://aspiegel.com/petalbot"},{"regex":"SerendeputyBot","name":"Serendeputy Bot","category":"Crawler","url":"https://serendeputy.com/about/serendeputy-bot"},{"regex":"ias-va.*admantx.*service-fetcher","name":"ADmantX Service Fetcher","category":"Service bot","url":"https://www.admantx.com/service-fetcher.html"},{"regex":"SemanticScholarBot","name":"Semantic Scholar Bot","category":"Crawler","url":"https://www.semanticscholar.org/crawler"},{"regex":"VelenPublicWebCrawler","name":"Velen Public Web Crawler","category":"Crawler","url":"https://hunter.io/robot"},{"regex":"Barkrowler","name":"Barkrowler","category":"Crawler","url":"http://www.exensa.com/crawl"},{"regex":"BDCbot","name":"BDCbot","category":"Crawler","url":"https://bigweb.bigdatacorp.com.br/pages/faq.aspx","producer":{"name":"BIG Data Solucoes Em Tecnologia de Informatica LTDA","url":"https://bigdatacorp.com.br/"}},{"regex":"adbeat","name":"Adbeat","category":"Crawler","url":"https://www.adbeat.com/operation_policy","producer":{"name":"PPC Labs LLC","url":"https://www.adbeat.com/"}},{"regex":"BW/(?:(\\\\d+[\\\\.\\\\d]+))","name":"BuiltWith","category":"Crawler","url":"https://builtwith.com/biup","producer":{"name":"BuiltWith Pty Ltd","url":"https://builtwith.com/"}},{"regex":"https://whatis.contentkingapp.com","name":"ContentKing","category":"Site Monitor","url":"https://whatis.contentkingapp.com/","producer":{"name":"ContentKing BV","url":"https://www.contentkingapp.com/"}},{"regex":"MicroAdBot","name":"MicroAdBot","category":"Crawler","url":"https://www.microad.co.jp/","producer":{"name":"MicroAd, Inc.","url":"https://www.microad.co.jp/"}},{"regex":"PingAdmin.Ru","name":"PingAdmin.Ru","category":"Site Monitor","url":"https://ping-admin.ru/"},{"regex":"notifyninja.+monitoring","name":"Notify Ninja","category":"Site Monitor","url":"http://notifyninja.com"},{"regex":"WebDataStats","name":"WebDataStats","category":"Crawler","url":"https://webdatastats.com/policy.html","producer":{"name":"WebTehRazrabotka LLC","url":"https://webdatastats.com/"}},{"regex":"parse.ly scraper","name":"parse.ly","category":"Crawler","url":"https://www.parse.ly/help/integration/crawler","producer":{"name":"Parsely, Inc.","url":"https://www.parse.ly/"}},{"regex":"Nimbostratus-Bot","name":"Nimbostratus Bot","category":"Site Monitor","url":"http://cloudsystemnetworks.com"},{"regex":"HeartRails_Capture/\\\\d","name":"Heart Rails Capture","category":"Service Agent","url":"http://capture.heartrails.com"},{"regex":"Project-Resonance","name":"Project Resonance","category":"Crawler","url":"http://project-resonance.com"},{"regex":"DataXu/\\\\d","name":"DataXu","category":"Service Agent","url":"https://advertising.roku.com/dataxu","producer":{"name":"Roku, Inc.","url":"https://roku.com"}},{"regex":"Cocolyzebot","name":"Cocolyzebot","category":"Crawler","url":"https://cocolyze.com/en/cocolyzebot","producer":{"name":"VSI INNOVATION SAS","url":"https://vsi-innovation.com/"}},{"regex":"veryhip","name":"VeryHip","category":"Crawler","url":"https://veryhip.com/","producer":{"name":"VeryHip","url":"https://veryhip.com/"}},{"regex":"LinkpadBot","name":"LinkpadBot","category":"Crawler","url":"https://www.linkpad.org/","producer":{"name":"Solomono LLC","url":"https://www.linkpad.org/"}},{"regex":"MuscatFerret","name":"MuscatFerret","category":"Crawler","url":"http://www.webtop.com/"},{"regex":"PageThing.com","name":"PageThing","category":"Crawler","url":"https://www.pagething.com/","producer":{"name":"SPECIALNOISE LTD","url":"https://www.specialnoise.com/"}},{"regex":"ArchiveBox","name":"ArchiveBox","url":"https://archivebox.io/","category":"Crawler","producer":{"name":"","url":""}},{"regex":"Choosito","name":"Choosito","url":"https://www.choosito.com/","category":"Crawler","producer":{"name":"Choosito! Inc.","url":"https://www.choosito.com/"}},{"regex":"datagnionbot","name":"datagnionbot","url":"https://www.datagnion.com/bot.html","category":"Crawler","producer":{"name":"DATAGNION GMBH","url":"https://www.datagnion.com/"}},{"regex":"WhatCMS","name":"WhatCMS","url":"https://whatcms.org/","category":"Crawler","producer":{"name":"","url":""}},{"regex":"httpx","name":"httpx","url":"https://github.com/projectdiscovery/httpx","category":"Crawler","producer":{"name":"","url":""}},{"regex":"scaninfo@expanseinc.com","name":"Expanse","category":"Security Checker","url":"https://expanse.co/","producer":{"name":"Expanse Inc.","url":"https://expanse.co/"}},{"regex":"HuaweiWebCatBot","name":"HuaweiWebCatBot","category":"Crawler","url":"https://isecurity.huawei.com","producer":{"name":"Huawei Technologies Co., Ltd.","url":"https://huawei.com"}},{"regex":"Hatena-Favicon","name":"Hatena Favicon","category":"Crawler","url":"https://www.hatena.ne.jp/faq/","producer":{"name":"Hatena Co., Ltd.","url":"https://www.hatena.ne.jp"}},{"regex":"RyowlEngine/(\\\\d+)","name":"Ryowl","category":"Crawler","url":"https://ryowl.org"},{"regex":"OdklBot/(\\\\d+)","name":"Odnoklassniki Bot","category":"Crawler","url":"https://odnoklassniki.ru"},{"regex":"Mediatoolkitbot","name":"Mediatoolkit Bot","category":"Crawler","url":"https://mediatoolkit.com"},{"regex":"ZoominfoBot","name":"ZoominfoBot","category":"Crawler","url":"https://www.zoominfo.com"},{"regex":"WeViKaBot/([\\\\d+\\\\.])","name":"WeViKaBot","category":"Crawler","url":"http://www.wevika.de"},{"regex":"SEOkicks","name":"SEOkicks","category":"Crawler","url":"https://www.seokicks.de/robot.html"},{"regex":"Plukkie/([\\\\d+\\\\.])","name":"Plukkie","category":"Crawler","url":"http://www.botje.com/plukkie.htm"},{"regex":"proximic;","name":"Comscore","category":"Crawler","url":"https://www.comscore.com/Web-Crawler"},{"regex":"SurdotlyBot/([\\\\d+\\\\.])","name":"SurdotlyBot","category":"Crawler","url":"http://sur.ly/bot.html"},{"regex":"Gowikibot/([\\\\d+\\\\.])","name":"Gowikibot","category":"Crawler","url":"http:/www.gowikibot.com"},{"regex":"SabsimBot/([\\\\d+\\\\.])","name":"SabsimBot","category":"Crawler","url":"https://sabsim.com"},{"regex":"LumtelBot/([\\\\d+\\\\.])","name":"LumtelBot","category":"Crawler","url":"https://umtel.com"},{"regex":"PiplBot","name":"PiplBot","category":"Crawler","url":"http://www.pipl.com/bot"},{"regex":"woobot/([\\\\d+\\\\.])","name":"WooRank","category":"Crawler","url":"https://www.woorank.com/bot"},{"regex":"[a-z0-9\\\\-_]*((?<!cu|power[ _]|m[ _])bot(?![ _]TAB|[ _]?5[0-9])|crawler|crawl|checker|archiver|transcoder|spider)([^a-z]|$)","name":"Generic Bot"}]');

/***/ }),

/***/ 27039:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"NetFront","name":"NetFront"},{"regex":"Edge","name":"Edge"},{"regex":"Trident","name":"Trident"},{"regex":"(?<!SmartHu)Blink","name":"Blink"},{"regex":"(?:Apple)?WebKit","name":"WebKit"},{"regex":"Presto","name":"Presto"},{"regex":"Goanna","name":"Goanna"},{"regex":"(?<!like )Gecko","name":"Gecko"},{"regex":"KHTML","name":"KHTML"},{"regex":"NetSurf","name":"NetSurf"},{"regex":"Servo","name":"Servo"},{"regex":"Goanna","name":"Goanna"},{"regex":"Ekioh(?:Flow)?","name":"EkiohFlow"}]');

/***/ }),

/***/ 67759:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"Helio/(\\\\d+[\\\\.\\\\d]+)","name":"Helio","version":"$1","engine":{"default":"Blink"}},{"regex":"7654Browser/(\\\\d+[\\\\.\\\\d]+)","name":"7654 Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Qazweb/(\\\\d+[\\\\.\\\\d]+)","name":"Qazweb","version":"$1","engine":{"default":"Gecko"}},{"regex":"Degdegan/(\\\\d+[\\\\.\\\\d]+)","name":"deg-degan","version":"$1","engine":{"default":"Blink"}},{"regex":"JavaFX/(\\\\d+[\\\\.\\\\d]+)","name":"JavaFX","version":"$1","engine":{"default":"WebKit"}},{"regex":"Chedot/(\\\\d+[\\\\.\\\\d]+)","name":"Chedot","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome/(\\\\d+[\\\\.\\\\d]+) \\\\(Chromium GOST\\\\)","name":"Chromium GOST","version":"$1","engine":{"default":"Blink"}},{"regex":"(?:DeledaoPersonal|DeledaoFamily)/(\\\\d+[\\\\.\\\\d]+)","name":"Deledao","version":"$1","engine":{"default":"Blink"}},{"regex":"HasBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"HasBrowser","version":"$1","engine":{"default":"Blink"}},{"regex":"Byffox/(\\\\d+[\\\\.\\\\d]+)","name":"Byffox","version":"$1","engine":{"default":"Gecko"}},{"regex":"Chrome/(\\\\d+[\\\\.\\\\d]+).+AgentWeb.+UCBrowser","name":"CoolBrowser","version":"$1","engine":{"default":"Blink"}},{"regex":"DotBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"Dot Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"CravingExplorer/(\\\\d+[\\\\.\\\\d]+)","name":"Craving Explorer","version":"$1","engine":{"default":"Blink"}},{"regex":"DeskBrowse/(\\\\d+[\\\\.\\\\d]+)","name":"DeskBrowse","version":"$1"},{"regex":"Lolifox/(\\\\d+[\\\\.\\\\d]+)","name":"Lolifox","version":"$1"},{"regex":"qutebrowser/(\\\\d+[\\\\.\\\\d]+).+Chrome","name":"Qutebrowser","version":"$1","engine":{"default":"Blink"}},{"regex":"qutebrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Qutebrowser","version":"$1"},{"regex":"flast/(\\\\d+[\\\\.\\\\d]+)","name":"Flast","version":"$1","engine":{"default":"Blink"}},{"regex":"PolyBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"PolyBrowser","version":"$1","engine":{"default":"Gecko"}},{"regex":"Chrome.+BriskBard/(\\\\d+[\\\\.\\\\d]+)","name":"BriskBard","version":"$1","engine":{"default":"Blink"}},{"regex":"BriskBard(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"BriskBard","version":"$1"},{"regex":"GinxDroidBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"GinxDroid Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"AviraScout/(\\\\d+[\\\\.\\\\d]+)","name":"Avira Scout","version":"$1","engine":{"default":"Blink"}},{"regex":"VenusBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"Venus Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome.+Otter(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Otter Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Otter(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Otter Browser","version":"$1"},{"regex":"Chrome.+Smooz/(\\\\d+[\\\\.\\\\d]+)","name":"Smooz","version":"$1","engine":{"default":"Blink"}},{"regex":"Smooz/(\\\\d+[\\\\.\\\\d]+)","name":"Smooz","version":"$1"},{"regex":"Cornowser/(\\\\d+[\\\\.\\\\d]+)","name":"Cornowser","version":"$1","engine":{"default":"Blink"}},{"regex":"Orca/(\\\\d+[\\\\.\\\\d]+)","name":"Orca","version":"$1"},{"regex":"Flow/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Flow","version":"$1","engine":{"default":"EkiohFlow"}},{"regex":"Ekioh/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Flow","version":"$1","engine":{"default":"EkiohFlow"}},{"regex":"xStand/(\\\\d+[\\\\.\\\\d]+)","name":"xStand","version":"$1","engine":{"default":"WebKit"}},{"regex":"Biyubi/(\\\\d+[\\\\.\\\\d]+)","name":"Biyubi","version":"$1"},{"regex":"(?:Perfect%20Browser(?:-iPad)?|Perfect(?:BrowserPro)?)/(\\\\d+[\\\\.\\\\d]+)","name":"Perfect Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"Browser/Phantom/V(\\\\d+[\\\\.\\\\d]+)","name":"Phantom Browser","version":"$1"},{"regex":"AwoX(?:/(\\\\d+[\\\\.\\\\d]+))? Browser","name":"AwoX","version":"$1"},{"regex":"Zetakey/(\\\\d+[\\\\.\\\\d]+)","name":"Zetakey","version":"$1","engine":{"default":"WebKit"}},{"regex":"PlayFreeBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"PlayFree Browser","version":"$1"},{"regex":"(?:chimlac_browser|chimlac)/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Chim Lac","version":"$1","engine":{"default":"Blink"}},{"regex":"Odin/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Odin","version":"$1","engine":{"default":"Blink"}},{"regex":"Tbrowser/(\\\\d+[\\\\.\\\\d]+)","name":"T-Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"SFive(?:_Android)?/.+ Chrome/(\\\\d+[\\\\.\\\\d]+)","name":"SFive","version":"$1","engine":{"default":"Blink"}},{"regex":"SFive_IOS/(\\\\d+[\\\\.\\\\d]+)","name":"SFive","version":"$1"},{"regex":"Navigateur web/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Navigateur Web","version":"$1"},{"regex":"Sraf(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Seraphic Sraf","version":"$1","engine":{"default":"Blink"}},{"regex":"SeewoBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Seewo Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"(?:Kode(?:iOS)?/(?:(\\\\d+[\\\\.\\\\d]+))?|TansoDL)","name":"Kode Browser","version":"$1"},{"regex":"UR/(?:(\\\\d+[\\\\.\\\\d]+))","name":"UR Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"OceanHero/([\\\\.\\\\d]+)","name":"OceanHero","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome/.+ SLBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Smart Lenovo Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"SLBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Smart Lenovo Browser","version":"$1"},{"regex":"Browzar","name":"Browzar","version":""},{"regex":"Stargon/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Stargon","version":"$1","engine":{"default":"Blink"}},{"regex":"NFSBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"NFS Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Borealis/(\\\\d+[\\\\.\\\\d]+)","name":"Borealis Navigator","version":"$1"},{"regex":"YoloBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Yolo Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"PHX/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Phoenix Browser","version":"$1"},{"regex":"PrivacyWall/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"PrivacyWall","version":"$1"},{"regex":"Ghostery:?(\\\\d+[\\\\.\\\\d]+)?","name":"Ghostery Privacy Browser","version":"$1"},{"regex":"Firefox/.*(?:Turkcell-)?YaaniBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Yaani Browser","version":"$1","engine":{"default":"Gecko"}},{"regex":"(?:Turkcell-)?YaaniBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Yaani Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"SEB/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Safe Exam Browser","version":"$1"},{"regex":"Colibri/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Colibri","version":"$1"},{"regex":"Xvast/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Xvast","version":"$1"},{"regex":"TungstenBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Tungsten","version":"$1"},{"regex":"Lulumi-browser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Lulumi","version":"$1"},{"regex":"ybrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Yahoo! Japan Browser","version":"$1"},{"regex":"iLunascapeLite/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Lunascape Lite","version":"$1"},{"regex":"Polypane/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Polypane","version":"$1"},{"regex":"OhHaiBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"OhHai Browser","version":"$1"},{"regex":"Sizzy/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Sizzy","version":"$1"},{"regex":"GlassBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Glass Browser","version":"$1"},{"regex":"ToGate/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"ToGate","version":"$1"},{"regex":"AirWatch Browser v(?:(\\\\d+[\\\\.\\\\d]+))?","name":"VMware AirWatch","version":"$1"},{"regex":"ADG/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"AOL Desktop","version":"$1"},{"regex":"Elements Browser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Elements Browser","version":"$1"},{"regex":"Light/(\\\\d+[\\\\.\\\\d]+)","name":"Light","version":"$1"},{"regex":"Valve Steam GameOverlay/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Steam In-Game Overlay","version":"$1"},{"regex":"115Browser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"115 Browser","version":"$1"},{"regex":"Atom/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Atom","version":"$1"},{"regex":"Mobile VR.+Firefox","name":"Firefox Reality","version":""},{"regex":"AVG(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"AVG Secure Browser","version":"$1"},{"regex":"Start/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"START Internet Browser","version":"$1"},{"regex":"Lovense(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Lovense Browser","version":"$1"},{"regex":"com.airfind.deltabrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Delta Browser","version":"$1"},{"regex":"(?:Ordissimo|webissimo3)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Ordissimo","version":"$1"},{"regex":"CCleaner(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"CCleaner","version":"$1"},{"regex":"AlohaLite(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Aloha Browser Lite","version":"$1","engine":{"default":"Blink"}},{"regex":"TaoBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Tao Browser","version":"$1"},{"regex":"Falkon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Falkon","version":"$1"},{"regex":"mCent(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"mCent","version":"$1"},{"regex":"SalamWeb(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"SalamWeb","version":"$1"},{"regex":"BlackHawk(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"BlackHawk","version":"$1"},{"regex":"Minimo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Minimo","version":"$1"},{"regex":"WIB(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Wear Internet Browser","version":"$1"},{"regex":"Origyn Web Browser","name":"Origyn Web Browser","version":""},{"regex":"Kinza(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Kinza","version":"$1"},{"regex":"Beamrise(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Beamrise","version":"$1"},{"regex":"Faux(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Faux Browser","version":"$1"},{"regex":"splash Version(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Splash","version":"$1"},{"regex":"MZBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Meizu Browser","version":"$1"},{"regex":"COSBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"COS Browser","version":"$1"},{"regex":"Crusta(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Crusta","version":"$1"},{"regex":"Hawk/TurboBrowser(?:/v?(\\\\d+[\\\\.\\\\d]+))?","name":"Hawk Turbo Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"FreeU(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"FreeU","version":"$1","engine":{"default":"Blink"}},{"regex":"NoxBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Nox Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Basilisk(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Basilisk","version":"$1","engine":{"default":"Goanna"}},{"regex":"SputnikBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Sputnik Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"TNSBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"K.Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"OculusBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Oculus Browser","version":"$1"},{"regex":"Jio(?:Browser|Pages)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Jio Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome/.+ Hola(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"hola! Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Slimjet/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Slimjet","version":"$1","engine":{"default":"Blink"}},{"regex":"7Star/(?:(\\\\d+[\\\\.\\\\d]+))","name":"7Star","version":"$1","engine":{"default":"Blink"}},{"regex":"MxNitro/(?:(\\\\d+[\\\\.\\\\d]+))","name":"MxNitro","version":"$1","engine":{"default":"Blink"}},{"regex":"HuaweiBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Huawei Browser","version":"$1"},{"regex":"VivoBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"vivo Browser","version":"$1"},{"regex":"RealmeBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Realme Browser","version":"$1"},{"regex":"Beaker ?Browser(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Beaker Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"QwantiOS/(\\\\d+[\\\\.\\\\d]+)","name":"Qwant Mobile","version":"$1","engine":{"default":"WebKit"}},{"regex":"QwantMobile(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Qwant Mobile","version":"$1","engine":{"default":"Gecko"}},{"regex":"Qwant/(\\\\d+[\\\\.\\\\d]+)","name":"Qwant Mobile","version":"$1","engine":{"default":"Gecko"}},{"regex":"TenFourFox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"TenFourFox","version":"$1","engine":{"default":"Gecko"}},{"regex":"AOLShield(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"AOL Shield","version":"$1","engine":{"default":"Gecko"}},{"regex":"Edge[ /](\\\\d+[\\\\.\\\\d]+)","name":"Microsoft Edge","version":"$1","engine":{"default":"Edge"}},{"regex":"EdgiOS[ /](\\\\d+[\\\\.\\\\d]+)","name":"Microsoft Edge","version":"$1","engine":{"default":"WebKit"}},{"regex":"EdgA[ /](\\\\d+[\\\\.\\\\d]+)","name":"Microsoft Edge","version":"$1","engine":{"default":"Blink"}},{"regex":"Edg[ /](\\\\d+[\\\\.\\\\d]+)","name":"Microsoft Edge","version":"$1","engine":{"default":"Blink"}},{"regex":"QIHU 360[ES]E","name":"360 Browser","version":""},{"regex":"360 Aphone Browser(?: \\\\((\\\\d+[\\\\.\\\\d]+)(?:beta)?\\\\))?","name":"360 Phone Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"SailfishBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Sailfish Browser","version":"$1","engine":{"default":"Gecko"}},{"regex":"IceCat(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"IceCat","version":"$1","engine":{"default":"Gecko"}},{"regex":"Mobicip","name":"Mobicip","version":"","engine":{"default":"Gecko"}},{"regex":"Camino(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Camino","version":"$1","engine":{"default":"Gecko"}},{"regex":"Waterfox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Waterfox","version":"$1","engine":{"default":"Gecko"}},{"regex":"Chrome/.+ AlohaBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Aloha Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"AlohaBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Aloha Browser","version":"$1"},{"regex":"(?:Avast|ASW|Safer)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Avast Secure Browser","version":"$1"},{"regex":"Epic(?:/(\\\\d+[\\\\.\\\\d]+))","name":"Epic","version":"$1","engine":{"default":"Gecko"}},{"regex":"Fennec(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Fennec","version":"$1","engine":{"default":"Gecko"}},{"regex":"Firefox.*Tablet browser (\\\\d+[\\\\.\\\\d]+)","name":"MicroB","version":"$1","engine":{"default":"Gecko"}},{"regex":"Maemo Browser(?: (\\\\d+[\\\\.\\\\d]+))?","name":"MicroB","version":"$1","engine":{"default":"Gecko"}},{"regex":"Deepnet Explorer (\\\\d+[\\\\.\\\\d]+)?","name":"Deepnet Explorer","version":"$1"},{"regex":"Avant ?Browser","name":"Avant Browser","version":"","engine":{"default":""}},{"regex":"OppoBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Oppo Browser","version":"$1"},{"regex":"Chrome/(\\\\d+[\\\\.\\\\d]+).*MRCHROME","name":"Amigo","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"AtomicBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Atomic Web Browser","version":"$1"},{"regex":"Bunjalloo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Bunjalloo","version":"$1"},{"regex":"Brave(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Brave","version":"$1","engine":{"default":"Blink"}},{"regex":"Iridium(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Iridium","version":"$1"},{"regex":"Iceweasel(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Iceweasel","version":"$1","engine":{"default":"Gecko"}},{"regex":"WebPositive","name":"WebPositive","version":"","engine":{"default":"WebKit"}},{"regex":".*Goanna.*PaleMoon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Pale Moon","version":"$1","engine":{"default":"Goanna"}},{"regex":"PaleMoon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Pale Moon","version":"$1","engine":{"default":"Gecko"}},{"regex":"CometBird(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"CometBird","version":"$1","engine":{"default":"Gecko"}},{"regex":"IceDragon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"IceDragon","version":"$1","engine":{"default":"Gecko"}},{"regex":"Flock(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Flock","version":"$1","engine":{"default":"Gecko","versions":{"3":"WebKit"}}},{"regex":"JigBrowserPlus/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Jig Browser Plus","version":"$1"},{"regex":"jig browser(?: web;|9i?)?(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Jig Browser","version":"$1"},{"regex":"Kapiko(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Kapiko","version":"$1","engine":{"default":"Gecko"}},{"regex":"Kylo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Kylo","version":"$1","engine":{"default":"Gecko"}},{"regex":"Origin/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Origin In-Game Overlay","version":"$1"},{"regex":"Cunaguaro(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Cunaguaro","version":"$1"},{"regex":"(?:TO-Browser/TOB|DT-Browser/DTB)(\\\\d+[\\\\.\\\\d]+)","name":"t-online.de Browser","version":"$1"},{"regex":"Kazehakase(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Kazehakase","version":"$1","engine":{"default":""}},{"regex":"ArcticFox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Arctic Fox","version":"$1","engine":{"default":"Goanna"}},{"regex":"Mypal(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Mypal","version":"$1","engine":{"default":"Goanna"}},{"regex":"Centaury(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Centaury","version":"$1","engine":{"default":"Goanna"}},{"regex":"(?:Focus|Klar)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox Focus","version":"$1"},{"regex":"Cyberfox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Cyberfox","version":"$1","engine":{"default":"Gecko"}},{"regex":"Firefox/(\\\\d+[\\\\.\\\\d]+).*\\\\(Swiftfox\\\\)","name":"Swiftfox","version":"$1","engine":{"default":"Gecko"}},{"regex":"(?:Mobile|Tablet).*Servo.*Firefox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox Mobile","version":"$1","engine":{"default":"Servo"}},{"regex":"(?:Mobile|Tablet).*Firefox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox Mobile","version":"$1","engine":{"default":"Gecko"}},{"regex":"FxiOS/(\\\\d+[\\\\.\\\\d]+)","name":"Firefox Mobile iOS","version":"$1","engine":{"default":"WebKit"}},{"regex":".*Servo.*Firefox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox","version":"$1","engine":{"default":"Servo"}},{"regex":"(?!.*Opera[ /])Firefox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox","version":"$1","engine":{"default":"Gecko"}},{"regex":"(?:BonEcho|GranParadiso|Lorentz|Minefield|Namoroka|Shiretoko)/(\\\\d+[\\\\.\\\\d]+)","name":"Firefox","version":"$1","engine":{"default":"Gecko"}},{"regex":"ANTFresco(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"ANT Fresco","version":"$1"},{"regex":"ANTGalio(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"ANTGalio","version":"$1"},{"regex":"(?:Espial|Escape)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Espial TV Browser","version":"$1"},{"regex":"RockMelt(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"RockMelt","version":"$1","engine":{"default":"WebKit"}},{"regex":"Fireweb Navigator(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Fireweb Navigator","version":"$1"},{"regex":"Fireweb(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Fireweb","version":"$1"},{"regex":"(?:Navigator|Netscape6?)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Netscape","version":"$1","engine":{"default":""}},{"regex":"(?:Polarity)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Polarity","version":"$1"},{"regex":"(?:QupZilla)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"QupZilla","version":"$1"},{"regex":"(?:Dooble)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Dooble","version":"$1"},{"regex":"Whale/(\\\\d+[\\\\.\\\\d]+)","name":"Whale Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Obigo[ ]?(?:InternetBrowser|Browser)?(?:[ /]([a-z0-9]*))?","name":"Obigo","version":"$1"},{"regex":"Obigo|Teleca","name":"Obigo","version":""},{"regex":"UCBrowserHD/(\\\\d[\\\\d\\\\.]+)","name":"UC Browser HD","version":"$1"},{"regex":"UCMini(?:[ /]?(\\\\d+[\\\\.\\\\d]+))?","name":"UC Browser Mini","version":"$1"},{"regex":"UC[ ]?Browser.* \\\\(UCMini\\\\)","name":"UC Browser Mini","version":""},{"regex":"UCTurbo(?:[ /]?(\\\\d+[\\\\.\\\\d]+))?","name":"UC Browser Turbo","version":"$1"},{"regex":"UC[ ]?Browser.* \\\\(UCTurbo\\\\)","name":"UC Browser Turbo","version":""},{"regex":"OPRGX(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Opera GX","version":"$1","engine":{"default":"Blink"}},{"regex":"(?:Opera Tablet.*Version|Opera/.+Opera Mobi.+Version|Mobile.+OPR)/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Mobile","version":"$1","engine":{"default":"Presto","versions":{"15":"Blink"}}},{"regex":"MMS/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Neon","version":"$1","engine":{"default":"Blink"}},{"regex":"OMI/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Devices","version":"$1","engine":{"default":"Blink"}},{"regex":"Opera%20Touch/(\\\\d+[\\\\.\\\\d]+)? CFNetwork/.+Darwin/.+(?!.*x86_64)","name":"Opera Touch","version":"$1","engine":{"default":"WebKit"}},{"regex":"OPT/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Touch","version":"$1","engine":{"default":"Blink"}},{"regex":"Opera/(\\\\d+[\\\\.\\\\d]+).+Opera Mobi","name":"Opera Mobile","version":"$1","engine":{"default":"Presto","versions":{"15":"Blink"}}},{"regex":"Opera ?Mini/(?:att/)?(\\\\d+[\\\\.\\\\d]+)","name":"Opera Mini","version":"$1","engine":{"default":"Presto"}},{"regex":"Opera ?Mini.+Version/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Mini","version":"$1","engine":{"default":"Presto"}},{"regex":"OPiOS/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Mini iOS","version":"$1","engine":{"default":"WebKit"}},{"regex":"Opera%20Mini/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Opera Mini iOS","version":"$1","engine":{"default":"WebKit"}},{"regex":"Opera.+Edition Next.+Version/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Next","version":"$1","engine":{"default":"Presto","versions":{"15":"Blink"}}},{"regex":"(?:Opera|OPR)[/ ](?:9.80.*Version/)?(\\\\d+[\\\\.\\\\d]+).+Edition Next","name":"Opera Next","version":"$1","engine":{"default":"Presto","versions":{"15":"Blink"}}},{"regex":"(?:Opera[/ ]?|OPR[/ ])(?:9.80.*Version/)?(\\\\d+[\\\\.\\\\d]+)","name":"Opera","version":"$1","engine":{"default":"","versions":{"7":"Presto","15":"Blink","3.5":"Elektra"}}},{"regex":"rekonq(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Rekonq","version":"$1","engine":{"default":"WebKit"}},{"regex":"CoolNovo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"CoolNovo","version":"$1","engine":{"default":""}},{"regex":"(?:Comodo[ _])?Dragon(?!fruit)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Comodo Dragon","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"ChromePlus(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"ChromePlus","version":"$1","engine":{"default":""}},{"regex":"Conkeror(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Conkeror","version":"$1","engine":{"default":"Gecko"}},{"regex":"Konqueror(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Konqueror","version":"$1","engine":{"default":"KHTML","versions":{"4":""}}},{"regex":"(?:baidubrowser|bdbrowser(?:(?:hd)?_i18n)?|FlyFlow|BaiduHD)(?:[/ ](\\\\d+[\\\\.\\\\d]*))?","name":"Baidu Browser","version":"$1"},{"regex":"(?:(?:BD)?Spark(?:Safe)?|BIDUBrowser)[/ ](\\\\d+[\\\\.\\\\d]*)","name":"Baidu Spark","version":"$1"},{"regex":"YaBrowser(?:/(\\\\d+[\\\\.\\\\d]*)) \\\\(lite\\\\)?","name":"Yandex Browser Lite","version":"$1","engine":{"default":"Blink"}},{"regex":"YaBrowser(?:/(\\\\d+[\\\\.\\\\d]*))(?: \\\\((alpha|beta)\\\\))?","name":"Yandex Browser","version":"$1 $2","engine":{"default":"Blink"}},{"regex":"Ya(?:ndex)?SearchBrowser(?:/(\\\\d+[\\\\.\\\\d]*))","name":"Yandex Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Vivaldi(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Vivaldi","version":"$1","engine":{"default":"Blink"}},{"regex":"TweakStyle(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"TweakStyle","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome.+Midori Browser/(\\\\d+[\\\\.\\\\d]+)","name":"Midori","version":"$1","engine":{"default":"Blink"}},{"regex":"Midori(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Midori","version":"$1","engine":{"default":"WebKit"}},{"regex":"Mercury(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Mercury","version":"$1"},{"regex":"Chrome.+Maxthon(?:.+\\\\(portable\\\\))?/(\\\\d+[\\\\.\\\\d]+)","name":"Maxthon","version":"$1","engine":{"default":"WebKit","versions":{"5.2":"Blink"}}},{"regex":"(?:Maxthon(?:%20Browser)?|MxBrowser(?:-inhouse|-iPhone)?)[ /](\\\\d+[\\\\.\\\\d]+)","name":"Maxthon","version":"$1","engine":{"default":"","versions":{"3":"WebKit"}}},{"regex":"(?:Maxthon|MyIE2)","name":"Maxthon","version":"","engine":{"default":""}},{"regex":"Puffin(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Puffin","version":"$1"},{"regex":"MobileIron(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Iron Mobile","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome(?:/(\\\\d+[\\\\.\\\\d]+))?.*Iron","name":"Iron","version":"$1","engine":{"default":"WebKit"}},{"regex":"Iron(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Iron","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"Epiphany(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"GNOME Web","version":"$1","engine":{"default":"Gecko","versions":{"2.9.16":"","2.28":"WebKit"}}},{"regex":"LieBaoFast(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"LieBaoFast","version":"$1"},{"regex":"LBBrowser(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Cheetah Browser","version":"$1"},{"regex":"SE (\\\\d+[\\\\.\\\\d]+)","name":"Sogou Explorer","version":"$1"},{"regex":"QQBrowserLite/([\\\\d\\\\.]+)","name":"QQ Browser Lite","version":"$1"},{"regex":"M?QQBrowser/Mini([\\\\.\\\\d]+)?","name":"QQ Browser Mini","version":"$1","engine":{"default":""}},{"regex":"M?QQBrowser(?:/([\\\\.\\\\d]+))?","name":"QQ Browser","version":"$1","engine":{"default":""}},{"regex":"(?:MIUIBrowser|MiuiBrowser)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"MIUI Browser","version":"$1","engine":{"default":""}},{"regex":"(?:coc_coc_browser|coccocbrowser|CocCoc)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Coc Coc","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"DuckDuckGo/(\\\\d+[\\\\.\\\\d]*)","name":"DuckDuckGo Privacy Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Samsung ?Browser(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Samsung Browser","version":"$1"},{"regex":"(?:SFB(?:rowser)?)/(\\\\d+[\\\\.\\\\d]+)","name":"Super Fast Browser","version":"$1"},{"regex":"com.browser.tssomas(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Super Fast Browser","version":"$1"},{"regex":"EUI Browser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"EUI Browser","version":"$1"},{"regex":"UBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"UBrowser","version":"$1"},{"regex":"Streamy(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Streamy","version":"$1","engine":{"default":"WebKit"}},{"regex":"isivioo","name":"Isivioo","version":"","engine":{"default":"WebKit"}},{"regex":"UC[ ]?Browser(?:[ /]?(\\\\d+[\\\\.\\\\d]+))?","name":"UC Browser","version":"$1"},{"regex":"UCWEB(?:[ /]?(\\\\d+[\\\\.\\\\d]+))?","name":"UC Browser","version":"$1"},{"regex":"UC AppleWebKit","name":"UC Browser","version":""},{"regex":"Tenta/(\\\\d+[\\\\.\\\\d]+)","name":"Tenta Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"Rocket/(\\\\d+[\\\\.\\\\d]+)","name":"Firefox Rocket","version":"$1","engine":{"default":"WebKit"}},{"regex":"Web Explorer/(\\\\d+[\\\\.\\\\d]+).*Chrome","name":"Web Explorer","version":"$1","engine":{"default":"WebKit"}},{"regex":"SznProhlizec/(\\\\d+[\\\\.\\\\d]+)","name":"Seznam Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"SogouMobileBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"Sogou Mobile Browser","version":"$1","engine":{"default":""}},{"regex":"Mint Browser/(\\\\d+[\\\\.\\\\d]+)","name":"Mint Browser","version":"$1","engine":{"default":""}},{"regex":"Ecosia (?:android|ios)@(\\\\d+[\\\\.\\\\d]+)","name":"Ecosia","version":"$1","engine":{"default":""}},{"regex":"ACHEETAHI","name":"CM Browser","version":"","engine":{"default":""}},{"regex":"Kiwi Chrome","name":"Kiwi","version":"","engine":{"default":""}},{"regex":"Mb2345Browser/(\\\\d+[\\\\.\\\\d]+)","name":"2345 Browser","version":"$1","engine":{"default":""}},{"regex":"QtWebEngine/(\\\\d+[\\\\.\\\\d]+)","name":"QtWebEngine","version":"$1","engine":{"default":""}},{"regex":"Silk/(\\\\d+[\\\\.\\\\d]+) like Chrome","name":"Mobile Silk","version":"$1","engine":{"default":"Blink"}},{"regex":"Silk(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Mobile Silk","version":"$1","engine":{"default":"WebKit"}},{"regex":"IBrowse(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"IBrowse","version":"$1"},{"regex":"UP.Browser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Openwave Mobile Browser","version":"$1"},{"regex":"Openwave(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Openwave Mobile Browser","version":"$1"},{"regex":"OneBrowser(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"ONE Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"(?:NokiaBrowser|BrowserNG)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Nokia Browser","version":"$1"},{"regex":"Series60/5\\\\.0","name":"Nokia Browser","version":"7.0"},{"regex":"Series60/(\\\\d+[\\\\.\\\\d]+)","name":"Nokia OSS Browser","version":"$1"},{"regex":"S40OviBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"Nokia Ovi Browser","version":"$1"},{"regex":"^Nokia|Nokia[EN]?\\\\d+","name":"Nokia Browser","version":""},{"regex":"Sleipnir(?:(?:%20Browser)?[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Sleipnir","version":"$1","engine":{"default":""}},{"regex":"NTENTBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NTENT Browser","version":"$1"},{"regex":"TV Bro/(\\\\d+[\\\\.\\\\d]+)","name":"TV Bro","version":"$1"},{"regex":"Chrome/.+ Quark(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Quark","version":"$1","engine":{"default":"WebKit"}},{"regex":"MonumentBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Monument Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"BlueBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Blue Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"JAPAN Browser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Japan Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"Version/.* Chrome(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome Webview","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"CrMo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome Mobile","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"CriOS(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome Mobile iOS","version":"$1","engine":{"default":"WebKit"}},{"regex":"Chrome(?:/(\\\\d+[\\\\.\\\\d]+))? Mobile","name":"Chrome Mobile","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"chromeframe(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome Frame","version":"$1","engine":{"default":"WebKit"}},{"regex":"Chromium(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chromium","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"HeadlessChrome(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Headless Chrome","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome(?!book)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"(?:Tizen|SLP) Browser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Tizen Browser","version":"$1"},{"regex":"Blazer(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Palm Blazer","version":"$1"},{"regex":"Pre/(\\\\d+[\\\\.\\\\d]+)","name":"Palm Pre","version":"$1"},{"regex":"(?:hpw|web)OS/(\\\\d+[\\\\.\\\\d]+)","name":"wOSBrowser","version":"$1"},{"regex":"WebPro(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Palm WebPro","version":"$1"},{"regex":"Palmscape(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Palmscape","version":"$1"},{"regex":"Jasmine(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Jasmine","version":"$1"},{"regex":"Lynx(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Lynx","version":"$1","engine":{"default":"Text-based"}},{"regex":"NCSA_Mosaic(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NCSA Mosaic","version":"$1"},{"regex":"ABrowse(?: (\\\\d+[\\\\.\\\\d]+))?","name":"ABrowse","version":"$1"},{"regex":"amaya(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Amaya","version":"$1"},{"regex":"AmigaVoyager(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Amiga Voyager","version":"$1"},{"regex":"Amiga-Aweb(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Amiga Aweb","version":"$1"},{"regex":"Arora(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Arora","version":"$1","engine":{"default":"WebKit"}},{"regex":"Beonex(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Beonex","version":"$1","engine":{"default":"Gecko"}},{"regex":"bline(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"B-Line","version":"$1","engine":{"default":"WebKit"}},{"regex":"BrowseX \\\\((\\\\d+[\\\\.\\\\d]+)","name":"BrowseX","version":"$1"},{"regex":"Charon(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Charon","version":"$1"},{"regex":"Cheshire(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Cheshire","version":"$1"},{"regex":"dbrowser","name":"dbrowser","version":"","engine":{"default":"WebKit"}},{"regex":"Dillo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Dillo","version":"$1","engine":{"default":"Dillo"}},{"regex":"Dolfin(?:/(\\\\d+[\\\\.\\\\d]+))?|dolphin","name":"Dolphin","version":"$1","engine":{"default":"WebKit"}},{"regex":"Elinks(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Elinks","version":"$1","engine":{"default":"Text-based"}},{"regex":"Element Browser(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Element Browser","version":"$1"},{"regex":"eZBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"eZ Browser","version":"$1"},{"regex":"Firebird(?! Build)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firebird","version":"$1","engine":{"default":"Gecko"}},{"regex":"Fluid(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Fluid","version":"$1","engine":{"default":"WebKit"}},{"regex":"Galeon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Galeon","version":"$1","engine":{"default":"Gecko"}},{"regex":"Google Earth(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Google Earth","version":"$1","engine":{"default":"WebKit"}},{"regex":"HotJava(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"HotJava","version":"$1"},{"regex":"iCabMobile(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"iCab Mobile","version":"$1","engine":{"default":"WebKit"}},{"regex":"iCab(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"iCab","version":"$1","engine":{"default":"iCab","versions":{"4":"WebKit"}}},{"regex":"i?Lunascape(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Lunascape","version":"$1","engine":{"default":""}},{"regex":"Crazy Browser (\\\\d+[\\\\.\\\\d]+)","name":"Crazy Browser","version":"$1","engine":{"default":"Trident"}},{"regex":"IEMobile[ /](\\\\d+[\\\\.\\\\d]+)","name":"IE Mobile","version":"$1","engine":{"default":"Trident"}},{"regex":"MSIE (\\\\d+[\\\\.\\\\d]+).*XBLWP7","name":"IE Mobile","version":"$1","engine":{"default":"Trident"}},{"regex":"MSIE.*Trident/4.0","name":"Internet Explorer","version":"8.0","engine":{"default":"Trident"}},{"regex":"MSIE.*Trident/5.0","name":"Internet Explorer","version":"9.0","engine":{"default":"Trident"}},{"regex":"MSIE.*Trident/6.0","name":"Internet Explorer","version":"10.0","engine":{"default":"Trident"}},{"regex":"Trident/[78].0","name":"Internet Explorer","version":"11.0","engine":{"default":"Trident"}},{"regex":"MSIE (\\\\d+[\\\\.\\\\d]+)","name":"Internet Explorer","version":"$1","engine":{"default":"Trident"}},{"regex":"IE[ /](\\\\d+[\\\\.\\\\d]+)","name":"Internet Explorer","version":"$1","engine":{"default":"Trident"}},{"regex":"Kindle/(\\\\d+[\\\\.\\\\d]+)","name":"Kindle Browser","version":"$1"},{"regex":"K-meleon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"K-meleon","version":"$1","engine":{"default":"Gecko"}},{"regex":"Links(?: \\\\((\\\\d+[\\\\.\\\\d]+))?","name":"Links","version":"$1","engine":{"default":"Text-based"}},{"regex":"LG Browser(?:/(\\\\d+[\\\\.\\\\d]+))","name":"LG Browser","version":"$1"},{"regex":"LuaKit(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"LuaKit","version":"$1"},{"regex":"OmniWeb(?:/[v]?(\\\\d+[\\\\.\\\\d]+))?","name":"OmniWeb","version":"$1","engine":{"default":"WebKit"}},{"regex":"Phoenix(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Phoenix","version":"$1"},{"regex":"NetFrontLifeBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NetFront Life","version":"$1","engine":{"default":"NetFront"}},{"regex":"NetFront(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NetFront","version":"$1","engine":{"default":"NetFront"}},{"regex":"PLAYSTATION|NINTENDO 3|AppleWebKit.+ N[XF]/\\\\d+\\\\.\\\\d+\\\\.\\\\d+","name":"NetFront","version":""},{"regex":"NetPositive(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NetPositive","version":"$1"},{"regex":"Odyssey Web Browser(?:.*OWB/(\\\\d+[\\\\.\\\\d]+))?","name":"Odyssey Web Browser","version":"$1"},{"regex":"OffByOne","name":"Off By One","version":""},{"regex":"(?:Oregano|OreganMediaBrowser)(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Oregano","version":"$1"},{"regex":"(?:Polaris|Embider)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Polaris","version":"$1"},{"regex":"SEMC-Browser(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"SEMC-Browser","version":"$1"},{"regex":"Shiira(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Shiira","version":"$1","engine":{"default":"WebKit"}},{"regex":"Skyfire(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Skyfire","version":"$1"},{"regex":"Snowshoe(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Snowshoe","version":"$1","engine":{"default":"WebKit"}},{"regex":"Sunrise(?:Browser)?(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Sunrise","version":"$1"},{"regex":"SuperBird(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"SuperBird","version":"$1"},{"regex":"Vision-Browser(?:/(\\\\d+[\\\\.\\\\d]+))","name":"Vision Mobile Browser","version":"$1"},{"regex":"WeTab-Browser","name":"WeTab Browser","version":""},{"regex":"Xiino(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Xiino","version":"$1"},{"regex":"BlackBerry|PlayBook|BB10","name":"BlackBerry Browser","version":""},{"regex":"Android","name":"Android Browser","version":"","engine":{"default":"WebKit"}},{"regex":"Coast(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Coast","version":"$1"},{"regex":"Surf(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"surf","version":"$1","engine":{"default":"WebKit"}},{"regex":"(?:(?:iPod|iPad|iPhone).+Version|MobileSafari)/(\\\\d+[\\\\.\\\\d]+)","name":"Mobile Safari","version":"$1","engine":{"default":"WebKit"}},{"regex":"(?:Version/(\\\\d+[\\\\.\\\\d]+).*)?Mobile.*Safari/","name":"Mobile Safari","version":"$1","engine":{"default":"WebKit"}},{"regex":"(?:iPod|iPhone|iPad)","name":"Mobile Safari","version":"","engine":{"default":"WebKit"}},{"regex":"Version/(\\\\d+[\\\\.\\\\d]+).*Safari/|Safari/?\\\\d+","name":"Safari","version":"$1","engine":{"default":"WebKit"}},{"regex":"Dorado WAP-Browser[/ ](\\\\d+[\\\\.\\\\d]+)","name":"Dorado","version":"$1"},{"regex":"NetSurf(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NetSurf","version":"$1","engine":{"default":"NetSurf"}},{"regex":"Uzbl","name":"Uzbl","version":""},{"regex":"SimpleBrowser","name":"SimpleBrowser","version":""},{"regex":"Zvu(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Zvu","version":"$1","engine":{"default":"Gecko"}},{"regex":"GOGGalaxyClient/(\\\\d+[\\\\.\\\\d]+)?","name":"GOG Galaxy","version":"$1"},{"regex":"WAP Browser/MAUI|(?:\\\\w+)?Maui Wap Browser|MAUI[- ]Browser","name":"MAUI WAP Browser","version":""},{"regex":"SP%20Browser/(\\\\d+[\\\\.\\\\d]+)","name":"SP Browser","version":"$1","engine":{"default":"WebKit"}}]');

/***/ }),

/***/ 60169:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"Akregator(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Akregator","version":"$1","url":"http://userbase.kde.org/Akregator","type":"Feed Reader"},{"regex":"Apple-PubSub(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Apple PubSub","version":"$1","url":"https://developer.apple.com/library/mac/documentation/Darwin/Reference/ManPages/man1/pubsub.1.html","type":"Feed Reader"},{"regex":"BashPodder","name":"BashPodder","version":"","url":"http://lincgeek.org/bashpodder/","type":"Feed Reader"},{"regex":"Breaker/v([\\\\d\\\\.]+)","name":"Breaker","version":"$1","url":"https://www.breaker.audio/","type":"Feed Reader App"},{"regex":"Downcast/([\\\\d\\\\.]+)","name":"Downcast","version":"$1","url":"http://downcastapp.com/","type":"Feed Reader App"},{"regex":"FeedDemon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"FeedDemon","version":"$1","url":"http://www.feeddemon.com/","type":"Feed Reader"},{"regex":"Feeddler(?:RSS|PRO)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Feeddler RSS Reader","version":"$1","url":"http://www.chebinliu.com/projects/iphone/feeddler-rss-reader/","type":"Feed Reader App"},{"regex":"QuiteRSS(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"QuiteRSS","version":"$1","url":"https://quiterss.org","type":"Feed Reader App"},{"regex":"gPodder/([\\\\d\\\\.]+)","name":"gPodder","version":"$1","url":"http://gpodder.org/","type":"Feed Reader App"},{"regex":"JetBrains Omea Reader(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"JetBrains Omea Reader","version":"$1","url":"http://www.jetbrains.com/omea/reader/","type":"Feed Reader"},{"regex":"Liferea(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Liferea","version":"$1","url":"http://liferea.sf.net/","type":"Feed Reader"},{"regex":"(?:NetNewsWire|Evergreen.+MacOS)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"NetNewsWire","version":"$1","url":"http://netnewswireapp.com/","type":"Feed Reader"},{"regex":"NewsBlur (?:iPhone|iPad) App(?: v(\\\\d+[\\\\.\\\\d]+))?","name":"NewsBlur Mobile App","version":"$1","url":"http://www.newsblur.com","type":"Feed Reader App"},{"regex":"NewsBlur(?:/(\\\\d+[\\\\.\\\\d]+))","name":"NewsBlur","version":"$1","url":"http://www.newsblur.com","type":"Feed Reader"},{"regex":"newsbeuter(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Newsbeuter","version":"$1","url":"http://www.newsbeuter.org/","type":"Feed Reader"},{"regex":"PritTorrent/([\\\\d\\\\.]+)","name":"PritTorrent","version":"$1","url":"http://bitlove.org","type":"Feed Reader"},{"regex":"Pulp[/ ](\\\\d+[\\\\.\\\\d]+)","name":"Pulp","version":"$1","url":"http://www.acrylicapps.com/pulp/","type":"Feed Reader App"},{"regex":"ReadKit(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"ReadKit","version":"$1","url":"http://readkitapp.com/","type":"Feed Reader App"},{"regex":"Reeder[/ ](\\\\d+[\\\\.\\\\d]+)","name":"Reeder","version":"$1","url":"http://reederapp.com/","type":"Feed Reader App"},{"regex":"RSSBandit(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"RSS Bandit","version":"$1","url":"http://www.rssbandit.org)","type":"Feed Reader"},{"regex":"RSS Junkie(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"RSS Junkie","version":"$1","url":"https://play.google.com/store/apps/details?id=com.bitpowder.rssjunkie","type":"Feed Reader App"},{"regex":"RSSOwl(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"RSSOwl","version":"$1","url":"http://www.rssowl.org/","type":"Feed Reader"},{"regex":"Stringer","name":"Stringer","version":"","url":"https://github.com/swanson/stringer","type":"Feed Reader"}]');

/***/ }),

/***/ 18561:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"Wget(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Wget","version":"$1"},{"regex":"Guzzle(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Guzzle (PHP HTTP Client)","version":"$1"},{"regex":"(?:lib)?curl(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"curl","version":"$1"},{"regex":"python-requests(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Python Requests","version":"$1"},{"regex":"Python-urllib(?:/?(\\\\d+[\\\\.\\\\d]+))?","name":"Python urllib","version":"$1"},{"regex":"Java(?:/?(\\\\d+[\\\\.\\\\d]+))?","name":"Java","version":"$1"},{"regex":"(?:perlclient|libwww-perl)(?:/?(\\\\d+[\\\\.\\\\d]+))?","name":"Perl","version":"$1"},{"regex":"okhttp/([\\\\d\\\\.]+)","name":"OkHttp","version":"$1"},{"regex":"HTTP_Request2(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"HTTP_Request2","version":"$1"},{"regex":"HTTP_Request2(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"HTTP_Request2","version":"$1","url":"http://pear.php.net/package/http_request2"},{"regex":"Mechanize(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Mechanize","version":"$1","url":"http://github.com/sparklemotion/mechanize/"},{"regex":"aiohttp(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"aiohttp","version":"$1"},{"regex":"Google-HTTP-Java-Client(?:/(\\\\d+[\\\\.\\\\d\\\\w-]+))?","name":"Google HTTP Java Client","version":"$1"},{"regex":"WWW-Mechanize(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"WWW-Mechanize","version":"$1"},{"regex":"Faraday(?: v(\\\\d+[\\\\.\\\\d]+))?","name":"Faraday","version":"$1"},{"regex":"(?:Go-http-client|Go )/?(?:(\\\\d+[\\\\.\\\\d]+))?(?: package http)?","name":"Go-http-client","version":"$1"},{"regex":"urlgrabber(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"urlgrabber (yum)","version":"$1"},{"regex":"libdnf(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"libdnf","version":"$1"},{"regex":"HTTPie(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"HTTPie","version":"$1"},{"regex":"rest-client/(\\\\d+[\\\\.\\\\d]+).*ruby","name":"REST Client for Ruby","version":"$1"},{"regex":"RestSharp/(\\\\d+[\\\\.\\\\d]+)","name":"RestSharp","version":"$1","url":"http://restsharp.org/"},{"regex":"scalaj-http/(\\\\d+[\\\\.\\\\d]+)","name":"ScalaJ HTTP","version":"$1","url":"https://github.com/scalaj/scalaj-http"},{"regex":"REST::Client/(\\\\d+)","name":"Perl REST::Client","version":"$1","url":"https://metacpan.org/pod/REST::Client"},{"regex":"node-fetch/(\\\\d+[\\\\.\\\\d]+)","name":"Node Fetch","version":"$1","url":"https://github.com/node-fetch/node-fetch"},{"regex":"ReactorNetty/(\\\\d+[\\\\.\\\\d]+)","name":"ReactorNetty","version":"$1","url":"https://github.com/reactor/reactor-netty"},{"regex":"PostmanRuntime(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Postman Desktop","version":"$1","url":"https://github.com/postmanlabs/postman-runtime"},{"regex":"Jakarta Commons-HttpClient/([\\\\.\\\\d]+)","name":"Jakarta Commons HttpClient","version":"$1","url":"https://hc.apache.org/httpclient-3.x"},{"regex":"WinHttp.WinHttpRequest.+([\\\\.\\\\d]+)","name":"WinHttp WinHttpRequest","version":"$1"},{"regex":"Embarcadero URI Client/([\\\\.\\\\d]+)","name":"Embarcadero URI Client","version":"$1"},{"regex":"Mikrotik/([\\\\.\\\\d]+)","name":"Mikrotik Fetch","version":"$1"},{"regex":"GRequests(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"GRequests","version":"$1"},{"regex":"akka-http/([\\\\.\\\\d]+)","name":"Akka HTTP","version":"$1"}]');

/***/ }),

/***/ 41659:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"Audacious(?:[ /]([\\\\d\\\\.]+))?","name":"Audacious","version":"$1"},{"regex":"Banshee(?:[ /]([\\\\d\\\\.]+))?","name":"Banshee","version":"$1"},{"regex":"Boxee(?:[ /]([\\\\d\\\\.]+))?","name":"Boxee","version":"$1"},{"regex":"Clementine(?:[ /]([\\\\d\\\\.]+))?","name":"Clementine","version":"$1"},{"regex":"Deezer(?:/([\\\\d\\\\.]+))?","name":"Deezer","version":"$1"},{"regex":"iTunes(?:-iPhone|-iPad)?(?:/([\\\\d\\\\.]+))?","name":"iTunes","version":"$1"},{"regex":"FlyCast(?:/([\\\\d\\\\.]+))?","name":"FlyCast","version":"$1"},{"regex":"foobar2000(?:/([\\\\d\\\\.]+))?","name":"Foobar2000","version":"$1"},{"regex":"MediaMonkey(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"MediaMonkey","version":"$1"},{"regex":"Miro(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Miro","version":"$1"},{"regex":"NexPlayer(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NexPlayer","version":"$1"},{"regex":"Nightingale(?:/([\\\\d\\\\.]+))?","name":"Nightingale","version":"$1"},{"regex":"QuickTime(?:(?:(?:.+qtver=)|(?:(?: E-)?[\\\\./]))([\\\\d\\\\.]+))?","name":"QuickTime","version":"$1"},{"regex":"Songbird(?:/([\\\\d\\\\.]+))?","name":"Songbird","version":"$1"},{"regex":"SubStream(?:/([\\\\d\\\\.]+))?","name":"SubStream","version":"$1"},{"regex":"Sonos/([\\\\d\\\\.]+)?","name":"SONOS","version":"$1"},{"regex":"(?:Lib)?VLC(?:/([\\\\d\\\\.]+))?","name":"VLC","version":"$1"},{"regex":"Winamp(?:MPEG)?(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Winamp","version":"$1"},{"regex":"(?:Windows-Media-Player|NSPlayer)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Windows Media Player","version":"$1"},{"regex":"XBMC(?:/([\\\\d\\\\.]+))?","name":"XBMC","version":"$1"},{"regex":"Kodi(?:/([\\\\d\\\\.]+))?","name":"Kodi","version":"$1"},{"regex":"stagefright(?:/([\\\\d\\\\.]+))?","name":"Stagefright","version":"$1"},{"regex":"GoogleChirp(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Google Podcasts","version":"$1"},{"regex":"Music Player Daemon (?:(\\\\d+[\\\\.\\\\d]+))?","name":"Music Player Daemon","version":"$1"},{"regex":"mpv (?:(\\\\d+[\\\\.\\\\d]+))?","name":"mpv","version":"$1"}]');

/***/ }),

/***/ 92115:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"AndroidDownloadManager(?:[ /]([\\\\d\\\\.]+))?","name":"AndroidDownloadManager","version":"$1"},{"regex":"(?:Apple)?News(?:[ /][\\\\d\\\\.]+)? Version(?:[ /]([\\\\d\\\\.]+))?","name":"Apple News","version":"$1"},{"regex":"bPod","name":"bPod","version":""},{"regex":"MessengerLiteForiOS.(?:FBAV)(?:[ /]([\\\\d\\\\.]+))?","name":"Facebook Messenger Lite","version":"$1"},{"regex":"(?:MessengerForiOS|MESSENGER).(?:FBAV)(?:[ /]([\\\\d\\\\.]+))?","name":"Facebook Messenger","version":"$1"},{"regex":"(?:FBAV|com.facebook.katana)(?:[ /]([\\\\d\\\\.]+))?","name":"Facebook","version":"$1"},{"regex":"(?:FBAN|FBSV|FBID|FBBV)/","name":"Facebook","version":""},{"regex":"FeedR(?:/([\\\\d\\\\.]+))?","name":"FeedR","version":"$1"},{"regex":"com.google.android.apps.searchlite","name":"Google Go","version":""},{"regex":"com.google.android.apps.magazines","name":"Google Play Newsstand","version":""},{"regex":"com.google.GooglePlus","name":"Google Plus","version":""},{"regex":"MicroMessenger/([^; ]+)","name":"WeChat","version":"$1"},{"regex":"WeChatShareExtensionNew/([\\\\d\\\\.]+)","name":"WeChat Share Extension","version":"$1"},{"regex":"DingTalk/([0-9\\\\.]+)","name":"DingTalk","version":"$1"},{"regex":".*__weibo__([0-9\\\\.]+)__","name":"Sina Weibo","version":"$1"},{"regex":"Pinterest(?: for (?:Android|iOS))?(?:/([\\\\d\\\\.]+))?","name":"Pinterest","version":"$1"},{"regex":"Podcatcher Deluxe","name":"Podcatcher Deluxe","version":""},{"regex":"com.google.android.youtube(?:/([\\\\d\\\\.]+))?","name":"YouTube","version":"$1"},{"regex":"([^/]+)/(\\\\d+(?:\\\\.\\\\d+)+) \\\\((?:iPhone|iPad); iOS [0-9\\\\.]+; Scale/[0-9\\\\.]+\\\\)","name":"$1","version":"$2"},{"regex":"WhatsApp(?:[ /]([\\\\d\\\\.]+))?","name":"WhatsApp","version":"$1"},{"regex":"Line(?:[ /]([\\\\d\\\\.]+))","name":"Line","version":"$1"},{"regex":"Instacast(?:HD)?/(\\\\d\\\\.[\\\\d\\\\.abc]+) CFNetwork/([\\\\d\\\\.]+) Darwin/([\\\\d\\\\.]+)","name":"Instacast","version":"$1"},{"regex":"Podcasts/([\\\\d\\\\.]+)","name":"Podcasts","version":"$1"},{"regex":"Pocket Casts(?:, (?:Android|iOS) v([\\\\d\\\\.]+))?","name":"Pocket Casts","version":"$1"},{"regex":"Podcat/([\\\\d\\\\.]+)","name":"Podcat","version":"$1"},{"regex":"BeyondPod","name":"BeyondPod","version":null},{"regex":"AntennaPod/?([\\\\d\\\\.]+)?","name":"AntennaPod","version":"$1"},{"regex":"Overcast/([\\\\d\\\\.]+)","name":"Overcast","version":"$1"},{"regex":"(?:CastBox|fm.castbox.audiobook.radio.podcast)/?([\\\\d\\\\.]+)?","name":"CastBox","version":"$1"},{"regex":"Player FM","name":"Player FM","version":""},{"regex":"Podkicker(?: Pro)?/([\\\\d\\\\.]+)","name":"Podkicker","version":"$1"},{"regex":"PodcastRepublic/([\\\\d\\\\.]+)","name":"Podcast Republic","version":"$1"},{"regex":"Castro/(\\\\d+)","name":"Castro","version":"$1"},{"regex":"Castro 2 ([\\\\d\\\\.]+)/[\\\\d]+ Like iTunes","name":"Castro 2","version":"$1"},{"regex":"Castro 2","name":"Castro 2","version":""},{"regex":"DoggCatcher","name":"DoggCatcher","version":null},{"regex":"PodcastAddict/v([\\\\d]+)","name":"Podcast & Radio Addict","version":"$1"},{"regex":"Podcat(?:%202)?/([\\\\d]+) CFNetwork","name":"Podcat","version":"$1"},{"regex":"iCatcher[^\\\\d]+([\\\\d\\\\.]+)","name":"iCatcher","version":"$1"},{"regex":"YelpApp/([\\\\d\\\\.]+)","name":"Yelp Mobile","version":"$1"},{"regex":"jp.co.yahoo.android.yjtop/([\\\\d\\\\.]+)","name":"Yahoo! Japan","version":"$1"},{"regex":"RSSRadio/([\\\\d]+)?","name":"RSSRadio","version":"$1"},{"regex":"SogouSearch Android[\\\\d\\\\.]+ version([\\\\d\\\\.]+)?","name":"SogouSearch App","version":"$1"},{"regex":"NewsArticle/([\\\\d\\\\.]+)?","name":"NewsArticle App","version":"$1"},{"regex":"tieba/([\\\\d\\\\.]+)?","name":"tieba","version":"$1"},{"regex":"com\\\\.douban\\\\.group/([\\\\d\\\\.]+)?","name":"douban App","version":"$1"},{"regex":"BingWeb/([\\\\d\\\\.]+)?","name":"BingWebApp","version":"$1"},{"regex":"(?:com.google.GoogleMobile|GSA)/([\\\\d\\\\.]+)?","name":"Google Search App","version":"$1"},{"regex":"Flipboard/([\\\\d\\\\.]+)?","name":"Flipboard App","version":"$1"},{"regex":"Instagram[ /]([\\\\d\\\\.]+)?","name":"Instagram App","version":"$1"},{"regex":"baiduboxapp/([\\\\d\\\\.]+)?","name":"Baidu Box App","version":"$1"},{"regex":"Crosswalk(?!.*(?:Streamy|QwantMobile))/([\\\\d\\\\.]+)?","name":"CrosswalkApp","version":"$1"},{"regex":"Twitter for iPhone[/]?([\\\\d\\\\.]+)?","name":"Twitter","version":"$1"},{"regex":"Twitter/([\\\\d\\\\.]+)","name":"Twitter","version":"$1"},{"regex":"TwitterAndroid[/]?([\\\\d\\\\.]+)?","name":"Twitter","version":"$1"},{"regex":"TopBuzz/([\\\\d\\\\.]+)","name":"TopBuzz","version":"$1"},{"regex":"Snapchat/([\\\\d\\\\.]+)","name":"Snapchat","version":"$1"},{"regex":"UnityPlayer/([\\\\d\\\\.]+)","name":"UnityPlayer","version":"$1"},{"regex":"UCURSOS/v([\\\\d\\\\.]+)","name":"U-Cursos","version":"$1"},{"regex":"HeyTapBrowser/([\\\\d\\\\.]+)","name":"HeyTapBrowser","version":"$1"},{"regex":"RobloxApp/([\\\\d\\\\.]+)","name":"Roblox","version":"$1"},{"regex":"Viber/([\\\\d\\\\.]+)","name":"Viber","version":"$1"},{"regex":"Siri/1","name":"Siri","version":"1.0"},{"regex":"LinkedIn/([\\\\d\\\\.]+)","name":"LinkedIn","version":"$1"},{"regex":"Instapaper/([\\\\d\\\\.]+)","name":"Instapaper","version":"$1"},{"regex":"Keeper/([\\\\d\\\\.]+)","name":"Keeper Password Manager","version":"$1"},{"regex":"Skyeng Teachers/([\\\\d\\\\.]+)","name":"Skyeng Teachers","version":"$1"},{"regex":"Kik/([\\\\d\\\\.]+) \\\\(Android","name":"Kik","version":"$1"},{"regex":"Procast/?([\\\\d\\\\.]+)?","name":"Procast","version":"$1"},{"regex":"DeviantArt/([\\\\d\\\\.]+)","name":"DeviantArt","version":""},{"regex":"Discord/([\\\\d\\\\.]+)","name":"Discord","version":""},{"regex":"Covenant%20Eyes/([\\\\d\\\\.]+)","name":"Covenant Eyes","version":"$1"},{"regex":"HP%20Smart/([\\\\d\\\\.]+)","name":"HP Smart","version":""},{"regex":"Bitsboard/([\\\\d\\\\.]+)","name":"Bitsboard","version":"$1"},{"regex":"Betbull/([\\\\d\\\\.]+)","name":"BetBull","version":""},{"regex":"U-Cursos/([\\\\d\\\\.]+)","name":"U-Cursos","version":""},{"regex":"1PasswordThumbs/([\\\\d\\\\.]+)","name":"1Password","version":"$1"},{"regex":"(?:Microsoft Office )?(Access|Excel|OneDrive for Business|OneNote|PowerPoint|Project|Publisher|Visio|Word)[ /]([\\\\d\\\\.]+)","name":"Microsoft Office $1","version":"$2"},{"regex":"OneDriveiOSApp/([\\\\d\\\\.]+)","name":"Microsoft OneDrive","version":"$1"},{"regex":"Microsoft Office Mobile/([\\\\d\\\\.]+)","name":"Microsoft Office Mobile","version":"$1"},{"regex":"OC/([\\\\d\\\\.]+) \\\\(Skype for Business\\\\)","name":"Skype for Business","version":"$1"},{"regex":"TikTok[/ ](\\\\d+\\\\.(?:[\\\\.\\\\d]+))?","name":"TikTok","version":"$1"},{"regex":"NAVER/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Naver","version":"$1"},{"regex":"Copied/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Copied","version":""},{"regex":"Pic%20Collage/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Pic Collage","version":"$1"},{"regex":"Papers/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Papers","version":"$1"},{"regex":"RoboForm/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"RoboForm","version":""},{"regex":"Slack/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Slack","version":""},{"regex":"KAKAOTALK (\\\\d+\\\\.(?:[\\\\.\\\\d]+))?","name":"KakaoTalk","version":"$1"},{"regex":"ShopeeVN/([\\\\d\\\\.]+)","name":"Shopee","version":"$1"},{"regex":"SPORT1/([\\\\d\\\\.]+)","name":"SPORT1","version":""},{"regex":"Clovia/([\\\\d\\\\.]+)","name":"Clovia","version":"$1"},{"regex":"ShowMe/([\\\\d\\\\.]+)","name":"ShowMe","version":"$1"},{"regex":"Wattpad/([\\\\d\\\\.]+)","name":"Wattpad","version":"$1"},{"regex":"WSJ/([\\\\d\\\\.]+)","name":"The Wall Street Journal","version":""},{"regex":"WH%20Questions/([\\\\d\\\\.]+)","name":"WH Questions","version":"$1"},{"regex":"whisper/([\\\\d\\\\.]+)","name":"Whisper","version":""},{"regex":"Opal/([\\\\d\\\\.]+)","name":"Opal Travel","version":"$1"},{"regex":"Zalo/([\\\\d\\\\.]+)","name":"Zalo","version":"$1"},{"regex":"Yandex/([\\\\d\\\\.]+)","name":"Yandex","version":""},{"regex":"Zoho%20Chat/([\\\\d\\\\.]+)","name":"Zoho Chat","version":"$1"},{"regex":"Thunder/(\\\\d+[\\\\.\\\\d]+)","name":"Thunder","version":"$1"},{"regex":"CGNBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"CGN","version":"$1"},{"regex":"Podbean/.+App (\\\\d+[\\\\.\\\\d]+)","name":"Podbean","version":"$1"},{"regex":"AlexaMediaPlayer/(\\\\d+[\\\\.\\\\d]+)","name":"Alexa Media Player","version":"$1"},{"regex":"TuneIn Radio Pro(?:[^/]+)?/(\\\\d+[\\\\.\\\\d]+)","name":"TuneIn Radio Pro","version":"$1"},{"regex":"TuneIn Radio(?:[^/]+)?/(\\\\d+[\\\\.\\\\d]+)","name":"TuneIn Radio","version":"$1"},{"regex":"Podcaster/(\\\\d+[\\\\.\\\\d]+)","name":"Podcaster","version":"$1"},{"regex":"Swoot/(\\\\d+[\\\\.\\\\d]+)","name":"Swoot","version":"$1"},{"regex":"RadioPublic/android-(\\\\d+[\\\\.\\\\d]+)","name":"RadioPublic","version":"$1"},{"regex":"Podimo/(\\\\d+[\\\\.\\\\d]+)","name":"Podimo","version":"$1"},{"regex":"com.evolve.podcast/(\\\\d+[\\\\.\\\\d]+)","name":"Evolve Podcast","version":"$1"},{"regex":" Rocket.Chat\\\\+?/(\\\\d+[\\\\.\\\\d]+)","name":"Rocket Chat","version":"$1"},{"regex":"^Pandora Audio.+Android","name":"Pandora","version":""},{"regex":"^NPROneAndroid","name":"NPR One","version":""},{"regex":"^WirtschaftsWoche-iOS-(\\\\d+[\\\\.\\\\d]+)","name":"Wirtschafts Woche","version":"$1"},{"regex":"^Outlook-iOS/.+\\\\((\\\\d+[\\\\.\\\\d]+)\\\\)$","name":"Microsoft Outlook","version":"$1"},{"regex":"^TVirl/(\\\\d+[\\\\.\\\\d]+)","name":"TVirl","version":"$1"},{"regex":"2?chMate/(\\\\d+[\\\\.\\\\d]+)","name":"ChMate","version":"$1"},{"regex":"2tch/(\\\\d+[\\\\.\\\\d]+)","name":"2tch","version":"$1"},{"regex":"Ciisaa/(\\\\d+[\\\\.\\\\d]+)","name":"Ciisaa","version":"$1"},{"regex":"BB2C (\\\\d+[\\\\.\\\\d]+)","name":"BB2C","version":"$1"},{"regex":"twinkle/(\\\\d+[\\\\.\\\\d]+)","name":"twinkle","version":"$1"},{"regex":"JaneStyle_iOS/(\\\\d+[\\\\.\\\\d]+)","name":"JaneStyle","version":"$1"}]');

/***/ }),

/***/ 77182:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"Outlook-Express(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Outlook Express","version":"$1"},{"regex":"Microsoft Outlook(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Microsoft Outlook","version":"$1"},{"regex":"(?:Thunderbird|Icedove|Shredder)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Thunderbird","version":"$1"},{"regex":"Airmail(?: (\\\\d+[\\\\.\\\\d]+))?","name":"Airmail","version":"$1"},{"regex":"Lotus-Notes(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Lotus Notes","version":"$1"},{"regex":"Barca(?:Pro)?(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Barca","version":"$1"},{"regex":"Postbox(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Postbox","version":"$1"},{"regex":"MailBar(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"MailBar","version":"$1"},{"regex":"The Bat!(?: Voyager)?(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"The Bat!","version":"$1"},{"regex":"DAVdroid(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"DAVdroid","version":"$1"},{"regex":"(?:SeaMonkey|Iceape)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"SeaMonkey","version":"$1"},{"regex":"Live5ch/(\\\\d+[\\\\.\\\\d]+)","name":"Live5ch","version":"$1"},{"regex":"JaneView/","name":"JaneView","version":""},{"regex":"BathyScaphe/","name":"BathyScaphe","version":""}]');

/***/ }),

/***/ 95191:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Nikon":{"regex":"Coolpix S800c","device":"camera","model":"Coolpix S800c"},"Samsung":{"regex":"EK-G[CN][0-9]{3}","device":"camera","models":[{"regex":"EK-GN120","model":"Galaxy NX"},{"regex":"EK-GC100","model":"Galaxy Camera"},{"regex":"EK-GC110","model":"Galaxy Camera WiFi only"},{"regex":"EK-GC200","model":"Galaxy Camera 2"},{"regex":"EK-GC([0-9]{3})","model":"Galaxy Camera $1"}]}}');

/***/ }),

/***/ 5178:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Tesla":{"regex":"(?:Tesla/[0-9.]+|QtCarBrowser)","device":"car browser","models":[{"regex":"QtCarBrowser","model":"Model S"},{"regex":"Tesla/[0-9.]+","model":""}]},"MAC AUDIO":{"regex":"Mac Audio Spro","device":"car browser","models":[{"regex":"Spro","model":"S Pro"}]},"Topway":{"regex":"sp9853i_1h10_vmm","device":"car browser","models":[{"regex":"sp9853i_1h10_vmm","model":"TS9"}]}}');

/***/ }),

/***/ 78127:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Archos":{"regex":"Archos.*GAMEPAD([2]?)","device":"console","model":"Gamepad $1"},"Microsoft":{"regex":"Xbox","device":"console","models":[{"regex":"Xbox Series X","model":"Xbox Series X"},{"regex":"Xbox One X","model":"Xbox One X"},{"regex":"Xbox One","model":"Xbox One"},{"regex":"XBOX_ONE_ED","model":"Xbox One S"},{"regex":"Xbox","model":"Xbox 360"}]},"Nintendo":{"regex":"Nintendo (([3]?DS[i]?)|Wii[U]?|Switch)","device":"console","model":"$1"},"OUYA":{"regex":"OUYA","device":"console","model":"OUYA"},"Sega":{"regex":"Dreamcast","device":"console","model":"Dreamcast"},"Sony":{"regex":"PlayStation (3|4 Pro|4|Portable|Vita)","device":"console","model":"PlayStation $1"}}');

/***/ }),

/***/ 47511:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"360":{"regex":"(?:180[1379]-A01|1713-A01|1707-A01|1509-A00|1603-A03|1607-A01|1503-A01)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"1807-A01(?:[);/ ]|$)","model":"N7"},{"regex":"1803-A01(?:[);/ ]|$)","model":"N7 Lite"},{"regex":"1809-A01(?:[);/ ]|$)","model":"N7 Pro"},{"regex":"1713-A01(?:[);/ ]|$)","model":"N6 Lite"},{"regex":"1707-A01(?:[);/ ]|$)","model":"N6"},{"regex":"1801-A01(?:[);/ ]|$)","model":"N6 Pro"},{"regex":"1509-A00(?:[);/ ]|$)","model":"Q5 Plus"},{"regex":"1503-A01(?:[);/ ]|$)","model":"N4"},{"regex":"1603-A03(?:[);/ ]|$)","model":"N4A"},{"regex":"1607-A01(?:[);/ ]|$)","model":"N5S"}]},"8848":{"regex":"8848 (M[3-6])(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Ace":{"regex":"(?:BUZZ [12]|BUZZ 2|CLEVER 1|URBAN 1(?: Pro)?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"BUZZ ([12]) Lite","model":"Buzz $1 Lite"},{"regex":"BUZZ ([12]) Plus","model":"Buzz $1 Plus"},{"regex":"BUZZ ([12])","model":"Buzz $1"},{"regex":"CLEVER 1","model":"Clever 1"},{"regex":"URBAN 1 Pro","model":"Urban 1 Pro"},{"regex":"URBAN 1","model":"Urban 1"}]},"Tunisie Telecom":{"regex":"StarTrail TT(?:[);/ ]|$)","device":"smartphone","model":"StarTrail by TT"},"SFR":{"regex":"StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem|StarTab","device":"smartphone","models":[{"regex":"StarXtrem II(?:[);/ ]|$)","model":"StarXtrem 2"},{"regex":"StarXtrem ?([3-6])(?:[);/ ]|$)","model":"StarXtrem $1"},{"regex":"StarXtrem(?:[);/ ]|$)","model":"StarXtrem"},{"regex":"StarTrail III(?:[);/ ]|$)","model":"StarTrail 3"},{"regex":"StarTrail II(?:[);/ ]|$)","model":"StarTrail 2"},{"regex":"StarTrail[ _]?([1-9])[ _]([34])G(?:[);/ ]|$)","model":"StarTrail $1 $2G"},{"regex":"StarTrail[ _]?([1-9])(?:[);/ ]|$)","model":"StarTrail $1"},{"regex":"StarTrail(?:[);/ ]|$)","model":"StarTrail"},{"regex":"StarShine II(?:[);/ ]|$)","model":"StarShine 2"},{"regex":"StarShine(?:[);/ ]|$)","model":"StarShine"},{"regex":"STARADDICT 4(?:[);/ ]|$)","model":"Staraddict 4"},{"regex":"STARADDICT III(?:[);/ ]|$)","model":"Staraddict 3"},{"regex":"STARADDICT II Plus(?:[);/ ]|$)","model":"Staraddict 2 Plus"},{"regex":"STARADDICT II(?:[);/ ]|$)","model":"Staraddict 2"},{"regex":"STARADDICT(?:[);/ ]|$)","model":"Staraddict"},{"regex":"StarText II(?:[);/ ]|$)","model":"StarText 2"},{"regex":"StarText(?:[);/ ]|$)","model":"StarText"},{"regex":"StarNaute II(?:[);/ ]|$)","model":"StarNaute 2"},{"regex":"StarNaute(?:[);/ ]|$)","model":"StarNaute"},{"regex":"StarTab","model":"StarTab","device":"tablet"},{"regex":"((?:StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem)[^;/]*) Build","model":"$1"}]},"HTC":{"regex":"HTC|Sprint (?:APA|ATP)|ADR(?!910L)[a-z0-9]+|NexusHD2|Amaze[ _]4G(?:[);/ ]|$)|(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\\\))|(Amaze[ _]4G|(?<!BLU LIFE )One ?[XELSV\\\\+]+)(?:[);/ ]|$)|SPV E6[05]0|(One M8|One Mini 2|X525a|PG86100|PC36100|XV6975|PJ83100|2PYB2|2PS64|2PZC5|0PJA10|0PJA2|HTV33|0PM92|0PCV1|601HT|0PAJ5|HTL2[23]|HTV3[12]|2PQ93|X2-HT|EXODUS 1|ISW13HT)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"2PZC5(?:[);/ ]|$)","model":"U11"},{"regex":"XV6975(?:[);/ ]|$)","model":"Imagio"},{"regex":"PG86100(?:[);/ ]|$)","model":"Evo 3G"},{"regex":"PC36100(?:[);/ ]|$)","model":"Evo 4G"},{"regex":"(?:HTV33|601HT)(?:[);/ ]|$)","model":"U11"},{"regex":"(?:801e|802[wdt])","model":"One"},{"regex":"PJ83100(?:[);/ ]|$)","model":"One X"},{"regex":"One Mini 2(?:[);/ ]|$)","model":"One Mini 2"},{"regex":"X2-HT(?:[);/ ]|$)","model":"One X2"},{"regex":"ISW13HT(?:[);/ ]|$)","model":"J"},{"regex":"HTL22(?:[);/ ]|$)","model":"J One"},{"regex":"HTL23(?:[);/ ]|$)","model":"J Butterfly"},{"regex":"(?:0PJA2|0PJA10)(?:[);/ ]|$)","model":"One M9"},{"regex":"X525a(?:[);/ ]|$)","model":"One X+"},{"regex":"2PQ93(?:[);/ ]|$)","model":"One A9"},{"regex":"ADR6300","model":"Droid Incredible"},{"regex":"ADR6400L","model":"ThunderBolt"},{"regex":"ADR6410LRA","model":"Droid Incredible 3"},{"regex":"SPV E600","model":"Excalibur"},{"regex":"SPV E650","model":"Vox"},{"regex":"2PYB2","model":"Bolt"},{"regex":"2PS64","model":"10"},{"regex":"0PM92(?:[);/ ]|$)","model":"Desire 626S"},{"regex":"0PCV1(?:[);/ ]|$)","model":"Desire 510"},{"regex":"608t(?:[);/ ]|$)","model":"Desire 608t"},{"regex":"EXODUS 1(?:[);/ ]|$)","model":"Exodus 1"},{"regex":"NexusHD2","model":"HD2"},{"regex":"HTC[ _\\\\-]P715a","device":"tablet","model":"P715a"},{"regex":"HTC[ _\\\\-]Flyer Build","device":"tablet","model":"Flyer"},{"regex":"HTC[ _\\\\-]Flyer[ _\\\\-]([\\\\w]{1,5})","device":"tablet","model":"Flyer $1"},{"regex":"HTC[ _\\\\-]One[ _\\\\-]max(?:[);/ ]|$)","device":"phablet","model":"One max"},{"regex":"HTC[ _]([^/;]+) [0-9]+(?:\\\\.[0-9]+)+ Build","model":"$1"},{"regex":"HTC[ _]([^/;]+) Build","model":"$1"},{"regex":"HTC[ _]([a-z0-9]+[ _\\\\-]?(?:[a-z0-9_+\\\\-])*)","model":"$1"},{"regex":"USCCHTC(\\\\d+)","model":"$1"},{"regex":"Sprint (ATP.*) Build","device":"tablet","model":"$1 (Sprint)"},{"regex":"Sprint (APA.*) Build","model":"$1 (Sprint)"},{"regex":"(?:HTC-)?HTC(?:[\\\\-/ ])?([a-z0-9\\\\-_]+)","model":"$1"},{"regex":"HTC;(?: )?([a-z0-9 ]+)","model":"$1"},{"regex":"(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\\\))","model":"$1 $2"},{"regex":"(Amaze[ _]4G|One ?[XELSV\\\\+]*) Build","model":"$1"},{"regex":"(ADR[^;/]+) Build","model":"$1"},{"regex":"(ADR[a-z0-9]+)","model":"$1"},{"regex":"(One M8)","model":"$1"},{"regex":"0PAJ5(?:[);/ ]|$)","model":"One E8"},{"regex":"HTV32(?:[);/ ]|$)","model":"10"},{"regex":"HTV31(?:[);/ ]|$)","model":"J Butterfly"}]},"Microsoft":{"regex":"KIN\\\\.(One|Two)|RM-(?:1010|1031|106[57]|107[23467]|1089|109[02]|1096|1099|1109|111[348]|1127|1141|115[24]|994)|Microsoft; Lumia|Lumia (?:1530|1320|950|850|650|640|550|535|435)|Corporation/Surface","device":"smartphone","models":[{"regex":"KIN\\\\.(One|Two)","device":"feature phone","model":"Kin $1"},{"regex":"RM-1099|Lumia 430","model":"Lumia 430"},{"regex":"RM-1114|Lumia 435","model":"Lumia 435"},{"regex":"RM-1031|Lumia 532","model":"Lumia 532"},{"regex":"Lumia 535 Dual SIM","model":"Lumia 535 Dual SIM"},{"regex":"RM-109[02]|RM-1089|Lumia 535","model":"Lumia 535"},{"regex":"RM-1141|Lumia 540","model":"Lumia 540"},{"regex":"RM-1127|Lumia 550","model":"Lumia 550"},{"regex":"RM-1010","model":"Lumia 638"},{"regex":"Lumia 640 XL LTE","model":"Lumia 640 XL LTE","device":"phablet"},{"regex":"RM-106[57]|RM-1096|Lumia 640 XL","model":"Lumia 640 XL","device":"phablet"},{"regex":"Lumia 640 LTE Dual SIM","model":"Lumia 640 LTE Dual SIM"},{"regex":"Lumia 640 LTE","model":"Lumia 640 LTE"},{"regex":"Lumia 640 Dual SIM","model":"Lumia 640 Dual SIM"},{"regex":"RM-1109|RM-1113|RM-107[23467]|Lumia 640","model":"Lumia 640"},{"regex":"RM-1154|Lumia 650","model":"Lumia 650"},{"regex":"RM-1152","model":"Lumia 650 SS"},{"regex":"Lumia 850","model":"Lumia 850"},{"regex":"Lumia 950 XL Dual SIM","model":"Lumia 950 XL Dual SIM","device":"phablet"},{"regex":"Lumia 950 XL","model":"Lumia 950 XL","device":"phablet"},{"regex":"Lumia 950 Dual SIM","model":"Lumia 950 Dual SIM"},{"regex":"Lumia 950|RM-1118","model":"Lumia 950"},{"regex":"RM-994|Lumia 1320","model":"Lumia 1320"},{"regex":"Lumia 1530","model":"Lumia 1530"},{"regex":"Surface Book 3","device":"desktop","model":"Surface Book 3"},{"regex":"Surface Pro( [34])?","device":"desktop","model":"Surface Pro$1"},{"regex":"Microsoft; Lumia ([^;/)]+)(?:[;/)]|$)","model":"Lumia $1"}]},"Nokia":{"regex":"Nokia(?!Browser|Webview|; GT-I8750)|Lumia|Maemo RX|portalmmm/2\\\\.0 N7|portalmmm/2\\\\.0 NK|nok[0-9]+|Symbian.*\\\\s([a-z0-9]+)$|RX-51 N900|TA-[0-9]{4}|ARM; 909","device":"smartphone","models":[{"regex":"TA-10(07|23|29|35)","model":"2"},{"regex":"TA-10(20|28|32|38)","model":"3"},{"regex":"TA-10(24|27|44|53)","model":"5"},{"regex":"TA-10(00|03|21|25|33|39|54)","model":"6"},{"regex":"TA-1041","model":"7"},{"regex":"TA-10(04|12|52)","model":"8"},{"regex":"Nokia 8\\\\.1","model":"8.1"},{"regex":"Nokia 8 Sirocco","model":"8 Sirocco"},{"regex":"Nokia 7\\\\.1","model":"7.1"},{"regex":"Nokia 7 plus","model":"7 plus"},{"regex":"Nokia 6\\\\.1 Plus","model":"6.1 Plus"},{"regex":"Nokia 6\\\\.1","model":"6.1"},{"regex":"Nokia 5\\\\.1 Plus","model":"5.1 Plus"},{"regex":"Nokia 5\\\\.1","model":"5.1"},{"regex":"Nokia 3\\\\.1 Plus","model":"3.1 Plus"},{"regex":"Nokia 3\\\\.1","model":"3.1"},{"regex":"Nokia 2\\\\.1","model":"2.1"},{"regex":"Nokia 1 Plus","model":"1 Plus"},{"regex":"Nokia 1","model":"1"},{"regex":"RX-51 N900","model":"N900"},{"regex":"(?: )?(Nokia500|nokiaasha500(?:dualsim)?)(?: Build|[_);/])","model":"Asha 500"},{"regex":"Nokia5130c(?:-2)?","model":"5130 XpressMusic"},{"regex":"Nokia5230","model":"Nuron"},{"regex":"Nokia5233","model":"5233"},{"regex":"Nokia5800d-1","model":"5800 XpressMusic"},{"regex":"Nokia6210Navigator","model":"Navigator"},{"regex":"Nokia8800e?","model":"Sapphire Arte"},{"regex":"NOKIA-RH-17","model":"2280"},{"regex":"NOKIA-RH-27","model":"6225"},{"regex":"NOKIA-RH-34","model":"6585"},{"regex":"NOKIA-RH-48","model":"3105"},{"regex":"NOKIA-RM-11","model":"3205"},{"regex":"Nokia808 PureView","model":"808 PureView"},{"regex":"Nokia ?([0-9]{4})c(?:-)?","model":"$1 Classic"},{"regex":"Nokia ?([0-9]{4})s(?:-)?","model":"$1 Slide"},{"regex":"Nokia ?([0-9]{4})","model":"$1"},{"regex":"(?: )?Nokia([235][0-9]{2})(?: Build|[_);/])","model":"Asha $1"},{"regex":"Nokia([CEX]-?[0-9]{1,2}i?)-[0-9]{1,2}u?(?: Build|[_);/])","model":"$1"},{"regex":"Nokia;? 520T","model":"Lumia 520T"},{"regex":"RM-91[45]","model":"Lumia 520"},{"regex":"RM-997|Nokia 526","model":"Lumia 526"},{"regex":"RM-846","model":"Lumia 620"},{"regex":"RM-97[68]","model":"Lumia 630"},{"regex":"RM-97[45]","model":"Lumia 635"},{"regex":"RM-1027","model":"Lumia 636"},{"regex":"NOKIA;? 710","model":"Lumia 710"},{"regex":"Nokia;? 720T","model":"Lumia 720T"},{"regex":"RM-885","model":"Lumia 720"},{"regex":"Lumia 730","model":"Lumia 730"},{"regex":"RM-103[89]","model":"Lumia 735"},{"regex":"Nokia;? 800C","model":"Lumia 800C"},{"regex":"Nokia;? 800","model":"Lumia 800"},{"regex":"Nokia 820","model":"Lumia 820"},{"regex":"RM-984","model":"Lumia 830"},{"regex":"Nokia;? 900","model":"Lumia 900"},{"regex":"(RM-82[12]|Nokia;? 920)(?: Build|[_);/])","model":"Lumia 920"},{"regex":"(RM-89[23]|RM-910|Nokia;? 925)(?: Build|[a_);/])","model":"Lumia 925"},{"regex":"Lumia 929","model":"Lumia Icon"},{"regex":"RM-1045","model":"Lumia 930"},{"regex":"(ARM; 909|NOKIA;? 909|NOKIA; id300)(?: Build|[_);/])","model":"Lumia 1020"},{"regex":"NOKIA;? 1520\\\\.1","model":"Lumia 1520.1"},{"regex":"Nokia ([A-Za-z0-9\\\\. ]+)(?: Build|\\\\))","model":"$1"},{"regex":"Nokia(N[0-9]+)","model":"$1"},{"regex":"Nokia-([a-z0-9]+)","model":"N$1"},{"regex":"NOKIA; (?!Qt;)([a-z0-9\\\\- ]+)","model":"$1"},{"regex":"NOKIA[ _]?([a-z0-9\\\\-]+)","model":"$1"},{"regex":"NOKIA/([a-z0-9 ]+)","model":"$1"},{"regex":"(Lumia [a-z0-9\\\\-]+ XL)","device":"phablet","model":"$1"},{"regex":"(Lumia [a-z0-9\\\\-]+)","model":"$1"},{"regex":"Maemo RX-51 ([a-z0-9]+)","model":"$1"},{"regex":"Maemo RX-34","model":"N800"},{"regex":"NokiaInternal|Nokia-WAP-Toolkit|Nokia-MIT-Browser|Nokia Mobile|Nokia Browser|Nokia/Series","model":""},{"regex":"portalmmm/2\\\\.0 (N7[37]|NK[a-z0-9]+)","model":"$1"},{"regex":"nok([0-9]+)","model":"$1"},{"regex":"Symbian.*\\\\s([a-z0-9]+)$","device":"feature phone","model":"$1"}]},"CnM":{"regex":"CnM","device":"tablet","models":[{"regex":"CnM[ \\\\-](?:Touchpad|TP)[ \\\\-]([0-9\\\\.]+)","model":"Touchpad $1"}]},"RIM":{"regex":"BB10;|BlackBerry|rim[0-9]+|PlayBook|STV100-[1234]|STH100-[12]|BBA100-[12]|BBB100-[1234567]|BBD100-[126]|BB[EF]100-[123456789]|BB[CGH]100-1","device":"smartphone","models":[{"regex":"BBA100-[12]","model":"BlackBerry DTEK60"},{"regex":"BBB100-[1234567]","model":"KEYone"},{"regex":"BBC100-1","model":"Aurora"},{"regex":"BBD100-[126]","model":"Motion"},{"regex":"BBE100-[123456789]","model":"KEY2 LE"},{"regex":"BBF100-[1234567]","model":"KEY2"},{"regex":"BBF100-8","model":"KEY2 Silver"},{"regex":"BBF100-9","model":"KEY2 Black"},{"regex":"BBG100-1","model":"Evolve"},{"regex":"BBH100-1","model":"Evolve X"},{"regex":"STV100-[1234]","model":"BlackBerry Priv"},{"regex":"STH100-[12]","model":"BlackBerry DTEK50"},{"regex":"BB10; ([a-z0-9\\\\- ]+)\\\\)","model":"BlackBerry $1"},{"regex":"PlayBook.+RIM Tablet OS","model":"BlackBerry Playbook","device":"tablet"},{"regex":"BlackBerry(?: )?([a-z0-9]+)","model":"BlackBerry $1"},{"regex":"rim([0-9]+)","model":"BlackBerry $1"},{"regex":"9000","model":"Bold 9000"},{"regex":"9300","model":"Curve 3G 9300"},{"regex":"(8520|8530|9220|9320|9360)","model":"Curve $1"},{"regex":"9630","model":"Tour 9630"},{"regex":"9720","model":"9720"},{"regex":"(9800|9860)","model":"Torch $1"},{"regex":"BlackBerry","model":"BlackBerry"}]},"CHIA":{"regex":"(SVEGLIO[ _][QH]1|TREO_TAB8G|GTA7WF)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"SVEGLIO[ _]([QH]1)","model":"Sveglio $1"},{"regex":"TREO_TAB8G","device":"tablet","model":"TREO TAB8G"},{"regex":"GTA7WF","device":"tablet","model":"GTA7WF"}]},"Palm":{"regex":"(?:Pre|Pixi)/(\\\\d+)\\\\.(\\\\d+)|Palm|Treo|Xiino","device":"smartphone","models":[{"regex":"((?:Pre|Pixi))/(\\\\d+\\\\.\\\\d+)","model":"$1 $2"},{"regex":"Palm(?:[ \\\\-])?((?!OS|Source|scape)[a-z0-9]+)","model":"$1"},{"regex":"Treo([a-z0-9]+)","model":"Treo $1"},{"regex":"Tungsten","model":"Tungsten"},{"regex":"Xiino|Palmscape","model":""}]},"HP":{"regex":"Hewlett-Packard|HP/HP|HP EliteBook 820|TouchPad/\\\\d+\\\\.\\\\d+|hp-tablet|HP ?iPAQ|webOS.*P160U|HP (?:Pro )?Slate|HP [78]|HP 10 Plus|Compaq [7|8]|HP; [^;/)]+","device":"smartphone","models":[{"regex":"HP Slate 6 Voice Tab","model":"Slate 6 VoiceTab","device":"phablet"},{"regex":"HP 10 Plus","model":"10 Plus","device":"tablet"},{"regex":"HP ([78][^)/;]*)(?: Build|\\\\))","model":"Slate $1","device":"tablet"},{"regex":"Compaq ([78][^/;]*) Build","model":"Compaq $1","device":"tablet"},{"regex":"HP Pro Slate 8","model":"Pro Slate 8","device":"tablet"},{"regex":"HP Slate ?(.+) Build","model":"Slate $1","device":"tablet"},{"regex":"HP Slate ?([0-9]+)","model":"Slate $1","device":"tablet"},{"regex":"TouchPad/(\\\\d+\\\\.\\\\d+)|hp-tablet","model":"TouchPad","device":"tablet"},{"regex":"HP; ([^;/)]+)","model":"$1"},{"regex":"HP ?iPAQ ?([a-z0-9]+)","model":"iPAQ $1"},{"regex":"webOS.*(P160U)","model":"Veer"},{"regex":"HP ProBook (6560b)","device":"desktop","model":"ProBook $1"},{"regex":"HP EliteBook 820 G2","device":"desktop","model":"EliteBook 820 G2"},{"regex":"Z240 Tower Workstation","device":"desktop","model":"Z240 Tower Workstation"}]},"TiPhone":{"regex":"TiPhone ?([a-z0-9]+)","device":"smartphone","model":"$1"},"Apple":{"regex":"(?:iTunes-)?Apple[ _]?TV|Apple/|(?:Apple-|iTunes-)?(?<!like )(?:iPad|iPhone)|iPh[0-9],[0-9]|CFNetwork|HomePod|Watch ?OS|Watch1,[12]|MDCR_Mac|ICRU_iP(?:ad|hone)","models":[{"regex":"HomePod","device":"smart speaker","model":"HomePod"},{"regex":"Watch1,1","device":"wearable","model":"Watch 38mm"},{"regex":"Watch1,2","device":"wearable","model":"Watch 42mm"},{"regex":"Watch2,6","device":"wearable","model":"Watch Series 1 38mm"},{"regex":"Watch2,7","device":"wearable","model":"Watch Series 1 42mm"},{"regex":"Watch2,3","device":"wearable","model":"Watch Series 2 38mm"},{"regex":"Watch2,4","device":"wearable","model":"Watch Series 2 42mm"},{"regex":"Watch3,[13]","device":"wearable","model":"Watch Series 3 38mm"},{"regex":"Watch3,[24]","device":"wearable","model":"Watch Series 3 42mm"},{"regex":"Watch5,(?:9|11)","device":"wearable","model":"Watch SE 40mm"},{"regex":"Watch5,1[02]","device":"wearable","model":"Watch SE 44mm"},{"regex":"Watch([456]),[13]","device":"wearable","model":"Watch Series $1 40mm"},{"regex":"Watch([456]),[24]","device":"wearable","model":"Watch Series $1 44mm"},{"regex":"(?:.+_)?MacBook7(?:%2C|,)1","device":"desktop","model":"MacBook 13\\" (2010)"},{"regex":"(?:.+_)?MacPro5(?:%2C|,)1","device":"desktop","model":"Mac Pro (2010-2012)"},{"regex":"(?:.+_)?iMac12(?:%2C|,)1","device":"desktop","model":"iMac 21.5\\" (2011)"},{"regex":"(?:.+_)?iMac17(?:%2C|,)1","device":"desktop","model":"iMac 27\\" (2015)"},{"regex":"(?:.+_)?iMac19(?:%2C|,)2","device":"desktop","model":"iMac 21.5\\" (2019)"},{"regex":"(?:.+_)?iMac19(?:%2C|,)1","device":"desktop","model":"iMac 27\\" (2019)"},{"regex":"(?:.+_)?iMac20(?:%2C|,)[12]","device":"desktop","model":"iMac 27\\" (2020)"},{"regex":"(?:.+_)?iMac14(?:%2C|,)2","device":"desktop","model":"iMac 27\\" (2013)"},{"regex":"(?:.+_)?iMac14(?:%2C|,)4","device":"desktop","model":"iMac 21.5\\" (2014)"},{"regex":"(?:.+_)?iMac14(?:%2C|,)1","device":"desktop","model":"iMac 21.5\\" (2013)"},{"regex":"(?:.+_)?MacBook6(?:%2C|,)1","device":"desktop","model":"MacBook 13\\" (2009)"},{"regex":"(?:.+_)?MacBook8(?:%2C|,)1","device":"desktop","model":"MacBook 12\\" (2015)"},{"regex":"(?:.+_)?MacBook9(?:%2C|,)1","device":"desktop","model":"MacBook 12\\" (2016)"},{"regex":"(?:.+_)?iMac10(?:%2C|,)1","device":"desktop","model":"iMac (2009)"},{"regex":"(?:.+_)?MacBookAir2(?:%2C|,)1","device":"desktop","model":"MacBook Air (2009)"},{"regex":"(?:.+_)?MacBookAir3(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2010)"},{"regex":"(?:.+_)?MacBookAir3(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2010)"},{"regex":"(?:.+_)?MacBookAir4(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2011)"},{"regex":"(?:.+_)?MacBookAir4(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2011)"},{"regex":"(?:.+_)?MacBookAir5(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2012)"},{"regex":"(?:.+_)?MacBookAir5(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2012)"},{"regex":"(?:.+_)?MacBookAir6(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2013-2014)"},{"regex":"(?:.+_)?MacBookAir6(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2013-2014)"},{"regex":"(?:.+_)?MacBookAir7(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2015)"},{"regex":"(?:.+_)?MacBookAir7(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2015-2017)"},{"regex":"(?:.+_)?MacBookAir8(?:%2C|,)1","device":"desktop","model":"MacBook Air 13\\" (2018)"},{"regex":"(?:.+_)?MacBookAir8(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2019)"},{"regex":"(?:.+_)?MacBookAir9(?:%2C|,)1","device":"desktop","model":"MacBook Air 13\\" (2020)"},{"regex":"(?:.+_)?MacBookAir10(?:%2C|,)1","device":"desktop","model":"MacBook Air 13\\" (2020)"},{"regex":"(?:.+_)?MacBookPro1(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2006)"},{"regex":"(?:.+_)?MacBookPro1(?:%2C|,)2","device":"desktop","model":"MacBook Pro 17\\" (2006)"},{"regex":"(?:.+_)?MacBookPro2(?:%2C|,)1","device":"desktop","model":"MacBook Pro 17\\" (2007)"},{"regex":"(?:.+_)?MacBookPro2(?:%2C|,)2","device":"desktop","model":"MacBook Pro 15\\" (2007)"},{"regex":"(?:.+_)?MacBookPro[34](?:%2C|,)1","device":"desktop","model":"MacBook Pro (2008)"},{"regex":"(?:.+_)?MacBookPro5(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2008)"},{"regex":"(?:.+_)?MacBookPro5(?:%2C|,)2","device":"desktop","model":"MacBook Pro 17\\" (2009)"},{"regex":"(?:.+_)?MacBookPro5(?:%2C|,)[34]","device":"desktop","model":"MacBook Pro 15\\" (2009)"},{"regex":"(?:.+_)?MacBookPro5(?:%2C|,)5","device":"desktop","model":"MacBook Pro 13\\" (2009)"},{"regex":"(?:.+_)?MacBookPro6(?:%2C|,)1","device":"desktop","model":"MacBook Pro 17\\" (2010)"},{"regex":"(?:.+_)?MacBookPro6(?:%2C|,)2","device":"desktop","model":"MacBook Pro 15\\" (2010)"},{"regex":"(?:.+_)?MacBookPro7(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2010)"},{"regex":"(?:.+_)?MacBookPro8(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2011)"},{"regex":"(?:.+_)?MacBookPro8(?:%2C|,)2","device":"desktop","model":"MacBook Pro 15\\" (2011)"},{"regex":"(?:.+_)?MacBookPro8(?:%2C|,)3","device":"desktop","model":"MacBook Pro 17\\" (2011)"},{"regex":"(?:.+_)?MacBookPro9(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2012)"},{"regex":"(?:.+_)?MacBookPro9(?:%2C|,)2","device":"desktop","model":"MacBook Pro 13\\" (2012)"},{"regex":"(?:.+_)?MacBookPro10(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2012-2013)"},{"regex":"(?:.+_)?MacBookPro10(?:%2C|,)2","device":"desktop","model":"MacBook Pro 13\\" (2012-2013)"},{"regex":"(?:.+_)?MacBookPro11(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2013-2014)"},{"regex":"(?:.+_)?MacBookPro11(?:%2C|,)[23]","device":"desktop","model":"MacBook Pro 15\\" (2013-2014)"},{"regex":"(?:.+_)?MacBookPro11(?:%2C|,)[45]","device":"desktop","model":"MacBook Pro 15\\" (2015)"},{"regex":"(?:.+_)?MacBookPro12(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2015)"},{"regex":"(?:.+_)?MacBookPro13(?:%2C|,)[12]","device":"desktop","model":"MacBook Pro 13\\" (2016)"},{"regex":"(?:.+_)?MacBookPro13(?:%2C|,)3","device":"desktop","model":"MacBook Pro 15\\" (2016)"},{"regex":"(?:.+_)?MacBookPro14(?:%2C|,)[12]","device":"desktop","model":"MacBook Pro 13\\" (2017)"},{"regex":"(?:.+_)?MacBookPro14(?:%2C|,)3","device":"desktop","model":"MacBook Pro 15\\" (2017)"},{"regex":"(?:.+_)?MacBookPro15(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2018-2019)"},{"regex":"(?:.+_)?MacBookPro15(?:%2C|,)2","device":"desktop","model":"MacBook Pro 13\\" (2018-2019)"},{"regex":"(?:.+_)?MacBookPro15(?:%2C|,)3","device":"desktop","model":"MacBook Pro 15\\" (2019)"},{"regex":"(?:.+_)?MacBookPro15(?:%2C|,)4","device":"desktop","model":"MacBook Pro 13\\" (2019)"},{"regex":"(?:.+_)?MacBookPro16(?:%2C|,)[14]","device":"desktop","model":"MacBook Pro 16\\" (2019)"},{"regex":"(?:.+_)?MacBookPro16(?:%2C|,)[23]","device":"desktop","model":"MacBook Pro 13\\" (2020)"},{"regex":"(?:.+_)?MacBookPro17(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2020)"},{"regex":"(?:.+_)?Macmini8(?:%2C|,)1","device":"desktop","model":"Mac Mini (2018)"},{"regex":"(?:.+_)?Macmini9(?:%2C|,)1","device":"desktop","model":"Mac Mini (2020)"},{"regex":"(?:.+_)?Macmini7(?:%2C|,)1","device":"desktop","model":"Mac Mini (2014)"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?1[C,_]1","model":"iPhone","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?1[C,_]2","model":"iPhone 3G","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?2[C,_]1| 3GS\\\\)$","model":"iPhone 3GS","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?3[C,_][123]","model":"iPhone 4","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?4[C,_]1|1C2%254enohPi| 4S\\\\)$","model":"iPhone 4S","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?5[C,_][12]| 5\\\\)$","model":"iPhone 5","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?5[C,_][34]","model":"iPhone 5C","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?6[C,_][12]| 5S\\\\)$","model":"iPhone 5S","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?7[C,_]1|1C2%257enohPi| 6PLUS\\\\)$","model":"iPhone 6 Plus","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?7[C,_]2| 6\\\\)$","model":"iPhone 6","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?8[C,_]2| 6SPLUS\\\\)$","model":"iPhone 6s Plus","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?8[C,_]1|iPhone 6s| 6S\\\\)$","model":"iPhone 6s","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?8[C,_]4| SE\\\\)$","model":"iPhone SE","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?9[C,_][13]| 7\\\\)$","model":"iPhone 7","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?9[C,_][24]| 7PLUS\\\\)$","model":"iPhone 7 Plus","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?10[C,_][14]| 8\\\\)$","model":"iPhone 8","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?10[C,_][25]| 8PLUS\\\\)$","model":"iPhone 8 Plus","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?10[C,_][36]|iPhone X| X\\\\)$","model":"iPhone X","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?11[C,_][2]| XS\\\\)$","model":"iPhone XS","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?11[C,_][46]| XSMAX\\\\)$","model":"iPhone XS Max","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?11[C,_][8]| XR\\\\)$","model":"iPhone XR","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?12[C,_][1]| 11\\\\)$","model":"iPhone 11","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?12[C,_][3]| 11PRO\\\\)$","model":"iPhone 11 Pro","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?12[C,_][5]| 11PROMAX\\\\)$","model":"iPhone 11 Pro Max","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?12[C,_][8]","model":"iPhone SE (2020)","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?13[C,_][1]","model":"iPhone 12 Mini","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?13[C,_][2]","model":"iPhone 12","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?13[C,_][3]","model":"iPhone 12 Pro","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?13[C,_][4]","model":"iPhone 12 Pro Max","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPad1[C,_]1","model":"iPad","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad2[C,_][1234]","model":"iPad 2","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad2[C,_][567]","model":"iPad Mini","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad3[C,_][123]","model":"iPad 3","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad3[C,_][456]","model":"iPad 4","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad4[C,_][123]","model":"iPad Air","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad4[C,_][456]","model":"iPad Mini 2","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad4[C,_][789]","model":"iPad Mini 3","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad5[C,_][12]","model":"iPad Mini 4","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad5[C,_][34]","model":"iPad Air 2","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad6[C,_][34]","model":"iPad Pro 9.7","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad6[C,_][78]","model":"iPad Pro 12.9","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad6[C,_](?:11|12)","model":"iPad 5 9.7","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad7[C,_][12]","model":"iPad Pro 2 12.9","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad7[C,_][34]","model":"iPad Pro 10.5","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad7[C,_][56]","model":"iPad 6 9.7","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad7[C,_](?:11|12)","model":"iPad 7 10.2","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad8[C,_](?:9|10)","model":"iPad Pro 2 11\\"","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad8[C,_]1[12]","model":"iPad Pro 4 12.9\\"","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad8[C,_][1-4]","model":"iPad Pro 3 11.0","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad8[C,_][5-8]","model":"iPad Pro 3 12.9","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad11[C,_][12]","model":"iPad Mini 5","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad11[C,_][34]","model":"iPad Air 3","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad11[C,_][67]","model":"iPad 8 10.2\\"","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad13[C,_][12]","model":"iPad Air 4","device":"tablet"},{"regex":"Apple-?TV2[C,_]1","model":"Apple TV 2","device":"tv"},{"regex":"Apple-?TV3[C,_][12]","model":"Apple TV 3","device":"tv"},{"regex":"Apple-?TV5[C,_]3","model":"Apple TV 4","device":"tv"},{"regex":"Apple-?TV6[C,_]2","model":"Apple TV 4K","device":"tv"},{"regex":"(?:iTunes-)?Apple[ _]?TV","model":"Apple TV","device":"tv"},{"regex":"HomePod","model":"HomePod","device":"smart speaker"},{"regex":"iTunes-iPad/[0-9]+(?:\\\\.[0-9]+)* \\\\(([^;]+);","model":"iPad $1","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad","model":"iPad","device":"tablet"},{"regex":"iTunes-iPhone/[0-9]+(?:\\\\.[0-9]+)* \\\\(([^;]+);","model":"iPhone $1","device":"smartphone"},{"regex":"(?:Apple-)?iPhone ?(3GS?|4S?|5[CS]?|6(:? Plus)?)?","model":"iPhone $1","device":"smartphone"}]},"MicroMax":{"regex":"(?:MicroMax[ \\\\-\\\\_]?[a-z0-9]+|Q327)|4560MMX|P70221|(?:YU(?:5040|5530)|AQ5001(?: Canvas Power)?|N8216|N8301)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"AQ5001 Canvas Power","model":"Canvas Power"},{"regex":"AQ5001","model":"Canvas Juice 2"},{"regex":"4560MMX(?:[);/ ]|$)","model":"4560MMX"},{"regex":"E481","model":"Canvas 5"},{"regex":"P70221(?:[);/ ]|$)","model":"Canvas Tab","device":"tablet"},{"regex":"Q327","model":"Bolt"},{"regex":"Q417","model":"Canvas Mega"},{"regex":"Q402\\\\+","model":"Bolt Pace"},{"regex":"YU5040(?:[);/ ]|$)","model":"YU Yureka YU5040"},{"regex":"YU5530(?:[);/ ]|$)","model":"YU Yureka S YU5530"},{"regex":"Q424","model":"Bolt Selfie"},{"regex":"Q426","model":"Canvas Mega 2"},{"regex":"N8216","model":"Infinity N11"},{"regex":"N8301","model":"Infinity N12"},{"regex":"MicroMax(?:[ \\\\-\\\\_])?(X291|X246|X252|X458|X312)","model":"$1","device":"feature phone"},{"regex":"MicroMax(?:[ \\\\-\\\\_])?(P[a-z0-9]+)","model":"$1","device":"tablet"},{"regex":"MicroMax(?:[ \\\\-\\\\_])?([a-z0-9]+)","model":"$1"}]},"3Q":{"regex":"AC0731B|AC1024C|AC7803C|BC9710AM|EL72B|LC0720C|LC0723B|LC0725B|LC0804B|LC0808B|LC0809B|LC0810C|LC0816C|LC0901D|LC1016C|MT0724B|MT0729[BD]|MT0811B|OC1020A|RC0709B|RC0710B|RC0718C|RC0719H|RC0721B|RC0722C|RC0726B|RC0734H|RC0743H|RC0817C|RC1018C|RC1019G|RC1025F|RC1301C|RC780[24]F|RC9711B|RC9712C|RC9716B|RC9717B|RC9724C|RC9726C|RC9727F|RC9730C|RC9731C|TS0807B|TS1013B|VM0711A|VM1017A|RC0813C|QS9719D|QS9718C|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT7801C|TS9708B|AC0732C|MT0739D|MT0812E|(?:3Q_)?ER71B","device":"tablet","models":[{"regex":"MT0724B|LC0901D|LC0816C|LC0810C|LC0809B|LC0808B|LC0804B|LC0725B|LC0723B","model":"Qoo! P-Pad"},{"regex":"VM1017A|TS1013B|TS0807B|RC9731C|RC9730C|RC9727F|RC9726C|RC9724C|RC9717B|RC9716B|RC9712C|RC9711B|RC1301C|RC1025F|RC1019G|RC1018C|RC0817C|RC0813C|RC0743H|RC0734H|RC0726B|RC0722C|RC0721B|RC0719H|RC0718C|RC0710B|RC0709B|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT0811B|MT0739D|MT0729[BD]|LC1016C|LC0720C|BC9710AM|AC1024C|AC0731B","model":"Qoo! Q-Pad"},{"regex":"MT7801C|QS9718C|QS9719D|VM0711A|OC1020A","model":"Qoo! Surf"},{"regex":"TS9708B","model":"Surf TS1009B"},{"regex":"AC7803C|AC0732C","model":"Qoo! Lite"},{"regex":"MT0812E|RC7802F","model":"Qoo! Meta"},{"regex":"EL72B|(?:3Q_)?ER71B","model":"Qoo! Q-Book"},{"regex":"(RC7804F)","model":"Qoo! Glaze"}]},"4Good":{"regex":"4Good[ _]|S450m [43]G|S555m 4G|S501m 3G|T700i_3G|People (?:G503|G410|GT300)|Light (?:A103|B100)","device":"smartphone","models":[{"regex":"T700i_3G","model":"T700i 3G","device":"tablet"},{"regex":"People GT300","model":"People GT300","device":"tablet"},{"regex":"S555m[_ ]4G","model":"People"},{"regex":"(S(?:450m|501m)[_ ][43]G|Light (?:A103|B100)|People (?:G503|G410))","model":"$1"},{"regex":"4Good[ _]([^;/]+) Build","model":"$1"},{"regex":"4Good[ _]([^);/ ]+)","model":"$1"}]},"Acteck":{"regex":"BLECK","device":"tablet","model":"Bleck"},"Alba":{"regex":"Alba ?(?:57|4|10 TABLET|(?:7|10)(?:Nou|Pie))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Alba 57","model":"5.7"},{"regex":"Alba (4)","model":"$1"},{"regex":"10 TABLET","device":"tablet","model":"10 Tablet"},{"regex":"Alba((?:7|10)(?:Nou|Pie))","device":"tablet","model":"$1"}]},"AllCall":{"regex":"AllCall_|Heat[34]|Rio_X(?:[);/ ]|$)|Hot ?[125][^;/]+ Build","device":"smartphone","models":[{"regex":"AllCall_(Alpha|Atom|Bro|Madrid)","model":"$1"},{"regex":"AllCall_S1_X","model":"S1 X"},{"regex":"AllCall_S1","model":"S1"},{"regex":"AllCall_RIO_S","model":"Rio S"},{"regex":"AllCall_RIO_PRO","model":"Rio Pro"},{"regex":"AllCall_RIO","model":"Rio"},{"regex":"Heat([34])","model":"Heat $1"},{"regex":"Rio_X(?:[);/ ]|$)","model":"Rio X"},{"regex":"Hot ?([125][^;/]+) Build","model":"Hot $1"}]},"Bravis":{"regex":"Bravis[ _]|A501 Bright|A552 JOY Max|A504 Trace|A505 JOY Plus|A503 Joy|NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961|NP 104 3G|B501|N1-570 Space|Atlas A551|A512 Harmony Pro|A510_Jeans_4G|A509_Jeans|N1_550_Cruiser","device":"smartphone","models":[{"regex":"A501 BRIGHT","model":"A501 Bright"},{"regex":"Bravis[_ ]X500","model":"Trace Pro"},{"regex":"Bravis[_ ]A506","model":"Crystal"},{"regex":"Bravis[_ ]A553","model":"Discovery"},{"regex":"BRAVIS[ _]TAU","model":"Tau"},{"regex":"BRAVIS[ _]DELTA","model":"Delta"},{"regex":"BRAVIS[ _]TREND","model":"Trend"},{"regex":"B501","model":"Easy"},{"regex":"N1-570","model":"Space"},{"regex":"BRAVIS[ ]A554","model":"A554 Grand"},{"regex":"BRAVIS[ ]S500","model":"S500 Diamond"},{"regex":"A505 JOY Plus","model":"A505 Joy Plus"},{"regex":"A552 JOY Max","model":"A552 Joy Max"},{"regex":"Atlas A551","model":"A551 Atlas"},{"regex":"A503 Joy","model":"A503 Joy"},{"regex":"A504 Trace","model":"A504 Trace"},{"regex":"A512 Harmony Pro","model":"A512 Harmony Pro"},{"regex":"A510_Jeans_4G","model":"A510 Jeans 4G"},{"regex":"A509_Jeans","model":"A509 Jeans"},{"regex":"BRAVIS NEO","model":"A401 Neo"},{"regex":"N1_550_Cruiser","model":"N1-550 Cruiser"},{"regex":"BRAVIS OMEGA","model":"Omega"},{"regex":"BRAVIS BIZ","model":"Biz"},{"regex":"BRAVIS POWER","model":"Power"},{"regex":"BRAVIS[ _]SPARK","model":"Spark"},{"regex":"BRAVIS[ _]SLIM[ _]3G","model":"Slim 3G","device":"tablet"},{"regex":"NP 104 3G","model":"NP104 3G","device":"tablet"},{"regex":"BRAVIS NP 103","model":"NP103","device":"tablet"},{"regex":"BRAVIS NP 844","model":"NP844","device":"tablet"},{"regex":"Bravis[_ ]([^;\\\\)]+) Build","model":"$1"},{"regex":"(NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961)","model":"$1","device":"tablet"}]},"Acer":{"regex":"acer|(?<!Satellite |ZTE BLADE |ImSmart |ERGO |X-Style Tab )a(?:101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)|Android.*V3[67]0(?:[);/ ]|$)|Android.*Z1[23456]0 Build|Android.*Z5\\\\d{2} Build|Android.*T0[234678] Build|Android.*S55(?:[);/ ]|$)|(?:A1-(713(HD)?|7[23]4|830|841|840FHD|81[01])|A3-A[1234][01]|B1-(7[1235-8][01](HD)?|7[23]3|7A0|8[1235]0|A71|860A)|TPA60W|B3-(A[125]0|A3[02]|A40FHD)|E39)(?:[);/ ]|$)|S5[12]0 Build|(DA[0-9]+HQ?L|Aspire (?:V5-121|XC-704G|V5-573G)|Chromebook 14 \\\\(CB3-431\\\\)|Predator G9-793|GT-810|B1-870|B3-A4[02]|B3-A50FHD)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"DA220HQL(?:[);/ ]|$)","model":"DA220HQL","device":"smart display"},{"regex":"DA241HL(?:[);/ ]|$)","model":"DA241HL","device":"smart display"},{"regex":"(DA[0-9]+HQ?L)(?:[);/ ]|$)","model":"$1","device":"smart display"},{"regex":"A1-81[01]","model":"Iconia A","device":"tablet"},{"regex":"TPA60W","model":"TPA60W","device":"tablet"},{"regex":"A1-84(1|0FHD)","model":"Iconia Tab 8","device":"tablet"},{"regex":"A1-713(HD)?","model":"Iconia Tab 7","device":"tablet"},{"regex":"A1-830","model":"Iconia A1","device":"tablet"},{"regex":"A1-7[23]4","model":"Iconia Talk S","device":"tablet"},{"regex":"A3-A[12][01]","model":"Iconia A3","device":"tablet"},{"regex":"A3-A[34]0","model":"Iconia Tab 10","device":"tablet"},{"regex":"B1-7(?:[5678]0|30HD|A0)","model":"Iconia One 7","device":"tablet"},{"regex":"B1-7[123][01]|B1-A71","model":"Iconia B1","device":"tablet"},{"regex":"B1-7[23]3","model":"Iconia Talk 7","device":"tablet"},{"regex":"B1-8[123567]0","model":"Iconia One 8","device":"tablet"},{"regex":"B3-A([125]0|3[02]|[45]0FHD|4[02])","model":"Iconia One 10","device":"tablet"},{"regex":"A101","model":"Vangogh","device":"tablet"},{"regex":"A200","model":"Picasso E","device":"tablet"},{"regex":"A50[01]","model":"Picasso","device":"tablet"},{"regex":"Acer One 7","model":"One 7","device":"tablet"},{"regex":"GT-810","model":"Predator 8","device":"tablet"},{"regex":"E39(?:[);/ ]|$)","model":"Liquid E700"},{"regex":"E310(?:[);/ ]|$)","model":"Liquid Mini"},{"regex":"E320(?:-orange)?(?:[);/ ]|$)","model":"Liquid Express"},{"regex":"E310(?:[);/ ]|$)","model":"beTouch E210"},{"regex":"Android.*V360(?:[);/ ]|$)","model":"Liquid E1 Duo"},{"regex":"Android.*V370(?:[);/ ]|$)","model":"Liquid E2 Duo"},{"regex":"S510(?:[);/ ]|$)","model":"Liquid S1"},{"regex":"S520(?:[);/ ]|$)","model":"Liquid S2"},{"regex":"(?:Acer_)?P400(?:[);/ ]|$)","model":"neoTouch P400"},{"regex":"(?:Acer_)?P300(?:[);/ ]|$)","model":"neoTouch P300"},{"regex":"(?:Acer_)?S200(?:[);/ ]|$)","model":"neoTouch S200"},{"regex":"(?:Acer_)?E100(?:[);/ ]|$)","model":"beTouch E100"},{"regex":"Android.*Z1([234])0(?:[);/ ]|$)","model":"Liquid Z$1"},{"regex":"Android.*Z110(?:[);/ ]|$)","model":"Liquid Z110"},{"regex":"Android.*Z150(?:[);/ ]|$)","model":"Liquid Z5 Duo"},{"regex":"Android.*Z160(?:[);/ ]|$)","model":"Liquid Z4 Duo"},{"regex":"Android.*Z(5\\\\d{2})(?:[);/ ]|$)","model":"Liquid Z$1"},{"regex":"Android.*S57(?:[);/ ]|$)","model":"Liquid Jade Z"},{"regex":"Android.*T02(?:[);/ ]|$)","model":"Liquid Z530"},{"regex":"Android.*T03(?:[);/ ]|$)","model":"Liquid Z630"},{"regex":"Android.*T04(?:[);/ ]|$)","model":"Liquid Z630S"},{"regex":"Android.*T06(?:[);/ ]|$)","model":"Liquid Zest"},{"regex":"Android.*T07(?:[);/ ]|$)","model":"Liquid Zest 4G"},{"regex":"Android.*T08(?:[);/ ]|$)","model":"Liquid Zest Plus"},{"regex":"TM01(?:[);/ ]|$)","model":"Liquid M330"},{"regex":"M220(?:[);/ ]|$)","model":"Liquid M220"},{"regex":"AcerTD600","model":"TD600"},{"regex":"Android.*S55(?:[);/ ]|$)","model":"Liquid Jade"},{"regex":"(?:Acer )?(Chromebook R1[13])","model":"$1","device":"desktop"},{"regex":"(?:Acer )?(Chromebook 14)","model":"$1","device":"desktop"},{"regex":"(Aspire (?:V5-121|XC-704G|V5-573G|A515-51G))","model":"$1","device":"desktop"},{"regex":"(Predator G9-793|Aspire E5-511)","model":"$1","device":"desktop"},{"regex":"Acer; ?([^;\\\\(\\\\)/]+)","model":"$1"},{"regex":"Acer(?! ?inc)[ _\\\\-]?([^;\\\\(\\\\)/]+)[();/ ]","model":"$1"},{"regex":"acer[\\\\-_]([a-z0-9]+)","model":"$1"},{"regex":"a(101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)","model":"Iconia Tab A$1","device":"tablet"}]},"Advan":{"regex":"(?:ADVAN (?:M4|S40)|i7U|S45E|S50H|I7D|i55[KD]|i4U|S7D|S4Z|i5[KE]|S5E[ _]NXT|S5J\\\\+|S4\\\\+)(?:[);/ ]|$)|[ ](?:50(?:[46]1|59)|600[24])(?: Build|\\\\) AppleWebKit)|(?:E1C_3G)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ADVAN M4","model":"M4"},{"regex":"ADVAN S40","model":"S40"},{"regex":"i7U","model":"I Lite i7U"},{"regex":"S5E[ _]NXT","model":"S5E NXT"},{"regex":"i(55[KD]|5[KE])","model":"I$1"},{"regex":"i4U","model":"I4U"},{"regex":" 6004(?: Build|\\\\) AppleWebKit)","model":"G2 Pro"},{"regex":" 6002(?: Build|\\\\) AppleWebKit)","model":"G3 Pro"},{"regex":"(S45E|50[46]1|5059|S50H|I7D|S7D|S4Z|S5J\\\\+|S4\\\\+)(?:[);/ ]|$)","model":"$1"},{"regex":"E1C_3G","device":"tablet","model":"E1C 3G"}]},"Advance":{"regex":"Hollogram|(?:HL(?:4936|6246|[56]575|5[67]67)|IntroTr3544|Pr(?:61(?:4[56]|50)|60[27]0|5[69]50)|Tr3845)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"IntroTr3544|Tr3845","model":"Intro","device":"tablet"},{"regex":"Pr(61(?:4[56]|50)|60[27]0|5[69]50)","model":"Prime PR$1","device":"tablet"},{"regex":"HL(4936|6246|[56]575|5[67]67)","model":"Hollogram HL$1"},{"regex":"Hollogram ([^;/)]+)(?: Build|[;)])","model":"Hollogram $1"}]},"AGM":{"regex":"AGM ([^/;)]+)(?: Build|[;)])","device":"smartphone","model":"$1"},"Airness":{"regex":"AIRNESS-([\\\\w]+)","device":"feature phone","model":"$1"},"Aiwa":{"regex":"(?:AW790|M300|AWM(?:533|50[19]|561)|AW500)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"AW790(?:[);/ ]|$)","model":"AW790"},{"regex":"AW500(?:[);/ ]|$)","model":"AW500"},{"regex":"AWM(533|50[19]|561)(?:[);/ ]|$)","model":"AWM$1"},{"regex":"M300(?:[);/ ]|$)","model":"M300","device":"phablet"}]},"Akai":{"regex":"AKAI,|Akai[ _-]|Eco[ _]E2|Glory[ _](?:G[1235]|L[123]|O[125])|TAB-[79]8[03]0Q?|X6 METAL|AKTB-703MZ","device":"smartphone","models":[{"regex":"TAB-([79]8[03]0Q?)","device":"tablet","model":"TAB $1"},{"regex":"AKTB-703MZ","device":"tablet","model":"AKTB-703MZ"},{"regex":"X6 METAL","model":"iLike"},{"regex":"Glory[ _](G[1235]|L[123]|O[125])","model":"Glory $1"},{"regex":"Eco[ _]E2","model":"Eco E2"},{"regex":"Akai[ _-]([^;/)]+)(?: Build|[;)])","model":"$1"},{"regex":"AKAI,(AK3219NF)","device":"tv","model":"$1"},{"regex":"Si2157LG32","device":"tv","model":"Si2157LG32"}]},"Arian Space":{"regex":"Arian Space","device":"tablet","models":[{"regex":"100 ST1004PG","model":"100"},{"regex":"80 SS8003PG","model":"80"},{"regex":"71 ST7002PG","model":"71"},{"regex":"70 ST7001RW","model":"70"}]},"Alcatel":{"regex":"Alcatel|Alc(?!or )[a-z0-9]+|One[ _]?Touch|idol3|TIMXL|(?:(?:4003[AJ]|4009[ADEFIKMSX]|4013[DEJKMX]|4014[ADEKMX]|4015[ADNTX]|4016[ADX]|4017[ADEFSX]|4018[ADEFMX]|4024[EDX]|4027[ADNX]|4028[AEJS]|4032[ADEX]|4034[ADEFGXTL]|4035[ADXY]|4045[ADEX]|4047[ADFGNX]|4049[DEGMX]|4060[SW]|A466BG|A621BL|4114E|4087U|5001[ADJTU]|5002[ADFH]|5003[ADGU]|5006D|5007[AU]|5008[ADUYT]|5009[AD]|5010[DEGSUX]|5011A|5012[DFG]|5015[ADEX]|5016[AXJ]|5017[ABDEOX]|5019D|5022[EDX]|5023[EF]|5024[ADJF]|5025[DEG]|5026[ADJ]|5027B|5028[AYD]|5029[EYD]|5030[DE]|5032W|5033[AEFXDJGMOTXYQS]|5034D|5036D|5038[ADEX]|5039[DY]|5041[CD]|5042[ADEFGWXT]|5044[ADGIKOPSTY]|5045[ADFGIJTXY]|5046[ADGIJSTUY]|5047[DIUY]|5048[AYUI]|5049[EGSWZ]|5050[ASXY]|5051[ADEJMTWX]|5052[ADY]|5053[ADKY]|5054[ADNSTWX]|5056[ADEGIJMNTUWX]|5057M|5058[AIY]|5059[ADJXYZIST]|5060[ADJ]|5061[KU]|5065[ADNWX]|5070D|5080[ADFQUX]|5085[ABCDGHIJNOQY]|5086[ADY]|5090[AIY]|5095[IKY]|5098[OS]|5099[ADYUI]|5116J|5145A|6016[ADEX]|6036[AXY]|6037[BKY]|6039[AHJKY]|6042D|6043[AD]|6044D|6045[BFIKOYX]|6050[AFY]|6055[ABDHIKPUYZ]|6058[ADX]|6060[SX]|6062W|6070K|7040[ADEFKRT]|7041[DX]|7042A|7043[AEKY]|7044[AX]|7045Y|7048[ASWX]|7053D|7055A|7070X|7071[ADX]|8030Y|8050[DEGX]|8063|8088[XQM]|9001[DIX]|9002X|9003[AX]|9024O|9005X|9026X|9007[ATX]|9008[ADIJNTUX]|9009G|9010X|9020A|9022X|9027[FTWX]|9029Z|9203A|A(?:464BG|570BL|50[13]DL|57[17]VL|574BL)|I213|I216X|(?<!\\\\.)80(?:82|6[78])|A576CC)(?:_(?:EEA|RU))?|P360X)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"4087U","model":"1SE Light"},{"regex":"5022[EDX]|5070D","model":"One Touch Pop Star"},{"regex":"6044D","model":"One Touch Pop Up"},{"regex":"4015[ATX]|4016A","model":"One Touch Pop C1"},{"regex":"4015[DN]|4016[DX]","model":"One Touch Pop C1 Dual SIM"},{"regex":"4032[AX]","model":"One Touch Pop C2"},{"regex":"4032[DE]","model":"One Touch Pop C2 Dual SIM"},{"regex":"5036D","model":"One Touch Pop C5 Dual SIM"},{"regex":"7040[AFK]|7041X|7042A","model":"One Touch Pop C7"},{"regex":"7040[DE]|7041D","model":"One Touch Pop C7 Dual SIM"},{"regex":"4018[ADEFMX]","model":"One Touch Pop D1"},{"regex":"4035[ADXY]","model":"One Touch Pop D3"},{"regex":"5038[ADEX]","model":"One Touch Pop D5"},{"regex":"4045[AX]","model":"One Touch Pop 2 4\\""},{"regex":"4045[DE]","model":"One Touch Pop 2 4\\" Dual SIM"},{"regex":"5042[AFGWX]","model":"One Touch Pop 2 4.5\\""},{"regex":"5042[DE]","model":"One Touch Pop 2 4.5\\" Dual SIM"},{"regex":"7043[AY]|7044[AX]","model":"One Touch Pop 2 5\\""},{"regex":"7043[EK]","model":"One Touch Pop 2 5\\" Dual SIM"},{"regex":"50[16]5X","model":"One Touch Pop 3"},{"regex":"5015[AE]|5016[AJ]|5065[ADWX]|5116J","model":"One Touch Pop 3 5\\""},{"regex":"5025[DEG]|5054[ADSTX]","model":"One Touch Pop 3 5.5\\""},{"regex":"5015D","model":"One Touch Pop 3 Dual SIM"},{"regex":"5051[AEJMTWX]","model":"One Touch Pop 4"},{"regex":"5051D","model":"One Touch Pop 4 Dual SIM"},{"regex":"5095[IKY]","model":"One Touch Pop 4S"},{"regex":"5056[ADEGJMTUX]","model":"One Touch Pop 4+"},{"regex":"7070X","model":"One Touch Pop 4 6\\""},{"regex":"5057M","model":"One Touch Pop Mirage"},{"regex":"5050[ASXY]","model":"One Touch Pop S3"},{"regex":"7045Y","model":"One Touch Pop S7"},{"regex":"6037[BKY]","model":"One Touch Idol 2"},{"regex":"5042T","model":"One Touch Astro"},{"regex":"5027B","model":"One Touch Dawn"},{"regex":"5024[ADF]|5028Y","model":"1S"},{"regex":"7071[ADX]","model":"A7 XL"},{"regex":"5002[ADH]","model":"1B (2020)"},{"regex":"4034T","model":"1E"},{"regex":"5002F","model":"1A (2020)"},{"regex":"5034D","model":"3L"},{"regex":"A576CC","model":"Kora A576CC"},{"regex":"7040[RT]","model":"One Touch Fierce 2"},{"regex":"5056[NW]","model":"One Touch Fierce 4"},{"regex":"5054N","model":"One Touch Fierce XL"},{"regex":"6042D","model":"One Touch Flash"},{"regex":"6016[AX]","model":"One Touch Idol 2 mini"},{"regex":"6016[DE]","model":"One Touch Idol 2 mini Dual SIM"},{"regex":"6036[AXY]","model":"One Touch Idol 2 mini S"},{"regex":"6050[AFY]","model":"One Touch Idol 2S"},{"regex":"6039[AHJKY]|idol3","model":"One Touch Idol 3"},{"regex":"6045[BFIKOYX]","model":"One Touch Idol 3 5.5\\""},{"regex":"6055[ABDHIKPUYZ]","model":"One Touch Idol 4"},{"regex":"6070K","model":"One Touch Idol 4S"},{"regex":"6058[ADX]","model":"One Touch Idol 5"},{"regex":"6060[SX]","model":"One Touch Idol 5S"},{"regex":"6043[AD]","model":"One Touch Idol X+"},{"regex":"8030Y","model":"One Touch Hero 2"},{"regex":"7055A","model":"One Touch Hero 2C"},{"regex":"7053D","model":"One Touch X1"},{"regex":"5065N","model":"TRU"},{"regex":"A574BL","model":"Raven"},{"regex":"A577VL","model":"Zip"},{"regex":"A466BG","model":"Pixi Unite"},{"regex":"5056I","model":"One Touch Optus X Smart"},{"regex":"A570BL","model":"One Touch Pixi Avion LTE"},{"regex":"A571VL","model":"One Touch Pixi Avion 4G LTE"},{"regex":"4024[DEX]","model":"One Touch Pixi First"},{"regex":"A464BG","model":"One Touch Pixi Glitz"},{"regex":"A621BL","model":"One Touch Pixi Glory"},{"regex":"4014D","model":"One Touch Pixi 2"},{"regex":"4009[AFIKMSX]","model":"One Touch Pixi 3 3.5\\""},{"regex":"4009[DE]","model":"One Touch Pixi 3 3.5\\" Dual SIM"},{"regex":"4003[AJ]|4013[DEJKMX]|4014[AEKMX]|4114E","model":"One Touch Pixi 3 4\\""},{"regex":"4027[ADNX]|4028[AEJS]|5019D","model":"One Touch Pixi 3 4.5\\""},{"regex":"5017[ABDEOX]","model":"One Touch Pixi 3 4.5\\" 4G"},{"regex":"9002X","model":"One Touch Pixi 3 7\\"","device":"phablet"},{"regex":"9007A","model":"One Touch Pixi 3 7\\"","device":"tablet"},{"regex":"9007[TX]","model":"One Touch Pixi 3 7\\" 4G","device":"tablet"},{"regex":"9009G","model":"1T","device":"tablet"},{"regex":"(?!<\\\\.)8082(?:_(?:EEA|RU))?(?:[);/ ]|$)","model":"1T 10","device":"tablet"},{"regex":"(?!<\\\\.)806[78](?:_(?:EEA|RU))?(?:[);/ ]|$)","model":"1T 7","device":"tablet"},{"regex":"9022X","model":"One Touch Pixi 3 8\\"","device":"phablet"},{"regex":"9010X","model":"One Touch Pixi 3 10\\"","device":"tablet"},{"regex":"4017[ADEFSX]","model":"One Touch Pixi 4 3.5\\""},{"regex":"4034[ADEFGXL]","model":"One Touch Pixi 4 4\\""},{"regex":"4060[SW]","model":"One Touch Pixi 4 4.5\\""},{"regex":"5023[EF]","model":"One Touch Pixi 4 Plus Power"},{"regex":"5010[DEGSUX]","model":"One Touch Pixi 4 5\\" 3G"},{"regex":"5041D","model":"One Touch Pixi 4 5.0\\""},{"regex":"5012[DFG]","model":"One Touch Pixi 4 5.5\\" 3G"},{"regex":"5045[ADFGIJTXY]|5145A","model":"One Touch Pixi 4 5\\" 4G"},{"regex":"5098O","model":"One Touch Pixi Theatre"},{"regex":"A501DL","model":"A1"},{"regex":"A503DL","model":"A1X"},{"regex":"5046[ADIJTUY]","model":"A3"},{"regex":"5011A|5049[EG]","model":"A3 Plus"},{"regex":"9008[ADIJNTUX]","model":"A3 XL"},{"regex":"9203A","model":"A3 7\\" 3G","device":"tablet"},{"regex":"9027[FTWX]","model":"3T 8.0\\"","device":"tablet"},{"regex":"9026X","model":"A3 10\\"","device":"tablet"},{"regex":"5085[BQ]","model":"A5"},{"regex":"5085[ADHIJY]","model":"A5 LED"},{"regex":"5085N","model":"A5 Max LED"},{"regex":"5090[AIY]","model":"A7"},{"regex":"5046[GS]","model":"A30"},{"regex":"5049S","model":"A30 Plus"},{"regex":"5049Z","model":"A30 Fierce"},{"regex":"5085[GO]","model":"A50"},{"regex":"5048[AYUI]","model":"3X (2019)"},{"regex":"5049W","model":"Revvl"},{"regex":"8050[GX]","model":"One Touch Pixi 4 6\\" 3G"},{"regex":"8050[ED]","model":"One Touch Pixi 4 6\\" 3G Dual SIM"},{"regex":"5098S|9001[DIX]","model":"One Touch Pixi 4 6\\" 4G"},{"regex":"9003[AX]","model":"One Touch Pixi 4 7\\" 3G","device":"tablet"},{"regex":"8063","model":"One Touch Pixi 4 7\\" WiFi","device":"tablet"},{"regex":"9024O","model":"One Touch Pixi 5","device":"tablet"},{"regex":"I216X","model":"One Touch Pixi 7","device":"tablet"},{"regex":"I213","model":"One Touch Pixi 7","device":"tablet"},{"regex":"9005X","model":"One Touch Pixi 8","device":"tablet"},{"regex":"P320X","model":"One Touch POP 8","device":"tablet"},{"regex":"P310X","model":"One Touch POP 7","device":"tablet"},{"regex":"9020A","model":"One Touch Trek HD","device":"tablet"},{"regex":"7048[ASWX]","model":"One Touch Go Play"},{"regex":"(?:Alcatel-)?OT-802","model":"Wave"},{"regex":"ALCATEL_ONE_TOUCH_768T","model":"Island"},{"regex":"(?:TRIBE_)?3075A","model":"One Touch Tribe"},{"regex":"ALCATEL_one_touch_585","model":"One Touch 585"},{"regex":"ALCATEL_ONE_TOUCH_838","model":"One Touch 838"},{"regex":"ALCATEL_one_touch_813d","model":"One Touch 813D"},{"regex":"ALCATEL_one_touch_813","model":"One Touch 813"},{"regex":"OT871A","model":"One Touch 871A"},{"regex":"P360X","model":"One Touch Pop 10"},{"regex":"(?:Alcatel[ _])?One[ _]?Touch[ _]((?:T[0-9]+|TAB[^/;]+|EVO[78](?:HD)?)) Build","device":"tablet","model":"One Touch $1"},{"regex":"(?:Alcatel[ _])?One[ _]?Touch([^/;]*) Build","model":"One Touch$1"},{"regex":"(?:Alcatel[ _])?One[ _]?Touch([^/;\\\\)]*)\\\\)","model":"One Touch$1"},{"regex":"5080[ADFQUX]","model":"Shine Lite"},{"regex":"TIMXL","model":"TIM XL"},{"regex":"5085C","model":"PulseMix"},{"regex":"4049[DEGMX]","model":"U3"},{"regex":"5044[ADIKOPTY]","model":"U5"},{"regex":"4047[DFXN]","model":"U5 3G"},{"regex":"5047[DIUY]","model":"U5 HD"},{"regex":"4047G","model":"U5 Lite"},{"regex":"4047A","model":"U5 Plus"},{"regex":"4044[CV]","model":"Quick Flip"},{"regex":"4044O","model":"Cingular Flip 2"},{"regex":"(?:Alcatel)?4044[MNT]","model":"Go Flip"},{"regex":"5044[GS]","model":"U50"},{"regex":"5033[ADXJEFGMOTXYQS]","model":"1"},{"regex":"5009[AD]","model":"1C"},{"regex":"5008[ADUYT]","model":"1X (2019)"},{"regex":"5007[AU]","model":"1V (2020)"},{"regex":"5003[ADGU]","model":"1C (2019)"},{"regex":"5006D","model":"3C (2019)"},{"regex":"5024J","model":"1S"},{"regex":"5028[AD]","model":"1S (2020)"},{"regex":"5030[DE]","model":"1SE (2020)"},{"regex":"5001[ADJTU]","model":"1V"},{"regex":"5059[ADJXYZIT]","model":"1X"},{"regex":"5059S","model":"Avalon V"},{"regex":"5060[ADJ]","model":"5V","device":"phablet"},{"regex":"5052[ADY]|5053[ADKY]","model":"3"},{"regex":"5029E","model":"3 (2020)"},{"regex":"5029[DY]","model":"3L (2020)"},{"regex":"5032W|5099[ADYUI]","model":"3V"},{"regex":"5026[ADJ]","model":"3C"},{"regex":"5039[DY]","model":"3L","device":"phablet"},{"regex":"5058[AIY]","model":"3X"},{"regex":"5061[KU]","model":"3X (2020)"},{"regex":"5086[ADY]","model":"5"},{"regex":"6062W","model":"7"},{"regex":"8088[XQM]","model":"3T 10","device":"tablet"},{"regex":"9029Z","model":"Joy Tab","device":"tablet"},{"regex":"9029Z","model":"Joy Tab","device":"tablet"},{"regex":"Alcatel UP","model":""},{"regex":"(?:ALCATEL_)?A383G","model":"Big Easy Plus"},{"regex":"5041C","model":"TETRA"},{"regex":"ALCATEL([^/;]+) Build","model":"$1"},{"regex":"ALCATEL[ \\\\-]?([^/;\\\\)]+)","model":"$1"},{"regex":"ALCATEL_([^/;\\\\)]+)","model":"$1"},{"regex":"Alc([a-z0-9]+)","model":"$1"}]},"Allview":{"regex":"Allview|A4You|H1003_LTE_PRO|A5_(?:Easy(?:_TM)?|Ready(?:_TM)?|Quad|Quad_Plus_TM)|A[5-9]_Lite|A5Smiley|A6_Duo|A10_Lite_2019|A10_(?:Plus|Max)|AX2_Frenzy|AX4Nano|AX5NanoQ|C6_Duo|E[23]_Living|E3_(?:Jump|Sign)|E4_Lite|M9_Connect|P(?:43_Easy|[5689]_Energy|6_Energy_Lite|[68]_Energy_Mini(?:_TM)?|(41|[458])_eMagic(?:_TM)?|[589](?:_)?Life(?:_TM)?|[567]_Lite(?:_TM)?|6_plus|[45678]_Pro|7_Seon|10_Life|10_Max|10_Style|7_Xtreme|6_Qmax|4_Quad)|V(?:[134]_Viper|1_Viper_I|2_Viper_(?:E|I|S|X|X_plus|Xe))|X4_Soul_Vision|X(?:[1-46]_Soul_Xtreme|[1-5]_Soul|3_Soul_Lite|[2-6]_Soul_Mini(?:_TM)?|4_Soul_Mini_S(?:_TM)?|[2-5]_Soul_Style(?:_TM)?|2_Soul_Style_Plus|2_Twin)|Viva_(?:H801|100[13]G|(?:H100[12]|H701|H802)_LTE|C701|i701G)","device":"smartphone","models":[{"regex":"A4You","model":"A4 You"},{"regex":"AX2_Frenzy","model":"AX2 Frenzy","device":"tablet"},{"regex":"AX4Nano","model":"AX4 Nano"},{"regex":"AX5NanoQ","model":"AX5 Nano Q","device":"tablet"},{"regex":"C6_Duo","model":"C6 Duo"},{"regex":"E([23])_Living","model":"E$1 Living"},{"regex":"E3_Jump","model":"E3 Jump"},{"regex":"E3_Sign","model":"E3 Sign"},{"regex":"E4_Lite","model":"E4 Lite"},{"regex":"M9_Connect","model":"M9 Connect"},{"regex":"P43_Easy","model":"P43 Easy"},{"regex":"P(41|[458])_eMagic(?:_TM)?","model":"P$1 eMagic"},{"regex":"P([567])_Lite(?:_TM)?","model":"P$1 Lite"},{"regex":"P6_plus","model":"P6 Plus"},{"regex":"P6_Qmax","model":"P6 Qmax"},{"regex":"P([45678])_Pro","model":"P$1 Pro"},{"regex":"P4_Quad","model":"P4 Quad"},{"regex":"P9_Energy_Lite_2017","model":"P9 Energy Lite (2017)"},{"regex":"P9_Energy_S","model":"P9 Energy S"},{"regex":"P([69])_Energy_Lite","model":"P$1 Energy Lite"},{"regex":"P8_Energy_PRO","model":"P8 Energy Pro"},{"regex":"P([689])_Energy_mini(?:_TM)?","model":"P$1 Energy Mini"},{"regex":"P([5689])_Energy","model":"P$1 Energy"},{"regex":"P7_Seon","model":"P7 Seon"},{"regex":"P7_Xtreme","model":"P7 Xtreme"},{"regex":"P([589])(?:_)?Life(?:_TM)?","model":"P$1 Life"},{"regex":"P10_Life","model":"P10 Life"},{"regex":"P10_Max","model":"P10 Max"},{"regex":"P10_Style","model":"P10 Style"},{"regex":"V([12])_Viper_I4G(?:_TM)?","model":"V$1 Viper I 4G"},{"regex":"V1_Viper_I","model":"V1 Viper I"},{"regex":"V([134])_Viper","model":"V$1 Viper"},{"regex":"V2_Viper_X_plus","model":"V2 Viper X Plus"},{"regex":"V2_Viper_(E|I|S|X(?:e)?)","model":"V2 Viper $1"},{"regex":"X4_Soul_Vision","model":"X4 Soul Vision"},{"regex":"X([1246])_Soul_Xtreme","model":"X$1 Soul Xtreme"},{"regex":"X4_Soul_Infinity_(L|N|S|Z)","model":"X4 Soul Infinity $1"},{"regex":"X([34])_Soul_Lite","model":"X$1 Soul Lite"},{"regex":"X4_Soul_Mini_S(?:_TM)?","model":"X4 Soul Mini S"},{"regex":"X([23456])_Soul_Mini(?:_TM)?","model":"X$1 Soul Mini"},{"regex":"X3_Soul_PLUS","model":"X3 Soul Plus"},{"regex":"X([35])_Soul_Pro","model":"X$1 Soul Pro"},{"regex":"X2_Soul_Style_Plus","model":"X2 Soul Style Plus"},{"regex":"X([2345])_Soul_Style(?:_TM)?","model":"X$1 Soul Style"},{"regex":"X([12345])_Soul","model":"X$1 Soul"},{"regex":"X2_Twin","model":"X2 Twin"},{"regex":"A5_Easy(?:_TM)?","model":"A5 Easy"},{"regex":"A([56789])_Lite","model":"A$1 Lite"},{"regex":"A5_Ready(?:_TM)?","model":"A5 Ready"},{"regex":"A5Smiley","model":"A5 Smiley"},{"regex":"A5_Quad_Plus_TM","model":"A5 Quad Plus"},{"regex":"A5_Quad","model":"A5 Quad"},{"regex":"A6_Duo","model":"A6 Duo"},{"regex":"A10_Lite_2019","model":"A10 Lite (2019)"},{"regex":"A10_Plus","model":"A10 Plus"},{"regex":"A10_Max","model":"A10 Max"},{"regex":"Impera S","model":"Impera S"},{"regex":"ALLVIEW P4i","model":"AllDro P4"},{"regex":"Allview_P2","model":"AllDro"},{"regex":"AllviewCityPlus","device":"tablet","model":"City Plus"},{"regex":"AllviewCity","device":"tablet","model":"City"},{"regex":"AllviewAX2Frenzy","device":"tablet","model":"AX2 Frenzy"},{"regex":"Allview2SpeedDuo","device":"tablet","model":"Alldro 2 Speed Duo"},{"regex":"Allview3SpeedQuad","device":"tablet","model":"Alldro 3 Speed Quad"},{"regex":"H1003_LTE_PRO","device":"tablet","model":"Viva H1003 LTE Pro"},{"regex":"Viva_(H801|100[13]G|(?:H802|H100[12]|H701)_LTE|C701|i701G)","device":"tablet","model":"Viva $1"},{"regex":"ALLVIEW ?SPEEDI","device":"tablet","model":"Speed I"},{"regex":"ALLVIEW ?SPEED","device":"tablet","model":"Speed"},{"regex":"ALLVIEWSPEED","device":"tablet","model":"Speed"},{"regex":"AX4Nano","device":"tablet","model":"AX4 Nano"},{"regex":"ALLVIEW_TX1_Quasar","device":"tablet","model":"TX1 Quasar"},{"regex":"Allview[ _-]([^;/]+) Build","model":"$1"},{"regex":"Allview[ _-]([^;/]+)(?:[;/)]|$)","model":"$1"}]},"Allwinner":{"regex":"(?:QUAD-CORE (?:A64 p3|A33 y3|T3 K2001M)|ZY-07B|UltraOcta-T8|OCTA-CORE T8)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"QUAD-CORE A64 p3","model":"A64 QUAD-CORE p3"},{"regex":"QUAD-CORE A33 y3","model":"A33 QUAD-CORE y3"},{"regex":"ZY-07B","model":"ZY-07B"},{"regex":"UltraOcta-T8","device":"car browser","model":"Ultra Octa T8"},{"regex":"QUAD-CORE T3 K2001M","device":"car browser","model":"QUAD-CORE T3 K2001M"},{"regex":"OCTA-CORE T8","device":"car browser","model":"OCTA-CORE T8"}]},"altron":{"regex":"(AL-555|GI-626|OB[_-](?:421|728|627))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"AL-555","model":"AL-555"},{"regex":"OB[_-](421|728|627)","model":"OB-$1"},{"regex":"GI-626","device":"phablet","model":"GI-626"}]},"AMGOO":{"regex":"AM(350|355|40[257]|41[025]|450|50[89]|52[037]|51[58]|53[05])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"AM350","model":"Jack Pro"},{"regex":"AM(355|407)","model":"Tigo"},{"regex":"AM402","model":"Pronto"},{"regex":"AM410","model":"Unico"},{"regex":"AM450","model":"Swift"},{"regex":"AM508","model":"Fuego"},{"regex":"AM509","model":"Uno"},{"regex":"AM515","model":"D1"},{"regex":"AM518","model":"C1"},{"regex":"AM520","model":"Pro"},{"regex":"AM523","model":"Plus"},{"regex":"AM527","model":"Geo"},{"regex":"AM530","model":"A1"},{"regex":"AM535","model":"P1"},{"regex":"AM([0-9]{3})","model":"AM$1"}]},"Amoi":{"regex":"Amoi|(?:A862W|Clever[ -]?(?:Gem S52|Gleam S45|Pad P7|Wave S50|Touch S46|JOY S40|Lite S41))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Clever Pad P7","model":"Clever Pad P7"},{"regex":"A862W","model":"A862W"},{"regex":"CLEVER JOY S40","model":"Clever Joy S40"},{"regex":"Clever[ -]?(Gleam S45|Gem S52|Wave S50|Touch S46|Lite S41)","model":"Clever $1"},{"regex":"Amoi[\\\\- /]([a-z0-9]+)","model":"$1"},{"regex":"Amoisonic-([a-z0-9]+)","model":"$1"}]},"Ainol":{"regex":"Numy|novo[0-9]|Novo 10 Hero|AX10PRO|NUMY3GAX9|NOVO10 Spark|Aurora-II","device":"tablet","models":[{"regex":"Numy 3G AX1","model":"Novo 7 Numy AX1 3G"},{"regex":"Numy[_ ]?3G[_ ]?Sword","model":"Numy 3G Sword"},{"regex":"NOVO10 Spark","model":"Novo 10 Spark"},{"regex":"AX10PRO","model":"Numy AX10 Pro"},{"regex":"Numy_3G_AX3","model":"Numy AX3 Sword"},{"regex":"Numy3GTalos","model":"Numy 3G Talos"},{"regex":"Numy_3G_BW1","model":"Numy 3G Talos 2"},{"regex":"NUMY3GAX9(?:[);/ ]|$)","model":"Numy 3G AX9"},{"regex":"Numy3G_AX10(?:[);/ ]|$)","model":"Numy 3G AX10"},{"regex":"(Novo 10 Hero QuadCore)","model":"$1"},{"regex":"Aurora-II","model":"Novo 7 Aurora II"},{"regex":"Novo7 Flame(?:[);/ ]|$)","model":"Novo 7 Flame"},{"regex":"NOVO7(?:[);/ ]|$)","model":"Novo 7"},{"regex":"Numy[ _]([^;/]+) Build","model":"Numy $1"},{"regex":"Novo([0-9]+)[ \\\\-]([^;/]+) Build","model":"Novo $1 $2"}]},"Archos":{"regex":"(?:YL-)?Archos|(?:A50TI|AC101BHE)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Archos (Oxygen (?:63|57|68XL))(?:[);/ ]|$)","model":"$1"},{"regex":"A50TI(?:[);/ ]|$)","model":"50 Titanium 4G"},{"regex":"Archos ?5(?:[);/ ]|$)","device":"tablet","model":"5"},{"regex":"AC101BHE(?:[);/ ]|$)","device":"tablet","model":"101B Helium 4G"},{"regex":"(?:YL-)?Archos ([^/;]*(?:PAD)[^/;]*) Build","device":"tablet","model":"$1"},{"regex":"Archos ((?:[789]|10)[0-9]?[a-z]* ?(?:G9|G10|Helium|Titanium|Cobalt|Platinum|Xenon|Carbon|Neon|XS|IT)[^/;]*) Build","device":"tablet","model":"$1"},{"regex":"(?:YL-)?Archos ([a-z0-9 ]+) Build","model":"$1"},{"regex":"(?:YL-)?Archos ([a-z0-9]+)","model":"$1"}]},"Axxion":{"regex":"Axxion ATAB-[0-9]+(?:[);/ ]|$)","device":"tablet","models":[{"regex":"Axxion ATAB-([0-9]+)(?:[);/ ]|$)","model":"ATAB-$1"}]},"MEU":{"regex":"MEU ([a-z0-9]+) Build","device":"smartphone","model":"$1"},"Arnova":{"regex":"arnova|ARCHM901|AN7CG2|AN7G2(DTE|I)?|AN7[BCDFH]?G3|A80KSC|AN8G2|AN8[BC]?G3|AN9G2I?|AN9G3|A101[BC]|AN10G2|AN10BG2(DT|I)?|AN10BG3(DT)?|AN10[CD]G3","device":"tablet","models":[{"regex":"ARCHM901","model":"M901"},{"regex":"AN7CG2","model":"7c G2"},{"regex":"AN7G2I|AN7G2|AN7G2DTE","model":"7 G2"},{"regex":"AN7G3","model":"7 G3"},{"regex":"AN7BG3","model":"7b G3"},{"regex":"AN7CG3","model":"7c G3"},{"regex":"AN7DG3-CP","model":"Childpad"},{"regex":"AN7DG3","model":"7d G3"},{"regex":"AN7FG3","model":"7f G3"},{"regex":"AN7HG3","model":"7h G3"},{"regex":"A80KSC","model":"8"},{"regex":"AN8G2","model":"8 G2"},{"regex":"AN8G3","model":"8 G3"},{"regex":"AN8BG3","model":"8b G3"},{"regex":"AN8CG3","model":"8c G3"},{"regex":"AN9G2I","model":"9i G2"},{"regex":"AN9G2","model":"9 G2"},{"regex":"AN9G3","model":"9 G3"},{"regex":"A101B2|A101C|AN10G2","model":"10 G2"},{"regex":"A101B","model":"10"},{"regex":"AN10BG2|AN10BG2DT|AN10BG2I","model":"10b G2"},{"regex":"AN10BG3|AN10BG3DT|AN10BG3-LZ","model":"10b G3"},{"regex":"AN10CG3","model":"10c G3"},{"regex":"AN10DG3","model":"10d G3"},{"regex":"ARNOVA 90G3","model":"90 G3"},{"regex":"ARNOVA 90 G4","model":"90 G4"},{"regex":"ARNOVA 97G4","model":"97 G4"},{"regex":"ARNOVA 101 G4","model":"101 G4"},{"regex":"Arnova ([^/;]*) Build","model":"$1"}]},"ARRIS":{"regex":"ARRIS","device":"tv","models":[{"regex":"ARRIS[,;] ([^),;/]+)","model":"$1"}]},"Ask":{"regex":"ASK[ _]","device":"smartphone","models":[{"regex":"ASK[ _]791SP[ _]3G","model":"791SP 3G","device":"tablet"},{"regex":"ASK[_ ]([^/;]*) Build","model":"$1"}]},"ANS":{"regex":"UL40 Build","device":"smartphone","model":"UL40"},"AOC":{"regex":"AOC,","device":"tv","models":[{"regex":"(LE(?:32|43)S5970(?:s)?-20|LE55U7970-30|LE43S5977-20|U60856)","model":"$1"}]},"Assistant":{"regex":"(AS[-_](?:50[123]|543[1-6]|44[12]1|541[12]|54[23]1|6431|[46]01L)|AP-(?:109|115G|721N|753G|7[25]7G|10[68]|107G|110N|941|719))[;/)_ ]","device":"smartphone","models":[{"regex":"AS[-_]401L(?:[);/ ]|$)","model":"Asper"},{"regex":"AS-5432(?:[);/ ]|$)","model":"Agio"},{"regex":"AS[-_](?:5434|501)(?:[);/ ]|$)","model":"Club"},{"regex":"AS_601L(?:[);/ ]|$)","model":"AS-601L"},{"regex":"AS-5433 Secret(?:[);/ ]|$)","model":"Secret"},{"regex":"AS-5433(?:[);/ ]|$)","model":"Max Secret"},{"regex":"AS-5421(?:[);/ ]|$)","model":"Surf"},{"regex":"AS-44[12]1(?:[);/ ]|$)","model":"Unami"},{"regex":"AS-5431(?:[);/ ]|$)","model":"Prima"},{"regex":"AS-502(?:[);/ ]|$)","model":"Shot"},{"regex":"AS-503(?:[);/ ]|$)","model":"Target"},{"regex":"AS-5435(?:[);/ ]|$)","model":"Shine"},{"regex":"AS-5436[ _]","model":"Grid"},{"regex":"AS-6431(?:[);/ ]|$)","model":"Rider"},{"regex":"AS-5411[_ ]","model":"Max Ritm"},{"regex":"AS-5412 Max(?:[);/ ]|$)","model":"AS-5412 Max"},{"regex":"AP-721N(?:[);/ ]|$)","model":"AP-721N Force","device":"tablet"},{"regex":"AP-941(?:[);/ ]|$)","model":"AP-941","device":"tablet"},{"regex":"AP-108(?:[);/ ]|$)","model":"Cetus","device":"tablet"},{"regex":"AP-106(?:[);/ ]|$)","model":"AP-106 Force","device":"tablet"},{"regex":"(AP-(?:109|115G|7[25]7G|753G|107G|110N|719))(?:[);/ ]|$)","device":"tablet","model":"$1"}]},"Ark":{"regex":"(ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\\\))|EDGE A5HD|Elf_S8|ICON (R40\\\\+|R45)|Impulse[ _](P[12])|Wizard_[12](?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\\\))","model":"Benefit $1"},{"regex":"Impulse[ _]P1\\\\+","model":"Impulse P1 Plus"},{"regex":"Impulse[ _](P[12])","model":"Impulse $1"},{"regex":"EDGE (A5HD)","model":"Edge $1"},{"regex":"ICON (R40\\\\+|R45)","model":"Icon $1"},{"regex":"Wizard_([12])","model":"Wizard $1"},{"regex":"Elf_S8(?:[);/ ]|$)","model":"Elf S8"}]},"Garmin-Asus":{"regex":"Garmin-Asus|Garminfone","device":"smartphone","models":[{"regex":"Garminfone[ \\\\-_]([^;/]*)Build","model":"Garminfone $1"},{"regex":"Garmin-Asus[ \\\\-_]([^;/]+)Build","model":"$1"},{"regex":"Garmin-Asus[ \\\\-_]([^;/]+)[\\\\)/]","model":"$1"}]},"Asus":{"regex":"Asus|Transformer|ZenFone Max|TF300T|Slider SL101|PadFone|ME302(?:C|KL)|ME301T|ME371MG|ME17(?:1|2V|3X)|(?:K0[01][0-9a-z]|P(?:00[18ACIL]|01[MTVWYZ]|01MA|01T_1|02[13478])(?: Build|\\\\))|X015D|X018D|X003|X00[7ABT]D|Z00D|Z00[MTY]D|Z01[7FGHKMR]D)(?:[);/ ]|$)|G55[023]KL|ZB(631|602|633|55[135]|50[01])KL|ZC(55[134]|520|600)KL|ZA550KL|ZE(5[02]0|620|55[2345])KL|ZD55[23]KL|ZS6(?:61|7[01])KS|ZS(6[0236]0|55[10])KL|ZB(500KG|601KL)|MeMo Pad FHD 10 LTE|Z00[SV]D","device":"smartphone","models":[{"regex":"ME171(?:[);/ ]|$)","model":"Eee Pad MeMO 171","device":"tablet"},{"regex":"ASUS Z906(?:[);/ ]|$)","model":"Z906 10.1\\"","device":"tablet"},{"regex":"ME172V","model":"MeMO Pad","device":"tablet"},{"regex":"ME302C(?:[);/ ]|$)","model":"MeMO Pad FHD 10","device":"tablet"},{"regex":"(ME302KL|MeMo Pad FHD 10 LTE)(?:[);/ ]|$)","model":"MeMO Pad FHD 10 LTE","device":"tablet"},{"regex":"ME301T(?:[);/ ]|$)","model":"MeMO Pad Smart 10","device":"tablet"},{"regex":"Z101(?:[);/ ]|$)","model":"Z101","device":"tablet"},{"regex":"X Pad 10 LTE(?:[);/ ]|$)","model":"X Pad 10 LTE","device":"tablet"},{"regex":"(?:K01[3A]|K007|K00R)(?:[);/ ]|$)|MeMO Pad 7","model":"MeMO Pad 7","device":"tablet"},{"regex":"K01E(?:[);/ ]|$)","model":"MeMO Pad 10 ME103K","device":"tablet"},{"regex":"K00U|ME173X(?:[);/ ]|$)","model":"MeMO Pad HD 7","device":"tablet"},{"regex":"(?:K011|K00L)(?:[);/ ]|$)","model":"MeMO Pad 8","device":"tablet"},{"regex":"K014(?:[);/ ]|$)","model":"MeMO Pad 8.9","device":"tablet"},{"regex":"K00S(?:[);/ ]|$)","model":"MeMO Pad HD 7 Dual SIM","device":"tablet"},{"regex":"K00F(?:[);/ ]|$)","model":"MeMO Pad 10","device":"tablet"},{"regex":"K00C(?:[);/ ]|$)","model":"Transformer Pad TF701T","device":"tablet"},{"regex":"K010(?:[);/ ]|$)","model":"Transformer Pad TF103C","device":"tablet"},{"regex":"K018(?:[);/ ]|$)","model":"Transformer Pad TF103CG","device":"tablet"},{"regex":"TF300T(?:[);/ ]|$)","model":"Transformer Pad TF300T","device":"tablet"},{"regex":"K01B(?:[);/ ]|$)","model":"Transformer Pad TF303K","device":"tablet"},{"regex":"Slider SL101","model":"Eee Pad Slider SL101","device":"tablet"},{"regex":"P01[YZ]","model":"ZenPad C 7.0","device":"tablet"},{"regex":"P008 Build","model":"ZenPad Z8","device":"tablet"},{"regex":"P001","model":"ZenPad Z10","device":"tablet"},{"regex":"(?:ASUS_)?P00J","model":"ZenPad Z8s","device":"tablet"},{"regex":"P01[VW]","model":"ZenPad 7.0","device":"tablet"},{"regex":"(?:P024|P00A)(?:[);/ ]|$)","model":"ZenPad 8.0","device":"tablet"},{"regex":"P01MA(?: Build|\\\\))|P01M(?: Build|\\\\))","model":"ZenPad S 8.0","device":"tablet"},{"regex":"P027","model":"ZenPad 3S 10","device":"tablet"},{"regex":"(?:ASUS_)?P00I","model":"ZenPad 3S 10 LTE","device":"tablet"},{"regex":"(?:ASUS_)?P00C|P02[138]|P00L|P01T_1","model":"ZenPad 10","device":"tablet"},{"regex":"ASUS Tablet P1801-T","model":"Transformer AiO P1801 18.4\\"","device":"tablet"},{"regex":"ASUS TAB A8","model":"TAB A8","device":"tablet"},{"regex":"ME371MG(?:[);/ ]|$)","model":"Fonepad","device":"phablet"},{"regex":"K00G(?:[);/ ]|$)","model":"Fonepad Note 6","device":"phablet"},{"regex":"(?:K012|K00E)(?:[);/ ]|$)","model":"Fonepad 7","device":"phablet"},{"regex":"K00Z(?:[);/ ]|$)","model":"Fonepad 7 Dual SIM","device":"phablet"},{"regex":"K016(?:[);/ ]|$)","model":"Fonepad 8","device":"phablet"},{"regex":"(?:ASUS_)?T00N","model":"PadFone S"},{"regex":"(?:ASUS_)?T00[CE]","model":"PadFone Mini"},{"regex":"(?:ASUS[-_])?T00T","model":"PadFone X Mini"},{"regex":"PadFone T008","model":"PadFone E"},{"regex":"PadFone T004","model":"PadFone Infinity"},{"regex":"(?:ASUS_)?A002(A)?","model":"ZenFone AR"},{"regex":"(?:ASUS_)?A006","model":"ZenFone V"},{"regex":"(?:ASUS_)?A009","model":"ZenFone V Live"},{"regex":"(?:ASUS_)?Z007","model":"ZenFone C"},{"regex":"(?:ASUS_)?(X00P[SD]|ZB555KL)","model":"ZenFone Max M1"},{"regex":"(?:ASUS_)?(?:ZB60[12]KL)|ZenFone Max Pro M1","model":"ZenFone Max Pro M1"},{"regex":"(?:ASUS_)?(X01([AB]D)|ZB633KL)(?:[);/ ]|$)","model":"ZenFone Max M2"},{"regex":"(?:ASUS_)?(?:Z00[AD]|Z008D|Z008|Z00AD[AB]?|ZE551ML)","model":"ZenFone 2"},{"regex":"(?:ASUS_)?(?:ZenFone 2E)","model":"ZenFone 2E"},{"regex":"(?:ASUS_)?(?:A007|Z00YD|ZA550KL|ZB553KL|ZB501KL)(?:[);/ ]|$)","model":"ZenFone Live"},{"regex":"(?:ASUS_)?(?:X00RD|G552KL)","model":"ZenFone Live L1"},{"regex":"G553KL","model":"ZenFone Lite L1"},{"regex":"(?:ASUS_)?(?:Z00[ERLMTW]D|Z011D|ZE500KL)","model":"ZenFone 2 Laser"},{"regex":"(?:ASUS_)?(?:T00[IQ1]|Z01KD)","model":"ZenFone 4"},{"regex":"(?:ASUS_)?(?:T00[JF]|X00QD|X00QSA|ZE620KL)","model":"ZenFone 5"},{"regex":"(?:ASUS_)?T00P","model":"ZenFone 5 LTE"},{"regex":"(?:ASUS_)?(?:T00K|X017DA|X017D|ZC600KL)","model":"ZenFone 5 Lite"},{"regex":"(?:ASUS_)?(?:Z01RD|ZS620KL)","model":"ZenFone 5Z"},{"regex":"(?:ASUS_)?(?:T00G|Z002|ZS630KL|I01WD[X]?)","model":"ZenFone 6"},{"regex":"(?:ASUS_)?ZS671KS","model":"ZenFone 7 Pro"},{"regex":"(?:ASUS_)?(?:ZS670KS|I002D)(?:[);/ ]|$)","model":"ZenFone 7"},{"regex":"(?:ASUS_)?Z010D","model":"ZenFone Max"},{"regex":"(?:ASUS_)?X018D","model":"ZenFone Max Plus M1"},{"regex":"(?:ASUS_)?X00TD?","model":"ZenFone Max Pro M1"},{"regex":"(?:ASUS_)?(?:X01BDA|ZB631KL|Zenfone Max Pro M2)","model":"ZenFone Max Pro M2"},{"regex":"(?:ASUS_)?X014D","model":"ZenFone Go Plus"},{"regex":"(?:ASUS_)?(L001|X00[7AB]D|X009[DB][DA]|X009D|Z00[SV]D|ZB500K[LG]|ZB551KL)","model":"ZenFone Go"},{"regex":"(?:ASUS_)?X013D","model":"ZenFone Go Life"},{"regex":"(?:ASUS_)?G550KL","model":"ZenFone Go TV"},{"regex":"(?:ASUS_)?Z00[SV]D","model":"ZenFone Go"},{"regex":"(?:ASUS_)?(X00[23])","model":"ZenFone Pegasus"},{"regex":"(?:ASUS_)?X005","model":"ZenFone Pegasus 5000"},{"regex":"(?:ASUS_)?X550","model":"ZenFone Pegasus 2 Plus"},{"regex":"(?:ASUS_)?(X00GD)","model":"ZenFone Pegasus 3S Max"},{"regex":"(?:ASUS_)?(?:X00D[DS]|X008D)|ZC553KL","model":"ZenFone 3 Max"},{"regex":"(?:ASUS_)?(X008)","model":"ZenFone 3 Pegasus"},{"regex":"(?:ASUS_)?(ZE553KL|Z01HD)","model":"ZenFone 3 Zoom"},{"regex":"(?:ASUS_)?ZS550KL","model":"ZenFone 3 Deluxe"},{"regex":"(?:ASUS_)?Z00UD","model":"ZenFone Selfie"},{"regex":"(?:ASUS_)?(Z016[DS]|Z01FD)","model":"ZenFone 3 Deluxe"},{"regex":"(?:ASUS_)?(Z017DA|ZE520KL|ZE552KL|Z017D|Z012(D|S))","model":"ZenFone 3"},{"regex":"(?:ASUS_)?Z01B[DS]|ZC551KL","model":"ZenFone 3 Laser"},{"regex":"(?:ASUS_)?A001","model":"ZenFone 3 Ultra"},{"regex":"(?:ASUS_)?(?:ZD552KL|Z01MDA?)(?:[);/ ]|$)","model":"ZenFone 4 Selfie Pro"},{"regex":"(?:ASUS_)?(?:X00LDA|ZD553KL)","model":"ZenFone 4 Selfie"},{"regex":"(?:ASUS_)?(?:X00LD|Z01KS|Z01KDA|ZE554KL)","model":"ZenFone 4"},{"regex":"(?:ASUS_)?X00(?:[HIK]D|IS)|ZC554KL|ZC520KL","model":"ZenFone 4 Max"},{"regex":"(?:ASUS_)?X015D","model":"ZenFone 4 Max Plus"},{"regex":"(?:ASUS_)?(:?Z01G[DS]|ZS551KL)","model":"ZenFone 4 Pro"},{"regex":"(?:ASUS_)?Z00XS","model":"ZenFone Zoom"},{"regex":"(?:ASUS_)?(?:Z01QD|ZS600KL)","model":"ROG Phone"},{"regex":"(?:ASUS_)?(?:I001D[ABCE]?|ZS660KL)","model":"ROG Phone 2"},{"regex":"(?:ASUS_)?(?:I003DD?|ZS661KS)","model":"ROG Phone 3"},{"regex":"(?:ASUS_)?(?:I005DA)","model":"ROG Phone 5"},{"regex":"ZN220IC","device":"desktop","model":"Zen AiO ZN220IC"},{"regex":"(?:ASUS_)?ZenWatch( 2)?","device":"wearable","model":"ZenWatch$1"},{"regex":"Asus(?:-|;)?([a-z0-9]+)","model":"$1"},{"regex":"(PadFone(?: [^;/]+)?) Build","model":"$1"},{"regex":"(PadFone(?: [a-z0-9]+)?)","model":"$1"},{"regex":"(?:Asus|Transformer) ((?:Pad |Prime )?TF[0-9a-z]+)","device":"tablet","model":"Transformer $1"},{"regex":"Chromebook Flip (C10[01]PA|C302)","device":"desktop","model":"Chromebook Flip $1"}]},"Audiovox":{"regex":"Audiovox|CDM|UTS(?:TARCOM)?\\\\-|audio(?!book)[a-z0-9\\\\-]+","device":"smartphone","models":[{"regex":"Audiovox[_\\\\-]([a-z0-9\\\\-]+)","model":"$1"},{"regex":"CDM(?:-)?([a-z0-9]+)","model":"CDM-$1"},{"regex":"UTS(?:TARCOM)?-([a-z0-9\\\\-]+)","model":"CDM-$1"},{"regex":"audio([a-z0-9\\\\-]+)","model":"CDM-$1"}]},"AVH":{"regex":"Excer[ _]","device":"tablet","models":[{"regex":"Excer[ _]G5.3","model":"Excer G5.3"},{"regex":"Excer[ _]G5","model":"Excer G5"},{"regex":"Excer[ _]10[ _]PRO","model":"Excer 10 Pro"},{"regex":"Excer[ _]8","model":"Excer 8"}]},"Avvio":{"regex":"Avvio[ _]?([a-z0-9\\\\-]+)|(?:CHIVAS_55|Colombia_2018|Mint_M353)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"CHIVAS_55","model":"Chivas 55"},{"regex":"Mint_M353","model":"Mint M353"},{"regex":"Colombia_2018","model":"Colombia (2018)"},{"regex":"Avvio[ _]PAD","model":"PAD","device":"tablet"},{"regex":"Avvio[ _]?([a-z0-9\\\\-]+)","model":"$1"}]},"Azumi Mobile":{"regex":"Azumi[_ -]|(?:SPEED55|A50_Style_Plus)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Azumi[_ -]([^/;]+) Build","model":"$1"},{"regex":"Azumi[_ -]([a-z0-9_]+)","model":"$1"},{"regex":"SPEED55","model":"Speed 5.5\\""},{"regex":"A50_Style_Plus","model":"A50 Style Plus"}]},"Barnes & Noble":{"regex":"Nook|BN[TR]V[0-9]+","device":"tablet","models":[{"regex":"Nook([a-z0-9]+)","model":"Nook $1"},{"regex":"Nook[ _]([^/;]+)[ _]Build","model":"Nook $1"},{"regex":"(BN[TR]V[0-9]+)","model":"Nook $1"}]},"BGH":{"regex":"(?!Positivo )BGH ([^/;\\\\)]+)(?: Build|\\\\))","device":"smartphone","models":[{"regex":"Y([17]00|2[01]0|1010)","device":"tablet","model":"Y$1"},{"regex":"BGH (\\\\+Simple|Mini)","device":"tablet","model":"$1"},{"regex":"Y710 KIDS","device":"tablet","model":"Y710 Kids"},{"regex":"JOY X2","model":"Joy X2"},{"regex":"BGH ([^/;\\\\)]+)(?: Build|\\\\))","model":"$1"}]},"Bitel":{"regex":"Bitel[ _-]([^/;]+) Build|(?:B(?:840[5-9]|841[0456]|850[2346]|860[146]|9401|950[1-5])|S8402L?|S8501L?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(B(?:840[5789]|841[0456]|850[2346]|860[146]|9401|950[12345])|S8402L?|S8501L?)","model":"$1"},{"regex":"Bitel[ _-]([^/;]+) Build","model":"$1"}]},"Blu":{"regex":"BLU[ _]|(?:blu|Dash)[ _]([^/;)]+)(?: Build|[;)])|(?:Studio[ _](5.0K|5.5|View XL|Mega|C 8\\\\+8|[CGM][ _]HD|[CGX]|SELFIE|Selfie LTE|Touch|M5 Plus|J[1258]|X8 HD)|Advance (4.0 ?[LM]|5.[02](?: HD)?|A4|L[45])|ENERGY (DIAMOND|XL)|Energy X 2|LIFE XL|B110DL|Dash (?:X[2L]|L3)|PURE (?:X[LR]|MINI)|Life One X2|G90(?: PRO)?|Grand M3|GRAND (?:5.5 HD|XL LTE)|R1 (?:HD|PLUS)|Tank Xtreme [45].0|Tank Xtreme Pro|Touchbook M7 Pro|DASH X PLUS|C[456] 2019|BOLD N1|B130DL|Vivo 5 Mini)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Advance (4.0 ?[LM]|4.0|5.[02](?: HD)?|A4|L[54])","model":"Advance $1"},{"regex":"(?:BLU[_ ])?Studio[ _](5.0 C|5.5|View XL|Mega|C 8\\\\+8|[CG][ _]HD|C|G|Touch|M HD|M5 Plus|J[1258]|X8 HD|X5|XL|X)(?:[);/ ]|$)","model":"Studio $1"},{"regex":"(?:BLU[_ ])?Studio[ _]5.0 ?K(?:[);/ ]|$)","model":"Studio 5.0 K"},{"regex":"STUDIO SELFIE LTE","model":"Studio Selfie LTE"},{"regex":"STUDIO ONE","model":"Studio One"},{"regex":"STUDIO SELFIE ([23]|LTE)","model":"Studio Selfie $1"},{"regex":"STUDIO SELFIE","model":"Studio Selfie"},{"regex":"(?:BLU[_ ])?NEO_ENERGY_MINI","model":"Neo Energy Mini"},{"regex":"ENERGY DIAMOND","model":"Energy Diamond"},{"regex":"ENERGY XL","model":"Energy XL"},{"regex":"Energy X 2","model":"Energy X 2"},{"regex":"ENERGY X PLUS 2","model":"Energy X Plus 2"},{"regex":"ENERGY X PLUS","model":"Energy X Plus"},{"regex":"LIFE XL","model":"Life XL"},{"regex":"DASH[ _]X[ _]PLUS[ _]LTE","model":"Dash X Plus LTE"},{"regex":"DASH X PLUS","model":"Dash X Plus"},{"regex":"DASH 4.5","model":"Dash 4.5"},{"regex":"Dash XL","model":"Dash XL"},{"regex":"PURE (X[LR])","model":"Pure $1"},{"regex":"PURE MINI","model":"Pure Mini"},{"regex":"BOLD N1","model":"Bold N1"},{"regex":"Life One X2","model":"Life One X2"},{"regex":"LIFE ONE X","model":"Life One X"},{"regex":"LIFE ONE","model":"Life One"},{"regex":"LIFE MARK","model":"Life Mark"},{"regex":"NEO X PLUS","model":"Neo X Plus"},{"regex":"NEO (XL|X)","model":"Neo $1"},{"regex":"G90 PRO","model":"G90 Pro"},{"regex":"G90","model":"G90"},{"regex":"GRAND 5.5 HD","model":"Grand 5.5 HD"},{"regex":"Grand X LTE","model":"Grand X LTE"},{"regex":"Grand XL LTE","model":"Grand XL LTE"},{"regex":"Grand M3","model":"Grand M3"},{"regex":"B110DL","model":"View Mega"},{"regex":"B130DL","model":"View 2"},{"regex":"R1 HD","model":"R1 HD"},{"regex":"R1 PLUS","model":"R1 Plus"},{"regex":"C([456]) (2019)","model":"C$1 ($2)"},{"regex":"Tank Xtreme ([45]).0","model":"Tank Xtreme $1.0\\""},{"regex":"Tank Xtreme Pro","model":"Tank Xtreme Pro"},{"regex":"VIVO AIR LTE","model":"Vivo Air LTE"},{"regex":"Touchbook G7","model":"Touchbook G7"},{"regex":"(?:BLU[_ ])?VIVO[ _]SELFIE","model":"Vivo Selfie"},{"regex":"(?:BLU[_ ])?Vivo 5 Mini","model":"Vivo 5 Mini"},{"regex":"Touchbook M7 Pro","model":"Touchbook M7 Pro","device":"tablet"},{"regex":"STUDIO 7.0 II","model":"Studio 7.0\\" II","device":"tablet"},{"regex":"DASH (L[45] LTE|5.0|L[45]X|L3|X2|[LMX])(?:[);/ ]|$)","model":"Dash $1"},{"regex":"DASH[ _]([^)/;]+)(?: Build|\\\\))","model":"Dash $1"},{"regex":"blu[ _]([^/;]+)( Build|[);])","model":"$1"}]},"Bluegood":{"regex":"BLUEGOOD","device":"smartphone","models":[{"regex":"V6","model":"V6"}]},"Blackview":{"regex":"Blackview|(BV([24-9]000|[46]900|(5[1589]|9[15689])00|6[138]00)(?:[ _](?:PRO))?|(P10000(?:[ _](?:PRO))?)|omega[ _]pro|Alife[ _][PS]1|Heatwave|DM550|BV9700Pro|(?<!Lenovo[_ ])A[68]0(?:Pro)?\\\\))|A[86]0Plus|BL6000Pro","device":"smartphone","models":[{"regex":"A60Pro\\\\)","model":"A60 Pro"},{"regex":"A60\\\\)","model":"A60"},{"regex":"A80Pro(?:[);/ ]|$)","model":"A80 Pro"},{"regex":"A([86]0)Plus(?:[);/ ]|$)","model":"A$1 Plus"},{"regex":"(BV6000S)","model":"$1"},{"regex":"(BV9700|BL6000)Pro","model":"$1 Pro"},{"regex":"Blackview (A[78]|E7S)","model":"$1"},{"regex":"BV9000Pro-F","model":"BV9000 Pro F"},{"regex":"(BV([48]000|9[56]00|6[83]00))Pro","model":"$1 Pro"},{"regex":"(BV6[13]00)(?:[);/ ]|$)","model":"$1","device":"phablet"},{"regex":"(BV([24-9]000|6900|4900|(5[1589]|9[15689])00)(?:[ _](?:PRO))?)","model":"$1"},{"regex":"(P10000(?:[ _](?:PRO))?)","model":"$1"},{"regex":"omega[ _]pro","model":"Omega Pro"},{"regex":"(Alife[ _][PS]1|DM550|Heatwave)","model":"$1"}]},"Bluboo":{"regex":"Bluboo|Xfire|Picasso 4G|Maya Build","device":"smartphone","models":[{"regex":"Maya Build","model":"Maya"},{"regex":"Xfire2","model":"Xfire 2"},{"regex":"Picasso 4G","model":"Picasso 4G"},{"regex":"Xfire","model":"Xfire"},{"regex":"Bluboo[ _-]?([^;/)]+) Build","model":"$1"},{"regex":"Bluboo[ _-]?([^;/)]+)","model":"$1"}]},"Black Fox":{"regex":"BMM[ _-]?(?:44[123]D|441[WB]|44[12]S|431D|533D|54[12]S|541[ABW]|54[123]D|543S|531[ABD]|532 S)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"BMM443D","model":"B7 Fox+"},{"regex":"BMM441S","model":"B8 Fox"},{"regex":"BMM442S|BMM441B","model":"B8 Fox+"},{"regex":"BMM441W","model":"B8M"},{"regex":"BMM442D","model":"B7"},{"regex":"BMM531D","model":"B6"},{"regex":"BMM531A","model":"B5"},{"regex":"BMM541A","model":"B5+"},{"regex":"BMM543[DS]","model":"B4"},{"regex":"BMM441D","model":"B4 Mini"},{"regex":"BMM541B","model":"B4 Mini NFC"},{"regex":"BMM531B","model":"B4 Mini (2019)"},{"regex":"BMM542D","model":"B3+"},{"regex":"BMM541D","model":"B3"},{"regex":"BMM541W","model":"B7R Fox"},{"regex":"BMM 532 S","model":"BMM 532S"},{"regex":"BMM[ _-]?(533D|431D|54[12]S)(?:[);/ ]|$)","model":"BMM $1"}]},"bogo":{"regex":"BO-(FRSP4|LFSPBS5|LFSP4|LFSPSL4|LFSPBS5|LFSPSL6QCI)","device":"smartphone","models":[{"regex":"BO-LFSP4","model":"LifeStyle 4DC"},{"regex":"BO-LFSPSL4","model":"LifeStyle 4SL"},{"regex":"BO-LFSPBS5","model":"LifeStyle 5BS"},{"regex":"BO-LFSPSL6QCI","model":"LifeStyle 6QC"},{"regex":"BO-(FRSP4)","model":"$1"}]},"Boway":{"regex":"(?:sprd-)?(BOWAY)","device":"smartphone","models":[{"regex":"BOWAY[ _-]([^/;]+)[ _]Build","model":"$1"},{"regex":"([^/;]+) Build/BOWAY","model":"$1"},{"regex":".*BOWAY[ _-]([^/;]+)/","model":"$1"}]},"Brondi":{"regex":"Brondi[ _]|(?:CENTURION|GLADIATOR| GLORY|LUXURY|SENSUELLE|VICTORY)(?:[ _-]?[2-6])?(?:[);/ ]|$)|Surfing Tab|501 SZ","device":"smartphone","models":[{"regex":"(?:Brondi[ _])?(620 SZ|730_4G_HD|501 SZ)(?:[);/ ]|$)","model":"$1"},{"regex":"CENTURION(?:[ _-]?([2-6]))?(?:[);/ ]|$)","model":"CENTURION $1"},{"regex":"GLADIATOR(?:[ _-]?([2-6]))?(?:[);/ ]|$)","model":"GLADIATOR $1"},{"regex":"GLORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)","model":"GLORY $1"},{"regex":"LUXURY(?:[ _-]?([2-6]))?(?:[);/ ]|$)","model":"LUXURY $1"},{"regex":"SENSUELLE(?:[ _-]?([2-6]))?(?:[);/ ]|$)","model":"SENSUELLE $1"},{"regex":"VICTORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)","model":"VICTORY $1"},{"regex":"Surfing Tab ([^;/]+) Build","model":"SURFING TAB $1","device":"tablet"},{"regex":"Surfing Tab ([^;/)]+)[;/)]","model":"SURFING TAB $1","device":"tablet"}]},"VGO TEL":{"regex":"(?:Venture V(?:[278]|12)|Ocean[_ ][689]|Ocean9L)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Venture V([278]|12)(?:[);/ ]|$)","model":"Venture V$1"},{"regex":"Ocean[_ ]?([689]|9L)(?:[);/ ]|$)","model":"Ocean $1"}]},"Vivo":{"regex":"((?:VIV-|BBG-)?(?<!FBCR/)vivo(?!(?:Browser)))|(?:V1730(D[AT]|GA)|V18(18CA|01A0|13B[AT]|18T|09[AT]|1[346][AT]|[13]8[AT]|14A|24[B]?A|2[19][AT]|3[12][AT]|36[AT])|V1731CA|V1732[AT]|V1818CT|V19[01]1[AT]|V1932[AT]|V191[3469][AT]|V192[1348]A|V193[04]A|V194[15]A|V1938CT|V1955A|V1938T|V1730EA|V19[26]2A|V196[35]A|V198[16]A|V1936A[L]?|V19[59]0A|V200[125]A|1819|V201[12]A|V202[0345]C?A|V202[235-9]|V2054A|V203[026]|V204[03]|V2049A|X50 Pro\\\\+|I1927)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"V1824[B]?A(?:[);/ ]|$)","model":"iQOO"},{"regex":"V1955A(?:[);/ ]|$)","model":"iQOO 3"},{"regex":"I1927(?:[);/ ]|$)","model":"iQOO 3 5G"},{"regex":"V2049A(?:[);/ ]|$)","model":"iQOO 7"},{"regex":"V1922A(?:[);/ ]|$)","model":"iQOO Pro"},{"regex":"V1916A(?:[);/ ]|$)","model":"iQOO Pro 5G"},{"regex":"V1914A(?:[);/ ]|$)","model":"iQOO Neo"},{"regex":"V1981A(?:[);/ ]|$)","model":"iQOO Neo 3"},{"regex":"V1936A[L]?(?:[);/ ]|$)","model":"iQOO Neo 855"},{"regex":"V1986A(?:[);/ ]|$)","model":"iQOO Z1"},{"regex":"V2012A(?:[);/ ]|$)","model":"iQOO Z1x"},{"regex":"V1919A(?:[);/ ]|$)","model":"iQOO Z5x"},{"regex":"V2023A(?:[);/ ]|$)","model":"iQOO U1"},{"regex":"V2024A(?:[);/ ]|$)","model":"iQOO 5"},{"regex":"V2025A(?:[);/ ]|$)","model":"iQOO 5 Pro"},{"regex":"V2025(?:[);/ ]|$)","model":"V20"},{"regex":"V2040(?:[);/ ]|$)","model":"V20 (2021)"},{"regex":"vivo 1805(?:[);/ ]|$)","model":"Nex"},{"regex":"V1923A(?:[);/ ]|$)","model":"Nex 3"},{"regex":"V1924A(?:[);/ ]|$)","model":"Nex 3 5G"},{"regex":"V1950A(?:[);/ ]|$)","model":"Nex 3S"},{"regex":"V1821[AT](?:[);/ ]|$)","model":"Nex Dual Display"},{"regex":"Vivo ONE(?:[);/ ]|$)","model":"One"},{"regex":"V1831[AT](?:[);/ ]|$)","model":"S1"},{"regex":"V1832[AT](?:[);/ ]|$)","model":"S1 Pro"},{"regex":"V1932[AT](?:[);/ ]|$)","model":"S5"},{"regex":"V1962A(?:[);/ ]|$)","model":"S6 5G"},{"regex":"V2020C?A(?:[);/ ]|$)","model":"S7"},{"regex":"V1941A(?:[);/ ]|$)","model":"U3"},{"regex":"V1928A(?:[);/ ]|$)","model":"U3X"},{"regex":"vivo 1804(?:[);/ ]|$)","model":"V11 Pro"},{"regex":"vivo 1806(?:[);/ ]|$)","model":"V11i"},{"regex":"1819(?:[);/ ]|$)","model":"V15"},{"regex":"vivo 1818(?:[);/ ]|$)","model":"V15 Pro"},{"regex":"vivo 1909(?:[);/ ]|$)","model":"V17 Pro"},{"regex":"V2022(?:[);/ ]|$)","model":"V20 SE"},{"regex":"(?:VIV-|BBG-)?vivo[ _]1601(?:[);/ ]|$)","model":"V5"},{"regex":"vivo 1609(?:[);/ ]|$)","model":"V5 Lite"},{"regex":"vivo 1611(?:[);/ ]|$)","model":"V5 Plus"},{"regex":"vivo (1713|1612)(?:[);/ ]|$)","model":"V5s"},{"regex":"vivo 1718(?:[);/ ]|$)","model":"V7"},{"regex":"vivo 1716(?:[);/ ]|$)","model":"V7 Plus"},{"regex":"vivo 1723(?:[);/ ]|$)","model":"V9"},{"regex":"vivo 1727(?:[);/ ]|$)","model":"V9 Youth"},{"regex":"vivo 1721(?:[);/ ]|$)","model":"X20"},{"regex":"X20Plus(?:[);/ ]|$)","model":"X20 Plus"},{"regex":"vivo 1725(?:[);/ ]|$)","model":"X21"},{"regex":"V1814[AT](?:[);/ ]|$)","model":"X21S"},{"regex":"V1809[AT](?:[);/ ]|$)","model":"X23"},{"regex":"V1816[AT](?:[);/ ]|$)","model":"X23"},{"regex":"V18(38|29)[AT](?:[);/ ]|$)","model":"X27"},{"regex":"V1836[AT](?:[);/ ]|$)","model":"X27 Pro"},{"regex":"V1938CT(?:[);/ ]|$)","model":"X30"},{"regex":"V1938T(?:[);/ ]|$)","model":"X30 Pro"},{"regex":"V2001A(?:[);/ ]|$)","model":"X50"},{"regex":"V2005A(?:[);/ ]|$)","model":"X50 Pro"},{"regex":"(?:V2011A|X50 Pro\\\\+)(?:[);/ ]|$)","model":"X50 Pro Plus"},{"regex":"X9Plus(?:[);/ ]|$)","model":"X9 Plus"},{"regex":"vivo 1902(?:[);/ ]|$)","model":"Y17"},{"regex":"vivo 1915(?:[);/ ]|$)","model":"Y19"},{"regex":"V202[79](?:[);/ ]|$)","model":"Y20"},{"regex":"V2028(?:[);/ ]|$)","model":"Y11s"},{"regex":"V2043(?:[);/ ]|$)","model":"Y20 (2021)"},{"regex":"V2032(?:[);/ ]|$)","model":"Y20i"},{"regex":"V2023(?:[);/ ]|$)","model":"V20 SE"},{"regex":"V1901[AT](?:[);/ ]|$)","model":"Y3"},{"regex":"V1930A(?:[);/ ]|$)","model":"Y3 Standard"},{"regex":"V2036(?:[);/ ]|$)","model":"Y31"},{"regex":"V1934A(?:[);/ ]|$)","model":"Y5s"},{"regex":"V1965A(?:[);/ ]|$)","model":"Y50"},{"regex":"V2030(?:[);/ ]|$)","model":"Y51"},{"regex":"V2054A(?:[);/ ]|$)","model":"Y31s"},{"regex":"vivo 1606(?:[);/ ]|$)","model":"Y53i"},{"regex":"vivo 1603(?:[);/ ]|$)","model":"Y55l"},{"regex":"vivo 1610(?:[);/ ]|$)","model":"Y55s"},{"regex":"vivo 1719(?:[);/ ]|$)","model":"Y65"},{"regex":"vivo 1714(?:[);/ ]|$)","model":"Y69"},{"regex":"V2002A(?:[);/ ]|$)","model":"Y70s"},{"regex":"vivo 1724(?:[);/ ]|$)","model":"Y71"},{"regex":"vivo 1801(?:[);/ ]|$)","model":"Y71i"},{"regex":"V1731CA(?:[);/ ]|$)","model":"Y73"},{"regex":"V1913[AT](?:[);/ ]|$)","model":"Y7s"},{"regex":"vivo 180([38]|8i)(?:[);/ ]|$)","model":"Y81"},{"regex":"vivo 1812(?:[);/ ]|$)","model":"Y81i"},{"regex":"V1732[AT](?:[);/ ]|$)","model":"Y81s"},{"regex":"vivo 1726(?:[);/ ]|$)","model":"Y83 Pro"},{"regex":"V1730EA(?:[);/ ]|$)","model":"Y89"},{"regex":"vivo 181[17](?:[);/ ]|$)","model":"Y91"},{"regex":"V1945A(?:[);/ ]|$)","model":"Y9s"},{"regex":"V2026(?:[);/ ]|$)","model":"Y12s"},{"regex":"vivo 18(16|20)(?:[);/ ]|$)","model":"Y91i"},{"regex":"(V1818[AT]|vivo 181[45])(?:[);/ ]|$)","model":"Y93"},{"regex":"V1818C[AT](?:[);/ ]|$)","model":"Y93s"},{"regex":"vivo 1807(?:[);/ ]|$)","model":"Y95"},{"regex":"V1813[AT](?:[);/ ]|$)","model":"Y97"},{"regex":"V1801A0(?:[);/ ]|$)","model":"Z1"},{"regex":"V1730D[AT](?:[);/ ]|$)","model":"Z1i"},{"regex":"vivo 1917(?:[);/ ]|$)","model":"Z1x"},{"regex":"V1813B[AT](?:[);/ ]|$)","model":"Z3"},{"regex":"V1730GA(?:[);/ ]|$)","model":"Z3x"},{"regex":"V1921A(?:[);/ ]|$)","model":"Z5"},{"regex":"V1911A(?:[);/ ]|$)","model":"Z5x"},{"regex":"V1990A(?:[);/ ]|$)","model":"Z5x (2020)"},{"regex":"V1963A(?:[);/ ]|$)","model":"Z6"},{"regex":"(?:VIV-|BBG-)?vivo[ _]([^/;]+) Build","model":"$1"},{"regex":"(?:VIV-|BBG-)?vivo[ _]([^);/]+)(?:[);/]|$)","model":"$1"}]},"Vinsoc":{"regex":"(XA Pro) Build","device":"smartphone","model":"$1"},"Bird":{"regex":"BIRD[\\\\-. _]([^;/]+)","device":"feature phone","models":[{"regex":"BIRD[\\\\-. _]([^;/]+) Build","model":"$1"},{"regex":"BIRD[\\\\-. _]([^;/]+)","model":"$1"}]},"Becker":{"regex":"Becker-([a-z0-9]+)","device":"feature phone","model":"$1"},"Beeline":{"regex":"Beeline","device":"smartphone","models":[{"regex":"Beeline[_ ]Pro[_ ]([2436])","model":"Pro $1"},{"regex":"Tab (Fast|Pro)","model":"Tab $1","device":"tablet"},{"regex":"Tab ([0-9])","model":"Tab $1","device":"tablet"},{"regex":"Tab","model":"Tab","device":"tablet"},{"regex":"E700","model":"E700"},{"regex":"Smart2","model":"Smart 2"},{"regex":"Smart ([0-9])","model":"Smart $1"},{"regex":"Smart Dual","model":"Smart Dual"},{"regex":"(?:Beeline[_ ])?Fast[_ ]2(?:[);/ ]|$)","model":"Fast 2"},{"regex":"Fast(?:[);/ ]|$)","model":"Fast"}]},"Beetel":{"regex":"Beetel ([a-z0-9]+)","device":"feature phone","model":"$1"},"BenQ-Siemens":{"regex":"BENQ-SIEMENS - ([a-z0-9]+)","device":"feature phone","model":"$1"},"BenQ":{"regex":"BENQ(?:[ \\\\-])?([a-z0-9]+)|F52_09(?:[);/ ]|$)","device":"feature phone","models":[{"regex":"F52_09(?:[);/ ]|$)","model":"F52"},{"regex":"BENQ(?:[ \\\\-])?([a-z0-9]+)","model":"$1"}]},"Blaupunkt":{"regex":"Blaupunkt|Soundphone S2|Atlantis[_ ](?:1001A|1010A|A10\\\\.G40[23])|SLplus02|Discovery[_ ](?:A10_302|111C|1000C|1001A?)|Endeavour[_ ](?:785|101[GLM]|1000|1001|101[03]|1100)|Polaris[_ ]803|BP_6010","device":"tablet","models":[{"regex":"Discovery[_ ]111C","model":"Discovery 111C"},{"regex":"Discovery[_ ]A10_302","model":"Discovery A10.302"},{"regex":"Discovery[_ ]1000C","model":"Discovery 1000C"},{"regex":"Discovery[_ ]1001A","model":"Discovery 1001A"},{"regex":"Discovery[_ ]1001","model":"Discovery 1001"},{"regex":"Soundphone S2","model":"Soundphone S2"},{"regex":"Endeavour[_ ](101[GLM]|785|100[01]|101[03]|1100)","model":"Endeavour $1"},{"regex":"Polaris[_ ](803)","model":"Polaris $1"},{"regex":"Atlantis[_ ](1001A|1010A|A10\\\\.G40[23])","model":"Atlantis $1"},{"regex":"SLplus02","model":"SL Plus 02"},{"regex":"(BP_6010)","model":"$1"},{"regex":"Blaupunkt[_ ](SL[_ ]0[124]|SM[_ ]0[12])","device":"smartphone","model":"$1"},{"regex":"(4K Android TV)","device":"tv","model":"$1"}]},"Bmobile":{"regex":"Bmobile[_ ]|AX-?(?:[1-9][0-9]{2,3}[eEO+]?|7OO)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"AX-?([1-9][0-9]{2,3}[eEO+]?)","model":"AX$1"},{"regex":"AX7OO","model":"AX700"},{"regex":"Bmobile[_ ]([^/;]+) Build","model":"$1"},{"regex":"Bmobile[_ ]([a-z0-9]+)","model":"$1"}]},"bq":{"regex":"Aquaris|bq [^/;]+ Build|BQS[-_]([0-9]{4})|(BQ(ru)?[_ -][0-9]{3,4})|BQ5059|BQ1008G|BQru_BQru-","device":"smartphone","models":[{"regex":"BQ(?:ru)?-(?:5209L|5044)(?:[);/ ]|$)","model":"Strike LTE"},{"regex":"BQ(?:ru)?-(?:6035L)(?:[);/ ]|$)","model":"Strike Power Max"},{"regex":"BQ(?:ru)?-(?:5535L)(?:[);/ ]|$)","model":"Strike Power Plus"},{"regex":"BQ(S|ru)?-(?:5070|6040L)(?:[);/ ]|$)","model":"Magic"},{"regex":"BQ(S|ru)?-(?:6424L)(?:[);/ ]|$)","model":"Magic O"},{"regex":"BQ(?:S|ru)?-(?:5730L)(?:[);/ ]|$)","model":"Magic C"},{"regex":"BQ(?:S|ru)?-(?:5731L)(?:[);/ ]|$)","model":"Magic S"},{"regex":"BQ(?:S|ru)?-5745L(?:[);/ ]|$)","model":"Clever"},{"regex":"BQ(?:S|ru)?-5533G(?:[);/ ]|$)","model":"Fresh"},{"regex":"BQ(?:S|ru)?-5031G(?:[);/ ]|$)","model":"Fun"},{"regex":"BQ(?:S|ru)?-(?:5732L)(?:[);/ ]|$)","model":"Aurora SE"},{"regex":"BQ(?:S|ru)?-6430L(?:[);/ ]|$)","model":"Aurora"},{"regex":"BQ(?:S|ru)?-6630L(?:[);/ ]|$)","model":"Magic L"},{"regex":"BQ-9011[G]?(?:[);/ ]|$)","model":"Vision","device":"tablet"},{"regex":"BQ-8068L(?:[);/ ]|$)","model":"Hornet Plus Pro"},{"regex":"BQ-8067L","model":"Hornet Plus","device":"tablet"},{"regex":"BQ-8052G","model":"BQ-8052G","device":"tablet"},{"regex":"BQ-8041L","model":"Art","device":"tablet"},{"regex":"BQ-7084G","model":"Simple","device":"tablet"},{"regex":"BQ-7061G","model":"Andros","device":"tablet"},{"regex":"BQ(ru)?-(7082)","model":"Armor","device":"tablet"},{"regex":"BQ-7051G","model":"Elba","device":"tablet"},{"regex":"BQ-7036L","model":"Hornet","device":"tablet"},{"regex":"BQ-7022(G)?","model":"Canion","device":"tablet"},{"regex":"BQ-7021G","model":"Hit","device":"tablet"},{"regex":"BQ-7010G","model":"Max","device":"tablet"},{"regex":"BQ-7006G","model":"Union","device":"tablet"},{"regex":"BQ-7003","model":"Jamaica","device":"tablet"},{"regex":"BQ-6200L|BQ-6000L","model":"Aurora"},{"regex":"BQ-6631G","model":"Surf"},{"regex":"BQ-6022G","model":"Aura"},{"regex":"BQ(ru)?[ -]6015L","model":"Universe"},{"regex":"BQ(?:S|ru)?-(?:5525|6030G|6010G)","model":"Practic"},{"regex":"BQ-6001L|BQ-6050","model":"Jumbo"},{"regex":"BQ-5707G(?:[);/ ]|$)","model":"Next Music"},{"regex":"BQ-5702(?:[);/ ]|$)","model":"Spring"},{"regex":"BQ-5700L(?:[);/ ]|$)","model":"Space X"},{"regex":"BQ-(?:5591|551[89]G)(?:[);/ ]|$)","model":"Jeans"},{"regex":"BQ-5522","model":"Next"},{"regex":"BQ-5520L(?:[);/ ]|$)","model":"Silk"},{"regex":"BQ-5519L(?:[);/ ]|$)","model":"Fast Plus"},{"regex":"BQ-5540L(?:[);/ ]|$)","model":"Fast Pro"},{"regex":"BQ-5517L(?:[);/ ]|$)","model":"Twin Pro"},{"regex":"BQ-5516L(?:[);/ ]|$)","model":"Twin"},{"regex":"BQS-5515(?:[);/ ]|$)","model":"Wide"},{"regex":"BQ-5515[L]?(?:[);/ ]|$)","model":"Fast"},{"regex":"BQ-(?:5512L|5528L)(?:[);/ ]|$)","model":"Strike Forward"},{"regex":"BQ-5511L(?:[);/ ]|$)","model":"Bliss"},{"regex":"BQS[_ ]5505(?:[);/ ]|$)","model":"Amsterdam"},{"regex":"BQ(?:ru)?-5510(?:[);/ ]|$)","model":"Strike Power Max 4G"},{"regex":"BQ(?:ru)?-(?:5521|5594)(?:[);/ ]|$)","model":"Strike Power Max"},{"regex":"BQ-5508L(?:[);/ ]|$)","model":"Next LTE"},{"regex":"BQ-5507L(?:[);/ ]|$)","model":"Iron Max"},{"regex":"BQ(?:ru)?-5504(?:[);/ ]|$)","model":"Strike Selfie Max"},{"regex":"BQ(?:ru)?-5503(?:[);/ ]|$)","model":"Nice 2"},{"regex":"BQ(?:ru)?-6045L(?:[);/ ]|$)","model":"Nice"},{"regex":"BQ(?:ru)?-4030G(?:[);/ ]|$)","model":"Nice Mini"},{"regex":"BQS-5502(?:[);/ ]|$)","model":"Hammer"},{"regex":"BQS-5501(?:[);/ ]|$)","model":"Kawasaki"},{"regex":"BQS-5500(?:[);/ ]|$)","model":"Vancouver"},{"regex":"BQ-5500L(?:[);/ ]|$)","model":"Advance"},{"regex":"BQ-5302G(?:[);/ ]|$)","model":"Velvet 2"},{"regex":"BQ-5301(?:[);/ ]|$)","model":"Strike View"},{"regex":"BQ-5300G(?:[);/ ]|$)","model":"Velvet View"},{"regex":"BQ(ru|S)?-(?:5211|5020)(?:[);/ ]|$)","model":"Strike"},{"regex":"BQ-5206L(?:[);/ ]|$)","model":"Balance"},{"regex":"BQ(?:ru|S)?-(?:5204|5050)(?:[);/ ]|$)","model":"Strike Selfie"},{"regex":"BQ(?:ru)?-5203(?:[);/ ]|$)","model":"Vision"},{"regex":"BQ(?:ru)?-5202(?:[);/ ]|$)","model":"Space Lite"},{"regex":"BQ(?:ru)?-5201(?:[);/ ]|$)","model":"Space"},{"regex":"BQ-5082(?:[);/ ]|$)","model":"Sense 2"},{"regex":"BQ-5045L(?:[);/ ]|$)","model":"Wallet"},{"regex":"BQ-5047L(?:[);/ ]|$)","model":"Like"},{"regex":"BQ-5071(?:[);/ ]|$)","model":"Belief"},{"regex":"BQ[S]?-(?:5065|5340)(?:[);/ ]|$)","model":"Choice"},{"regex":"BQ(?:S|ru)?-5046L(?:[);/ ]|$)","model":"Choice LTE"},{"regex":"BQ(?:ru)?-?(?:5059|5514G)(?:[);/ ]|$)","model":"Strike Power"},{"regex":"(?:BQru_)?BQ(?:ru)?-5058(?:[);/ ]|$)","model":"Strike Power Easy"},{"regex":"BQ(?:ru)?-5057(?:[);/ ]|$)","model":"Strike 2"},{"regex":"BQ[S]?-(?:5056|5030)(?:[);/ ]|$)","model":"Fresh"},{"regex":"BQ-6042l(?:[);/ ]|$)","model":"Magic E"},{"regex":"BQS-5055(?:[);/ ]|$)","model":"Turbo Plus"},{"regex":"BQ(?:ru)?-5054(?:[);/ ]|$)","model":"Crystal"},{"regex":"BQ-5052(?:[);/ ]|$)","model":"Sense"},{"regex":"BQ[S]?-5045(?:[);/ ]|$)","model":"Fast"},{"regex":"BQ(?:ru)?-(?:5037|5514L)(?:[);/ ]|$)","model":"Strike Power 4G"},{"regex":"BQ(?:ru)?-5035(?:[);/ ]|$)","model":"Velvet"},{"regex":"BQ(?:ru)?-5033(?:[);/ ]|$)","model":"Shark"},{"regex":"BQ-5541L(?:[);/ ]|$)","model":"Shark Rush"},{"regex":"BQ-5032(?:[);/ ]|$)","model":"Element"},{"regex":"BQS-5025(?:[);/ ]|$)","model":"High Way"},{"regex":"BQ(?:ru)?-5022(?:[);/ ]|$)","model":"Bond"},{"regex":"BQ-5015L(?:[);/ ]|$)","model":"First"},{"regex":"BQ-5016G(?:[);/ ]|$)","model":"Choice"},{"regex":"BQ-5012L(?:[);/ ]|$)","model":"Rich"},{"regex":"BQ-5521L(?:[);/ ]|$)","model":"Rich Max"},{"regex":"BQS-5011(?:[);/ ]|$)","model":"Monte Carlo"},{"regex":"BQ-5010G(?:[);/ ]|$)","model":"Spot"},{"regex":"BQ-5000G(?:[);/ ]|$)","model":"Velvet Easy"},{"regex":"BQS-5010(?:[);/ ]|$)","model":"Prague"},{"regex":"BQ-5009L(?:[);/ ]|$)","model":"Trend"},{"regex":"BQS-500[59](?:[);/ ]|$)","model":"Sydney"},{"regex":"BQ-5008L(?:[);/ ]|$)","model":"Brave"},{"regex":"BQ-5007L(?:[);/ ]|$)","model":"Iron"},{"regex":"BQS-5006(?:[);/ ]|$)","model":"Los Angeles"},{"regex":"BQ-(?:5005L|5530L)(?:[);/ ]|$)","model":"Intense"},{"regex":"BQS-5004(?:[);/ ]|$)","model":"Paris"},{"regex":"BQ-5003L(?:[);/ ]|$)","model":"Shark Pro"},{"regex":"BQ-5002G(?:[);/ ]|$)","model":"Fun"},{"regex":"BQS-5002(?:[);/ ]|$)","model":"Colombo"},{"regex":"BQS-5003(?:[);/ ]|$)","model":"Colombo II"},{"regex":"BQ-5001L(?:[);/ ]|$)","model":"Contact"},{"regex":"BQS-5001(?:[);/ ]|$)","model":"Milan"},{"regex":"BQ(?:ru|S)?-5000(?:[);/ ]|$)","model":"Tokyo"},{"regex":"BQS-4800(?:[);/ ]|$)","model":"Blade"},{"regex":"BQS-4707(?:[);/ ]|$)","model":"Montreal"},{"regex":"BQS-4702(?:[);/ ]|$)","model":"Оsaka"},{"regex":"BQS-4701(?:[);/ ]|$)","model":"Venice"},{"regex":"BQ-(?:4585|5011G)(?:[);/ ]|$)","model":"Fox View"},{"regex":"BQ(?:ru)?-4583(?:[);/ ]|$)","model":"Fox Power"},{"regex":"BQS-4570(?:[);/ ]|$)","model":"Drive"},{"regex":"BQS-4560(?:[);/ ]|$)","model":"Golf"},{"regex":"BQS-4555(?:[);/ ]|$)","model":"Turbo"},{"regex":"BQS-4550(?:[);/ ]|$)","model":"Richmond"},{"regex":"BQ(?:ru)?-(?:4526|5004G)(?:[);/ ]|$)","model":"Fox"},{"regex":"BQS-4525(?:[);/ ]|$)","model":"Vienna"},{"regex":"BQS-4516(?:[);/ ]|$)","model":"Singapore"},{"regex":"BQS-4515(?:[);/ ]|$)","model":"Moscow"},{"regex":"BQS-4510(?:[);/ ]|$)","model":"Florence"},{"regex":"BQS-4505(?:[);/ ]|$)","model":"Santiago"},{"regex":"BQS-4503(?:[);/ ]|$)","model":"Dubai"},{"regex":"BQS-4502(?:[);/ ]|$)","model":"Kingston"},{"regex":"BQS-4501 Bristol","model":"Bristol"},{"regex":"BQ-4501G(?:[);/ ]|$)","model":"Fox Easy"},{"regex":"BQ(?:ru)?-4500(?:[);/ ]|$)","model":"Fox LTE"},{"regex":"BQ-4077(?:[);/ ]|$)","model":"Shark Mini"},{"regex":"BQ(?:ru)?-4072(?:[);/ ]|$)","model":"Strike Mini"},{"regex":"BQ(?:ru)?[- ]402[68](?:[);/ ]|$)","model":"Up!"},{"regex":"BQS-4010(?:[);/ ]|$)","model":"Aspen"},{"regex":"BQS-4009(?:[);/ ]|$)","model":"Orleans"},{"regex":"BQS-4008(?:[);/ ]|$)","model":"Shanghai"},{"regex":"BQS-4007(?:[);/ ]|$)","model":"Valencia"},{"regex":"BQS-4005(?:[);/ ]|$)","model":"Seoul"},{"regex":"BQS-4004(?:[);/ ]|$)","model":"Dusseldorf"},{"regex":"BQS-4003(?:[);/ ]|$)","model":"Verona"},{"regex":"BQ-4001G(?:[);/ ]|$)","model":"Cool"},{"regex":"BQS-4001(?:[);/ ]|$)","model":"Oxford"},{"regex":"BQS-3510(?:[);/ ]|$)","model":"Aspen Mini"},{"regex":"BQS-3503(?:[);/ ]|$)","model":"Bombay"},{"regex":"BQ-1085L(?:[);/ ]|$)","model":"Hornet Max Pro","device":"tablet"},{"regex":"BQ-1084L(?:[);/ ]|$)","model":"Hornet Max","device":"tablet"},{"regex":"BQ-1083G(?:[);/ ]|$)","model":"Armor Pro Plus","device":"tablet"},{"regex":"BQ-1082G(?:[);/ ]|$)","model":"Armor Pro","device":"tablet"},{"regex":"BQ-1077L(?:[);/ ]|$)","model":"Armor Pro LTE","device":"tablet"},{"regex":"BQ(?:ru)?-1057L(?:[);/ ]|$)","model":"Passion","device":"tablet"},{"regex":"BQ-1051G(?:[);/ ]|$)","model":"Corsika","device":"tablet"},{"regex":"BQ-1050G(?:[);/ ]|$)","model":"Hawaii","device":"tablet"},{"regex":"BQ[-]?1008G(?:[);/ ]|$)","model":"Grace","device":"tablet"},{"regex":"Aquaris M8","model":"Aquaris M8","device":"tablet"},{"regex":"Aquaris_([AM])4.5","model":"Aquaris $14.5"},{"regex":"BQ(?:ru)?[_ -](?:5590|5740G)(?:[);/ ]|$)","model":"Spring"},{"regex":"BQ[S]?-(?:6016L|5520)(?:[);/ ]|$)","model":"Mercury"},{"regex":"BQ(?:S|ru)?-(?:5701L|5060)(?:[);/ ]|$)","model":"Slim"},{"regex":"(BQ-7850|BQ-700[12]G|BQ-8002G|BQ-905[12]G|BQ-9702G|BQ-7056G)","model":"$1","device":"tablet"},{"regex":"BQ-8006G(?:[);/ ]|$)","model":"Java","device":"tablet"},{"regex":"BQ-7062G(?:[);/ ]|$)","model":"Fiji","device":"tablet"},{"regex":"BQ(?:ru)?-1081G(?:[);/ ]|$)","model":"Grace 3G","device":"tablet"},{"regex":"BQ-7802G(?:[);/ ]|$)","model":"Luzon","device":"tablet"},{"regex":"BQ-7008G(?:[);/ ]|$)","model":"Clarion","device":"tablet"},{"regex":"BQ-7064G(?:[);/ ]|$)","model":"Fusion","device":"tablet"},{"regex":"BQ-7050G(?:[);/ ]|$)","model":"Malta","device":"tablet"},{"regex":"BQ-7000G(?:[);/ ]|$)","model":"Сharm","device":"tablet"},{"regex":"BQ-7040G(?:[);/ ]|$)","model":"Сharm Plus","device":"tablet"},{"regex":"BQ-7038G(?:[);/ ]|$)","model":"Light Plus","device":"tablet"},{"regex":"BQ-7005G(?:[);/ ]|$)","model":"Maui","device":"tablet"},{"regex":"BQ-7098G(?:[);/ ]|$)","model":"Armor Power","device":"tablet"},{"regex":"BQ-1007(?:[);/ ]|$)","model":"Necker","device":"tablet"},{"regex":"BQ-1045[G]?(?:[);/ ]|$)","model":"Orion","device":"tablet"},{"regex":"BQ-(?:1054L|1020L)(?:[);/ ]|$)","model":"Nexion","device":"tablet"},{"regex":"BQ-7083G(?:[);/ ]|$)","model":"Light","device":"tablet"},{"regex":"BQ-8077L(?:[);/ ]|$)","model":"Exion Plus","device":"tablet"},{"regex":"BQ(?:ru)?-7083(?:[);/ ]|$)","model":"7083","device":"tablet"},{"regex":"BQ(?:ru)?-1056L(?:[);/ ]|$)","model":"1056L","device":"tablet"},{"regex":"BQ(?:ru)?-1022l(?:[);/ ]|$)","model":"Armor Pro LTE+","device":"tablet"},{"regex":"BQ(?:ru)?-1024L(?:[);/ ]|$)","model":"Exion Pro","device":"tablet"},{"regex":"BQ(?:ru)?-7081(?:[);/ ]|$)","model":"Charm","device":"tablet"},{"regex":"(?:bq )?(Aquaris[^/;]*) Build","model":"$1"},{"regex":"Aquaris (E(4.5|[56])|M(5|10)|U2 Lite|U2|U (Lite|Plus)|V Plus|X5 Plus|X2? Pro|X[25]|[CMUVX])","model":"Aquaris $1"},{"regex":"bq ([^/;]+) Build","model":"$1","device":"tablet"}]},"Bush":{"regex":"Bush[ _-]|Bush10Nou","device":"smartphone","models":[{"regex":"Bush10Nou","device":"tablet","model":"10Nou"},{"regex":"BUSH ([^;/)]+)Tablet(?: Build|[);])","model":"$1Tablet","device":"tablet"},{"regex":"BUSH ([^;/)]+)(?: Build|[);])","model":"$1"}]},"CAGI":{"regex":"CAGI-","device":"smartphone","models":[{"regex":"CAGI-OMEGA","model":"Omega"},{"regex":"CAGI-([a-z0-9_\\\\-]+)","model":"$1"}]},"Capitel":{"regex":"Capitel-([a-z0-9]+)","device":"feature phone","model":"$1"},"Captiva":{"regex":"Captiva[ _-]([^;/)]+)(?: Build|\\\\))","device":"tablet","model":"Pad $1"},"Casio":{"regex":"(C811|C7[57]1)(?: 4G)?(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"C751(?:[);/ ]|$)","model":"G\'zOne Ravine"},{"regex":"C771(?:[);/ ]|$)","model":"G\'zOne Commando"},{"regex":"C811 4G(?:[);/ ]|$)","model":"G\'zOne Commando 4G LTE"}]},"Casper":{"regex":"CASPER[_ ]|VIA[- _](T7D|A[34]|E3|F[123]|G4|M4|[LS]8|S7|P2|V8C|A1_Plus(?:_64)?|A1(?:_1)?|S[13]0|S|T17_M|T1[07]|T7|T7-3G|T8B|T8D-3G|S1[78])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:CASPER[_ ])?VIA_A1_Plus(?:_64)?","model":"VIA A1 Plus"},{"regex":"(?:CASPER[_ ])?VIA[_ ](G1_Plus|G1|E1|[AE]2|M[123]|V[35689]|V10|G3|V6X|A[34]|E3|F[123]|G4|M4|P2|S|V8C|A1(?:_1)?)(?:[);/ ]|$)","model":"VIA $1"},{"regex":"CASPER_VIA_E1c","model":"VIA E1C"},{"regex":"CASPER_L10_4.5G","model":"L10 4.5G","device":"tablet"},{"regex":"CASPER_(S[23]8)(?:[);/ ]|$)","model":"$1","device":"tablet"},{"regex":"VIA[- _](T7|T8D)-3G","model":"VIA $1 3G","device":"tablet"},{"regex":"VIA[- _](T7D|S[13]0|[LS]8|S7|T17_M|T1[07]|T7|T8B|S1[78])(?:[);/ ]|$)","model":"VIA $1","device":"tablet"}]},"Cat":{"regex":"Cat ?(tablet|stargate|nova)|B15Q|CAT B35|CAT-B100","device":"tablet","models":[{"regex":"B15Q","model":"B15Q","device":"smartphone"},{"regex":"CAT B35","model":"B35","device":"smartphone"},{"regex":"Cat ?(?:tablet)? ?((?:Galactica|Nova|StarGate|PHOENIX)[^/;]*) Build","model":"$1"},{"regex":"Cat ?tablet","model":"Nova"},{"regex":"CAT-(B100)","device":"feature phone","model":"$1"}]},"Carrefour":{"regex":"CT(?:10[0123]0|7[12]0|820)(?:W|FR)?(?:[);/ ]|$)","device":"tablet","models":[{"regex":"CT820","model":"Touch Tablet Neo2"},{"regex":"CT(10[0123]0(?:W|FR)?)","model":"CT$1"},{"regex":"CT(7[12]0(?:W|FR)?)","model":"CT$1"}]},"Celkon":{"regex":"Celkon|Millennia Hero","device":"smartphone","models":[{"regex":"Celkon[ _*](C[78]20)","model":"$1","device":"tablet"},{"regex":"Millennia Hero","model":"Millennia Hero"},{"regex":"Celkon[ _*](CT[^;/]+) Build","model":"$1","device":"tablet"},{"regex":"Celkon[ _*]([^;/]+) Build","model":"$1"},{"regex":"Celkon[\\\\. _*]([^;/\\\\)]+)[\\\\)/]","model":"$1"}]},"Changhong":{"regex":"Changhong","device":"smartphone","models":[{"regex":"Changhong[ ]?(X1-K|X6|R8|Z9S?|Z1S|S18)(?:[);/ ]|$)","model":"$1"},{"regex":"ChangHong Android TV","device":"tv","model":""},{"regex":"(?:Opera TV.+)Changhong-([^);/]+)","device":"tv","model":"$1"}]},"Cherry Mobile":{"regex":"Cherry|Superion S1 DTV|Flare([ _])?(2X|4|A[123]|J[123568]|P[13]|S[4-8]|X2|Y[367]|S Play|HD|LITE|XL|X_V2|Y3s|Tab)(?:[ _](?:Pro|Plus|Max|LTE))?|Fusion Bolt|Omega[_ ](?:Icon 2|Icon Lite 2|lite[_ ][43][Cs]?|HD [45]|HD_Duo)|Spin Max 2|Selfie_Two","device":"smartphone","models":[{"regex":"(Flare2X)","model":"$1"},{"regex":"Flare[_ ]HD[_ ]([345])","model":"Flare HD $1"},{"regex":"Flare_HD_MAX","model":"Flare HD Max"},{"regex":"FLARE LITE","model":"Flare Lite"},{"regex":"Flare S Play","model":"Flare S Play"},{"regex":"Flare[_ ]J([26])S","model":"Flare J$1s"},{"regex":"Flare_(J2|S7)_Prime","model":"Flare $1 Prime"},{"regex":"Flare_S7_Deluxe","model":"Flare S7 Deluxe"},{"regex":"Flare_S7_Power","model":"Flare S7 Power"},{"regex":"Flare[_ ]Y([367])[_ ]Pro","model":"Flare Y$1 Pro"},{"regex":"Flare XL Plus","model":"Flare XL Plus"},{"regex":"Flare[ _]X[_ ]V2","model":"Flare X V2"},{"regex":"Flare[ _](A2|J3|P1|S[467])[ _]Lite","model":"Flare $1 Lite"},{"regex":"Flare[ _](J[12]|S[57]|Y3|J6)[ _]mini","model":"Flare $1 Mini"},{"regex":"Flare_J2_2018","model":"Flare J2 (2018)"},{"regex":"Flare S4 Max LTE","model":"Flare S4 Max LTE"},{"regex":"Flare[_ ](S[47]|J2)[_ ]Max","model":"Flare $1 Max"},{"regex":"FlareS5LiteDTV","model":"Flare S5 Lite DTV"},{"regex":"Flare[_ ](S[567]|J6)[_ ]Plus","model":"Flare $1 Plus"},{"regex":"FLARE S6 POWER","model":"Flare S6 Power"},{"regex":"Flare(?:[ _])?(4|A[123]|J8 LTE|J[13568]|P[13]|S[4-8]|X2|Y3s|Y7_LTE|Y[673])","model":"Flare $1"},{"regex":"OMEGA HD ([45])","model":"Omega HD $1"},{"regex":"Omega_HD_Duo","model":"Omega HD Duo"},{"regex":"Omega Icon Lite 2","model":"Omega Icon Lite 2"},{"regex":"Omega Icon 2","model":"Omega Icon 2"},{"regex":"Omega[_ ]Lite[_ ](3[Cs]|4)","model":"Omega Lite $1"},{"regex":"Spin Max 2","model":"Spin Max 2"},{"regex":"Selfie_Two","model":"Selfie Two"},{"regex":"(Fusion Bolt|Flare Tab Pro|Flare Tab|Superion S1 DTV)","model":"$1","device":"tablet"},{"regex":"Cherry(?:[ _]?Mobile)?[ _]?([^/;]+)(?: Build|[);])","model":"$1"}]},"China Mobile":{"regex":"(M812C|1501_M02|9930i|A1303|A309W|M651CY) Build","device":"smartphone","models":[{"regex":"M651CY","model":"A3"},{"regex":"(M812C|1501_M02|9930i|A1303|A309W)","model":"$1"}]},"Comio":{"regex":"Comio|CT701G PLUS|CT701W|GT100","device":"smartphone","models":[{"regex":"GT100","model":"GT100","device":"tablet"},{"regex":"CT701W","model":"CT701W","device":"tablet"},{"regex":"CT701G PLUS","model":"CT701G Plus","device":"tablet"},{"regex":"Comio[ _-]?([^;/)]+)(?: Build|[);])","model":"$1"}]},"Compal":{"regex":"Compal-[a-z0-9]+","device":"feature phone","model":"$1"},"Artel":{"regex":"Artel[_ ]|\\\\w+_ARTEL_\\\\w+|GAP YOQ(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"GAP YOQ(?:[);/ ]|$)","model":"Gap Yo Q"},{"regex":"Artel[_ ](Quadro(?: Pro)?|Tesla|Air|Tomchi|Premium|U3_4G|Z5|Sentinel (?:X 8G|X D5|X)|T10)","model":"$1"},{"regex":"Artel[_ ]Komi3","model":"Komi 3"},{"regex":"Artel[_ ](Star|Nova|Connect|Choice|Style)","model":"$1","device":"tablet"},{"regex":"(?:\\\\w+_)?ARTEL_([FVM]5|X[45])_\\\\w+","device":"feature phone","model":"$1"}]},"ComTrade Tesla":{"regex":"Tesla|Impulse 7.85 3G|Impulse 10.1 OCTA|Smartphone_6.1|SP(?:6.2|6.2_Lite)|TTL(?:713G|8)","device":"smartphone","models":[{"regex":"TeslaEvo5.0","model":"Evo 5.0"},{"regex":"(Gravity 9.7 SHD)","model":"$1","device":"tablet"},{"regex":"(Impulse 7.85 3G)","model":"$1","device":"tablet"},{"regex":"Impulse 10.1 OCTA","model":"Impulse 10.1\\" OCTA","device":"tablet"},{"regex":"Tesla_SP([^/;]+)L Build","model":"Smartphone $1 Lite"},{"regex":"Smartphone_6.1","model":"Smartphone 6.1"},{"regex":"SP6.2_Lite","model":"Smartphone 6.2 Lite"},{"regex":"Tesla_SP([^/;]+) Build","model":"Smartphone $1"},{"regex":"SP([^/;]+) Build","model":"Smartphone $1"},{"regex":"Smartphone ([36])","model":"Smartphone $1"},{"regex":"Tesla_Tablet_785","model":"7.85\\"","device":"tablet"},{"regex":"TTH7","model":"H7","device":"tablet"},{"regex":"TTL7 Build","model":"L7","device":"tablet"},{"regex":"Tesla_Tablet_L7_3G","model":"L7 3G","device":"tablet"},{"regex":"(L7.1)","model":"$1","device":"tablet"},{"regex":"TTL713G","model":"L7.1 3G","device":"tablet"},{"regex":"(L7 Quad) Build","model":"$1","device":"tablet"},{"regex":"(L7 Quad Lite)","model":"$1","device":"tablet"},{"regex":"TTL8 Build","model":"L8","device":"tablet"},{"regex":"(L8.1)","model":"$1","device":"tablet"},{"regex":"TESLA_TABLET_M7","model":"M7","device":"tablet"},{"regex":"Tesla_Tablet_M8","model":"M8","device":"tablet"}]},"ConCorde":{"regex":"ConCorde ([^/;]+) Build|Concorde_Raptor_Z55(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Concorde_(Raptor_Z55)(?:[);/ ]|$)","model":"$1"},{"regex":"ConCorde Tab ?([^/;]+) Build","model":"Tab $1","device":"tablet"},{"regex":"ConCorde ReadMan ?([^/;]+) Build","model":"ReadMan $1","device":"tablet"},{"regex":"ConCorde ([^/;]+) Build","model":"$1"}]},"Condor":{"regex":"Allure (?:M[13]|X)|Griffe T[2356789]|TFX712G|TRA-901G|TGW[-]?(710G|709)|(?:PGN\\\\-?[456][012][0-9]|PHS\\\\-601|PHQ519|PHQ52[056]|TB105L|TB717G|PKT\\\\-301|Plume (?:H1|L[1-468]|P8|P6 PRO LTE))(?:[);/ ]|$)|CTAB[^/;]+ Build","device":"smartphone","models":[{"regex":"CTAB([^/;]+) Build","device":"tablet","model":"CTAB $1"},{"regex":"(TGW)-?(710G|709)(?:[);/ ]|$)","device":"tablet","model":"$1 $2"},{"regex":"(TFX712G|TB105L|TB717G)(?:[);/ ]|$)","device":"tablet","model":"$1"},{"regex":"(TRA)-(901G)(?:[);/ ]|$)","device":"tablet","model":"$1 $2"},{"regex":"PHS\\\\-601","model":"C8"},{"regex":"PGN\\\\-?403","model":"C4+ Noir"},{"regex":"PGN\\\\-?404","model":"C7 Mini"},{"regex":"PGN\\\\-?409","model":"Plume P4"},{"regex":"PKT\\\\-?301","model":"C2"},{"regex":"PGN\\\\-?504","model":"C5"},{"regex":"PGN\\\\-?505","model":"C8S"},{"regex":"PGN\\\\-?506","model":"C7"},{"regex":"(Allure (?:M[13]|X))","model":"$1"},{"regex":"PGN\\\\-?507","model":"Allure A9"},{"regex":"PGN\\\\-?508","model":"C6+"},{"regex":"PGN\\\\-?509","model":"C6 Pro"},{"regex":"PGN\\\\-?511","model":"Allure A9 Plus"},{"regex":"PGN\\\\-?513","model":"Griffe G4"},{"regex":"PHQ519","model":"Griffe G4S"},{"regex":"PHQ520","model":"Griffe G5"},{"regex":"PHQ525","model":"Griffe G6"},{"regex":"PHQ526","model":"Griffe G6 Pro"},{"regex":"PGN\\\\-?514","model":"Plume P7"},{"regex":"PGN\\\\-?515","model":"Plume P4 Pro"},{"regex":"PGN\\\\-?516","model":"Plume P5"},{"regex":"PGN\\\\-?51[78]","model":"Plume P6"},{"regex":"PGN\\\\-?521","model":"Griffe G4 Plus"},{"regex":"Griffe T3 ?pro","model":"Griffe T3 Pro"},{"regex":"Griffe T([0-9]) Plus","model":"Griffe T$1 Plus"},{"regex":"Griffe T([0-9])","model":"Griffe T$1"},{"regex":"PGN\\\\-?522","model":"P6 Plus"},{"regex":"PGN\\\\-?523","model":"P7 Plus"},{"regex":"PGN\\\\-?527","model":"Plume P4 Plus"},{"regex":"PGN\\\\-?528|PLUME P6 PRO LTE","model":"Plume P6 Pro LTE"},{"regex":"PGN\\\\-?605","model":"Plume P8"},{"regex":"PGN\\\\-?606","model":"Allure A55"},{"regex":"PGN\\\\-?607","model":"Allure A100"},{"regex":"PGN\\\\-?608","model":"Allure A55 Slim"},{"regex":"PGN\\\\-?609","model":"Allure A100 Lite"},{"regex":"PGN\\\\-?610","model":"Plume P8 Lite"},{"regex":"PGN\\\\-?611","model":"Allure A8"},{"regex":"PGN\\\\-?612","model":"Allure A8 Plus"},{"regex":"PGN\\\\-?613","model":"Allure A55 Plus"},{"regex":"Plume H1","model":"Plume H1"},{"regex":"Plume L([2468]) Pro","model":"Plume L$1 Pro"},{"regex":"Plume L3 Plus","model":"Plume L3 Plus"},{"regex":"Plume L3 Smart","model":"Plume L3 Smart"},{"regex":"Plume L([1-4])","model":"Plume L$1"},{"regex":"Plume P8 Pro","model":"Plume P8 Pro"},{"regex":"PGN\\\\-?([0-9]{3})","model":"PGN-$1"}]},"Coolpad":{"regex":"(?:YL-)?Coolpad|(?:Cool_9S|1824-S0|8190Q|1831-A0|8676-[AM]01|CP8298_I00|CP3648A|CP8676_I0[23]|REVVLPLUS C3701A|VCR-[AI]0|C105-E0|C106-[79]| C106|MTS-T0|cp3705A[S]?|ORL-C0|DLS-E0|8298-M02|5560S)(?:[);/ ]|$)|(8295|5860S) Build","device":"smartphone","models":[{"regex":"VCR-[AI]0","model":"Cool Play 6"},{"regex":"1831-A0(?:[);/ ]|$)","model":"Cool Play C7"},{"regex":"REVVLPLUS C3701A","model":"REVVL Plus","device":"phablet"},{"regex":"8190Q(?:[);/ ]|$)","model":"8190Q"},{"regex":"DLS-E0(?:[);/ ]|$)","model":"N5"},{"regex":"1824-S0(?:[);/ ]|$)","model":"N5C"},{"regex":"CP3705A[S]?(?:[);/ ]|$)","model":"Legacy"},{"regex":"CP3648A(?:[);/ ]|$)","model":"Legacy S"},{"regex":"MTS-T0(?:[);/ ]|$)","model":"N2M"},{"regex":"C106-[79](?:[);/ ]|$)","model":"Cool 1"},{"regex":"C105-E0(?:[);/ ]|$)","model":"Cool S1"},{"regex":"ORL-C0(?:[);/ ]|$)","model":"Cool 9"},{"regex":"Cool_9S(?:[);/ ]|$)","model":"Cool 9S"},{"regex":"5560S(?:[);/ ]|$)","model":"Arise"},{"regex":"(5860S|8295) Build","model":"$1"},{"regex":"CP8676_I02(?:[);/ ]|$)","model":"Note 3"},{"regex":"CP8676_I03(?:[);/ ]|$)","model":"Note 3 Plus"},{"regex":"CP8298_I00(?:[);/ ]|$)","model":"Note 3 Lite"},{"regex":"(8676-[AM]01|8298-M02)(?:[);/ ]|$)","model":"$1"},{"regex":"(?:YL-)?Coolpad[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"(?:YL-)?Coolpad[ _\\\\-]?([a-z0-9\\\\-]+)","model":"$1"}]},"Clarmin":{"regex":"Clarmin","device":"smartphone","models":[{"regex":"Clarmin[_ ](B[65]|C1)","model":"$1"}]},"CORN":{"regex":"CORN ","device":"smartphone","models":[{"regex":"CORN R20","model":"R20"}]},"Cosmote":{"regex":"Cosmote","device":"smartphone","models":[{"regex":"Cosmote_My_mini_Tab","device":"tablet","model":"My Mini Tab"}]},"Cricket":{"regex":"Cricket-([a-z0-9]+)|U705AC(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"U705AC","model":"Ovation"},{"regex":"Cricket-([a-z0-9]+)","device":"feature phone","model":"$1"}]},"Crius Mea":{"regex":"(Q7A\\\\+?)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Crosscall":{"regex":"Crosscall|ODYSSEY_Plus|Odyssey S1|Trekker-[MSX][1234]|Action-X3|Core-X3","device":"smartphone","models":[{"regex":"Action-X3","model":"Action-X3"},{"regex":"Core-X3","model":"Core-X3"},{"regex":"Crosscall ([^;/]+) Build","model":"$1"},{"regex":"ODYSSEY_Plus","model":"ODYSSEY+"},{"regex":"Odyssey S1","model":"ODYSSEY S1"},{"regex":"Trekker-([MSX][1234](?: Core)?)","model":"Trekker-$1"}]},"AllDocube":{"regex":"(?:T1001XS?|T1006S?|iPlay_[24]0|U1006H?)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"T1001XS(?:[);/ ]|$)","model":"M5XS"},{"regex":"T1006S(?:[);/ ]|$)","model":"M5S"},{"regex":"T1006(?:[);/ ]|$)","model":"M5"},{"regex":"T1001X(?:[);/ ]|$)","model":"M5X"},{"regex":"U1006H?(?:[);/ ]|$)","model":"iPlay 10 Pro 10.1\\""},{"regex":"iPlay_([24]0)(?:[);/ ]|$)","model":"iPlay $1"}]},"Cube":{"regex":"(<!myPhone ?)Cube|(U[0-9]+GT|K8GT)|(?:T8-PLUSM?S?|T8PLUSML|I1-TF[BD]?|I1-TC|i1002S|Iwork10 Flagship|iwork10 Pro)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"U27GT","model":"Talk 8"},{"regex":"(?:T8-PLUSM?S?|T8PLUSML)(?:[);/ ]|$)","model":"T8 Ultimate"},{"regex":"U55GT","model":"Talk 79"},{"regex":"U65GT","model":"Talk 9X"},{"regex":"I1-TF[BD]?(?:[);/ ]|$)","model":"iWork 8 Air"},{"regex":"I1-TC(?:[);/ ]|$)","model":"iWork 8 Ultimate"},{"regex":"(?:i1002S|iwork10 Pro)(?:[);/ ]|$)","model":"iWork 10 Pro"},{"regex":"Iwork10 Flagship(?:[);/ ]|$)","model":"iWork 10 Flagship"},{"regex":"(U[0-9]+GT[^;/]*) Build","model":"$1"},{"regex":"(U[0-9]+GT(?:[0-9]|[\\\\-_][a-z]+)?)","model":"$1"},{"regex":"(K8GT)","model":"$1"}]},"CUBOT":{"regex":"CUBOT|RAINBOW 2|KING_KONG_3|ZORRO 001|KINGKONG[_ ]MINI2?|KING KONG CS|(?<!QUMO )QUEST(?!(?:[0-9]|\\\\s[0-9]))(?: LITE)?|NOTE 20 PRO","device":"smartphone","models":[{"regex":"CHEETAH 2","model":"Cheetah 2"},{"regex":"RAINBOW 2","model":"Rainbow 2"},{"regex":"RAINBOW","model":"Rainbow"},{"regex":"DINOSAUR","model":"Dinosaur"},{"regex":"KINGKONG MINI2","model":"King Kong Mini 2"},{"regex":"KINGKONG_MINI","model":"King Kong Mini"},{"regex":"KING_KONG_3","model":"King Kong 3"},{"regex":"KING KONG CS","model":"King Kong CS"},{"regex":"KING KONG","model":"King Kong"},{"regex":"QUEST LITE","model":"Quest Lite"},{"regex":"QUEST","model":"Quest"},{"regex":"ZORRO 001","model":"Zorro 001"},{"regex":"CUBOT[ _]Echo","model":"Echo"},{"regex":"CUBOT[ _]MANITO","model":"Manito"},{"regex":"CUBOT[ _]MAGIC","model":"Magic"},{"regex":"CUBOT[ _]MAX","model":"Max"},{"regex":"NOTE Plus","model":"Note Plus"},{"regex":"NOTE 20 PRO","model":"Note 20 Pro"},{"regex":"CUBOT[_ ]NOTE[_ ]S","model":"Note S"},{"regex":"CUBOT_NOVA","model":"Nova"},{"regex":"CUBOT_POWER","model":"Power"},{"regex":"CUBOT_X18_Plus","model":"X18 Plus"},{"regex":"CUBOT[ _](A5|C6W|H3|J3|P7|P20|[RXJ]9|R11|X18)(?:[);/ ]|$)","model":"$1"},{"regex":"CUBOT ([^;/]+) Build","model":"$1"},{"regex":"([^;/]+) Build/CUBOT","model":"$1"}]},"Clout":{"regex":"Hind[ _]5\\\\.1|X417[ _]Amaze|X418[ _]Zest|X421[ _]Nova|X422[ ]Exotic|X425[ _]Shavit|X428[ _]Astute","device":"smartphone","models":[{"regex":"Hind[ _]5\\\\.1","model":"Hind 5.1"},{"regex":"X417[ _]Amaze","model":"X417 Amaze"},{"regex":"X418[ _]Zest","model":"X418 Zest"},{"regex":"X421[ _]Nova","model":"X421 Nova"},{"regex":"X422[ _]Exotic","model":"X422 Exotic"},{"regex":"X425[ _]Shavit","model":"X425 Shavit"},{"regex":"X428[ _]Astute","model":"X428 Astute"}]},"Concord":{"regex":"Concord[ _-]|(?:Flyfix 6|C-721|Plus-7_C777|Plus_M19_C779|Plus-9_C778)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"M10","model":"M10"},{"regex":"Flyfix 6","model":"Flyfix 6"},{"regex":"C-721","model":"Flyfix Q","device":"tablet"},{"regex":"Plus[-_]([79]|M19)_(C77[789])(?:[);/ ]|$)","model":"Plus-$1 $2","device":"tablet"}]},"Crescent":{"regex":"WING 5|WING9|Venus[ _][14]","device":"smartphone","models":[{"regex":"WING 5","model":"Wing 5"},{"regex":"WING9","model":"Wing 9"},{"regex":"Venus[ _]([14])","model":"Venus $1"}]},"Cyrus":{"regex":"Cyrus[ _-]","device":"smartphone","models":[{"regex":"Cyrus[ _-]?([^;/)]+) Build","model":"$1"},{"regex":"Cyrus[ _-]?([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"Datang":{"regex":"DATANG","device":"smartphone","models":[{"regex":"(?:DATANG[ _-])+([^;/]+) Build","model":"$1"},{"regex":"(?:DATANG[ _-])+([^;/)]+)(?:[;/)]|$)","model":"$1"}]},"Datsun":{"regex":"DATSUN","device":"smartphone","models":[{"regex":"DATSUN_D5500","model":"D5500"},{"regex":"Datsun_D5001","model":"D5001"}]},"Danew":{"regex":"Dslide ?([^;/]+) Build|Konnect_?(?:402|50[246]|60[127])|GEODROID_A5","device":"smartphone","models":[{"regex":"Konnect_?(402|50[246]|60[127])","model":"Konnect $1"},{"regex":"Dslide ?([^;/]+) Build","device":"tablet","model":"DSlide $1"},{"regex":"GEODROID_A5","device":"tablet","model":"Geodroid A5"}]},"Denver":{"regex":"(?:TA[CDQ]-[0-9]+)|P(?:.+)TAQ-(?:[0-9]+)|SDQ[_-](?:550[24]4L|52001G|50002G|57004L)","device":"tablet","models":[{"regex":"P(?:.+)TAQ-(10213GMK2|10172MK3|10242MK2|70242MK2|[0-9]+)(?:[);/ ]|$)","model":"TAQ-$1"},{"regex":"(TA[CDQ]-[0-9]+)","model":"$1"},{"regex":"SDQ[_-](550[24]4L|52001G|50002G|57004L)","device":"smartphone","model":"SDQ-$1"}]},"Dell":{"regex":"Dell[^a-z]|Venue|XCD35","device":"smartphone","models":[{"regex":"XCD35","model":"XCD35"},{"regex":"Venue (8 7840|10 7040|8 3830)","model":"Venue $1","device":"tablet"},{"regex":"(?:Dell )?Venue Build","model":"Venue"},{"regex":"Dell; Venue Pro","model":"Venue Pro"},{"regex":"(OptiPlex (?:3050|7010))","device":"desktop","model":"$1"},{"regex":"(?:Dell )?(Streak|Venue) ?([^/;]*) Build","model":"$1 $2","device":"tablet"},{"regex":"(?:Dell Inc./)?(XPS 13 9360|Latitude 7480)(?:[);/ ]|$)","device":"desktop","model":"$1"},{"regex":"Dell; ((?:Streak|Venue)[^;/\\\\)]*)","model":"$1","device":"tablet"},{"regex":"Dell; ([^;/\\\\)]+)","model":"$1"},{"regex":"Dell[ _\\\\-]([^/;]+) Build","model":"$1"}]},"Desay":{"regex":"Desay","device":"smartphone","models":[{"regex":"Desay[ _-]?([^;/)]+) Build","model":"$1"},{"regex":"Desay[ _-]?([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"DEXP":{"regex":"DEXP|(?:Ursus|Ixion)[ _]([^;/)]+)|H135[ _]Build|Larus_TV1|Ixion(?:ML4.7|ES250)|M150Storm|(?:SENIOR|F4[38]D8000K|VA[12]10|VA170|ML450|MS[56]50|BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|AL[23]50|AS155|AS260|GS15[035]| (?:N280i|P380i|R110|BL160|B450|B340|A1[45]0|A340|AS160|GL[23]55|ES750))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Ixion[_ ]([^;/]+)(?: Build|\\\\))","model":"Ixion $1"},{"regex":"(ML450|MS[56]50|ES750)(?:[);/ ]|$)","model":"Ixion $1"},{"regex":"IxionES250(?:[);/ ]|$)","model":"Ixion ES250 Rage"},{"regex":"IxionML4.7(?:[);/ ]|$)","model":"Ixion ML 4.7\\""},{"regex":"M150Storm(?:[);/ ]|$)","model":"Ixion M150 Storm"},{"regex":"AL250(?:[);/ ]|$)","model":"4.5\\" AL250"},{"regex":"AL350(?:[);/ ]|$)","model":"5.0\\" AL350"},{"regex":"AS155(?:[);/ ]|$)","model":"5.45\\" AS155"},{"regex":"AS260(?:[);/ ]|$)","model":"5.85\\" AS260","device":"phablet"},{"regex":"Ursus ([^;/)]+)(?: Build|\\\\))","model":"Ursus $1","device":"tablet"},{"regex":"(VA[21]10|VA170|R110|N280i|P380i)(?:[);/ ]|$)","model":"Ursus $1","device":"tablet"},{"regex":" (B450|B340|BL160|A340)(?:[);/ ]|$)","model":"$1"},{"regex":"SENIOR(?:[);/ ]|$)","model":"Senior"},{"regex":"Larus_TV1","device":"feature phone","model":"Larus_TV1"},{"regex":"H135[ _]Build","model":"Atlas","device":"desktop"},{"regex":"(BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|A1[45]0|GS15[035]|AS160|GL[23]55)(?:[);/ ]|$)","model":"$1"},{"regex":"DEXP[ _]([^;/]+) Build","model":"$1"},{"regex":"DEXP[ _]([^);/]+)(?:[);/ ]|$)","model":"$1"},{"regex":"(F4[38]D8000K)(?:[);/ ]|$)","device":"tv","model":"$1"}]},"Dbtel":{"regex":"DBTEL(?:[\\\\-/])?([a-z0-9]+)","device":"feature phone","model":"$1"},"Dialog":{"regex":"Dialog ?([^;/]+) Build","device":"smartphone","model":"$1"},"Dicam":{"regex":"DICAM-([a-z0-9]+)","device":"feature phone","model":"$1"},"Digi":{"regex":"(?<!FBCR/)Digi[ _]([^);/]+)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Digicel":{"regex":"DIGICEL","device":"smartphone","models":[{"regex":"DL810","model":"DL810"},{"regex":"DIGICEL ([^/;]+) Build","model":"$1"}]},"Digiland":{"regex":"(?:DL1008M|DL(?:1023|9002|[78]006))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"DL1008M","model":"DL1008M"},{"regex":"DL(1023|9002|[78]006)","model":"DL$1"}]},"Digma":{"regex":"Digma[_ ]([^;/]+) Build|HIT HT707[10]MG|CITI (?:7 E401 4G|8 E400 4G|ATL 4G|Kids|Octa [178]0|1902 3G|10 E402|Z530 3G)|(CITI[_ ](?:[A-Z0-9]+)[_ ][34]G)[ _][TC][ST](606[32]ML|111[46]ML|11[459]4MG|1117PG|1207MG|1210MG|1195MG|1196ML|3001ML|4024PG|5009PL|5021ML|5026PL|500[67]PG|7052PG|706[56]MG|709[68]PL|7097MG|720[48]MG|7140ML|7141MG|7113PL|7193MG|820[69]MG|7153MG|8139ML|8143MG|8152ML|1050PL|8205PG|7203MG|106[24]ML|1115MG)|HIT 4G|HT7074ML|IDX5|(iDx10|iDx7)|MVM900H(?:WZ|C)|MVM908HCZ|(iDxD8 3G|iDxD10 3G|iDrQ10 3G|iDxD[45]|iDxQ5|iD[nx]D7(?:[_ ]3G)?)|PS604M|PT452E|LINX B510 3G LT5037MG|LINX A452 3G LT4030PG|LINX A453 3G LT4038PG|LINX A420 3G LS4019PG|LINX A450 3G LT4028PG|Linx A400 3G LT4001PG|Linx C500 3G LT5001PG|Linx PS474S|LS504[01]PL|LT40(47|54)MG|PS1043MG|LS405[01]MG|LS5053ML|LT5048MG|HT7071MG|LT5052ML|HT5035PG|HT4039PG|LT4049PG|NS6902QL|NS9797MG|TS7854M|TS1012E 3G|TT1004PG|TT702[045]MG|TT1002MG|TT7026MW|((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\\\.ST]+|Prime)(?:[ _][43]G)?)|(VOX[ _](?:[0-9\\\\.A-Z]+)[_ ][43]G)","device":"smartphone","models":[{"regex":"HIT(?: 3G)? HT707[10]MG","model":"HIT 3G","device":"tablet"},{"regex":"iDx5","model":"iDx5"},{"regex":"HT5035PG","model":"HIT Q500 3G"},{"regex":"HT4039PG","model":"HIT Q401 3G"},{"regex":"(VOX[ _](?:[0-9\\\\.A-Z]+)[_ ][43]G)","model":"$1"},{"regex":"PS604M","model":"Linx 6.0"},{"regex":"LT4049PG","model":"Linx Atom 3G"},{"regex":"LT5048MG","model":"Linx Joy 3G"},{"regex":"LT5052ML","model":"Linx Base 4G"},{"regex":"LT4047MG","model":"Linx Alfa 3G"},{"regex":"LS4050MG","model":"Linx X1 3G"},{"regex":"LS4051MG","model":"Linx X1 Pro 3G"},{"regex":"LT4054MG","model":"Linx Argo 3G"},{"regex":"LS5041PL","model":"Linx Trix 4G"},{"regex":"LS5040PL","model":"Linx Rage 4G"},{"regex":"LS5053ML","model":"Linx Pay 4G"},{"regex":"Linx ([A-Z][0-9]{3}) 3G (?:LT4028PG|LS4019PG|LT4001PG|LT5001PG|LT4038PG|LT5037MG|LT4030PG)","model":"Linx $1 3G"},{"regex":"(Linx PS474S)","model":"$1"},{"regex":"PT452E","model":"Linx 4.5"},{"regex":"CITI ATL 4G CS5029ML","model":"CITI ATL 4G"},{"regex":"(CITI Z530 3G)","model":"$1"},{"regex":"(CITI [A-Z0-9]+ [34]G) C[ST](?:606[32]ML|4024PG|5009PL|5021ML|5026PL)","model":"$1"},{"regex":"TS7854M","model":"Plane 8.1\\" 3G","device":"tablet"},{"regex":"PS1043MG","model":"Plane 10.3\\" 3G","device":"tablet"},{"regex":"TS1012E 3G","model":"Plane 10.1\\" 3G","device":"tablet"},{"regex":"MVM900H(?:WZ|C)","model":"iDx8","device":"tablet"},{"regex":"MVM908HCZ","model":"iDx9","device":"tablet"},{"regex":"(iD(?:xD10|rQ10|xD7)[_ ]3G)","model":"$1","device":"tablet"},{"regex":"(iDx10|iDx7)","model":"$1"},{"regex":"(iDxD[45]|iDxQ5)","model":"$1"},{"regex":"HIT 4G HT7074ML","model":"HIT 4G","device":"tablet"},{"regex":"CITI[_ ](1902 3G|Kids|8527_4G|Octa [178]0|10 E402 4G|8 E400 4G|7 E401 4G)","model":"CITI $1","device":"tablet"},{"regex":"(CITI[ _](?:[A-Z0-9]+)[ _][34]G)[ _][TC][ST](?:106[24]ML|111[46]ML|1115MG|1117PG|1207MG|1210MG|3001ML|500[67]PG|7052PG|706[567]MG|7097MG|720[48]MG|820[69]MG|11[459]4MG|1195MG|1196ML|3001ML|8152ML|1050PL|709[68]PL|7113PL|7193MG|7216MG|8205PG|7203MG|8143MG|7153MG|7141MG|7140ML)","model":"$1","device":"tablet"},{"regex":"iDxD8 3G","model":"D-Plane2 8","device":"tablet"},{"regex":"(iDnD7)","model":"$1","device":"tablet"},{"regex":"NS6902QL","model":"Platina 7.2 4G","device":"tablet"},{"regex":"NS9797MG","model":"Platina 7.2 3G","device":"tablet"},{"regex":"TT1004PG","model":"Optima 10.4\\" 3G","device":"tablet"},{"regex":"TT1002MG","model":"Optima D 10.4\\" 3G","device":"tablet"},{"regex":"TT7025MG","model":"Optima 7.5\\" 3G","device":"tablet"},{"regex":"TT7026MW","model":"Optima 7.6\\" 3G","device":"tablet"},{"regex":"TT7020MG","model":"Optima 7.3\\" 3G","device":"tablet"},{"regex":"TT7024MG","model":"Optima 7.4\\" 3G","device":"tablet"},{"regex":"((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\\\.STNM]+|Prime)(?:[ _][43]G)?)","model":"$1","device":"tablet"},{"regex":"Digma[_ ]([^;/]+) Build","model":"$1","device":"tablet"}]},"DoCoMo":{"regex":"DoCoMo|\\\\;FOMA|KGT/1\\\\.0","device":"feature phone","models":[{"regex":"DoCoMo/.+MST.+(SH2101V)","model":"$1"},{"regex":"DoCoMo/[12]\\\\.0[/ ]([a-z0-9]+)","model":"$1"},{"regex":"([a-z0-9]+)(?:_W)?\\\\;FOMA","model":"$1"},{"regex":"KGT/1\\\\.0 ([a-z0-9]+)","model":"$1"}]},"Doogee":{"regex":"DOOGEE[ _-]|Valencia2_Y100_?(?:pro|plus)|Y100_Plus|X5max(?:[_ ]PRO)?|Shoot_[12]|x5_doogee|(KISSME|BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)|(?:BL12000|BL5500[_ ]Lite|X9 Mini|LEO_DG280|Y9Plus|Hitman_DG850|S(?:[568]8|9[056]|59|40)Pro|X95Pro|S40Lite|BL[579]000|N20Pro|(?<!Lenovo )S90C|Ibiza_F2)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:Valencia2_)?Y100_Plus(?:[);/ ]|$)","model":"Valencia2 Y100 Plus"},{"regex":"Valencia2_Y100pro","model":"Valencia2 Y100 Pro"},{"regex":"LEO_(DG280)","model":"Leo $1"},{"regex":"(BL[579]000|S90C)(?:[);/ ]|$)","model":"$1"},{"regex":"X95Pro(?:[);/ ]|$)","model":"X95 Pro"},{"regex":"N20Pro(?:[);/ ]|$)","model":"N20 Pro"},{"regex":"BL12000 PRO","model":"BL12000 Pro"},{"regex":"BL5500[_ ]Lite","model":"BL5500 Lite"},{"regex":"BL12000","model":"BL12000"},{"regex":"S([568]8|9[056]|59|40)Pro","model":"S$1 Pro"},{"regex":"S40Lite","model":"S40 Lite"},{"regex":"KISSME-DG580","model":"Kissme DG580"},{"regex":"Hitman_DG850","model":"Hitman DG580"},{"regex":"X9 Mini","model":"X9 Mini"},{"regex":"x5_doogee","model":"X5"},{"regex":"Shoot_([12])","model":"Shoot $1"},{"regex":"Ibiza_F2","model":"Ibiza F2"},{"regex":"(X5max(?:[_ ]PRO)?)","model":"$1"},{"regex":"(?:DOOGEE[ _-])?(BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|Valencia2_Y100pro|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)","model":"$1 $2"},{"regex":"DOOGEE[ _-]([^);/]+) Build","model":"$1"},{"regex":"DOOGEE[ _-]([^);/]+)(?:[);/ ]|$)","model":"$1"},{"regex":"Y9Plus(?:[);/ ]|$)","model":"Y9 Plus"}]},"Doov":{"regex":"(?:Doov-)?Doov[ _]","device":"smartphone","models":[{"regex":"(?:Doov-)?Doov[ _]([^;/]+) Build","model":"$1"},{"regex":"(?:Doov-)?Doov[ _]([^);/]+)(?:[);/ ]|$)","model":"$1"}]},"Dopod":{"regex":"Dopod(?: )?([a-z0-9]+)","device":"feature phone","model":"$1"},"Doro":{"regex":"Doro","device":"smartphone","models":[{"regex":"Doro[ _-]?([^;/)]+) Build","model":"$1"},{"regex":"Doro[ _-]([0-9a-z]+)","model":"$1"}]},"Dune HD":{"regex":"DuneHD|SOLO 4K(?:[);/ ]|$)","device":"tv","models":[{"regex":"SOLO 4K(?:[);/ ]|$)","model":"Solo 4k"},{"regex":"DuneHD/\\\\d.\\\\d \\\\([a-z]+__([a-z0-9_-]+);","model":"$1"},{"regex":"DuneHD/\\\\d.\\\\d \\\\(([a-z0-9_-]+);","model":"$1"}]},"DNS":{"regex":"(?:DNS|AirTab)[ _\\\\-]([^;/)]+)|(?:S4505M|S4004M|SD01M)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:DNS[_ ])?(S4505M|S4004M|SD01M|S4502|S4003|S4003)(?:[);/ ]|$)","model":"$1"},{"regex":"AirTab[ _\\\\-]([^;/]+)(?: Build|[);])","model":"AirTab $1","device":"tablet"},{"regex":"DNS[ _\\\\-]([^;/]+)(?: Build|[);])","model":"$1"}]},"E-Boda":{"regex":"E-Boda|Eclipse_(?:G400M|G500)","device":"smartphone","models":[{"regex":"E-Boda ((?:Revo|Izzycomm|Essential|Intelligence|Supreme)[^/;]+) Build","device":"tablet","model":"$1"},{"regex":"Eclipse_(G400M|G500)","model":"Eclipse $1"},{"regex":"E-Boda ([^/;]+) Build","model":"$1"}]},"Easypix":{"regex":"EasyPad|EasyPhone","device":"smartphone","models":[{"regex":"(EasyPhone[^/;]+) Build","model":"$1"},{"regex":"EasyPad ([^/;)]+)(?: Build|[;)])","model":"EasyPad $1","device":"tablet"}]},"EBEST":{"regex":"EBEST","device":"smartphone","models":[{"regex":"EBEST[ _-]?([^;/)]+) Build","model":"$1"},{"regex":"EBEST[ _-]?([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"Echo Mobiles":{"regex":"ECHO[ _](HOLI|HORIZON|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION)|HORIZON_M|Stellar 3G|FEELING","device":"smartphone","models":[{"regex":"ECHO_HORIZON_LITE","model":"HORIZON Lite"},{"regex":"(HORIZON_M|FEELING)(?:[);/ ]|$)","model":"$1"},{"regex":"STELLAR 3G","model":"STELLAR 3G"},{"regex":"ECHO_SMART_4G","model":"SMART 4G"},{"regex":"ECHO[ _](HOLI|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION)","model":"$1"}]},"ECS":{"regex":"(?:TA10CA3|TM105A?|TR10[CR]S1)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"TA10CA3(?:[);/ ]|$)","model":"TA10CA3"},{"regex":"(TR10[CR]S1)(?:[);/ ]|$)","model":"$1"},{"regex":"TM105A(?:[);/ ]|$)","model":"TM105A"},{"regex":"TM105(?:[);/ ]|$)","model":"TM105"}]},"EE":{"regex":"Hawk_from_EE","device":"smartphone","models":[{"regex":"Hawk_from_EE","model":"Hawk"}]},"EKT":{"regex":"EK-(?:5040|5336|5540|5937|6020|8680|MII|T7020)","device":"tablet","models":[{"regex":"EK-(MII|T7020)","model":"EK-$1"},{"regex":"EK-(5040|5336|5540|5937|6020|8680)","device":"smartphone","model":"EK-$1"}]},"Eks Mobility":{"regex":"S5LS|X4UPlus","device":"smartphone","models":[{"regex":"S5LS","model":"S5LS"},{"regex":"X4UPlus","model":"X4U Plus"}]},"Elephone":{"regex":"Elephone|P6000( ?Pro| ?Plus|\\\\+| ?02| 5.0 01)?","device":"smartphone","models":[{"regex":"Elephone Trunk(?:[);/ ]|$)","model":"Trunk"},{"regex":"P6000(\\\\+| ?Plus)(?:[);/ ]|$)","model":"P6000 Plus"},{"regex":"P6000 02(?:[);/ ]|$)","model":"P6000 02"},{"regex":"P6000 5.0 01(?:[);/ ]|$)","model":"P6000 01"},{"regex":"P6000 ?Pro(?:[);/ ]|$)","model":"P6000 Pro"},{"regex":"(?:Elephone[ _])?(P[768]000|S2)(?:[);/ ]|$)","model":"$1"},{"regex":"Elephone[ _\\\\-]([^/;]+)(?: Build|[;)])","model":"$1"}]},"Element":{"regex":"AFTRS","model":"Element 4K (2017)","device":"tv"},"Elenberg":{"regex":"(TAB(?:101|728)[ _]3G|TAB7(?:[03]8|16|40|3[30]))(?:[);/ ]|$)","device":"tablet","model":"$1"},"Ericy":{"regex":"Ericy-([a-z0-9]+)","device":"feature phone","model":"$1"},"Essential":{"regex":"PH-1[ )]","device":"smartphone","models":[{"regex":"PH-1[ )]","model":"PH-1"}]},"E-tel":{"regex":"E-tel_i250","device":"smartphone","models":[{"regex":"E-tel[_ ]i250","model":"i250"}]},"Evercoss":{"regex":"EVERCOSS[ _]|(A75A\\\\*|U50A_PLUS|M50 STAR|A75 MAX)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"A75A\\\\*(?:[);/ ]|$)","model":"A75A Star"},{"regex":"A75 MAX*(?:[);/ ]|$)","model":"A75 Max"},{"regex":"U50A_PLUS(?:[);/ ]|$)","model":"U50A Plus"},{"regex":"M50 STAR(?:[);/ ]|$)","model":"M50 Star"},{"regex":"EVERCOSS[ _](A7[BRLZ]|A65|A74A|A5Z)(?:[);/ ]|$)","model":"$1"}]},"Eurostar":{"regex":"(ET7002C-H12|Onyx-[13]S)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Onyx-([13]S)(?:[);/ ]|$)","model":"Onyx $1"},{"regex":"ET7002C-H12(?:[);/ ]|$)","model":"ePad 4S","device":"tablet"}]},"Eton":{"regex":"Eton","device":"smartphone","models":[{"regex":"Eton[ _-]?([^;/)]+) Build","model":"$1"},{"regex":"Eton[ _-]?([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"Essentielb":{"regex":"(?:Wooze[_ ]?(?:I55?|I45|X?L)|HEYOU(?:[135]|30))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"HEYOU([135]|30)(?:[);/ ]|$)","model":"HEYou $1"},{"regex":"Wooze[_ ]?((?:I55?|I45|X?L))(?:[);/ ]|$)","model":"Wooze $1"}]},"Facebook":{"regex":"PortalTV","device":"tv","model":"Portal TV"},"Rikomagic":{"regex":"MK(80[28][^/;]*) Build","device":"tv","model":"MK$1"},"Rinno":{"regex":"Rinno (R(?:400|505))","device":"smartphone","model":"$1"},"Riviera":{"regex":"RIVIERA ","device":"smartphone","models":[{"regex":"F23","model":"F23"}]},"Senseit":{"regex":"SENSEIT[ _]?([^;/)]+)( Build|\\\\))","device":"smartphone","model":"$1"},"Sony":{"regex":"Sony(?: ?Ericsson)?|SGP|Xperia|(?:[4-9]0[12])SO|C1[569]0[45]|C2[01]0[45]|C230[45]|C530[236]|C550[23]|C6[56]0[236]|C6616|C68(?:0[26]|[34]3)|C69(?:0[236]|16|43)|D200[45]|D21(?:0[45]|14)|D22(?:0[236]|12|43)|D230[2356]|D240[36]|D25(?:02|33)|D510[236]|D530[36]|D5316|D5322|D5503|D58[03]3|D65(?:0[23]|43|63)|D66[03458]3|D66[14]6|D6708|E(?:20[0345]3|2006|210[45]|2115|2124|230[36]|2312|23[356]3|530[36]|53[3456]3|5506|55[356]3|56[46305][36]|58[02]3|65[35]3|66[0358]3|68[358]3)|I[34]312|I4332|F311[12356]|F331[13]|F321[12356]|F5[13]21|F5122|F813[12]|F833[12]|G312[135]|G311[26]|G322[136]|G3212|G331[123]|G3412|G3416|G342[136]|G823[12]|G834[123]|G8[14]4[12]|H(?:3113|3123|3133|3213|3223|3311|3321|4113|4133|4213|4233|4311|4331|4413|4433|82[167]6|83[12]4|8416|9436)|(?:WT|LT|SO|ST|SK|MK)[0-9]+[a-z]+[0-9]*(?: Build|\\\\))|X?L39H|XM50[ht]|W960|portalmmm/2\\\\.0 K|S3[69]h|SOG01|SOL2[2346]|SOV3[1-9]|SOV4[0-3]|X10[ia]v?|E1[05][ai]v?|MT[0-9]{2}[a-z]? Build|SO-0(?:[12]C|[345]D|[234]E|[1-5]F|[1-5]G|[1-4]H|[1-4]J|[1-5]K|1M|[1-3]L)|R800[aix]|J3173|J82[17]0|J9110|J92[16]0|J81[17]0|I[34]113|I3[12]23|I42[19]3|H9493|H8296|H8166|H4493|G2299|LiveWithWalkman|BRAVIA|SGP771|E3 Dual|A001SO|I4193|E6508|SOT31|SO-[45]1A|SO-52A|XQ-A[DT]51|XQ-A[TU]42|XQ-AS[67]2|XQ-A[TSU]52|SOL25|SOG02|A002SO|NW-(A100|Z1000)Series|J3273","device":"smartphone","models":[{"regex":"(?:Sony(?:Ericsson)?)?E10[ai]v?","model":"Xperia X10 mini","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?U20","model":"Xperia X10 mini pro","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?E15[ai]v?","model":"Xperia X8","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?(LT15[ai]?v?|SO-01C)","model":"Xperia arc","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?LT18[ai]v?","model":"Xperia arc S","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?MT11","model":"Xperia neo V","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?MT15","model":"Xperia neo","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?MT27","model":"Xperia Sola","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?MK16[ai]","model":"Xperia pro","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?ST15[ai]","model":"Xperia mini","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?ST17[ai]","model":"Xperia active","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?SO-02L","model":"Xperia Ace","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?ST18[ai]","model":"Xperia ray","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?SK17[ai]?","model":"Xperia mini pro","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?X10[ai]v?","model":"Xperia X10","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)M1","model":"Aspen","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?R800","model":"Xperia PLAY","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?WT19|LiveWithWalkman","model":"Live with Walkman","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?CK13i","model":"txt","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?CK15[ai]","model":"txt pro","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?F100i","model":"Jalou","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?J105","model":"Naite","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?J108","model":"Cedar","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?J10","model":"Elm","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?J20","model":"Hazel","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U10","model":"Aino","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U100","model":"Yari","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U1","model":"Satio","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U5","model":"Vivaz","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U8","model":"Vivaz pro","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?W20","model":"Zylo","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?W100","model":"Spiro","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?W150","model":"Yendo","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?W960","model":"W960","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?WT13","model":"Mix Walkman","brand":"Sony Ericsson","device":"feature phone"},{"regex":"SO-04F","model":"Xperia A2"},{"regex":"G2299","model":"Xperia R1 Plus"},{"regex":"SO-04G","model":"Xperia A4"},{"regex":"(?:Sony(?:Ericsson)?)?I(?:4113|31[12]3)","model":"Xperia 10"},{"regex":"(?:Sony(?:Ericsson)?)?J3173(?:[);/ ]|$)","model":"Xperia Ace"},{"regex":"(?:A001SO|XQ-A[TU]52|XQ-AU42|SO-41A|SOV43)(?:[);/ ]|$)","model":"Xperia 10 II"},{"regex":"(?:Sony(?:Ericsson)?)?I(?:42[19]3|3223)","model":"Xperia 10 Plus"},{"regex":"(?:Sony(?:Ericsson)?)?I4193","model":"Xperia 10 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:J(?:9110|81[17]0)|SOV40|SO-03L|802SO)","model":"Xperia 1"},{"regex":"(?:Sony(?:Ericsson)?)?(?:SOG01|SO-51A|XQ-AT42|XQ-AT51)(?:[);/ ]|$)","model":"Xperia 1 II"},{"regex":"(?:Sony(?:Ericsson)?)?LT22i|Xperia P","model":"Xperia P"},{"regex":"(?:Sony(?:Ericsson)?)?LT25i|Xperia V","model":"Xperia V"},{"regex":"(?:Sony(?:Ericsson)?)?J92[16]0","model":"Xperia 5 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:J82[17]0|SO-01M|SOV41|901SO)","model":"Xperia 5"},{"regex":"(?:Sony(?:Ericsson)?)?(?:SOG02|A002SO|XQ-AS[567]2|SO-52A)","model":"Xperia 5 II"},{"regex":"(?:Sony(?:Ericsson)?)?(?:SOV42|902SO)","model":"Xperia 8"},{"regex":"(?:Sony(?:Ericsson)?)?J3273","model":"Xperia 8 Lite"},{"regex":"(?:Sony(?:Ericsson)?)?LT26ii","model":"Xperia SL"},{"regex":"(?:Sony(?:Ericsson)?)?LT26i|Xperia S(?:[);/ ]|$)","model":"Xperia S"},{"regex":"(?:Sony(?:Ericsson)?)?SO-02C","model":"Xperia arco"},{"regex":"(?:Sony(?:Ericsson)?)?SO-03D","model":"Xperia arco HD"},{"regex":"(?:Sony(?:Ericsson)?)?LT26w","model":"Xperia arco S"},{"regex":"(?:Sony(?:Ericsson)?)?LT28[aih]","model":"Xperia ion"},{"regex":"(?:Sony(?:Ericsson)?)?LT29i|Xperia TX(?:[);/ ]|$)","model":"Xperia TX"},{"regex":"(?:Sony(?:Ericsson)?)?LT30a","model":"Xperia T LTE"},{"regex":"(?:Sony(?:Ericsson)?)?LT30p","model":"Xperia T"},{"regex":"(?:Sony(?:Ericsson)?)?ST21[ia]2","model":"Xperia tipo dual"},{"regex":"(?:Sony(?:Ericsson)?)?ST21[ia]","model":"Xperia tipo"},{"regex":"(?:Sony(?:Ericsson)?)?ST23[ia]","model":"Xperia miro"},{"regex":"(?:Sony(?:Ericsson)?)?ST25[ia]","model":"Xperia U"},{"regex":"(?:Sony(?:Ericsson)?)?SOL22","model":"Xperia UL"},{"regex":"(?:Sony(?:Ericsson)?)?ST26[ia]","model":"Xperia J"},{"regex":"(?:Sony(?:Ericsson)?)?ST27[ia]","model":"Xperia go"},{"regex":"(?:Sony(?:Ericsson)?)?C150[45]","model":"Xperia E"},{"regex":"(?:Sony(?:Ericsson)?)?C160[45]","model":"Xperia E Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E210[45]|E2115|E2124)","model":"Xperia E4"},{"regex":"(?:Sony(?:Ericsson)?)?E20[05]3|E2006","model":"Xperia E4G"},{"regex":"(?:Sony(?:Ericsson)?)?C190[45]","model":"Xperia M"},{"regex":"(?:Sony(?:Ericsson)?)?C200[45]","model":"Xperia M Dual"},{"regex":"(?:Sony(?:Ericsson)?)?C210[45]|S36h","model":"Xperia L"},{"regex":"(?:Sony(?:Ericsson)?)?C230[45]|S39h","model":"Xperia C"},{"regex":"(?:Sony(?:Ericsson)?)?C530[236]|Xperia SP(?:[);/ ]|$)","model":"Xperia SP"},{"regex":"(?:Sony(?:Ericsson)?)?C550[23]","model":"Xperia ZR"},{"regex":"(?:Sony(?:Ericsson)?)?C650[236]|Xperia ZL(?:[);/ ]|$)","model":"Xperia ZL"},{"regex":"(?:Sony(?:Ericsson)?)?SOL25(?:[);/ ]|$)","model":"Xperia ZL2"},{"regex":"(?:Sony(?:Ericsson)?)?(?:C66(?:0[236]|16)|SO-02E)","model":"Xperia Z"},{"regex":"(?:Sony(?:Ericsson)?)?(?:C68(?:0[26]|[34]3)|XL39H|SOL24)|Xperia Z Ultra(?:[);/ ]|$)","device":"phablet","model":"Xperia Z Ultra"},{"regex":"Xperia Z(?:[);/ ]|$)","model":"Xperia Z"},{"regex":"(?:Sony(?:Ericsson)?)?D200[45]","model":"Xperia E1"},{"regex":"(?:Sony(?:Ericsson)?)?D21(?:0[45]|14)","model":"Xperia E1 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D22(?:0[236]|43)","model":"Xperia E3"},{"regex":"(?:Sony(?:Ericsson)?)?D2212|E3 Dual","model":"Xperia E3 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?E20[34]3","model":"Xperia E4g Dual"},{"regex":"H33[12]1","model":"Xperia L2"},{"regex":"H43[13]1","model":"Xperia L2 Dual"},{"regex":"I3312","model":"Xperia L3"},{"regex":"I43[13]2","model":"Xperia L3 Dual"},{"regex":"XQ-AD51","model":"Xperia L4"},{"regex":"(?:Sony(?:Ericsson)?)?D2302","model":"Xperia M2 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D230[356]","model":"Xperia M2"},{"regex":"(?:Sony(?:Ericsson)?)?D240[36]","model":"Xperia M2 Aqua"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E230[36]|E23[35]3)","model":"Xperia M4 Aqua"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E2312|E2363)","model":"Xperia M4 Aqua Dual"},{"regex":"(?:Sony(?:Ericsson)?)?E56[05][36]","model":"Xperia M5"},{"regex":"(?:Sony(?:Ericsson)?)?E56[436]3","model":"Xperia M5 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D2502","model":"Xperia C3 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D2533","model":"Xperia C3"},{"regex":"(?:Sony(?:Ericsson)?)?E53[05]3|E5306","model":"Xperia C4"},{"regex":"(?:Sony(?:Ericsson)?)?E53[0346]3","model":"Xperia C4 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?E5506|E5553","model":"Xperia C5 Ultra"},{"regex":"(?:Sony(?:Ericsson)?)?E55[36]3","model":"Xperia C5 Ultra Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D510[236]","model":"Xperia T3"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D530[36]|D5316|XM50[ht])","model":"Xperia T2 Ultra","device":"phablet"},{"regex":"(?:Sony(?:Ericsson)?)?D5322","model":"Xperia T2 Ultra Dual","device":"phablet"},{"regex":"(?:Sony(?:Ericsson)?)?D5503|Xperia Z1 Compact","model":"Xperia Z1 Compact"},{"regex":"(?:Sony(?:Ericsson)?)?(?:C69(?:0[236]|16|43)|SOL23|L39H|SO-0[12]F)|Xperia Z1(?:[);/ ]|$)","model":"Xperia Z1"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D58[03]3|SO-02G)|Xperia Z3 Compact(?:[);/ ]|$)","model":"Xperia Z3 Compact"},{"regex":"Xperia Z2 Tablet Wifi","model":"Xperia Z2 Tablet WiFi","device":"tablet"},{"regex":"SGP561","model":"Xperia Z2 Tablet","device":"tablet"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D65(?:0[23]|43)|SO-03F)|Xperia Z2(?:[);/ ]|$)","model":"Xperia Z2"},{"regex":"D6563","model":"Xperia Z2a"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D66[045]3|D66[14]6|SO-01G|SOL26|401SO)|Xperia Z3(?:[);/ ]|$)","model":"Xperia Z3"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D6633|D6683)","model":"Xperia Z3 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E65[35]3)","model":"Xperia Z3+"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D6708)","model":"Xperia Z3v"},{"regex":"SOV31|402SO|SO-03G","model":"Xperia Z4"},{"regex":"E6508","model":"Xperia Z4v"},{"regex":"SGP771|SOT31|SO-05G","model":"Xperia Z4","device":"tablet"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E58[02]3|SO-02H)","model":"Xperia Z5 Compact"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E66[05]3|SOV32|501SO|SO-01H)","model":"Xperia Z5"},{"regex":"(?:Sony(?:Ericsson)?)?E66[38]3","model":"Xperia Z5 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E68[58]3|SO-03H)","model":"Xperia Z5 Premium"},{"regex":"(?:Sony(?:Ericsson)?)?E6833","model":"Xperia Z5 Premium Dual"},{"regex":"(?:Sony(?:Ericsson)?)?F311[135]","model":"Xperia XA"},{"regex":"(?:Sony(?:Ericsson)?)?F311[26]","model":"Xperia XA Dual"},{"regex":"(?:Sony(?:Ericsson)?)?F321[135]","model":"Xperia XA Ultra"},{"regex":"(?:Sony(?:Ericsson)?)?F321[26]","model":"Xperia XA Ultra Dual"},{"regex":"(?:Sony(?:Ericsson)?)?F833[12]|SOV34|601SO|SO-01J","model":"Xperia XZ"},{"regex":"(?:Sony(?:Ericsson)?)?(?:701SO|SOV36|G834[123]|SO-01K)","model":"Xperia XZ1"},{"regex":"(?:Sony(?:Ericsson)?)?G8441|SO-02K","model":"Xperia XZ1 Compact"},{"regex":"(?:Sony(?:Ericsson)?)?F331[13]","model":"Xperia E5"},{"regex":"(?:Sony(?:Ericsson)?)?G312[135]|G311[26]","model":"Xperia XA1"},{"regex":"(?:Sony(?:Ericsson)?)?G341[26]|G342[13]","model":"Xperia XA1 Plus"},{"regex":"(?:Sony(?:Ericsson)?)?G3426","model":"Xperia XA1 Plus Dual"},{"regex":"(?:Sony(?:Ericsson)?)?G322[136]|G3212","model":"Xperia XA1 Ultra"},{"regex":"(?:Sony(?:Ericsson)?)?H31[123]3","model":"Xperia XA2"},{"regex":"(?:Sony(?:Ericsson)?)?H41[13]3","model":"Xperia XA2 Dual"},{"regex":"H44[19]3","model":"Xperia XA2 Plus Dual"},{"regex":"H4433","model":"H4433"},{"regex":"(?:Sony(?:Ericsson)?)?H(?:3213|3223|4213|4233)","model":"Xperia XA2 Ultra"},{"regex":"(?:Sony(?:Ericsson)?)?G823[12]|SOV35|602SO|SO-03J","model":"Xperia XZs"},{"regex":"(?:Sony(?:Ericsson)?)?G814[12]|SO-04[JK]","model":"Xperia XZ Premium"},{"regex":"(?:Sony(?:Ericsson)?)?(?:H83[12]4|H82[17]6|SOV37|SO-03K|H8296|702SO)","model":"Xperia XZ2"},{"regex":"H8266","model":"Xperia XZ2 Dual"},{"regex":"SO-05K","model":"Xperia XZ2 Compact"},{"regex":"(?:H8166|SOV38)(?:[);/ ]|$)","model":"Xperia XZ2 Premium Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:H(8416|9436|9493)|SO-01L|SOV39|801SO)","model":"Xperia XZ3"},{"regex":"(?:Sony(?:Ericsson)?)?G331[13]","model":"Xperia L1"},{"regex":"(?:Sony(?:Ericsson)?)?G3312","model":"Xperia L1 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?SO-04E","model":"Xperia A"},{"regex":"(?:Sony(?:Ericsson)?)?SO-04D","model":"Xperia GX"},{"regex":"(?:Sony(?:Ericsson)?)?SO-05D","model":"Xperia SX"},{"regex":"(?:Sony(?:Ericsson)?)?F5121","model":"Xperia X"},{"regex":"(?:Sony(?:Ericsson)?)?F5122","model":"Xperia X Dual"},{"regex":"(?:Sony(?:Ericsson)?)?F5321|SO-02J","model":"Xperia X Compact"},{"regex":"(?:Sony(?:Ericsson)?)?(?:F8131|502SO|SOV33|SO-04H)","model":"Xperia X Performance"},{"regex":"(?:Sony(?:Ericsson)?)?F8132","model":"Xperia X Performance Dual"},{"regex":"SGP(?:311|312|321)(?:[);/ ]|$)|SO-03E","model":"Xperia Tablet Z","device":"tablet"},{"regex":"SGP712(?:[);/ ]|$)","model":"Xperia Tablet Z4","device":"tablet"},{"regex":"SGP(?:511|512|521)(?:[);/ ]|$)|SO-05F","model":"Xperia Tablet Z2","device":"tablet"},{"regex":"SGP(?:6[124]1|612)(?:[);/ ]|$)","model":"Xperia Tablet Z3 Compact","device":"tablet"},{"regex":"SGPT(?:12|121|122|123|13|131|132|133)(?:[);/ ]|$)","model":"Xperia Tablet S","device":"tablet"},{"regex":"(?:BRAVIA )(2K GB ATV3|4K UR2|4K GB ATV3|4K GB|4K 2015|2015)(?:[);/ ]|$)","model":"Bravia $1","device":"tv"},{"regex":"NW-A100Series","model":"Walkman A100","device":"portable media player"},{"regex":"NW-Z1000Series","model":"Walkman Z1000","device":"portable media player"},{"regex":"SonyBDP|SonyDBV","model":"Blu-ray Player","device":"tv"},{"regex":"(?:Sony-)?(KDL?-?[0-9a-z]+)","model":"$1","device":"tv"},{"regex":"Opera TV Store.*(?:Sony-)([0-9a-z\\\\-_]+)","model":"$1","device":"tv"},{"regex":"((?:WT|SO|ST|SK|MK)[0-9]+[a-z]*[0-9]*)(?: Build|\\\\))","model":"$1","brand":"Sony Ericsson"},{"regex":"(MT[0-9]{2}[a-z]?)(?:[);/ ]|$)","model":"$1","brand":"Sony Ericsson"},{"regex":"portalmmm/2.0 K([a-z0-9]+)","model":"K$1","brand":"Sony Ericsson"},{"regex":"Sony ?Ericsson?([^/;]*) Build","model":"$1","brand":"Sony Ericsson"},{"regex":"SonyEricsson([CGJKPTWZ][0-9]+[a-z]+)/","model":"$1","brand":"Sony Ericsson","device":"feature phone"},{"regex":"Sony ?Ericsson ?([a-z0-9\\\\-]+)","model":"$1","brand":"Sony Ericsson"},{"regex":"Sony (Tablet[^/;]*) Build","model":"$1","device":"tablet"},{"regex":"(SGP[^/;]*) Build","model":"$1","device":"tablet"},{"regex":"Xperia ([^/;]*Tablet[^/;]*) Build","model":"Xperia $1","device":"tablet"},{"regex":"Xperia ([^;/]+) Build","model":"Xperia $1"},{"regex":"Sony[ -]?([^/;]*) Build","model":"$1"},{"regex":"Sony[ -]?([a-z0-9\\\\-]+)","model":"$1"}]},"Ergo":{"regex":"ERGO|(V550[_ ]Vision|B502 Basic|B504[_ ]Unit|A502[_ ]Aurum|A503[ _]Optima|Prime B400|A551 Sky 4G|A553 Power|A555 Universe|Force F500|GoTab GBT9|GoTab Gti8|F501_Magic|V551[ _]Aura|V540_Level|V570_BIG_BEN|B506[_ ]INTRO|A503-Optima|B505_Unit_4G)","device":"smartphone","models":[{"regex":"F501_Magic","model":"F501 Magic"},{"regex":"B502 Basic","model":"B502 Basic"},{"regex":"A503-Optima","model":"A503 Optima"},{"regex":"B506[_ ]INTRO","model":"B506 Intro"},{"regex":"V550[_ ]Vision","model":"V550 Vision"},{"regex":"B504[_ ]Unit","model":"B504 Unit"},{"regex":"B505_Unit_4G","model":"B505 Unit 4G"},{"regex":"V551[ _]Aura","model":"V551 Aura"},{"regex":"V540_Level","model":"V540 Level"},{"regex":"V570_BIG_BEN","model":"V570 Big Ben"},{"regex":"Ergo F502","model":"F502 Platinum"},{"regex":"(ERGO_)?A500[ _]Best","model":"A500 Best"},{"regex":"(ERGO_)?A550[ _]Maxx","model":"A550 Maxx"},{"regex":"Prime B400","model":"Prime B400"},{"regex":"A502[_ ]Aurum","model":"A502 Aurum"},{"regex":"A503[ _]Optima","model":"A503 Optima"},{"regex":"A551 Sky 4G","model":"A551 Sky 4G"},{"regex":"A553 Power","model":"A553 Power"},{"regex":"A555 Universe","model":"A555 Universe"},{"regex":"ERGO[_ ]A556","model":"A556"},{"regex":"ERGO[_ ]F500","model":"F500"},{"regex":"ERGO[_ ]F501","model":"F501"},{"regex":"B500 First","model":"B500 First"},{"regex":"Force F500","model":"Force F500"},{"regex":"GoTab GBT9","model":"GoTab GBT9","device":"tablet"},{"regex":"GoTab Gti8","model":"GoTab GTi8","device":"tablet"},{"regex":"ERGO[_ ]Tab[ _]Crystal[ _]Lite","model":"Tab Crystal Lite","device":"tablet"},{"regex":"ERGO[_ ]Tab[ _]Hero[ _]II","model":"Tab Hero II","device":"tablet"},{"regex":"ERGO[_ ](B700)","model":"Tab $1","device":"tablet"},{"regex":"ERGO SmartBox SX","model":"SmartBox SX","device":"tv"}]},"Ericsson":{"regex":"(?:Ericsson(?:/ )?[a-z0-9]+)|(?:R380 2.0 WAP1.1)","device":"feature phone","models":[{"regex":"Ericsson(?:/ )?([a-z0-9]+)","model":"$1"},{"regex":"R380 2.0 WAP1.1","model":"R380"}]},"Energizer":{"regex":"PowerMax|ENERGY[_ ]?(?:[45]00|400S|S[56]00|E12|E5[02]0S?)(?:[_ ](?:LTE|EU))?","device":"smartphone","models":[{"regex":"PowerMax(P[0-9]+S?)","model":"Power Max $1"},{"regex":"ENERGY[_ ]([45]00|E520)[_ ]LTE","model":"Energy $1 LTE"},{"regex":"ENERGY[_ ]400S","model":"Energy 400S"},{"regex":"ENERGY400","model":"Energy 400"},{"regex":"ENERGY[_ ]S([56]00)","model":"Energy S$1"},{"regex":"ENERGY[_ ]?(E500S|E500|E12)","model":"Energy $1"}]},"Energy Sistem":{"regex":"ENERGY[ _-]?([^;/]+) Build|Energy Phone Pro 3","device":"smartphone","models":[{"regex":"Energy Phone Pro 3","model":"Energy Phone Pro 3"},{"regex":"ENERGY[ _-]?([^;/]+) Build","device":"tablet","model":"$1"}]},"eTouch":{"regex":"eTouch ?([a-z0-9]+)","device":"smartphone","model":"$1"},"Etuline":{"regex":"(ETL-S(?:3520|4521|5042|5084|6022)|ETL-T(?:752G|882G|9[78]0))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(ETL-S(?:[^/); ]+))","model":"$1"},{"regex":"(ETL-T(?:[^/); ]+))","device":"tablet","model":"$1"}]},"Storex":{"regex":"eZee[^a-z]*Tab ?([^;/]*) Build|STOREX LinkBox","device":"tablet","models":[{"regex":"eZee[^a-z]*Tab ?([^;/]*) Build","model":"eZee\'Tab$1"},{"regex":"STOREX LinkBox","model":"LinkBox","device":"tv"}]},"Evertek":{"regex":"(Ever(?:Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Smart|Star)[^/;]*) Build|E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG","device":"smartphone","models":[{"regex":"(E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG)","device":"tablet","model":"Everpad $1"},{"regex":"(Ever(?:Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Smart|Star)[^/;]*) Build","model":"$1"}]},"Evolio":{"regex":"Evolio|M4MAGIC","device":"smartphone","models":[{"regex":"M4MAGIC","model":"M4 Magic"},{"regex":"Evolio_M5Pro","model":"M5 Pro"},{"regex":"Evolio[ _](M6|S4 Cobalt|S5|X10|Yuppi)","model":"$1"}]},"Evolveo":{"regex":"EVOLVEO|StrongPhone","device":"smartphone","models":[{"regex":"EVOLVEO MultiMedia Box M4","device":"tv","model":"MultiMedia Box M4"},{"regex":"Smart TV ([^;/]*) Build","device":"tv","model":"Smart TV $1"},{"regex":"EVOLVEO StrongPhone G([248])","model":"StrongPhone G$1"},{"regex":"(?:EVOLVEO[ _])?StrongPhone[ _]?Q([679])(_LTE)?","model":"StrongPhone Q$1$2"},{"regex":"EVOLVEO[ _]([^;/]*) Build","model":"$1"}]},"Explay":{"regex":"Explay|[\\\\w]+-EXPLAY-FIN|ActiveD[ _]|Atlant |Informer[ _][0-9]+|CinemaTV 3G|Surfer[ _][0-9\\\\.]|sQuad[ _][0-9\\\\.]|Onliner[1-3]|RioPlay|Leader|Pulsar|Infinityll|Imperium[78]|Indigo|Lagoon","device":"tablet","models":[{"regex":"ActiveD[ _]7.4[ _]3G","model":"ActiveD 7.4 3G"},{"regex":"Imperium([78])(?:[);/ ]|$)","model":"Imperium $1 3G"},{"regex":"ActiveD[ _]8.2[ _]3G","model":"ActiveD 8.2 3G"},{"regex":"CinemaTV[ _]3G","model":"CinemaTV 3G"},{"regex":"Infinityll","model":"Infinity II"},{"regex":"Informer[ _]([0-9]+(?:[ _]3G)?)","model":"Informer $1"},{"regex":"Surfer[ _]([0-9\\\\.]+(?:[ _]3G)?)","model":"Surfer $1"},{"regex":"sQuad[ _]([0-9\\\\.]+(?:[ _]3G)?)","model":"sQuad $1"},{"regex":"Onliner([1-3])","model":"Onliner $1"},{"regex":"Atlant(?:[);/ ]|$)","device":"smartphone","model":"Atlant"},{"regex":"Indigo(?:[);/ ]|$)","device":"smartphone","model":"Indigo"},{"regex":"Pulsar(?:[);/ ]|$)","device":"smartphone","model":"Pulsar"},{"regex":"[\\\\w]+-EXPLAY-FIN","device":"feature phone","model":"Fin"},{"regex":"Lagoon(?:[);/ ]|$)","model":"Lagoon"},{"regex":"Explay[ _-]([^;/]+)(?: Build|[;)])","model":"$1"},{"regex":"RioPlay(?:[);/ ]|$)","device":"smartphone","model":"Rio Play"},{"regex":"Leader","model":"Leader"}]},"EvroMedia":{"regex":"EVROMEDIA|Playpad[ _]|PLAY_PAD_PRO_XL","device":"tablet","models":[{"regex":"Playpad 3G GOO","model":"Play Pad 3G Goo"},{"regex":"Play Pad 3G 2Goo","model":"Play Pad 3G 2Goo"},{"regex":"Play Pad PRO","model":"Play Pad Pro"},{"regex":"PLAY_PAD_PRO_XL","model":"Play Pad Pro XL"},{"regex":"PlayPad 3GTab XL","model":"Play Pad 3G Tab XL"}]},"EKO":{"regex":"EKO","device":"smartphone","models":[{"regex":"EKO[ _-]?([^;/)]+) Build","model":"$1"},{"regex":"EKO[ _-]?([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"Extrem":{"regex":"Rock X9+|ROCK_X11","device":"smartphone","models":[{"regex":"Rock X9+","model":"Rock X9+"},{"regex":"ROCK_X11","model":"Rock X11"}]},"Ezze":{"regex":"EZZE-|EZ(?!Browser)[a-z0-9]+","device":"feature phone","models":[{"regex":"EZZE-([a-z0-9]+)","model":"$1"},{"regex":"EZ([a-z0-9]+)","model":"EZ$1"}]},"Ezio":{"regex":"EZIO-([a-z0-9]+)","device":"feature phone","model":"$1"},"Forstar":{"regex":"Amosta ?3G5","device":"smartphone","models":[{"regex":"Amosta ?3G5","model":"Amosta 3G5"}]},"Foxconn":{"regex":"InFocus M[0-9]+[a-z]?","device":"smartphone","models":[{"regex":"InFocus M([0-9]+[a-z]?)","model":"InFocus M$1"}]},"Fondi":{"regex":"Fondi[- _]([^;/)]+)|(T702|Q008B|Q010B|Q718B|Q902|T602B|T707G|T708B|T725B|T725B1|T907B)(?:\\\\)| Build)","device":"smartphone","models":[{"regex":"(T702|T602B)","model":"$1"},{"regex":"(Q008B|Q010B|Q718B|Q902|T707G|T708B|T725B|T725B1|T907B)","device":"tablet","model":"$1"},{"regex":"Fondi[- _]([^;/)]+)","model":"$1"}]},"Fairphone":{"regex":"(FP(?:1U?|2))(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Famoco":{"regex":"(FX[123]00)","device":"smartphone","model":"$1"},"FiGO":{"regex":"ATRIUM II F55L2|TRIO F40LT|CENTRIC S50G|EPIC F50G|Gravity X55L|Orion M50L|ULTRA M50G|M405B|VIRTUE3|F55L Build","device":"smartphone","models":[{"regex":"ATRIUM II F55L2","model":"Atrium II"},{"regex":"(F55L)","model":"$1"},{"regex":"TRIO F40LT","model":"Trio F40LT"},{"regex":"EPIC F50G","model":"Epic F50G"},{"regex":"(Gravity X55L|Orion M50L)","model":"$1"},{"regex":"ULTRA M50G","model":"Prime"},{"regex":"M405B_8GB","model":"Virtue II 8GB"},{"regex":"M405B","model":"Virtue II"},{"regex":"VIRTUE3","model":"Virtue III"},{"regex":"CENTRIC S50G","model":"Centric S50G"}]},"FNB":{"regex":"ConeXis (A[12]|X[12])|SP5045V","device":"smartphone","models":[{"regex":"SP5045V","model":"SP5045V"},{"regex":"ConeXis A1","model":"ConeXis A1"},{"regex":"ConeXis A2","model":"ConeXis A2"},{"regex":"ConeXis X1","model":"ConeXis X1"},{"regex":"ConeXis X2","model":"ConeXis X2"}]},"Fujitsu":{"regex":"(?:F-01[FHJKLM]|F-02[EFGHLK]|F-03[DEFGKHL]|F-04[EGFHKJ]|F-05[DEFJG]|F-06[EF]|F-07[DE]|F-08D|F-09[DE]|F-10D|F-[45]1A|F-[45]2A|F-11D|F-12C|M532|FARTM933KZ|901FJ|arrows(?:RX|M03|M0[45](?:-PREMIUM)?)|801FJ|FJL2[12])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"F-51A(?:[);/ ]|$)","model":"Arrows 5G F-51A"},{"regex":"F-01F(?:[);/ ]|$)","model":"Arrows NX F-01F"},{"regex":"(F-01[LM]|F-06F|F-03K|F-42A)(?:[);/ ]|$)","model":"Easy Phone $1"},{"regex":"F-03L(?:[);/ ]|$)","model":"Arrows Phone F-03L"},{"regex":"F-01J(?:[);/ ]|$)","model":"Arrows NX F-01J"},{"regex":"F-01K(?:[);/ ]|$)","model":"Arrows NX F-01K"},{"regex":"F-01H(?:[);/ ]|$)","model":"Arrows Fit F-01H"},{"regex":"F-02E(?:[);/ ]|$)","model":"Arrows X F-02E"},{"regex":"F-02G(?:[);/ ]|$)","model":"Arrows NX F-02G"},{"regex":"FJL21(?:[);/ ]|$)","model":"Arrows EF FJL21"},{"regex":"FJL22(?:[);/ ]|$)","model":"Arrows Z FJL22"},{"regex":"F-02H(?:[);/ ]|$)","model":"Arrows NX F-02H"},{"regex":"F-52A(?:[);/ ]|$)","model":"Arrows NX9 F-52A"},{"regex":"F-03D(?:[);/ ]|$)","model":"Arrows Kiss F-03D"},{"regex":"F-03E(?:[);/ ]|$)","model":"Arrows Kiss F-03E"},{"regex":"F-03F(?:[);/ ]|$)","model":"Disney Mobile F-03F"},{"regex":"F-03H(?:[);/ ]|$)","model":"Arrows SV F-03H"},{"regex":"901FJ(?:[);/ ]|$)","model":"Arrows J 901FJ"},{"regex":"F-04E(?:[);/ ]|$)","model":"Arrows V F-04E"},{"regex":"F-04G(?:[);/ ]|$)","model":"Arrows NX F-04G"},{"regex":"F-05D(?:[);/ ]|$)","model":"Arrows X LTE F-05D"},{"regex":"F-05F(?:[);/ ]|$)","model":"Arrows NX F-05F"},{"regex":"F-05J(?:[);/ ]|$)","model":"Arrows Be F-05J"},{"regex":"F-05G(?:[);/ ]|$)","model":"Arrows K-tai"},{"regex":"F-04K(?:[);/ ]|$)","model":"Arrows Be F-04K"},{"regex":"F-02L(?:[);/ ]|$)","model":"Arrows Be 3 F-02L"},{"regex":"F-41A(?:[);/ ]|$)","model":"Arrows Be 4 F-41A"},{"regex":"F-06E(?:[);/ ]|$)","model":"Arrows NX F-06E"},{"regex":"F-07D(?:[);/ ]|$)","model":"Arrows μ F-07D"},{"regex":"801FJ(?:[);/ ]|$)","model":"Arrows U 801FJ"},{"regex":"F-07E(?:[);/ ]|$)","model":"Disney Mobile F-07E"},{"regex":"F-08D(?:[);/ ]|$)","model":"Disney Mobile F-08D"},{"regex":"F-09D(?:[);/ ]|$)","model":"ANTEPRIMA F-09D"},{"regex":"F-09E(?:[);/ ]|$)","model":"Raku-Raku Smartphone Premium F-09E"},{"regex":"F-10D(?:[);/ ]|$)","model":"Arrows X F-10D"},{"regex":"F-11D(?:[);/ ]|$)","model":"Arrows Me F-11D"},{"regex":"F-12C(?:[);/ ]|$)","model":"F-12C"},{"regex":"(F-04[JF])(?:[);/ ]|$)","model":"$1"},{"regex":"arrowsM03(?:[);/ ]|$)","model":"Arrows M03"},{"regex":"arrowsRX(?:[);/ ]|$)","model":"Arrows RX"},{"regex":"arrowsM04-PREMIUM(?:[);/ ]|$)","model":"Arrows M04 Premium"},{"regex":"arrowsM(0[45])(?:[);/ ]|$)","model":"Arrows M$1"},{"regex":"(F-0[32]F|F-03G|F-04H|F-05E|F-02K)(?:[);/ ]|$)","model":"Arrows Tab $1","device":"tablet"},{"regex":"FARTM933KZ","model":"Arrows Tab M504/HA4","device":"tablet"},{"regex":"M532(?:[);/ ]|$)","model":"Stylistic","device":"tablet"}]},"G-TiDE":{"regex":"G-TiDE","device":"smartphone","models":[{"regex":"Shining7","model":"Shining 7"},{"regex":"G-TiDE_(A1|S[34])","model":"$1"},{"regex":"G-TiDE V6","model":"V6"},{"regex":"E(57|60|66|72|77)","model":"$1"}]},"Gemini":{"regex":"(GEM[0-9]+[a-z]*)","device":"tablet","model":"$1"},"General Mobile":{"regex":"GM 5 Plus|GM8 go|GM [68] d|GM 8|General Mobile 4G|GM 9 (?:Pro|Plus)|e-tab 20(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"GM 5 Plus","model":"GM 5 Plus"},{"regex":"GM ([68]) d","model":"GM $1D"},{"regex":"GM 8","model":"GM 8"},{"regex":"GM8 go","model":"GM 8 Go"},{"regex":"GM 9 Pro","model":"GM 9 Pro"},{"regex":"GM 9 Plus","model":"GM 9 Plus"},{"regex":"General Mobile 4G Dual","model":"4G Dual"},{"regex":"General Mobile 4G","model":"4G"},{"regex":"e-tab 20(?:[);/ ]|$)","device":"tablet","model":"E-Tab 20"}]},"Geotel":{"regex":"GEOTEL[ _]?","device":"smartphone","models":[{"regex":"G1","model":"G1"},{"regex":"GEOTEL[ _]?Note","model":"Note"},{"regex":"GEOTEL[ _]AMIGO","model":"Amigo"}]},"Ghia":{"regex":"GHIA|QS702|VECTOR10\\\\.1","device":"smartphone","models":[{"regex":"QS702","model":"QS702"},{"regex":"GHIA_ZEUS_3G","model":"Zeus 3G"},{"regex":"GHIA_AXIS7","model":"Axis 7","device":"tablet"},{"regex":"VECTOR10\\\\.1","model":"Vector 10.1\\"","device":"tablet"}]},"Gigabyte":{"regex":"GSmart[ _][a-z0-9 ]+(?: Build|\\\\))|Gigabyte-[a-z0-9]+|Simba SX1|GSmart_Classic_Lite|(?<!Eagle )Classic[_ ](?:Joy|Pro)","device":"smartphone","models":[{"regex":"(GSmart[ _][a-z0-9 ]+)(?: Build|[);])","model":"$1"},{"regex":"Gigabyte-([a-z0-9]+)","model":"$1"},{"regex":"(Classic[ _](?:Joy|Pro)|GSmart_Classic_Lite)","model":"$1"},{"regex":"Simba SX1","model":"GSmart Simba SX1"}]},"Gigaset":{"regex":"Gigaset|(?: GS80|GS1[0189]0|GS1[89]5|GS2[89]0|GS5[357]-6|GS[23]70(?:_Plus)?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Gigaset QV(1030|830)","model":"Gigaset QV$1","device":"tablet"},{"regex":"G(S[23]70)[_ ]Plus(?:[);/ ]|$)","model":"G$1 Plus"},{"regex":"GS([23]70|1[0189]0|1[89]5|2[89]0|80)(?:[);/ ]|$)","model":"GS$1"},{"regex":"GS57-6","model":"ME Pro"},{"regex":"GS55-6","model":"ME"},{"regex":"GS53-6","model":"ME Pure"},{"regex":"Gigaset ([^;/]+) Build","model":"$1"},{"regex":"Gigaset ([^;/)]+)(?:[);/]|$)","model":"$1"}]},"Ginzzu":{"regex":"GINZZU[_ ]|((?:RS(?:7[14]|81|9[67])D)|S5002|(?<!Wave Pro )S5021|S5230|S50[45]0|S5120|RS(6[12]|9[45])D|S40[23]0|RS850[12]|RS9602)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"GINZZU[_ ]?(S40[17]0|S4710|ST60[14]0|ST6120)","model":"$1"},{"regex":"GINZZU[_ ]?(GT-(?:1050|7105|70[1-4]0|7115|7210|[WX]831|X[78]70|7810|8[01]10|X853))","model":"$1","device":"tablet"},{"regex":"(RS6[12]D) ULTIMATE","model":"$1 Ultimate"},{"regex":"(?:GINZZU[ _])?((?:RS(?:7[14]|81|9[4-7])D)|S50[45]0|S5002|S5021|S5230|S5120|S40[23]0|RS850[12]|RS9602|RS94D)(?:[);/ ]|$)","model":"$1"}]},"Gionee":{"regex":"(?:GIO-)?GIONEE[ _-]?[a-z0-9]+|(?:Dream_D1|V188S?|GN[0-9]{3,4}[a-z]?)(?:[);/ ]|$)|F103(?: Pro)?(?: Build|\\\\))|P5 mini Build|P7 Max Build|(M7 Power|F106L|F100A|F103S|F103 Pro)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"GN810(?:[);/ ]|$)","model":"GN810","device":"phablet"},{"regex":"GN([0-9]{3,4}[a-z]?)(?:[);/ ]|$)","model":"GN$1"},{"regex":"(F106L|F100A|V188S|V188|F103S)(?:[);/ ]|$)","model":"$1"},{"regex":"M7 Power(?:[);/ ]|$)","model":"M7 Power"},{"regex":"P5 mini Build","model":"P5 mini"},{"regex":"P7 Max Build","model":"P7 Max"},{"regex":"(S11) Lite(?:[);/ ]|$)","model":"$1 Lite"},{"regex":"F103( Pro)?( BUILD|\\\\))","model":"F103$1"},{"regex":"(?:(?:GIO-)?GIONEE[ _-])?Dream_D1(?:[);/ ]|$)","model":"Dream D1"},{"regex":"(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+).*Android","model":"$1"},{"regex":"Android.*(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+)","model":"$1"},{"regex":"(?:GIO-)?GIONEE[ _-]?([a-z0-9]+)","model":"$1","device":"feature phone"}]},"Grape":{"regex":"(?:Grape[ _])?GTM-5([^;/]+) Build","device":"smartphone","model":"GTM-5$1"},"Vizio":{"regex":"Vizio|VAP430|VTAB1008","device":"tv","models":[{"regex":"VAP430","model":"VAP430"},{"regex":"VTAB1008","device":"tablet","model":"VTAB1008"}]},"GOCLEVER":{"regex":"GOCLEVER|QUANTUM_[0-9]{3}|QUANTUM [0-9]{1}|QUANTUM 700N|Quantum2 500|QUANTUM_(1010N|1010M|900)|ARIES|INSIGNIA|ORION_|ELIPSO|LIBRA[ _]97","device":"smartphone","models":[{"regex":"QUANTUM_(1010N|1010M|900)","model":"QUANTUM $1","device":"tablet"},{"regex":"INSIGNIA_(785_PRO|1010M|800M)","model":"INSIGNIA $1","device":"tablet"},{"regex":"(ORION|ARIES|ELIPSO)[_ ](71|101|102)","model":"$1 $2","device":"tablet"},{"regex":"TQ700N","model":"QUANTUM 700N","device":"tablet"},{"regex":"Quantum2 500","model":"Quantum 2 500"},{"regex":"((?:QUANTUM|ARIES|INSIGNIA|ORION|ELIPSO)[ _-]?[^;/]+)(?: Build|\\\\))","model":"$1"},{"regex":"GOCLEVER[ _-]TAB[ _-]?([^;/]+) Build","model":"TAB $1","device":"tablet"},{"regex":"GOCLEVER[ _-]?([^;/]+) Build","model":"$1"},{"regex":"TAB ([^;/)]+) Build/GOCLEVER","model":"TAB $1","device":"tablet"},{"regex":"([^;/)]+) Build/GOCLEVER","model":"$1"},{"regex":"GOCLEVER[ _-]?TAB[ _-]([^;/)]+)(?:[;/)]|$)","model":"TAB $1","device":"tablet"},{"regex":"GOCLEVER[ _-]?([^;/)]+)(?:[;/)]|$)","model":"$1"},{"regex":"LIBRA[ _]97","model":"Libra 97","device":"tablet"}]},"GoMobile":{"regex":"GO Onyx|GO[0-9]{3,4}","device":"smartphone","models":[{"regex":"GO Onyx","model":"Go Onyx"},{"regex":"GO([0-9]{3,4})","model":"Go$1"}]},"Gol Mobile":{"regex":"F10_PRIME","device":"smartphone","models":[{"regex":"F10_PRIME","model":"F10 Prime"}]},"Goly":{"regex":"Goly[ _-]","device":"smartphone","models":[{"regex":"Goly[ _-]([^;/]+) Build","model":"$1"},{"regex":"Goly[ _-]([^;/)]+)(?:[;/)]|$)","model":"$1"}]},"Google":{"regex":"Nexus|GoogleTV|Glass(?<!Browser)|CrKey[^a-z0-9]|Pixel(?: Build|\\\\))|Pixel (?:XL|C|[2-5]|[2-4] XL)|Google 2XL|G011A","device":"smartphone","models":[{"regex":"Glass","model":"Glass"},{"regex":"Galaxy Nexus","model":"Galaxy Nexus"},{"regex":"(Nexus (?:S|4|5X?|One))","model":"$1"},{"regex":"(Nexus (?:6P?))","device":"phablet","model":"$1"},{"regex":"(Nexus (?:7|9|10))","device":"tablet","model":"$1"},{"regex":"CrKey[^a-z0-9]","model":"Chromecast","device":"tv"},{"regex":"GoogleTV","device":"tv","model":"GoogleTV"},{"regex":"Pixel(?: Build|\\\\))","model":"Pixel"},{"regex":"Pixel XL","model":"Pixel XL"},{"regex":"Pixel 3 XL","model":"Pixel 3 XL"},{"regex":"Pixel 2 XL","model":"Pixel 2 XL"},{"regex":"Pixel 3a XL","model":"Pixel 3a XL"},{"regex":"Pixel 3a","model":"Pixel 3a"},{"regex":"Pixel 4 XL","model":"Pixel 4 XL"},{"regex":"Pixel 4a \\\\(5G\\\\)","model":"Pixel 4a (5G)"},{"regex":"pixel 4a","model":"Pixel 4a"},{"regex":"G011A","model":"Pixel 2"},{"regex":"Google 2XL","model":"Pixel 2 XL"},{"regex":"pixel ([2-5])","model":"Pixel $1"},{"regex":"Pixel C","device":"tablet","model":"Pixel C"}]},"Gradiente":{"regex":"GRADIENTE","device":"feature phone","models":[{"regex":"GRADIENTE-([a-z0-9]+)","model":"$1"},{"regex":"GRADIENTE ([a-z0-9\\\\-]+)","model":"$1"}]},"Grundig":{"regex":"GR?-TB[0-9]+[a-z]*|GRUNDIG|portalmmm/2\\\\.0 G|AFTEU(?:011|014|FF014)","device":"tv","models":[{"regex":"(GR?-TB[0-9]+[a-z]*)","device":"tablet","model":"$1"},{"regex":"GRUNDIG ([a-z0-9]+)","model":"$1"},{"regex":"portalmmm/2\\\\.0 G([a-z0-9]+)","model":"G$1"},{"regex":"AFTEU014","model":"Vision 7 4K (2019)"},{"regex":"AFTEUFF014","model":"OLED 4K (2019)"},{"regex":"AFTEU011","model":"Vision 6 HD (2019)"}]},"Hafury":{"regex":"HAFURY","device":"smartphone","models":[{"regex":"(MIX|UMAX)","model":"$1"}]},"Haier":{"regex":"Haier|I6_Infinity|Titan[ _]T[135]|(?:HW-)?W(?:71[67]|757|860|970)(?:[);/ ]|$)|S5 Silk|(?:HM-)?(N505|N700|G(?:152|303|353|552|70[01])?-FL|HM-N501-FL|G(?:303)?-W|I(?:557)?-FL)|(?:PAD[ _](?:D71|G781|d85))|A2_Lite_NFC","device":"smartphone","models":[{"regex":"A2_Lite_NFC","model":"Alpha A2 Lite NFC"},{"regex":"HM-N505-FL","model":"I8"},{"regex":"S5 Silk","model":"S5 Silk"},{"regex":"HM-N700-FL","model":"L7"},{"regex":"HM-N501-FL","model":"L56"},{"regex":"(?:HM-)?(G(?:152|353|552|70[01])|G(?:303)|I(?:557))","model":"$1"},{"regex":"(Titan[_ ]T[135]|I6_Infinity)","model":"$1"},{"regex":"(?:HW-)?W(71[67]|757|860|970)(?:[);/ ]|$)","model":"W$1"},{"regex":"PAD[ -_](D71|G781|d85)","device":"tablet","model":"$1"},{"regex":"Haier[ _\\\\-](H[WT]-[^/;]+) Build","model":"$1"},{"regex":"Haier[ _\\\\-](H[WT]-[a-z0-9_\\\\-]+)","model":"$1"},{"regex":"Haier[ _\\\\-](sy[0-9]+)","model":"$1"},{"regex":"Haier[ _\\\\-]([a-z0-9\\\\-]+)","model":"$1","device":"feature phone"}]},"HannSpree":{"regex":"(HSG[0-9]{4})|SN97T41W|SN1AT71W\\\\(B\\\\)|SN70T51A|SN70T31?|T7-QC","device":"tablet","models":[{"regex":"(HSG[0-9]{4})","model":"$1"},{"regex":"SN1AT71W\\\\(B\\\\)","model":"SN1AT71W(B)"},{"regex":"SN70T31","model":"SN70T31"},{"regex":"SN70T3","model":"SN70T3"},{"regex":"SN70T51A","model":"SN70T51A"},{"regex":"SN97T41W","model":"SN97T41W"},{"regex":"T7-QC","model":"SNAT71BUE"}]},"Hasee":{"regex":"Hasee","device":"smartphone","models":[{"regex":"Hasee ([^;/]+) Build","model":"$1"},{"regex":"Hasee ([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"Hisense":{"regex":"(?:HS-)?Hisense ([^;/]+) Build|Hisense [^);/]+|HISENSE; |HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9\\\\-]*|E270BSA|HWCD100E|HITV300C|M470BS[AE]|EG98|E2281|EG680|I46D1G|HAT4KDTV|HLTE([237]00T|200M|203T|202N|21[023567]T|22[67]T|22[13]E|230E|310[TM]|31[16]T|500T|501N|510[TM]|7[23]0T)","device":"smartphone","models":[{"regex":"E270BSA","device":"tablet","model":"Sero 7"},{"regex":"M470BS[AE]","device":"tablet","model":"Sero 7 Pro"},{"regex":"E2281","device":"tablet","model":"Sero 8"},{"regex":"HLTE202N","model":"A5"},{"regex":"HLTE203T","model":"A5 Pro CC"},{"regex":"HLTE700T","model":"A6"},{"regex":"HLTE730T","model":"A6L"},{"regex":"HLTE221E","model":"E Max"},{"regex":"HLTE501N","model":"V Plus"},{"regex":"HLTE223E","model":"H30"},{"regex":"I46D1G","model":"Smartfren Andromax R"},{"regex":"EG680","model":"Smartfren Andromax Z"},{"regex":"EG98","model":"Smartfren Andromax U2"},{"regex":"HLTE200T(?:[);/ ]|$)","model":"F26"},{"regex":"HLTE210T(?:[);/ ]|$)","model":"F28"},{"regex":"HLTE215T(?:[);/ ]|$)","model":"F29"},{"regex":"HLTE213T(?:[);/ ]|$)","model":"King Kong 4"},{"regex":"HLTE311T(?:[);/ ]|$)","model":"King Kong 4 Pro"},{"regex":"HLTE216T(?:[);/ ]|$)","model":"King Kong 5"},{"regex":"HLTE316T(?:[);/ ]|$)","model":"King Kong 5 Pro"},{"regex":"HLTE226T(?:[);/ ]|$)","model":"King Kong 6"},{"regex":"HLTE217T(?:[);/ ]|$)","model":"F30S"},{"regex":"HLTE227T(?:[);/ ]|$)","model":"F40"},{"regex":"HLTE310[TM](?:[);/ ]|$)","model":"H18"},{"regex":"HLTE510[TM](?:[);/ ]|$)","model":"H20"},{"regex":"HLTE500T(?:[);/ ]|$)","model":"H11"},{"regex":"HLTE230E(?:[);/ ]|$)","model":"H40 Lite"},{"regex":"HLTE720T(?:[);/ ]|$)","model":"U30","device":"phablet"},{"regex":"HWCD100E(?:[);/ ]|$)","model":"U40 Lite"},{"regex":"(HLTE300T|HLTE200M|HLTE212T)(?:[);/ ]|$)","model":"$1"},{"regex":"HITV300C(?:[);/ ]|$)","model":"E9"},{"regex":"E260T\\\\+(?:[);/ ]|$)","model":"Nana"},{"regex":"(HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9\\\\-]*)","model":"$1"},{"regex":"(HAT4KDTV)(?:[);/ ]|$)","device":"tv","model":"$1"},{"regex":"(?:HS-)?Hisense ([^;/]+) Build","model":"$1"},{"regex":"Hisense ([^);/]+)","model":"$1"}]},"Hi-Level":{"regex":"HLV-T([a-z0-9]+)","device":"tablet","model":"HLV-T$1"},"Hoffmann":{"regex":"(HOFFMANN|Neo[_ ]A[1379]00)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Neo[_ ](A[1379]00)","model":"Neo $1"},{"regex":"HOFFMANN[ _]X[-_ ](Prime|Twist|Max)","model":"X $1"}]},"Homtom":{"regex":"Homtom|(?:HT[0-9]{1,2})(?: ?Pro)?(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:Homtom[_ ])?HT ?([0-9]{1,2}(?: ?Pro)?)(?:[);/ ]|$)","model":"HT$1"},{"regex":"Homtom ([^;/]+) Build","model":"$1"}]},"Hosin":{"regex":"HOSIN[ _-]","device":"smartphone","models":[{"regex":"HOSIN[ _-]([^;/]+) Build","model":"$1"},{"regex":"HOSIN[ _-]([^;/]+)(?:[;/)]|$)","model":"$1"}]},"Hoozo":{"regex":"(?:HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)|HZ0010)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)(?:[);/ ]|$)","model":"$1"},{"regex":"(HZ0010)(?:[);/ ]|$)","model":"$1"}]},"Minix":{"regex":"NEO-(?:X8-H|U9-H|X[57]-mini|X8H-PLUS|X88-?I|X7-216A|X5-116A|X[68]|U1|Z64)(?:[);/ ]|$)","device":"tv","models":[{"regex":"NEO-X8-H(?:[);/ ]|$)","model":"NEO X8H"},{"regex":"NEO-X([57])-mini(?:[);/ ]|$)","model":"NEO X$1 Mini"},{"regex":"NEO-X8H-PLUS(?:[);/ ]|$)","model":"NEO X8H Plus"},{"regex":"NEO-X88-?I(?:[);/ ]|$)","model":"NEO X88i"},{"regex":"NEO-X7-216A(?:[);/ ]|$)","model":"NEO X7"},{"regex":"NEO-X5-116A(?:[);/ ]|$)","model":"NEO X5"},{"regex":"NEO-X([68])(?:[);/ ]|$)","model":"NEO X$1"},{"regex":"NEO-U1(?:[);/ ]|$)","model":"NEO U1"},{"regex":"NEO-Z64(?:[);/ ]|$)","model":"NEO Z64"},{"regex":"NEO-U9-H(?:[);/ ]|$)","model":"NEO U9H"}]},"Huawei":{"regex":"(HW-)?(?:Huawei|MediaPad T1|Ideos|Honor[ _]?|(?:(?:AGS|AGS2|ALE|ALP|AMN|ANA|ANE|ARE|ARS|ASK|ATH|ATU|AUM|BAC|BAH[23]?|BG2|BGO|B[ZK]K|BKL|BL[ALN]|BND|BTV|CA[GMNZ]|CH[CM]|CHE[12]?|CLT|CMR|COL|COR|CPN|CRO|CRR|CUN|DIG|DLI|DRA|DUA|DUB|DUK|EDI|ELE|EML|EVA|EVR|FDR|FIG|FLA|FRD|FRL|GEM|GRA|HDN|HLK|HMA|Hol|HRY|HWI|H[36]0|INE|JAT|JEF|JDN|JDN2|JKM|JMM|JSN|KII|KIW|KNT|KOB|KSA|LDN|LEO|LIO|LLD|LND|LON|LRA|LUA|LY[AO]|MAR|MHA|MRD|MYA|NCE|NEM|NEO|NXT|PAR|PCT|PIC|PLE|PLK|POT|PPA|PRA|RIO|RNE|RVL|SCC|SCL|SCM|SEA|SHT|SLA|SNE|SPN|STF|STK|TAG|TIT|TNY|TRT|VCE|VEN|VIE|VKY|VNS|VOG|VRD|VTR|WAS|YAL|G(?:527|620S|621|630|735)|Y(?:221|330|550|6[23]5))-(?:[A-Z]{0,2}[0-9]{1,4}[A-Z]{0,3}?)|H1711|U(?:8230|8500|8661|8665|8667|8800|8818|8860|9200|9508))(?:[);/ ]|$))|hi6210sft|PE-(UL00|TL[12]0|TL00M)|T1-(A21[Lw]|A23L|701u|823L)|G7-(?:L01|TL00)|HW-01K|JNY-(LX[12]|AL10)|OXF-AN[01]0|TAS-(A[LN]00|L29|TL00)|WLZ-(AL10|AN00)|NIC-LX1A|MRX-(AL09|W09)|CDY-(?:[AT]N00|AN90|NX9A)|GLK-(?:[AT]L00|LX1U)|JER-[AT]N10|ELS-(?:[AT]N[10]0|NX9|N39|N04)|AKA-(AL10|L29)|MON-(W|AL)19|BMH-AN[12]0|AQM-([AT]L[01]0|LX1)|MOA-(AL[02]0|LX9N)|NTS-AL00|ART-(?:[AT]L00[xm]|L29N?|L28)|MED-(?:[AT]L00|LX9N?)|EBG-(?:AN[01]0|TN00)|ANA-(?:[AT]N00|NX9)|BZ[AK]-W00|BZT-(W09|AL[01]0)|HDL-(AL09|W09)|HWV3[123]|HW-02L|TEL-[AT]N(?:00a?|10)|KKG-AN00|MXW-AN00|JKM-AL00[ab]|TAH-(?:N29|AN00)m|C8817D|T1-821W|d-01[JK]|d-02[HK]|KRJ-W09|HWT31|Y320-U10|Y541-U02|VAT-L19|70[14]HW|60[58]HW|NOH-(?:NX9|AN00)|TNNH-AN00|LIO-(?:[TA]L00|[LN]29|AN00)|KOB2-[LW]09|AGS3-[WL]09|DNN-LX9|NEY-NX9|LON-AL00|HLK-L41|503HW|AGR-[LW]09|PPA-LX[12]|ANG-AN00|NOP-AN00","device":"smartphone","models":[{"regex":"POT-[TA]L00a(?:[);/ ]|$)","model":"9S"},{"regex":"U9500(?:[);/ ]|$)","model":"Ascend D1"},{"regex":"Z100-UL00(?:[);/ ]|$)","model":"Ascend D3"},{"regex":"Y320-(?:U10|T00|U05)(?:[);/ ]|$)","model":"Ascend Y320"},{"regex":"Y330-U05(?:[);/ ]|$)","model":"Ascend Y330"},{"regex":"Y541-U02(?:[);/ ]|$)","model":"Ascend Y5C"},{"regex":"U8818(?:[);/ ]|$)","model":"Ascend G300"},{"regex":"G527-U081(?:[);/ ]|$)","model":"Ascend G527"},{"regex":"(G620S-L0[13]|C8817D)(?:[);/ ]|$)","model":"Ascend G620S"},{"regex":"G630-U251(?:[);/ ]|$)","model":"Ascend G630"},{"regex":"G7-(?:L01|TL00)(?:[);/ ]|$)","model":"Ascend G7"},{"regex":"P7-L10(?:[);/ ]|$)","model":"Ascend P7"},{"regex":"G730-C00(?:[);/ ]|$)","model":"Ascend G730"},{"regex":"U9200(?:[);/ ]|$)","model":"Ascend P1"},{"regex":"H1711(?:[);/ ]|$)","model":"Ascend XT2"},{"regex":"Y221-U(?:[12]2|[0345]3)(?:[);/ ]|$)","model":"Ascend Y221"},{"regex":"Y550-L03(?:[);/ ]|$)","model":"Ascend Y550"},{"regex":"ART-[AT]L00[xm](?:[);/ ]|$)","model":"Enjoy 10"},{"regex":"STK-[AT]L00(?:[);/ ]|$)","model":"Enjoy 10 Plus"},{"regex":"MED-[AT]L00(?:[);/ ]|$)","model":"Enjoy 10E"},{"regex":"AQM-[AT]L00(?:[);/ ]|$)","model":"Enjoy 10S"},{"regex":"TAG-[ACT]L00(?:[);/ ]|$)","model":"Enjoy 5S"},{"regex":"NCE-(AL[10]0|TL10)(?:[);/ ]|$)","model":"Enjoy 6"},{"regex":"DIG-(?:TL10|AL00)(?:[);/ ]|$)","model":"Enjoy 6S"},{"regex":"SLA-(?:AL00|TL10)(?:[);/ ]|$)","model":"Enjoy 7"},{"regex":"FIG-(?:[AT]L[10]0)(?:[);/ ]|$)","model":"Enjoy 7S"},{"regex":"(?:TRT-AL00[A]?|TRT-TL10A)(?:[);/ ]|$)","model":"Enjoy 7 Plus"},{"regex":"LDN-(?:AL[12]0|TL[02]0)(?:[);/ ]|$)","model":"Enjoy 8"},{"regex":"FLA-AL10(?:[);/ ]|$)","model":"Enjoy 8 Plus"},{"regex":"ATU-[AT]L10(?:[);/ ]|$)","model":"Enjoy 8e"},{"regex":"MRD-[TA]L00(?:[);/ ]|$)","model":"Enjoy 9e"},{"regex":"DVC-TN20(?:[);/ ]|$)","model":"Enjoy 20 Pro"},{"regex":"U8665(?:[);/ ]|$)","model":"Fusion 2"},{"regex":"MED-LX9N?(?:[);/ ]|$)","model":"Y6p"},{"regex":"G735-L(?:03|12|23)(?:[);/ ]|$)","model":"G Play"},{"regex":"CHC-U(?:0[13]|23)(?:[);/ ]|$)","model":"G Play Mini"},{"regex":"(?:Honor_|HW-)?G621-TL00M?(?:[);/ ]|$)","model":"G621"},{"regex":"DIG-L2[12](?:[);/ ]|$)","model":"GR3 (2017)"},{"regex":"KII-L21(?:[);/ ]|$)","model":"GR5"},{"regex":"BLL-L2[12](?:[);/ ]|$)","model":"GR5 (2017)"},{"regex":"RIO-L03(?:[);/ ]|$)","model":"GX8"},{"regex":"U8860(?:[);/ ]|$)","model":"Honor"},{"regex":"COL-(?:AL[01]0|TL[01]0|L29)(?:[);/ ]|$)","model":"Honor 10"},{"regex":"HRY-(?:[AT]L00[A]?|LX[12]|LX1MEB)(?:[);/ ]|$)","model":"Honor 10 Lite"},{"regex":"HRY-LX1T(?:[);/ ]|$)","model":"Honor 10I"},{"regex":"U9508(?:[);/ ]|$)","model":"Honor 2"},{"regex":"YAL-(?:L21|[AT]L00)(?:[);/ ]|$)","model":"Honor 20"},{"regex":"LRA-AL00(?:[);/ ]|$)","model":"Honor 20 Lite"},{"regex":"(HRY-AL00T[a]?)(?:[);/ ]|$)","model":"Honor 20I"},{"regex":"YAL-(L41|AL10)(?:[);/ ]|$)","model":"Honor 20 Pro"},{"regex":"(MAR-LX1H|YAL-AL50)(?:[);/ ]|$)","model":"Honor 20S"},{"regex":"(?:BMH-AN[12]0|MXW-AN00)(?:[);/ ]|$)","model":"Honor 30"},{"regex":"EBG-[AT]N00(?:[);/ ]|$)","model":"Honor 30 Pro"},{"regex":"EBG-AN10(?:[);/ ]|$)","model":"Honor 30 Pro Plus"},{"regex":"CDY-(?:AN90|NX9A)(?:[);/ ]|$)","model":"Honor 30S"},{"regex":"LRA-LX1(?:[);/ ]|$)","model":"Honor 30I"},{"regex":"(?:Honor_|HW-)?H30-(?:C00|L01M?|L02|U10|T00|T10)(?:_TD)?(?:[);/ ]|$)","model":"Honor 3C"},{"regex":"Hol-U19(?:[);/ ]|$)","model":"Honor 3C Lite"},{"regex":"G750-T01(?:[);/ ]|$)","model":"Honor 3X"},{"regex":"(?:Honor_|HW-)?SCL-(?:AL00|CL00|TL00H?)(?:_TD)?(?:[);/ ]|$)","model":"Honor 4A"},{"regex":"(?:Honor_|HW-)?CHM-U01(?:_TD)?(?:[);/ ]|$)","model":"Honor 4C"},{"regex":"Honor 4c Pro(?:[);/ ]|$)","model":"Honor 4C Pro"},{"regex":"AQM-AL10(?:[);/ ]|$)","model":"Honor 4T Pro"},{"regex":"(CHE2?-[UT]L00[HM]?|CHE1-CL[12]0|CHE2-L(?:1[12]|23)|Che1-L04|CHE-TL00)(?:[);/ ]|$)","model":"Honor 4X"},{"regex":"(?:Honor_|HW-)?CUN-[AT]L00(?:[);/ ]|$)","model":"Honor 5 Play"},{"regex":"(?:Honor_|HW-)?CAM-(?:AL00|TL00H|TL00)(?:_TD)?(?:[);/ ]|$)","model":"Honor 5A"},{"regex":"(?:Honor_|HW-)?NEM-(?:AL10|L51|UL10|TL00)(?:[);/ ]|$)","model":"Honor 5C"},{"regex":"(?:Honor_|HW-)?NEM-(?:L22|TL00H)(?:[);/ ]|$)","model":"Honor 5C Dual SIM"},{"regex":"(?:Honor_|HW-)?KIW-(?:AL10|TL00H|[TC]L00|L2[1-4]|UL00)(?:_TD)?(?:[);/ ]|$)","model":"Honor 5X"},{"regex":"((?:Honor_|HW-)?H60-L(?:01|02|03|04|11|12)(?:_TD)?|HW-H60-J1)(?:[);/ ]|$)","model":"Honor 6"},{"regex":"MYA-TL10(?:[);/ ]|$)","model":"Honor 6 Play"},{"regex":"PE-(UL00|TL[12]0|TL00M)(?:[);/ ]|$)","model":"Honor 6 Plus"},{"regex":"(?:HONOR[ _]?)?DLI-(?:AL10|L[24]2|TL20)(?:[);/ ]|$)","model":"Honor 6A"},{"regex":"DIG-L21HN(?:[);/ ]|$)","model":"Honor 6C"},{"regex":"JMM-L22(?:[);/ ]|$)","model":"Honor 6C Pro"},{"regex":"(?:HONOR[ _]?)?BLN-(?:L2[124]|AL[1234]0|TL[01]0(?:[);/ ]|$))","model":"Honor 6X"},{"regex":"(?:Honor[_]?|HW-)?PLK-(?:AL10|CL00|TL00|TL01H?|UL00|L01)(?:[);/ ]|$)","model":"Honor 7"},{"regex":"(?:Honor_|HW-)?NEM-L21(?:[);/ ]|$)","model":"Honor 7 Lite"},{"regex":"AUM-(?:AL[20]0|L33[A]?|TL20)(?:[);/ ]|$)","model":"Honor 7A"},{"regex":"AUM-L29(?:[);/ ]|$)","model":"Honor 7A Pro"},{"regex":"(?:Honor_|HW-)?(?:LND-(?:AL[34]0|L29|TL40)|AUM-L41)(?:[);/ ]|$)","model":"Honor 7C"},{"regex":"ATH-(?:[CAU]L00|TL00H)(?:[);/ ]|$)","model":"Honor 7i"},{"regex":"(?:Honor_|HW-)?DUA-(?:L22|LX3)(?:[);/ ]|$)","model":"Honor 7S"},{"regex":"(?:HONOR[ _]?)?BND-(?:AL[01]0|TL10|L2[14]|L31)(?:[);/ ]|$)","model":"Honor 7X"},{"regex":"(?:FRD-(?:AL[01]0|L0[249]|L1[49]|DL00)|VAT-L19)(?:[);/ ]|$)","model":"Honor 8"},{"regex":"PRA-(?:AL00X|AL00|TL10)(?:[);/ ]|$)","model":"Honor 8 Lite"},{"regex":"DUK-(?:L09|TL30)(?:[);/ ]|$)","model":"Honor 8 Pro"},{"regex":"VEN-L22(?:[);/ ]|$)","model":"Honor 8 Smart"},{"regex":"JAT-L(29|X[13])(?:[);/ ]|$)","model":"Honor 8A"},{"regex":"JAT-L41(?:[);/ ]|$)","model":"Honor 8A Pro"},{"regex":"BKK-(?:AL[10]0|L21|L22|LX2|TL00)(?:[);/ ]|$)","model":"Honor 8C"},{"regex":"KSA-(LX[239]|AL00)(?:[);/ ]|$)","model":"Honor 8S"},{"regex":"JSN-L(?:2[123]|42)|JSN-[TA]L00[a]?(?:[);/ ]|$)","model":"Honor 8X"},{"regex":"ARE-(?:AL[10]0|L22(?:HN)?|TL00)(?:[);/ ]|$)","model":"Honor 8X Max"},{"regex":"STF-(?:AL[10]0|L09S?|TL10)(?:[);/ ]|$)","model":"Honor 9"},{"regex":"MOA-LX9N(?:[);/ ]|$)","model":"Honor 9A"},{"regex":"AKA-L29(?:[);/ ]|$)","model":"Honor 9C"},{"regex":"LLD-(?:AL[01]0|L[23]1|TL10)(?:[);/ ]|$)","model":"Honor 9 Lite"},{"regex":"LLD-AL[23]0(?:[);/ ]|$)","model":"Honor 9i"},{"regex":"DUA-LX9(?:[);/ ]|$)","model":"Honor 9S"},{"regex":"HLK-AL00a?(?:[);/ ]|$)","model":"Honor 9X"},{"regex":"HLK-(?:AL10|L4[12])(?:[);/ ]|$)","model":"Honor 9X Pro"},{"regex":"CAM-UL00(?:[);/ ]|$)","model":"Honor Holly 3"},{"regex":"NTS-AL00(?:[);/ ]|$)","model":"Honor Magic"},{"regex":"TNY-[AT]L00(?:[);/ ]|$)","model":"Honor Magic 2"},{"regex":"RVL-AL09(?:[);/ ]|$)","model":"Honor Note 10"},{"regex":"EDI-AL10(?:[);/ ]|$)","model":"Honor Note 8"},{"regex":"VKY-TL00(?:[);/ ]|$)","model":"Honor P10 Plus"},{"regex":"VOG-AL00(?:[);/ ]|$)","model":"Honor P30 Pro"},{"regex":"ANA-(?:[AT]N00|NX9)(?:[);/ ]|$)","model":"Honor P40"},{"regex":"COR-(?:AL[01]0|L29|TL10)(?:[);/ ]|$)","model":"Honor Play"},{"regex":"ASK-AL00x(?:[);/ ]|$)","model":"Honor Play 3"},{"regex":"KSA-AL10(?:[);/ ]|$)","model":"Honor Play 3E"},{"regex":"TNNH-AN00(?:[);/ ]|$)","model":"Honor Play 4"},{"regex":"CHM-[CUT]L00[HM]?(?:[);/ ]|$)","model":"Honor Play 4C"},{"regex":"AKA-AL10(?:[);/ ]|$)","model":"Honor Play 4T"},{"regex":"DUA-[TA]L00(?:[);/ ]|$)","model":"Honor Play 7"},{"regex":"JAT-[AT]L00(?:[);/ ]|$)","model":"Honor Play 8A"},{"regex":"MOA-AL[02]0(?:[);/ ]|$)","model":"Honor Play 9A"},{"regex":"BKL-(?:AL00|AL20|AL30|L09|TL10)(?:[);/ ]|$)","model":"Honor V10"},{"regex":"PCT-[TA]L10(?:[);/ ]|$)","model":"Honor V20"},{"regex":"KNT-(?:AL[12]0|[TU]L10)(?:[);/ ]|$)","model":"Honor V8"},{"regex":"DUK-AL20(?:[);/ ]|$)","model":"Honor V9"},{"regex":"JMM-[AT]L[01]0(?:[);/ ]|$)","model":"Honor V9 Play"},{"regex":"BKL-L04(?:[);/ ]|$)","model":"Honor View 10"},{"regex":"PCT-L29(?:[);/ ]|$)","model":"Honor View 20"},{"regex":"OXF-AN00(?:[);/ ]|$)","model":"Honor View 30"},{"regex":"OXF-AN10(?:[);/ ]|$)","model":"Honor View 30 Pro"},{"regex":"(?:Honor_|HW-)?SCL-L(01|32)(?:_TD)?(?:[);/ ]|$)","model":"Honor Y6"},{"regex":"(?:Honor_|HW-)?LYO-L21(?:[);/ ]|$)","model":"Honor Y6 II Compact"},{"regex":"TEL-(?:AN(?:00a?|10)|TN00)(?:[);/ ]|$)","model":"Honor X10"},{"regex":"KKG-AN00(?:[);/ ]|$)","model":"Honor X10 Max"},{"regex":"DNN-LX9(?:[);/ ]|$)","model":"Honor X10 Lite"},{"regex":"U8500(?:[);/ ]|$)","model":"Ideos X2"},{"regex":"U8510(?:[);/ ]|$)","model":"Ideos X3"},{"regex":"U8800(?:[);/ ]|$)","model":"Ideos X5"},{"regex":"MLA-AL10(?:[);/ ]|$)","model":"Maimang 5"},{"regex":"POT-AL10(?:[);/ ]|$)","model":"Maimang 8"},{"regex":"TAH-(?:N29|AN00)m(?:[);/ ]|$)","model":"Mate XS"},{"regex":"ALP-(?:[TA]L00|L[02]9)(?:[);/ ]|$)","model":"Mate 10"},{"regex":"RNE-(?:AL00|L(?:01|03|21|23))(?:[);/ ]|$)","model":"Mate 10 Lite"},{"regex":"BLA-(?:A09|L[02]9|[TA]L00)(?:[);/ ]|$)","model":"Mate 10 Pro"},{"regex":"HMA-(?:[AT]L00|L[02]9)(?:[);/ ]|$)","model":"Mate 20"},{"regex":"SNE-(?:AL00|LX[0-3])(?:[);/ ]|$)","model":"Mate 20 Lite"},{"regex":"LYA-(?:AL[01]0|L[02]9|L0C|TL00)(?:[);/ ]|$)","model":"Mate 20 Pro"},{"regex":"LYA-AL00P(?:[);/ ]|$)","model":"Mate 20 RS"},{"regex":"EVR-(?:[TA]L00|L29|N29|AN00)(?:[);/ ]|$)","model":"Mate 20 X"},{"regex":"TAS-([AT]L00|L29)(?:[);/ ]|$)","model":"Mate 30"},{"regex":"TAS-AN00(?:[);/ ]|$)","model":"Mate 30 5G"},{"regex":"SPN-AL00(?:[);/ ]|$)","model":"Mate 30 Lite"},{"regex":"LIO-(?:[TA]L00|L29|AN00)(?:[);/ ]|$)","model":"Mate 30 Pro"},{"regex":"LIO-N29(?:[);/ ]|$)","model":"Mate 30 Pro 5G"},{"regex":"NOH-(?:NX9|AN00)(?:[);/ ]|$)","model":"Mate 40 Pro"},{"regex":"NOP-AN00(?:[);/ ]|$)","model":"Mate 40 Pro+"},{"regex":"NXT-(?:AL10|L29)(?:[);/ ]|$)","model":"Mate 8"},{"regex":"MHA-(?:L[02]9|[AT]L00)(?:[);/ ]|$)","model":"Mate 9"},{"regex":"BLL-L23(?:[);/ ]|$)","model":"Mate 9 Lite"},{"regex":"LON-(?:AL00(?:-PD)?|L29)(?:[);/ ]|$)","model":"Mate 9 Pro"},{"regex":"NEO-AL00(?:[);/ ]|$)","model":"Mate RS"},{"regex":"NEO-L29(?:[);/ ]|$)","model":"Mate RS Porsche Design"},{"regex":"CRR-(?:L09|UL00)(?:[);/ ]|$)","model":"Mate S"},{"regex":"BND-L34(?:[);/ ]|$)","model":"Mate SE"},{"regex":"(CAZ-(?:AL[01]0|TL[12]0)|CAN-L[01][1-3])(?:[);/ ]|$)","model":"Nova"},{"regex":"608HW(?:[);/ ]|$)","model":"Nova Lite"},{"regex":"(?:PIC-(?:[AT]L00|LX9)|HWV31)(?:[);/ ]|$)","model":"Nova 2"},{"regex":"704HW(?:[);/ ]|$)","model":"Nova 2 Lite"},{"regex":"BAC-(?:L01|TL00)(?:[);/ ]|$)","model":"Nova 2 Plus"},{"regex":"BAC-(?:AL00|L2[12])(?:[);/ ]|$)","model":"Nova 2 Plus Dual SIM"},{"regex":"RNE-L[02]2(?:[);/ ]|$)","model":"Nova 2I"},{"regex":"HWI-[AT]L00(?:[);/ ]|$)","model":"Nova 2S"},{"regex":"PAR-(?:[AT]L00|LX[19]|LX1M|TL20)(?:[);/ ]|$)","model":"Nova 3"},{"regex":"ANE-AL00(?:[);/ ]|$)","model":"Nova 3e"},{"regex":"INE-(?:AL00|LX[12]r|LX[12]|TL00)(?:[);/ ]|$)","model":"Nova 3i"},{"regex":"VCE-(L22|[AT]L00)(?:[);/ ]|$)","model":"Nova 4"},{"regex":"MAR-AL00(?:[);/ ]|$)","model":"Nova 4e"},{"regex":"SEA-AL00(?:[);/ ]|$)","model":"Nova 5"},{"regex":"SEA-AL10(?:[);/ ]|$)","model":"Nova 5 Pro"},{"regex":"GLK-(?:[AT]L00|LX1U)(?:[);/ ]|$)","model":"Nova 5i"},{"regex":"SPN-TL00(?:[);/ ]|$)","model":"Nova 5i Pro"},{"regex":"WLZ-AL10(?:[);/ ]|$)","model":"Nova 6"},{"regex":"WLZ-AN00(?:[);/ ]|$)","model":"Nova 6 5G"},{"regex":"JNY-AL10(?:[);/ ]|$)","model":"Nova 6 SE"},{"regex":"JEF-(?:[AT]N00|AN20|NX9)(?:[);/ ]|$)","model":"Nova 7 5G"},{"regex":"JER-[AT]N10(?:[);/ ]|$)","model":"Nova 7 Pro 5G"},{"regex":"CDY-(?:[AT]N00|NX9B)(?:[);/ ]|$)","model":"Nova 7 SE 5G"},{"regex":"JNY-LX2(?:[);/ ]|$)","model":"Nova 7i"},{"regex":"ANG-AN00(?:[);/ ]|$)","model":"Nova 8 5G"},{"regex":"DIG-L01(?:[);/ ]|$)","model":"Nova Smart"},{"regex":"WAS-AL00(?:[);/ ]|$)","model":"Nova Youth"},{"regex":"FIG-L(?:A1|X[123])(?:[);/ ]|$)","model":"P smart"},{"regex":"POT-(?:LX(?:[13]|1T|2J|1AF)|AL00)(?:[);/ ]|$)","model":"P smart (2019)"},{"regex":"POT-LX1A(?:[);/ ]|$)","model":"P smart (2020)"},{"regex":"PPA-LX[12](?:[);/ ]|$)","model":"P smart (2021)"},{"regex":"STK-LX1(?:[);/ ]|$)","model":"P smart Z"},{"regex":"VTR-(?:L[02]9|AL00|TL00)(?:[);/ ]|$)","model":"P10"},{"regex":"WAS-(?:L(?:X1|X1A|X2|X2J|X3|03T)|TL10)(?:[);/ ]|$)","model":"P10 Lite"},{"regex":"VKY-(?:AL00|L09|L29)(?:[);/ ]|$)","model":"P10 Plus"},{"regex":"BAC-L[02]3(?:[);/ ]|$)","model":"P10 Selfie"},{"regex":"EML-(?:[TA]L00|L[02]9)(?:[);/ ]|$)","model":"P20"},{"regex":"(?:ANE-(?:LX[123]|LX2J|TL00)|HWV32)(?:[);/ ]|$)","model":"P20 Lite"},{"regex":"(?:CLT-(?:AL0[01]|TL0[01]|L(?:04|[02]9))|HW-01K)(?:[);/ ]|$)","model":"P20 Pro"},{"regex":"(ELE-L(?:04|09|29)|ELE-[AT]L00)(?:[);/ ]|$)","model":"P30"},{"regex":"(?:MAR-(?:LX(?:1[BM]|2J?|3BM)|TL00)|NIC-LX1A|HWV33)(?:[);/ ]|$)","model":"P30 Lite"},{"regex":"MAR-LX[13]Am?(?:[);/ ]|$)","model":"P30 Lite Dual SIM"},{"regex":"(?:VOG-(?:L(?:04|09|29)|TL00|AL10)|HW-02L)(?:[);/ ]|$)","model":"P30 Pro"},{"regex":"ANA-LX4(?:[);/ ]|$)","model":"P40"},{"regex":"JNY-LX1(?:[);/ ]|$)","model":"P40 Lite"},{"regex":"ART-L29(?:[);/ ]|$)","model":"P40 Lite E"},{"regex":"ART-L29N(?:[);/ ]|$)","model":"P40 Lite E NFC"},{"regex":"(?:ELS-(?:[AT]N00|NX9|N04)|NEY-NX9)(?:[);/ ]|$)","model":"P40 Pro"},{"regex":"ELS-(?:AN10|N39)(?:[);/ ]|$)","model":"P40 Pro Plus"},{"regex":"GRA-(?:L09|UL00)(?:[);/ ]|$)","model":"P8"},{"regex":"(?:ALE-L(?:02|21|23)|ALE-UL00|ALE-TL00|503HW)(?:[);/ ]|$)","model":"P8 Lite (2015)"},{"regex":"(?:PRA-L(?:A1|X2|X1|X3)|hi6210sft)(?:[);/ ]|$)","model":"P8 Lite (2017)"},{"regex":"EVA-(?:AL[10]0|L[012]9|[TCD]L00)(?:[);/ ]|$)","model":"P9"},{"regex":"VNS-L(?:[23]1|[26]2)(?:[);/ ]|$)","model":"P9 Lite"},{"regex":"SLA-L(?:02|03|22|23)(?:[);/ ]|$)","model":"P9 Lite Mini"},{"regex":"DIG-L(?:03|23)(?:[);/ ]|$)","model":"P9 Lite Smart"},{"regex":"VIE-(?:AL10|L[02]9)(?:[);/ ]|$)","model":"P9 Plus"},{"regex":"ATH-UL0[16](?:[);/ ]|$)","model":"ShotX"},{"regex":"U(8230|8661|8667)(?:[);/ ]|$)","model":"U$1"},{"regex":"ARS-([AT]L00|L22)(?:[);/ ]|$)","model":"Y Max"},{"regex":"CRO-(?:L[02]2|U00)(?:[);/ ]|$)","model":"Y3 (2017)"},{"regex":"CAG-L[02]2(?:[);/ ]|$)","model":"Y3 (2018)"},{"regex":"LUA-(U22|L2[12]|U03)(?:[);/ ]|$)","model":"Y3II"},{"regex":"MYA-(?:L(?:02|03|2[23])|U29)(?:[);/ ]|$)","model":"Y5 (2017)"},{"regex":"DRA-L(?:01|03|21|23|X3)(?:[);/ ]|$)","model":"Y5 (2018)"},{"regex":"AMN-LX[1239](?:[);/ ]|$)","model":"Y5 (2019)"},{"regex":"DRA-LX5(?:[);/ ]|$)","model":"Y5 lite"},{"regex":"DRA-LX9(?:[);/ ]|$)","model":"Y5p"},{"regex":"CRO-L[02]3(?:[);/ ]|$)","model":"Y5 Lite (2017)"},{"regex":"CAG-L[02]3(?:[);/ ]|$)","model":"Y5 Lite (2018)"},{"regex":"DRA-(?:LX2|[AT]L00)(?:[);/ ]|$)","model":"Y5 Prime (2018)"},{"regex":"MYA-L13(?:[);/ ]|$)","model":"Y5 Pro (2017)"},{"regex":"CUN-(?:L(?:0[123]|2[123]|33)|U29)(?:[);/ ]|$)","model":"Y5II"},{"regex":"(?:SCC-U21|SCL-U31)(?:[);/ ]|$)","model":"Y6"},{"regex":"MYA-L11(?:[);/ ]|$)","model":"Y6 (2016)"},{"regex":"MYA-(L41|AL10)(?:[);/ ]|$)","model":"Y6 (2017)"},{"regex":"ATU-L(?:11|21|22|X3)(?:[);/ ]|$)","model":"Y6 (2018)"},{"regex":"MRD-L(?:X1[NF]?|X3)(?:[);/ ]|$)","model":"Y6 (2019)"},{"regex":"ATU-L(?:31|42)(?:[);/ ]|$)","model":"Y6 Prime (2018)"},{"regex":"TIT-(?:AL00|L01|U02)(?:[);/ ]|$)","model":"Y6 Pro"},{"regex":"MRD-LX2(?:[);/ ]|$)","model":"Y6 Pro (2019)"},{"regex":"Y625-U03(?:[);/ ]|$)","model":"Y625"},{"regex":"Y635-L0[123](?:[);/ ]|$)","model":"Y635"},{"regex":"Y635-L21(?:[);/ ]|$)","model":"Y635 Dual SIM"},{"regex":"CAM-L(?:03|21|23|32)(?:[);/ ]|$)","model":"Y6II"},{"regex":"TRT-LX[123](?:[);/ ]|$)","model":"Y7 (2017)"},{"regex":"LDN-L(?:01|X3)(?:[);/ ]|$)","model":"Y7 (2018)"},{"regex":"(?:HUAWEI[ _]?)?DUB-(?:LX[13]|TL00)(?:[);/ ]|$)","model":"Y7 (2019)"},{"regex":"(LDN-(?:AL00|L21)|TRT-TL10)(?:[);/ ]|$)","model":"Y7 Prime"},{"regex":"(LDN-(?:LX2|TL10)|TRT-(?:L21A|L53))(?:[);/ ]|$)","model":"Y7 Prime (2018)"},{"regex":"DUB-(?:LX2|AL00)(?:[);/ ]|$)","model":"Y7 Pro (2019)"},{"regex":"DUB-AL00a(?:[);/ ]|$)","model":"Enjoy 9"},{"regex":"DUB-AL20(?:[);/ ]|$)","model":"Y7 Pro (2019)"},{"regex":"PPA-LX3(?:[);/ ]|$)","model":"Y7a"},{"regex":"ART-L28(?:[);/ ]|$)","model":"Y7p"},{"regex":"AQM-LX1(?:[);/ ]|$)","model":"Y8p"},{"regex":"FLA-(LX[123]|AL20|TL10)(?:[);/ ]|$)","model":"Y9 (2018)"},{"regex":"JKM-(?:[TA]L00[ab]?|LX[123])(?:[);/ ]|$)","model":"Y9 (2019)"},{"regex":"STK-(L2[12]|LX3)(?:[);/ ]|$)","model":"Y9 Prime (2019)"},{"regex":"FRL-L2[23](?:[);/ ]|$)","model":"Y9a"},{"regex":"HWT31(?:[);/ ]|$)","model":"Qua Tab 02 10.1\\"","device":"tablet"},{"regex":"HDN-[LW]09(?:[);/ ]|$)","model":"Honor Water Play 10.1","device":"tablet"},{"regex":"BAH3-(?:AL00|[LW]09)(?:[);/ ]|$)","model":"MatePad 10.4\\"","device":"tablet"},{"regex":"BAH3-W59(?:[);/ ]|$)","model":"MatePad 10.4\\" WiFi","device":"tablet"},{"regex":"AGS3-[WL]09(?:[);/ ]|$)","model":"MatePad T10s","device":"tablet"},{"regex":"HDL-(?:W09|AL09)(?:[);/ ]|$)","model":"Honor Water Play 8.0","device":"tablet"},{"regex":"JDN-(?:AL00|W09)(?:[);/ ]|$)","model":"Honor Pad 2","device":"tablet"},{"regex":"KRJ-W09(?:[);/ ]|$)","model":"Honor Pad V6","device":"tablet"},{"regex":"MON-(W|AL)19(?:[);/ ]|$)","device":"tablet","model":"MatePad C5 8"},{"regex":"BZA-W00(?:[);/ ]|$)","device":"tablet","model":"C3 9.6"},{"regex":"M2-801L(?:[);/ ]|$)","device":"tablet","model":"MediaPad M2 8.0\\""},{"regex":"MRX-(AL09|W09)(?:[);/ ]|$)","device":"tablet","model":"MatePad Pro"},{"regex":"CMR-(?:AL[01]9|W09)(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 10.8"},{"regex":"CMR-W19(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 Pro 10.8"},{"regex":"SCM-AL09(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 Pro"},{"regex":"GEM-70[1-3]L(?:[);/ ]|$)","device":"tablet","model":"MediaPad X2"},{"regex":"(?:JDN2-(:?[WL]09|AL[50]0)|BAH2-(?:AL[01]0|L09|W[01]9))(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 Lite"},{"regex":"SHT-(?:AL|W)09(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 8.4"},{"regex":"VRD-(?:(AL|W)09|AL10|W10)(?:[);/ ]|$)","device":"tablet","model":"MediaPad M6 8.4"},{"regex":"SCM-W09(?:[);/ ]|$)","device":"tablet","model":"MediaPad M6 10"},{"regex":"BTV-W09(?:[);/ ]|$)","device":"tablet","model":"MediaPad M3 8"},{"regex":"(BAH-W09|CPN-(?:L|W)09|CPN-AL00|701HW)(?:[);/ ]|$)","device":"tablet","model":"MediaPad M3 Lite"},{"regex":"BAH-(?:L09|AL00)(?:[);/ ]|$)","device":"tablet","model":"MediaPad M3 Lite 10"},{"regex":"BTV-DL09","device":"tablet","model":"MediaPad M3"},{"regex":"(AGS2-AL00|JDN2-W09)HN(?:[);/ ]|$)","device":"tablet","model":"Honor Tab 5"},{"regex":"AGS2-(?:[LW]09|W19|L03)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T5 10"},{"regex":"KOB2-[LW]09(?:[);/ ]|$)","device":"tablet","model":"MediaPad T 8.0\\""},{"regex":"AGR-[LW]09(?:[);/ ]|$)","device":"tablet","model":"MediaPad T 10"},{"regex":"AGS-(?:L0[39]|W09)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T3 10"},{"regex":"(KOB-(?:L|W)09|BZK-[LW]00)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T3 8"},{"regex":"BG2-(?:U0[13]|W09)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T3 7"},{"regex":"BGO-L03(?:[);/ ]|$)","device":"tablet","model":"MediaPad T2 7.0"},{"regex":"(?:BGO-DL09|PLE-70[13]L)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T2 7.0 Pro"},{"regex":"JDN-L01(?:[);/ ]|$)","device":"tablet","model":"MediaPad T2 8.0 Pro"},{"regex":"(?:FDR-(A01[LW]|A03L)|605HW)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T2 10.0\\" Pro"},{"regex":"T1-(?:A21[LW]|A23L)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T1 10"},{"regex":"T1-701u(?:[);/ ]|$)","device":"tablet","model":"MediaPad T1 7"},{"regex":"(?:T1-82(?:3L|1W)|MediaPad T1 8.0)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T1 8"},{"regex":"AGS2-AL00(?:[);/ ]|$)","device":"tablet","model":"Enjoy Tablet 10.1"},{"regex":"BZT-(W09|AL[01]0)(?:[);/ ]|$)","device":"tablet","model":"MediaPad C5 10.1"},{"regex":"(?:d-01J|d-02[HK])(?:[);/ ]|$)","device":"tablet","model":"D Tab Compact"},{"regex":"(d-01K)(?:[);/ ]|$)","device":"tablet","model":"dtab d-01K"},{"regex":"LEO-BX9(?:[);/ ]|$)","device":"wearable","model":"Smart Watch 2"},{"regex":"(MediaPad[^/;]*) Build","device":"tablet","model":"$1"},{"regex":"Ideos([^;/]*) Build","model":"Ideos$1"},{"regex":"(?:HUAWEI )?MT([0-9]+)","device":"phablet","model":"Ascend Mate $1"},{"regex":"Huawei[ _\\\\-]?([^/;]*) Build","model":"$1"},{"regex":"(?:HW-)?Huawei(?!Browser)(?:/1\\\\.0/0?(?:Huawei))?[_\\\\- /]?([a-z0-9\\\\-_]+)","model":"$1"},{"regex":"Huawei; ([a-z0-9 \\\\-]+)","model":"$1"}]},"Hyundai":{"regex":"Hyundai|Ultra (?:Active|Air|Charm|Dream|Energy|Latitude|Link|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)|G(24027|2552[34])K|W25042L|HP554O|Seoul S8|L503F Plus|HT0701L16|HT0704K08|HT1004L16|HT1004LI16|Koral_8W2|Eternity[_ ]G25","device":"smartphone","models":[{"regex":"Ultra (Active|Air|Charm|Dream|Energy Lite|Energy Plus|Energy|Latitude|Link|Live II|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)","model":"Ultra $1"},{"regex":"Seoul S8","model":"Seoul S8"},{"regex":"G25523K","model":"Eternity G23"},{"regex":"Eternity[_ ]G25","model":"Eternity G25"},{"regex":"G25524K","model":"Eternity G24"},{"regex":"G24027K","model":"Eternity G27"},{"regex":"W25042L","model":"Eternity W42"},{"regex":"HP554O","model":"HP554O"},{"regex":"L503F Plus","model":"L503F Plus"},{"regex":"L503F Plus","model":"L503F Plus"},{"regex":"(?:Hyundai_)?(Eternity_G57L)","model":"$1"},{"regex":"HT0701L16","model":"Koral 7XL","device":"tablet"},{"regex":"HT1004LI16","model":"Koral 10XL","device":"tablet"},{"regex":"Koral_8W2","model":"Koral 8W2","device":"tablet"},{"regex":"HT1004L16","model":"Koral 10XL","device":"tablet"},{"regex":"HT0704K08","model":"Koral 7M4","device":"tablet"},{"regex":"Hyundai ([^;/]+) Build","model":"$1","device":"tablet"},{"regex":"Hyundai[ _\\\\-]?([a-z0-9_-]+)","model":"$1","device":"tablet"}]},"i-Joy":{"regex":"i-Joy|i-Call|(?:Neon[79]|Sygnus|Deox|Elektra (?:M|L|XL|XXL))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Elektra M(?:[);/ ]|$)","model":"Elektra M"},{"regex":"Elektra L(?:[);/ ]|$)","model":"Elektra L"},{"regex":"Elektra XL(?:[);/ ]|$)","model":"Elektra XL"},{"regex":"Elektra XXL(?:[);/ ]|$)","model":"Elektra XXL","device":"phablet"},{"regex":"Neon([79])(?:[);/ ]|$)","model":"Neon $1","device":"tablet"},{"regex":"Sygnus(?:[);/ ]|$)","model":"Sygnus","device":"tablet"},{"regex":"Deox(?:[);/ ]|$)","model":"Deox","device":"tablet"},{"regex":"i-Call ([^;/]+) Build","model":"i-Call $1"},{"regex":"i-Joy ([^;/]+) Build","model":"$1"}]},"iBall":{"regex":"iBall[ _]([^;/)]+)[ _]Build|iBall_Slide|(?:Snap[_ ]4G2|6351-Q400i|iT-KSA0003|iT-KSA0012|iT-KSA0066|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Brisk 4G2|Blaze_V4|Wondro 10|Q27 4G|Andi (?:Wink|5G Blink) 4G)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"Andi Wink 4G","device":"smartphone","model":"Andi Wink 4G"},{"regex":"Andi 5G Blink 4G","device":"smartphone","model":"Andi 5G Blink 4G"},{"regex":"(Snap[_ ]4G2|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Blaze_V4|Wondro 10|Q27 4G|Brisk 4G2)(?:[);/ ]|$)","model":"$1"},{"regex":"6351-Q400i(?:[);/ ]|$)","model":"Slide"},{"regex":"iT-KSA0003(?:[);/ ]|$)","model":"iTAB BizniZ"},{"regex":"iT-KSA0066(?:[);/ ]|$)","model":"iTAB BizniZ Mini"},{"regex":"iT-KSA0012(?:[);/ ]|$)","model":"iTAB Moviez Pro"},{"regex":"iBall[ _]([^;/)]+)(?:[ _]Build|\\\\))","model":"$1"}]},"iRola":{"regex":"iRola ([^/;]+) Build|(DX758|DX752|DX752|DX758[ _]?Pro) Build","device":"tablet","models":[{"regex":"DX758[ _]?Pro","model":"DX758 Pro"},{"regex":"(DX758|DX752)","model":"$1"},{"regex":"iRola ([^/;]+) Build","model":"$1"}]},"iRulu":{"regex":"iRULU[ _-](X11|V[34]|U2|AL101)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"iRULU[ _-](X11|V[34]|AL101)(?:[);/ ]|$)","model":"$1"},{"regex":"iRULU[ _](U2)(?:[);/ ]|$)","device":"smartphone","model":"$1"}]},"Irbis":{"regex":"IRBIS|TZ(1(?:0[04]|42|5[01]|84|65|7[01345-89]|8[356]|9[12578])|49|55|72|22|7(?:1[124679]|2[021567]|37|4[257]|5[23457]|6[12]|72|7[17]|8[1]|9[147])|8(?:[34]1|5[3-8]|6[45]|7[2478]|8[1-5]|9[0127])|96[0-9])|TZ85|TZ13|TZ(?:one|art|HIT|81L)|(SP(?:0[56]|2[01]|4[1-36]|40[12]|45[345]|49[34]|50|51[0147]|531|54[12]|55[0124]|571))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(TZ(?:[0-9]+)|TZ(?:one|art|HIT|81L))(?:[);/ ]|$)","model":"$1"},{"regex":"(SP[0-9]+)(?:[);/ ]|$)","device":"smartphone","model":"$1"}]},"iBerry":{"regex":"AUXUS ([^/;]+) Build","device":"smartphone","models":[{"regex":"AUXUS (Core[^/;]+) Build","device":"tablet","model":"$1"},{"regex":"AUXUS ([^/;]+) Build","model":"$1"}]},"iHunt":{"regex":"iHunt|One_ Love_|TITAN_P11000_PRO|Like_(3|4U|3_Pro)|X300 Elite|S10_Tank_2019|S60_Discovery_2019|AlienXLite2020|Alien X Lite|Alien_X|S20 Ultra ApeX 2021","device":"smartphone","models":[{"regex":"iHunt_Like","model":"Like"},{"regex":"S10_Tank_2019","model":"S10 Tank (2019)"},{"regex":"One_ Love_","model":"One Love"},{"regex":"TITAN_P11000_PRO","model":"Titan P11000 Pro"},{"regex":"Like_3_Pro","model":"Like 3 Pro"},{"regex":"Like_3","model":"Like 3"},{"regex":"Like_4U","model":"Like 4U"},{"regex":"X300 Elite","model":"X300 Elite"},{"regex":"S60_Discovery_2019","model":"S60 Discovery (2019)"},{"regex":"AlienXLite2020","model":"Alien X Lite (2020)"},{"regex":"Alien X Lite PRO","model":"Alien X Lite Pro"},{"regex":"Alien X Lite","model":"Alien X Lite"},{"regex":"Alien_X_ApeX","model":"Alien X ApeX"},{"regex":"Alien_X","model":"Alien X"},{"regex":"S20 Ultra ApeX 2021","model":"S20 Ultra ApeX (2021)"}]},"IconBIT":{"regex":"IconBIT|NT-(3506M|0704S|0909T|1009T|10[01]1T|1017T|3601P/3602P|3603P|3702S|3805C|3905T|3701S|0701S|0805C|0902S|370[23]M)|XDS[789]4K|Omnicast UHD|Movie Smart 4K|Movie IPTV Quad","device":"tablet","models":[{"regex":"NT-3506M","device":"smartphone","model":"NetTAB Mercury Quad FHD"},{"regex":"NT-0704S","model":"NetTAB Sky LE"},{"regex":"NT-0909T","model":"NetTAB Thor IZ"},{"regex":"NT-1009T","model":"NetTAB Thor quad II"},{"regex":"NT-10[01]1T","model":"NetTAB Thor LE"},{"regex":"NT-1017T","model":"NetTAB Thor 3G quad"},{"regex":"NT-3601P/3602P","model":"NetTAB Pocket 3G"},{"regex":"NT-3603P","model":"NetTAB Pocket 3G Slim"},{"regex":"NT-3702S","model":"NetTAB Sky HD 3G"},{"regex":"NT-3805C","model":"NetTAB Skat 3G quad"},{"regex":"NT-3701S","model":"NetTAB Sky 3G duo"},{"regex":"NT-3905T","model":"NetTAB Thor ZX 3G"},{"regex":"NT-0701S","model":"NetTAB Sky net"},{"regex":"NT-0805C","model":"NetTAB Skat MX"},{"regex":"NT-0902S","model":"NetTAB Space quad RX"},{"regex":"NT-3702M","model":"NetTAB Matrix 3G duo"},{"regex":"NT-3703M","model":"NetTAB Matrix 3GT"},{"regex":"(?:iconBIT )?(Movie Smart 4K|Movie IPTV Quad|Movie Ultra HD 4K|XDS[789]4K|Omnicast UHD)","model":"$1","device":"tv"}]},"LYF":{"regex":"(LYF[ _])?LS-[456][0-9]{3}|LYF/[^/]+/","device":"smartphone","models":[{"regex":"LS-4004","model":"Flame 2"},{"regex":"LS-5501","model":"Earth 1"},{"regex":"LS-5021","model":"Earth 2"},{"regex":"LS-5505","model":"Water F1"},{"regex":"LS-4503","model":"Flame LS-4503"},{"regex":"LS-4001","model":"Flame 3"},{"regex":"LS-4003","model":"Flame 4"},{"regex":"LS-4002","model":"Flame 5"},{"regex":"LS-4005","model":"Flame 6"},{"regex":"(LYF[ _])?LS-4006","model":"Flame 7"},{"regex":"LS-4008","model":"Flame 7S"},{"regex":"LS-450[58]","model":"Flame 8"},{"regex":"LS-5002","model":"Water 1"},{"regex":"LS-5005","model":"Water 4"},{"regex":"LS-5006","model":"Water 6"},{"regex":"LS-5008","model":"Water 2"},{"regex":"LS-5009","model":"Wind 6"},{"regex":"LS-5013","model":"Wind 5"},{"regex":"LS-5014","model":"Wind 4"},{"regex":"LS-5010","model":"Wind 1"},{"regex":"LS-5015","model":"Water 8"},{"regex":"LS-5016","model":"Wind 7"},{"regex":"LS-5504","model":"Water 7"},{"regex":"LS-5507","model":"Water 7S"},{"regex":"LS-5017","model":"Water 11"},{"regex":"LS-5018","model":"Wind 4S"},{"regex":"LS-5020","model":"Water 10"},{"regex":"LS-5201","model":"Water F1S"},{"regex":"LS-5502","model":"Wind 3"},{"regex":"LS-5503","model":"Water 3"},{"regex":"LS-5506","model":"Water 9"},{"regex":"LS-6001","model":"Wind 2"},{"regex":"LYF/([^/]+)/","model":"$1"}]},"Lumus":{"regex":"LUMUS Shell|(?:NEO(SR620|SC600)|INNOSR545|Lumus[_ ]Ion)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"NEO(SR620|SC600)(?:[);/ ]|$)","model":"Neo $1"},{"regex":"INNO(SR545)(?:[);/ ]|$)","model":"INNO $1"},{"regex":"Lumus[_ ]Ion(?:[);/ ]|$)","model":"Ion"},{"regex":"LUMUS Shell [0-9A-Z]+","device":"tv","model":""}]},"M4tel":{"regex":"M4 SS[0-9]{4}(?:-R)?|M4_B[23]","device":"smartphone","models":[{"regex":"SS1050","model":"Joy"},{"regex":"SS1060","model":"Live"},{"regex":"SS1070","model":"Sense"},{"regex":"SS1080","model":"Max One"},{"regex":"SS1090","model":"Max Ultra"},{"regex":"SS4020","model":"Play"},{"regex":"SS4040","model":"In Touch"},{"regex":"SS4045","model":"Style"},{"regex":"SS4345","model":"Soul Mini"},{"regex":"SS4350","model":"Soul"},{"regex":"SS4445","model":"Style Access"},{"regex":"SS4450","model":"Share"},{"regex":"SS4451","model":"Believe"},{"regex":"SS4452","model":"Dream"},{"regex":"SS4453","model":"Inspiration"},{"regex":"SS4455","model":"Excite"},{"regex":"SS4456","model":"Evolution"},{"regex":"SS4457-R","model":"Ever"},{"regex":"SS4457","model":"Elegance"},{"regex":"SS4458-R","model":"Feel Plus"},{"regex":"SS4458","model":"Attitude"},{"regex":"M4_B([23])","model":"B$1"}]},"IMO Mobile":{"regex":"IMO[ _]\\\\w","device":"smartphone","models":[{"regex":"IMO[ _]Q([23]) Plus(?:[);/ ]|$)","model":"Q$1 Plus"},{"regex":"IMO[ _]Q2(?:[);/ ]|$)","model":"Q2"},{"regex":"IMO[ _]S2(?:[);/ ]|$)","model":"S2"},{"regex":"IMO[ _]FEEL A2(?:[);/ ]|$)","model":"Feel A2"},{"regex":"IMO[ _]S50(?:[);/ ]|$)","model":"S50 Light"},{"regex":"IMO[ _]S80(?:[);/ ]|$)","model":"S80 Hero"},{"regex":"IMO[ _]S89(?:[);/ ]|$)","model":"S89 Miracle"},{"regex":"IMO[ _]S88(?:[);/ ]|$)","model":"S88 Discovery"},{"regex":"IMO[ _]S99(?:[);/ ]|$)","model":"S99 Ocean"},{"regex":"IMO[ _]S98(?:[);/ ]|$)","model":"S98 Champion"},{"regex":"IMO[ _]S87(?:[);/ ]|$)","model":"S87 Raptor"},{"regex":"IMO[ _]S67(?:[);/ ]|$)","model":"S67 Blast"},{"regex":"IMO[ _]S78(?:[);/ ]|$)","model":"S78 Glory"},{"regex":"IMO[ _]Q8(?:[);/ ]|$)","model":"Q8 Clarity"},{"regex":"IMO[ _]Discovery II(?:[);/ ]|$)","model":"Discovery II"},{"regex":"IMO[ _]Q(?:[);/ ]|$)","model":"Q"},{"regex":"IMO[ _](Y5|Z[67])(?:[);/ ]|$)","model":"Tab $1","device":"tablet"},{"regex":"IMO TAB X9(?:[);/ ]|$)","model":"Tab X9","device":"tablet"}]},"iLA":{"regex":"iLA[-_ ](Silk|X)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"iNew":{"regex":"iNew|(?:V7A|V3 Plus|V3-?E|V3C|FIRE_Tab_6)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"V3C(?:[);/ ]|$)","model":"V3C"},{"regex":"V3-?E(?:[);/ ]|$)","model":"V3-E"},{"regex":"V3 Plus(?:[);/ ]|$)","model":"V3 Plus"},{"regex":"V7A(?:[);/ ]|$)","model":"V7A"},{"regex":"FIRE_Tab_6(?:[);/ ]|$)","device":"tablet","model":"Fire Tab 6"},{"regex":"iNew[ -_]([^;/]+) Build","model":"$1"}]},"iPro":{"regex":"(?:Kylin[ _]5.[05]S?|KYLIN40|Jade[78]s|Amber[67]S?|Amber5S_Pro|Phonenix50S|Zafiro)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Kylin_5.0S","model":"Kylin 5.0S"},{"regex":"Kylin (5.[05])","model":"Kylin $1"},{"regex":"KYLIN40","model":"Kylin 40"},{"regex":"Jade([78])s","model":"Jade $1s"},{"regex":"Amber7S","model":"Amber 7S"},{"regex":"Amber5S_Pro","model":"Amber 5S Pro"},{"regex":"Amber6","model":"Amber 6"},{"regex":"Phonenix50S","model":"Phonenix 50S"},{"regex":"Zafiro","model":"Zafiro"}]},"Infinix":{"regex":"Infinix","device":"smartphone","models":[{"regex":"Infinix[ _-]X260","model":"Buzz"},{"regex":"Infinix[ _-]X502","model":"Alpha Marvel"},{"regex":"Infinix[ _-]X570","model":"Alpha"},{"regex":"Infinix[ _-]X350","model":"Surf Smart"},{"regex":"Infinix[ _-]X351","model":"Surf Smart 3G"},{"regex":"Infinix[ _-]X352","model":"Surf Smart 2"},{"regex":"Infinix[ _-]X403","model":"Surf Spice"},{"regex":"Infinix[ _-]X503","model":"Surf Bravo"},{"regex":"Infinix[ _-]X511","model":"Surf Noir"},{"regex":"Infinix[ _-]X400","model":"Race"},{"regex":"Infinix[ _-]X401","model":"Race Lite"},{"regex":"Infinix[ _-]X450","model":"Race Bolt"},{"regex":"Infinix[ _-]X451","model":"Race Bolt Q"},{"regex":"Infinix[ _-]X454","model":"Race Bolt 2"},{"regex":"Infinix[ _-]X500","model":"Race Eagle"},{"regex":"Infinix[ _-]X501","model":"Race Jet"},{"regex":"Infinix[ _-]X506","model":"Zero"},{"regex":"Infinix[ _-]X509","model":"Zero 2"},{"regex":"Infinix[ _-]X552","model":"Zero 3"},{"regex":"Infinix[ _-]X555","model":"Zero 4"},{"regex":"Infinix[ _-]X(?:574|602)","model":"Zero 4 Plus"},{"regex":"Infinix[ _-]X603","model":"Zero 5"},{"regex":"Infinix[ _-]X603B","model":"Zero 5 Pro"},{"regex":"Infinix[ _-]X620","model":"Zero 6"},{"regex":"Infinix[ _-]X507","model":"Hot"},{"regex":"Infinix[ _-]X510","model":"Hot 2"},{"regex":"Infinix[ _-]X55[34]","model":"Hot 3"},{"regex":"Infinix[ _-]X521","model":"Hot S"},{"regex":"Infinix[ _-]X522","model":"Hot S2"},{"regex":"Infinix[ _-]X557","model":"Hot 4"},{"regex":"Infinix[ _-]X556","model":"Hot 4 Pro"},{"regex":"Infinix[ _-]X559c","model":"Hot 5"},{"regex":"Infinix[ _-]X559","model":"Hot 5 Lite"},{"regex":"Infinix[ _-]X606[BC]?","model":"Hot 6"},{"regex":"Infinix[ _-]X608","model":"Hot 6 Pro"},{"regex":"Infinix[ _-]X624","model":"Hot 7"},{"regex":"Infinix[ _-]X650","model":"Hot 8"},{"regex":"Infinix[ _-]X680","model":"Hot 9 Play"},{"regex":"Infinix[ _-]X573B?","model":"Hot S3"},{"regex":"Infinix[ _-]X5010","model":"Smart"},{"regex":"Infinix[ _-]X5515F","model":"Smart 2"},{"regex":"Infinix[ _-]X5514D","model":"Smart 2 Pro"},{"regex":"Infinix[ _-]X653","model":"Smart 4"},{"regex":"Infinix[ _-]X626","model":"S4"},{"regex":"Infinix[ _-]X652","model":"S5"},{"regex":"Infinix[ _-]X660","model":"S5 Pro"},{"regex":"Infinix[ _-]X551","model":"Hot Note","device":"phablet"},{"regex":"Infinix[ _-]X600","model":"Note 2","device":"phablet"},{"regex":"Infinix[ _-]X601","model":"Note 3","device":"phablet"},{"regex":"Infinix[ _-]X572","model":"Note 4","device":"phablet"},{"regex":"Infinix[ _-]X571","model":"Note 4 Pro","device":"phablet"},{"regex":"Infinix[ _-]X604","model":"Note 5","device":"phablet"},{"regex":"Infinix[ _-]X610","model":"Note 6","device":"phablet"},{"regex":"Infinix[ _-]X690","model":"Note 7","device":"phablet"},{"regex":"Infinix[ _-]X656","model":"Note 7 Lite","device":"phablet"},{"regex":"Infinix HOT ([a-z]?[1-6])( (?:Lite|Plus|Pro))?","model":"Hot $1$2"},{"regex":"Infinix[ _-](X[78]00)","device":"tablet","model":"$1"},{"regex":"Infinix[ _-](X\\\\d+)","model":"$1"},{"regex":"Infinix[ _-]([a-z0-9_\\\\-]+)","model":"$1"}]},"InFocus":{"regex":"IF(900[1237]|902[19]|903[15])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"IF9001","model":"Turbo 5"},{"regex":"IF9007","model":"A3"},{"regex":"IF9021","model":"Turbo 5 Plus"},{"regex":"IF9035","model":"A2"},{"regex":"IF9002","model":"M5s"},{"regex":"IF9003","model":"M6s"},{"regex":"IF9031","model":"Vision 3"},{"regex":"IF9029","model":"Vision 3 Pro"}]},"InnJoo":{"regex":"InnJoo|(?:Halo Plus|Halo X|Halo[ _]4(?:[ _]mini[ _]LTE)?|Halo2 3G|Fire2 Plus LTE)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"InnJoo[ _]X3(?:[);/ ]|$)","model":"X3"},{"regex":"Halo[ _]X[ _]LTE(?:[);/ ]|$)","model":"Halo X LTE"},{"regex":"InnJoo[ _]X(?:[);/ ]|$)","model":"X"},{"regex":"Halo Plus(?:[);/ ]|$)","model":"Halo Plus"},{"regex":"Halo[ _]4[ _]mini[ _]LTE(?:[);/ ]|$)","model":"Halo 4 Mini LTE"},{"regex":"Halo 4(?:[);/ ]|$)","model":"Halo 4"},{"regex":"Halo2 3G(?:[);/ ]|$)","model":"Halo 2 3G"},{"regex":"InnJoo[ _]Pro2(?:[);/ ]|$)","model":"Pro 2"},{"regex":"Innjoo ONE 3G(?:[);/ ]|$)","model":"One 3G"},{"regex":"Innjoo[ _]2[ _]LTE(?:[);/ ]|$)","model":"2 LTE"},{"regex":"InnJoo[ _]([2-4])","model":"$1"},{"regex":"Fire2 Plus LTE","model":"Fire 2 Plus LTE"}]},"Inkti":{"regex":"intki[ _]([^/;]*)[ _]Build","device":"smartphone","model":"$1"},"Innos":{"regex":"Innos_?(D6000)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Innostream":{"regex":"INNO([a-z0-9]+)","device":"feature phone","model":"INNO$1"},"Insignia":{"regex":"NS-(P11A8100|P10A8100|P10A6100|P16AT08|P16AT10|P16AT785HD|P08A7100|P10A7100)(?:[);/ ]|$)|AFTEAMR311|AFTJMST12","device":"tablet","models":[{"regex":"NS-P11A8100","model":"11.6\\""},{"regex":"NS-(P10A6100|P16AT10)","model":"Flex 10.1\\""},{"regex":"NS-P16AT08","model":"Flex 8\\""},{"regex":"NS-P08A7100","model":"8\\""},{"regex":"NS-(P10A8100|P10A7100)","model":"10.1\\""},{"regex":"NS-P16AT785HD","model":"Flex Elite 7.85\\""},{"regex":"AFTEAMR311","model":"HD (2018)","device":"tv"},{"regex":"AFTJMST12","model":"4K (2018)","device":"tv"}]},"INQ":{"regex":"INQ[/ ]","device":"feature phone","models":[{"regex":"INQ/([a-z0-9\\\\-]+)","model":"$1"},{"regex":"INQ ([^;/]+) Build","model":"$1","device":"smartphone"}]},"Intex":{"regex":"Intex|(Aqua|Cloud[ _][XY][0-9]{1}|Cloud (?:Fame|Glory) 4G)|IM0318ND(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"IM0318ND","model":"Aqua Lions 3"},{"regex":"Intex[ _]([^/;]*)[ _]Build","model":"$1"},{"regex":"(Cloud (?:Fame|Glory) 4G)","model":"$1"},{"regex":"(Aqua|Cloud)[ _\\\\.]([^/;\\\\)]+)(?:[ _]Build|(?<!Build)/|\\\\))","model":"$1 $2"},{"regex":"Intex[ _]([a-z0-9_+\\\\-]+)","model":"$1"}]},"i-mate":{"regex":"i-mate ([a-z0-9]+)","device":"feature phone","model":"$1"},"i-mobile":{"regex":"i-mobile ?[a-z0-9]+|i-Style|IQ ?(9\\\\.1|5\\\\.5|5\\\\.6A?)","device":"feature phone","models":[{"regex":"i-mobile (i-note[^/;]*) Build","model":"$1","device":"tablet"},{"regex":"i-Style ?([^;/]+) Build","model":"i-Style $1","device":"smartphone"},{"regex":"IQ ?(9\\\\.1|5\\\\.5|5\\\\.6A?)","model":"IQ $1","device":"smartphone"},{"regex":"i-mobile (IQ[^/;]*) Build","model":"$1","device":"smartphone"},{"regex":"i-mobile(?: )?([a-z0-9\\\\- ]+) Build","model":"$1"},{"regex":"i-mobile(?: )?([a-z0-9]+)","model":"$1"}]},"iKoMo":{"regex":"iKoMo ([a-z0-9]+)","device":"feature phone","model":"$1"},"iOcean":{"regex":"iOCEAN|M6752|W180|X7[ _]?S|X8 mini","device":"smartphone","models":[{"regex":"X7S-T","model":"X7S-T"},{"regex":"X8 mini pro","model":"X8 Mini Pro"},{"regex":"X8 mini","model":"X8 Mini"},{"regex":"X7[ _]?S","model":"X7S Elite"},{"regex":"(M6752|W180) Build","model":"$1"},{"regex":"iOCEAN[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"iOCEAN[ _\\\\-]?([^);/ ]+)","model":"$1"}]},"iView":{"regex":"(733TPC|730TPC|769TPCII|930TPC)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Impression":{"regex":"(?:Impression[ _\\\\-]?([^/;]+)|A502|I10\\\\-LE|ImPad[ _]?(.*)|ImSmart[ _]?(.*))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(A502)","model":"$1","device":"smartphone"},{"regex":"ImSmart[ _]?([^/;)]+)(?: Build|\\\\))","model":"ImSmart $1","device":"smartphone"},{"regex":"ImPad[ _]?([^/;)]+)(?: Build|\\\\))","model":"ImPad $1"},{"regex":"(I10\\\\-LE)","model":"$1","device":"smartphone"},{"regex":"Impression[ _\\\\-]?([^/;)]+)(?: Build|\\\\))","model":"$1"}]},"iLife":{"regex":"(ITELL[_ ](?:K3300|K3500N?|K4700))(?:[);/ ]|$)","device":"tablet","model":"$1"},"iTel":{"regex":"itel|iNote|GP10X2019(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"W6502","device":"phablet","model":"S16"},{"regex":"W5505","model":"A36"},{"regex":"W6002E?","model":"S15"},{"regex":"L5502","model":"A44 Air"},{"regex":"L5505","model":"A47"},{"regex":"L6006","model":"A48"},{"regex":"L6003P","model":"A55 LTE"},{"regex":"L6002P","model":"S15 Pro"},{"regex":"L5002","model":"A22"},{"regex":"L5503","model":"A46"},{"regex":"L6004","model":"A56 LTE"},{"regex":"W6004P","model":"A56 Pro"},{"regex":"W6001","model":"P33 Plus"},{"regex":"W6003","model":"A55"},{"regex":"L6005","model":"Vision 1"},{"regex":"L6501","model":"Vision 1 Plus"},{"regex":"L6502","model":"Vision 1 Pro"},{"regex":"GP10X2019","model":"GP10X2019"},{"regex":"iNote ([^/;]*)Build","model":"iNote $1"},{"regex":"iNote_([a-z0-9\\\\-_]+)","model":"iNote $1"},{"regex":"itel-it(1410|1512|1520)(?:[);/ ]|$)","model":"it$1"},{"regex":"itel-it1553(?:[);/ ]|$)","model":"Power Pro"},{"regex":"itel[- ](A14|A16 Plus|A44 Power|A23S|A52 Lite)","model":"$1"},{"regex":"itel it1701","device":"tablet","model":"iNote Prime"},{"regex":"itel it170([23])","device":"tablet","model":"iNote Prime $1"},{"regex":"iTel ([^/;]*)Build","model":"$1"},{"regex":"iTel[_ ]([a-z0-9\\\\-_]*)","model":"$1"}]},"iZotron":{"regex":"(Mi7_HERO_(?:BETA|TAB))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"Mi7[_ ]HERO[_ ]BETA(?:[);/ ]|$)","model":"MI7 Hero Beta"},{"regex":"Mi7[_ ]HERO[_ ]TAB(?:[);/ ]|$)","model":"MI7 Hero Tab"}]},"JAY-Tech":{"regex":"TPC-[A-Z0-9]+|TPCY-TX[TE][^);/ ]+","device":"tablet","models":[{"regex":"TPC-([A-Z0-9]+)","model":"Tablet PC $1"},{"regex":"(TPCY-TX[TE][^);/ ]+)","model":"$1"}]},"Jiayu":{"regex":"JIAYU[ _-]|(?:JY-G4[\\\\\\\\_]G5|(?:JY-[a-z0-9]+)|JY_G4C)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:JIAYU G4_G5|JY-G4[\\\\\\\\_]G5)(?:[);/ ]|$)","model":"G4/G5"},{"regex":"JIAYU[ _-](G4[S]?|G2F|G3[S]?|S[23])(?:[);/ ]|$)","model":"$1"},{"regex":"JY[-_]([a-z0-9]+|G4C)(?:[);/ ]|$)","model":"JY-$1"}]},"Jolla":{"regex":"Jolla","device":"smartphone","model":""},"Just5":{"regex":"JUST5(-)?SPACER(s)?|COSMO[_ ](L707|L808)|BLASTER|FREEDOM[ _](C100|M303|X1)|Freedom","device":"smartphone","models":[{"regex":"COSMO[_ ](L707|L808)","model":"Cosmo $1"},{"regex":"FREEDOM[ _](C100|M303|X1)","model":"Freedom $1"},{"regex":"Freedom","model":"Freedom"},{"regex":"JUST5(-)?SPACER2s","model":"Spacer 2S"},{"regex":"JUST5(-)?SPACER2","model":"Spacer 2"},{"regex":"JUST5SPACER","model":"Spacer"},{"regex":"BLASTER 2","model":"Blaster 2"},{"regex":"BLASTER","model":"Blaster"}]},"Kalley":{"regex":"KALLEY|(?:ELEMENT (?:MAX|Q)|ELEMENT_PRO_2|K-BOOK(?:8MG|73G))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ELEMENT MAX","model":"Element Max"},{"regex":"ELEMENT Q","model":"Element Q"},{"regex":"ELEMENT_PRO_2","model":"Element Pro 2"},{"regex":"K-BOOK(8MG|73G)","device":"tablet","model":"K-BOOK$1"},{"regex":"KALLEY,(55D1240)","device":"tv","model":"$1"}]},"Kaan":{"regex":"KAAN[ _](N[12]|A1)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Kazam":{"regex":"Kazam|Trooper_X[0-9][0-9](?:[);/ ]|$)|Tornado 348|TROOPER 4\\\\.0","device":"smartphone","models":[{"regex":"Tornado 348","model":"Tornado 348"},{"regex":"Thunder 450W","model":"Thunder 450W"},{"regex":"TROOPER 4\\\\.0","model":"Trooper X4.0"},{"regex":"Trooper_X([0-9])([0-9])(?:[);/ ]|$)","model":"Trooper X$1.$2"},{"regex":"Kazam[; _]([^;/)]+)(?: Build|\\\\))","model":"$1"}]},"Keneksi":{"regex":"KENEKSI|(?:Hemera|Teta Dual|Helios)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(Hemera|Teta Dual|Helios)(?:[);/ ]|$)","model":"$1"},{"regex":"KENEKSI[ _-]liberty","model":"Liberty"},{"regex":"KENEKSI[ _-]FLASH","model":"Flash"},{"regex":"KENEKSI[ _-]SUN","model":"Sun"},{"regex":"KENEKSI[ _-]ZETA","model":"Zeta"},{"regex":"KENEKSI[ _-]SIGMA","model":"Sigma"},{"regex":"KENEKSI[ _-](Moon|Libra_Dual|Glass|Amber|Chance|Amulet|Choice|Crystal|Dream|Delta[_ ]Dual|Norma 2|Norma|Sky|Fire 2|Fire|Flame|Flora|Rock|Solo|Soul|Step|Smart|Star|Storm|Wind)","model":"$1"}]},"Kempler & Strauss":{"regex":"Alumini_?3_?Plus|Alumini ?[23]|KEMPLER_(?:P1|TV|X|8_PLUS)","device":"smartphone","models":[{"regex":"Alumini ?2","model":"Alumini 2"},{"regex":"Alumini_?3_?Plus","model":"Alumini 3 Plus"},{"regex":"Alumini3","model":"Alumini 3"},{"regex":"KEMPLER_P1","model":"P1"},{"regex":"KEMPLER_TV","model":"TV"},{"regex":"KEMPLER_X","model":"X"},{"regex":"KEMPLER_8_PLUS","model":"8 Plus"}]},"Kiano":{"regex":"Kiano|Elegance_[45]_[015](?:_PRO)?|Elegance 6|CORE 10.1 DUAL 3G|Intelect ?(7|8|10)|Slim ?Tab ?\\\\d+(?:[_ ]3GR?)?(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Slim ?Tab ?(\\\\d+)(?:[_ ]3GR?)?","model":"Slim Tab $1","device":"tablet"},{"regex":"CORE 10.1 DUAL 3G","model":"CORE 10.1 DUAL 3G","device":"tablet"},{"regex":"Elegance_(5)_([51])_Pro","model":"Elegance $1.$2\\" Pro"},{"regex":"Elegance_([45])_([015])","model":"Elegance $1.$2\\""},{"regex":"Elegance 6","model":"Elegance 6 5.85\\""},{"regex":"(Kiano)?(Intelect|Elegance) ?(7|8|10)?","model":"$2 $3","device":"tablet"},{"regex":"Kiano[ _]([^;/]+) Build","model":"$1"}]},"Kingsun":{"regex":"Kingsun[ _-]","device":"smartphone","models":[{"regex":"Kingsun[ _-]([^;/]+) Build","model":"$1"},{"regex":"Kingsun[ -]((?!Build)[a-z0-9_-]+)","model":"$1"}]},"Kocaso":{"regex":"Kocaso|M(?:729|7[357][026][hw]?|76[01236][bw]?|83[016]|8[567]0|1050s|106[012368]w?|1070|X736(?:-kit)?|X780)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"M729(?:[);/ ]|$)","model":"M729"},{"regex":"M(7[357][026])[hw]?(?:[);/ ]|$)","model":"M$1"},{"regex":"M(76[01236])[bw]?(?:[);/ ]|$)","model":"M$1"},{"regex":"MX780(?:[);/ ]|$)","model":"MX780"},{"regex":"M(83[016])(?:[);/ ]|$)","model":"M$1"},{"regex":"M(8[567]0)(?:[);/ ]|$)","model":"M$1"},{"regex":"M851(?:[);/ ]|$)","model":"M851"},{"regex":"M1050S(?:[);/ ]|$)","model":"M1050s"},{"regex":"M(106[012368])W?(?:[);/ ]|$)","model":"M$1"},{"regex":"M1070(?:[);/ ]|$)","model":"M1070"},{"regex":"MX736(?:-kit)?(?:[);/ ]|$)","model":"MX736"},{"regex":"MX780(?:[);/ ]|$)","model":"MX780"},{"regex":"Kocaso[ _\\\\-]?([^;/]+) Build","model":"$1"},{"regex":"Kocaso[ _\\\\-]?([a-z0-9_-]+)","model":"$1"}]},"Kogan":{"regex":"Kogan","device":"smartphone","models":[{"regex":"Kogan[ _-]([^;/]+) Build","model":"$1"},{"regex":"Kogan[ _-]([a-z0-9_-]+)","model":"$1"}]},"Komu":{"regex":"Komu[ -]","device":"smartphone","models":[{"regex":"Komu[ -]([^;/]+) Build","model":"$1"},{"regex":"Komu[ -]([a-z0-9_-]+)","model":"$1"}]},"Koobee":{"regex":"Koobee","device":"smartphone","models":[{"regex":"Koobee[ _\\\\-]?([^;/]+) Build","model":"$1"},{"regex":"Koobee[ _\\\\-]?([a-z0-9_-]+)","model":"$1"}]},"Kumai":{"regex":"(?:KM-)?Kumai","device":"smartphone","models":[{"regex":"(?:KM-)?Kumai[ _\\\\-]?([^;/]+) Build","model":"$1"},{"regex":"(?:KM-)?Kumai[ _\\\\-]?([a-z0-9_-]+)","model":"$1"}]},"KT-Tech":{"regex":"(KM-[a-z0-9]+|EV-[a-z0-9]+)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"KDDI":{"regex":"kddi-([a-z0-9]+)","device":"feature phone","model":"$1"},"Kodak":{"regex":"KODAK|(?:IM5|Ektra|Smartway_T1)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"IM5","model":"IM5"},{"regex":"Ektra(?:[);/ ]|$)","model":"Ektra"},{"regex":"(?:KODAK[_ ])?SMARTWAY[_ ]([MTX]1)","model":"Smartway $1"},{"regex":"Tablet (7|10)","device":"tablet","model":"Tablet $1"}]},"KOPO":{"regex":"KOPO[ _-]","device":"smartphone","models":[{"regex":"KOPO[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"KOPO[ _\\\\-]?([^);/ ]+)","model":"$1"}]},"Koridy":{"regex":"KORIDY[ _-]([^/;]+) Build","device":"smartphone","model":"$1"},"KRONO":{"regex":"NET1100|NET_(?:TITAN|VOLT)","device":"smartphone","models":[{"regex":"NET1100","model":"NET 1100"},{"regex":"NET_(TITAN|VOLT)","model":"NET $1"}]},"K-Touch":{"regex":"K-?Touch[ _][a-z0-9]+","device":"smartphone","models":[{"regex":"K-?Touch[ _]([^/;]*)[ _]Build","model":"$1"},{"regex":"K-?Touch[ _]([a-z0-9]+)","model":"$1"}]},"Diva":{"regex":"(QC-(?:703GN|704GA|803GN|1013G|7BHD))(?:[);/ ]|$)","device":"tablet","model":"$1"},"Kyocera":{"regex":"Kyocera|KWC-|QC-[0-9]{4}|(?:QC6035|NP501KC|302KC|503KC|602KC|705KC|901KC|C51[27]0|C5155|C5215|C67[35]0|C6522N?|C6530N|C6740N?|C6743|E6[89]10|KYL2[13]|KYV3[13-9]|KYT3[123]|KYF3[123579]|KYF40|KYX31|KYG01|KYY2[1-4]|S2151|KC-S701|S[468]-KC|KYV40U?|KYV4[1-8]|KYV4[47]|KC-S301AE|X3-KC|E6560[CT]|E6782[L]?|E6790(?:TM)?|[47]04KC|A001KC|WX10K|URBANO PROGRESSO|E7110)(?:[-_]u2?)?(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"C5120(?:[);/ ]|$)","model":"Milano"},{"regex":"S4-KC(?:[);/ ]|$)","model":"One S4"},{"regex":"S6-KC(?:[);/ ]|$)","model":"One S6"},{"regex":"S8-KC(?:[);/ ]|$)","model":"One S8"},{"regex":"C5155(?:[);/ ]|$)","model":"Rise"},{"regex":"602KC(?:[);/ ]|$)","model":"Digno G"},{"regex":"503KC(?:[);/ ]|$)","model":"Digno E"},{"regex":"404KC(?:[);/ ]|$)","model":"Digno C"},{"regex":"704KC(?:[);/ ]|$)","model":"Digno J"},{"regex":"302KC(?:[);/ ]|$)","model":"Digno T"},{"regex":"NP501KC(?:[);/ ]|$)","model":"Digno"},{"regex":"WX10K(?:[);/ ]|$)","model":"Digno Dual 2"},{"regex":"KYV36(?:[);/ ]|$)","model":"Digno Rafre"},{"regex":"901KC(?:[);/ ]|$)","model":"Digno BX"},{"regex":"KYV39(?:[);/ ]|$)","model":"Miraie F"},{"regex":"KYX31(?:[);/ ]|$)","model":"Infobar XV"},{"regex":"C5170(?:[);/ ]|$)","model":"Hydro"},{"regex":"C5215(?:[);/ ]|$)","model":"Hydro EDGE"},{"regex":"C6522N?","model":"Hydro XTRM"},{"regex":"C6730","model":"Hydro ICON"},{"regex":"C6750","model":"Hydro ELITE"},{"regex":"C6530N","model":"Hydro LIFE"},{"regex":"C6740(N)?","model":"Hydro WAVE"},{"regex":"C6743","model":"Hydro Reach"},{"regex":"E6560[CT]","model":"DuraForce"},{"regex":"E6810","model":"DuraForce Pro"},{"regex":"E6910","model":"DuraForce Pro 2"},{"regex":"E7110","model":"DuraForce Ultra 5G"},{"regex":"KC-S701","model":"Torque"},{"regex":"KYG01","model":"Torque 5G"},{"regex":"KYL21(?:[);/ ]|$)","model":"Digno S"},{"regex":"KYL23(?:[);/ ]|$)","model":"Miraie"},{"regex":"KYY24(?:[);/ ]|$)","model":"Torque G01"},{"regex":"KYF32(?:[);/ ]|$)","model":"Easy Mobile Phone"},{"regex":"KYF35(?:[);/ ]|$)","model":"Marvera"},{"regex":"KYF40(?:[);/ ]|$)","model":"Mamorino 5"},{"regex":"KYF3[179](?:[);/ ]|$)","model":"Gratina 4G"},{"regex":"KYV48(?:[);/ ]|$)","model":"Gratina KYV48"},{"regex":"KYF33(?:[);/ ]|$)","model":"Torque X01"},{"regex":"KYV35(?:[);/ ]|$)","model":"Torque G02"},{"regex":"KYV41(?:[);/ ]|$)","model":"Torque G03"},{"regex":"KYV46(?:[);/ ]|$)","model":"Torque G04"},{"regex":"KYV47(?:-u)?(?:[);/ ]|$)","model":"Basio 4"},{"regex":"KYV43(?:[);/ ]|$)","model":"Basio 3"},{"regex":"705KC(?:[);/ ]|$)","model":"Kantan Sumaho"},{"regex":"KYV37(?:[);/ ]|$)","model":"Qua Phone"},{"regex":"KYV42(?:_u)?(?:[);/ ]|$)","model":"Qua Phone QX"},{"regex":"KYV44(?:_u2?)?(?:[);/ ]|$)","model":"Qua Phone QZ"},{"regex":"KYT33(?:[);/ ]|$)","model":"Qua Tab QZ10","device":"tablet"},{"regex":"KYT32(?:[);/ ]|$)","model":"Qua Tab QZ8","device":"tablet"},{"regex":"KYT31(?:[);/ ]|$)","model":"Qua Tab 01","device":"tablet"},{"regex":"KYV40U?(?:[);/ ]|$)","model":"Rafre"},{"regex":"KYV33(?:[);/ ]|$)","model":"Infobar A03"},{"regex":"KYY21(?:[);/ ]|$)","model":"Urbano L01"},{"regex":"KYY22(?:[);/ ]|$)","model":"Urbano L02"},{"regex":"KYY23(?:[);/ ]|$)","model":"Urbano L03"},{"regex":"KYV31(?:[);/ ]|$)","model":"Urbano V01"},{"regex":"KYV34(?:[);/ ]|$)","model":"Urbano V02"},{"regex":"KYV(?:45|38)(?:[);/ ]|$)","model":"Urbano V03"},{"regex":"(?:Kyocera-)?E6790(?:TM)?","model":"DuraForce XD"},{"regex":"X3-KC(?:[);/ ]|$)","model":"One X3"},{"regex":"E6782(?:[);/ ]|$)","model":"Brigadier"},{"regex":"E6782L(?:[);/ ]|$)","model":"DuraScout"},{"regex":"(KC-S301AE)(?:[);/ ]|$)","model":"$1"},{"regex":"A001KC(?:[);/ ]|$)","model":"Katan Sumaho 2"},{"regex":"URBANO PROGRESSO(?:[);/ ]|$)","model":"Urbano Progresso"},{"regex":"S2151","model":"Coast","device":"feature phone"},{"regex":"Kyocera-KZ-([a-z0-9]+)","model":"KZ $1"},{"regex":"Kyocera(?:[\\\\-/])?([a-z0-9]+)","model":"$1"},{"regex":"(KWC|QC)-?([a-z0-9]+)","model":"$1-$2"}]},"Krüger&Matz":{"regex":"Kruger[ _&]Matz|KrugerMatz[ _]|FLOW ?5PLUS|FLOW_5|FLOW7|FLOW6(?:S|Lite)|DRIVE[_ ]6S?|MOVE8mini|MOVE_|LIVE_6plus|LIVE 5 PLUS|LIVE4_KM043[89]|LIVE 7S|KM(?:106[67]|1065G|0701_1|0702|0805_1)","device":"smartphone","models":[{"regex":"MOVE8mini","model":"MOVE 8 Mini"},{"regex":"MOVE_6_mini","model":"MOVE 6 Mini"},{"regex":"MOVE[_ ]([78]|6S)","model":"MOVE $1"},{"regex":"DRIVE 4 mini LTE","model":"DRIVE 4 mini LTE"},{"regex":"DRIVE[ _]([456][S]?)(?:[);/ ]|$)","model":"DRIVE $1"},{"regex":"FLOW ?5PLUS(?:[);/ ]|$)","model":"FLOW 5 Plus"},{"regex":"FLOW6Lite(?:[);/ ]|$)","model":"FLOW 6 Lite"},{"regex":"FLOW[ _]?([4-7][S]?)(?:[);/ ]|$)","model":"FLOW $1"},{"regex":"LIVE4_(KM043[89])(?:[);/ ]|$)","model":"LIVE 4 $1"},{"regex":"KrugerMatz_LIVE4(?:[);/ ]|$)","model":"LIVE 4"},{"regex":"_LIVE5_(KM0450)(?:[);/ ]|$)","model":"LIVE 5 $1"},{"regex":"LIVE 5 PLUS(?:[);/ ]|$)","model":"LIVE 5 Plus"},{"regex":"LIVE_6plus(?:[);/ ]|$)","model":"LIVE 6 Plus"},{"regex":"LIVE 7S(?:[);/ ]|$)","model":"LIVE 7S"},{"regex":"KM(106[67])(?:[);/ ]|$)","device":"tablet","model":"EAGLE $1 10.1\\""},{"regex":"KM(1065G)(?:[);/ ]|$)","device":"tablet","model":"EAGLE $1 10.1\\""},{"regex":"KM0(701)_1(?:[);/ ]|$)","device":"tablet","model":"EAGLE $1 7.1\\""},{"regex":"KM0(805)_1(?:[);/ ]|$)","device":"tablet","model":"EAGLE $1 8.0\\""},{"regex":"KM0(702)(?:[);/ ]|$)","device":"tablet","model":"EAGLE $1 7.0\\""}]},"LAIQ":{"regex":"LAIQ","device":"smartphone","models":[{"regex":"(Glam|New York|Dubai)(?:[);/ ]|$)","model":"$1"}]},"AIS":{"regex":"iris708|Kingcomm C500","device":"smartphone","models":[{"regex":"iris708","model":"LAVA PRO 4.5"},{"regex":"Kingcomm C500","model":"Super Smart Plus X3"}]},"Lava":{"regex":"Lava[ _]|LAVAA1|(?:DISCOVER136|KKT QUADRA)|iris[ _]?([^/;]+)(?:\\\\)| Build)|A(?:67|76) Build|X1 Selfie Build|X41 Plus Build|(?:Flair Z1|PixelV1|Pixel V2|Z61_2GB|A97 IPS|A97 2GB PLUS|L[EH]9920(?:[_ ]P)?|L[NEH]9910|LH9810|Ivory(?:S1|S4G)?|A76Plus)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Flair Z1(?:[);/ ]|$)","model":"Flair Z1"},{"regex":"A97 IPS(?:[);/ ]|$)","model":"A97 IPS"},{"regex":"A97 2GB PLUS(?:[);/ ]|$)","model":"A97 2GB Plus"},{"regex":"A76Plus(?:[);/ ]|$)","model":"A76 Plus"},{"regex":"Pixel ?V([12])(?:[);/ ]|$)","model":"Pixel V$1"},{"regex":"X1 Selfie(?:[);/ ]|$)","model":"Iris X1 Selfie"},{"regex":"X41 Plus(?:[);/ ]|$)","model":"X41 Plus"},{"regex":"(?:LAVA[_ ]?)?A([13]|67|76)(?:[);/ ]|$)","model":"A$1"},{"regex":"LAVA_R1","model":"R1"},{"regex":"Z61_2GB(?:[);/ ]|$)","model":"Z61"},{"regex":"LE9920[ _]P(?:[);/ ]|$)","model":"V7"},{"regex":"LE9920(?:[);/ ]|$)","model":"Z53"},{"regex":"LH9910(?:[);/ ]|$)","model":"Z52"},{"regex":"LH9810(?:[);/ ]|$)","model":"Iris 52"},{"regex":"LN9910(?:[);/ ]|$)","model":"Z41"},{"regex":"LE9910(?:[);/ ]|$)","model":"V8"},{"regex":"LH9920(?:[);/ ]|$)","model":"V+6"},{"regex":"DISCOVER136","device":"feature phone","model":"Discover 136"},{"regex":"KKT QUADRA","device":"feature phone","model":"KKT Quadra"},{"regex":"KKT40[ ]?Power[P\\\\+]","device":"feature phone","model":"KKT40 Power Plus"},{"regex":"Ivory(S1|S4G)?(?:[);/ ]|$)","device":"tablet","model":"Ivory $1"},{"regex":"iris[ _]?([^/;]+)(?:\\\\)| Build)","model":"Iris $1"},{"regex":"Lava[ _]?([^/;]+)(?:/| Build)","model":"$1"}]},"SKG":{"regex":"(Modern[ _](?:S10?|S[3679]))(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Landvo":{"regex":"XM[123]00|(?<!Blade )S6 Build","device":"smartphone","models":[{"regex":"S6 Build","model":"S6"},{"regex":"XM([123])00([^/;]*) Build","model":"XM$100$2"}]},"Land Rover":{"regex":"Land[ ]?Rover[d]?[ _-](?:X1[0-9]|Explore|T878|L15\\\\+|V18|V[168]|X)(?:[);/ ]|$)|Polar3","device":"smartphone","models":[{"regex":"Land[ ]?Rover[d]?[ _-](X1[0-9]|Explore|T878|L15\\\\+|V18|V[168]|X)(?:[);/ ]|$)","model":"$1"},{"regex":"Polar3","model":"Ioutdoor Polar 3"}]},"Lanix":{"regex":"LANIX-([a-z0-9]+)|Ilium[ _]|IliumPad|X120C|Alpha 950","device":"smartphone","models":[{"regex":"ILIUM[ _]?PAD[ _]?([^;/]+)(?: Build|[;)])","model":"Ilium Pad $1","device":"tablet"},{"regex":"X120C","model":"Ilium X120C"},{"regex":"Ilium[ _](Alpha [15]s|Alpha [379]|L(?:200|6[12]0|9[0125]0|1[0124]00|1050|1120)|LT5[012]0|M[13579]|S(?:106|520|6[27]0)|X(?:1[12]0|2[0126]0|5[12]0|500B|710)|M[579]s)(?:[);/ ]|$)","model":"Ilium $1"},{"regex":"ILIUM[ _]([^;/]+) Build","model":"Ilium $1"},{"regex":"Alpha 950","model":"Ilium Alpha 950"},{"regex":"LANIX-([a-z0-9]+)","device":"feature phone","model":"$1"}]},"Lark":{"regex":"(Lark|Cumulus|Evolution|FreeMe|Ultimate (?:X4|7i))[ _-]|Build/Lark|Bjorn[_ ]SP-500|FreeBird 5WiFi","device":"tablet","models":[{"regex":"Cumulus[ _](5\\\\.5|[56])[ _]HD","model":"Cumulus $1 HD","device":"smartphone"},{"regex":"FreeMe X2 ([79]) (?:ver|v)?\\\\.([23])","model":"FreeMe X2 $1 Version $2"},{"regex":"FreeMe X4 7 3G HD","model":"FreeMe X4 7HD 3G"},{"regex":"FreeMe[ _]X2[ _]([7-9])","model":"FreeMe X2 $1"},{"regex":"FreeMe X4[ _]7[_ ]HD","model":"FreeMe X4 7HD"},{"regex":"FreeMe X4[ _]9","model":"FreeMe X4 9"},{"regex":"FreeBird 5WiFi","model":"FreeBird 5 WiFi"},{"regex":"(?:Lark[ _-])?Evolution[ _](X2 7 3G-GPS|X4[_ ]10\\\\.1|10|X4[_ ]7[ _]IPS)","model":"Evolution $1"},{"regex":"Ul(?:ti|it)mate (X4 10\\\\.1 3G IPS|X4 8s 3G|7i)","model":"Ultimate $1"},{"regex":"PHABLET 7","model":"Phablet 7"},{"regex":"Phablet 6\\\\.0","model":"Phablet 6.0","device":"smartphone"},{"regex":"Bjorn[_ ]SP-500","model":"Bjorn SP-500","device":"smartphone"},{"regex":"Cirrus[ _](4\\\\.5|[45])","model":"Cirrus $1","device":"smartphone"},{"regex":"Lark[ _](Stratus[_ ]5)","model":"$1","device":"smartphone"}]},"LCT":{"regex":"LCT_([a-z0-9]+)","device":"feature phone","model":"$1"},"Le Pan":{"regex":"Le ?Pan|TC970 ([^;/]+)Build","device":"tablet","models":[{"regex":"TC802A","model":"Le Pan Mini"},{"regex":"TC970 ([^;/]+)Build","model":"TC970 $1"},{"regex":"Le ?Pan ?(II|S)(?:[);/ ]|$)","model":"Le Pan $1"},{"regex":"Le ?Pan ?([^;/]+) Build","model":"$1"}]},"Leagoo":{"regex":"(?:MY)?LEAGOO[ _-]?|(?:M5 EDGE|KIICAA (POWER|MIX)|Leapad[ _](?:X|7s)|Elite [15]|Venture 1|Z10-E)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"LEAGOO[- _]M8[_-]?Pro(?:[);/ ]|$)","model":"M8 Pro"},{"regex":"LEAGOO[- _](Z[156]|M[58]|T1)(?:[);/ ]|$)","model":"$1"},{"regex":"M5 EDGE","model":"M5 Edge"},{"regex":"LEAGOO[_ ]Lead([57])","model":"Lead $1"},{"regex":"KIICAA POWER","model":"KICCAA Power"},{"regex":"KIICAA MIX","model":"KICCAA Mix"},{"regex":"Elite ([15])(?:[);/ ]|$)","model":"Elite $1"},{"regex":"Venture 1(?:[);/ ]|$)","model":"Venture 1"},{"regex":"(?:LEAGOO[- _])?(Z10-E|M6)(?:[);/ ]|$)","model":"$1"},{"regex":"(?:My)?Leagoo[- _](E4)(?:[);/ ]|$)","model":"$1"},{"regex":"(?:Leapad[ _])(7s|10|X)","model":"LeaPad $1","device":"tablet"}]},"Ledstar":{"regex":"(?:Ledstar[_ ])?(?:Trendy 5.0|Novus_Premium_6.0)","device":"smartphone","models":[{"regex":"Trendy 5.0","model":"Trendy 5.0"},{"regex":"Ledstar_Novus_Premium_6.0(?:[);/ ]|$)","model":"Novus Premium 6.0\\""}]},"LeEco":{"regex":"Letv|LeEco|Le ?X[0-9][^;/]+|Le Max|Le [12]|Le2[_ ]x527|X900 Build|(?:X[89]00\\\\+|X52[67])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"X800\\\\+","model":"Le 1 Pro"},{"regex":"X900\\\\+","model":"Max X900+"},{"regex":"X50[10]","model":"Le 1S"},{"regex":"(X910)","model":"$1"},{"regex":"X900 Build","model":"Le X900"},{"regex":"(?:Le ?X526|Le2[_ ]x527|Le 2|X52[67])(?:[);/ ]|$)","model":"Le 2"},{"regex":"Le ?X([^;/]+) Build","model":"Le X$1"},{"regex":"Le ?X([^) ;/]+)","model":"Le X$1"},{"regex":"Le ?([12][^;/]+) Build","model":"Le $1"},{"regex":"Le Max([^;/]*) Build","model":"Le Max$1"},{"regex":"Le Max([^ ;/]*)","model":"Le Max$1"},{"regex":"LeEco ([^;/]+) Build","model":"$1"}]},"Leotec":{"regex":"LESPH501[14]|LESPH5003B|SUPERNOVA (Qi16|Qi32|i3G96[X]?)","device":"smartphone","models":[{"regex":"LESPH5011","model":"Argon e250"},{"regex":"LESPH5003B","model":"Argon A250B"},{"regex":"LESPH5014","model":"Krypton K150"},{"regex":"SUPERNOVA (Qi16|Qi32|i3G96[X]?)","device":"tablet","model":"Supernova $1"}]},"Lephone":{"regex":"lephone[ _]|lephoneP1","device":"smartphone","models":[{"regex":"lephone[ _](K7|K10)","device":"feature phone","model":"$1"},{"regex":"lephone(?:[ _])?(W(1[0125]|[279])|T2|P1)(?:[);/ ]|$)","model":"$1"},{"regex":"lephone_W7_plus","model":"W7 Plus"}]},"Lenco":{"regex":"Lenco ([^/;]*) Build","device":"tablet","model":"$1"},"Lenovo":{"regex":"(?:LNV-)?Lenovo|IdeaTab|IdeaPad|Thinkpad|Yoga Tablet|Tab2A[0-9]-[0-9]{2}[a-z]?|ZUK[ -_]|(?:TB2-X30L|TB3-710I|YT3-X50[ML]|K50a40|TB-(?:X103F|8504F|X304F|X704V|X704A)|A5500-H|A2107A-H|A3500-HV|A2109A|S6000|Z2 Plus|Vibe[ _](?:P1|S6i Plus|S[23567]i|C|[ZX]2|K5(?: Plus)?|V7)|P2A42|L38011|L18011|[5-8]01LV|[67]02LV|Z2131|K350t|K31-t3|TAB 2 A8-50LC|S90-A|P70-A|VR-1541F)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Lenovo ?G780","model":"G780","device":"desktop"},{"regex":"Lenovo ?A3500-FL","model":"IdeaTab A7-40","device":"tablet"},{"regex":"(?:Lenovo ?)?A3500-(?:H|HV|F)","model":"IdeaTab A7-50","device":"tablet"},{"regex":"(?:Lenovo[ _])?A5500-[HF]","model":"IdeaTab A8-50","device":"tablet"},{"regex":"Lenovo ?A7600-[HF]","model":"IdeaTab A10-70","device":"tablet"},{"regex":"A2107A-H","model":"A2107","device":"tablet"},{"regex":"A2109A","model":"IdeaTab A2109A","device":"tablet"},{"regex":"TB2-X30[FL]","model":"Tab 2 A10-30","device":"tablet"},{"regex":"YT3-X50[FLM]","model":"Yoga Tab 3","device":"tablet"},{"regex":"TB3-730X","model":"TAB3 7","device":"tablet"},{"regex":"TB3-710[IF]","model":"TAB3 7 Essential","device":"tablet"},{"regex":"TB-7703X","model":"TAB3 7 Plus","device":"tablet"},{"regex":"TB3-X70L","model":"TAB3 10 Plus","device":"tablet"},{"regex":"TB-8703X","model":"TAB3 8 Plus","device":"tablet"},{"regex":"TAB 2 A8-50LC","model":"TAB2 A8-50LC","device":"tablet"},{"regex":"501LV(?:[);/ ]|$)","model":"TAB2 8.0\\"","device":"tablet"},{"regex":"TAB 2 A10-70L(?:[);/ ]|$)","model":"TAB 2 A10","device":"tablet"},{"regex":"(?:TB3-850[FM]|601LV)(?:[);/ ]|$)","model":"TAB3 8","device":"tablet"},{"regex":"602LV(?:[);/ ]|$)","model":"TAB3 8 Dual","device":"tablet"},{"regex":"TB-X304[FL]","model":"TAB4 10","device":"tablet"},{"regex":"TB-8504X","model":"TAB4 8","device":"tablet"},{"regex":"TB-8704X","model":"TAB4 8 Plus","device":"tablet"},{"regex":"(?:TB-X704[FVL]|70[12]LV)(?:[);/ ]|$)","model":"TAB4 10 Plus","device":"tablet"},{"regex":"801LV(?:[);/ ]|$)","model":"TAB5 10.1\\"","device":"tablet"},{"regex":"TB-X103F(?:[);/ ]|$)","model":"TAB10 10.1\\"","device":"tablet"},{"regex":"TB-X704A(?:[);/ ]|$)","model":"Moto Tab","device":"tablet"},{"regex":"TB-X605F(?:[);/ ]|$)","model":"Tab M10","device":"tablet"},{"regex":"TB-X705F(?:[);/ ]|$)","model":"Tab P10","device":"tablet"},{"regex":"TB-X705F(?:[);/ ]|$)","model":"Tab P10","device":"tablet"},{"regex":"TB-7104I(?:[);/ ]|$)","model":"Tab E7","device":"tablet"},{"regex":"TB-8304F1(?:[);/ ]|$)","model":"Tab E8","device":"tablet"},{"regex":"TB-7304X(?:[);/ ]|$)","model":"Tab 7 Essential","device":"tablet"},{"regex":"TB-7504X(?:[);/ ]|$)","model":"Tab 7","device":"tablet"},{"regex":"TB-X606[FXV](?:[);/ ]|$)","model":"Tab M10 FHD Plus","device":"tablet"},{"regex":"Lenovo ?B8000(-[FH])?","model":"Yoga Tablet 10","device":"tablet"},{"regex":"YOGA Tablet 2 Pro-1380[FL]","model":"Yoga Tablet 2 Pro 13.3\\"","device":"tablet"},{"regex":"YOGA Tablet 2-1050[FL]","model":"Yoga Tablet 2 10.1\\"","device":"tablet"},{"regex":"YOGA Tablet 2-830(?:[FL]|LC)","model":"Yoga Tablet 2 8.0\\"","device":"tablet"},{"regex":"Lenovo ?B6000(-[FH])?","model":"Yoga Tablet 8","device":"tablet"},{"regex":"YT3-X90(L|F|X)","model":"Yoga 3 Pro","device":"tablet"},{"regex":"YT3-850[FL]","model":"Yoga Tab 3 8","device":"tablet"},{"regex":"YT3-850M","model":"Yoga Tab 3 10","device":"tablet"},{"regex":"YT-X703L","model":"Yoga Tab 3 Plus","device":"tablet"},{"regex":"S6000(?:[);/ ]|$)","model":"IdeaTab S6000","device":"tablet"},{"regex":"Lenovo ([ASB][0-9]{4})[A-Z]?\\\\-[EHF]","model":"IdeaTab $1","device":"tablet"},{"regex":"ThinkPadTablet_(A[0-9]{3})_","model":"ThinkPad Tablet $1","device":"tablet"},{"regex":"ThinkPad ?Tablet([^;/]*) Build","model":"ThinkPad Tablet$1","device":"tablet"},{"regex":"Lenovo ?A3300-(?:GV|H)","model":"TAB 2 A7-30","device":"tablet"},{"regex":"TAB 2 A7-30[HGD]C","model":"TAB 2 A7","device":"tablet"},{"regex":"TB-8504F","model":"TAB 4 8","device":"tablet"},{"regex":"TB-X304X","model":"Tab 4 10.1\\"","device":"tablet"},{"regex":"TB-X304X","model":"Tab 4 10.1\\"","device":"tablet"},{"regex":"TB-X304F","model":"TAB4 10","device":"tablet"},{"regex":"TB-X505[FX]","model":"M10","device":"tablet"},{"regex":"TB-X104[FXL]","model":"E10","device":"tablet"},{"regex":"Tab2A([0-9]-[0-9]{2}[a-z]?)","model":"TAB 2 A$1","device":"tablet"},{"regex":"IdeaTab[ \\\\-_]?([a-z0-9]+)","model":"IdeaTab $1","device":"tablet"},{"regex":"Yoga Tablet([^;/]+) Build","model":"Yoga Tablet$1","device":"tablet"},{"regex":"TB-8505F","model":"Tab M8","device":"tablet"},{"regex":"TB-8705F","model":"Tab M8 FHD","device":"tablet"},{"regex":"TB-8705F","model":"Tab M8 FHD","device":"tablet"},{"regex":"Lenovo (TB[0-9]?\\\\-[a-z0-9\\\\-]+) Build","model":"$1","device":"tablet"},{"regex":"L18011(?:[);/ ]|$)","model":"A5"},{"regex":"Z2 Plus","model":"Z2 Plus"},{"regex":"Z2151","model":"ZUK Edge"},{"regex":"Z213[12]","model":"ZUK Z2"},{"regex":"Z2121","model":"ZUK Z2 Pro"},{"regex":"ZUK[ -_]([^/;]*)(?: Build|\\\\))","model":"ZUK $1"},{"regex":"K10a40(?:[);/ ]|$)","model":"C2"},{"regex":"k50a40(?:[);/ ]|$)","model":"K3 Note"},{"regex":"A7010a48(?:[);/ ]|$)","model":"K4 Note"},{"regex":"K350t(?:[);/ ]|$)","model":"K5"},{"regex":"L38011(?:[);/ ]|$)","model":"K5 Play"},{"regex":"A7020a4[08](?:[);/ ]|$)","model":"K5 Note"},{"regex":"K31-t3(?:[);/ ]|$)","model":"K31"},{"regex":"(?:A6020a46|Vibe K5 Plus)(?:[);/ ]|$)","model":"Vibe K5 Plus"},{"regex":"(?:Lenovo-)?(?:A6020(?:a40|l36)|Vibe K5)(?:[);/ ]|$)","model":"Vibe K5"},{"regex":"VIBE Z2(?:[);/ ]|$)","model":"Vibe Z2"},{"regex":"VIBE C(?:[);/ ]|$)","model":"Vibe C"},{"regex":"VIBE X2(?:[);/ ]|$)","model":"Vibe X2"},{"regex":"VIBE V7(?:[);/ ]|$)","model":"Vibe V7"},{"regex":"VIBE S6i Plus(?:[);/ ]|$)","model":"Vibe S6i Plus"},{"regex":"VIBE[ _]S([23567])i(?:[);/ ]|$)","model":"Vibe S$1i"},{"regex":"k33a48(?:[);/ ]|$)","model":"K6"},{"regex":"P2A42(?:[);/ ]|$)","model":"P2"},{"regex":"k53a48(?:[);/ ]|$)","model":"K6 Note"},{"regex":"K33a42(?:[);/ ]|$)","model":"K6 Power"},{"regex":"P1ma40(?:[);/ ]|$)","model":"Vibe P1m"},{"regex":"Vibe P1 Turbo(?:[);/ ]|$)","model":"Vibe P1 Turbo"},{"regex":"(?:P1(?:a42|c72)|Vibe P1)(?:[);/ ]|$)","model":"Vibe P1"},{"regex":"A2016a40(?:[);/ ]|$)","model":"Vibe B"},{"regex":"A1010a20(?:[);/ ]|$)","model":"A Plus"},{"regex":"Z90a40(?:[);/ ]|$)","model":"Vibe Shot"},{"regex":"S1a40(?:[);/ ]|$)","model":"Vibe S1"},{"regex":"L78071(?:[);/ ]|$)","model":"Z5s"},{"regex":"L58041(?:[);/ ]|$)","model":"S5 Pro"},{"regex":"L18021(?:[);/ ]|$)","model":"A3"},{"regex":"PB2-670M(?:[);/ ]|$)","model":"Phab 2"},{"regex":"(S90-A|P70-A)(?:[);/ ]|$)","model":"$1"},{"regex":"IdeaPad ?([^;/]*) Build","model":"IdeaPad $1","device":"tablet"},{"regex":"VR-1541F","device":"wearable","model":"Mirage Solo"},{"regex":"LENOVO/81W8(?:[);/ ]|$)","device":"desktop","model":"IdeaPad S145-15IIL"},{"regex":"LENOVO/81MV(?:[);/ ]|$)","device":"desktop","model":"IdeaPad S145-15IWL"},{"regex":"LENOVO/81SS(?:[);/ ]|$)","device":"desktop","model":"Flex 14API 81SS"},{"regex":"Lenovo TAB ?([^/;]*) Build","model":"TAB $1","device":"tablet"},{"regex":"Lenovo ([^/;]*) Build","model":"$1"},{"regex":"(?:LNV-|Lenovo-)?Lenovo[ \\\\-_]?([a-z0-9_+\\\\-]+)","model":"$1"}]},"Lexand":{"regex":"(?:SC7 PRO HD|S5A[1-4]|S4A[1-5]|S6A1|A811|A802)(?:[);/ ]|$)|Lexand ([^;/]+) Build","device":"smartphone","models":[{"regex":"A(811|802)","device":"tablet","model":"A$1"},{"regex":"S4A1","model":"Vega"},{"regex":"S4A2","model":"Irida"},{"regex":"S4A3","model":"Pallada"},{"regex":"S4A5","model":"Oxygen"},{"regex":"S4A4 NEON","model":"S4A4 Neon"},{"regex":"S5A1","model":"Callisto"},{"regex":"S5A2","model":"Overon"},{"regex":"S5A3","model":"Capella"},{"regex":"S5A4","model":"Argon"},{"regex":"S6A1","model":"Antares"},{"regex":"SC7 PRO HD","model":"SC7 PRO HD"},{"regex":"Lexand ([^;/]+) Build","model":"$1"}]},"Lexibook":{"regex":"(MFC[0-9]{3}[a-z]{2,})","device":"tablet","models":[{"regex":"MFC191FR","model":"Tablet Ultra 3 XL"},{"regex":"MFC045FR","model":"TabTab"},{"regex":"MFC163FR","model":"Tablet Master 3"},{"regex":"MFC142FR","model":"Tablet Kids"},{"regex":"MFC250FR","model":"Tablet Junior"},{"regex":"MFC270FR","model":"Tablet Junior Power Touch"},{"regex":"MFC280FR","model":"Tablet Junior 2"},{"regex":"MFC156FR","model":"Tablet One"},{"regex":"MFC155FR","model":"Tablet Master"},{"regex":"MFC157FR","model":"Tablet Master 2"},{"regex":"MFC17[05]FR","model":"Tablet Ultra"},{"regex":"MFC375FR","model":"Tablet Ultra 2"},{"regex":"MFC162FR","model":"Power Tablet"},{"regex":"MFC180FR","model":"Tablet Advanced"},{"regex":"MFC181FR","model":"Tablet Advanced 2"},{"regex":"MFC500FR","model":"Tablet XL"},{"regex":"MFC190BBFR","model":"Barbie Tablet"},{"regex":"MFC195DCFR","model":"Tablet Disney Cars HD"},{"regex":"MFC195FUFR","model":"Furby Tablet"},{"regex":"MFC195DPFR","model":"Tablet Disney Princesse HD"},{"regex":"MFC140FR","model":"LapTab"},{"regex":"MFC141FR","model":"LapTab 2"},{"regex":"(MFC[0-9]{3}[a-z]{2,})","model":"$1"}]},"LG":{"regex":"LG|Web0S; Linux/SmartTV|portalmmm/2\\\\.0 (?:KE|KG|KP|L3)|(?:VX[0-9]+|L-0[12]D|L-07C|P713|(LM-[A-Z][0-9]{3}[A-Z]{0,3}(?:\\\\(FGN?\\\\)|\\\\(G\\\\)|\\\\.FN|\\\\.F(?:GN?)?)?)|LM-(X625N1|G820QM[0127]))(?:[);/ ]|$)|NetCast|RS98[78]|RS500|VS(?:50[01]|835|876|880|98[0578]|99[056]|(410|415|425|500|880)PP)|VS820|VS870 4G|Nexsus 5|LML(41[34]D|211B|713D|212V)L|VK810 4G|VK815|X5-LG|L-05[DE]|L-03K|L-01[LJK]|L-52A|L-[45]1A|901LG|A001LG|80[12]LG|402LG|LGT32|L-02K|L-01F|LM-V40|DM-01K|LMX130IM","device":"smartphone","models":[{"regex":"DM-01K","model":"Disney Mobile DM-01K"},{"regex":"LG-D325","model":"L70"},{"regex":"LG-D340F8","model":"L70 Tri"},{"regex":"LM-X210APM","model":"Phoenix 4"},{"regex":"LG-P505R","model":"Phoenix"},{"regex":"LM-X210VPP","model":"Zone 4"},{"regex":"LM-X220PM","model":"Tribute Empire"},{"regex":"VS980|L-01F","model":"G2"},{"regex":"LG-D6(?:18|20)","model":"G2 Mini"},{"regex":"LG-D85[01258]|VS985","model":"G3"},{"regex":"LG-D72[2458]","model":"G3 Beat"},{"regex":"LG-H81[158]","model":"G4"},{"regex":"LG-H525n?","model":"G4c"},{"regex":"LG-(?:H540|H542|H630)","model":"G4 Stylus"},{"regex":"LG-H736","model":"G4s"},{"regex":"LG-H735","model":"G4 Beat"},{"regex":"LG-H8(?:20|3[01]|5[08]|6[08])|VS987|RS988","model":"G5"},{"regex":"LG-H84[05]","model":"G5 SE"},{"regex":"VS988|LG-H87(?:0DS|3)","model":"G6"},{"regex":"LM-Q850","model":"G7 Fit"},{"regex":"LM-Q910","model":"G7 One"},{"regex":"LM-G820(N|QM[0127]|UMB)?","model":"G8"},{"regex":"LM-G850","model":"G8X ThinQ"},{"regex":"LM-G810","model":"G8S ThinQ"},{"regex":"901LG(?:[);/ ]|$)","model":"G8X ThinQ"},{"regex":"VS501|LM-X120","model":"K20"},{"regex":"(?:LG-)?H502","model":"Magna"},{"regex":"(?:LG-)?H343","model":"Risio"},{"regex":"(?:LG-)?H650","model":"Zero"},{"regex":"(?:LG-)?M154","model":"Risio 2"},{"regex":"(?:LG-)?P500H","model":"Optimus One"},{"regex":"(L-05[DE])(?:[);/ ]|$)","model":"Optimus it $1"},{"regex":"LG-L160L(?:[);/ ]|$)","model":"Optimus LTE 2"},{"regex":"P713(?:[);/ ]|$)","model":"Optimus L7II"},{"regex":"L-01D(?:[);/ ]|$)","model":"Optimus LTE L-01D"},{"regex":"L-02D(?:[);/ ]|$)","model":"PRADA phone L-02D"},{"regex":"L-07C","model":"Optimus Bright L-07C"},{"regex":"(?:LG-)?F800(?:S|K|L)?","model":"V20"},{"regex":"LM-Q710(?:\\\\(FGN\\\\)|[\\\\.]?FGN)","model":"Q Stylus Plus"},{"regex":"801LG","model":"Q Stylus"},{"regex":"LM-Q[67]10\\\\.FG(?:[);/ ]|$)","model":"Q7"},{"regex":"LM-(Q725[KL]|Q610.FGN)(?:[);/ ]|$)","model":"Q7+"},{"regex":"LM-Q815[SL](?:[);/ ]|$)","model":"Q8+"},{"regex":"LM-Q925L(?:[);/ ]|$)","model":"Q9"},{"regex":"LM-Q730N(?:[);/ ]|$)","model":"Q70"},{"regex":"LGV33(?:[);/ ]|$)","model":"Qua Phone PX"},{"regex":"L-03K(?:[);/ ]|$)","model":"Style"},{"regex":"L-01L(?:[);/ ]|$)","model":"Style 2"},{"regex":"VS835(?:[);/ ]|$)","model":"Stylo 2 V"},{"regex":"L-41A(?:[);/ ]|$)","model":"Style 3"},{"regex":"LM-Q710|LML713DL","model":"Stylo 4"},{"regex":"(?:LM-Q720|LGL722DL)(?:[);/ ]|$)","model":"Stylo 5"},{"regex":"LM-Q730(?:[);/ ]|$)","model":"Stylo 6"},{"regex":"LM-G710(N|VM)?","model":"G7 ThinQ"},{"regex":"LM-X210CM","model":"Fortune 2"},{"regex":"LM-X410\\\\.F(?:[);/ ]|$)","model":"Premier Pro"},{"regex":"LML41[34]DL(?:[);/ ]|$)","model":"Premier Pro LTE"},{"regex":"LM-X525","model":"Q60"},{"regex":"LM-X210K","model":"X2"},{"regex":"LG-K580","model":"X Cam"},{"regex":"LM-X510WM","model":"X Power 3"},{"regex":"LM-X(?:41[05]K|410S)","model":"X4"},{"regex":"LM-X(415[LS]|410L)","model":"X4+"},{"regex":"LM-X410(?:\\\\.FN|\\\\(FG\\\\))","model":"K11"},{"regex":"LM-X(?:320|410[UP]M)","model":"K30"},{"regex":"LMX130IM","model":"W10"},{"regex":"LM-X410","model":"LM-X410"},{"regex":"LM-X420N","model":"X4 (2019)"},{"regex":"LG-X230","model":"K4"},{"regex":"LM-X420","model":"K40"},{"regex":"LM-X430(?:[);/ ]|$)","model":"K40S"},{"regex":"LG-X220","model":"K5"},{"regex":"LM-X540","model":"K50S"},{"regex":"(?:802LG|LM-X520)(?:[);/ ]|$)","model":"K50"},{"regex":"402LG","model":"Spray"},{"regex":"L-02K","model":"JoJo"},{"regex":"(?:LM-X510[KLS]|X5-LG)","model":"X5"},{"regex":"LM-X625N1","model":"X6"},{"regex":"LM-X625N","model":"X6 (2019)"},{"regex":"LGMS210","model":"Aristo"},{"regex":"LM-X210[G]?","model":"Aristo 2"},{"regex":"LM-X220","model":"Aristo 3"},{"regex":"LM-V40(?:5|9N)?(?:[);/ ]|$)","model":"V40 ThinQ"},{"regex":"LM-(?:V500N|V450)(?:[);/ ]|$)","model":"V50 ThinQ"},{"regex":"LM-V510N","model":"V50S ThinQ"},{"regex":"LM-Q920N","model":"Q92"},{"regex":"LM-Q927L","model":"Q9 One"},{"regex":"(?:LG-)?(?:RS987|H901|H96[0128]|VS990)","model":"V10"},{"regex":"LG-X240","model":"K8 (2017)"},{"regex":"(?:LG-)?RS500","model":"K8 4G"},{"regex":"(?:LG-)?VS500","model":"K8 V"},{"regex":"LM-X212\\\\(G\\\\)","model":"K8 (2018)"},{"regex":"(?:LG-)?H91[058]","model":"V20"},{"regex":"(?:LG-)?H990(?:DS|N|T)?","model":"V20"},{"regex":"(?:LG-)?LS997","model":"V20"},{"regex":"(?:LG-)?VS995","model":"V20"},{"regex":"(?:LG-)?US999","model":"V20"},{"regex":"(?:VS996|LG-(?:H933|H93[012]|H932PR|[LU]S998|AS998)|LGM-V300[KLS])(?:[);/ ]|$)","model":"V30"},{"regex":"L-01J(?:[);/ ]|$)","model":"V20 Pro"},{"regex":"(?:L-01K|LGV35)(?:[);/ ]|$)","model":"V30 Plus"},{"regex":"L-51A(?:[);/ ]|$)","model":"V60"},{"regex":"(?:L-52A|LM-G900N?)(?:[);/ ]|$)","model":"Velvet 5G"},{"regex":"(?:LM-G910)(?:[);/ ]|$)","model":"Velvet 4G"},{"regex":"(?:A001LG|LM-V600)(?:[);/ ]|$)","model":"V60 ThinQ 5G"},{"regex":"(?:LG-)?VS410PP","model":"Optimus Zone"},{"regex":"LM-V350[N]?","model":"V35"},{"regex":"(?:LG-)?VS415PP","model":"Optimus Zone 2"},{"regex":"(?:LG-)?VS425PP","model":"Optimus Zone 3"},{"regex":"(?:LG-)?K100","model":"K3"},{"regex":"(?:LG-?)?(?:K|MS)33[02]","model":"K7"},{"regex":"(?:LG-?)?(?:K|MS)350","model":"K8"},{"regex":"VS500PP","model":"K8 V"},{"regex":"(?:LG-)?K420(?:N)?","model":"K10"},{"regex":"(?:LG-)?K430(?:DS|DSF|DSY)?","model":"K10"},{"regex":"(?:LG-)?M250N?","model":"K10 (2017)"},{"regex":"(?:LG-)?F670[KLS]?","model":"K10"},{"regex":"(?:LG-)?M255","model":"K20"},{"regex":"(?:LG-?)?[MT]P260","model":"K20 Plus"},{"regex":"LM-K200(?:[);/ ]|$)","model":"K22"},{"regex":"LM-K300(?:[);/ ]|$)","model":"K31"},{"regex":"LM-K420(?:[);/ ]|$)","model":"K42"},{"regex":"LM-K500(?:[);/ ]|$)","model":"K51"},{"regex":"LM-K520(?:[);/ ]|$)","model":"K52"},{"regex":"LM-Q510N(?:[);/ ]|$)","model":"Q51"},{"regex":"LM-Q630N?(?:[);/ ]|$)","model":"Q61"},{"regex":"(?:LG-)?M700(?:N|A|DSK|AN)?","model":"Q6"},{"regex":"LM-X440IM","model":"W30"},{"regex":"(?:LG-?)?K220","model":"X Power"},{"regex":"(?:LG-?)?M320","model":"X Power 2"},{"regex":"(?:LG-)?K371","model":"Phoenix 2"},{"regex":"(?:LG-)?M150","model":"Phoenix 3"},{"regex":"(?:LG-)?F100[SL]","model":"Optimus Vu"},{"regex":"(?:LG-)?P880","model":"Optimus 4X HD"},{"regex":"(?:LG-)?(H340n?|H324)","model":"Leon"},{"regex":"(?:LG-)?H342","model":"Leon 4G LTE"},{"regex":"(?:LG-)?H422","model":"Spirit"},{"regex":"(?:LG)?C660","model":"Optimus Pro"},{"regex":"LML21(?:1B|2V)L","model":"Rebel 4"},{"regex":"VS876","model":"Lucid 3"},{"regex":"VS880(PP)?","model":"G Vista"},{"regex":"VS820","model":"Lancet"},{"regex":"VS870 4G","model":"Lucid 2"},{"regex":"LM-F100N?(?:[);/ ]|$)","device":"phablet","model":"WING"},{"regex":"LGUK410","model":"G Pad 7.0\\" LTE","device":"tablet"},{"regex":"LGLK430","model":"G Pad F 7.0\\"","device":"tablet"},{"regex":"LGLK430","model":"G Pad F 7.0\\"","device":"tablet"},{"regex":"LG-V490","model":"G Pad 8.0","device":"tablet"},{"regex":"LGT01","model":"G Pad 8.0\\" LTE","device":"tablet"},{"regex":"LG-V500","model":"G Pad 8.3","device":"tablet"},{"regex":"LG-V700","model":"G Pad 10.1","device":"tablet"},{"regex":"LG-V935","model":"G Pad II 10.1","device":"tablet"},{"regex":"LG-V521","model":"G Pad X 8.0","device":"tablet"},{"regex":"VK810","model":"G Pad 8.3 LTE","device":"tablet"},{"regex":"VK815","model":"G Pad X 8.3","device":"tablet"},{"regex":"LGT32","model":"Qua Tad PZ","device":"tablet"},{"regex":"LGT31","model":"Qua Tad PX","device":"tablet"},{"regex":"webOS.TV","device":"tv","model":"WebOS TV"},{"regex":"LGE_DLNA_SDK|NetCast","device":"tv","model":"NetCast"},{"regex":"LG Watch Urbane","device":"wearable","model":"Watch Urbane"},{"regex":"(LM-[A-Z]{1}[0-9]{3}([A-Z]{1,3})?)","model":"$1"},{"regex":"LGE(?: |-LG| LG-AX|-)([a-z0-9]+)","model":"$1"},{"regex":"FBDV/LG-([a-z0-9]+);FBSV","model":"$1"},{"regex":"LGE;([a-z0-9\\\\-]+)","model":"$1"},{"regex":"LG[ _\\\\-](V90.*|Optimus[ _\\\\-]Pad.*) Build","device":"tablet","model":"$1"},{"regex":"LG(?:/|-LG| |-)?([^/;]*) Build","model":"$1"},{"regex":"LG(?:/|-LG| |-)?([a-z0-9]+)","model":"$1"},{"regex":"LG; ([a-z0-9 ]+)","model":"$1"},{"regex":"portalmmm/2.0 ((?:KE|KG|KP|L3)[a-z0-9]+)","model":"$1"},{"regex":"(VX[0-9]+)","model":"$1"},{"regex":"Web0S; Linux/SmartTV","device":"tv","model":""}]},"Lingwin":{"regex":"Lingwin[ _\\\\-]","device":"smartphone","models":[{"regex":"Lingwin[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"Lingwin[ _\\\\-]?([^);/ ]+)","model":"$1"}]},"Logicom":{"regex":"LOGICOM[_ ]|(TAB950|TAB1062|E731|E812|E912|E1031|POWER BOT|La[ _]Tab[ _](?:7[24]|10[57]|114)|(?:B|C|M|ID|VR)[ _]?BOT[ _]?(?:TAB[ _])?([0-9]+\\\\+?)(?:PLUS)?|KT712A_4\\\\.4|L-?IXIR[0-9]*|L-ITE|L-EGANTONE(?:-R)?|L-?EMENT.+|Le[ _]?(?:Hop|Hello|Lift|Hola|Moov[2]?|Must(?: 2)?|Starter L|Fit FR|Spark|Prime|Smooth(?: FR)?))[_);/ ]","device":"tablet","models":[{"regex":"La[ _]Tab[ _](7[24]|10[57]|114)(?:[);/ ]|$)","model":"La Tab $1"},{"regex":"LOGICOM_LA_TAB_LINK_71","model":"La Tab Link 71"},{"regex":"KT712A_4.4|L-IXIR TAB 701 3G","model":"L-ixir Tab 701 3G"},{"regex":"LIXIR1041","model":"L-ixir Tab 1041"},{"regex":"L-?IXIR[ _]TAB[ _]([^);/]+)( Build|[);])","model":"L-ixir Tab $1"},{"regex":"L-ITE[ _](400M|452|50[46] HD|506R HD|552 HD)(?:[);/ ]|$)","device":"smartphone","model":"L-ite $1"},{"regex":"L-ITE[ _]([^;/]+) Build","model":"L-ite Tab $1"},{"regex":"L-?EMENT[ _]?(350|451|40[103]|55[013]|50[15]|500L?)(?:[);/ ]|$)","model":"L-ement $1","device":"smartphone"},{"regex":"L-?EMENT[ _](?:TAB)[ )]?([^);/]+)(?: Build|[);])","model":"L-ement Tab $1"},{"regex":"L-?EMENT[ _]?(74[01])(?:[);/ ]|$)","model":"L-ement Tab $1"},{"regex":"(TAB950|TAB1062|E731|E812|E912|E1031)(?:[);/ ]|$)","model":"$1"},{"regex":"POWER BOT","model":"POWER BOT"},{"regex":"((?:B|C|M|ID|VR))[ _]?BOT[ _]?((?:TAB[ _])?([0-9]+\\\\+?)(?:PLUS)?)","model":"$1 BOT $2"},{"regex":"Le Lift","model":"Le Lift","device":"smartphone"},{"regex":"Le Hola FR(?:[);/ ]|$)","model":"Le Hola FR","device":"smartphone"},{"regex":"Le[ _]Hola(?:[);/ ]|$)","model":"Le Hola","device":"smartphone"},{"regex":"LeMoov2(?:[);/ ]|$)","model":"Le Moov 2","device":"smartphone"},{"regex":"LeMoov(?:[);/ ]|$)","model":"Le Moov","device":"smartphone"},{"regex":"Le Fit FR(?:[);/ ]|$)","model":"Le Fit FR","device":"smartphone"},{"regex":"Le Hop(?:[);/ ]|$)","model":"Le Hop","device":"smartphone"},{"regex":"Le[ _]Hello(?:[);/ ]|$)","model":"Le Hello","device":"smartphone"},{"regex":"Le Smooth FR(?:[);/ ]|$)","model":"Le Smooth FR","device":"smartphone"},{"regex":"Le Smooth(?:[);/ ]|$)","model":"Le Smooth","device":"smartphone"},{"regex":"Le Must 2(?:[);/ ]|$)","device":"smartphone","model":"Le Must 2"},{"regex":"Le Must(?:[);/ ]|$)","model":"Le Must","device":"smartphone"},{"regex":"Le Starter L(?:[);/ ]|$)","model":"Le Starter L","device":"smartphone"},{"regex":"Le[ _]Spark(?:[);/ ]|$)","model":"Le Spark","device":"smartphone"},{"regex":"Le[ _]Prime(?:[);/ ]|$)","model":"Le Prime","device":"smartphone"},{"regex":"L-EGANTONE-R","model":"L-Egant One R","device":"smartphone"},{"regex":"L-EGANTONE","model":"L-Egant One","device":"smartphone"}]},"Konka":{"regex":"KONKA[_ ]([a-z0-9]+)","device":"smartphone","models":[{"regex":"E5660S","model":"Viva 5660s"},{"regex":"W830","model":"Tango 830"},{"regex":"W(9[67]0)","model":"Expose $1"},{"regex":"W990","model":"Tuxedo 990"},{"regex":"KONKA[_ ]([a-z0-9]+)","device":"feature phone","model":"$1"}]},"Konrow":{"regex":"(?:BIGCOOL|COOLFIVE|COOL-K|Just5|Link5|EASY(?:5|62)|CITY55|Cool55)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"BIGCOOL(?:[);/ ]|$)","model":"BigCool"},{"regex":"COOL-K(?:[);/ ]|$)","model":"Cool-K"},{"regex":"Cool55(?:[);/ ]|$)","model":"Cool 55"},{"regex":"COOLFIVE(?:[);/ ]|$)","model":"Cool Five"},{"regex":"Just5(?:[);/ ]|$)","model":"Just 5"},{"regex":"Link5(?:[);/ ]|$)","model":"Link 5"},{"regex":"EASY(5|62)(?:[);/ ]|$)","model":"Easy $1"},{"regex":"CITY55(?:[);/ ]|$)","model":"City 55"}]},"Karbonn":{"regex":"(?:Browser-)?Karbonn|K9 Kavach 4G|K9[_ ]Viraat[_ ]Plus|K9 Music 4G|K9 Smart|K9 VIRAAT 4G|Aura (?:Sleek Plus|Power 4G Plus|Note Play)|Titanium[ _](?:3D-Plex|Octane Plus|Vista 4G|Jumbo|S360|S1[059]|S35|S20[13]|S22|S[15]|S200 HD|Frames S7|MOGHUL|S9)|K-lite F3|Sparkle V|Alfa A114 Quad|Quattro L55 HD","device":"smartphone","models":[{"regex":"K9 Kavach 4G","model":"K9 Kavach 4G"},{"regex":"K9 Music 4G","model":"K9 Music 4G"},{"regex":"K9 Smart 1GB","model":"K9 Smart"},{"regex":"K9 Smart 4G","model":"K9 Smart 4G"},{"regex":"K9 Smart Grand","model":"K9 Smart Grand"},{"regex":"K9 Smart Yuva","model":"K9 Smart Yuva"},{"regex":"K9 Smart","model":"K9 Smart"},{"regex":"K9[_ ]Viraat[_ ]Plus","model":"K9 Viraat Plus"},{"regex":"Aura Sleek Plus","model":"Aura Sleek Plus"},{"regex":"Aura Power 4G Plus","model":"Aura Power 4G Plus"},{"regex":"Aura Note Play","model":"Aura Note Play"},{"regex":"Alfa A114 Quad","model":"Alfa A114 Quad"},{"regex":"karbonnK9 Viraat 4G|K9 VIRAAT 4G","model":"K9 Viraat 4G"},{"regex":"Titanium[ _]S2[ _]Plus","model":"Titanium S2 Plus"},{"regex":"Titanium_S9Plus","model":"Titanium S9 Plus"},{"regex":"Titanium[_ ]S(99|360|1[059]|109|35|200 HD|20[13]|22|[15])(?:[);/ ]|$)","model":"Titanium S$1"},{"regex":"Titanium Vista 4G","model":"Titanium Vista 4G"},{"regex":"Titanium Jumbo 2","model":"Titanium Jumbo 2"},{"regex":"Titanium Jumbo","model":"Titanium Jumbo"},{"regex":"Titanium[ _]MOGHUL","model":"Titanium Moghul"},{"regex":"Titanium Frames S7","model":"Titanium Frames S7"},{"regex":"Titanium Octane Plus","model":"Titanium Octane Plus"},{"regex":"Titanium[ _]3D-Plex","model":"Titanium 3D Plex"},{"regex":"K-lite F3","model":"K-Lite F3"},{"regex":"Sparkle V","model":"Sparkle V"},{"regex":"Quattro L55 HD","model":"Quattro L55 HD"},{"regex":"Karbonn ([a-z0-9]+) WAP-Browser","model":"$1","device":"feature phone"},{"regex":"WAP Browser-Karbonn ([a-z0-9]+)/","model":"$1","device":"feature phone"},{"regex":"Karbonn_([^;/)]+)","model":"$1"},{"regex":"Karbonn ([^;/]+) Build","model":"$1"},{"regex":"Karbonn ([^;/]+)/","model":"$1"}]},"Sagem":{"regex":"SAGEM|portalmmm/2.0 (?:SG|my)","device":"smartphone","models":[{"regex":"SAGEM-(my[a-z0-9\\\\-]+)","model":"$1","device":"feature phone"},{"regex":"SAGEM ([a-z0-9]+)","model":"$1"},{"regex":"SAGEM-([a-z0-9\\\\-]+)","model":"$1"},{"regex":"portalmmm/2.0 ((?:SG|my)[a-z0-9]+)","model":"$1"}]},"Coby Kyros":{"regex":"(MID(?:1024|1125|1126|1045|1048|1060|1065|4331|7012|7015A?|7016|7022|7032|7035|7036|7042|7047|7048|7052|7065|7120|8024|8042|8048|8065|8125|8127|8128|9724|9740|9742))(?:[);/ ]|$)","device":"tablet","model":"$1"},"Mpman":{"regex":"(?:MPQC|MPDC)[0-9]+|PH(?:150|340|350|360|451|500|520|544|604)|(?:MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP100i OCTA|MP(?:843|717|718|1010|7007|7008|843|888|959|969)|MGP7)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"((?:MPQC|MPDC)[0-9]+[^/;)]+)(?: Build|\\\\))","model":"$1"},{"regex":"MP100i OCTA(?:[);/ ]|$)","model":"MP100i OCTA"},{"regex":"(MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP(?:843|717|718|1010|7007|7008|843|888|959|969)|MGP7)(?:[);/ ]|$)","model":"$1"},{"regex":"(PH(?:150|340|350|360|451|500|520|544|604))","model":"$1","device":"smartphone"}]},"Majestic":{"regex":"MAJESTIC[ _-]|CRONO ?[0-9]+|TAB (?:647|411) 3G|URANO 77LTE","device":"smartphone","models":[{"regex":"URANO 77LTE(?:[);/ ]|$)","model":"Urano 77 LTE"},{"regex":"TAB (647|411) 3G","model":"Tab $1 3G","device":"tablet"},{"regex":"MAJESTIC[ _]Tab([^;/]+)Build","model":"Tab$1","device":"tablet"},{"regex":"MAJESTIC[ _]Tab([^);/]+)(?:[);/]|$)","model":"Tab$1","device":"tablet"},{"regex":"MAJESTIC[ _]([^;/]+)Build","model":"$1"},{"regex":"MAJESTIC[ _]([^);/]+)(?:(?:[);/ ]|$)|$)","model":"$1"},{"regex":"CRONO ?([0-9]+) Build","model":"Crono $1"},{"regex":"CRONO ?([0-9]+)(?:[);/]|$)","model":"Crono $1"}]},"Manta Multimedia":{"regex":"MSP950(1[245]|2[01])|MSP96017|((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)","device":"tablet","model":"$1"},{"regex":"MSP95012","model":"Titano 1"},{"regex":"MSP95014","model":"Titano 3"},{"regex":"MSP95015","model":"Mezo 2"},{"regex":"MSP95020","model":"Rocky 2"},{"regex":"MSP95021","model":"Rocky 3 Pro"},{"regex":"MSP96017","model":"Forto 2"}]},"Masstel":{"regex":"Masstel","device":"smartphone","models":[{"regex":"Masstel[_ ](Juno[_ ]Q3|X9|N4[56]0|N5[2458]0|N536|M05|M1[29]0|M1[125]|M250|M25)(?:[);/ ]|$)","model":"$1"},{"regex":"Masstel[_ ]\\\\((M18)\\\\)","model":"$1"},{"regex":"Masstel_Tab7LTE(?:[);/ ]|$)","model":"Tab 7 LTE","device":"tablet"},{"regex":"Masstel Tab (840|700i)(?:[);/ ]|$)","model":"Tab $1","device":"tablet"}]},"Maxwest":{"regex":"(?:Astro[_ ](?:5N_LTE|X4|5_GO_LTE|X55s)|Virtue Z5|Nitro[_ ](?:4S?|55R|5[XR]|[45] GO|4s LTE)|Gravity_55?_GO|Nitro_Phablet_9s)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Astro_5N_LTE","model":"Astro 5N LTE"},{"regex":"Astro_5_GO_LTE","model":"Astro 5 Go LTE"},{"regex":"Virtue Z5","model":"Virtue Z5"},{"regex":"Astro X55s","model":"Astro X55s"},{"regex":"Astro[_ ]X4","model":"Astro X4"},{"regex":"Nitro ([45]) GO","model":"Nitro $1 GO"},{"regex":"Nitro 4s LTE","model":"Nitro 4s LTE"},{"regex":"Nitro[ _]4s","model":"Nitro 4s"},{"regex":"Nitro_(4|55R|5[XR])","model":"Nitro $1"},{"regex":"Gravity_(55?)_GO","model":"Gravity $1 GO"},{"regex":"Nitro_Phablet_9s","device":"tablet","model":"Nitro Phablet 9s"}]},"True Slim":{"regex":"(SSB-508[ED])(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Maze Speed":{"regex":"(SSB-(?:500|508)|SSB408D|SSB504R)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"SSB-?(500|508|408D|504R)(?:[);/ ]|$)","model":"SSB-$1"}]},"Maze":{"regex":"(?:Alpha[_ ]X|Maze Alpha)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Alpha[_ ]X(?:[);/ ]|$)","model":"Alpha X"},{"regex":"Maze Alpha(?:[);/ ]|$)","model":"Alpha"}]},"Mediacom":{"regex":"(?:SmartPad7503G|M-SP10MXA|M-PPAB500|SmartPad970s2(?:3G)?|M[_-][MPS]P[0-9a-z]+|M-IPRO[0-9a-z]+|1AEC)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"SmartPad7503G(?:[);/ ]|$)","model":"SmartPad 750 3G"},{"regex":"SmartPad970s23G(?:[);/ ]|$)","model":"SmartPad 970 S2 3G"},{"regex":"SmartPad970s2(?:[);/ ]|$)","model":"SmartPad 970 S2"},{"regex":"M-MP84[02]M(?:[);/ ]|$)","model":"SmartPad 8.0\\" Mobile"},{"regex":"M-MP940M(?:[);/ ]|$)","model":"SmartPad 9.7\\" Mobile"},{"regex":"M-SP10MXA(?:[);/ ]|$)","model":"SmartPad MX 10.1\\""},{"regex":"M-SP8MXA(?:[);/ ]|$)","model":"SmartPad MX 8.0\\""},{"regex":"M-SP7HXAH(?:[);/ ]|$)","model":"SmartPad HX 7.0\\""},{"regex":"M-SP8HXAH(?:[);/ ]|$)","model":"SmartPad HX 8.0\\" HD"},{"regex":"M-MP(?:710|720|725|726|740)GOx?(?:[);/ ]|$)","model":"SmartPad 7.0\\" Go"},{"regex":"M-MP876S2(?:[);/ ]|$)","model":"SmartPad 8.0\\" S2"},{"regex":"M-MP8S2[AB]?3G(?:[);/ ]|$)","model":"SmartPad 8.0\\" S2 3G"},{"regex":"M-MP(101|102|860|875)S2[BW]?(?:[);/ ]|$)","model":"SmartPad $1 S2"},{"regex":"M-MP85S23G(?:[);/ ]|$)","model":"SmartPad 875 S2 3G"},{"regex":"M-SP1AGO3G","model":"SmartPad 10 Go 3G"},{"regex":"M-SP7xGO3G","model":"SmartPad 10.1\\" iPro 3G"},{"regex":"1AEC","model":"SmartPad 10 Eclipse"},{"regex":"M-MP10[45][01]S2(?:[);/ ]|$)","model":"SmartPad 10.1\\" S2"},{"regex":"M-MP1S2[AB]3G(?:[);/ ]|$)","model":"SmartPad 10.1\\" S2 3G"},{"regex":"M-MP8[24]S4(?:[);/ ]|$)","model":"SmartPad 8.0\\" S4"},{"regex":"M-MP8S4[AB]3G(?:[);/ ]|$)","model":"SmartPad 8.0\\" S4 3G"},{"regex":"M-MP9S4A3G(?:[);/ ]|$)","model":"SmartPad 9.7\\" S4 3G"},{"regex":"M-MP1[02]S4(?:[);/ ]|$)","model":"SmartPad 10.1\\" S4"},{"regex":"M-MP1040MC?(?:[);/ ]|$)","model":"SmartPad 10.1\\" HD S4 3G"},{"regex":"M-MP1S4[AB]3G(?:[);/ ]|$)","model":"SmartPad 10.1\\" S4 3G"},{"regex":"M-SP10HXxH(?:[);/ ]|$)","model":"SmartPad 10.1\\" HX HD"},{"regex":"M-SP10MXHA(?:[);/ ]|$)","model":"SmartPad 10.1\\" MX"},{"regex":"M-SP10MXHL(?:[);/ ]|$)","model":"SmartPad 10.1\\" MX Lite"},{"regex":"M-MP8PA3G(?:[);/ ]|$)","model":"SmartPad 8.0\\" HD Pro 3G"},{"regex":"M-MP10PA(?:[);/ ]|$)","model":"SmartPad 10.1\\" HD Pro"},{"regex":"M-MP10PA3G(?:[);/ ]|$)","model":"SmartPad 10.1\\" HD Pro 3G"},{"regex":"M-IPRO([18][01]0)[BW](?:[);/ ]|$)","model":"SmartPad 8.0\\" HD iPro$1 3G"},{"regex":"(?:M-MP75S23G|M-MP72[01]M)(?:[);/ ]|$)","model":"SmartPad 7.0\\" Mobile","device":"phablet"},{"regex":"M-MP7S2[ABDK]3G(?:[);/ ]|$)","model":"SmartPad 7.0\\" S2 3G","device":"phablet"},{"regex":"M-MP5303G(?:[);/ ]|$)","model":"SmartPad Mini Mobile","device":"phablet"},{"regex":"M-PPxB400(?:[);/ ]|$)","model":"PhonePad Duo B400","device":"phablet"},{"regex":"M-PPAG550(?:[);/ ]|$)","model":"PhonePad Duo G550","device":"phablet"},{"regex":"M-PPAB500(?:[);/ ]|$)","model":"PhonePad Duo B500","device":"phablet"},{"regex":"M-PP2G530(?:[);/ ]|$)","model":"PhonePad Duo G530","device":"phablet"},{"regex":"M-PPG700(?:[);/ ]|$)","model":"PhonePad Duo G700","device":"phablet"},{"regex":"M-PPxS531(?:[);/ ]|$)","model":"PhonePad Duo S531","device":"phablet"},{"regex":"M-PP2S550(?:[);/ ]|$)","model":"PhonePad Duo S550","device":"phablet"},{"regex":"M-PP2S650C?(?:[);/ ]|$)","model":"PhonePad Duo S650","device":"phablet"},{"regex":"M-PPxS551U(?:[);/ ]|$)","model":"PhonePad Duo S551U","device":"phablet"},{"regex":"M-PPAG4(?:[);/ ]|$)","model":"PhonePad Duo G4","device":"smartphone"},{"regex":"M-PP[ABC]G500(?:[);/ ]|$)","model":"PhonePad Duo G500","device":"smartphone"},{"regex":"M-PP2S500[BC]?(?:[);/ ]|$)","model":"PhonePad Duo S500","device":"smartphone"},{"regex":"M[_-]PP[Ax]X(470|510|520)U(?:[);/ ]|$)","model":"PhonePad Duo X$1U","device":"smartphone"},{"regex":"M-PPxG(400|501|[457][PM]?)(?:[);/ ]|$)","model":"PhonePad Duo G$1","device":"smartphone"},{"regex":"M-PPxS(532[LU]|470|501|5P?|7P?)(?:[);/ ]|$)","model":"PhonePad Duo S$1","device":"smartphone"},{"regex":"M-PPxG(450)(?:[);/ ]|$)","model":"PhonePad Duo G$1","device":"smartphone"},{"regex":"M-MP([0-9a-z]+)","model":"SmartPad $1"}]},"Medion":{"regex":"Medion|(?:MD_)?LIFETAB|([SPX]10[0-9]{2}X|E10[45]1X|X5001|P851X|P850X|E691X|E1050X)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:MD_)?LIFETAB_([a-z0-9]+)","device":"tablet","model":"Lifetab $1"},{"regex":"(E450[46]|E5004|S5004|X5001|E5020|P5015)(?:[);/ ]|$)","model":"Life $1"},{"regex":"(B5530)(?:[);/ ]|$)","model":"$1"},{"regex":"(E10[45]1X)(?:[);/ ]|$)","device":"tablet","model":"$1"},{"regex":"([SPX]10[0-9]{2}X|P851X|P850X|E691X|E1050X)(?:[);/ ]|$)","model":"Lifetab $1","device":"tablet"},{"regex":"Medion(?: Smartphone)? ([^/;]+) Build","model":"$1"}]},"MEEG":{"regex":"MEEG[ _-]","device":"smartphone","models":[{"regex":"MEEG[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"MEEG[ _\\\\-]?([^);/ ]+)","model":"$1"}]},"Fourel":{"regex":"(?:EASYSMARTM3|EasySmart M2)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"EASY ?SMART ?M([32])","model":"Easy Smart M$1"}]},"Meizu":{"regex":"Meizu|MZ-[a-z]|(?<!POCO )(M04[05]|MZ-16th(?: Plus)?|MZ-16[st]|M7[12]1C|M35[1356]|M612C|M578CA|M181[36]|M1822|M681C|M6T|MX[ -]?[2345](?: Pro)?|(?:MZ-)?m[1-6] note|M621C|M1852|M57[18]C|M3[ESX]|M031|m1 metal|M1 E|M2|M2 E|M5s Build|PRO [67]|PRO 7-[HS]| 15 Lite| 16th|MZ-15 (?:Lite|Plus)|MZ-16 X)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:MZ-)?M571C","device":"phablet","model":"M2 Note"},{"regex":"(?:MZ-|Meizu-)?m([1-6])[_ ]note(?:[);/ ]|$)","device":"phablet","model":"M$1 Note"},{"regex":"M1 E(?:[);/ ]|$)","model":"M1E"},{"regex":"M2 E(?:[);/ ]|$)","model":"M2E"},{"regex":"(?:MZ-)?M578C[A]?|M2(?:[);/ ]|$)","model":"M2"},{"regex":"M681C(?:[);/ ]|$)","model":"M3 Note","device":"phablet"},{"regex":"M621C(?:[);/ ]|$)","model":"M5 Note","device":"phablet"},{"regex":"M711C(?:[);/ ]|$)","model":"M6"},{"regex":"M721C(?:[);/ ]|$)","model":"M6 Note","device":"phablet"},{"regex":"M6T","model":"M6T"},{"regex":"M3E","model":"M3E"},{"regex":"M3S","model":"M3S"},{"regex":"M3X","model":"M3X"},{"regex":"M5S|M612C","model":"M5S"},{"regex":"(M04[05]|MX[ -]?2)(?:[);/ ]|$)","model":"MX2"},{"regex":"(M35[1356]|MX[ -]?3)(?:[);/ ]|$)","model":"MX3"},{"regex":"MX[ -]?4 Pro(?:[);/ ]|$)","model":"MX4 Pro"},{"regex":"MX[ -]?4(?:[);/ ]|$)","model":"MX4"},{"regex":"(Meizu[- _])?MX[ -]?5(?:[);/ ]|$)","model":"MX5"},{"regex":"m1 metal","model":"M1 Metal"},{"regex":"M1813(?:[);/ ]|$)","model":"M8"},{"regex":"M1816(?:[);/ ]|$)","model":"M8 Lite"},{"regex":"PRO 7-[HS](?:[);/ ]|$)","model":"PRO 7"},{"regex":"PRO 7 Plus(?:[);/ ]|$)","model":"Pro 7 Plus"},{"regex":"PRO ([67])","model":"PRO $1"},{"regex":"M031(?:[);/ ]|$)","model":"MX Dual Core"},{"regex":"M1852(?:[);/ ]|$)","model":"X8"},{"regex":"M1822(?:[);/ ]|$)","model":"Note 8"},{"regex":"MZ-16T(?:[);/ ]|$)","model":"16T"},{"regex":"(?:MZ-)?16th Plus(?:[);/ ]|$)","model":"16th Plus"},{"regex":"MZ-15 Plus(?:[);/ ]|$)","model":"15 Plus"},{"regex":"(?:MZ-15 Lite| 15 Lite)(?:[);/ ]|$)","model":"15 Lite"},{"regex":"MZ-16th| 16th(?:[);/ ]|$)","model":"16th"},{"regex":"MZ-16 X(?:[);/ ]|$)","model":"16X"},{"regex":"Meizu[_ ]note([89])(?:[);/ ]|$)","device":"phablet","model":"Note $1"},{"regex":"(?:MZ-)?Meizu[_ ]([^/;]+) Build","model":"$1"},{"regex":"(?:MZ-)?Meizu[_ ]([a-z0-9_]+)","model":"$1"},{"regex":"MZ-([^/;]+) Build","model":"$1"}]},"Meitu":{"regex":"(?:(?<!MI CC 9 )Meitu[2]?|MP1503|MP1512|MP160[235]|MP170[19]|MP171[138])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"MP1503(?:[);/ ]|$)","model":"M6"},{"regex":"MP1512(?:[);/ ]|$)","model":"M6s"},{"regex":"MP1602(?:[);/ ]|$)","model":"T8"},{"regex":"MP1605(?:[);/ ]|$)","model":"V6"},{"regex":"MP17(?:01|13)(?:[);/ ]|$)","model":"T8s"},{"regex":"MP1718(?:[);/ ]|$)","model":"T9"},{"regex":"MP1603(?:[);/ ]|$)","model":"M8"},{"regex":"MP17(?:09|11)(?:[);/ ]|$)","model":"M8s"},{"regex":"Meitu2(?:[);/ ]|$)","model":"2"},{"regex":"Meitu (Kiss|[MV]4)(?:[);/ ]|$)","model":"$1"}]},"Memup":{"regex":"SlidePad ?([^;/]*) Build|SPNG?[0-9]{2,4}[a-z]{0,2}(?:[);/ ]|$)|SP704CE?|SP-NG708-3G","device":"tablet","models":[{"regex":"SlidePad ?([^;/]*) Build","model":"SlidePad $1"},{"regex":"SPNG([0-9]{2,4}[a-z]{0,2})(?:[);/ ]|$)","model":"SlidePad NG$1"},{"regex":"SP-NG(708)-3G(?:[);/ ]|$)","model":"SlidePad NG$1 3G"},{"regex":"SP704(CE?)","model":"SlidePad 704$1"}]},"Mecer":{"regex":"(M785|800P3[12]C|101P51C|X1010)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"M785(?:[);/ ]|$)","model":"Xpress Smartlife M785"},{"regex":"X1010(?:[);/ ]|$)","model":"X1010"},{"regex":"800P31C(?:[);/ ]|$)","model":"Xpress Smartlife 800P31C"},{"regex":"800P32C(?:[);/ ]|$)","model":"Xpress Smartlife 800P32C"},{"regex":"101P51C(?:[);/ ]|$)","model":"Xpress Smartlife 101P51C"}]},"Mio":{"regex":"MIO(?:/)?([a-z0-9]+)|(?:MOBIX M6|Mio TouchPad 7 Quad Core)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"MOBIX M6(?:[);/ ]|$)","model":"Mobix M6"},{"regex":"MIO(?:/)?([a-z0-9]+)","model":"$1"},{"regex":"Mio TouchPad 7 Quad Core","device":"tablet","model":"TouchPad 7 Quad Core"}]},"Miray":{"regex":"MIDM[_-]|MPM[_-]","device":"smartphone","models":[{"regex":"MIDM[_-]([a-z0-9]+)","model":"MIDM $1","device":"tablet"},{"regex":"MPM[_-]([a-z0-9]+)","model":"MPM $1"}]},"Mitsubishi":{"regex":"MITSU|portalmmm/[12]\\\\.0 M","device":"feature phone","models":[{"regex":"MITSU/[a-z0-9.]+ \\\\(([a-z0-9]+)\\\\)","model":"$1"},{"regex":"MITSU[ \\\\-]?([a-z0-9]+)","model":"$1"},{"regex":"portalmmm/[12]\\\\.0 (M[a-z0-9]+)","model":"$1"}]},"MIXC":{"regex":"(M35|M20|G7106|G7108)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(M[0-9]{1,2})(?:[);/ ]|$)","model":"$1"},{"regex":"(G[0-9]{4})(?:[);/ ]|$)","model":"$1"}]},"Mobiola":{"regex":"(MS5[50]X6|MS55X5|MS55L1|MS50L1|MS43A3000|MS45A4000|MS50A4000|MS50A4500|MS50A5000|MS50A6000|MS50B11000|MB-2900 QUATTRO|POLYS[_ ]MS45L1|Wave5)","device":"smartphone","models":[{"regex":"MS50X6","model":"Atmos II"},{"regex":"POLYS[_ ]MS45L1","model":"Polys MS45L1"},{"regex":"MS55X6","model":"Atmos Pro II"},{"regex":"MS55X5","model":"Atmos Pro"},{"regex":"MS55L1","model":"GAIA"},{"regex":"MS50L1","model":"Inti"},{"regex":"MB-2900 QUATTRO","model":"MB-2900 Quattro"},{"regex":"MS43A3000","model":"MS43A3000"},{"regex":"MS45A4000","model":"eOn 45"},{"regex":"MS50A4000","model":"eOn 50"},{"regex":"MS50A4500","model":"eOn 50 Elegance"},{"regex":"MS50A5000","model":"eOn 50 Quad 8"},{"regex":"MS50A6000","model":"eOn 50 Quad 16"},{"regex":"MS50B11000","model":"MS50B11000"},{"regex":"Wave5","model":"Wave 5"}]},"Mobicel":{"regex":"Mobicel_(R1)|(?:HYPE|DANDY(?:_ZAM)?|(?<!SMADL )Matrix|TRENDY PLUS|FENDY_DS|TANGO_LITE|BLINK|BERRY[_ ]?(?:[12]|PLUS))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Matrix","model":"Matrix"},{"regex":"BLINK","model":"Blink"},{"regex":"BERRY1","model":"Berry 1"},{"regex":"BERRY 2","model":"Berry 2"},{"regex":"BERRY[_ ]PLUS","model":"Berry Plus"},{"regex":"TRENDY PLUS","model":"Trendy Plus"},{"regex":"HYPE","model":"Hype"},{"regex":"DANDY_ZAM","model":"Dandy Zam"},{"regex":"DANDY","model":"Dandy"},{"regex":"TANGO_LITE","model":"Tango Lite"},{"regex":"FENDY_DS","model":"Fendy DS"},{"regex":"Mobicel_(R1)","model":"$1"}]},"Mobiistar":{"regex":"Mobiistar|Zumbo[ _]S|PRIME X MAX|X1 Notch|E1 Selfie","device":"smartphone","models":[{"regex":"X1 Notch(?:[);/ ]|$)","model":"X1 Notch"},{"regex":"E1 Selfie(?:[);/ ]|$)","model":"E1 Selfie"},{"regex":"mobiistar_LAI_Zumbo(?:[);/ ]|$)","model":"Zumbo"},{"regex":"Zumbo[_ ]S[_ ]2017[_ ]Lite(?:[);/ ]|$)","model":"Lai Zumbo S Lite (2017)"},{"regex":"Zumbo[_ ]S[_ ]2017(?:[);/ ]|$)","model":"Lai Zumbo S (2017)"},{"regex":"mobiistar ZUMBO S2( Dual)","model":"Zumbo S2"},{"regex":"Mobiistar_LAI_Zumbo_J_2017(?:[);/ ]|$)","model":"Lai Zumbo J (2017)"},{"regex":"Mobiistar_LAI_Zumbo_J(?:[);/ ]|$)","model":"Lai Zumbo J"},{"regex":"Mobiistar_Zumbo_J2","model":"Lai Zumbo J2"},{"regex":"Mobiistar[_ ]Zumbo[_ ]S2","model":"Zumbo S2"},{"regex":"mobiistar ZUMBO Power","model":"Zumbo Power"},{"regex":"mobiistar[ _]LAI[ _]YUNA[ _]([1XCS])","model":"Lai Yuna $1"},{"regex":"mobiistar LAI Yuki","model":"Lai Yuki"},{"regex":"mobiistar[ _]LAI[ _]ZORO[ _]([23])","model":"Lai Zoro $1"},{"regex":"mobiistar[ _]LAI[ _]Zena","model":"Lai Zena"},{"regex":"mobiistar[ _]LAI[ _]Z([12])?","model":"Lai Z$1"},{"regex":"mobiistar_ZORO_4G","model":"Zoro 4G"},{"regex":"mobiistar touch LAI 512","model":"Touch Lai 512"},{"regex":"mobiistar LAI 504([KC])","model":"Lai 504$1"},{"regex":"mobiistar LAI Y","model":"Lai Y"},{"regex":"mobiistar PRIME X 2017","model":"Prime X"},{"regex":"mobiistar[ _]PRIME[ _](X1|558|X[ _]Plus|X[ _]Grand) Build","model":"Prime $1"},{"regex":"PRIME X MAX 2018","model":"Prime X Max"},{"regex":"mobiistar[ _]KOOL([ _]Lite)?","model":"Kool$1"},{"regex":"mobiistar KAT 452 Build","model":"Kat 452"},{"regex":"mobiistar_LAI_YOLLO Build","model":"Lai Yollo"},{"regex":"Mobiistar[ _]([^;/)]+)(?: Build|[;)])","model":"$1"}]},"MSI":{"regex":"Primo ?(?:9[13]|81|76)|Enjoy 7 Plus","device":"tablet","models":[{"regex":"Primo ?(9[13]|76|81)","model":"Primo $1"},{"regex":"Enjoy 7 Plus","model":"Enjoy 7 Plus"}]},"MLLED":{"regex":"MLLED[ _]","device":"smartphone","models":[{"regex":"MLLED[ _]([^;/]+)Build","model":"$1"},{"regex":"MLLED[ _]([^);/]+)(?:[);/]|$)","model":"$1"}]},"Mobistel":{"regex":"(Cynus[ _][^/;)]+)( Build|\\\\))","device":"smartphone","model":"$1"},"Mecool":{"regex":"(?:KM9PRO|BB2 PRO|K[I]{1,3} PRO|KI PLUS|KM9_TV_BOX|M8SPROW|M8S (?:PLUS|PRO) (?:DVB|[LW]|PLUS)|M8S (?:MAX|PRO))(?:[);/ ]|$)","device":"tv","models":[{"regex":"KM9PRO(?:[);/ ]|$)","model":"KM9 Pro"},{"regex":"KM9_TV_BOX(?:[);/ ]|$)","model":"KM9 TV Box"},{"regex":"BB2 PRO(?:[);/ ]|$)","model":"BB2 Pro"},{"regex":"(K[I]{1,3}) PRO(?:[);/ ]|$)","model":"$1 Pro"},{"regex":"KI PLUS(?:[);/ ]|$)","model":"KI Plus"},{"regex":"M8SPROW(?:[);/ ]|$)","model":"M8S Pro W"},{"regex":"M8S PLUS DVB(?:[);/ ]|$)","model":"M8S Plus DVB"},{"regex":"M8S PLUS ([LW])(?:[);/ ]|$)","model":"M8S Plus $1"},{"regex":"M8S PRO ([LW])(?:[);/ ]|$)","model":"M8S Pro $1"},{"regex":"M8S PRO PLUS(?:[);/ ]|$)","model":"M8S Pro Plus"},{"regex":"M8S PRO(?:[);/ ]|$)","model":"M8S Pro"},{"regex":"M8S MAX(?:[);/ ]|$)","model":"M8S Max"}]},"Modecom":{"regex":"Modecom|Free(?:Way )?Tab|xino z[\\\\d]+ x[\\\\d]+","device":"tablet","models":[{"regex":"xino Z([\\\\d]+) X([\\\\d]+)","model":"Xino Z$1 X$2","device":"smartphone"},{"regex":"FreeTab[ _\\\\-]?([^/;]+)? Build","model":"FreeTab $1"},{"regex":"FreeTab[ _\\\\-]?((?!Build)[^);/ ]+)?","model":"FreeTab $1"},{"regex":"FreeWay Tab[ _\\\\-]?([^/;]+) Build","model":"FreeWay Tab $1"},{"regex":"FreeWay Tab[ _\\\\-]?((?!Build)[^);/ ]+)","model":"FreeWay Tab $1"}]},"Mofut":{"regex":"Mofut","device":"smartphone","models":[{"regex":"Mofut[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"Mofut[ _\\\\-]?((?!Build)[^);/ ]+)","model":"$1"}]},"BrightSign":{"regex":"BrightSign","device":"tv","models":[{"regex":"(HD1023|XD233|XD230|XD1030|XT114[34]|4K1142|LS424)","model":"$1"}]},"Motorola":{"regex":"MOT(?!TO)|(?<!AN)DROID ?(?:Build|[a-z0-9]+)|portalmmm/2.0 (?:E378i|L6|L7|v3)|XOOM [^;/]*Build|XT1941-2|XT1924-9|XT1925-10|XT1965-6|XT1970-5|XT1799-2|XT1021|XT1710-08|XT180[3-5]|XT194[23]-1|XT1929-15|(?:XT|MZ|MB|ME)[0-9]{3,4}[a-z]?(?:\\\\(Defy\\\\)|-0[1-5])?(?:[;]? Build|\\\\))","device":"smartphone","models":[{"regex":"MOT-V360","model":"V360","device":"feature phone"},{"regex":"(?:MOT-|Motorola-)?XT300","model":"Spice"},{"regex":"(?:MOT-|Motorola-)?XT30[35]","model":"Motosmart ME"},{"regex":"(?:MOT-|Motorola-)?XT31[16]","model":"Fire"},{"regex":"(?:MOT-|Motorola-)?XT32[01]","model":"Defy Mini"},{"regex":"(?:MOT-|Motorola-)?XT3(?:89|90)","model":"Motosmart"},{"regex":"(?:MOT-|Motorola-)?XT502","model":"Quench"},{"regex":"(?:MOT-|Motorola-)?XT531","model":"Fire XT"},{"regex":"(?:MOT-|Motorola-)?XT535","model":"Defy"},{"regex":"(?:MOT-|Motorola-)?XT55[567]C?","model":"Defy XT"},{"regex":"(?:MOT-|Motorola-)?XT603","model":"Admiral"},{"regex":"(?:MOT-|Motorola-)?XT610","model":"Droid Pro"},{"regex":"(?:MOT-|Motorola-)?XT615","model":"Motoluxe"},{"regex":"(?:MOT-|Motorola-)?XT621","model":"Primus"},{"regex":"(?:MOT-|Motorola-)?XT626","model":"IronRock"},{"regex":"(?:MOT-|Motorola-)?XT682","model":"Atrix"},{"regex":"(?:MOT-|Motorola-)?XT685","model":"Motoluxe Dual-SIM"},{"regex":"(?:MOT-|Motorola-)?XT687","model":"Atrix TV"},{"regex":"(?:MOT-|Motorola-)?XT720","model":"Milestone"},{"regex":"(?:MOT-|Motorola-)?XT800W","model":"Glam"},{"regex":"(?:MOT-|Motorola-)?XT860","model":"Milestone 3"},{"regex":"(?:MOT-|Motorola-)?XT881","model":"Electrify 2"},{"regex":"(?:MOT-|Motorola-)?XT882","model":"Moto XT882"},{"regex":"(?:MOT-|Motorola-)?XT88[56]","model":"Droid RAZR V"},{"regex":"(?:MOT-|Motorola-)?XT890","model":"Droid RAZR i"},{"regex":"(?:MOT-|Motorola-)?XT894","model":"Droid 4"},{"regex":"(?:MOT-|Motorola-)?XT897","model":"Photon Q"},{"regex":"(?:MOT-|Motorola-)?XT901","model":"Electrify M"},{"regex":"(?:MOT-|Motorola-)?XT90[567]","model":"Droid RAZR M"},{"regex":"(?:MOT-|Motorola-)?XT910S?","model":"Droid RAZR"},{"regex":"(?:MOT-|Motorola-)?XT91[4568]","model":"Droid RAZR D1"},{"regex":"(?:MOT-|Motorola-)?XT9(?:19|20)","model":"Droid RAZR D3"},{"regex":"(?:MOT-|Motorola-)?XT925","model":"Droid RAZR HD"},{"regex":"(?:MOT-|Motorola-)?XT102[12]","model":"Moto E"},{"regex":"(?:MOT-|Motorola-)?XT1706","model":"Moto E3 Power"},{"regex":"(?:MOT-|Motorola-)?XT1924-9|moto e5 plus","model":"Moto E5 Plus"},{"regex":"Moto E5 Play","model":"Moto E5 Play"},{"regex":"Moto E5 go(?:[);/ ]|$)","model":"Moto E5 Go"},{"regex":"Moto E6(?:[);/ ]|$)","model":"Moto E6"},{"regex":"(?:MOT-|Motorola-)?XT1030","model":"Droid Mini"},{"regex":"(?:MOT-|Motorola-)?XT1096","model":"Moto X2"},{"regex":"(?:MOT-|Motorola-)?XT1254","model":"Droid Turbo"},{"regex":"(?:MOT-|Motorola-)?XT10(?:28|3[1234]|68|69)","model":"Moto G"},{"regex":"(?:MOT-|Motorola-)?XT1799-2","model":"Moto G5s"},{"regex":"(?:MOT-|Motorola-)?XT180[3-5]","model":"Moto G5s Plus"},{"regex":"(?:MOT-|Motorola-)?XT168[57]","model":"Moto G5 Plus"},{"regex":"(?:MOT-|Motorola-)?XT1670","model":"Moto G5"},{"regex":"(?:MOT-|Motorola-)?XT1925-10","model":"Moto G6"},{"regex":"(?:MOT-|Motorola-)?XT1965-6","model":"Moto G7 Plus"},{"regex":"(?:MOT-|Motorola-)?XT10(?:49|5[23568]|60|9[23457])","model":"Moto X"},{"regex":"(?:MOT-|Motorola-)?XT1562","model":"Moto X Play"},{"regex":"(?:MOT-|Motorola-)?XT1572","model":"Moto X Style"},{"regex":"(?:MOT-|Motorola-)?XT1080","model":"Droid Ultra"},{"regex":"(?:MOT-|Motorola-)?XT1650-05","model":"Moto Z"},{"regex":"moto z4(?:[);/ ]|$)","model":"Moto Z4"},{"regex":"(?:MOT-|Motorola-)?XT1635(?:-0[1-3])?","model":"Moto Z Play"},{"regex":"(?:MOT-|Motorola-)?XT1710-(?:-0[28])?","model":"Moto Z2 Play"},{"regex":"(?:MOT-|Motorola-)?XT1789-05","model":"Moto Z2 Force"},{"regex":"(?:MOT-|Motorola-)?XT1929-15","model":"Moto Z3"},{"regex":"(?:MOT-|Motorola-)?XT1663","model":"Moto M"},{"regex":"(?:MOT-|Motorola-)?XT1943-1","model":"P30"},{"regex":"(?:MOT-|Motorola-)?XT1941-2","model":"P30 Play"},{"regex":"(?:MOT-|Motorola-)?XT1942-1","model":"P30 Note"},{"regex":"(?:MOT-|Motorola-)?XT1970-5","model":"One Vision"},{"regex":"(?:MOT-|Motorola-)?one zoom","model":"One Zoom"},{"regex":"motorola one action","model":"One Action"},{"regex":"motorola one macro","model":"One Macro"},{"regex":"motorola one 5G UW","model":"One 5G UW"},{"regex":"moto g power","model":"Moto G Power"},{"regex":"moto g\\\\(([0-9])\\\\) power lite","model":"Moto G$1 Power Lite"},{"regex":"moto g\\\\(([0-9])\\\\) power","model":"Moto G$1 Power"},{"regex":"moto g\\\\(([0-9])\\\\) supra","model":"Moto G$1 Supra"},{"regex":"moto g\\\\(([0-9])\\\\) plus","model":"Moto G$1 Plus"},{"regex":"moto g\\\\(([0-9]+)\\\\) play","model":"Moto G$1 Play"},{"regex":"moto g\\\\(([0-9]+)\\\\)","model":"Moto G$1"},{"regex":"Moto ([CGEXZ]) ?\\\\(([a-z0-9]+)\\\\)( Plus| Play)?","model":"Moto $1$2$3"},{"regex":"Moto ?([CGEXZ])([0-9]+)( Plus| Play)?","model":"Moto $1$2$3"},{"regex":"(?:Motorola-)?Moto[ _]?([CGEXZ])([ _](?:Plus|Play))?","model":"Moto $1$2"},{"regex":"MotoroiX","model":"MotoroiX"},{"regex":"Motorola[ _\\\\-]([^/;]+)(?: Build|[);])","model":"$1"},{"regex":"MOTORAZR[ _\\\\-]([a-z0-9]+)","model":"RAZR $1"},{"regex":"MOTORIZR[ _\\\\-]([a-z0-9]+)","model":"RIZR $1"},{"regex":"MOT(?!OROLA)[O]?[_\\\\-]?([a-z0-9.]+)","model":"$1"},{"regex":"(?<!AN)DROID ?([a-z0-9 ]*) Build","model":"DROID $1"},{"regex":"(?<!AN)DROID ?([a-z0-9]+)","model":"DROID $1"},{"regex":"portalmmm/2.0 ((?:E378i|L6|L7|V3)[a-z0-9]+)","model":"$1"},{"regex":"(XOOM [^;/]*)Build","device":"tablet","model":"$1"},{"regex":"(MZ[0-9]{3})(?:[);/ ]|$)","device":"tablet","model":"$1"},{"regex":"((?:ME|MB|XT)[0-9]{3,4}(?:\\\\(Defy\\\\))?)(?:[);/ ]|$)","model":"$1"}]},"Movic":{"regex":"MOVIC","device":"smartphone","models":[{"regex":"MOVIC[ -]W([2345])","model":"W$1"}]},"MTN":{"regex":"MTN-","device":"smartphone","models":[{"regex":"MTN-(L860|S620)","model":"Sm@rt Mini $1"},{"regex":"MTN-8978P","device":"tablet","model":"Steppa"},{"regex":"MTN-([a-z0-9_\\\\-]+)","model":"MTN-$1"}]},"MyTab":{"regex":"MyTAB[ _-](?:8 MINI Dual Core|U55GT)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"MyTAB[ _-]8 MINI Dual Core(?:[);/ ]|$)","model":"8 Mini Dual Core"},{"regex":"MyTAB-U55GT(?:[);/ ]|$)","model":"U55GT"}]},"MyPhone":{"regex":"(?:MyPhone|MyPad|MyTab)[ _][^;/)]+( Build|\\\\))|Cube_LTE|myTab10II|HAMMER[ _](Blade2_PRO|IRON_3|Explorer|ENERGY|Titan 2|AXE[_ ](?:M[_ ]LTE|Pro)|Iron 2|Active[2]?(_LTE)?)|C-Smart_pix|myPhone_Fun_8|FUN_18x9|MyPhoneMY27|Prime_4_Lite|myA17|myX12|Pocket_2|Prime_18x9|Prime3Lite|myT6 DTV|myXI1 (?:Plus|Pro)|myXI3|Q_Smart_BE","device":"smartphone","models":[{"regex":"MyPad[ _]([^;/]+) Build","model":"MyPad $1","device":"tablet"},{"regex":"MyTab[ _]([^;/]+) Build","model":"MyTab $1","device":"tablet"},{"regex":"myTab_10III","model":"MyTab 10 III","device":"tablet"},{"regex":"myTab10II","model":"MyTab 10 II","device":"tablet"},{"regex":"myT6 DTV","model":"myT6 DTV","device":"tablet"},{"regex":"Cube_LTE","model":"Cube LTE"},{"regex":"Prime_4_Lite","model":"Prime 4 Lite"},{"regex":"HAMMER[ _]ENERGY","model":"Hammer Energy"},{"regex":"HAMMER_AXE[_ ]M[_ ]LTE","model":"Hammer Axe M LTE"},{"regex":"Hammer Titan 2","model":"Hammer Titan 2"},{"regex":"Hammer[ _]Iron[ _](2|3)","model":"Hammer Iron $1"},{"regex":"Hammer[ _]Explorer","model":"Hammer Explorer"},{"regex":"Hammer Active(?:[);/ ]|$)","model":"Hammer Active"},{"regex":"Hammer_Active2(?:[);/ ]|$)","model":"Hammer Active 2"},{"regex":"Hammer_Active2_LTE(?:[);/ ]|$)","model":"Hammer Active 2 LTE"},{"regex":"Hammer AXE Pro","model":"Hammer Axe Pro"},{"regex":"Hammer_Blade2_PRO","model":"Hammer Blade 2 Pro"},{"regex":"C-Smart_pix","model":"C-Smart Pix"},{"regex":"Pocket_2(?:[);/ ]|$)","model":"Pocket 2"},{"regex":"myA17(?:[);/ ]|$)","model":"myA17"},{"regex":"(?:myPhone_)?Fun_(8|18x9)","model":"FUN $1"},{"regex":"MyPhoneMY27","model":"my27"},{"regex":"myX12(?:[);/ ]|$)","model":"myX12"},{"regex":"myXI1 Plus(?:[);/ ]|$)","model":"myXI1 Plus"},{"regex":"myXI1 Pro(?:[);/ ]|$)","model":"myXI1 Pro"},{"regex":"myXI3(?:[);/ ]|$)","model":"myXI3"},{"regex":"Q_Smart_BE(?:[);/ ]|$)","model":"Q-Smart BE"},{"regex":"Prime_18x9(_LTE)?(?:[);/ ]|$)","model":"Prime 18x9$1"},{"regex":"Prime3Lite(?:[);/ ]|$)","model":"Prime 3 Lite"},{"regex":"MyPhone[ _]([^;/)]+)( Build|\\\\))","model":"$1"}]},"MyWigo":{"regex":"MyWigo ","device":"smartphone","models":[{"regex":"City3","model":"City 3"}]},"Myros":{"regex":"(E70 Ultra)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Myria":{"regex":" (Myria_[^/;]+|502M|Cozy|Easy tab 9|Grand) Build|Myria_FIVE|Myria_Grand_4G|Myria_Wide_2|Myria_Wide_4G","device":"smartphone","models":[{"regex":"Myria_([^/;]+) Build","model":"$1"},{"regex":"Myria_FIVE","model":"Five"},{"regex":"(502M|Grand)","model":"$1"},{"regex":"Myria_Grand_4G","model":"Grand 4G"},{"regex":"Myria_Wide_4G","model":"Wide 4G"},{"regex":"Myria_Wide_2","model":"Wide 2"},{"regex":"(Cozy|Easy tab 9)","model":"$1","device":"tablet"}]},"M.T.T.":{"regex":"M.T.T.","device":"smartphone","models":[{"regex":"M.T.T. ?Tablet([^;/]+)? Build","device":"tablet","model":"Tablet$1"},{"regex":"M.T.T. ?([^;/]+) Build","model":"$1"}]},"Navon":{"regex":"Navon[_ ]|(?:Vision_Tab_(?:7|10)|Superme_Max|Predator (?:10|3G)|Platinum[_ ]10[_ ]3G(?:_V2)?|Supreme[_ ](?:Fine(?:[_ ]Micro)?|Chief|Pure|Pro)(?:[_ ](?:Mini|Plus))?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"M505 LTE(?:[);/ ]|$)","model":"Mizu M505 LTE"},{"regex":"(F552|D504)(?:[);/ ]|$)","model":"Mizu $1"},{"regex":"Superme_Max(?:[);/ ]|$)","model":"Supreme Max"},{"regex":"Supreme_Fine_Mini(?:[);/ ]|$)","model":"Supreme Fine Mini"},{"regex":"Supreme_Fine_Micro(?:[);/ ]|$)","model":"Supreme Fine Micro"},{"regex":"Supreme[_ ]Fine[_ ]Plus(?:[);/ ]|$)","model":"Supreme Fine Plus"},{"regex":"Supreme_Fine(?:[);/ ]|$)","model":"Supreme Fine"},{"regex":"Supreme[_ ]Chief(?:[);/ ]|$)","model":"Supreme Chief"},{"regex":"Supreme[_ ]Pure[ _]Plus(?:[);/ ]|$)","model":"Supreme Pure Plus"},{"regex":"Supreme Pure(?:[);/ ]|$)","model":"Supreme Pure"},{"regex":"Supreme[_ ]Pro(?:[);/ ]|$)","model":"Supreme Pro"},{"regex":"Navon[_ ]Infinity(?:[);/ ]|$)","model":"Infinity"},{"regex":"(?:Navon[_ ])?Platinum[ _]10[ _]3G(_V2)?(?:[);/ ]|$)","device":"tablet","model":"Platinum 10.1\\" 3G$1"},{"regex":"(?:Navon[_ ])?Orpheus[ _]3G(?:[);/ ]|$)","device":"tablet","model":"Orpheus 3G"},{"regex":"Predator (3G|10)(?:[);/ ]|$)","device":"tablet","model":"Predator $1"},{"regex":"Vision_Tab_(7|10)(?:[);/ ]|$)","device":"tablet","model":"Vision Tab $1"}]},"NOA":{"regex":"(?:NOA-)?NOA[ _]|Hummer(?:_2019_R|LE)|NextSE","device":"smartphone","models":[{"regex":"NOA[_ ]CORE[_ ]FORTE","model":"Core Forte"},{"regex":"HummerLE","model":"Hummer LE"},{"regex":"Hummer_2019_R","model":"Hummer R (2019)"},{"regex":"NOA[_ ]Hummer[_ ]Lite","model":"Hummer Lite"},{"regex":"NOA[_ ]MOVEse","model":"Move SE"},{"regex":"NextSE","model":"Next SE"},{"regex":"NOA[_ ]NEXT","model":"Next"},{"regex":"NOA[_ ]VISION[_ ]H3SE","model":"Vision H3SE"},{"regex":"NOA[_ ]VISION[_ ]H3","model":"Vision H3"},{"regex":"NOA[_ ]LOOP","model":"Loop"},{"regex":"(?:NOA-)?NOA[_ ]H4se","model":"H4SE"},{"regex":"NOA[_ ]Mg12","model":"MG12"},{"regex":"NOA[_ ]H44SE","model":"H44SE"},{"regex":"NOA[_ ]H10LE","model":"H10LE"},{"regex":"NOA[_ ]([^;)/ ]+)","model":"$1"}]},"Nobby":{"regex":"Nobby[ ](S500|X800|S300(?: Pro)?)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"NEC":{"regex":"NEC[ _\\\\-]|KGT/2\\\\.0|PC-TE508(?:S1|[BH]AW)|PC-TE510(?:HAW|BAL|S1)|PC-TS708T1W|PC-TS507N1S|PC-TE507JAW|portalmmm/1\\\\.0 (?:DB|N)|(?:portalmmm|o2imode)/2.0[ ,]N|(?:N-06C|N-02E|LAVIE Tab E (?:10|8)FHD1)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"N-06C(?:[);/ ]|$)","model":"Medias Amadana"},{"regex":"N-02E(?:[);/ ]|$)","model":"Medias U"},{"regex":"(?:NEC[ _\\\\-]|KGT/2\\\\.0 )([a-z0-9]+)","model":"$1"},{"regex":"portalmmm/1\\\\.0 ((?:DB|N)[a-z0-9]+)","model":"$1"},{"regex":"(?:portalmmm|o2imode)/2\\\\.0[ ,](N[a-z0-9]+)","model":"$1"},{"regex":"PC-TE508[BH]AW(?:[);/ ]|$)","device":"tablet","model":"LAVIE Tab E TE508"},{"regex":"PC-TE510(?:BAL|HAW|S1)(?:[);/ ]|$)","device":"tablet","model":"LAVIE Tab E TE510"},{"regex":"PC-TS507N1S(?:[);/ ]|$)","device":"tablet","model":"LAVIE Tab S TS507"},{"regex":"PC-TS708T1W(?:[);/ ]|$)","device":"tablet","model":"LAVIE Tab S TS708"},{"regex":"PC-TE507JAW(?:[);/ ]|$)","device":"tablet","model":"LAVIE Tab E TS507"},{"regex":"PC-TE508S1(?:[);/ ]|$)","device":"tablet","model":"LAVIE Tab E TE508"},{"regex":"(LAVIE Tab E (?:10|8)FHD1)(?:[);/ ]|$)","device":"tablet","model":"$1"}]},"Neffos":{"regex":"Neffos|(TP601A)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"TP601A(?:[);/ ]|$)","model":"C5L"},{"regex":"Neffos[_ ]Y50","model":"Y50"},{"regex":"Neffos X20 Pro","model":"X20 Pro"},{"regex":"Neffos[_ ]((?:[YNCXA])[0-9][A-Z]?(?: Max| Lite)?)","model":"$1"}]},"Nextbit":{"regex":"Nextbit|(?:Robin)(?: Build|\\\\))","device":"smartphone","models":[{"regex":"(Robin)(?:[);/ ]|$)","model":"$1"}]},"Newgen":{"regex":"NEWGEN\\\\-([a-z0-9]+)","device":"feature phone","model":"$1"},"Netgear":{"regex":"GTV100","device":"tv","models":[{"regex":"GTV100","model":"NeoTV Prime"}]},"NeuImage":{"regex":"NIM-","device":"smartphone","models":[{"regex":"NIM-(450D|550O|600Q)","model":"$1"}]},"NextBook":{"regex":"Next[0-9]|NX(?:785QC8G|M900MC|008HD8G|010HI8G|M908HC|M726|16A8116K|A8QC116|16A10132S|16A11264)","device":"tablet","models":[{"regex":"NX008HD8G","model":"Premium 8 HD"},{"regex":"NXA8QC116","model":"Ares 8"},{"regex":"NX16A8116K","model":"Ares A8"},{"regex":"NX16A10132S","model":"Ares A10"},{"regex":"NX16A11264","model":"Ares A11"},{"regex":"NXM908HC","model":"Premium 9"},{"regex":"NX010HI8G","model":"Premium 10 Hi"},{"regex":"NX785QC8G","model":"8"},{"regex":"NXM900MC","model":"8 HD"},{"regex":"NXM726","model":"Premium 7"},{"regex":"Next([0-9]+[^;/]+) Build","model":"Next $1"}]},"NGM":{"regex":"NGM[_ ][a-z0-9]+|(Forward|Dynamic)[ _]?[^/;]+(?:Build|/)","device":"smartphone","models":[{"regex":"(Forward|Dynamic)[ _]?([^/;]+) Build","model":"$1 $2"},{"regex":"(Forward|Dynamic)[ _]?([^/;]+)/","model":"$1 $2"},{"regex":"NGM ([^;/]+) Build","model":"$1"},{"regex":"NGM_([a-z0-9]+)","model":"$1"}]},"Nexian":{"regex":"S?Nexian","device":"smartphone","models":[{"regex":"S?Nexian[ ]?([a-z0-9\\\\-]+)","model":"$1"},{"regex":"S?Nexian-([a-z0-9]+)","model":"$1"}]},"Noain":{"regex":"NOAIN","device":"smartphone","models":[{"regex":"NOAIN[ _-]([^;/]+) Build","model":"$1"},{"regex":"NOAIN[ _-]([^;/)]+)(?:[;/)]|$)","model":"$1"}]},"Noblex":{"regex":"Noblex|NBX-","device":"smartphone","models":[{"regex":"(?:Noblex|NBX)[ _-]([^;/]+) Build","model":"$1"},{"regex":"(?:Noblex|NBX)[ _-]([^;/)]+)(?:[;/)]|$)","model":"$1"}]},"Nomu":{"regex":"Nomu[ _-](?:T18|S30mini|S10)(?:[);/ ]|$)|V1600S(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Nomu[ _-]T18(?:[);/ ]|$)","model":"T18"},{"regex":"Nomu[ _-]s10(?:[);/ ]|$)","model":"S10"},{"regex":"Nomu[ _-]S30mini(?:[);/ ]|$)","model":"S30 Mini"},{"regex":"(V1600S)(?:[);/ ]|$)","model":"$1"}]},"Nomi":{"regex":"Nomi[ _-]|(C101010 Ultra2|i501[234]|i5032|i50[57]0|i5510|i5532|C0(700(?:[02358]|2HD)|7850)|C1010[0-3])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"i501[23](?:[);/ ]|$)","model":"Evo M2"},{"regex":"I5070(?:[);/ ]|$)","model":"Iron-X"},{"regex":"i5014(?:[);/ ]|$)","model":"Evo M4"},{"regex":"i5032(?:[);/ ]|$)","model":"Evo X2"},{"regex":"i5050(?:[);/ ]|$)","model":"Evo Z"},{"regex":"Nomi_i4510(?:[);/ ]|$)","model":"Beat M"},{"regex":"i5532(?:[);/ ]|$)","model":"Space X2"},{"regex":"i5510(?:[);/ ]|$)","model":"Space M"},{"regex":"C101010 Ultra2","model":"Ultra 2","device":"tablet"},{"regex":"(C0(?:700(?:[02358]|2HD)|7850)|C1010[0-3])(?:[);/ ]|$)","model":"$1","device":"tablet"},{"regex":"Nomi[ _-]([^;/]+) Build","model":"$1"},{"regex":"Nomi[ _-]([^;/)]+)(?:[;/)]|$)","model":"$1"}]},"NUU Mobile":{"regex":"NUU_|(?:(?:N(5702|5001)L|S6001L)|A6L-[CG])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"NUU_A([13])","model":"A$1"},{"regex":"NUU_M([32])(?:[);/ ]|$)","model":"M$1"},{"regex":"NUU_X5(?:[);/ ]|$)","model":"X5"},{"regex":"S6001L","model":"G2"},{"regex":"N5702L","model":"G3"},{"regex":"(N5001L|A6L-[CG])(?:[);/ ]|$)","model":"$1"}]},"NYX Mobile":{"regex":"NYX[ _]","device":"smartphone","models":[{"regex":"NYX_A1","model":"A1"},{"regex":"NYX_Blink","model":"Blink"},{"regex":"NYX_EGO","model":"Ego"},{"regex":"NYX_FENIX","model":"Fenix"},{"regex":"NYX_FLY_II","model":"Fly II"},{"regex":"NYX_FLY_MINI","model":"Fly Mini"},{"regex":"NYX_FLY","model":"Fly"},{"regex":"NYX_HIT","model":"Hit"},{"regex":"NYX_JAK","model":"Jak"},{"regex":"NYX_JOIN","model":"Join"},{"regex":"NYX_NOBA_II","model":"Noba II"},{"regex":"NYX_NOBA","model":"Noba"},{"regex":"NYX_ORBIS","model":"Orbis"},{"regex":"NYX[ _]REX","model":"Rex"},{"regex":"NYX_SHADE","model":"Shade"},{"regex":"NYX_SKY","model":"Sky"},{"regex":"NYX_SPARK","model":"Spark"},{"regex":"NYX_VOX","model":"Vox"},{"regex":"NYX_ZEUZ_HD","model":"Zeus HD"}]},"Nous":{"regex":"(?:NS(?:[356]|500[2-68]|5511|5502)|NS 5511)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"NS 5511(?:[);/ ]|$)","model":"NS5511"},{"regex":"(NS[0-9]{1,4})(?:[);/ ]|$)","model":"$1"}]},"Nvidia":{"regex":"NVIDIA|SHIELD Tablet K1|SHIELD Android TV|Tegra(Note-P1640| Note 7)","device":"tablet","models":[{"regex":"TegraNote-P1640","model":"Tegra Note P1640"},{"regex":"(SHIELD Tablet K1|Tegra Note 7)(?: Build|[;)])","model":"$1"},{"regex":"SHIELD Android TV","model":"SHIELD Android TV","device":"tv"},{"regex":"NVIDIA_SHIELD_PRO_2019","model":"SHIELD TV Pro","device":"tv"},{"regex":"NVIDIA Shield","model":"SHIELD TV","device":"tv"}]},"O+":{"regex":"O\\\\+[ _](Air|Crunch|Ultra|Upsized|Venti|360 ALPHA PLUS 2.0)","device":"smartphone","models":[{"regex":"O\\\\+[ _](Crunch|Ultra 2.0|Ultra|Upsized|Venti 4G)","model":"$1"},{"regex":"O\\\\+_AIR","model":"Air"},{"regex":"O\\\\+ 360 ALPHA PLUS 2.0","model":"360 Alpha Plus 2.0"}]},"O2":{"regex":"Xda|(?<!FBCR/)O2[ \\\\-]|COCOON","device":"smartphone","models":[{"regex":"(Xda[ _][a-z0-9_]+)","model":"$1"},{"regex":"(COCOON)","model":"$1"},{"regex":"O2 ([a-z0-9 ]+)","model":"$1"},{"regex":"O2-([a-z0-9]+)","model":"$1"}]},"Odys":{"regex":"ODYS[ _-]|IEOS[_ ]([^/;]+)|NOON(?:_PRO)? Build|SPACE10_(?:PLUS|PRO)_3G|THOR_?10|TAO_X10|RAPID_?(?:10|7)_?LTE|MAVEN_?10_|CONNECT[78]|ELEMENT10_PLUS_3G|XELIO[_0-9P]|ADM816HC|ADM8000KP|NEO6_LTE|EOS10|AEON|FALCON_10_PLUS_3G|FUSION|THANOS_10|MAVEN_X10_HD(?:_LTE)?|JUNIOR_8_PRO|JuniorT8Pro|(?:NOVA|PYRO)_X?7_PLUS_3G|UNO_X8|SLADE_X55|XELIO_PRO_10_LTE|NOTOSplus3G","device":"tablet","models":[{"regex":"XELIO[_ ]A10","model":"Xelio A10"},{"regex":"XELIOPHONETAB3","model":"Xelio Phonetab 3"},{"regex":"THANOS_10","model":"Thanos 10"},{"regex":"XELIO_NEXT_10_PLUS_3G","model":"Xelio Next 10 Plus 3G"},{"regex":"XELIO_PHONE_TAB7_3G","model":"Xelio Phonetab 7 3G"},{"regex":"XELIO10EXTREME","model":"Xelio 10 Xtreme"},{"regex":"XELIO10_PLUS_3G","model":"Xelio 10 Plus 3G"},{"regex":"XELIO10_HD_PLUS_3G","model":"Xelio 10 HD Plus 3G"},{"regex":"XELIO_10_HD","model":"Xelio 10 HD"},{"regex":"XELIO_PRO_10_LTE","model":"Xelio Pro 10 LTE"},{"regex":"ELEMENT10_PLUS_3G","model":"Element 10 Plus 3G"},{"regex":"CONNECT8PLUS","model":"Connect 8 Plus"},{"regex":"CONNECT7PRO","model":"Connect 7 Pro"},{"regex":"MAVEN_X10_HD_LTE","model":"Maven X10 HD LTE"},{"regex":"MAVEN_X10_HD","model":"Maven X10 HD"},{"regex":"MAVEN_?10_PRO_PLUS_3G","model":"Maven 10 Pro Plus 3G"},{"regex":"MAVEN_?10_?PLUS","model":"Maven 10 Plus"},{"regex":"MAVEN_?10_?PRO","model":"Maven 10 Pro"},{"regex":"MAVEN_?10_?HD","model":"Maven 10 HD"},{"regex":"RAPID_?7_?LTE","model":"Rapid 7 LTE"},{"regex":"RAPID_?10_?LTE","model":"Rapid 10 LTE"},{"regex":"TAO_X10","model":"Tao X10"},{"regex":"SPACE10_PLUS_3G","model":"Space 10 Plus 3G"},{"regex":"SPACE10_PRO_3G","model":"Space 10 Pro 3G"},{"regex":"THOR_?10 Build","model":"Thor 10"},{"regex":"JuniorT8Pro","model":"Junior T8 Pro"},{"regex":"JUNIOR_8_PRO","model":"Junior 8 Pro"},{"regex":"ADM816HC","model":"Neo X"},{"regex":"EOS10","model":"EOS 10"},{"regex":"AEON","model":"Aeon"},{"regex":"FALCON_10_PLUS_3G","model":"Falcon 10 Plus 3G"},{"regex":"FUSION","model":"Fusion 7"},{"regex":"UNO_X8","model":"Uno X8"},{"regex":"ADM8000KP","model":"Titan"},{"regex":"PYRO_7_PLUS_3G","model":"Pyro 7 Plus 3G"},{"regex":"NOVA_X7_PLUS_3G","model":"Nova X7 Plus 3G"},{"regex":"ODYS_NOVA_X7","model":"Nova X7"},{"regex":"THOR_?10_PLUS_3G","model":"Thor 10 Plus 3G"},{"regex":"NOTOSplus3G","model":"Notos Plus 3G"},{"regex":"NEO6[_ ]LTE","model":"Neo 6 LTE","device":"smartphone"},{"regex":"SLADE_X55","model":"Slade X55","device":"smartphone"},{"regex":"IEOS[ _]([^/;]+) Build","model":"Ieos $1"},{"regex":"(?:ODYS[ _-])?NOON Build","model":"Noon"},{"regex":"(?:ODYS[ _-])?NOON_PRO Build","model":"Noon Pro"},{"regex":"Odys[ _-]([^/;]+) Build","model":"$1"}]},"Obi":{"regex":"Obi[ _-]|(SJ1\\\\.5|SJ2\\\\.6|S400|S452\\\\+|S451|S453|S501|S502|S503\\\\+?|S507|S520|S550|S551|falcon)[ _]","device":"smartphone","models":[{"regex":"SJ2\\\\.6","model":"SJ2.6"},{"regex":"SJ1\\\\.5","model":"SJ1.5"},{"regex":"(?:Obi_)?S400","model":"Skipper"},{"regex":"(?:Obi_)?S451|falcon","model":"Flacon"},{"regex":"(?:Obi_)?S452\\\\+","model":"Python"},{"regex":"(?:Obi_)?S453","model":"Fox"},{"regex":"(?:Obi_)?S501","model":"Wolverine"},{"regex":"(?:Obi_)?S502","model":"Leopard"},{"regex":"(?:Obi_)?S503\\\\+","model":"Boa Plus"},{"regex":"(?:Obi_)?S503","model":"Boa"},{"regex":"(?:Obi_)?S507","model":"Pelican"},{"regex":"(?:Obi_)?S520","model":"Octopus"},{"regex":"(?:Obi_)?S550","model":"Crane"},{"regex":"(?:Obi_)?S551","model":"Hornbill"},{"regex":"(?:Obi_)?S454","model":"Alligator"},{"regex":"Obi[ _-]([^;/]+) Build","model":"$1"},{"regex":"Obi[ _-]([^;/)]+)(?:[;/)]|$)","model":"$1"}]},"Okapia":{"regex":"Signature (?:L|Pro|Touch)","device":"smartphone","models":[{"regex":"Signature (L|Pro|Touch)","model":"Signature $1"}]},"Onda":{"regex":"Onda|(?:(?:V820w|V891[w]?|V919(?: 3G)? Air)[ _-]DualOS|(?:V919 4G Air|V989 Air|V972) Core[48]|T2101L2B1C| V10 4G|OBOOK (?:20 SE|20 PLUS DUALOS)|OBOOK10 SE|V919 Air CH DualOS)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ONDA[ _]MID","model":"MID","device":"tablet"},{"regex":"V820w[ _-]DualOS","model":"V820W Dual OS","device":"tablet"},{"regex":"V891W[ _-]DualOS","model":"V891W Dual OS","device":"tablet"},{"regex":"V891[ _-]DualOS","model":"V891 Dual OS","device":"tablet"},{"regex":"V919 3G Air[ _-]DualOS","model":"V919 3G Air Dual OS","device":"tablet"},{"regex":"V919 Air[ _-]DualOS","model":"V919 Air Dual OS","device":"tablet"},{"regex":"V919 Air CH DualOS","model":"V919 Air CH Dual OS","device":"tablet"},{"regex":"V919 4G Air Core8","model":"V919 4G Air Core 8","device":"tablet"},{"regex":"V972 Core4","model":"V919 Core 4","device":"tablet"},{"regex":"V989 Air Core8","model":"V989 Air Core 8","device":"tablet"},{"regex":"T2101L2B1C|OBOOK 20 PLUS DUALOS","model":"oBook 20 Plus Dual OS","device":"tablet"},{"regex":" V10 4G(?:[);/ ]|$)","model":"V10 10.1\\" 4G","device":"tablet"},{"regex":"OBOOK 20 SE(?:[);/ ]|$)","model":"oBook 20 SE","device":"tablet"},{"regex":"OBOOK10 SE(?:[);/ ]|$)","model":"oBook 10 SE","device":"tablet"},{"regex":"([a-z0-9]+)[ _]Onda","model":"$1"},{"regex":"Onda ([a-z0-9]+)","model":"$1"}]},"OnePlus":{"regex":"(?:du_)?ONEPLUS|(?:A0001|A200[135]|AC200[13]|A300[03]|A3010|A5000|A600[03]|A601[03]|BE201[1235]|BE2025|BE202[89]|E100[135]|GM191[03517]|GM190[0135]|GM192[05]|HD191[013]|HD190[01357]|HD1925|IN201[013579]|IN202[0135]|KB200[01357]|LE2117|LE212[03])(?: Build|\\\\))","device":"smartphone","models":[{"regex":"AC200[13](?:[);/ ]|$)","model":"Nord 5G"},{"regex":"BE2012(?:[);/ ]|$)","model":"Clover"},{"regex":"BE201[135](?:[);/ ]|$)","model":"Nord N100"},{"regex":"BE2025(?:[);/ ]|$)","model":"Nord N10"},{"regex":"BE2029(?:[);/ ]|$)","model":"Nord N10 5G"},{"regex":"BE2028(?:[);/ ]|$)","model":"Nord N10 Lite"},{"regex":"IN202[0135](?:[);/ ]|$)","model":"8 Pro"},{"regex":"KB2000(?:[);/ ]|$)","model":"8T"},{"regex":"IN201[01357](?:[);/ ]|$)","model":"8"},{"regex":"IN2019(?:[);/ ]|$)","model":"8 5G UW"},{"regex":"LE2117(?:[);/ ]|$)","model":"9"},{"regex":"LE212[03](?:[);/ ]|$)","model":"9 Pro"},{"regex":"(?:GM191[01357]|OnePlus 7 Pro)(?:[);/ ]|$)","model":"7 Pro"},{"regex":"GM190[0135](?:[);/ ]|$)","model":"7"},{"regex":"HD190[01357](?:[);/ ]|$)","model":"7T"},{"regex":"(?:HD191[013]|OnePlus 7T Pro)(?:[);/ ]|$)","model":"7T Pro"},{"regex":"(?:HD1925|GM192[05])(?:[);/ ]|$)","model":"7T Pro 5G"},{"regex":"KB200[1357](?:[);/ ]|$)","model":"8T"},{"regex":"A0001(?:[);/ ]|$)","model":"One"},{"regex":"A200[135]|OnePlus2","model":"2"},{"regex":"E100[135](?:[);/ ]|$)","model":"X"},{"regex":"A3010|OnePlus3T","model":"3T"},{"regex":"A300[03]|OnePlus3","model":"3"},{"regex":"A5010|OnePlus[ ]?5T","model":"5T"},{"regex":"A5000|OnePlus5","model":"5"},{"regex":"A600[03]|OnePlus6","model":"6"},{"regex":"A601[03](?:[);/ ]|$)","model":"6T"},{"regex":"(?:du_)?ONEPLUS ?([^;/]+) Build","model":"$1"}]},"Realme":{"regex":"Realme[ _]|(?:RMX(?:19(03|4[1235]|19|9[23]|2[157]|[01379]1|73)|20(?:[025-7]1|[037]2|2[57]|63|7[56]|8[156]|[2-5]0)|21(?:0[13]|17|[12]1|4[24]|5[15]|6[13]|7[60]|8[059]|9[35])|2200|18(0[1579]|11|3[13]|2[157]|[45]1|45)|3201|30[38]1|3063)|(?:OPPO[ _]?)?CPH1861)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:OPPO[ _]?)?CPH1861(?:[);/ ]|$)","model":"1"},{"regex":"RMX180[59]","model":"2"},{"regex":"RMX180[17]","model":"2 Pro"},{"regex":"RMX(1833|182[15])","model":"3"},{"regex":"RMX1827","model":"3i"},{"regex":"RMX1851","model":"3 Pro"},{"regex":"RMX190[13]|Realme X(?:[);/ ]|$)","model":"X"},{"regex":"RMX199[12]","model":"X2"},{"regex":"RMX1993","model":"X2 Dual"},{"regex":"RMX1931|Realme X2 Pro(?:[);/ ]|$)","model":"X2 Pro"},{"regex":"RMX2117","model":"Q2 5G"},{"regex":"RMX2176(?:[);/ ]|$)","model":"X7 5G"},{"regex":"RMX2121(?:[);/ ]|$)","model":"X7 Pro 5G"},{"regex":"RMX1921|Realme XT(?:[);/ ]|$)","model":"XT"},{"regex":"RMX19(1[19]|27)","model":"5"},{"regex":"RMX197[13]","model":"5 Pro"},{"regex":"RMX203[02]","model":"5i"},{"regex":"RMX2001","model":"6"},{"regex":"RMX2040","model":"6I"},{"regex":"RMX2002","model":"6S"},{"regex":"RMX206[13](?:[);/ ]|$)","model":"6 Pro"},{"regex":"RMX215[15]","model":"7"},{"regex":"RMX2103","model":"7I"},{"regex":"RMX2170","model":"7 Pro"},{"regex":"RMX3081","model":"8 Pro"},{"regex":"RMX1925(?:[);/ ]|$)","model":"5S"},{"regex":"RMX1811(?:[);/ ]|$)","model":"C1"},{"regex":"RMX194[1235](?:[);/ ]|$)","model":"C2"},{"regex":"RMX202[107](?:[);/ ]|$)","model":"C3"},{"regex":"RMX2185(?:[);/ ]|$)","model":"C11"},{"regex":"RMX2189(?:[);/ ]|$)","model":"C12"},{"regex":"RMX2180(?:[);/ ]|$)","model":"C15"},{"regex":"RMX2195(?:[);/ ]|$)","model":"C15 Qualcomm Edition"},{"regex":"RMX2101(?:[);/ ]|$)","model":"C17"},{"regex":"RMX3063(?:[);/ ]|$)","model":"C20"},{"regex":"RMX3031(?:[);/ ]|$)","model":"GT Neo"},{"regex":"RMX216[13](?:[);/ ]|$)","model":"Narzo 20 Pro"},{"regex":"RMX2193(?:[);/ ]|$)","model":"Narzo 20"},{"regex":"RMX2050(?:[);/ ]|$)","model":"Narzo 20A"},{"regex":"RMX1831(?:[);/ ]|$)","model":"U1"},{"regex":"RMX(?:20(?:51|[2]5)|2144)(?:[);/ ]|$)","model":"X50 5G"},{"regex":"RMX2071(?:[);/ ]|$)","model":"X50 Pro"},{"regex":"RMX207[56](?:[);/ ]|$)","model":"X50 Pro 5G"},{"regex":"RMX2072(?:[);/ ]|$)","model":"X50 Pro Player"},{"regex":"RMX(2142|2081)(?:[);/ ]|$)","model":"X3"},{"regex":"RMX208[56](?:[);/ ]|$)","model":"X3 Super Zoom"},{"regex":"RMX2111","model":"V5 5G"},{"regex":"RMX2200","model":"V3 5G"},{"regex":"RMX3201","model":"C21"},{"regex":"Realme[ _]([1-9])[ _]Pro(?:[);/ ]|$)","model":"$1 Pro"}]},"OPPO":{"regex":"(?:OB-)?OPPO[ _]?([a-z0-9]+)|N1T|R8001|OPG01|A00[12]OP|(?:X90[07][0679]|U70[57]T?|X909T?|R(?:10[01]1|2001|201[07]|6007|7005|7007|80[13579]|81[13579]|82[01379]|83[013]|800[067]|8015|810[679]|811[13]|820[057])[KLSTW]?|N520[79]|N5117|A33f|A33fw|A37fw?|PAAM00|PAAT00|PAC[TM]00)(?:[);/ ]|$)|R7kf|R7plusf|R7Plusm|A1601|CPH[0-9]{4}|CPH19(69|79|23|1[179])|PB(A[TM]00|CT10|BT30|CM[13]0|[FD]M00)|P(DAM10|ADM00|AF[TM]00|ADT00|AHM00|BBM[03]0|BBT00|BDT00|BFT00|[CB]E[MT]00|CA[MT]00|C[CDG]M00|CA[MT]10|[CD]PM00|CRM00|CDT00|CD[TM]10|CHM[013]0|CKM[08]0|CLM[15]0|DEM[13]0|DHM00|DK[TM]00|DPT00|DB[TM]00|DCM00|[CD]NM00|DVM00|DY[TM]20|DNT00|EA[TM]00)|PDSM00","device":"smartphone","models":[{"regex":"PCHM10(?:[);/ ]|$)","model":"A11"},{"regex":"(?:CPH2083|CPH2077)(?:[);/ ]|$)","model":"A12"},{"regex":"PCHM00(?:[);/ ]|$)","model":"A11x"},{"regex":"CPH1923(?:[);/ ]|$)","model":"A1K"},{"regex":"(?:OPPO[ _]?)?(CPH1837|PAD[TM]00)(?:[);/ ]|$)","model":"A3"},{"regex":"(?:OPPO[ _]?)?A37f(w)(?:[);/ ]|$)","model":"A37f$1"},{"regex":"A37f(?:[);/ ]|$)","model":"A37f"},{"regex":"(?:OPPO[ _]?)?CPH1605(?:[);/ ]|$)","model":"A39"},{"regex":"CPH20(?:81|73|31|15)(?:[);/ ]|$)","model":"A31"},{"regex":"(?:OPPO[ _]?)?(?:CPH18(?:0[35]|53)|PBBM30)(?:[);/ ]|$)","model":"A3s"},{"regex":"(?:OPPO[ _]?)?(?:CPH1809|PBA[TM]00|PBBT30)(?:[);/ ]|$)","model":"A5"},{"regex":"CPH19(?:3[13]|43)(?:[);/ ]|$)","model":"A5 (2020)"},{"regex":"PDVM00(?:[);/ ]|$)","model":"A32"},{"regex":"(?:PDAM10|CPH2069|CPH2061)(?:[);/ ]|$)","model":"A52"},{"regex":"CPH2127(?:[);/ ]|$)","model":"A53"},{"regex":"(?:OPPO[ _]?)?CPH170[15](?:[);/ ]|$)","model":"A57"},{"regex":"CPH19(?:09|1[02])(?:[);/ ]|$)","model":"A5S"},{"regex":"(?:OPPO[ _]?)?(?:CPH190[15]|PBF[TM]00)(?:[);/ ]|$)","model":"A7"},{"regex":"(?:OPPO[ _]?)?(CPH1801|CPH1717)(?:[);/ ]|$)","model":"A71"},{"regex":"(?:OPPO[ _]?)?(?:PDY[TM]20|CPH2067)(?:[);/ ]|$)","model":"A72"},{"regex":"(?:OPPO[ _]?)?CPH1715(?:[);/ ]|$)","model":"A77"},{"regex":"PCD[TM]00(?:[);/ ]|$)","model":"A7n"},{"regex":"(PBBT00|PBBM00)(?:[);/ ]|$)","model":"A7x"},{"regex":"(?:OPPO[ _]?)?(?:PDBM00)(?:[);/ ]|$)","model":"A8"},{"regex":"(?:OPPO[ _]?)?CPH1729(?:[);/ ]|$)","model":"A83"},{"regex":"(?:OPPO[ _]?)?CPH1827(?:[);/ ]|$)","model":"A83 (2018)"},{"regex":"PCA[TM]10(?:[);/ ]|$)","model":"A9"},{"regex":"(CPH1937|CPH1941|PCHM30)(?:[);/ ]|$)","model":"A9 (2020)"},{"regex":"(?:OPPO[ _]?)?CPH1938(?:[);/ ]|$)","model":"A9 (EN)"},{"regex":"(?:PCPM00|CPH20[02]1)(?:[);/ ]|$)","model":"A91"},{"regex":"CPH2059(?:[);/ ]|$)","model":"A92"},{"regex":"PDKT00(?:[);/ ]|$)","model":"A92s"},{"regex":"PDKM00(?:[);/ ]|$)","model":"A93s"},{"regex":"PCE[TM]00(?:[);/ ]|$)","model":"A9x"},{"regex":"(?:OPPO[ _]?)?CPH1851(?:[);/ ]|$)","model":"AX5"},{"regex":"CPH1920(?:[);/ ]|$)","model":"AX5s"},{"regex":"(?:OPPO[ _]?)?CPH1903(?:[);/ ]|$)","model":"AX7"},{"regex":"(?:OPPO[ _]?)?X9009(?:[);/ ]|$)","model":"F1 Plus"},{"regex":"CPH191[135](?:[);/ ]|$)","model":"F11"},{"regex":"CPH19(?:69|87)(?:[);/ ]|$)","model":"F11 Pro"},{"regex":"(?:OPPO[ _]?)?(?:CPH2119)(?:[);/ ]|$)","model":"F17 Pro"},{"regex":"(?:OPPO[ _]?)?A1601(?:[);/ ]|$)","model":"F1s"},{"regex":"(?:OPPO[ _]?)?CPH1609(?:[);/ ]|$)","model":"F3"},{"regex":"(?:OPPO[ _]?)?CPH1613(?:[);/ ]|$)","model":"F3 Plus"},{"regex":"(?:OPPO[ _]?)?CPH172[37](?:[);/ ]|$)","model":"F5"},{"regex":"(?:OPPO[ _]?)?CPH1725(?:[);/ ]|$)","model":"F5 Youth"},{"regex":"(?:OPPO[ _]?)?CPH(1859|18(?:19|21))(?:[);/ ]|$)","model":"F7"},{"regex":"(?:OPPO[ _]?)?(?:CPH1825|CPH1881)(?:[);/ ]|$)","model":"F9"},{"regex":"(?:OPPO[ _]?)?CPH1823(?:[);/ ]|$)","model":"F9 Pro"},{"regex":"(?:OPPO[ _]?)?X909T?(?:[);/ ]|$)","model":"Find 5"},{"regex":"(?:OPPO[ _]?)?R827T?(?:[);/ ]|$)","model":"Find 5 Mini"},{"regex":"(?:OPPO[ _]?)?X907[067](?:[);/ ]|$)","model":"Find 7"},{"regex":"(?:OPPO[ _]?)?X900[067](?:[);/ ]|$)","model":"Find 7a"},{"regex":"(?:OPPO[ _]?)?R815[TW]?(?:[);/ ]|$)","model":"Find Clover"},{"regex":"(?:OPPO[ _]?)?R8015(?:[);/ ]|$)","model":"Find Guitar"},{"regex":"(?:OPPO[ _]?)?R8111(?:[);/ ]|$)","model":"Find Melody"},{"regex":"(?:OPPO[ _]?)?R821T?(?:[);/ ]|$)","model":"Find Muse"},{"regex":"(?:OPPO[ _]?)?U707T?(?:[);/ ]|$)","model":"Find Way S"},{"regex":"(?:OPPO[ _]?)?U705T(?:[);/ ]|$)","model":"Ulike 2"},{"regex":"(?:OPPO[ _]?)?(?:CPH187[15]|PAF[MT]00)(?:[);/ ]|$)","model":"Find X"},{"regex":"(?:OPPO[ _]?)?(?:PAHM00)(?:[);/ ]|$)","model":"Find X Lamborghini"},{"regex":"(?:OPPO[ _]?)?(?:PDEM10|CPH2023)(?:[);/ ]|$)","model":"Find X2"},{"regex":"(?:OPPO[ _]?)?CPH2005(?:[);/ ]|$)","model":"Find X2 Lite"},{"regex":"(?:OPPO[ _]?)?(?:PDEM30|OPG01|CPH2025)(?:[);/ ]|$)","model":"Find X2 Pro"},{"regex":"(?:OPPO[ _]?)?R1011 Build","model":"Joy Plus"},{"regex":"(?:OPPO[ _]?)?(PBC(?:M30|T10))(?:[);/ ]|$)","model":"K1"},{"regex":"CPH1955(?:[);/ ]|$)","model":"K3"},{"regex":"(?:OPPO[ _]?)?(PCNM00)(?:[);/ ]|$)","model":"K5"},{"regex":"(?:OPPO[ _]?)?(PCLM50)(?:[);/ ]|$)","model":"K7"},{"regex":"(?:OPPO[ _]?)?N5117(?:[);/ ]|$)","model":"N1 Mini"},{"regex":"(?:OPPO[ _]?)?N520[79](?:[);/ ]|$)","model":"N3"},{"regex":"(?:OPPO[ _]?)?R831T?(?:[);/ ]|$)","model":"Neo"},{"regex":"(?:OPPO[ _]?)?R831K(?:[);/ ]|$)","model":"Neo 3"},{"regex":"(?:OPPO[ _]?)?R831[SL](?:[);/ ]|$)","model":"Neo 5"},{"regex":"(?:OPPO[ _]?)?A33f(?:[);/ ]|$)","model":"Neo 7"},{"regex":"(?:OPPO[ _]?)?A33fw(?:[);/ ]|$)","model":"Neo 7s"},{"regex":"(?:OPPO[ _]?)?R8113(?:[);/ ]|$)","model":"Piano"},{"regex":"(?:OPPO[ _]?)?CPH1707(?:[);/ ]|$)","model":"R11"},{"regex":"R8001(?:[);/ ]|$)","model":"R1K"},{"regex":"(?:OPPO[ _]?)?CPH1719(?:[);/ ]|$)","model":"R11s"},{"regex":"(?:OPPO[ _]?)?CPH1721(?:[);/ ]|$)","model":"R11s Plus"},{"regex":"(?:OPPO[ _]?)?(?:CPH1835|PAC[TM]00|PAAM00)(?:[);/ ]|$)","model":"R15"},{"regex":"(?:OPPO[ _]?)?(?:CPH183[13]|PAAT00)(?:[);/ ]|$)","model":"R15 Pro"},{"regex":"PBCM10(?:[);/ ]|$)","model":"R15x"},{"regex":"(?:OPPO[ _]?)?(?:CPH1879|PBE[MT]00)(?:[);/ ]|$)","model":"R17"},{"regex":"(?:OPPO[ _]?)?(?:CPH1893)(?:[);/ ]|$)","model":"R17 Neo"},{"regex":"(?:OPPO[ _]?)?(?:CPH1877|PBD[MT]00)(?:[);/ ]|$)","model":"R17 Pro"},{"regex":"(?:OPPO[ _]?)?R8006(?:[);/ ]|$)","model":"R1L"},{"regex":"(?:OPPO[ _]?)?R800[07](?:[);/ ]|$)","model":"R1S"},{"regex":"(?:OPPO[ _]?)?R810[679](?:[);/ ]|$)","model":"R5"},{"regex":"(?:OPPO[ _]?)?R7kf(?:[);/ ]|$)","model":"R7 Lite"},{"regex":"(?:OPPO[ _]?)?R7Plusm(?:[);/ ]|$)","model":"R7 Plus"},{"regex":"(?:OPPO[ _]?)?R7Plusf(?:[);/ ]|$)","model":"R7 Plus F"},{"regex":"(?:OPPO[ _]?)?X9079(?:[);/ ]|$)","model":"R9 Plus"},{"regex":"(?:OPPO[ _]?)?CPH1607(?:[);/ ]|$)","model":"R9s"},{"regex":"(?:OPPO[ _]?)?(?:CPH1611|R9s Plus)(?:[);/ ]|$)","model":"R9s Plus"},{"regex":"(?:CPH1917|PCA[MT]00)(?:[);/ ]|$)","model":"Reno"},{"regex":"CPH1983(?:[);/ ]|$)","model":"Reno A"},{"regex":"PCCM00(?:[);/ ]|$)","model":"Reno 10X"},{"regex":"CPH1919(?:[);/ ]|$)","model":"Reno 10X Zoom"},{"regex":"(?:PCKM00|CPH1907)(?:[);/ ]|$)","model":"Reno 2"},{"regex":"CPH1989(?:[);/ ]|$)","model":"Reno 2F"},{"regex":"(?:PCKM80|CPH1945|CPH1951)(?:[);/ ]|$)","model":"Reno 2Z"},{"regex":"CPH2043(?:[);/ ]|$)","model":"Reno 3"},{"regex":"(?:CPH2013|A002OP)(?:[);/ ]|$)","model":"Reno 3A"},{"regex":"(?:PDCM00|A001OP)(?:[);/ ]|$)","model":"Reno 3 5G"},{"regex":"(?:PCRM00|CPH203[57]|CPH2009)","model":"Reno 3 Pro"},{"regex":"CPH2113(?:[);/ ]|$)","model":"Reno 4 4G"},{"regex":"CPH2125(?:[);/ ]|$)","model":"Reno 4 Lite"},{"regex":"CPH2109(?:[);/ ]|$)","model":"Reno 4 Pro 4G"},{"regex":"PDP[TM]00(?:[);/ ]|$)","model":"Reno 4 5G"},{"regex":"PEA[TM]00(?:[);/ ]|$)","model":"Reno 4 SE 5G "},{"regex":"PDN[TM]00(?:[);/ ]|$)","model":"Reno 4 Pro 5G"},{"regex":"PDSM00(?:[);/ ]|$)","model":"Reno 5 Pro 5G"},{"regex":"CPH192[15]","model":"Reno 5G"},{"regex":"PCLM10(?:[);/ ]|$)","model":"Reno Ace"},{"regex":"PDHM00(?:[);/ ]|$)","model":"Reno Ace 2"},{"regex":"PCGM00(?:[);/ ]|$)","model":"Reno K3"},{"regex":"(?:OPPO[ _]?)?(?:CPH1979|PCD[TM]10)(?:[);/ ]|$)","model":"Reno Z"},{"regex":"N1T?(?:[);/ ]|$)","model":"N1T","device":"phablet"},{"regex":"R([0-9]{3,4}[KSTW]?)(?:[);/ ]|$)","model":"R$1"},{"regex":"(CPH[0-9]{4})","model":"$1"},{"regex":"(?:OB-)?OPPO[ _]?((?!Browser)[a-z0-9]+)","model":"$1"}]},"Opsson":{"regex":"Opsson|IUSAI","device":"smartphone","models":[{"regex":"IUSAI[ _]([^/;]+) Build","model":"Iusai $1"},{"regex":"IUSAI[ _]([^/;\\\\)]+)[/;\\\\)]","model":"Iusai $1"},{"regex":"Opsson[ _]([^/;]+) Build","model":"$1"},{"regex":"(?:Opsson-)?Opsson[ -_]([^/;]+)/","model":"$1"}]},"Orange":{"regex":"SPV[ \\\\-]?([a-z0-9]+)|(?<!FBCR/)Orange[ _-](?!Tahiti-LS\\\\))([^/;]+)( Build|\\\\))(?<!Tahiti-LS\\\\))|SC/IHD92|Nura 2|FunTab ([^/;]+) Build|Orange Mahpee","device":"smartphone","models":[{"regex":"SC/IHD92","model":"Livebox Play","device":"tv"},{"regex":"Nura 2","model":"Nura 2"},{"regex":"Sego","model":"Sego","device":"tablet"},{"regex":"FunTab ([^/;]+) Build","model":"FunTab $1","device":"tablet"},{"regex":"Orange[ _-](Rise)(3[12]|5[12])(?:[);/ ]|$)","model":"$1 $2"},{"regex":"Orange[ _-](Dive)72(?:[);/ ]|$)","model":"$1 72"},{"regex":"Orange[ _-](Daytona|Dive (30|7[13])|Dublin|Fova|Gova|Hi 4G|Hiro|Kivo|Monte Carlo|Neva 80|Neva play|Nura|Reyo|Rise[_ ](3[034]|40|5[345])|Rono|Roya|San Francisco|Tactile internet 2|Tado|Yomi|Yumo|Zali|Mahpee)(?:[);/ ]|$)","model":"$1"},{"regex":"SPV[ \\\\-]?([a-z0-9]+)","model":"SPV $1"}]},"Oukitel":{"regex":"OUKITEL|(?:(?:C15|C16|K10000|K[46]000)(?:[ _]Pro)|K4000Pro|U16 Max|U7 Max|U7 Plus|U11[_ ]Plus|U20_Plus|OK6000 Plus|WP5000|WP[58] Pro|K[46]000[ _](?:Plus|Lite)|Y4800|K10000|K[4-8]000| WP[5-7])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(C15|C16|K10000|K[46]000|WP[258]|U15)[ _]?Pro(?:[);/ ]|$)","model":"$1 Pro"},{"regex":"OUKITEL K([37])(?:[);/ ]|$)","model":"K$1"},{"regex":"(K10000|U16|U7)[ _]Max(?:[);/ ]|$)","model":"$1 Max"},{"regex":"(U20|K[46]000|U7|U11|OK6000)[_ ]?Plus(?:[);/ ]|$)","model":"$1 Plus"},{"regex":"(K4000)[_ ]Lite(?:[);/ ]|$)","model":"$1 Lite"},{"regex":"(Y4800|K10000|K[4-8]000|WP2|WP5000|[CU]2|U10)(?:[);/ ]|$)","model":"$1"},{"regex":" (WP[5-7])(?:[);/ ]|$)","model":"$1"},{"regex":"OUKITEL; ([^;]+);","model":"$1"}]},"OKWU":{"regex":"OKWU SIGMA(?:[);/ ]|$)","device":"smartphone","model":"Sigma"},"Ouki":{"regex":"OUKI|OK[AU][0-9]+[a-z]* Build","device":"smartphone","models":[{"regex":"OUKI[ _-]?([^;/]+) Build","model":"$1"},{"regex":"([^;/)]+) Build/OUKI","model":"$1"},{"regex":"OUKI[ _-]?([^;/)]+)(?:[;/)]|$)","model":"$1"},{"regex":"(OK[AU][0-9]+[a-z]*) Build","model":"$1"}]},"Overmax":{"regex":"OV-[a-z]+(?:[^;(/]*)[();/ ]|Qualcore 10(?:10|27)|Vertis 5021 Aim|OV1027[34]G","device":"tablet","models":[{"regex":"OV-V10","model":"Vertis Yard","device":"smartphone"},{"regex":"Vertis 5021 Aim","model":"Vertis 5021 Aim","device":"smartphone"},{"regex":"OV-Vertis[ _-]([^;/]+) Build","model":"Vertis $1","device":"smartphone"},{"regex":"Qualcore 1010","model":"Qualcore 1010","device":"tablet"},{"regex":"Qualcore 1027 4G","model":"Qualcore 1027 4G","device":"tablet"},{"regex":"OV1027([34])G","model":"Qualcore 1027 $1G","device":"tablet"},{"regex":"(OV-[a-z]+(?:[^;(/]*))(?<!Build)[();/ ]","model":"$1"}]},"Oysters":{"regex":"Oysters|T84ERI[ _]3G|T72HM(s_)?3G|T102MS_3G|T102ER3G|(T74HMi|T84Bi)[_ ]4G|T74MR4G|T84Ni[_ ][34]G|Pacific[ ]?800i|T104B_[34]G|IndianV|T72HA_3G|T74D_3G|T74N_3G|T74SC_3G|T74Mai_3G|T104MBi_3G|T104SCi_3G|T104ER4G|Atlantic4G|AntarcticE|T7V 3G","device":"tablet","models":[{"regex":"Pacific[ ]?800i","device":"smartphone","model":"Pacific 800i"},{"regex":"Atlantic4G","device":"smartphone","model":"Atlantic 4G"},{"regex":"AntarcticE","device":"smartphone","model":"Antarctic E"},{"regex":"IndianV","device":"smartphone","model":"Indian V"},{"regex":"Oysters[_ ]PacificV","device":"smartphone","model":"Pacific V"},{"regex":"Oysters ((?:Arctic|Indian|Atlantic|Pacific)[^/;]+) Build","device":"smartphone","model":"$1"},{"regex":"(T84ERI[ _]3G|T72HM(s_)?3G|(?:(T74HMi|T84Bi)[_ ]4G)|T84Ni[_ ][34]G)","model":"$1"},{"regex":"(T74MR|T102MS|T104B|T74SC|T74[DN]|T72HA|T102ER|T104SCi|T104MBi|T104ER|T7V)[ _]?([34]G)","model":"$1 $2"},{"regex":"T74Mai_3G","model":"T74MAi 3G"},{"regex":"Oysters ([^/;]+)( Build|\\\\))","model":"$1"}]},"öwn":{"regex":"OWN[ _]|(?:S4035[ _][34]G|Smart8|SMART PLUS LTE)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"FUN ([67])","model":"Fun $1"},{"regex":"FUN 5\\\\(4G\\\\)","model":"Fun 5 4G"},{"regex":"(?:OWN[ _])?(S3000D|S3010|S3020D|S4010|S4025|S4035[ _][34]G)","model":"$1"},{"regex":"One Plus","model":"One Plus"},{"regex":"One","model":"One"},{"regex":"SMART 9","model":"Smart 9"},{"regex":"Smart8(?:[);/ ]|$)","model":"Smart 8"},{"regex":"SMART PLUS LTE(?:[);/ ]|$)","model":"Smart Plus LTE"}]},"Panacom":{"regex":"T-i708D","device":"smartphone","models":[{"regex":"T-i708D","device":"tablet","model":"T-i708D"}]},"Panasonic":{"regex":"Panasonic|PANATV[0-9]+|Viera/|(?:P902i|P-0[28]D|FZ-B2D|FZ-[NX]1|DMC-CM1|P-01J|P-03E)(?:[);/ ]|$)|Eluga[ _]|P55 Novo 4G","device":"smartphone","models":[{"regex":"P-01J(?:[);/ ]|$)","model":"P-smart Keitai"},{"regex":"P-03E(?:[);/ ]|$)","model":"Eluga P"},{"regex":"Eluga[ _-]([^;/]+) Build","model":"Eluga $1"},{"regex":"Eluga[ _-]([^);/]+)[;/)]","model":"Eluga $1"},{"regex":"(DMC-CM1)","model":"Lumix $1","device":"camera"},{"regex":"P-02D(?:[);/ ]|$)","model":"Lumix Phone P-02D"},{"regex":"(FZ-[XN]1)(?:[);/ ]|$)","model":"Toughpad $1"},{"regex":"FZ-B2D(?:[);/ ]|$)","model":"Toughpad FZ-B2D","device":"tablet"},{"regex":"P55 Novo 4G","model":"P55 Novo 4G"},{"regex":"P902i(?:[);/ ]|$)","device":"feature phone","model":"P902i"},{"regex":"Panasonic MIL DLNA","device":"tv","model":"Viera Cast"},{"regex":"PANATV[0-9]+|Viera/","device":"tv","model":"Smart TV"},{"regex":"(43D1200|(?:32|43)D1270|32D1280)","device":"tv","model":"$1"},{"regex":"Panasonic[ _\\\\-]?([a-z0-9]+)","model":"$1"},{"regex":"portalmmm/2.0 (P[a-z0-9]+)","model":"$1"},{"regex":"P-08D(?:[);/ ]|$)","model":"Eluga Live 10.1\\"","device":"tablet"}]},"PCBOX":{"regex":"Art-PCB-V116|Bee-PCB-V216|Clap-PCB-I316|PCB-T(103|715)","device":"smartphone","models":[{"regex":"Art-PCB-V116","model":"Art"},{"regex":"Bee-PCB-V216","model":"Bee"},{"regex":"Clap-PCB-I316","model":"Clap"},{"regex":"PCB-T103","device":"tablet","model":"Curi Lite"},{"regex":"PCB-T715","device":"tablet","model":"T715"}]},"PCD":{"regex":"PH4001","device":"smartphone","models":[{"regex":"PH4001","model":"PH4001"}]},"PCD Argentina":{"regex":"PCD[ ]?50[689]","device":"smartphone","models":[{"regex":"PCD[ ]?(50[689])","model":"$1"}]},"ArmPhone":{"regex":"(TSD Octa A0520P|TSD Quadra A050[59]P)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Pentagram":{"regex":"Pentagram|Quadra|Monster X5","device":"tablet","models":[{"regex":"(?:PENTAGRAM[_ ])?EON[_ ]PRIX","model":"Eon Prix"},{"regex":"Quadra 7(?: UltraSlim)?","model":"Quadra 7 UltraSlim"},{"regex":"Monster X5?","model":"Monster X5","device":"smartphone"},{"regex":"Quadra ?([^);/]*) Build","model":"Quadra $1"},{"regex":"Pentagram ?TAB ?([^);/]*) Build","model":"Tab $1"},{"regex":"Pentagram ?([^);/]*) Build","model":"$1","device":"smartphone"}]},"TCL":{"regex":"TCL,|TCL[_ -][a-z0-9]+|(?:TCL[_ -][^;/]+ Build)|(?:TCLGalaG60(?:\\\\(9108A\\\\))?|A502DL|T78[02]H|5199I|7040N|5133A|5159[AJ]|5152D|T770H|T671H|T790Y|T766H_EEA|T766A|T799[BH]|Percee TV)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"TCLGalaG60(?:\\\\(9108A\\\\))?(?:[);/ ]|$)","model":"Gala G60"},{"regex":"5199I(?:[);/ ]|$)","model":"C9"},{"regex":"5152D(?:[);/ ]|$)","model":"C5"},{"regex":"5133A(?:[);/ ]|$)","model":"L5"},{"regex":"T780H(?:[);/ ]|$)","model":"Plex"},{"regex":"T782H(?:[);/ ]|$)","model":"10 Plus"},{"regex":"T790Y(?:[);/ ]|$)","model":"10 5G"},{"regex":"TCL[_ -]([^;/]+) Build","model":"$1"},{"regex":"TCL[_ -]([a-z0-9]+)","model":"$1"},{"regex":"(7040N)(?:[);/ ]|$)","model":"$1"},{"regex":"A502DL(?:[);/ ]|$)","model":"LX"},{"regex":"5159[AJ](?:[);/ ]|$)","model":"L9"},{"regex":"T770H(?:[);/ ]|$)","model":"10L"},{"regex":"T766[HA](?:_EEA)?(?:[);/ ]|$)","model":"10 SE"},{"regex":"T671H(?:_EEA)?(?:[);/ ]|$)","model":"20 SE"},{"regex":"T799[BH](?:[);/ ]|$)","model":"10 Pro"},{"regex":"(Percee TV)(?:[);/ ]|$)","device":"tv","model":"$1"},{"regex":"((?:43|55)S62FS|(?:43|50)P65US|U(?:43|60)P60|65P4USM|(?:40|49)S62|L32S6|55P610|50P8S|55S62|(?:43|50)P6US|55DP60)","device":"tv","model":"$1"}]},"JVC":{"regex":"JVC[;,]|JVC Shell","device":"tv","models":[{"regex":"JVC Shell [0-9A-Z]+","model":""},{"regex":"JVC[;,](32D1290)","model":"$1"}]},"phoneOne":{"regex":"phoneOne[ \\\\-]?([a-z0-9]+)","device":"smartphone","model":"$1"},"Primepad":{"regex":"PD\\\\-(3127NC|3127) Build","device":"tablet","models":[{"regex":"PD\\\\-3127NC Build","model":"PD-3127NC"},{"regex":"PD\\\\-3127 Build","model":"PD-3127"}]},"Pioneer":{"regex":"Pioneer|.*; R1 Build|dvr700pi|XDP-300R","device":"smartphone","models":[{"regex":".*; R1 Build","model":"R1","device":"tablet"},{"regex":"Pioneer[ _-]?([^;/]+) Build","model":"$1"},{"regex":"Pioneer[ _-]?([^;/)]+)(?:[;/)]|$)","model":"$1"},{"regex":"dvr700pi","model":"DVR700PI 7.0\\"","device":"tablet"},{"regex":"(XDP-300R)","device":"portable media player","model":"$1"}]},"Pixus":{"regex":"Pixus|(hiPower|Ride[_ ][34]G|Play[ _]Three[ _]v(?:[24].0|3.1))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"Ride[_ ]([34])G","model":"Ride $1G"},{"regex":"Play[ _]Three[ _]v([24].0|3.1)","model":"Play Three v$1"},{"regex":"Play Two","model":"Play Two"},{"regex":"Play Five","model":"Play Five"},{"regex":"hiPower","model":"hiPower"},{"regex":"Pixus[ _]Sprint","model":"Sprint"},{"regex":"Touch 7 3G","model":"Touch 7 3G"},{"regex":"Pixus[ _]hiMax","model":"HiMax 9.6\\""},{"regex":"Pixus[ _]Blast","model":"Blast 10.1\\""},{"regex":"Pixus[ _]Joker","model":"Joker 10.1\\""},{"regex":"Pixus Blaze 10.1 3G","model":"Blaze 10.1\\" 3G"},{"regex":"Raze","model":"Raze","device":"smartphone"},{"regex":"Pixus_Jet","model":"Jet","device":"smartphone"},{"regex":"pixus hit 2","model":"Hit 2","device":"smartphone"}]},"PULID":{"regex":"PULID[ _]|F1[01357]\\\\+? Build","device":"smartphone","models":[{"regex":"F(1[01357]\\\\+?) Build","model":"F$1"},{"regex":"PULID[ _]([^;/]+) Build","model":"$1"},{"regex":"PULID[ _]([a-z0-9_]+)\\\\)","model":"$1"}]},"Point of View":{"regex":"POV_TV|POV_TAB|MOB-5045","device":"tablet","models":[{"regex":"POV_TV-HDMI-KB-01","model":"HDMI Smart TV Dongle","device":"tv"},{"regex":"POV_TV-HDMI-200BT","model":"Mini PC HDMI Dongle","device":"tv"},{"regex":"MOB-5045","model":"Mobii Phone 5045","device":"smartphone"},{"regex":"POV_TAB-P506","model":"ONYX 506 Navi"},{"regex":"POV_TAB[_-]NAVI7[_-]3G[_-]M","model":"ONYX 507 Navi"},{"regex":"POV_TAB-P527S","model":"ONYX 527S"},{"regex":"POV_TAB-P547","model":"ONYX 547 Navi"},{"regex":"POV_TAB-PROTAB26","model":"ProTab 26 XXL IPS"},{"regex":"POV_TAB-PROTAB25XXL8?","model":"ProTab 25XXL"},{"regex":"POV_TAB-PL1015","model":"Mobii 1015"},{"regex":"POV_TAB-PROTAB([a-z0-9]+)","model":"ProTab $1"},{"regex":"POV_TAB-P?([a-z0-9]+)","model":"Mobii $1"}]},"Pomp":{"regex":"POMP[ _-]","device":"smartphone","models":[{"regex":"POMP[ _-]([^;/]+) Build","model":"$1"},{"regex":"POMP[ _-]([^;/)]+)(?:[;/)]|$)","model":"$1"}]},"PPTV":{"regex":"(KING 7S?)","device":"smartphone","model":"$1"},"ProScan":{"regex":"PLT([^;/]+) Build|PLT(?:777[45]|9774|1074)G(?:[);/ ]|$)","device":"tablet","models":[{"regex":"PLT([^;/]+) Build","model":"PLT$1"},{"regex":"PLT(777[45]|9774|1074)G","model":"PLT$1G"}]},"RCA Tablets":{"regex":"RCT([^;/]+) Build|RCA RLTP4028|RCT6513W87|RCT6973W43(?:MD)?|RCT6703W12|RCT(?:6A06P22|6603W47M7|6303W87(?:DK|M)|6773W22B|6203W46L|6873W42M|6K03W13)","device":"smartphone","models":[{"regex":"RCA RLTP4028","model":"RLTP4028"},{"regex":"RCT6513W87","device":"tablet","model":"Galileo Pro 11.5\\""},{"regex":"RCT6873W42M","device":"tablet","model":"Voyager 7.0\\""},{"regex":"RCT6973W43(?:MD)?","device":"tablet","model":"Voyager III 7.0\\""},{"regex":"RCT6773W22B","device":"tablet","model":"Voyager II 7.0\\""},{"regex":"RCT6703W12","device":"tablet","model":"Atlas 10.0\\""},{"regex":"RCT6203W46L","device":"tablet","model":"Pro 10 Edition II"},{"regex":"RCT6A06P22","device":"tablet","model":"Endeavor 10.0\\" HD"},{"regex":"RCT(?:6303W87(?:DK|M)|6K03W13)","device":"tablet","model":"Viking Pro 10.0\\""},{"regex":"RCT6603W47M7","device":"tablet","model":"Viking II 10.0\\""},{"regex":"RCT([^;/)]+)(?: Build|[;)])","device":"tablet","model":"RCT$1"}]},"Readboy":{"regex":"Readboy[ _-]","device":"tablet","models":[{"regex":"Readboy[ _-]([^;/)]+)(?: Build|[;)])","model":"$1"}]},"Roku":{"regex":"Roku/DVP","device":"tv","model":"Digital Video Player"},"Rokit":{"regex":"IO Pro","device":"smartphone","models":[{"regex":"IO Pro","model":"IO Pro"}]},"Rombica":{"regex":"(Rombica|SSQ-A0500|Smart Box v[0-9]+)(?:[);/ ]|$)","device":"tv","models":[{"regex":"SSQ-A0500(?:[);/ ]|$)","model":"Smart Stick 4K"},{"regex":"(Infinity K8|Smart Box (?:v00[345789]|Quad|Ultra HD v002|4K V001))(?:[);/ ]|$)","model":"$1"}]},"Rover":{"regex":"Rover ([0-9]+)","device":"feature phone","model":"$1"},"RoverPad":{"regex":"(?:Rover[ ]?Pad|RoverPhone|Sky 7.85 3G)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"RoverPhone(?:[);/ ]|$)","model":"","device":"smartphone"},{"regex":"(?:Rover[ ]?Pad)?sky 7.85(?: 3G)?(?:[);/ ]|$)","model":"Sky 7.85\\" 3G"},{"regex":"RoverPad (10.4|Air S70|9.7 3G|Sky 9.7|3W A73|3W7|3WT70|3W9.4)(?:[);/ ]|$)","model":"$1"}]},"Roadrover":{"regex":"Roadrover ChangAn S","device":"tablet","model":"ChangAn S"},"RT Project":{"regex":"Shock 5","device":"smartphone","models":[{"regex":"Shock 5","model":"Shock 5"}]},"S-TELL":{"regex":"S-TELL","device":"smartphone","models":[{"regex":"(?:S-TELL[ _])?M4(61|77|80)","model":"M4$1"}]},"Safaricom":{"regex":"NEON_RAY","device":"smartphone","models":[{"regex":"NEON_RAY","model":"Neon Ray"}]},"Santin":{"regex":"(?:SANTIN|BiTBiZ_V58|ACTOMA ACE|DREAMPLUS03A|Candy U7 Pro)[);/_ ]","device":"smartphone","models":[{"regex":"BiTBiZ_V58(?:[);/ ]|$)","model":"BiTBiZ V58"},{"regex":"Candy U7 Pro(?:[);/ ]|$)","model":"Candy U7 Pro"},{"regex":"DREAMPLUS03A(?:[);/ ]|$)","model":"Dream Plus 03A"},{"regex":"GreenOrange(?:[);/ ]|$)","model":"Green Orange"},{"regex":"halove(?:[);/ ]|$)","model":"Halove"},{"regex":"ACTOMA ACE(?:[);/ ]|$)","model":"Actoma Ace"},{"regex":"monica(?:[);/ ]|$)","model":"Monica"},{"regex":"POWER(?:[);/ ]|$)","model":"Power"},{"regex":"GALAZ(?:[);/ ]|$)","model":"Galaz"},{"regex":"NEWDUN(?:[);/ ]|$)","model":"Newdun"},{"regex":"SANTIN[ _][#]?(Dante|Candy U7|Armor|YSL-Y7|ANT.W|N[13]|JS|S6|V9|Life Shine)(?:[);/ ]|$)","model":"$1"}]},"Siemens":{"regex":"SIEMENS|SIE-|portalmmm/2\\\\.0 SI|(?:S55|SL45i)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:SIE-)?(S[56]5|S40|C45|ME45|SLIK)(?:[);/ ]|$)","device":"feature phone","model":"$1"},{"regex":"SIEMENS[ \\\\-]([a-z0-9]+)","model":"$1"},{"regex":"SIE(?:MENS )?[\\\\-]?([a-z0-9]+)","model":"$1"},{"regex":"(?:SIE-)?(SL45i)","model":"$1"},{"regex":"portalmmm/2.0 (SI[a-z0-9]+)","model":"$1"}]},"Soundmax":{"regex":"((?:SM-LED32M(?:11|04)S)(?:_-Ver01)?|SM-LED40M04S)(?:[);/ ]|$)","device":"tv","model":"$1"},"Samsung":{"regex":"SAMSUNG(?! ?Browser)|Maple (?!III)|SC-(?:01[FGHKLM]|02[CGHJKLM]|03[JKL]|04[EJL]|05[GL]|(?:4[12]|5[1234])A)|N[57]100|N5110|N9100|S(?:CH|GH|PH|EC|AM|HV|HW|M)-|SMART-TV|GT-|(?<!GOG|GOG )Galaxy|(?:portalmmm|o2imode)/2\\\\.0 [SZ]|sam[rua]|vollo Vi86(?:[);/ ]|$)|(?:OTV-)?SMT-E5015|ISW11SC|SCV4[0-9]|SCV3[1-9]|40[34]SC|SCL2[234]|SCG0[1-7]|SCT21","device":"smartphone","models":[{"regex":"GT-B9150","device":"tv","model":"Home Sync"},{"regex":"(?:OTV-)?SMT-E5015","device":"tv","model":"SMT-E5015"},{"regex":"Maple ","device":"tv","model":""},{"regex":"(?:SAMSUNG-)?(?:GT-)?N5100","device":"tablet","model":"Galaxy Note 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T677(?:[ATV]|N[KL])?(?:[);/ ]|$)","device":"tablet","model":"Galaxy View 18.4\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T670(?:[);/ ]|$)","device":"tablet","model":"Galaxy View 18.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?(?:GT-)?N5110","device":"tablet","model":"Galaxy Note 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?GT-N5120","device":"tablet","model":"Galaxy Note 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?(?:GT|SM)-N8000","device":"tablet","model":"Galaxy Note 10.1\\""},{"regex":"(?:SAMSUNG-)?GT-N8010","device":"tablet","model":"Galaxy Note 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?GT-N8020","device":"tablet","model":"Galaxy Note 10.1\\" LTE"},{"regex":"(?:SAMSUNG-)?GT-P1000M?|SCH-I800","device":"tablet","model":"Galaxy Tab"},{"regex":"(?:SAMSUNG-)?GT-P3100B?","device":"tablet","model":"Galaxy Tab 2 7\\""},{"regex":"(?:SAMSUNG-)?GT-P311[03]","device":"tablet","model":"Galaxy Tab 2 7\\" WiFi"},{"regex":"(?:SAMSUNG-)?GT-P5100|SCH-I915","device":"tablet","model":"Galaxy Tab 2 10.1\\""},{"regex":"(?:SAMSUNG-)?GT-P511[03]","device":"tablet","model":"Galaxy Tab 2 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T217T","device":"tablet","model":"Galaxy Tab 3 7.0\\" 4G"},{"regex":"(?:SAMSUNG-)?GT-P5200","device":"tablet","model":"Galaxy Tab 3 10.1\\""},{"regex":"(?:SAMSUNG-)?GT-P5210","device":"tablet","model":"Galaxy Tab 3 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?GT-P5220","device":"tablet","model":"Galaxy Tab 3 10.1\\" LTE"},{"regex":"(?:SAMSUNG-)?GT-P6200","device":"tablet","model":"Galaxy Tab 7\\" Plus"},{"regex":"(?:SAMSUNG-)?GT-P6201","device":"tablet","model":"Galaxy Tab 7\\" Plus N"},{"regex":"(?:SAMSUNG-)?GT-P6810","device":"tablet","model":"Galaxy Tab 7.7\\""},{"regex":"(?:SAMSUNG-)?GT-P7100","device":"tablet","model":"Galaxy Tab 10.1v"},{"regex":"(?:SAMSUNG-)?GT-P75[01]0","device":"tablet","model":"Galaxy Tab 10.1\\""},{"regex":"(?:SAMSUNG-)?SM-P600","device":"tablet","model":"Galaxy Note 10.1\\" 2014 Edition WiFi"},{"regex":"(?:SAMSUNG-)?SM-P60[12]","device":"tablet","model":"Galaxy Note 10.1\\" 2014 Edition"},{"regex":"(?:SAMSUNG-)?SM-(?:P605|P607T)","device":"tablet","model":"Galaxy Note 10.1\\" 2014 Edition LTE"},{"regex":"(?:SAMSUNG-)?SM-P900","device":"tablet","model":"Galaxy NotePRO 12.2\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-P901","device":"tablet","model":"Galaxy NotePRO 12.2\\""},{"regex":"(?:SAMSUNG-)?SM-P905","device":"tablet","model":"Galaxy NotePRO 12.2\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:P587|P588C)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 10.1\\" with S Pen (2016) LTE"},{"regex":"(?:SAMSUNG-)?SM-P583(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 10.1\\" with S Pen (2016) WiFi"},{"regex":"(?:SAMSUNG-)?SM-P205(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 8.0\\" with S Pen (2019) LTE"},{"regex":"(?:SAMSUNG-)?SM-P200(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 8.0\\" with S Pen (2019) WiFi"},{"regex":"(?:SAMSUNG-)?SM-T307U(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 8.4\\" (2020) LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T505[CN]?|T507)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A7 10.4\\" (2020) LTE"},{"regex":"(?:SAMSUNG-)?SM-T500(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A7 10.4\\" (2020) WiFi"},{"regex":"(?:SAMSUNG-)?SM-T11[03]","device":"tablet","model":"Galaxy Tab 3 Lite 7.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T830[X]?|T837R4)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S4 10.5\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T837P(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S4 10.5\\" with S Pen"},{"regex":"(?:SAMSUNG-)?SM-(?:T835[CN]?|T837[VTA]?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S4 10.5\\""},{"regex":"(?:SAMSUNG-)?SM-(?:T725[CN]?|T720X|T727(?:R4|[AUV])?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S5e 10.5\\""},{"regex":"(?:SAMSUNG-)?SM-T720(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S5e 10.5\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T865N?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 10.5\\""},{"regex":"(?:SAMSUNG-)?SM-T867(?:R4|[VU])?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 10.5\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:P615[CN]?|P617)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 Lite 10.4\\""},{"regex":"(?:SAMSUNG-)?SM-P610X?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 Lite 10.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T860(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 10.5\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T866N(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 10.5\\" 5G"},{"regex":"(?:SAMSUNG-)?SM-T111[M]?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab 3 Lite 7.0\\""},{"regex":"(?:SAMSUNG-)?SM-T116(?:BU|NU|NY)?","device":"tablet","model":"Galaxy Tab 3 V"},{"regex":"(?:SAMSUNG-)?SM-(?:T2105|T212)","device":"tablet","model":"Galaxy Tab 3 7.0\\" Kids"},{"regex":"(?:SAMSUNG-)?SM-T210R?","device":"tablet","model":"Galaxy Tab 3 7.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T21(?:[15]|7[AS])","device":"tablet","model":"Galaxy Tab 3 7.0\\""},{"regex":"(?:SAMSUNG-)?SM-T230(?:NU)?","device":"tablet","model":"Galaxy Tab 4 7.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T23[15]|403SC","device":"tablet","model":"Galaxy Tab 4 7.0\\" 3G"},{"regex":"(?:SAMSUNG-)?SM-(?:T239|T237[PV])","device":"tablet","model":"Galaxy Tab 4 7.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T232(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab 4 7.0\\" WiFi + 3G"},{"regex":"(?:SAMSUNG-)?SM-T310","device":"tablet","model":"Galaxy Tab 3 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T311","device":"tablet","model":"Galaxy Tab 3 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T315","device":"tablet","model":"Galaxy Tab 3 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T330","device":"tablet","model":"Galaxy Tab 4 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T33[215]|T337[AVT])","device":"tablet","model":"Galaxy Tab 4 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T520","device":"tablet","model":"Galaxy TabPRO 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T53[15]|T537[AV])","device":"tablet","model":"Galaxy Tab 4 10.1\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T536(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab 4 10.1\\" Advanced"},{"regex":"(?:SAMSUNG-)?SM-T532(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab 4 10.1\\""},{"regex":"(?:SAMSUNG-)?SM-T320","device":"tablet","model":"Galaxy TabPRO 8.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T325","device":"tablet","model":"Galaxy TabPRO 8.4\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T525","device":"tablet","model":"Galaxy TabPRO 10.1\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T530(?:NU)?|T533)","device":"tablet","model":"Galaxy Tab 4 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T700","device":"tablet","model":"Galaxy Tab S 8.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T705|T707[AV])","device":"tablet","model":"Galaxy Tab S 8.4\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T800","device":"tablet","model":"Galaxy Tab S 10.5\\" WiFi"},{"regex":"(?:SAMSUNG-)?(?:SM-(?:T805|T807[PV]?)|SCT21)","device":"tablet","model":"Galaxy Tab S 10.5\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T813|T810)","device":"tablet","model":"Galaxy Tab S2 9.7\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T719[CY]?|T715(?:N0|[CY])?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S2 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T71[03]|T710X)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S2 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T815|T817[ATW]?|T818[ATVW]?|T819[Y]?)","device":"tablet","model":"Galaxy Tab S2 9.7\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T820","device":"tablet","model":"Galaxy Tab S3 9.7\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T82[57]","device":"tablet","model":"Galaxy Tab S3 9.7\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T975N?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7+ 12.4\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T970(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7+ 12.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T976[BN]|T978U)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7+ 12.4\\" 5G"},{"regex":"(?:SAMSUNG-)?SM-T870(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7 11.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T875N?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7 11.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T878U(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7 11.0\\" 5G"},{"regex":"(?:SAMSUNG-)?SM-T900","device":"tablet","model":"Galaxy TabPRO 12.2\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T280","device":"tablet","model":"Galaxy Tab A 7.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T285","device":"tablet","model":"Galaxy Tab A 7.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T3[58]0","device":"tablet","model":"Galaxy Tab A 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:P350|T3[58]5|T357[TW])","device":"tablet","model":"Galaxy Tab A 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T387(?:AA|R4|VK|[TVW])","device":"tablet","model":"Galaxy Tab A 8.0\\" LTE (2018)"},{"regex":"(?:SAMSUNG-)?SM-T295","device":"tablet","model":"Galaxy Tab A 8.0\\" LTE (2019)"},{"regex":"(?:SAMSUNG-)?SM-T290","device":"tablet","model":"Galaxy Tab A 8.0\\" WiFi (2019)"},{"regex":"(?:SAMSUNG-)?SM-(?:P355([MY])?|T550)","device":"tablet","model":"Galaxy Tab A 9.7\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:P550|P555(M)?|T555)","device":"tablet","model":"Galaxy Tab A 9.7\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T58[05]|P58[05])","device":"tablet","model":"Galaxy Tab A 10.1\\" WiFi (2016)"},{"regex":"(?:SAMSUNG-)?SM-T587[P]?","device":"tablet","model":"Galaxy Tab A 10.1\\" LTE (2016)"},{"regex":"(?:SAMSUNG-)?SM-T59[057]","device":"tablet","model":"Galaxy Tab A 10.5\\" LTE (2018)"},{"regex":"(?:SAMSUNG-)?SM-T51(?:7P|[057])","device":"tablet","model":"Galaxy Tab A 10.1\\" (2019)"},{"regex":"(?:SAMSUNG-)?SM-(?:T37[57]|T378[KLSV])","device":"tablet","model":"Galaxy Tab E 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T56[02]","device":"tablet","model":"Galaxy Tab E 9.6\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T561","device":"tablet","model":"Galaxy Tab E 9.6\\" 3G"},{"regex":"(?:SAMSUNG-)?SM-T567V","device":"tablet","model":"Galaxy Tab E 9.6\\" 4G"},{"regex":"(?:SAMSUNG-)?SM-T365(?:F0|[MY])?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T360(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T395[CN]?|T397U)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 2 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T390(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 2 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T575N?|T577U?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 3 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T570(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 3 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T545|T547U?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active Pro 10.1\\""},{"regex":"(?:SAMSUNG-)?SM-T540(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active Pro 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:P902|P907A)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Note Pro 12.2\\""},{"regex":"(?:SAMSUNG[- ])?SM-T2519","model":"Galaxy Tab Q","device":"tablet"},{"regex":"(?:SAMSUNG )?SM-R820","device":"wearable","model":"Galaxy Watch Active 2"},{"regex":"(?:SAMSUNG-)?SM-G850(?:8S|[AFKLMSWXY])","model":"Galaxy Alpha"},{"regex":"(?:SAMSUNG-)?GT-B5330","model":"Galaxy Chat"},{"regex":"(?:SAMSUNG-)?SM-A605K","model":"Galaxy Jean"},{"regex":"(?:SAMSUNG-)?SM-A202K","model":"Galaxy Jean 2"},{"regex":"(?:SAMSUNG-)?GT-B5510","model":"Galaxy Y Pro"},{"regex":"(?:SAMSUNG-)?GT-B5512","model":"Galaxy Y Pro Duos"},{"regex":"(?:SAMSUNG-)?GT-B7510","model":"Galaxy Pro"},{"regex":"(?:SAMSUNG-)?GT-I5700","model":"Galaxy Spica"},{"regex":"(?:SAMSUNG-)?GT-I5801","model":"Galaxy Apollo"},{"regex":"(?:SAMSUNG-)?GT-I5800","model":"Galaxy 3"},{"regex":"(?:SAMSUNG-)?GT-I8000","model":"Omnia II"},{"regex":"(?:SAMSUNG-)?(?:GT-I8150|SM-T255S)","model":"Galaxy W"},{"regex":"SC-01H(?:[);/ ]|$)","model":"Galaxy Active Neo"},{"regex":"(?:SAMSUNG-)?GT-S5830","model":"Galaxy Ace"},{"regex":"(?:SAMSUNG-)?SM-(?:G357(?:FZ|M)|G310HN)","model":"Galaxy Ace Style"},{"regex":"(?:SAMSUNG-)?GT-I8160","model":"Galaxy Ace 2"},{"regex":"(?:SAMSUNG-)?SM-G313(?:HY|M[LUY]|[FM])","model":"Galaxy Ace 4"},{"regex":"(?:SAMSUNG-)?SM-G316M","model":"Galaxy Ace 4 Duos"},{"regex":"(?:SAMSUNG-)?SM-G313[HU]","model":"Galaxy Ace 4 Lite"},{"regex":"(?:SAMSUNG-)?SM-(?:G316U|G318(?:H|ML))(?:[);/ ]|$)","model":"Galaxy Ace 4 Neo"},{"regex":"(?:SAMSUNG-)?SM-G9100(?:[);/ ]|$)","model":"Galaxy S II"},{"regex":"(?:SAMSUNG-)?SHV-E120S(?:[);/ ]|$)","model":"Galaxy S II HD LTE"},{"regex":"(?:SAMSUNG-)?GT-I8190","model":"Galaxy S III mini"},{"regex":"(?:SAMSUNG-)?GT-I8200","model":"Galaxy S III mini Value Edition"},{"regex":"(?:SAMSUNG-)?GT-I826[02]","model":"Galaxy Core"},{"regex":"(?:SAMSUNG-)?SM-G386W","model":"Galaxy Core LTE"},{"regex":"(?:SAMSUNG-)?SM-G3589W","model":"Galaxy Core Lite LTE"},{"regex":"(?:SAMSUNG-)?GT-I8320","model":"H1"},{"regex":"(?:SAMSUNG-)?GT-I85[23]0","model":"Galaxy Beam"},{"regex":"(?:SAMSUNG-)?SM-G3858","model":"Galaxy Beam 2"},{"regex":"(?:SAMSUNG-)?SM-G600S","model":"Galaxy Wide"},{"regex":"(?:SAMSUNG-)?GT-I855[028]","model":"Galaxy Win"},{"regex":"(?:SAMSUNG-)?SM-G381[28]","model":"Galaxy Win Pro"},{"regex":"(?:SAMSUNG-)?GT-I8580","model":"Galaxy Core Advance"},{"regex":"(?:SAMSUNG-)?GT-I8730","model":"Galaxy Express"},{"regex":"(?:SAMSUNG-)?SM-(?:E500(?:HQ|YZ|[0FHM])|S978L)","model":"Galaxy E5"},{"regex":"(?:SAMSUNG-)?SM-E700[09FHM]","model":"Galaxy E7"},{"regex":"(?:SAMSUNG-)?GT-I90(?:00|08|18|88)","model":"Galaxy S"},{"regex":"(?:SAMSUNG-)?GT-I9001","model":"Galaxy S Plus"},{"regex":"(?:SAMSUNG-)?GT-I9003","model":"Galaxy SL"},{"regex":"(?:SAMSUNG-)?GT-I9010","model":"Galaxy S Giorgio Armani"},{"regex":"(?:SAMSUNG-)?GT-I9070","model":"Galaxy S Advance"},{"regex":"(?:SAMSUNG-)?GT-I910[08]","model":"Galaxy S II"},{"regex":"(?:SAMSUNG-)?ISW11SC","model":"Galaxy S II WiMAX"},{"regex":"(?:SAMSUNG-)?GT-I9103","model":"Galaxy R"},{"regex":"(?:SAMSUNG-)?GT-I9105","model":"Galaxy S II Plus"},{"regex":"(?:SAMSUNG-)?SM-G730(?:W8|[AV])","model":"Galaxy S3 mini"},{"regex":"(?:SAMSUNG-)?(?:GT-I919[025]|SCH-I435)","model":"Galaxy S4 mini"},{"regex":"(?:SAMSUNG-)?GT-I9515","model":"Galaxy S4 Value Edition"},{"regex":"(?:SAMSUNG-)?GT-I9295","model":"Galaxy S4 ACTIVE"},{"regex":"(?:SAMSUNG-)?(?:GT-I9300|SCH-(?:I535|I939|L710))","model":"Galaxy S III"},{"regex":"(?:SAMSUNG-)?(?:GT-I9305|SCH-R530)","model":"Galaxy S III LTE"},{"regex":"(?:SAMSUNG-)?(?:SM-S975L|GT-I950[025]|SC-04E|SCH-(?:I545|I959|R970)|SGH-M919N?|Galaxy-S4)","model":"Galaxy S4"},{"regex":"(?:SAMSUNG-)?GT-I9506","model":"Galaxy S4 with LTE+"},{"regex":"(?:SAMSUNG-)?GT-S5280","model":"Galaxy STAR"},{"regex":"(?:SAMSUNG-)?GT-S5301","model":"Galaxy POCKET Plus"},{"regex":"(?:SAMSUNG-)?GT-S5310","model":"Galaxy POCKET Neo"},{"regex":"(?:SAMSUNG-)?SM-G110[BHM]","model":"Galaxy POCKET 2"},{"regex":"(?:SAMSUNG-)?GT-S5360","model":"Galaxy Y Hello Kitty"},{"regex":"(?:SAMSUNG-)?GT-S6310","model":"Galaxy Young"},{"regex":"(?:SAMSUNG-)?GT-S6312","model":"Galaxy Young DUOS"},{"regex":"(?:SAMSUNG-)?SM-G130(?:BT|HN|[EHMU])","model":"Galaxy Young 2"},{"regex":"(?:SAMSUNG-)?SM-G130BU","model":"Galaxy Young 2 Pro"},{"regex":"(?:SAMSUNG-)?GT-S6790","model":"Galaxy FAME Lite with NFC"},{"regex":"(?:SAMSUNG-)?GT-S6810","model":"Galaxy FAME"},{"regex":"(?:SAMSUNG-)?GT-S6812","model":"Galaxy FAME Duos"},{"regex":"SC-04J(?:[);/ ]|$)","model":"Galaxy Feel"},{"regex":"SC-02L(?:[);/ ]|$)","model":"Galaxy Feel 2"},{"regex":"(?:SAMSUNG-)?GT-S7275","model":"Galaxy ACE 3"},{"regex":"(?:SAMSUNG-)?GT-S7500","model":"Galaxy ACE Plus"},{"regex":"(?:SAMSUNG-)?(?:GT-S7560|SCH-I699)","model":"Galaxy Trend"},{"regex":"(?:SAMSUNG-)?GT-S7390","model":"Galaxy Trend Lite"},{"regex":"(?:SAMSUNG-)?GT-S7580","model":"Galaxy Trend Plus"},{"regex":"(?:SAMSUNG-)?SCH-I739","model":"Galaxy Trend 2"},{"regex":"(?:SAMSUNG-)?(?:GT-S7562|SCH-I919)","model":"Galaxy S DUOS"},{"regex":"(?:SAMSUNG-)?GT-S7582","model":"Galaxy S DUOS 2"},{"regex":"(?:SAMSUNG-)?SM-(?:G31[36]HU|G313HZ)","model":"Galaxy S DUOS 3"},{"regex":"(?:SAMSUNG-)?GT-S7710","model":"Galaxy Xcover 2"},{"regex":"(?:SAMSUNG-)?SM-G388F","model":"Galaxy Xcover 3"},{"regex":"(?:SAMSUNG-)?SM-G389F","model":"Galaxy Xcover 3 VE"},{"regex":"(?:SAMSUNG-)?SM-G390[FWY]","model":"Galaxy Xcover 4"},{"regex":"(?:SAMSUNG-)?SM-G398FN","model":"Galaxy Xcover 4s"},{"regex":"(?:SAMSUNG-)?SM-G715(?:FN|U1|[AUW])","model":"Galaxy Xcover Pro"},{"regex":"(?:SAMSUNG-)?SM-G889(?:YB|[AFG])","model":"Galaxy Xcover FieldPro"},{"regex":"(?:SAMSUNG-)?GT-S8500","model":"Wave"},{"regex":"(?:SAMSUNG-)?GT-S8530","model":"Wave II"},{"regex":"(?:SAMSUNG-)?GT-S8600","model":"Wave 3"},{"regex":"(?:SAMSUNG-)?GT-S5380","model":"Wave Y"},{"regex":"(?:SAMSUNG-)?GT-S7250","model":"Wave M"},{"regex":"(?:SAMSUNG-)?GT-S5250","model":"Wave 525"},{"regex":"(?:SAMSUNG-)?GT-S5330","model":"Wave 533"},{"regex":"(?:SAMSUNG-)?GT-S5780","model":"Wave 578"},{"regex":"(?:SAMSUNG-)?GT-S7230","model":"Wave 723"},{"regex":"(?:SAMSUNG-)?SM-(?:C101|C105([AL])?)","model":"Galaxy S4 zoom"},{"regex":"(?:SAMSUNG-)?SM-(?:C111(M)?|C115)","model":"Galaxy K zoom"},{"regex":"(?:SAMSUNG-)?SM-G318[HM]Z","model":"Galaxy V Plus"},{"regex":"(?:SAMSUNG-)?SM-G355(?:6D|[89HM])","model":"Galaxy Core 2"},{"regex":"(?:SAMSUNG-)?SM-G350","model":"Galaxy Core Plus"},{"regex":"(?:SAMSUNG-)?SM-(?:G360[FH]?|S820L)","model":"Galaxy Core Prime"},{"regex":"(?:SAMSUNG-)?SM-G361[FH]?","model":"Galaxy Core Prime Value Edition"},{"regex":"(?:SAMSUNG-)?SM-(?:G386F|G3518(?:_TD)?|G3586V)","model":"Galaxy Core LTE"},{"regex":"(?:SAMSUNG-)?SM-G3568V","model":"Galaxy Core Mini 4G"},{"regex":"(?:SAMSUNG-)?SM-G5108Q?","model":"Galaxy Core Max"},{"regex":"(?:SAMSUNG-)?SM-G3815","model":"Galaxy EXPRESS II"},{"regex":"(?:SAMSUNG-)?SM-G800","model":"Galaxy S5 mini"},{"regex":"(?:SAMSUNG-)?SM-G9009D","model":"Galaxy S5 Dual-SIM"},{"regex":"(?:SAMSUNG-)?SM-(?:G900|G906[KLS]|S902L|S903VL)|Galaxy-S5|SCL23","model":"Galaxy S5"},{"regex":"(?:SAMSUNG-)?SM-G901F","model":"Galaxy S5 LTE+"},{"regex":"(?:SAMSUNG-)?SM-G870[AFW]|SC-02G","model":"Galaxy S5 Active"},{"regex":"(?:SAMSUNG-)?SM-G903[FMW]","model":"Galaxy S5 Neo"},{"regex":"(?:SAMSUNG-)?SM-G860P","model":"Galaxy S5 K Sport"},{"regex":"(?:SAMSUNG-)?(?:SM-G920(?:F[DQ]|W8|[089AFIKLPRSTVX])?|SM-S906L|SM-S907VL)|SC-05G","model":"Galaxy S6"},{"regex":"(?:SAMSUNG-)?SM-G890A","model":"Galaxy S5 Active"},{"regex":"(?:SAMSUNG-)?SM-G925[0ADFIKLPRSTVWX]|SCV31|404SC","model":"Galaxy S6 Edge"},{"regex":"(?:SAMSUNG-)?SM-G928(?:7C|N0|R4|W8|[07ACFGIKLPSTVX])","model":"Galaxy S6 Edge+"},{"regex":"(?:SAMSUNG-)?SM-G930(?:AZ|FD|R[467]|T1|V[CL]|W8|[0AFKLPRSTUVX8])?(?:[);/ ]|$)","model":"Galaxy S7"},{"regex":"(?:SAMSUNG-)?SM-G935(?:R4|W8|[0AFKLPSTUVX])|SC-02H|SCV33","model":"Galaxy S7 Edge"},{"regex":"(?:SAMSUNG-)?SM-G891A","model":"Galaxy S7 Active"},{"regex":"(?:SAMSUNG-)?SM-G950[08FNUW]?|SCV36|SC-02J","model":"Galaxy S8"},{"regex":"(?:SAMSUNG-)?SM-G8750","model":"Galaxy S8 Lite"},{"regex":"(?:SAMSUNG-)?SM-G892[AU]","model":"Galaxy S8 Active"},{"regex":"(?:SAMSUNG-)?SM-G955[0AFKLNPRTUVWX]?|SCV35|SC-03J","model":"Galaxy S8+"},{"regex":"(?:SAMSUNG-)?SM-G960[0FNUWX]?|SCV38|SC-02K","model":"Galaxy S9"},{"regex":"(?:SAMSUNG-)?SM-G965[0FNUWX]|SCV39|SC-03K","model":"Galaxy S9+"},{"regex":"(?:SAMSUNG-)?(?:SM-(?:G973|G977[BNPTU])|SCV41|SC-03L)","model":"Galaxy S10"},{"regex":"(?:SAMSUNG-)?SM-(?:S10 Lite|G770(?:U1|F))","model":"Galaxy S10 Lite"},{"regex":"(?:SAMSUNG-)?(?:SM-G975[08FUNWX]|SCV42|SC-04L)","model":"Galaxy S10+"},{"regex":"SC-05L","model":"Galaxy S10+ Olympic Games Edition"},{"regex":"(?:SAMSUNG-)?SM-G970(?:U1|[08FUNWX])(?:[);/ ]|$)","model":"Galaxy S10e"},{"regex":"(?:SAMSUNG-)?SM-G980F","model":"Galaxy S20"},{"regex":"(?:SAMSUNG-)?SM-G981(?:U1|[0BNUVW])|SCG01|SC-51A","model":"Galaxy S20 5G"},{"regex":"(?:SAMSUNG-)?SM-G780F","model":"Galaxy S20 FE"},{"regex":"(?:SAMSUNG-)?SM-G781(?:U1|[0BNUVW])","model":"Galaxy S20 FE 5G"},{"regex":"(?:SAMSUNG-)?SM-G988(?:U1|[0BNQUW])|SCG03","model":"Galaxy S20 Ultra 5G"},{"regex":"(?:SAMSUNG-)?SM-G985F|SCG02","model":"Galaxy S20+"},{"regex":"(?:SAMSUNG-)?SM-G986(?:U1|[0BNUW])|SC-52A","model":"Galaxy S20+ 5G"},{"regex":"(?:SAMSUNG-)?SM-G991(?:U1|[0BNW])","model":"Galaxy S21 5G"},{"regex":"(?:SAMSUNG-)?SM-G998(?:U1|[0BNUW])","model":"Galaxy S21 Ultra 5G"},{"regex":"(?:SAMSUNG-)?SM-G996(?:U1|[0BNWU])","model":"Galaxy S21+ 5G"},{"regex":"(?:SAMSUNG-)?SM-F700(?:U1|[0FNUW])|SCV47","model":"Galaxy Z Flip"},{"regex":"(?:SAMSUNG-)?SM-F707(?:U1|[0BNUW])|SCG04","model":"Galaxy Z Flip 5G"},{"regex":"(?:SAMSUNG-)?SCH-I200","model":"Galaxy Stellar"},{"regex":"(?:SAMSUNG-)?SCH-I829","model":"Galaxy Style Duos"},{"regex":"(?:SAMSUNG-)?(?:SCH-R740|SGH-S730)","model":"Galaxy Discover"},{"regex":"(?:SAMSUNG-)?SCH-S738","model":"Galaxy Centura"},{"regex":"vollo Vi86(?:[);/ ]|$)","model":"Vollo Vi86"},{"regex":"(?:SAMSUNG-)?SM-G386(?:T1|T)","model":"Galaxy Avant"},{"regex":"(?:SAMSUNG-)?SM-A716S","model":"Galaxy A Quantum"},{"regex":"(?:SAMSUNG-)?SM-(?:A015(?:DL|[TU]1|[AFGMUV])|S111DL)","model":"Galaxy A01"},{"regex":"(?:SAMSUNG-)?SM-A013[FGM]","model":"Galaxy A01 Core"},{"regex":"(?:SAMSUNG-)?SM-A025[FGM]","model":"Galaxy A02s"},{"regex":"(?:SAMSUNG-)?SM-A022G","model":"Galaxy A02"},{"regex":"(?:SAMSUNG-)?SM-A260[FG]","model":"Galaxy A2 Core"},{"regex":"(?:SAMSUNG-)?SM-A300(?:FU|YZ|XU|XZ|[09FGHMXY])","model":"Galaxy A3 (2015)"},{"regex":"(?:SAMSUNG-)?SM-A310(?:N0|[FMXY])","model":"Galaxy A3 (2016)"},{"regex":"(?:SAMSUNG-)?SM-A320(?:FL|[FXY])","model":"Galaxy A3 (2017)"},{"regex":"(?:SAMSUNG-)?SM-A430F","model":"Galaxy A4"},{"regex":"(?:SAMSUNG-)?SM-A500(?:YZ|[9LSWY])?(?:[);/ ]|$)","model":"Galaxy A5"},{"regex":"(?:SAMSUNG-)?SM-A500[0FGHKM]","model":"Galaxy A5 Duos"},{"regex":"(?:SAMSUNG-)?SM-A500(?:FU|X)","model":"Galaxy A5 (2015)"},{"regex":"(?:SAMSUNG-)?SM-A510[08FKLMSXY]","model":"Galaxy A5 (2016)"},{"regex":"(?:SAMSUNG-)?SM-A520[FKLSWX]","model":"Galaxy A5 (2017)"},{"regex":"(?:SAMSUNG-)?SM-A525F","model":"Galaxy A52"},{"regex":"(?:SAMSUNG-)?SM-A600(?:AZ|FN|GN|T1|[AFGNPTUX])","model":"Galaxy A6"},{"regex":"(?:SAMSUNG-)?SM-A605(?:[FG]N|[08FGX])","model":"Galaxy A6+"},{"regex":"(?:SAMSUNG-)?SM-G6200","model":"Galaxy A6s (2018)"},{"regex":"(?:SAMSUNG-)?SM-A606[0Y]","model":"Galaxy A60"},{"regex":"(?:SAMSUNG-)?SM-A700(?:YD|[09FHKLSX])","model":"Galaxy A7"},{"regex":"(?:SAMSUNG-)?SM-A710[08FKLMSXY]","model":"Galaxy A7 (2016)"},{"regex":"(?:SAMSUNG-)?SM-A720[FMSX]","model":"Galaxy A7 (2017)"},{"regex":"(?:SAMSUNG-)?SM-A750(?:GN|[CFGNX])","model":"Galaxy A7 (2018)"},{"regex":"(?:SAMSUNG-)?SM-A71(?:5[FW])?(?:[);/ ]|$)","model":"Galaxy A71"},{"regex":"(?:SAMSUNG-)?SM-A725F(?:[);/ ]|$)","model":"Galaxy A72"},{"regex":"(?:SAMSUNG-)?SM-A716(?:U1|[0BUV])(?:[);/ ]|$)","model":"Galaxy A71 5G"},{"regex":"(?:SAMSUNG-)?SM-A(?:530F|800[0FISXY])|SCV32","model":"Galaxy A8"},{"regex":"(?:SAMSUNG-)?SM-G885[FSY]","model":"Galaxy A8 Star"},{"regex":"(?:SAMSUNG-)?SM-A810(?:YZ|[FS])","model":"Galaxy A8 (2016)"},{"regex":"(?:SAMSUNG-)?SM-(?:A8s|G887[0F])","model":"Galaxy A8s"},{"regex":"(?:SAMSUNG-)?SM-A530[MNWX]","model":"Galaxy A8 (2018)"},{"regex":"(?:SAMSUNG-)?SM-A730[FX]","model":"Galaxy A8+ (2018)"},{"regex":"(?:SAMSUNG-)?SM-A900[0F]","model":"Galaxy A9"},{"regex":"SM-A9\\\\[7\\\\]","model":"Galaxy A9 7"},{"regex":"(?:SAMSUNG-)?SM-A920[0FXN]","model":"Galaxy A9 (2018)"},{"regex":"(?:SAMSUNG-)?SM-G885[08]","model":"Galaxy A9 Star"},{"regex":"(?:SAMSUNG-)?SM-(?:A9 Pro|A910[0F]|G887N)","model":"Galaxy A9 Pro"},{"regex":"(?:SAMSUNG-)?SM-A105[FGMN]","model":"Galaxy A10"},{"regex":"(?:SAMSUNG-)?SM-A107[FM]","model":"Galaxy A10s"},{"regex":"(?:SAMSUNG-)?SM-(?:S102DL|A102[NUW])","model":"Galaxy A10e"},{"regex":"(?:SAMSUNG-)?SM-A115(?:A[PZ]|U1|[AFMUW])","model":"Galaxy A11"},{"regex":"(?:SAMSUNG-)?SM-A125[FM]","model":"Galaxy A12"},{"regex":"(?:SAMSUNG-)?SM-(?:A205(?:U1|YN|[FGSWU])|S205DL)|SC-02M|SCV46","model":"Galaxy A20"},{"regex":"(?:SAMSUNG-)?(?:SM-A215(?:DL|U1|[UW])|SC-42A|SCV49)(?:[);/ ]|$)","model":"Galaxy A21"},{"regex":"(?:SAMSUNG-)?SM-A217[FMN](?:[);/ ]|$)","model":"Galaxy A21s"},{"regex":"(?:SAMSUNG-)?SM-A202[FG]","model":"Galaxy A20e"},{"regex":"(?:SAMSUNG-)?SM-A207[0FM]","model":"Galaxy A20s"},{"regex":"(?:SAMSUNG-)?(?:SM-A305(?:[FGY]N|GT|[FGN])|SCV43)","model":"Galaxy A30"},{"regex":"(?:SAMSUNG-)?SM-A307(?:FN|GN|GT|[FG])","model":"Galaxy A30s"},{"regex":"(?:SAMSUNG-)?SM-A315[FGN](?:[);/ ]|$)","model":"Galaxy A31"},{"regex":"(?:SAMSUNG-)?SM-A325F(?:[);/ ]|$)","model":"Galaxy A32"},{"regex":"(?:SAMSUNG-)?SM-A326(?:BR|B)","model":"Galaxy A32 5G"},{"regex":"(?:SAMSUNG-)?SM-A405(?:F[NM]|S)","model":"Galaxy A40"},{"regex":"(?:SAMSUNG-)?SM-A305[018](?:[);/ ]|$)","model":"Galaxy A40s"},{"regex":"(?:SAMSUNG-)?(?:SM-A415F|SC-41A|SCV48)(?:[);/ ]|$)","model":"Galaxy A41"},{"regex":"(?:SAMSUNG-)?SM-A426[0BN](?:[);/ ]|$)","model":"Galaxy A42 5G"},{"regex":"(?:SAMSUNG-)?SM-(?:A505(?:F[GN]|U1|YN|[FGNUWX])|S506DL|505FN)","model":"Galaxy A50"},{"regex":"(?:SAMSUNG-)?SM-A5070(?:[);/ ]|$)","model":"Galaxy A50s"},{"regex":"(?:SAMSUNG-)?SM-A507FN","model":"Galaxy A50s"},{"regex":"(?:SAMSUNG-)?SM-(?:A515[FUW]|S515DL)","model":"Galaxy A51"},{"regex":"(?:SAMSUNG-)?(?:SM-A516(?:U1|[0BNUV])|SC-54A|SCG07)","model":"Galaxy A51 5G"},{"regex":"(?:SAMSUNG-)?SM-A705(?:GM|[MYF]N|[0FUWX])","model":"Galaxy A70"},{"regex":"(?:SAMSUNG-)?SM-A707[0F]","model":"Galaxy A70s"},{"regex":"(?:SAMSUNG-)?SM-A805[0FNX]","model":"Galaxy A80"},{"regex":"(?:SAMSUNG-)?SM-A908[BN]","model":"Galaxy A90"},{"regex":"(?:SAMSUNG-)?SM-A9080","model":"Galaxy A90 5G"},{"regex":"(?:SAMSUNG-)?SM-F127G(?:[);/ ]|$)","model":"Galaxy F12"},{"regex":"(?:SAMSUNG-)?SM-F415F(?:[);/ ]|$)","model":"Galaxy F41"},{"regex":"(?:SAMSUNG-)?GT-I9301I","model":"Galaxy S III Neo"},{"regex":"(?:SAMSUNG-)?SM-S120VL(?:[);/ ]|$)","model":"Galaxy Luna"},{"regex":"(?:SAMSUNG-)?SM-(?:J100(?:FN|VPP|MU|[FGHMY])|S777C)","model":"Galaxy J1"},{"regex":"(?:SAMSUNG-)?SM-J105[BFHYM]","model":"Galaxy J1 Mini"},{"regex":"(?:SAMSUNG-)?SM-J106[BFHM]","model":"Galaxy J1 mini Prime"},{"regex":"(?:SAMSUNG-)?SM-(?:J120(?:ZN|[AFGHMPTW])|J05H)","model":"Galaxy J1 (2016)"},{"regex":"(?:SAMSUNG-)?SM-(?:J110[FGHLM]|J111[FM])","model":"Galaxy J1 Ace"},{"regex":"(?:SAMSUNG-)?SM-J200[FGHMY]","model":"Galaxy J2"},{"regex":"(?:SAMSUNG-)?SM-J200BT","model":"Galaxy J2 Duos"},{"regex":"(?:SAMSUNG-)?SM-J260AZ","model":"Galaxy J2 Pure"},{"regex":"(?:SAMSUNG-)?SM-(?:J260([AFGMY]|T1)|S260DL)","model":"Galaxy J2 Core"},{"regex":"(?:SAMSUNG-)?SM-J(?:210F|250[FGMNY])","model":"Galaxy J2 Pro"},{"regex":"(?:SAMSUNG-)?SM-(?:S367VL|S357BL)","model":"Galaxy J3 Orbit"},{"regex":"(?:SAMSUNG-)?SM-J311(?:[09]|9S)","model":"Galaxy J3 Pro"},{"regex":"(?:SAMSUNG-)?SM-S320VL(?:[);/ ]|$)","model":"Galaxy J3 Sky"},{"regex":"(?:SAMSUNG-)?SM-S327VL(?:[);/ ]|$)","model":"Galaxy J3 Luna Pro"},{"regex":"(?:SAMSUNG-)?SM-J327(?:T1|[ATW])(?:[);/ ]|$)","model":"Galaxy J3 Prime"},{"regex":"(?:SAMSUNG-)?SM-J327(?:[FP]|R4)","model":"Galaxy J3 Emerge"},{"regex":"(?:SAMSUNG-)?SM-J337R4(?:[);/ ]|$)","model":"Galaxy J3 Aura"},{"regex":"(?:SAMSUNG-)?SM-J337T(?:[);/ ]|$)","model":"Galaxy J3 Star"},{"regex":"(?:SAMSUNG-)?SM-J327V","model":"Galaxy J3 Eclipse"},{"regex":"(?:SAMSUNG-)?SM-S337TL","model":"Galaxy J3 Luna Pro"},{"regex":"(?:SAMSUNG-)?SM-J3109","model":"Galaxy J3 (2015)"},{"regex":"(?:SAMSUNG-)?SM-(?:J300H|J320(?:[ZF]N|R4|W8|YZ|[AFGHMNPVY]))","model":"Galaxy J3 (2016)"},{"regex":"(?:SAMSUNG-)?SM-(?:J330(?:FN|[08FGLN])|J327(?:R7|U))(?:[);/ ]|$)","model":"Galaxy J3 (2017)"},{"regex":"(?:SAMSUNG-)?SM-J337(?:VPP|[AWPUV])(?:[);/ ]|$)","model":"Galaxy J3 (2018)"},{"regex":"(?:SAMSUNG-)?SM-(?:G400[FG]|J400[FGM])","model":"Galaxy J4"},{"regex":"(?:SAMSUNG-)?SM-J500(?:FN|N0|[78FGHMY])(?:[);/ ]|$)","model":"Galaxy J5 (2015)"},{"regex":"(?:SAMSUNG-)?SM-(?:J510(?:[FGMU]N|FQ|[8FGHKLSY])|5108|G510H)(?:[);/ ]|$)","model":"Galaxy J5 (2016)"},{"regex":"(?:SAMSUNG-)?SM-J530","model":"Galaxy J5 (2017)"},{"regex":"(?:SAMSUNG-)?SM-G570[0FMY]","model":"Galaxy J5 Prime"},{"regex":"(?:SAMSUNG-)?SM-J600[FGLN]","model":"Galaxy J6"},{"regex":"(?:SAMSUNG-)?SM-J610[FG]","model":"Galaxy J6+"},{"regex":"(?:SAMSUNG-)?SM-J410[FG]","model":"Galaxy J4 Core"},{"regex":"(?:SAMSUNG-)?SM-J415(?:[FG]N|[FGN])","model":"Galaxy J4+"},{"regex":"(?:SAMSUNG-)?SM-J7[01]0(?:FN|MN|[8FHKM])","model":"Galaxy J7"},{"regex":"(?:SAMSUNG-)?SM-J700P","model":"Galaxy J7 (2015)"},{"regex":"(?:SAMSUNG-)?SM-(?:J700(?:T1|T)|J710GN|J7109)","model":"Galaxy J7 (2016)"},{"regex":"(?:SAMSUNG-)?SM-(?:J730[K]|J727(?:R4|[AFSU]))(?:[);/ ]|$)","model":"Galaxy J7 (2017)"},{"regex":"(?:SAMSUNG-)?SM-J737(?:R4|T1|VPP|[APSTUV])(?:[);/ ]|$)","model":"Galaxy J7 (2018)"},{"regex":"(?:SAMSUNG-)?SM-C710F","model":"Galaxy J7+ (C7)"},{"regex":"(?:SAMSUNG-)?SM-G610[FMY]","model":"Galaxy J7 Prime"},{"regex":"(?:SAMSUNG-)?SM-G611(?:FF|MT|M)","model":"Galaxy J7 Prime 2"},{"regex":"(?:SAMSUNG-)?SM-G615F","model":"Galaxy J7 Max"},{"regex":"(?:SAMSUNG-)?SM-(?:S727VL|S737TL)","model":"Galaxy J7 Sky Pro"},{"regex":"(?:SAMSUNG-)?SM-(?:J7 Pro|J730(?:GM|[FG]))","model":"Galaxy J7 Pro"},{"regex":"(?:SAMSUNG-)?SM-J701[FM]","model":"Galaxy J7 Core"},{"regex":"(?:SAMSUNG-)?SM-J720[FM]","model":"Galaxy J7 Duo"},{"regex":"(?:SAMSUNG-)?SM-(?:S767VL|S757BL)","model":"Galaxy J7 Crown"},{"regex":"(?:SAMSUNG-)?SM-J727[PTV]","model":"Galaxy J7 V"},{"regex":"SM-J7\\\\[7\\\\]","model":"Galaxy J7 7"},{"regex":"(?:SAMSUNG-)?SM-J810","model":"Galaxy J8"},{"regex":"SM-J8 Plus","model":"Galaxy J8 Plus"},{"regex":"SM-J8 Pro","model":"Galaxy J8 Pro"},{"regex":"SM-J9\\\\[7\\\\] Prime","model":"Galaxy J9 7 Prime"},{"regex":"SM-J9\\\\[8\\\\] Pro","model":"Galaxy J9 8 Pro"},{"regex":"(?:SAMSUNG-)?SM-M015[FG]","model":"Galaxy M01"},{"regex":"(?:SAMSUNG-)?SM-M013F","model":"Galaxy M01 Core"},{"regex":"(?:SAMSUNG-)?SM-M017F","model":"Galaxy M01s"},{"regex":"(?:SAMSUNG-)?SM-M025F","model":"Galaxy M02s"},{"regex":"(?:SAMSUNG-)?SM-M105[FGMY]","model":"Galaxy M10"},{"regex":"(?:SAMSUNG-)?SM-M107F","model":"Galaxy M10s"},{"regex":"(?:SAMSUNG-)?SM-M115[FM]","model":"Galaxy M11"},{"regex":"(?:SAMSUNG-)?SM-M127[FG]","model":"Galaxy M12"},{"regex":"(?:SAMSUNG-)?SM-(?:M205(?:[FGMN]|FN)|M20)(?:[);/ ]|$)","model":"Galaxy M20"},{"regex":"(?:SAMSUNG-)?SM-M215F","model":"Galaxy M21"},{"regex":"(?:SAMSUNG-)?SM-(?:M307(?:FN|[0F])|M30s)","model":"Galaxy M30s"},{"regex":"(?:SAMSUNG-)?SM-M305?","model":"Galaxy M30"},{"regex":"(?:SAMSUNG-)?SM-M315F","model":"Galaxy M31"},{"regex":"(?:SAMSUNG-)?SM-M317F","model":"Galaxy M31s"},{"regex":"(?:SAMSUNG-)?SM-M405","model":"Galaxy M40"},{"regex":"(?:SAMSUNG-)?SM-M515F","model":"Galaxy M51"},{"regex":"(?:SAMSUNG-)?SM-W201([689])","model":"Galaxy W201$1"},{"regex":"(?:SAMSUNG-)?SM-W2015","model":"Galaxy Golden 2"},{"regex":"(?:SAMSUNG-)?SM-G910S","model":"Galaxy Round"},{"regex":"(?:SAMSUNG-)?SM-(?:G550(?:FY|T[12]?)|S550TL|G55[01]0|G5520)","model":"Galaxy On5"},{"regex":"(?:SAMSUNG-)?SM-G5528","model":"Galaxy On5 (2016)"},{"regex":"(?:SAMSUNG-)?SM-G600(?:FY|[0F])","model":"Galaxy On7"},{"regex":"(?:SAMSUNG-)?SM-G610[0KLS]","model":"Galaxy On7 (2016)"},{"regex":"(?:SAMSUNG-)?SM-G611[FKLS]","model":"Galaxy On7 Prime"},{"regex":"(?:SAMSUNG-)?SM-C500[0X]","model":"Galaxy C5"},{"regex":"(?:SAMSUNG-)?SM-C501[08]","model":"Galaxy C5 Pro"},{"regex":"(?:SAMSUNG-)?SM-C700[0X]","model":"Galaxy C7"},{"regex":"(?:SAMSUNG-)?SM-C701[08FX]","model":"Galaxy C7 Pro"},{"regex":"(?:SAMSUNG-)?SM-C710[08]","model":"Galaxy C8"},{"regex":"(?:SAMSUNG-)?SM-C900[08FY]","model":"Galaxy C9 Pro"},{"regex":"(?:SAMSUNG-)?SM-Z130H","model":"Galaxy Z1"},{"regex":"(?:SAMSUNG-)?SM-Z200[FMY]","model":"Galaxy Z2"},{"regex":"(?:SAMSUNG-)?SM-Z300H","model":"Galaxy Z3"},{"regex":"(?:SAMSUNG-)?SM-Z400[FY]","model":"Galaxy Z4"},{"regex":"(?:SAMSUNG-)?SM-(?:G150(?:N[0KLS])?|G155S)(?:[);/ ]|$)","model":"Galaxy Folder"},{"regex":"(?:SAMSUNG-)?(?:SM-G16(?:0N|[05]0?|5N))(?:[);/ ]|$)","model":"Galaxy Folder 2"},{"regex":"(?:SAMSUNG-)?SM-J321AZ(?:[);/ ]|$)","model":"Galaxy Sol"},{"regex":"(?:SAMSUNG-)?SM-J326AZ(?:[);/ ]|$)","model":"Galaxy Sol 2"},{"regex":"(?:SAMSUNG-)?SM-J336AZ(?:[);/ ]|$)","model":"Galaxy Sol 3"},{"regex":"(?:SAMSUNG-)?SM-J727AZ(?:[);/ ]|$)","model":"Galaxy Halo"},{"regex":"(?:SAMSUNG-)?SM-J327AZ","model":"Galaxy Amp Prime 2"},{"regex":"(?:SAMSUNG-)?SM-J337AZ","model":"Galaxy Amp Prime 3 (2018)"},{"regex":"(?:SAMSUNG-)?SM-(?:F900[0FUW]|F907[BN])|SCV44","model":"Galaxy Fold","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-F916(?:U1|[0BNQUW])|SCG05","model":"Galaxy Z Fold 2 5G","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9060(?:[);/ ]|$)","model":"Galaxy Grand Neo","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9063","model":"Galaxy Grand Neo Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9(?:080|128)","model":"Galaxy Grand","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9168","model":"Galaxy Grand Neo+","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9082","model":"Galaxy Grand Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-N7000","model":"Galaxy Note","device":"phablet"},{"regex":"(?:SC-01G|SCL24)(?:[);/ ]|$)","model":"Galaxy Note Edge","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N935[FSLK](?:[);/ ]|$)","model":"Galaxy Note Fan Edition","device":"phablet"},{"regex":"(?:SAMSUNG-)?(?:(?:GT-)?N7100|SCH-(?:I605|N719|R950)|SPH-L900)(?:[);/ ]|$)","model":"Galaxy Note II","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-N7105","model":"Galaxy Note II LTE","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G710(?:2T|5[HL]|[25689KLS])?(?:[);/ ]|$)","model":"Galaxy Grand 2","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G720(?:AX|N0|[02])(?:[);/ ]|$)","model":"Galaxy Grand Max"},{"regex":"(?:SAMSUNG-)?SM-(?:G530(?:[689]W|[AF]Z|BT|MU|R[47]|[AFHMPTWY])|G531[FH]|S920L)(?:[);/ ]|$)","model":"Galaxy Grand Prime","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G531(?:BT|[MY])(?:[);/ ]|$)","model":"Galaxy Grand Prime VE Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G532F(?:[);/ ]|$)","model":"Galaxy Grand Prime Plus","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G532MT(?:[);/ ]|$)","model":"Galaxy J2 Prime (TV)","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G532[MG](?:[);/ ]|$)","model":"Galaxy J2 Prime","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N7502(?:[);/ ]|$)","model":"Galaxy Note 3 Neo Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N750[05LQ]?","model":"Galaxy Note 3 Neo","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N9002(?:[);/ ]|$)","model":"Galaxy Note 3 Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-9005(?:[);/ ]|$)","model":"Galaxy Note 3 LTE","device":"phablet"},{"regex":"(?:SAMSUNG-)?(?:SM-N900(?:W8|[05689][VQ]?|[AKLPSTV])?|SCL22|SC-01F(?:[);/ ]|$))","model":"Galaxy Note 3","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-(?:N910|910U)|N9100(?:[);/ ]|$)","model":"Galaxy Note 4","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N916[KLS]","model":"Galaxy Note 4 LTE","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N915","model":"Galaxy Note 4 Edge","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N920(?:R[467]|W8|[0ACFGIKLPSTVX])","model":"Galaxy Note 5","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N9208","model":"Galaxy Note 5 Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G750(?:8Q|[9AFH])","model":"Galaxy Mega 2","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I915[028]","model":"Galaxy Mega 5.8","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I920[05]","model":"Galaxy Mega 6.3","device":"phablet"},{"regex":"(?:SAMSUNG-)?(?:SM-N930(?:R[467]|W8|[0AFKLPSTUVX])|SCV34)","model":"Galaxy Note 7","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?SM-N950|SCV37|SC-01K","model":"Galaxy Note 8","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N960|SCV40|SC-01L)","model":"Galaxy Note 9","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?SM-(?:N970(?:U1|W8|[089DFJKLSUWX])|N971N)","model":"Galaxy Note 10","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?SM-N770[FX]","model":"Galaxy Note 10 Lite","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N975(?:U1|XU|[0CFUWX])|SM-N976[0BVNQU]|SC-01M|SCV45)","model":"Galaxy Note 10+","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N980(?:F/DS|F))","model":"Galaxy Note 20","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N981(?:B/DS|U1|[0BNUW]))","model":"Galaxy Note 20 5G","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N985(?:F/DS|F))","model":"Galaxy Note 20 Ultra","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N986(?:B/DS|U1|[0BNUW])|SC-53A|SCG06)","model":"Galaxy Note 20 Ultra 5G","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-W750V","model":"Ativ SE"},{"regex":"(?:SAMSUNG-)?SM-G310R5","model":"GreatCall Touch 3"},{"regex":"(?:SAMSUNG-)?GT-E2152","model":"E2152","device":"feature phone"},{"regex":"(?:SAMSUNG-)?(GT-(P|N8|N5)[0-9]+[a-z]?)","device":"tablet","model":"$1"},{"regex":"SC-02C","model":"Galaxy S II"},{"regex":"(?:SAMSUNG-)?((?:SM-[TNP]|GT-P)[a-z0-9_\\\\-]+)","device":"tablet","model":"$1"},{"regex":"((?:SCH|SGH|SPH|SHV|SHW|GT|SM)-[a-z0-9_\\\\-]+)","model":"$1"},{"regex":"SMART-TV","device":"tv","model":"Smart TV"},{"regex":"Galaxy ([^/;]+) Build","model":"Galaxy $1"},{"regex":"Galaxy ([a-z0-9]+)","model":"Galaxy $1"},{"regex":"SAMSUNG[\\\\-][ ]?([a-z0-9]+[\\\\-_][a-z0-9]+)","model":"$1"},{"regex":"SAMSUNG;[ ]?([a-z0-9]+[\\\\-_][a-z0-9]+)","model":"$1"},{"regex":"SAMSUNG[ _/\\\\-]?([a-z0-9\\\\-]+)","model":"$1"},{"regex":"SAMSUNG;[ ]?([a-z0-9 ]+)","model":"$1"},{"regex":"SEC-([a-z0-9]+)","model":"$1"},{"regex":"SAM-([a-z0-9]+)","model":"SCH-$1"},{"regex":"(?:portalmmm|o2imode)/2\\\\.0 ([SZ][a-z0-9]+)","model":"$1"},{"regex":"sam([rua][0-9]+)","model":"SCH-$1"}]},"Sanei":{"regex":"(?:8312D|G(60[25]|70[3568]G?|785|803)|N83(?:-2cpu)?|N91) Build","device":"smartphone","models":[{"regex":"N83","model":"N83"},{"regex":"N91","model":"N91"},{"regex":"8312D","model":"G101"},{"regex":"G(60[25]|70[3568]G?|785|803)","model":"G$1"}]},"Selfix":{"regex":"SELFIX","device":"smartphone","models":[{"regex":"SELFIX_SLASH6","model":"Slash 6"},{"regex":"VOYAGER-V45","model":"Voyager V45"}]},"Sencor":{"regex":"Sencor|ELEMENT[ _]?(?:7|8|9\\\\.7|10[ _]1)(?:[ _]?V[23])?(?:[);/ ]|$)|ELEMENT[ _]?(?:P[0-9]+|10.1 Q001)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(?:SENCOR[ _])?Element (10\\\\.1) (Q001)","model":"Element $1\\" $2"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V3","model":"Element 7 V3"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2[ _]BASIC","model":"Element 7 V2 Basic"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2","model":"Element 7 V2"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V3","model":"Element 8 V3"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V2","model":"Element 8 V2"},{"regex":"(?:SENCOR[ _])?ELEMENT8","model":"Element 8"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]9\\\\.7[ _]?V3","model":"Element 9.7 V3"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]9\\\\.7[ _]?V2","model":"Element 9.7 V2"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]9\\\\.7","model":"Element 9.7"},{"regex":"(?:SENCOR[ _])?ELEMENT10[ _]1","model":"Element 10.1"},{"regex":"(?:SENCOR[ _])?(7Q105)(?:[);/ ]|$)","model":"$1"},{"regex":"(?:SENCOR[ _])?ELEMENT[ _]?P([0-9]+)","model":"Element P$1","device":"smartphone"},{"regex":"Sencor[ _]([^;/]+) Build","model":"$1"}]},"Senwa":{"regex":"Senwa|(?:S\\\\-?(?:471|7[12]5|6[01]5|915|905TL|1000|5018)|V705B|LS50F| LS50?|LS5518H|LS5718)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"S-?471(?:[);/ ]|$)","model":"Jazz"},{"regex":"S-?605(?:[);/ ]|$)","model":"City"},{"regex":"S-?905TL(?:[);/ ]|$)","model":"Odin"},{"regex":"S-?1000(?:[);/ ]|$)","model":"Odin"},{"regex":"S-?5018(?:[);/ ]|$)","model":"Inizio"},{"regex":"S-?(615|7[12]5|915)(?:[);/ ]|$)","model":"S$1"},{"regex":"V705B(?:[);/ ]|$)","model":"V705B"},{"regex":"LS50F(?:[);/ ]|$)","model":"Evolution"},{"regex":" LS50(?:[);/ ]|$)","model":"Pegasus"},{"regex":" LS5(?:[);/ ]|$)","model":"Thor"},{"regex":"LS5518H(?:[);/ ]|$)","model":"Sparkly"},{"regex":"LS5718(?:[);/ ]|$)","model":"Diamond"},{"regex":"Senwa[ _-]*([^;/]+)(?: Build|[;)])","model":"$1"}]},"Sky":{"regex":"(?:SKY|Elite|Fuego)[_ ][3-7]\\\\.[05](?:[A-Z]{1,2})?|Elite[ _](?:5_0T|M45|[45]T|45T|GO|M5Plus|T55|T[46]|[AB]5|5_5_Octa)|Platinum[_ ](?:5.0M|5\\\\.5C|5\\\\.0+|M5|[ABCM]4|[ACG]55|[ABDEFG]5|A57|P9|X|UNO|VIEW2|O|4\\\\.0|4_0Plus)|PLATINUMVIEW|SKY[ _](?:55M|Pro_III)","device":"smartphone","models":[{"regex":"Platinum[_ ](?:5\\\\.0M|M5)","model":"Platinum 5.0M"},{"regex":"Platinum[_ ]5\\\\.5C","model":"Platinum 5.5C"},{"regex":"Platinum[_ ]5\\\\.0\\\\+","model":"Platinum 5.0 Plus"},{"regex":"Platinum_4_0Plus","model":"Platinum 4.0 Plus"},{"regex":"Platinum[ _]4\\\\.0","model":"Platinum 4.0"},{"regex":"Platinum[_ ](P9) Pro(?:[);/ ]|$)","model":"Platinum $1 Pro"},{"regex":"Platinum[_ ]([ABCM]4|[ACG]55|[ABDEFG]5|A57|P9|X|UNO|O)(?:[);/ ]|$)","model":"Platinum $1"},{"regex":"Platinum[_ ]?VIEW(2)?(?:[);/ ]|$)","device":"tablet","model":"Platinum View$1"},{"regex":"Elite_5_5_Octa","model":"Elite 5.5 Octa"},{"regex":"Elite M5Plus","model":"Elite M5 Plus"},{"regex":"Elite[ _](M45|Go|[45]T|T[46]|T55|[AB]5|A55|45T)(?:[);/ ]|$)","model":"Elite $1"},{"regex":"Elite[_ ]([3-7])[\\\\._]([05](?:[A-Z]{1,2})?\\\\+?)","model":"Elite $1.$2"},{"regex":"Fuego[_ ]([3-7]\\\\.[05](?:[A-Z]{1,2})?\\\\+?)","model":"Fuego $1"},{"regex":"SKY_Pro_III","model":"Pro III"},{"regex":"SKY 55M","model":"55M"},{"regex":"SKY[_ ]([3-7]\\\\.[05](?:[A-Z]{1,2})?)","model":"$1"}]},"Skyworth":{"regex":"Sky_?worth","device":"tv","models":[{"regex":"Sky_?worth ([^;/]+) Build","model":"$1"}]},"Smartfren":{"regex":"Smartfren|Androtab|Andromax|PD6D1J|AD682J|AD68[89]G|AD6B1H|AD9A1H|AD682H|AD683G","device":"smartphone","models":[{"regex":"S7 Build","model":"Andromax Tab 7.0","device":"tablet"},{"regex":"PD6D1J","model":"Andromax V3s"},{"regex":"AD682J","model":"Andromax T"},{"regex":"AD688G","model":"Andromax C2"},{"regex":"AD689G","model":"Andromax i3"},{"regex":"AD682H","model":"Andromax i3s"},{"regex":"AD6B1H","model":"Andromax G2 Hot"},{"regex":"AD9A1H","model":"Andromax G2"},{"regex":"AD683G","model":"Andromax I"},{"regex":"New Andromax-i","model":"New Andromax I"},{"regex":"Andromax[ _\\\\-]([^/;]+) Build","model":"Andromax $1"},{"regex":"Andromax[ _\\\\-]([a-z0-9]+)","model":"Andromax $1"},{"regex":"Smartfren[ _\\\\-]([^/;\\\\)]+)(?: Build|[/;\\\\)])","model":"$1"},{"regex":"(Androtab[^/;]+) Build","model":"$1","device":"tablet"}]},"Smartisan":{"regex":"(SM(?:70[15]|[89]01|919)|OD10[35]|YQ60[1357]|DE106|DT1901A|O[CE]106|OS103|O[CS]105)[ /;\\\\)]","device":"smartphone","models":[{"regex":"SM70[15]","model":"T1"},{"regex":"SM801","model":"T2"},{"regex":"SM901","model":"M1"},{"regex":"SM919","model":"M1L"},{"regex":"YQ60[1357]","model":"U1"},{"regex":"OD10[35]","model":"Pro"},{"regex":"OS105[ /;\\\\)]","model":"Pro 2"},{"regex":"DE106[ /;\\\\)]","model":"R1"},{"regex":"OE106[ /;\\\\)]","model":"Nut Pro 2s"},{"regex":"OC10[56][ /;\\\\)]","model":"Nut 3"},{"regex":"DT1901A[ /;\\\\)]","model":"Nut Pro 3"},{"regex":"OS103[ /;\\\\)]","model":"JianGuo Pro 2"}]},"STF Mobile":{"regex":"(?:Fractal|AERIAL PLUS|Origins Pro|BLOCK_MINI|BLOCK GO|BLOCK 3|SLAY II)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Fractal","model":"Fractal"},{"regex":"Origins Pro","model":"Origins Pro"},{"regex":"AERIAL PLUS","model":"Aerial Plus"},{"regex":"BLOCK_MINI","model":"Block Mini"},{"regex":"BLOCK 3 mini","model":"Block 3 Mini"},{"regex":"BLOCK 3","model":"Block 3"},{"regex":"BLOCK GO","model":"Block Go"},{"regex":"SLAY II","model":"Slay II"}]},"STK":{"regex":"STK[_ ]","device":"smartphone","models":[{"regex":"STK[_ ]([^/;]+) Build","model":"$1"},{"regex":"STK[_ ]([a-z0-9]+)","model":"$1"}]},"Stonex":{"regex":"STX[ -]([^;/]+)|STONE EVO","device":"smartphone","models":[{"regex":"STX[ -]([^;/]+) Build","model":"$1"},{"regex":"STX[ -]([a-z0-9_-]+)","model":"$1"}]},"SuperSonic":{"regex":"(SC-[0-9]+[a-z]+)","device":"tablet","model":"$1"},"Supra":{"regex":"SUPRA|NVTAB 7.0 3G","device":"smartphone","models":[{"regex":"SUPRA[ _]([^;/)]+)(?: Build|[;)])","device":"tablet","model":"$1"},{"regex":"(NVTAB 7.0 3G)","device":"tablet","model":"$1"}]},"Sumvision":{"regex":"(Cyclone [^/;]+) Build","device":"tablet","model":"$1"},"SunVan":{"regex":"SUNVAN[ _\\\\-]","device":"smartphone","models":[{"regex":"SUNVAN[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"SUNVAN[ _\\\\-]?([^);/ ]+)","model":"$1"}]},"SWISSMOBILITY":{"regex":"(?:SCHR9GR|PRA(?:U8|100)|ZUR(?:722M|70016W?|700[RW]|805A))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"SCHR9GR","model":"SCHON R9"},{"regex":"PRA(U8|100)","model":"PRA$1"},{"regex":"ZUR722M","device":"phablet","model":"Z72 go"},{"regex":"ZUR(70016W?|700[RW]|805A)(?:[);/ ]|$)","device":"tablet","model":"ZUR$1"}]},"Thomson":{"regex":"(?:Primo(7|8)|QM73[45]-8G|QM734-2|QM736-8G\\\\(HD\\\\)|(?<!\\\\.)8950|MID1002|5014G|TEO7RK|Friendly_TH101|Delight TH201)(?:[);/ ]|$)|(?:Tlink|Every)[0-9]+|THOMSON,","device":"tablet","models":[{"regex":"Primo(7|8)","model":"Primo $1"},{"regex":"QM734-2","model":"QM734-2"},{"regex":"QM734-8G","model":"QM734-8G"},{"regex":"QM735-8G","model":"QM735-8G"},{"regex":"QM736-8G\\\\(HD\\\\)","model":"QM736-8G (HD)"},{"regex":"(?<!\\\\.)8950(?:[);/ ]|$)","model":"3G 8950"},{"regex":"TEO7RK(?:[);/ ]|$)","model":"TEO7RK"},{"regex":"5014G(?:[);/ ]|$)","device":"smartphone","model":"5014G"},{"regex":"Tlink([0-9]+)","device":"smartphone","model":"Tlink$1"},{"regex":"Every([0-9]+)","device":"smartphone","model":"Every$1"},{"regex":"Delight TH201","device":"smartphone","model":"Delight TH201"},{"regex":"Friendly_TH101","device":"smartphone","model":"Friendly TH101"},{"regex":"((?:49|55)UC6306|55UC63|32HD55|40FD54|55UD63)","device":"tv","model":"$1"}]},"Tanix":{"regex":"TX5 MAX(?:[);/ ]|$)","device":"tv","model":"TX5 Max"},"Pantech":{"regex":"Pantech|P[GN]-|PT-[a-z0-9]{3,}|(?<!Winmax )TX[T]?[0-9]+|IM-[a-z0-9]+(?:[);/ ]|$)|ADR910L","device":"smartphone","models":[{"regex":"ADR910L","model":"Star Q"},{"regex":"IM-A870K","model":"Vega Iron"},{"regex":"Pantech[ \\\\-]?([a-z0-9]+)","model":"$1"},{"regex":"Pantech_([a-z0-9\\\\-]+)","model":"$1"},{"regex":"(P[GTN]-[a-z0-9]+)","model":"$1"},{"regex":"(TX[T]?[0-9]+)","model":"$1"},{"regex":"(IM-[a-z0-9]+)(?:[);/ ]|$)","model":"$1"}]},"Ployer":{"regex":"MOMO([0-9]|[ ]?mini[ ]?(?:S|3GS)?)","device":"tablet","models":[{"regex":"MOMOminiS","model":"MOMO mini S"},{"regex":"momo mini 3GS","model":"MOMO Mini 3GS"},{"regex":"MOMO([0-9][^);/]*) Build","model":"MOMO $1"},{"regex":"MOMO([0-9][^);/]*)(?:[);/]|$)","model":"MOMO $1"}]},"Plum":{"regex":"PLUM[ _]","device":"smartphone","models":[{"regex":"Z405","model":"Gator 3"},{"regex":"Z407","model":"Axe 4"},{"regex":"Z516","model":"Compass"},{"regex":"Z811","device":"tablet","model":"Optimax 11"},{"regex":"Z709","device":"tablet","model":"Optimax 7"},{"regex":"Z712","device":"tablet","model":"Optimax 12"}]},"Polaroid":{"regex":"Polaroid|(?:PMID|MIDC)[0-9a-z]+(?:[);/ ]|$)|MID(?:1014|0714)|PRO[VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z])|(?:P(?:400[56]|4526|500[56]|502[56]|504[67]|552[56])A|P902/A900|PSPC(?:505|550|[MZL]20A0|K2[01]NA)|SIGMA 5|MIDS145PXE|MIDS747PX|MID4004JBL|MIDS185PR|PSPTD21NA)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"P4005A","model":"Turbo C4"},{"regex":"P5005A","model":"Turbo C5"},{"regex":"P4006A","model":"Turbo D4"},{"regex":"PSPTD21NA","model":"Turbo D2 Plus"},{"regex":"P4526A","model":"Turbo E"},{"regex":"PSPC(505|550)","model":"Cosmo $1"},{"regex":"P5006A","model":"Cosmo K"},{"regex":"P5526A","model":"Cosmo K Plus"},{"regex":"PSPCK20NA","model":"Cosmo K2"},{"regex":"PSPCK21NA","model":"Cosmo K2 Plus"},{"regex":"P5026A","model":"Cosmo L"},{"regex":"PSPCL20A0","model":"Cosmo L2"},{"regex":"PSPCM20A0","model":"Cosmo M2"},{"regex":"P5046A","model":"Cosmo P5s"},{"regex":"P5525A","model":"Cosmo Q5s"},{"regex":"P5047A","model":"Cosmo Z"},{"regex":"PSPCZ20A0","model":"Cosmo Z2"},{"regex":"P5025A","model":"L5s"},{"regex":"PRO4611(?:PR201)?","model":"Pro4611"},{"regex":"PROV400","model":"Agate"},{"regex":"PROV350","model":"ProV350"},{"regex":"SIGMA 5(?:[);/ ]|$)","model":"Sigma 5"},{"regex":"PRO([VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z]))","model":"Pro$1"},{"regex":"PSPT350","model":"Turbo 350 Gris"},{"regex":"MIDS185PR","model":"Pure 10.1\\""},{"regex":"(MID(?:1014|0714|S145PXE|S747PX|4004JBL))","model":"$1","device":"tablet"},{"regex":"((?:PMID|MIDC)[0-9a-z]+)(?:[);/ ]|$)","model":"$1","device":"tablet"},{"regex":"(P902/A900)(?:[);/ ]|$)","model":"$1","device":"tablet"},{"regex":"Polaroid","model":"","device":"tablet"}]},"PolyPad":{"regex":"POLY ?PAD","device":"tablet","models":[{"regex":"POLY ?PAD[_ \\\\.]([a-z0-9]+)(?:[);/ ]|$)","model":"$1"},{"regex":"POLY ?PAD[_\\\\.]([a-z0-9]+)","model":"$1"}]},"Polytron":{"regex":"POLYTRON|W8480|W7430|PW1100S|W7550|W7531|W8570|R2401","device":"smartphone","models":[{"regex":"R2508","model":"Rocket"},{"regex":"POLYTRON[ _]R1500","model":"Rocket Q-Five"},{"regex":"R2401","model":"Rocket 2X"},{"regex":"POLYTRON[ _-]R2402","model":"Rocket R2402"},{"regex":"POLYTRON[ _-]R2403","model":"Rocket R1"},{"regex":"POLYTRON[ _-]R2406","model":"Rocket R2"},{"regex":"POLYTRON[ _-]R2407","model":"Rocket R3"},{"regex":"POLYTRON[ _-]R2452","model":"Rocket S1"},{"regex":"POLYTRON[ _-]R2457","model":"Rocket S2"},{"regex":"POLYTRON[ _-]R2501","model":"Rocket T1"},{"regex":"POLYTRON[ _-]R2507","model":"Rocket T3"},{"regex":"POLYTRON[ _-]R2509SE","model":"Rocket T6 SE"},{"regex":"POLYTRON[ _-]R2509","model":"Rocket T6"},{"regex":"POLYTRON[ _-]R250A","model":"Rocket T7"},{"regex":"POLYTRON[ _-]R2506","model":"Rocket T4"},{"regex":"POLYTRON[ _-](?:R3450|W1400)","model":"Rocket Jetz"},{"regex":"POLYTRON[ _-]R3500","model":"Rocket Jetz 5.0"},{"regex":"4G450","model":"Zap 5"},{"regex":"W6500","model":"Quadra Rocket"},{"regex":"W7452","model":"Quadra S2"},{"regex":"W7550","model":"Quadra V5"},{"regex":"W8570","model":"Quadra V7"},{"regex":"POLYTRON[ _]L501","model":"Rocket L501"},{"regex":"POLYTRON[ _]P520","model":"Prime 7S"},{"regex":"POLYTRON[ _]P552","model":"Prime 7 Pro"},{"regex":"4G500","model":"Zap 6 Cleo"},{"regex":"W8480","model":"Crystal 4 W8480"},{"regex":"W7531","model":"Wizard V"},{"regex":"W7430","model":"Quadra Mini W7430"},{"regex":"POLYTRON[ _]4G501","model":"Zap 6 Posh"},{"regex":"POLYTRON[ _]4G502","model":"Zap 6 Power"},{"regex":"POLYTRON[ _]4G503","model":"Zap 6 Flaz"},{"regex":"POLYTRON[_ ]?[ _]4G550","model":"Zap 6 Note"},{"regex":"POLYTRON[ _]4G551","model":"Zap 6 Posh Note"},{"regex":"PW1100S","model":"PW1100S"},{"regex":"Q2352","model":"Q2352"},{"regex":"POLYTRON[ _]T7800","model":"Cosmica T7800","device":"tablet"},{"regex":"POLYTRON[ _]T7700","model":"Rocket Pad","device":"tablet"}]},"Positivo":{"regex":"YPY_S450","device":"smartphone","models":[{"regex":"YPY_S450","model":"YPY S450"}]},"Prestigio":{"regex":"Prestigio 5500 DUO|(?:PMP|PAP|PMT|PSP|PGPS)[0-9]+[a-z0-9_]+(?:[);/ ]|$)|Muze C3","device":"tablet","models":[{"regex":"PMT3277_3G","model":"MultiPad Ranger 7.0 3G"},{"regex":"PGPS7799CIS08GBPG(?:[);/ ]|$)","model":"Geo Vision Tour 3"},{"regex":"PGPS7797(?:[);/ ]|$)","model":"Geo Vision Tour 2"},{"regex":"PMT3201_4G","model":"Grace 4G"},{"regex":"PSP5551DUO","model":"Grace S5"},{"regex":"PMT3287_3G","model":"MultiPad Ranger 8.0 3G"},{"regex":"Prestigio 5500 DUO","model":"MultiPhone 5500 Duo","device":"smartphone"},{"regex":"PMT3208[_ ]3G","model":"MultiPad Wize 8.0 3G"},{"regex":"PSP7546DUO([ _][A-Z]{2})?","model":"X Pro"},{"regex":"PSP7610DUO([ _][A-Z]{2})?","model":"S Max"},{"regex":"(PM[PT][0-9]+[a-z0-9_]+)(?:[);/ ]|$)","model":"$1"},{"regex":"((?:PAP|PSP)[0-9]+[a-z0-9_]+(?: DUO)?)(?:[);/ ]|$)","model":"$1","device":"smartphone"},{"regex":"Muze C3(?:[);/ ]|$)","model":"Muze C3","device":"smartphone"}]},"Sanyo":{"regex":"Sanyo|MobilePhone[ ;]","device":"feature phone","models":[{"regex":"SCP-?6750","model":"Katana Eclipse X"},{"regex":"SCP-?6760","model":"Incognito"},{"regex":"SCP-?6780","model":"Innuendo"},{"regex":"SANYO[ /_-]([a-z0-9\\\\-]+)","model":"$1"},{"regex":"MobilePhone ([a-z0-9\\\\-]+)","model":"$1"}]},"Qilive":{"regex":"Qilive [0-9][^;/]*|Q(7S5[5]?IN4G|7T10INP|8T10IN|8S55IN4G2|8S[56]IN4G|9T9IN|9T(?:7|10)IN4G|9S55IN4G|10S5[37]IN4G|10S[56]IN4G|10S[56]IN4GR|9S5IN4G|6T7IN)","device":"smartphone","models":[{"regex":"Q7S5IN4G","model":"Q7 5.0\\" 4G"},{"regex":"Q7S55IN4G","model":"Q7 5.5\\" 4G"},{"regex":"Q8S55IN4G2","model":"Q8 5.5\\" 4G"},{"regex":"Q8S6IN4G","model":"Q8 6.0\\" 4G"},{"regex":"Q8S5IN4GP","model":"Q8 5.1\\" 4G"},{"regex":"Q9S5IN4G","model":"Q9 5.0\\" 4G"},{"regex":"Q9S55IN4G","model":"Q9 5.5\\" 4G"},{"regex":"Q10S53IN4G","model":"Q10 5.3\\" 4G"},{"regex":"Q10S57IN4G","model":"Q10 5.7\\" 4G"},{"regex":"Q10S5IN4G[R]?","model":"Q10 5.0\\" 4G"},{"regex":"Q10S6IN4G","model":"Q10 6.0\\" 4G"},{"regex":"Q6T7IN","model":"Q6","device":"tablet"},{"regex":"Q7T10INP","model":"Q7 10.1\\"","device":"tablet"},{"regex":"Q8T10IN","model":"Q8 10.1\\"","device":"tablet"},{"regex":"Q9T7IN4G","model":"Q9 7.0\\" 4G","device":"tablet"},{"regex":"Q9T9IN","model":"Q9 9.0\\"","device":"tablet"},{"regex":"Q9T10IN4G","model":"Q9 10.1\\" 4G","device":"tablet"},{"regex":"Qilive ([0-5][^;/]*) Build","model":"$1"},{"regex":"Qilive ([0-5][^;/]*)/","model":"$1"},{"regex":"Qilive ([6-9][^;/]*) Build","model":"$1","device":"tablet"},{"regex":"Qilive ([6-9][^;/]*)/","model":"$1","device":"tablet"}]},"QMobile":{"regex":"QMobile|QTab(?!10EW)|Q-Smart|(?:E2 Noir|Noir X1S|LUNA PRO|NICE S|JazzX JS(?:[27]|10)(?: PRO)?|LT[57]00 PRO|LT950|Q Infinity|Hot Pro 2)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"JazzX JS7 PRO","model":"Jazz X JS7 Pro"},{"regex":"JazzX JS(2|10)","model":"Jazz X JS$1"},{"regex":"Noir X1S","model":"Noir X1S"},{"regex":"E2 Noir","model":"E2 Noir"},{"regex":"Hot Pro 2","model":"Hot Pro 2"},{"regex":"LT([57]00) PRO","model":"Noir LT$1 Pro"},{"regex":"LUNA PRO","model":"Luna Pro"},{"regex":"NICE S","model":"Nice S"},{"regex":"Q Infinity PRO","model":"Q Infinity Pro"},{"regex":"Q Infinity E Lite","model":"Q Infinity E Lite"},{"regex":"Q Infinity ([FCB])","model":"Q Infinity $1"},{"regex":"(LT950)(?:[);/ ]|$)","model":"$1"},{"regex":"QTab[ _-]([^;/]+) Build","model":"$1 Tab","device":"tablet"},{"regex":"QTab[ _-]([^;/)]+)(?:[;/)]|$)","model":"$1 Tab","device":"tablet"},{"regex":"(?:QMobile|Q-Smart)[ _-]([^;/]+) Build","model":"$1"},{"regex":"(?:QMobile|Q-Smart)[ _-]([^;/)]+)(?:[;/)]|$)","model":"$1"},{"regex":"Q Infinity","model":"Q Infinity"}]},"Maximus":{"regex":"Maximus[ _]|(Noir X)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:Maximus[ _])?(Noir X|D1)(?:[);/ ]|$)","model":"$1"},{"regex":"Maximus_(T2)","device":"tablet","model":"$1"}]},"Quantum":{"regex":"Quantum (?:Fit|MUV (?:PRO|UP)|Go|Mini|V|You [2E])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Quantum (Fit|Go|Mini|V|You [2E])(?:[);/ ]|$)","model":"$1"},{"regex":"Quantum MUV PRO(?:[);/ ]|$)","model":"MUV Pro"},{"regex":"Quantum MUV UP(?:[);/ ]|$)","model":"MUV Up"}]},"Quechua":{"regex":"Quechua Phone 5","device":"smartphone","model":"Quechua Phone 5"},"Ramos":{"regex":"Ramos ?([^/;]+) Build|MOS1(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(MOS1)(?:[);/ ]|$)","model":"$1"},{"regex":"Ramos ?([^/;]+) Build","model":"$1"}]},"Razer":{"regex":"Phone 2","device":"smartphone","model":"Phone 2"},"Sendo":{"regex":"Sendo([a-z0-9]+)","device":"feature phone","model":"$1"},"Turbo-X":{"regex":"Turbo-X|Hive V 3G|Turbox_S3","device":"smartphone","models":[{"regex":"Turbox_S3","model":"S3"},{"regex":"Turbo-X_A2(?:[);/ ]|$)","model":"A2"},{"regex":"Turbo-X_e3(?:[);/ ]|$)","model":"E3"},{"regex":"Turbo-X Ice(?:[);/ ]|$)","device":"tablet","model":"Ice"},{"regex":"Hive V 3G(?:[);/ ]|$)","device":"tablet","model":"Hive V 3G"},{"regex":"Turbo-X Tablet([^;/]+) Build","device":"tablet","model":"Tablet$1"},{"regex":"Turbo-X ([^;/]+) Build","model":"$1"}]},"Turbo":{"regex":"Turbo[_ ]?(?:X5[_ ]?(?:Max|Black|Space|Hero)|X8|X6[ _]Z|X[ _]Ray)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"TurboX5Space(?:[);/ ]|$)","model":"X5 Space"},{"regex":"TurboX5Hero(?:[);/ ]|$)","model":"X5 Hero"},{"regex":"TurboX[ _]Ray(?:[);/ ]|$)","model":"X Ray"},{"regex":"Turbo[ _]?X5[ _]?Black(?:[);/ ]|$)","model":"X5 Black"},{"regex":"Turbo[ _]X5[ _]Max(?:[);/ ]|$)","model":"X5 Max"},{"regex":"Turbo[ _]X6[ _]Z(?:[);/ ]|$)","model":"X6 Z"},{"regex":"Turbo[ _]X8(?:[);/ ]|$)","model":"X8"}]},"Silent Circle":{"regex":"Blackphone 2","device":"smartphone","model":"Blackphone 2"},"Sigma":{"regex":"Sigma(?!Designs)|(X[_-]Style[ _]?Tab[_ ]A([0-9]{2,3})|X[-_ ]?treme[-_ ]?PQ[0-9]{2}|X-Style_S5501)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:Sigma[ _])?X[-_ ]?treme[-_ ]?PQ([0-9]{2})(?:[);/ ]|$)","model":"X-Treme PQ$1"},{"regex":"X[_-]Style[ _]?Tab[_ ]A([0-9]{2,3})(?:[);/ ]|$)","model":"X-Style Tab A$1","device":"tablet"},{"regex":"(?:Sigma[ _])?X[-_ ]?Style[-_ ]S([0-9]+)(?:[);/ ]|$)","model":"X-Style S$1"}]},"Spice":{"regex":"(?<![\\\\d];)Spice","device":"smartphone","models":[{"regex":"Spice[ _\\\\-]?([^/;]+)(?:[\\\\)]| Build)","model":"$1"},{"regex":"Spice[ _\\\\-]?([^/;]+)(?:/|$)","model":"$1"}]},"Sharp":{"regex":"SHARP|SBM|SH-?[0-9]+[a-z]?(?:[);/ ]|$)|AQUOS|(?:SH-M0[14-9]|SH-M1[1-6](?:-y)?|S[357]-SH|SH-[MZ](10|01)|SH-[CL]02|SH-RM(?:1[125]|02)|[34]04SH|401SH|[45]02SH|306SH|[36]05SH|70[1246]SH|80[138]SH|90[1678]SH|50[3679]SH|SHL2[25]|SHV4[0-8]|SHV3[1-9](?:[-_]u)?|FS80(?:1[08]|32|28|0[29])|TG-L900S|NP601SH|403SH|603SH|SHF3[134]|SHV4[035][-_]u|SW001SH|SHG0[123]|X4-SH|A002SH|SH-A01|DM-01J|SH-D01|A001SH|606SH|FS801[56]|d-41A|NP80[567]SH|NP501SH)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"506SH(?:[);/ ]|$)","model":"Aquos Xx3"},{"regex":"603SH(?:[);/ ]|$)","model":"Aquos Xx3 Mini"},{"regex":"50[23]SH(?:[);/ ]|$)","model":"Aquos Xx2"},{"regex":"[34]04SH(?:[);/ ]|$)","model":"Aquos Xx"},{"regex":"606SH(?:[);/ ]|$)","model":"Aquos ea"},{"regex":"507SH(?:[);/ ]|$)","model":"Android One"},{"regex":"S3-SH(?:[);/ ]|$)","model":"Android One S3"},{"regex":"S5-SH(?:[);/ ]|$)","model":"Android One S5"},{"regex":"S7-SH(?:[);/ ]|$)","model":"Android One S7"},{"regex":"X4-SH(?:[);/ ]|$)","model":"Android One X4"},{"regex":"SH-M04(?:[);/ ]|$)","model":"Aquos SH-M04"},{"regex":"SH-M05(?:[);/ ]|$)","model":"Aquos Sense Lite"},{"regex":"SH-M07(?:[);/ ]|$)","model":"Aquos Sense Plus"},{"regex":"SHG03(?:[);/ ]|$)","model":"Aquos Sense 5G"},{"regex":"SH-D01(?:[);/ ]|$)","model":"Aquos D10"},{"regex":"SH-M12(?:-y)?(?:[);/ ]|$)","model":"Aquos S3 Dual SIM"},{"regex":"(?:SH-[MZ]10|801SH)(?:[);/ ]|$)","model":"Aquos Zero"},{"regex":"(?:SH-M13|906SH)(?:[);/ ]|$)","model":"Aquos Zero 2"},{"regex":"(?:SHG02|A002SH)(?:[);/ ]|$)","model":"Aquos Zero 5G Basic"},{"regex":"SH-Z01(?:[);/ ]|$)","model":"Aquos S2 (C10)"},{"regex":"(?:SH-02E|SH-01[GH]|SH-04H)(?:[);/ ]|$)","model":"Aquos Phone Zeta"},{"regex":"SH-?06D(?:[);/ ]|$)","model":"Aquos Phone SH-06D"},{"regex":"(SHL2[25]|SH-M01)(?:[);/ ]|$)","model":"Aquos Phone $1"},{"regex":"SH-L02(?:[);/ ]|$)","model":"Aquos L2"},{"regex":"(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)","model":"Aquos R"},{"regex":"(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)","model":"Aquos R"},{"regex":"(?:701SH|SHV41|SH-M06)(?:[);/ ]|$)","model":"Aquos R Compact"},{"regex":"(?:SH-M09|SHV42|706SH|SH-03K)(?:[);/ ]|$)","model":"Aquos R2"},{"regex":"803SH(?:[);/ ]|$)","model":"Aquos R2 Compact"},{"regex":"(?:908SH|SHG01|SH-M14)(?:[);/ ]|$)","model":"Aquos R5G"},{"regex":"SH-M16(?:[);/ ]|$)","model":"Aquos S4 Plus"},{"regex":"SH-M15(?:[);/ ]|$)","model":"Aquos S4 SIM"},{"regex":"SH-C02(?:[);/ ]|$)","model":"Aquos V"},{"regex":"(SHF3[134])(?:[);/ ]|$)","model":"Aquos K $1"},{"regex":"704SH(?:[);/ ]|$)","model":"Simple Smartphone 4"},{"regex":"(?:SH-02J|SH-04G)(?:[);/ ]|$)","model":"Aquos Ever"},{"regex":"SH-02H(?:[);/ ]|$)","model":"Aquos Compact"},{"regex":"30[56]SH(?:[);/ ]|$)","model":"Aquos Crystal"},{"regex":"402SH(?:[);/ ]|$)","model":"Aquos Crystal X"},{"regex":"403SH(?:[);/ ]|$)","model":"Aquos Crystal 2"},{"regex":"509SH(?:[);/ ]|$)","model":"Aquos 3"},{"regex":"NP601SH(?:[);/ ]|$)","model":"Aquos 2"},{"regex":"(?:SHV40|SHV3[24])(?:_u)?(?:[);/ ]|$)","model":"Aquos S"},{"regex":"702SH(?:[);/ ]|$)","model":"Aquos S Basic"},{"regex":"SHV3[183](?:[);/ ]|$)","model":"Aquos S Mini"},{"regex":"(?:FS8010|SH-M08|SHV43(?:-u)?|SH-01[KL])(?:[);/ ]|$)","model":"Aquos S2"},{"regex":"FS8016(?:[);/ ]|$)","model":"Aquos S2 Plus"},{"regex":"(?:SHV46|SH-R?M11|901SH)(?:[);/ ]|$)","model":"Aquos S3 Plus"},{"regex":"(?:SHV44|808SH|SH-04L|SH-03G)(?:[);/ ]|$)","model":"Aquos R3"},{"regex":"(?:FS8032|FS8015|SH-02M|SHV45(?:-U)?)(?:[);/ ]|$)","model":"Aquos S3"},{"regex":"FS8018(?:[);/ ]|$)","model":"Aquos S3 Mini"},{"regex":"(?:SHV48|907SH)(?:[);/ ]|$)","model":"Aquos S3 Basic"},{"regex":"SH-RM12(?:[);/ ]|$)","model":"Aquos S3 Lite"},{"regex":"SH-RM15(?:[);/ ]|$)","model":"Aquos S4 Lite"},{"regex":"SH-51A(?:[);/ ]|$)","model":"Aquos R5G"},{"regex":"SHV3[57](?:_u)?(?:[);/ ]|$)","model":"Aquos U"},{"regex":"TG-L900S(?:[);/ ]|$)","model":"Luna S"},{"regex":"SH-A01(?:[);/ ]|$)","model":"B10"},{"regex":"(?:FS8002|SHV47)(?:[);/ ]|$)","model":"Z2"},{"regex":"FS8009(?:[);/ ]|$)","model":"Z3"},{"regex":"FS8028(?:[);/ ]|$)","model":"R1S"},{"regex":"SHV36(?:[);/ ]|$)","model":"Basio 2"},{"regex":"SW001SH(?:[);/ ]|$)","model":"Star Wars"},{"regex":"SH-RM02","model":"Aquos SH-RM02"},{"regex":"401SH","model":"Aquos 401SH"},{"regex":"DM-01J","model":"Disney Mobile DM-01J"},{"regex":"A001SH","model":"Simple Sumaho 5"},{"regex":"NP80[56]SH","model":"Aquos Keitai 3"},{"regex":"NP807SH","model":"Aquos Keitai 10"},{"regex":"NP501SH","model":"Aquos Keitai"},{"regex":"SH-08E(?:[);/ ]|$)","device":"tablet","model":"Sharp Aquos Pad"},{"regex":"d-41A(?:[);/ ]|$)","device":"tablet","model":"dtab d-41A"},{"regex":"(LC-(?:[0-9]{2})[a-z0-9]+)(?:[);/ ]|$)","device":"tv","model":"$1"},{"regex":"SHARP-AQUOS|AQUOSBrowser","device":"tv","model":"Aquos Net Plus"},{"regex":"SHARP[ \\\\-]([a-z0-9\\\\-]+)","model":"$1"},{"regex":"(?:SHARP|SBM)([a-z0-9]+)","model":"$1"},{"regex":"(SH-?[0-9]+[a-z]?)(?:[);/ ]|$)","model":"$1"}]},"Simply":{"regex":"(NP602SI)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Softbank":{"regex":"Softbank|J-PHONE","device":"smartphone","models":[{"regex":"Softbank/[12]\\\\.0/([a-z0-9]+)","model":"$1"},{"regex":"([a-z0-9]+);Softbank;","model":"$1"},{"regex":"J-PHONE/[0-9]\\\\.[0-9]/([a-z0-9\\\\-]+)","model":"$1"}]},"Sonim":{"regex":"Sonim[ -]|XP(?:[67]7|88)00(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Sonim-XP3400","model":"XP3400","device":"feature phone"},{"regex":"XP6700(?:[);/ ]|$)","model":"XP6700"},{"regex":"XP7700(?:[);/ ]|$)","model":"XP7700"},{"regex":"XP8800(?:[);/ ]|$)","model":"XP8"}]},"Star":{"regex":"N(9[5678]00|8800|9000|9977)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"N9000","model":"Note 3"},{"regex":"N(9[5678]00|8800|9977)(?:[);/ ]|$)","model":"N$1"}]},"Starmobile":{"regex":"(?:Starmobile (?:Play (?:Neo|Spark|GO|Click))|UP[_ ](?:Sense|Rave|Groove|Prime|Selfie|Xtreme|XL))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Starmobile PLAY GO(?:[);/ ]|$)","model":"Play Go"},{"regex":"Starmobile Play (Neo|Spark|Click)(?:[);/ ]|$)","model":"Play $1"},{"regex":"UP[_ ](Sense|Rave|Groove|Prime|Selfie|Xtreme|XL)(?:[);/ ]|$)","model":"UP $1"}]},"Amazon":{"regex":"KF(?:OT|ONWI|TT|JWI|JWA|[DFS]OWI|A[PRSU]WI|T[BH]WI|SAW[IA]|GIWI|KAWI|MAWI|MEWI|MUWI|SUWI)(?:[);/ ]|$)|Kindle|Silk/\\\\d+\\\\.\\\\d+|AlexaMediaPlayer|Amazon (?:Tate|Jem)|AFT[ABMNRST]|SD4930UR|AEO(BC|KN)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"AFTA","model":"Fire TV Cube (Gen 1)","device":"tv"},{"regex":"AFTR","model":"Fire TV Cube (Gen 2)","device":"tv"},{"regex":"AFTN","model":"Fire TV (Gen 3)","device":"tv"},{"regex":"AFTB","model":"Fire TV","device":"tv"},{"regex":"AFT[MST]","model":"Fire TV stick","device":"tv"},{"regex":"KFFOWI(?:[);/ ]|$)","model":"Fire 7\\""},{"regex":"KFMUWI(?:[);/ ]|$)","model":"Fire 7\\" (2019)"},{"regex":"KFTT(?:[);/ ]|$)","model":"Kindle Fire HD"},{"regex":"KFJWI(?:[);/ ]|$)|Amazon Jem","model":"Kindle Fire HD 8.9\\" WiFi"},{"regex":"KFJWA(?:[);/ ]|$)","model":"Kindle Fire HD 8.9\\" 4G"},{"regex":"KFSOWI(?:[);/ ]|$)|Amazon Tate","model":"Kindle Fire HD 7\\" WiFi"},{"regex":"KFTHWI(?:[);/ ]|$)","model":"Kindle Fire HDX 7\\" WiFi"},{"regex":"KFTHWA(?:[);/ ]|$)","model":"Kindle Fire HDX 7\\" 4G"},{"regex":"KFAPWI(?:[);/ ]|$)","model":"Kindle Fire HDX 8.9\\" WiFi"},{"regex":"KFAPWA(?:[);/ ]|$)","model":"Kindle Fire HDX 8.9\\" 4G"},{"regex":"KFARWI(?:[);/ ]|$)","model":"Fire HD 6"},{"regex":"KFASWI(?:[);/ ]|$)","model":"Fire HD 7"},{"regex":"KFAUWI(?:[);/ ]|$)","model":"Fire HD 7 (2017)"},{"regex":"KFMEWI(?:[);/ ]|$)","model":"Fire HD 8 (2015)"},{"regex":"KFGIWI(?:[);/ ]|$)","model":"Fire HD 8 (2016)"},{"regex":"KFDOWI(?:[);/ ]|$)","model":"Fire HD 8 (2017)"},{"regex":"KFKAWI(?:[);/ ]|$)","model":"Fire HD 8 (2018)"},{"regex":"KFONWI(?:[);/ ]|$)","model":"Fire HD 8 (2020)"},{"regex":"KFSAWI(?:[);/ ]|$)","model":"Fire HDX 8.9"},{"regex":"KFSAWA(?:[);/ ]|$)","model":"Fire HDX 8.9 4G"},{"regex":"KFTBWI(?:[);/ ]|$)","model":"Fire HD 10"},{"regex":"KFSUWI(?:[);/ ]|$)","model":"Fire HD 10 (2017)"},{"regex":"KFMAWI(?:[);/ ]|$)","model":"Fire HD 10 (2019)"},{"regex":"SD4930UR","model":"Fire Phone","device":"smartphone"},{"regex":"KFOT|Kindle Fire|Silk/\\\\d+\\\\.\\\\d+","model":"Kindle Fire"},{"regex":"Kindle","model":"Kindle"},{"regex":"AEO(BC|KN)(?:[);/ ]|$)","model":"Echo","device":"smart speaker"},{"regex":"AlexaMediaPlayer","model":"Alexa","device":"smart speaker"}]},"Symphony":{"regex":"SYMPHONY[ \\\\_]([a-z0-9]+)|(?:roar[ _](?:V20|V78|E80|V150))|roarV95|ZVIII(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ZVIII","model":"ZVIII"},{"regex":"roar[ _]?(V20|E80|V78|V95|V150)(?:[);/ ]|$)","model":"Roar $1"},{"regex":"SYMPHONY[ \\\\_]([a-z0-9]+)","model":"$1"}]},"Helio":{"regex":"Helio (S60|S5)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Syrox":{"regex":"(SYX-(?:T70[04]|T10[12]))(?:[);/ ]|$)","device":"tablet","model":"$1"},"Qtek":{"regex":"Qtek[ _]?([a-z0-9]+)","device":"smartphone","model":"$1"},"Q-Touch":{"regex":"( Q09|QS701|Q05A)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"G-Touch":{"regex":"GTouch[_ ]|(?:Stella (?:XS?|Omega))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Stella (XS?|Omega)","model":"Stella $1"},{"regex":"GTouch[_ ]STELLA","model":"Stella"}]},"T-Mobile":{"regex":"T-Mobile[ _][a-z0-9 ]+|(?:REVVLRY|REVVL 2(?: PLUS)?|5062[ZW]|5007[ZW])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"5062[ZW]","model":"REVVL 4 Plus"},{"regex":"5007[ZW]","model":"REVVL 4"},{"regex":"REVVL 2 PLUS","model":"REVVL 2 Plus"},{"regex":"REVVLRY","model":"REVVL Plus"},{"regex":"REVVL 2(?:[);/ ]|$)","model":"REVVL 2"},{"regex":"T-Mobile[ _]([a-z0-9_ ]+) Build","model":"$1"},{"regex":"T-Mobile[ _]([a-z0-9_ ]+)","model":"$1"}]},"TB Touch":{"regex":"Ignis [89]","device":"tablet","models":[{"regex":"Ignis ([89])","model":"Ignis $1"}]},"Teclast":{"regex":"Teclast|TLA002|TLA016|X98 Air III|M20_4G|X98 Air II\\\\(HG5N\\\\)|Tbook|X80 Power\\\\(B2N4\\\\)|(?:T30|P80X|P20HD|P10_HD|M40)_(?:ROW|EEA)|T10\\\\(E3C6\\\\)|P10S\\\\(N4H5\\\\)|98\\\\(M1E[45789]\\\\)|98\\\\(M3E3\\\\)","device":"tablet","models":[{"regex":"Tbook[_ -]([^;/]+) Build","model":"Tbook $1"},{"regex":"T10\\\\(E3C6\\\\)","model":"T10"},{"regex":"T30_(ROW|EEA)","model":"T30 $1"},{"regex":"P80X_(ROW|EEA)","model":"P80X $1"},{"regex":"P10S\\\\(N4H5\\\\)","model":"P10S"},{"regex":"P20HD_(?:ROW|EEA)","model":"P20HD"},{"regex":"M40_(?:ROW|EEA)","model":"M40"},{"regex":"P10_HD_(?:ROW|EEA)","model":"P10HD"},{"regex":"M20_4G","model":"M20 4G"},{"regex":"TLA002","model":"M30 4G"},{"regex":"TLA016","model":"M16"},{"regex":"98\\\\(M1E[45789]\\\\)|98\\\\(M3E3\\\\)","model":"TPad 98 10.1\\" 4G"},{"regex":"X80 Power\\\\(B2N4\\\\)(?:[);/ ]|$)","model":"X98 Power"},{"regex":"X98 Air III(?:[);/ ]|$)","model":"X98 Air III"},{"regex":"X98 Air II\\\\(HG5N\\\\)(?:[);/ ]|$)","model":"X98 Air II"},{"regex":"Teclast[_ -]([^;/]+) Build","model":"$1"}]},"Tecno Mobile":{"regex":"Tecno|Phantom6|Phantom6-Plus|DP7C Pro-SGA1","device":"smartphone","models":[{"regex":"Phantom6-Plus","model":"Phantom 6 Plus"},{"regex":"Phantom6","model":"Phantom 6"},{"regex":"TECNO-W3","model":"W3"},{"regex":"TECNO[ _]F4 Pro(?:[);/ ]|$)","model":"F4 Pro"},{"regex":"TECNO[ _]KE5j(?:[);/ ]|$)","model":"Spark 6 Go"},{"regex":"TECNO[ _]ID6(?:[);/ ]|$)","model":"Camon iClick 2"},{"regex":"Tecno[ _]7C(?:[);/ ]|$)","model":"DroidPad 7C","device":"tablet"},{"regex":"DP7C Pro-SGA1(?:[);/ ]|$)","model":"DroidPad 7C Pro","device":"tablet"},{"regex":"TECNO[ _]DP10A Pro(?:[);/ ]|$)","model":"DroidPad 10A Pro","device":"tablet"},{"regex":"TECNO[ _]P904(?:[);/ ]|$)","model":"DroidPad 10D 4G","device":"tablet"},{"regex":"Tecno[ _]CB7[j]?","model":"Camon i4"},{"regex":"Tecno[ _]CF7(?:[);/ ]|$)","model":"Camon 11"},{"regex":"Tecno[ _]CC6(?:[);/ ]|$)","model":"Camon 12 Air"},{"regex":"Tecno[ _]CC7(?:[);/ ]|$)","model":"Camon 12"},{"regex":"Tecno[ _]KC8(?:[);/ ]|$)","model":"Spark 4"},{"regex":"Tecno[ _]BB4k(?:[);/ ]|$)","model":"Spark 4 Lite"},{"regex":"Tecno[ _]KD7(?:[);/ ]|$)","model":"Spark 5 Pro"},{"regex":"Tecno[ _]DP8D(?:[);/ ]|$)","model":"DroidPad 8D","device":"tablet"},{"regex":"Tecno[ _]LB8","model":"Pouvoir 3 Plus"},{"regex":"TECNO S9","device":"phablet","model":"S9"},{"regex":"Tecno ([^;/]+) Build","model":"$1"},{"regex":"Tecno[ _]?([a-z0-9_\\\\-]+)","model":"$1"}]},"TechPad":{"regex":"Tech ?pad|XTAB[ _-]|Dual C1081HD|S813G","device":"tablet","models":[{"regex":"S813G","model":"S813G"},{"regex":"TechPad10QC","model":"10QC"},{"regex":"TechPad_10xx","model":"10XX"},{"regex":"TechPad703","model":"703"},{"regex":"TechPad[_ ](10Y|9x|i700)","model":"$1"},{"regex":"TechPad[_ ]3Gx","model":"3Gx"},{"regex":"Dual C1081HD","model":"XTAB C1081HD"},{"regex":"XTAB[ _-]([^/;]+) Build","model":"XTAB $1"},{"regex":"Tech ?pad[ _-]([^/;)]+)(?: Build|[;)])","model":"$1","device":"smartphone"}]},"Tesco":{"regex":"Hudl (?:[^/;]+)(?: Build|[;)])|W032i-C3(?:[);/ ]|$)","device":"tablet","models":[{"regex":"Hudl ([^/;]+)(?: Build|[;)])","model":"Hudl $1"},{"regex":"W032i-C3(?:[);/ ]|$)","model":"Op3n Dott"}]},"teXet":{"regex":"Texet|(NaviPad [^/;]*) Build|TM-(?:1046|1058|1057|1067|3000|3200R|3500|4003|4071|450[34]|451[30]|4377|4082R|508[34]|550[358]|5010|5017|507[4-7]|5[23]77|6003|6906|702[13]|7055HD|709[69]|9747BT|9758|9751HD|9767|5513|520[410]|507[13]|558[134]|570[23]|7859|8044|9748[ _]3G|9720|7047HD[ _]3G|9757|9740|4982|4515|4083|500[3567]|5571|3204R|5016|8043|7047HD[ _]3G|8041HD|8066|705[23]|7041|8041HD|8051|8048|974[96]|973[78]W|974[170]|9743W|9750HD|7043XD|7049|7887|7037W|702[46])|TB-(771A|711A)|X-Force[\\\\(-]?TM-5009\\\\)?|X-Plus[\\\\(-]?TM-5577\\\\)?|TM_5011|X-pad (?:AIR 8|iX 7|NAVI 7.[35]|NAVI 10|SKY 8.1|STYLE 8|STYLE 10.1|HIT|LITE 7.[12]|QUAD (?:7.2|10|7)|SHINE 8.1)(?: 3G)?","device":"tablet","models":[{"regex":"TM-9749","model":"X-pad Plus 7.1 3G"},{"regex":"TM-9746","model":"X-pad Plus 7 3G"},{"regex":"TM-8051","model":"X-pad Force 8i 3G"},{"regex":"TM-1058","model":"X-Force 10 3G"},{"regex":"TM-8048","model":"X-pad Force 8 3G"},{"regex":"(NaviPad [^/;]*) Build","model":"$1"},{"regex":"TM-7055HD","model":"NaviPad 3G"},{"regex":"TM-9758","model":"X-pad Style 10.0\\""},{"regex":"X-pad SHINE 8.1 3G","model":"X-pad Shine 8.1\\" 3G"},{"regex":"X-pad QUAD 10 3G","model":"X-pad Quad 10.0\\" 3G"},{"regex":"X-pad QUAD 7 3G","model":"X-pad Quad 7.0\\" 3G"},{"regex":"X-pad QUAD 7.2 3G","model":"X-pad Quad 7.2\\" 3G"},{"regex":"X-pad STYLE 8 3G","model":"X-pad Style 8.0\\" 3G"},{"regex":"X-pad HIT 3G","model":"X-pad Hit 3G"},{"regex":"X-pad LITE (7.[12])","model":"X-pad Lite $1\\""},{"regex":"TM-9767","model":"X-pad Style 10.0\\" 3G"},{"regex":"X-pad STYLE 10.1 3G","model":"X-pad Style 10.1\\" 3G"},{"regex":"(X-pad (?:AIR 8|iX 7) 3G)","model":"$1"},{"regex":"TM-7096|X-pad NAVI 7.3 3G","model":"X-pad NAVI 7.3\\" 3G"},{"regex":"TM-7099","model":"X-pad NAVI 7.4\\" 3G"},{"regex":"X-pad NAVI 7.5 3G","model":"X-pad NAVI 7.5\\" 3G"},{"regex":"X-pad SKY 8.1 3G","model":"X-pad Sky 8.1\\" 3G"},{"regex":"TM-1046|X-pad NAVI 10 3G","model":"X-pad NAVI 10.0\\" 3G"},{"regex":"TM-7859","model":"X-pad NAVI 8.2\\" 3G"},{"regex":"TM-7049","model":"NaviPad TM-7049 3G"},{"regex":"TM-7887","model":"NaviPad TM-7887 3G"},{"regex":"TM-8066","model":"X-pad Rapid 8.2\\" 4G"},{"regex":"(TM-(?:1057|1067|6906|8043|9748[_ ]3G|9740|9757(?:[_ ]3G)?|7047HD[ _]3G|9747BT|9751HD|702[13]|705[23]|7041|9720|7047HD[_ ]3G|8044|8041HD|973[78]W|9743W|974[710]|9750HD|7043XD|7037W|702[46])|TB-(?:771A|711A|8041HD))","model":"$1"},{"regex":"TM-4503","device":"smartphone","model":"X-Quad"},{"regex":"(TM-(?:3000|3200R|4003|4083|4377|4504|451[30]|500[35]|5[23]77|5571|3204R|520[04]|5581|5505|5017|507[13-7]|5081|6003|5513))","device":"smartphone","model":"$1"},{"regex":"TM-5006","device":"smartphone","model":"X-Line"},{"regex":"TM-5007","device":"smartphone","model":"X-Shine"},{"regex":"TM_5011","device":"smartphone","model":"X-Omega"},{"regex":"TM-508(3|4)","device":"smartphone","model":"Pay $1G"},{"regex":"TM-558(3|4)","device":"smartphone","model":"Pay 5.5\\" $1G"},{"regex":"TM-5702","device":"smartphone","model":"Pay 5.7\\" 3G"},{"regex":"TM-5703","device":"smartphone","model":"Pay 5.7\\" Pro"},{"regex":"TM-5201","device":"smartphone","model":"Rock"},{"regex":"TM-4515","device":"smartphone","model":"X-Style"},{"regex":"TM-(5016|3500)","device":"smartphone","model":"X-Maxi 2"},{"regex":"TM-4071","device":"smartphone","model":"X-Smart"},{"regex":"TM-4982","device":"smartphone","model":"iX-Maxi"},{"regex":"TEXET[_ ]IX-MINI","device":"smartphone","model":"iX-Mini"},{"regex":"TM-5010","device":"smartphone","model":"X-Selfie"},{"regex":"TM-4082R","device":"smartphone","model":"X-Driver Quad"},{"regex":"TM-5503","device":"smartphone","model":"X-Mage"},{"regex":"TM-5508","device":"smartphone","model":"X-Cosmo"},{"regex":"X-Force[\\\\(-]?TM-5009\\\\)?","device":"smartphone","model":"X-Force"},{"regex":"X-Plus[\\\\(-]?TM-5577\\\\)?","device":"smartphone","model":"X-Plus"},{"regex":"teXet[_ ]X-medium[_ ]plus","device":"smartphone","model":"X-Medium Plus"}]},"Telefunken":{"regex":"TELEFUNKEN|Foxtrot|TEL-1013GIQA|TF-SP(?:500[12]|4002)|(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))|(TF-LED(?:65S75T2SU|32S39T2S|32S5[289]T2S|32S70T2S|40S63T2S))","device":"tablet","models":[{"regex":"TEL-1013GIQA","model":"Giqa 10.1 3G"},{"regex":"Foxtrot2","model":"Foxtrot 2","device":"smartphone"},{"regex":"(?:TELEFUNKEN)?(TF-SP(?:500[12]|4002)|Outdoor LTE|Foxtrot)","model":"$1","device":"smartphone"},{"regex":"(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))","model":"$1"},{"regex":"(TF-LED(?:65S75T2SU|32S39T2S|32S5[289]T2S|32S70T2S|40S63T2S))","model":"$1","device":"tv"}]},"Telego":{"regex":"TELEGO","device":"smartphone","models":[{"regex":"TELEGO-W503","model":"W503"},{"regex":"Telego_JOY2","model":"Joy 2"},{"regex":"Telego[ _]Mate","model":"Mate"}]},"Telenor":{"regex":"(?<!FBCR/)Telenor|Infinity E5","device":"smartphone","models":[{"regex":"Telenor[ _]([^;/]+)(?: Build|[;)])","model":"$1"},{"regex":"Infinity E5","model":"Infinity E5"}]},"Telit":{"regex":"Telit","device":"feature phone","models":[{"regex":"Telit_Mobile_Terminals-([a-z0-9]+)","model":"$1"},{"regex":"Telit[\\\\-_]?([a-z0-9]+)","model":"$1"}]},"ThL":{"regex":"ThL[ _-]|Knight 2","device":"smartphone","models":[{"regex":"Knight 2","model":"Knight 2"},{"regex":"ThL[ _-]*([^;/]+) Build","model":"$1"},{"regex":"ThL[ _-]*([^ ;/)]+)(?:[);/ ]|$)","model":"$1"}]},"TIANYU":{"regex":"TIANYU","device":"feature phone","models":[{"regex":"TIANYU ([a-z0-9]+)","model":"$1"},{"regex":"TIANYU-KTOUCH/([a-z0-9]+)","model":"$1"}]},"Timovi":{"regex":"Tmovi[ _]|(?:Infinit_Lite_2|Vision_PRO|VISION ULTRA|Epix)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Tmovi[ _]Prime","model":"Prime"},{"regex":"TMOVI_YEAH_BEAT","model":"Yeah Beat"},{"regex":"YeahLIVE","model":"Yeah LIVE"},{"regex":"Infinit Lite","model":"Infinit Lite"},{"regex":"Infinit_Lite_2","model":"Infinit Lite 2"},{"regex":"Vision_PRO","model":"Vision Pro"},{"regex":"VISION ULTRA","model":"Vision Ultra"},{"regex":"Epix","model":"Epix"}]},"Tooky":{"regex":"TOOKY","device":"smartphone","models":[{"regex":"TOOKY (A19|W1|T8[368]|T1982)(?:[);/ ]|$)","model":"$1"},{"regex":"TOOKY A9PLUS(?:[);/ ]|$)","model":"A9 Plus"}]},"Tolino":{"regex":"Tolino Tab ([^/;]+) Build","device":"tablet","model":"Tolino Tab $1"},"Top House":{"regex":"Coto[_ ]|X1013","device":"smartphone","models":[{"regex":"Coto W418","model":"Coto W418"},{"regex":"COTO_T117","model":"Coto T117","device":"tablet"},{"regex":"X1013","model":"X1013","device":"tablet"},{"regex":"COTO_T40017","model":"T40017"}]},"Toplux":{"regex":"Toplux ([a-z0-9]+)","device":"feature phone","model":"$1"},"Touchmate":{"regex":"TOUCHMATE|(TM-(?:MID1050WKD|MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|SM500N|SM410|MID1010))","device":"smartphone","models":[{"regex":"(TM-(?:MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|MID1010))","device":"tablet","model":"$1"},{"regex":"TM-MID1050WKD","device":"tablet","model":"Mega Matrix 10.1\\" 3G"},{"regex":"(TM-(?:SM500N|SM410))","model":"$1"},{"regex":"Touchmate ([^/;]+) Build","model":"$1"}]},"TrekStor":{"regex":"(?:TrekStor|Surftab) ([^/;]+)(?: Build|\\\\))|Surftab[^;\\\\)]*(?:[;\\\\)]|$)|ST10216-2A|ST13416-1|VT10416-[12]|TFMTKAW01232","device":"tablet","models":[{"regex":"ST10216-2A|VT10416-[12]","model":"SurfTab 10.1"},{"regex":"ST13416-1","model":"SurfTab Theatre 13.4\\""},{"regex":"PrimeTab P10","model":"PrimeTab P10"},{"regex":"TrekStor ([^/;]+) Build","model":"$1"},{"regex":"Surftab ([^/;]+) Build","model":"SurfTab $1"},{"regex":"Surftab[ _]([^;\\\\)]*)(?:[;\\\\)]|$)","model":"SurfTab $1"},{"regex":"TFMTKAW01232","model":"SurfTab L15"}]},"Trevi":{"regex":"Trevi[ _]|TAB[ _]10[ _]3G[ _]V16|TAB[ _](7|8)[ _]3G[ _]V8|TAB9 3G|MINITAB 3GV|Phablet[ _](?:4|4\\\\.5|5|5\\\\,3|6)[ _]?[CSQ]|REVERSE[ _]5\\\\.5[ _]?Q","device":"tablet","models":[{"regex":"TAB[ _]?(7|8)[ _]3G[ _]V8","model":"TAB $1 3G V8"},{"regex":"TAB[ _]?9[ _]3G[ _]V8","model":"TAB 9 3G V8"},{"regex":"TAB[ _]?9[ _]3G","model":"TAB 9 3G"},{"regex":"TAB[ _]10[ _]3G[ _]V16","model":"TAB 10 3G V16"},{"regex":"MINITAB 3GV","model":"MINITAB 3G V"},{"regex":"(?:Trevi_)?Phablet[ _]4[ _]?C","model":"Phablet 4 C","device":"smartphone"},{"regex":"(?:Trevi_)?Phablet[ _]4[ _]?S","model":"Phablet 4 S","device":"smartphone"},{"regex":"(?:Trevi_)?Phablet[ _]4.5[ _]?Q","model":"Phablet 4.5Q","device":"smartphone"},{"regex":"(?:Trevi_)?PHABLET[ _]5[ _]?S","model":"Phablet 5 S","device":"smartphone"},{"regex":"(?:Trevi_)?PHABLET[ _]5,3[ _]?Q","model":"Phablet 5.3 Q","device":"phablet"},{"regex":"(?:Trevi_)?REVERSE[ _]5.5[ _]?Q","model":"Phablet 5.5 Q REVERSE","device":"phablet"},{"regex":"(?:Trevi_)?PHABLET[ _]6[ _]?S","model":"Phablet 6 S","device":"phablet"},{"regex":"Trevi[_]([^;/]+) Build","model":"$1"}]},"TVC":{"regex":"(NuclearSX-SP5)","device":"smartphone","model":"Nuclear SX-SP5"},"U.S. Cellular":{"regex":"USCC-","device":"smartphone","models":[{"regex":"USCC-E6762","model":"Kyocera DuraForce"},{"regex":"(USCC-[a-z0-9_\\\\-]+)","model":"$1"}]},"Uhappy":{"regex":"Uhappy|UP?580|UP350|UP[35679]20","device":"smartphone","models":[{"regex":"UP([35679]20)","model":"UP$1"},{"regex":"UP350","model":"UP350"},{"regex":"UP580","model":"UP580"},{"regex":"U580","model":"U580"},{"regex":"Uhappy[ _-]([^;/]+) Build","model":"$1"},{"regex":"Uhappy[ _-]?([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"Unimax":{"regex":"U((?:67[013]|680)C|(?:452|504)TL|683CL|693CL)(?:[);/ ]|$)","device":"smartphone","model":"U$1"},"Unowhy":{"regex":"QOOQ ","device":"tablet","model":"QOOQ"},"UTStarcom":{"regex":"utstar[ _-]?([a-z0-9]+)","device":"feature phone","model":"$1"},"Ulefone":{"regex":"Ulefone|Gemini Pro|Power_[356]|S10_Pro|(?:Note [89]P|Armor(?:[ _](?:[2367]|2S|X[236]|6[SE]|3WT|3W|X))?|U00[78][ _]Pro|Be[ _]X|Be[ _]Touch(?:[ _][23])?|Be[ _](?:One|Pure)(?:[ _]Lite)?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"S10_Pro","model":"S10 Pro"},{"regex":"Be[ _]Touch([ _][23])?","model":"Be Touch$1"},{"regex":"Be[ _]Pure[ _]Lite","model":"Be Pure Lite"},{"regex":"Be[ _]Pure","model":"Be Pure"},{"regex":"Be[ _]One[ _]Lite","model":"Be One Lite"},{"regex":"Be[ _]One","model":"Be One"},{"regex":"Be[ _]X","model":"Be X"},{"regex":"U007 Pro","model":"U007 Pro"},{"regex":"U008 Pro","model":"U008 Pro"},{"regex":"Armor[ _]X([236])(?:[);/ ]|$)","model":"Armor X$1"},{"regex":"Armor[ _]6S(?:[);/ ]|$)","model":"Armor 6S"},{"regex":"Armor[ _]([679])E(?:[);/ ]|$)","model":"Armor $1E"},{"regex":"Armor[ _]X([57]) Pro(?:[);/ ]|$)","model":"Armor X$1 Pro"},{"regex":"Armor[ _]X([578])(?:[);/ ]|$)","model":"Armor X$1"},{"regex":"Armor[ _]([25])S(?:[);/ ]|$)","model":"Armor $1S"},{"regex":"Armor[ _]X(?:[);/ ]|$)","model":"Armor X"},{"regex":"Armor[ _]3W(?:[);/ ]|$)","model":"Armor 3W"},{"regex":"Armor[ _]3WT(?:[);/ ]|$)","model":"Armor 3WT"},{"regex":"Armor[ _]([236789])(?:[);/ ]|$)","model":"Armor $1"},{"regex":"Armor(?:[);/ ]|$)","model":"Armor"},{"regex":"Gemini Pro(?:[);/ ]|$)","model":"Gemini Pro"},{"regex":"Power[_ ]([356])","model":"Power $1"},{"regex":"Note 8P(?:[);/ ]|$)","model":"Note 8P"},{"regex":"Note 9P(?:[);/ ]|$)","device":"phablet","model":"Note 9P"},{"regex":"Ulefone[_ ](X|S1[ _]Pro|S[17])(?:[);/ ]|$)","model":"$1"},{"regex":"Ulefone[ _-]?([^;/]+) Build","model":"$1"},{"regex":"Ulefone[ _-]?([^;/)]+)(?:[;/)]|$)","model":"$1"}]},"UMIDIGI":{"regex":"UMI(?:DIGI)?[ _]|(?:A5_Pro|ROME[_ ]X|BISON|hammer_S)(?:[;/) ]|$)","device":"smartphone","models":[{"regex":"A5_Pro","model":"A5 Pro"},{"regex":"UMI TOUCH X","model":"Touch X"},{"regex":"UMI TOUCH","model":"Touch"},{"regex":"ROME[_ ]X","model":"Rome X"},{"regex":"BISON","model":"Bison"},{"regex":"hammer_S","model":"Hammer S"},{"regex":"UMI_(London|Diamond(?:_X)?)","model":"$1"},{"regex":"UMI(?:DIGI)?[ _]([^/;)]+)(?: Build|[;)])","model":"$1"}]},"Uniscope":{"regex":"Uniscope","device":"smartphone","models":[{"regex":"Uniscope[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"Uniscope[ _\\\\-]?([^);/ ]+)","model":"$1"}]},"Unnecto":{"regex":"Unnecto|(?:U513|U5151|U61[1356]|U7[12]0|U-830|U90[35])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"U513","model":"Drone XT"},{"regex":"U5151","model":"Bolt"},{"regex":"U611","model":"Quattro X"},{"regex":"U613","model":"Quattro S"},{"regex":"U615","model":"Quattro M"},{"regex":"U616","model":"U616"},{"regex":"U710","model":"Quattro U710"},{"regex":"U720","model":"Quattro Z"},{"regex":"U-830","model":"Rush"},{"regex":"U903","model":"Air"},{"regex":"U905","model":"Air 5.5"}]},"Unonu":{"regex":"Unonu[ _-]","device":"smartphone","models":[{"regex":"Unonu[ _-]([^;/]+) Build","model":"$1"},{"regex":"Unonu[ _-]?([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"UTOK":{"regex":"UTOK (45[01]D)","device":"smartphone","model":"$1"},"Vastking":{"regex":"(M910A|M783K|M783K-16G|M1072R-3G)(?:[);/ ]|$)","device":"tablet","model":"$1"},"ViewSonic":{"regex":"ViewSonic|VSD[0-9]+(?:[);/ ]|$)|ViewPad|ViewPhone","device":"smart display","models":[{"regex":"(?:ViewSonic-)?V500(?:[);/ ]|$)","model":"V500","device":"smartphone"},{"regex":"ViewSonic A8\\\\+(?:[);/ ]|$)","model":"A8 Plus","device":"smartphone"},{"regex":"(?:ViewSonic-)?ViewPhone ?([^;/]+) Build","model":"ViewPhone $1","device":"smartphone"},{"regex":"(?:ViewSonic-)?ViewPad ?([^;/]+) Build","model":"ViewPad $1","device":"tablet"},{"regex":"(VSD[0-9]+)(?:[);/ ]|$)","model":"$1"}]},"Vitelcom":{"regex":"Vitelcom|portalmmm/[12].0 TSM","device":"feature phone","models":[{"regex":"TSM-([a-z0-9]+)","model":"$1"},{"regex":"TSM([a-z0-9\\\\-]+)","model":"$1"},{"regex":"portalmmm/[12].0 (TSM[a-z0-9 ]+)","model":"$1"}]},"Fengxiang":{"regex":"(vKB011B|vKB004L)","device":"tablet","model":"$1"},"VK Mobile":{"regex":"VK-VK([79]00)(?:[);/ ]|$)","device":"feature phone","model":"VK$1"},"Vernee":{"regex":"Vernee|Mars Pro|Apollo[ _](?:Lite|X)|Thor (?:E|Plus)|X2_euro","device":"smartphone","models":[{"regex":"Apollo[ _]Lite","model":"Apollo Lite"},{"regex":"Apollo[ _]X","model":"Apollo X"},{"regex":"Mars Pro","model":"Mars Pro"},{"regex":"Thor E","model":"Thor E"},{"regex":"Thor Plus","model":"Thor Plus"},{"regex":"Vernee_M5","model":"M5"},{"regex":"X2_euro","model":"X2"},{"regex":"Vernee[ _-]([^;/]+) Build","model":"$1"},{"regex":"Vernee[ _-]([a-z0-9_-]+)","model":"$1"}]},"Vertu":{"regex":"Vertu[ ]?([a-z0-9]+)|(?:ASTER P|CONSTELLATION X)(?:[);/ ]|$)","device":"feature phone","models":[{"regex":"ASTER P(?:[);/ ]|$)","device":"smartphone","model":"Aster P"},{"regex":"CONSTELLATION X(?:[);/ ]|$)","device":"smartphone","model":"Constellation X"},{"regex":"Vertu[ ]?([a-z0-9]+)","model":"$1"}]},"Venso":{"regex":"(?:CX-508|CX-551|Reiv 500|Creon F5|Isprit U50|Isprit-U50-LTE)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Isprit U50|Isprit-U50-LTE","model":"Isprit U50"},{"regex":"(CX-508|CX-551|Reiv 500|Creon F5)","model":"$1"}]},"Verizon":{"regex":"QTA(SUN[12]|XIA1|QZ3|QZ3KID|IR7)|QMV7B","device":"tablet","models":[{"regex":"QTAXIA1|QTAIR7","model":"Ellipsis 10"},{"regex":"QTASUN1","model":"Ellipsis 8 HD"},{"regex":"QTASUN2","model":"Ellipsis 8 HD 4G LTE"},{"regex":"QTAQZ3KID","model":"Ellipsis Kids LTE"},{"regex":"QTAQZ3","model":"Ellipsis 8"},{"regex":"QMV7B","model":"Ellipsis 7"}]},"Verykool":{"regex":"verykool","device":"smartphone","models":[{"regex":"verykoolS5004","model":"Lotus JR."},{"regex":"verykoolS5005","model":"Lotus II"},{"regex":"verykool[ _]?([^/;]+) Build","model":"$1"},{"regex":"verykool[ _]?([^/;]+);","model":"$1"}]},"Vestel":{"regex":"Vestel[ _]|Venus[ _](GO|E[2-5]|V[1-9]|Z[1-9]0)|(?<!Winnovo )V_?TAB|VP74|VT97PRO|VSP145M|VSP250[GS]|VSP355[GS]|V3_5580_Dual","device":"smartphone","models":[{"regex":"VT97PRO","model":"VTab 9.7 Pro","device":"tablet"},{"regex":"VP74","model":"VTab Lite II","device":"tablet"},{"regex":"VTAB10","model":"VTab 10","device":"tablet"},{"regex":"V_TAB_7_ECO_III ","model":"VTab 7 Eco 3","device":"tablet"},{"regex":"V_TAB_([0-9]{4}[A-Z]?)","model":"VTab $1","device":"tablet"},{"regex":"V3_5580_Dual","model":"Venus V3 5580 Dual"},{"regex":"VSP145M","model":"Venus 4.5"},{"regex":"VSP250G","model":"Venus 5.0V"},{"regex":"VSP250S","model":"Venus 5.0X"},{"regex":"VSP355G","model":"Venus 5.5V"},{"regex":"VSP355S","model":"Venus 5.5X"},{"regex":"Venus[ _]V([1-9])","model":"Venus V$1"},{"regex":"Venus[ _]Z([1-9]0)","model":"Venus Z$1"},{"regex":"Venus[ _]GO","model":"Venus Go"},{"regex":"Venus E2 Plus Dual","model":"Venus E2 Plus Dual"},{"regex":"Venus[ _]E2 Plus","model":"Venus E2 Plus"},{"regex":"Venus[ _]E([345])","model":"Venus E$1"},{"regex":"Vestel_5000_Dual","model":"5000 Dual"},{"regex":"Vestel_5000_2gb","model":"5000 2GB"},{"regex":"Vestel[ _](5000|5530)","model":"$1"}]},"Videocon":{"regex":"Videocon[_ \\\\-]|(?:VT75C|V406018|V512930|V50(?:2430|3630|5024|5430|4630|5[98]20)|Z45_(?:Dazzle|Amaze)|Z45Q Star|Z50 Nova)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Videocon_V1585","device":"feature phone","model":"V1585"},{"regex":"Videocon[_ \\\\-]([a-z0-9]+)","model":"$1"},{"regex":"VT75C(?:[);/ ]|$)","model":"VT75C","device":"tablet"},{"regex":"V502430(?:[);/ ]|$)","model":"Kryton 3"},{"regex":"V505024(?:[);/ ]|$)","model":"Kryton 22 Plus"},{"regex":"V503630(?:[);/ ]|$)","model":"Delite 11"},{"regex":"V505920(?:[);/ ]|$)","model":"Metal Pro 2"},{"regex":"V505820(?:[);/ ]|$)","model":"Metal Pro 1"},{"regex":"V406018(?:[);/ ]|$)","model":"Starr 100"},{"regex":"V512930(?:[);/ ]|$)","model":"Ultra 50"},{"regex":"(V505430|V504630)(?:[);/ ]|$)","model":"$1"},{"regex":"Z45_(Dazzle|Amaze)(?:[);/ ]|$)","model":"Infinium Z45 $1"},{"regex":"Z45Q Star(?:[);/ ]|$)","model":"Infinium Z45Q Star"},{"regex":"Z50 Nova(?:[);/ ]|$)","model":"Infinium Z50 Nova"}]},"Vodafone":{"regex":"(?<!FBCR/)Vodafone[ _-]|Smart ?Tab ?(?:III? ?)?(?:|4G|7|10)[);/ -]|VodafoneSmartChat|VFD[ _][0-9]+(?:[);/ ]|$)|VFD320|VF6[89]5|VF-(696|1397|795|895N|1497)","device":"smartphone","models":[{"regex":"VFD 100","model":"Smart Mini"},{"regex":"VF685","model":"Smart Kicka"},{"regex":"VF695","model":"Smart First 6"},{"regex":"VFD 200","model":"Smart First 7"},{"regex":"VFD 300","model":"Smart Mini 7"},{"regex":"VFD 50[02]","model":"Smart Turbo 7"},{"regex":"VFD 51[013]","model":"Smart E8"},{"regex":"VFD 600","model":"Smart Prime 7"},{"regex":"VFD320","model":"Smart C9"},{"regex":"VFD 820","model":"Smart X9"},{"regex":"VFD 610","model":"Smart N8"},{"regex":"Smart ultra 6","model":"Smart Ultra 6"},{"regex":"VFD 700","model":"Smart Ultra 7"},{"regex":"VFD 720","model":"Smart N9"},{"regex":"VFD 900","model":"Smart Platinum 7"},{"regex":"Vodafone[ _]875(?:[);/ ]|$)","model":"Smart Mini"},{"regex":"Vodafone[ _]975N?(?:[);/ ]|$)","model":"Smart 3"},{"regex":"Vodafone[ _]785(?:[);/ ]|$)","model":"Smart 4 Mini"},{"regex":"Vodafone[ _]890N(?:[);/ ]|$)","model":"Smart 4 Turbo"},{"regex":"Vodafone[ _]985N(?:[);/ ]|$)","model":"Smart 4 Power"},{"regex":"VodafoneSmartChat","model":"Smart Chat"},{"regex":"VF-696","model":"Smart Grand 6"},{"regex":"VF-795","model":"Smart Speed 6"},{"regex":"VF-895N","model":"Smart Prime 6"},{"regex":"VF-1397","model":"Tab Speed 6","device":"tablet"},{"regex":"VF-1497","model":"Tab Prime 6","device":"tablet"},{"regex":"VFD 1100","device":"tablet","model":"Tab Mini 7"},{"regex":"VFD 1300","device":"tablet","model":"Smart Tab N8"},{"regex":"VFD 1400","device":"tablet","model":"Tab Prime 7"},{"regex":"Smart ?Tab ?3G","device":"tablet","model":"Smart Tab 3G"},{"regex":"Smart ?Tab ?4G","device":"tablet","model":"Smart Tab 4G"},{"regex":"Smart ?Tab ?4","model":"Smart Tab 4","device":"tablet"},{"regex":"SmartTab7[);/ -]","model":"Smart Tab 7","device":"tablet"},{"regex":"SmartTab10[);/ -]","model":"Smart Tab 10","device":"tablet"},{"regex":"Smart ?Tab ?II ?7","model":"Smart Tab II 7","device":"tablet"},{"regex":"Smart ?Tab ?II ?10","model":"Smart Tab II 10","device":"tablet"},{"regex":"Smart ?Tab ?III ?7","model":"Smart Tab III 7","device":"tablet"},{"regex":"Smart ?Tab ?III ?10","model":"Smart Tab III 10","device":"tablet"},{"regex":"VFD[ _]([0-9]+)(?:[);/ ]|$)","model":"VFD $1"},{"regex":"Vodafone[ _-]([^;/]+) Build","model":"$1"},{"regex":"Vodafone[ _-]([a-z0-9_-]+)","model":"$1"}]},"Vonino":{"regex":"Vonino|Epic (?:E8|P7)|Gyga[ _](?:X|S|QS|XS)|Jax[ _](?:QS|[SXQN]|Mini)|Magnet[ _]M[19]|Navo_QS|Onyx_(QS|Z)|Orin_QS|Pluri[ _](?:[BCMQ]7|[CQM]8)|Sirius_QS|Volt[ _][XS]|Xavy_(T7|L8)|Xylo[ _][XSPQT]|Zun[ _]X[OS]?|JAX_N","device":"smartphone","models":[{"regex":"Zun[ _]XO","model":"Zun XO"},{"regex":"Zun[ _]XS","model":"Zun XS"},{"regex":"Zun[ _]X","model":"Zun X"},{"regex":"Xylo[ _]([PSXQT])","model":"Xylo $1"},{"regex":"Volt[ _]S_A7","model":"Volt S A7"},{"regex":"Volt[ _]S","model":"Volt S"},{"regex":"Volt[ _]X","model":"Volt X"},{"regex":"Gyga[ _]QS","model":"Gyga QS"},{"regex":"Gyga[ _]XS","model":"Gyga XS"},{"regex":"Gyga[ _](S|X)","model":"Gyga $1"},{"regex":"Jax[ _]QS","model":"Jax QS"},{"regex":"Jax[ _]S_A7","model":"Jax S A7"},{"regex":"Jax[ _]([SQXN])","model":"Jax $1"},{"regex":"Jax[ _]Mini","model":"Jax Mini"},{"regex":"Epic (E8|P7)","model":"Epic $1","device":"tablet"},{"regex":"Pluri[ _](B|C|M|Q)7","model":"Pluri $17","device":"tablet"},{"regex":"Pluri[ _]([CQM])8","model":"Pluri $18","device":"tablet"},{"regex":"Magnet[ _]M([19])","model":"Magnet M$1","device":"tablet"},{"regex":"Navo_QS","model":"Navo QS","device":"tablet"},{"regex":"Onyx_(QS|Z)","model":"Onyx $1","device":"tablet"},{"regex":"Orin_QS","model":"Orin QS","device":"tablet"},{"regex":"Sirius_QS","model":"Sirius QS","device":"tablet"},{"regex":"Xavy_T7","model":"Xavy T7","device":"tablet"},{"regex":"Xavy_L8","model":"Xavy L8","device":"tablet"}]},"Vorago":{"regex":"VORAGO","device":"smartphone","models":[{"regex":"CELL-500","model":"CELL-500"}]},"Voto":{"regex":"VOTO[ _\\\\-]|VT8[89]8(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"VOTO[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"VOTO[ _\\\\-]?([^);/ ]+)","model":"$1"},{"regex":"(VT8[89]8)(?:[);/ ]|$)","model":"$1"}]},"Voxtel":{"regex":"Voxtel_([a-z0-9]+)","device":"feature phone","model":"$1"},"Vulcan":{"regex":"(?:VP5004A|HT0704W08|VS5513|VS4011|VR6031)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(VP5004A|VR6031)(?:[);/ ]|$)","model":"$1"},{"regex":"VS5513(?:[);/ ]|$)","model":"Tempo S13"},{"regex":"VS4011(?:[);/ ]|$)","model":"Tempo S11"},{"regex":"HT0704W08","model":"Koral 7W4","device":"tablet"}]},"Walton":{"regex":"Walton|Walpad|Primo[ _](C[1234]?|D[1-689]|E[1-589]|F8s|S7|EF[23]?|EM|F[1-79]i?|G[1-9]|GF[234]?|GH[23]?|GM|H[2-689M]|H7s|N[F1]?|NX2?|R[1-46]|R[HM]2?|RX[23]?|S[1-6]|V1|X[1-4]|Z|ZX)","device":"smartphone","models":[{"regex":"Walpad ([^;/]+) Build","device":"tablet","model":"Primo Walpad $1"},{"regex":"Primo S6 infinity","model":"Primo S6 Infinity"},{"regex":"Primo H8 Pro(?:[);/ ]|$)","model":"Primo H8 Pro"},{"regex":"Primo H8(?:[);/ ]|$)","model":"Primo H8 Turbo"},{"regex":"Primo[ _]([^;/)]+)(?: Build|[;)])","model":"Primo $1"},{"regex":"Walton[ _]([^;/)]+)(?: Build|[;)])","model":"$1"}]},"WellcoM":{"regex":"WELLCOM[ _\\\\-/]([a-z0-9]+)","device":"smartphone","model":"$1"},"Wexler":{"regex":"Wexler|(?:ULTIMA 7 TWIST PLUS|TAB10iQ3G|TAB[ _]10Q)(?:[);/ ]|$)|ZEN[ _](?:4\\\\.[57]|5)","device":"tablet","models":[{"regex":"(?:Wexler[ _\\\\-\\\\.])?ZEN[ _]4\\\\.5(?:[);/ ]|$)","model":"ZEN 4.5","device":"smartphone"},{"regex":"(?:Wexler[ _\\\\-\\\\.])?ZEN[ _]4\\\\.7(?:[);/ ]|$)","model":"ZEN 4.7","device":"smartphone"},{"regex":"(?:Wexler[ _\\\\-\\\\.])?ZEN[ _]5(?:[);/ ]|$)","model":"ZEN 5","device":"smartphone"},{"regex":"(?:Wexler[ _\\\\-\\\\.])?TAB[ _]10Q(?:[);/ ]|$)","model":"TAB 10Q"},{"regex":"TAB10iQ3G(?:[);/ ]|$)","model":"TAB 10iQ 3G"},{"regex":"Wexler[ _\\\\-\\\\.]([^;/]+) Build","model":"$1"},{"regex":"Wexler[ _\\\\-\\\\.]([^);/]+)(?:[);/]|$)","model":"$1"},{"regex":"(ULTIMA 7 TWIST PLUS)(?:[);/ ]|$)","model":"$1"}]},"Inco":{"regex":"(?:Inco[ _](Aurora II|Sphere|Plain[_ ]2S?|Plain2 S|Flex 2S|S4|Bloom 2)|(Horizon_S|Horizon \\\\+))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:Inco[ _])?(Plain[_ ]2S?|Horizon_S|Horizon \\\\+|Aurora II|Flex 2S|S4|Bloom 2)(?:[);/ ]|$)","model":"$1"},{"regex":"Plain2 S","model":"Plain 2S"},{"regex":"Inco Sphere(?:[);/ ]|$)","device":"tablet","model":"Sphere"}]},"Wink":{"regex":"(?<!mismart )Wink[_ ]","device":"smartphone","models":[{"regex":"Wink[_ ]((?:Glory|World|Share|City)(?:[_ ](?:SE|S))?)(?:[);/ ]|$)","model":"$1"},{"regex":"Wink[ _](Primo|Highway)(?:[);/ ]|$)","device":"tablet","model":"$1"}]},"Wiko":{"regex":"(?:WIKO[_ -])|(?:WIKO-)?CINK_[a-z0-9_]+|(?:WIKO-)?HIGHWAY_[a-z0-9_]+|(?:WIKO-)?(?:Cink([^/;]*)|Highway([^/;]*)|Iggy|Stairway|Rainbow ?(Jam|Lite|Up)?|Darkside|Darkmoon|Darkfull|Darknight|Freddy|FEVER|Jerry[2]?|Sublim|Ozzy|JIMMY|Barry|Birdy|Bloom|Getaway|Goa(?!nna)|Kite|Robby|Lenny[2-9]?|Slide|Sunset[2-9]?|Sunny[2-9]?|Tommy[2-9]?|PULP(?: Fab)?|Wax|HARRY|Ridge(?: Fab)?|U FEEL(?: Prime| Lite)?|U PULSE(?: LITE)?|View2 Go|View XL|View Prime)(?: Plus)?(?: 4G)?(?: Build|$)?|W_(?:C8[06]0|K[346]00|P130|P200|C200SN)|WC300|W-(?:V7[23]0|V8[30]0|P[36]11|K420|K510S?|K130)-(?:TMV|TIM|TVM|EEA|SUN|SWI|OPE|BYT|DU|TH)|WIM Lite|W-K360-TV|W-V600|W-K200|W-U300|U307AS|CINK PEAX 2|HIGHWAY PURE|C210AE|v3913","device":"smartphone","models":[{"regex":"(?:WIKO-)?Cink Peax 2","model":"Cink Peax 2"},{"regex":"(?:Wiko-)?Cink([^/;]*) Build","model":"Cink$1"},{"regex":"(?:WIKO-)?CINK_([a-z0-9_]+)","model":"Cink $1"},{"regex":"(?:WIKO-)?HIGHWAY PURE","model":"Highway Pure"},{"regex":"(?:WIKO-)?HIGHWAY STAR","model":"Highway Star"},{"regex":"(?:Wiko-)?Highway([^/;]*) Build","model":"Highway$1"},{"regex":"(?:WIKO-)?HIGHWAY_([a-z0-9_]+)","model":"Highway $1"},{"regex":"(?:WIKO-)?Iggy","model":"Iggy"},{"regex":"(?:WIKO-)?FEVER","model":"Fever"},{"regex":"(?:WIKO-)?Stairway","model":"Stairway"},{"regex":"(?:WIKO-)?Ridge Fab 4G","model":"Ridge Fab 4G"},{"regex":"(?:WIKO-)?Ridge 4G","model":"Ridge 4G"},{"regex":"(?:WIKO-)?Ridge","model":"Ridge"},{"regex":"(?:WIKO-)?Rainbow ([^/;]+) Build","model":"Rainbow $1"},{"regex":"(?:WIKO-)?Rainbow","model":"Rainbow"},{"regex":"(?:WIKO-)?Darkside","model":"Darkside"},{"regex":"(?:WIKO-)?Darkmoon","model":"Darkmoon"},{"regex":"(?:WIKO-)?Darkfull","model":"Darkfull"},{"regex":"(?:WIKO-)?Darknight","model":"Darknight"},{"regex":"(?:WIKO-)?Sublim","model":"Sublim"},{"regex":"(?:WIKO-)?Ozzy","model":"Ozzy"},{"regex":"(?:WIKO-)?Barry","model":"Barry"},{"regex":"(?:WIKO-)?Birdy","model":"Birdy"},{"regex":"(?:WIKO-)?Bloom","model":"Bloom"},{"regex":"(?:WIKO-)?JIMMY","model":"Jimmy"},{"regex":"JERRY MAX","model":"Jerry Max"},{"regex":"W_K300","model":"Jerry 3"},{"regex":"W-K420-TVM","model":"Jerry 4"},{"regex":"(?:WIKO-)?Jerry2","model":"Jerry 2"},{"regex":"(?:WIKO-)?Jerry","model":"Jerry"},{"regex":"(?:WIKO-)?Getaway","model":"Getaway"},{"regex":"(?:WIKO-)?Goa(?!nna)","model":"Goa"},{"regex":"(?:WIKO-)?Freddy","model":"Freddy"},{"regex":"(?:WIKO-)?Kite","model":"Kite"},{"regex":"W_K400","model":"Lenny 5"},{"regex":"C210AE(?:[);/ ]|$)","model":"Life"},{"regex":"U307AS(?:[);/ ]|$)","model":"Life 2"},{"regex":"v3913(?:[);/ ]|$)","model":"Kenny"},{"regex":"(?:WIKO-)?Lenny[ -_]?3 Max","model":"Lenny 3 Max"},{"regex":"(?:WIKO-)?Lenny[ -_]?4 Plus","model":"Lenny 4 Plus"},{"regex":"(?:WIKO-)?Lenny[ -_]?([2-9])","model":"Lenny $1"},{"regex":"(?:WIKO-)?Lenny","model":"Lenny"},{"regex":"(?:WIKO-)?Slide","model":"Slide"},{"regex":"(?:WIKO-)?Sunset2","model":"Sunset 2"},{"regex":"(?:WIKO-)?Sunset","model":"Sunset"},{"regex":"(?:WIKO-)?Sunny3","model":"Sunny 3"},{"regex":"W-K200","model":"Sunny 3 Plus"},{"regex":"(?:WIKO-)?Sunny2 Plus","model":"Sunny 2 Plus"},{"regex":"(?:WIKO-)?Sunny2","model":"Sunny 2"},{"regex":"W-K360-TV","model":"Sunny 4 Plus"},{"regex":"W-K130-TMV","model":"Sunny 4"},{"regex":"(?:WIKO-)?Sunny","model":"Sunny"},{"regex":"(?:W_K600|Tommy3|W_C200SN)","model":"Tommy 3"},{"regex":"(?:WIKO-)?Tommy2 Plus","model":"Tommy 2 Plus"},{"regex":"(?:WIKO-)?Tommy2","model":"Tommy 2"},{"regex":"(?:WIKO-)?Tommy","model":"Tommy"},{"regex":"(?:WIKO-)?Wax","model":"Wax"},{"regex":"(?:WIKO-)?HARRY","model":"Harry"},{"regex":"W-V600","model":"Harry 2"},{"regex":"(?:WIKO-)?WIM Lite","model":"WIM Lite"},{"regex":"(?:WIKO-)?Pulp Fab 4G","model":"Pulp Fab 4G"},{"regex":"(?:WIKO-)?Pulp Fab","model":"Pulp Fab"},{"regex":"(?:WIKO-)?Pulp 4G","model":"Pulp 4G"},{"regex":"(?:WIKO-)?Pulp","model":"Pulp"},{"regex":"(?:WIKO-)?Robby","model":"Robby"},{"regex":"(?:WIKO-)?U PULSE LITE","model":"U Pulse Lite"},{"regex":"(?:WIKO-)?U PULSE","model":"U Pulse"},{"regex":"(?:WIKO-)?U FEEL LITE","model":"U Feel Lite"},{"regex":"(?:WIKO-)?U FEEL PRIME","model":"U Feel Prime"},{"regex":"(?:WIKO-)?U FEEL","model":"U Feel"},{"regex":"(?:WIKO-)?View2 Go","model":"View 2 Go"},{"regex":"(?:WIKO-)?View XL","model":"View XL"},{"regex":"(?:WIKO-)?View Prime","model":"View Prime"},{"regex":"WC300","model":"View Lite"},{"regex":"W_C800","model":"View 2"},{"regex":"W_C860","model":"View 2 Pro"},{"regex":"W_P200","model":"View Max"},{"regex":"W_P130","model":"View Go"},{"regex":"W-V800-(TVM|TIM|EEA|OPE|DU)","model":"View 3 Lite"},{"regex":"W-K130-(?:OPE|EEA)","model":"Y50"},{"regex":"W-K420-EEA","model":"Y50"},{"regex":"W-K510-(?:TVM|EEA|OPE|SUN|BYT|TH)|W-K510S-SWI","model":"Y60"},{"regex":"W-V720-(?:EEA|OPE|SUN)","model":"Y80"},{"regex":"W-P311-(?:EEA|OPE|TVM)","model":"View 3"},{"regex":"W-P611-(?:EEA|OPE)","model":"View 3 Pro"},{"regex":"W-V830-EEA","model":"View 4"},{"regex":"W-V730-EEA","model":"View 4 Lite"},{"regex":"W-U300(?:[);/ ]|$)","model":"Ride"},{"regex":"Wiko ([^/;]+) Build","model":"$1"},{"regex":"Wiko ([^/; ]+)","model":"$1"}]},"Wieppo":{"regex":"Wieppo (S6 Lite|S[658]|E1)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Weimei":{"regex":"weplus_3","device":"smartphone","models":[{"regex":"weplus_3","model":"WePlus 3"}]},"Wileyfox":{"regex":"(?:Wileyfox [^/]+)|Swift 2(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Wileyfox Spark \\\\+","model":"Spark +"},{"regex":"Wileyfox Spark X","model":"Spark X"},{"regex":"Wileyfox (Spark|Swift)","model":"$1"},{"regex":"Wileyfox ([^/)]+)(?: Build|\\\\))","model":"$1"},{"regex":"Swift 2 (X|Plus)(?:[);/ ]|$)","model":"Swift 2 $1"},{"regex":"Swift 2(?:[);/ ]|$)","model":"Swift 2"}]},"Wolder":{"regex":"miSmart|miTab|WIAM \\\\#24|WOLDER","device":"smartphone","models":[{"regex":"WIAM \\\\#24","model":"Wiam #24"},{"regex":"WOLDER_WIAM_65","model":"Wiam #65"},{"regex":"miSmart[ \\\\-_]?([^/]+) Build","model":"miSmart $1"},{"regex":"miTab[ \\\\-_]?([^/)]+)(?: Build|\\\\))","device":"tablet","model":"miTab $1"}]},"Wolfgang":{"regex":"AT[ _-]AS([0-9A-Z]+)(?:[);/ ]|$)","device":"smartphone","model":"AT-AS$1"},"Wonu":{"regex":"Wonu ([a-z0-9]+)","device":"feature phone","model":"$1"},"Woo":{"regex":"SP5026i-Scorpio","device":"smartphone","models":[{"regex":"SP5026i-Scorpio","model":"Scorpio"}]},"Woxter":{"regex":"Woxter[ _]([^/;)]+)(?: Build|\\\\))|Nimbus 101Q","device":"tablet","models":[{"regex":"Nimbus 101Q","model":"Nimbus 101Q"},{"regex":"Woxter[ _]([^/;)]+)(?: Build|\\\\))","model":"$1"}]},"X-View":{"regex":"ZEN_U5\\\\+|AMBER_KIDS|Proton_Amber_HD|PROTON_JADE_2_PRO","device":"smartphone","models":[{"regex":"ZEN_U5\\\\+","model":"ZEN U5+"},{"regex":"AMBER_KIDS","device":"tablet","model":"Amber Kids"},{"regex":"Proton_Amber_HD","device":"tablet","model":"Proton Amber HD"},{"regex":"PROTON_JADE_2_PRO","device":"tablet","model":"Proton Jade 2 Pro"}]},"POCO":{"regex":"(?:POCO[ _](?:X[23]|F2 PRO|M[32])|M2010J19C[GI]|M2007J20C[ITG]|M2012K11AG|M2006C3MI|M2004J19PI|M2102J20SG)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"POCO X2(?:[);/ ]|$)","model":"X2"},{"regex":"(?:M2010J19C[GI]|POCO M3)(?:[);/ ]|$)","model":"M3"},{"regex":"M2012K11AG(?:[);/ ]|$)","model":"F3"},{"regex":"M2004J19PI(?:[);/ ]|$)","model":"M2"},{"regex":"POCO M2 Pro(?:[);/ ]|$)","model":"M2 Pro"},{"regex":"(?:M2007J20C[GT]|POCO X3 NFC)(?:[);/ ]|$)","model":"X3 NFC"},{"regex":"(?:M2007J20CI|POCO X3)(?:[);/ ]|$)","model":"X3"},{"regex":"M2102J20SG(?:[);/ ]|$)","model":"X3 Pro"},{"regex":"M2006C3MI(?:[);/ ]|$)","model":"C3"},{"regex":"POCO F2 PRO(?:[);/ ]|$)","model":"F2 Pro"}]},"Xiaomi":{"regex":"Xiaomi(?!/(?:Miui|Mint[ ])Browser)|Mi9 Pro 5G|(?:MI [a-z0-9]+|Mi-4c|MI-One[ _]?[a-z0-9]+|MIX(?: 2S?)?)(?:[);/ ]|$)|HM (?:[^/;]+) (?:Build|MIUI)|(?:2014501|2014011|201481[12378]|201302[23]|2013061) Build|Redmi|POCOPHONE|(?:SHARK )?(KLE|MBU)-[AH]0|SKR-[AH]0|SKW-[AH]0|POCO F1|DLT-[AH]0|MIBOX[234]([_ ]PRO)?|MiTV4[CSX]?|MiTV-(MSSP[01]|AXSO0)|AWM-A0|MI CC 9 Meitu Edition|MiBOX1S|MiTV4A|M2006J10C|M2006C3(?:L[IGC]|LVG|MN?G)|M2007J1(?:7[CGI]|SC)|M2002J9[EG]|HM2014819|WT88047|M2004J(?:7[AB]|19)C|M2012K11C|M2011K2[CG]|M2006C3[ML]II|M2003J15SC|M2007J3S[ICYGP]|M2007J22[CG]|M2101K6[GI]|M2101K(?:[79]AG|7AI)|M2010J19S[CGYI]|HM NOTE 1(?:LTE|W)|MI[_ ]PLAY|XIG01|MI_(NOTE_Pro|5X|4i|(?:A2|8)_Lite)","device":"smartphone","models":[{"regex":"SKR-[AH]0","model":"Black Shark"},{"regex":"AWM-A0","model":"Black Shark Helo"},{"regex":"SKW-[AH]0","model":"Black Shark 2"},{"regex":"DLT-[AH]0","model":"Black Shark 2 Pro"},{"regex":"(?:SHARK )?KLE-A0","model":"Black Shark 3"},{"regex":"(?:SHARK )?KLE-H0","model":"Black Shark 3 5G"},{"regex":"(?:SHARK )?MBU-H0","model":"Black Shark 3 Pro 5G"},{"regex":"(?:SHARK )?MBU-A0","model":"Black Shark 3 Pro"},{"regex":"Xiaomi_2014501|2014501 Build","model":"Hongmi 4G"},{"regex":"Xiaomi_2014011|2014011 Build","model":"Hongmi 1S"},{"regex":"Xiaomi_201302[23]|201302[23] Build","model":"Hongmi"},{"regex":"Xiaomi[_-]2014818|2014818 Build","model":"Hongmi 2 3G"},{"regex":"Xiaomi_2014817|2014817 Build","model":"Hongmi 2"},{"regex":"Xiaomi[_-]201481[123]|201481[123] Build","model":"Hongmi 2 4G"},{"regex":"MI[_ ]PLAY(?:[);/ ]|$)","model":"MI Play"},{"regex":"Mi 9 SE(?:[);/ ]|$)","model":"MI 9 SE"},{"regex":"MI CC 9 Meitu Edition(?:[);/ ]|$)","model":"MI CC 9"},{"regex":"Xiaomi_M2001J2E_TD-LTE(?:[);/ ]|$)","model":"MI 10"},{"regex":"M2011K2[CG](?:[);/ ]|$)","model":"MI 11"},{"regex":"M2007J3S[CYP](?:[);/ ]|$)","model":"MI 10T 5G"},{"regex":"M2007J3S[GI](?:[);/ ]|$)","model":"MI 10T Pro 5G"},{"regex":"M2007J17G(?:[);/ ]|$)","model":"MI 10T Lite 5G"},{"regex":"M2007J1SC(?:[);/ ]|$)","model":"MI 10 Ultra 5G"},{"regex":"(?:M2002J9[EG]|XIG01)(?:[);/ ]|$)","model":"MI 10 Lite 5G"},{"regex":"M2007J17I(?:[);/ ]|$)","model":"MI 10i"},{"regex":"M2101K9AG(?:[);/ ]|$)","model":"MI 11 Lite"},{"regex":"MI[ _]8[ _]Lite(?:[);/ ]|$)","model":"MI 8 Lite"},{"regex":"Mi 9T Pro(?:[);/ ]|$)","model":"MI 9T Pro"},{"regex":"Mi9 Pro 5G(?:[);/ ]|$)","model":"MI 9 Pro 5G"},{"regex":"MI ([89]) Lite(?:[);/ ]|$)","model":"MI $1 Lite"},{"regex":"MI 5s Plus(?:[);/ ]|$)","model":"MI 5s Plus"},{"regex":"Xiaomi_2013061|2013061 Build","model":"MI 3"},{"regex":"Mi-4c(?:[);/ ]|$)","model":"MI 4C"},{"regex":"MI 4W(?:[);/ ]|$)","model":"MI 4W"},{"regex":"Mi_4i(?:[);/ ]|$)","model":"MI 4i"},{"regex":"MI MAX 3(?:[);/ ]|$)","model":"MI MAX 3"},{"regex":"MI MAX 2(?:[);/ ]|$)","model":"MI MAX 2"},{"regex":"Mi[ _]A2[ _]Lite(?:[);/ ]|$)","model":"MI A2 Lite"},{"regex":"MIX 3(?:[);/ ]|$)","model":"MI MIX 3"},{"regex":"MIX 2S(?:[);/ ]|$)","model":"MI MIX 2S"},{"regex":"MIX 2(?:[);/ ]|$)","model":"MI MIX 2"},{"regex":"MIX(?:[);/ ]|$)","model":"MI MIX"},{"regex":"POCOPHONE[ _]F1|POCO F1","model":"Pocophone F1"},{"regex":"Redmi 5 Plus","model":"Redmi 5 Plus"},{"regex":"WT88047(?:[);/ ]|$)","model":"Redmi 2"},{"regex":"HM2014819(?:[);/ ]|$)","model":"Redmi 2 Pro"},{"regex":"HM 2A(?:[);/ ]|$)","model":"Redmi 2A"},{"regex":"HM 1S[CW]?(?:[);/ ]|$)","model":"Redmi 1S"},{"regex":"HM 1(?:[);/ ]|$)","model":"Redmi 1"},{"regex":"M2004J7AC(?:[);/ ]|$)","model":"Redmi 10X"},{"regex":"(?:M2004J19C|M2006C3MII)(?:[);/ ]|$)","model":"Redmi 9"},{"regex":"M2010J19SI(?:[);/ ]|$)","model":"Redmi 9 Power"},{"regex":"M2006C3L[GCI](?:[);/ ]|$)","model":"Redmi 9A"},{"regex":"M2006C3LII(?:[);/ ]|$)","model":"Redmi 9i"},{"regex":"M2006C3MG(?:[);/ ]|$)","model":"Redmi 9C"},{"regex":"M2006C3LVG(?:[);/ ]|$)","model":"Redmi 9AT"},{"regex":"M2010J19S[GY](?:[);/ ]|$)","model":"Redmi 9T"},{"regex":"M2006C3MNG(?:[);/ ]|$)","model":"Redmi 9C NFC"},{"regex":"M2004J7BC(?:[);/ ]|$)","model":"Redmi 10X Pro"},{"regex":"Redmi K20 Pro(?:[);/ ]|$)","model":"Redmi K20 Pro"},{"regex":"Redmi K30 5G(?:[);/ ]|$)","model":"Redmi K30 5G"},{"regex":"M2012K11C(?:[);/ ]|$)","model":"Redmi K40 Pro"},{"regex":"M2006J10C(?:[);/ ]|$)","model":"Redmi K30 Ultra"},{"regex":"Redmi Y1 Lite(?:[);/ ]|$)","model":"Redmi Y1 Lite"},{"regex":"MI PAD 4 PLUS(?:[);/ ]|$)","model":"Mi Pad 4 Plus","device":"tablet"},{"regex":"MI PAD 4(?:[);/ ]|$)","model":"Mi Pad 4","device":"tablet"},{"regex":"MI PAD 3(?:[);/ ]|$)","model":"Mi Pad 3","device":"tablet"},{"regex":"MI PAD 2(?:[);/ ]|$)","model":"Mi Pad 2","device":"tablet"},{"regex":"MI PAD(?:[);/ ]|$)","model":"Mi Pad","device":"tablet"},{"regex":"MIBOX3[ _]Pro(?:[);/ ]|$)","model":"Mi Box 3 Pro","device":"tv"},{"regex":"MIBOX([234])(?:[);/ ]|$)","model":"Mi Box $1","device":"tv"},{"regex":"MiBOX1S(?:[);/ ]|$)","model":"Mi Box 1S","device":"tv"},{"regex":"MiTV-MSSP1(?:[);/ ]|$)","model":"MiTV 4S","device":"tv"},{"regex":"(?:MiTV-AXSO0|MiTV4(?:A|-ANSM0)|MiTV-MSSP0)(?:[);/ ]|$)","model":"MiTV 4A","device":"tv"},{"regex":"(MiTV)(4[CSX]|4)(?:[);/ ]|$)","model":"$1 $2","device":"tv"},{"regex":"HM NOTE 1W(?:[);/ ]|$)","device":"phablet","model":"Redmi Note"},{"regex":"HM NOTE 1TD (?:Build|MIUI)","device":"phablet","model":"Hongmi Note 1TD"},{"regex":"HM NOTE 1(?:LTE|S)(?:W|GLOBAL|TD)? (?:Build|MIUI)|HM NOTE 1LTE","device":"phablet","model":"Redmi Note 4G"},{"regex":"Redmi Note 5A Prime","model":"Redmi Note 5A Prime","device":"phablet"},{"regex":"M2010J19SC(?:[);/ ]|$)","model":"Redmi Note 9","device":"phablet"},{"regex":"M2003J15SC(?:[);/ ]|$)","model":"Redmi Note 10X","device":"phablet"},{"regex":"M2007J22G(?:[);/ ]|$)","model":"Redmi Note 9T 5G","device":"phablet"},{"regex":"M2007J22C(?:[);/ ]|$)","model":"Redmi Note 9 5G","device":"phablet"},{"regex":"M2007J17C(?:[);/ ]|$)","model":"Redmi Note 9 Pro 5G","device":"phablet"},{"regex":"M2101K7A[GI]","model":"Redmi Note 10","device":"phablet"},{"regex":"M2101K6[GI]","model":"Redmi Note 10 Pro","device":"phablet"},{"regex":"Redmi Note ([5-9]) Pro(?:[);/ ]|$)","model":"Redmi Note $1 Pro","device":"phablet"},{"regex":"Redmi[ _]Note[ _]([^;/) ]+)?","model":"Redmi Note $1","device":"phablet"},{"regex":"Redmi[ _]([^;/) ]+)?","model":"Redmi $1"},{"regex":"MI_NOTE_Pro","model":"MI Note Pro","device":"phablet"},{"regex":"Mi Note 10 Pro","model":"Mi Note 10 Pro","device":"phablet"},{"regex":"MI[ _]Note[ _]([^;/) ]+)?","model":"MI Note $1","device":"phablet"},{"regex":"(MI(?:-One)?[ _](?:[^;/]*))Build","model":"$1"},{"regex":"(MI[ _][a-z0-9]+|MI-One[ _]?[a-z0-9]+)(?:[);/ ]|$)","model":"$1"},{"regex":"HM Note ([^/;]+) (?:Build|MIUI)","device":"phablet","model":"Note"},{"regex":"HM ([^/;]+) (?:Build|MIUI)","model":"HM $1"},{"regex":"Xiaomi[ _-]([^/;]+)(?: Build|$)","model":"$1"}]},"Xion":{"regex":"XI-CE(?:655|U[48])","device":"smartphone","models":[{"regex":"XI-CE(655|U[48])","model":"CE$1"}]},"Xolo":{"regex":"Xolo|(?:Q600|Q700s?|Q800|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5.[05]|Era5X|Era[ _]2V|Era_4X(?:_2GB)?)(?:[);/ ]|$)|BLACK-1XM","device":"smartphone","models":[{"regex":"BLACK-1XM","model":"Black 1X"},{"regex":"Era_?([45])X(?:[);/ ]|$)","model":"Era $1X"},{"regex":"Era_4X_2GB(?:[);/ ]|$)","model":"Era 4X 2GB"},{"regex":"Era[ _]2V(?:[);/ ]|$)","model":"Era 2V"},{"regex":"(Q600 Club|Q600|Q700s?|Q800|Q1000s Plus|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5.[05])(?:[);/ ]|$)","model":"$1"},{"regex":"Xolo[ _]?([^;/]+) Build","model":"$1"},{"regex":"Xolo[ _]?([a-z0-9_-]+)","model":"$1"}]},"Yarvik":{"regex":"Xenta[ \\\\-]Tab|Luna TAB|TAB09-410|TAB10-410|TAB07-485|TAB0[78]-200|TAB08-201-3G|TAB9-200|TAB09-211|TAB10-2[01]1|TAB13-201","device":"tablet","models":[{"regex":"Luna TAB07-920N","model":"Luna 7"},{"regex":"Luna TAB07-10[01]","model":"Luna 7c"},{"regex":"Luna TAB274","model":"Luna 7c"},{"regex":"Luna TAB474","model":"Luna 10"},{"regex":"Luna TAB10-150","model":"Luna 10c"},{"regex":"TAB09-410","model":"Noble 9.7"},{"regex":"TAB10-410","model":"Noble 10.1"},{"regex":"TAB07-485","model":"Noble Mini"},{"regex":"Xenta-TAB07-21[01]","model":"Xenta 7c"},{"regex":"TAB07-200","model":"Xenta 7ic"},{"regex":"TAB08-200","model":"Xenta 8ic"},{"regex":"TAB08-201-3G","model":"Xenta 8c"},{"regex":"TAB9-200","model":"Xenta 9.7ic"},{"regex":"TAB09-211","model":"Xenta 9.7ic+"},{"regex":"TAB10-2[01]1","model":"Xenta 10ic"},{"regex":"TAB13-201","model":"Xenta 13c"}]},"Yes":{"regex":"M631Y|M685Y4|M651G_MY|YES (MPY(?:48|54))","device":"smartphone","models":[{"regex":"M631Y","model":"Altitude"},{"regex":"M651G_MY","model":"Altitude 2"},{"regex":"M685Y4","model":"Altitude 3"},{"regex":"YES (MPY(?:48|54))","model":"$1"}]},"Yezz":{"regex":"Yezz|ANDY[ _]|(?:4E4|A5EI|LIV1)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"4E4","model":"Andy 4E4"},{"regex":"Yezz-AC4EI","model":"Andy 4EI"},{"regex":"YEZZ-A4M","model":"Andy A4M"},{"regex":"A5EI","model":"Andy A5EI"},{"regex":"LIV1","model":"LIV1"},{"regex":"Andy[ _]([A-Z]*[0-9]\\\\.[0-9][A-Z0-9]*)(?:[ _](LTE))?","model":"Andy $1 $2"},{"regex":"Andy[ _]([A-Z]*[0-9])([0-9][A-Z0-9]*)(?:[ _](LTE))?","model":"Andy $1.$2 $3"},{"regex":"Andy[ _]([A-Z]*[0-9][A-Z0-9]+)(?:[ _](LTE))?","model":"Andy $1 $2"}]},"Yu":{"regex":"(?:YU5[05]10[A]?|YU4711|AO5510|YU5050|YU501[14]|YU5551)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"YU5010[A]?(?:[);/ ]|$)","model":"Yuphoria"},{"regex":"YU5011(?:[);/ ]|$)","model":"Yunique 2"},{"regex":"YU5050(?:[);/ ]|$)","model":"Yutopia"},{"regex":"AO5510(?:[);/ ]|$)","model":"Yureka"},{"regex":"YU5551(?:[);/ ]|$)","model":"Yureka 2"},{"regex":"YU5510[A]?(?:[);/ ]|$)","model":"Yureka Plus"},{"regex":"YU4711(?:[);/ ]|$)","model":"Yunique"},{"regex":"YU5014(?:[);/ ]|$)","model":"Ace"}]},"Yuandao":{"regex":"N101[ _]DUAL(?:[ _]CORE)?(?:[ _]?2|\\\\|\\\\|)?(?:[ _]V11)?(?:[);/ ]|$)","device":"tablet","model":"N101"},"Yusun":{"regex":"Yusun|LA2-T","device":"smartphone","models":[{"regex":"LA2-T","model":"LA2-T"},{"regex":"Yusun ([^;/]+) Build","model":"$1"},{"regex":"Yusun ([a-z0-9_\\\\-\\\\+]+)","model":"$1"}]},"Ytone":{"regex":"YTONE[ _\\\\-]","device":"smartphone","models":[{"regex":"YTONE[ _\\\\-]?([^/;]+) Build","model":"$1"},{"regex":"YTONE[ _\\\\-]?([^);/ ]+)","model":"$1"}]},"Zonda":{"regex":"(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)|ZA409","device":"feature phone","models":[{"regex":"ZA409","device":"smartphone","model":"Muzic"},{"regex":"(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)","model":"$1"}]},"ZYQ":{"regex":"ZYQ-Q88|(Q(?:2602|262[436]|638|2688|272[89]|3022|3623|TAB Tab4|328 m9|328|668)|J77|Q[._](?:Up|Boss P99|Dee R09|Good M9|Hi|Hot|Me|Mate R99|Next|TOP-X8|You))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Q638","model":"I7"},{"regex":"Q2624","model":"Cheer 3G"},{"regex":"Q2602","model":"TV Next"},{"regex":"Q2728","model":"Zone 3G"},{"regex":"Q2729","model":"Q2729"},{"regex":"Q2688","model":"Q2688"},{"regex":"Q2623","model":"Win 3G"},{"regex":"Q2626","model":"Care 3G"},{"regex":"Q3623","model":"Braw 3G"},{"regex":"Q3022","model":"Q3022"},{"regex":"Q328 m9","model":"Q328 M9"},{"regex":"Q328","model":"Speed 3G"},{"regex":"Q668","model":"TV I4"},{"regex":"J77","model":"Q.Dee"},{"regex":"Q\\\\.Up C5","model":"Q.Up C5"},{"regex":"Q\\\\.Up","model":"Q.Up"},{"regex":"Q\\\\.Boss P99","model":"Q.Boss P99"},{"regex":"Q[._]Dee R09","model":"Q.Dee R09"},{"regex":"Q\\\\.Good M9","model":"Q.Good M9"},{"regex":"Q[._]Hi S1","model":"Q.Hi S1"},{"regex":"Q[._]Hi","model":"Q.Hi"},{"regex":"Q[._]Hot P7 3G","model":"Q.Hot P7 3G"},{"regex":"Q[._]Hot","model":"Q.Hot"},{"regex":"Q[._]Me Phone7 3G","model":"Q.Me Phone 7 3G"},{"regex":"Q[._]Me Plus7","model":"Q.Me Plus 7"},{"regex":"Q[._]Me","model":"Q.Me"},{"regex":"Q[._]Mate R99","model":"Q.Mate R99"},{"regex":"Q[._]Next B7","model":"Q.Next B7"},{"regex":"Q[._]Next J2","model":"Q.Next J2"},{"regex":"Q[._]TOP-X8","model":"Q.Top X8"},{"regex":"Q[._]You","model":"Q.You"},{"regex":"QTAB Tab4","model":"QTab Tab4","device":"tablet"},{"regex":"ZYQ-Q88","model":"Q88","device":"tablet"}]},"Toshiba":{"regex":"Toshiba|TSBNetTV/|portalmmm/[12].0 TS|T-01C|T-0[12]D|IS04|IS11T|AT1S0|AT300SE|AT(7-C|10-A|10[PL]E-A|100|200|270|300|330|374|400|470|500|503|570|703|830)","device":"smartphone","models":[{"regex":"T-01C","model":"Regza T-01C"},{"regex":"T-01D","model":"Regza T-01D"},{"regex":"T-02D","model":"Regza T-02D"},{"regex":"IS04","model":"Regza IS04"},{"regex":"IS11T","model":"Regza IS11T"},{"regex":"AT7-C","model":"Excite","device":"tablet"},{"regex":"AT1S0","model":"Regza AT1S0","device":"tablet"},{"regex":"AT300SE","model":"Regza AT300SE","device":"tablet"},{"regex":"AT500a","model":"Regza AT500a","device":"tablet"},{"regex":"AT(100|200|270|300|330|374|400|470|500|503|570|703|830)","model":"Regza AT$1","device":"tablet"},{"regex":"AT10([PL])E-A","model":"Excite AT10$1-A","device":"tablet"},{"regex":"AT10-A","model":"Excite AT10-A","device":"tablet"},{"regex":"TSBNetTV/","device":"tv","model":""},{"regex":"Toshiba[ /_\\\\-]?([a-z0-9_ \\\\-]+) Build","model":"$1"},{"regex":"Toshiba[ /_\\\\-]?([a-z0-9_\\\\-]+)","model":"$1"},{"regex":"portalmmm/[12].0 (TS[a-z0-9 ]+)","model":"$1"}]},"Vivax":{"regex":"VIVAX|(?:Fly5[_ ]Lite|Fun[_ ]S500|Point_(?:X[12]|X501)|PRO3|32LE77SM|40LE77SM|FUN S1|FUN_S20)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Fly5[_ ]Lite(?:[);/ ]|$)","model":"Fly 5 Lite"},{"regex":"Point_X([12])(?:[);/ ]|$)","model":"Point X$1"},{"regex":"Fun[_ ]S500(?:[);/ ]|$)","model":"Fun S500"},{"regex":"FUN[ _]S(1|20)(?:[);/ ]|$)","model":"Fun S$1"},{"regex":"VIVAX[ _]Fly3(?:[);/ ]|$)","model":"Fly 3"},{"regex":"VIVAX[ _]Fly[ _]V1(?:[);/ ]|$)","model":"Fly V1"},{"regex":"(?:VIVAX )?(Point[ _](?:X551|X501))(?:[);/ ]|$)","model":"$1"},{"regex":"SMART Point X5010(?:[);/ ]|$)","model":"Smart Point X5010"},{"regex":"VIVAX[_ ]PRO3","model":"Pro 3"},{"regex":"VIVAX TABLET TPC 802 3G(?:[);/ ]|$)","model":"TPC-802 3G"},{"regex":"(32LE77SM|40LE77SM)","device":"tv","model":"$1"}]},"MLS":{"regex":"IQ(?:0705|L550|1010w?|1012N?|1019N|1025|1380|1401|1436|1452a|1453|1470|1502a|1511|1552|1553|1568|1570|1805N|1806|1808|1810B_M|1832|1850|1890|5017|9610|181011N|E[12]00|EL41|G550|GW516|L30|L5[01]|M801|M1001|N700|P50|R300|S300|S1001|W503|W511T|W553N?|W60[38]|W626|M960|D700|9013_4N)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"IQ0705(?:[);/ ]|$)","model":"iQTalk Twist"},{"regex":"IQL550(?:[);/ ]|$)","model":"Notch Lite"},{"regex":"IQ1010W?(?:[);/ ]|$)","model":"iQTab 10","device":"tablet"},{"regex":"IQ1012N?(?:[);/ ]|$)","model":"iQTab Brave 3G","device":"tablet"},{"regex":"IQ1025(?:[);/ ]|$)","model":"iQTab Action 4G","device":"tablet"},{"regex":"iQ9013_4N(?:[);/ ]|$)","model":"Life 10.1\\"","device":"tablet"},{"regex":"IQ1019N(?:[);/ ]|$)","model":"Alu Plus 4G 10.1\\"","device":"tablet"},{"regex":"iQ1805N(?:[);/ ]|$)","model":"iQTab Ideal 8.0\\"","device":"tablet"},{"regex":"iQ181011N(?:[);/ ]|$)","model":"iQTab Care 8.0\\"","device":"tablet"},{"regex":"IQ1380(?:[);/ ]|$)","model":"Brain 3G"},{"regex":"IQ1401(?:[);/ ]|$)","model":"iQTalk Verse 4G"},{"regex":"IQ1436(?:[);/ ]|$)","model":"Color mini 4G"},{"regex":"IQ1452a(?:[);/ ]|$)","model":"TOP-S 4G"},{"regex":"IQ1453(?:[);/ ]|$)","model":"Trend 4G"},{"regex":"IQ1470(?:[);/ ]|$)","model":"iQTalk Onyx"},{"regex":"IQ1502a(?:[);/ ]|$)","model":"iQTalk Flame"},{"regex":"IQ1511(?:[);/ ]|$)","model":"iQTalk Spicy"},{"regex":"IQ1552(?:[);/ ]|$)","model":"iQTalk Titan 4G"},{"regex":"IQ1553(?:[);/ ]|$)","model":"Color 3 4G"},{"regex":"IQ1568(?:[);/ ]|$)","model":"Range 4G"},{"regex":"IQ1570(?:[);/ ]|$)","model":"iQTalk Color 5.5 4G"},{"regex":"IQ1806(?:[);/ ]|$)","model":"iQTab Rose","device":"tablet"},{"regex":"IQ1808(?:[);/ ]|$)","model":"iQTab Master","device":"tablet"},{"regex":"IQ1810B_M(?:[);/ ]|$)","model":"iQTab Novel 3G","device":"tablet"},{"regex":"IQ1832(?:[);/ ]|$)","model":"Jet 3G","device":"tablet"},{"regex":"IQ1850(?:[);/ ]|$)","model":"Diamond 5.2 4G"},{"regex":"IQ1890(?:[);/ ]|$)","model":"iQTalk Aura"},{"regex":"IQ5017(?:[);/ ]|$)","model":"Slice 4G"},{"regex":"IQ9610(?:[);/ ]|$)","model":"Angel 3G","device":"tablet"},{"regex":"iQM960(?:[);/ ]|$)","model":"Angel 3G (2018)","device":"tablet"},{"regex":"IQG550(?:[);/ ]|$)","model":"Style 4G"},{"regex":"IQGW516(?:[);/ ]|$)","model":"F5"},{"regex":"IQE100(?:[);/ ]|$)","model":"Energy 4G"},{"regex":"iQE200(?:[);/ ]|$)","model":"MX 4G"},{"regex":"IQEL41(?:[);/ ]|$)","model":"Fab 4G"},{"regex":"IQL30(?:[);/ ]|$)","model":"Status 4G"},{"regex":"IQL50(?:[);/ ]|$)","model":"More 4G"},{"regex":"IQL51(?:[);/ ]|$)","model":"Wave 4G"},{"regex":"IQM801(?:[);/ ]|$)","model":"Brace 2018 4G","device":"tablet"},{"regex":"IQM1001(?:[);/ ]|$)","model":"Level 4G","device":"tablet"},{"regex":"IQN700(?:[);/ ]|$)","model":"Inspire 4G"},{"regex":"IQP50(?:[);/ ]|$)","model":"Ruby 4G"},{"regex":"IQS300(?:[);/ ]|$)","model":"DX 4G"},{"regex":"IQS1001(?:[);/ ]|$)","model":"Vista 4G","device":"tablet"},{"regex":"IQR300(?:[);/ ]|$)","model":"R3 4G"},{"regex":"IQW608(?:[);/ ]|$)","model":"Regal"},{"regex":"iQW603(?:[);/ ]|$)","model":"Phab 6.0\\"","device":"phablet"},{"regex":"IQW626(?:[);/ ]|$)","model":"D6 4G"},{"regex":"IQW511T(?:[);/ ]|$)","model":"Liberal"},{"regex":"IQW553N?(?:[);/ ]|$)","model":"Alu 5.5\\""},{"regex":"IQW503(?:[);/ ]|$)","model":"Flame 4G (2018)"},{"regex":"iQD700(?:[);/ ]|$)","model":"Color Fingerprint 4G"}]},"Fly":{"regex":"Fly(?!Flow|touch)|Power Plus 5000|Photo Pro|Slimline|Life (?:Ace|Jet|Sky|Compact 4G|Geo)|FS50[1-9]|FS51[0-8]|FS52[0-9]|FS530|FS55[134]|FS40[1-9]|FS45[1-9]|4FS06|MERIDIAN-|(?:IQ(?!10[134]0)[0-9]{3,}[i]?)[ _]?(?:Quad|Firebird|Quattro|Turbo|Magic)?(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:Fly_)?IQ310(?:[);/ ]|$)","model":"Panorama","device":"tablet"},{"regex":"(?:Fly_)?IQ236(?:[);/ ]|$)","model":"Victory"},{"regex":"Slimline(?:[);/ ]|$)","model":"Slimline"},{"regex":"Power Plus 5000(?:[);/ ]|$)","model":"Power Plus 5000"},{"regex":"Photo Pro(?:[);/ ]|$)","model":"Photo Pro"},{"regex":"Life Ace(?:[);/ ]|$)","model":"Life Ace"},{"regex":"Life Jet(?:[);/ ]|$)","model":"Life Jet"},{"regex":"Life Sky(?:[);/ ]|$)","model":"Life Sky"},{"regex":"Life Geo(?:[);/ ]|$)","model":"Life Geo"},{"regex":"Life Compact 4G(?:[);/ ]|$)","model":"Life Compact 4G"},{"regex":"FS506","model":"Cirrus 3"},{"regex":"FS403","model":"Cumulus 1"},{"regex":"FS508","model":"Cirrus 6"},{"regex":"FS511","model":"Cirrus 7"},{"regex":"FS509","model":"Nimbus 9"},{"regex":"FS406","model":"Stratus 5"},{"regex":"FS404","model":"Stratus 3"},{"regex":"FS504","model":"Cirrus 2"},{"regex":"FS407","model":"Stratus 6"},{"regex":"FS401","model":"Stratus 1"},{"regex":"FS402","model":"Stratus 2"},{"regex":"FS501","model":"Nimbus 3"},{"regex":"FS502","model":"Cirrus 1"},{"regex":"FS507","model":"Cirrus 4"},{"regex":"FS505","model":"Nimbus 7"},{"regex":"FS551","model":"Nimbus 4"},{"regex":"FS514","model":"Cirrus 8"},{"regex":"FS553","model":"Cirrus 9"},{"regex":"FS554","model":"Power Plus FHD"},{"regex":"FS517","model":"Cirrus 11"},{"regex":"FS516","model":"Cirrus 12"},{"regex":"FS518","model":"Cirrus 13"},{"regex":"FS520","model":"Selfie 1"},{"regex":"FS521","model":"Power Plus 1"},{"regex":"FS522","model":"Cirrus 14"},{"regex":"FS523","model":"Cirrus 16"},{"regex":"FS524","model":"Knockout"},{"regex":"FS526","model":"Power Plus 2"},{"regex":"FS527","model":"Nimbus 17"},{"regex":"FS528","model":"Memory Plus"},{"regex":"FS529","model":"Сhamp"},{"regex":"FS530","model":"Power Plus XXL"},{"regex":"FS454","model":"Nimbus 8"},{"regex":"FS452","model":"Nimbus 2"},{"regex":"FS512","model":"Nimbus 10"},{"regex":"FS510","model":"Nimbus 12"},{"regex":"FS451","model":"Nimbus 1"},{"regex":"FS405","model":"Stratus 4"},{"regex":"FS408","model":"Stratus 8"},{"regex":"FS409","model":"Stratus 9"},{"regex":"FS455","model":"Nimbus 11"},{"regex":"FS456","model":"Nimbus 14"},{"regex":"FS457","model":"Nimbus 15"},{"regex":"FS459","model":"Nimbus 16"},{"regex":"FS458","model":"Stratus 7"},{"regex":"(?:Fly_)?IQ237(?:[);/ ]|$)","model":"Dynamic"},{"regex":"(?:Fly_)?IQ238(?:[);/ ]|$)","model":"Jazz"},{"regex":"(?:Fly_)?IQ240(?:[);/ ]|$)","model":"Whizz"},{"regex":"(?:Fly_)?IQ255(?:[);/ ]|$)","model":"Pride"},{"regex":"(?:Fly_)?IQ270(?: Firebird)?(?:[);/ ]|$)","model":"Firebird"},{"regex":"(?:Fly_)?IQ275(?:[);/ ]|$)","model":"Marathon"},{"regex":"(?:Fly_)?IQ285(?: Turbo)?(?:[);/ ]|$)","model":"Turbo"},{"regex":"(?:Fly_)?IQ430(?:[);/ ]|$)","model":"Evoke"},{"regex":"(?:Fly_)?IQ431(?:[);/ ]|$)","model":"Glory"},{"regex":"(?:Fly_)?IQ432(?:[);/ ]|$)","model":"Era Nano 1"},{"regex":"(?:Fly_)?IQ436(?:[);/ ]|$)","model":"Era Nano 3"},{"regex":"(?:Fly_)?IQ4490(?:[);/ ]|$)","model":"Era Nano 4"},{"regex":"(?:Fly_)?IQ434(?:[);/ ]|$)","model":"Era Nano 5"},{"regex":"(?:Fly_)?IQ4406(?:[);/ ]|$)","model":"Era Nano 6"},{"regex":"(?:Fly_)?IQ436i(?:[);/ ]|$)","model":"Era Nano 9"},{"regex":"(?:Fly_)?IQ440(?:[);/ ]|$)","model":"Energy"},{"regex":"(?:Fly_)?IQ4401(?:[);/ ]|$)","model":"Era Energy 2"},{"regex":"(?:Fly_)?IQ441(?:[);/ ]|$)","model":"Radiance"},{"regex":"(?:Fly_)?IQ442 Quad(?:[);/ ]|$)","model":"Miracle 2"},{"regex":"(?:Fly_)?IQ442(?:[);/ ]|$)","model":"Miracle"},{"regex":"(?:Fly_)?IQ443(?:[);/ ]|$)","model":"Trend"},{"regex":"(?:Fly_)?IQ444(?: Quattro)?(?:[);/ ]|$)","model":"Diamond 2"},{"regex":"(?:Fly_)?IQ445(?:[);/ ]|$)","model":"Genius"},{"regex":"(?:Fly_)?IQ446(?: Magic)?(?:[);/ ]|$)","model":"Magic"},{"regex":"(?:Fly_)?IQ447(?:[);/ ]|$)","model":"Era Life 1"},{"regex":"(?:Fly_)?IQ456(?:[);/ ]|$)","model":"Era Life 2"},{"regex":"(?:Fly_)?IQ4409 Quad(?:[);/ ]|$)","model":"Era Life 4"},{"regex":"(?:Fly_)?IQ448(?:[);/ ]|$)","model":"Chic"},{"regex":"(?:Fly_)?IQ449(?:[);/ ]|$)","model":"Pronto"},{"regex":"(?:Fly_)?IQ450(?:[);/ ]|$)","model":"Horizon"},{"regex":"(?:Fly_)?IQ450[ _]Quattro(?:[);/ ]|$)","model":"Horizon 2"},{"regex":"(?:Fly_)?IQ451(?:[);/ ]|$)","model":"Vista"},{"regex":"(?:Fly_)?IQ452 Quad(?:[);/ ]|$)","model":"Ego Vision 1"},{"regex":"(?:Fly_)?IQ454(?:[);/ ]|$)","model":"Evo Tech 1"},{"regex":"(?:Fly_)?IQ4403(?:[);/ ]|$)","model":"Energy 3"},{"regex":"(?:Fly_)?IQ4404(?:[);/ ]|$)","model":"Spark"},{"regex":"(?:Fly_)?IQ4410 Quad(?:[);/ ]|$)","model":"Phoenix"},{"regex":"(?:Fly_)?IQ4411(?:[);/ ]|$)","model":"Energy 2"},{"regex":"(?:Fly_)?IQ4412 Quad(?:[);/ ]|$)","model":"Coral"},{"regex":"(?:Fly_)?IQ4413[ _]Quad(?:[);/ ]|$)","model":"Evo Chic 3"},{"regex":"(?:Fly_)?IQ4414 Quad(?:[);/ ]|$)","model":"Evo Tech 3"},{"regex":"(?:Fly_)?IQ4415 Quad(?:[);/ ]|$)","model":"Era Style 3"},{"regex":"(?:Fly_)?IQ4504 Quad(?:[);/ ]|$)","model":"Evo Energy 5"},{"regex":"(?:Fly_)?IQ([0-9]+[i]? ?(?:Quad|Firebird|Quattro)?)(?:[);/ ]|$)","model":"IQ$1"},{"regex":"Fly[ _\\\\-]?([a-z0-9_]+)/","model":"$1","device":"feature phone"},{"regex":"Flylife[ _\\\\-]?([^/;]+) Build","model":"Flylife $1","device":"tablet"},{"regex":"Fly[ _\\\\-]?([a-z0-9]+)","model":"$1"},{"regex":"MERIDIAN-([a-z0-9]+)","model":"$1"}]},"FinePower":{"regex":"FinePower[_ ]?([AB][1-9]|[CD][1-9])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"FinePower[_ ]?([AB][1-9])(?:[);/ ]|$)","model":"$1","device":"tablet"},{"regex":"FinePower[_ ]?([CD][1-9])(?:[);/ ]|$)","model":"$1"}]},"Freetel":{"regex":"(?:FTJ17[AC]00|FTJ152[ABCD]|FTU18A00|FT141B|FT142D(?:_LTEXM)?|FT142A?|FTJ161[AB]|FTJ1[56]2E|FTJ162[BD]|FTE161[GE])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"FTJ152C","model":"Samurai Miyabi"},{"regex":"FTJ17A00(?:[);/ ]|$)","model":"Rei 2 Dual"},{"regex":"FTJ17C00(?:[);/ ]|$)","model":"Priori 5"},{"regex":"FTU18A00(?:[);/ ]|$)","model":"Cricket Wave"},{"regex":"FTJ161A","model":"Musashi"},{"regex":"FTE161E","model":"Ice 2"},{"regex":"FTE161G","model":"Ice 2 Plus"},{"regex":"FTJ162E","model":"Raijin"},{"regex":"FT141B","model":"Nico"},{"regex":"FT142D(?:_LTEXM)?(?:[);/ ]|$)","model":"XM"},{"regex":"FT142A?","model":"Priori 2"},{"regex":"FTJ152A","model":"Priori 3"},{"regex":"FTJ162D","model":"Priori 4"},{"regex":"FTJ152B","model":"Priori 3S LTE"},{"regex":"FTJ152D","model":"Samurai Kiwami"},{"regex":"FTJ162B","model":"Samurai Kiwami 2"},{"regex":"FTJ161B","model":"Samurai Rei"},{"regex":"FTJ152E","model":"Katana 1"}]},"Western Digital":{"regex":"Westerndigital|WDSimpleBrowser","device":"tv","models":[{"regex":"Streamer2010","model":"Streamer (2010)"}]},"Zeemi":{"regex":"ZEEMI[ _-]","device":"smartphone","models":[{"regex":"ZEEMI[ _-]([^/;]+) Build","model":"$1"},{"regex":"ZEEMI[ _-]([^/;)]+)(?:[);/]|$)","model":"$1"}]},"Zenek":{"regex":"Z5007|Z551[679]|Z6001","device":"smartphone","models":[{"regex":"Z5517","model":"Leopardo"},{"regex":"Z6001","model":"Libelula"},{"regex":"Z5007","model":"Oso"},{"regex":"Z5519","model":"Pingûino"},{"regex":"Z5516","model":"Zebra"}]},"Zopo":{"regex":"ZOPO|(?:ZOPO[_ ])?(Flash X3|ZP[0-9]{2,}[^/;]+)(?:\\\\)| Build)","device":"smartphone","models":[{"regex":"(?:ZOPO_C2_MOD|ZP998)(?:[);/ ]|$)","model":"C2 II"},{"regex":"ZOPO 9xxQuad(?:[);/ ]|$)","model":"9XX Quad"},{"regex":"(?:ZOPO_)?ZP980[+](?:[);/ ]|$)","model":"ZP980+"},{"regex":"(?:ZOPO_)?ZP980(?:[);/ ]|$)","model":"Scorpio"},{"regex":"ZP952(?:[);/ ]|$)","model":"Speed 7 Plus"},{"regex":"ZP951(?:[);/ ]|$)","model":"Speed 7"},{"regex":"ZP955(?:[);/ ]|$)","model":"Speed 8"},{"regex":"ZP950[+h]?(?:[);/ ]|$)","model":"Leader Max"},{"regex":"ZP(?:900H?|910)(?:[);/ ]|$)","model":"Leader"},{"regex":"ZP(?:800H|810)(?:[);/ ]|$)","model":"Libero HD"},{"regex":"ZP500[+]?(?:[);/ ]|$)","model":"Libero"},{"regex":"ZP330(?:[);/ ]|$)","model":"Color C"},{"regex":"ZP370(?:[);/ ]|$)","model":"Color S"},{"regex":"ZP5(63|86)(?:[);/ ]|$)","model":"Color X"},{"regex":"ZP567(?:[);/ ]|$)","model":"Color C5i"},{"regex":"ZP300[S+]?(?:[);/ ]|$)","model":"Field"},{"regex":"ZP200[+]?(?:[);/ ]|$)","model":"Shining"},{"regex":"ZP100(?:[);/ ]|$)","model":"Pilot"},{"regex":"ZP1790(?:[);/ ]|$)","model":"Flash X2"},{"regex":"ZP781(?:[);/ ]|$)","model":"Flash G5 Plus"},{"regex":"(?:ZOPO_)?(Flash X3|X1i|ZP[0-9]{2,}[^/;)]+)(?: Build|\\\\))","model":"$1"}]},"ZTE":{"regex":"ZTE|AxonPhone|([a-z0-9]+)_USA_Cricket|(?:Blade (?:V0820|L110|L[2357]|L7A|S6|V[6789]|V8Q|V8 SE|V9 VITA|X7|A(310|460|465|475|520|530|602)|V580|V Ultra|Q Lux)|N9[15]8St|NX(?:403A|404H|406E|40[X2]|507J|503A|505J|506J|508J|510J|512J|511J|513J|521J|523J_V1|529J|531J|541J|5[48]9J|551J|563J|569[HJ]|573J|575J|59[157]J|60[1689]J|61[12679]J|62[79]J|65[19]J|907J)|N818S|N951[0579]|N91[38]0|N9101|N913[267]|N952[01]|N9560|N9810|N799D|[UV]9180|[UV]9815|Z(?:233V|331|5031O|559DL|6621O|667T|768G|792|81[25]|818L|82[08]|83[12359]|85[125]|851M|992|(557|71[67]|798|836|861|916)BL|986DL|(232|718|828)TL|(?:233|353|558|717|799|837|862|899|917|963)VL|955A|95[678]|965|97[018]|98[1237]|986U|999|936L)|V769M|Apex2|G (LTE|Lux)|Vec|Z959|V865M|Z3001S|902ZT|KIS II Max|Kis 3|K3DX-V5G|Z930L|Optus X|Blade[ _](A510|A[357] 2019-T|A6 MAX|A0622|X9)|Z3153V|Z836F|Nubia Z(?:9|11)|Ctyon-A9|602ZT|MO-01[JK]|Z963U|402ZT|P545|P609|dandelion|901ZT|A001ZT|Z-01K|UZTE V808|ZR01|ZTG01|K8[37]CA)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"602ZT(?:[);/ ]|$)","model":"Libero 2"},{"regex":"A001ZT(?:[);/ ]|$)","model":"Libero 3"},{"regex":"901ZT(?:[);/ ]|$)","model":"Libero S10"},{"regex":"ZR01(?:[);/ ]|$)","model":"Rakuten Big"},{"regex":"ZTG01(?:[);/ ]|$)","model":"A1"},{"regex":"A7020(?:[);/ ]|$)","model":"Blade A7s (2020)"},{"regex":"ZTE 2050(?:RU)?","model":"Blade 20 Smart"},{"regex":"902ZT(?:[);/ ]|$)","model":"Axon 10 Pro 5G"},{"regex":"N799D(?:[);/ ]|$)","model":"Blade Eg"},{"regex":"Z818L(?:[);/ ]|$)","model":"Allstar"},{"regex":"Z3001S(?:[);/ ]|$)","model":"Quest Plus"},{"regex":"Ctyon-A9(?:[);/ ]|$)","model":"Ctyon A9"},{"regex":"K3DX-V5G(?:[);/ ]|$)","model":"V5G"},{"regex":"N918St(?:[);/ ]|$)","model":"V5S"},{"regex":"N958St(?:[);/ ]|$)","model":"V5 Max"},{"regex":"N9101(?:[);/ ]|$)","model":"Imperial"},{"regex":"Z963U(?:[);/ ]|$)","model":"Imperial Max"},{"regex":"N9120(?:[);/ ]|$)","model":"Avid"},{"regex":"N9130(?:[);/ ]|$)","model":"Speed"},{"regex":"N9132(?:[);/ ]|$)","model":"Prestige"},{"regex":"N9136(?:[);/ ]|$)","model":"Prestige 2"},{"regex":"N9137(?:[);/ ]|$)","model":"Tempo X"},{"regex":"N9180(?:[);/ ]|$)","model":"V5"},{"regex":"N9510(?:[);/ ]|$)","model":"Warp 4G"},{"regex":"N9517(?:[);/ ]|$)","model":"Blade Force"},{"regex":"Z559DL(?:[);/ ]|$)","model":"Blade T2"},{"regex":"402ZT(?:[);/ ]|$)","model":"Blade Q+"},{"regex":"Blade Q Lux(?:[);/ ]|$)","model":"Blade Q Lux"},{"regex":"N9515(?:[);/ ]|$)","model":"Warp Sync"},{"regex":"N9519(?:[);/ ]|$)","model":"Warp 7"},{"regex":"N9520(?:[);/ ]|$)","model":"Boost Max"},{"regex":"N9521(?:[);/ ]|$)","model":"Boost Max+"},{"regex":"N9560(?:[);/ ]|$)","model":"Max XL"},{"regex":"N9810(?:[);/ ]|$)","model":"Vital"},{"regex":"NX40[X2](?:[);/ ]|$)","model":"Nubia Z5 Mini"},{"regex":"NX(403[AE]|406E|404H)(?:[);/ ]|$)","model":"Nubia Z5S Mini"},{"regex":"NX503A(?:[);/ ]|$)","model":"Nubia Z5S"},{"regex":"NX506J(?:[);/ ]|$)","model":"Nubia Z7"},{"regex":"NX507J(?:[);/ ]|$)","model":"Nubia Z7 Mini"},{"regex":"NX505J(?:[);/ ]|$)","model":"Nubia Z7 Max"},{"regex":"NX508J(?:[);/ ]|$)","model":"Nubia Z9"},{"regex":"(NX5[12]1J|Nubia Z9 mini)(?:[);/ ]|$)","model":"Nubia Z9 Mini"},{"regex":"(NX510J|Nubia Z9 Max)(?:[);/ ]|$)","model":"Nubia Z9 Max"},{"regex":"NX512J(?:[);/ ]|$)","model":"Nubia Z9 Max Dual"},{"regex":"NX531J(?:[);/ ]|$)","model":"Nubia Z11"},{"regex":"NX523J_V1","model":"Nubia Z11 Max"},{"regex":"(?:NX549J|Nubia Z11 mini S)(?:[);/ ]|$)","model":"Nubia Z11 Mini S"},{"regex":"(?:NX529J|Nubia Z11 mini)(?:[);/ ]|$)","model":"Nubia Z11 Mini"},{"regex":"NX606J(?:[);/ ]|$)","model":"Nubia Z18"},{"regex":"NX616J(?:[);/ ]|$)","model":"Nubia Z18S"},{"regex":"NX611J(?:[);/ ]|$)","model":"Nubia Z18 Mini"},{"regex":"NX551J(?:[);/ ]|$)","model":"Nubia M2"},{"regex":"NX563J(?:[);/ ]|$)","model":"Nubia Z17"},{"regex":"NX569[HJ](?:[);/ ]|$)","model":"Nubia Z17 Mini"},{"regex":"NX589J(?:[);/ ]|$)","model":"Nubia Z17 Mini S"},{"regex":"NX591J(?:[);/ ]|$)","model":"Nubia Z17 Lite"},{"regex":"NX595J(?:[);/ ]|$)","model":"Nubia Z17S"},{"regex":"NX612J(?:[);/ ]|$)","model":"Nubia V18"},{"regex":"NX627J","model":"Nubia Z20"},{"regex":"NX513J(?:[);/ ]|$)","model":"Nubia My Prague"},{"regex":"NX601J(?:[);/ ]|$)","model":"Nubia X6"},{"regex":"NX609J(?:[);/ ]|$)","model":"Nubia Red Magic"},{"regex":"NX659J(?:[);/ ]|$)","model":"Nubia Red Magic 5G"},{"regex":"NX651J(?:[);/ ]|$)","model":"Nubia Play"},{"regex":"NX619J(?:[);/ ]|$)","model":"Nubia Red Magic Mars"},{"regex":"NX629J(?:[);/ ]|$)","model":"Nubia Red Magic 3"},{"regex":"NX573J","model":"Nubia M2 Lite"},{"regex":"NX907J(?:[);/ ]|$)","model":"Nubia M2 Play"},{"regex":"NX541J","model":"Nubia N1"},{"regex":"NX597J","model":"Nubia N1 Lite"},{"regex":"NX575J","model":"Nubia N2"},{"regex":"NX6(08|17)J(?:[);/ ]|$)","model":"Nubia N3"},{"regex":"[UV]9180(?:[);/ ]|$)","model":"V5 Red Bull"},{"regex":"[UV]9815(?:[);/ ]|$)","model":"Grand Memo LTE"},{"regex":"V779M","model":"Joey Jump 2"},{"regex":"V807","model":"Blade C"},{"regex":"V809","model":"Blade C2"},{"regex":"ZTE_Blade_C2_Plus","model":"Blade C2 Plus"},{"regex":"Blade G Plus","model":"Blade G Plus"},{"regex":"ZTE_Blade_III","model":"Blade III"},{"regex":"(?:ZTE_)?V829","model":"Blade G Pro"},{"regex":"V882","model":"Lord"},{"regex":"V967S","model":"Grand X2"},{"regex":"V970M?|V987","model":"Grand X"},{"regex":"Z959(?:[);/ ]|$)","model":"Grand X3"},{"regex":"V8000","model":"Nova 4"},{"regex":"Z95[67]","model":"Grand X4"},{"regex":"Z987","model":"Grand X Max+"},{"regex":"(?:ZTE_)?Grand[ _]Era","model":"Grand Era"},{"regex":"V788D","model":"Kis Plus"},{"regex":"Z331(?:[);/ ]|$)","model":"Z331"},{"regex":"N818S(?:[);/ ]|$)","model":"N818S"},{"regex":"Z5031O(?:[);/ ]|$)","model":"Optus X Spirit 2"},{"regex":"P545(?:[);/ ]|$)","model":"Optus X Power 2"},{"regex":"P609(?:[);/ ]|$)","model":"Optus X Wave"},{"regex":"Optus X Start(?:[);/ ]|$)","model":"Optus X Start"},{"regex":"BA520(?:[);/ ]|$)","model":"Blade A520"},{"regex":"Blade (A(0620|310|321|452|460|462|465|475|510|512|52[012]|530|531|602|612|910)|L[12]10|L130|V0730|V0800|V580|V1000)(?:[);/ ]|$)","model":"Blade $1"},{"regex":"Blade L2 Plus(?:[);/ ]|$)","model":"Blade L2 Plus"},{"regex":"(?:ZTE_)?Blade[ _]L2(?:[);/ ]|$)","model":"Blade L2"},{"regex":"Blade L3 Plus(?:[);/ ]|$)","model":"Blade L3 Plus"},{"regex":"Blade L3 Apex(?:[);/ ]|$)","model":"Blade L3 Apex"},{"regex":"Blade L3(?:[);/ ]|$)","model":"Blade L3"},{"regex":"Blade L5 Plus(?:[);/ ]|$)","model":"Blade L5 Plus"},{"regex":"Blade L5(?:[);/ ]|$)","model":"Blade L5"},{"regex":"Blade L6(?:[);/ ]|$)","model":"Blade L6"},{"regex":"Blade L7A(?:[);/ ]|$)","model":"Blade L7A"},{"regex":"Blade L7(?:[);/ ]|$)","model":"Blade L7"},{"regex":"Blade L8(?:RU)?(?:[);/ ]|$)","model":"Blade L8"},{"regex":"Blade A([357]) (20(?:19|20))","model":"Blade A$1 ($2)"},{"regex":"Blade A3 Lite(?:[);/ ]|$)","model":"Blade A3 Lite"},{"regex":"BLADE A0622(?:[);/ ]|$)","model":"Blade A6"},{"regex":"BLADE A6 MAX(?:[);/ ]|$)","model":"Blade A6 Max"},{"regex":"Blade S6 Plus(?:[);/ ]|$)","model":"Blade S6 Plus"},{"regex":"Blade S6(?:[);/ ]|$)","model":"Blade S6"},{"regex":"T920(?:[);/ ]|$)","model":"Blade S7"},{"regex":"BLADE V Ultra(?:[);/ ]|$)","model":"Blade V Ultra"},{"regex":"Blade V6 MAX(?:[);/ ]|$)","model":"Blade V6 Max"},{"regex":"Blade V6 Plus(?:[);/ ]|$)","model":"Blade V6 Plus"},{"regex":"Blade (?:V7 Lite|V0720)(?:[);/ ]|$)","model":"Blade V7 Lite"},{"regex":"Blade V([67])(?:[);/ ]|$)","model":"Blade V$1"},{"regex":"Blade X([79])(?:[);/ ]|$)","model":"Blade X$1"},{"regex":"Blade V8Q(?:[);/ ]|$)","model":"Blade V8Q"},{"regex":"Blade V8 SE(?:[);/ ]|$)","model":"Blade V8 SE"},{"regex":"Blade V(9|10) Vita(?:[);/ ]|$)","model":"Blade V$1 Vita"},{"regex":"Blade V([89]|10)(?:[);/ ]|$)","model":"Blade V$1"},{"regex":"BLADE V0820(?:[);/ ]|$)","model":"Blade V8 Lite"},{"regex":"BLADE V0850(?:[);/ ]|$)","model":"Blade V8 Mini"},{"regex":"(?:Blade[ _])?(Apex2|G (LTE|Lux)|Vec|A510)","model":"Blade $1"},{"regex":"Z768G(?:[);/ ]|$)","model":"Midnight"},{"regex":"Z820","model":"Obsidian"},{"regex":"Z986U","model":"Blade Max 3"},{"regex":"Z971","model":"Blade Spark"},{"regex":"Z978","model":"Blade V8 Pro"},{"regex":"Z839","model":"Blade Vantage"},{"regex":"Z3153V","model":"Blade Vantage 2"},{"regex":"Z930L","model":"Unico LTE"},{"regex":"Z965","model":"Blade X"},{"regex":"Z981","model":"Blade Z Max Pro"},{"regex":"Z982","model":"Blade Z Max"},{"regex":"Z983","model":"Blade X Max"},{"regex":"Z717[BV]L(?:[);/ ]|$)","model":"Citrine LTE"},{"regex":"Z233VL(?:[);/ ]|$)","model":"Cymbal-C LTE"},{"regex":"Z233V","model":"Cymbal LTE"},{"regex":"Z232TL","model":"Cymbal-G LTE"},{"regex":"Z353VL","model":"Cymbal-T LTE"},{"regex":"Z718TL","model":"Jasper LTE"},{"regex":"KIS II Max","model":"Kis II Max"},{"regex":"Kis 3","model":"Kis 3"},{"regex":"(?:Z798BL|Z799VL)(?:[);/ ]|$)","model":"Majesty Pro LTE"},{"regex":"Z899VL","model":"Majesty Pro Plus LTE"},{"regex":"Z828TL","model":"Midnight Pro LTE"},{"regex":"(?:ZTE-)?Z792","model":"Fanfare"},{"regex":"(?:ZTE-)?Z812","model":"Maven"},{"regex":"Z815","model":"Fanfare 2"},{"regex":"Z831","model":"Maven 2"},{"regex":"Z832","model":"Sonata 3"},{"regex":"Z835","model":"Maven 3"},{"regex":"Z851(?:[);/ ]|$)","model":"Prelude Plus"},{"regex":"Z851M","model":"Overture 3"},{"regex":"Z852","model":"Fanfare 3"},{"regex":"Z828","model":"Avid Plus"},{"regex":"Z855","model":"Avid 4"},{"regex":"Z833","model":"Avid TRIO"},{"regex":"(?:Z836BL|Z837VL|Z836F)(?:[);/ ]|$)","model":"ZFive 2 LTE"},{"regex":"Z558VL","model":"ZFive C LTE"},{"regex":"Z557BL","model":"ZFive G LTE"},{"regex":"(?:Z861BL|Z862VL)(?:[);/ ]|$)","model":"ZFive L LTE"},{"regex":"Z916BL","model":"ZMax Grand LTE"},{"regex":"Z917VL","model":"ZMax Champ LTE"},{"regex":"(?:Z958|Z955A)(?:[);/ ]|$)","model":"ZMax 2"},{"regex":"dandelion(?:[);/ ]|$)","model":"ZMax 3"},{"regex":"Z963VL","model":"Max Duo LTE"},{"regex":"Z970","model":"ZMax Z970"},{"regex":"Z986DL","model":"MAX Blue LTE"},{"regex":"(?:ZTE[-_])?Z992","model":"Avail 2"},{"regex":"(?:Z999|Z-01K)(?:[);/ ]|$)","model":"Axon M"},{"regex":"B2016","model":"Axon Mini"},{"regex":"A2015","model":"Axon Tianji"},{"regex":"A2017[GU]?","model":"Axon 7"},{"regex":"A2018","model":"Axon 7s"},{"regex":"A2019G Pro","model":"Axon Pro"},{"regex":"B2017G","model":"Axon 7 Mini"},{"regex":"A2020G? Pro(?:[);/ ]|$)","model":"Axon 10 Pro"},{"regex":"Z667T","model":"Zinger"},{"regex":"V?975|geek","model":"Geek"},{"regex":"Z716BL","model":"Citrine LTE"},{"regex":"X500","model":"Score"},{"regex":"X501","model":"Groove"},{"regex":"(?:ZTE-)?G-X991","model":"Rio"},{"regex":"F-450","model":"Adamant"},{"regex":"Z936L(?:[);/ ]|$)","model":"Lever"},{"regex":"MO-01[JK](?:[);/ ]|$)","model":"Mono"},{"regex":"V865M(?:[);/ ]|$)","model":"V865M"},{"regex":"Z6621O(?:[);/ ]|$)","model":"Optus X Vista"},{"regex":"V769M(?:[);/ ]|$)","model":"Leo Q2"},{"regex":"K83CA(?:[);/ ]|$)","device":"tablet","model":"Grand X View 3"},{"regex":"K87CA(?:[);/ ]|$)","device":"tablet","model":"Grand X View 4"},{"regex":"AxonPhone ([^;/]+) Build","model":"AxonPhone $1"},{"regex":"([a-z0-9]+)_USA_Cricket","model":"$1"},{"regex":"ZTE[- ](V98|V96A|V81|V70)(?:[);/ ]|$)","model":"$1","device":"tablet"},{"regex":"ZTE[- ]([a-z0-9\\\\-_ ]+) Build","model":"$1"},{"regex":"ZTE-(?:G |G-)?([a-z0-9 _]+)","model":"$1"},{"regex":"U?ZTE[ _]([a-z0-9]+)","model":"$1"}]},"Zuum":{"regex":"Zuum[ _-]|(?:Akus Z|COVET|MAGNO|ONIX S|STEDI|STELLAR(?:[ _](?:Z|PRO|[MP]1))?|GRAVITY Z|AURA X|COVET_PRO_LITE|RONI)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Akus Z","model":"Akus Z"},{"regex":"COVET_PRO_LITE","model":"Covet Pro Lite"},{"regex":"COVET PRO","model":"Covet Pro"},{"regex":"COVET( Z)?","model":"Covet$1"},{"regex":"MAGNO PLUS","model":"Magno Plus"},{"regex":"MAGNO( C)?","model":"Magno$1"},{"regex":"ONIX S","model":"Onix S"},{"regex":"STEDI","model":"Stedi"},{"regex":"STELLAR PRO","model":"Stellar Pro"},{"regex":"STELLAR PLUS","model":"Stellar Plus"},{"regex":"STELLAR ([MP]1|Z)","model":"Stellar $1"},{"regex":"STELLAR MINI","model":"Stellar Mini"},{"regex":"STELLAR MINI","model":"Stellar Mini"},{"regex":"STELLAR","model":"Stellar"},{"regex":"GRAVITY Z","model":"Gravity Z"},{"regex":"AURA X","model":"Aura X"},{"regex":"RONI","model":"Roni"},{"regex":"Zuum[ _-]([^;/]+) Build","model":"$1"},{"regex":"Zuum[ _-]?([^;/)]+)(?:[);/ ]|$)","model":"$1"}]},"Zen":{"regex":"(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\\\))|AdmireGlam","device":"smartphone","models":[{"regex":"AdmireGlam(?:[);/ ]|$)","model":"Admire Glam"},{"regex":"(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\\\))","model":"$1"}]},"Zync":{"regex":"ZYNC|(Cloud Z5|Z1000|Z18|Z99|Z99[_ ][23]G|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(Z18| DuZ99al Core|Z99[_ ][23]G|Z99 Dual Core|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)","model":"$1"},{"regex":"(Z1000[^/;]+)Build","model":"$1"},{"regex":"Cloud (Z5)","model":"Cloud $1"},{"regex":"ZYNC Cloud[ _]([^;]+)Build","model":"Cloud $1"},{"regex":"ZYNC[ _]([^;]+)Build","model":"$1"}]},"Lemhoov":{"regex":"Lemhoov","device":"smartphone","models":[{"regex":"Lemhoov[ _-]([^/;]+) Build","model":"$1"}]},"MTC":{"regex":"MTC[ _](968|97[82]|970|982[OT]?|1078)|(?:MTC[_ ])?SMART[ _]?(?:Race[2]?|Sprint|Run|Surf[2]?)[ _]4G|MTC975|Smart_(?:LINE|Light)|MTC[ _]SMART[ _](?:Run|Start_2)|Redbox Mini 5\\\\(MTS\\\\)","device":"smartphone","models":[{"regex":"MTC[ _]?(97[258]|970[H]?|982[OT]?|968)","model":"$1"},{"regex":"MTC[ _](1078)","model":"$1","device":"tablet"},{"regex":"SMART[ _]Race[ _]4G","model":"Smart Race 4G"},{"regex":"SMART[ _]Race2[ _]4G","model":"Smart Race 2 4G"},{"regex":"(?:MTC_)?SMART[ _]Sprint[ _]4G","model":"Smart Sprint 4G"},{"regex":"(?:MTC_)?SMART[ _]Start_2","model":"Smart Start 2"},{"regex":"Smart_LINE","model":"Smart Line"},{"regex":"Smart_Light","model":"Smart Light"},{"regex":"SMART[ _]?Run(?:[ _]4G)?","model":"Smart Run 4G"},{"regex":"SMART[ _]Surf2[ _]4G","model":"Smart Surf 2 4G"},{"regex":"SMART[ _]Surf[ _]4G","model":"Smart Surf 4G"},{"regex":"Redbox Mini 5\\\\(MTS\\\\)","device":"tv","model":"Redbox Mini 5"}]},"MegaFon":{"regex":"MegaFon|MFLoginPh|MegLogPh|(MFLogin[34]T?|MS3B|SP-A5|SP-A20i)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"MFLoginPh|MegLogPh","model":"Login+"},{"regex":"MFLogin4","model":"Login 4 LTE"},{"regex":"MFLogin3T|MegaFon Login 3","model":"Login 3","device":"tablet"},{"regex":"MS3B|Megafon Optima","model":"Optima"},{"regex":"SP-A20i","model":"Mint"},{"regex":"(SP-A5)","model":"$1"}]},"Inoi":{"regex":"INOI","device":"smartphone","models":[{"regex":"INOI 2 Lite 2019","model":"2 Lite (2019)"},{"regex":"INOI ([257]) (2019|202[01])(?:[);/ ]|$)","model":"$1 ($2)"},{"regex":"INOI[_ ]([^);/]+)(?: Build|[;)])","model":"$1"}]},"Vertex":{"regex":"(?:Luck|Lion_Dual|V709X|Tab [43]G (?:7-2|8-1|10-1)|Pro_P3[01]0_4G|Lion_DC|Baccara|Eagle[ _]4G|ImpressMAX)(?:[);/ ]|$)|Impress[ _]([^;/]+)(?:Build|\\\\))","device":"smartphone","models":[{"regex":"(Lion_Dual|Lion_DC|Baccara|Eagle[ _]4G|Luck)(?:[);/ ]|$)","model":"$1"},{"regex":"ImpressMAX(?:[);/ ]|$)","model":"Impress Max"},{"regex":"Pro_P(3[01]0)_4G(?:[);/ ]|$)","model":"Pro P$1 4G"},{"regex":"(Impress[ _]([^;/]+))(?:Build|\\\\))","model":"$1"},{"regex":"(V709X)","device":"tablet","model":"$1"},{"regex":"Tab ([43])G ([78]|10)-([21])","device":"tablet","model":"Tab $1G $2.$3\\""}]},"Unknown":{"regex":"WebTV/(\\\\d+\\\\.\\\\d+)","device":"tv","model":"Web TV"},"Starway":{"regex":"Andromeda[ _]S(707|84[05]|850|8)(?:[);/ ]|$)","device":"tablet","model":"Andromeda S$1"},"Savio":{"regex":" (TB-PO1|TB-B01|TB-G01)(?:[);/ ]|$)","device":"tv","model":"$1"},"Simbans":{"regex":"TangoTab|Presto[ )]|Ultimax|Valumax|S72-B|SX2W","device":"tablet","models":[{"regex":"TangoTab","model":"TangoTab"},{"regex":"Ultimax","model":"Ultimax"},{"regex":"Valumax","model":"Valumax"},{"regex":"Presto","model":"Presto"},{"regex":"S72-B","model":"S72-B"},{"regex":"SX2W","model":"SX2W"}]},"MYFON":{"regex":"MYPAD7s","device":"tablet","model":"My Pad 7s"},"X-TIGI":{"regex":"X[-_]TIGI|Hope7[_ ]Mate|Photo_P15_Lite","device":"smartphone","models":[{"regex":"X-TIGI_JOY10_PRO","model":"Joy 10 Pro","device":"tablet"},{"regex":"Hope7[_ ]Mate","model":"Hope 7 Mate","device":"tablet"},{"regex":"X-TIGI_JOY7_MAX","model":"Joy 7 Max","device":"tablet"},{"regex":"X-TIGI[_ ]V28[_ ]LTE","model":"V28 LTE"},{"regex":"X[-_]TIGI[_ ]V19","model":"V19"},{"regex":"X-TIGI[_ ]Photo[_ ]P11","model":"Photo P11"},{"regex":"Photo_P15_Lite","model":"Photo P15 Lite"},{"regex":"X[-_]TIGI[ _-]([^/;)]+) Build","model":"$1"}]},"Xiaolajiao":{"regex":"(LA2-(?:L|S[N]?)|HLA Note3|20190416Q|20170608S|20180322D)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"HLA Note3(?:[);/ ]|$)","model":"Red Pepper Note 3"},{"regex":"(LA2-(?:L|S[N]?))(?:[);/ ]|$)","model":"$1"},{"regex":"(20190416Q)(?:[);/ ]|$)","model":"$1"},{"regex":"20170608S(?:[);/ ]|$)","model":"Red Pepper Plus"},{"regex":"20180322D(?:[);/ ]|$)","model":"E Sports"}]},"Ritmix":{"regex":"(RMD[-_](?:10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)|RMP-(?:450|50[56]|530|600))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"RMD[-_](10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)(?:[);/ ]|$)","model":"RMD-$1"},{"regex":"RMP[-_](450|50[56]|530|600)(?:[);/ ]|$)","model":"RMP-$1","device":"smartphone"}]},"Ross&Moor":{"regex":"RMD[-_](974R|600)(?:[);/ ]|$)","device":"tablet","model":"RMD-$1"},"R-TV":{"regex":"R-TV BOX[ _]?(MINI\\\\+|X99|X10 PRO|[RXS]10)","device":"tv","model":"Box $1"},"NEXBOX":{"regex":"(MXQ|MXQ-Pro)-NEXBOX|NEXBOX-([^) ]+)","device":"tv","models":[{"regex":"MXQ-Pro-NEXBOX","model":"MXQ Pro"},{"regex":"MXQ-NEXBOX","model":"MXQ"},{"regex":"NEXBOX-([^) ]+)","model":"$1"}]},"True":{"regex":" TRUE BEYOND TAB 3G|SMART[ _](MAX 4.0 PLUS|4G[ _](?:GEN C [45].[05]|Champion|Speedy 5.0 Plus|Speedy[_ ]5inch|P1))","device":"smartphone","models":[{"regex":"SMART MAX 4.0 PLUS","model":"Smart Max 4.0 Plus"},{"regex":"SMART 4G Gen C ([45].[05])","model":"Smart 4G Gen C $1\\""},{"regex":"SMART 4G Speedy 5.0 Plus","model":"Smart 4G Speedy 5.0 Plus"},{"regex":"SMART[ _]4G[_ ]Speedy[_ ]5inch","model":"Smart 4G Speedy 5"},{"regex":"SMART[ _]4G[_ ]Champion","model":"Smart 4G Champion"},{"regex":"SMART[ _]4G[_ ]P1 Prime","model":"Smart 4G P1 Prime"},{"regex":"SMART[ _]4G[_ ]P1","model":"Smart 4G P1"},{"regex":"TRUE BEYOND TAB 3G","model":"Beyond Tab 3G"}]},"Yandex":{"regex":"(YNDX-?000SB)(?:[);/ ]|$)","device":"smartphone","model":"YNDX-000SB"},"FORME":{"regex":"FORME[ _-]","device":"smartphone","models":[{"regex":"FORME[ _-]F520(?:[);/ ]|$)","model":"Forever"},{"regex":"FORME[ _-](A[35]7|R7S?|P6)(?:[);/ ]|$)","model":"$1"}]},"Shuttle":{"regex":"(PNT-704[025])(?:[);/ ]|$)","device":"tablet","model":"$1"},"BDF":{"regex":"(BDF[- ](?:819|P10|K107H|KT107|MT6753|X20)|K960N_MT(?:6580|6753)(?:_32_N)?)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"BDF[- ](819|P10|K107H|KT107|MT6753|X20)(?:[);/ ]|$)","model":"$1"},{"regex":"K960N_MT(6580|6753)(_32_N)?(?:[);/ ]|$)","model":"BK960N MT$1"}]},"Highscreen":{"regex":"HIGHSCREEN|(Easy[- ]Power(?:[- ]Pro)?|Pure[_ ](?:Power|F)|Power Ice(?: Max)?|Easy[_ ]([SFL]|XL)(?:_Pro)?|Razar_Pro|Power Rage(?: Evo)?|Zera-S-Power|Zera[ _][UFS]|Power[ _]?Five[ matrixstyle _]?(?:Pro|Evo|Max|Max(?:Lite|2))|PowerFour|BOOST II(?:se)?|Fest(?:XL)?(?:-Pro)?|Tasty|Boost3|Boost 3(?: Pro)? SE|Expanse|Hercules|Alpha Rage|VergeM)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(Power Ice(?:[ ](?:Max|Evo))?|Power Rage(?: Evo)?|Zera[ _][UFS])(?:[);/ ]|$)","model":"$1"},{"regex":"PowerFivePro(?:[);/ ]|$)","model":"Power Five Pro"},{"regex":"PowerFiveMaxLite(?:[);/ ]|$)","model":"Power Five Max Lite"},{"regex":"PowerFiveMax2(?:[);/ ]|$)","model":"Power Five Max 2"},{"regex":"Power Five Evo(?:[);/ ]|$)","model":"Power Five Evo"},{"regex":"Power Five Max(?:[);/ ]|$)","model":"Power Five Max"},{"regex":"FestXL-Pro(?:[);/ ]|$)","model":"Fest XL Pro"},{"regex":"FestXL(?:[);/ ]|$)","model":"Fest XL"},{"regex":"Fest-Pro(?:[);/ ]|$)","model":"Fest Pro"},{"regex":"Fest(?:[);/ ]|$)","model":"Fest"},{"regex":"PowerFour(?:[);/ ]|$)","model":"Power Four"},{"regex":"Pure[_ ]Power(?:[);/ ]|$)","model":"Pure Power"},{"regex":"Pure[ _]F(?:[);/ ]|$)","model":"Pure F"},{"regex":"Razar_Pro(?:[);/ ]|$)","model":"Razar Pro"},{"regex":"Easy[_ ]([SLF]|XL)[_ ]Pro(?:[);/ ]|$)","model":"Easy $1 Pro"},{"regex":"Easy[_ ]([SFL]|XL)(?:[);/ ]|$)","model":"Easy $1"},{"regex":"(?:HIGHSCREEN )?Easy[- ]Power[- ]Pro(?:[);/ ]|$)","model":"Easy Power Pro"},{"regex":"(?:HIGHSCREEN )?Easy-Power(?:[);/ ]|$)","model":"Easy Power"},{"regex":"BOOST II(?:[);/ ]|$)","model":"Boost 2"},{"regex":"BOOST IIse(?:[);/ ]|$)","model":"Boost 2 SE"},{"regex":"Boost 3 SE(?:[);/ ]|$)","model":"Boost 3 SE"},{"regex":"Boost 3 Pro SE(?:[);/ ]|$)","model":"Boost 3 Pro SE"},{"regex":"BOOST3(?:[);/ ]|$)","model":"Boost 3"},{"regex":"Zera-S-Power(?:[);/ ]|$)","model":"Zera S Power"},{"regex":"Tasty(?:[);/ ]|$)","model":"Tasty"},{"regex":"VergeM(?:[);/ ]|$)","model":"Verge M"},{"regex":"WinWin(?:[);/ ]|$)","model":"WinWin"},{"regex":"Expanse(?:[);/ ]|$)","model":"Expanse"},{"regex":"Hercules(?:[);/ ]|$)","model":"Hercules"},{"regex":"Alpha Rage(?:[);/ ]|$)","model":"Alpha Rage"}]},"CVTE":{"regex":"CVTE[_ ](MSD338_(:?1G|512M))(?:[);/ ]|$)","device":"tv","model":"$1"},"Globex":{"regex":"(GU1011C|GU8012C|GU7013C|GU730C|GU-6012B)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"GU8012C(?:[);/ ]|$)","model":"X8"},{"regex":"GU-6012B(?:[);/ ]|$)","model":"GU6012B"},{"regex":"(GU1011C|GU7013C|GU730C)(?:[);/ ]|$)","model":"$1"}]},"Atom":{"regex":"ATOM-(108AM|216RK|216AM)(?:[);/ ]|$)","device":"tv","model":"$1"},"Qumo":{"regex":"QUMO[ _]?|(?:Quest[ _]?(?:408|410|45[56]|50[679])|Vega[ _]?78[23]|Sirius[ _]?(?:1001|890))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(?:QUMO[ _]?)?Vega[ _]?(78[23]|8002)(?:[);/ ]|$)","model":"Vega $1"},{"regex":"Yooda(?:[);/ ]|$)","model":"Yooda"},{"regex":"Sirius[ _]?(1001|890)(?:[);/ ]|$)","model":"Sirius $1"},{"regex":"(?:QUMO)?(Sirius 101-4G 8GB Black|Altair 701 8GB Black|Altair 71 4GB Black|Altair 700[24]|Altair 706)(?:[);/ ]|$)","model":"$1"},{"regex":"(?:QUMO[ _])?Quest[ _]?(35[34]|40[268]|410|45[2568]|47[46]|50[679]|5[17]0|600)(?:[);/ ]|$)","device":"smartphone","model":"Quest $1"}]},"Umax":{"regex":"VisionBook[ _]|[78]Qa_3G(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(VisionBook[ _](?:10Qi|7Q[i]?|8Q[ei]?|P70|8Qi_3G)(?:[ _](?:[34]G|Plus|LTE))?)(?:[);/ ]|$)","model":"$1"},{"regex":"([78])Qa_3G(?:[);/ ]|$)","model":"VisionBook $1Qa 3G"},{"regex":"VisionBook_10Q_LTE(?:[);/ ]|$)","model":"VisionBook 10Q LTE"},{"regex":"VisionBook_P50Plus_LTE(?:[);/ ]|$)","device":"smartphone","model":"VisionBook P50 Plus LTE"},{"regex":"(VisionBook[ _](?:P50 LTE|P55 X2 LTE|P55 LTE(?: Pro)?))(?:[);/ ]|$)","device":"smartphone","model":"$1"}]},"Mann":{"regex":"(ZUG 3|ZUG 5S(?: Q)?)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Unihertz":{"regex":"(Titan|Jelly-Pro|Atom_X?L)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(Jelly)-(Pro)(?:[);/ ]|$)","model":"$1 $2"},{"regex":"(Titan|Atom_X?L)(?:[);/ ]|$)","model":"$1"}]},"Chuwi":{"regex":"(?:CW-(Hi8-super|Hi12|V99i?|V17HD3G|VX8-3G|V88-QUAD|V9-DUAL|V88S|Vi[78]|[HV]i10 (?:pro|plus))|Hi10 (?:Pro|plus)|HiPad X|HiBox-hero|HiBook(?: pro)?|Hi[89] ?(?:Air|Pro)|Hi8SE|Vi10(?: ?Pro)?)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(CW-Hi8-super)(?:[);/ ]|$)","model":"Hi8"},{"regex":"(?:CW-)?(Vi10|Hi10) plus(?:[);/ ]|$)","model":"$1 Plus"},{"regex":"CW-(V88)-QUAD(?:[);/ ]|$)","model":"$1 Quad"},{"regex":"CW-(V9)-DUAL(?:[);/ ]|$)","model":"$1 Dual"},{"regex":"CW-(V17HD|VX8)-?(3G)(?:[);/ ]|$)","model":"$1 $2"},{"regex":"(?:CW-)?(Hi10) pro(?:[);/ ]|$)","model":"$1 Pro"},{"regex":"HiBook pro(?:[);/ ]|$)","model":"HiBook Pro"},{"regex":"HiBook(?:[);/ ]|$)","model":"HiBook"},{"regex":"HiPad X(?:[);/ ]|$)","model":"HiPad X"},{"regex":"Hi([89]) ?Air(?:[);/ ]|$)","model":"Hi$1 Air"},{"regex":"Hi8SE(?:[);/ ]|$)","model":"Hi8 SE"},{"regex":"Hi([89]) ?pro(?:[);/ ]|$)","model":"Hi$1 Pro"},{"regex":"Vi10 Plus(?:[);/ ]|$)","model":"Vi10 Plus"},{"regex":"Vi10 ?Pro(?:[);/ ]|$)","model":"Vi10 Pro"},{"regex":"Vi10(?:[);/ ]|$)","model":"Vi10"},{"regex":"HiBox-hero(?:[);/ ]|$)","model":"HiBox Hero","device":"desktop"},{"regex":"CW-(Vi[78]|Hi12|V99i?|V88S)(?:[);/ ]|$)","model":"$1"}]},"Bezkam":{"regex":"BEZKAM (BK-RAM2)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"NG Optics":{"regex":"(NG3128HD)(?:[);/ ]|$)","device":"tv","model":"$1"},"KATV1":{"regex":"(KATV-01) PRO(?:[);/ ]|$)","device":"tv","model":"$1 Pro"},"Ghong":{"regex":"GHONG(V10)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Xoro":{"regex":"(?:TelePAD(?:795|731|1032|10A3|7A3)|Era 2X|HMT(?:390Q?|400)|HST 260)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"TelePAD(7|10)A3 4G(?:[);/ ]|$)","model":"TelePad $1 A3 4G"},{"regex":"TelePAD(795|731|1032)(?:[);/ ]|$)","model":"TelePad $1"},{"regex":"HMT(390Q?|400)(?:[);/ ]|$)","model":"HMT $1","device":"portable media player"},{"regex":"HST 260(?:[);/ ]|$)","model":"HST 260","device":"tv"},{"regex":"(Era 2X)(?:[);/ ]|$)","model":"$1","device":"smartphone"}]},"Vinga":{"regex":"VMP-(015-162|021-82|041-162|011-81|025-324|045-664)(?:[);/ ]|$)","device":"tv","models":[{"regex":"VMP-021-82","model":"021"},{"regex":"VMP-025-324","model":"025"},{"regex":"VMP-015-162","model":"015"},{"regex":"VMP-041-162","model":"041"},{"regex":"VMP-045-664","model":"045"},{"regex":"VMP-011-81","model":"011"}]},"Viumee":{"regex":"SMART[_ ](EV[56])(?:[);/ ]|$)","device":"smartphone","model":"Smart $1"},"Nuvo":{"regex":"Nuvo[_ ](NS35|Blue ND40|Green[_ ]ND[_ ]45)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Nuvo[_ ](NS35)(?:[);/ ]|$)","model":"$1"},{"regex":"Blue (ND40)(?:[);/ ]|$)","model":"$1"},{"regex":"Green[_ ]ND[_ ]45(?:[);/ ]|$)","model":"ND45"}]},"Sunvell":{"regex":"(?:T95ZPLUS|T95[KU]PRO)(?:[);/ ]|$)","device":"tv","models":[{"regex":"T95ZPLUS","model":"T95Z Plus"},{"regex":"(T95[KU])PRO","model":"$1 Pro"}]},"Ugoos":{"regex":"UGOOS-AM6(?:[);/ ]|$)","device":"tv","model":"AM6"},"Yxtel":{"regex":"YXTEL_([HU]1|U3)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Proline":{"regex":"(H10882M-TN)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Yota":{"regex":"(YD20[16]|YOTA 3[+])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"YD20[16](?:[);/ ]|$)","model":"Phone 2"},{"regex":"YOTA 3[+](?:[);/ ]|$)","model":"Phone 3 Plus"}]},"Mystery":{"regex":"MYSTERY|(MID-(?:123G|72[12]|7[01348]3G|753G|8[23]3G))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"MID-(123G|72[12]|7[01348]3G|753G|8[23]3G)(?:[);/ ]|$)","model":"MID-$1"},{"regex":"MYSTERY_TV_(D3155CH31)","device":"tv","model":"$1"}]},"Ritzviva":{"regex":"(RITZVIVA[_ ]S500C)(?:[);/ ]|$)","device":"smartphone","model":"S500C"},"DeWalt":{"regex":"DeWalt (MD501)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Runbo":{"regex":"Runbo|F1-TT(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Runbo[ _-]?(X5-W|F1 Plus|F1-TT|F1-EN|F1|TT|Q5-S|X5-King|X6|Q5)(?:[);/ ]|$)","model":"$1"},{"regex":"F1-TT","model":"F1-TT"}]},"NewsMy":{"regex":"(CarPad-(?:II|III)-P)(?:[);/ ]|$)","device":"car browser","model":"$1"},"Newsday":{"regex":"Newsday[_ ](E1|A[12])(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Daewoo":{"regex":"Daewoo|(DTA-07IDRF)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(DTA-07IDRF)(?:[);/ ]|$)","model":"Archive 7P"},{"regex":"Daewoo (Android TV 638)(?:[);/ ]|$)","model":"$1","device":"tv"}]},"Vesta":{"regex":"VESTA32LD86(?:[);/ ]|$)","device":"tv","model":"SmartT V2.0 32LD86S"},"Spectrum":{"regex":"(CARBONO_5|CUARZO_6|DIAMANTE_5|VULCANO_55)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"VULCANO_55(?:[);/ ]|$)","model":"Vulcano 5.5\\""},{"regex":"CARBONO_5(?:[);/ ]|$)","model":"Carbono 5.0\\""},{"regex":"CUARZO_6(?:[);/ ]|$)","model":"Cuarzo 6.0\\""},{"regex":"DIAMANTE_5(?:[);/ ]|$)","model":"Diamante 5.0\\""}]},"Kivi":{"regex":"(?:24H600G[RU]|24FR50WU|24HK30B|32HR55GU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|55U600G[RU]|65UP50GU|55U[PC]50G[RU]|50U600G[RU]|50UX10S|55UR50G[RU]|40FK30G|40FR50BR|43UK35G|50FK30G|50UK35G|32HR50GR|55UC30G|32HK30G|40FK30G|32HR50GU|43UK30G|32FR50(?:WR|BU)|32FK3[02]G)(?:_-Ver0[0-9])?(?:[);/ ]|$)","device":"tv","models":[{"regex":"(24H600G[RU]|24FR50WU|24HK30B|32HR55GU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|55U600G[RU]|65UP50GU|55U[PC]50G[RU]|50UX10S|50U600G[RU]|55UR50G[RU]|40FK30G|40FR50BR|43UK35G|50FK30G|50UK35G|32HR50GR|32FR50(?:WR|BU)|32FK3[02]G)(?:[);/ ]|$)","model":"$1"},{"regex":"(55UC30G|40FK30G|43UK30G|32HR50G[RU]|32HK30G|32FK32G)_-Ver0([0-9])(?:[);/ ]|$)","model":"$1 v$2"}]},"Divisat":{"regex":"(Divisat)(?:[);/ ]|$)","device":"tv","models":[{"regex":"(J-Link)(?:[);/ ]|$)","model":"$1"}]},"Kanji":{"regex":"KJ-(OB03|YUBI)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"KJ-OB03(?:[);/ ]|$)","model":"Cata 7"},{"regex":"KJ-YUBI(?:[);/ ]|$)","model":"Yubi 3G"}]},"Kaiomy":{"regex":"KaiCloud[ ]?(7[48]4|942)(?:[);/ ]|$)","device":"tablet","model":"KaiCloud $1"},"National":{"regex":"(NX-32THS100)(?:[);/ ]|$)","device":"tv","model":"$1"},"Vsun":{"regex":"(?:VSUN (?:ILLUSION|RACE|V9)|MARS TOUCH|MARS NOTE|MARS NOCAM|SATURN SELFIE)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ILLUSION(?:[);/ ]|$)","model":"Illusion"},{"regex":"MARS TOUCH(?:[);/ ]|$)","model":"Mars Touch"},{"regex":"MARS NOTE(?:[);/ ]|$)","model":"Mars Note"},{"regex":"MARS NOCAM(?:[);/ ]|$)","model":"Mars Nocam"},{"regex":"SATURN SELFIE(?:[);/ ]|$)","model":"Saturn Selfie"},{"regex":"RACE(?:[);/ ]|$)","model":"Race"},{"regex":"(V9)(?:[);/ ]|$)","model":"$1"}]},"Shift Phones":{"regex":"(SHIFT6m)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"RugGear":{"regex":"(RugGear|RG(?:310|500|65[05]|702|7[13]0|850))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(RG[0-9]+)(?:[);/ ]|$)","model":"$1"}]},"Aligator":{"regex":"ALIGATOR[_ ]","device":"smartphone","models":[{"regex":"ALIGATOR[ _](S4080|S50(?:6[56]|[678]0)|S5540|RX510|S6500|RX710|RX800|S5520)(?:[);/ ]|$)","model":"$1"}]},"Maxcom":{"regex":"(MS(?:45[036]|505|514)|MS457(?:PLUS)?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(MS457)PLUS(?:[);/ ]|$)","model":"$1 Plus"},{"regex":"MS(45[0367]|505|514)(?:[);/ ]|$)","model":"MS$1"}]},"Luna":{"regex":"(?:LUNA[ _](?:V55|G[56]0)|TG-L800S)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"LUNA[ _](V55|G[56]0)(?:[);/ ]|$)","model":"$1"},{"regex":"(TG-L800S)(?:[);/ ]|$)","model":"$1"}]},"Protruly":{"regex":"PROTRULY[ _](D[78]|V10S)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"JFone":{"regex":"JFone[ _](JS501)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Uhans":{"regex":"(A101S)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Soyes":{"regex":"SOYES[ _]([67]S|XS)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Zidoo":{"regex":"ZIDOO[ _](H6 Pro|X6 Pro|X9S|Z10|X[158]|X20 Pro|Z9S)(?:[);/ ]|$)","device":"tv","model":"$1"},"Zfiner":{"regex":"ZFINERY900(?:[);/ ]|$)","device":"tablet","model":"Y900"},"iGet":{"regex":"SMART[_ ](G10[12]|S7[02]|G71|G81[H]?)(?:[);/ ]|$)","device":"tablet","model":"Smart $1"},"iVA":{"regex":"(LAMCY (?:L3[05]0|C100|L400)|IVA S6)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"LAMCY (L3[05]0|C100|L400)(?:[);/ ]|$)","model":"Lamcy $1"},{"regex":"IVA S6(?:[);/ ]|$)","model":"S6"}]},"Phicomm":{"regex":"(PHICOMM)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"C630 \\\\(CLUE L\\\\)(?:[);/ ]|$)","model":"Clue L"},{"regex":"E653\\\\(ENERGY L\\\\)(?:[);/ ]|$)","model":"Energy L"},{"regex":"PHICOMM ENERGY 3\\\\+(?:[);/ ]|$)","model":"Energy 3+"},{"regex":"CLUE (2S|M)(?:[);/ ]|$)","model":"Clue $1"}]},"Huadoo":{"regex":"Huadoo[ _](HG0[46]|HG11|V[34])(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Gome":{"regex":"(?:GOME[_ ](?:201[678].+|C7_Note(?:_Plus)?|U9|S[17])|Fenmmy_Note)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"GOME[_ ](?:2018X38A)(?:[);/ ]|$)","model":"C72"},{"regex":"GOME[_ ](?:2018X07A)(?:[);/ ]|$)","model":"C7"},{"regex":"GOME[_ ](?:2017X05A)(?:[);/ ]|$)","model":"C71"},{"regex":"GOME[_ ](?:2016G68A)(?:[);/ ]|$)","model":"K1"},{"regex":"GOME[_ ](?:2016M25A)(?:[);/ ]|$)","model":"U1"},{"regex":"GOME[_ ](?:2017M27A)(?:[);/ ]|$)","model":"U7"},{"regex":"GOME[_ ](C7_Note(?:_Plus)?|U9|S[17])(?:[);/ ]|$)","model":"$1"},{"regex":"(?:GOME[_ ])?(Fenmmy_Note)(?:[);/ ]|$)","device":"phablet","model":"$1"}]},"Voyo":{"regex":"(?:VOYO[_ ](?:A15)|i8-Max|Q101-4G)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"i8-Max(?:[);/ ]|$)","model":"i8 Max"},{"regex":"(Q101)-4G(?:[);/ ]|$)","model":"$1 4G"},{"regex":"VOYO[_ ](A15)(?:[);/ ]|$)","model":"$1"}]},"Ryte":{"regex":"RYTE (U55 LTE)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Vontar":{"regex":"(HK1 (?:Max|MINI|PLUS|PRO)|VONTAR[ -](?:Z[58]|V1|KIII|MX-4K|X3))(?:[);/ ]|$)","device":"tv","models":[{"regex":"VONTAR[ -](Z[58]|V1|KIII|MX-4K|X3)(?:[);/ ]|$)","model":"$1"},{"regex":"HK1 Max(?:[);/ ]|$)","model":"HK1 Max"},{"regex":"HK1 MINI(?:[);/ ]|$)","model":"HK1 Mini"},{"regex":"HK1 PLUS(?:[);/ ]|$)","model":"HK1 Plus"},{"regex":"HK1 PRO(?:[);/ ]|$)","model":"HK1 Pro"}]},"Vorke":{"regex":"VORKE (Z[157]|Z6(?: Plus)?)(?:[);/ ]|$)","device":"tv","model":"$1"},"Wigor":{"regex":"Wigor (V4)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"NEXON":{"regex":"NEXON (X[1589])(?:[);/ ]|$)","device":"tv","model":"$1"},"ONN":{"regex":"(ONA19TB00[327]|10000520[6-9]|O8HD)(?:[);/ ]|$)","device":"tablet","model":"$1"},"EXO":{"regex":"(Wave_i101G|Wave i101[Hb])(?:[);/ ]|$)","device":"tablet","model":"$1"},"Q.Bell":{"regex":"(QPHONE[_ ](?:10.1|9.[12]|7.1|5.[46])|QTAB10EW)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(QPHONE[_ ](?:10.1|9.[12]|7.1|5.[46]))(?:[);/ ]|$)","model":"$1"},{"regex":"QTAB10EW","device":"tablet","model":"QTAB10EW"}]},"Datawind":{"regex":"DW-[A-Z0-9]{5}(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(DW-PS3G5)(?:[);/ ]|$)","model":"Pocket Surfer 3G5"},{"regex":"DW-UBT7W","device":"tablet","model":"Ubislate 7W"}]},"Droxio":{"regex":"DROXIO (C40|B45)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Goophone":{"regex":"Goophone[ _]|(?:M(G492|L7[JK]2)CH|MN(4A2|8J2)ZP|MGA92ZP|MKU82ZP|MNGW2CH|MNH02CH|MNRM2CH)[/]A(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:MG492CH|MGA92ZP)[/]A(?:[);/ ]|$)","model":"I6 Plus"},{"regex":"ML7[JK]2CH[/]A(?:[);/ ]|$)","model":"I6"},{"regex":"MKU82ZP[/]A(?:[);/ ]|$)","model":"I6S"},{"regex":"MNGW2CH[/]A(?:[);/ ]|$)","model":"I6S Plus"},{"regex":"(?:MN4A2ZP|MNH02CH)[/]A(?:[);/ ]|$)","model":"I7"},{"regex":"(?:MN8J2ZP|MNRM2CH)[/]A(?:[);/ ]|$)","model":"I7 Plus"},{"regex":"S4 MEGA(?:[);/ ]|$)","model":"S4 Mega"},{"regex":"Goophone i([69])(?:[);/ ]|$)","model":"I$1"}]},"PocketBook":{"regex":"PocketBook[ _/]","device":"tablet","models":[{"regex":"PocketBook SURFpad 3 \\\\(([\\\\d]+).([\\\\d]+)[\\"]?\\\\)(?:[);/ ]|$)","model":"Surfpad 3 $1.$2\\""},{"regex":"PocketBook/(62[67]|63[12]|740|840)(?:[);/ ]|$)","model":"$1"}]},"Bitmore":{"regex":"(?:Mobitab10c-3G|Tab1011Q_II)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(Mobitab)(10)c-3G(?:[);/ ]|$)","model":"$1 $2C 3G"},{"regex":"Tab1011Q_II(?:[);/ ]|$)","model":"Tab1011Q II"}]},"Kuliao":{"regex":"KULIAO (K10)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Sugar":{"regex":"SUGAR[ _]","device":"smartphone","models":[{"regex":"SUGAR Y([78]) MAX(?:[);/ ]|$)","model":"Y$1 Max"},{"regex":"SUGAR F7 Mini(?:[);/ ]|$)","model":"F7 Mini"},{"regex":"SUGAR (C[12]1|C1[23]|S11|C11s|[SF]20s?|[YF]11|[YFS]9|C[679]|[FY]7|Y12s|Y1[256]|P1)(?:[);/ ]|$)","model":"$1"}]},"Subor":{"regex":"SUBOR[ _]","device":"smartphone","models":[{"regex":"SUBOR[ _](S5|2019)(?:[);/ ]|$)","model":"$1"},{"regex":"SUBOR[_ ]K10PLUS(?:[);/ ]|$)","model":"K10 Plus"}]},"Xshitou":{"regex":"Xshitou[_ ](P7)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"JKL":{"regex":"JKL[_ ](A28)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Gree":{"regex":"(G0215D|G0245D|G0335D)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Vodacom":{"regex":"(?:Vodacom)[ _](Power Tab 10)(?:[);/ ]|$)","device":"tablet","model":"$1"},"VKworld":{"regex":"(?:(?:VK700)-MAX|VK700 Pro|T5SE|VK700X|vk6050|vk6735|vk700)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(VK700)-MAX(?:[);/ ]|$)","model":"$1 Max"},{"regex":"(VK700) Pro(?:[);/ ]|$)","model":"$1 Pro"},{"regex":"T5SE(?:[);/ ]|$)","model":"T5 SE"},{"regex":"VK(700X|6050|6735|700)(?:[);/ ]|$)","model":"VK$1"}]},"Mito":{"regex":"MITO[- _](A(?:1[0678]|19_[12]GB|21|3[59]|55|180|2[36]0|313|322|33|3[136]0|[35]50|6[89]|7[235]|82|[356]0|810|950)|T(?:8|10|35|3[03]0|510|888)|311)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"MITO[- _](A(?:1[0678]|19_[12]GB|21|3[59]|55|180|2[36]0|33|322|313|3[136]0|[35]50|6[89]|7[235]|82|[356]0|810|950)|311)(?:[);/ ]|$)","model":"$1"},{"regex":"MITO[ _](T(?:8|10|35|3[03]0|510|888))(?:[);/ ]|$)","device":"tablet","model":"$1"}]},"TWM":{"regex":"Amazing[ _](X[35]s|X[123567]|A5S|A3[025]|A[468]|A4S|A5[057]|P6)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Amazing[ _](X[35])s(?:[);/ ]|$)","model":"Amazing $1S"},{"regex":"Amazing[ _](A5S|X[123567]|A[468]|A4S|A5[057]|A3[025])(?:[);/ ]|$)","model":"Amazing $1"},{"regex":"Amazing[ _](P6)(?:[);/ ]|$)","device":"tablet","model":"Amazing $1"}]},"TWZ":{"regex":"TWZ[-_ ](?:TabPlay|Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])|TWZQQ1","device":"smartphone","models":[{"regex":"TWZ[_ ]TabPlay[_ ](12[56])","device":"tablet","model":"TabPlay $1"},{"regex":"TWZ[-_ ]?(Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])","model":"$1"}]},"Onix":{"regex":"(?:ONIX S405|AT101-1116)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(AT101-1116)(?:[);/ ]|$)","model":"$1"},{"regex":"(S405)(?:[);/ ]|$)","device":"smartphone","model":"$1"}]},"Oale":{"regex":"Apex([13])(?:[);/ ]|$)","device":"smartphone","model":"Apex $1"},"Mobo":{"regex":"(?:(?:MOBO[_ ]MB7005|MT7-421HD)|(?:MT7-442D|MT7-411D))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(?:MOBO[_ ])?(MB7005|MT7-421HD|MT7-442D|MT7-411D)(?:[);/ ]|$)","model":"$1"}]},"Macoox":{"regex":"(MC-X7MINI)(?:[);/ ]|$)","device":"smartphone","model":"MC-X7 Mini"},"Prixton":{"regex":"PRIXTON |(T7012Q)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"PRIXTON (C18)","device":"smartphone","model":"$1"},{"regex":"(T7012Q)(?:[);/ ]|$)","model":"$1"}]},"Magnus":{"regex":"Magnus[ _](?:bravoZ[23]0|Infinity_?(?:G8|G11))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"bravo(Z[23]0)","model":"Bravo $1"},{"regex":"(?:Magnus[ _])?Infinity_?(G8|G11)","model":"Infinity $1"}]},"Newland":{"regex":"(?:NLS-MT90)(?:[);/ ]|$)","device":"smartphone","model":"MT90 Orca"},"Orbic":{"regex":"(?:RC555L|RC501L)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"RC555L(?:[);/ ]|$)","model":"Wonder"},{"regex":"RC501L(?:[);/ ]|$)","model":"Slim"}]},"RED":{"regex":"(?:H1A1000)(?:[);/ ]|$)","device":"smartphone","model":"Hydrogen One"},"Contixo":{"regex":"Contixo|(?:CX-1045 3G|KT995 3G|CX1045)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"CX-?1045(?: 3G)?(?:[);/ ]|$)","model":"CX-1045 3G"},{"regex":"CONTIXO GX 1035(?:[);/ ]|$)","model":"GX-1035 4G 10.1\\""},{"regex":"Contixo GT1160 4G(?:[);/ ]|$)","model":"GT1160 4G 10.1\\""},{"regex":"B105(?:[);/ ]|$)","model":"B105 3G 10.1\\""},{"regex":"B108(?:[);/ ]|$)","model":"B108 4G 10.1\\""},{"regex":"KT107(?: 3G)?(?:[);/ ]|$)","model":"KT107 3G 10.1\\""},{"regex":"K109(?:[);/ ]|$)","model":"KT109 4G 10.1\\""},{"regex":"KT715 3G(?:[);/ ]|$)","model":"KT715 3G 7.0\\""},{"regex":"KT995(?:[);/ ]|$)","model":"KT995 3G 10.1\\""},{"regex":"KT1100GT(?:[);/ ]|$)","model":"KT1100GT"}]},"E-Ceros":{"regex":"(?:CT9716(?:-B)?)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"CT9716(?:[);/ ]|$)","model":"Revolution"},{"regex":"CT9716-B(?:[);/ ]|$)","model":"Revolution HD"}]},"How":{"regex":"(?:HT-705XS|705-G Go|1001-G Go)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(HT-705XS)(?:[);/ ]|$)","model":"$1"},{"regex":"(1001-G Go)(?:[);/ ]|$)","model":"HT-1001G Go Kids"},{"regex":"(705-G Go)(?:[);/ ]|$)","model":"HT-$1"}]},"Multilaser":{"regex":"(?:Multilaser[ _](?:[FEGH])(?:[_ ](?:Pro|Max|Lite))?|MS50[LGX]|M7[_-]3G[_-]PLUS|MS5\\\\.V2|MS45S_A6|ML([02]1|12)-M7s[- ]?Quad-?Core| ML01-M7-SD|MS45S|MS50S|MS60[XZ]|M7SQC_Plus|MS80X|MS40[GS]|MS55M|MS70|M7-3G QUAD CORE|M7sLite|MS50L_4G|MS60F(?:_PLUS)?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Multilaser[ _]G[_ ]Pro(?:[);/ ]|$)","model":"G Pro"},{"regex":"Multilaser[ _]F[_ ]Pro(?:[);/ ]|$)","model":"F Pro"},{"regex":"Multilaser[ _]G[_ ]Max(?:[);/ ]|$)","model":"G Max"},{"regex":"Multilaser[ _]G(?:[);/ ]|$)","model":"G"},{"regex":"Multilaser[ _]E[_ ]Lite(?:[);/ ]|$)","model":"E Lite"},{"regex":"Multilaser[ _]([FEH])(?:[);/ ]|$)","model":"$1"},{"regex":"MS60F_PLUS(?:[);/ ]|$)","model":"MS60F Plus"},{"regex":"(MS50[LGX]|MS45S_A6|MS40[GS]|MS55M|MS60F|MS70|MS60[XZ]|MS45S|MS80X|MS50L_4G|MS50S|MS5\\\\.V2)(?:[);/ ]|$)","model":"$1"},{"regex":"M7[_-]3G[_-]PLUS(?:[);/ ]|$)","device":"tablet","model":"M7 3G Plus"},{"regex":"M7SQC_PLUS(?:[);/ ]|$)","device":"tablet","model":"M7SQC Plus"},{"regex":"M7-3G QUAD CORE(?:[);/ ]|$)","device":"tablet","model":"M7 3G Quad Core"},{"regex":"ML([02]1|12)-M7s[- ]?Quad-?Core(?:[);/ ]|$)","device":"tablet","model":"ML$1-M7s Quad Core"},{"regex":"M7sLite(?:[);/ ]|$)","device":"tablet","model":"M7s Lite"},{"regex":"ML01-M7-SD(?:[);/ ]|$)","device":"tablet","model":"ML01-M7 SD"}]},"Positivo BGH":{"regex":"(?:T1060B|S455|Positivo (?:Twist|Ypy|Mini I)|Twist[ _](?:\\\\(2018\\\\)|2 (?:Fit|Pro)|Mini|Tab|Metal(?: 32GB)?|Max|XL|SE|[23SM]))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"S455(?:[);/ ]|$)","model":"Selfie"},{"regex":"Twist \\\\(2018\\\\)(?:[);/ ]|$)","model":"Twist (2018)"},{"regex":"Twist Metal 32GB(?:[);/ ]|$)","model":"Twist Metal 32GB"},{"regex":"Twist Metal(?:[);/ ]|$)","model":"Twist Metal"},{"regex":"Twist Max(?:[);/ ]|$)","model":"Twist Max"},{"regex":"Twist[ _]Mini(?:[);/ ]|$)","model":"Twist Mini"},{"regex":"Twist 2 Fit(?:[);/ ]|$)","model":"Twist 2 Fit"},{"regex":"Twist 2 Pro(?:[);/ ]|$)","model":"Twist 2 Pro"},{"regex":"Twist XL(?:[);/ ]|$)","model":"Twist XL"},{"regex":"Twist SE(?:[);/ ]|$)","model":"Twist SE"},{"regex":"(?:Positivo )?Twist ([23SM])(?:[);/ ]|$)","model":"Twist $1"},{"regex":"(?:Positivo )Mini I(?:[);/ ]|$)","model":"Mini I"},{"regex":"T1060B(?:[);/ ]|$)","device":"tablet","model":"T1060B"},{"regex":"Positivo Ypy (AB7F|AB10H|L1050E)(?:[);/ ]|$)","device":"tablet","model":"Ypy $1"},{"regex":"Twist Tab(?:[);/ ]|$)","device":"tablet","model":"Twist Tab"}]},"Maxtron":{"regex":"Maxtron[ _-](V[327]|S[89]|T1)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Maxtron[ _-](V[327]|S[89])(?:[);/ ]|$)","model":"$1"},{"regex":"Maxtron[ _-](T1)(?:[);/ ]|$)","device":"tablet","model":"$1"}]},"Philco":{"regex":"PHILCO |(PCS01|PH350B|PTB7R|PTB7PAP_PTB7PAB_PTB7PAR)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(PCS01|PH350B)(?:[);/ ]|$)","model":"$1"},{"regex":"(PTB7R)(?:[);/ ]|$)","device":"tablet","model":"$1"},{"regex":"PHILCO Android TV(?:[);/ ]|$)","device":"tv","model":""},{"regex":"PTB7PAP_PTB7PAB_PTB7PAR(?:[);/ ]|$)","device":"tablet","model":"PTB7PA"}]},"SEMP TCL":{"regex":"(?:GO[35]E|5101J|GO3C(?: Plus)?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"5101J(?:[);/ ]|$)","model":"L9 Plus"},{"regex":"GO3C Plus(?:[);/ ]|$)","model":"GO! 3C Plus"},{"regex":"GO3C(?:[);/ ]|$)","model":"GO! 3C"},{"regex":"(GO[35]E)(?:[);/ ]|$)","model":"$1"}]},"Newman":{"regex":"Newman[ _](P308|K1)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Swipe":{"regex":"(Elite Sense|Elite_VR)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Owwo":{"regex":"(?:OWWO[ _]?(?:[1457]S|Q[78])|CARNIVAL B5)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"OWWO[ _]?([1457]S|Q[78])(?:[);/ ]|$)","model":"$1"},{"regex":"CARNIVAL B5(?:[);/ ]|$)","model":"Carnival B5"}]},"TD Systems":{"regex":"(K32DLX9HS|K40DLM8FS|K40DLX9FS)(?:[);/ ]|$)","device":"tv","model":"$1"},"Ravoz":{"regex":"RAVOZ[ _](Z5 (?:Lite|Pro)|Z[3-7]|R[478])(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Tone":{"regex":"TONE (e19|m15|e20)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"AT&T":{"regex":"(?:U304AA|QS5509A|U705AA)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"U304AA(?:[);/ ]|$)","model":"Radiant Core"},{"regex":"U705AA(?:[);/ ]|$)","model":"Radiant Max"},{"regex":"QS5509A(?:[);/ ]|$)","model":"Axia"}]},"BIHEE":{"regex":"(ZBH-)?BIHEE","device":"smartphone","models":[{"regex":"(A1[12]|A[78]\\\\+|A[56])(?:[);/ ]|$)","model":"$1"}]},"Enot":{"regex":"Enot[ _-](E102|J101)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Kooper":{"regex":"Kooper-mobile-W502(?:[);/ ]|$)","device":"smartphone","model":"Mobile W502"},"Lesia":{"regex":"ANOVA A5(?:[);/ ]|$)","device":"smartphone","model":"Anova A5"},"Anry":{"regex":"ANRY-(RS10|[SX]20)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Tinai":{"regex":"Tinai (K[12])(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Winds":{"regex":"NOTE GRACE V(?:[);/ ]|$)","device":"smartphone","model":"Note Grace V"},"Asano":{"regex":"32LF7130S(?:[);/ ]|$)","device":"tv","model":"32LF7130S 32.0\\""},"Phonemax":{"regex":"PHONEMAX[_ ](Saturn(?:[_ ]X)?|Mars|Venus X)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"PHONEMAX[_ ]Saturn[_ ]X(?:[);/ ]|$)","model":"Saturn X"},{"regex":"PHONEMAX[_ ]Saturn(?:[);/ ]|$)","model":"Saturn"},{"regex":"PHONEMAX[_ ]Mars(?:[);/ ]|$)","model":"Mars"},{"regex":"PHONEMAX[_ ]Venus X(?:[);/ ]|$)","model":"Venus X"}]},"Vipro":{"regex":"VIPRO(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"VIPRO PRO2X(?:[);/ ]|$)","model":"Pro 2X"},{"regex":"VIPRO PRO[ _-]?([0-9])(?:[);/ ]|$)","model":"Pro $1"}]},"OzoneHD":{"regex":"Ozone HD|OzoneHD[ _](T2 WiFi|4K(?: TV)?|Fun)(?:[);/ ]|$)","device":"tv","model":"$1"},"Kzen":{"regex":"(?:Ureki_U1|Victor V1|DART KZ07)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Ureki_U1","model":"Ureki U1"},{"regex":"Victor V1","model":"Victor V1"},{"regex":"DART KZ07","device":"tablet","model":"Dart KZ07"}]},"Melrose":{"regex":"MELROSE_(?:S9|2019)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"MELROSE_S9(?:[);/ ]|$)","model":"S9"},{"regex":"MELROSE_2019(?:[);/ ]|$)","model":"2019 Ultra Slim 3.4\\""}]},"Crony":{"regex":"CRONY-7021(?:[);/ ]|$)","device":"tablet","model":"7021"},"Takara":{"regex":"(MID211H)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Tronsmart":{"regex":"(Orion R68G|Draco AW80|Draco H3|Vega S95_(?:Meta|Pro|Telos))(?:[);/ ]|$)","device":"tv","model":"$1"},"Amigoo":{"regex":"AMIGOO (R300|R9 Max|M1 Max|X15)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Lumigon":{"regex":"Lumigon[ _](T3)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Neomi":{"regex":"NEO[ ]?(90[689])(?:[);/ ]|$)","device":"smartphone","model":"Neo $1"},"Eltex":{"regex":"(?:NV5(?:01|10)WAC|NV501|NV510WB)(?:[);/ ]|$)","device":"tv","models":[{"regex":"NV5(01|10)WAC(?:[);/ ]|$)","model":"NV-5$1-Wac"},{"regex":"NV501(?:[);/ ]|$)","model":"NV-501"},{"regex":"NV510WB(?:[);/ ]|$)","model":"NV-510-WB"}]},"Senkatel":{"regex":"Senkatel[ _](T1009|T8002|T701[12]|T9702)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Bobarry":{"regex":"(?:K10[ ]?SE)(?:[);/ ]|$)","device":"tablet","model":"K10 SE"},"Wortmann":{"regex":"TERRA[ _]PAD[ _](100[45])(?:[);/ ]|$)","device":"tablet","model":"Terra Pad $1"},"BB Mobile":{"regex":"Techno[-_ ](8\\\\.0|9\\\\.7|TQ863Q|X595BT|S700BF|I700AJ|10.1 LTE TQ060X|7.0 LTE TQ763I|I785AP|I101BI)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"Techno[_ ]S700BF(?:[);/ ]|$)","model":"Techno 7.0\\" Pioneer LTE S700BF"},{"regex":"Techno[_ ]10.1 LTE TQ060X(?:[);/ ]|$)","model":"Techno 10.0\\" LTE TQ060X"},{"regex":"Techno[_ ]TQ863Q(?:[);/ ]|$)","model":"Techno 8.0\\" Poplar LTE TQ863Q"},{"regex":"Techno[_ ]I700AJ(?:[);/ ]|$)","model":"Techno 7.0\\" Mozg LTE I700AJ"},{"regex":"Techno[-_ ]I785AP(?:[);/ ]|$)","model":"Techno 7.85\\" Mozg I785AP"},{"regex":"Techno[-_ ]I101BI(?:[);/ ]|$)","model":"Techno 10.1\\" Mozg I101BI"},{"regex":"Techno[_ ]7.0 LTE TQ763I(?:[);/ ]|$)","model":"Techno 7.0\\" Kalash LTE TQ763I"},{"regex":"Techno[_ ](9\\\\.7|8\\\\.0) 3G(?:[);/ ]|$)","model":"Techno $1\\" 3G"},{"regex":"Techno[_ ](?:X595BT)(?:[);/ ]|$)","device":"smartphone","model":"Techno Spark 3G X595BT"}]},"2E":{"regex":"(?:E500A_2019|2E E450 2018)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"E500A_2019(?:[);/ ]|$)","model":"E500A (2019)"},{"regex":"2E E450 2018(?:[);/ ]|$)","model":"E450 (2018)"}]},"Billion":{"regex":"Capture\\\\+(?:[);/ ]|$)","device":"smartphone","model":"Capture Plus"},"Tele2":{"regex":"Tele2[ _]","device":"smartphone","models":[{"regex":"Tele2[ _](Mi[dn]i)[ _]1.1(?:[);/ ]|$)","model":"$1 1.1"},{"regex":"Tele2[ _]Midi[ _]2.0(?:[);/ ]|$)","model":"Midi 2.0"},{"regex":"Tele2[ _]((?:Maxi|Midi)(?:[_ ](?:Plus|LTE))?)(?:[);/ ]|$)","model":"$1"},{"regex":"Tele2[ _](Mi[dn]i)(?:[);/ ]|$)","model":"$1"}]},"Alfawise":{"regex":"(?:Alfawise (?:A9)|(?:A95X_R1))(?:[);/ ]|$)","device":"tv","models":[{"regex":"(A95X_R1)(?:[);/ ]|$)","model":"$1"},{"regex":"Alfawise (A9)","model":"$1"}]},"Klipad":{"regex":"KLIPAD_|(?:KL-V905|KL4889|KL9878|7589AN)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:KLIPAD_)?(V355B?|KL600|KL-V905)(?:[);/ ]|$)","model":"$1"},{"regex":"(KL4889|7589AN|KL9878)(?:[);/ ]|$)","device":"tablet","model":"$1"}]},"SQOOL":{"regex":"SQOOL-V(41?)(?:[);/ ]|$)","device":"tablet","model":"V$1"},"TurboKids":{"regex":"Turbokids[-_ ]?(TMNT|3G|S4)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Jinga":{"regex":"Jinga[-_ ]|(?:(?:Fresh|Optim)4G|Pass(?:Plus|3G)|PicassoNote|Hotz[_ ]M1|WinPRO|Touch4G|Start3G|IGO[ _]L[41]|Basco (?:L3|L[45]00|XS1|S2))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Optim4G(?:[);/ ]|$)","model":"Optim 4G"},{"regex":"Fresh4G(?:[);/ ]|$)","model":"Fresh 4G"},{"regex":"Hotz[_ ]M1(?:[);/ ]|$)","model":"Hotz M1"},{"regex":"PassPlus(?:[);/ ]|$)","model":"Pass Plus"},{"regex":"Pass3G(?:[);/ ]|$)","model":"Pass 3G"},{"regex":"WinPRO(?:[);/ ]|$)","model":"Win Pro"},{"regex":"Touch4G(?:[);/ ]|$)","model":"Touch 4G"},{"regex":"Start3G(?:[);/ ]|$)","model":"Start 4G"},{"regex":"PicassoNote(?:[);/ ]|$)","model":"Picasso Note"},{"regex":"Jinga Iron(?:[);/ ]|$)","model":"Iron"},{"regex":"Jinga Basco neo(?:[);/ ]|$)","model":"Basco Neo"},{"regex":"(?:Jinga )?Basco (L3|L[45]00|XS1|S2)(?:[);/ ]|$)","model":"Basco $1"},{"regex":"Jinga Trezor S1 Plus(?:[);/ ]|$)","model":"Trezor S1 Plus"},{"regex":"JINGA_IGO_L2(?:[);/ ]|$)","model":"IGO L2"},{"regex":"(?:JINGA[_ ])?IGO[_ ]([ML]1|L4)(?:[);/ ]|$)","model":"IGO $1"},{"regex":"Jinga Trezor S1 Plus(?:[);/ ]|$)","model":"Trezor S1 Plus"}]},"Twoe":{"regex":"(?:TWOE[-_ ]E450R|F534L|F572L|E500A)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"TWOE[-_ ](E450R)(?:[);/ ]|$)","model":"$1"},{"regex":"(F534L|F572L|E500A)(?:[);/ ]|$)","model":"$1"}]},"iTruck":{"regex":"iTRUCK 7 3G(?:[);/ ]|$)","device":"smartphone","model":"7.0\\" 3G"},"Torex":{"regex":"TOREX[- ](?:PS12|S18|S27)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"TOREX-(PS12)","model":"$1"},{"regex":"TOREX[- ](S18|S27)","device":"smartphone","model":"$1"}]},"Doffler":{"regex":"(24DHS54)(?:[);/ ]|$)","device":"tv","model":"$1"},"Oyyu":{"regex":"OYYUT11(?:[);/ ]|$)","device":"tablet","model":"T11 3G"},"Primux":{"regex":"Primux","device":"smartphone","models":[{"regex":"Primux_ioxphone(?:[);/ ]|$)","model":"IOX Phone"},{"regex":"PrimuxDelta6(?:[);/ ]|$)","model":"Delta 6"},{"regex":"PrimuxKappa(P50[01])(?:[);/ ]|$)","model":"Kappa $1"},{"regex":"PrimuxKappa(?:[);/ ]|$)","model":"Kappa"},{"regex":"Primux_Beta2(?:[);/ ]|$)","model":"Beta 2"},{"regex":"Primux_?Omega([57])(?:[);/ ]|$)","model":"Omega $1"},{"regex":"PrimuxUP(?:[);/ ]|$)","device":"tablet","model":"UP"},{"regex":" PrimuxZonda4(?:[);/ ]|$)","device":"tablet","model":"Zonda 4"},{"regex":"Primux_Siroco6(?:[);/ ]|$)","device":"tablet","model":"Siroco 6"}]},"iMars":{"regex":"(?:IMARS VEGA X7|VIVI_8)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"IMARS VEGA X7","model":"Vega X7"},{"regex":"VIVI_8","model":"VIVI 8"}]},"Logic":{"regex":"LOGIC[_ ](X[135]|X4M|L5D|X5[AFT]|X60G|L61|X60_PLUS)(:?[_ ]LITE2?)?(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"LOGIC[_ ]X60_PLUS(?:[);/ ]|$)","model":"X60 Plus"},{"regex":"LOGIC[_ ](X5|X4M)[_ ]LITE(?:[);/ ]|$)","model":"$1 Lite"},{"regex":"LOGIC[_ ](X5)[_ ]LITE2(?:[);/ ]|$)","model":"$1 Lite 2"},{"regex":"LOGIC[_ ](X[13]|X4M|L5D|X5[AFT]|X60G|L61)(?:[);/ ]|$)","model":"$1"}]},"Cloudpad":{"regex":"\\\\+VT(?:107C|Q007C)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"\\\\+VT(107C)","model":"+VT$1"},{"regex":"\\\\+VTQ(007C)","model":"+VTQ$1"}]},"Cloudfone":{"regex":"(?:Thrill (?:Boost[ ]?(2|3)?|Snap|Access)|Excite Prime 2 Pro|NBA Edition)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Thrill Boost (2|3)(?:[);/ ]|$)","model":"Thrill Boost $1"},{"regex":"Thrill Boost(?:[);/ ]|$)","model":"Thrill Boost"},{"regex":"Thrill Snap(?:[);/ ]|$)","model":"Thrill Snap"},{"regex":"Thrill Access(?:[);/ ]|$)","model":"Thrill Access"},{"regex":"Excite Prime 2 Pro(?:[);/ ]|$)","model":"Excite Prime 2 Pro"},{"regex":"NBA Edition(?:[);/ ]|$)","model":"NBA Edition"}]},"Vsmart":{"regex":"(?:Joy 1\\\\+|Active 1\\\\+|Bee 3|Active 3)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Joy 1\\\\+(?:[);/ ]|$)","model":"Joy 1 Plus"},{"regex":"Active 1\\\\+(?:[);/ ]|$)","model":"Active 1 Plus"},{"regex":"Bee 3(?:[);/ ]|$)","model":"Bee 3"},{"regex":"Active 3(?:[);/ ]|$)","model":"Active 3"}]},"MiXzo":{"regex":"(?:MiXzo[ _])?(?:ME1023|ME1030|MX1037|MX1024|MX10[24]1|MX1397)([ _][34]G)?(?:[);/ ]|$)","device":"tablet","models":[{"regex":"MiXzo[_ ]ME(1023|1030)(?:[_ ]3G)(?:[);/ ]|$)","model":"ME$1 3G"},{"regex":"MiXzo[_ ]MX1021(?:[_ ]3G)?(?:[);/ ]|$)","model":"MX1021 3G"},{"regex":"(?:MiXzo[ _])?MX(1037|1041|1024|1397)[ _]4G(?:[);/ ]|$)","model":"MX$1 4G"}]},"Openbox":{"regex":"Openbox (A[34](?: (?:Pro|Lite))?)(?:[);/ ]|$)","device":"tv","model":"$1"},"Ziox":{"regex":"ZIOX[_ ]|(?:Astra Viva 4G|Astra NXT Pro|Duopix F9)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ZIOX[_ ]F9[_ ]PRO(?:[);/ ]|$)","model":"F9 Pro"},{"regex":"Astra Viva 4G(?:[);/ ]|$)","model":"Astra Viva 4G"},{"regex":"Astra NXT Pro(?:[);/ ]|$)","model":"Astra NXT Pro"},{"regex":"Duopix F9(?:[);/ ]|$)","model":"Duopix F9"}]},"iDroid":{"regex":"APACHE G6(?:[);/ ]|$)","device":"smartphone","model":"Apache G6"},"Aoson":{"regex":"aoson(?:R10[1-3]|S[78]|M707TG)(?:[_ ]?Pro)?(?:[);/ ]|$)","device":"tablet","models":[{"regex":"aosonR10([1-3])(?:[);/ ]|$)","model":"R10$1 10.1\\""},{"regex":"aosonS7_Pro(?:[);/ ]|$)","model":"S7 Pro 7.0\\""},{"regex":"aosonS7(?:[);/ ]|$)","model":"S7 7.0\\""},{"regex":"aosonS8Pro(?:[);/ ]|$)","model":"S8 Pro 8.0\\""},{"regex":"aoson(M707TG)(?:[);/ ]|$)","model":"$1"}]},"FireFly Mobile":{"regex":"(?:AURII[ _](?:Passion|Virtuoso|ULTRA|Secret Lite|AMUSE[_ ]3G|FORCE|FUSION|F8[_ ]Premium|XCITE|DELIGHT|DREAM[_ ](?:MINI|One))|SECRET_XR|INTENSE[ _](?:POWER|METAL_2|XT)|SUPER SWEET|SWEET MINI)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"AURII[ _]FORCE(?:[);/ ]|$)","model":"Aurii Force"},{"regex":"AURII[ _]DELIGHT(?:[);/ ]|$)","model":"Aurii Delight"},{"regex":"AURII[ _]DREAM[_ ]MINI(?:[);/ ]|$)","model":"Aurii Dream Mini"},{"regex":"AURII[ _]DREAM[_ ]One(?:[);/ ]|$)","model":"Aurii Dream One"},{"regex":"AURII[ _]ULTRA(?:[);/ ]|$)","model":"Aurii Ultra"},{"regex":"AURII[ _]AMUSE[_ ]3G(?:[);/ ]|$)","model":"Aurii Amuse 3G"},{"regex":"AURII[ _]FUSION(?:[);/ ]|$)","model":"Aurii Fusion"},{"regex":"AURII[ _]XCITE(?:[);/ ]|$)","model":"Aurii xCite"},{"regex":"SECRET_XR(?:[);/ ]|$)","model":"Aurii Secret XR"},{"regex":"AURII[ _]((?:Passion|Virtuoso|Secret Lite|F8[_ ]Premium))(?:[);/ ]|$)","model":"Aurii $1"},{"regex":"INTENSE POWER(?:[);/ ]|$)","model":"Intense Power"},{"regex":"INTENSE_XT(?:[);/ ]|$)","model":"Intense XT"},{"regex":"INTENSE_METAL_2(?:[);/ ]|$)","model":"Intense Metal 2"},{"regex":"SUPER SWEET(?:[);/ ]|$)","model":"Super Sweet"},{"regex":"SWEET MINI(?:[);/ ]|$)","model":"Sweet Mini"}]},"i-Cherry":{"regex":"iCherry_?","device":"smartphone","models":[{"regex":"iCherry[ _](C(?:25[1258]|21[16]|110|121|22[0379]|23[03])|X1)(?:[);/ ]|$)","model":"$1"},{"regex":"iCherry-C256","device":"tablet","model":"C256 Nano 3G"}]},"NextTab":{"regex":"TAB (A40[13]0)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Time2":{"regex":"(TC1050G)(?:[);/ ]|$)","device":"tablet","model":"$1 10.1\\""},"Sunstech":{"regex":"(TAB2323GMQC)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Hotwav":{"regex":"(?:Venus[_ ]X1[024569]|Cosmos[ _](?:V8_lite|V19_Plus|V2[0-3]|U2|V19|V[569])|Pearl K2|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13])|Hot[_ ]6)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Cosmos[ _]V8_lite(?:[);/ ]|$)","model":"Cosmos V8 Lite"},{"regex":"Hot[_ ]6?(?:[);/ ]|$)","model":"Hot 6"},{"regex":"(Venus[_ ]X1[024569]|Cosmos[ _](?:V19_Plus|V2[0-3]|U2|V19|V[569])|Pearl K2|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13]))(?:[);/ ]|$)","model":"$1"}]},"Tetratab":{"regex":"CASEBOOK_3(?:[);/ ]|$)","device":"tablet","model":"Casebook 3"},"Dolamee":{"regex":"Dolamee[_ -](D[56])(?:[);/ ]|$)","device":"tv","model":"$1"},"Invin":{"regex":"INVIN[ _-]|KM5PRO(?:[);/ ]|$)","device":"tv","models":[{"regex":"INVIN[ _-](X[24]|KM[678])","model":"$1"},{"regex":"KM5PRO","model":"KM5 Pro"}]},"Doopro":{"regex":"Doopro P3(?:[);/ ]|$)","device":"smartphone","model":"P3"},"IQM":{"regex":"IQM (?:picasso|vivaldi|newton)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"IQM picasso(?:[);/ ]|$)","model":"Picasso"},{"regex":"IQM vivaldi(?:[);/ ]|$)","model":"Vivaldi"},{"regex":"IQM newton(?:[);/ ]|$)","model":"Newton"}]},"Nos":{"regex":"Nos (?:FIVE|NOVU|NEVA|Roya)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"NOS FIVE(?:[);/ ]|$)","model":"Five"},{"regex":"NOS NOVU III(?:[);/ ]|$)","model":"Novu III"},{"regex":"NOS NOVU II(?:[);/ ]|$)","model":"Novu II"},{"regex":"NOS NOVU(?:[);/ ]|$)","model":"Novu"},{"regex":"NOS NEVA 80(?:[);/ ]|$)","model":"Neva 80"},{"regex":"NOS Roya(?:[);/ ]|$)","model":"Roya"}]},"Accent":{"regex":"(?:ACCENT[_ ]NEON|FAST73G|PEARL[_ ]A[24567]|TANK_P55|CAMELEON[_ ](?:C[456]|A1)(?:[_ ]PLUS)?|Speed[- ](?:[AXYM]2|X2\\\\+))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ACCENT[_ ]NEON(?:[);/ ]|$)","model":"Neon"},{"regex":"CAMELEON[_ ]C6[_ ]PLUS(?:[);/ ]|$)","model":"Cameleon C6 Plus"},{"regex":"Speed[- ]([AXYM]2)(?:[);/ ]|$)","model":"Speed $1"},{"regex":"Speed-X2\\\\+(?:[);/ ]|$)","model":"Speed X2 Plus"},{"regex":"CAMELEON[_ ](C[456]|A1)(?:[);/ ]|$)","model":"Cameleon $1"},{"regex":"PEARL A4 Lite(?:[);/ ]|$)","model":"Pearl A4 Lite"},{"regex":"PEARL[_ ]A([2567])(?:[);/ ]|$)","model":"Pearl A$1"},{"regex":"TANK_P55(?:[);/ ]|$)","model":"Tank P55"},{"regex":"FAST73G(?:[);/ ]|$)","device":"phablet","model":"FAST7 3G"}]},"Avenzo":{"regex":"Avenzo(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"MOB4 4G(?:[);/ ]|$)","model":"Mob 4 4G"},{"regex":"MOB4PRO 4G(?:[);/ ]|$)","model":"Mob 4 Pro 4G"}]},"Beelink":{"regex":"(?:Beelink (?:G[ST]1|LAKE I|SEA I|A1)|GTKing|GT1mini-2|GT1-mini(?:-AT)?)(?:[);/ ]|$)","device":"tv","models":[{"regex":"Beelink (G[ST]1|LAKE I|SEA I|A1)(?:[);/ ]|$)","model":"$1"},{"regex":"GT1-mini(?:-AT)?(?:[);/ ]|$)","model":"GT1 Mini"},{"regex":"GT1mini-2(?:[);/ ]|$)","model":"GT1 Mini 2"},{"regex":"GTKing(?:[);/ ]|$)","model":"GT King"}]},"MAXVI":{"regex":"MAXVI[ _](?:MS401)(?:[);/ ]|$)|(?:\\\\w+)?_MAXVI_\\\\w+|MS502[_ ]Orion|MS531","device":"smartphone","models":[{"regex":"MAXVI[ _](MS401)","model":"$1"},{"regex":"MS531","model":"MS531 Vega"},{"regex":"MS502[_ ]Orion","model":"MS502 Orion"},{"regex":"(?:\\\\w+)?MAXVI_(P11|K10|X[358]00)_\\\\w+","device":"feature phone","model":"$1"}]},"MDC Store":{"regex":"Prime_S(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Prime_S(?:[);/ ]|$)","model":"Prime S"}]},"meanIT":{"regex":"meanIT[ _](?:C[12]|X10|X[126]|MG430|Q[145])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"meanIT[ _]Q1 plus(?:[);/ ]|$)","model":"Q1 Plus"},{"regex":"meanIT[ _](C[12]|X[126]|MG430|Q[145])(?:[);/ ]|$)","model":"$1"},{"regex":"meanIT[ _]X10(?:[);/ ]|$)","device":"tablet","model":"X10"}]},"Kenxinda":{"regex":"Three[_ ]Proofings[_ ]W([5-9])(?:[);/ ]|$)","device":"smartphone","model":"Three Proofings W$1"},"X-BO":{"regex":"X[-]?BO (V[78]|V1[01]|V[89]\\\\+)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Xgody":{"regex":"XGODY","device":"smartphone","models":[{"regex":"XGODY Y17(?:[);/ ]|$)","model":"Y17"},{"regex":"XGODY_X96(?:[);/ ]|$)","model":"X96","device":"tv"}]},"Alcor":{"regex":"(Access_Q784C)(?:[);/ ]|$)","device":"tablet","model":"$1"},"iBrit":{"regex":"IBRIT_|(?:SI5[12])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"IBRIT_I([57])(?:[);/ ]|$)","model":"I$1"},{"regex":"iBRIT_POWER6(?:[);/ ]|$)","model":"Power 6"},{"regex":"iBRIT_Speed Pro(?:[);/ ]|$)","model":"Speed Pro"},{"regex":"SI51(?:[);/ ]|$)","model":"Speed"},{"regex":"SI52(?:[);/ ]|$)","model":"Speed Plus"}]},"Ovvi":{"regex":"Jumbo X1","device":"smartphone","model":"Jumbo X1"},"Fero":{"regex":"Fero[_ ]|Royale[_ ](?:[YX]2|A1)","device":"smartphone","models":[{"regex":"Fero_Y1","model":"Y1"},{"regex":"Royale Y2 Lite","model":"Royale Y2 Lite"},{"regex":"Royale[_ ]([YX]2|A1)","model":"Royale $1"},{"regex":"FERO PACE","model":"Pace"},{"regex":"Fero[ _](A4001|A450[23]|A5001|L100|Iris|Power|Mega LTE|Vibe)","model":"$1"}]},"Ruio":{"regex":"Ruio[ _]","device":"smartphone","models":[{"regex":"Ruio[ _](S4)(?:[);/ ]|$)","model":"$1"},{"regex":"Ruio[ _](S5)Plus(?:[);/ ]|$)","model":"$1 Plus"}]},"Transpeed":{"regex":"Transpeed_|(?:TR99 MINI\\\\+|TR99)(?:[);/ ]|$)","device":"tv","models":[{"regex":"TR99 MINI\\\\+","model":"TR99 Mini Plus"},{"regex":"(?:Transpeed_)?(TR99|H616|6K)(?:[);/ ]|$)","model":"$1"}]},"VVETIME":{"regex":"ZYVV1(?:[);/ ]|$)","device":"smartphone","model":"V1"},"A1":{"regex":"A1 (?:Alpha|Alpha 20\\\\+)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"A1 Alpha 20\\\\+","model":"Alpha 20 Plus"},{"regex":"A1 Alpha","model":"Alpha"}]},"Swisstone":{"regex":"swisstone (SD 5[13]0)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"P-UP":{"regex":"MD-04P(?:[);/ ]|$)","device":"phablet","model":"Mode 1 RR"},"iVooMi":{"regex":"(?:Innelo_1|iV 505)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Innelo_1","model":"Innelo 1"},{"regex":"iV 505","model":"Me 1"}]},"Pixelphone":{"regex":"Pixelphone S1(?:[);/ ]|$)","device":"smartphone","model":"S1"},"Pixela":{"regex":"Infineum[_ ](Z4?5)(?:[);/ ]|$)","device":"smartphone","model":"Infineum $1"},"Iris":{"regex":"(?:Vox[_ ](?:[45]S|Alpha|POP|STEEL Plus|Energy)|IS2_?Plus|IS2S|Next_P_PRO|IRS002-16)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Vox[_ ]([45])S","model":"Vox $1S"},{"regex":"VOX Alpha Plus","model":"Vox Alpha Plus"},{"regex":"VOX STEEL Plus","model":"Vox Steel Plus"},{"regex":"VOX Alpha","model":"Vox Alpha"},{"regex":"VOX Energy","model":"Vox Energy"},{"regex":"VOX POP plus","model":"Vox Pop Plus"},{"regex":"VOX POP Pro","model":"Vox Pop Pro"},{"regex":"Next_P_PRO","model":"Next P Pro"},{"regex":"IS2_?Plus","model":"IS2 Plus"},{"regex":"IRS002-16","model":"I-S6"},{"regex":"IS2S","model":"IS2S"}]},"Fonos":{"regex":"Fonos-(O1)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Xtouch":{"regex":"Xtouch[ _](X10|A5)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Conquest":{"regex":"Conquest[-_](?:S(?:[68]|1[0126])|F2)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Conquest[-_]S([68]|1[0126])","model":"S$1"},{"regex":"Conquest-F2","model":"F2"}]},"Zatec":{"regex":"ZATEC[_ ]|(?:[ ]WIND|ZPLAY1_2018|Zpower_(?:Plus|2018))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ZATEC[_ ]GRAVITY(?:[);/ ]|$)","model":"Gravity"},{"regex":"[ ]WIND(?:[);/ ]|$)","model":"Wind"},{"regex":"ZPLAY1_2018","model":"Zplay (2018)"},{"regex":"Zpower_2018","model":"Zpower (2018)"},{"regex":"Zpower_Plus","model":"Zpower Plus"}]},"Selenga":{"regex":"Selenga[ _](A[134])(?:[);/ ]|$)","device":"tv","model":"$1"},"Starlight":{"regex":"Starlight|(?:My_Star_X|RIO STAR|C_Note_Pro|Star_Mix_2)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"My_Star_X","model":"My Star X"},{"regex":"RIO STAR","model":"Rio Star"},{"regex":"C_Note_Pro","model":"C Note Pro"},{"regex":"Star_Mix_2","model":"Star Mix 2"},{"regex":"Starlight_ROME_X","model":"Rome X"}]},"GEOFOX":{"regex":"GEOFOX[_](MID743)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Tinmo":{"regex":"TiNMO[- _](A11|K3)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Matrix":{"regex":"(7116-A5)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Verico":{"regex":"(RP-UDM0[12]A|RP-UDP05A)(?:[);/ ]|$)","device":"tablet","model":"Uni Pad $1"},"TTEC":{"regex":"(Magictab (?:9GX|7GE|718))(?:[);/ ]|$)","device":"tablet","model":"$1"},"eSTAR":{"regex":"eSTAR[_ ](?:Grand|GO\\\\!?|Zoom Quad|Gemini|MINI[_ ]3G|BEAUTY|MOON)","device":"tablet","models":[{"regex":"eSTAR (Grand|GO\\\\!?) (HD Intel|IPS Intel|IPS|HD|Intel) Quad Core 3G","model":"$1 $2 Quad Core 3G"},{"regex":"eSTAR (Zoom Quad|Gemini|GO)","model":"$1"},{"regex":"eSTAR GRAND HD quad core( [34]G)?","model":"Grand HD Quad Core$1"},{"regex":"eSTAR GRAND","model":"Grand"},{"regex":"eSTAR BEAUTY HD Quad core","model":"Beauty HD Quad Core"},{"regex":"eSTAR MOON HD Quad core","model":"Moon HD Quad Core 3G"},{"regex":"eSTAR BEAUTY 2 HD Quad core","model":"Beauty 2 HD Quad Core"},{"regex":"eSTAR[_ ]MINI[_ ]3G","model":"Mini 3G"}]},"Hometech":{"regex":"(?:Ideal (?:10S|Tab [79])|ALFA10TB|ALFA[_ ](?:10RC|10TM?|7RS|[78]RC|7M)|HT[ _](?:7RT|8MZ))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(Ideal (?:10S|Tab 9))(?:[);/ ]|$)","model":"$1"},{"regex":"ALFA[_ ]?(10RC|10T[BM]?|7RS|[78]RC|7M)(?:[);/ ]|$)","model":"ALFA $1"},{"regex":"Ideal Tab 7 Ips( 3G)?","model":"Ideal Tab 7 IPS$1"},{"regex":"HT[ _](7RT|8MZ)(?:[);/ ]|$)","model":"HT $1"}]},"ExMobile":{"regex":"EX(29|45)i(?:[);/ ]|$)","device":"smartphone","model":"EX $1i"},"Hipstreet":{"regex":"10DTB12(?:[);/ ]|$)","device":"tablet","model":"Phoenix"},"Navitech":{"regex":"(NeoTab)[ _-]((?:S1[23]0|S125|H85|H11[05]|KID741|S9700))(?:[);/ ]|$)","device":"tablet","model":"$1 $2"},"NorthTech":{"regex":"(NT-TP10)(?:[);/ ]|$)","device":"tablet","model":"TouchPad 10.0\\""},"UNIWA":{"regex":"UNIWA[ _](X5)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Andowl":{"regex":"ANDOWL-(Q[45])(?:[);/ ]|$)","device":"tv","model":"$1"},"Silelis":{"regex":"Silelis[ _](T-1)(?:[);/ ]|$)","device":"tv","model":"$1"},"Bluedot":{"regex":"BLUEDOT[_ ]|(?:BNT-71)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"(?:BLUEDOT[_ ])?(BNP-500)(?:[);/ ]|$)","device":"smartphone","model":"$1"},{"regex":"(BNT-71)(?:[);/ ]|$)","model":"$1"}]},"Planet Computers":{"regex":"(Cosmo_Communicator)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Reach":{"regex":"(Allure[_ ](?:Ultra(?:[_]Curve)?|Secure|Admire|Rise))(?:[);/ ]|$)","device":"smartphone","model":"$1"},"MobiWire":{"regex":"(?:Kiona|KANUNA|Halona|Kicka[_ ][45][ _]Plus|Kohana|Kosumi|KWANITA|Lonan|Hotah|Kicka 5|Kiona)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"KANUNA","model":"Kanuna"},{"regex":"KWANITA","model":"Kwanita"},{"regex":"(Kiona|Kicka[_ ][45][ _]Plus|Kohana|Kosumi|Lonan|Halona|Hotah|Kicka 5|Kiona)(?:[);/ ]|$)","model":"$1"}]},"Hezire":{"regex":"(HTB801)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Hurricane":{"regex":"Hurricane[ _]|(?:Flame_Plus)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Hurricane[ _]IGNITE","model":"Ignite"},{"regex":"Hurricane[ _]Bolt","model":"Bolt"},{"regex":"Hurricane[ _]VORTEX","model":"Vortex"},{"regex":"Hurricane[ _]GIGA","model":"Giga"},{"regex":"Flame_Plus","model":"Flame Plus"}]},"iSWAG":{"regex":"ISWAG[ _]","device":"smartphone","models":[{"regex":"ISWAG[_ ]VIPER","model":"Viper"},{"regex":"iSWAG[_ ]Lynx","model":"Lynx"},{"regex":"iSWAG[_ ]MANTRA","model":"Mantra"},{"regex":"iSWAG[_ ]MEGA","model":"Mega"},{"regex":"iSWAG[_ ]NEMESIS","model":"Nemesis"}]},"Reeder":{"regex":"(?:reeder[_ ](?:3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)|P12Curve)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"reeder[_ ](3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)(?:[);/ ]|$)","model":"$1"},{"regex":"P12Curve","device":"smartphone","model":"P12 Curve"}]},"ELARI":{"regex":"KidPhone4G(?:[);/ ]|$)","device":"wearable","model":"KidPhone 4G"},"Epik One":{"regex":"(K501 Plus|[ ]K5(?:0[0-4]|1[01]|03T|3[456]|4[05]|73)|[ ]K60[01]|[ ]X507T|[ ]K40[56]|[ ]T700)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"K501 Plus","model":"Leo Plus"},{"regex":"K501","model":"Leo"},{"regex":"K500","model":"Omega Lite"},{"regex":"K502","model":"Omega"},{"regex":"K503T","model":"Leo Turbo"},{"regex":"K503","model":"Leo Max"},{"regex":"K504","model":"Titan 3G"},{"regex":"X507T","model":"Titan II"},{"regex":"K510","model":"Bolt"},{"regex":"K511","model":"Bolt Pro"},{"regex":"K534","model":"Hada"},{"regex":"K535","model":"Hada Turbo"},{"regex":"K545","model":"Rocket"},{"regex":"K536","model":"Royal"},{"regex":"K540","model":"Excalibur"},{"regex":"K573","model":"Panther"},{"regex":"K600","model":"Jupiter"},{"regex":"K601","model":"Jupiter One"},{"regex":"K406","model":"Pebble Plus"},{"regex":"K405","model":"Pebble II"},{"regex":"T700","model":"Palette","device":"tablet"}]},"Altice":{"regex":"Altice[ _](S62|S31|S43)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Kult":{"regex":"(Ambition|Beyond)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Beyond":{"regex":"SURVE(10|[26-8]|[12] PRO)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"SURVE([12]) PRO","model":"Surve $1 Pro"},{"regex":"SURVE(10|[26-8])","model":"Surve $1"}]},"BioRugged":{"regex":"(?:BioWolf 8-F30|BIOWOLF8F30|Ruggbo 20 Lite)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"BioWolf 8-F30|BIOWOLF8F30","model":"BioWolf 8-F30"},{"regex":"Ruggbo 20 Lite","model":"Ruggbo 20 Lite"}]},"VAIO":{"regex":"(?:VPA051|VA-10J)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"VPA051","model":"Phone A"},{"regex":"(VA-10J)","model":"$1"}]},"Spark":{"regex":"Spark Plus 3(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Plus 3","model":"Plus 3"}]},"SPC":{"regex":"(?:Gravity Max|GRAVITY_OCTACORE|SPC SMART LITE|SPC_ALIEN(?:_STICK)?|SPC Glow9.7)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"GRAVITY_OCTACORE","model":"Gravity OctaCore"},{"regex":"Gravity Max","model":"Gravity Max"},{"regex":"SPC Glow9.7","model":"Glow 9.7\\""},{"regex":"SPC SMART LITE","device":"smartphone","model":"Smart Lite"},{"regex":"SPC_ALIEN_STICK","device":"tv","model":"Alien Stick"},{"regex":"SPC_ALIEN","device":"tv","model":"Alien"}]},"Winmax":{"regex":"Winmax[ _](?:XC14|XC[46]|TX30)(?:[);/ ]|$)|MAUI.+Winmax_BD45","device":"smartphone","models":[{"regex":"Winmax[ _](XC14|XC[46])(?:[);/ ]|$)","model":"$1"},{"regex":"Winmax[ _](TX30)(?:[);/ ]|$)","device":"tablet","model":"$1"},{"regex":"MAUI.+Winmax_(BD45)","device":"feature phone","model":"$1"}]},"Zebra":{"regex":" (TC5[16]|TC2[05]|TC75|TC7[05]x|TC700H)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Thuraya":{"regex":"Thuraya[ _](X5-Touch)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Bkav":{"regex":"Bphone[ _](B111[45]|B2017)(?:[);/ ]|$)","device":"smartphone","model":"Bphone $1"},"Brandt":{"regex":"(BPRIME|BSTAR\\\\+?|BPRIMES|B-ONE)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Bigben":{"regex":"GAMETAB-ONE(?:[);/ ]|$)","device":"tablet","model":"GameTab-One"},"SMARTEC":{"regex":"(Atractivo)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Asanzo":{"regex":"ASANZO[ _](?:A2|S[23]|[SZ]5|S3_PLUS)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ASANZO[ _]S3[ _]PLUS","model":"S3 Plus"},{"regex":"ASANZO[ _](A2|S[23]|[SZ]5)(?:[);/ ]|$)","model":"$1"}]},"Artizlee":{"regex":"Artizlee[ _]S9|ATL-(?:16|21(?:PLUS|[XT])?|31|26)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"ATL-21PLUS(?:[);/ ]|$)","model":"ATL-21 Plus"},{"regex":"(ATL-(?:16|21[XT]?|31|26))(?:[);/ ]|$)","model":"$1"},{"regex":"Artizlee[ _]S9","device":"smartphone","model":"S9"}]},"Mintt":{"regex":"(?:Coolmintt(?:A3|M2)?|Ultramintt(?:S2)?|FRESHMINTT(?:A7|A10)?)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Coolmintt ?([PM]1|P3|A3|M2)(?:[);/ ]|$)","model":"CoolMintt $1"},{"regex":"Ultramintt ?([SR]1|S2)(?:[);/ ]|$)","model":"UltraMintt $1"},{"regex":"FRESHMINTT ?(A7|A10)(?:[);/ ]|$)","device":"tablet","model":"FreshMintt $1"}]},"Premio":{"regex":"(?:186HS2080531|186HS1050531|186HS1050232|186FT1080231|185FT5050231|PREMIO[ _](?:S50|P420|P451))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"186HS2080531","model":"X1"},{"regex":"186HS1050531","model":"P541"},{"regex":"185FT5050231","model":"P511"},{"regex":"186FT1080231","model":"P571"},{"regex":"186HS1050232","model":"P630"},{"regex":"PREMIO[ _](S50|P420|P451)(?:[);/ ]|$)","model":"$1"}]},"Trifone":{"regex":"Passion[-_](?:1S|PRO|PLUS)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Passion-1S","model":"Passion 1S"},{"regex":"Passion-Plus","model":"Passion Plus"},{"regex":"Passion_Pro","model":"Passion Pro"}]},"Bluewave":{"regex":"(?:33GT HD|WV8R-M|WV8R[_-]N)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"33GT HD","model":"Wave 8 HD+"},{"regex":"WV8R-M","model":"Wave 8 Red Marshmallow"},{"regex":"WV8R[_-]N","model":"Wave 8 Red Nougat"}]},"Siragon":{"regex":"Siragon|(?:SP-(?:5250|5400|5050))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:Siragon[_ ])?(SP-(?:5[12]50|5400|5050))","model":"$1"}]},"Poppox":{"regex":"Poppox P3","device":"smartphone","model":"P3"},"Zentality":{"regex":"C-723ULTRA(?:[);/ ]|$)","device":"tablet","model":"C-723 Ultra"},"Black Bear":{"regex":"(B6 Master|B6 Note X)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Fortis":{"regex":"(Apollo 5 Neo)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"OpelMobile":{"regex":" OpelMobile_(SmartJX)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"NuAns":{"regex":"NEO \\\\[Reloaded\\\\](?:[);/ ]|$)","device":"smartphone","model":"NEO Reloaded"},"Koolnee":{"regex":"(K1 Trio)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Sansui":{"regex":"Sansui[_ ]","device":"smartphone","models":[{"regex":"Sansui[_ ](Switch|Play|Fun|SA4[01]|U4[56]|U3[02]|Nova)(?:[);/ ]|$)","model":"$1"}]},"Sico":{"regex":"SICO[_ ](?:PLUS|e1002)|Express3-Max|SSR3-1-51-5M|SSD-1-53-13M","device":"smartphone","models":[{"regex":"SICO[_ ]PLUS2","model":"Plus 2"},{"regex":"SICO[_ ]PLUS","model":"Plus"},{"regex":"SSR3-1-51-5M","model":"Pro 3"},{"regex":"SSD-1-53-13M","model":"Diamond"},{"regex":"SICO[_ ]e1002","device":"tablet","model":"E1002"},{"regex":"Express3-Max","device":"tablet","model":"Express 3 Max"}]},"Smadl":{"regex":"Android.+(?:Safari)(?!/[\\\\d.]+)(?: Build|\\\\) AppleWebKit)|SMADL[ _]","device":"smartphone","models":[{"regex":"Android.+(?:Safari)(?!/[\\\\d.]+)(?: Build|\\\\) AppleWebKit)","model":"Safari"},{"regex":"SMADL[ _]Matri([2X])","model":"Matri $1"}]},"EXCEED":{"regex":"(EX7SL?4|EX10S4)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Tymes":{"regex":"Tymes[ _](V5)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Solone":{"regex":"SOLONE|(?:E1457|W145[02])(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"E1457","model":"Earth Iron E1457"},{"regex":"W1450","model":"Wind Breeze W1450"},{"regex":"W1452","model":"Wind Air W1452"},{"regex":"SOLONE A47","model":"SL-A47"},{"regex":"SOLONE[ _]Elite[ _]L5501","model":"Elite L5501"},{"regex":"SOLONE[ _]SUMO[_ ]S5001","model":"Sumo S5001"},{"regex":"SOLONE[ _](SL-K40|S5002)(?:[);/ ]|$)","model":"$1"}]},"FarEasTone":{"regex":"Smart ?(601|550|50[59])(?:[);/ ]|$)","device":"smartphone","model":"Smart $1"},"Smailo":{"regex":"Smailo_(2GO)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Colors":{"regex":"(?:Colors[ _](S(?:[19]|11)|P70|P[456]5|P32|E15|P50 Plus)|Pride_1A|P52_Pride5C|P90_Pride5X)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Pride_1A(?:[);/ ]|$)","model":"Pride 1A"},{"regex":"P52_Pride5C(?:[);/ ]|$)","model":"Pride 5C"},{"regex":"P90_Pride5X(?:[);/ ]|$)","model":"Pride 5X"},{"regex":"Colors[ _](S(?:[19]|11)|P70|E15|P[456]5|P32|P50 Plus)(?:[);/ ]|$)","model":"$1"}]},"Honeywell":{"regex":"(EDA50K?|EDA70|EDA51)(?:[);/ ]|$)","device":"smartphone","model":"ScanPal $1"},"Electroneum":{"regex":"electroneum(M1)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"High Q":{"regex":"(ELT070[46]H|ELT0802H)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Pluzz":{"regex":"Pluzz[_-](Z552|PL5[05]10|PL4010|PL501[46]|Elite_Dual)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"IKU Mobile":{"regex":"(Powerful_K55i|Curvy C50L)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"IKI Mobile":{"regex":"(?:GO5_55|BLESS_GO55|BLESSPLUS|KF4Go|KF5bless)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"GO5_55","model":"Go 5.5\\""},{"regex":"BLESS_GO55","model":"Bless Go 5.5\\""},{"regex":"BLESSPLUS","model":"Bless Plus"},{"regex":"(KF4Go|KF5bless)","model":"$1"}]},"CG Mobile":{"regex":"(?:CG_OMEGA6|Omega (?:[38])|CG_EON_Blaze_Pro|CG\\\\|EON Blaze GOLD)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Omega ([38])(?:[);/ ]|$)","model":"Omega $1"},{"regex":"CG_OMEGA6(?:[);/ ]|$)","model":"Omega 6"},{"regex":"CG_EON_Blaze_Pro(?:[);/ ]|$)","model":"EON Blaze Pro"},{"regex":"CG\\\\|EON Blaze GOLD(?:[);/ ]|$)","model":"EON Blaze Gold"}]},"IUNI":{"regex":"IUNI[ _]","device":"smartphone","models":[{"regex":"IUNI[ _](U3|i1|N1)","model":"$1"}]},"ZH&K":{"regex":"(?:ODYSSEY O2|ODYSSEY RANGE)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ODYSSEY O2","model":"Odyssey O2"},{"regex":"ODYSSEY RANGE","model":"Odyssey Range"}]},"Ordissimo":{"regex":"(LeNumero1)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Necnot":{"regex":"(M002[DGQK]-2|M002N|M002N-3T|M002W-2T|6M-3T)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Einstein":{"regex":"Einstein(T3)(?:[);/ ]|$)","device":"tablet","model":"$1"},"AfriOne":{"regex":"(CYGNUSX?|Gravity Z2|ChampionPro)(?:[);/ ]|$)","device":"phablet","models":[{"regex":"CYGNUSX(?:[);/ ]|$)","model":"Cygnus X"},{"regex":"CYGNUS(?:[);/ ]|$)","model":"Cygnus"},{"regex":"Gravity Z2(?:[);/ ]|$)","device":"smartphone","model":"Gravity Z2"},{"regex":"ChampionPro(?:[);/ ]|$)","device":"smartphone","model":"Champion Pro"}]},"Connex":{"regex":"(CTAB1044hn|CTAB-1044)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Connectce":{"regex":"(?:CP6001A)(?:[);/ ]|$)","device":"smartphone","model":"Connect Core 6"},"Clementoni":{"regex":"(?:CLEMPAD[_ ](?:6_XL|HR_Plus|HR|[68]|7_S|201[89])|ClemPhone_7|MFC_(?:2018|8))(?:[);/ ]|$)","device":"tablet","models":[{"regex":"CLEMPAD_(201[89])","model":"Clempad ($1)"},{"regex":"MFC_2018","model":"Clempad (2018)"},{"regex":"MFC_8","model":"Clempad 8"},{"regex":"CLEMPAD_7_S","model":"Clempad 7S"},{"regex":"Clempad[_ ](6_XL|HR_Plus|HR|[68])","model":"Clempad $1"},{"regex":"ClemPhone[ _](7)","device":"smartphone","model":"Clemphone $1"}]},"Cell-C":{"regex":"Cell_?C_","device":"smartphone","models":[{"regex":"Cell_C_(Summit_Plus|Fame|Evolve)(?:[);/ ]|$)","model":"$1"},{"regex":"CELLC_Evolve","device":"tablet","model":"Evolve"}]},"VC":{"regex":"(?:Camellia_II|Cactus II|Maple III|Maple-II|Cactus-Pro|LavenderII|Jasmine-II)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(Camellia_II|Cactus II|Maple III)(?:[);/ ]|$)","model":"$1"},{"regex":"Cactus-Pro","model":"Cactus Pro"},{"regex":"(Maple|Jasmine|Lavender)-?II(?:[);/ ]|$)","model":"$1 II"}]},"CellAllure":{"regex":"(?:Cool_Extreme_2|Earn|Fashion2Plus|Fashion[ _]C|Cool Duo|CHIC_X1)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(Cool_Extreme_2|Earn|Fashion[ _]C|Cool Duo)(?:[);/ ]|$)","model":"$1"},{"regex":"Fashion2Plus","model":"Fashion 2 Plus"},{"regex":"CHIC_X1","model":"Chic X1"}]},"Eagle":{"regex":"Eagle[ _](Classic Pro|Elite|Gold)(?:[);/ ]|$)","device":"tv","model":"$1"},"Invens":{"regex":"(Fighter|Eager)(?: Build|[;)])","device":"smartphone","model":"$1"},"Chico Mobile":{"regex":"(?:ALTO (?:Bombo|classic|Estrella|JUEGO|SUBIR|[235])|FUEGO MAX|OJOS[ _](?:CAMBIO|NUBE|[68i]|ORO))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ALTO Bombo","model":"Alto Bombo"},{"regex":"ALTO classic","model":"Alto Classic"},{"regex":"ALTO Estrella","model":"Alto Estrella"},{"regex":"ALTO JUEGO","model":"Alto Juego"},{"regex":"ALTO SUBIR","model":"Alto Subir"},{"regex":"ALTO ([235])","model":"Alto $1"},{"regex":"OJOS[ _]([68i])","model":"Ojos $1"},{"regex":"OJOS NUBE","model":"Ojos Nube"},{"regex":"OJOS CAMBIO","model":"Ojos Cambio"},{"regex":"OJOS ORO","model":"Ojos Oro"},{"regex":"FUEGO MAX","device":"tablet","model":"Fuego Max"}]},"Claresta":{"regex":"Claresta[ _]|(?:AirPhoneS[56]|AirPhone K6)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"AirPhone ?(S[56]|K6)","model":"AirPhone $1"},{"regex":"Claresta (F3) PRO","model":"$1 Pro"},{"regex":"Claresta[ _](F4)","model":"$1"}]},"Camfone":{"regex":"(?:Camfone (?:SE)|Hero[_ ](?:H5\\\\+|SE2|H9|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(Hero[_ ](?:H5\\\\+|SE2|H9|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s))(?:[);/ ]|$)","model":"$1"},{"regex":"Camfone (SE)(?:[);/ ]|$)","model":"$1"}]},"Bellphone":{"regex":"Bp100 X-Plus(?:[);/ ]|$)","device":"smartphone","model":"BP 100 X-Plus"},"Gini":{"regex":"Gini[ _]","device":"smartphone","models":[{"regex":"Gini[ _]W(7)","model":"W$1"},{"regex":"Gini[ _]n(8)","model":"N$1"},{"regex":"Gini[ _]s5Pro","model":"S5 Pro"},{"regex":"Gini[ _]Tab[ _](V[78])","device":"tablet","model":"Tab $1"}]},"MIVO":{"regex":"(Caryota [1245789]|Jazz J[13] 2018)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(Caryota [1245789])(?:[);/ ]|$)","model":"$1"},{"regex":"Jazz (J[13]) 2018","model":"Jazz $1 (2018)"}]},"Jesy":{"regex":"Jesy_(J7)","device":"smartphone","model":"$1"},"Teknosa":{"regex":"Preo[ _]","device":"smartphone","models":[{"regex":"Preo Teknosa P1","model":"Preo P1"},{"regex":"Preo[ _]P([23])","model":"Preo P$1"}]},"Hyve":{"regex":"(?:Pryme 01|ST01)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Pryme 01","model":"Pryme 01"},{"regex":"ST01","model":"Storm ST01"}]},"EWIS":{"regex":"OCTA T720Q(?:[);/ ]|$)","device":"tablet","model":"Octa T720Q"},"Leader Phone":{"regex":"(Vyper|N-5[07]|N-45)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"N-45 light","model":"N-45 Light"},{"regex":"(Vyper|N-5[07]|N-45)(?:[);/ ]|$)","model":"$1"}]},"Cavion":{"regex":"(?:Cavion[_ ](?:Solid[_ ]4[\\\\._]5|Base[ _](?:7|7_3G_Silver|5\\\\.0|10|7.2 Quad)|10_3GRQ)|Cavion7.1quad)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Cavion[_ ]Solid[_ ]4[\\\\._]5","model":"Solid 4.5\\""},{"regex":"Cavion BASE 5.0","model":"Base 5.0\\""},{"regex":"CAVION_10_3GRQ","device":"tablet","model":"Base 10 3GR Quad"},{"regex":"Cavion(?:7.1quad)","device":"tablet","model":"Base 7.1\\" Quad"},{"regex":"Cavion Base 7.2 Quad","device":"tablet","model":"Base 7.2\\" Quad"},{"regex":"Cavion Base 10","device":"tablet","model":"Base 10"},{"regex":"Cavion Base 7 Dual","device":"tablet","model":"Base 7.0\\" Dual"},{"regex":"Cavion Base 7 Quad","device":"tablet","model":"Base 7.0\\" Quad"},{"regex":"Cavion_Base_7_3G_Silver","device":"tablet","model":"Base 7.0\\" 3G Silver"}]},"GLX":{"regex":"GLX (?:Aria|Dorna|Taban|Shine|Spark|ASA)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"GLX ASA","model":"Asa"},{"regex":"GLX (Aria|Taban|Shine|Spark)(?:[);/ ]|$)","model":"$1"},{"regex":"GLX (Dorna)(?:[);/ ]|$)","device":"tablet","model":"$1"}]},"Seeken":{"regex":"Seeken[ _-]","device":"smartphone","models":[{"regex":"Seeken[_ -](SG1|SJ1)","model":"$1"},{"regex":"Seeken[_ -](ST-101)","device":"tablet","model":"$1"}]},"Jivi":{"regex":"(?:Revolution TnT3|Xtreme_(?:[37]|3x)|Xtreme (?:XT84|XT309 Plus|1))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Revolution (TnT3)","model":"Revolution $1"},{"regex":"Xtreme (XT84)","model":"Xtreme Klick $1"},{"regex":"Xtreme (XT309) Plus","model":"Xtreme View Pro $1Plus"},{"regex":"Xtreme[ _]([137]|3x)(?:[);/ ]|$)","model":"Xtreme $1"}]},"Winnovo":{"regex":"Winnovo[ _]","device":"tablet","models":[{"regex":"Winnovo[ _](M866|M798|VTab|750[PK])(?:[);/ ]|$)","model":"$1"},{"regex":"Winnovo[ _](K5[46]|K43)[a-z]{2}","device":"smartphone","model":"$1"}]},"WE":{"regex":"WE (A[15]0|B3|F[12]0|E[12]|L[3469]|R[34]|V[34]|S1|X[13]|T1)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Trio":{"regex":"Trio V51 DT(?:[);/ ]|$)","device":"smartphone","model":"V51DT"},"Seuic":{"regex":"(AUTOID9N)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Centric":{"regex":"(?:Centric[- ]CM(?:5001|33[23]1|3321Plus)|CM4331)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"(?:Centric[- ])?CM5001","model":"A1"},{"regex":"(?:Centric[- ])?CM3321Plus","model":"P1 Plus"},{"regex":"(?:Centric[- ])?CM3321","model":"P1"},{"regex":"(?:Centric[- ])?CM3331","model":"L3"},{"regex":"(?:Centric[- ])?CM4331","model":"G1"}]},"Kata":{"regex":"Kata[ _-]","device":"smartphone","models":[{"regex":"Kata[ _-](C3|L1|M3s|M4|V[56])(?:[);/ ]|$)","model":"$1"},{"regex":"Kata[ _-]i5-\\\\w","model":"I5"},{"regex":"Kata-(T5)(?:[);/ ]|$)","device":"tablet","model":"$1"},{"regex":"Kata-Tmini4(?:[);/ ]|$)","device":"tablet","model":"T Mini 4"},{"regex":"Kata Box 2(?:[);/ ]|$)","device":"tv","model":"Box 2"}]},"Leff":{"regex":"Leff Shell (?:HV320WHB-N55|LC390TA2A)(?:[);/ ]|$)","device":"tv","model":""},"Hardkernel":{"regex":"ODROID[-]?(C2|U2|XU[34])(?:[);/ ]|$)","device":"peripheral","model":"ODROID $1"},"Wiseasy":{"regex":"WISENET5(?:[);/ ]|$)","device":"peripheral","model":"WISENET5"},"Shtrikh-M":{"regex":"SHTRIH-SMARTPOS-F2(?:[);/ ]|$)","device":"peripheral","model":"Smartpos F2"},"BBK":{"regex":"([65]5|4[03]|3[29]|28)LEX[-_](81(?:27|39|45|58|61)|71(?:[23]7|4[345]|5[45]|6[368]|[57]8))[_/]([FU]?TS2C)(?:[);/ ]|$)","device":"tv","model":"$1LEX-$2/$3"},"4ife":{"regex":"4ife (4K Smart TV Box)(?:[);/ ]|$)","device":"tv","model":"$1"},"Westpoint":{"regex":"WESTPOINT[;,]","device":"tv","models":[{"regex":"(TETS-4919SM)","model":"$1"}]},"Wintouch":{"regex":"Q93S","device":"tablet","model":"Q93S"},"Aiuto":{"regex":"(AT702)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Seatel":{"regex":"Seatel","device":"smartphone","models":[{"regex":"Seatel[ _](L2|V8[AE]|T[5-8]|R6|V[89])(?:[);/ ]|$)","model":"$1"}]},"Ditecma":{"regex":"(M1092R(?:-[12]|V[45])?)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Datamini":{"regex":"(K908H4G)(?:[);/ ]|$)","device":"tablet","model":"$1"},"3GNET":{"regex":"(?<!NetType/)3GNET[ _]","device":"smartphone","models":[{"regex":"3GNET[ _](U8|T800|U6s)(?:[);/ ]|$)","model":"$1"},{"regex":"3GNET[ _]T ?900","model":"T900"}]},"Yoka TV":{"regex":"KB2 PRO(?:[);/ ]|$)","device":"tv","model":"KB2 Pro"},"Formuler":{"regex":"Formuler[ _]","device":"tv","models":[{"regex":"Formuler[ _](Z8(?: Pro)?)(?:[);/ ]|$)","model":"$1"}]},"Malata":{"regex":"(?:Build/)?Malata[ _]?([a-z0-9]+)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"IT":{"regex":"IT-(?:1101S?|1101-QUAD)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"IT-1101-QUAD","model":"1101 Quad"},{"regex":"IT-(1101S?)","model":"$1"}]},"Navcity":{"regex":"NP-752Go(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"NP-752Go","model":"NP-752 Go"}]},"Jiake":{"regex":"(?:JK(?:960|103) 3G|JK-?760)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"JK-?(760)(?:[);/ ]|$)","model":"JK-$1"},{"regex":"JK(960|103) 3G(?:[);/ ]|$)","device":"tablet","model":"JK-$1 3G"}]},"iQ&T":{"regex":"(IFoo (?:U200|H55))(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Mantra":{"regex":"(MFSTAB(?:_74G)?)(?:[);/ ]|$)","device":"peripheral","model":"$1"},"Datalogic":{"regex":"(?:MEMOR 10)(?:[);/ ]|$)","device":"smartphone","model":"Memor 10"},"Naomi Phone":{"regex":"NAOMIPHONE Ambar(?:[);/ ]|$)","device":"smartphone","model":"Ambar"},"Navitel":{"regex":"NAVITEL[ _]","device":"tablet","models":[{"regex":"NAVITEL[ _](T70[07]) 3G(?:[);/ ]|$)","model":"$1 3G"},{"regex":"NAVITEL[ _](T757)LTE(?:[);/ ]|$)","model":"$1 LTE"},{"regex":"NAVITEL[ _](A73[0157]|A650)(?:[);/ ]|$)","model":"$1"},{"regex":"RE900 Full HD(?:[);/ ]|$)","model":"RE900 Full HD"}]},"Linnex":{"regex":"LI(22)(?:[);/ ]|$)","device":"smartphone","model":"Li $1"},"Smartab":{"regex":"(ST1009)(?:[);/ ]|$)","device":"tablet","model":"$1"},"SuperTab":{"regex":"SuperTab(A10|K7|S7G)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Suzuki":{"regex":"SUZUKI[ _]|(?:ECOPAD7|SUMOPad10)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"SUMOPAD(8100|10)(?:[);/ ]|$)","model":"SumoPad $1"},{"regex":"ECOPAD7","model":"ECOPad 7"}]},"Philips":{"regex":"Philips|AND1E(?:[);/ ]|$)|NETTV/|PI3210G|TLE(821L|722G)|TPM1[79]1E|70PUH6774_96|QM16[134]E|Xenium S[25]66|S397|W5510","device":"smartphone","models":[{"regex":"(?:Philips[_ ])?Xenium[ _](S[25]66|V787)(?:[);/ ]|$)","model":"Xenium $1"},{"regex":"(?:Philips[_ ])?(S397|W5510)(?:[);/ ]|$)","model":"$1"},{"regex":"AND1E(?: TV)?(?:[);/ ]|$)","model":"Android TV","device":"tv"},{"regex":"(PI3210G)","model":"$1","device":"tablet"},{"regex":"(TPM1[79]1E)","model":"$1","device":"tv"},{"regex":"(QM16[134]E)","model":"$1","device":"tv"},{"regex":"(70PUH6774)_96","model":"$1/96 4K UHD","device":"tv"},{"regex":"(TLE821L)(?:[);/ ]|$)","model":"$1 4G LTE","device":"tablet"},{"regex":"(TLE722G)(?:[);/ ]|$)","model":"$1","device":"tablet"},{"regex":"Philips, BDP([0-9]{4})","model":"Blu-ray Player (BDP$1)","device":"tv"},{"regex":"Philips, ([a-z0-9-]+)","model":"$1","device":"tv"},{"regex":"(NETTV/[0-9\\\\.]{5})","model":"NetTV Series","device":"tv"},{"regex":"Philips-FISIO ([a-z0-9]+)","model":"Fisio $1"},{"regex":"Philips[ _-]?([a-z0-9\\\\-@]+)","model":"$1"}]},"INCAR":{"regex":"(KZCAR)(?:[);/ ]|$)","device":"car browser","model":"$1"},"FaRao Pro":{"regex":"(FTRW100)(?:[);/ ]|$)","device":"tablet","model":"$1"},"Nabi":{"regex":"(?:DMTAB-(?:IN08A|NV08B|NV2[04]A)|NBTY07SMKG|NBFP07PMKG|SNB02-NV7A|NABI2-NV7A)(?:[);/ ]|$)","device":"tablet","models":[{"regex":"DMTAB-(?:IN08A|NV08B)","model":"Dream Tab HD 8.0\\""},{"regex":"DMTAB-NV(2[04])A","model":"Big Tab HD $1.0\\""},{"regex":"NBTY07SMKG","model":"Barbie Tab 7.0\\""},{"regex":"NBFP07PMKG","model":"Fisher Price Learning Tab 7.0\\""},{"regex":"SNB02-NV7A","model":"2S Tab"},{"regex":"NABI2-NV7A","model":"2 Tab"}]},"StrawBerry":{"regex":"StrawBerry[ _]","device":"smartphone","models":[{"regex":"StrawBerry[ _](SX|QX15)(?:[);/ ]|$)","model":"$1"}]},"Gresso":{"regex":"Gresso[ _]","device":"smartphone","models":[{"regex":"Gresso[ _]Regal(?:[);/ ]|$)","model":"Regal"}]},"Pendoo":{"regex":"Pendoo|A5X MAX(?:[\\\\.-]\\\\w+)?\\\\.01\\\\.d4","device":"tv","models":[{"regex":"Pendoo ?(T95Z|X10) PLUS","model":"$1 Plus"},{"regex":"Pendoo ?X8PRO+","model":"X8 Pro+"},{"regex":"Pendoo[ \\\\.]?(X9[29])","model":"$1"},{"regex":"pendoo mini","model":"Mini"},{"regex":"A5X MAX(?:[\\\\.-]\\\\w+)?\\\\.01\\\\.d4","model":"A5X Max"}]},"PiPO":{"regex":"Pipo[_ ]|PipoM9Pro","device":"tablet","models":[{"regex":"Pipo[_ ]([TP]9)","model":"$1"},{"regex":"PipoM9Pro","model":"M9 Pro"},{"regex":"PIPO[_ ](X10|X9S)","device":"tv","model":"$1"}]},"Engel":{"regex":"(EN1007Q)plus(?:[);/ ]|$)","device":"tv","model":"$1 Plus"},"Genesis":{"regex":"(SK-Mtek GT730[15])(?:[);/ ]|$)","device":"tablet","model":"$1"},"InfoKit":{"regex":"(TVB-906X)(?:[);/ ]|$)","device":"tv","model":"$1"},"Blloc":{"regex":"(Zero18)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Huskee":{"regex":"VULKANO(?:[);/ ]|$)","device":"smartphone","model":"Vulkano"},"SOLE":{"regex":"SOLE[_ ]POP[_ ]S([45]0)(?:[);/ ]|$)","device":"smartphone","model":"Pop S$1"},"SOLO":{"regex":"SOLO[_ ](Aspire(?: M)?)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"OINOM":{"regex":"OINOM[_ ](V9D|V7H|V[679])(?:[);/ ]|$)","device":"smartphone","model":"$1"},"Singtech":{"regex":"Singtech|(?:Sapphire[_ ](?:H50S|H7S?|H90))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Sapphire[_ ](H50S|H7S?|H90)(?:[);/ ]|$)","model":"Sapphire $1"},{"regex":"Singtech[ _](Q2|S1)(?:[);/ ]|$)","model":"$1"}]},"Sunny":{"regex":"(SS4G9 Mira|SS4G7 Sole|SS4G1 Luna|SS4G8 Nora|SS4G6 Lola)(?:[);/ ]|$)","device":"smartphone","model":"$1"},"TEENO":{"regex":"TEENO","device":"smartphone","models":[{"regex":"TEENO[_ ](S9|A1|S11)(?:[);/ ]|$)","model":"$1"}]},"v-mobile":{"regex":"Vmobile[ _]","device":"smartphone","models":[{"regex":"Vmobile[ _](J7)(?:[);/ ]|$)","model":"$1"},{"regex":"Vmobile XS Pro(?:[);/ ]|$)","model":"XS Pro"}]},"OASYS":{"regex":"(TEG9300)(?:[);/ ]|$)","device":"peripheral","model":"$1"},"Aspera":{"regex":"ASPERA|(?:Wren)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"ASPERA[ _](R5h|RT3|A4[02]|A50)(?:[);/ ]|$)","model":"$1"},{"regex":"Wren(?:[);/ ]|$)","model":"Wren"}]},"Vision Touch":{"regex":"Vision ?Touch","device":"smartphone","models":[{"regex":"VisionTouchLife","model":"Life"},{"regex":"Inspire","model":"Inspire"}]},"NOBUX":{"regex":"SMART_VOLT_NX5(?:[);/ ]|$)","device":"smartphone","model":"Smart Volt NX5"},"Hitech":{"regex":"(Amaze[ _](?:S2_4G|S[56] 4G|S1|S[56](?: Plus)?))(?:[);/ ]|$)","device":"smartphone","model":"$1"},"F150":{"regex":"Bison2021(?:[);/ ]|$)","device":"smartphone","model":"B2021"},"BilimLand":{"regex":"BilimBook mini(?:[);/ ]|$)","device":"desktop","model":"BilimBook Mini"},"Greentel":{"regex":"X1_Light_Lte(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"X1_Light_Lte","model":"X1 Light LTE"}]},"Kyowon":{"regex":"(KA-E410W)(?:[);/ ]|$)","device":"tablet","model":"$1"},"LT Mobile":{"regex":"(?:LT-NOTE 10S)","device":"smartphone","models":[{"regex":"LT-NOTE 10S","model":"Note 10S"}]},"ONYX BOOX":{"regex":"KON_TIKI(?:[);/ ]|$)","device":"tablet","model":"Kon Tiki"},"GFive":{"regex":"(?:PRESIDENT_GOLD_(9|10))(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"PRESIDENT_GOLD_(9|10)","model":"President Gold $1"}]},"KINGZONE":{"regex":"KINGZONE_","device":"smartphone","models":[{"regex":"KINGZONE_(N5)(?:[);/ ]|$)","model":"$1"}]},"M-Tech":{"regex":"EROS 4G(?:[);/ ]|$)","device":"smartphone","model":"Eros 4G"},"Fantec":{"regex":"FAN-M300H(?:[);/ ]|$)","device":"smartphone","model":"M300H"},"AURIS":{"regex":"(TB-703G)(?:[);/ ]|$)","device":"tablet","model":"$1"},"YUHO":{"regex":"YUHO_","device":"smartphone","models":[{"regex":"YUHO_(O2|H2|Y[123])_PRO","model":"$1 Pro"},{"regex":"YUHO_Vast_Plus","model":"Vast Plus"},{"regex":"YUHO_Y1_ACE","model":"Y1 Ace"},{"regex":"YUHO_Y1_STAR","model":"Y1 Star"},{"regex":"YUHO_O1_LITE","model":"O1 Lite"},{"regex":"YUHO_(Vast2?|O[12]|Y2)(?:[);/ ]|$)","model":"$1"}]},"2F Mobile":{"regex":"(Z8PLUS|Z8POCKET)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"Z8PLUS","model":"Z8 Plus"},{"regex":"Z8POCKET","model":"Z8 Pocket"}]}}');

/***/ }),

/***/ 95236:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Acer":{"regex":"FBMD/(?:Aspire E5-421G|Z5WAL|One S1003);","device":"desktop","models":[{"regex":"FBMD/Aspire E5-421G;","model":"Aspire E5-421G"},{"regex":"FBMD/Z5WAL;","model":"Aspire E5-511"},{"regex":"FBMD/One S1003;","model":"One 10"}]},"Asus":{"regex":"FBMD/(?:K50IN|K54L|T100HAN|T103HAF|UX360CAK|X550LB|X553MA|X555LN|X556UQK);","device":"desktop","models":[{"regex":"FBMD/K50IN;","model":"K50IN"},{"regex":"FBMD/K54L;","model":"K54L"},{"regex":"FBMD/T100HAN;","model":"Transformer Book"},{"regex":"FBMD/T103HAF;","model":"Transformer Mini"},{"regex":"FBMD/UX360CAK;","model":"ZenBook Flip"},{"regex":"FBMD/X550LB;","model":"X550LB"},{"regex":"FBMD/X553MA;","model":"X553MA"},{"regex":"FBMD/X555LN;","model":"X555LN"},{"regex":"FBMD/X556UQK;","model":"X556UQK"}]},"Dell":{"regex":"FBMD/(?:Latitude E4300|Inspiron 3541|XPS 15 95[35]0);","device":"desktop","models":[{"regex":"Latitude E4300","model":"Latitude E4300"},{"regex":"Inspiron 3541","model":"Inspiron 3541"},{"regex":"XPS 15 9530","model":"XPS 15 9530"},{"regex":"XPS 15 9550","model":"XPS 15 9550"}]},"HP":{"regex":"FBMD/((?:Compaq|HP) |23-f364)","device":"desktop","models":[{"regex":"Compaq Presario CQ61 Notebook PC","model":"Compaq Presario CQ61"},{"regex":"HP Pavilion x2 Detachable","model":"Pavilion x2"},{"regex":"HP Laptop 15-bs0xx","model":"15 Laptop PC"},{"regex":"HP ENVY x360 Convertible 15-bp0xx","model":"ENVY x360 Convertible PC"},{"regex":"HP EliteBook (25[67]0p)","model":"EliteBook $1"},{"regex":"HP ProBook (440 G5|6[35]60b)","model":"ProBook $1"},{"regex":"HP Pavilion dv6 Notebook PC","model":"Pavilion dv6"},{"regex":"HP Pavilion Notebook","model":"Pavilion"},{"regex":"HP Spectre x360 Convertible","model":"Spectre x360"},{"regex":"HP Pavilion All-in-One 24-r0xx","model":"Pavilion 24-r0xx All-in-One Desktop PC","device":"desktop"},{"regex":"23-f364","model":"Pavilion TouchSmart 23-f364 All-in-One Desktop PC","device":"desktop"}]},"Lenovo":{"regex":"FBMD/(?:37021C5|80E5|80SM|80VR);","device":"desktop","models":[{"regex":"FBMD/37021C5;","model":"ThinkPad Helix 3702"},{"regex":"FBMD/80E5;","model":"G50-80"},{"regex":"FBMD/80SM;","model":"Ideapad 310-15ISK"},{"regex":"FBMD/80VR;","model":"Legion Y720"}]},"Schneider":{"regex":"FBMD/SCL141CTP;","device":"desktop","model":"Notebook 14\\" Cherry Trail"},"Thomson":{"regex":"FBMD/TH360R12.32CTW;","device":"desktop","model":"Prestige TH-360R12.32CTW"},"Toshiba":{"regex":"FBMD/Satellite ","device":"desktop","models":[{"regex":"Satellite (A[25]00|C650|C855|L650|S855)","model":"Satellite $1"},{"regex":"Satellite ([^;\\\\)]+);","model":"Satellite $1"}]}}');

/***/ }),

/***/ 92437:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Apple":{"regex":"(?:Apple-)?iPod","device":"portable media player","models":[{"regex":"(?:Apple-)?iPod1[C,]1","model":"iPod Touch 1G"},{"regex":"(?:Apple-)?iPod2[C,]1","model":"iPod Touch 2G"},{"regex":"(?:Apple-)?iPod3[C,]1","model":"iPod Touch 3"},{"regex":"(?:Apple-)?iPod4[C,]1","model":"iPod Touch 4"},{"regex":"(?:Apple-)?iPod5[C,]1","model":"iPod Touch 5"},{"regex":"(?:Apple-)?iPod7[C,]1","model":"iPod Touch 6"},{"regex":"(?:Apple-)?iPod","model":"iPod Touch"}]},"Cowon":{"regex":"COWON ([^;/]+) Build","device":"portable media player","model":"$1"},"Microsoft":{"regex":"Microsoft ZuneHD","device":"portable media player","model":"Zune HD"},"Panasonic":{"regex":"(SV-MV100)","device":"portable media player","model":"$1"},"Samsung":{"regex":"YP-(G[SIPB]?1|G[57]0|GB70D)","device":"portable media player","models":[{"regex":"YP-G[B]?1","model":"Galaxy Player 4.0"},{"regex":"YP-G70","model":"Galaxy Player 5.0"},{"regex":"YP-GS1","model":"Galaxy Player 3.6"},{"regex":"YP-GI1","model":"Galaxy Player 4.2"},{"regex":"YP-GP1","model":"Galaxy Player 5.8"},{"regex":"YP-G50","model":"Galaxy Player 50"},{"regex":"YP-GB70D","model":"Galaxy Player 70 Plus"}]},"Wizz":{"regex":"(DV-PTB1080)(?:[);/ ]|$)","device":"portable media player","model":"$1"},"SONOS":{"regex":"Sonos/.+\\\\((?:ZP.+)\\\\)|Sonos;","device":"portable media player","models":[{"regex":"\\\\((ZPS(?:[13569]|1[1-578]|2[03])|ZP90)\\\\)","model":"$1"},{"regex":"Sonos;Play5;","model":"Play:5"},{"regex":"Sonos;One;","model":"One"}]}}');

/***/ }),

/***/ 8093:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Airties":{"regex":"Airties","device":"tv","models":[{"regex":"Airties; ?([^);/]+)","model":"$1"}]},"ALDI NORD":{"regex":"ALDINORD[;,]","device":"tv","model":""},"ALDI SÜD":{"regex":"ALDISUED[;,]","device":"tv","model":""},"Altech UEC":{"regex":"Altech UEC","device":"tv","models":[{"regex":"Altech UEC; ?([^);/]+)","model":"$1"}]},"AOC":{"regex":"AOC","device":"tv","models":[{"regex":"(LE43S5970-20|S50856)","model":"$1"}]},"ARRIS":{"regex":"ARRIS[;,]","device":"tv","models":[{"regex":"FS-ARS-01B","model":"FS-ARS-01B"}]},"Atvio":{"regex":"ATVIO","device":"tv","models":[{"regex":"55D1620","model":"55D1620"}]},"BangOlufsen":{"regex":"Bangolufsen","device":"tv","model":"BeoVision"},"Blaupunkt":{"regex":"Blaupunkt_UMC[;,]","device":"tv","models":[{"regex":"LC-65CUG8052E","model":"LC-65CUG8052E"}]},"Bush":{"regex":"BUSH[;,]","device":"tv","model":""},"Celcus":{"regex":"CELCUS[;,]","device":"tv","model":""},"Changhong":{"regex":"Changhong","device":"tv","models":[{"regex":"Changhong; ?([^);/]+)","model":"$1"}]},"CreNova":{"regex":"CreNova","device":"tv","model":"CNV001"},"Digihome":{"regex":"DIGIHOME[;,]","device":"tv","model":""},"DMM":{"regex":"DMM","device":"tv","model":"Dreambox"},"ELECTRONIA":{"regex":"ELECTRONIA[;,]","device":"tv","model":""},"Essentielb":{"regex":"ESSENTIELB[;,]","device":"tv","model":""},"Finlux":{"regex":"FINLUX[;,]","device":"tv","model":""},"F&U":{"regex":"FU[;,]","device":"tv","model":""},"Fuego":{"regex":"FUEGO[;,]","device":"tv","model":""},"GoGEN":{"regex":"GOGEN[;,]","device":"tv","model":""},"Grundig":{"regex":"(OWB|Grundig|Arcelik)","device":"tv","model":""},"Haier":{"regex":"(?:HHW_)?HAIER","device":"tv","models":[{"regex":"LE55X7000U","model":"LE55X7000U"}]},"Hi-Level":{"regex":"HI-LEVEL[;,]","device":"tv","model":""},"Hisense":{"regex":"Hisense|Eurofins_Digital_Testing","device":"tv","models":[{"regex":"50ADEVTOOL","model":"50ADEVTOOL"},{"regex":"50A683FEVS","model":"50A683FEVS"},{"regex":"55A6100EE","model":"55A6100EE"},{"regex":"55U62QGAVT","model":"55U62QGAVT"},{"regex":"50A6502EA","model":"50A6502EA"},{"regex":"MICALIDVB6886","model":"MICALIDVB6886"},{"regex":"(L[A-Z]{2,3}[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,6}[0-9]?[A-Z]?)","model":"$1"},{"regex":"(H[A-Z]?[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,4})","model":"$1"}]},"Hitachi":{"regex":"Hitachi[;,]","device":"tv","models":[{"regex":"49D2900","model":"49D2900"}]},"Horizon":{"regex":"HORIZON[;,]","device":"tv","model":""},"Hotel":{"regex":"HOTEL[;,]","device":"tv","model":""},"Humax":{"regex":"Humax","device":"tv","models":[{"regex":"(HD-FOX C|HD (FOX\\\\+|NANO)|iCord (HD\\\\+|MINI|Cable)|(CX|IR)HD-5100(C|S)|HM9503HD)","model":"$1"},{"regex":"HMS1000S","model":"HMS-1000S"},{"regex":"Humax; ([^);/]+)","model":"$1"}]},"Hyundai":{"regex":"HYUNDAI[;,]","device":"tv","model":""},"Ikea":{"regex":"Ikea","device":"tv","model":""},"Intek":{"regex":"Intek","device":"tv","models":[{"regex":"(Vantage|VT-100|VT-1)","model":"$1"}]},"Inverto":{"regex":"Inverto","device":"tv","models":[{"regex":"inverto; ([^);/]+)","model":"$1"},{"regex":"(Volksbox Web Edition|Volksbox Essential|Volksbox II|Volksbox)","model":"$1"}]},"JVC":{"regex":"AFTSO001|JVC[;,]","device":"tv","models":[{"regex":"AFTSO001","model":"4K (2019)"}]},"Kalley":{"regex":"KALLEY[;,]","device":"tv","models":[{"regex":"32D1620","model":"32D1620"}]},"KUBO":{"regex":"KUBO[;,]","device":"tv","model":""},"Laurus":{"regex":"LAURUS[;,]","device":"tv","model":""},"LG":{"regex":"LGE","device":"tv","models":[{"regex":"XU43WT180N","model":"XU43WT180N"},{"regex":"43LJ614V-ZA","model":"43LJ614V-ZA"},{"regex":"55SK850V-ZA","model":"55SK850V-ZA"},{"regex":"KEY0000213F1z","model":"KEY0000213F1z"},{"regex":"KEY0000213F","model":"KEY0000213F"},{"regex":"KEY000000(2E|2F|3B|3F)","model":"KEY000000$1"},{"regex":"(NetCast [0-9]{1}.[0-9]{1}|GLOBAL_PLAT3)","model":"$1"},{"regex":"(OLED[0-9]{2}[A-Z0-9]{3}[A-Z]{2})","model":"$1"},{"regex":"(OLED[0-9]{2}[A-Z][0-9][A-Z])","model":"$1"},{"regex":"(OLED[0-9]{2}[A-Z0-9]{2})","model":"$1"},{"regex":"([0-9]{2}[A-Z]{2}[0-9]{4}[A-Z0-9]{1}[A-Z]{2})","model":"$1"},{"regex":"([0-9]{2}NANO[0-9]{3}[A-Z]{2})","model":"$1"},{"regex":"([0-9]{2}NANO[0-9]{2})","model":"$1"},{"regex":"LGE;? ?([0-9]{2}[A-Z]{2}[0-9]{2,4}[A-Z]?)","model":"$1"},{"regex":"LM21U","model":"LM21U"},{"regex":"32LM","model":"32LM"}]},"Lifemaxx":{"regex":"Lifemaxx[;,]","device":"tv","model":""},"Linsar":{"regex":"LINSAR[;,]","device":"tv","model":""},"Loewe":{"regex":"Loewe","device":"tv","models":[{"regex":"([A-Z]{2}[0-9]{3})","model":"$1"}]},"Luxor":{"regex":"LUXOR[;,]","device":"tv","model":""},"Manhattan":{"regex":"Manhattan","device":"tv","models":[{"regex":"T3","model":"T3"}]},"MediaTek":{"regex":"MTK|MediaTek;","device":"tv","models":[{"regex":"(MT[0-9]{4})","model":"$1"}]},"Medion":{"regex":"Medion","device":"tv","model":""},"Miray":{"regex":"MIRAY","device":"tv","models":[{"regex":"LEDM-322NIP","model":"LEDM-322NIP"}]},"MStar":{"regex":"MStar[;,]","device":"tv","models":[{"regex":"([24])KTV18","model":"$1KTV18"}]},"MTC":{"regex":"MTC[;,]","device":"tv","models":[{"regex":"([24])K_Android_TV_V01","model":"$1K Android TV"}]},"Nordmende":{"regex":"NORDMENDE[;,]","device":"tv","model":""},"Metz":{"regex":"Metz","device":"tv","model":""},"Ok":{"regex":"OK[;,]","device":"tv","model":""},"Panasonic":{"regex":"Panasonic","device":"tv","models":[{"regex":"VIERA (201[1-9])","model":"VIERA ($1)"},{"regex":"(DIGA [A-Z]{1}[0-9]{4})","model":"$1"},{"regex":"DIGA Webkit ([A-Z]{1}[0-9]{4})","model":"DIGA $1"},{"regex":"SmartTV(201[89]|202[0-1])","model":"Smart TV ($1)"}]},"PEAQ":{"regex":"PEAQ","device":"tv","model":""},"Philips":{"regex":"Philips|NETTV/","device":"tv","models":[{"regex":"Philips[,;] ?((?! )[^),;/]+)","model":"$1"},{"regex":"NETTV/[0-9\\\\.]{5}","model":"NetTV Series"}]},"Polaroid":{"regex":"POLAROID[;,]","device":"tv","model":""},"PROFiLO":{"regex":"PROFILO[;,]","device":"tv","model":""},"Qilive":{"regex":"QILIVE[;,]","device":"tv","model":""},"REGAL":{"regex":"REGAL[;,]","device":"tv","model":""},"Saba":{"regex":"Saba[;,]","device":"tv","model":""},"Salora":{"regex":"Salora[;,]","device":"tv","model":""},"Samsung":{"regex":"Samsung|Maple_2011","device":"tv","models":[{"regex":"SmartTV(201[2-9]|202[0-1]):([^);/]+)","model":"$2"},{"regex":"SmartTV(201[2-9]|202[0-1])","model":"Smart TV ($1)"},{"regex":"Maple_2011","model":"Smart TV (2011)"}]},"SCBC":{"regex":"SCBC[;,]","device":"tv","models":[{"regex":"SCBC586","model":"SCBC586"},{"regex":"43D1850","model":"43D1850"}]},"SEG":{"regex":"SEG[;,]","device":"tv","model":""},"Selevision":{"regex":"Selevision","device":"tv","models":[{"regex":"Selevision; (?:Selevision )?([^);/]+)","model":"$1"},{"regex":"(EMC1000i)","model":"$1"}]},"Sharp":{"regex":"(?:UMC-)?Sharp","device":"tv","models":[{"regex":"Sharp[,;] ?((?! |HbbTV)[^),;/]+)","model":"$1"},{"regex":"(LE[0-9]{3}[A-Z]{0,3})","model":"$1"},{"regex":"LC-([^);/]+)","model":"LC-$1"},{"regex":"BLA-43","model":"BLA-43"}]},"Skyworth":{"regex":"Sky_worth","device":"tv","models":[{"regex":"Sky_worth;([^);/]+)","model":"$1"}]},"Smart":{"regex":"Smart[;,]","device":"tv","models":[{"regex":"Smart; ([^);/]+)","model":"$1"},{"regex":"([A-Z]{2}[0-9]{2}|ZAPPIX)","model":"$1"}]},"Sony":{"regex":"Sony","device":"tv","models":[{"regex":"KDL-GR1","model":"KDL-GR1"},{"regex":"KDL-GN([56])","model":"KDL-GN$1"},{"regex":"BRAVIA (VH1|4K VH2)","model":"BRAVIA $1"},{"regex":"(KDL?-?[0-9]{2}[A-Z]{1}[0-9]{4}[A-Z]{1})","model":"$1"},{"regex":"(KDL?-?[0-9]{2}[A-Z]{1}[0-9]{3}[A-Z]{1})","model":"$1"},{"regex":"(KDL?-?[0-9]{2}[A-Z]{1,2}[0-9]{1,5})","model":"$1"}]},"SWTV":{"regex":"SWTV[;,]","device":"tv","models":[{"regex":"SKWE20E21","model":"SKWE20E21"}]},"TD Systems":{"regex":"TDSystems[;,]","device":"tv","models":[{"regex":"SmartTV(2019|2020)","model":"Smart TV ($1)"}]},"Technicolor":{"regex":"Technicolor","device":"tv","models":[{"regex":"uzw4054ttg","model":"UZW4054TTG"}]},"Technika":{"regex":"TECHNIKA[;,]","device":"tv","model":""},"TechniSat":{"regex":"TechniSat","device":"tv","models":[{"regex":"((DigiCorder|MultyVision|Digit) (ISIO S|ISIO C|ISIO))","model":"$1"}]},"TechnoTrend":{"regex":"TechnoTrend","device":"tv","models":[{"regex":"([A-Z]{1}-[0-9]{3})","model":"$1"}]},"Techwood":{"regex":"Techwood[;,]","device":"tv","model":""},"Telefunken":{"regex":"Telefunken","device":"tv","model":""},"TCL":{"regex":"TCL","device":"tv","models":[{"regex":"(32D1820|(?:39|55)D2900|32D2930|(?:32|43)S4900)","model":"$1"}]},"Thomson":{"regex":"THOMSON[,]?|THOM","device":"tv","models":[{"regex":"(TB28D19DHS-01|T28D18SFS-01B)","model":"$1 28.0\\""},{"regex":"(T32RTM5040|T32D18SFS-01B)","model":"$1 32.0\\""},{"regex":"(T43FSL5031|T43D18SFS-01B)","model":"$1 43.0\\""},{"regex":"(T40D18SFS-01B)","model":"$1 40.0\\""},{"regex":"(T49D18SFS-01B)","model":"$1 49.0\\""},{"regex":"(T55D18[SD]FS-01B)","model":"$1 55.0\\""},{"regex":"40FB5426","model":"40FB5426"}]},"TOKYO":{"regex":"TOKYO[;,]","device":"tv","models":[{"regex":"TOKTCLED32S","model":"TOKTCLED32S"}]},"Toshiba":{"regex":"Toshiba","device":"tv","models":[{"regex":"40L2600","model":"40L2600"},{"regex":"(([0-9]{2}|DTV_)[A-Z]{2}[0-9]{1,3})","model":"$1"}]},"Videoweb":{"regex":"videoweb|tv2n","device":"tv","models":[{"regex":"(tv2n)","model":"$1"},{"regex":"(videowebtv)","model":"VideoWeb TV"}]},"VOX":{"regex":"VOX[;,]","device":"tv","model":""},"WELLINGTON":{"regex":"WELLINGTON[;,]","device":"tv","model":""},"X.Vision":{"regex":"X-VISION[;,]","device":"tv","model":""},"Vestel":{"regex":"(?:Vestel.+VESTEL|VESTEL;)","device":"tv","model":""}}');

/***/ }),

/***/ 8949:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"regex":"Grid OS (\\\\d+[\\\\.\\\\d]+)","name":"GridOS","version":"$1"},{"regex":"CaixaMagica","name":"Caixa Mágica","version":""},{"regex":"Mageia; Linux","name":"Mageia","version":""},{"regex":"(?:WH|WhaleTV/)(\\\\d+[\\\\.\\\\d]+)","name":"Whale OS","version":"$1"},{"regex":"Tizen[ /]?(\\\\d+[\\\\.\\\\d]+)?","name":"Tizen","version":"$1"},{"regex":"Sailfish|Jolla","name":"Sailfish OS","version":""},{"regex":"(?:Ali)?YunOS[ /]?(\\\\d+[\\\\.\\\\d]+)?","name":"YunOS","version":"$1"},{"regex":"Windows Phone;FBSV/(\\\\d+[\\\\.\\\\d]+)","name":"Windows Phone","version":"$1"},{"regex":"(?:Windows Phone (?:OS)?|wds)[ /]?(\\\\d+[\\\\.\\\\d]+)","name":"Windows Phone","version":"$1"},{"regex":"XBLWP7|Windows Phone","name":"Windows Phone","version":""},{"regex":"Windows CE(?: (\\\\d+[\\\\.\\\\d]+))?","name":"Windows CE","version":"$1"},{"regex":"(?:IEMobile|Windows ?Mobile)(?: (\\\\d+[\\\\.\\\\d]+))?","name":"Windows Mobile","version":"$1"},{"regex":"Windows NT 6.2; ARM;","name":"Windows RT","version":""},{"regex":"Windows NT 6.3; ARM;","name":"Windows RT","version":"8.1"},{"regex":"Windows IoT 10.0","name":"Windows IoT","version":"10"},{"regex":"KAIOS(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"KaiOS","version":"$1"},{"regex":"RazoDroiD(?: v(\\\\d+[\\\\.\\\\d]*))?","name":"RazoDroiD","version":"$1"},{"regex":"MildWild(?: CM-(\\\\d+[\\\\.\\\\d]*))?","name":"MildWild","version":"$1"},{"regex":"CyanogenMod(?:[\\\\-/](?:CM)?(\\\\d+[\\\\.\\\\d]*))?","name":"CyanogenMod","version":"$1"},{"regex":"(?:.*_)?MocorDroid(?:(\\\\d+[\\\\.\\\\d]*))?","name":"MocorDroid","version":"$1"},{"regex":"Fire OS(?:/(\\\\d+[\\\\.\\\\d]*))?","name":"Fire OS","version":"$1"},{"regex":"AFTSO001","name":"Fire OS","version":"7"},{"regex":"FydeOS","name":"FydeOS","version":""},{"regex":"(?:Podbean|Podimo)(?:.+)?/Android","name":"Android","version":""},{"regex":"Pinterest for Android/.+; (\\\\d(?:[\\\\d\\\\.]+)?)\\\\)$","name":"Android","version":"$1"},{"regex":"Android; (\\\\d+[\\\\.\\\\d]*); Mobile;","name":"Android","version":"$1"},{"regex":"[ ]([\\\\d\\\\.]+)\\\\) AppleWebKit.*ROBLOX Android App","name":"Android","version":"$1"},{"regex":"(?:(?:Orca-)?Android|Adr)[ /]?(?:[a-z]+ )?(\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"(?:Allview_TX1_Quasar|Cosmote_My_mini_Tab) (\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"Android ?(?:jelly bean|Kit Kat|S.O. Ginger Bread|The FireCyano|:) (\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"(?:Orca-Android|FB4A).*FBSV/(\\\\d+[\\\\.\\\\d]*);","name":"Android","version":"$1"},{"regex":" Adr |Android|Silk-Accelerated=[a-z]{4,5}","name":"Android","version":""},{"regex":"(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe|.+K_?Android_?TV_|Sonos/.+\\\\(ACR_","name":"Android","version":""},{"regex":"Linux; Andr0id[; ](\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"Linux; diordnA[; ](\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"AmigaOS[ ]?(\\\\d+[\\\\.\\\\d]+)","name":"AmigaOS","version":"$1"},{"regex":"AmigaOS|AmigaVoyager|Amiga-AWeb","name":"AmigaOS","version":""},{"regex":"ThreadX(?:/(\\\\d+[\\\\.\\\\d]*))?","name":"ThreadX","version":"$1"},{"regex":"Nucleus(?:(?: |/v?)(\\\\d+[\\\\.\\\\d]*))?","name":"MTK / Nucleus","version":"$1"},{"regex":"MTK(?:(?: |/v?)(\\\\d+[\\\\.\\\\d]*))?","name":"MTK / Nucleus","version":"$1"},{"regex":"MRE/(\\\\d+)\\\\.(\\\\d+).*;MAUI","name":"MRE","version":"$1.$2"},{"regex":"dvkbuntu","name":"DVKBuntu","version":""},{"regex":"Helio/(\\\\d+[\\\\.\\\\d]+)","name":"Lumin OS","version":"$1"},{"regex":"HasCodingOs (\\\\d+[\\\\.\\\\d]+)","name":"HasCodingOS","version":"$1"},{"regex":"PCLinuxOS/(\\\\d+[\\\\.\\\\d]+)","name":"PCLinuxOS","version":"$1"},{"regex":"(Ordissimo|webissimo3)","name":"Ordissimo","version":""},{"regex":"(?:Win|Sistema )Fenix","name":"Fenix","version":""},{"regex":"TOS; Linux","name":"TmaxOS","version":""},{"regex":"Maemo","name":"Maemo","version":""},{"regex":"Arch ?Linux(?:[ /\\\\-](\\\\d+[\\\\.\\\\d]+))?","name":"Arch Linux","version":"$1"},{"regex":"VectorLinux(?: package)?(?:[ /\\\\-](\\\\d+[\\\\.\\\\d]+))?","name":"VectorLinux","version":"$1"},{"regex":"Linux; .*((?:Debian|Knoppix|Mint|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack))[ /](\\\\d+[\\\\.\\\\d]+)","name":"$1","version":"$2"},{"regex":"Deepin[ /](\\\\d+[\\\\.\\\\d]+)","name":"Deepin","version":"$1"},{"regex":"(Debian|Knoppix|Mint(?! Browser)|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack|Freebox)(?:(?: Enterprise)? Linux)?(?:[ /\\\\-](\\\\d+[\\\\.\\\\d]+))?","name":"$1","version":"$2"},{"regex":"OS ROSA; Linux","name":"Rosa","version":""},{"regex":"WEBOS(\\\\d+[\\\\.\\\\d]+)","name":"webOS","version":"$1"},{"regex":"Web0S; Linux/SmartTV.+Chrome/68","name":"webOS","version":"5"},{"regex":"Web0S; Linux/SmartTV.+Chrome/53","name":"webOS","version":"4"},{"regex":"Web0S; Linux/SmartTV.+Chrome/38","name":"webOS","version":"3"},{"regex":"Web0S; Linux/SmartTV.+Safari/538","name":"webOS","version":"2"},{"regex":"Web0S; Linux/SmartTV.+Safari/537","name":"webOS","version":"1"},{"regex":"(?:Web0S; .*WEBOS|webOS|web0S|Palm webOS|hpwOS)(?:[/]?(\\\\d+[\\\\.\\\\d]+))?","name":"webOS","version":"$1"},{"regex":"(?:PalmOS|Palm OS)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?|Palm","name":"palmOS","version":"$1"},{"regex":"Xiino(?:.*v\\\\. (\\\\d+[\\\\.\\\\d]+))?","name":"palmOS","version":"$1"},{"regex":"MorphOS(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"MorphOS","version":"$1"},{"regex":"FBW.+FBSV/(\\\\d+[\\\\.\\\\d]*);","name":"Windows","version":"$1"},{"regex":"mingw32","name":"Windows","version":""},{"regex":"Windows/(\\\\d+\\\\.\\\\d+)","name":"Windows","version":"$1"},{"regex":"CYGWIN_NT-10.0|Windows NT 10.0|Windows 10","name":"Windows","version":"10"},{"regex":"CYGWIN_NT-6.4|Windows NT 6.4|Windows 10|win10","name":"Windows","version":"10"},{"regex":"CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1","name":"Windows","version":"8.1"},{"regex":"CYGWIN_NT-6.2|Windows NT 6.2|Windows 8","name":"Windows","version":"8"},{"regex":"CYGWIN_NT-6.1|Windows NT 6.1|Windows 7|win7","name":"Windows","version":"7"},{"regex":"CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista","name":"Windows","version":"Vista"},{"regex":"CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64","name":"Windows","version":"Server 2003"},{"regex":"CYGWIN_NT-5.1|Windows NT 5.1|Windows XP","name":"Windows","version":"XP"},{"regex":"CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000","name":"Windows","version":"2000"},{"regex":"CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT","name":"Windows","version":"NT"},{"regex":"CYGWIN_ME-4.90|Win 9x 4.90|Windows ME","name":"Windows","version":"ME"},{"regex":"CYGWIN_98-4.10|Win98|Windows 98","name":"Windows","version":"98"},{"regex":"CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95","name":"Windows","version":"95"},{"regex":"Windows 3.1","name":"Windows","version":"3.1"},{"regex":"Windows","name":"Windows","version":""},{"regex":"Haiku","name":"Haiku OS","version":""},{"regex":"(?:Watch1,[12]/|Watch OS,|watchOS[ /])(\\\\d+[\\\\.\\\\d]*)","name":"watchOS","version":"$1"},{"regex":"iPad/([89]|1[012]).(\\\\d+[\\\\.\\\\d]*)","name":"iOS","version":"$1.$2"},{"regex":"Pinterest for iOS/.+; (\\\\d(?:[\\\\d\\\\.]+)?)\\\\)$","name":"iOS","version":"$1"},{"regex":"CFNetwork/.+ Darwin/20.4.0(?!.*x86_64)","name":"iOS","version":"14.5"},{"regex":"CFNetwork/.+ Darwin/20.3.0(?!.*x86_64)","name":"iOS","version":"14.4"},{"regex":"CFNetwork/.+ Darwin/20.2.0(?!.*x86_64)","name":"iOS","version":"14.3"},{"regex":"CFNetwork/.+ Darwin/20.1.0(?!.*x86_64)","name":"iOS","version":"14.2"},{"regex":"CFNetwork/.+ Darwin/20.0.0(?!.*x86_64)","name":"iOS","version":"14.0"},{"regex":"CFNetwork/.+ Darwin/19.6.0(?!.*x86_64)","name":"iOS","version":"13.6"},{"regex":"CFNetwork/.+ Darwin/19.5.0(?!.*x86_64)","name":"iOS","version":"13.5"},{"regex":"CFNetwork/.+ Darwin/19.4.0(?!.*x86_64)","name":"iOS","version":"13.4"},{"regex":"CFNetwork/.+ Darwin/19.3.0(?!.*x86_64)","name":"iOS","version":"13.3.1"},{"regex":"CFNetwork/.+ Darwin/19.2.0(?!.*x86_64)","name":"iOS","version":"13.3"},{"regex":"CFNetwork/.+ Darwin/19.0.0(?!.*x86_64)","name":"iOS","version":"13.0"},{"regex":"CFNetwork/.+ Darwin/18.7.0(?!.*x86_64)","name":"iOS","version":"12.4"},{"regex":"CFNetwork/.+ Darwin/18.6.0(?!.*x86_64)","name":"iOS","version":"12.3"},{"regex":"CFNetwork/.+ Darwin/18.5.0(?!.*x86_64)","name":"iOS","version":"12.2"},{"regex":"CFNetwork/.+ Darwin/18.2.0(?!.*x86_64)","name":"iOS","version":"12.1"},{"regex":"CFNetwork/.+ Darwin/18.0.0(?!.*x86_64)","name":"iOS","version":"12.0"},{"regex":"CFNetwork/.+ Darwin/17.7.0(?!.*x86_64)","name":"iOS","version":"11.4.1"},{"regex":"CFNetwork/.+ Darwin/17.6.0(?!.*x86_64)","name":"iOS","version":"11.4"},{"regex":"CFNetwork/889(?!.*x86_64)","name":"iOS","version":"11.1"},{"regex":"CFNetwork/887(?!.*x86_64)","name":"iOS","version":"11.0"},{"regex":"CFNetwork/811(?!.*x86_64)","name":"iOS","version":"10.3"},{"regex":"CFNetwork/808\\\\.3","name":"iOS","version":"10.3"},{"regex":"CFNetwork/808\\\\.2","name":"iOS","version":"10.2"},{"regex":"CFNetwork/808\\\\.1","name":"iOS","version":"10.1"},{"regex":"CFNetwork/808\\\\.0","name":"iOS","version":"10.0"},{"regex":"CFNetwork/808","name":"iOS","version":"10"},{"regex":"CFNetwork/758\\\\.4\\\\.3","name":"iOS","version":"9.3.2"},{"regex":"CFNetwork/758\\\\.3\\\\.15","name":"iOS","version":"9.3"},{"regex":"CFNetwork/758\\\\.2\\\\.[78]","name":"iOS","version":"9.2"},{"regex":"CFNetwork/758\\\\.1\\\\.6","name":"iOS","version":"9.1"},{"regex":"CFNetwork/758\\\\.0\\\\.2","name":"iOS","version":"9.0"},{"regex":"CFNetwork/711\\\\.5\\\\.6","name":"iOS","version":"8.4.1"},{"regex":"CFNetwork/711\\\\.4\\\\.6","name":"iOS","version":"8.4"},{"regex":"CFNetwork/711\\\\.3\\\\.18","name":"iOS","version":"8.3"},{"regex":"CFNetwork/711\\\\.2\\\\.23","name":"iOS","version":"8.2"},{"regex":"CFNetwork/711\\\\.1\\\\.1[26]","name":"iOS","version":"8.1"},{"regex":"CFNetwork/711\\\\.0\\\\.6","name":"iOS","version":"8.0"},{"regex":"CFNetwork/672\\\\.1","name":"iOS","version":"7.1"},{"regex":"CFNetwork/672\\\\.0","name":"iOS","version":"7.0"},{"regex":"CFNetwork/609\\\\.1","name":"iOS","version":"6.1"},{"regex":"CFNetwork/60[29]","name":"iOS","version":"6.0"},{"regex":"CFNetwork/548\\\\.1","name":"iOS","version":"5.1"},{"regex":"CFNetwork/548\\\\.0","name":"iOS","version":"5.0"},{"regex":"CFNetwork/485\\\\.13","name":"iOS","version":"4.3"},{"regex":"CFNetwork/485\\\\.12","name":"iOS","version":"4.2"},{"regex":"CFNetwork/485\\\\.10","name":"iOS","version":"4.1"},{"regex":"CFNetwork/485\\\\.2","name":"iOS","version":"4.0"},{"regex":"CFNetwork/467\\\\.12","name":"iOS","version":"3.2"},{"regex":"CFNetwork/459","name":"iOS","version":"3.1"},{"regex":"iPhone/(\\\\d+[\\\\.\\\\d]*) hw/","name":"iOS","version":"$1"},{"regex":"iOS(\\\\d+\\\\.\\\\d+\\\\.\\\\d+)","name":"iOS","version":"$1"},{"regex":"iOS(\\\\d+)\\\\.(\\\\d+)0","name":"iOS","version":"$1.$2"},{"regex":"iPhone OS ([0-9]{1})([0-9]{1})([0-9]{1})","name":"iOS","version":"$1.$2.$3"},{"regex":"(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\\\d+(?:[_\\\\.]\\\\d+)*)","name":"iOS","version":"$1"},{"regex":"(?:FBIOS|Messenger(?:Lite)?ForiOS).*FBSV/ ?(\\\\d+[\\\\.\\\\d]*);","name":"iOS","version":"$1"},{"regex":"(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\\\d+\\\\.\\\\d+)|; Opera)?","name":"iOS","version":"$1"},{"regex":"(?:Podcasts/(?:[\\\\d\\\\.]+)|Instacast(?:HD)?/(?:\\\\d\\\\.[\\\\d\\\\.abc]+)|Pocket Casts, iOS|\\\\(iOS\\\\)|iOS; Opera|Overcast|Castro|Podcat|iCatcher|RSSRadio/|MobileSafari/)(?!.*x86_64)","name":"iOS","version":""},{"regex":"iTunes-(iPod|iPad|iPhone)/(?:[\\\\d\\\\.]+)","name":"iOS","version":""},{"regex":"iOS/Version ([\\\\d\\\\.]+)","name":"iOS","version":"$1"},{"regex":"Sonos/.+\\\\(ICRU_","name":"iOS","version":""},{"regex":"CFNetwork/.+ Darwin/20.2.0.*(x86_64)|(x86_64-apple-)?darwin20.2.0","name":"Mac","version":"11.1"},{"regex":"CFNetwork/.+ Darwin/20.[01].0.*(x86_64)|(x86_64-apple-)?darwin20.[01].0","name":"Mac","version":"11.0"},{"regex":"CFNetwork/.+ Darwin/19.6.0.*(x86_64)|(x86_64-apple-)?darwin19.6.0","name":"Mac","version":"10.15.6"},{"regex":"CFNetwork/.+ Darwin/19.5.0.*(x86_64)|(x86_64-apple-)?darwin19.5.0","name":"Mac","version":"10.15.5"},{"regex":"CFNetwork/.+ Darwin/19.4.0.*(x86_64)|(x86_64-apple-)?darwin19.4.0","name":"Mac","version":"10.15.4"},{"regex":"CFNetwork/.+ Darwin/19.3.0.*(x86_64)|(x86_64-apple-)?darwin19.3.0","name":"Mac","version":"10.15.3"},{"regex":"CFNetwork/.+ Darwin/19.2.0.*(x86_64)|(x86_64-apple-)?darwin19.2.0","name":"Mac","version":"10.15.2"},{"regex":"CFNetwork/(?:108[258]|109[18]|1103).*(x86_64)","name":"Mac","version":"10.15"},{"regex":"CFNetwork/.+ Darwin/18.2.0.*(x86_64)|(x86_64-apple-)?darwin18.2.0","name":"Mac","version":"10.14.1"},{"regex":"CFNetwork/(?:96[29]|97[14568]).*(x86_64)","name":"Mac","version":"10.14"},{"regex":"CFNetwork/.+ Darwin/17.7.0.*(x86_64)|(x86_64-apple-)?darwin17.7.0","name":"Mac","version":"10.13.6"},{"regex":"CFNetwork/.+ Darwin/17.6.0.*(x86_64)|(x86_64-apple-)?darwin17.6.0","name":"Mac","version":"10.13.5"},{"regex":"CFNetwork/.+ Darwin/17.5.0.*(x86_64)|(x86_64-apple-)?darwin17.5.0","name":"Mac","version":"10.13.4"},{"regex":"CFNetwork/.+ Darwin/17.4.0.*(x86_64)|(x86_64-apple-)?darwin17.4.0","name":"Mac","version":"10.13.3"},{"regex":"CFNetwork/.+ Darwin/17.3.0.*(x86_64)|(x86_64-apple-)?darwin17.3.0","name":"Mac","version":"10.13.2"},{"regex":"CFNetwork/.+ Darwin/17.2.0.*(x86_64)|(x86_64-apple-)?darwin17.2.0","name":"Mac","version":"10.13.1"},{"regex":"CFNetwork/(?:887|889|893|897|901|902).*(x86_64)","name":"Mac","version":"10.13"},{"regex":"CFNetwork/.+ Darwin/16.7.0.*(x86_64)|(x86_64-apple-)?darwin16.7.0","name":"Mac","version":"10.12.6"},{"regex":"CFNetwork/.+ Darwin/16.6.0.*(x86_64)|(x86_64-apple-)?darwin16.6.0","name":"Mac","version":"10.12.5"},{"regex":"CFNetwork/.+ Darwin/16.5.0.*(x86_64)|(x86_64-apple-)?darwin16.5.0","name":"Mac","version":"10.12.4"},{"regex":"CFNetwork/.+ Darwin/16.3.0.*(x86_64)|(x86_64-apple-)?darwin16.3.0","name":"Mac","version":"10.12.3"},{"regex":"CFNetwork/.+ Darwin/16.2.0.*(x86_64)|(x86_64-apple-)?darwin16.2.0","name":"Mac","version":"10.12.2"},{"regex":"CFNetwork/.+ Darwin/16.1.0.*(x86_64)|(x86_64-apple-)?darwin16.1.0","name":"Mac","version":"10.12.1"},{"regex":"CFNetwork/811.*(x86_64)","name":"Mac","version":"10.12"},{"regex":"CFNetwork/807","name":"Mac","version":"10.12"},{"regex":"CFNetwork/.+ Darwin/15.6.0.*(x86_64)|(x86_64-apple-)?darwin15.6.0","name":"Mac","version":"10.11.6"},{"regex":"CFNetwork/.+ Darwin/15.5.0.*(x86_64)|(x86_64-apple-)?darwin15.5.0","name":"Mac","version":"10.11.5"},{"regex":"CFNetwork/.+ Darwin/15.4.0.*(x86_64)|(x86_64-apple-)?darwin15.4.0","name":"Mac","version":"10.11.4"},{"regex":"CFNetwork/.+ Darwin/15.3.0.*(x86_64)|(x86_64-apple-)?darwin15.3.0","name":"Mac","version":"10.11.3"},{"regex":"CFNetwork/.+ Darwin/15.2.0.*(x86_64)|(x86_64-apple-)?darwin15.2.0","name":"Mac","version":"10.11.2"},{"regex":"CFNetwork/760","name":"Mac","version":"10.11"},{"regex":"CFNetwork/.+ Darwin/14.5.0.*(x86_64)|(x86_64-apple-)?darwin14.5.0","name":"Mac","version":"10.10.5"},{"regex":"CFNetwork/.+ Darwin/14.4.0.*(x86_64)|(x86_64-apple-)?darwin14.4.0","name":"Mac","version":"10.10.4"},{"regex":"CFNetwork/.+ Darwin/14.3.0.*(x86_64)|(x86_64-apple-)?darwin14.3.0","name":"Mac","version":"10.10.3"},{"regex":"CFNetwork/.+ Darwin/14.1.0.*(x86_64)|(x86_64-apple-)?darwin14.1.0","name":"Mac","version":"10.10.2"},{"regex":"CFNetwork/720","name":"Mac","version":"10.10"},{"regex":"CFNetwork/.+ Darwin/13.4.0.*(x86_64)|(x86_64-apple-)?darwin13.4.0","name":"Mac","version":"10.9.5"},{"regex":"CFNetwork/.+ Darwin/13.3.0.*(x86_64)|(x86_64-apple-)?darwin13.3.0","name":"Mac","version":"10.9.4"},{"regex":"CFNetwork/.+ Darwin/13.2.0.*(x86_64)|(x86_64-apple-)?darwin13.2.0","name":"Mac","version":"10.9.3"},{"regex":"CFNetwork/.+ Darwin/13.1.0.*(x86_64)|(x86_64-apple-)?darwin13.1.0","name":"Mac","version":"10.9.2"},{"regex":"CFNetwork/673","name":"Mac","version":"10.9"},{"regex":"CFNetwork/.+ Darwin/12.5.0.*(x86_64)|(x86_64-apple-)?darwin12.5.0","name":"Mac","version":"10.8.5"},{"regex":"CFNetwork/.+ Darwin/12.4.0.*(x86_64)|(x86_64-apple-)?darwin12.4.0","name":"Mac","version":"10.8.4"},{"regex":"CFNetwork/.+ Darwin/12.3.0.*(x86_64)|(x86_64-apple-)?darwin12.3.0","name":"Mac","version":"10.8.3"},{"regex":"CFNetwork/.+ Darwin/12.2.0.*(x86_64)|(x86_64-apple-)?darwin12.2.0","name":"Mac","version":"10.8.2"},{"regex":"CFNetwork/.+ Darwin/12.1.0.*(x86_64)|(x86_64-apple-)?darwin12.1.0","name":"Mac","version":"10.8.1"},{"regex":"CFNetwork/596","name":"Mac","version":"10.8"},{"regex":"CFNetwork/.+ Darwin/11.5.0.*(x86_64)|(x86_64-apple-)?darwin11.5.0","name":"Mac","version":"10.7.5"},{"regex":"CFNetwork/.+ Darwin/11.4.0.*(x86_64)|(x86_64-apple-)?darwin11.4.0","name":"Mac","version":"10.7.4"},{"regex":"CFNetwork/.+ Darwin/11.3.0.*(x86_64)|(x86_64-apple-)?darwin11.3.0","name":"Mac","version":"10.7.3"},{"regex":"CFNetwork/.+ Darwin/11.2.0.*(x86_64)|(x86_64-apple-)?darwin11.2.0","name":"Mac","version":"10.7.2"},{"regex":"CFNetwork/.+ Darwin/11.1.0.*(x86_64)|(x86_64-apple-)?darwin11.1.0","name":"Mac","version":"10.7.1"},{"regex":"CFNetwork/520","name":"Mac","version":"10.7"},{"regex":"CFNetwork/454","name":"Mac","version":"10.6"},{"regex":"CFNetwork/(?:438|422|339|330|221|220|217)","name":"Mac","version":"10.5"},{"regex":"CFNetwork/12[89]","name":"Mac","version":"10.4"},{"regex":"CFNetwork/1\\\\.2","name":"Mac","version":"10.3"},{"regex":"CFNetwork/1\\\\.1","name":"Mac","version":"10.2"},{"regex":"Mac[ +]OS[ +]?X(?:[ /](?:Version )?(\\\\d+(?:[_\\\\.]\\\\d+)+))?","name":"Mac","version":"$1"},{"regex":"Mac (?:OS/)?(\\\\d+(?:[_\\\\.]\\\\d+)+)","name":"Mac","version":"$1"},{"regex":"macOS/(\\\\d+[\\\\.\\\\d]+)","name":"Mac","version":"$1"},{"regex":"Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook|macOS|Sonos/.+\\\\(MDCR_","name":"Mac","version":""},{"regex":"SeewoOS x86_64 (\\\\d+[\\\\.\\\\d]+)","name":"SeewoOS","version":"$1"},{"regex":"CrOS [a-z0-9_]+ .* Chrome/(\\\\d+[\\\\.\\\\d]+)","name":"Chrome OS","version":"$1"},{"regex":"(?:BB10;.+Version|Black[Bb]erry[0-9a-z]+|Black[Bb]erry.+Version)/(\\\\d+[\\\\.\\\\d]+)","name":"BlackBerry OS","version":"$1"},{"regex":"RIM Tablet OS (\\\\d+[\\\\.\\\\d]+)","name":"BlackBerry Tablet OS","version":"$1"},{"regex":"RIM Tablet OS|QNX|Play[Bb]ook","name":"BlackBerry Tablet OS","version":""},{"regex":"BlackBerry","name":"BlackBerry OS","version":""},{"regex":"bPod","name":"BlackBerry OS","version":""},{"regex":"BeOS","name":"BeOS","version":""},{"regex":"Symbian/3.+NokiaBrowser/7\\\\.3","name":"Symbian^3","version":"Anna"},{"regex":"Symbian/3.+NokiaBrowser/7\\\\.4","name":"Symbian^3","version":"Belle"},{"regex":"Symbian/3","name":"Symbian^3","version":""},{"regex":"(?:Series ?60|SymbOS|S60)(?:[ /]?(\\\\d+[\\\\.\\\\d]+|V\\\\d+))?","name":"Symbian OS Series 60","version":"$1"},{"regex":"Series40","name":"Symbian OS Series 40","version":""},{"regex":"SymbianOS/(\\\\d+[\\\\.\\\\d]+)","name":"Symbian OS","version":"$1"},{"regex":"MeeGo|WeTab","name":"MeeGo","version":""},{"regex":"Symbian(?: OS)?|SymbOS","name":"Symbian OS","version":""},{"regex":"Nokia","name":"Symbian","version":""},{"regex":"(?:Mobile|Tablet);.+Firefox/\\\\d+\\\\.\\\\d+","name":"Firefox OS","version":""},{"regex":"RISC OS(?:-NC)?(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"RISC OS","version":"$1"},{"regex":"Inferno(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Inferno","version":"$1"},{"regex":"bada(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Bada","version":"$1"},{"regex":"(?:Brew(?!-Applet)(?: MP)?|BMP)(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Brew","version":"$1"},{"regex":"GoogleTV(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Google TV","version":"$1"},{"regex":"AppleTV(?:/?(\\\\d+[\\\\.\\\\d]+))?","name":"Apple TV","version":"$1"},{"regex":"WebTV/(\\\\d+[\\\\.\\\\d]+)","name":"WebTV","version":"$1"},{"regex":"RemixOS 5.1.1","name":"Remix OS","version":"1"},{"regex":"RemixOS 6.0","name":"Remix OS","version":"2"},{"regex":"RemixOS","name":"Remix OS","version":""},{"regex":"(?:SunOS|Solaris)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Solaris","version":"$1"},{"regex":"AIX(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"AIX","version":"$1"},{"regex":"HP-UX(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"HP-UX","version":"$1"},{"regex":"FreeBSD(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"FreeBSD","version":"$1"},{"regex":"NetBSD(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"NetBSD","version":"$1"},{"regex":"OpenBSD(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"OpenBSD","version":"$1"},{"regex":"DragonFly(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"DragonFly","version":"$1"},{"regex":"Syllable(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"Syllable","version":"$1"},{"regex":"IRIX(?:;64)?(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))","name":"IRIX","version":"$1"},{"regex":"OSF1(?:[/ ]?v?(\\\\d+[\\\\.\\\\d]+))?","name":"OSF1","version":"$1"},{"regex":"Nintendo (Wii|Switch)","name":"Nintendo","version":"$1"},{"regex":"PlayStation ?([34])","name":"PlayStation","version":"$1"},{"regex":"Xbox|KIN\\\\.(?:One|Two)","name":"Xbox","version":"360"},{"regex":"Nitro|Nintendo ([3]?DS[i]?)","name":"Nintendo Mobile","version":"$1"},{"regex":"PlayStation ((?:Portable|Vita))","name":"PlayStation Portable","version":"$1"},{"regex":"OS/2","name":"OS/2","version":""},{"regex":"Linux(?:OS)?[^a-z]","name":"GNU/Linux","version":""}]');

/***/ }),

/***/ 69806:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Dell":["MDDR(JS)?","MDDC(JS)?","MDDS(JS)?"],"Acer":["MAAR(JS)?"],"Sony":["MASE(JS)?","MASP(JS)?","MASA(JS)?"],"Asus":["MAAU","NP0[26789]","ASJB","ASU2(JS)?"],"Samsung":["MASM(JS)?","SMJB"],"Lenovo":["MALC(JS)?","MALE(JS)?","MALN(JS)?","LCJB","LEN2"],"Toshiba":["MATM(JS)?","MATB(JS)?","MATP(JS)?","TNJB","TAJB"],"Medion":["MAMD"],"MSI":["MAMI(JS)?","MAM3"],"Gateway":["MAGW(JS)?"],"Fujitsu":["MAFS(JS)?","FSJB"],"Compaq":["CPDTDF","CPNTDF(JS?)","CMNTDF(JS)?","CMDTDF(JS)?"],"HP":["HPCMHP","HPNTDF(JS)?","HPDTDF(JS)?"],"Hyrican":["MANM(JS)?"],"Ordissimo":["Ordissimo","webissimo3"]}');

/***/ }),

/***/ 43005:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"36":"360 Phone Browser","1B":"115 Browser","2B":"2345 Browser","3B":"360 Browser","7B":"7654 Browser","AA":"Avant Browser","AB":"ABrowse","AF":"ANT Fresco","AG":"ANTGalio","AL":"Aloha Browser","AH":"Aloha Browser Lite","AM":"Amaya","AO":"Amigo","AN":"Android Browser","AE":"AOL Desktop","AD":"AOL Shield","AR":"Arora","AX":"Arctic Fox","AV":"Amiga Voyager","AW":"Amiga Aweb","A0":"Atom","AT":"Atomic Web Browser","AS":"Avast Secure Browser","VG":"AVG Secure Browser","AC":"Avira Scout","A1":"AwoX","BA":"Beaker Browser","BM":"Beamrise","BB":"BlackBerry Browser","BD":"Baidu Browser","BS":"Baidu Spark","BI":"Basilisk","BE":"Beonex","BH":"BlackHawk","BJ":"Bunjalloo","BL":"B-Line","BU":"Blue Browser","BN":"Borealis Navigator","BR":"Brave","BK":"BriskBard","BX":"BrowseX","BZ":"Browzar","BY":"Biyubi","BF":"Byffox","CA":"Camino","CL":"CCleaner","C6":"Chedot","C0":"Centaury","CC":"Coc Coc","C4":"CoolBrowser","C2":"Colibri","CD":"Comodo Dragon","C1":"Coast","CX":"Charon","CE":"CM Browser","CF":"Chrome Frame","HC":"Headless Chrome","CH":"Chrome","CI":"Chrome Mobile iOS","CK":"Conkeror","CM":"Chrome Mobile","CN":"CoolNovo","CO":"CometBird","CB":"COS Browser","CW":"Cornowser","C3":"Chim Lac","CP":"ChromePlus","CR":"Chromium","C5":"Chromium GOST","CY":"Cyberfox","CS":"Cheshire","CT":"Crusta","CG":"Craving Explorer","CZ":"Crazy Browser","CU":"Cunaguaro","CV":"Chrome Webview","DB":"dbrowser","DE":"Deepnet Explorer","DG":"deg-degan","DA":"Deledao","DT":"Delta Browser","DS":"DeskBrowse","DF":"Dolphin","DO":"Dorado","DR":"Dot Browser","DL":"Dooble","DI":"Dillo","DD":"DuckDuckGo Privacy Browser","EC":"Ecosia","EI":"Epic","EL":"Elinks","EB":"Element Browser","EE":"Elements Browser","EZ":"eZ Browser","EU":"EUI Browser","EP":"GNOME Web","ES":"Espial TV Browser","FA":"Falkon","FX":"Faux Browser","F1":"Firefox Mobile iOS","FB":"Firebird","FD":"Fluid","FE":"Fennec","FF":"Firefox","FK":"Firefox Focus","FY":"Firefox Reality","FR":"Firefox Rocket","FL":"Flock","FO":"Flow","FM":"Firefox Mobile","FW":"Fireweb","FN":"Fireweb Navigator","FS":"Flast","FU":"FreeU","GA":"Galeon","GH":"Ghostery Privacy Browser","GI":"GinxDroid Browser","GB":"Glass Browser","GE":"Google Earth","GO":"GOG Galaxy","HS":"HasBrowser","HA":"Hawk Turbo Browser","HE":"Helio","HO":"hola! Browser","HJ":"HotJava","HU":"Huawei Browser","IB":"IBrowse","IC":"iCab","I2":"iCab Mobile","I1":"Iridium","I3":"Iron Mobile","I4":"IceCat","ID":"IceDragon","IV":"Isivioo","IW":"Iceweasel","IE":"Internet Explorer","IM":"IE Mobile","IR":"Iron","JB":"Japan Browser","JS":"Jasmine","JA":"JavaFX","JI":"Jig Browser","JP":"Jig Browser Plus","JO":"Jio Browser","KB":"K.Browser","KI":"Kindle Browser","KM":"K-meleon","KO":"Konqueror","KP":"Kapiko","KN":"Kinza","KW":"Kiwi","KD":"Kode Browser","KY":"Kylo","KZ":"Kazehakase","LB":"Cheetah Browser","LF":"LieBaoFast","LG":"LG Browser","LH":"Light","LI":"Links","IF":"Lolifox","LO":"Lovense Browser","LU":"LuaKit","LL":"Lulumi","LS":"Lunascape","LN":"Lunascape Lite","LX":"Lynx","M1":"mCent","MB":"MicroB","MC":"NCSA Mosaic","MZ":"Meizu Browser","ME":"Mercury","MF":"Mobile Safari","MI":"Midori","MO":"Mobicip","MU":"MIUI Browser","MS":"Mobile Silk","MN":"Minimo","MT":"Mint Browser","MX":"Maxthon","NM":"MxNitro","MY":"Mypal","MR":"Monument Browser","MW":"MAUI WAP Browser","NW":"Navigateur Web","NR":"NFS Browser","NB":"Nokia Browser","NO":"Nokia OSS Browser","NV":"Nokia Ovi Browser","NX":"Nox Browser","NE":"NetSurf","NF":"NetFront","NL":"NetFront Life","NP":"NetPositive","NS":"Netscape","NT":"NTENT Browser","OC":"Oculus Browser","O1":"Opera Mini iOS","OB":"Obigo","O2":"Odin","H2":"OceanHero","OD":"Odyssey Web Browser","OF":"Off By One","HH":"OhHai Browser","OE":"ONE Browser","OX":"Opera GX","OG":"Opera Neon","OH":"Opera Devices","OI":"Opera Mini","OM":"Opera Mobile","OP":"Opera","ON":"Opera Next","OO":"Opera Touch","OA":"Orca","OS":"Ordissimo","OR":"Oregano","O0":"Origin In-Game Overlay","OY":"Origyn Web Browser","OV":"Openwave Mobile Browser","OW":"OmniWeb","OT":"Otter Browser","PL":"Palm Blazer","PM":"Pale Moon","PY":"Polypane","PP":"Oppo Browser","PR":"Palm Pre","PU":"Puffin","PW":"Palm WebPro","PA":"Palmscape","PE":"Perfect Browser","PH":"Phantom Browser","PX":"Phoenix","PB":"Phoenix Browser","PF":"PlayFree Browser","PO":"Polaris","PT":"Polarity","LY":"PolyBrowser","PI":"PrivacyWall","PS":"Microsoft Edge","QA":"Qazweb","Q2":"QQ Browser Lite","Q1":"QQ Browser Mini","QQ":"QQ Browser","QT":"Qutebrowser","QU":"Quark","QZ":"QupZilla","QM":"Qwant Mobile","QW":"QtWebEngine","RE":"Realme Browser","RK":"Rekonq","RM":"RockMelt","SB":"Samsung Browser","SA":"Sailfish Browser","S8":"Seewo Browser","SC":"SEMC-Browser","SE":"Sogou Explorer","SF":"Safari","S5":"Safe Exam Browser","SW":"SalamWeb","SV":"SFive","SH":"Shiira","S1":"SimpleBrowser","SY":"Sizzy","SK":"Skyfire","SS":"Seraphic Sraf","SL":"Sleipnir","S6":"Slimjet","S7":"SP Browser","7S":"7Star","LE":"Smart Lenovo Browser","OZ":"Smooz","SN":"Snowshoe","SO":"Sogou Mobile Browser","S2":"Splash","SI":"Sputnik Browser","SR":"Sunrise","SP":"SuperBird","SU":"Super Fast Browser","S3":"surf","SG":"Stargon","S0":"START Internet Browser","S4":"Steam In-Game Overlay","ST":"Streamy","SX":"Swiftfox","SZ":"Seznam Browser","TR":"T-Browser","TO":"t-online.de Browser","TA":"Tao Browser","TF":"TenFourFox","TB":"Tenta Browser","TZ":"Tizen Browser","TU":"Tungsten","TG":"ToGate","TS":"TweakStyle","TV":"TV Bro","UB":"UBrowser","UC":"UC Browser","UH":"UC Browser HD","UM":"UC Browser Mini","UT":"UC Browser Turbo","UR":"UR Browser","UZ":"Uzbl","VE":"Venus Browser","VI":"Vivaldi","VV":"vivo Browser","VB":"Vision Mobile Browser","VM":"VMware AirWatch","WI":"Wear Internet Browser","WP":"Web Explorer","WE":"WebPositive","WF":"Waterfox","WH":"Whale Browser","WO":"wOSBrowser","WT":"WeTab Browser","YJ":"Yahoo! Japan Browser","YA":"Yandex Browser","YL":"Yandex Browser Lite","YN":"Yaani Browser","YB":"Yolo Browser","XS":"xStand","XI":"Xiino","XV":"Xvast","ZE":"Zetakey","ZV":"Zvu"}');

/***/ }),

/***/ 56643:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["36","OC","PU","SK","MF","OI","OM","DD","DB","ST","BL","IV","FM","C1","C4","SA","SB","FR","WP","HA","NX","HU","VV","RE","CB","MZ","UM","FK","FX","WI","MN","M1","AH","SU","EU","EZ","UT","DT","S0","QU","YN","JB","GH","PI","SG","KD","PE","UH","S7","CW","OZ","GI","VE"]');

/***/ }),

/***/ 26622:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"operatingSystem":{"AIX":"AIX","AND":"Android","AMG":"AmigaOS","ATV":"Apple TV","ARL":"Arch Linux","BTR":"BackTrack","SBA":"Bada","BEO":"BeOS","BLB":"BlackBerry OS","QNX":"BlackBerry Tablet OS","BMP":"Brew","CES":"CentOS","COS":"Chrome OS","CYN":"CyanogenMod","DEB":"Debian","DEE":"Deepin","DFB":"DragonFly","FED":"Fedora","FOS":"Firefox OS","FIR":"Fire OS","FRE":"Freebox","BSD":"FreeBSD","FYD":"FydeOS","GNT":"Gentoo","GTV":"Google TV","HPX":"HP-UX","HAI":"Haiku OS","IRI":"IRIX","INF":"Inferno","KOS":"KaiOS","KNO":"Knoppix","KBT":"Kubuntu","LIN":"GNU/Linux","LBT":"Lubuntu","VLN":"VectorLinux","MAC":"Mac","MAE":"Maemo","MDR":"Mandriva","SMG":"MeeGo","MCD":"MocorDroid","MIN":"Mint","MLD":"MildWild","MOR":"MorphOS","NBS":"NetBSD","MTK":"MTK / Nucleus","MRE":"MRE","WII":"Nintendo","NDS":"Nintendo Mobile","OS2":"OS/2","T64":"OSF1","OBS":"OpenBSD","ORD":"Ordissimo","PSP":"PlayStation Portable","PS3":"PlayStation","RHT":"Red Hat","ROS":"RISC OS","RSO":"Rosa","REM":"Remix OS","RZD":"RazoDroiD","SAB":"Sabayon","SSE":"SUSE","SAF":"Sailfish OS","SEE":"SeewoOS","SLW":"Slackware","SOS":"Solaris","SYL":"Syllable","SYM":"Symbian","SYS":"Symbian OS","S40":"Symbian OS Series 40","S60":"Symbian OS Series 60","SY3":"Symbian^3","TDX":"ThreadX","TIZ":"Tizen","TOS":"TmaxOS","UBT":"Ubuntu","WAS":"watchOS","WTV":"WebTV","WHS":"Whale OS","WIN":"Windows","WCE":"Windows CE","WIO":"Windows IoT","WMO":"Windows Mobile","WPH":"Windows Phone","WRT":"Windows RT","XBX":"Xbox","XBT":"Xubuntu","YNS":"YunOs","IOS":"iOS","POS":"palmOS","WOS":"webOS"},"osFamilies":{"Android":["AND","CYN","FIR","REM","RZD","MLD","MCD","YNS"],"AmigaOS":["AMG","MOR"],"Apple TV":["ATV"],"BlackBerry":["BLB","QNX"],"Brew":["BMP"],"BeOS":["BEO","HAI"],"Chrome OS":["COS","FYD","SEE"],"Firefox OS":["FOS","KOS"],"Gaming Console":["WII","PS3"],"Google TV":["GTV"],"IBM":["OS2"],"iOS":["IOS","WAS"],"RISC OS":["ROS"],"GNU/Linux":["LIN","ARL","DEB","KNO","MIN","UBT","KBT","XBT","LBT","FED","RHT","VLN","MDR","GNT","SAB","SLW","SSE","CES","BTR","SAF","ORD","TOS","RSO","DEE","FRE"],"Mac":["MAC"],"Mobile Gaming Console":["PSP","NDS","XBX"],"Real-time OS":["MTK","TDX","MRE"],"Other Mobile":["WOS","POS","SBA","TIZ","SMG","MAE"],"Symbian":["SYM","SYS","SY3","S60","S40"],"Unix":["SOS","AIX","HPX","BSD","NBS","OBS","DFB","SYL","IRI","T64","INF"],"WebTV":["WTV"],"Windows":["WIN"],"Windows Mobile":["WPH","WMO","WCE","WRT","WIO"],"Other Smart TV":["WHS"]}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(16395), __webpack_exec__(15187), __webpack_exec__(91118), __webpack_exec__(69898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);